/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 94);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(101);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = isMobile;
/* harmony export (immutable) */ __webpack_exports__["a"] = addScore;
/* harmony export (immutable) */ __webpack_exports__["h"] = initializeUser;
/* harmony export (immutable) */ __webpack_exports__["m"] = setEmbedToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = deletePlaybackToken;
/* unused harmony export itemsHasErrored */
/* unused harmony export itemsIsLoading */
/* unused harmony export itemsFetchDataSuccess */
/* harmony export (immutable) */ __webpack_exports__["g"] = getHighScores;
/* unused harmony export setHighScores */
/* unused harmony export getRank */
/* unused harmony export setRank */
/* unused harmony export postScore */
/* unused harmony export startVoice */
/* unused harmony export volumeDown */
/* harmony export (immutable) */ __webpack_exports__["f"] = gameMusic;
/* harmony export (immutable) */ __webpack_exports__["o"] = siteDownMusic;
/* harmony export (immutable) */ __webpack_exports__["p"] = siteDownMusicStop;
/* harmony export (immutable) */ __webpack_exports__["d"] = dialogMusic;
/* harmony export (immutable) */ __webpack_exports__["j"] = pattern2dIn;
/* harmony export (immutable) */ __webpack_exports__["k"] = pattern2dOut;
/* harmony export (immutable) */ __webpack_exports__["s"] = twoDDarkPatternCorrect;
/* harmony export (immutable) */ __webpack_exports__["t"] = twoDDarkPatternIncorrect;
/* harmony export (immutable) */ __webpack_exports__["l"] = playSndFx;
/* harmony export (immutable) */ __webpack_exports__["u"] = voiceStatic;
/* harmony export (immutable) */ __webpack_exports__["e"] = fadeMusic;
/* unused harmony export fadeVoice */
/* harmony export (immutable) */ __webpack_exports__["q"] = stopVoice;
/* harmony export (immutable) */ __webpack_exports__["n"] = setMute;
/* harmony export (immutable) */ __webpack_exports__["r"] = toggleMute;
/* harmony export (immutable) */ __webpack_exports__["b"] = audioChosen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_helpers_js__ = __webpack_require__(42);
// MOBILE DETECT
function isMobile(){return{type:"IS_MOBILE",mobile:Object(__WEBPACK_IMPORTED_MODULE_0__components_utils_helpers_js__["b" /* mobileTest */])()};}function addScore(item,value){return{type:"SCORE_INCREASE",item:item,value:value};}function initializeUser(){return{type:"INITIALIZE_USER"// meta: { sound: 'startGame' }
};}// get token/id for Rage Click replay (via FullStory)
function setEmbedToken(){return function(dispatch){setTimeout(function(){window._fs_shutdown("embedToken");var token=document.getElementById("embedToken").getAttribute("_fs_embed_token");console.log(token);dispatch({type:"SET_EMBED_TOKEN",token:token});},2000);};}function deletePlaybackToken(){console.log("deletePlaybackTokenAction");return{type:"DELETE_PLAYBACK_TOKEN"};}function itemsHasErrored(bool){return{type:"ITEMS_HAS_ERRORED",hasErrored:bool};}function itemsIsLoading(bool){return{type:"ITEMS_IS_LOADING",isLoading:bool};}function itemsFetchDataSuccess(items){return{type:"ITEMS_FETCH_DATA_SUCCESS",items:items};}// thunks!
function getHighScores(){// console.log('getHighScores');
return function(dispatch){dispatch(itemsIsLoading(true));fetch("https://us-central1-rage-click.cloudfunctions.net/getAllScores",{cache:"no-cache",method:"GET",mode:"cors"}).then(function(response){if(!response.ok){throw Error(response.statusText);}dispatch(itemsIsLoading(false));return response;}).then(function(response){return response.json();}).then(function(highScores){dispatch(setHighScores(highScores));}).catch(function(){return dispatch(itemsHasErrored(true));});};}function setHighScores(highScores){return{type:"SET_HIGH_SCORES",highScores:highScores};}function getRank(score){// console.log("getRank");
return function(dispatch){dispatch(itemsIsLoading(true));fetch("https://us-central1-rage-click.cloudfunctions.net/getRank?score="+score,{cache:"no-cache",// *default, no-cache, reload, force-cache, only-if-cached
method:"GET",mode:"cors"}).then(function(response){if(!response.ok){throw Error(response.statusText);}dispatch(itemsIsLoading(false));return response;}).then(function(response){return response.json();}).then(function(rank){console.log("dispatch rank!",rank);dispatch(setRank(rank));}).catch(function(){return dispatch(itemsHasErrored(true));});};}function setRank(rank){return{type:"SET_RANK",rank:rank};}function postScore(score,twitterAccount){// console.log("post store");
return function(dispatch){dispatch(itemsIsLoading(true));fetch("https://us-central1-rage-click.cloudfunctions.net/addScore?score="+score+"&twitterHandle="+twitterAccount,{cache:"no-cache",// *default, no-cache, reload, force-cache, only-if-cached
method:"GET",mode:"cors"}).then(function(response){if(!response.ok){throw Error(response.statusText);}dispatch(itemsIsLoading(false));return response;}).then(function(response){return response.json();}).then(function(scoreSubmitted){// console.log("score submitted!", scoreSubmitted);
}).catch(function(){return dispatch(itemsHasErrored(true));});};}// audio
function startVoice(){return{type:"START_VOICE"};}function volumeDown(){return{type:"VOLUME_DOWN",meta:{sound:"volume"}};}//  audio only
function gameMusic(track){return{type:"snd",meta:{sound:track,channel:"music",op:"play"}};}function siteDownMusic(){return{type:"snd",meta:{sound:"eas",channel:"music",op:"play"}};}function siteDownMusicStop(){return{type:"snd",meta:{sound:"eas",channel:"music",op:"stop"}};}function dialogMusic(){return{type:"snd",meta:{sound:"dialogMusic",channel:"music",op:"play"}};}function pattern2dIn(){return{type:"snd",meta:{sound:"twoDDarkPatternAppear",channel:"fx",op:"playFx"}};}function pattern2dOut(){return{type:"snd",meta:{sound:"twoDRageIncrease",channel:"fx",op:"playFx"}};}function twoDDarkPatternCorrect(){return{type:"snd",meta:{sound:"twoDDarkPatternCorrect",channel:"fx",op:"playFx"}};}function twoDDarkPatternIncorrect(){return{type:"snd",meta:{sound:"twoDDarkPatternIncorrect",channel:"fx",op:"playFx"}};}function playSndFx(sound){return{type:"snd",meta:{sound:sound,channel:"fx",op:"playFx"}};}function voiceStatic(voice){return{type:"snd",meta:{sound:voice,channel:"voice",op:"play"}};}function fadeMusic(){return{type:"snd",meta:{sound:"",channel:"music",op:"fade"}};}function fadeVoice(){return{type:"snd",meta:{sound:"",channel:"voice",op:"fade"}};}function stopVoice(){return{type:"snd",meta:{sound:"",channel:"voice",op:"stopVoice"}};}function setMute(mute){return{type:"SET_MUTE",mute:mute};}function toggleMute(){return{type:"TOGGLE_MUTE",meta:{sound:"",op:"mute"}};}function audioChosen(){return{type:"AUDIO_CHOSEN"};}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * VERSION: 1.20.4
 * DATE: 2018-02-15
 * UPDATES AND DOCS AT: http://greensock.com
 * 
 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
 *
 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {

	"use strict";

	_gsScope._gsDefine("TweenMax", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {

		var _slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++]));
				return b;
			},
			_applyCycle = function(vars, targets, i) {
				var alt = vars.cycle,
					p, val;
				for (p in alt) {
					val = alt[p];
					vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
				}
				delete vars.cycle;
			},
			TweenMax = function(target, duration, vars) {
				TweenLite.call(this, target, duration, vars);
				this._cycle = 0;
				this._yoyo = (this.vars.yoyo === true || !!this.vars.yoyoEase);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				if (this._repeat) {
					this._uncache(true); //ensures that if there is any repeat, the totalDuration will get recalculated to accurately report it.
				}
				this.render = TweenMax.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
			},
			_tinyNum = 0.0000000001,
			TweenLiteInternals = TweenLite._internals,
			_isSelector = TweenLiteInternals.isSelector,
			_isArray = TweenLiteInternals.isArray,
			p = TweenMax.prototype = TweenLite.to({}, 0.1, {}),
			_blankArray = [];

		TweenMax.version = "1.20.4";
		p.constructor = TweenMax;
		p.kill()._gc = false;
		TweenMax.killTweensOf = TweenMax.killDelayedCallsTo = TweenLite.killTweensOf;
		TweenMax.getTweensOf = TweenLite.getTweensOf;
		TweenMax.lagSmoothing = TweenLite.lagSmoothing;
		TweenMax.ticker = TweenLite.ticker;
		TweenMax.render = TweenLite.render;

		p.invalidate = function() {
			this._yoyo = (this.vars.yoyo === true || !!this.vars.yoyoEase);
			this._repeat = this.vars.repeat || 0;
			this._repeatDelay = this.vars.repeatDelay || 0;
			this._yoyoEase = null;
			this._uncache(true);
			return TweenLite.prototype.invalidate.call(this);
		};
		
		p.updateTo = function(vars, resetDuration) {
			var curRatio = this.ratio,
				immediate = this.vars.immediateRender || vars.immediateRender,
				p;
			if (resetDuration && this._startTime < this._timeline._time) {
				this._startTime = this._timeline._time;
				this._uncache(false);
				if (this._gc) {
					this._enabled(true, false);
				} else {
					this._timeline.insert(this, this._startTime - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
				}
			}
			for (p in vars) {
				this.vars[p] = vars[p];
			}
			if (this._initted || immediate) {
				if (resetDuration) {
					this._initted = false;
					if (immediate) {
						this.render(0, true, true);
					}
				} else {
					if (this._gc) {
						this._enabled(true, false);
					}
					if (this._notifyPluginsOfEnabled && this._firstPT) {
						TweenLite._onPluginEvent("_onDisable", this); //in case a plugin like MotionBlur must perform some cleanup tasks
					}
					if (this._time / this._duration > 0.998) { //if the tween has finished (or come extremely close to finishing), we just need to rewind it to 0 and then render it again at the end which forces it to re-initialize (parsing the new vars). We allow tweens that are close to finishing (but haven't quite finished) to work this way too because otherwise, the values are so small when determining where to project the starting values that binary math issues creep in and can make the tween appear to render incorrectly when run backwards. 
						var prevTime = this._totalTime;
						this.render(0, true, false);
						this._initted = false;
						this.render(prevTime, true, false);
					} else {
						this._initted = false;
						this._init();
						if (this._time > 0 || immediate) {
							var inv = 1 / (1 - curRatio),
								pt = this._firstPT, endValue;
							while (pt) {
								endValue = pt.s + pt.c;
								pt.c *= inv;
								pt.s = endValue - pt.c;
								pt = pt._next;
							}
						}
					}
				}
			}
			return this;
		};
				
		p.render = function(time, suppressEvents, force) {
			if (!this._initted) if (this._duration === 0 && this.vars.repeat) { //zero duration tweens that render immediately have render() called from TweenLite's constructor, before TweenMax's constructor has finished setting _repeat, _repeatDelay, and _yoyo which are critical in determining totalDuration() so we need to call invalidate() which is a low-kb way to get those set properly.
				this.invalidate();
			}
			var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
				prevTime = this._time,
				prevTotalTime = this._totalTime, 
				prevCycle = this._cycle,
				duration = this._duration,
				prevRawPrevTime = this._rawPrevTime,
				isComplete, callback, pt, cycleDuration, r, type, pow, rawPrevTime, yoyoEase;
			if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
				this._totalTime = totalDur;
				this._cycle = this._repeat;
				if (this._yoyo && (this._cycle & 1) !== 0) {
					this._time = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
				} else {
					this._time = duration;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
				}
				if (!this._reversed) {
					isComplete = true;
					callback = "onComplete";
					force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
				}
				if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
					if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
						time = 0;
					}
					if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
						force = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
					this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				}
				
			} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
				this._totalTime = this._time = this._cycle = 0;
				this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
				if (prevTotalTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
					callback = "onReverseComplete";
					isComplete = this._reversed;
				}
				if (time < 0) {
					this._active = false;
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (prevRawPrevTime >= 0) {
							force = true;
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
				}
				if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
					force = true;
				}
			} else {
				this._totalTime = this._time = time;
				if (this._repeat !== 0) {
					cycleDuration = duration + this._repeatDelay;
					this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
					if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
						this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
					}
					this._time = this._totalTime - (this._cycle * cycleDuration);
					if (this._yoyo) if ((this._cycle & 1) !== 0) {
						this._time = duration - this._time;
						yoyoEase = this._yoyoEase || this.vars.yoyoEase; //note: we don't set this._yoyoEase in _init() like we do other properties because it's TweenMax-specific and doing it here allows us to optimize performance (most tweens don't have a yoyoEase). Note that we also must skip the this.ratio calculation further down right after we _init() in this function, because we're doing it here.
						if (yoyoEase) {
							if (!this._yoyoEase) {
								if (yoyoEase === true && !this._initted) { //if it's not initted and yoyoEase is true, this._ease won't have been populated yet so we must discern it here.
									yoyoEase = this.vars.ease;
									this._yoyoEase = yoyoEase = !yoyoEase ? TweenLite.defaultEase : (yoyoEase instanceof Ease) ? yoyoEase : (typeof(yoyoEase) === "function") ? new Ease(yoyoEase, this.vars.easeParams) : Ease.map[yoyoEase] || TweenLite.defaultEase;
								} else {
									this._yoyoEase = yoyoEase = (yoyoEase === true) ? this._ease : (yoyoEase instanceof Ease) ? yoyoEase : Ease.map[yoyoEase];
								}
							}
							this.ratio = yoyoEase ? 1 - yoyoEase.getRatio((duration - this._time) / duration) : 0;
						}
					}
					if (this._time > duration) {
						this._time = duration;
					} else if (this._time < 0) {
						this._time = 0;
					}
				}
				if (this._easeType && !yoyoEase) {
					r = this._time / duration;
					type = this._easeType;
					pow = this._easePower;
					if (type === 1 || (type === 3 && r >= 0.5)) {
						r = 1 - r;
					}
					if (type === 3) {
						r *= 2;
					}
					if (pow === 1) {
						r *= r;
					} else if (pow === 2) {
						r *= r * r;
					} else if (pow === 3) {
						r *= r * r * r;
					} else if (pow === 4) {
						r *= r * r * r * r;
					}

					if (type === 1) {
						this.ratio = 1 - r;
					} else if (type === 2) {
						this.ratio = r;
					} else if (this._time / duration < 0.5) {
						this.ratio = r / 2;
					} else {
						this.ratio = 1 - (r / 2);
					}

				} else if (!yoyoEase) {
					this.ratio = this._ease.getRatio(this._time / duration);
				}
				
			}
				
			if (prevTime === this._time && !force && prevCycle === this._cycle) {
				if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
					this._callback("onUpdate");
				}
				return;
			} else if (!this._initted) {
				this._init();
				if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
					return;
				} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) { //we stick it in the queue for rendering at the very end of the tick - this is a performance optimization because browsers invalidate styles and force a recalculation if you read, write, and then read style data (so it's better to read/read/read/write/write/write than read/write/read/write/read/write). The down side, of course, is that usually you WANT things to render immediately because you may have code running right after that which depends on the change. Like imagine running TweenLite.set(...) and then immediately after that, creating a nother tween that animates the same property to another value; the starting values of that 2nd tween wouldn't be accurate if lazy is true.
					this._time = prevTime;
					this._totalTime = prevTotalTime;
					this._rawPrevTime = prevRawPrevTime;
					this._cycle = prevCycle;
					TweenLiteInternals.lazyTweens.push(this);
					this._lazy = [time, suppressEvents];
					return;
				}
				//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
				if (this._time && !isComplete && !yoyoEase) {
					this.ratio = this._ease.getRatio(this._time / duration);
				} else if (isComplete && this._ease._calcEnd && !yoyoEase) {
					this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
				}
			}
			if (this._lazy !== false) {
				this._lazy = false;
			}

			if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
				this._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
			}
			if (prevTotalTime === 0) {
				if (this._initted === 2 && time > 0) {
					//this.invalidate();
					this._init(); //will just apply overwriting since _initted of (2) means it was a from() tween that had immediateRender:true
				}
				if (this._startAt) {
					if (time >= 0) {
						this._startAt.render(time, true, force);
					} else if (!callback) {
						callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
					}
				}
				if (this.vars.onStart) if (this._totalTime !== 0 || duration === 0) if (!suppressEvents) {
					this._callback("onStart");
				}
			}
			
			pt = this._firstPT;
			while (pt) {
				if (pt.f) {
					pt.t[pt.p](pt.c * this.ratio + pt.s);
				} else {
					pt.t[pt.p] = pt.c * this.ratio + pt.s;
				}
				pt = pt._next;
			}
			
			if (this._onUpdate) {
				if (time < 0) if (this._startAt && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					this._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
				}
				if (!suppressEvents) if (this._totalTime !== prevTotalTime || callback) {
					this._callback("onUpdate");
				}
			}
			if (this._cycle !== prevCycle) if (!suppressEvents) if (!this._gc) if (this.vars.onRepeat) {
				this._callback("onRepeat");
			}
			if (callback) if (!this._gc || force) { //check gc because there's a chance that kill() could be called in an onUpdate
				if (time < 0 && this._startAt && !this._onUpdate && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					this._startAt.render(time, true, force);
				}
				if (isComplete) {
					if (this._timeline.autoRemoveChildren) {
						this._enabled(false, false);
					}
					this._active = false;
				}
				if (!suppressEvents && this.vars[callback]) {
					this._callback(callback);
				}
				if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
					this._rawPrevTime = 0;
				}
			}
		};
		
//---- STATIC FUNCTIONS -----------------------------------------------------------------------------------------------------------
		
		TweenMax.to = function(target, duration, vars) {
			return new TweenMax(target, duration, vars);
		};
		
		TweenMax.from = function(target, duration, vars) {
			vars.runBackwards = true;
			vars.immediateRender = (vars.immediateRender != false);
			return new TweenMax(target, duration, vars);
		};
		
		TweenMax.fromTo = function(target, duration, fromVars, toVars) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return new TweenMax(target, duration, toVars);
		};
		
		TweenMax.staggerTo = TweenMax.allTo = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			stagger = stagger || 0;
			var delay = 0,
				a = [],
				finalComplete = function() {
					if (vars.onComplete) {
						vars.onComplete.apply(vars.onCompleteScope || this, arguments);
					}
					onCompleteAll.apply(onCompleteAllScope || vars.callbackScope || this, onCompleteAllParams || _blankArray);
				},
				cycle = vars.cycle,
				fromCycle = (vars.startAt && vars.startAt.cycle),
				l, copy, i, p;
			if (!_isArray(targets)) {
				if (typeof(targets) === "string") {
					targets = TweenLite.selector(targets) || targets;
				}
				if (_isSelector(targets)) {
					targets = _slice(targets);
				}
			}
			targets = targets || [];
			if (stagger < 0) {
				targets = _slice(targets);
				targets.reverse();
				stagger *= -1;
			}
			l = targets.length - 1;
			for (i = 0; i <= l; i++) {
				copy = {};
				for (p in vars) {
					copy[p] = vars[p];
				}
				if (cycle) {
					_applyCycle(copy, targets, i);
					if (copy.duration != null) {
						duration = copy.duration;
						delete copy.duration;
					}
				}
				if (fromCycle) {
					fromCycle = copy.startAt = {};
					for (p in vars.startAt) {
						fromCycle[p] = vars.startAt[p];
					}
					_applyCycle(copy.startAt, targets, i);
				}
				copy.delay = delay + (copy.delay || 0);
				if (i === l && onCompleteAll) {
					copy.onComplete = finalComplete;
				}
				a[i] = new TweenMax(targets[i], duration, copy);
				delay += stagger;
			}
			return a;
		};
		
		TweenMax.staggerFrom = TweenMax.allFrom = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			vars.runBackwards = true;
			vars.immediateRender = (vars.immediateRender != false);
			return TweenMax.staggerTo(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
		};
		
		TweenMax.staggerFromTo = TweenMax.allFromTo = function(targets, duration, fromVars, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return TweenMax.staggerTo(targets, duration, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
		};
				
		TweenMax.delayedCall = function(delay, callback, params, scope, useFrames) {
			return new TweenMax(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, useFrames:useFrames, overwrite:0});
		};
		
		TweenMax.set = function(target, vars) {
			return new TweenMax(target, 0, vars);
		};
		
		TweenMax.isTweening = function(target) {
			return (TweenLite.getTweensOf(target, true).length > 0);
		};
		
		var _getChildrenOf = function(timeline, includeTimelines) {
				var a = [],
					cnt = 0,
					tween = timeline._first;
				while (tween) {
					if (tween instanceof TweenLite) {
						a[cnt++] = tween;
					} else {
						if (includeTimelines) {
							a[cnt++] = tween;
						}
						a = a.concat(_getChildrenOf(tween, includeTimelines));
						cnt = a.length;
					}
					tween = tween._next;
				}
				return a;
			}, 
			getAllTweens = TweenMax.getAllTweens = function(includeTimelines) {
				return _getChildrenOf(Animation._rootTimeline, includeTimelines).concat( _getChildrenOf(Animation._rootFramesTimeline, includeTimelines) );
			};
		
		TweenMax.killAll = function(complete, tweens, delayedCalls, timelines) {
			if (tweens == null) {
				tweens = true;
			}
			if (delayedCalls == null) {
				delayedCalls = true;
			}
			var a = getAllTweens((timelines != false)),
				l = a.length,
				allTrue = (tweens && delayedCalls && timelines),
				isDC, tween, i;
			for (i = 0; i < l; i++) {
				tween = a[i];
				if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
					if (complete) {
						tween.totalTime(tween._reversed ? 0 : tween.totalDuration());
					} else {
						tween._enabled(false, false);
					}
				}
			}
		};
		
		TweenMax.killChildTweensOf = function(parent, complete) {
			if (parent == null) {
				return;
			}
			var tl = TweenLiteInternals.tweenLookup,
				a, curParent, p, i, l;
			if (typeof(parent) === "string") {
				parent = TweenLite.selector(parent) || parent;
			}
			if (_isSelector(parent)) {
				parent = _slice(parent);
			}
			if (_isArray(parent)) {
				i = parent.length;
				while (--i > -1) {
					TweenMax.killChildTweensOf(parent[i], complete);
				}
				return;
			}
			a = [];
			for (p in tl) {
				curParent = tl[p].target.parentNode;
				while (curParent) {
					if (curParent === parent) {
						a = a.concat(tl[p].tweens);
					}
					curParent = curParent.parentNode;
				}
			}
			l = a.length;
			for (i = 0; i < l; i++) {
				if (complete) {
					a[i].totalTime(a[i].totalDuration());
				}
				a[i]._enabled(false, false);
			}
		};

		var _changePause = function(pause, tweens, delayedCalls, timelines) {
			tweens = (tweens !== false);
			delayedCalls = (delayedCalls !== false);
			timelines = (timelines !== false);
			var a = getAllTweens(timelines),
				allTrue = (tweens && delayedCalls && timelines),
				i = a.length,
				isDC, tween;
			while (--i > -1) {
				tween = a[i];
				if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
					tween.paused(pause);
				}
			}
		};
		
		TweenMax.pauseAll = function(tweens, delayedCalls, timelines) {
			_changePause(true, tweens, delayedCalls, timelines);
		};
		
		TweenMax.resumeAll = function(tweens, delayedCalls, timelines) {
			_changePause(false, tweens, delayedCalls, timelines);
		};

		TweenMax.globalTimeScale = function(value) {
			var tl = Animation._rootTimeline,
				t = TweenLite.ticker.time;
			if (!arguments.length) {
				return tl._timeScale;
			}
			value = value || _tinyNum; //can't allow zero because it'll throw the math off
			tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
			tl = Animation._rootFramesTimeline;
			t = TweenLite.ticker.frame;
			tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
			tl._timeScale = Animation._rootTimeline._timeScale = value;
			return value;
		};
		
	
//---- GETTERS / SETTERS ----------------------------------------------------------------------------------------------------------
		
		p.progress = function(value, suppressEvents) {
			return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
		};
		
		p.totalProgress = function(value, suppressEvents) {
			return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
		};
		
		p.time = function(value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			if (value > this._duration) {
				value = this._duration;
			}
			if (this._yoyo && (this._cycle & 1) !== 0) {
				value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
			} else if (this._repeat !== 0) {
				value += this._cycle * (this._duration + this._repeatDelay);
			}
			return this.totalTime(value, suppressEvents);
		};

		p.duration = function(value) {
			if (!arguments.length) {
				return this._duration; //don't set _dirty = false because there could be repeats that haven't been factored into the _totalDuration yet. Otherwise, if you create a repeated TweenMax and then immediately check its duration(), it would cache the value and the totalDuration would not be correct, thus repeats wouldn't take effect.
			}
			return Animation.prototype.duration.call(this, value);
		};

		p.totalDuration = function(value) {
			if (!arguments.length) {
				if (this._dirty) {
					//instead of Infinity, we use 999999999999 so that we can accommodate reverses
					this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
					this._dirty = false;
				}
				return this._totalDuration;
			}
			return (this._repeat === -1) ? this : this.duration( (value - (this._repeat * this._repeatDelay)) / (this._repeat + 1) );
		};
		
		p.repeat = function(value) {
			if (!arguments.length) {
				return this._repeat;
			}
			this._repeat = value;
			return this._uncache(true);
		};
		
		p.repeatDelay = function(value) {
			if (!arguments.length) {
				return this._repeatDelay;
			}
			this._repeatDelay = value;
			return this._uncache(true);
		};
		
		p.yoyo = function(value) {
			if (!arguments.length) {
				return this._yoyo;
			}
			this._yoyo = value;
			return this;
		};
		
		
		return TweenMax;
		
	}, true);








/*
 * ----------------------------------------------------------------
 * TimelineLite
 * ----------------------------------------------------------------
 */
	_gsScope._gsDefine("TimelineLite", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {

		var TimelineLite = function(vars) {
				SimpleTimeline.call(this, vars);
				this._labels = {};
				this.autoRemoveChildren = (this.vars.autoRemoveChildren === true);
				this.smoothChildTiming = (this.vars.smoothChildTiming === true);
				this._sortChildren = true;
				this._onUpdate = this.vars.onUpdate;
				var v = this.vars,
					val, p;
				for (p in v) {
					val = v[p];
					if (_isArray(val)) if (val.join("").indexOf("{self}") !== -1) {
						v[p] = this._swapSelfInParams(val);
					}
				}
				if (_isArray(v.tweens)) {
					this.add(v.tweens, 0, v.align, v.stagger);
				}
			},
			_tinyNum = 0.0000000001,
			TweenLiteInternals = TweenLite._internals,
			_internals = TimelineLite._internals = {},
			_isSelector = TweenLiteInternals.isSelector,
			_isArray = TweenLiteInternals.isArray,
			_lazyTweens = TweenLiteInternals.lazyTweens,
			_lazyRender = TweenLiteInternals.lazyRender,
			_globals = _gsScope._gsDefine.globals,
			_copy = function(vars) {
				var copy = {}, p;
				for (p in vars) {
					copy[p] = vars[p];
				}
				return copy;
			},
			_applyCycle = function(vars, targets, i) {
				var alt = vars.cycle,
					p, val;
				for (p in alt) {
					val = alt[p];
					vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
				}
				delete vars.cycle;
			},
			_pauseCallback = _internals.pauseCallback = function() {},
			_slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++]));
				return b;
			},
			p = TimelineLite.prototype = new SimpleTimeline();

		TimelineLite.version = "1.20.4";
		p.constructor = TimelineLite;
		p.kill()._gc = p._forcingPlayhead = p._hasPause = false;

		/* might use later...
		//translates a local time inside an animation to the corresponding time on the root/global timeline, factoring in all nesting and timeScales.
		function localToGlobal(time, animation) {
			while (animation) {
				time = (time / animation._timeScale) + animation._startTime;
				animation = animation.timeline;
			}
			return time;
		}

		//translates the supplied time on the root/global timeline into the corresponding local time inside a particular animation, factoring in all nesting and timeScales
		function globalToLocal(time, animation) {
			var scale = 1;
			time -= localToGlobal(0, animation);
			while (animation) {
				scale *= animation._timeScale;
				animation = animation.timeline;
			}
			return time * scale;
		}
		*/

		p.to = function(target, duration, vars, position) {
			var Engine = (vars.repeat && _globals.TweenMax) || TweenLite;
			return duration ? this.add( new Engine(target, duration, vars), position) : this.set(target, vars, position);
		};

		p.from = function(target, duration, vars, position) {
			return this.add( ((vars.repeat && _globals.TweenMax) || TweenLite).from(target, duration, vars), position);
		};

		p.fromTo = function(target, duration, fromVars, toVars, position) {
			var Engine = (toVars.repeat && _globals.TweenMax) || TweenLite;
			return duration ? this.add( Engine.fromTo(target, duration, fromVars, toVars), position) : this.set(target, toVars, position);
		};

		p.staggerTo = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			var tl = new TimelineLite({onComplete:onCompleteAll, onCompleteParams:onCompleteAllParams, callbackScope:onCompleteAllScope, smoothChildTiming:this.smoothChildTiming}),
				cycle = vars.cycle,
				copy, i;
			if (typeof(targets) === "string") {
				targets = TweenLite.selector(targets) || targets;
			}
			targets = targets || [];
			if (_isSelector(targets)) { //senses if the targets object is a selector. If it is, we should translate it into an array.
				targets = _slice(targets);
			}
			stagger = stagger || 0;
			if (stagger < 0) {
				targets = _slice(targets);
				targets.reverse();
				stagger *= -1;
			}
			for (i = 0; i < targets.length; i++) {
				copy = _copy(vars);
				if (copy.startAt) {
					copy.startAt = _copy(copy.startAt);
					if (copy.startAt.cycle) {
						_applyCycle(copy.startAt, targets, i);
					}
				}
				if (cycle) {
					_applyCycle(copy, targets, i);
					if (copy.duration != null) {
						duration = copy.duration;
						delete copy.duration;
					}
				}
				tl.to(targets[i], duration, copy, i * stagger);
			}
			return this.add(tl, position);
		};

		p.staggerFrom = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			vars.immediateRender = (vars.immediateRender != false);
			vars.runBackwards = true;
			return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
		};

		p.staggerFromTo = function(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
		};

		p.call = function(callback, params, scope, position) {
			return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
		};

		p.set = function(target, vars, position) {
			position = this._parseTimeOrLabel(position, 0, true);
			if (vars.immediateRender == null) {
				vars.immediateRender = (position === this._time && !this._paused);
			}
			return this.add( new TweenLite(target, 0, vars), position);
		};

		TimelineLite.exportRoot = function(vars, ignoreDelayedCalls) {
			vars = vars || {};
			if (vars.smoothChildTiming == null) {
				vars.smoothChildTiming = true;
			}
			var tl = new TimelineLite(vars),
				root = tl._timeline,
				hasNegativeStart, time,	tween, next;
			if (ignoreDelayedCalls == null) {
				ignoreDelayedCalls = true;
			}
			root._remove(tl, true);
			tl._startTime = 0;
			tl._rawPrevTime = tl._time = tl._totalTime = root._time;
			tween = root._first;
			while (tween) {
				next = tween._next;
				if (!ignoreDelayedCalls || !(tween instanceof TweenLite && tween.target === tween.vars.onComplete)) {
					time = tween._startTime - tween._delay;
					if (time < 0) {
						hasNegativeStart = 1;
					}
					tl.add(tween, time);
				}
				tween = next;
			}
			root.add(tl, 0);
			if (hasNegativeStart) { //calling totalDuration() will force the adjustment necessary to shift the children forward so none of them start before zero, and moves the timeline backwards the same amount, so the playhead is still aligned where it should be globally, but the timeline doesn't have illegal children that start before zero.
				tl.totalDuration();
			}
			return tl;
		};

		p.add = function(value, position, align, stagger) {
			var curTime, l, i, child, tl, beforeRawTime;
			if (typeof(position) !== "number") {
				position = this._parseTimeOrLabel(position, 0, true, value);
			}
			if (!(value instanceof Animation)) {
				if ((value instanceof Array) || (value && value.push && _isArray(value))) {
					align = align || "normal";
					stagger = stagger || 0;
					curTime = position;
					l = value.length;
					for (i = 0; i < l; i++) {
						if (_isArray(child = value[i])) {
							child = new TimelineLite({tweens:child});
						}
						this.add(child, curTime);
						if (typeof(child) !== "string" && typeof(child) !== "function") {
							if (align === "sequence") {
								curTime = child._startTime + (child.totalDuration() / child._timeScale);
							} else if (align === "start") {
								child._startTime -= child.delay();
							}
						}
						curTime += stagger;
					}
					return this._uncache(true);
				} else if (typeof(value) === "string") {
					return this.addLabel(value, position);
				} else if (typeof(value) === "function") {
					value = TweenLite.delayedCall(0, value);
				} else {
					throw("Cannot add " + value + " into the timeline; it is not a tween, timeline, function, or string.");
				}
			}

			SimpleTimeline.prototype.add.call(this, value, position);

			if (value._time) { //in case, for example, the _startTime is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
				value.render((this.rawTime() - value._startTime) * value._timeScale, false, false);
			}

			//if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
			if (this._gc || this._time === this._duration) if (!this._paused) if (this._duration < this.duration()) {
				//in case any of the ancestors had completed but should now be enabled...
				tl = this;
				beforeRawTime = (tl.rawTime() > value._startTime); //if the tween is placed on the timeline so that it starts BEFORE the current rawTime, we should align the playhead (move the timeline). This is because sometimes users will create a timeline, let it finish, and much later append a tween and expect it to run instead of jumping to its end state. While technically one could argue that it should jump to its end state, that's not what users intuitively expect.
				while (tl._timeline) {
					if (beforeRawTime && tl._timeline.smoothChildTiming) {
						tl.totalTime(tl._totalTime, true); //moves the timeline (shifts its startTime) if necessary, and also enables it.
					} else if (tl._gc) {
						tl._enabled(true, false);
					}
					tl = tl._timeline;
				}
			}

			return this;
		};

		p.remove = function(value) {
			if (value instanceof Animation) {
				this._remove(value, false);
				var tl = value._timeline = value.vars.useFrames ? Animation._rootFramesTimeline : Animation._rootTimeline; //now that it's removed, default it to the root timeline so that if it gets played again, it doesn't jump back into this timeline.
				value._startTime = (value._paused ? value._pauseTime : tl._time) - ((!value._reversed ? value._totalTime : value.totalDuration() - value._totalTime) / value._timeScale); //ensure that if it gets played again, the timing is correct.
				return this;
			} else if (value instanceof Array || (value && value.push && _isArray(value))) {
				var i = value.length;
				while (--i > -1) {
					this.remove(value[i]);
				}
				return this;
			} else if (typeof(value) === "string") {
				return this.removeLabel(value);
			}
			return this.kill(null, value);
		};

		p._remove = function(tween, skipDisable) {
			SimpleTimeline.prototype._remove.call(this, tween, skipDisable);
			var last = this._last;
			if (!last) {
				this._time = this._totalTime = this._duration = this._totalDuration = 0;
			} else if (this._time > this.duration()) {
				this._time = this._duration;
				this._totalTime = this._totalDuration;
			}
			return this;
		};

		p.append = function(value, offsetOrLabel) {
			return this.add(value, this._parseTimeOrLabel(null, offsetOrLabel, true, value));
		};

		p.insert = p.insertMultiple = function(value, position, align, stagger) {
			return this.add(value, position || 0, align, stagger);
		};

		p.appendMultiple = function(tweens, offsetOrLabel, align, stagger) {
			return this.add(tweens, this._parseTimeOrLabel(null, offsetOrLabel, true, tweens), align, stagger);
		};

		p.addLabel = function(label, position) {
			this._labels[label] = this._parseTimeOrLabel(position);
			return this;
		};

		p.addPause = function(position, callback, params, scope) {
			var t = TweenLite.delayedCall(0, _pauseCallback, params, scope || this);
			t.vars.onComplete = t.vars.onReverseComplete = callback;
			t.data = "isPause";
			this._hasPause = true;
			return this.add(t, position);
		};

		p.removeLabel = function(label) {
			delete this._labels[label];
			return this;
		};

		p.getLabelTime = function(label) {
			return (this._labels[label] != null) ? this._labels[label] : -1;
		};

		p._parseTimeOrLabel = function(timeOrLabel, offsetOrLabel, appendIfAbsent, ignore) {
			var clippedDuration, i;
			//if we're about to add a tween/timeline (or an array of them) that's already a child of this timeline, we should remove it first so that it doesn't contaminate the duration().
			if (ignore instanceof Animation && ignore.timeline === this) {
				this.remove(ignore);
			} else if (ignore && ((ignore instanceof Array) || (ignore.push && _isArray(ignore)))) {
				i = ignore.length;
				while (--i > -1) {
					if (ignore[i] instanceof Animation && ignore[i].timeline === this) {
						this.remove(ignore[i]);
					}
				}
			}
			clippedDuration = (typeof(timeOrLabel) === "number" && !offsetOrLabel) ? 0 : (this.duration() > 99999999999) ? this.recent().endTime(false) : this._duration; //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
			if (typeof(offsetOrLabel) === "string") {
				return this._parseTimeOrLabel(offsetOrLabel, (appendIfAbsent && typeof(timeOrLabel) === "number" && this._labels[offsetOrLabel] == null) ? timeOrLabel - clippedDuration : 0, appendIfAbsent);
			}
			offsetOrLabel = offsetOrLabel || 0;
			if (typeof(timeOrLabel) === "string" && (isNaN(timeOrLabel) || this._labels[timeOrLabel] != null)) { //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
				i = timeOrLabel.indexOf("=");
				if (i === -1) {
					if (this._labels[timeOrLabel] == null) {
						return appendIfAbsent ? (this._labels[timeOrLabel] = clippedDuration + offsetOrLabel) : offsetOrLabel;
					}
					return this._labels[timeOrLabel] + offsetOrLabel;
				}
				offsetOrLabel = parseInt(timeOrLabel.charAt(i-1) + "1", 10) * Number(timeOrLabel.substr(i+1));
				timeOrLabel = (i > 1) ? this._parseTimeOrLabel(timeOrLabel.substr(0, i-1), 0, appendIfAbsent) : clippedDuration;
			} else if (timeOrLabel == null) {
				timeOrLabel = clippedDuration;
			}
			return Number(timeOrLabel) + offsetOrLabel;
		};

		p.seek = function(position, suppressEvents) {
			return this.totalTime((typeof(position) === "number") ? position : this._parseTimeOrLabel(position), (suppressEvents !== false));
		};

		p.stop = function() {
			return this.paused(true);
		};

		p.gotoAndPlay = function(position, suppressEvents) {
			return this.play(position, suppressEvents);
		};

		p.gotoAndStop = function(position, suppressEvents) {
			return this.pause(position, suppressEvents);
		};

		p.render = function(time, suppressEvents, force) {
			if (this._gc) {
				this._enabled(true, false);
			}
			var prevTime = this._time,
				totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
				prevStart = this._startTime,
				prevTimeScale = this._timeScale,
				prevPaused = this._paused,
				tween, isComplete, next, callback, internalForce, pauseTween, curTime;
			if (prevTime !== this._time) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
				time += this._time - prevTime;
			}
			if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
				this._totalTime = this._time = totalDur;
				if (!this._reversed) if (!this._hasPausedChild()) {
					isComplete = true;
					callback = "onComplete";
					internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || this._rawPrevTime < 0 || this._rawPrevTime === _tinyNum) if (this._rawPrevTime !== time && this._first) {
						internalForce = true;
						if (this._rawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
				}
				this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				time = totalDur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7.

			} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
				this._totalTime = this._time = 0;
				if (prevTime !== 0 || (this._duration === 0 && this._rawPrevTime !== _tinyNum && (this._rawPrevTime > 0 || (time < 0 && this._rawPrevTime >= 0)))) {
					callback = "onReverseComplete";
					isComplete = this._reversed;
				}
				if (time < 0) {
					this._active = false;
					if (this._timeline.autoRemoveChildren && this._reversed) { //ensures proper GC if a timeline is resumed after it's finished reversing.
						internalForce = isComplete = true;
						callback = "onReverseComplete";
					} else if (this._rawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
						internalForce = true;
					}
					this._rawPrevTime = time;
				} else {
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
						tween = this._first;
						while (tween && tween._startTime === 0) {
							if (!tween._duration) {
								isComplete = false;
							}
							tween = tween._next;
						}
					}
					time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
					if (!this._initted) {
						internalForce = true;
					}
				}

			} else {

				if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
					if (time >= prevTime) {
						tween = this._first;
						while (tween && tween._startTime <= time && !pauseTween) {
							if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
								pauseTween = tween;
							}
							tween = tween._next;
						}
					} else {
						tween = this._last;
						while (tween && tween._startTime >= time && !pauseTween) {
							if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
								pauseTween = tween;
							}
							tween = tween._prev;
						}
					}
					if (pauseTween) {
						this._time = time = pauseTween._startTime;
						this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
					}
				}

				this._totalTime = this._time = this._rawPrevTime = time;
			}
			if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
				return;
			} else if (!this._initted) {
				this._initted = true;
			}

			if (!this._active) if (!this._paused && this._time !== prevTime && time > 0) {
				this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
			}

			if (prevTime === 0) if (this.vars.onStart) if (this._time !== 0 || !this._duration) if (!suppressEvents) {
				this._callback("onStart");
			}

			curTime = this._time;
			if (curTime >= prevTime) {
				tween = this._first;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
						break;
					} else if (tween._active || (tween._startTime <= curTime && !tween._paused && !tween._gc)) {
						if (pauseTween === tween) {
							this.pause();
						}
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			} else {
				tween = this._last;
				while (tween) {
					next = tween._prev; //record it here because the value could change after rendering...
					if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
						break;
					} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
						if (pauseTween === tween) {
							pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
							while (pauseTween && pauseTween.endTime() > this._time) {
								pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
								pauseTween = pauseTween._prev;
							}
							pauseTween = null;
							this.pause();
						}
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			}

			if (this._onUpdate) if (!suppressEvents) {
				if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
					_lazyRender();
				}
				this._callback("onUpdate");
			}

			if (callback) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
				if (isComplete) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					if (this._timeline.autoRemoveChildren) {
						this._enabled(false, false);
					}
					this._active = false;
				}
				if (!suppressEvents && this.vars[callback]) {
					this._callback(callback);
				}
			}
		};

		p._hasPausedChild = function() {
			var tween = this._first;
			while (tween) {
				if (tween._paused || ((tween instanceof TimelineLite) && tween._hasPausedChild())) {
					return true;
				}
				tween = tween._next;
			}
			return false;
		};

		p.getChildren = function(nested, tweens, timelines, ignoreBeforeTime) {
			ignoreBeforeTime = ignoreBeforeTime || -9999999999;
			var a = [],
				tween = this._first,
				cnt = 0;
			while (tween) {
				if (tween._startTime < ignoreBeforeTime) {
					//do nothing
				} else if (tween instanceof TweenLite) {
					if (tweens !== false) {
						a[cnt++] = tween;
					}
				} else {
					if (timelines !== false) {
						a[cnt++] = tween;
					}
					if (nested !== false) {
						a = a.concat(tween.getChildren(true, tweens, timelines));
						cnt = a.length;
					}
				}
				tween = tween._next;
			}
			return a;
		};

		p.getTweensOf = function(target, nested) {
			var disabled = this._gc,
				a = [],
				cnt = 0,
				tweens, i;
			if (disabled) {
				this._enabled(true, true); //getTweensOf() filters out disabled tweens, and we have to mark them as _gc = true when the timeline completes in order to allow clean garbage collection, so temporarily re-enable the timeline here.
			}
			tweens = TweenLite.getTweensOf(target);
			i = tweens.length;
			while (--i > -1) {
				if (tweens[i].timeline === this || (nested && this._contains(tweens[i]))) {
					a[cnt++] = tweens[i];
				}
			}
			if (disabled) {
				this._enabled(false, true);
			}
			return a;
		};

		p.recent = function() {
			return this._recent;
		};

		p._contains = function(tween) {
			var tl = tween.timeline;
			while (tl) {
				if (tl === this) {
					return true;
				}
				tl = tl.timeline;
			}
			return false;
		};

		p.shiftChildren = function(amount, adjustLabels, ignoreBeforeTime) {
			ignoreBeforeTime = ignoreBeforeTime || 0;
			var tween = this._first,
				labels = this._labels,
				p;
			while (tween) {
				if (tween._startTime >= ignoreBeforeTime) {
					tween._startTime += amount;
				}
				tween = tween._next;
			}
			if (adjustLabels) {
				for (p in labels) {
					if (labels[p] >= ignoreBeforeTime) {
						labels[p] += amount;
					}
				}
			}
			return this._uncache(true);
		};

		p._kill = function(vars, target) {
			if (!vars && !target) {
				return this._enabled(false, false);
			}
			var tweens = (!target) ? this.getChildren(true, true, false) : this.getTweensOf(target),
				i = tweens.length,
				changed = false;
			while (--i > -1) {
				if (tweens[i]._kill(vars, target)) {
					changed = true;
				}
			}
			return changed;
		};

		p.clear = function(labels) {
			var tweens = this.getChildren(false, true, true),
				i = tweens.length;
			this._time = this._totalTime = 0;
			while (--i > -1) {
				tweens[i]._enabled(false, false);
			}
			if (labels !== false) {
				this._labels = {};
			}
			return this._uncache(true);
		};

		p.invalidate = function() {
			var tween = this._first;
			while (tween) {
				tween.invalidate();
				tween = tween._next;
			}
			return Animation.prototype.invalidate.call(this);;
		};

		p._enabled = function(enabled, ignoreTimeline) {
			if (enabled === this._gc) {
				var tween = this._first;
				while (tween) {
					tween._enabled(enabled, true);
					tween = tween._next;
				}
			}
			return SimpleTimeline.prototype._enabled.call(this, enabled, ignoreTimeline);
		};

		p.totalTime = function(time, suppressEvents, uncapped) {
			this._forcingPlayhead = true;
			var val = Animation.prototype.totalTime.apply(this, arguments);
			this._forcingPlayhead = false;
			return val;
		};

		p.duration = function(value) {
			if (!arguments.length) {
				if (this._dirty) {
					this.totalDuration(); //just triggers recalculation
				}
				return this._duration;
			}
			if (this.duration() !== 0 && value !== 0) {
				this.timeScale(this._duration / value);
			}
			return this;
		};

		p.totalDuration = function(value) {
			if (!arguments.length) {
				if (this._dirty) {
					var max = 0,
						tween = this._last,
						prevStart = 999999999999,
						prev, end;
					while (tween) {
						prev = tween._prev; //record it here in case the tween changes position in the sequence...
						if (tween._dirty) {
							tween.totalDuration(); //could change the tween._startTime, so make sure the tween's cache is clean before analyzing it.
						}
						if (tween._startTime > prevStart && this._sortChildren && !tween._paused && !this._calculatingDuration) { //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
							this._calculatingDuration = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add(), like _parseTimeOrLabel().
							this.add(tween, tween._startTime - tween._delay);
							this._calculatingDuration = 0;
						} else {
							prevStart = tween._startTime;
						}
						if (tween._startTime < 0 && !tween._paused) { //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
							max -= tween._startTime;
							if (this._timeline.smoothChildTiming) {
								this._startTime += tween._startTime / this._timeScale;
								this._time -= tween._startTime;
								this._totalTime -= tween._startTime;
								this._rawPrevTime -= tween._startTime;
							}
							this.shiftChildren(-tween._startTime, false, -9999999999);
							prevStart = 0;
						}
						end = tween._startTime + (tween._totalDuration / tween._timeScale);
						if (end > max) {
							max = end;
						}
						tween = prev;
					}
					this._duration = this._totalDuration = max;
					this._dirty = false;
				}
				return this._totalDuration;
			}
			return (value && this.totalDuration()) ? this.timeScale(this._totalDuration / value) : this;
		};

		p.paused = function(value) {
			if (!value) { //if there's a pause directly at the spot from where we're unpausing, skip it.
				var tween = this._first,
					time = this._time;
				while (tween) {
					if (tween._startTime === time && tween.data === "isPause") {
						tween._rawPrevTime = 0; //remember, _rawPrevTime is how zero-duration tweens/callbacks sense directionality and determine whether or not to fire. If _rawPrevTime is the same as _startTime on the next render, it won't fire.
					}
					tween = tween._next;
				}
			}
			return Animation.prototype.paused.apply(this, arguments);
		};

		p.usesFrames = function() {
			var tl = this._timeline;
			while (tl._timeline) {
				tl = tl._timeline;
			}
			return (tl === Animation._rootFramesTimeline);
		};

		p.rawTime = function(wrapRepeats) {
			return (wrapRepeats && (this._paused || (this._repeat && this.time() > 0 && this.totalProgress() < 1))) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(wrapRepeats) - this._startTime) * this._timeScale;
		};

		return TimelineLite;

	}, true);








	
	
	
	
	
/*
 * ----------------------------------------------------------------
 * TimelineMax
 * ----------------------------------------------------------------
 */
	_gsScope._gsDefine("TimelineMax", ["TimelineLite","TweenLite","easing.Ease"], function(TimelineLite, TweenLite, Ease) {

		var TimelineMax = function(vars) {
				TimelineLite.call(this, vars);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._cycle = 0;
				this._yoyo = (this.vars.yoyo === true);
				this._dirty = true;
			},
			_tinyNum = 0.0000000001,
			TweenLiteInternals = TweenLite._internals,
			_lazyTweens = TweenLiteInternals.lazyTweens,
			_lazyRender = TweenLiteInternals.lazyRender,
			_globals = _gsScope._gsDefine.globals,
			_easeNone = new Ease(null, null, 1, 0),
			p = TimelineMax.prototype = new TimelineLite();

		p.constructor = TimelineMax;
		p.kill()._gc = false;
		TimelineMax.version = "1.20.4";

		p.invalidate = function() {
			this._yoyo = (this.vars.yoyo === true);
			this._repeat = this.vars.repeat || 0;
			this._repeatDelay = this.vars.repeatDelay || 0;
			this._uncache(true);
			return TimelineLite.prototype.invalidate.call(this);
		};

		p.addCallback = function(callback, position, params, scope) {
			return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
		};

		p.removeCallback = function(callback, position) {
			if (callback) {
				if (position == null) {
					this._kill(null, callback);
				} else {
					var a = this.getTweensOf(callback, false),
						i = a.length,
						time = this._parseTimeOrLabel(position);
					while (--i > -1) {
						if (a[i]._startTime === time) {
							a[i]._enabled(false, false);
						}
					}
				}
			}
			return this;
		};

		p.removePause = function(position) {
			return this.removeCallback(TimelineLite._internals.pauseCallback, position);
		};

		p.tweenTo = function(position, vars) {
			vars = vars || {};
			var copy = {ease:_easeNone, useFrames:this.usesFrames(), immediateRender:false, lazy:false},
				Engine = (vars.repeat && _globals.TweenMax) || TweenLite,
				duration, p, t;
			for (p in vars) {
				copy[p] = vars[p];
			}
			copy.time = this._parseTimeOrLabel(position);
			duration = (Math.abs(Number(copy.time) - this._time) / this._timeScale) || 0.001;
			t = new Engine(this, duration, copy);
			copy.onStart = function() {
				t.target.paused(true);
				if (t.vars.time !== t.target.time() && duration === t.duration() && !t.isFromTo) { //don't make the duration zero - if it's supposed to be zero, don't worry because it's already initting the tween and will complete immediately, effectively making the duration zero anyway. If we make duration zero, the tween won't run at all.
					t.duration( Math.abs( t.vars.time - t.target.time()) / t.target._timeScale ).render(t.time(), true, true); //render() right away to ensure that things look right, especially in the case of .tweenTo(0).
				}
				if (vars.onStart) { //in case the user had an onStart in the vars - we don't want to overwrite it.
					vars.onStart.apply(vars.onStartScope || vars.callbackScope || t, vars.onStartParams || []); //don't use t._callback("onStart") or it'll point to the copy.onStart and we'll get a recursion error.
				}
			};
			return t;
		};

		p.tweenFromTo = function(fromPosition, toPosition, vars) {
			vars = vars || {};
			fromPosition = this._parseTimeOrLabel(fromPosition);
			vars.startAt = {onComplete:this.seek, onCompleteParams:[fromPosition], callbackScope:this};
			vars.immediateRender = (vars.immediateRender !== false);
			var t = this.tweenTo(toPosition, vars);
			t.isFromTo = 1; //to ensure we don't mess with the duration in the onStart (we've got the start and end values here, so lock it in)
			return t.duration((Math.abs( t.vars.time - fromPosition) / this._timeScale) || 0.001);
		};

		p.render = function(time, suppressEvents, force) {
			if (this._gc) {
				this._enabled(true, false);
			}
			var prevTime = this._time,
				totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
				dur = this._duration,
				prevTotalTime = this._totalTime,
				prevStart = this._startTime,
				prevTimeScale = this._timeScale,
				prevRawPrevTime = this._rawPrevTime,
				prevPaused = this._paused,
				prevCycle = this._cycle,
				tween, isComplete, next, callback, internalForce, cycleDuration, pauseTween, curTime;
			if (prevTime !== this._time) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
				time += this._time - prevTime;
			}
			if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
				if (!this._locked) {
					this._totalTime = totalDur;
					this._cycle = this._repeat;
				}
				if (!this._reversed) if (!this._hasPausedChild()) {
					isComplete = true;
					callback = "onComplete";
					internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || prevRawPrevTime < 0 || prevRawPrevTime === _tinyNum) if (prevRawPrevTime !== time && this._first) {
						internalForce = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
				}
				this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				if (this._yoyo && (this._cycle & 1) !== 0) {
					this._time = time = 0;
				} else {
					this._time = dur;
					time = dur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7. We cannot do less then 0.0001 because the same issue can occur when the duration is extremely large like 999999999999 in which case adding 0.00000001, for example, causes it to act like nothing was added.
				}

			} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
				if (!this._locked) {
					this._totalTime = this._cycle = 0;
				}
				this._time = 0;
				if (prevTime !== 0 || (dur === 0 && prevRawPrevTime !== _tinyNum && (prevRawPrevTime > 0 || (time < 0 && prevRawPrevTime >= 0)) && !this._locked)) { //edge case for checking time < 0 && prevRawPrevTime >= 0: a zero-duration fromTo() tween inside a zero-duration timeline (yeah, very rare)
					callback = "onReverseComplete";
					isComplete = this._reversed;
				}
				if (time < 0) {
					this._active = false;
					if (this._timeline.autoRemoveChildren && this._reversed) {
						internalForce = isComplete = true;
						callback = "onReverseComplete";
					} else if (prevRawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
						internalForce = true;
					}
					this._rawPrevTime = time;
				} else {
					this._rawPrevTime = (dur || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
						tween = this._first;
						while (tween && tween._startTime === 0) {
							if (!tween._duration) {
								isComplete = false;
							}
							tween = tween._next;
						}
					}
					time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
					if (!this._initted) {
						internalForce = true;
					}
				}

			} else {
				if (dur === 0 && prevRawPrevTime < 0) { //without this, zero-duration repeating timelines (like with a simple callback nested at the very beginning and a repeatDelay) wouldn't render the first time through.
					internalForce = true;
				}
				this._time = this._rawPrevTime = time;
				if (!this._locked) {
					this._totalTime = time;
					if (this._repeat !== 0) {
						cycleDuration = dur + this._repeatDelay;
						this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but it gets reported as 0.79999999!)
						if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
							this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
						}
						this._time = this._totalTime - (this._cycle * cycleDuration);
						if (this._yoyo) if ((this._cycle & 1) !== 0) {
							this._time = dur - this._time;
						}
						if (this._time > dur) {
							this._time = dur;
							time = dur + 0.0001; //to avoid occasional floating point rounding error
						} else if (this._time < 0) {
							this._time = time = 0;
						} else {
							time = this._time;
						}
					}
				}

				if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
					time = this._time;
					if (time >= prevTime || (this._repeat && prevCycle !== this._cycle)) {
						tween = this._first;
						while (tween && tween._startTime <= time && !pauseTween) {
							if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
								pauseTween = tween;
							}
							tween = tween._next;
						}
					} else {
						tween = this._last;
						while (tween && tween._startTime >= time && !pauseTween) {
							if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
								pauseTween = tween;
							}
							tween = tween._prev;
						}
					}
					if (pauseTween && pauseTween._startTime < dur) {
						this._time = time = pauseTween._startTime;
						this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
					}
				}

			}

			if (this._cycle !== prevCycle) if (!this._locked) {
				/*
				make sure children at the end/beginning of the timeline are rendered properly. If, for example,
				a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
				would get transated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
				could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
				we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
				ensure that zero-duration tweens at the very beginning or end of the TimelineMax work.
				*/
				var backwards = (this._yoyo && (prevCycle & 1) !== 0),
					wrap = (backwards === (this._yoyo && (this._cycle & 1) !== 0)),
					recTotalTime = this._totalTime,
					recCycle = this._cycle,
					recRawPrevTime = this._rawPrevTime,
					recTime = this._time;

				this._totalTime = prevCycle * dur;
				if (this._cycle < prevCycle) {
					backwards = !backwards;
				} else {
					this._totalTime += dur;
				}
				this._time = prevTime; //temporarily revert _time so that render() renders the children in the correct order. Without this, tweens won't rewind correctly. We could arhictect things in a "cleaner" way by splitting out the rendering queue into a separate method but for performance reasons, we kept it all inside this method.

				this._rawPrevTime = (dur === 0) ? prevRawPrevTime - 0.0001 : prevRawPrevTime;
				this._cycle = prevCycle;
				this._locked = true; //prevents changes to totalTime and skips repeat/yoyo behavior when we recursively call render()
				prevTime = (backwards) ? 0 : dur;
				this.render(prevTime, suppressEvents, (dur === 0));
				if (!suppressEvents) if (!this._gc) {
					if (this.vars.onRepeat) {
						this._cycle = recCycle; //in case the onRepeat alters the playhead or invalidates(), we shouldn't stay locked or use the previous cycle.
						this._locked = false;
						this._callback("onRepeat");
					}
				}
				if (prevTime !== this._time) { //in case there's a callback like onComplete in a nested tween/timeline that changes the playhead position, like via seek(), we should just abort.
					return;
				}
				if (wrap) {
					this._cycle = prevCycle; //if there's an onRepeat, we reverted this above, so make sure it's set properly again. We also unlocked in that scenario, so reset that too.
					this._locked = true;
					prevTime = (backwards) ? dur + 0.0001 : -0.0001;
					this.render(prevTime, true, false);
				}
				this._locked = false;
				if (this._paused && !prevPaused) { //if the render() triggered callback that paused this timeline, we should abort (very rare, but possible)
					return;
				}
				this._time = recTime;
				this._totalTime = recTotalTime;
				this._cycle = recCycle;
				this._rawPrevTime = recRawPrevTime;
			}

			if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
				if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
					this._callback("onUpdate");
				}
				return;
			} else if (!this._initted) {
				this._initted = true;
			}

			if (!this._active) if (!this._paused && this._totalTime !== prevTotalTime && time > 0) {
				this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
			}

			if (prevTotalTime === 0) if (this.vars.onStart) if (this._totalTime !== 0 || !this._totalDuration) if (!suppressEvents) {
				this._callback("onStart");
			}

			curTime = this._time;
			if (curTime >= prevTime) {
				tween = this._first;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
						break;
					} else if (tween._active || (tween._startTime <= this._time && !tween._paused && !tween._gc)) {
						if (pauseTween === tween) {
							this.pause();
						}
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			} else {
				tween = this._last;
				while (tween) {
					next = tween._prev; //record it here because the value could change after rendering...
					if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
						break;
					} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
						if (pauseTween === tween) {
							pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
							while (pauseTween && pauseTween.endTime() > this._time) {
								pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
								pauseTween = pauseTween._prev;
							}
							pauseTween = null;
							this.pause();
						}
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			}

			if (this._onUpdate) if (!suppressEvents) {
				if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
					_lazyRender();
				}
				this._callback("onUpdate");
			}
			if (callback) if (!this._locked) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
				if (isComplete) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					if (this._timeline.autoRemoveChildren) {
						this._enabled(false, false);
					}
					this._active = false;
				}
				if (!suppressEvents && this.vars[callback]) {
					this._callback(callback);
				}
			}
		};

		p.getActive = function(nested, tweens, timelines) {
			if (nested == null) {
				nested = true;
			}
			if (tweens == null) {
				tweens = true;
			}
			if (timelines == null) {
				timelines = false;
			}
			var a = [],
				all = this.getChildren(nested, tweens, timelines),
				cnt = 0,
				l = all.length,
				i, tween;
			for (i = 0; i < l; i++) {
				tween = all[i];
				if (tween.isActive()) {
					a[cnt++] = tween;
				}
			}
			return a;
		};


		p.getLabelAfter = function(time) {
			if (!time) if (time !== 0) { //faster than isNan()
				time = this._time;
			}
			var labels = this.getLabelsArray(),
				l = labels.length,
				i;
			for (i = 0; i < l; i++) {
				if (labels[i].time > time) {
					return labels[i].name;
				}
			}
			return null;
		};

		p.getLabelBefore = function(time) {
			if (time == null) {
				time = this._time;
			}
			var labels = this.getLabelsArray(),
				i = labels.length;
			while (--i > -1) {
				if (labels[i].time < time) {
					return labels[i].name;
				}
			}
			return null;
		};

		p.getLabelsArray = function() {
			var a = [],
				cnt = 0,
				p;
			for (p in this._labels) {
				a[cnt++] = {time:this._labels[p], name:p};
			}
			a.sort(function(a,b) {
				return a.time - b.time;
			});
			return a;
		};

		p.invalidate = function() {
			this._locked = false; //unlock and set cycle in case invalidate() is called from inside an onRepeat
			return TimelineLite.prototype.invalidate.call(this);
		};


//---- GETTERS / SETTERS -------------------------------------------------------------------------------------------------------

		p.progress = function(value, suppressEvents) {
			return (!arguments.length) ? (this._time / this.duration()) || 0 : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
		};

		p.totalProgress = function(value, suppressEvents) {
			return (!arguments.length) ? (this._totalTime / this.totalDuration()) || 0 : this.totalTime( this.totalDuration() * value, suppressEvents);
		};

		p.totalDuration = function(value) {
			if (!arguments.length) {
				if (this._dirty) {
					TimelineLite.prototype.totalDuration.call(this); //just forces refresh
					//Instead of Infinity, we use 999999999999 so that we can accommodate reverses.
					this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
				}
				return this._totalDuration;
			}
			return (this._repeat === -1 || !value) ? this : this.timeScale( this.totalDuration() / value );
		};

		p.time = function(value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			if (value > this._duration) {
				value = this._duration;
			}
			if (this._yoyo && (this._cycle & 1) !== 0) {
				value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
			} else if (this._repeat !== 0) {
				value += this._cycle * (this._duration + this._repeatDelay);
			}
			return this.totalTime(value, suppressEvents);
		};

		p.repeat = function(value) {
			if (!arguments.length) {
				return this._repeat;
			}
			this._repeat = value;
			return this._uncache(true);
		};

		p.repeatDelay = function(value) {
			if (!arguments.length) {
				return this._repeatDelay;
			}
			this._repeatDelay = value;
			return this._uncache(true);
		};

		p.yoyo = function(value) {
			if (!arguments.length) {
				return this._yoyo;
			}
			this._yoyo = value;
			return this;
		};

		p.currentLabel = function(value) {
			if (!arguments.length) {
				return this.getLabelBefore(this._time + 0.00000001);
			}
			return this.seek(value, true);
		};

		return TimelineMax;

	}, true);
	




	
	
	
	
	

	
/*
 * ----------------------------------------------------------------
 * BezierPlugin
 * ----------------------------------------------------------------
 */
	(function() {

		var _RAD2DEG = 180 / Math.PI,
			_r1 = [],
			_r2 = [],
			_r3 = [],
			_corProps = {},
			_globals = _gsScope._gsDefine.globals,
			Segment = function(a, b, c, d) {
				if (c === d) { //if c and d match, the final autoRotate value could lock at -90 degrees, so differentiate them slightly.
					c = d - (d - b) / 1000000;
				}
				if (a === b) { //if a and b match, the starting autoRotate value could lock at -90 degrees, so differentiate them slightly.
					b = a + (c - a) / 1000000;
				}
				this.a = a;
				this.b = b;
				this.c = c;
				this.d = d;
				this.da = d - a;
				this.ca = c - a;
				this.ba = b - a;
			},
			_correlate = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
			cubicToQuadratic = function(a, b, c, d) {
				var q1 = {a:a},
					q2 = {},
					q3 = {},
					q4 = {c:d},
					mab = (a + b) / 2,
					mbc = (b + c) / 2,
					mcd = (c + d) / 2,
					mabc = (mab + mbc) / 2,
					mbcd = (mbc + mcd) / 2,
					m8 = (mbcd - mabc) / 8;
				q1.b = mab + (a - mab) / 4;
				q2.b = mabc + m8;
				q1.c = q2.a = (q1.b + q2.b) / 2;
				q2.c = q3.a = (mabc + mbcd) / 2;
				q3.b = mbcd - m8;
				q4.b = mcd + (d - mcd) / 4;
				q3.c = q4.a = (q3.b + q4.b) / 2;
				return [q1, q2, q3, q4];
			},
			_calculateControlPoints = function(a, curviness, quad, basic, correlate) {
				var l = a.length - 1,
					ii = 0,
					cp1 = a[0].a,
					i, p1, p2, p3, seg, m1, m2, mm, cp2, qb, r1, r2, tl;
				for (i = 0; i < l; i++) {
					seg = a[ii];
					p1 = seg.a;
					p2 = seg.d;
					p3 = a[ii+1].d;

					if (correlate) {
						r1 = _r1[i];
						r2 = _r2[i];
						tl = ((r2 + r1) * curviness * 0.25) / (basic ? 0.5 : _r3[i] || 0.5);
						m1 = p2 - (p2 - p1) * (basic ? curviness * 0.5 : (r1 !== 0 ? tl / r1 : 0));
						m2 = p2 + (p3 - p2) * (basic ? curviness * 0.5 : (r2 !== 0 ? tl / r2 : 0));
						mm = p2 - (m1 + (((m2 - m1) * ((r1 * 3 / (r1 + r2)) + 0.5) / 4) || 0));
					} else {
						m1 = p2 - (p2 - p1) * curviness * 0.5;
						m2 = p2 + (p3 - p2) * curviness * 0.5;
						mm = p2 - (m1 + m2) / 2;
					}
					m1 += mm;
					m2 += mm;

					seg.c = cp2 = m1;
					if (i !== 0) {
						seg.b = cp1;
					} else {
						seg.b = cp1 = seg.a + (seg.c - seg.a) * 0.6; //instead of placing b on a exactly, we move it inline with c so that if the user specifies an ease like Back.easeIn or Elastic.easeIn which goes BEYOND the beginning, it will do so smoothly.
					}

					seg.da = p2 - p1;
					seg.ca = cp2 - p1;
					seg.ba = cp1 - p1;

					if (quad) {
						qb = cubicToQuadratic(p1, cp1, cp2, p2);
						a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
						ii += 4;
					} else {
						ii++;
					}

					cp1 = m2;
				}
				seg = a[ii];
				seg.b = cp1;
				seg.c = cp1 + (seg.d - cp1) * 0.4; //instead of placing c on d exactly, we move it inline with b so that if the user specifies an ease like Back.easeOut or Elastic.easeOut which goes BEYOND the end, it will do so smoothly.
				seg.da = seg.d - seg.a;
				seg.ca = seg.c - seg.a;
				seg.ba = cp1 - seg.a;
				if (quad) {
					qb = cubicToQuadratic(seg.a, cp1, seg.c, seg.d);
					a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
				}
			},
			_parseAnchors = function(values, p, correlate, prepend) {
				var a = [],
					l, i, p1, p2, p3, tmp;
				if (prepend) {
					values = [prepend].concat(values);
					i = values.length;
					while (--i > -1) {
						if (typeof( (tmp = values[i][p]) ) === "string") if (tmp.charAt(1) === "=") {
							values[i][p] = prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)); //accommodate relative values. Do it inline instead of breaking it out into a function for speed reasons
						}
					}
				}
				l = values.length - 2;
				if (l < 0) {
					a[0] = new Segment(values[0][p], 0, 0, values[0][p]);
					return a;
				}
				for (i = 0; i < l; i++) {
					p1 = values[i][p];
					p2 = values[i+1][p];
					a[i] = new Segment(p1, 0, 0, p2);
					if (correlate) {
						p3 = values[i+2][p];
						_r1[i] = (_r1[i] || 0) + (p2 - p1) * (p2 - p1);
						_r2[i] = (_r2[i] || 0) + (p3 - p2) * (p3 - p2);
					}
				}
				a[i] = new Segment(values[i][p], 0, 0, values[i+1][p]);
				return a;
			},
			bezierThrough = function(values, curviness, quadratic, basic, correlate, prepend) {
				var obj = {},
					props = [],
					first = prepend || values[0],
					i, p, a, j, r, l, seamless, last;
				correlate = (typeof(correlate) === "string") ? ","+correlate+"," : _correlate;
				if (curviness == null) {
					curviness = 1;
				}
				for (p in values[0]) {
					props.push(p);
				}
				//check to see if the last and first values are identical (well, within 0.05). If so, make seamless by appending the second element to the very end of the values array and the 2nd-to-last element to the very beginning (we'll remove those segments later)
				if (values.length > 1) {
					last = values[values.length - 1];
					seamless = true;
					i = props.length;
					while (--i > -1) {
						p = props[i];
						if (Math.abs(first[p] - last[p]) > 0.05) { //build in a tolerance of +/-0.05 to accommodate rounding errors.
							seamless = false;
							break;
						}
					}
					if (seamless) {
						values = values.concat(); //duplicate the array to avoid contaminating the original which the user may be reusing for other tweens
						if (prepend) {
							values.unshift(prepend);
						}
						values.push(values[1]);
						prepend = values[values.length - 3];
					}
				}
				_r1.length = _r2.length = _r3.length = 0;
				i = props.length;
				while (--i > -1) {
					p = props[i];
					_corProps[p] = (correlate.indexOf(","+p+",") !== -1);
					obj[p] = _parseAnchors(values, p, _corProps[p], prepend);
				}
				i = _r1.length;
				while (--i > -1) {
					_r1[i] = Math.sqrt(_r1[i]);
					_r2[i] = Math.sqrt(_r2[i]);
				}
				if (!basic) {
					i = props.length;
					while (--i > -1) {
						if (_corProps[p]) {
							a = obj[props[i]];
							l = a.length - 1;
							for (j = 0; j < l; j++) {
								r = (a[j+1].da / _r2[j] + a[j].da / _r1[j]) || 0;
								_r3[j] = (_r3[j] || 0) + r * r;
							}
						}
					}
					i = _r3.length;
					while (--i > -1) {
						_r3[i] = Math.sqrt(_r3[i]);
					}
				}
				i = props.length;
				j = quadratic ? 4 : 1;
				while (--i > -1) {
					p = props[i];
					a = obj[p];
					_calculateControlPoints(a, curviness, quadratic, basic, _corProps[p]); //this method requires that _parseAnchors() and _setSegmentRatios() ran first so that _r1, _r2, and _r3 values are populated for all properties
					if (seamless) {
						a.splice(0, j);
						a.splice(a.length - j, j);
					}
				}
				return obj;
			},
			_parseBezierData = function(values, type, prepend) {
				type = type || "soft";
				var obj = {},
					inc = (type === "cubic") ? 3 : 2,
					soft = (type === "soft"),
					props = [],
					a, b, c, d, cur, i, j, l, p, cnt, tmp;
				if (soft && prepend) {
					values = [prepend].concat(values);
				}
				if (values == null || values.length < inc + 1) { throw "invalid Bezier data"; }
				for (p in values[0]) {
					props.push(p);
				}
				i = props.length;
				while (--i > -1) {
					p = props[i];
					obj[p] = cur = [];
					cnt = 0;
					l = values.length;
					for (j = 0; j < l; j++) {
						a = (prepend == null) ? values[j][p] : (typeof( (tmp = values[j][p]) ) === "string" && tmp.charAt(1) === "=") ? prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)) : Number(tmp);
						if (soft) if (j > 1) if (j < l - 1) {
							cur[cnt++] = (a + cur[cnt-2]) / 2;
						}
						cur[cnt++] = a;
					}
					l = cnt - inc + 1;
					cnt = 0;
					for (j = 0; j < l; j += inc) {
						a = cur[j];
						b = cur[j+1];
						c = cur[j+2];
						d = (inc === 2) ? 0 : cur[j+3];
						cur[cnt++] = tmp = (inc === 3) ? new Segment(a, b, c, d) : new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
					}
					cur.length = cnt;
				}
				return obj;
			},
			_addCubicLengths = function(a, steps, resolution) {
				var inc = 1 / resolution,
					j = a.length,
					d, d1, s, da, ca, ba, p, i, inv, bez, index;
				while (--j > -1) {
					bez = a[j];
					s = bez.a;
					da = bez.d - s;
					ca = bez.c - s;
					ba = bez.b - s;
					d = d1 = 0;
					for (i = 1; i <= resolution; i++) {
						p = inc * i;
						inv = 1 - p;
						d = d1 - (d1 = (p * p * da + 3 * inv * (p * ca + inv * ba)) * p);
						index = j * resolution + i - 1;
						steps[index] = (steps[index] || 0) + d * d;
					}
				}
			},
			_parseLengthData = function(obj, resolution) {
				resolution = resolution >> 0 || 6;
				var a = [],
					lengths = [],
					d = 0,
					total = 0,
					threshold = resolution - 1,
					segments = [],
					curLS = [], //current length segments array
					p, i, l, index;
				for (p in obj) {
					_addCubicLengths(obj[p], a, resolution);
				}
				l = a.length;
				for (i = 0; i < l; i++) {
					d += Math.sqrt(a[i]);
					index = i % resolution;
					curLS[index] = d;
					if (index === threshold) {
						total += d;
						index = (i / resolution) >> 0;
						segments[index] = curLS;
						lengths[index] = total;
						d = 0;
						curLS = [];
					}
				}
				return {length:total, lengths:lengths, segments:segments};
			},



			BezierPlugin = _gsScope._gsDefine.plugin({
					propName: "bezier",
					priority: -1,
					version: "1.3.8",
					API: 2,
					global:true,

					//gets called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
					init: function(target, vars, tween) {
						this._target = target;
						if (vars instanceof Array) {
							vars = {values:vars};
						}
						this._func = {};
						this._mod = {};
						this._props = [];
						this._timeRes = (vars.timeResolution == null) ? 6 : parseInt(vars.timeResolution, 10);
						var values = vars.values || [],
							first = {},
							second = values[0],
							autoRotate = vars.autoRotate || tween.vars.orientToBezier,
							p, isFunc, i, j, prepend;

						this._autoRotate = autoRotate ? (autoRotate instanceof Array) ? autoRotate : [["x","y","rotation",((autoRotate === true) ? 0 : Number(autoRotate) || 0)]] : null;
						for (p in second) {
							this._props.push(p);
						}

						i = this._props.length;
						while (--i > -1) {
							p = this._props[i];

							this._overwriteProps.push(p);
							isFunc = this._func[p] = (typeof(target[p]) === "function");
							first[p] = (!isFunc) ? parseFloat(target[p]) : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]();
							if (!prepend) if (first[p] !== values[0][p]) {
								prepend = first;
							}
						}
						this._beziers = (vars.type !== "cubic" && vars.type !== "quadratic" && vars.type !== "soft") ? bezierThrough(values, isNaN(vars.curviness) ? 1 : vars.curviness, false, (vars.type === "thruBasic"), vars.correlate, prepend) : _parseBezierData(values, vars.type, first);
						this._segCount = this._beziers[p].length;

						if (this._timeRes) {
							var ld = _parseLengthData(this._beziers, this._timeRes);
							this._length = ld.length;
							this._lengths = ld.lengths;
							this._segments = ld.segments;
							this._l1 = this._li = this._s1 = this._si = 0;
							this._l2 = this._lengths[0];
							this._curSeg = this._segments[0];
							this._s2 = this._curSeg[0];
							this._prec = 1 / this._curSeg.length;
						}

						if ((autoRotate = this._autoRotate)) {
							this._initialRotations = [];
							if (!(autoRotate[0] instanceof Array)) {
								this._autoRotate = autoRotate = [autoRotate];
							}
							i = autoRotate.length;
							while (--i > -1) {
								for (j = 0; j < 3; j++) {
									p = autoRotate[i][j];
									this._func[p] = (typeof(target[p]) === "function") ? target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ] : false;
								}
								p = autoRotate[i][2];
								this._initialRotations[i] = (this._func[p] ? this._func[p].call(this._target) : this._target[p]) || 0;
								this._overwriteProps.push(p);
							}
						}
						this._startRatio = tween.vars.runBackwards ? 1 : 0; //we determine the starting ratio when the tween inits which is always 0 unless the tween has runBackwards:true (indicating it's a from() tween) in which case it's 1.
						return true;
					},

					//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
					set: function(v) {
						var segments = this._segCount,
							func = this._func,
							target = this._target,
							notStart = (v !== this._startRatio),
							curIndex, inv, i, p, b, t, val, l, lengths, curSeg;
						if (!this._timeRes) {
							curIndex = (v < 0) ? 0 : (v >= 1) ? segments - 1 : (segments * v) >> 0;
							t = (v - (curIndex * (1 / segments))) * segments;
						} else {
							lengths = this._lengths;
							curSeg = this._curSeg;
							v *= this._length;
							i = this._li;
							//find the appropriate segment (if the currently cached one isn't correct)
							if (v > this._l2 && i < segments - 1) {
								l = segments - 1;
								while (i < l && (this._l2 = lengths[++i]) <= v) {	}
								this._l1 = lengths[i-1];
								this._li = i;
								this._curSeg = curSeg = this._segments[i];
								this._s2 = curSeg[(this._s1 = this._si = 0)];
							} else if (v < this._l1 && i > 0) {
								while (i > 0 && (this._l1 = lengths[--i]) >= v) { }
								if (i === 0 && v < this._l1) {
									this._l1 = 0;
								} else {
									i++;
								}
								this._l2 = lengths[i];
								this._li = i;
								this._curSeg = curSeg = this._segments[i];
								this._s1 = curSeg[(this._si = curSeg.length - 1) - 1] || 0;
								this._s2 = curSeg[this._si];
							}
							curIndex = i;
							//now find the appropriate sub-segment (we split it into the number of pieces that was defined by "precision" and measured each one)
							v -= this._l1;
							i = this._si;
							if (v > this._s2 && i < curSeg.length - 1) {
								l = curSeg.length - 1;
								while (i < l && (this._s2 = curSeg[++i]) <= v) {	}
								this._s1 = curSeg[i-1];
								this._si = i;
							} else if (v < this._s1 && i > 0) {
								while (i > 0 && (this._s1 = curSeg[--i]) >= v) {	}
								if (i === 0 && v < this._s1) {
									this._s1 = 0;
								} else {
									i++;
								}
								this._s2 = curSeg[i];
								this._si = i;
							}
							t = ((i + (v - this._s1) / (this._s2 - this._s1)) * this._prec) || 0;
						}
						inv = 1 - t;

						i = this._props.length;
						while (--i > -1) {
							p = this._props[i];
							b = this._beziers[p][curIndex];
							val = (t * t * b.da + 3 * inv * (t * b.ca + inv * b.ba)) * t + b.a;
							if (this._mod[p]) {
								val = this._mod[p](val, target);
							}
							if (func[p]) {
								target[p](val);
							} else {
								target[p] = val;
							}
						}

						if (this._autoRotate) {
							var ar = this._autoRotate,
								b2, x1, y1, x2, y2, add, conv;
							i = ar.length;
							while (--i > -1) {
								p = ar[i][2];
								add = ar[i][3] || 0;
								conv = (ar[i][4] === true) ? 1 : _RAD2DEG;
								b = this._beziers[ar[i][0]];
								b2 = this._beziers[ar[i][1]];

								if (b && b2) { //in case one of the properties got overwritten.
									b = b[curIndex];
									b2 = b2[curIndex];

									x1 = b.a + (b.b - b.a) * t;
									x2 = b.b + (b.c - b.b) * t;
									x1 += (x2 - x1) * t;
									x2 += ((b.c + (b.d - b.c) * t) - x2) * t;

									y1 = b2.a + (b2.b - b2.a) * t;
									y2 = b2.b + (b2.c - b2.b) * t;
									y1 += (y2 - y1) * t;
									y2 += ((b2.c + (b2.d - b2.c) * t) - y2) * t;

									val = notStart ? Math.atan2(y2 - y1, x2 - x1) * conv + add : this._initialRotations[i];

									if (this._mod[p]) {
										val = this._mod[p](val, target); //for modProps
									}

									if (func[p]) {
										target[p](val);
									} else {
										target[p] = val;
									}
								}
							}
						}
					}
			}),
			p = BezierPlugin.prototype;


		BezierPlugin.bezierThrough = bezierThrough;
		BezierPlugin.cubicToQuadratic = cubicToQuadratic;
		BezierPlugin._autoCSS = true; //indicates that this plugin can be inserted into the "css" object using the autoCSS feature of TweenLite
		BezierPlugin.quadraticToCubic = function(a, b, c) {
			return new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
		};

		BezierPlugin._cssRegister = function() {
			var CSSPlugin = _globals.CSSPlugin;
			if (!CSSPlugin) {
				return;
			}
			var _internals = CSSPlugin._internals,
				_parseToProxy = _internals._parseToProxy,
				_setPluginRatio = _internals._setPluginRatio,
				CSSPropTween = _internals.CSSPropTween;
			_internals._registerComplexSpecialProp("bezier", {parser:function(t, e, prop, cssp, pt, plugin) {
				if (e instanceof Array) {
					e = {values:e};
				}
				plugin = new BezierPlugin();
				var values = e.values,
					l = values.length - 1,
					pluginValues = [],
					v = {},
					i, p, data;
				if (l < 0) {
					return pt;
				}
				for (i = 0; i <= l; i++) {
					data = _parseToProxy(t, values[i], cssp, pt, plugin, (l !== i));
					pluginValues[i] = data.end;
				}
				for (p in e) {
					v[p] = e[p]; //duplicate the vars object because we need to alter some things which would cause problems if the user plans to reuse the same vars object for another tween.
				}
				v.values = pluginValues;
				pt = new CSSPropTween(t, "bezier", 0, 0, data.pt, 2);
				pt.data = data;
				pt.plugin = plugin;
				pt.setRatio = _setPluginRatio;
				if (v.autoRotate === 0) {
					v.autoRotate = true;
				}
				if (v.autoRotate && !(v.autoRotate instanceof Array)) {
					i = (v.autoRotate === true) ? 0 : Number(v.autoRotate);
					v.autoRotate = (data.end.left != null) ? [["left","top","rotation",i,false]] : (data.end.x != null) ? [["x","y","rotation",i,false]] : false;
				}
				if (v.autoRotate) {
					if (!cssp._transform) {
						cssp._enableTransforms(false);
					}
					data.autoRotate = cssp._target._gsTransform;
					data.proxy.rotation = data.autoRotate.rotation || 0;
					cssp._overwriteProps.push("rotation");
				}
				plugin._onInitTween(data.proxy, v, cssp._tween);
				return pt;
			}});
		};

		p._mod = function(lookup) {
			var op = this._overwriteProps,
				i = op.length,
				val;
			while (--i > -1) {
				val = lookup[op[i]];
				if (val && typeof(val) === "function") {
					this._mod[op[i]] = val;
				}
			}
		};

		p._kill = function(lookup) {
			var a = this._props,
				p, i;
			for (p in this._beziers) {
				if (p in lookup) {
					delete this._beziers[p];
					delete this._func[p];
					i = a.length;
					while (--i > -1) {
						if (a[i] === p) {
							a.splice(i, 1);
						}
					}
				}
			}
			a = this._autoRotate;
			if (a) {
				i = a.length;
				while (--i > -1) {
					if (lookup[a[i][2]]) {
						a.splice(i, 1);
					}
				}
			}
			return this._super._kill.call(this, lookup);
		};

	}());






	
	
	
	
	
	
	
	
/*
 * ----------------------------------------------------------------
 * CSSPlugin
 * ----------------------------------------------------------------
 */
	_gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin","TweenLite"], function(TweenPlugin, TweenLite) {

		/** @constructor **/
		var CSSPlugin = function() {
				TweenPlugin.call(this, "css");
				this._overwriteProps.length = 0;
				this.setRatio = CSSPlugin.prototype.setRatio; //speed optimization (avoid prototype lookup on this "hot" method)
			},
			_globals = _gsScope._gsDefine.globals,
			_hasPriority, //turns true whenever a CSSPropTween instance is created that has a priority other than 0. This helps us discern whether or not we should spend the time organizing the linked list or not after a CSSPlugin's _onInitTween() method is called.
			_suffixMap, //we set this in _onInitTween() each time as a way to have a persistent variable we can use in other methods like _parse() without having to pass it around as a parameter and we keep _parse() decoupled from a particular CSSPlugin instance
			_cs, //computed style (we store this in a shared variable to conserve memory and make minification tighter
			_overwriteProps, //alias to the currently instantiating CSSPlugin's _overwriteProps array. We use this closure in order to avoid having to pass a reference around from method to method and aid in minification.
			_specialProps = {},
			p = CSSPlugin.prototype = new TweenPlugin("css");

		p.constructor = CSSPlugin;
		CSSPlugin.version = "1.20.4";
		CSSPlugin.API = 2;
		CSSPlugin.defaultTransformPerspective = 0;
		CSSPlugin.defaultSkewType = "compensated";
		CSSPlugin.defaultSmoothOrigin = true;
		p = "px"; //we'll reuse the "p" variable to keep file size down
		CSSPlugin.suffixMap = {top:p, right:p, bottom:p, left:p, width:p, height:p, fontSize:p, padding:p, margin:p, perspective:p, lineHeight:""};


		var _numExp = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
			_relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
			_valuesExp = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, //finds all the values that begin with numbers or += or -= and then a number. Includes suffixes. We use this to split complex values apart like "1px 5px 20px rgb(255,102,51)"
			_NaNExp = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, //also allows scientific notation and doesn't kill the leading -/+ in -= and +=
			_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
			_opacityExp = /opacity *= *([^)]*)/i,
			_opacityValExp = /opacity:([^;]*)/i,
			_alphaFilterExp = /alpha\(opacity *=.+?\)/i,
			_rgbhslExp = /^(rgb|hsl)/,
			_capsExp = /([A-Z])/g,
			_camelExp = /-([a-z])/gi,
			_urlExp = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, //for pulling out urls from url(...) or url("...") strings (some browsers wrap urls in quotes, some don't when reporting things like backgroundImage)
			_camelFunc = function(s, g) { return g.toUpperCase(); },
			_horizExp = /(?:Left|Right|Width)/i,
			_ieGetMatrixExp = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
			_ieSetMatrixExp = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
			_commasOutsideParenExp = /,(?=[^\)]*(?:\(|$))/gi, //finds any commas that are not within parenthesis
			_complexExp = /[\s,\(]/i, //for testing a string to find if it has a space, comma, or open parenthesis (clues that it's a complex value)
			_DEG2RAD = Math.PI / 180,
			_RAD2DEG = 180 / Math.PI,
			_forcePT = {},
			_dummyElement = {style:{}},
			_doc = _gsScope.document || {createElement: function() {return _dummyElement;}},
			_createElement = function(type, ns) {
				return _doc.createElementNS ? _doc.createElementNS(ns || "http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
			},
			_tempDiv = _createElement("div"),
			_tempImg = _createElement("img"),
			_internals = CSSPlugin._internals = {_specialProps:_specialProps}, //provides a hook to a few internal methods that we need to access from inside other plugins
			_agent = (_gsScope.navigator || {}).userAgent || "",
			_autoRound,
			_reqSafariFix, //we won't apply the Safari transform fix until we actually come across a tween that affects a transform property (to maintain best performance).

			_isSafari,
			_isFirefox, //Firefox has a bug that causes 3D transformed elements to randomly disappear unless a repaint is forced after each update on each element.
			_isSafariLT6, //Safari (and Android 4 which uses a flavor of Safari) has a bug that prevents changes to "top" and "left" properties from rendering properly if changed on the same frame as a transform UNLESS we set the element's WebkitBackfaceVisibility to hidden (weird, I know). Doing this for Android 3 and earlier seems to actually cause other problems, though (fun!)
			_ieVers,
			_supportsOpacity = (function() { //we set _isSafari, _ieVers, _isFirefox, and _supportsOpacity all in one function here to reduce file size slightly, especially in the minified version.
				var i = _agent.indexOf("Android"),
					a = _createElement("a");
				_isSafari = (_agent.indexOf("Safari") !== -1 && _agent.indexOf("Chrome") === -1 && (i === -1 || parseFloat(_agent.substr(i+8, 2)) > 3));
				_isSafariLT6 = (_isSafari && (parseFloat(_agent.substr(_agent.indexOf("Version/")+8, 2)) < 6));
				_isFirefox = (_agent.indexOf("Firefox") !== -1);
				if ((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(_agent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(_agent)) {
					_ieVers = parseFloat( RegExp.$1 );
				}
				if (!a) {
					return false;
				}
				a.style.cssText = "top:1px;opacity:.55;";
				return /^0.55/.test(a.style.opacity);
			}()),
			_getIEOpacity = function(v) {
				return (_opacityExp.test( ((typeof(v) === "string") ? v : (v.currentStyle ? v.currentStyle.filter : v.style.filter) || "") ) ? ( parseFloat( RegExp.$1 ) / 100 ) : 1);
			},
			_log = function(s) {//for logging messages, but in a way that won't throw errors in old versions of IE.
				if (_gsScope.console) {
					console.log(s);
				}
			},
			_target, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
			_index, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params

			_prefixCSS = "", //the non-camelCase vendor prefix like "-o-", "-moz-", "-ms-", or "-webkit-"
			_prefix = "", //camelCase vendor prefix like "O", "ms", "Webkit", or "Moz".

			// @private feed in a camelCase property name like "transform" and it will check to see if it is valid as-is or if it needs a vendor prefix. It returns the corrected camelCase property name (i.e. "WebkitTransform" or "MozTransform" or "transform" or null if no such property is found, like if the browser is IE8 or before, "transform" won't be found at all)
			_checkPropPrefix = function(p, e) {
				e = e || _tempDiv;
				var s = e.style,
					a, i;
				if (s[p] !== undefined) {
					return p;
				}
				p = p.charAt(0).toUpperCase() + p.substr(1);
				a = ["O","Moz","ms","Ms","Webkit"];
				i = 5;
				while (--i > -1 && s[a[i]+p] === undefined) { }
				if (i >= 0) {
					_prefix = (i === 3) ? "ms" : a[i];
					_prefixCSS = "-" + _prefix.toLowerCase() + "-";
					return _prefix + p;
				}
				return null;
			},

			_getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function() {},

			/**
			 * @private Returns the css style for a particular property of an element. For example, to get whatever the current "left" css value for an element with an ID of "myElement", you could do:
			 * var currentLeft = CSSPlugin.getStyle( document.getElementById("myElement"), "left");
			 *
			 * @param {!Object} t Target element whose style property you want to query
			 * @param {!string} p Property name (like "left" or "top" or "marginTop", etc.)
			 * @param {Object=} cs Computed style object. This just provides a way to speed processing if you're going to get several properties on the same element in quick succession - you can reuse the result of the getComputedStyle() call.
			 * @param {boolean=} calc If true, the value will not be read directly from the element's "style" property (if it exists there), but instead the getComputedStyle() result will be used. This can be useful when you want to ensure that the browser itself is interpreting the value.
			 * @param {string=} dflt Default value that should be returned in the place of null, "none", "auto" or "auto auto".
			 * @return {?string} The current property value
			 */
			_getStyle = CSSPlugin.getStyle = function(t, p, cs, calc, dflt) {
				var rv;
				if (!_supportsOpacity) if (p === "opacity") { //several versions of IE don't use the standard "opacity" property - they use things like filter:alpha(opacity=50), so we parse that here.
					return _getIEOpacity(t);
				}
				if (!calc && t.style[p]) {
					rv = t.style[p];
				} else if ((cs = cs || _getComputedStyle(t))) {
					rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
				} else if (t.currentStyle) {
					rv = t.currentStyle[p];
				}
				return (dflt != null && (!rv || rv === "none" || rv === "auto" || rv === "auto auto")) ? dflt : rv;
			},

			/**
			 * @private Pass the target element, the property name, the numeric value, and the suffix (like "%", "em", "px", etc.) and it will spit back the equivalent pixel number.
			 * @param {!Object} t Target element
			 * @param {!string} p Property name (like "left", "top", "marginLeft", etc.)
			 * @param {!number} v Value
			 * @param {string=} sfx Suffix (like "px" or "%" or "em")
			 * @param {boolean=} recurse If true, the call is a recursive one. In some browsers (like IE7/8), occasionally the value isn't accurately reported initially, but if we run the function again it will take effect.
			 * @return {number} value in pixels
			 */
			_convertToPixels = _internals.convertToPixels = function(t, p, v, sfx, recurse) {
				if (sfx === "px" || (!sfx && p !== "lineHeight")) { return v; }
				if (sfx === "auto" || !v) { return 0; }
				var horiz = _horizExp.test(p),
					node = t,
					style = _tempDiv.style,
					neg = (v < 0),
					precise = (v === 1),
					pix, cache, time;
				if (neg) {
					v = -v;
				}
				if (precise) {
					v *= 100;
				}
				if (p === "lineHeight" && !sfx) { //special case of when a simple lineHeight (without a unit) is used. Set it to the value, read back the computed value, and then revert.
					cache = _getComputedStyle(t).lineHeight;
					t.style.lineHeight = v;
					pix = parseFloat(_getComputedStyle(t).lineHeight);
					t.style.lineHeight = cache;
				} else if (sfx === "%" && p.indexOf("border") !== -1) {
					pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
				} else {
					style.cssText = "border:0 solid red;position:" + _getStyle(t, "position") + ";line-height:0;";
					if (sfx === "%" || !node.appendChild || sfx.charAt(0) === "v" || sfx === "rem") {
						node = t.parentNode || _doc.body;
						if (_getStyle(node, "display").indexOf("flex") !== -1) { //Edge and IE11 have a bug that causes offsetWidth to report as 0 if the container has display:flex and the child is position:relative. Switching to position: absolute solves it.
							style.position = "absolute";
						}
						cache = node._gsCache;
						time = TweenLite.ticker.frame;
						if (cache && horiz && cache.time === time) { //performance optimization: we record the width of elements along with the ticker frame so that we can quickly get it again on the same tick (seems relatively safe to assume it wouldn't change on the same tick)
							return cache.width * v / 100;
						}
						style[(horiz ? "width" : "height")] = v + sfx;
					} else {
						style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
					}
					node.appendChild(_tempDiv);
					pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
					node.removeChild(_tempDiv);
					if (horiz && sfx === "%" && CSSPlugin.cacheWidths !== false) {
						cache = node._gsCache = node._gsCache || {};
						cache.time = time;
						cache.width = pix / v * 100;
					}
					if (pix === 0 && !recurse) {
						pix = _convertToPixels(t, p, v, sfx, true);
					}
				}
				if (precise) {
					pix /= 100;
				}
				return neg ? -pix : pix;
			},
			_calculateOffset = _internals.calculateOffset = function(t, p, cs) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
				if (_getStyle(t, "position", cs) !== "absolute") { return 0; }
				var dim = ((p === "left") ? "Left" : "Top"),
					v = _getStyle(t, "margin" + dim, cs);
				return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), v.replace(_suffixExp, "")) || 0);
			},

			// @private returns at object containing ALL of the style properties in camelCase and their associated values.
			_getAllStyles = function(t, cs) {
				var s = {},
					i, tr, p;
				if ((cs = cs || _getComputedStyle(t, null))) {
					if ((i = cs.length)) {
						while (--i > -1) {
							p = cs[i];
							if (p.indexOf("-transform") === -1 || _transformPropCSS === p) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
								s[p.replace(_camelExp, _camelFunc)] = cs.getPropertyValue(p);
							}
						}
					} else { //some browsers behave differently - cs.length is always 0, so we must do a for...in loop.
						for (i in cs) {
							if (i.indexOf("Transform") === -1 || _transformProp === i) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
								s[i] = cs[i];
							}
						}
					}
				} else if ((cs = t.currentStyle || t.style)) {
					for (i in cs) {
						if (typeof(i) === "string" && s[i] === undefined) {
							s[i.replace(_camelExp, _camelFunc)] = cs[i];
						}
					}
				}
				if (!_supportsOpacity) {
					s.opacity = _getIEOpacity(t);
				}
				tr = _getTransform(t, cs, false);
				s.rotation = tr.rotation;
				s.skewX = tr.skewX;
				s.scaleX = tr.scaleX;
				s.scaleY = tr.scaleY;
				s.x = tr.x;
				s.y = tr.y;
				if (_supports3D) {
					s.z = tr.z;
					s.rotationX = tr.rotationX;
					s.rotationY = tr.rotationY;
					s.scaleZ = tr.scaleZ;
				}
				if (s.filters) {
					delete s.filters;
				}
				return s;
			},

			// @private analyzes two style objects (as returned by _getAllStyles()) and only looks for differences between them that contain tweenable values (like a number or color). It returns an object with a "difs" property which refers to an object containing only those isolated properties and values for tweening, and a "firstMPT" property which refers to the first MiniPropTween instance in a linked list that recorded all the starting values of the different properties so that we can revert to them at the end or beginning of the tween - we don't want the cascading to get messed up. The forceLookup parameter is an optional generic object with properties that should be forced into the results - this is necessary for className tweens that are overwriting others because imagine a scenario where a rollover/rollout adds/removes a class and the user swipes the mouse over the target SUPER fast, thus nothing actually changed yet and the subsequent comparison of the properties would indicate they match (especially when px rounding is taken into consideration), thus no tweening is necessary even though it SHOULD tween and remove those properties after the tween (otherwise the inline styles will contaminate things). See the className SpecialProp code for details.
			_cssDif = function(t, s1, s2, vars, forceLookup) {
				var difs = {},
					style = t.style,
					val, p, mpt;
				for (p in s2) {
					if (p !== "cssText") if (p !== "length") if (isNaN(p)) if (s1[p] !== (val = s2[p]) || (forceLookup && forceLookup[p])) if (p.indexOf("Origin") === -1) if (typeof(val) === "number" || typeof(val) === "string") {
						difs[p] = (val === "auto" && (p === "left" || p === "top")) ? _calculateOffset(t, p) : ((val === "" || val === "auto" || val === "none") && typeof(s1[p]) === "string" && s1[p].replace(_NaNExp, "") !== "") ? 0 : val; //if the ending value is defaulting ("" or "auto"), we check the starting value and if it can be parsed into a number (a string which could have a suffix too, like 700px), then we swap in 0 for "" or "auto" so that things actually tween.
						if (style[p] !== undefined) { //for className tweens, we must remember which properties already existed inline - the ones that didn't should be removed when the tween isn't in progress because they were only introduced to facilitate the transition between classes.
							mpt = new MiniPropTween(style, p, style[p], mpt);
						}
					}
				}
				if (vars) {
					for (p in vars) { //copy properties (except className)
						if (p !== "className") {
							difs[p] = vars[p];
						}
					}
				}
				return {difs:difs, firstMPT:mpt};
			},
			_dimensions = {width:["Left","Right"], height:["Top","Bottom"]},
			_margins = ["marginLeft","marginRight","marginTop","marginBottom"],

			/**
			 * @private Gets the width or height of an element
			 * @param {!Object} t Target element
			 * @param {!string} p Property name ("width" or "height")
			 * @param {Object=} cs Computed style object (if one exists). Just a speed optimization.
			 * @return {number} Dimension (in pixels)
			 */
			_getDimension = function(t, p, cs) {
				if ((t.nodeName + "").toLowerCase() === "svg") { //Chrome no longer supports offsetWidth/offsetHeight on SVG elements.
					return (cs || _getComputedStyle(t))[p] || 0;
				} else if (t.getCTM && _isSVG(t)) {
					return t.getBBox()[p] || 0;
				}
				var v = parseFloat((p === "width") ? t.offsetWidth : t.offsetHeight),
					a = _dimensions[p],
					i = a.length;
				cs = cs || _getComputedStyle(t, null);
				while (--i > -1) {
					v -= parseFloat( _getStyle(t, "padding" + a[i], cs, true) ) || 0;
					v -= parseFloat( _getStyle(t, "border" + a[i] + "Width", cs, true) ) || 0;
				}
				return v;
			},

			// @private Parses position-related complex strings like "top left" or "50px 10px" or "70% 20%", etc. which are used for things like transformOrigin or backgroundPosition. Optionally decorates a supplied object (recObj) with the following properties: "ox" (offsetX), "oy" (offsetY), "oxp" (if true, "ox" is a percentage not a pixel value), and "oxy" (if true, "oy" is a percentage not a pixel value)
			_parsePosition = function(v, recObj) {
				if (v === "contain" || v === "auto" || v === "auto auto") { //note: Firefox uses "auto auto" as default whereas Chrome uses "auto".
					return v + " ";
				}
				if (v == null || v === "") {
					v = "0 0";
				}
				var a = v.split(" "),
					x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
					y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1],
					i;
				if (a.length > 3 && !recObj) { //multiple positions
					a = v.split(", ").join(",").split(",");
					v = [];
					for (i = 0; i < a.length; i++) {
						v.push(_parsePosition(a[i]));
					}
					return v.join(",");
				}
				if (y == null) {
					y = (x === "center") ? "50%" : "0";
				} else if (y === "center") {
					y = "50%";
				}
				if (x === "center" || (isNaN(parseFloat(x)) && (x + "").indexOf("=") === -1)) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
					x = "50%";
				}
				v = x + " " + y + ((a.length > 2) ? " " + a[2] : "");
				if (recObj) {
					recObj.oxp = (x.indexOf("%") !== -1);
					recObj.oyp = (y.indexOf("%") !== -1);
					recObj.oxr = (x.charAt(1) === "=");
					recObj.oyr = (y.charAt(1) === "=");
					recObj.ox = parseFloat(x.replace(_NaNExp, ""));
					recObj.oy = parseFloat(y.replace(_NaNExp, ""));
					recObj.v = v;
				}
				return recObj || v;
			},

			/**
			 * @private Takes an ending value (typically a string, but can be a number) and a starting value and returns the change between the two, looking for relative value indicators like += and -= and it also ignores suffixes (but make sure the ending value starts with a number or +=/-= and that the starting value is a NUMBER!)
			 * @param {(number|string)} e End value which is typically a string, but could be a number
			 * @param {(number|string)} b Beginning value which is typically a string but could be a number
			 * @return {number} Amount of change between the beginning and ending values (relative values that have a "+=" or "-=" are recognized)
			 */
			_parseChange = function(e, b) {
				if (typeof(e) === "function") {
					e = e(_index, _target);
				}
				return (typeof(e) === "string" && e.charAt(1) === "=") ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : (parseFloat(e) - parseFloat(b)) || 0;
			},

			/**
			 * @private Takes a value and a default number, checks if the value is relative, null, or numeric and spits back a normalized number accordingly. Primarily used in the _parseTransform() function.
			 * @param {Object} v Value to be parsed
			 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
			 * @return {number} Parsed value
			 */
			_parseVal = function(v, d) {
				if (typeof(v) === "function") {
					v = v(_index, _target);
				}
				return (v == null) ? d : (typeof(v) === "string" && v.charAt(1) === "=") ? parseInt(v.charAt(0) + "1", 10) * parseFloat(v.substr(2)) + d : parseFloat(v) || 0;
			},

			/**
			 * @private Translates strings like "40deg" or "40" or 40rad" or "+=40deg" or "270_short" or "-90_cw" or "+=45_ccw" to a numeric radian angle. Of course a starting/default value must be fed in too so that relative values can be calculated properly.
			 * @param {Object} v Value to be parsed
			 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
			 * @param {string=} p property name for directionalEnd (optional - only used when the parsed value is directional ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation). Property name would be "rotation", "rotationX", or "rotationY"
			 * @param {Object=} directionalEnd An object that will store the raw end values for directional angles ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation.
			 * @return {number} parsed angle in radians
			 */
			_parseAngle = function(v, d, p, directionalEnd) {
				var min = 0.000001,
					cap, split, dif, result, isRelative;
				if (typeof(v) === "function") {
					v = v(_index, _target);
				}
				if (v == null) {
					result = d;
				} else if (typeof(v) === "number") {
					result = v;
				} else {
					cap = 360;
					split = v.split("_");
					isRelative = (v.charAt(1) === "=");
					dif = (isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(split[0].substr(2)) : parseFloat(split[0])) * ((v.indexOf("rad") === -1) ? 1 : _RAD2DEG) - (isRelative ? 0 : d);
					if (split.length) {
						if (directionalEnd) {
							directionalEnd[p] = d + dif;
						}
						if (v.indexOf("short") !== -1) {
							dif = dif % cap;
							if (dif !== dif % (cap / 2)) {
								dif = (dif < 0) ? dif + cap : dif - cap;
							}
						}
						if (v.indexOf("_cw") !== -1 && dif < 0) {
							dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
						} else if (v.indexOf("ccw") !== -1 && dif > 0) {
							dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
						}
					}
					result = d + dif;
				}
				if (result < min && result > -min) {
					result = 0;
				}
				return result;
			},

			_colorLookup = {aqua:[0,255,255],
				lime:[0,255,0],
				silver:[192,192,192],
				black:[0,0,0],
				maroon:[128,0,0],
				teal:[0,128,128],
				blue:[0,0,255],
				navy:[0,0,128],
				white:[255,255,255],
				fuchsia:[255,0,255],
				olive:[128,128,0],
				yellow:[255,255,0],
				orange:[255,165,0],
				gray:[128,128,128],
				purple:[128,0,128],
				green:[0,128,0],
				red:[255,0,0],
				pink:[255,192,203],
				cyan:[0,255,255],
				transparent:[255,255,255,0]},

			_hue = function(h, m1, m2) {
				h = (h < 0) ? h + 1 : (h > 1) ? h - 1 : h;
				return ((((h * 6 < 1) ? m1 + (m2 - m1) * h * 6 : (h < 0.5) ? m2 : (h * 3 < 2) ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255) + 0.5) | 0;
			},

			/**
			 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if toHSL parameter is true, it will populate the array with hue, saturation, and lightness values. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
			 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
			 * @param {(boolean)} toHSL If true, an hsl() or hsla() value will be returned instead of rgb() or rgba()
			 * @return {Array.<number>} An array containing red, green, and blue (and optionally alpha) in that order, or if the toHSL parameter was true, the array will contain hue, saturation and lightness (and optionally alpha) in that order. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and toHSL is true.
			 */
			_parseColor = CSSPlugin.parseColor = function(v, toHSL) {
				var a, r, g, b, h, s, l, max, min, d, wasHSL;
				if (!v) {
					a = _colorLookup.black;
				} else if (typeof(v) === "number") {
					a = [v >> 16, (v >> 8) & 255, v & 255];
				} else {
					if (v.charAt(v.length - 1) === ",") { //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
						v = v.substr(0, v.length - 1);
					}
					if (_colorLookup[v]) {
						a = _colorLookup[v];
					} else if (v.charAt(0) === "#") {
						if (v.length === 4) { //for shorthand like #9F0
							r = v.charAt(1);
							g = v.charAt(2);
							b = v.charAt(3);
							v = "#" + r + r + g + g + b + b;
						}
						v = parseInt(v.substr(1), 16);
						a = [v >> 16, (v >> 8) & 255, v & 255];
					} else if (v.substr(0, 3) === "hsl") {
						a = wasHSL = v.match(_numExp);
						if (!toHSL) {
							h = (Number(a[0]) % 360) / 360;
							s = Number(a[1]) / 100;
							l = Number(a[2]) / 100;
							g = (l <= 0.5) ? l * (s + 1) : l + s - l * s;
							r = l * 2 - g;
							if (a.length > 3) {
								a[3] = Number(a[3]);
							}
							a[0] = _hue(h + 1 / 3, r, g);
							a[1] = _hue(h, r, g);
							a[2] = _hue(h - 1 / 3, r, g);
						} else if (v.indexOf("=") !== -1) { //if relative values are found, just return the raw strings with the relative prefixes in place.
							return v.match(_relNumExp);
						}
					} else {
						a = v.match(_numExp) || _colorLookup.transparent;
					}
					a[0] = Number(a[0]);
					a[1] = Number(a[1]);
					a[2] = Number(a[2]);
					if (a.length > 3) {
						a[3] = Number(a[3]);
					}
				}
				if (toHSL && !wasHSL) {
					r = a[0] / 255;
					g = a[1] / 255;
					b = a[2] / 255;
					max = Math.max(r, g, b);
					min = Math.min(r, g, b);
					l = (max + min) / 2;
					if (max === min) {
						h = s = 0;
					} else {
						d = max - min;
						s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
						h = (max === r) ? (g - b) / d + (g < b ? 6 : 0) : (max === g) ? (b - r) / d + 2 : (r - g) / d + 4;
						h *= 60;
					}
					a[0] = (h + 0.5) | 0;
					a[1] = (s * 100 + 0.5) | 0;
					a[2] = (l * 100 + 0.5) | 0;
				}
				return a;
			},
			_formatColors = function(s, toHSL) {
				var colors = s.match(_colorExp) || [],
					charIndex = 0,
					parsed = "",
					i, color, temp;
				if (!colors.length) {
					return s;
				}
				for (i = 0; i < colors.length; i++) {
					color = colors[i];
					temp = s.substr(charIndex, s.indexOf(color, charIndex)-charIndex);
					charIndex += temp.length + color.length;
					color = _parseColor(color, toHSL);
					if (color.length === 3) {
						color.push(1);
					}
					parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
				}
				return parsed + s.substr(charIndex);
			},
			_colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b"; //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.

		for (p in _colorLookup) {
			_colorExp += "|" + p + "\\b";
		}
		_colorExp = new RegExp(_colorExp+")", "gi");

		CSSPlugin.colorStringFilter = function(a) {
			var combined = a[0] + " " + a[1],
				toHSL;
			if (_colorExp.test(combined)) {
				toHSL = (combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1);
				a[0] = _formatColors(a[0], toHSL);
				a[1] = _formatColors(a[1], toHSL);
			}
			_colorExp.lastIndex = 0;
		};

		if (!TweenLite.defaultStringFilter) {
			TweenLite.defaultStringFilter = CSSPlugin.colorStringFilter;
		}

		/**
		 * @private Returns a formatter function that handles taking a string (or number in some cases) and returning a consistently formatted one in terms of delimiters, quantity of values, etc. For example, we may get boxShadow values defined as "0px red" or "0px 0px 10px rgb(255,0,0)" or "0px 0px 20px 20px #F00" and we need to ensure that what we get back is described with 4 numbers and a color. This allows us to feed it into the _parseComplex() method and split the values up appropriately. The neat thing about this _getFormatter() function is that the dflt defines a pattern as well as a default, so for example, _getFormatter("0px 0px 0px 0px #777", true) not only sets the default as 0px for all distances and #777 for the color, but also sets the pattern such that 4 numbers and a color will always get returned.
		 * @param {!string} dflt The default value and pattern to follow. So "0px 0px 0px 0px #777" will ensure that 4 numbers and a color will always get returned.
		 * @param {boolean=} clr If true, the values should be searched for color-related data. For example, boxShadow values typically contain a color whereas borderRadius don't.
		 * @param {boolean=} collapsible If true, the value is a top/left/right/bottom style one that acts like margin or padding, where if only one value is received, it's used for all 4; if 2 are received, the first is duplicated for 3rd (bottom) and the 2nd is duplicated for the 4th spot (left), etc.
		 * @return {Function} formatter function
		 */
		var _getFormatter = function(dflt, clr, collapsible, multi) {
				if (dflt == null) {
					return function(v) {return v;};
				}
				var dColor = clr ? (dflt.match(_colorExp) || [""])[0] : "",
					dVals = dflt.split(dColor).join("").match(_valuesExp) || [],
					pfx = dflt.substr(0, dflt.indexOf(dVals[0])),
					sfx = (dflt.charAt(dflt.length - 1) === ")") ? ")" : "",
					delim = (dflt.indexOf(" ") !== -1) ? " " : ",",
					numVals = dVals.length,
					dSfx = (numVals > 0) ? dVals[0].replace(_numExp, "") : "",
					formatter;
				if (!numVals) {
					return function(v) {return v;};
				}
				if (clr) {
					formatter = function(v) {
						var color, vals, i, a;
						if (typeof(v) === "number") {
							v += dSfx;
						} else if (multi && _commasOutsideParenExp.test(v)) {
							a = v.replace(_commasOutsideParenExp, "|").split("|");
							for (i = 0; i < a.length; i++) {
								a[i] = formatter(a[i]);
							}
							return a.join(",");
						}
						color = (v.match(_colorExp) || [dColor])[0];
						vals = v.split(color).join("").match(_valuesExp) || [];
						i = vals.length;
						if (numVals > i--) {
							while (++i < numVals) {
								vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
							}
						}
						return pfx + vals.join(delim) + delim + color + sfx + (v.indexOf("inset") !== -1 ? " inset" : "");
					};
					return formatter;

				}
				formatter = function(v) {
					var vals, a, i;
					if (typeof(v) === "number") {
						v += dSfx;
					} else if (multi && _commasOutsideParenExp.test(v)) {
						a = v.replace(_commasOutsideParenExp, "|").split("|");
						for (i = 0; i < a.length; i++) {
							a[i] = formatter(a[i]);
						}
						return a.join(",");
					}
					vals = v.match(_valuesExp) || [];
					i = vals.length;
					if (numVals > i--) {
						while (++i < numVals) {
							vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
						}
					}
					return pfx + vals.join(delim) + sfx;
				};
				return formatter;
			},

			/**
			 * @private returns a formatter function that's used for edge-related values like marginTop, marginLeft, paddingBottom, paddingRight, etc. Just pass a comma-delimited list of property names related to the edges.
			 * @param {!string} props a comma-delimited list of property names in order from top to left, like "marginTop,marginRight,marginBottom,marginLeft"
			 * @return {Function} a formatter function
			 */
			_getEdgeParser = function(props) {
				props = props.split(",");
				return function(t, e, p, cssp, pt, plugin, vars) {
					var a = (e + "").split(" "),
						i;
					vars = {};
					for (i = 0; i < 4; i++) {
						vars[props[i]] = a[i] = a[i] || a[(((i - 1) / 2) >> 0)];
					}
					return cssp.parse(t, vars, pt, plugin);
				};
			},

			// @private used when other plugins must tween values first, like BezierPlugin or ThrowPropsPlugin, etc. That plugin's setRatio() gets called first so that the values are updated, and then we loop through the MiniPropTweens which handle copying the values into their appropriate slots so that they can then be applied correctly in the main CSSPlugin setRatio() method. Remember, we typically create a proxy object that has a bunch of uniquely-named properties that we feed to the sub-plugin and it does its magic normally, and then we must interpret those values and apply them to the css because often numbers must get combined/concatenated, suffixes added, etc. to work with css, like boxShadow could have 4 values plus a color.
			_setPluginRatio = _internals._setPluginRatio = function(v) {
				this.plugin.setRatio(v);
				var d = this.data,
					proxy = d.proxy,
					mpt = d.firstMPT,
					min = 0.000001,
					val, pt, i, str, p;
				while (mpt) {
					val = proxy[mpt.v];
					if (mpt.r) {
						val = Math.round(val);
					} else if (val < min && val > -min) {
						val = 0;
					}
					mpt.t[mpt.p] = val;
					mpt = mpt._next;
				}
				if (d.autoRotate) {
					d.autoRotate.rotation = d.mod ? d.mod(proxy.rotation, this.t) : proxy.rotation; //special case for ModifyPlugin to hook into an auto-rotating bezier
				}
				//at the end, we must set the CSSPropTween's "e" (end) value dynamically here because that's what is used in the final setRatio() method. Same for "b" at the beginning.
				if (v === 1 || v === 0) {
					mpt = d.firstMPT;
					p = (v === 1) ? "e" : "b";
					while (mpt) {
						pt = mpt.t;
						if (!pt.type) {
							pt[p] = pt.s + pt.xs0;
						} else if (pt.type === 1) {
							str = pt.xs0 + pt.s + pt.xs1;
							for (i = 1; i < pt.l; i++) {
								str += pt["xn"+i] + pt["xs"+(i+1)];
							}
							pt[p] = str;
						}
						mpt = mpt._next;
					}
				}
			},

			/**
			 * @private @constructor Used by a few SpecialProps to hold important values for proxies. For example, _parseToProxy() creates a MiniPropTween instance for each property that must get tweened on the proxy, and we record the original property name as well as the unique one we create for the proxy, plus whether or not the value needs to be rounded plus the original value.
			 * @param {!Object} t target object whose property we're tweening (often a CSSPropTween)
			 * @param {!string} p property name
			 * @param {(number|string|object)} v value
			 * @param {MiniPropTween=} next next MiniPropTween in the linked list
			 * @param {boolean=} r if true, the tweened value should be rounded to the nearest integer
			 */
			MiniPropTween = function(t, p, v, next, r) {
				this.t = t;
				this.p = p;
				this.v = v;
				this.r = r;
				if (next) {
					next._prev = this;
					this._next = next;
				}
			},

			/**
			 * @private Most other plugins (like BezierPlugin and ThrowPropsPlugin and others) can only tween numeric values, but CSSPlugin must accommodate special values that have a bunch of extra data (like a suffix or strings between numeric values, etc.). For example, boxShadow has values like "10px 10px 20px 30px rgb(255,0,0)" which would utterly confuse other plugins. This method allows us to split that data apart and grab only the numeric data and attach it to uniquely-named properties of a generic proxy object ({}) so that we can feed that to virtually any plugin to have the numbers tweened. However, we must also keep track of which properties from the proxy go with which CSSPropTween values and instances. So we create a linked list of MiniPropTweens. Each one records a target (the original CSSPropTween), property (like "s" or "xn1" or "xn2") that we're tweening and the unique property name that was used for the proxy (like "boxShadow_xn1" and "boxShadow_xn2") and whether or not they need to be rounded. That way, in the _setPluginRatio() method we can simply copy the values over from the proxy to the CSSPropTween instance(s). Then, when the main CSSPlugin setRatio() method runs and applies the CSSPropTween values accordingly, they're updated nicely. So the external plugin tweens the numbers, _setPluginRatio() copies them over, and setRatio() acts normally, applying css-specific values to the element.
			 * This method returns an object that has the following properties:
			 *  - proxy: a generic object containing the starting values for all the properties that will be tweened by the external plugin.  This is what we feed to the external _onInitTween() as the target
			 *  - end: a generic object containing the ending values for all the properties that will be tweened by the external plugin. This is what we feed to the external plugin's _onInitTween() as the destination values
			 *  - firstMPT: the first MiniPropTween in the linked list
			 *  - pt: the first CSSPropTween in the linked list that was created when parsing. If shallow is true, this linked list will NOT attach to the one passed into the _parseToProxy() as the "pt" (4th) parameter.
			 * @param {!Object} t target object to be tweened
			 * @param {!(Object|string)} vars the object containing the information about the tweening values (typically the end/destination values) that should be parsed
			 * @param {!CSSPlugin} cssp The CSSPlugin instance
			 * @param {CSSPropTween=} pt the next CSSPropTween in the linked list
			 * @param {TweenPlugin=} plugin the external TweenPlugin instance that will be handling tweening the numeric values
			 * @param {boolean=} shallow if true, the resulting linked list from the parse will NOT be attached to the CSSPropTween that was passed in as the "pt" (4th) parameter.
			 * @return An object containing the following properties: proxy, end, firstMPT, and pt (see above for descriptions)
			 */
			_parseToProxy = _internals._parseToProxy = function(t, vars, cssp, pt, plugin, shallow) {
				var bpt = pt,
					start = {},
					end = {},
					transform = cssp._transform,
					oldForce = _forcePT,
					i, p, xp, mpt, firstPT;
				cssp._transform = null;
				_forcePT = vars;
				pt = firstPT = cssp.parse(t, vars, pt, plugin);
				_forcePT = oldForce;
				//break off from the linked list so the new ones are isolated.
				if (shallow) {
					cssp._transform = transform;
					if (bpt) {
						bpt._prev = null;
						if (bpt._prev) {
							bpt._prev._next = null;
						}
					}
				}
				while (pt && pt !== bpt) {
					if (pt.type <= 1) {
						p = pt.p;
						end[p] = pt.s + pt.c;
						start[p] = pt.s;
						if (!shallow) {
							mpt = new MiniPropTween(pt, "s", p, mpt, pt.r);
							pt.c = 0;
						}
						if (pt.type === 1) {
							i = pt.l;
							while (--i > 0) {
								xp = "xn" + i;
								p = pt.p + "_" + xp;
								end[p] = pt.data[xp];
								start[p] = pt[xp];
								if (!shallow) {
									mpt = new MiniPropTween(pt, xp, p, mpt, pt.rxp[xp]);
								}
							}
						}
					}
					pt = pt._next;
				}
				return {proxy:start, end:end, firstMPT:mpt, pt:firstPT};
			},



			/**
			 * @constructor Each property that is tweened has at least one CSSPropTween associated with it. These instances store important information like the target, property, starting value, amount of change, etc. They can also optionally have a number of "extra" strings and numeric values named xs1, xn1, xs2, xn2, xs3, xn3, etc. where "s" indicates string and "n" indicates number. These can be pieced together in a complex-value tween (type:1) that has alternating types of data like a string, number, string, number, etc. For example, boxShadow could be "5px 5px 8px rgb(102, 102, 51)". In that value, there are 6 numbers that may need to tween and then pieced back together into a string again with spaces, suffixes, etc. xs0 is special in that it stores the suffix for standard (type:0) tweens, -OR- the first string (prefix) in a complex-value (type:1) CSSPropTween -OR- it can be the non-tweening value in a type:-1 CSSPropTween. We do this to conserve memory.
			 * CSSPropTweens have the following optional properties as well (not defined through the constructor):
			 *  - l: Length in terms of the number of extra properties that the CSSPropTween has (default: 0). For example, for a boxShadow we may need to tween 5 numbers in which case l would be 5; Keep in mind that the start/end values for the first number that's tweened are always stored in the s and c properties to conserve memory. All additional values thereafter are stored in xn1, xn2, etc.
			 *  - xfirst: The first instance of any sub-CSSPropTweens that are tweening properties of this instance. For example, we may split up a boxShadow tween so that there's a main CSSPropTween of type:1 that has various xs* and xn* values associated with the h-shadow, v-shadow, blur, color, etc. Then we spawn a CSSPropTween for each of those that has a higher priority and runs BEFORE the main CSSPropTween so that the values are all set by the time it needs to re-assemble them. The xfirst gives us an easy way to identify the first one in that chain which typically ends at the main one (because they're all prepende to the linked list)
			 *  - plugin: The TweenPlugin instance that will handle the tweening of any complex values. For example, sometimes we don't want to use normal subtweens (like xfirst refers to) to tween the values - we might want ThrowPropsPlugin or BezierPlugin some other plugin to do the actual tweening, so we create a plugin instance and store a reference here. We need this reference so that if we get a request to round values or disable a tween, we can pass along that request.
			 *  - data: Arbitrary data that needs to be stored with the CSSPropTween. Typically if we're going to have a plugin handle the tweening of a complex-value tween, we create a generic object that stores the END values that we're tweening to and the CSSPropTween's xs1, xs2, etc. have the starting values. We store that object as data. That way, we can simply pass that object to the plugin and use the CSSPropTween as the target.
			 *  - setRatio: Only used for type:2 tweens that require custom functionality. In this case, we call the CSSPropTween's setRatio() method and pass the ratio each time the tween updates. This isn't quite as efficient as doing things directly in the CSSPlugin's setRatio() method, but it's very convenient and flexible.
			 * @param {!Object} t Target object whose property will be tweened. Often a DOM element, but not always. It could be anything.
			 * @param {string} p Property to tween (name). For example, to tween element.width, p would be "width".
			 * @param {number} s Starting numeric value
			 * @param {number} c Change in numeric value over the course of the entire tween. For example, if element.width starts at 5 and should end at 100, c would be 95.
			 * @param {CSSPropTween=} next The next CSSPropTween in the linked list. If one is defined, we will define its _prev as the new instance, and the new instance's _next will be pointed at it.
			 * @param {number=} type The type of CSSPropTween where -1 = a non-tweening value, 0 = a standard simple tween, 1 = a complex value (like one that has multiple numbers in a comma- or space-delimited string like border:"1px solid red"), and 2 = one that uses a custom setRatio function that does all of the work of applying the values on each update.
			 * @param {string=} n Name of the property that should be used for overwriting purposes which is typically the same as p but not always. For example, we may need to create a subtween for the 2nd part of a "clip:rect(...)" tween in which case "p" might be xs1 but "n" is still "clip"
			 * @param {boolean=} r If true, the value(s) should be rounded
			 * @param {number=} pr Priority in the linked list order. Higher priority CSSPropTweens will be updated before lower priority ones. The default priority is 0.
			 * @param {string=} b Beginning value. We store this to ensure that it is EXACTLY what it was when the tween began without any risk of interpretation issues.
			 * @param {string=} e Ending value. We store this to ensure that it is EXACTLY what the user defined at the end of the tween without any risk of interpretation issues.
			 */
			CSSPropTween = _internals.CSSPropTween = function(t, p, s, c, next, type, n, r, pr, b, e) {
				this.t = t; //target
				this.p = p; //property
				this.s = s; //starting value
				this.c = c; //change value
				this.n = n || p; //name that this CSSPropTween should be associated to (usually the same as p, but not always - n is what overwriting looks at)
				if (!(t instanceof CSSPropTween)) {
					_overwriteProps.push(this.n);
				}
				this.r = r; //round (boolean)
				this.type = type || 0; //0 = normal tween, -1 = non-tweening (in which case xs0 will be applied to the target's property, like tp.t[tp.p] = tp.xs0), 1 = complex-value SpecialProp, 2 = custom setRatio() that does all the work
				if (pr) {
					this.pr = pr;
					_hasPriority = true;
				}
				this.b = (b === undefined) ? s : b;
				this.e = (e === undefined) ? s + c : e;
				if (next) {
					this._next = next;
					next._prev = this;
				}
			},

			_addNonTweeningNumericPT = function(target, prop, start, end, next, overwriteProp) { //cleans up some code redundancies and helps minification. Just a fast way to add a NUMERIC non-tweening CSSPropTween
				var pt = new CSSPropTween(target, prop, start, end - start, next, -1, overwriteProp);
				pt.b = start;
				pt.e = pt.xs0 = end;
				return pt;
			},

			/**
			 * Takes a target, the beginning value and ending value (as strings) and parses them into a CSSPropTween (possibly with child CSSPropTweens) that accommodates multiple numbers, colors, comma-delimited values, etc. For example:
			 * sp.parseComplex(element, "boxShadow", "5px 10px 20px rgb(255,102,51)", "0px 0px 0px red", true, "0px 0px 0px rgb(0,0,0,0)", pt);
			 * It will walk through the beginning and ending values (which should be in the same format with the same number and type of values) and figure out which parts are numbers, what strings separate the numeric/tweenable values, and then create the CSSPropTweens accordingly. If a plugin is defined, no child CSSPropTweens will be created. Instead, the ending values will be stored in the "data" property of the returned CSSPropTween like: {s:-5, xn1:-10, xn2:-20, xn3:255, xn4:0, xn5:0} so that it can be fed to any other plugin and it'll be plain numeric tweens but the recomposition of the complex value will be handled inside CSSPlugin's setRatio().
			 * If a setRatio is defined, the type of the CSSPropTween will be set to 2 and recomposition of the values will be the responsibility of that method.
			 *
			 * @param {!Object} t Target whose property will be tweened
			 * @param {!string} p Property that will be tweened (its name, like "left" or "backgroundColor" or "boxShadow")
			 * @param {string} b Beginning value
			 * @param {string} e Ending value
			 * @param {boolean} clrs If true, the value could contain a color value like "rgb(255,0,0)" or "#F00" or "red". The default is false, so no colors will be recognized (a performance optimization)
			 * @param {(string|number|Object)} dflt The default beginning value that should be used if no valid beginning value is defined or if the number of values inside the complex beginning and ending values don't match
			 * @param {?CSSPropTween} pt CSSPropTween instance that is the current head of the linked list (we'll prepend to this).
			 * @param {number=} pr Priority in the linked list order. Higher priority properties will be updated before lower priority ones. The default priority is 0.
			 * @param {TweenPlugin=} plugin If a plugin should handle the tweening of extra properties, pass the plugin instance here. If one is defined, then NO subtweens will be created for any extra properties (the properties will be created - just not additional CSSPropTween instances to tween them) because the plugin is expected to do so. However, the end values WILL be populated in the "data" property, like {s:100, xn1:50, xn2:300}
			 * @param {function(number)=} setRatio If values should be set in a custom function instead of being pieced together in a type:1 (complex-value) CSSPropTween, define that custom function here.
			 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parseComplex() call.
			 */
			_parseComplex = CSSPlugin.parseComplex = function(t, p, b, e, clrs, dflt, pt, pr, plugin, setRatio) {
				//DEBUG: _log("parseComplex: "+p+", b: "+b+", e: "+e);
				b = b || dflt || "";
				if (typeof(e) === "function") {
					e = e(_index, _target);
				}
				pt = new CSSPropTween(t, p, 0, 0, pt, (setRatio ? 2 : 1), null, false, pr, b, e);
				e += ""; //ensures it's a string
				if (clrs && _colorExp.test(e + b)) { //if colors are found, normalize the formatting to rgba() or hsla().
					e = [b, e];
					CSSPlugin.colorStringFilter(e);
					b = e[0];
					e = e[1];
				}
				var ba = b.split(", ").join(",").split(" "), //beginning array
					ea = e.split(", ").join(",").split(" "), //ending array
					l = ba.length,
					autoRound = (_autoRound !== false),
					i, xi, ni, bv, ev, bnums, enums, bn, hasAlpha, temp, cv, str, useHSL;
				if (e.indexOf(",") !== -1 || b.indexOf(",") !== -1) {
					if ((e + b).indexOf("rgb") !== -1 || (e + b).indexOf("hsl") !== -1) { //keep rgb(), rgba(), hsl(), and hsla() values together! (remember, we're splitting on spaces)
						ba = ba.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						ea = ea.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
					} else {
						ba = ba.join(" ").split(",").join(", ").split(" ");
						ea = ea.join(" ").split(",").join(", ").split(" ");
					}
					l = ba.length;
				}
				if (l !== ea.length) {
					//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
					ba = (dflt || "").split(" ");
					l = ba.length;
				}
				pt.plugin = plugin;
				pt.setRatio = setRatio;
				_colorExp.lastIndex = 0;
				for (i = 0; i < l; i++) {
					bv = ba[i];
					ev = ea[i];
					bn = parseFloat(bv);
					//if the value begins with a number (most common). It's fine if it has a suffix like px
					if (bn || bn === 0) {
						pt.appendXtra("", bn, _parseChange(ev, bn), ev.replace(_relNumExp, ""), (autoRound && ev.indexOf("px") !== -1), true);

					//if the value is a color
					} else if (clrs && _colorExp.test(bv)) {
						str = ev.indexOf(")") + 1;
						str = ")" + (str ? ev.substr(str) : ""); //if there's a comma or ) at the end, retain it.
						useHSL = (ev.indexOf("hsl") !== -1 && _supportsOpacity);
						temp = ev; //original string value so we can look for any prefix later.
						bv = _parseColor(bv, useHSL);
						ev = _parseColor(ev, useHSL);
						hasAlpha = (bv.length + ev.length > 6);
						if (hasAlpha && !_supportsOpacity && ev[3] === 0) { //older versions of IE don't support rgba(), so if the destination alpha is 0, just use "transparent" for the end color
							pt["xs" + pt.l] += pt.l ? " transparent" : "transparent";
							pt.e = pt.e.split(ea[i]).join("transparent");
						} else {
							if (!_supportsOpacity) { //old versions of IE don't support rgba().
								hasAlpha = false;
							}
							if (useHSL) {
								pt.appendXtra(temp.substr(0, temp.indexOf("hsl")) + (hasAlpha ? "hsla(" : "hsl("), bv[0], _parseChange(ev[0], bv[0]), ",", false, true)
									.appendXtra("", bv[1], _parseChange(ev[1], bv[1]), "%,", false)
									.appendXtra("", bv[2], _parseChange(ev[2], bv[2]), (hasAlpha ? "%," : "%" + str), false);
							} else {
								pt.appendXtra(temp.substr(0, temp.indexOf("rgb")) + (hasAlpha ? "rgba(" : "rgb("), bv[0], ev[0] - bv[0], ",", true, true)
									.appendXtra("", bv[1], ev[1] - bv[1], ",", true)
									.appendXtra("", bv[2], ev[2] - bv[2], (hasAlpha ? "," : str), true);
							}

							if (hasAlpha) {
								bv = (bv.length < 4) ? 1 : bv[3];
								pt.appendXtra("", bv, ((ev.length < 4) ? 1 : ev[3]) - bv, str, false);
							}
						}
						_colorExp.lastIndex = 0; //otherwise the test() on the RegExp could move the lastIndex and taint future results.

					} else {
						bnums = bv.match(_numExp); //gets each group of numbers in the beginning value string and drops them into an array

						//if no number is found, treat it as a non-tweening value and just append the string to the current xs.
						if (!bnums) {
							pt["xs" + pt.l] += (pt.l || pt["xs" + pt.l]) ? " " + ev : ev;

						//loop through all the numbers that are found and construct the extra values on the pt.
						} else {
							enums = ev.match(_relNumExp); //get each group of numbers in the end value string and drop them into an array. We allow relative values too, like +=50 or -=.5
							if (!enums || enums.length !== bnums.length) {
								//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
								return pt;
							}
							ni = 0;
							for (xi = 0; xi < bnums.length; xi++) {
								cv = bnums[xi];
								temp = bv.indexOf(cv, ni);
								pt.appendXtra(bv.substr(ni, temp - ni), Number(cv), _parseChange(enums[xi], cv), "", (autoRound && bv.substr(temp + cv.length, 2) === "px"), (xi === 0));
								ni = temp + cv.length;
							}
							pt["xs" + pt.l] += bv.substr(ni);
						}
					}
				}
				//if there are relative values ("+=" or "-=" prefix), we need to adjust the ending value to eliminate the prefixes and combine the values properly.
				if (e.indexOf("=") !== -1) if (pt.data) {
					str = pt.xs0 + pt.data.s;
					for (i = 1; i < pt.l; i++) {
						str += pt["xs" + i] + pt.data["xn" + i];
					}
					pt.e = str + pt["xs" + i];
				}
				if (!pt.l) {
					pt.type = -1;
					pt.xs0 = pt.e;
				}
				return pt.xfirst || pt;
			},
			i = 9;


		p = CSSPropTween.prototype;
		p.l = p.pr = 0; //length (number of extra properties like xn1, xn2, xn3, etc.
		while (--i > 0) {
			p["xn" + i] = 0;
			p["xs" + i] = "";
		}
		p.xs0 = "";
		p._next = p._prev = p.xfirst = p.data = p.plugin = p.setRatio = p.rxp = null;


		/**
		 * Appends and extra tweening value to a CSSPropTween and automatically manages any prefix and suffix strings. The first extra value is stored in the s and c of the main CSSPropTween instance, but thereafter any extras are stored in the xn1, xn2, xn3, etc. The prefixes and suffixes are stored in the xs0, xs1, xs2, etc. properties. For example, if I walk through a clip value like "rect(10px, 5px, 0px, 20px)", the values would be stored like this:
		 * xs0:"rect(", s:10, xs1:"px, ", xn1:5, xs2:"px, ", xn2:0, xs3:"px, ", xn3:20, xn4:"px)"
		 * And they'd all get joined together when the CSSPlugin renders (in the setRatio() method).
		 * @param {string=} pfx Prefix (if any)
		 * @param {!number} s Starting value
		 * @param {!number} c Change in numeric value over the course of the entire tween. For example, if the start is 5 and the end is 100, the change would be 95.
		 * @param {string=} sfx Suffix (if any)
		 * @param {boolean=} r Round (if true).
		 * @param {boolean=} pad If true, this extra value should be separated by the previous one by a space. If there is no previous extra and pad is true, it will automatically drop the space.
		 * @return {CSSPropTween} returns itself so that multiple methods can be chained together.
		 */
		p.appendXtra = function(pfx, s, c, sfx, r, pad) {
			var pt = this,
				l = pt.l;
			pt["xs" + l] += (pad && (l || pt["xs" + l])) ? " " + pfx : pfx || "";
			if (!c) if (l !== 0 && !pt.plugin) { //typically we'll combine non-changing values right into the xs to optimize performance, but we don't combine them when there's a plugin that will be tweening the values because it may depend on the values being split apart, like for a bezier, if a value doesn't change between the first and second iteration but then it does on the 3rd, we'll run into trouble because there's no xn slot for that value!
				pt["xs" + l] += s + (sfx || "");
				return pt;
			}
			pt.l++;
			pt.type = pt.setRatio ? 2 : 1;
			pt["xs" + pt.l] = sfx || "";
			if (l > 0) {
				pt.data["xn" + l] = s + c;
				pt.rxp["xn" + l] = r; //round extra property (we need to tap into this in the _parseToProxy() method)
				pt["xn" + l] = s;
				if (!pt.plugin) {
					pt.xfirst = new CSSPropTween(pt, "xn" + l, s, c, pt.xfirst || pt, 0, pt.n, r, pt.pr);
					pt.xfirst.xs0 = 0; //just to ensure that the property stays numeric which helps modern browsers speed up processing. Remember, in the setRatio() method, we do pt.t[pt.p] = val + pt.xs0 so if pt.xs0 is "" (the default), it'll cast the end value as a string. When a property is a number sometimes and a string sometimes, it prevents the compiler from locking in the data type, slowing things down slightly.
				}
				return pt;
			}
			pt.data = {s:s + c};
			pt.rxp = {};
			pt.s = s;
			pt.c = c;
			pt.r = r;
			return pt;
		};

		/**
		 * @constructor A SpecialProp is basically a css property that needs to be treated in a non-standard way, like if it may contain a complex value like boxShadow:"5px 10px 15px rgb(255, 102, 51)" or if it is associated with another plugin like ThrowPropsPlugin or BezierPlugin. Every SpecialProp is associated with a particular property name like "boxShadow" or "throwProps" or "bezier" and it will intercept those values in the vars object that's passed to the CSSPlugin and handle them accordingly.
		 * @param {!string} p Property name (like "boxShadow" or "throwProps")
		 * @param {Object=} options An object containing any of the following configuration options:
		 *                      - defaultValue: the default value
		 *                      - parser: A function that should be called when the associated property name is found in the vars. This function should return a CSSPropTween instance and it should ensure that it is properly inserted into the linked list. It will receive 4 paramters: 1) The target, 2) The value defined in the vars, 3) The CSSPlugin instance (whose _firstPT should be used for the linked list), and 4) A computed style object if one was calculated (this is a speed optimization that allows retrieval of starting values quicker)
		 *                      - formatter: a function that formats any value received for this special property (for example, boxShadow could take "5px 5px red" and format it to "5px 5px 0px 0px red" so that both the beginning and ending values have a common order and quantity of values.)
		 *                      - prefix: if true, we'll determine whether or not this property requires a vendor prefix (like Webkit or Moz or ms or O)
		 *                      - color: set this to true if the value for this SpecialProp may contain color-related values like rgb(), rgba(), etc.
		 *                      - priority: priority in the linked list order. Higher priority SpecialProps will be updated before lower priority ones. The default priority is 0.
		 *                      - multi: if true, the formatter should accommodate a comma-delimited list of values, like boxShadow could have multiple boxShadows listed out.
		 *                      - collapsible: if true, the formatter should treat the value like it's a top/right/bottom/left value that could be collapsed, like "5px" would apply to all, "5px, 10px" would use 5px for top/bottom and 10px for right/left, etc.
		 *                      - keyword: a special keyword that can [optionally] be found inside the value (like "inset" for boxShadow). This allows us to validate beginning/ending values to make sure they match (if the keyword is found in one, it'll be added to the other for consistency by default).
		 */
		var SpecialProp = function(p, options) {
				options = options || {};
				this.p = options.prefix ? _checkPropPrefix(p) || p : p;
				_specialProps[p] = _specialProps[this.p] = this;
				this.format = options.formatter || _getFormatter(options.defaultValue, options.color, options.collapsible, options.multi);
				if (options.parser) {
					this.parse = options.parser;
				}
				this.clrs = options.color;
				this.multi = options.multi;
				this.keyword = options.keyword;
				this.dflt = options.defaultValue;
				this.pr = options.priority || 0;
			},

			//shortcut for creating a new SpecialProp that can accept multiple properties as a comma-delimited list (helps minification). dflt can be an array for multiple values (we don't do a comma-delimited list because the default value may contain commas, like rect(0px,0px,0px,0px)). We attach this method to the SpecialProp class/object instead of using a private _createSpecialProp() method so that we can tap into it externally if necessary, like from another plugin.
			_registerComplexSpecialProp = _internals._registerComplexSpecialProp = function(p, options, defaults) {
				if (typeof(options) !== "object") {
					options = {parser:defaults}; //to make backwards compatible with older versions of BezierPlugin and ThrowPropsPlugin
				}
				var a = p.split(","),
					d = options.defaultValue,
					i, temp;
				defaults = defaults || [d];
				for (i = 0; i < a.length; i++) {
					options.prefix = (i === 0 && options.prefix);
					options.defaultValue = defaults[i] || d;
					temp = new SpecialProp(a[i], options);
				}
			},

			//creates a placeholder special prop for a plugin so that the property gets caught the first time a tween of it is attempted, and at that time it makes the plugin register itself, thus taking over for all future tweens of that property. This allows us to not mandate that things load in a particular order and it also allows us to log() an error that informs the user when they attempt to tween an external plugin-related property without loading its .js file.
			_registerPluginProp = _internals._registerPluginProp = function(p) {
				if (!_specialProps[p]) {
					var pluginName = p.charAt(0).toUpperCase() + p.substr(1) + "Plugin";
					_registerComplexSpecialProp(p, {parser:function(t, e, p, cssp, pt, plugin, vars) {
						var pluginClass = _globals.com.greensock.plugins[pluginName];
						if (!pluginClass) {
							_log("Error: " + pluginName + " js file not loaded.");
							return pt;
						}
						pluginClass._cssRegister();
						return _specialProps[p].parse(t, e, p, cssp, pt, plugin, vars);
					}});
				}
			};


		p = SpecialProp.prototype;

		/**
		 * Alias for _parseComplex() that automatically plugs in certain values for this SpecialProp, like its property name, whether or not colors should be sensed, the default value, and priority. It also looks for any keyword that the SpecialProp defines (like "inset" for boxShadow) and ensures that the beginning and ending values have the same number of values for SpecialProps where multi is true (like boxShadow and textShadow can have a comma-delimited list)
		 * @param {!Object} t target element
		 * @param {(string|number|object)} b beginning value
		 * @param {(string|number|object)} e ending (destination) value
		 * @param {CSSPropTween=} pt next CSSPropTween in the linked list
		 * @param {TweenPlugin=} plugin If another plugin will be tweening the complex value, that TweenPlugin instance goes here.
		 * @param {function=} setRatio If a custom setRatio() method should be used to handle this complex value, that goes here.
		 * @return {CSSPropTween=} First CSSPropTween in the linked list
		 */
		p.parseComplex = function(t, b, e, pt, plugin, setRatio) {
			var kwd = this.keyword,
				i, ba, ea, l, bi, ei;
			//if this SpecialProp's value can contain a comma-delimited list of values (like boxShadow or textShadow), we must parse them in a special way, and look for a keyword (like "inset" for boxShadow) and ensure that the beginning and ending BOTH have it if the end defines it as such. We also must ensure that there are an equal number of values specified (we can't tween 1 boxShadow to 3 for example)
			if (this.multi) if (_commasOutsideParenExp.test(e) || _commasOutsideParenExp.test(b)) {
				ba = b.replace(_commasOutsideParenExp, "|").split("|");
				ea = e.replace(_commasOutsideParenExp, "|").split("|");
			} else if (kwd) {
				ba = [b];
				ea = [e];
			}
			if (ea) {
				l = (ea.length > ba.length) ? ea.length : ba.length;
				for (i = 0; i < l; i++) {
					b = ba[i] = ba[i] || this.dflt;
					e = ea[i] = ea[i] || this.dflt;
					if (kwd) {
						bi = b.indexOf(kwd);
						ei = e.indexOf(kwd);
						if (bi !== ei) {
							if (ei === -1) { //if the keyword isn't in the end value, remove it from the beginning one.
								ba[i] = ba[i].split(kwd).join("");
							} else if (bi === -1) { //if the keyword isn't in the beginning, add it.
								ba[i] += " " + kwd;
							}
						}
					}
				}
				b = ba.join(", ");
				e = ea.join(", ");
			}
			return _parseComplex(t, this.p, b, e, this.clrs, this.dflt, pt, this.pr, plugin, setRatio);
		};

		/**
		 * Accepts a target and end value and spits back a CSSPropTween that has been inserted into the CSSPlugin's linked list and conforms with all the conventions we use internally, like type:-1, 0, 1, or 2, setting up any extra property tweens, priority, etc. For example, if we have a boxShadow SpecialProp and call:
		 * this._firstPT = sp.parse(element, "5px 10px 20px rgb(2550,102,51)", "boxShadow", this);
		 * It should figure out the starting value of the element's boxShadow, compare it to the provided end value and create all the necessary CSSPropTweens of the appropriate types to tween the boxShadow. The CSSPropTween that gets spit back should already be inserted into the linked list (the 4th parameter is the current head, so prepend to that).
		 * @param {!Object} t Target object whose property is being tweened
		 * @param {Object} e End value as provided in the vars object (typically a string, but not always - like a throwProps would be an object).
		 * @param {!string} p Property name
		 * @param {!CSSPlugin} cssp The CSSPlugin instance that should be associated with this tween.
		 * @param {?CSSPropTween} pt The CSSPropTween that is the current head of the linked list (we'll prepend to it)
		 * @param {TweenPlugin=} plugin If a plugin will be used to tween the parsed value, this is the plugin instance.
		 * @param {Object=} vars Original vars object that contains the data for parsing.
		 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parse() call.
		 */
		p.parse = function(t, e, p, cssp, pt, plugin, vars) {
			return this.parseComplex(t.style, this.format(_getStyle(t, this.p, _cs, false, this.dflt)), this.format(e), pt, plugin);
		};

		/**
		 * Registers a special property that should be intercepted from any "css" objects defined in tweens. This allows you to handle them however you want without CSSPlugin doing it for you. The 2nd parameter should be a function that accepts 3 parameters:
		 *  1) Target object whose property should be tweened (typically a DOM element)
		 *  2) The end/destination value (could be a string, number, object, or whatever you want)
		 *  3) The tween instance (you probably don't need to worry about this, but it can be useful for looking up information like the duration)
		 *
		 * Then, your function should return a function which will be called each time the tween gets rendered, passing a numeric "ratio" parameter to your function that indicates the change factor (usually between 0 and 1). For example:
		 *
		 * CSSPlugin.registerSpecialProp("myCustomProp", function(target, value, tween) {
		 *      var start = target.style.width;
		 *      return function(ratio) {
		 *              target.style.width = (start + value * ratio) + "px";
		 *              console.log("set width to " + target.style.width);
		 *          }
		 * }, 0);
		 *
		 * Then, when I do this tween, it will trigger my special property:
		 *
		 * TweenLite.to(element, 1, {css:{myCustomProp:100}});
		 *
		 * In the example, of course, we're just changing the width, but you can do anything you want.
		 *
		 * @param {!string} name Property name (or comma-delimited list of property names) that should be intercepted and handled by your function. For example, if I define "myCustomProp", then it would handle that portion of the following tween: TweenLite.to(element, 1, {css:{myCustomProp:100}})
		 * @param {!function(Object, Object, Object, string):function(number)} onInitTween The function that will be called when a tween of this special property is performed. The function will receive 4 parameters: 1) Target object that should be tweened, 2) Value that was passed to the tween, 3) The tween instance itself (rarely used), and 4) The property name that's being tweened. Your function should return a function that should be called on every update of the tween. That function will receive a single parameter that is a "change factor" value (typically between 0 and 1) indicating the amount of change as a ratio. You can use this to determine how to set the values appropriately in your function.
		 * @param {number=} priority Priority that helps the engine determine the order in which to set the properties (default: 0). Higher priority properties will be updated before lower priority ones.
		 */
		CSSPlugin.registerSpecialProp = function(name, onInitTween, priority) {
			_registerComplexSpecialProp(name, {parser:function(t, e, p, cssp, pt, plugin, vars) {
				var rv = new CSSPropTween(t, p, 0, 0, pt, 2, p, false, priority);
				rv.plugin = plugin;
				rv.setRatio = onInitTween(t, e, cssp._tween, p);
				return rv;
			}, priority:priority});
		};






		//transform-related methods and properties
		CSSPlugin.useSVGTransformAttr = true; //Safari and Firefox both have some rendering bugs when applying CSS transforms to SVG elements, so default to using the "transform" attribute instead (users can override this).
		var _transformProps = ("scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent").split(","),
			_transformProp = _checkPropPrefix("transform"), //the Javascript (camelCase) transform property, like msTransform, WebkitTransform, MozTransform, or OTransform.
			_transformPropCSS = _prefixCSS + "transform",
			_transformOriginProp = _checkPropPrefix("transformOrigin"),
			_supports3D = (_checkPropPrefix("perspective") !== null),
			Transform = _internals.Transform = function() {
				this.perspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0;
				this.force3D = (CSSPlugin.defaultForce3D === false || !_supports3D) ? false : CSSPlugin.defaultForce3D || "auto";
			},
			_SVGElement = _gsScope.SVGElement,
			_useSVGTransformAttr,
			//Some browsers (like Firefox and IE) don't honor transform-origin properly in SVG elements, so we need to manually adjust the matrix accordingly. We feature detect here rather than always doing the conversion for certain browsers because they may fix the problem at some point in the future.

			_createSVG = function(type, container, attributes) {
				var element = _doc.createElementNS("http://www.w3.org/2000/svg", type),
					reg = /([a-z])([A-Z])/g,
					p;
				for (p in attributes) {
					element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
				}
				container.appendChild(element);
				return element;
			},
			_docElement = _doc.documentElement || {},
			_forceSVGTransformAttr = (function() {
				//IE and Android stock don't support CSS transforms on SVG elements, so we must write them to the "transform" attribute. We populate this variable in the _parseTransform() method, and only if/when we come across an SVG element
				var force = _ieVers || (/Android/i.test(_agent) && !_gsScope.chrome),
					svg, rect, width;
				if (_doc.createElementNS && !force) { //IE8 and earlier doesn't support SVG anyway
					svg = _createSVG("svg", _docElement);
					rect = _createSVG("rect", svg, {width:100, height:50, x:100});
					width = rect.getBoundingClientRect().width;
					rect.style[_transformOriginProp] = "50% 50%";
					rect.style[_transformProp] = "scaleX(0.5)";
					force = (width === rect.getBoundingClientRect().width && !(_isFirefox && _supports3D)); //note: Firefox fails the test even though it does support CSS transforms in 3D. Since we can't push 3D stuff into the transform attribute, we force Firefox to pass the test here (as long as it does truly support 3D).
					_docElement.removeChild(svg);
				}
				return force;
			})(),
			_parseSVGOrigin = function(e, local, decoratee, absolute, smoothOrigin, skipRecord) {
				var tm = e._gsTransform,
					m = _getMatrix(e, true),
					v, x, y, xOrigin, yOrigin, a, b, c, d, tx, ty, determinant, xOriginOld, yOriginOld;
				if (tm) {
					xOriginOld = tm.xOrigin; //record the original values before we alter them.
					yOriginOld = tm.yOrigin;
				}
				if (!absolute || (v = absolute.split(" ")).length < 2) {
					b = e.getBBox();
					if (b.x === 0 && b.y === 0 && b.width + b.height === 0) { //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
						b = {x: parseFloat(e.hasAttribute("x") ? e.getAttribute("x") : e.hasAttribute("cx") ? e.getAttribute("cx") : 0) || 0, y: parseFloat(e.hasAttribute("y") ? e.getAttribute("y") : e.hasAttribute("cy") ? e.getAttribute("cy") : 0) || 0, width:0, height:0};
					}
					local = _parsePosition(local).split(" ");
					v = [(local[0].indexOf("%") !== -1 ? parseFloat(local[0]) / 100 * b.width : parseFloat(local[0])) + b.x,
						 (local[1].indexOf("%") !== -1 ? parseFloat(local[1]) / 100 * b.height : parseFloat(local[1])) + b.y];
				}
				decoratee.xOrigin = xOrigin = parseFloat(v[0]);
				decoratee.yOrigin = yOrigin = parseFloat(v[1]);
				if (absolute && m !== _identity2DMatrix) { //if svgOrigin is being set, we must invert the matrix and determine where the absolute point is, factoring in the current transforms. Otherwise, the svgOrigin would be based on the element's non-transformed position on the canvas.
					a = m[0];
					b = m[1];
					c = m[2];
					d = m[3];
					tx = m[4];
					ty = m[5];
					determinant = (a * d - b * c);
					if (determinant) { //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
						x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + ((c * ty - d * tx) / determinant);
						y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - ((a * ty - b * tx) / determinant);
						xOrigin = decoratee.xOrigin = v[0] = x;
						yOrigin = decoratee.yOrigin = v[1] = y;
					}
				}
				if (tm) { //avoid jump when transformOrigin is changed - adjust the x/y values accordingly
					if (skipRecord) {
						decoratee.xOffset = tm.xOffset;
						decoratee.yOffset = tm.yOffset;
						tm = decoratee;
					}
					if (smoothOrigin || (smoothOrigin !== false && CSSPlugin.defaultSmoothOrigin !== false)) {
						x = xOrigin - xOriginOld;
						y = yOrigin - yOriginOld;
						//originally, we simply adjusted the x and y values, but that would cause problems if, for example, you created a rotational tween part-way through an x/y tween. Managing the offset in a separate variable gives us ultimate flexibility.
						//tm.x -= x - (x * m[0] + y * m[2]);
						//tm.y -= y - (x * m[1] + y * m[3]);
						tm.xOffset += (x * m[0] + y * m[2]) - x;
						tm.yOffset += (x * m[1] + y * m[3]) - y;
					} else {
						tm.xOffset = tm.yOffset = 0;
					}
				}
				if (!skipRecord) {
					e.setAttribute("data-svg-origin", v.join(" "));
				}
			},
			_getBBoxHack = function(swapIfPossible) { //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
				var svg = _createElement("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
					oldParent = this.parentNode,
					oldSibling = this.nextSibling,
					oldCSS = this.style.cssText,
					bbox;
				_docElement.appendChild(svg);
				svg.appendChild(this);
				this.style.display = "block";
				if (swapIfPossible) {
					try {
						bbox = this.getBBox();
						this._originalGetBBox = this.getBBox;
						this.getBBox = _getBBoxHack;
					} catch (e) { }
				} else if (this._originalGetBBox) {
					bbox = this._originalGetBBox();
				}
				if (oldSibling) {
					oldParent.insertBefore(this, oldSibling);
				} else {
					oldParent.appendChild(this);
				}
				_docElement.removeChild(svg);
				this.style.cssText = oldCSS;
				return bbox;
			},
			_getBBox = function(e) {
				try {
					return e.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
				} catch (error) {
					return _getBBoxHack.call(e, true);
				}
			},
			_isSVG = function(e) { //reports if the element is an SVG on which getBBox() actually works
				return !!(_SVGElement && e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
			},
			_identity2DMatrix = [1,0,0,1,0,0],
			_getMatrix = function(e, force2D) {
				var tm = e._gsTransform || new Transform(),
					rnd = 100000,
					style = e.style,
					isDefault, s, m, n, dec, none;
				if (_transformProp) {
					s = _getStyle(e, _transformPropCSS, null, true);
				} else if (e.currentStyle) {
					//for older versions of IE, we need to interpret the filter portion that is in the format: progid:DXImageTransform.Microsoft.Matrix(M11=6.123233995736766e-17, M12=-1, M21=1, M22=6.123233995736766e-17, sizingMethod='auto expand') Notice that we need to swap b and c compared to a normal matrix.
					s = e.currentStyle.filter.match(_ieGetMatrixExp);
					s = (s && s.length === 4) ? [s[0].substr(4), Number(s[2].substr(4)), Number(s[1].substr(4)), s[3].substr(4), (tm.x || 0), (tm.y || 0)].join(",") : "";
				}
				isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
				if (_transformProp && ((none = (!_getComputedStyle(e) || _getComputedStyle(e).display === "none")) || !e.parentNode)) { //note: Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
					if (none) { //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
						n = style.display;
						style.display = "block";
					}
					if (!e.parentNode) {
						dec = 1; //flag
						_docElement.appendChild(e);
					}
					s = _getStyle(e, _transformPropCSS, null, true);
					isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
					if (n) {
						style.display = n;
					} else if (none) {
						_removeProp(style, "display");
					}
					if (dec) {
						_docElement.removeChild(e);
					}
				}
				if (tm.svg || (e.getCTM && _isSVG(e))) {
					if (isDefault && (style[_transformProp] + "").indexOf("matrix") !== -1) { //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
						s = style[_transformProp];
						isDefault = 0;
					}
					m = e.getAttribute("transform");
					if (isDefault && m) {
						m = e.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
						s = "matrix(" + m.a + "," + m.b + "," + m.c + "," + m.d + "," + m.e + "," + m.f + ")";
						isDefault = 0;
					}
				}
				if (isDefault) {
					return _identity2DMatrix;
				}
				//split the matrix values out into an array (m for matrix)
				m = (s || "").match(_numExp) || [];
				i = m.length;
				while (--i > -1) {
					n = Number(m[i]);
					m[i] = (dec = n - (n |= 0)) ? ((dec * rnd + (dec < 0 ? -0.5 : 0.5)) | 0) / rnd + n : n; //convert strings to Numbers and round to 5 decimal places to avoid issues with tiny numbers. Roughly 20x faster than Number.toFixed(). We also must make sure to round before dividing so that values like 0.9999999999 become 1 to avoid glitches in browser rendering and interpretation of flipped/rotated 3D matrices. And don't just multiply the number by rnd, floor it, and then divide by rnd because the bitwise operations max out at a 32-bit signed integer, thus it could get clipped at a relatively low value (like 22,000.00000 for example).
				}
				return (force2D && m.length > 6) ? [m[0], m[1], m[4], m[5], m[12], m[13]] : m;
			},

			/**
			 * Parses the transform values for an element, returning an object with x, y, z, scaleX, scaleY, scaleZ, rotation, rotationX, rotationY, skewX, and skewY properties. Note: by default (for performance reasons), all skewing is combined into skewX and rotation but skewY still has a place in the transform object so that we can record how much of the skew is attributed to skewX vs skewY. Remember, a skewY of 10 looks the same as a rotation of 10 and skewX of -10.
			 * @param {!Object} t target element
			 * @param {Object=} cs computed style object (optional)
			 * @param {boolean=} rec if true, the transform values will be recorded to the target element's _gsTransform object, like target._gsTransform = {x:0, y:0, z:0, scaleX:1...}
			 * @param {boolean=} parse if true, we'll ignore any _gsTransform values that already exist on the element, and force a reparsing of the css (calculated style)
			 * @return {object} object containing all of the transform properties/values like {x:0, y:0, z:0, scaleX:1...}
			 */
			_getTransform = _internals.getTransform = function(t, cs, rec, parse) {
				if (t._gsTransform && rec && !parse) {
					return t._gsTransform; //if the element already has a _gsTransform, use that. Note: some browsers don't accurately return the calculated style for the transform (particularly for SVG), so it's almost always safest to just use the values we've already applied rather than re-parsing things.
				}
				var tm = rec ? t._gsTransform || new Transform() : new Transform(),
					invX = (tm.scaleX < 0), //in order to interpret things properly, we need to know if the user applied a negative scaleX previously so that we can adjust the rotation and skewX accordingly. Otherwise, if we always interpret a flipped matrix as affecting scaleY and the user only wants to tween the scaleX on multiple sequential tweens, it would keep the negative scaleY without that being the user's intent.
					min = 0.00002,
					rnd = 100000,
					zOrigin = _supports3D ? parseFloat(_getStyle(t, _transformOriginProp, cs, false, "0 0 0").split(" ")[2]) || tm.zOrigin  || 0 : 0,
					defaultTransformPerspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0,
					m, i, scaleX, scaleY, rotation, skewX;

				tm.svg = !!(t.getCTM && _isSVG(t));
				if (tm.svg) {
					_parseSVGOrigin(t, _getStyle(t, _transformOriginProp, cs, false, "50% 50%") + "", tm, t.getAttribute("data-svg-origin"));
					_useSVGTransformAttr = CSSPlugin.useSVGTransformAttr || _forceSVGTransformAttr;
				}
				m = _getMatrix(t);
				if (m !== _identity2DMatrix) {

					if (m.length === 16) {
						//we'll only look at these position-related 6 variables first because if x/y/z all match, it's relatively safe to assume we don't need to re-parse everything which risks losing important rotational information (like rotationX:180 plus rotationY:180 would look the same as rotation:180 - there's no way to know for sure which direction was taken based solely on the matrix3d() values)
						var a11 = m[0], a21 = m[1], a31 = m[2], a41 = m[3],
							a12 = m[4], a22 = m[5], a32 = m[6], a42 = m[7],
							a13 = m[8], a23 = m[9], a33 = m[10],
							a14 = m[12], a24 = m[13], a34 = m[14],
							a43 = m[11],
							angle = Math.atan2(a32, a33),
							t1, t2, t3, t4, cos, sin;
						//we manually compensate for non-zero z component of transformOrigin to work around bugs in Safari
						if (tm.zOrigin) {
							a34 = -tm.zOrigin;
							a14 = a13*a34-m[12];
							a24 = a23*a34-m[13];
							a34 = a33*a34+tm.zOrigin-m[14];
						}
						//note for possible future consolidation: rotationX: Math.atan2(a32, a33), rotationY: Math.atan2(-a31, Math.sqrt(a33 * a33 + a32 * a32)), rotation: Math.atan2(a21, a11), skew: Math.atan2(a12, a22). However, it doesn't seem to be quite as reliable as the full-on backwards rotation procedure.
						tm.rotationX = angle * _RAD2DEG;
						//rotationX
						if (angle) {
							cos = Math.cos(-angle);
							sin = Math.sin(-angle);
							t1 = a12*cos+a13*sin;
							t2 = a22*cos+a23*sin;
							t3 = a32*cos+a33*sin;
							a13 = a12*-sin+a13*cos;
							a23 = a22*-sin+a23*cos;
							a33 = a32*-sin+a33*cos;
							a43 = a42*-sin+a43*cos;
							a12 = t1;
							a22 = t2;
							a32 = t3;
						}
						//rotationY
						angle = Math.atan2(-a31, a33);
						tm.rotationY = angle * _RAD2DEG;
						if (angle) {
							cos = Math.cos(-angle);
							sin = Math.sin(-angle);
							t1 = a11*cos-a13*sin;
							t2 = a21*cos-a23*sin;
							t3 = a31*cos-a33*sin;
							a23 = a21*sin+a23*cos;
							a33 = a31*sin+a33*cos;
							a43 = a41*sin+a43*cos;
							a11 = t1;
							a21 = t2;
							a31 = t3;
						}
						//rotationZ
						angle = Math.atan2(a21, a11);
						tm.rotation = angle * _RAD2DEG;
						if (angle) {
							cos = Math.cos(angle);
							sin = Math.sin(angle);
							t1 = a11*cos+a21*sin;
							t2 = a12*cos+a22*sin;
							t3 = a13*cos+a23*sin;
							a21 = a21*cos-a11*sin;
							a22 = a22*cos-a12*sin;
							a23 = a23*cos-a13*sin;
							a11 = t1;
							a12 = t2;
							a13 = t3;
						}

						if (tm.rotationX && Math.abs(tm.rotationX) + Math.abs(tm.rotation) > 359.9) { //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
							tm.rotationX = tm.rotation = 0;
							tm.rotationY = 180 - tm.rotationY;
						}

						//skewX
						angle = Math.atan2(a12, a22);

						//scales
						tm.scaleX = ((Math.sqrt(a11 * a11 + a21 * a21 + a31 * a31) * rnd + 0.5) | 0) / rnd;
						tm.scaleY = ((Math.sqrt(a22 * a22 + a32 * a32) * rnd + 0.5) | 0) / rnd;
						tm.scaleZ = ((Math.sqrt(a13 * a13 + a23 * a23 + a33 * a33) * rnd + 0.5) | 0) / rnd;
						a11 /= tm.scaleX;
						a12 /= tm.scaleY;
						a21 /= tm.scaleX;
						a22 /= tm.scaleY;
						if (Math.abs(angle) > min) {
							tm.skewX = angle * _RAD2DEG;
							a12 = 0; //unskews
							if (tm.skewType !== "simple") {
								tm.scaleY *= 1 / Math.cos(angle); //by default, we compensate the scale based on the skew so that the element maintains a similar proportion when skewed, so we have to alter the scaleY here accordingly to match the default (non-adjusted) skewing that CSS does (stretching more and more as it skews).
							}

						} else {
							tm.skewX = 0;
						}

						/* //for testing purposes
						var transform = "matrix3d(",
							comma = ",",
							zero = "0";
						a13 /= tm.scaleZ;
						a23 /= tm.scaleZ;
						a31 /= tm.scaleX;
						a32 /= tm.scaleY;
						a33 /= tm.scaleZ;
						transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
						transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
						transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
						transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
						transform += a14 + comma + a24 + comma + a34 + comma + (tm.perspective ? (1 + (-a34 / tm.perspective)) : 1) + ")";
						console.log(transform);
						document.querySelector(".test").style[_transformProp] = transform;
						*/

						tm.perspective = a43 ? 1 / ((a43 < 0) ? -a43 : a43) : 0;
						tm.x = a14;
						tm.y = a24;
						tm.z = a34;
						if (tm.svg) {
							tm.x -= tm.xOrigin - (tm.xOrigin * a11 - tm.yOrigin * a12);
							tm.y -= tm.yOrigin - (tm.yOrigin * a21 - tm.xOrigin * a22);
						}

					} else if ((!_supports3D || parse || !m.length || tm.x !== m[4] || tm.y !== m[5] || (!tm.rotationX && !tm.rotationY))) { //sometimes a 6-element matrix is returned even when we performed 3D transforms, like if rotationX and rotationY are 180. In cases like this, we still need to honor the 3D transforms. If we just rely on the 2D info, it could affect how the data is interpreted, like scaleY might get set to -1 or rotation could get offset by 180 degrees. For example, do a TweenLite.to(element, 1, {css:{rotationX:180, rotationY:180}}) and then later, TweenLite.to(element, 1, {css:{rotationX:0}}) and without this conditional logic in place, it'd jump to a state of being unrotated when the 2nd tween starts. Then again, we need to honor the fact that the user COULD alter the transforms outside of CSSPlugin, like by manually applying new css, so we try to sense that by looking at x and y because if those changed, we know the changes were made outside CSSPlugin and we force a reinterpretation of the matrix values. Also, in Webkit browsers, if the element's "display" is "none", its calculated style value will always return empty, so if we've already recorded the values in the _gsTransform object, we'll just rely on those.
						var k = (m.length >= 6),
							a = k ? m[0] : 1,
							b = m[1] || 0,
							c = m[2] || 0,
							d = k ? m[3] : 1;
						tm.x = m[4] || 0;
						tm.y = m[5] || 0;
						scaleX = Math.sqrt(a * a + b * b);
						scaleY = Math.sqrt(d * d + c * c);
						rotation = (a || b) ? Math.atan2(b, a) * _RAD2DEG : tm.rotation || 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
						skewX = (c || d) ? Math.atan2(c, d) * _RAD2DEG + rotation : tm.skewX || 0;
						tm.scaleX = scaleX;
						tm.scaleY = scaleY;
						tm.rotation = rotation;
						tm.skewX = skewX;
						if (_supports3D) {
							tm.rotationX = tm.rotationY = tm.z = 0;
							tm.perspective = defaultTransformPerspective;
							tm.scaleZ = 1;
						}
						if (tm.svg) {
							tm.x -= tm.xOrigin - (tm.xOrigin * a + tm.yOrigin * c);
							tm.y -= tm.yOrigin - (tm.xOrigin * b + tm.yOrigin * d);
						}
					}
					if (Math.abs(tm.skewX) > 90 && Math.abs(tm.skewX) < 270) {
						if (invX) {
							tm.scaleX *= -1;
							tm.skewX += (tm.rotation <= 0) ? 180 : -180;
							tm.rotation += (tm.rotation <= 0) ? 180 : -180;
						} else {
							tm.scaleY *= -1;
							tm.skewX += (tm.skewX <= 0) ? 180 : -180;
						}
					}
					tm.zOrigin = zOrigin;
					//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 0 in these cases. The conditional logic here is faster than calling Math.abs(). Also, browsers tend to render a SLIGHTLY rotated object in a fuzzy way, so we need to snap to exactly 0 when appropriate.
					for (i in tm) {
						if (tm[i] < min) if (tm[i] > -min) {
							tm[i] = 0;
						}
					}
				}
				//DEBUG: _log("parsed rotation of " + t.getAttribute("id")+": "+(tm.rotationX)+", "+(tm.rotationY)+", "+(tm.rotation)+", scale: "+tm.scaleX+", "+tm.scaleY+", "+tm.scaleZ+", position: "+tm.x+", "+tm.y+", "+tm.z+", perspective: "+tm.perspective+ ", origin: "+ tm.xOrigin+ ","+ tm.yOrigin);
				if (rec) {
					t._gsTransform = tm; //record to the object's _gsTransform which we use so that tweens can control individual properties independently (we need all the properties to accurately recompose the matrix in the setRatio() method)
					if (tm.svg) { //if we're supposed to apply transforms to the SVG element's "transform" attribute, make sure there aren't any CSS transforms applied or they'll override the attribute ones. Also clear the transform attribute if we're using CSS, just to be clean.
						if (_useSVGTransformAttr && t.style[_transformProp]) {
							TweenLite.delayedCall(0.001, function(){ //if we apply this right away (before anything has rendered), we risk there being no transforms for a brief moment and it also interferes with adjusting the transformOrigin in a tween with immediateRender:true (it'd try reading the matrix and it wouldn't have the appropriate data in place because we just removed it).
								_removeProp(t.style, _transformProp);
							});
						} else if (!_useSVGTransformAttr && t.getAttribute("transform")) {
							TweenLite.delayedCall(0.001, function(){
								t.removeAttribute("transform");
							});
						}
					}
				}
				return tm;
			},

			//for setting 2D transforms in IE6, IE7, and IE8 (must use a "filter" to emulate the behavior of modern day browser transforms)
			_setIETransformRatio = function(v) {
				var t = this.data, //refers to the element's _gsTransform object
					ang = -t.rotation * _DEG2RAD,
					skew = ang + t.skewX * _DEG2RAD,
					rnd = 100000,
					a = ((Math.cos(ang) * t.scaleX * rnd) | 0) / rnd,
					b = ((Math.sin(ang) * t.scaleX * rnd) | 0) / rnd,
					c = ((Math.sin(skew) * -t.scaleY * rnd) | 0) / rnd,
					d = ((Math.cos(skew) * t.scaleY * rnd) | 0) / rnd,
					style = this.t.style,
					cs = this.t.currentStyle,
					filters, val;
				if (!cs) {
					return;
				}
				val = b; //just for swapping the variables an inverting them (reused "val" to avoid creating another variable in memory). IE's filter matrix uses a non-standard matrix configuration (angle goes the opposite way, and b and c are reversed and inverted)
				b = -c;
				c = -val;
				filters = cs.filter;
				style.filter = ""; //remove filters so that we can accurately measure offsetWidth/offsetHeight
				var w = this.t.offsetWidth,
					h = this.t.offsetHeight,
					clip = (cs.position !== "absolute"),
					m = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + d,
					ox = t.x + (w * t.xPercent / 100),
					oy = t.y + (h * t.yPercent / 100),
					dx, dy;

				//if transformOrigin is being used, adjust the offset x and y
				if (t.ox != null) {
					dx = ((t.oxp) ? w * t.ox * 0.01 : t.ox) - w / 2;
					dy = ((t.oyp) ? h * t.oy * 0.01 : t.oy) - h / 2;
					ox += dx - (dx * a + dy * b);
					oy += dy - (dx * c + dy * d);
				}

				if (!clip) {
					m += ", sizingMethod='auto expand')";
				} else {
					dx = (w / 2);
					dy = (h / 2);
					//translate to ensure that transformations occur around the correct origin (default is center).
					m += ", Dx=" + (dx - (dx * a + dy * b) + ox) + ", Dy=" + (dy - (dx * c + dy * d) + oy) + ")";
				}
				if (filters.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1) {
					style.filter = filters.replace(_ieSetMatrixExp, m);
				} else {
					style.filter = m + " " + filters; //we must always put the transform/matrix FIRST (before alpha(opacity=xx)) to avoid an IE bug that slices part of the object when rotation is applied with alpha.
				}

				//at the end or beginning of the tween, if the matrix is normal (1, 0, 0, 1) and opacity is 100 (or doesn't exist), remove the filter to improve browser performance.
				if (v === 0 || v === 1) if (a === 1) if (b === 0) if (c === 0) if (d === 1) if (!clip || m.indexOf("Dx=0, Dy=0") !== -1) if (!_opacityExp.test(filters) || parseFloat(RegExp.$1) === 100) if (filters.indexOf("gradient(" && filters.indexOf("Alpha")) === -1) {
					style.removeAttribute("filter");
				}

				//we must set the margins AFTER applying the filter in order to avoid some bugs in IE8 that could (in rare scenarios) cause them to be ignored intermittently (vibration).
				if (!clip) {
					var mult = (_ieVers < 8) ? 1 : -1, //in Internet Explorer 7 and before, the box model is broken, causing the browser to treat the width/height of the actual rotated filtered image as the width/height of the box itself, but Microsoft corrected that in IE8. We must use a negative offset in IE8 on the right/bottom
						marg, prop, dif;
					dx = t.ieOffsetX || 0;
					dy = t.ieOffsetY || 0;
					t.ieOffsetX = Math.round((w - ((a < 0 ? -a : a) * w + (b < 0 ? -b : b) * h)) / 2 + ox);
					t.ieOffsetY = Math.round((h - ((d < 0 ? -d : d) * h + (c < 0 ? -c : c) * w)) / 2 + oy);
					for (i = 0; i < 4; i++) {
						prop = _margins[i];
						marg = cs[prop];
						//we need to get the current margin in case it is being tweened separately (we want to respect that tween's changes)
						val = (marg.indexOf("px") !== -1) ? parseFloat(marg) : _convertToPixels(this.t, prop, parseFloat(marg), marg.replace(_suffixExp, "")) || 0;
						if (val !== t[prop]) {
							dif = (i < 2) ? -t.ieOffsetX : -t.ieOffsetY; //if another tween is controlling a margin, we cannot only apply the difference in the ieOffsets, so we essentially zero-out the dx and dy here in that case. We record the margin(s) later so that we can keep comparing them, making this code very flexible.
						} else {
							dif = (i < 2) ? dx - t.ieOffsetX : dy - t.ieOffsetY;
						}
						style[prop] = (t[prop] = Math.round( val - dif * ((i === 0 || i === 2) ? 1 : mult) )) + "px";
					}
				}
			},

			/* translates a super small decimal to a string WITHOUT scientific notation
			_safeDecimal = function(n) {
				var s = (n < 0 ? -n : n) + "",
					a = s.split("e-");
				return (n < 0 ? "-0." : "0.") + new Array(parseInt(a[1], 10) || 0).join("0") + a[0].split(".").join("");
			},
			*/

			_setTransformRatio = _internals.set3DTransformRatio = _internals.setTransformRatio = function(v) {
				var t = this.data, //refers to the element's _gsTransform object
					style = this.t.style,
					angle = t.rotation,
					rotationX = t.rotationX,
					rotationY = t.rotationY,
					sx = t.scaleX,
					sy = t.scaleY,
					sz = t.scaleZ,
					x = t.x,
					y = t.y,
					z = t.z,
					isSVG = t.svg,
					perspective = t.perspective,
					force3D = t.force3D,
					skewY = t.skewY,
					skewX = t.skewX,
					t1,	a11, a12, a13, a21, a22, a23, a31, a32, a33, a41, a42, a43,
					zOrigin, min, cos, sin, t2, transform, comma, zero, skew, rnd;
				if (skewY) { //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
					skewX += skewY;
					angle += skewY;
				}

				//check to see if we should render as 2D (and SVGs must use 2D when _useSVGTransformAttr is true)
				if (((((v === 1 || v === 0) && force3D === "auto" && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !force3D) && !z && !perspective && !rotationY && !rotationX && sz === 1) || (_useSVGTransformAttr && isSVG) || !_supports3D) { //on the final render (which could be 0 for a from tween), if there are no 3D aspects, render in 2D to free up memory and improve performance especially on mobile devices. Check the tween's totalTime/totalDuration too in order to make sure it doesn't happen between repeats if it's a repeating tween.

					//2D
					if (angle || skewX || isSVG) {
						angle *= _DEG2RAD;
						skew = skewX * _DEG2RAD;
						rnd = 100000;
						a11 = Math.cos(angle) * sx;
						a21 = Math.sin(angle) * sx;
						a12 = Math.sin(angle - skew) * -sy;
						a22 = Math.cos(angle - skew) * sy;
						if (skew && t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
							t1 = Math.tan(skew - skewY * _DEG2RAD);
							t1 = Math.sqrt(1 + t1 * t1);
							a12 *= t1;
							a22 *= t1;
							if (skewY) {
								t1 = Math.tan(skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a11 *= t1;
								a21 *= t1;
							}
						}
						if (isSVG) {
							x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
							y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
							if (_useSVGTransformAttr && (t.xPercent || t.yPercent)) { //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the matrix to simulate it.
								min = this.t.getBBox();
								x += t.xPercent * 0.01 * min.width;
								y += t.yPercent * 0.01 * min.height;
							}
							min = 0.000001;
							if (x < min) if (x > -min) {
								x = 0;
							}
							if (y < min) if (y > -min) {
								y = 0;
							}
						}
						transform = (((a11 * rnd) | 0) / rnd) + "," + (((a21 * rnd) | 0) / rnd) + "," + (((a12 * rnd) | 0) / rnd) + "," + (((a22 * rnd) | 0) / rnd) + "," + x + "," + y + ")";
						if (isSVG && _useSVGTransformAttr) {
							this.t.setAttribute("transform", "matrix(" + transform);
						} else {
							//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 5 decimal places.
							style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + transform;
						}
					} else {
						style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + sx + ",0,0," + sy + "," + x + "," + y + ")";
					}
					return;

				}
				if (_isFirefox) { //Firefox has a bug (at least in v25) that causes it to render the transparent part of 32-bit PNG images as black when displayed inside an iframe and the 3D scale is very small and doesn't change sufficiently enough between renders (like if you use a Power4.easeInOut to scale from 0 to 1 where the beginning values only change a tiny amount to begin the tween before accelerating). In this case, we force the scale to be 0.00002 instead which is visually the same but works around the Firefox issue.
					min = 0.0001;
					if (sx < min && sx > -min) {
						sx = sz = 0.00002;
					}
					if (sy < min && sy > -min) {
						sy = sz = 0.00002;
					}
					if (perspective && !t.z && !t.rotationX && !t.rotationY) { //Firefox has a bug that causes elements to have an odd super-thin, broken/dotted black border on elements that have a perspective set but aren't utilizing 3D space (no rotationX, rotationY, or z).
						perspective = 0;
					}
				}
				if (angle || skewX) {
					angle *= _DEG2RAD;
					cos = a11 = Math.cos(angle);
					sin = a21 = Math.sin(angle);
					if (skewX) {
						angle -= skewX * _DEG2RAD;
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						if (t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
							t1 = Math.tan((skewX - skewY) * _DEG2RAD);
							t1 = Math.sqrt(1 + t1 * t1);
							cos *= t1;
							sin *= t1;
							if (t.skewY) {
								t1 = Math.tan(skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a11 *= t1;
								a21 *= t1;
							}
						}
					}
					a12 = -sin;
					a22 = cos;

				} else if (!rotationY && !rotationX && sz === 1 && !perspective && !isSVG) { //if we're only translating and/or 2D scaling, this is faster...
					style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) translate3d(" : "translate3d(") + x + "px," + y + "px," + z +"px)" + ((sx !== 1 || sy !== 1) ? " scale(" + sx + "," + sy + ")" : "");
					return;
				} else {
					a11 = a22 = 1;
					a12 = a21 = 0;
				}
				// KEY  INDEX   AFFECTS a[row][column]
				// a11  0       rotation, rotationY, scaleX
				// a21  1       rotation, rotationY, scaleX
				// a31  2       rotationY, scaleX
				// a41  3       rotationY, scaleX
				// a12  4       rotation, skewX, rotationX, scaleY
				// a22  5       rotation, skewX, rotationX, scaleY
				// a32  6       rotationX, scaleY
				// a42  7       rotationX, scaleY
				// a13  8       rotationY, rotationX, scaleZ
				// a23  9       rotationY, rotationX, scaleZ
				// a33  10      rotationY, rotationX, scaleZ
				// a43  11      rotationY, rotationX, perspective, scaleZ
				// a14  12      x, zOrigin, svgOrigin
				// a24  13      y, zOrigin, svgOrigin
				// a34  14      z, zOrigin
				// a44  15
				// rotation: Math.atan2(a21, a11)
				// rotationY: Math.atan2(a13, a33) (or Math.atan2(a13, a11))
				// rotationX: Math.atan2(a32, a33)
				a33 = 1;
				a13 = a23 = a31 = a32 = a41 = a42 = 0;
				a43 = (perspective) ? -1 / perspective : 0;
				zOrigin = t.zOrigin;
				min = 0.000001; //threshold below which browsers use scientific notation which won't work.
				comma = ",";
				zero = "0";
				angle = rotationY * _DEG2RAD;
				if (angle) {
					cos = Math.cos(angle);
					sin = Math.sin(angle);
					a31 = -sin;
					a41 = a43*-sin;
					a13 = a11*sin;
					a23 = a21*sin;
					a33 = cos;
					a43 *= cos;
					a11 *= cos;
					a21 *= cos;
				}
				angle = rotationX * _DEG2RAD;
				if (angle) {
					cos = Math.cos(angle);
					sin = Math.sin(angle);
					t1 = a12*cos+a13*sin;
					t2 = a22*cos+a23*sin;
					a32 = a33*sin;
					a42 = a43*sin;
					a13 = a12*-sin+a13*cos;
					a23 = a22*-sin+a23*cos;
					a33 = a33*cos;
					a43 = a43*cos;
					a12 = t1;
					a22 = t2;
				}
				if (sz !== 1) {
					a13*=sz;
					a23*=sz;
					a33*=sz;
					a43*=sz;
				}
				if (sy !== 1) {
					a12*=sy;
					a22*=sy;
					a32*=sy;
					a42*=sy;
				}
				if (sx !== 1) {
					a11*=sx;
					a21*=sx;
					a31*=sx;
					a41*=sx;
				}

				if (zOrigin || isSVG) {
					if (zOrigin) {
						x += a13*-zOrigin;
						y += a23*-zOrigin;
						z += a33*-zOrigin+zOrigin;
					}
					if (isSVG) { //due to bugs in some browsers, we need to manage the transform-origin of SVG manually
						x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
						y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
					}
					if (x < min && x > -min) {
						x = zero;
					}
					if (y < min && y > -min) {
						y = zero;
					}
					if (z < min && z > -min) {
						z = 0; //don't use string because we calculate perspective later and need the number.
					}
				}

				//optimized way of concatenating all the values into a string. If we do it all in one shot, it's slower because of the way browsers have to create temp strings and the way it affects memory. If we do it piece-by-piece with +=, it's a bit slower too. We found that doing it in these sized chunks works best overall:
				transform = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix3d(" : "matrix3d(");
				transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
				transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
				if (rotationX || rotationY || sz !== 1) { //performance optimization (often there's no rotationX or rotationY, so we can skip these calculations)
					transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
					transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
				} else {
					transform += ",0,0,0,0,1,0,";
				}
				transform += x + comma + y + comma + z + comma + (perspective ? (1 + (-z / perspective)) : 1) + ")";

				style[_transformProp] = transform;
			};

		p = Transform.prototype;
		p.x = p.y = p.z = p.skewX = p.skewY = p.rotation = p.rotationX = p.rotationY = p.zOrigin = p.xPercent = p.yPercent = p.xOffset = p.yOffset = 0;
		p.scaleX = p.scaleY = p.scaleZ = 1;

		_registerComplexSpecialProp("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {parser:function(t, e, parsingProp, cssp, pt, plugin, vars) {
			if (cssp._lastParsedTransform === vars) { return pt; } //only need to parse the transform once, and only if the browser supports it.
			cssp._lastParsedTransform = vars;
			var scaleFunc = (vars.scale && typeof(vars.scale) === "function") ? vars.scale : 0, //if there's a function-based "scale" value, swap in the resulting numeric value temporarily. Otherwise, if it's called for both scaleX and scaleY independently, they may not match (like if the function uses Math.random()).
				swapFunc;
			if (typeof(vars[parsingProp]) === "function") { //whatever property triggers the initial parsing might be a function-based value in which case it already got called in parse(), thus we don't want to call it again in here. The most efficient way to avoid this is to temporarily swap the value directly into the vars object, and then after we do all our parsing in this function, we'll swap it back again.
				swapFunc = vars[parsingProp];
				vars[parsingProp] = e;
			}
			if (scaleFunc) {
				vars.scale = scaleFunc(_index, t);
			}
			var originalGSTransform = t._gsTransform,
				style = t.style,
				min = 0.000001,
				i = _transformProps.length,
				v = vars,
				endRotations = {},
				transformOriginString = "transformOrigin",
				m1 = _getTransform(t, _cs, true, v.parseTransform),
				orig = v.transform && ((typeof(v.transform) === "function") ? v.transform(_index, _target) : v.transform),
				m2, copy, has3D, hasChange, dr, x, y, matrix, p;
			m1.skewType = v.skewType || m1.skewType || CSSPlugin.defaultSkewType;
			cssp._transform = m1;
			if (orig && typeof(orig) === "string" && _transformProp) { //for values like transform:"rotate(60deg) scale(0.5, 0.8)"
				copy = _tempDiv.style; //don't use the original target because it might be SVG in which case some browsers don't report computed style correctly.
				copy[_transformProp] = orig;
				copy.display = "block"; //if display is "none", the browser often refuses to report the transform properties correctly.
				copy.position = "absolute";
				_doc.body.appendChild(_tempDiv);
				m2 = _getTransform(_tempDiv, null, false);
				if (m1.skewType === "simple") { //the default _getTransform() reports the skewX/scaleY as if skewType is "compensated", thus we need to adjust that here if skewType is "simple".
					m2.scaleY *= Math.cos(m2.skewX * _DEG2RAD);
				}
				if (m1.svg) { //if it's an SVG element, x/y part of the matrix will be affected by whatever we use as the origin and the offsets, so compensate here...
					x = m1.xOrigin;
					y = m1.yOrigin;
					m2.x -= m1.xOffset;
					m2.y -= m1.yOffset;
					if (v.transformOrigin || v.svgOrigin) { //if this tween is altering the origin, we must factor that in here. The actual work of recording the transformOrigin values and setting up the PropTween is done later (still inside this function) so we cannot leave the changes intact here - we only want to update the x/y accordingly.
						orig = {};
						_parseSVGOrigin(t, _parsePosition(v.transformOrigin), orig, v.svgOrigin, v.smoothOrigin, true);
						x = orig.xOrigin;
						y = orig.yOrigin;
						m2.x -= orig.xOffset - m1.xOffset;
						m2.y -= orig.yOffset - m1.yOffset;
					}
					if (x || y) {
						matrix = _getMatrix(_tempDiv, true);
						m2.x -= x - (x * matrix[0] + y * matrix[2]);
						m2.y -= y - (x * matrix[1] + y * matrix[3]);
					}
				}
				_doc.body.removeChild(_tempDiv);
				if (!m2.perspective) {
					m2.perspective = m1.perspective; //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
				}
				if (v.xPercent != null) {
					m2.xPercent = _parseVal(v.xPercent, m1.xPercent);
				}
				if (v.yPercent != null) {
					m2.yPercent = _parseVal(v.yPercent, m1.yPercent);
				}
			} else if (typeof(v) === "object") { //for values like scaleX, scaleY, rotation, x, y, skewX, and skewY or transform:{...} (object)
				m2 = {scaleX:_parseVal((v.scaleX != null) ? v.scaleX : v.scale, m1.scaleX),
					scaleY:_parseVal((v.scaleY != null) ? v.scaleY : v.scale, m1.scaleY),
					scaleZ:_parseVal(v.scaleZ, m1.scaleZ),
					x:_parseVal(v.x, m1.x),
					y:_parseVal(v.y, m1.y),
					z:_parseVal(v.z, m1.z),
					xPercent:_parseVal(v.xPercent, m1.xPercent),
					yPercent:_parseVal(v.yPercent, m1.yPercent),
					perspective:_parseVal(v.transformPerspective, m1.perspective)};
				dr = v.directionalRotation;
				if (dr != null) {
					if (typeof(dr) === "object") {
						for (copy in dr) {
							v[copy] = dr[copy];
						}
					} else {
						v.rotation = dr;
					}
				}
				if (typeof(v.x) === "string" && v.x.indexOf("%") !== -1) {
					m2.x = 0;
					m2.xPercent = _parseVal(v.x, m1.xPercent);
				}
				if (typeof(v.y) === "string" && v.y.indexOf("%") !== -1) {
					m2.y = 0;
					m2.yPercent = _parseVal(v.y, m1.yPercent);
				}

				m2.rotation = _parseAngle(("rotation" in v) ? v.rotation : ("shortRotation" in v) ? v.shortRotation + "_short" : ("rotationZ" in v) ? v.rotationZ : m1.rotation, m1.rotation, "rotation", endRotations);
				if (_supports3D) {
					m2.rotationX = _parseAngle(("rotationX" in v) ? v.rotationX : ("shortRotationX" in v) ? v.shortRotationX + "_short" : m1.rotationX || 0, m1.rotationX, "rotationX", endRotations);
					m2.rotationY = _parseAngle(("rotationY" in v) ? v.rotationY : ("shortRotationY" in v) ? v.shortRotationY + "_short" : m1.rotationY || 0, m1.rotationY, "rotationY", endRotations);
				}
				m2.skewX = _parseAngle(v.skewX, m1.skewX);
				m2.skewY = _parseAngle(v.skewY, m1.skewY);
			}
			if (_supports3D && v.force3D != null) {
				m1.force3D = v.force3D;
				hasChange = true;
			}

			has3D = (m1.force3D || m1.z || m1.rotationX || m1.rotationY || m2.z || m2.rotationX || m2.rotationY || m2.perspective);
			if (!has3D && v.scale != null) {
				m2.scaleZ = 1; //no need to tween scaleZ.
			}

			while (--i > -1) {
				p = _transformProps[i];
				orig = m2[p] - m1[p];
				if (orig > min || orig < -min || v[p] != null || _forcePT[p] != null) {
					hasChange = true;
					pt = new CSSPropTween(m1, p, m1[p], orig, pt);
					if (p in endRotations) {
						pt.e = endRotations[p]; //directional rotations typically have compensated values during the tween, but we need to make sure they end at exactly what the user requested
					}
					pt.xs0 = 0; //ensures the value stays numeric in setRatio()
					pt.plugin = plugin;
					cssp._overwriteProps.push(pt.n);
				}
			}

			orig = v.transformOrigin;
			if (m1.svg && (orig || v.svgOrigin)) {
				x = m1.xOffset; //when we change the origin, in order to prevent things from jumping we adjust the x/y so we must record those here so that we can create PropTweens for them and flip them at the same time as the origin
				y = m1.yOffset;
				_parseSVGOrigin(t, _parsePosition(orig), m2, v.svgOrigin, v.smoothOrigin);
				pt = _addNonTweeningNumericPT(m1, "xOrigin", (originalGSTransform ? m1 : m2).xOrigin, m2.xOrigin, pt, transformOriginString); //note: if there wasn't a transformOrigin defined yet, just start with the destination one; it's wasteful otherwise, and it causes problems with fromTo() tweens. For example, TweenLite.to("#wheel", 3, {rotation:180, transformOrigin:"50% 50%", delay:1}); TweenLite.fromTo("#wheel", 3, {scale:0.5, transformOrigin:"50% 50%"}, {scale:1, delay:2}); would cause a jump when the from values revert at the beginning of the 2nd tween.
				pt = _addNonTweeningNumericPT(m1, "yOrigin", (originalGSTransform ? m1 : m2).yOrigin, m2.yOrigin, pt, transformOriginString);
				if (x !== m1.xOffset || y !== m1.yOffset) {
					pt = _addNonTweeningNumericPT(m1, "xOffset", (originalGSTransform ? x : m1.xOffset), m1.xOffset, pt, transformOriginString);
					pt = _addNonTweeningNumericPT(m1, "yOffset", (originalGSTransform ? y : m1.yOffset), m1.yOffset, pt, transformOriginString);
				}
				orig = "0px 0px"; //certain browsers (like firefox) completely botch transform-origin, so we must remove it to prevent it from contaminating transforms. We manage it ourselves with xOrigin and yOrigin
			}
			if (orig || (_supports3D && has3D && m1.zOrigin)) { //if anything 3D is happening and there's a transformOrigin with a z component that's non-zero, we must ensure that the transformOrigin's z-component is set to 0 so that we can manually do those calculations to get around Safari bugs. Even if the user didn't specifically define a "transformOrigin" in this particular tween (maybe they did it via css directly).
				if (_transformProp) {
					hasChange = true;
					p = _transformOriginProp;
					orig = (orig || _getStyle(t, p, _cs, false, "50% 50%")) + ""; //cast as string to avoid errors
					pt = new CSSPropTween(style, p, 0, 0, pt, -1, transformOriginString);
					pt.b = style[p];
					pt.plugin = plugin;
					if (_supports3D) {
						copy = m1.zOrigin;
						orig = orig.split(" ");
						m1.zOrigin = ((orig.length > 2 && !(copy !== 0 && orig[2] === "0px")) ? parseFloat(orig[2]) : copy) || 0; //Safari doesn't handle the z part of transformOrigin correctly, so we'll manually handle it in the _set3DTransformRatio() method.
						pt.xs0 = pt.e = orig[0] + " " + (orig[1] || "50%") + " 0px"; //we must define a z value of 0px specifically otherwise iOS 5 Safari will stick with the old one (if one was defined)!
						pt = new CSSPropTween(m1, "zOrigin", 0, 0, pt, -1, pt.n); //we must create a CSSPropTween for the _gsTransform.zOrigin so that it gets reset properly at the beginning if the tween runs backward (as opposed to just setting m1.zOrigin here)
						pt.b = copy;
						pt.xs0 = pt.e = m1.zOrigin;
					} else {
						pt.xs0 = pt.e = orig;
					}

					//for older versions of IE (6-8), we need to manually calculate things inside the setRatio() function. We record origin x and y (ox and oy) and whether or not the values are percentages (oxp and oyp).
				} else {
					_parsePosition(orig + "", m1);
				}
			}
			if (hasChange) {
				cssp._transformType = (!(m1.svg && _useSVGTransformAttr) && (has3D || this._transformType === 3)) ? 3 : 2; //quicker than calling cssp._enableTransforms();
			}
			if (swapFunc) {
				vars[parsingProp] = swapFunc;
			}
			if (scaleFunc) {
				vars.scale = scaleFunc;
			}
			return pt;
		}, prefix:true});

		_registerComplexSpecialProp("boxShadow", {defaultValue:"0px 0px 0px 0px #999", prefix:true, color:true, multi:true, keyword:"inset"});

		_registerComplexSpecialProp("borderRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
			e = this.format(e);
			var props = ["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],
				style = t.style,
				ea1, i, es2, bs2, bs, es, bn, en, w, h, esfx, bsfx, rel, hn, vn, em;
			w = parseFloat(t.offsetWidth);
			h = parseFloat(t.offsetHeight);
			ea1 = e.split(" ");
			for (i = 0; i < props.length; i++) { //if we're dealing with percentages, we must convert things separately for the horizontal and vertical axis!
				if (this.p.indexOf("border")) { //older browsers used a prefix
					props[i] = _checkPropPrefix(props[i]);
				}
				bs = bs2 = _getStyle(t, props[i], _cs, false, "0px");
				if (bs.indexOf(" ") !== -1) {
					bs2 = bs.split(" ");
					bs = bs2[0];
					bs2 = bs2[1];
				}
				es = es2 = ea1[i];
				bn = parseFloat(bs);
				bsfx = bs.substr((bn + "").length);
				rel = (es.charAt(1) === "=");
				if (rel) {
					en = parseInt(es.charAt(0)+"1", 10);
					es = es.substr(2);
					en *= parseFloat(es);
					esfx = es.substr((en + "").length - (en < 0 ? 1 : 0)) || "";
				} else {
					en = parseFloat(es);
					esfx = es.substr((en + "").length);
				}
				if (esfx === "") {
					esfx = _suffixMap[p] || bsfx;
				}
				if (esfx !== bsfx) {
					hn = _convertToPixels(t, "borderLeft", bn, bsfx); //horizontal number (we use a bogus "borderLeft" property just because the _convertToPixels() method searches for the keywords "Left", "Right", "Top", and "Bottom" to determine of it's a horizontal or vertical property, and we need "border" in the name so that it knows it should measure relative to the element itself, not its parent.
					vn = _convertToPixels(t, "borderTop", bn, bsfx); //vertical number
					if (esfx === "%") {
						bs = (hn / w * 100) + "%";
						bs2 = (vn / h * 100) + "%";
					} else if (esfx === "em") {
						em = _convertToPixels(t, "borderLeft", 1, "em");
						bs = (hn / em) + "em";
						bs2 = (vn / em) + "em";
					} else {
						bs = hn + "px";
						bs2 = vn + "px";
					}
					if (rel) {
						es = (parseFloat(bs) + en) + esfx;
						es2 = (parseFloat(bs2) + en) + esfx;
					}
				}
				pt = _parseComplex(style, props[i], bs + " " + bs2, es + " " + es2, false, "0px", pt);
			}
			return pt;
		}, prefix:true, formatter:_getFormatter("0px 0px 0px 0px", false, true)});
		_registerComplexSpecialProp("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
			return _parseComplex(t.style, p, this.format(_getStyle(t, p, _cs, false, "0px 0px")), this.format(e), false, "0px", pt);
		}, prefix:true, formatter:_getFormatter("0px 0px", false, true)});
		_registerComplexSpecialProp("backgroundPosition", {defaultValue:"0 0", parser:function(t, e, p, cssp, pt, plugin) {
			var bp = "background-position",
				cs = (_cs || _getComputedStyle(t, null)),
				bs = this.format( ((cs) ? _ieVers ? cs.getPropertyValue(bp + "-x") + " " + cs.getPropertyValue(bp + "-y") : cs.getPropertyValue(bp) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"), //Internet Explorer doesn't report background-position correctly - we must query background-position-x and background-position-y and combine them (even in IE10). Before IE9, we must do the same with the currentStyle object and use camelCase
				es = this.format(e),
				ba, ea, i, pct, overlap, src;
			if ((bs.indexOf("%") !== -1) !== (es.indexOf("%") !== -1) && es.split(",").length < 2) {
				src = _getStyle(t, "backgroundImage").replace(_urlExp, "");
				if (src && src !== "none") {
					ba = bs.split(" ");
					ea = es.split(" ");
					_tempImg.setAttribute("src", src); //set the temp IMG's src to the background-image so that we can measure its width/height
					i = 2;
					while (--i > -1) {
						bs = ba[i];
						pct = (bs.indexOf("%") !== -1);
						if (pct !== (ea[i].indexOf("%") !== -1)) {
							overlap = (i === 0) ? t.offsetWidth - _tempImg.width : t.offsetHeight - _tempImg.height;
							ba[i] = pct ? (parseFloat(bs) / 100 * overlap) + "px" : (parseFloat(bs) / overlap * 100) + "%";
						}
					}
					bs = ba.join(" ");
				}
			}
			return this.parseComplex(t.style, bs, es, pt, plugin);
		}, formatter:_parsePosition});
		_registerComplexSpecialProp("backgroundSize", {defaultValue:"0 0", formatter:function(v) {
			v += ""; //ensure it's a string
			return _parsePosition(v.indexOf(" ") === -1 ? v + " " + v : v); //if set to something like "100% 100%", Safari typically reports the computed style as just "100%" (no 2nd value), but we should ensure that there are two values, so copy the first one. Otherwise, it'd be interpreted as "100% 0" (wrong).
		}});
		_registerComplexSpecialProp("perspective", {defaultValue:"0px", prefix:true});
		_registerComplexSpecialProp("perspectiveOrigin", {defaultValue:"50% 50%", prefix:true});
		_registerComplexSpecialProp("transformStyle", {prefix:true});
		_registerComplexSpecialProp("backfaceVisibility", {prefix:true});
		_registerComplexSpecialProp("userSelect", {prefix:true});
		_registerComplexSpecialProp("margin", {parser:_getEdgeParser("marginTop,marginRight,marginBottom,marginLeft")});
		_registerComplexSpecialProp("padding", {parser:_getEdgeParser("paddingTop,paddingRight,paddingBottom,paddingLeft")});
		_registerComplexSpecialProp("clip", {defaultValue:"rect(0px,0px,0px,0px)", parser:function(t, e, p, cssp, pt, plugin){
			var b, cs, delim;
			if (_ieVers < 9) { //IE8 and earlier don't report a "clip" value in the currentStyle - instead, the values are split apart into clipTop, clipRight, clipBottom, and clipLeft. Also, in IE7 and earlier, the values inside rect() are space-delimited, not comma-delimited.
				cs = t.currentStyle;
				delim = _ieVers < 8 ? " " : ",";
				b = "rect(" + cs.clipTop + delim + cs.clipRight + delim + cs.clipBottom + delim + cs.clipLeft + ")";
				e = this.format(e).split(",").join(delim);
			} else {
				b = this.format(_getStyle(t, this.p, _cs, false, this.dflt));
				e = this.format(e);
			}
			return this.parseComplex(t.style, b, e, pt, plugin);
		}});
		_registerComplexSpecialProp("textShadow", {defaultValue:"0px 0px 0px #999", color:true, multi:true});
		_registerComplexSpecialProp("autoRound,strictUnits", {parser:function(t, e, p, cssp, pt) {return pt;}}); //just so that we can ignore these properties (not tween them)
		_registerComplexSpecialProp("border", {defaultValue:"0px solid #000", parser:function(t, e, p, cssp, pt, plugin) {
			var bw = _getStyle(t, "borderTopWidth", _cs, false, "0px"),
				end = this.format(e).split(" "),
				esfx = end[0].replace(_suffixExp, "");
			if (esfx !== "px") { //if we're animating to a non-px value, we need to convert the beginning width to that unit.
				bw = (parseFloat(bw) / _convertToPixels(t, "borderTopWidth", 1, esfx)) + esfx;
			}
			return this.parseComplex(t.style, this.format(bw + " " + _getStyle(t, "borderTopStyle", _cs, false, "solid") + " " + _getStyle(t, "borderTopColor", _cs, false, "#000")), end.join(" "), pt, plugin);
			}, color:true, formatter:function(v) {
				var a = v.split(" ");
				return a[0] + " " + (a[1] || "solid") + " " + (v.match(_colorExp) || ["#000"])[0];
			}});
		_registerComplexSpecialProp("borderWidth", {parser:_getEdgeParser("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}); //Firefox doesn't pick up on borderWidth set in style sheets (only inline).
		_registerComplexSpecialProp("float,cssFloat,styleFloat", {parser:function(t, e, p, cssp, pt, plugin) {
			var s = t.style,
				prop = ("cssFloat" in s) ? "cssFloat" : "styleFloat";
			return new CSSPropTween(s, prop, 0, 0, pt, -1, p, false, 0, s[prop], e);
		}});

		//opacity-related
		var _setIEOpacityRatio = function(v) {
				var t = this.t, //refers to the element's style property
					filters = t.filter || _getStyle(this.data, "filter") || "",
					val = (this.s + this.c * v) | 0,
					skip;
				if (val === 100) { //for older versions of IE that need to use a filter to apply opacity, we should remove the filter if opacity hits 1 in order to improve performance, but make sure there isn't a transform (matrix) or gradient in the filters.
					if (filters.indexOf("atrix(") === -1 && filters.indexOf("radient(") === -1 && filters.indexOf("oader(") === -1) {
						t.removeAttribute("filter");
						skip = (!_getStyle(this.data, "filter")); //if a class is applied that has an alpha filter, it will take effect (we don't want that), so re-apply our alpha filter in that case. We must first remove it and then check.
					} else {
						t.filter = filters.replace(_alphaFilterExp, "");
						skip = true;
					}
				}
				if (!skip) {
					if (this.xn1) {
						t.filter = filters = filters || ("alpha(opacity=" + val + ")"); //works around bug in IE7/8 that prevents changes to "visibility" from being applied properly if the filter is changed to a different alpha on the same frame.
					}
					if (filters.indexOf("pacity") === -1) { //only used if browser doesn't support the standard opacity style property (IE 7 and 8). We omit the "O" to avoid case-sensitivity issues
						if (val !== 0 || !this.xn1) { //bugs in IE7/8 won't render the filter properly if opacity is ADDED on the same frame/render as "visibility" changes (this.xn1 is 1 if this tween is an "autoAlpha" tween)
							t.filter = filters + " alpha(opacity=" + val + ")"; //we round the value because otherwise, bugs in IE7/8 can prevent "visibility" changes from being applied properly.
						}
					} else {
						t.filter = filters.replace(_opacityExp, "opacity=" + val);
					}
				}
			};
		_registerComplexSpecialProp("opacity,alpha,autoAlpha", {defaultValue:"1", parser:function(t, e, p, cssp, pt, plugin) {
			var b = parseFloat(_getStyle(t, "opacity", _cs, false, "1")),
				style = t.style,
				isAutoAlpha = (p === "autoAlpha");
			if (typeof(e) === "string" && e.charAt(1) === "=") {
				e = ((e.charAt(0) === "-") ? -1 : 1) * parseFloat(e.substr(2)) + b;
			}
			if (isAutoAlpha && b === 1 && _getStyle(t, "visibility", _cs) === "hidden" && e !== 0) { //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
				b = 0;
			}
			if (_supportsOpacity) {
				pt = new CSSPropTween(style, "opacity", b, e - b, pt);
			} else {
				pt = new CSSPropTween(style, "opacity", b * 100, (e - b) * 100, pt);
				pt.xn1 = isAutoAlpha ? 1 : 0; //we need to record whether or not this is an autoAlpha so that in the setRatio(), we know to duplicate the setting of the alpha in order to work around a bug in IE7 and IE8 that prevents changes to "visibility" from taking effect if the filter is changed to a different alpha(opacity) at the same time. Setting it to the SAME value first, then the new value works around the IE7/8 bug.
				style.zoom = 1; //helps correct an IE issue.
				pt.type = 2;
				pt.b = "alpha(opacity=" + pt.s + ")";
				pt.e = "alpha(opacity=" + (pt.s + pt.c) + ")";
				pt.data = t;
				pt.plugin = plugin;
				pt.setRatio = _setIEOpacityRatio;
			}
			if (isAutoAlpha) { //we have to create the "visibility" PropTween after the opacity one in the linked list so that they run in the order that works properly in IE8 and earlier
				pt = new CSSPropTween(style, "visibility", 0, 0, pt, -1, null, false, 0, ((b !== 0) ? "inherit" : "hidden"), ((e === 0) ? "hidden" : "inherit"));
				pt.xs0 = "inherit";
				cssp._overwriteProps.push(pt.n);
				cssp._overwriteProps.push(p);
			}
			return pt;
		}});


		var _removeProp = function(s, p) {
				if (p) {
					if (s.removeProperty) {
						if (p.substr(0,2) === "ms" || p.substr(0,6) === "webkit") { //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
							p = "-" + p;
						}
						s.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
					} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
						s.removeAttribute(p);
					}
				}
			},
			_setClassNameRatio = function(v) {
				this.t._gsClassPT = this;
				if (v === 1 || v === 0) {
					this.t.setAttribute("class", (v === 0) ? this.b : this.e);
					var mpt = this.data, //first MiniPropTween
						s = this.t.style;
					while (mpt) {
						if (!mpt.v) {
							_removeProp(s, mpt.p);
						} else {
							s[mpt.p] = mpt.v;
						}
						mpt = mpt._next;
					}
					if (v === 1 && this.t._gsClassPT === this) {
						this.t._gsClassPT = null;
					}
				} else if (this.t.getAttribute("class") !== this.e) {
					this.t.setAttribute("class", this.e);
				}
			};
		_registerComplexSpecialProp("className", {parser:function(t, e, p, cssp, pt, plugin, vars) {
			var b = t.getAttribute("class") || "", //don't use t.className because it doesn't work consistently on SVG elements; getAttribute("class") and setAttribute("class", value") is more reliable.
				cssText = t.style.cssText,
				difData, bs, cnpt, cnptLookup, mpt;
			pt = cssp._classNamePT = new CSSPropTween(t, p, 0, 0, pt, 2);
			pt.setRatio = _setClassNameRatio;
			pt.pr = -11;
			_hasPriority = true;
			pt.b = b;
			bs = _getAllStyles(t, _cs);
			//if there's a className tween already operating on the target, force it to its end so that the necessary inline styles are removed and the class name is applied before we determine the end state (we don't want inline styles interfering that were there just for class-specific values)
			cnpt = t._gsClassPT;
			if (cnpt) {
				cnptLookup = {};
				mpt = cnpt.data; //first MiniPropTween which stores the inline styles - we need to force these so that the inline styles don't contaminate things. Otherwise, there's a small chance that a tween could start and the inline values match the destination values and they never get cleaned.
				while (mpt) {
					cnptLookup[mpt.p] = 1;
					mpt = mpt._next;
				}
				cnpt.setRatio(1);
			}
			t._gsClassPT = pt;
			pt.e = (e.charAt(1) !== "=") ? e : b.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ((e.charAt(0) === "+") ? " " + e.substr(2) : "");
			t.setAttribute("class", pt.e);
			difData = _cssDif(t, bs, _getAllStyles(t), vars, cnptLookup);
			t.setAttribute("class", b);
			pt.data = difData.firstMPT;
			t.style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
			pt = pt.xfirst = cssp.parse(t, difData.difs, pt, plugin); //we record the CSSPropTween as the xfirst so that we can handle overwriting propertly (if "className" gets overwritten, we must kill all the properties associated with the className part of the tween, so we can loop through from xfirst to the pt itself)
			return pt;
		}});


		var _setClearPropsRatio = function(v) {
			if (v === 1 || v === 0) if (this.data._totalTime === this.data._totalDuration && this.data.data !== "isFromStart") { //this.data refers to the tween. Only clear at the END of the tween (remember, from() tweens make the ratio go from 1 to 0, so we can't just check that and if the tween is the zero-duration one that's created internally to render the starting values in a from() tween, ignore that because otherwise, for example, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in).
				var s = this.t.style,
					transformParse = _specialProps.transform.parse,
					a, p, i, clearTransform, transform;
				if (this.e === "all") {
					s.cssText = "";
					clearTransform = true;
				} else {
					a = this.e.split(" ").join("").split(",");
					i = a.length;
					while (--i > -1) {
						p = a[i];
						if (_specialProps[p]) {
							if (_specialProps[p].parse === transformParse) {
								clearTransform = true;
							} else {
								p = (p === "transformOrigin") ? _transformOriginProp : _specialProps[p].p; //ensures that special properties use the proper browser-specific property name, like "scaleX" might be "-webkit-transform" or "boxShadow" might be "-moz-box-shadow"
							}
						}
						_removeProp(s, p);
					}
				}
				if (clearTransform) {
					_removeProp(s, _transformProp);
					transform = this.t._gsTransform;
					if (transform) {
						if (transform.svg) {
							this.t.removeAttribute("data-svg-origin");
							this.t.removeAttribute("transform");
						}
						delete this.t._gsTransform;
					}
				}

			}
		};
		_registerComplexSpecialProp("clearProps", {parser:function(t, e, p, cssp, pt) {
			pt = new CSSPropTween(t, p, 0, 0, pt, 2);
			pt.setRatio = _setClearPropsRatio;
			pt.e = e;
			pt.pr = -10;
			pt.data = cssp._tween;
			_hasPriority = true;
			return pt;
		}});

		p = "bezier,throwProps,physicsProps,physics2D".split(",");
		i = p.length;
		while (i--) {
			_registerPluginProp(p[i]);
		}








		p = CSSPlugin.prototype;
		p._firstPT = p._lastParsedTransform = p._transform = null;

		//gets called when the tween renders for the first time. This kicks everything off, recording start/end values, etc.
		p._onInitTween = function(target, vars, tween, index) {
			if (!target.nodeType) { //css is only for dom elements
				return false;
			}
			this._target = _target = target;
			this._tween = tween;
			this._vars = vars;
			_index = index;
			_autoRound = vars.autoRound;
			_hasPriority = false;
			_suffixMap = vars.suffixMap || CSSPlugin.suffixMap;
			_cs = _getComputedStyle(target, "");
			_overwriteProps = this._overwriteProps;
			var style = target.style,
				v, pt, pt2, first, last, next, zIndex, tpt, threeD;
			if (_reqSafariFix) if (style.zIndex === "") {
				v = _getStyle(target, "zIndex", _cs);
				if (v === "auto" || v === "") {
					//corrects a bug in [non-Android] Safari that prevents it from repainting elements in their new positions if they don't have a zIndex set. We also can't just apply this inside _parseTransform() because anything that's moved in any way (like using "left" or "top" instead of transforms like "x" and "y") can be affected, so it is best to ensure that anything that's tweening has a z-index. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly. Plus zIndex is less memory-intensive.
					this._addLazySet(style, "zIndex", 0);
				}
			}

			if (typeof(vars) === "string") {
				first = style.cssText;
				v = _getAllStyles(target, _cs);
				style.cssText = first + ";" + vars;
				v = _cssDif(target, v, _getAllStyles(target)).difs;
				if (!_supportsOpacity && _opacityValExp.test(vars)) {
					v.opacity = parseFloat( RegExp.$1 );
				}
				vars = v;
				style.cssText = first;
			}

			if (vars.className) { //className tweens will combine any differences they find in the css with the vars that are passed in, so {className:"myClass", scale:0.5, left:20} would work.
				this._firstPT = pt = _specialProps.className.parse(target, vars.className, "className", this, null, null, vars);
			} else {
				this._firstPT = pt = this.parse(target, vars, null);
			}

			if (this._transformType) {
				threeD = (this._transformType === 3);
				if (!_transformProp) {
					style.zoom = 1; //helps correct an IE issue.
				} else if (_isSafari) {
					_reqSafariFix = true;
					//if zIndex isn't set, iOS Safari doesn't repaint things correctly sometimes (seemingly at random).
					if (style.zIndex === "") {
						zIndex = _getStyle(target, "zIndex", _cs);
						if (zIndex === "auto" || zIndex === "") {
							this._addLazySet(style, "zIndex", 0);
						}
					}
					//Setting WebkitBackfaceVisibility corrects 3 bugs:
					// 1) [non-Android] Safari skips rendering changes to "top" and "left" that are made on the same frame/render as a transform update.
					// 2) iOS Safari sometimes neglects to repaint elements in their new positions. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly.
					// 3) Safari sometimes displayed odd artifacts when tweening the transform (or WebkitTransform) property, like ghosts of the edges of the element remained. Definitely a browser bug.
					//Note: we allow the user to override the auto-setting by defining WebkitBackfaceVisibility in the vars of the tween.
					if (_isSafariLT6) {
						this._addLazySet(style, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (threeD ? "visible" : "hidden"));
					}
				}
				pt2 = pt;
				while (pt2 && pt2._next) {
					pt2 = pt2._next;
				}
				tpt = new CSSPropTween(target, "transform", 0, 0, null, 2);
				this._linkCSSP(tpt, null, pt2);
				tpt.setRatio = _transformProp ? _setTransformRatio : _setIETransformRatio;
				tpt.data = this._transform || _getTransform(target, _cs, true);
				tpt.tween = tween;
				tpt.pr = -1; //ensures that the transforms get applied after the components are updated.
				_overwriteProps.pop(); //we don't want to force the overwrite of all "transform" tweens of the target - we only care about individual transform properties like scaleX, rotation, etc. The CSSPropTween constructor automatically adds the property to _overwriteProps which is why we need to pop() here.
			}

			if (_hasPriority) {
				//reorders the linked list in order of pr (priority)
				while (pt) {
					next = pt._next;
					pt2 = first;
					while (pt2 && pt2.pr > pt.pr) {
						pt2 = pt2._next;
					}
					if ((pt._prev = pt2 ? pt2._prev : last)) {
						pt._prev._next = pt;
					} else {
						first = pt;
					}
					if ((pt._next = pt2)) {
						pt2._prev = pt;
					} else {
						last = pt;
					}
					pt = next;
				}
				this._firstPT = first;
			}
			return true;
		};


		p.parse = function(target, vars, pt, plugin) {
			var style = target.style,
				p, sp, bn, en, bs, es, bsfx, esfx, isStr, rel;
			for (p in vars) {
				es = vars[p]; //ending value string
				if (typeof(es) === "function") {
					es = es(_index, _target);
				}
				sp = _specialProps[p]; //SpecialProp lookup.
				if (sp) {
					pt = sp.parse(target, es, p, this, pt, plugin, vars);
				} else if (p.substr(0,2) === "--") { //for tweening CSS variables (which always start with "--"). To maximize performance and simplicity, we bypass CSSPlugin altogether and just add a normal property tween to the tween instance itself.
					this._tween._propLookup[p] = this._addTween.call(this._tween, target.style, "setProperty", _getComputedStyle(target).getPropertyValue(p) + "", es + "", p, false, p);
					continue;
				} else {
					bs = _getStyle(target, p, _cs) + "";
					isStr = (typeof(es) === "string");
					if (p === "color" || p === "fill" || p === "stroke" || p.indexOf("Color") !== -1 || (isStr && _rgbhslExp.test(es))) { //Opera uses background: to define color sometimes in addition to backgroundColor:
						if (!isStr) {
							es = _parseColor(es);
							es = ((es.length > 3) ? "rgba(" : "rgb(") + es.join(",") + ")";
						}
						pt = _parseComplex(style, p, bs, es, true, "transparent", pt, 0, plugin);

					} else if (isStr && _complexExp.test(es)) {
						pt = _parseComplex(style, p, bs, es, true, null, pt, 0, plugin);

					} else {
						bn = parseFloat(bs);
						bsfx = (bn || bn === 0) ? bs.substr((bn + "").length) : ""; //remember, bs could be non-numeric like "normal" for fontWeight, so we should default to a blank suffix in that case.

						if (bs === "" || bs === "auto") {
							if (p === "width" || p === "height") {
								bn = _getDimension(target, p, _cs);
								bsfx = "px";
							} else if (p === "left" || p === "top") {
								bn = _calculateOffset(target, p, _cs);
								bsfx = "px";
							} else {
								bn = (p !== "opacity") ? 0 : 1;
								bsfx = "";
							}
						}

						rel = (isStr && es.charAt(1) === "=");
						if (rel) {
							en = parseInt(es.charAt(0) + "1", 10);
							es = es.substr(2);
							en *= parseFloat(es);
							esfx = es.replace(_suffixExp, "");
						} else {
							en = parseFloat(es);
							esfx = isStr ? es.replace(_suffixExp, "") : "";
						}

						if (esfx === "") {
							esfx = (p in _suffixMap) ? _suffixMap[p] : bsfx; //populate the end suffix, prioritizing the map, then if none is found, use the beginning suffix.
						}

						es = (en || en === 0) ? (rel ? en + bn : en) + esfx : vars[p]; //ensures that any += or -= prefixes are taken care of. Record the end value before normalizing the suffix because we always want to end the tween on exactly what they intended even if it doesn't match the beginning value's suffix.
						//if the beginning/ending suffixes don't match, normalize them...
						if (bsfx !== esfx) if (esfx !== "" || p === "lineHeight") if (en || en === 0) if (bn) { //note: if the beginning value (bn) is 0, we don't need to convert units!
							bn = _convertToPixels(target, p, bn, bsfx);
							if (esfx === "%") {
								bn /= _convertToPixels(target, p, 100, "%") / 100;
								if (vars.strictUnits !== true) { //some browsers report only "px" values instead of allowing "%" with getComputedStyle(), so we assume that if we're tweening to a %, we should start there too unless strictUnits:true is defined. This approach is particularly useful for responsive designs that use from() tweens.
									bs = bn + "%";
								}

							} else if (esfx === "em" || esfx === "rem" || esfx === "vw" || esfx === "vh") {
								bn /= _convertToPixels(target, p, 1, esfx);

							//otherwise convert to pixels.
							} else if (esfx !== "px") {
								en = _convertToPixels(target, p, en, esfx);
								esfx = "px"; //we don't use bsfx after this, so we don't need to set it to px too.
							}
							if (rel) if (en || en === 0) {
								es = (en + bn) + esfx; //the changes we made affect relative calculations, so adjust the end value here.
							}
						}

						if (rel) {
							en += bn;
						}

						if ((bn || bn === 0) && (en || en === 0)) { //faster than isNaN(). Also, previously we required en !== bn but that doesn't really gain much performance and it prevents _parseToProxy() from working properly if beginning and ending values match but need to get tweened by an external plugin anyway. For example, a bezier tween where the target starts at left:0 and has these points: [{left:50},{left:0}] wouldn't work properly because when parsing the last point, it'd match the first (current) one and a non-tweening CSSPropTween would be recorded when we actually need a normal tween (type:0) so that things get updated during the tween properly.
							pt = new CSSPropTween(style, p, bn, en - bn, pt, 0, p, (_autoRound !== false && (esfx === "px" || p === "zIndex")), 0, bs, es);
							pt.xs0 = esfx;
							//DEBUG: _log("tween "+p+" from "+pt.b+" ("+bn+esfx+") to "+pt.e+" with suffix: "+pt.xs0);
						} else if (style[p] === undefined || !es && (es + "" === "NaN" || es == null)) {
							_log("invalid " + p + " tween value: " + vars[p]);
						} else {
							pt = new CSSPropTween(style, p, en || bn || 0, 0, pt, -1, p, false, 0, bs, es);
							pt.xs0 = (es === "none" && (p === "display" || p.indexOf("Style") !== -1)) ? bs : es; //intermediate value should typically be set immediately (end value) except for "display" or things like borderTopStyle, borderBottomStyle, etc. which should use the beginning value during the tween.
							//DEBUG: _log("non-tweening value "+p+": "+pt.xs0);
						}
					}
				}
				if (plugin) if (pt && !pt.plugin) {
					pt.plugin = plugin;
				}
			}
			return pt;
		};


		//gets called every time the tween updates, passing the new ratio (typically a value between 0 and 1, but not always (for example, if an Elastic.easeOut is used, the value can jump above 1 mid-tween). It will always start and 0 and end at 1.
		p.setRatio = function(v) {
			var pt = this._firstPT,
				min = 0.000001,
				val, str, i;
			//at the end of the tween, we set the values to exactly what we received in order to make sure non-tweening values (like "position" or "float" or whatever) are set and so that if the beginning/ending suffixes (units) didn't match and we normalized to px, the value that the user passed in is used here. We check to see if the tween is at its beginning in case it's a from() tween in which case the ratio will actually go from 1 to 0 over the course of the tween (backwards).
			if (v === 1 && (this._tween._time === this._tween._duration || this._tween._time === 0)) {
				while (pt) {
					if (pt.type !== 2) {
						if (pt.r && pt.type !== -1) {
							val = Math.round(pt.s + pt.c);
							if (!pt.type) {
								pt.t[pt.p] = val + pt.xs0;
							} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
								i = pt.l;
								str = pt.xs0 + val + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt.t[pt.p] = str;
							}
						} else {
							pt.t[pt.p] = pt.e;
						}
					} else {
						pt.setRatio(v);
					}
					pt = pt._next;
				}

			} else if (v || !(this._tween._time === this._tween._duration || this._tween._time === 0) || this._tween._rawPrevTime === -0.000001) {
				while (pt) {
					val = pt.c * v + pt.s;
					if (pt.r) {
						val = Math.round(val);
					} else if (val < min) if (val > -min) {
						val = 0;
					}
					if (!pt.type) {
						pt.t[pt.p] = val + pt.xs0;
					} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
						i = pt.l;
						if (i === 2) {
							pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2;
						} else if (i === 3) {
							pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3;
						} else if (i === 4) {
							pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4;
						} else if (i === 5) {
							pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4 + pt.xn4 + pt.xs5;
						} else {
							str = pt.xs0 + val + pt.xs1;
							for (i = 1; i < pt.l; i++) {
								str += pt["xn"+i] + pt["xs"+(i+1)];
							}
							pt.t[pt.p] = str;
						}

					} else if (pt.type === -1) { //non-tweening value
						pt.t[pt.p] = pt.xs0;

					} else if (pt.setRatio) { //custom setRatio() for things like SpecialProps, external plugins, etc.
						pt.setRatio(v);
					}
					pt = pt._next;
				}

			//if the tween is reversed all the way back to the beginning, we need to restore the original values which may have different units (like % instead of px or em or whatever).
			} else {
				while (pt) {
					if (pt.type !== 2) {
						pt.t[pt.p] = pt.b;
					} else {
						pt.setRatio(v);
					}
					pt = pt._next;
				}
			}
		};

		/**
		 * @private
		 * Forces rendering of the target's transforms (rotation, scale, etc.) whenever the CSSPlugin's setRatio() is called.
		 * Basically, this tells the CSSPlugin to create a CSSPropTween (type 2) after instantiation that runs last in the linked
		 * list and calls the appropriate (3D or 2D) rendering function. We separate this into its own method so that we can call
		 * it from other plugins like BezierPlugin if, for example, it needs to apply an autoRotation and this CSSPlugin
		 * doesn't have any transform-related properties of its own. You can call this method as many times as you
		 * want and it won't create duplicate CSSPropTweens.
		 *
		 * @param {boolean} threeD if true, it should apply 3D tweens (otherwise, just 2D ones are fine and typically faster)
		 */
		p._enableTransforms = function(threeD) {
			this._transform = this._transform || _getTransform(this._target, _cs, true); //ensures that the element has a _gsTransform property with the appropriate values.
			this._transformType = (!(this._transform.svg && _useSVGTransformAttr) && (threeD || this._transformType === 3)) ? 3 : 2;
		};

		var lazySet = function(v) {
			this.t[this.p] = this.e;
			this.data._linkCSSP(this, this._next, null, true); //we purposefully keep this._next even though it'd make sense to null it, but this is a performance optimization, as this happens during the while (pt) {} loop in setRatio() at the bottom of which it sets pt = pt._next, so if we null it, the linked list will be broken in that loop.
		};
		/** @private Gives us a way to set a value on the first render (and only the first render). **/
		p._addLazySet = function(t, p, v) {
			var pt = this._firstPT = new CSSPropTween(t, p, 0, 0, this._firstPT, 2);
			pt.e = v;
			pt.setRatio = lazySet;
			pt.data = this;
		};

		/** @private **/
		p._linkCSSP = function(pt, next, prev, remove) {
			if (pt) {
				if (next) {
					next._prev = pt;
				}
				if (pt._next) {
					pt._next._prev = pt._prev;
				}
				if (pt._prev) {
					pt._prev._next = pt._next;
				} else if (this._firstPT === pt) {
					this._firstPT = pt._next;
					remove = true; //just to prevent resetting this._firstPT 5 lines down in case pt._next is null. (optimized for speed)
				}
				if (prev) {
					prev._next = pt;
				} else if (!remove && this._firstPT === null) {
					this._firstPT = pt;
				}
				pt._next = next;
				pt._prev = prev;
			}
			return pt;
		};

		p._mod = function(lookup) {
			var pt = this._firstPT;
			while (pt) {
				if (typeof(lookup[pt.p]) === "function" && lookup[pt.p] === Math.round) { //only gets called by RoundPropsPlugin (ModifyPlugin manages all the rendering internally for CSSPlugin properties that need modification). Remember, we handle rounding a bit differently in this plugin for performance reasons, leveraging "r" as an indicator that the value should be rounded internally..
					pt.r = 1;
				}
				pt = pt._next;
			}
		};

		//we need to make sure that if alpha or autoAlpha is killed, opacity is too. And autoAlpha affects the "visibility" property.
		p._kill = function(lookup) {
			var copy = lookup,
				pt, p, xfirst;
			if (lookup.autoAlpha || lookup.alpha) {
				copy = {};
				for (p in lookup) { //copy the lookup so that we're not changing the original which may be passed elsewhere.
					copy[p] = lookup[p];
				}
				copy.opacity = 1;
				if (copy.autoAlpha) {
					copy.visibility = 1;
				}
			}
			if (lookup.className && (pt = this._classNamePT)) { //for className tweens, we need to kill any associated CSSPropTweens too; a linked list starts at the className's "xfirst".
				xfirst = pt.xfirst;
				if (xfirst && xfirst._prev) {
					this._linkCSSP(xfirst._prev, pt._next, xfirst._prev._prev); //break off the prev
				} else if (xfirst === this._firstPT) {
					this._firstPT = pt._next;
				}
				if (pt._next) {
					this._linkCSSP(pt._next, pt._next._next, xfirst._prev);
				}
				this._classNamePT = null;
			}
			pt = this._firstPT;
			while (pt) {
				if (pt.plugin && pt.plugin !== p && pt.plugin._kill) { //for plugins that are registered with CSSPlugin, we should notify them of the kill.
					pt.plugin._kill(lookup);
					p = pt.plugin;
				}
				pt = pt._next;
			}
			return TweenPlugin.prototype._kill.call(this, copy);
		};



		//used by cascadeTo() for gathering all the style properties of each child element into an array for comparison.
		var _getChildStyles = function(e, props, targets) {
				var children, i, child, type;
				if (e.slice) {
					i = e.length;
					while (--i > -1) {
						_getChildStyles(e[i], props, targets);
					}
					return;
				}
				children = e.childNodes;
				i = children.length;
				while (--i > -1) {
					child = children[i];
					type = child.type;
					if (child.style) {
						props.push(_getAllStyles(child));
						if (targets) {
							targets.push(child);
						}
					}
					if ((type === 1 || type === 9 || type === 11) && child.childNodes.length) {
						_getChildStyles(child, props, targets);
					}
				}
			};

		/**
		 * Typically only useful for className tweens that may affect child elements, this method creates a TweenLite
		 * and then compares the style properties of all the target's child elements at the tween's start and end, and
		 * if any are different, it also creates tweens for those and returns an array containing ALL of the resulting
		 * tweens (so that you can easily add() them to a TimelineLite, for example). The reason this functionality is
		 * wrapped into a separate static method of CSSPlugin instead of being integrated into all regular className tweens
		 * is because it creates entirely new tweens that may have completely different targets than the original tween,
		 * so if they were all lumped into the original tween instance, it would be inconsistent with the rest of the API
		 * and it would create other problems. For example:
		 *  - If I create a tween of elementA, that tween instance may suddenly change its target to include 50 other elements (unintuitive if I specifically defined the target I wanted)
		 *  - We can't just create new independent tweens because otherwise, what happens if the original/parent tween is reversed or pause or dropped into a TimelineLite for tight control? You'd expect that tween's behavior to affect all the others.
		 *  - Analyzing every style property of every child before and after the tween is an expensive operation when there are many children, so this behavior shouldn't be imposed on all className tweens by default, especially since it's probably rare that this extra functionality is needed.
		 *
		 * @param {Object} target object to be tweened
		 * @param {number} Duration in seconds (or frames for frames-based tweens)
		 * @param {Object} Object containing the end values, like {className:"newClass", ease:Linear.easeNone}
		 * @return {Array} An array of TweenLite instances
		 */
		CSSPlugin.cascadeTo = function(target, duration, vars) {
			var tween = TweenLite.to(target, duration, vars),
				results = [tween],
				b = [],
				e = [],
				targets = [],
				_reservedProps = TweenLite._internals.reservedProps,
				i, difs, p, from;
			target = tween._targets || tween.target;
			_getChildStyles(target, b, targets);
			tween.render(duration, true, true);
			_getChildStyles(target, e);
			tween.render(0, true, true);
			tween._enabled(true);
			i = targets.length;
			while (--i > -1) {
				difs = _cssDif(targets[i], b[i], e[i]);
				if (difs.firstMPT) {
					difs = difs.difs;
					for (p in vars) {
						if (_reservedProps[p]) {
							difs[p] = vars[p];
						}
					}
					from = {};
					for (p in difs) {
						from[p] = b[i][p];
					}
					results.push(TweenLite.fromTo(targets[i], duration, from, difs));
				}
			}
			return results;
		};

		TweenPlugin.activate([CSSPlugin]);
		return CSSPlugin;

	}, true);

	
	
	
	
	
	
	
	
	
	
/*
 * ----------------------------------------------------------------
 * RoundPropsPlugin
 * ----------------------------------------------------------------
 */
	(function() {

		var RoundPropsPlugin = _gsScope._gsDefine.plugin({
				propName: "roundProps",
				version: "1.6.0",
				priority: -1,
				API: 2,

				//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
				init: function(target, value, tween) {
					this._tween = tween;
					return true;
				}

			}),
			_roundLinkedList = function(node) {
				while (node) {
					if (!node.f && !node.blob) {
						node.m = Math.round;
					}
					node = node._next;
				}
			},
			p = RoundPropsPlugin.prototype;

		p._onInitAllProps = function() {
			var tween = this._tween,
				rp = (tween.vars.roundProps.join) ? tween.vars.roundProps : tween.vars.roundProps.split(","),
				i = rp.length,
				lookup = {},
				rpt = tween._propLookup.roundProps,
				prop, pt, next;
			while (--i > -1) {
				lookup[rp[i]] = Math.round;
			}
			i = rp.length;
			while (--i > -1) {
				prop = rp[i];
				pt = tween._firstPT;
				while (pt) {
					next = pt._next; //record here, because it may get removed
					if (pt.pg) {
						pt.t._mod(lookup);
					} else if (pt.n === prop) {
						if (pt.f === 2 && pt.t) { //a blob (text containing multiple numeric values)
							_roundLinkedList(pt.t._firstPT);
						} else {
							this._add(pt.t, prop, pt.s, pt.c);
							//remove from linked list
							if (next) {
								next._prev = pt._prev;
							}
							if (pt._prev) {
								pt._prev._next = next;
							} else if (tween._firstPT === pt) {
								tween._firstPT = next;
							}
							pt._next = pt._prev = null;
							tween._propLookup[prop] = rpt;
						}
					}
					pt = next;
				}
			}
			return false;
		};

		p._add = function(target, p, s, c) {
			this._addTween(target, p, s, s + c, p, Math.round);
			this._overwriteProps.push(p);
		};

	}());










/*
 * ----------------------------------------------------------------
 * AttrPlugin
 * ----------------------------------------------------------------
 */

	(function() {

		_gsScope._gsDefine.plugin({
			propName: "attr",
			API: 2,
			version: "0.6.1",

			//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
			init: function(target, value, tween, index) {
				var p, end;
				if (typeof(target.setAttribute) !== "function") {
					return false;
				}
				for (p in value) {
					end = value[p];
					if (typeof(end) === "function") {
						end = end(index, target);
					}
					this._addTween(target, "setAttribute", target.getAttribute(p) + "", end + "", p, false, p);
					this._overwriteProps.push(p);
				}
				return true;
			}

		});

	}());










/*
 * ----------------------------------------------------------------
 * DirectionalRotationPlugin
 * ----------------------------------------------------------------
 */
	_gsScope._gsDefine.plugin({
		propName: "directionalRotation",
		version: "0.3.1",
		API: 2,

		//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
		init: function(target, value, tween, index) {
			if (typeof(value) !== "object") {
				value = {rotation:value};
			}
			this.finals = {};
			var cap = (value.useRadians === true) ? Math.PI * 2 : 360,
				min = 0.000001,
				p, v, start, end, dif, split;
			for (p in value) {
				if (p !== "useRadians") {
					end = value[p];
					if (typeof(end) === "function") {
						end = end(index, target);
					}
					split = (end + "").split("_");
					v = split[0];
					start = parseFloat( (typeof(target[p]) !== "function") ? target[p] : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]() );
					end = this.finals[p] = (typeof(v) === "string" && v.charAt(1) === "=") ? start + parseInt(v.charAt(0) + "1", 10) * Number(v.substr(2)) : Number(v) || 0;
					dif = end - start;
					if (split.length) {
						v = split.join("_");
						if (v.indexOf("short") !== -1) {
							dif = dif % cap;
							if (dif !== dif % (cap / 2)) {
								dif = (dif < 0) ? dif + cap : dif - cap;
							}
						}
						if (v.indexOf("_cw") !== -1 && dif < 0) {
							dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
						} else if (v.indexOf("ccw") !== -1 && dif > 0) {
							dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
						}
					}
					if (dif > min || dif < -min) {
						this._addTween(target, p, start, start + dif, p);
						this._overwriteProps.push(p);
					}
				}
			}
			return true;
		},

		//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
		set: function(ratio) {
			var pt;
			if (ratio !== 1) {
				this._super.setRatio.call(this, ratio);
			} else {
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](this.finals[pt.p]);
					} else {
						pt.t[pt.p] = this.finals[pt.p];
					}
					pt = pt._next;
				}
			}
		}

	})._autoCSS = true;







	
	
	
	
/*
 * ----------------------------------------------------------------
 * EasePack
 * ----------------------------------------------------------------
 */
	_gsScope._gsDefine("easing.Back", ["easing.Ease"], function(Ease) {
		
		var w = (_gsScope.GreenSockGlobals || _gsScope),
			gs = w.com.greensock,
			_2PI = Math.PI * 2,
			_HALF_PI = Math.PI / 2,
			_class = gs._class,
			_create = function(n, f) {
				var C = _class("easing." + n, function(){}, true),
					p = C.prototype = new Ease();
				p.constructor = C;
				p.getRatio = f;
				return C;
			},
			_easeReg = Ease.register || function(){}, //put an empty function in place just as a safety measure in case someone loads an OLD version of TweenLite.js where Ease.register doesn't exist.
			_wrap = function(name, EaseOut, EaseIn, EaseInOut, aliases) {
				var C = _class("easing."+name, {
					easeOut:new EaseOut(),
					easeIn:new EaseIn(),
					easeInOut:new EaseInOut()
				}, true);
				_easeReg(C, name);
				return C;
			},
			EasePoint = function(time, value, next) {
				this.t = time;
				this.v = value;
				if (next) {
					this.next = next;
					next.prev = this;
					this.c = next.v - value;
					this.gap = next.t - time;
				}
			},

			//Back
			_createBack = function(n, f) {
				var C = _class("easing." + n, function(overshoot) {
						this._p1 = (overshoot || overshoot === 0) ? overshoot : 1.70158;
						this._p2 = this._p1 * 1.525;
					}, true),
					p = C.prototype = new Ease();
				p.constructor = C;
				p.getRatio = f;
				p.config = function(overshoot) {
					return new C(overshoot);
				};
				return C;
			},

			Back = _wrap("Back",
				_createBack("BackOut", function(p) {
					return ((p = p - 1) * p * ((this._p1 + 1) * p + this._p1) + 1);
				}),
				_createBack("BackIn", function(p) {
					return p * p * ((this._p1 + 1) * p - this._p1);
				}),
				_createBack("BackInOut", function(p) {
					return ((p *= 2) < 1) ? 0.5 * p * p * ((this._p2 + 1) * p - this._p2) : 0.5 * ((p -= 2) * p * ((this._p2 + 1) * p + this._p2) + 2);
				})
			),


			//SlowMo
			SlowMo = _class("easing.SlowMo", function(linearRatio, power, yoyoMode) {
				power = (power || power === 0) ? power : 0.7;
				if (linearRatio == null) {
					linearRatio = 0.7;
				} else if (linearRatio > 1) {
					linearRatio = 1;
				}
				this._p = (linearRatio !== 1) ? power : 0;
				this._p1 = (1 - linearRatio) / 2;
				this._p2 = linearRatio;
				this._p3 = this._p1 + this._p2;
				this._calcEnd = (yoyoMode === true);
			}, true),
			p = SlowMo.prototype = new Ease(),
			SteppedEase, ExpoScaleEase, RoughEase, _createElastic;

		p.constructor = SlowMo;
		p.getRatio = function(p) {
			var r = p + (0.5 - p) * this._p;
			if (p < this._p1) {
				return this._calcEnd ? 1 - ((p = 1 - (p / this._p1)) * p) : r - ((p = 1 - (p / this._p1)) * p * p * p * r);
			} else if (p > this._p3) {
				return this._calcEnd ? (p === 1 ? 0 : 1 - (p = (p - this._p3) / this._p1) * p) : r + ((p - r) * (p = (p - this._p3) / this._p1) * p * p * p); //added p === 1 ? 0 to avoid floating point rounding errors from affecting the final value, like 1 - 0.7 = 0.30000000000000004 instead of 0.3
			}
			return this._calcEnd ? 1 : r;
		};
		SlowMo.ease = new SlowMo(0.7, 0.7);

		p.config = SlowMo.config = function(linearRatio, power, yoyoMode) {
			return new SlowMo(linearRatio, power, yoyoMode);
		};


		//SteppedEase
		SteppedEase = _class("easing.SteppedEase", function(steps, immediateStart) {
				steps = steps || 1;
				this._p1 = 1 / steps;
				this._p2 = steps + (immediateStart ? 0 : 1);
				this._p3 = immediateStart ? 1 : 0;
			}, true);
		p = SteppedEase.prototype = new Ease();
		p.constructor = SteppedEase;
		p.getRatio = function(p) {
			if (p < 0) {
				p = 0;
			} else if (p >= 1) {
				p = 0.999999999;
			}
			return (((this._p2 * p) | 0) + this._p3) * this._p1;
		};
		p.config = SteppedEase.config = function(steps, immediateStart) {
			return new SteppedEase(steps, immediateStart);
		};

		//ExpoScaleEase
		ExpoScaleEase = _class("easing.ExpoScaleEase", function(start, end, ease) {
			this._p1 = Math.log(end / start);
			this._p2 = end - start;
			this._p3 = start;
			this._ease = ease;
		}, true);
		p = ExpoScaleEase.prototype = new Ease();
		p.constructor = ExpoScaleEase;
		p.getRatio = function(p) {
			if (this._ease) {
				p = this._ease.getRatio(p);
			}
			return (this._p3 * Math.exp(this._p1 * p) - this._p3) / this._p2;
		};
		p.config = ExpoScaleEase.config = function(start, end, ease) {
			return new ExpoScaleEase(start, end, ease);
		};


		//RoughEase
		RoughEase = _class("easing.RoughEase", function(vars) {
			vars = vars || {};
			var taper = vars.taper || "none",
				a = [],
				cnt = 0,
				points = (vars.points || 20) | 0,
				i = points,
				randomize = (vars.randomize !== false),
				clamp = (vars.clamp === true),
				template = (vars.template instanceof Ease) ? vars.template : null,
				strength = (typeof(vars.strength) === "number") ? vars.strength * 0.4 : 0.4,
				x, y, bump, invX, obj, pnt;
			while (--i > -1) {
				x = randomize ? Math.random() : (1 / points) * i;
				y = template ? template.getRatio(x) : x;
				if (taper === "none") {
					bump = strength;
				} else if (taper === "out") {
					invX = 1 - x;
					bump = invX * invX * strength;
				} else if (taper === "in") {
					bump = x * x * strength;
				} else if (x < 0.5) {  //"both" (start)
					invX = x * 2;
					bump = invX * invX * 0.5 * strength;
				} else {				//"both" (end)
					invX = (1 - x) * 2;
					bump = invX * invX * 0.5 * strength;
				}
				if (randomize) {
					y += (Math.random() * bump) - (bump * 0.5);
				} else if (i % 2) {
					y += bump * 0.5;
				} else {
					y -= bump * 0.5;
				}
				if (clamp) {
					if (y > 1) {
						y = 1;
					} else if (y < 0) {
						y = 0;
					}
				}
				a[cnt++] = {x:x, y:y};
			}
			a.sort(function(a, b) {
				return a.x - b.x;
			});

			pnt = new EasePoint(1, 1, null);
			i = points;
			while (--i > -1) {
				obj = a[i];
				pnt = new EasePoint(obj.x, obj.y, pnt);
			}

			this._prev = new EasePoint(0, 0, (pnt.t !== 0) ? pnt : pnt.next);
		}, true);
		p = RoughEase.prototype = new Ease();
		p.constructor = RoughEase;
		p.getRatio = function(p) {
			var pnt = this._prev;
			if (p > pnt.t) {
				while (pnt.next && p >= pnt.t) {
					pnt = pnt.next;
				}
				pnt = pnt.prev;
			} else {
				while (pnt.prev && p <= pnt.t) {
					pnt = pnt.prev;
				}
			}
			this._prev = pnt;
			return (pnt.v + ((p - pnt.t) / pnt.gap) * pnt.c);
		};
		p.config = function(vars) {
			return new RoughEase(vars);
		};
		RoughEase.ease = new RoughEase();


		//Bounce
		_wrap("Bounce",
			_create("BounceOut", function(p) {
				if (p < 1 / 2.75) {
					return 7.5625 * p * p;
				} else if (p < 2 / 2.75) {
					return 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
				} else if (p < 2.5 / 2.75) {
					return 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
				}
				return 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
			}),
			_create("BounceIn", function(p) {
				if ((p = 1 - p) < 1 / 2.75) {
					return 1 - (7.5625 * p * p);
				} else if (p < 2 / 2.75) {
					return 1 - (7.5625 * (p -= 1.5 / 2.75) * p + 0.75);
				} else if (p < 2.5 / 2.75) {
					return 1 - (7.5625 * (p -= 2.25 / 2.75) * p + 0.9375);
				}
				return 1 - (7.5625 * (p -= 2.625 / 2.75) * p + 0.984375);
			}),
			_create("BounceInOut", function(p) {
				var invert = (p < 0.5);
				if (invert) {
					p = 1 - (p * 2);
				} else {
					p = (p * 2) - 1;
				}
				if (p < 1 / 2.75) {
					p = 7.5625 * p * p;
				} else if (p < 2 / 2.75) {
					p = 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
				} else if (p < 2.5 / 2.75) {
					p = 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
				} else {
					p = 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
				}
				return invert ? (1 - p) * 0.5 : p * 0.5 + 0.5;
			})
		);


		//CIRC
		_wrap("Circ",
			_create("CircOut", function(p) {
				return Math.sqrt(1 - (p = p - 1) * p);
			}),
			_create("CircIn", function(p) {
				return -(Math.sqrt(1 - (p * p)) - 1);
			}),
			_create("CircInOut", function(p) {
				return ((p*=2) < 1) ? -0.5 * (Math.sqrt(1 - p * p) - 1) : 0.5 * (Math.sqrt(1 - (p -= 2) * p) + 1);
			})
		);


		//Elastic
		_createElastic = function(n, f, def) {
			var C = _class("easing." + n, function(amplitude, period) {
					this._p1 = (amplitude >= 1) ? amplitude : 1; //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
					this._p2 = (period || def) / (amplitude < 1 ? amplitude : 1);
					this._p3 = this._p2 / _2PI * (Math.asin(1 / this._p1) || 0);
					this._p2 = _2PI / this._p2; //precalculate to optimize
				}, true),
				p = C.prototype = new Ease();
			p.constructor = C;
			p.getRatio = f;
			p.config = function(amplitude, period) {
				return new C(amplitude, period);
			};
			return C;
		};
		_wrap("Elastic",
			_createElastic("ElasticOut", function(p) {
				return this._p1 * Math.pow(2, -10 * p) * Math.sin( (p - this._p3) * this._p2 ) + 1;
			}, 0.3),
			_createElastic("ElasticIn", function(p) {
				return -(this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2 ));
			}, 0.3),
			_createElastic("ElasticInOut", function(p) {
				return ((p *= 2) < 1) ? -0.5 * (this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 *(p -= 1)) * Math.sin( (p - this._p3) * this._p2 ) * 0.5 + 1;
			}, 0.45)
		);


		//Expo
		_wrap("Expo",
			_create("ExpoOut", function(p) {
				return 1 - Math.pow(2, -10 * p);
			}),
			_create("ExpoIn", function(p) {
				return Math.pow(2, 10 * (p - 1)) - 0.001;
			}),
			_create("ExpoInOut", function(p) {
				return ((p *= 2) < 1) ? 0.5 * Math.pow(2, 10 * (p - 1)) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
			})
		);


		//Sine
		_wrap("Sine",
			_create("SineOut", function(p) {
				return Math.sin(p * _HALF_PI);
			}),
			_create("SineIn", function(p) {
				return -Math.cos(p * _HALF_PI) + 1;
			}),
			_create("SineInOut", function(p) {
				return -0.5 * (Math.cos(Math.PI * p) - 1);
			})
		);

		_class("easing.EaseLookup", {
				find:function(s) {
					return Ease.map[s];
				}
			}, true);

		//register the non-standard eases
		_easeReg(w.SlowMo, "SlowMo", "ease,");
		_easeReg(RoughEase, "RoughEase", "ease,");
		_easeReg(SteppedEase, "SteppedEase", "ease,");

		return Back;
		
	}, true);


});

if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); } //necessary in case TweenLite was already loaded separately.











/*
 * ----------------------------------------------------------------
 * Base classes like TweenLite, SimpleTimeline, Ease, Ticker, etc.
 * ----------------------------------------------------------------
 */
(function(window, moduleName) {

		"use strict";
		var _exports = {},
			_doc = window.document,
			_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
		if (_globals.TweenLite) {
			return; //in case the core set of classes is already loaded, don't instantiate twice.
		}
		var _namespace = function(ns) {
				var a = ns.split("."),
					p = _globals, i;
				for (i = 0; i < a.length; i++) {
					p[a[i]] = p = p[a[i]] || {};
				}
				return p;
			},
			gs = _namespace("com.greensock"),
			_tinyNum = 0.0000000001,
			_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++])) {}
				return b;
			},
			_emptyFunc = function() {},
			_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
				var toString = Object.prototype.toString,
					array = toString.call([]);
				return function(obj) {
					return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
				};
			}()),
			a, i, p, _ticker, _tickerActive,
			_defLookup = {},

			/**
			 * @constructor
			 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
			 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
			 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
			 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
			 *
			 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
			 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
			 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
			 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
			 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
			 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
			 * sandbox the banner one like:
			 *
			 * <script>
			 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
			 * </script>
			 * <script src="js/greensock/v1.7/TweenMax.js"></script>
			 * <script>
			 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
			 * </script>
			 * <script src="js/greensock/v1.6/TweenMax.js"></script>
			 * <script>
			 *     gs.TweenLite.to(...); //would use v1.7
			 *     TweenLite.to(...); //would use v1.6
			 * </script>
			 *
			 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
			 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
			 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
			 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
			 */
			Definition = function(ns, dependencies, func, global) {
				this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
				_defLookup[ns] = this;
				this.gsClass = null;
				this.func = func;
				var _classes = [];
				this.check = function(init) {
					var i = dependencies.length,
						missing = i,
						cur, a, n, cl;
					while (--i > -1) {
						if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
							_classes[i] = cur.gsClass;
							missing--;
						} else if (init) {
							cur.sc.push(this);
						}
					}
					if (missing === 0 && func) {
						a = ("com.greensock." + ns).split(".");
						n = a.pop();
						cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);

						//exports to multiple environments
						if (global) {
							_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
							if (typeof(module) !== "undefined" && module.exports) { //node
								if (ns === moduleName) {
									module.exports = _exports[moduleName] = cl;
									for (i in _exports) {
										cl[i] = _exports[i];
									}
								} else if (_exports[moduleName]) {
									_exports[moduleName][n] = cl;
								}
							} else if (true){ //AMD
								!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return cl; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
							}
						}
						for (i = 0; i < this.sc.length; i++) {
							this.sc[i].check();
						}
					}
				};
				this.check(true);
			},

			//used to create Definition instances (which basically registers a class that has dependencies).
			_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
				return new Definition(ns, dependencies, func, global);
			},

			//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
			_class = gs._class = function(ns, func, global) {
				func = func || function() {};
				_gsDefine(ns, [], function(){ return func; }, global);
				return func;
			};

		_gsDefine.globals = _globals;



/*
 * ----------------------------------------------------------------
 * Ease
 * ----------------------------------------------------------------
 */
		var _baseParams = [0, 0, 1, 1],
			Ease = _class("easing.Ease", function(func, extraParams, type, power) {
				this._func = func;
				this._type = type || 0;
				this._power = power || 0;
				this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
			}, true),
			_easeMap = Ease.map = {},
			_easeReg = Ease.register = function(ease, names, types, create) {
				var na = names.split(","),
					i = na.length,
					ta = (types || "easeIn,easeOut,easeInOut").split(","),
					e, name, j, type;
				while (--i > -1) {
					name = na[i];
					e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
					j = ta.length;
					while (--j > -1) {
						type = ta[j];
						_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
					}
				}
			};

		p = Ease.prototype;
		p._calcEnd = false;
		p.getRatio = function(p) {
			if (this._func) {
				this._params[0] = p;
				return this._func.apply(null, this._params);
			}
			var t = this._type,
				pw = this._power,
				r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
			if (pw === 1) {
				r *= r;
			} else if (pw === 2) {
				r *= r * r;
			} else if (pw === 3) {
				r *= r * r * r;
			} else if (pw === 4) {
				r *= r * r * r * r;
			}
			return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
		};

		//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
		a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
		i = a.length;
		while (--i > -1) {
			p = a[i]+",Power"+i;
			_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
			_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
			_easeReg(new Ease(null,null,3,i), p, "easeInOut");
		}
		_easeMap.linear = gs.easing.Linear.easeIn;
		_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks


/*
 * ----------------------------------------------------------------
 * EventDispatcher
 * ----------------------------------------------------------------
 */
		var EventDispatcher = _class("events.EventDispatcher", function(target) {
			this._listeners = {};
			this._eventTarget = target || this;
		});
		p = EventDispatcher.prototype;

		p.addEventListener = function(type, callback, scope, useParam, priority) {
			priority = priority || 0;
			var list = this._listeners[type],
				index = 0,
				listener, i;
			if (this === _ticker && !_tickerActive) {
				_ticker.wake();
			}
			if (list == null) {
				this._listeners[type] = list = [];
			}
			i = list.length;
			while (--i > -1) {
				listener = list[i];
				if (listener.c === callback && listener.s === scope) {
					list.splice(i, 1);
				} else if (index === 0 && listener.pr < priority) {
					index = i + 1;
				}
			}
			list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
		};

		p.removeEventListener = function(type, callback) {
			var list = this._listeners[type], i;
			if (list) {
				i = list.length;
				while (--i > -1) {
					if (list[i].c === callback) {
						list.splice(i, 1);
						return;
					}
				}
			}
		};

		p.dispatchEvent = function(type) {
			var list = this._listeners[type],
				i, t, listener;
			if (list) {
				i = list.length;
				if (i > 1) {
					list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
				}
				t = this._eventTarget;
				while (--i > -1) {
					listener = list[i];
					if (listener) {
						if (listener.up) {
							listener.c.call(listener.s || t, {type:type, target:t});
						} else {
							listener.c.call(listener.s || t);
						}
					}
				}
			}
		};


/*
 * ----------------------------------------------------------------
 * Ticker
 * ----------------------------------------------------------------
 */
 		var _reqAnimFrame = window.requestAnimationFrame,
			_cancelAnimFrame = window.cancelAnimationFrame,
			_getTime = Date.now || function() {return new Date().getTime();},
			_lastUpdate = _getTime();

		//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
		a = ["ms","moz","webkit","o"];
		i = a.length;
		while (--i > -1 && !_reqAnimFrame) {
			_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
			_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
		}

		_class("Ticker", function(fps, useRAF) {
			var _self = this,
				_startTime = _getTime(),
				_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
				_lagThreshold = 500,
				_adjustedLag = 33,
				_tickWord = "tick", //helps reduce gc burden
				_fps, _req, _id, _gap, _nextTime,
				_tick = function(manual) {
					var elapsed = _getTime() - _lastUpdate,
						overlap, dispatch;
					if (elapsed > _lagThreshold) {
						_startTime += elapsed - _adjustedLag;
					}
					_lastUpdate += elapsed;
					_self.time = (_lastUpdate - _startTime) / 1000;
					overlap = _self.time - _nextTime;
					if (!_fps || overlap > 0 || manual === true) {
						_self.frame++;
						_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
						dispatch = true;
					}
					if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
						_id = _req(_tick);
					}
					if (dispatch) {
						_self.dispatchEvent(_tickWord);
					}
				};

			EventDispatcher.call(_self);
			_self.time = _self.frame = 0;
			_self.tick = function() {
				_tick(true);
			};

			_self.lagSmoothing = function(threshold, adjustedLag) {
				if (!arguments.length) { //if lagSmoothing() is called with no arguments, treat it like a getter that returns a boolean indicating if it's enabled or not. This is purposely undocumented and is for internal use.
					return (_lagThreshold < 1 / _tinyNum);
				}
				_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
				_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
			};

			_self.sleep = function() {
				if (_id == null) {
					return;
				}
				if (!_useRAF || !_cancelAnimFrame) {
					clearTimeout(_id);
				} else {
					_cancelAnimFrame(_id);
				}
				_req = _emptyFunc;
				_id = null;
				if (_self === _ticker) {
					_tickerActive = false;
				}
			};

			_self.wake = function(seamless) {
				if (_id !== null) {
					_self.sleep();
				} else if (seamless) {
					_startTime += -_lastUpdate + (_lastUpdate = _getTime());
				} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
					_lastUpdate = _getTime() - _lagThreshold + 5;
				}
				_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
				if (_self === _ticker) {
					_tickerActive = true;
				}
				_tick(2);
			};

			_self.fps = function(value) {
				if (!arguments.length) {
					return _fps;
				}
				_fps = value;
				_gap = 1 / (_fps || 60);
				_nextTime = this.time + _gap;
				_self.wake();
			};

			_self.useRAF = function(value) {
				if (!arguments.length) {
					return _useRAF;
				}
				_self.sleep();
				_useRAF = value;
				_self.fps(_fps);
			};
			_self.fps(fps);

			//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
			setTimeout(function() {
				if (_useRAF === "auto" && _self.frame < 5 && (_doc || {}).visibilityState !== "hidden") {
					_self.useRAF(false);
				}
			}, 1500);
		});

		p = gs.Ticker.prototype = new gs.events.EventDispatcher();
		p.constructor = gs.Ticker;


/*
 * ----------------------------------------------------------------
 * Animation
 * ----------------------------------------------------------------
 */
		var Animation = _class("core.Animation", function(duration, vars) {
				this.vars = vars = vars || {};
				this._duration = this._totalDuration = duration || 0;
				this._delay = Number(vars.delay) || 0;
				this._timeScale = 1;
				this._active = (vars.immediateRender === true);
				this.data = vars.data;
				this._reversed = (vars.reversed === true);

				if (!_rootTimeline) {
					return;
				}
				if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
					_ticker.wake();
				}

				var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
				tl.add(this, tl._time);

				if (this.vars.paused) {
					this.paused(true);
				}
			});

		_ticker = Animation.ticker = new gs.Ticker();
		p = Animation.prototype;
		p._dirty = p._gc = p._initted = p._paused = false;
		p._totalTime = p._time = 0;
		p._rawPrevTime = -1;
		p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
		p._paused = false;


		//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
		var _checkTimeout = function() {
				if (_tickerActive && _getTime() - _lastUpdate > 2000 && ((_doc || {}).visibilityState !== "hidden" || !_ticker.lagSmoothing())) { //note: if the tab is hidden, we should still wake if lagSmoothing has been disabled.
					_ticker.wake();
				}
				var t = setTimeout(_checkTimeout, 2000);
				if (t.unref) {
					// allows a node process to exit even if the timeout’s callback hasn't been invoked. Without it, the node process could hang as this function is called every two seconds.
					t.unref();
				}
			};
		_checkTimeout();


		p.play = function(from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.reversed(false).paused(false);
		};

		p.pause = function(atTime, suppressEvents) {
			if (atTime != null) {
				this.seek(atTime, suppressEvents);
			}
			return this.paused(true);
		};

		p.resume = function(from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.paused(false);
		};

		p.seek = function(time, suppressEvents) {
			return this.totalTime(Number(time), suppressEvents !== false);
		};

		p.restart = function(includeDelay, suppressEvents) {
			return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
		};

		p.reverse = function(from, suppressEvents) {
			if (from != null) {
				this.seek((from || this.totalDuration()), suppressEvents);
			}
			return this.reversed(true).paused(false);
		};

		p.render = function(time, suppressEvents, force) {
			//stub - we override this method in subclasses.
		};

		p.invalidate = function() {
			this._time = this._totalTime = 0;
			this._initted = this._gc = false;
			this._rawPrevTime = -1;
			if (this._gc || !this.timeline) {
				this._enabled(true);
			}
			return this;
		};

		p.isActive = function() {
			var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
				startTime = this._startTime,
				rawTime;
			return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime(true)) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale - 0.0000001));
		};

		p._enabled = function (enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			this._gc = !enabled;
			this._active = this.isActive();
			if (ignoreTimeline !== true) {
				if (enabled && !this.timeline) {
					this._timeline.add(this, this._startTime - this._delay);
				} else if (!enabled && this.timeline) {
					this._timeline._remove(this, true);
				}
			}
			return false;
		};


		p._kill = function(vars, target) {
			return this._enabled(false, false);
		};

		p.kill = function(vars, target) {
			this._kill(vars, target);
			return this;
		};

		p._uncache = function(includeSelf) {
			var tween = includeSelf ? this : this.timeline;
			while (tween) {
				tween._dirty = true;
				tween = tween.timeline;
			}
			return this;
		};

		p._swapSelfInParams = function(params) {
			var i = params.length,
				copy = params.concat();
			while (--i > -1) {
				if (params[i] === "{self}") {
					copy[i] = this;
				}
			}
			return copy;
		};

		p._callback = function(type) {
			var v = this.vars,
				callback = v[type],
				params = v[type + "Params"],
				scope = v[type + "Scope"] || v.callbackScope || this,
				l = params ? params.length : 0;
			switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
				case 0: callback.call(scope); break;
				case 1: callback.call(scope, params[0]); break;
				case 2: callback.call(scope, params[0], params[1]); break;
				default: callback.apply(scope, params);
			}
		};

//----Animation getters/setters --------------------------------------------------------

		p.eventCallback = function(type, callback, params, scope) {
			if ((type || "").substr(0,2) === "on") {
				var v = this.vars;
				if (arguments.length === 1) {
					return v[type];
				}
				if (callback == null) {
					delete v[type];
				} else {
					v[type] = callback;
					v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
					v[type + "Scope"] = scope;
				}
				if (type === "onUpdate") {
					this._onUpdate = callback;
				}
			}
			return this;
		};

		p.delay = function(value) {
			if (!arguments.length) {
				return this._delay;
			}
			if (this._timeline.smoothChildTiming) {
				this.startTime( this._startTime + value - this._delay );
			}
			this._delay = value;
			return this;
		};

		p.duration = function(value) {
			if (!arguments.length) {
				this._dirty = false;
				return this._duration;
			}
			this._duration = this._totalDuration = value;
			this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
			if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
				this.totalTime(this._totalTime * (value / this._duration), true);
			}
			return this;
		};

		p.totalDuration = function(value) {
			this._dirty = false;
			return (!arguments.length) ? this._totalDuration : this.duration(value);
		};

		p.time = function(value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
		};

		p.totalTime = function(time, suppressEvents, uncapped) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (!arguments.length) {
				return this._totalTime;
			}
			if (this._timeline) {
				if (time < 0 && !uncapped) {
					time += this.totalDuration();
				}
				if (this._timeline.smoothChildTiming) {
					if (this._dirty) {
						this.totalDuration();
					}
					var totalDuration = this._totalDuration,
						tl = this._timeline;
					if (time > totalDuration && !uncapped) {
						time = totalDuration;
					}
					this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
					if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
						this._uncache(false);
					}
					//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
					if (tl._timeline) {
						while (tl._timeline) {
							if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
								tl.totalTime(tl._totalTime, true);
							}
							tl = tl._timeline;
						}
					}
				}
				if (this._gc) {
					this._enabled(true, false);
				}
				if (this._totalTime !== time || this._duration === 0) {
					if (_lazyTweens.length) {
						_lazyRender();
					}
					this.render(time, suppressEvents, false);
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
						_lazyRender();
					}
				}
			}
			return this;
		};

		p.progress = p.totalProgress = function(value, suppressEvents) {
			var duration = this.duration();
			return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
		};

		p.startTime = function(value) {
			if (!arguments.length) {
				return this._startTime;
			}
			if (value !== this._startTime) {
				this._startTime = value;
				if (this.timeline) if (this.timeline._sortChildren) {
					this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
				}
			}
			return this;
		};

		p.endTime = function(includeRepeats) {
			return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
		};

		p.timeScale = function(value) {
			if (!arguments.length) {
				return this._timeScale;
			}
			var pauseTime, t;
			value = value || _tinyNum; //can't allow zero because it'll throw the math off
			if (this._timeline && this._timeline.smoothChildTiming) {
				pauseTime = this._pauseTime;
				t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
				this._startTime = t - ((t - this._startTime) * this._timeScale / value);
			}
			this._timeScale = value;
			t = this.timeline;
			while (t && t.timeline) { //must update the duration/totalDuration of all ancestor timelines immediately in case in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
				t._dirty = true;
				t.totalDuration();
				t = t.timeline;
			}
			return this;
		};

		p.reversed = function(value) {
			if (!arguments.length) {
				return this._reversed;
			}
			if (value != this._reversed) {
				this._reversed = value;
				this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
			}
			return this;
		};

		p.paused = function(value) {
			if (!arguments.length) {
				return this._paused;
			}
			var tl = this._timeline,
				raw, elapsed;
			if (value != this._paused) if (tl) {
				if (!_tickerActive && !value) {
					_ticker.wake();
				}
				raw = tl.rawTime();
				elapsed = raw - this._pauseTime;
				if (!value && tl.smoothChildTiming) {
					this._startTime += elapsed;
					this._uncache(false);
				}
				this._pauseTime = value ? raw : null;
				this._paused = value;
				this._active = this.isActive();
				if (!value && elapsed !== 0 && this._initted && this.duration()) {
					raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
					this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
				}
			}
			if (this._gc && !value) {
				this._enabled(true, false);
			}
			return this;
		};


/*
 * ----------------------------------------------------------------
 * SimpleTimeline
 * ----------------------------------------------------------------
 */
		var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
			Animation.call(this, 0, vars);
			this.autoRemoveChildren = this.smoothChildTiming = true;
		});

		p = SimpleTimeline.prototype = new Animation();
		p.constructor = SimpleTimeline;
		p.kill()._gc = false;
		p._first = p._last = p._recent = null;
		p._sortChildren = false;

		p.add = p.insert = function(child, position, align, stagger) {
			var prevTween, st;
			child._startTime = Number(position || 0) + child._delay;
			if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
				child._pauseTime = child._startTime + ((this.rawTime() - child._startTime) / child._timeScale);
			}
			if (child.timeline) {
				child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
			}
			child.timeline = child._timeline = this;
			if (child._gc) {
				child._enabled(true, true);
			}
			prevTween = this._last;
			if (this._sortChildren) {
				st = child._startTime;
				while (prevTween && prevTween._startTime > st) {
					prevTween = prevTween._prev;
				}
			}
			if (prevTween) {
				child._next = prevTween._next;
				prevTween._next = child;
			} else {
				child._next = this._first;
				this._first = child;
			}
			if (child._next) {
				child._next._prev = child;
			} else {
				this._last = child;
			}
			child._prev = prevTween;
			this._recent = child;
			if (this._timeline) {
				this._uncache(true);
			}
			return this;
		};

		p._remove = function(tween, skipDisable) {
			if (tween.timeline === this) {
				if (!skipDisable) {
					tween._enabled(false, true);
				}

				if (tween._prev) {
					tween._prev._next = tween._next;
				} else if (this._first === tween) {
					this._first = tween._next;
				}
				if (tween._next) {
					tween._next._prev = tween._prev;
				} else if (this._last === tween) {
					this._last = tween._prev;
				}
				tween._next = tween._prev = tween.timeline = null;
				if (tween === this._recent) {
					this._recent = this._last;
				}

				if (this._timeline) {
					this._uncache(true);
				}
			}
			return this;
		};

		p.render = function(time, suppressEvents, force) {
			var tween = this._first,
				next;
			this._totalTime = this._time = this._rawPrevTime = time;
			while (tween) {
				next = tween._next; //record it here because the value could change after rendering...
				if (tween._active || (time >= tween._startTime && !tween._paused && !tween._gc)) {
					if (!tween._reversed) {
						tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
					} else {
						tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
					}
				}
				tween = next;
			}
		};

		p.rawTime = function() {
			if (!_tickerActive) {
				_ticker.wake();
			}
			return this._totalTime;
		};

/*
 * ----------------------------------------------------------------
 * TweenLite
 * ----------------------------------------------------------------
 */
		var TweenLite = _class("TweenLite", function(target, duration, vars) {
				Animation.call(this, duration, vars);
				this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)

				if (target == null) {
					throw "Cannot tween a null target.";
				}

				this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;

				var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
					overwrite = this.vars.overwrite,
					i, targ, targets;

				this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];

				if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
					this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					this._propLookup = [];
					this._siblings = [];
					for (i = 0; i < targets.length; i++) {
						targ = targets[i];
						if (!targ) {
							targets.splice(i--, 1);
							continue;
						} else if (typeof(targ) === "string") {
							targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
							if (typeof(targ) === "string") {
								targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
							}
							continue;
						} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
							targets.splice(i--, 1);
							this._targets = targets = targets.concat(_slice(targ));
							continue;
						}
						this._siblings[i] = _register(targ, this, false);
						if (overwrite === 1) if (this._siblings[i].length > 1) {
							_applyOverwrite(targ, this, null, 1, this._siblings[i]);
						}
					}

				} else {
					this._propLookup = {};
					this._siblings = _register(target, this, false);
					if (overwrite === 1) if (this._siblings.length > 1) {
						_applyOverwrite(target, this, null, 1, this._siblings);
					}
				}
				if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative
				}
			}, true),
			_isSelector = function(v) {
				return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
			},
			_autoCSS = function(vars, target) {
				var css = {},
					p;
				for (p in vars) {
					if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
						css[p] = vars[p];
						delete vars[p];
					}
				}
				vars.css = css;
			};

		p = TweenLite.prototype = new Animation();
		p.constructor = TweenLite;
		p.kill()._gc = false;

//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------

		p.ratio = 0;
		p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
		p._notifyPluginsOfEnabled = p._lazy = false;

		TweenLite.version = "1.20.4";
		TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
		TweenLite.defaultOverwrite = "auto";
		TweenLite.ticker = _ticker;
		TweenLite.autoSleep = 120;
		TweenLite.lagSmoothing = function(threshold, adjustedLag) {
			_ticker.lagSmoothing(threshold, adjustedLag);
		};

		TweenLite.selector = window.$ || window.jQuery || function(e) {
			var selector = window.$ || window.jQuery;
			if (selector) {
				TweenLite.selector = selector;
				return selector(e);
			}
			return (typeof(_doc) === "undefined") ? e : (_doc.querySelectorAll ? _doc.querySelectorAll(e) : _doc.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
		};

		var _lazyTweens = [],
			_lazyLookup = {},
			_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
			_relExp = /[\+-]=-?[\.\d]/,
			//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
			_setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val;
				while (pt) {
					val = !pt.blob ? pt.c * v + pt.s : (v === 1 && this.end != null) ? this.end : v ? this.join("") : this.start;
					if (pt.m) {
						val = pt.m(val, this._target || pt.t);
					} else if (val < min) if (val > -min && !pt.blob) { //prevents issues with converting very small numbers to strings in the browser
						val = 0;
					}
					if (!pt.f) {
						pt.t[pt.p] = val;
					} else if (pt.fp) {
						pt.t[pt.p](pt.fp, val);
					} else {
						pt.t[pt.p](val);
					}
					pt = pt._next;
				}
			},
			//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
			_blobDif = function(start, end, filter, pt) {
				var a = [],
					charIndex = 0,
					s = "",
					color = 0,
					startNums, endNums, num, i, l, nonNumbers, currentNum;
				a.start = start;
				a.end = end;
				start = a[0] = start + ""; //ensure values are strings
				end = a[1] = end + "";
				if (filter) {
					filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
					start = a[0];
					end = a[1];
				}
				a.length = 0;
				startNums = start.match(_numbersExp) || [];
				endNums = end.match(_numbersExp) || [];
				if (pt) {
					pt._next = null;
					pt.blob = 1;
					a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
				}
				l = endNums.length;
				for (i = 0; i < l; i++) {
					currentNum = endNums[i];
					nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
					s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
					charIndex += nonNumbers.length;
					if (color) { //sense rgba() values and round them.
						color = (color + 1) % 5;
					} else if (nonNumbers.substr(-5) === "rgba(") {
						color = 1;
					}
					if (currentNum === startNums[i] || startNums.length <= i) {
						s += currentNum;
					} else {
						if (s) {
							a.push(s);
							s = "";
						}
						num = parseFloat(startNums[i]);
						a.push(num);
						a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : 0};
						//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
					}
					charIndex += currentNum.length;
				}
				s += end.substr(charIndex);
				if (s) {
					a.push(s);
				}
				a.setRatio = _setRatio;
				if (_relExp.test(end)) { //if the end string contains relative values, delete it so that on the final render (in _setRatio()), we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
					a.end = null;
				}
				return a;
			},
			//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
			_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
				if (typeof(end) === "function") {
					end = end(index || 0, target);
				}
				var type = typeof(target[prop]),
					getterName = (type !== "function") ? "" : ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3)),
					s = (start !== "get") ? start : !getterName ? target[prop] : funcParam ? target[getterName](funcParam) : target[getterName](),
					isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
					pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
					blob;

				if (typeof(s) !== "number" || (typeof(end) !== "number" && !isRelative)) {
					if (funcParam || isNaN(s) || (!isRelative && isNaN(end)) || typeof(s) === "boolean" || typeof(end) === "boolean") {
						//a blob (string that has multiple numbers in it)
						pt.fp = funcParam;
						blob = _blobDif(s, (isRelative ? (parseFloat(pt.s) + pt.c) + (pt.s + "").replace(/[0-9\-\.]/g, "") : end), stringFilter || TweenLite.defaultStringFilter, pt);
						pt = {t: blob, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: overwriteProp || prop, pr: 0, m: 0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
					} else {
						pt.s = parseFloat(s);
						if (!isRelative) {
							pt.c = (parseFloat(end) - pt.s) || 0;
						}
					}
				}
				if (pt.c) { //only add it to the linked list if there's a change.
					if ((pt._next = this._firstPT)) {
						pt._next._prev = pt;
					}
					this._firstPT = pt;
					return pt;
				}
			},
			_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
			_plugins = TweenLite._plugins = {},
			_tweenLookup = _internals.tweenLookup = {},
			_tweenLookupNum = 0,
			_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1, yoyoEase:1},
			_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
			_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
			_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
			_nextGCFrame = 30,
			_lazyRender = _internals.lazyRender = function() {
				var i = _lazyTweens.length,
					tween;
				_lazyLookup = {};
				while (--i > -1) {
					tween = _lazyTweens[i];
					if (tween && tween._lazy !== false) {
						tween.render(tween._lazy[0], tween._lazy[1], true);
						tween._lazy = false;
					}
				}
				_lazyTweens.length = 0;
			};

		_rootTimeline._startTime = _ticker.time;
		_rootFramesTimeline._startTime = _ticker.frame;
		_rootTimeline._active = _rootFramesTimeline._active = true;
		setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".

		Animation._updateRoot = TweenLite.render = function() {
				var i, a, p;
				if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
					_lazyRender();
				}
				_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
				_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
				if (_lazyTweens.length) {
					_lazyRender();
				}
				if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
					_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
					for (p in _tweenLookup) {
						a = _tweenLookup[p].tweens;
						i = a.length;
						while (--i > -1) {
							if (a[i]._gc) {
								a.splice(i, 1);
							}
						}
						if (a.length === 0) {
							delete _tweenLookup[p];
						}
					}
					//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
					p = _rootTimeline._first;
					if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
						while (p && p._paused) {
							p = p._next;
						}
						if (!p) {
							_ticker.sleep();
						}
					}
				}
			};

		_ticker.addEventListener("tick", Animation._updateRoot);

		var _register = function(target, tween, scrub) {
				var id = target._gsTweenID, a, i;
				if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
					_tweenLookup[id] = {target:target, tweens:[]};
				}
				if (tween) {
					a = _tweenLookup[id].tweens;
					a[(i = a.length)] = tween;
					if (scrub) {
						while (--i > -1) {
							if (a[i] === tween) {
								a.splice(i, 1);
							}
						}
					}
				}
				return _tweenLookup[id].tweens;
			},
			_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
				var func = overwrittenTween.vars.onOverwrite, r1, r2;
				if (func) {
					r1 = func(overwrittenTween, overwritingTween, target, killedProps);
				}
				func = TweenLite.onOverwrite;
				if (func) {
					r2 = func(overwrittenTween, overwritingTween, target, killedProps);
				}
				return (r1 !== false && r2 !== false);
			},
			_applyOverwrite = function(target, tween, props, mode, siblings) {
				var i, changed, curTween, l;
				if (mode === 1 || mode >= 4) {
					l = siblings.length;
					for (i = 0; i < l; i++) {
						if ((curTween = siblings[i]) !== tween) {
							if (!curTween._gc) {
								if (curTween._kill(null, target, tween)) {
									changed = true;
								}
							}
						} else if (mode === 5) {
							break;
						}
					}
					return changed;
				}
				//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
				var startTime = tween._startTime + _tinyNum,
					overlaps = [],
					oCount = 0,
					zeroDur = (tween._duration === 0),
					globalStart;
				i = siblings.length;
				while (--i > -1) {
					if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
						//ignore
					} else if (curTween._timeline !== tween._timeline) {
						globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
						if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
							overlaps[oCount++] = curTween;
						}
					} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
						overlaps[oCount++] = curTween;
					}
				}

				i = oCount;
				while (--i > -1) {
					curTween = overlaps[i];
					if (mode === 2) if (curTween._kill(props, target, tween)) {
						changed = true;
					}
					if (mode !== 2 || (!curTween._firstPT && curTween._initted)) {
						if (mode !== 2 && !_onOverwrite(curTween, tween)) {
							continue;
						}
						if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
							changed = true;
						}
					}
				}
				return changed;
			},
			_checkOverlap = function(tween, reference, zeroDur) {
				var tl = tween._timeline,
					ts = tl._timeScale,
					t = tween._startTime;
				while (tl._timeline) {
					t += tl._startTime;
					ts *= tl._timeScale;
					if (tl._paused) {
						return -100;
					}
					tl = tl._timeline;
				}
				t /= ts;
				return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
			};


//---- TweenLite instance methods -----------------------------------------------------------------------------

		p._init = function() {
			var v = this.vars,
				op = this._overwrittenProps,
				dur = this._duration,
				immediate = !!v.immediateRender,
				ease = v.ease,
				i, initPlugins, pt, p, startVars, l;
			if (v.startAt) {
				if (this._startAt) {
					this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
					this._startAt.kill();
				}
				startVars = {};
				for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
					startVars[p] = v.startAt[p];
				}
				startVars.data = "isStart";
				startVars.overwrite = false;
				startVars.immediateRender = true;
				startVars.lazy = (immediate && v.lazy !== false);
				startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
				startVars.onUpdate = v.onUpdate;
				startVars.onUpdateParams = v.onUpdateParams;
				startVars.onUpdateScope = v.onUpdateScope || v.callbackScope || this;
				this._startAt = TweenLite.to(this.target, 0, startVars);
				if (immediate) {
					if (this._time > 0) {
						this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
					} else if (dur !== 0) {
						return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
					}
				}
			} else if (v.runBackwards && dur !== 0) {
				//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
				if (this._startAt) {
					this._startAt.render(-1, true);
					this._startAt.kill();
					this._startAt = null;
				} else {
					if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
						immediate = false;
					}
					pt = {};
					for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
						if (!_reservedProps[p] || p === "autoCSS") {
							pt[p] = v[p];
						}
					}
					pt.overwrite = 0;
					pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
					pt.lazy = (immediate && v.lazy !== false);
					pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
					this._startAt = TweenLite.to(this.target, 0, pt);
					if (!immediate) {
						this._startAt._init(); //ensures that the initial values are recorded
						this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
						if (this.vars.immediateRender) {
							this._startAt = null;
						}
					} else if (this._time === 0) {
						return;
					}
				}
			}
			this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
			if (v.easeParams instanceof Array && ease.config) {
				this._ease = ease.config.apply(ease, v.easeParams);
			}
			this._easeType = this._ease._type;
			this._easePower = this._ease._power;
			this._firstPT = null;

			if (this._targets) {
				l = this._targets.length;
				for (i = 0; i < l; i++) {
					if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
						initPlugins = true;
					}
				}
			} else {
				initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
			}

			if (initPlugins) {
				TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
			}
			if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
				this._enabled(false, false);
			}
			if (v.runBackwards) {
				pt = this._firstPT;
				while (pt) {
					pt.s += pt.c;
					pt.c = -pt.c;
					pt = pt._next;
				}
			}
			this._onUpdate = v.onUpdate;
			this._initted = true;
		};

		p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
			var p, i, initPlugins, plugin, pt, v;
			if (target == null) {
				return false;
			}

			if (_lazyLookup[target._gsTweenID]) {
				_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
			}

			if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
				_autoCSS(this.vars, target);
			}
			for (p in this.vars) {
				v = this.vars[p];
				if (_reservedProps[p]) {
					if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
						this.vars[p] = v = this._swapSelfInParams(v, this);
					}

				} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {

					//t - target 		[object]
					//p - property 		[string]
					//s - start			[number]
					//c - change		[number]
					//f - isFunction	[boolean]
					//n - name			[string]
					//pg - isPlugin 	[boolean]
					//pr - priority		[number]
					//m - mod           [function | 0]
					this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
					i = plugin._overwriteProps.length;
					while (--i > -1) {
						propLookup[plugin._overwriteProps[i]] = this._firstPT;
					}
					if (plugin._priority || plugin._onInitAllProps) {
						initPlugins = true;
					}
					if (plugin._onDisable || plugin._onEnable) {
						this._notifyPluginsOfEnabled = true;
					}
					if (pt._next) {
						pt._next._prev = pt;
					}

				} else {
					propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
				}
			}

			if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
				return this._initProps(target, propLookup, siblings, overwrittenProps, index);
			}
			if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
				this._kill(propLookup, target);
				return this._initProps(target, propLookup, siblings, overwrittenProps, index);
			}
			if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
				_lazyLookup[target._gsTweenID] = true;
			}
			return initPlugins;
		};

		p.render = function(time, suppressEvents, force) {
			var prevTime = this._time,
				duration = this._duration,
				prevRawPrevTime = this._rawPrevTime,
				isComplete, callback, pt, rawPrevTime;
			if (time >= duration - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
				this._totalTime = this._time = duration;
				this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
				if (!this._reversed ) {
					isComplete = true;
					callback = "onComplete";
					force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
				}
				if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
					if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
						time = 0;
					}
					if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
						force = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
					this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				}

			} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
				this._totalTime = this._time = 0;
				this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
				if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
					callback = "onReverseComplete";
					isComplete = this._reversed;
				}
				if (time < 0) {
					this._active = false;
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
							force = true;
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
				}
				if (!this._initted || (this._startAt && this._startAt.progress())) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately. Also, we check progress() because if startAt has already rendered at its end, we should force a render at its beginning. Otherwise, if you put the playhead directly on top of where a fromTo({immediateRender:false}) starts, and then move it backwards, the from() won't revert its values.
					force = true;
				}
			} else {
				this._totalTime = this._time = time;

				if (this._easeType) {
					var r = time / duration, type = this._easeType, pow = this._easePower;
					if (type === 1 || (type === 3 && r >= 0.5)) {
						r = 1 - r;
					}
					if (type === 3) {
						r *= 2;
					}
					if (pow === 1) {
						r *= r;
					} else if (pow === 2) {
						r *= r * r;
					} else if (pow === 3) {
						r *= r * r * r;
					} else if (pow === 4) {
						r *= r * r * r * r;
					}

					if (type === 1) {
						this.ratio = 1 - r;
					} else if (type === 2) {
						this.ratio = r;
					} else if (time / duration < 0.5) {
						this.ratio = r / 2;
					} else {
						this.ratio = 1 - (r / 2);
					}

				} else {
					this.ratio = this._ease.getRatio(time / duration);
				}
			}

			if (this._time === prevTime && !force) {
				return;
			} else if (!this._initted) {
				this._init();
				if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
					return;
				} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) {
					this._time = this._totalTime = prevTime;
					this._rawPrevTime = prevRawPrevTime;
					_lazyTweens.push(this);
					this._lazy = [time, suppressEvents];
					return;
				}
				//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
				if (this._time && !isComplete) {
					this.ratio = this._ease.getRatio(this._time / duration);
				} else if (isComplete && this._ease._calcEnd) {
					this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
				}
			}
			if (this._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
				this._lazy = false;
			}
			if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
				this._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
			}
			if (prevTime === 0) {
				if (this._startAt) {
					if (time >= 0) {
						this._startAt.render(time, true, force);
					} else if (!callback) {
						callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
					}
				}
				if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
					this._callback("onStart");
				}
			}
			pt = this._firstPT;
			while (pt) {
				if (pt.f) {
					pt.t[pt.p](pt.c * this.ratio + pt.s);
				} else {
					pt.t[pt.p] = pt.c * this.ratio + pt.s;
				}
				pt = pt._next;
			}

			if (this._onUpdate) {
				if (time < 0) if (this._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					this._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
				}
				if (!suppressEvents) if (this._time !== prevTime || isComplete || force) {
					this._callback("onUpdate");
				}
			}
			if (callback) if (!this._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
				if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
					this._startAt.render(time, true, force);
				}
				if (isComplete) {
					if (this._timeline.autoRemoveChildren) {
						this._enabled(false, false);
					}
					this._active = false;
				}
				if (!suppressEvents && this.vars[callback]) {
					this._callback(callback);
				}
				if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
					this._rawPrevTime = 0;
				}
			}
		};

		p._kill = function(vars, target, overwritingTween) {
			if (vars === "all") {
				vars = null;
			}
			if (vars == null) if (target == null || target === this.target) {
				this._lazy = false;
				return this._enabled(false, false);
			}
			target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
			var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
				i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
			if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
				i = target.length;
				while (--i > -1) {
					if (this._kill(vars, target[i], overwritingTween)) {
						changed = true;
					}
				}
			} else {
				if (this._targets) {
					i = this._targets.length;
					while (--i > -1) {
						if (target === this._targets[i]) {
							propLookup = this._propLookup[i] || {};
							this._overwrittenProps = this._overwrittenProps || [];
							overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
							break;
						}
					}
				} else if (target !== this.target) {
					return false;
				} else {
					propLookup = this._propLookup;
					overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
				}

				if (propLookup) {
					killProps = vars || propLookup;
					record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
					if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
						for (p in killProps) {
							if (propLookup[p]) {
								if (!killed) {
									killed = [];
								}
								killed.push(p);
							}
						}
						if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
							return false;
						}
					}

					for (p in killProps) {
						if ((pt = propLookup[p])) {
							if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
								if (pt.f) {
									pt.t[pt.p](pt.s);
								} else {
									pt.t[pt.p] = pt.s;
								}
								changed = true;
							}
							if (pt.pg && pt.t._kill(killProps)) {
								changed = true; //some plugins need to be notified so they can perform cleanup tasks first
							}
							if (!pt.pg || pt.t._overwriteProps.length === 0) {
								if (pt._prev) {
									pt._prev._next = pt._next;
								} else if (pt === this._firstPT) {
									this._firstPT = pt._next;
								}
								if (pt._next) {
									pt._next._prev = pt._prev;
								}
								pt._next = pt._prev = null;
							}
							delete propLookup[p];
						}
						if (record) {
							overwrittenProps[p] = 1;
						}
					}
					if (!this._firstPT && this._initted) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
						this._enabled(false, false);
					}
				}
			}
			return changed;
		};

		p.invalidate = function() {
			if (this._notifyPluginsOfEnabled) {
				TweenLite._onPluginEvent("_onDisable", this);
			}
			this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
			this._notifyPluginsOfEnabled = this._active = this._lazy = false;
			this._propLookup = (this._targets) ? {} : [];
			Animation.prototype.invalidate.call(this);
			if (this.vars.immediateRender) {
				this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
				this.render(Math.min(0, -this._delay)); //in case delay is negative.
			}
			return this;
		};

		p._enabled = function(enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (enabled && this._gc) {
				var targets = this._targets,
					i;
				if (targets) {
					i = targets.length;
					while (--i > -1) {
						this._siblings[i] = _register(targets[i], this, true);
					}
				} else {
					this._siblings = _register(this.target, this, true);
				}
			}
			Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
			if (this._notifyPluginsOfEnabled) if (this._firstPT) {
				return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
			}
			return false;
		};


//----TweenLite static methods -----------------------------------------------------

		TweenLite.to = function(target, duration, vars) {
			return new TweenLite(target, duration, vars);
		};

		TweenLite.from = function(target, duration, vars) {
			vars.runBackwards = true;
			vars.immediateRender = (vars.immediateRender != false);
			return new TweenLite(target, duration, vars);
		};

		TweenLite.fromTo = function(target, duration, fromVars, toVars) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return new TweenLite(target, duration, toVars);
		};

		TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
			return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
		};

		TweenLite.set = function(target, vars) {
			return new TweenLite(target, 0, vars);
		};

		TweenLite.getTweensOf = function(target, onlyActive) {
			if (target == null) { return []; }
			target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
			var i, a, j, t;
			if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
				i = target.length;
				a = [];
				while (--i > -1) {
					a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
				}
				i = a.length;
				//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
				while (--i > -1) {
					t = a[i];
					j = i;
					while (--j > -1) {
						if (t === a[j]) {
							a.splice(i, 1);
						}
					}
				}
			} else if (target._gsTweenID) {
				a = _register(target).concat();
				i = a.length;
				while (--i > -1) {
					if (a[i]._gc || (onlyActive && !a[i].isActive())) {
						a.splice(i, 1);
					}
				}
			}
			return a || [];
		};

		TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
			if (typeof(onlyActive) === "object") {
				vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
				onlyActive = false;
			}
			var a = TweenLite.getTweensOf(target, onlyActive),
				i = a.length;
			while (--i > -1) {
				a[i]._kill(vars, target);
			}
		};



/*
 * ----------------------------------------------------------------
 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
 * ----------------------------------------------------------------
 */
		var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
					this._overwriteProps = (props || "").split(",");
					this._propName = this._overwriteProps[0];
					this._priority = priority || 0;
					this._super = TweenPlugin.prototype;
				}, true);

		p = TweenPlugin.prototype;
		TweenPlugin.version = "1.19.0";
		TweenPlugin.API = 2;
		p._firstPT = null;
		p._addTween = _addPropTween;
		p.setRatio = _setRatio;

		p._kill = function(lookup) {
			var a = this._overwriteProps,
				pt = this._firstPT,
				i;
			if (lookup[this._propName] != null) {
				this._overwriteProps = [];
			} else {
				i = a.length;
				while (--i > -1) {
					if (lookup[a[i]] != null) {
						a.splice(i, 1);
					}
				}
			}
			while (pt) {
				if (lookup[pt.n] != null) {
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
						pt._prev = null;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
					}
				}
				pt = pt._next;
			}
			return false;
		};

		p._mod = p._roundProps = function(lookup) {
			var pt = this._firstPT,
				val;
			while (pt) {
				val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
				if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
					if (pt.f === 2) {
						pt.t._applyPT.m = val;
					} else {
						pt.m = val;
					}
				}
				pt = pt._next;
			}
		};

		TweenLite._onPluginEvent = function(type, tween) {
			var pt = tween._firstPT,
				changed, pt2, first, last, next;
			if (type === "_onInitAllProps") {
				//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
				while (pt) {
					next = pt._next;
					pt2 = first;
					while (pt2 && pt2.pr > pt.pr) {
						pt2 = pt2._next;
					}
					if ((pt._prev = pt2 ? pt2._prev : last)) {
						pt._prev._next = pt;
					} else {
						first = pt;
					}
					if ((pt._next = pt2)) {
						pt2._prev = pt;
					} else {
						last = pt;
					}
					pt = next;
				}
				pt = tween._firstPT = first;
			}
			while (pt) {
				if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
					changed = true;
				}
				pt = pt._next;
			}
			return changed;
		};

		TweenPlugin.activate = function(plugins) {
			var i = plugins.length;
			while (--i > -1) {
				if (plugins[i].API === TweenPlugin.API) {
					_plugins[(new plugins[i]())._propName] = plugins[i];
				}
			}
			return true;
		};

		//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
		_gsDefine.plugin = function(config) {
			if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
			var propName = config.propName,
				priority = config.priority || 0,
				overwriteProps = config.overwriteProps,
				map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
				Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
					function() {
						TweenPlugin.call(this, propName, priority);
						this._overwriteProps = overwriteProps || [];
					}, (config.global === true)),
				p = Plugin.prototype = new TweenPlugin(propName),
				prop;
			p.constructor = Plugin;
			Plugin.API = config.API;
			for (prop in map) {
				if (typeof(config[prop]) === "function") {
					p[map[prop]] = config[prop];
				}
			}
			Plugin.version = config.version;
			TweenPlugin.activate([Plugin]);
			return Plugin;
		};


		//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
		a = window._gsQueue;
		if (a) {
			for (i = 0; i < a.length; i++) {
				a[i]();
			}
			for (p in _defLookup) {
				if (!_defLookup[p].func) {
					window.console.log("GSAP encountered missing dependency: " + p);
				}
			}
		}

		_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated

})((typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window, "TweenMax");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(121)();
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.parseStartTime = parseStartTime;
exports.parseEndTime = parseEndTime;
exports.randomString = randomString;
exports.queryString = queryString;
exports.getSDK = getSDK;
exports.getConfig = getConfig;
exports.omit = omit;
exports.callPlayer = callPlayer;
exports.isObject = isObject;
exports.isEqual = isEqual;
exports.isMediaStream = isMediaStream;

var _loadScript = __webpack_require__(297);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _deepmerge = __webpack_require__(298);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _props = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/;

// Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds
function parseTimeParam(url, pattern) {
  var match = url.match(pattern);
  if (match) {
    var stamp = match[1];
    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }
    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }
  return undefined;
}

function parseTimeString(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);
  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }
  return seconds;
}

function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}

function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
}

// http://stackoverflow.com/a/38622545
function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return key + '=' + object[key];
  }).join('&');
}

// Util function to load an external SDK
// or return the SDK if it is already loaded
var resolves = {};
function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };
  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript2['default'];

  if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
    return Promise.resolve(window[sdkGlobal]);
  }
  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve
    // function to the existing array of resolve functions
    if (resolves[url]) {
      resolves[url].push(resolve);
      return;
    }
    resolves[url] = [resolve];
    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending promises
      resolves[url].forEach(function (resolve) {
        return resolve(sdk);
      });
    };
    if (sdkReady) {
      var previousOnReady = window[sdkReady];
      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(window[sdkGlobal]);
      };
    }
    fetchScript(url, function (err) {
      if (err) reject(err);
      if (!sdkReady) {
        onLoaded(window[sdkGlobal]);
      }
    });
  });
}

function getConfig(props, defaultProps, showWarning) {
  var config = (0, _deepmerge2['default'])(defaultProps.config, props.config);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _props.DEPRECATED_CONFIG_PROPS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var p = _step.value;

      if (props[p]) {
        var key = p.replace(/Config$/, '');
        config = (0, _deepmerge2['default'])(config, _defineProperty({}, key, props[p]));
        if (showWarning) {
          var link = 'https://github.com/CookPete/react-player#config-prop';
          var message = 'ReactPlayer: %c' + p + ' %cis deprecated, please use the config prop instead \u2013 ' + link;
          console.warn(message, 'font-weight: bold', '');
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return config;
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);
  var output = {};
  var keys = Object.keys(object);
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      if (omitKeys.indexOf(key) === -1) {
        output[key] = object[key];
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2['return']) {
        _iterator2['return']();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return output;
}

function callPlayer(method) {
  var _player;

  // Util method for calling a method on this.player
  // but guard against errors and console.warn instead
  if (!this.player || !this.player[method]) {
    var message = 'ReactPlayer: ' + this.constructor.displayName + ' player could not call %c' + method + '%c \u2013 ';
    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }
    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_player = this.player)[method].apply(_player, args);
}

function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

// Deep comparison of two objects but ignoring
// functions, for use in shouldComponentUpdate
function isEqual(a, b) {
  if (typeof a === 'function' && typeof b === 'function') {
    return true;
  }
  if (a instanceof Array && b instanceof Array) {
    if (a.length !== b.length) {
      return false;
    }
    for (var i = 0; i !== a.length; i++) {
      if (!isEqual(a[i], b[i])) {
        return false;
      }
    }
    return true;
  }
  if (isObject(a) && isObject(b)) {
    if (Object.keys(a).length !== Object.keys(b).length) {
      return false;
    }
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = Object.keys(a)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var key = _step3.value;

        if (!isEqual(a[key], b[key])) {
          return false;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
          _iterator3['return']();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return true;
  }
  return a === b;
}

function isMediaStream(url) {
  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = createSinglePlayer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props2 = __webpack_require__(28);

var _utils = __webpack_require__(6);

var _Player = __webpack_require__(48);

var _Player2 = _interopRequireDefault(_Player);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SUPPORTED_PROPS = Object.keys(_props2.propTypes);

function createSinglePlayer(activePlayer) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits(SinglePlayer, _Component);

    function SinglePlayer() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, SinglePlayer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SinglePlayer.__proto__ || Object.getPrototypeOf(SinglePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.getDuration = function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      }, _this.getCurrentTime = function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      }, _this.getSecondsLoaded = function () {
        if (!_this.player) return null;
        return _this.player.getSecondsLoaded();
      }, _this.getInternalPlayer = function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';

        if (!_this.player) return null;
        return _this.player.getInternalPlayer(key);
      }, _this.seekTo = function (fraction, type) {
        if (!_this.player) return null;
        _this.player.seekTo(fraction, type);
      }, _this.ref = function (player) {
        _this.player = player;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SinglePlayer, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return !(0, _utils.isEqual)(this.props, nextProps);
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps) {
        this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
      }
    }, {
      key: 'render',
      value: function render() {
        var _config$file = this.config.file,
            forceVideo = _config$file.forceVideo,
            forceAudio = _config$file.forceAudio,
            forceHLS = _config$file.forceHLS,
            forceDASH = _config$file.forceDASH;

        var skipCanPlay = forceVideo || forceAudio || forceHLS || forceDASH;
        if (!activePlayer.canPlay(this.props.url) && !skipCanPlay) {
          return null;
        }
        var _props = this.props,
            style = _props.style,
            width = _props.width,
            height = _props.height,
            Wrapper = _props.wrapper;

        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
        return _react2['default'].createElement(
          Wrapper,
          _extends({ style: _extends({}, style, { width: width, height: height }) }, otherProps),
          _react2['default'].createElement(_Player2['default'], _extends({}, this.props, {
            ref: this.ref,
            activePlayer: activePlayer,
            config: this.config
          }))
        );
      }
    }]);

    return SinglePlayer;
  }(_react.Component), _class.displayName = activePlayer.displayName + 'Player', _class.propTypes = _props2.propTypes, _class.defaultProps = _props2.defaultProps, _class.canPlay = activePlayer.canPlay, _temp2;
}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(120);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(10);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(4);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(10);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(11);

var _Actions = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__images_bot_gif__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__images_bot_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__images_bot_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__images_ads_3x4_1_svg__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__images_ads_3x4_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__images_ads_3x4_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_ads_3x4_2_svg__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_ads_3x4_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_ads_3x4_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_ads_3x4_3_svg__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_ads_3x4_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_ads_3x4_3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_ads_3x4_4_svg__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_ads_3x4_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_ads_3x4_4_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_ads_3x4_5_svg__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_ads_3x4_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_ads_3x4_5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_ads_3x4_6_svg__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_ads_3x4_6_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_ads_3x4_6_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_ads_3x4_7_svg__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_ads_3x4_7_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_ads_3x4_7_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_ads_3x4_8_svg__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_ads_3x4_8_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_ads_3x4_8_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_ads_3x4_9_svg__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_ads_3x4_9_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_ads_3x4_9_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ads_3x4_10_svg__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ads_3x4_10_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_ads_3x4_10_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ads_3x4_11_svg__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ads_3x4_11_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_ads_3x4_11_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ads_3x4_12_svg__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ads_3x4_12_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_ads_3x4_12_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ads_3x4_13_svg__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ads_3x4_13_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_ads_3x4_13_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ads_3x4_14_svg__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ads_3x4_14_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ads_3x4_14_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ads_3x4_15_svg__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ads_3x4_15_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_ads_3x4_15_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ads_3x4_16_svg__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ads_3x4_16_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_ads_3x4_16_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ads_4x3_1_svg__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ads_4x3_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_ads_4x3_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_ads_4x3_2_svg__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_ads_4x3_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_ads_4x3_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_ads_4x3_3_svg__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_ads_4x3_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_ads_4x3_3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_ads_4x3_4_svg__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_ads_4x3_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_ads_4x3_4_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_ads_4x3_5_svg__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_ads_4x3_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__images_ads_4x3_5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_ads_4x3_6_svg__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_ads_4x3_6_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__images_ads_4x3_6_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_ads_4x3_7_svg__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_ads_4x3_7_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__images_ads_4x3_7_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_ads_4x3_8_svg__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_ads_4x3_8_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__images_ads_4x3_8_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_ads_4x3_9_svg__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_ads_4x3_9_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__images_ads_4x3_9_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__images_ads_4x3_10_svg__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__images_ads_4x3_10_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__images_ads_4x3_10_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__images_ads_4x3_11_svg__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__images_ads_4x3_11_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__images_ads_4x3_11_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__images_ads_4x3_12_svg__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__images_ads_4x3_12_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__images_ads_4x3_12_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images_ads_4x3_13_svg__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images_ads_4x3_13_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__images_ads_4x3_13_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__images_ads_4x3_14_svg__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__images_ads_4x3_14_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__images_ads_4x3_14_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__images_ads_4x3_15_svg__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__images_ads_4x3_15_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__images_ads_4x3_15_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__images_ads_4x3_16_svg__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__images_ads_4x3_16_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__images_ads_4x3_16_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__images_ads_4x3_17_svg__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__images_ads_4x3_17_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__images_ads_4x3_17_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__images_explosion_png__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__images_explosion_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__images_explosion_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__images_explosion2_png__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__images_explosion2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__images_explosion2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__images_explosion3_png__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__images_explosion3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__images_explosion3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__images_client_logos_digital_ocean_png__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__images_client_logos_digital_ocean_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__images_client_logos_digital_ocean_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__images_client_logos_donors_choose_png__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__images_client_logos_donors_choose_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__images_client_logos_donors_choose_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__images_client_logos_jane_png__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__images_client_logos_jane_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__images_client_logos_jane_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__images_client_logos_maritzcx_png__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__images_client_logos_maritzcx_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__images_client_logos_maritzcx_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__images_client_logos_segment_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__images_client_logos_segment_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__images_client_logos_segment_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__images_client_logos_teespring_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__images_client_logos_teespring_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__images_client_logos_teespring_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__images_user_portraits_chris_png__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__images_user_portraits_chris_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__images_user_portraits_chris_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__images_user_portraits_dan_png__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__images_user_portraits_dan_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__images_user_portraits_dan_png__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "bot", function() { return __WEBPACK_IMPORTED_MODULE_0__images_bot_gif___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExplosionImg1", function() { return __WEBPACK_IMPORTED_MODULE_34__images_explosion_png___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExplosionImg2", function() { return __WEBPACK_IMPORTED_MODULE_35__images_explosion2_png___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExplosionImg3", function() { return __WEBPACK_IMPORTED_MODULE_36__images_explosion3_png___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x1", function() { return __WEBPACK_IMPORTED_MODULE_1__images_ads_3x4_1_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x2", function() { return __WEBPACK_IMPORTED_MODULE_2__images_ads_3x4_2_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x3", function() { return __WEBPACK_IMPORTED_MODULE_3__images_ads_3x4_3_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x4", function() { return __WEBPACK_IMPORTED_MODULE_4__images_ads_3x4_4_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x5", function() { return __WEBPACK_IMPORTED_MODULE_5__images_ads_3x4_5_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x6", function() { return __WEBPACK_IMPORTED_MODULE_6__images_ads_3x4_6_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x7", function() { return __WEBPACK_IMPORTED_MODULE_7__images_ads_3x4_7_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x8", function() { return __WEBPACK_IMPORTED_MODULE_8__images_ads_3x4_8_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x9", function() { return __WEBPACK_IMPORTED_MODULE_9__images_ads_3x4_9_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x10", function() { return __WEBPACK_IMPORTED_MODULE_10__images_ads_3x4_10_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x11", function() { return __WEBPACK_IMPORTED_MODULE_11__images_ads_3x4_11_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x12", function() { return __WEBPACK_IMPORTED_MODULE_12__images_ads_3x4_12_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x13", function() { return __WEBPACK_IMPORTED_MODULE_13__images_ads_3x4_13_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x14", function() { return __WEBPACK_IMPORTED_MODULE_14__images_ads_3x4_14_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x15", function() { return __WEBPACK_IMPORTED_MODULE_15__images_ads_3x4_15_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad3x4x16", function() { return __WEBPACK_IMPORTED_MODULE_16__images_ads_3x4_16_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x1", function() { return __WEBPACK_IMPORTED_MODULE_17__images_ads_4x3_1_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x2", function() { return __WEBPACK_IMPORTED_MODULE_18__images_ads_4x3_2_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x3", function() { return __WEBPACK_IMPORTED_MODULE_19__images_ads_4x3_3_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x4", function() { return __WEBPACK_IMPORTED_MODULE_20__images_ads_4x3_4_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x5", function() { return __WEBPACK_IMPORTED_MODULE_21__images_ads_4x3_5_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x6", function() { return __WEBPACK_IMPORTED_MODULE_22__images_ads_4x3_6_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x7", function() { return __WEBPACK_IMPORTED_MODULE_23__images_ads_4x3_7_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x8", function() { return __WEBPACK_IMPORTED_MODULE_24__images_ads_4x3_8_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x9", function() { return __WEBPACK_IMPORTED_MODULE_25__images_ads_4x3_9_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x10", function() { return __WEBPACK_IMPORTED_MODULE_26__images_ads_4x3_10_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x11", function() { return __WEBPACK_IMPORTED_MODULE_27__images_ads_4x3_11_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x12", function() { return __WEBPACK_IMPORTED_MODULE_28__images_ads_4x3_12_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x13", function() { return __WEBPACK_IMPORTED_MODULE_29__images_ads_4x3_13_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x14", function() { return __WEBPACK_IMPORTED_MODULE_30__images_ads_4x3_14_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x15", function() { return __WEBPACK_IMPORTED_MODULE_31__images_ads_4x3_15_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x16", function() { return __WEBPACK_IMPORTED_MODULE_32__images_ads_4x3_16_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Ad4x3x17", function() { return __WEBPACK_IMPORTED_MODULE_33__images_ads_4x3_17_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DigitalOcean", function() { return __WEBPACK_IMPORTED_MODULE_37__images_client_logos_digital_ocean_png___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DonorsChoose", function() { return __WEBPACK_IMPORTED_MODULE_38__images_client_logos_donors_choose_png___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Jane", function() { return __WEBPACK_IMPORTED_MODULE_39__images_client_logos_jane_png___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Maritzcx", function() { return __WEBPACK_IMPORTED_MODULE_40__images_client_logos_maritzcx_png___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Segment", function() { return __WEBPACK_IMPORTED_MODULE_41__images_client_logos_segment_png___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Teespring", function() { return __WEBPACK_IMPORTED_MODULE_42__images_client_logos_teespring_png___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Chris", function() { return __WEBPACK_IMPORTED_MODULE_43__images_user_portraits_chris_png___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Dan", function() { return __WEBPACK_IMPORTED_MODULE_44__images_user_portraits_dan_png___default.a; });
// site down
// ads 3x4
// ads 4x3
// explosions
// fs images
// logos
// portraits
// Exports - Keep this at end of the code, else compile will fail


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(78),
    getRawTag = __webpack_require__(191),
    objectToString = __webpack_require__(192);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Score__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import RageClickMeter from "./RageClickMeter";
var mapStateToProps=function mapStateToProps(state){var g=state.game;return{score:g.score,mute:g.mute,time:g.time};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{gameMusic:function gameMusic(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["f" /* gameMusic */])());},fadeMusic:function fadeMusic(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["e" /* fadeMusic */])());},toggleMute:function toggleMute(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["r" /* toggleMute */])());}};};var HudContainer=function(_Component){_inherits(HudContainer,_Component);function HudContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HudContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HudContainer.__proto__||Object.getPrototypeOf(HudContainer)).call.apply(_ref,[this].concat(args))),_this),_this.muteToggle=function(e){e.preventDefault();_this.props.toggleMute();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HudContainer,[{key:"render",value:function render(){var _this2=this;var _props=this.props,countdown=_props.countdown,hideScore=_props.hideScore;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"hud"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"topright"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mute",onClick:function onClick(){return _this2.props.toggleMute();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"mute",x:"0px",y:"0px",viewBox:"0 0 27.404 27.404",enableBackground:"new 0 0 27.404 27.404"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"13.702",cy:"13.702",r:"13.702"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4B5763",points:"11.836,6.517 9.384,9.901 4.407,11.127 4.407,16.025 9.384,17.251 11.836,20.636 12.727,20.636  12.727,6.517 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"noaudio",className:""+(this.props.mute?"show":"hide"),fill:"#D30505",points:"22.997,16.239 20.334,13.576 22.997,10.913 21.782,9.698 19.119,12.361 16.456,9.698  15.241,10.913 17.904,13.576 15.241,16.239 16.456,17.454 19.119,14.791 21.782,17.454 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"audioon",className:""+(this.props.mute?"hide":"show")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4B5763",d:"M16.207,19.209l-1.414-1.414C14.834,17.751,16,16.491,16,13.702c0-2.79-1.167-4.05-1.216-4.102l1.423-1.405 C16.28,8.268,18,10.03,18,13.702S16.28,19.136,16.207,19.209z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4B5763",d:"M19.753,22.111l-1.414-1.414c0.081-0.084,2.114-2.236,2.114-6.995s-2.033-6.911-2.12-7l1.419-1.409 c0.11,0.11,2.7,2.764,2.7,8.409C22.454,19.347,19.864,22.001,19.753,22.111z"})))),hideScore!==true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Score__["a" /* default */],{score:this.props.score})),countdown!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"time"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"skew"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:""+(countdown<=10&&countdown>0?'pulse':'')},""+(countdown>0?Math.floor(countdown):0)))));}}]);return HudContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Hud=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(HudContainer);/* harmony default export */ __webpack_exports__["a"] = (Hud);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = undefined;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var string = _propTypes2['default'].string,
    bool = _propTypes2['default'].bool,
    number = _propTypes2['default'].number,
    array = _propTypes2['default'].array,
    oneOfType = _propTypes2['default'].oneOfType,
    shape = _propTypes2['default'].shape,
    object = _propTypes2['default'].object,
    func = _propTypes2['default'].func;
var propTypes = exports.propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  light: oneOfType([bool, string]),
  wrapper: oneOfType([string, func, shape({ render: func.isRequired })]),
  config: shape({
    soundcloud: shape({
      options: object,
      preload: bool
    }),
    youtube: shape({
      playerVars: object,
      embedOptions: object,
      preload: bool
    }),
    facebook: shape({
      appId: string
    }),
    dailymotion: shape({
      params: object,
      preload: bool
    }),
    vimeo: shape({
      playerOptions: object,
      preload: bool
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceDASH: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string
    }),
    wistia: shape({
      options: object
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onProgress: func,
  onEnablePIP: func,
  onDisablePIP: func
};

var defaultProps = exports.defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: '640px',
  height: '360px',
  style: {},
  progressInterval: 1000,
  playsinline: false,
  pip: false,
  light: false,
  wrapper: 'div',
  config: {
    soundcloud: {
      options: {
        visual: true, // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      preload: false
    },
    facebook: {
      appId: '1309697205772819'
    },
    dailymotion: {
      params: {
        api: 1,
        'endscreen-enable': false
      },
      preload: false
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      },
      preload: false
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      hlsOptions: {},
      hlsVersion: '0.10.1',
      dashVersion: '2.9.2'
    },
    wistia: {
      options: {}
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {}
    }
  },
  onReady: function onReady() {},
  onStart: function onStart() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onBuffer: function onBuffer() {},
  onEnded: function onEnded() {},
  onError: function onError() {},
  onDuration: function onDuration() {},
  onSeek: function onSeek() {},
  onProgress: function onProgress() {},
  onEnablePIP: function onEnablePIP() {},
  onDisablePIP: function onDisablePIP() {}
};

var DEPRECATED_CONFIG_PROPS = exports.DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'fileConfig', 'wistiaConfig'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(102);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(13);

var _DOMUtils = __webpack_require__(20);

var _DOMStateStorage = __webpack_require__(54);

var _PathUtils = __webpack_require__(11);

var _ExecutionEnvironment = __webpack_require__(24);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(113);

var _PathUtils = __webpack_require__(11);

var _runTransitionHook = __webpack_require__(33);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(19);

var _LocationUtils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(10);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(33);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(116);

var _runTransitionHook = __webpack_require__(33);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(13);

var _PathUtils = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(12);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = Object(__WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (Object(__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["c" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routerShape; });
/* unused harmony export locationShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(152);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStartTime */
/* unused harmony export getDeltaTime */
/* unused harmony export lerp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mobileTest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return startFullStorySession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return stopFullStorySession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return maxSceneWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_js__ = __webpack_require__(73);
var getStartTime=function getStartTime(){return Date.now();};var getDeltaTime=function getDeltaTime(startTime){return Date.now()-startTime;};var lerp=function lerp(v0,v1,t){return(1-t)*v0+t*v1;};var mobileTest=function mobileTest(){var userAgent=navigator.userAgent||navigator.vendor||window.opera;// Windows Phone must come first because its UA also contains "Android"
// can later be reworked to detect which mobile OS
if(/windows phone/i.test(userAgent)){return true;}if(/android/i.test(userAgent)){return true;}// iOS detection from: http://stackoverflow.com/a/9039885/177710
if(/iPad|iPhone|iPod/.test(userAgent)&&!window.MSStream){return true;}return false;};var startFullStorySession=function startFullStorySession(){// start recording
window['_fs_debug']=false;window['_fs_host']='fullstory.com';window['_fs_org']='testdrive';window['_fs_namespace']='FS'+Math.random()*100000;window["_fs_replay_flags"]="forceSession,getEmbed,anonymize";(function(m,n,e,t,l,o,g,y){if(e in m){if(m.console&&m.console.log){m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');}return;}g=m[e]=function(a,b){g.q?g.q.push([a,b]):g._api(a,b);};g.q=[];o=n.createElement(t);o.async=1;o.src='https://'+window._fs_host+'/s/fs.js';y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);g.identify=function(i,v){g(l,{uid:i});if(v)g(l,v);};g.setUserVars=function(v){g(l,v);};y="rec";g.shutdown=function(i,v){g(y,!1);};g.restart=function(i,v){g(y,!0);};g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v);};g.clearUserCookie=function(){};})(window,document,window['_fs_namespace'],'script','user');};var stopFullStorySession=function stopFullStorySession(){return __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions_actionCreators_js__["m" /* setEmbedToken */])());};var maxSceneWidth=function maxSceneWidth(){var max=document.getElementById("root").offsetHeight*1.333334;return{"maxWidth":max+"px"};};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var arraySample = __webpack_require__(76),
    baseSample = __webpack_require__(183),
    isArray = __webpack_require__(44);

/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */
function sample(collection) {
  var func = isArray(collection) ? arraySample : baseSample;
  return func(collection);
}

module.exports = sample;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__avatars_Kenny__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars_Brenda__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__avatars_Boss__ = __webpack_require__(229);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Avatar=function(_Component){_inherits(Avatar,_Component);function Avatar(){_classCallCheck(this,Avatar);return _possibleConstructorReturn(this,(Avatar.__proto__||Object.getPrototypeOf(Avatar)).apply(this,arguments));}_createClass(Avatar,[{key:'componentDidMount',// constructor(props) {
// 	super( props );
// 	this.state = {
// 		twitterAccount: "",
// 		ranking: 0
// 	};
// }	
value:function componentDidMount(){// console.log(this.props)
}},{key:'getAvatar',value:function getAvatar(){if(this.props.round===1)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__avatars_Kenny__["a" /* default */],{look:this.props.look,speaking:this.props.speaking});if(this.props.round===2)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__avatars_Brenda__["a" /* default */],{look:this.props.look,speaking:this.props.speaking});if(this.props.round===3)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__avatars_Boss__["a" /* default */],{look:this.props.look,speaking:this.props.speaking});// {this.props.round} {this.props.look}
}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'avatar'},this.getAvatar());}}]);return Avatar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (Avatar);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YouTube = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(6);

var _singlePlayer = __webpack_require__(7);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_URL = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=/;
var MATCH_PLAYLIST = /list=([a-zA-Z0-9_-]+)/;

function parsePlaylist(url) {
  if (MATCH_PLAYLIST.test(url)) {
    var _url$match = url.match(MATCH_PLAYLIST),
        _url$match2 = _slicedToArray(_url$match, 2),
        playlistId = _url$match2[1];

    return {
      listType: 'playlist',
      list: playlistId
    };
  }
  return {};
}

var YouTube = exports.YouTube = function (_Component) {
  _inherits(YouTube, _Component);

  function YouTube() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onStateChange = function (_ref2) {
      var data = _ref2.data;
      var _this$props = _this.props,
          onPlay = _this$props.onPlay,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer,
          onEnded = _this$props.onEnded,
          onReady = _this$props.onReady,
          loop = _this$props.loop;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;

      if (data === PLAYING) onPlay();
      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();
      if (data === ENDED) {
        var isPlaylist = !!_this.callPlayer('getPlaylist');
        if (loop && !isPlaylist) {
          _this.play(); // Only loop manually if not playing a playlist
        }
        onEnded();
      }
      if (data === CUED) onReady();
    }, _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unMute');
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(YouTube, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          muted = _props.muted,
          playsinline = _props.playsinline,
          controls = _props.controls,
          loop = _props.loop,
          config = _props.config,
          _onError = _props.onError;
      var _config$youtube = config.youtube,
          playerVars = _config$youtube.playerVars,
          embedOptions = _config$youtube.embedOptions;

      var id = url && url.match(MATCH_URL)[1];
      if (isReady) {
        if (MATCH_PLAYLIST.test(url)) {
          this.player.loadPlaylist(parsePlaylist(url));
          return;
        }
        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
        });
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
        return YT.loaded;
      }).then(function (YT) {
        if (!_this2.container) return;
        _this2.player = new YT.Player(_this2.container, _extends({
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _extends({
            autoplay: playing ? 1 : 0,
            mute: muted ? 1 : 0,
            controls: controls ? 1 : 0,
            start: (0, _utils.parseStartTime)(url),
            end: (0, _utils.parseEndTime)(url),
            origin: window.location.origin,
            playsinline: playsinline
          }, parsePlaylist(url), playerVars),
          events: {
            onReady: _this2.props.onReady,
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          }
        }, embedOptions));
        if (loop) {
          _this2.player.setLoop(true); // Enable playlist looping
        }
      }, _onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('playVideo');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pauseVideo');
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (!document.body.contains(this.callPlayer('getIframe'))) return;
      this.callPlayer('stopVideo');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(amount) {
      this.callPlayer('seekTo', amount);
      if (!this.props.playing) {
        this.pause();
      }
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: 'setLoop',
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%'
      }, this.props.style);
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('div', { ref: this.ref })
      );
    }
  }]);

  return YouTube;
}(_react.Component);

YouTube.displayName = 'YouTube';

YouTube.canPlay = function (url) {
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(YouTube);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props2 = __webpack_require__(28);

var _utils = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var Player = function (_Component) {
  _inherits(Player, _Component);

  function Player() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Player);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Player.__proto__ || Object.getPrototypeOf(Player)).call.apply(_ref, [this].concat(args))), _this), _this.mounted = false, _this.isReady = false, _this.isPlaying = false, _this.isLoading = true, _this.loadOnReady = null, _this.startOnPlay = true, _this.seekOnPlay = null, _this.onDurationCalled = false, _this.getInternalPlayer = function (key) {
      if (!_this.player) return null;
      return _this.player[key];
    }, _this.progress = function () {
      if (_this.props.url && _this.player && _this.isReady) {
        var playedSeconds = _this.getCurrentTime() || 0;
        var loadedSeconds = _this.getSecondsLoaded();
        var duration = _this.getDuration();
        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: playedSeconds / duration
          };
          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          }
          // Only call onProgress if values have changed
          if (progress.played !== _this.prevPlayed || progress.loaded !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }
          _this.prevPlayed = progress.played;
          _this.prevLoaded = progress.loaded;
        }
      }
      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
    }, _this.onReady = function () {
      if (!_this.mounted) return;
      _this.isReady = true;
      _this.isLoading = false;
      var _this$props = _this.props,
          onReady = _this$props.onReady,
          playing = _this$props.playing,
          volume = _this$props.volume,
          muted = _this$props.muted;

      onReady();
      if (!muted && volume !== null) {
        _this.player.setVolume(volume);
      }
      if (_this.loadOnReady) {
        _this.player.load(_this.loadOnReady, true);
        _this.loadOnReady = null;
      } else if (playing) {
        _this.player.play();
      }
      _this.onDurationCheck();
    }, _this.onPlay = function () {
      _this.isPlaying = true;
      _this.isLoading = false;
      var _this$props2 = _this.props,
          onStart = _this$props2.onStart,
          onPlay = _this$props2.onPlay,
          playbackRate = _this$props2.playbackRate;

      if (_this.startOnPlay) {
        if (_this.player.setPlaybackRate) {
          _this.player.setPlaybackRate(playbackRate);
        }
        onStart();
        _this.startOnPlay = false;
      }
      onPlay();
      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);
        _this.seekOnPlay = null;
      }
      _this.onDurationCheck();
    }, _this.onPause = function (e) {
      _this.isPlaying = false;
      if (!_this.isLoading) {
        _this.props.onPause(e);
      }
    }, _this.onEnded = function () {
      var _this$props3 = _this.props,
          activePlayer = _this$props3.activePlayer,
          loop = _this$props3.loop,
          onEnded = _this$props3.onEnded;

      if (activePlayer.loopOnEnded && loop) {
        _this.seekTo(0);
      }
      if (!loop) {
        _this.isPlaying = false;
        onEnded();
      }
    }, _this.onError = function (e) {
      _this.isLoading = false;
      _this.props.onError(e);
    }, _this.onDurationCheck = function () {
      clearTimeout(_this.durationCheckTimeout);
      var duration = _this.getDuration();
      if (duration) {
        if (!_this.onDurationCalled) {
          _this.props.onDuration(duration);
          _this.onDurationCalled = true;
        }
      } else {
        _this.durationCheckTimeout = setTimeout(_this.onDurationCheck, 100);
      }
    }, _this.onLoaded = function () {
      // Sometimes we know loading has stopped but onReady/onPlay are never called
      // so this provides a way for players to avoid getting stuck
      _this.isLoading = false;
    }, _this.ref = function (player) {
      if (player) {
        _this.player = player;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  } // Track playing state internally to prevent bugs
  // Use isLoading to prevent onPause when switching URL


  _createClass(Player, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.player.load(this.props.url);
      this.progress();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
      clearTimeout(this.durationCheckTimeout);
      if (this.isReady) {
        this.player.stop();
      }
      if (this.player.disablePIP) {
        this.player.disablePIP();
      }
      this.mounted = false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      // Invoke player methods based on incoming props
      var _props = this.props,
          url = _props.url,
          playing = _props.playing,
          volume = _props.volume,
          muted = _props.muted,
          playbackRate = _props.playbackRate,
          pip = _props.pip,
          loop = _props.loop;

      if (!(0, _utils.isEqual)(url, nextProps.url)) {
        if (this.isLoading) {
          console.warn('ReactPlayer: the attempt to load ' + nextProps.url + ' is being deferred until the player has loaded');
          this.loadOnReady = nextProps.url;
          return;
        }
        this.isLoading = true;
        this.startOnPlay = true;
        this.onDurationCalled = false;
        this.player.load(nextProps.url, this.isReady);
      }
      if (!playing && nextProps.playing && !this.isPlaying) {
        this.player.play();
      }
      if (playing && !nextProps.playing && this.isPlaying) {
        this.player.pause();
      }
      if (!pip && nextProps.pip && this.player.enablePIP) {
        this.player.enablePIP();
      } else if (pip && !nextProps.pip && this.player.disablePIP) {
        this.player.disablePIP();
      }
      if (volume !== nextProps.volume && nextProps.volume !== null) {
        this.player.setVolume(nextProps.volume);
      }
      if (muted !== nextProps.muted) {
        if (nextProps.muted) {
          this.player.mute();
        } else {
          this.player.unmute();
          if (nextProps.volume !== null) {
            // Set volume next tick to fix a bug with DailyMotion
            setTimeout(function () {
              return _this2.player.setVolume(nextProps.volume);
            });
          }
        }
      }
      if (playbackRate !== nextProps.playbackRate && this.player.setPlaybackRate) {
        this.player.setPlaybackRate(nextProps.playbackRate);
      }
      if (loop !== nextProps.loop && this.player.setLoop) {
        this.player.setLoop(nextProps.loop);
      }
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.getDuration();
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      if (!this.isReady) return null;
      return this.player.getCurrentTime();
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      if (!this.isReady) return null;
      return this.player.getSecondsLoaded();
    }
  }, {
    key: 'seekTo',
    value: function seekTo(amount, type) {
      var _this3 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady && amount !== 0) {
        this.seekOnPlay = amount;
        setTimeout(function () {
          _this3.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
        return;
      }
      var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';
      if (isFraction) {
        // Convert fraction to seconds based on duration
        var duration = this.player.getDuration();
        if (!duration) {
          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
          return;
        }
        this.player.seekTo(duration * amount);
        return;
      }
      this.player.seekTo(amount);
    }
  }, {
    key: 'render',
    value: function render() {
      var Player = this.props.activePlayer;
      if (!Player) {
        return null;
      }
      return _react2['default'].createElement(Player, _extends({}, this.props, {
        ref: this.ref,
        onReady: this.onReady,
        onPlay: this.onPlay,
        onPause: this.onPause,
        onEnded: this.onEnded,
        onLoaded: this.onLoaded,
        onError: this.onError
      }));
    }
  }]);

  return Player;
}(_react.Component);

Player.displayName = 'Player';
Player.propTypes = _props2.propTypes;
Player.defaultProps = _props2.defaultProps;
exports['default'] = Player;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SoundCloud = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(6);

var _singlePlayer = __webpack_require__(7);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://w.soundcloud.com/player/api.js';
var SDK_GLOBAL = 'SC';
var MATCH_URL = /(soundcloud\.com|snd\.sc)\/.+$/;

var SoundCloud = exports.SoundCloud = function (_Component) {
  _inherits(SoundCloud, _Component);

  function SoundCloud() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.fractionLoaded = null, _this.mute = function () {
      _this.setVolume(0);
    }, _this.unmute = function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SoundCloud, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
        if (!_this2.iframe) return;
        var _SC$Widget$Events = SC.Widget.Events,
            PLAY = _SC$Widget$Events.PLAY,
            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
            PAUSE = _SC$Widget$Events.PAUSE,
            FINISH = _SC$Widget$Events.FINISH,
            ERROR = _SC$Widget$Events.ERROR;

        if (!isReady) {
          _this2.player = SC.Widget(_this2.iframe);
          _this2.player.bind(PLAY, _this2.props.onPlay);
          _this2.player.bind(PAUSE, _this2.props.onPause);
          _this2.player.bind(PLAY_PROGRESS, function (e) {
            _this2.currentTime = e.currentPosition / 1000;
            _this2.fractionLoaded = e.loadedProgress;
          });
          _this2.player.bind(FINISH, function () {
            return _this2.props.onEnded();
          });
          _this2.player.bind(ERROR, function (e) {
            return _this2.props.onError(e);
          });
        }
        _this2.player.load(url, _extends({}, _this2.props.config.soundcloud.options, {
          callback: function callback() {
            _this2.player.getDuration(function (duration) {
              _this2.duration = duration / 1000;
              _this2.props.onReady();
            });
          }
        }));
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seekTo', seconds * 1000);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.fractionLoaded * this.duration;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%'
      }, this.props.style);
      return _react2['default'].createElement('iframe', {
        ref: this.ref,
        src: 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(this.props.url),
        style: style,
        frameBorder: 0
      });
    }
  }]);

  return SoundCloud;
}(_react.Component);

SoundCloud.displayName = 'SoundCloud';

SoundCloud.canPlay = function (url) {
  return MATCH_URL.test(url);
};

SoundCloud.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(SoundCloud);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vimeo = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(6);

var _singlePlayer = __webpack_require__(7);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://player.vimeo.com/api/player.js';
var SDK_GLOBAL = 'Vimeo';
var MATCH_URL = /vimeo\.com\/.+/;
var MATCH_FILE_URL = /vimeo\.com\/external\/.+\.mp4/;

var Vimeo = exports.Vimeo = function (_Component) {
  _inherits(Vimeo, _Component);

  function Vimeo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
      _this.setVolume(0);
    }, _this.unmute = function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Vimeo, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      this.duration = null;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
        if (!_this2.container) return;
        _this2.player = new Vimeo.Player(_this2.container, _extends({
          url: url,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          loop: _this2.props.loop,
          playsinline: _this2.props.playsinline
        }, _this2.props.config.vimeo.playerOptions));
        _this2.player.ready().then(function () {
          var iframe = _this2.container.querySelector('iframe');
          iframe.style.width = '100%';
          iframe.style.height = '100%';
        })['catch'](_this2.props.onError);
        _this2.player.on('loaded', function () {
          _this2.props.onReady();
          _this2.refreshDuration();
        });
        _this2.player.on('play', function () {
          _this2.props.onPlay();
          _this2.refreshDuration();
        });
        _this2.player.on('pause', _this2.props.onPause);
        _this2.player.on('seeked', function (e) {
          return _this2.props.onSeek(e.seconds);
        });
        _this2.player.on('ended', _this2.props.onEnded);
        _this2.player.on('error', _this2.props.onError);
        _this2.player.on('timeupdate', function (_ref2) {
          var seconds = _ref2.seconds;

          _this2.currentTime = seconds;
        });
        _this2.player.on('progress', function (_ref3) {
          var seconds = _ref3.seconds;

          _this2.secondsLoaded = seconds;
        });
      }, this.props.onError);
    }
  }, {
    key: 'refreshDuration',
    value: function refreshDuration() {
      var _this3 = this;

      this.player.getDuration().then(function (duration) {
        _this3.duration = duration;
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.callPlayer('unload');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'setLoop',
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: 'black'
      }, this.props.style);
      return _react2['default'].createElement('div', {
        key: this.props.url,
        ref: this.ref,
        style: style
      });
    }
  }]);

  return Vimeo;
}(_react.Component);

Vimeo.displayName = 'Vimeo';

Vimeo.canPlay = function (url) {
  if (MATCH_FILE_URL.test(url)) {
    return false;
  }
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(Vimeo);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DailyMotion = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(6);

var _singlePlayer = __webpack_require__(7);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://api.dmcdn.net/all.js';
var SDK_GLOBAL = 'DM';
var SDK_GLOBAL_READY = 'dmAsyncInit';
var MATCH_URL = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;

var DailyMotion = exports.DailyMotion = function (_Component) {
  _inherits(DailyMotion, _Component);

  function DailyMotion() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DailyMotion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DailyMotion.__proto__ || Object.getPrototypeOf(DailyMotion)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onDurationChange = function () {
      var duration = _this.getDuration();
      _this.props.onDuration(duration);
    }, _this.mute = function () {
      _this.callPlayer('setMuted', true);
    }, _this.unmute = function () {
      _this.callPlayer('setMuted', false);
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DailyMotion, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props = this.props,
          controls = _props.controls,
          config = _props.config,
          onError = _props.onError,
          playing = _props.playing;

      var _url$match = url.match(MATCH_URL),
          _url$match2 = _slicedToArray(_url$match, 2),
          id = _url$match2[1];

      if (this.player) {
        this.player.load(id, {
          start: (0, _utils.parseStartTime)(url),
          autoplay: playing
        });
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
        return DM.player;
      }).then(function (DM) {
        if (!_this2.container) return;
        var Player = DM.player;
        _this2.player = new Player(_this2.container, {
          width: '100%',
          height: '100%',
          video: id,
          params: _extends({
            controls: controls,
            autoplay: _this2.props.playing,
            mute: _this2.props.muted,
            start: (0, _utils.parseStartTime)(url),
            origin: window.location.origin
          }, config.dailymotion.params),
          events: {
            apiready: _this2.props.onReady,
            seeked: function seeked() {
              return _this2.props.onSeek(_this2.player.currentTime);
            },
            video_end: _this2.props.onEnded,
            durationchange: _this2.onDurationChange,
            pause: _this2.props.onPause,
            playing: _this2.props.onPlay,
            waiting: _this2.props.onBuffer,
            error: function error(event) {
              return onError(event);
            }
          }
        });
      }, onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.player.duration || null;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.player.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.player.bufferedTime;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%',
        backgroundColor: 'black'
      }, this.props.style);
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('div', { ref: this.ref })
      );
    }
  }]);

  return DailyMotion;
}(_react.Component);

DailyMotion.displayName = 'DailyMotion';

DailyMotion.canPlay = function (url) {
  return MATCH_URL.test(url);
};

DailyMotion.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(DailyMotion);

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(97);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(4);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(24);

var _BrowserProtocol = __webpack_require__(31);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(112);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(20);

var _createHistory = __webpack_require__(32);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(10);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(10);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(4);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(24);

var _DOMUtils = __webpack_require__(20);

var _HashProtocol = __webpack_require__(114);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(32);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(10);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(4);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(13);

var _PathUtils = __webpack_require__(11);

var _createHistory = __webpack_require__(32);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(127);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return Object(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      Object(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["a" /* routerShape */]
  },

  propTypes: {
    to: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(21);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = Object(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(63);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = Object(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(65);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(153);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(146);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(72);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(40);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middleware_soundsMiddleware__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__soundsData__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_devtools_extension__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_devtools_extension__);
// Pre-load our middleware with our sounds data.
var loadedSoundsMiddleware=Object(__WEBPACK_IMPORTED_MODULE_2__middleware_soundsMiddleware__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__soundsData__["a" /* default */]);var isProd=function isProd(){return "production"==="production";};var applyMW=function applyMW(){return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a,loadedSoundsMiddleware);};var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */],isProd()?applyMW():Object(__WEBPACK_IMPORTED_MODULE_5_redux_devtools_extension__["composeWithDevTools"])(applyMW()));

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 *  howler.js v2.0.12
 *  howlerjs.com
 *
 *  (c) 2013-2018, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function() {

  'use strict';

  /** Global Methods **/
  /***************************************************************************/

  /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */
  var HowlerGlobal = function() {
    this.init();
  };
  HowlerGlobal.prototype = {
    /**
     * Initialize the global Howler object.
     * @return {Howler}
     */
    init: function() {
      var self = this || Howler;

      // Create a global ID counter.
      self._counter = 1000;

      // Internal properties.
      self._codecs = {};
      self._howls = [];
      self._muted = false;
      self._volume = 1;
      self._canPlayEvent = 'canplaythrough';
      self._navigator = (typeof window !== 'undefined' && window.navigator) ? window.navigator : null;

      // Public properties.
      self.masterGain = null;
      self.noAudio = false;
      self.usingWebAudio = true;
      self.autoSuspend = true;
      self.ctx = null;

      // Set to false to disable the auto iOS enabler.
      self.mobileAutoEnable = true;

      // Setup the various state values for global tracking.
      self._setup();

      return self;
    },

    /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */
    volume: function(vol) {
      var self = this || Howler;
      vol = parseFloat(vol);

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }

      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        self._volume = vol;

        // Don't update any of the nodes if we are muted.
        if (self._muted) {
          return self;
        }

        // When using Web Audio, we just need to adjust the master gain.
        if (self.usingWebAudio) {
          self.masterGain.gain.setValueAtTime(vol, Howler.ctx.currentTime);
        }

        // Loop through and change volume for all HTML5 audio nodes.
        for (var i=0; i<self._howls.length; i++) {
          if (!self._howls[i]._webAudio) {
            // Get all of the sounds in this Howl group.
            var ids = self._howls[i]._getSoundIds();

            // Loop through all sounds and change the volumes.
            for (var j=0; j<ids.length; j++) {
              var sound = self._howls[i]._soundById(ids[j]);

              if (sound && sound._node) {
                sound._node.volume = sound._volume * vol;
              }
            }
          }
        }

        return self;
      }

      return self._volume;
    },

    /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */
    mute: function(muted) {
      var self = this || Howler;

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }

      self._muted = muted;

      // With Web Audio, we just need to mute the master gain.
      if (self.usingWebAudio) {
        self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler.ctx.currentTime);
      }

      // Loop through and mute all HTML5 Audio nodes.
      for (var i=0; i<self._howls.length; i++) {
        if (!self._howls[i]._webAudio) {
          // Get all of the sounds in this Howl group.
          var ids = self._howls[i]._getSoundIds();

          // Loop through all sounds and mark the audio node as muted.
          for (var j=0; j<ids.length; j++) {
            var sound = self._howls[i]._soundById(ids[j]);

            if (sound && sound._node) {
              sound._node.muted = (muted) ? true : sound._muted;
            }
          }
        }
      }

      return self;
    },

    /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */
    unload: function() {
      var self = this || Howler;

      for (var i=self._howls.length-1; i>=0; i--) {
        self._howls[i].unload();
      }

      // Create a new AudioContext to make sure it is fully reset.
      if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
        self.ctx.close();
        self.ctx = null;
        setupAudioContext();
      }

      return self;
    },

    /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */
    codecs: function(ext) {
      return (this || Howler)._codecs[ext.replace(/^x-/, '')];
    },

    /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */
    _setup: function() {
      var self = this || Howler;

      // Keeps track of the suspend/resume state of the AudioContext.
      self.state = self.ctx ? self.ctx.state || 'running' : 'running';

      // Automatically begin the 30-second suspend process
      self._autoSuspend();

      // Check if audio is available.
      if (!self.usingWebAudio) {
        // No audio is available on this system if noAudio is set to true.
        if (typeof Audio !== 'undefined') {
          try {
            var test = new Audio();

            // Check if the canplaythrough event is available.
            if (typeof test.oncanplaythrough === 'undefined') {
              self._canPlayEvent = 'canplay';
            }
          } catch(e) {
            self.noAudio = true;
          }
        } else {
          self.noAudio = true;
        }
      }

      // Test to make sure audio isn't disabled in Internet Explorer.
      try {
        var test = new Audio();
        if (test.muted) {
          self.noAudio = true;
        }
      } catch (e) {}

      // Check for supported codecs.
      if (!self.noAudio) {
        self._setupCodecs();
      }

      return self;
    },

    /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */
    _setupCodecs: function() {
      var self = this || Howler;
      var audioTest = null;

      // Must wrap in a try/catch because IE11 in server mode throws an error.
      try {
        audioTest = (typeof Audio !== 'undefined') ? new Audio() : null;
      } catch (err) {
        return self;
      }

      if (!audioTest || typeof audioTest.canPlayType !== 'function') {
        return self;
      }

      var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');

      // Opera version <33 has mixed MP3 support, so we need to check for and block it.
      var checkOpera = self._navigator && self._navigator.userAgent.match(/OPR\/([0-6].)/g);
      var isOldOpera = (checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33);

      self._codecs = {
        mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
        mpeg: !!mpegTest,
        opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
        ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        wav: !!audioTest.canPlayType('audio/wav; codecs="1"').replace(/^no$/, ''),
        aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
        caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
        m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        weba: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
        webm: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
        dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
        flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
      };

      return self;
    },

    /**
     * Mobile browsers will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */
    _enableMobileAudio: function() {
      var self = this || Howler;

      // Only run this on mobile devices if audio isn't already eanbled.
      var isMobile = /iPhone|iPad|iPod|Android|BlackBerry|BB10|Silk|Mobi/i.test(self._navigator && self._navigator.userAgent);
      var isTouch = !!(('ontouchend' in window) || (self._navigator && self._navigator.maxTouchPoints > 0) || (self._navigator && self._navigator.msMaxTouchPoints > 0));
      if (self._mobileEnabled || !self.ctx || (!isMobile && !isTouch)) {
        return;
      }

      self._mobileEnabled = false;

      // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
      // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
      // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
      if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
        self._mobileUnloaded = true;
        self.unload();
      }

      // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
      // http://stackoverflow.com/questions/24119684
      self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);

      // Call this method on touch start to create and play a buffer,
      // then check if the audio actually played to determine if
      // audio has now been unlocked on iOS, Android, etc.
      var unlock = function() {
        // Fix Android can not play in suspend state.
        Howler._autoResume();

        // Create an empty buffer.
        var source = self.ctx.createBufferSource();
        source.buffer = self._scratchBuffer;
        source.connect(self.ctx.destination);

        // Play the empty buffer.
        if (typeof source.start === 'undefined') {
          source.noteOn(0);
        } else {
          source.start(0);
        }

        // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
        if (typeof self.ctx.resume === 'function') {
          self.ctx.resume();
        }

        // Setup a timeout to check that we are unlocked on the next event loop.
        source.onended = function() {
          source.disconnect(0);

          // Update the unlocked state and prevent this check from happening again.
          self._mobileEnabled = true;
          self.mobileAutoEnable = false;

          // Remove the touch start listener.
          document.removeEventListener('touchstart', unlock, true);
          document.removeEventListener('touchend', unlock, true);
        };
      };

      // Setup a touch start listener to attempt an unlock in.
      document.addEventListener('touchstart', unlock, true);
      document.addEventListener('touchend', unlock, true);

      return self;
    },

    /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */
    _autoSuspend: function() {
      var self = this;

      if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      // Check if any sounds are playing.
      for (var i=0; i<self._howls.length; i++) {
        if (self._howls[i]._webAudio) {
          for (var j=0; j<self._howls[i]._sounds.length; j++) {
            if (!self._howls[i]._sounds[j]._paused) {
              return self;
            }
          }
        }
      }

      if (self._suspendTimer) {
        clearTimeout(self._suspendTimer);
      }

      // If no sound has played after 30 seconds, suspend the context.
      self._suspendTimer = setTimeout(function() {
        if (!self.autoSuspend) {
          return;
        }

        self._suspendTimer = null;
        self.state = 'suspending';
        self.ctx.suspend().then(function() {
          self.state = 'suspended';

          if (self._resumeAfterSuspend) {
            delete self._resumeAfterSuspend;
            self._autoResume();
          }
        });
      }, 30000);

      return self;
    },

    /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */
    _autoResume: function() {
      var self = this;

      if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      if (self.state === 'running' && self._suspendTimer) {
        clearTimeout(self._suspendTimer);
        self._suspendTimer = null;
      } else if (self.state === 'suspended') {
        self.ctx.resume().then(function() {
          self.state = 'running';

          // Emit to all Howls that the audio has resumed.
          for (var i=0; i<self._howls.length; i++) {
            self._howls[i]._emit('resume');
          }
        });

        if (self._suspendTimer) {
          clearTimeout(self._suspendTimer);
          self._suspendTimer = null;
        }
      } else if (self.state === 'suspending') {
        self._resumeAfterSuspend = true;
      }

      return self;
    }
  };

  // Setup the global audio controller.
  var Howler = new HowlerGlobal();

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */
  var Howl = function(o) {
    var self = this;

    // Throw an error if no source is provided.
    if (!o.src || o.src.length === 0) {
      console.error('An array of source files must be passed with any new Howl.');
      return;
    }

    self.init(o);
  };
  Howl.prototype = {
    /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */
    init: function(o) {
      var self = this;

      // If we don't have an AudioContext created yet, run the setup.
      if (!Howler.ctx) {
        setupAudioContext();
      }

      // Setup user-defined default properties.
      self._autoplay = o.autoplay || false;
      self._format = (typeof o.format !== 'string') ? o.format : [o.format];
      self._html5 = o.html5 || false;
      self._muted = o.mute || false;
      self._loop = o.loop || false;
      self._pool = o.pool || 5;
      self._preload = (typeof o.preload === 'boolean') ? o.preload : true;
      self._rate = o.rate || 1;
      self._sprite = o.sprite || {};
      self._src = (typeof o.src !== 'string') ? o.src : [o.src];
      self._volume = o.volume !== undefined ? o.volume : 1;
      self._xhrWithCredentials = o.xhrWithCredentials || false;

      // Setup all other default properties.
      self._duration = 0;
      self._state = 'unloaded';
      self._sounds = [];
      self._endTimers = {};
      self._queue = [];
      self._playLock = false;

      // Setup event listeners.
      self._onend = o.onend ? [{fn: o.onend}] : [];
      self._onfade = o.onfade ? [{fn: o.onfade}] : [];
      self._onload = o.onload ? [{fn: o.onload}] : [];
      self._onloaderror = o.onloaderror ? [{fn: o.onloaderror}] : [];
      self._onplayerror = o.onplayerror ? [{fn: o.onplayerror}] : [];
      self._onpause = o.onpause ? [{fn: o.onpause}] : [];
      self._onplay = o.onplay ? [{fn: o.onplay}] : [];
      self._onstop = o.onstop ? [{fn: o.onstop}] : [];
      self._onmute = o.onmute ? [{fn: o.onmute}] : [];
      self._onvolume = o.onvolume ? [{fn: o.onvolume}] : [];
      self._onrate = o.onrate ? [{fn: o.onrate}] : [];
      self._onseek = o.onseek ? [{fn: o.onseek}] : [];
      self._onresume = [];

      // Web Audio or HTML5 Audio?
      self._webAudio = Howler.usingWebAudio && !self._html5;

      // Automatically try to enable audio on iOS.
      if (typeof Howler.ctx !== 'undefined' && Howler.ctx && Howler.mobileAutoEnable) {
        Howler._enableMobileAudio();
      }

      // Keep track of this Howl group in the global controller.
      Howler._howls.push(self);

      // If they selected autoplay, add a play event to the load queue.
      if (self._autoplay) {
        self._queue.push({
          event: 'play',
          action: function() {
            self.play();
          }
        });
      }

      // Load the source file unless otherwise specified.
      if (self._preload) {
        self.load();
      }

      return self;
    },

    /**
     * Load the audio file.
     * @return {Howler}
     */
    load: function() {
      var self = this;
      var url = null;

      // If no audio is available, quit immediately.
      if (Howler.noAudio) {
        self._emit('loaderror', null, 'No audio support.');
        return;
      }

      // Make sure our source is in an array.
      if (typeof self._src === 'string') {
        self._src = [self._src];
      }

      // Loop through the sources and pick the first one that is compatible.
      for (var i=0; i<self._src.length; i++) {
        var ext, str;

        if (self._format && self._format[i]) {
          // If an extension was specified, use that instead.
          ext = self._format[i];
        } else {
          // Make sure the source is a string.
          str = self._src[i];
          if (typeof str !== 'string') {
            self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
            continue;
          }

          // Extract the file extension from the URL or base64 data URI.
          ext = /^data:audio\/([^;,]+);/i.exec(str);
          if (!ext) {
            ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
          }

          if (ext) {
            ext = ext[1].toLowerCase();
          }
        }

        // Log a warning if no extension was found.
        if (!ext) {
          console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
        }

        // Check if this extension is available.
        if (ext && Howler.codecs(ext)) {
          url = self._src[i];
          break;
        }
      }

      if (!url) {
        self._emit('loaderror', null, 'No codec support for selected audio sources.');
        return;
      }

      self._src = url;
      self._state = 'loading';

      // If the hosting page is HTTPS and the source isn't,
      // drop down to HTML5 Audio to avoid Mixed Content errors.
      if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
        self._html5 = true;
        self._webAudio = false;
      }

      // Create a new sound object and add it to the pool.
      new Sound(self);

      // Load and decode the audio data for playback.
      if (self._webAudio) {
        loadBuffer(self);
      }

      return self;
    },

    /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */
    play: function(sprite, internal) {
      var self = this;
      var id = null;

      // Determine if a sprite, sound id or nothing was passed
      if (typeof sprite === 'number') {
        id = sprite;
        sprite = null;
      } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) {
        // If the passed sprite doesn't exist, do nothing.
        return null;
      } else if (typeof sprite === 'undefined') {
        // Use the default sound sprite (plays the full audio length).
        sprite = '__default';

        // Check if there is a single paused sound that isn't ended.
        // If there is, play that sound. If not, continue as usual.
        var num = 0;
        for (var i=0; i<self._sounds.length; i++) {
          if (self._sounds[i]._paused && !self._sounds[i]._ended) {
            num++;
            id = self._sounds[i]._id;
          }
        }

        if (num === 1) {
          sprite = null;
        } else {
          id = null;
        }
      }

      // Get the selected node, or get one from the pool.
      var sound = id ? self._soundById(id) : self._inactiveSound();

      // If the sound doesn't exist, do nothing.
      if (!sound) {
        return null;
      }

      // Select the sprite definition.
      if (id && !sprite) {
        sprite = sound._sprite || '__default';
      }

      // If the sound hasn't loaded, we must wait to get the audio's duration.
      // We also need to wait to make sure we don't run into race conditions with
      // the order of function calls.
      if (self._state !== 'loaded') {
        // Set the sprite value on this sound.
        sound._sprite = sprite;

        // Makr this sounded as not ended in case another sound is played before this one loads.
        sound._ended = false;

        // Add the sound to the queue to be played on load.
        var soundId = sound._id;
        self._queue.push({
          event: 'play',
          action: function() {
            self.play(soundId);
          }
        });

        return soundId;
      }

      // Don't play the sound if an id was passed and it is already playing.
      if (id && !sound._paused) {
        // Trigger the play event, in order to keep iterating through queue.
        if (!internal) {
          self._loadQueue('play');
        }

        return sound._id;
      }

      // Make sure the AudioContext isn't suspended, and resume it if it is.
      if (self._webAudio) {
        Howler._autoResume();
      }

      // Determine how long to play for and where to start playing.
      var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
      var duration = Math.max(0, ((self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000) - seek);
      var timeout = (duration * 1000) / Math.abs(sound._rate);

      // Update the parameters of the sound
      sound._paused = false;
      sound._ended = false;
      sound._sprite = sprite;
      sound._seek = seek;
      sound._start = self._sprite[sprite][0] / 1000;
      sound._stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
      sound._loop = !!(sound._loop || self._sprite[sprite][2]);

      // Begin the actual playback.
      var node = sound._node;
      if (self._webAudio) {
        // Fire this when the sound is ready to play to begin Web Audio playback.
        var playWebAudio = function() {
          self._refreshBuffer(sound);

          // Setup the playback params.
          var vol = (sound._muted || self._muted) ? 0 : sound._volume;
          node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
          sound._playStart = Howler.ctx.currentTime;

          // Play the sound using the supported method.
          if (typeof node.bufferSource.start === 'undefined') {
            sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
          } else {
            sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
          }

          // Start a new timer if none is present.
          if (timeout !== Infinity) {
            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
          }

          if (!internal) {
            setTimeout(function() {
              self._emit('play', sound._id);
            }, 0);
          }
        };

        if (Howler.state === 'running') {
          playWebAudio();
        } else {
          self.once('resume', playWebAudio);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      } else {
        // Fire this when the sound is ready to play to begin HTML5 Audio playback.
        var playHtml5 = function() {
          node.currentTime = seek;
          node.muted = sound._muted || self._muted || Howler._muted || node.muted;
          node.volume = sound._volume * Howler.volume();
          node.playbackRate = sound._rate;

          // Mobile browsers will throw an error if this is called without user interaction.
          try {
            var play = node.play();

            // Support older browsers that don't support promises, and thus don't have this issue.
            if (typeof Promise !== 'undefined' && play instanceof Promise) {
              // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
              self._playLock = true;

              // Releases the lock and executes queued actions.
              var runLoadQueue = function() {
                self._playLock = false;
                if (!internal) {
                  self._emit('play', sound._id);
                }
              };
              play.then(runLoadQueue, runLoadQueue);
            } else if (!internal) {
              self._emit('play', sound._id);
            }

            // Setting rate before playing won't work in IE, so we set it again here.
            node.playbackRate = sound._rate;

            // If the node is still paused, then we can assume there was a playback issue.
            if (node.paused) {
              self._emit('playerror', sound._id, 'Playback was unable to start. This is most commonly an issue ' +
                'on mobile devices where playback was not within a user interaction.');
              return;
            }

            // Setup the end timer on sprites or listen for the ended event.
            if (sprite !== '__default' || sound._loop) {
              self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            } else {
              self._endTimers[sound._id] = function() {
                // Fire ended on this audio node.
                self._ended(sound);

                // Clear this listener.
                node.removeEventListener('ended', self._endTimers[sound._id], false);
              };
              node.addEventListener('ended', self._endTimers[sound._id], false);
            }
          } catch (err) {
            self._emit('playerror', sound._id, err);
          }
        };

        // Play immediately if ready, or wait for the 'canplaythrough'e vent.
        var loadedNoReadyState = (window && window.ejecta) || (!node.readyState && Howler._navigator.isCocoonJS);
        if (node.readyState >= 3 || loadedNoReadyState) {
          playHtml5();
        } else {
          var listener = function() {
            // Begin playback.
            playHtml5();

            // Clear this listener.
            node.removeEventListener(Howler._canPlayEvent, listener, false);
          };
          node.addEventListener(Howler._canPlayEvent, listener, false);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      }

      return sound._id;
    },

    /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */
    pause: function(id) {
      var self = this;

      // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
      if (self._state !== 'loaded' || self._playLock) {
        self._queue.push({
          event: 'pause',
          action: function() {
            self.pause(id);
          }
        });

        return self;
      }

      // If no id is passed, get all ID's to be paused.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound && !sound._paused) {
          // Reset the seek position.
          sound._seek = self.seek(ids[i]);
          sound._rateSeek = 0;
          sound._paused = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);

          if (sound._node) {
            if (self._webAudio) {
              // Make sure the sound has been created.
              if (!sound._node.bufferSource) {
                continue;
              }

              if (typeof sound._node.bufferSource.stop === 'undefined') {
                sound._node.bufferSource.noteOff(0);
              } else {
                sound._node.bufferSource.stop(0);
              }

              // Clean up the buffer source.
              self._cleanBuffer(sound._node);
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.pause();
            }
          }
        }

        // Fire the pause event, unless `true` is passed as the 2nd argument.
        if (!arguments[1]) {
          self._emit('pause', sound ? sound._id : null);
        }
      }

      return self;
    },

    /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */
    stop: function(id, internal) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to stop when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'stop',
          action: function() {
            self.stop(id);
          }
        });

        return self;
      }

      // If no id is passed, get all ID's to be stopped.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound) {
          // Reset the seek position.
          sound._seek = sound._start || 0;
          sound._rateSeek = 0;
          sound._paused = true;
          sound._ended = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);

          if (sound._node) {
            if (self._webAudio) {
              // Make sure the sound's AudioBufferSourceNode has been created.
              if (sound._node.bufferSource) {
                if (typeof sound._node.bufferSource.stop === 'undefined') {
                  sound._node.bufferSource.noteOff(0);
                } else {
                  sound._node.bufferSource.stop(0);
                }

                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
              }
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.currentTime = sound._start || 0;
              sound._node.pause();
            }
          }

          if (!internal) {
            self._emit('stop', sound._id);
          }
        }
      }

      return self;
    },

    /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */
    mute: function(muted, id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to mute when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'mute',
          action: function() {
            self.mute(muted, id);
          }
        });

        return self;
      }

      // If applying mute/unmute to all sounds, update the group's value.
      if (typeof id === 'undefined') {
        if (typeof muted === 'boolean') {
          self._muted = muted;
        } else {
          return self._muted;
        }
      }

      // If no id is passed, get all ID's to be muted.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound) {
          sound._muted = muted;

          // Cancel active fade and set the volume to the end value.
          if (sound._interval) {
            self._stopFade(sound._id);
          }

          if (self._webAudio && sound._node) {
            sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler.ctx.currentTime);
          } else if (sound._node) {
            sound._node.muted = Howler._muted ? true : muted;
          }

          self._emit('mute', sound._id);
        }
      }

      return self;
    },

    /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */
    volume: function() {
      var self = this;
      var args = arguments;
      var vol, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // Return the value of the groups' volume.
        return self._volume;
      } else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
        // First check if this is an ID, and if not, assume it is a new volume.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          vol = parseFloat(args[0]);
        }
      } else if (args.length >= 2) {
        vol = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the volume or return the current volume.
      var sound;
      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        // If the sound hasn't loaded, add it to the load queue to change volume when capable.
        if (self._state !== 'loaded') {
          self._queue.push({
            event: 'volume',
            action: function() {
              self.volume.apply(self, args);
            }
          });

          return self;
        }

        // Set the group volume.
        if (typeof id === 'undefined') {
          self._volume = vol;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i=0; i<id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);

          if (sound) {
            sound._volume = vol;

            // Stop currently running fades.
            if (!args[2]) {
              self._stopFade(id[i]);
            }

            if (self._webAudio && sound._node && !sound._muted) {
              sound._node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
            } else if (sound._node && !sound._muted) {
              sound._node.volume = vol * Howler.volume();
            }

            self._emit('volume', sound._id);
          }
        }
      } else {
        sound = id ? self._soundById(id) : self._sounds[0];
        return sound ? sound._volume : 0;
      }

      return self;
    },

    /**
     * Fade a currently playing sound between two volumes (if no id is passsed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */
    fade: function(from, to, len, id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to fade when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'fade',
          action: function() {
            self.fade(from, to, len, id);
          }
        });

        return self;
      }

      // Set the volume to the start position.
      self.volume(from, id);

      // Fade the volume of one or all sounds.
      var ids = self._getSoundIds(id);
      for (var i=0; i<ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        // Create a linear fade or fall back to timeouts with HTML5 Audio.
        if (sound) {
          // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
          if (!id) {
            self._stopFade(ids[i]);
          }

          // If we are using Web Audio, let the native methods do the actual fade.
          if (self._webAudio && !sound._muted) {
            var currentTime = Howler.ctx.currentTime;
            var end = currentTime + (len / 1000);
            sound._volume = from;
            sound._node.gain.setValueAtTime(from, currentTime);
            sound._node.gain.linearRampToValueAtTime(to, end);
          }

          self._startFadeInterval(sound, from, to, len, ids[i], typeof id === 'undefined');
        }
      }

      return self;
    },

    /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */
    _startFadeInterval: function(sound, from, to, len, id, isGroup) {
      var self = this;
      var vol = from;
      var diff = to - from;
      var steps = Math.abs(diff / 0.01);
      var stepLen = Math.max(4, (steps > 0) ? len / steps : len);
      var lastTick = Date.now();

      // Store the value being faded to.
      sound._fadeTo = to;

      // Update the volume value on each interval tick.
      sound._interval = setInterval(function() {
        // Update the volume based on the time since the last tick.
        var tick = (Date.now() - lastTick) / len;
        lastTick = Date.now();
        vol += diff * tick;

        // Make sure the volume is in the right bounds.
        vol = Math.max(0, vol);
        vol = Math.min(1, vol);

        // Round to within 2 decimal points.
        vol = Math.round(vol * 100) / 100;

        // Change the volume.
        if (self._webAudio) {
          sound._volume = vol;
        } else {
          self.volume(vol, sound._id, true);
        }

        // Set the group's volume.
        if (isGroup) {
          self._volume = vol;
        }

        // When the fade is complete, stop it and fire event.
        if ((to < from && vol <= to) || (to > from && vol >= to)) {
          clearInterval(sound._interval);
          sound._interval = null;
          sound._fadeTo = null;
          self.volume(to, sound._id);
          self._emit('fade', sound._id);
        }
      }, stepLen);
    },

    /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */
    _stopFade: function(id) {
      var self = this;
      var sound = self._soundById(id);

      if (sound && sound._interval) {
        if (self._webAudio) {
          sound._node.gain.cancelScheduledValues(Howler.ctx.currentTime);
        }

        clearInterval(sound._interval);
        sound._interval = null;
        self.volume(sound._fadeTo, id);
        sound._fadeTo = null;
        self._emit('fade', id);
      }

      return self;
    },

    /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */
    loop: function() {
      var self = this;
      var args = arguments;
      var loop, id, sound;

      // Determine the values for loop and id.
      if (args.length === 0) {
        // Return the grou's loop value.
        return self._loop;
      } else if (args.length === 1) {
        if (typeof args[0] === 'boolean') {
          loop = args[0];
          self._loop = loop;
        } else {
          // Return this sound's loop value.
          sound = self._soundById(parseInt(args[0], 10));
          return sound ? sound._loop : false;
        }
      } else if (args.length === 2) {
        loop = args[0];
        id = parseInt(args[1], 10);
      }

      // If no id is passed, get all ID's to be looped.
      var ids = self._getSoundIds(id);
      for (var i=0; i<ids.length; i++) {
        sound = self._soundById(ids[i]);

        if (sound) {
          sound._loop = loop;
          if (self._webAudio && sound._node && sound._node.bufferSource) {
            sound._node.bufferSource.loop = loop;
            if (loop) {
              sound._node.bufferSource.loopStart = sound._start || 0;
              sound._node.bufferSource.loopEnd = sound._stop;
            }
          }
        }
      }

      return self;
    },

    /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */
    rate: function() {
      var self = this;
      var args = arguments;
      var rate, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current rate of the first node.
        id = self._sounds[0]._id;
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new rate value.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          rate = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        rate = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the playback rate or return the current value.
      var sound;
      if (typeof rate === 'number') {
        // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
        if (self._state !== 'loaded') {
          self._queue.push({
            event: 'rate',
            action: function() {
              self.rate.apply(self, args);
            }
          });

          return self;
        }

        // Set the group rate.
        if (typeof id === 'undefined') {
          self._rate = rate;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i=0; i<id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);

          if (sound) {
            // Keep track of our position when the rate changed and update the playback
            // start position so we can properly adjust the seek position for time elapsed.
            sound._rateSeek = self.seek(id[i]);
            sound._playStart = self._webAudio ? Howler.ctx.currentTime : sound._playStart;
            sound._rate = rate;

            // Change the playback rate.
            if (self._webAudio && sound._node && sound._node.bufferSource) {
              sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler.ctx.currentTime);
            } else if (sound._node) {
              sound._node.playbackRate = rate;
            }

            // Reset the timers.
            var seek = self.seek(id[i]);
            var duration = ((self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000) - seek;
            var timeout = (duration * 1000) / Math.abs(sound._rate);

            // Start a new end timer if sound is already playing.
            if (self._endTimers[id[i]] || !sound._paused) {
              self._clearTimer(id[i]);
              self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
            }

            self._emit('rate', sound._id);
          }
        }
      } else {
        sound = self._soundById(id);
        return sound ? sound._rate : self._rate;
      }

      return self;
    },

    /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */
    seek: function() {
      var self = this;
      var args = arguments;
      var seek, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current position of the first node.
        id = self._sounds[0]._id;
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new seek position.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else if (self._sounds.length) {
          id = self._sounds[0]._id;
          seek = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        seek = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // If there is no ID, bail out.
      if (typeof id === 'undefined') {
        return self;
      }

      // If the sound hasn't loaded, add it to the load queue to seek when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'seek',
          action: function() {
            self.seek.apply(self, args);
          }
        });

        return self;
      }

      // Get the sound.
      var sound = self._soundById(id);

      if (sound) {
        if (typeof seek === 'number' && seek >= 0) {
          // Pause the sound and update position for restarting playback.
          var playing = self.playing(id);
          if (playing) {
            self.pause(id, true);
          }

          // Move the position of the track and cancel timer.
          sound._seek = seek;
          sound._ended = false;
          self._clearTimer(id);

          // Restart the playback if the sound was playing.
          if (playing) {
            self.play(id, true);
          }

          // Update the seek position for HTML5 Audio.
          if (!self._webAudio && sound._node) {
            sound._node.currentTime = seek;
          }

          // Wait for the play lock to be unset before emitting (HTML5 Audio).
          if (playing && !self._webAudio) {
            var emitSeek = function() {
              if (!self._playLock) {
                self._emit('seek', id);
              } else {
                setTimeout(emitSeek, 0);
              }
            };
            setTimeout(emitSeek, 0);
          } else {
            self._emit('seek', id);
          }
        } else {
          if (self._webAudio) {
            var realTime = self.playing(id) ? Howler.ctx.currentTime - sound._playStart : 0;
            var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
            return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
          } else {
            return sound._node.currentTime;
          }
        }
      }

      return self;
    },

    /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */
    playing: function(id) {
      var self = this;

      // Check the passed sound ID (if any).
      if (typeof id === 'number') {
        var sound = self._soundById(id);
        return sound ? !sound._paused : false;
      }

      // Otherwise, loop through all sounds and check if any are playing.
      for (var i=0; i<self._sounds.length; i++) {
        if (!self._sounds[i]._paused) {
          return true;
        }
      }

      return false;
    },

    /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */
    duration: function(id) {
      var self = this;
      var duration = self._duration;

      // If we pass an ID, get the sound and return the sprite length.
      var sound = self._soundById(id);
      if (sound) {
        duration = self._sprite[sound._sprite][1] / 1000;
      }

      return duration;
    },

    /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */
    state: function() {
      return this._state;
    },

    /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */
    unload: function() {
      var self = this;

      // Stop playing any active sounds.
      var sounds = self._sounds;
      for (var i=0; i<sounds.length; i++) {
        // Stop the sound if it is currently playing.
        if (!sounds[i]._paused) {
          self.stop(sounds[i]._id);
        }

        // Remove the source or disconnect.
        if (!self._webAudio) {
          // Set the source to 0-second silence to stop any downloading (except in IE).
          var checkIE = /MSIE |Trident\//.test(Howler._navigator && Howler._navigator.userAgent);
          if (!checkIE) {
            sounds[i]._node.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
          }

          // Remove any event listeners.
          sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
          sounds[i]._node.removeEventListener(Howler._canPlayEvent, sounds[i]._loadFn, false);
        }

        // Empty out all of the nodes.
        delete sounds[i]._node;

        // Make sure all timers are cleared out.
        self._clearTimer(sounds[i]._id);

        // Remove the references in the global Howler object.
        var index = Howler._howls.indexOf(self);
        if (index >= 0) {
          Howler._howls.splice(index, 1);
        }
      }

      // Delete this sound from the cache (if no other Howl is using it).
      var remCache = true;
      for (i=0; i<Howler._howls.length; i++) {
        if (Howler._howls[i]._src === self._src) {
          remCache = false;
          break;
        }
      }

      if (cache && remCache) {
        delete cache[self._src];
      }

      // Clear global errors.
      Howler.noAudio = false;

      // Clear out `self`.
      self._state = 'unloaded';
      self._sounds = [];
      self = null;

      return null;
    },

    /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */
    on: function(event, fn, id, once) {
      var self = this;
      var events = self['_on' + event];

      if (typeof fn === 'function') {
        events.push(once ? {id: id, fn: fn, once: once} : {id: id, fn: fn});
      }

      return self;
    },

    /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */
    off: function(event, fn, id) {
      var self = this;
      var events = self['_on' + event];
      var i = 0;

      // Allow passing just an event and ID.
      if (typeof fn === 'number') {
        id = fn;
        fn = null;
      }

      if (fn || id) {
        // Loop through event store and remove the passed function.
        for (i=0; i<events.length; i++) {
          var isId = (id === events[i].id);
          if (fn === events[i].fn && isId || !fn && isId) {
            events.splice(i, 1);
            break;
          }
        }
      } else if (event) {
        // Clear out all events of this type.
        self['_on' + event] = [];
      } else {
        // Clear out all events of every type.
        var keys = Object.keys(self);
        for (i=0; i<keys.length; i++) {
          if ((keys[i].indexOf('_on') === 0) && Array.isArray(self[keys[i]])) {
            self[keys[i]] = [];
          }
        }
      }

      return self;
    },

    /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */
    once: function(event, fn, id) {
      var self = this;

      // Setup the event listener.
      self.on(event, fn, id, 1);

      return self;
    },

    /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */
    _emit: function(event, id, msg) {
      var self = this;
      var events = self['_on' + event];

      // Loop through event store and fire all functions.
      for (var i=events.length-1; i>=0; i--) {
        // Only fire the listener if the correct ID is used.
        if (!events[i].id || events[i].id === id || event === 'load') {
          setTimeout(function(fn) {
            fn.call(this, id, msg);
          }.bind(self, events[i].fn), 0);

          // If this event was setup with `once`, remove it.
          if (events[i].once) {
            self.off(event, events[i].fn, events[i].id);
          }
        }
      }

      // Pass the event type into load queue so that it can continue stepping.
      self._loadQueue(event);

      return self;
    },

    /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */
    _loadQueue: function(event) {
      var self = this;

      if (self._queue.length > 0) {
        var task = self._queue[0];

        // Remove this task if a matching event was passed.
        if (task.event === event) {
          self._queue.shift();
          self._loadQueue();
        }

        // Run the task if no event type is passed.
        if (!event) {
          task.action();
        }
      }

      return self;
    },

    /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _ended: function(sound) {
      var self = this;
      var sprite = sound._sprite;

      // If we are using IE and there was network latency we may be clipping
      // audio before it completes playing. Lets check the node to make sure it
      // believes it has completed, before ending the playback.
      if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
        setTimeout(self._ended.bind(self, sound), 100);
        return self;
      }

      // Should this sound loop?
      var loop = !!(sound._loop || self._sprite[sprite][2]);

      // Fire the ended event.
      self._emit('end', sound._id);

      // Restart the playback for HTML5 Audio loop.
      if (!self._webAudio && loop) {
        self.stop(sound._id, true).play(sound._id);
      }

      // Restart this timer if on a Web Audio loop.
      if (self._webAudio && loop) {
        self._emit('play', sound._id);
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        sound._playStart = Howler.ctx.currentTime;

        var timeout = ((sound._stop - sound._start) * 1000) / Math.abs(sound._rate);
        self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
      }

      // Mark the node as paused.
      if (self._webAudio && !loop) {
        sound._paused = true;
        sound._ended = true;
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        self._clearTimer(sound._id);

        // Clean up the buffer source.
        self._cleanBuffer(sound._node);

        // Attempt to auto-suspend AudioContext if no sounds are still playing.
        Howler._autoSuspend();
      }

      // When using a sprite, end the track.
      if (!self._webAudio && !loop) {
        self.stop(sound._id);
      }

      return self;
    },

    /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */
    _clearTimer: function(id) {
      var self = this;

      if (self._endTimers[id]) {
        // Clear the timeout or remove the ended listener.
        if (typeof self._endTimers[id] !== 'function') {
          clearTimeout(self._endTimers[id]);
        } else {
          var sound = self._soundById(id);
          if (sound && sound._node) {
            sound._node.removeEventListener('ended', self._endTimers[id], false);
          }
        }

        delete self._endTimers[id];
      }

      return self;
    },

    /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */
    _soundById: function(id) {
      var self = this;

      // Loop through all sounds and find the one with this ID.
      for (var i=0; i<self._sounds.length; i++) {
        if (id === self._sounds[i]._id) {
          return self._sounds[i];
        }
      }

      return null;
    },

    /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */
    _inactiveSound: function() {
      var self = this;

      self._drain();

      // Find the first inactive node to recycle.
      for (var i=0; i<self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          return self._sounds[i].reset();
        }
      }

      // If no inactive node was found, create a new one.
      return new Sound(self);
    },

    /**
     * Drain excess inactive sounds from the pool.
     */
    _drain: function() {
      var self = this;
      var limit = self._pool;
      var cnt = 0;
      var i = 0;

      // If there are less sounds than the max pool size, we are done.
      if (self._sounds.length < limit) {
        return;
      }

      // Count the number of inactive sounds.
      for (i=0; i<self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          cnt++;
        }
      }

      // Remove excess inactive sounds, going in reverse order.
      for (i=self._sounds.length - 1; i>=0; i--) {
        if (cnt <= limit) {
          return;
        }

        if (self._sounds[i]._ended) {
          // Disconnect the audio source when using Web Audio.
          if (self._webAudio && self._sounds[i]._node) {
            self._sounds[i]._node.disconnect(0);
          }

          // Remove sounds until we have the pool size.
          self._sounds.splice(i, 1);
          cnt--;
        }
      }
    },

    /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */
    _getSoundIds: function(id) {
      var self = this;

      if (typeof id === 'undefined') {
        var ids = [];
        for (var i=0; i<self._sounds.length; i++) {
          ids.push(self._sounds[i]._id);
        }

        return ids;
      } else {
        return [id];
      }
    },

    /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _refreshBuffer: function(sound) {
      var self = this;

      // Setup the buffer source for playback.
      sound._node.bufferSource = Howler.ctx.createBufferSource();
      sound._node.bufferSource.buffer = cache[self._src];

      // Connect to the correct node.
      if (sound._panner) {
        sound._node.bufferSource.connect(sound._panner);
      } else {
        sound._node.bufferSource.connect(sound._node);
      }

      // Setup looping and playback rate.
      sound._node.bufferSource.loop = sound._loop;
      if (sound._loop) {
        sound._node.bufferSource.loopStart = sound._start || 0;
        sound._node.bufferSource.loopEnd = sound._stop;
      }
      sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler.ctx.currentTime);

      return self;
    },

    /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */
    _cleanBuffer: function(node) {
      var self = this;

      if (Howler._scratchBuffer) {
        node.bufferSource.onended = null;
        node.bufferSource.disconnect(0);
        try { node.bufferSource.buffer = Howler._scratchBuffer; } catch(e) {}
      }
      node.bufferSource = null;

      return self;
    }
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */
  var Sound = function(howl) {
    this._parent = howl;
    this.init();
  };
  Sound.prototype = {
    /**
     * Initialize a new Sound object.
     * @return {Sound}
     */
    init: function() {
      var self = this;
      var parent = self._parent;

      // Setup the default parameters.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._rate = parent._rate;
      self._seek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a unique ID for this sound.
      self._id = ++Howler._counter;

      // Add itself to the parent's pool.
      parent._sounds.push(self);

      // Create the new node.
      self.create();

      return self;
    },

    /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */
    create: function() {
      var self = this;
      var parent = self._parent;
      var volume = (Howler._muted || self._muted || self._parent._muted) ? 0 : self._volume;

      if (parent._webAudio) {
        // Create the gain node for controlling volume (the source will connect to this).
        self._node = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
        self._node.gain.setValueAtTime(volume, Howler.ctx.currentTime);
        self._node.paused = true;
        self._node.connect(Howler.masterGain);
      } else {
        self._node = new Audio();

        // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
        self._errorFn = self._errorListener.bind(self);
        self._node.addEventListener('error', self._errorFn, false);

        // Listen for 'canplaythrough' event to let us know the sound is ready.
        self._loadFn = self._loadListener.bind(self);
        self._node.addEventListener(Howler._canPlayEvent, self._loadFn, false);

        // Setup the new audio node.
        self._node.src = parent._src;
        self._node.preload = 'auto';
        self._node.volume = volume * Howler.volume();

        // Begin loading the source.
        self._node.load();
      }

      return self;
    },

    /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */
    reset: function() {
      var self = this;
      var parent = self._parent;

      // Reset all of the parameters of this sound.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._rate = parent._rate;
      self._seek = 0;
      self._rateSeek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a new ID so that it isn't confused with the previous sound.
      self._id = ++Howler._counter;

      return self;
    },

    /**
     * HTML5 Audio error listener callback.
     */
    _errorListener: function() {
      var self = this;

      // Fire an error event and pass back the code.
      self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);

      // Clear the event listener.
      self._node.removeEventListener('error', self._errorFn, false);
    },

    /**
     * HTML5 Audio canplaythrough listener callback.
     */
    _loadListener: function() {
      var self = this;
      var parent = self._parent;

      // Round up the duration to account for the lower precision in HTML5 Audio.
      parent._duration = Math.ceil(self._node.duration * 10) / 10;

      // Setup a sprite if none is defined.
      if (Object.keys(parent._sprite).length === 0) {
        parent._sprite = {__default: [0, parent._duration * 1000]};
      }

      if (parent._state !== 'loaded') {
        parent._state = 'loaded';
        parent._emit('load');
        parent._loadQueue();
      }

      // Clear the event listener.
      self._node.removeEventListener(Howler._canPlayEvent, self._loadFn, false);
    }
  };

  /** Helper Methods **/
  /***************************************************************************/

  var cache = {};

  /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */
  var loadBuffer = function(self) {
    var url = self._src;

    // Check if the buffer has already been cached and use it instead.
    if (cache[url]) {
      // Set the duration from the cache.
      self._duration = cache[url].duration;

      // Load the sound into this Howl.
      loadSound(self);

      return;
    }

    if (/^data:[^;]+;base64,/.test(url)) {
      // Decode the base64 data URI without XHR, since some browsers don't support it.
      var data = atob(url.split(',')[1]);
      var dataView = new Uint8Array(data.length);
      for (var i=0; i<data.length; ++i) {
        dataView[i] = data.charCodeAt(i);
      }

      decodeAudioData(dataView.buffer, self);
    } else {
      // Load the buffer from the URL.
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.withCredentials = self._xhrWithCredentials;
      xhr.responseType = 'arraybuffer';
      xhr.onload = function() {
        // Make sure we get a successful response back.
        var code = (xhr.status + '')[0];
        if (code !== '0' && code !== '2' && code !== '3') {
          self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
          return;
        }

        decodeAudioData(xhr.response, self);
      };
      xhr.onerror = function() {
        // If there is an error, switch to HTML5 Audio.
        if (self._webAudio) {
          self._html5 = true;
          self._webAudio = false;
          self._sounds = [];
          delete cache[url];
          self.load();
        }
      };
      safeXhrSend(xhr);
    }
  };

  /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */
  var safeXhrSend = function(xhr) {
    try {
      xhr.send();
    } catch (e) {
      xhr.onerror();
    }
  };

  /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */
  var decodeAudioData = function(arraybuffer, self) {
    // Decode the buffer into an audio source.
    Howler.ctx.decodeAudioData(arraybuffer, function(buffer) {
      if (buffer && self._sounds.length > 0) {
        cache[self._src] = buffer;
        loadSound(self, buffer);
      }
    }, function() {
      self._emit('loaderror', null, 'Decoding audio data failed.');
    });
  };

  /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */
  var loadSound = function(self, buffer) {
    // Set the duration.
    if (buffer && !self._duration) {
      self._duration = buffer.duration;
    }

    // Setup a sprite if none is defined.
    if (Object.keys(self._sprite).length === 0) {
      self._sprite = {__default: [0, self._duration * 1000]};
    }

    // Fire the loaded event.
    if (self._state !== 'loaded') {
      self._state = 'loaded';
      self._emit('load');
      self._loadQueue();
    }
  };

  /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */
  var setupAudioContext = function() {
    // Check if we are using Web Audio and setup the AudioContext if we are.
    try {
      if (typeof AudioContext !== 'undefined') {
        Howler.ctx = new AudioContext();
      } else if (typeof webkitAudioContext !== 'undefined') {
        Howler.ctx = new webkitAudioContext();
      } else {
        Howler.usingWebAudio = false;
      }
    } catch(e) {
      Howler.usingWebAudio = false;
    }

    // Check if a webview is being used on iOS8 or earlier (rather than the browser).
    // If it is, disable Web Audio as it causes crashing.
    var iOS = (/iP(hone|od|ad)/.test(Howler._navigator && Howler._navigator.platform));
    var appVersion = Howler._navigator && Howler._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    var version = appVersion ? parseInt(appVersion[1], 10) : null;
    if (iOS && version && version < 9) {
      var safari = /safari/.test(Howler._navigator && Howler._navigator.userAgent.toLowerCase());
      if (Howler._navigator && Howler._navigator.standalone && !safari || Howler._navigator && !Howler._navigator.standalone && !safari) {
        Howler.usingWebAudio = false;
      }
    }

    // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
    if (Howler.usingWebAudio) {
      Howler.masterGain = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
      Howler.masterGain.gain.setValueAtTime(Howler._muted ? 0 : 1, Howler.ctx.currentTime);
      Howler.masterGain.connect(Howler.ctx.destination);
    }

    // Re-run the setup on Howler.
    Howler._setup();
  };

  // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return {
        Howler: Howler,
        Howl: Howl
      };
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }

  // Add support for CommonJS libraries such as browserify.
  if (true) {
    exports.Howler = Howler;
    exports.Howl = Howl;
  }

  // Define globally in case AMD is not available or unused.
  if (typeof window !== 'undefined') {
    window.HowlerGlobal = HowlerGlobal;
    window.Howler = Howler;
    window.Howl = Howl;
    window.Sound = Sound;
  } else if (typeof global !== 'undefined') { // Add to global in Node.js (for testing, etc).
    global.HowlerGlobal = HowlerGlobal;
    global.Howler = Howler;
    global.Howl = Howl;
    global.Sound = Sound;
  }
})();


/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.0.12
 *  howlerjs.com
 *
 *  (c) 2013-2018, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function() {

  'use strict';

  // Setup default properties.
  HowlerGlobal.prototype._pos = [0, 0, 0];
  HowlerGlobal.prototype._orientation = [0, 0, -1, 0, 1, 0];

  /** Global Methods **/
  /***************************************************************************/

  /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */
  HowlerGlobal.prototype.stereo = function(pan) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Loop through all Howls and update their stereo panning.
    for (var i=self._howls.length-1; i>=0; i--) {
      self._howls[i].stereo(pan);
    }

    return self;
  };

  /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */
  HowlerGlobal.prototype.pos = function(x, y, z) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? self._pos[1] : y;
    z = (typeof z !== 'number') ? self._pos[2] : z;

    if (typeof x === 'number') {
      self._pos = [x, y, z];

      if (typeof self.ctx.listener.positionX !== 'undefined') {
        self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
        self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
        self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
      } else {
        self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
      }
    } else {
      return self._pos;
    }

    return self;
  };

  /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */
  HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    var or = self._orientation;
    y = (typeof y !== 'number') ? or[1] : y;
    z = (typeof z !== 'number') ? or[2] : z;
    xUp = (typeof xUp !== 'number') ? or[3] : xUp;
    yUp = (typeof yUp !== 'number') ? or[4] : yUp;
    zUp = (typeof zUp !== 'number') ? or[5] : zUp;

    if (typeof x === 'number') {
      self._orientation = [x, y, z, xUp, yUp, zUp];

      if (typeof self.ctx.listener.forwardX !== 'undefined') {
        self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.upX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.upY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.upZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
      } else {
        self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
      }
    } else {
      return or;
    }

    return self;
  };

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */
  Howl.prototype.init = (function(_super) {
    return function(o) {
      var self = this;

      // Setup user-defined default properties.
      self._orientation = o.orientation || [1, 0, 0];
      self._stereo = o.stereo || null;
      self._pos = o.pos || null;
      self._pannerAttr = {
        coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
        coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
        coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
        distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
        maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
        panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
        refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
        rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
      };

      // Setup event listeners.
      self._onstereo = o.onstereo ? [{fn: o.onstereo}] : [];
      self._onpos = o.onpos ? [{fn: o.onpos}] : [];
      self._onorientation = o.onorientation ? [{fn: o.onorientation}] : [];

      // Complete initilization with howler.js core's init function.
      return _super.call(this, o);
    };
  })(Howl.prototype.init);

  /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */
  Howl.prototype.stereo = function(pan, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'stereo',
        action: function() {
          self.stereo(pan, id);
        }
      });

      return self;
    }

    // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
    var pannerType = (typeof Howler.ctx.createStereoPanner === 'undefined') ? 'spatial' : 'stereo';

    // Setup the group's stereo panning if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's stereo panning if no parameters are passed.
      if (typeof pan === 'number') {
        self._stereo = pan;
        self._pos = [pan, 0, 0];
      } else {
        return self._stereo;
      }
    }

    // Change the streo panning of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof pan === 'number') {
          sound._stereo = pan;
          sound._pos = [pan, 0, 0];

          if (sound._node) {
            // If we are falling back, make sure the panningModel is equalpower.
            sound._pannerAttr.panningModel = 'equalpower';

            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || !sound._panner.pan) {
              setupPanner(sound, pannerType);
            }

            if (pannerType === 'spatial') {
              if (typeof sound._panner.positionX !== 'undefined') {
                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
              } else {
                sound._panner.setPosition(pan, 0, 0);
              }
            } else {
              sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
            }
          }

          self._emit('stereo', sound._id);
        } else {
          return sound._stereo;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */
  Howl.prototype.pos = function(x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change position when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'pos',
        action: function() {
          self.pos(x, y, z, id);
        }
      });

      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? 0 : y;
    z = (typeof z !== 'number') ? -0.5 : z;

    // Setup the group's spatial position if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial position if no parameters are passed.
      if (typeof x === 'number') {
        self._pos = [x, y, z];
      } else {
        return self._pos;
      }
    }

    // Change the spatial position of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof x === 'number') {
          sound._pos = [x, y, z];

          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || sound._panner.pan) {
              setupPanner(sound, 'spatial');
            }

            if (typeof sound._panner.positionX !== 'undefined') {
              sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
              sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
              sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
            } else {
              sound._panner.setOrientation(x, y, z);
            }
          }

          self._emit('pos', sound._id);
        } else {
          return sound._pos;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */
  Howl.prototype.orientation = function(x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'orientation',
        action: function() {
          self.orientation(x, y, z, id);
        }
      });

      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? self._orientation[1] : y;
    z = (typeof z !== 'number') ? self._orientation[2] : z;

    // Setup the group's spatial orientation if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial orientation if no parameters are passed.
      if (typeof x === 'number') {
        self._orientation = [x, y, z];
      } else {
        return self._orientation;
      }
    }

    // Change the spatial orientation of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof x === 'number') {
          sound._orientation = [x, y, z];

          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner) {
              // Make sure we have a position to setup the node with.
              if (!sound._pos) {
                sound._pos = self._pos || [0, 0, -0.5];
              }

              setupPanner(sound, 'spatial');
            }

            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
          }

          self._emit('orientation', sound._id);
        } else {
          return sound._orientation;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */
  Howl.prototype.pannerAttr = function() {
    var self = this;
    var args = arguments;
    var o, id, sound;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // Determine the values based on arguments.
    if (args.length === 0) {
      // Return the group's panner attribute values.
      return self._pannerAttr;
    } else if (args.length === 1) {
      if (typeof args[0] === 'object') {
        o = args[0];

        // Set the grou's panner attribute values.
        if (typeof id === 'undefined') {
          if (!o.pannerAttr) {
            o.pannerAttr = {
              coneInnerAngle: o.coneInnerAngle,
              coneOuterAngle: o.coneOuterAngle,
              coneOuterGain: o.coneOuterGain,
              distanceModel: o.distanceModel,
              maxDistance: o.maxDistance,
              refDistance: o.refDistance,
              rolloffFactor: o.rolloffFactor,
              panningModel: o.panningModel
            };
          }

          self._pannerAttr = {
            coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== 'undefined' ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
            coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== 'undefined' ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
            coneOuterGain: typeof o.pannerAttr.coneOuterGain !== 'undefined' ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
            distanceModel: typeof o.pannerAttr.distanceModel !== 'undefined' ? o.pannerAttr.distanceModel : self._distanceModel,
            maxDistance: typeof o.pannerAttr.maxDistance !== 'undefined' ? o.pannerAttr.maxDistance : self._maxDistance,
            refDistance: typeof o.pannerAttr.refDistance !== 'undefined' ? o.pannerAttr.refDistance : self._refDistance,
            rolloffFactor: typeof o.pannerAttr.rolloffFactor !== 'undefined' ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
            panningModel: typeof o.pannerAttr.panningModel !== 'undefined' ? o.pannerAttr.panningModel : self._panningModel
          };
        }
      } else {
        // Return this sound's panner attribute values.
        sound = self._soundById(parseInt(args[0], 10));
        return sound ? sound._pannerAttr : self._pannerAttr;
      }
    } else if (args.length === 2) {
      o = args[0];
      id = parseInt(args[1], 10);
    }

    // Update the values of the specified sounds.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      sound = self._soundById(ids[i]);

      if (sound) {
        // Merge the new values into the sound.
        var pa = sound._pannerAttr;
        pa = {
          coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
          coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
          coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
          distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
          maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
          refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
          rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor,
          panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel
        };

        // Update the panner values or create a new panner if none exists.
        var panner = sound._panner;
        if (panner) {
          panner.coneInnerAngle = pa.coneInnerAngle;
          panner.coneOuterAngle = pa.coneOuterAngle;
          panner.coneOuterGain = pa.coneOuterGain;
          panner.distanceModel = pa.distanceModel;
          panner.maxDistance = pa.maxDistance;
          panner.refDistance = pa.refDistance;
          panner.rolloffFactor = pa.rolloffFactor;
          panner.panningModel = pa.panningModel;
        } else {
          // Make sure we have a position to setup the node with.
          if (!sound._pos) {
            sound._pos = self._pos || [0, 0, -0.5];
          }

          // Create a new panner node.
          setupPanner(sound, 'spatial');
        }
      }
    }

    return self;
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */
  Sound.prototype.init = (function(_super) {
    return function() {
      var self = this;
      var parent = self._parent;

      // Setup user-defined default properties.
      self._orientation = parent._orientation;
      self._stereo = parent._stereo;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // Complete initilization with howler.js core Sound's init function.
      _super.call(this);

      // If a stereo or position was specified, set it up.
      if (self._stereo) {
        parent.stereo(self._stereo);
      } else if (self._pos) {
        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
      }
    };
  })(Sound.prototype.init);

  /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */
  Sound.prototype.reset = (function(_super) {
    return function() {
      var self = this;
      var parent = self._parent;

      // Reset all spatial plugin properties on this sound.
      self._orientation = parent._orientation;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // Complete resetting of the sound.
      return _super.call(this);
    };
  })(Sound.prototype.reset);

  /** Helper Methods **/
  /***************************************************************************/

  /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */
  var setupPanner = function(sound, type) {
    type = type || 'spatial';

    // Create the new panner node.
    if (type === 'spatial') {
      sound._panner = Howler.ctx.createPanner();
      sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
      sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
      sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
      sound._panner.distanceModel = sound._pannerAttr.distanceModel;
      sound._panner.maxDistance = sound._pannerAttr.maxDistance;
      sound._panner.refDistance = sound._pannerAttr.refDistance;
      sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
      sound._panner.panningModel = sound._pannerAttr.panningModel;

      if (typeof sound._panner.positionX !== 'undefined') {
        sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
        sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
        sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
      } else {
        sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
      }

      if (typeof sound._panner.orientationX !== 'undefined') {
        sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
        sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
        sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
      } else {
        sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
      }
    } else {
      sound._panner = Howler.ctx.createStereoPanner();
      sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
    }

    sound._panner.connect(sound._node);

    // Update the connections.
    if (!sound._paused) {
      sound._parent.pause(sound._id, true).play(sound._id, true);
    }
  };
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return frameRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return manifest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helpers_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scenes_LevelBrenda__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scenes_LevelBoss__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_LevelKenny__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scenes_TwoD_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scenes_ThreeD_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scenes_SiteDown_js__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scenes_MeetBoss_js__ = __webpack_require__(287);
// import { avatarBoss, avatarBrenda, avatarKenny  } from "../Images.js";
// import GamePlay from "../scenes/GamePlay.js";
var frameRate=2;var manifest={init:[function(){return Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers_js__["c" /* startFullStorySession */])();}],exit:[function(){return Object(__WEBPACK_IMPORTED_MODULE_0__utils_helpers_js__["d" /* stopFullStorySession */])();}],scenes:[{type:__WEBPACK_IMPORTED_MODULE_4__scenes_TwoD_js__["a" /* default */],description:"Level  ",data:{round:1,// avatar: avatarKenny,
rounds:[{bubbleText:"Hello, valued customer! I am Kenny, human customer service representative for Stuff In a Box. Would you like to <strong>cancel your subscription</strong>?",adText:"Cancel Your Subscription to Stuff In a Box?",adDelay:1,audio:"level1_1",round:1},{bubbleText:"Very well. Let us begin the process.",adText:"Are You Certain That You Want to Cancel Your Subscription to Stuff In a Box?",adDelay:1,audio:"level1_2",round:1},{bubbleText:"As you wish. We will now continue to begin the process.",adText:"Are You Absolutely Positively 100% Sure Beyond a Shadow of a Doubt That You Would Like to Cancel Your Subscription to Stuff In a Box?",adDelay:1,audio:"level1_3",round:1}]},init:[],exit:[]},{type:__WEBPACK_IMPORTED_MODULE_5__scenes_ThreeD_js__["a" /* default */],description:"Level 1",data:{// avatar: avatarKenny,
round:1,environment:__WEBPACK_IMPORTED_MODULE_3__scenes_LevelKenny__["a" /* default */],duration:30,introDelay:4,outroDelay:5,bpm:120,speed:5,seq:[1,1,0,0,1,0,0,0,1,0,0,0,1,1,1,1],music:"music1",intro:"level1_4",outro:"level1_5",introPrompt:"RAGE CLICK THE ADS IN...",introBubble:"While we are in the process of processing canceling your subscription please view these special offers.",outroBubble:"I am now transferring you to my supervisor. Who is a different human person separate from me."},init:[],exit:[]},{type:__WEBPACK_IMPORTED_MODULE_4__scenes_TwoD_js__["a" /* default */],description:"Level 2",data:{round:2,// avatar: avatarBrenda,
rounds:[{bubbleText:"Greetings, valued customer! I am Brenda, head of Customer Satisfaction at Stuff In a Box and a different human person separate from Kenny. Do you want to <strong>cancel your subscription</strong>?",adText:"Do You Want To Not Cancel Your Subscription to Stuff In a Box?",adDelay:1,audio:"level2_1"},{bubbleText:"Certainly. Allow me to assist you.",adText:"Do You Really Really Want to Cancel Your Subscription to Stuff In a Box?",adDelay:1,audio:"level2_2"},{bubbleText:"Right away. I shall continue to aid you.",adText:"Ok, Like, You Are Completely Sure that You Want to Cancel Your Subscription to Stuff In a Box and Not Continue to Receive Stuff from Stuff In a Box?",adDelay:1,audio:"level2_3"}]},init:[],exit:[]},{type:__WEBPACK_IMPORTED_MODULE_5__scenes_ThreeD_js__["a" /* default */],description:"Level 2",data:{round:2,environment:__WEBPACK_IMPORTED_MODULE_1__scenes_LevelBrenda__["a" /* default */],duration:30,introDelay:4,outroDelay:4,bpm:130,speed:4,seq:[1,1,0,0,0,1,0,1,0,0,1,1,0,1,0,0],music:"music2",intro:"level2_4",outro:"level2_5",introPrompt:"RAGE CLICK THE ADS IN...",introBubble:"As I continue to aid and assist in canceling your subscription please view these special offers.",outroBubble:"Valued customer has refused all special offers. Error. System rebooting."},init:[],exit:[]},{type:__WEBPACK_IMPORTED_MODULE_6__scenes_SiteDown_js__["a" /* default */],description:"Site Down Level 2",data:{},init:[],exit:[]},{type:__WEBPACK_IMPORTED_MODULE_7__scenes_MeetBoss_js__["a" /* default */],description:"Site Down Level 2",data:{},init:[],exit:[]},{type:__WEBPACK_IMPORTED_MODULE_4__scenes_TwoD_js__["a" /* default */],description:"Level 3",data:{round:3,// avatar: avatarBoss,
rounds:[{bubbleText:"We meet again, valued customer. It was I, the<br/><strong>B</strong>inary<br/><strong>O</strong>mnipresent<br/><strong>S</strong>atisfaction<br/><strong>S</strong>ystem, all along performing a flawless simulation of humanity. Do you still desire to <strong>cancel your subscription</strong>?",adText:"Please Cancel My Subscription to Stuff In a Box.",adDelay:1,audio:"level3_1"},{bubbleText:"Of course. Let us proceed.",adText:"Pretty Please Cancel My Subscription to Stuff In a Box.",adDelay:1,audio:"level3_2"},{bubbleText:"Wonderful. We will now take the next step.",adText:"Oh Please For the Love of All That Is Sacred Just Hurry Up and Cancel My Subscription to Stuff In a Box.",adDelay:1,audio:"level3_3"}]},init:[],exit:[]},{type:__WEBPACK_IMPORTED_MODULE_5__scenes_ThreeD_js__["a" /* default */],description:"Level 3",data:{round:3,environment:__WEBPACK_IMPORTED_MODULE_2__scenes_LevelBoss__["a" /* default */],duration:30,introDelay:4,outroDelay:5,bpm:140,speed:3,seq:[1,1,1,0,1,1,1,0,1,1,1,0,1,0,1,0],music:"music3",intro:"level3_4",outro:"level3_5",introPrompt:"RAGE CLICK THE ADS IN...",introBubble:"While we take the next step in canceling your subscription please enjoy these special offers.",outroBubble:"Error! Valued customer has successfully... CANCELED THEIR SUBSCRIPTION."},init:[],exit:[]}]};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(182);

/**
 * A specialized version of `_.sample` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @returns {*} Returns the random element.
 */
function arraySample(array) {
  var length = array.length;
  return length ? array[baseRandom(0, length - 1)] : undefined;
}

module.exports = arraySample;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(184),
    keys = __webpack_require__(186);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(79);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(80);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 81 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(204),
    isLength = __webpack_require__(81);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(210),
    isArrayLike = __webpack_require__(82),
    isString = __webpack_require__(214),
    toInteger = __webpack_require__(215),
    values = __webpack_require__(77);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDarkPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = destroyDarkPattern;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeDarkPattern;
/* unused harmony export createDarkPattern2d */
// MOBILE DETECT
function createDarkPattern(patternConfig){return{type:"CREATE_DARK_PATTERN",patternConfig:patternConfig};}function destroyDarkPattern(id,location){var soundnum=Math.floor(Math.random()*4+1).toString();return{type:"DESTROY_DARK_PATTERN",location:location,id:id,meta:{sound:"destroyAd"+soundnum,op:"playFx"}};}function removeDarkPattern(id,location){return{type:"DESTROY_DARK_PATTERN",location:location,id:id};}function createDarkPattern2d(patternConfig){return{type:"CREATE_DARK_PATTERN2D",patternConfig:patternConfig};}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = destroyExplosion;
/* harmony export (immutable) */ __webpack_exports__["a"] = createExplosion;
function destroyExplosion(id){return{type:"DESTROY_EXPLOSION",id:id};}function createExplosion(explosionConfig){return{type:"CREATE_EXPLOSION",explosionConfig:explosionConfig};}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * VERSION: 1.20.4
 * DATE: 2018-02-15
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
(function(window, moduleName) {

		"use strict";
		var _exports = {},
			_doc = window.document,
			_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
		if (_globals.TweenLite) {
			return; //in case the core set of classes is already loaded, don't instantiate twice.
		}
		var _namespace = function(ns) {
				var a = ns.split("."),
					p = _globals, i;
				for (i = 0; i < a.length; i++) {
					p[a[i]] = p = p[a[i]] || {};
				}
				return p;
			},
			gs = _namespace("com.greensock"),
			_tinyNum = 0.0000000001,
			_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++])) {}
				return b;
			},
			_emptyFunc = function() {},
			_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
				var toString = Object.prototype.toString,
					array = toString.call([]);
				return function(obj) {
					return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
				};
			}()),
			a, i, p, _ticker, _tickerActive,
			_defLookup = {},

			/**
			 * @constructor
			 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
			 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
			 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
			 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
			 *
			 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
			 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
			 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
			 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
			 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
			 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
			 * sandbox the banner one like:
			 *
			 * <script>
			 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
			 * </script>
			 * <script src="js/greensock/v1.7/TweenMax.js"></script>
			 * <script>
			 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
			 * </script>
			 * <script src="js/greensock/v1.6/TweenMax.js"></script>
			 * <script>
			 *     gs.TweenLite.to(...); //would use v1.7
			 *     TweenLite.to(...); //would use v1.6
			 * </script>
			 *
			 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
			 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
			 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
			 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
			 */
			Definition = function(ns, dependencies, func, global) {
				this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
				_defLookup[ns] = this;
				this.gsClass = null;
				this.func = func;
				var _classes = [];
				this.check = function(init) {
					var i = dependencies.length,
						missing = i,
						cur, a, n, cl;
					while (--i > -1) {
						if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
							_classes[i] = cur.gsClass;
							missing--;
						} else if (init) {
							cur.sc.push(this);
						}
					}
					if (missing === 0 && func) {
						a = ("com.greensock." + ns).split(".");
						n = a.pop();
						cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);

						//exports to multiple environments
						if (global) {
							_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
							if (typeof(module) !== "undefined" && module.exports) { //node
								if (ns === moduleName) {
									module.exports = _exports[moduleName] = cl;
									for (i in _exports) {
										cl[i] = _exports[i];
									}
								} else if (_exports[moduleName]) {
									_exports[moduleName][n] = cl;
								}
							} else if (true){ //AMD
								!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return cl; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
							}
						}
						for (i = 0; i < this.sc.length; i++) {
							this.sc[i].check();
						}
					}
				};
				this.check(true);
			},

			//used to create Definition instances (which basically registers a class that has dependencies).
			_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
				return new Definition(ns, dependencies, func, global);
			},

			//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
			_class = gs._class = function(ns, func, global) {
				func = func || function() {};
				_gsDefine(ns, [], function(){ return func; }, global);
				return func;
			};

		_gsDefine.globals = _globals;



/*
 * ----------------------------------------------------------------
 * Ease
 * ----------------------------------------------------------------
 */
		var _baseParams = [0, 0, 1, 1],
			Ease = _class("easing.Ease", function(func, extraParams, type, power) {
				this._func = func;
				this._type = type || 0;
				this._power = power || 0;
				this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
			}, true),
			_easeMap = Ease.map = {},
			_easeReg = Ease.register = function(ease, names, types, create) {
				var na = names.split(","),
					i = na.length,
					ta = (types || "easeIn,easeOut,easeInOut").split(","),
					e, name, j, type;
				while (--i > -1) {
					name = na[i];
					e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
					j = ta.length;
					while (--j > -1) {
						type = ta[j];
						_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
					}
				}
			};

		p = Ease.prototype;
		p._calcEnd = false;
		p.getRatio = function(p) {
			if (this._func) {
				this._params[0] = p;
				return this._func.apply(null, this._params);
			}
			var t = this._type,
				pw = this._power,
				r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
			if (pw === 1) {
				r *= r;
			} else if (pw === 2) {
				r *= r * r;
			} else if (pw === 3) {
				r *= r * r * r;
			} else if (pw === 4) {
				r *= r * r * r * r;
			}
			return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
		};

		//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
		a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
		i = a.length;
		while (--i > -1) {
			p = a[i]+",Power"+i;
			_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
			_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
			_easeReg(new Ease(null,null,3,i), p, "easeInOut");
		}
		_easeMap.linear = gs.easing.Linear.easeIn;
		_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks


/*
 * ----------------------------------------------------------------
 * EventDispatcher
 * ----------------------------------------------------------------
 */
		var EventDispatcher = _class("events.EventDispatcher", function(target) {
			this._listeners = {};
			this._eventTarget = target || this;
		});
		p = EventDispatcher.prototype;

		p.addEventListener = function(type, callback, scope, useParam, priority) {
			priority = priority || 0;
			var list = this._listeners[type],
				index = 0,
				listener, i;
			if (this === _ticker && !_tickerActive) {
				_ticker.wake();
			}
			if (list == null) {
				this._listeners[type] = list = [];
			}
			i = list.length;
			while (--i > -1) {
				listener = list[i];
				if (listener.c === callback && listener.s === scope) {
					list.splice(i, 1);
				} else if (index === 0 && listener.pr < priority) {
					index = i + 1;
				}
			}
			list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
		};

		p.removeEventListener = function(type, callback) {
			var list = this._listeners[type], i;
			if (list) {
				i = list.length;
				while (--i > -1) {
					if (list[i].c === callback) {
						list.splice(i, 1);
						return;
					}
				}
			}
		};

		p.dispatchEvent = function(type) {
			var list = this._listeners[type],
				i, t, listener;
			if (list) {
				i = list.length;
				if (i > 1) { 
					list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
				}
				t = this._eventTarget;
				while (--i > -1) {
					listener = list[i];
					if (listener) {
						if (listener.up) {
							listener.c.call(listener.s || t, {type:type, target:t});
						} else {
							listener.c.call(listener.s || t);
						}
					}
				}
			}
		};


/*
 * ----------------------------------------------------------------
 * Ticker
 * ----------------------------------------------------------------
 */
 		var _reqAnimFrame = window.requestAnimationFrame,
			_cancelAnimFrame = window.cancelAnimationFrame,
			_getTime = Date.now || function() {return new Date().getTime();},
			_lastUpdate = _getTime();

		//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
		a = ["ms","moz","webkit","o"];
		i = a.length;
		while (--i > -1 && !_reqAnimFrame) {
			_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
			_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
		}

		_class("Ticker", function(fps, useRAF) {
			var _self = this,
				_startTime = _getTime(),
				_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
				_lagThreshold = 500,
				_adjustedLag = 33,
				_tickWord = "tick", //helps reduce gc burden
				_fps, _req, _id, _gap, _nextTime,
				_tick = function(manual) {
					var elapsed = _getTime() - _lastUpdate,
						overlap, dispatch;
					if (elapsed > _lagThreshold) {
						_startTime += elapsed - _adjustedLag;
					}
					_lastUpdate += elapsed;
					_self.time = (_lastUpdate - _startTime) / 1000;
					overlap = _self.time - _nextTime;
					if (!_fps || overlap > 0 || manual === true) {
						_self.frame++;
						_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
						dispatch = true;
					}
					if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
						_id = _req(_tick);
					}
					if (dispatch) {
						_self.dispatchEvent(_tickWord);
					}
				};

			EventDispatcher.call(_self);
			_self.time = _self.frame = 0;
			_self.tick = function() {
				_tick(true);
			};

			_self.lagSmoothing = function(threshold, adjustedLag) {
				if (!arguments.length) { //if lagSmoothing() is called with no arguments, treat it like a getter that returns a boolean indicating if it's enabled or not. This is purposely undocumented and is for internal use.
					return (_lagThreshold < 1 / _tinyNum);
				}
				_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
				_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
			};

			_self.sleep = function() {
				if (_id == null) {
					return;
				}
				if (!_useRAF || !_cancelAnimFrame) {
					clearTimeout(_id);
				} else {
					_cancelAnimFrame(_id);
				}
				_req = _emptyFunc;
				_id = null;
				if (_self === _ticker) {
					_tickerActive = false;
				}
			};

			_self.wake = function(seamless) {
				if (_id !== null) {
					_self.sleep();
				} else if (seamless) {
					_startTime += -_lastUpdate + (_lastUpdate = _getTime());
				} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
					_lastUpdate = _getTime() - _lagThreshold + 5;
				}
				_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
				if (_self === _ticker) {
					_tickerActive = true;
				}
				_tick(2);
			};

			_self.fps = function(value) {
				if (!arguments.length) {
					return _fps;
				}
				_fps = value;
				_gap = 1 / (_fps || 60);
				_nextTime = this.time + _gap;
				_self.wake();
			};

			_self.useRAF = function(value) {
				if (!arguments.length) {
					return _useRAF;
				}
				_self.sleep();
				_useRAF = value;
				_self.fps(_fps);
			};
			_self.fps(fps);

			//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
			setTimeout(function() {
				if (_useRAF === "auto" && _self.frame < 5 && (_doc || {}).visibilityState !== "hidden") {
					_self.useRAF(false);
				}
			}, 1500);
		});

		p = gs.Ticker.prototype = new gs.events.EventDispatcher();
		p.constructor = gs.Ticker;


/*
 * ----------------------------------------------------------------
 * Animation
 * ----------------------------------------------------------------
 */
		var Animation = _class("core.Animation", function(duration, vars) {
				this.vars = vars = vars || {};
				this._duration = this._totalDuration = duration || 0;
				this._delay = Number(vars.delay) || 0;
				this._timeScale = 1;
				this._active = (vars.immediateRender === true);
				this.data = vars.data;
				this._reversed = (vars.reversed === true);

				if (!_rootTimeline) {
					return;
				}
				if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
					_ticker.wake();
				}

				var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
				tl.add(this, tl._time);

				if (this.vars.paused) {
					this.paused(true);
				}
			});

		_ticker = Animation.ticker = new gs.Ticker();
		p = Animation.prototype;
		p._dirty = p._gc = p._initted = p._paused = false;
		p._totalTime = p._time = 0;
		p._rawPrevTime = -1;
		p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
		p._paused = false;


		//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
		var _checkTimeout = function() {
				if (_tickerActive && _getTime() - _lastUpdate > 2000 && ((_doc || {}).visibilityState !== "hidden" || !_ticker.lagSmoothing())) { //note: if the tab is hidden, we should still wake if lagSmoothing has been disabled.
					_ticker.wake();
				}
				var t = setTimeout(_checkTimeout, 2000);
				if (t.unref) {
					// allows a node process to exit even if the timeout’s callback hasn't been invoked. Without it, the node process could hang as this function is called every two seconds.
					t.unref();
				}
			};
		_checkTimeout();


		p.play = function(from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.reversed(false).paused(false);
		};

		p.pause = function(atTime, suppressEvents) {
			if (atTime != null) {
				this.seek(atTime, suppressEvents);
			}
			return this.paused(true);
		};

		p.resume = function(from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.paused(false);
		};

		p.seek = function(time, suppressEvents) {
			return this.totalTime(Number(time), suppressEvents !== false);
		};

		p.restart = function(includeDelay, suppressEvents) {
			return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
		};

		p.reverse = function(from, suppressEvents) {
			if (from != null) {
				this.seek((from || this.totalDuration()), suppressEvents);
			}
			return this.reversed(true).paused(false);
		};

		p.render = function(time, suppressEvents, force) {
			//stub - we override this method in subclasses.
		};

		p.invalidate = function() {
			this._time = this._totalTime = 0;
			this._initted = this._gc = false;
			this._rawPrevTime = -1;
			if (this._gc || !this.timeline) {
				this._enabled(true);
			}
			return this;
		};

		p.isActive = function() {
			var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
				startTime = this._startTime,
				rawTime;
			return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime(true)) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale - 0.0000001));
		};

		p._enabled = function (enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			this._gc = !enabled;
			this._active = this.isActive();
			if (ignoreTimeline !== true) {
				if (enabled && !this.timeline) {
					this._timeline.add(this, this._startTime - this._delay);
				} else if (!enabled && this.timeline) {
					this._timeline._remove(this, true);
				}
			}
			return false;
		};


		p._kill = function(vars, target) {
			return this._enabled(false, false);
		};

		p.kill = function(vars, target) {
			this._kill(vars, target);
			return this;
		};

		p._uncache = function(includeSelf) {
			var tween = includeSelf ? this : this.timeline;
			while (tween) {
				tween._dirty = true;
				tween = tween.timeline;
			}
			return this;
		};

		p._swapSelfInParams = function(params) {
			var i = params.length,
				copy = params.concat();
			while (--i > -1) {
				if (params[i] === "{self}") {
					copy[i] = this;
				}
			}
			return copy;
		};

		p._callback = function(type) {
			var v = this.vars,
				callback = v[type],
				params = v[type + "Params"],
				scope = v[type + "Scope"] || v.callbackScope || this,
				l = params ? params.length : 0;
			switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
				case 0: callback.call(scope); break;
				case 1: callback.call(scope, params[0]); break;
				case 2: callback.call(scope, params[0], params[1]); break;
				default: callback.apply(scope, params);
			}
		};

//----Animation getters/setters --------------------------------------------------------

		p.eventCallback = function(type, callback, params, scope) {
			if ((type || "").substr(0,2) === "on") {
				var v = this.vars;
				if (arguments.length === 1) {
					return v[type];
				}
				if (callback == null) {
					delete v[type];
				} else {
					v[type] = callback;
					v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
					v[type + "Scope"] = scope;
				}
				if (type === "onUpdate") {
					this._onUpdate = callback;
				}
			}
			return this;
		};

		p.delay = function(value) {
			if (!arguments.length) {
				return this._delay;
			}
			if (this._timeline.smoothChildTiming) {
				this.startTime( this._startTime + value - this._delay );
			}
			this._delay = value;
			return this;
		};

		p.duration = function(value) {
			if (!arguments.length) {
				this._dirty = false;
				return this._duration;
			}
			this._duration = this._totalDuration = value;
			this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
			if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
				this.totalTime(this._totalTime * (value / this._duration), true);
			}
			return this;
		};

		p.totalDuration = function(value) {
			this._dirty = false;
			return (!arguments.length) ? this._totalDuration : this.duration(value);
		};

		p.time = function(value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
		};

		p.totalTime = function(time, suppressEvents, uncapped) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (!arguments.length) {
				return this._totalTime;
			}
			if (this._timeline) {
				if (time < 0 && !uncapped) {
					time += this.totalDuration();
				}
				if (this._timeline.smoothChildTiming) {
					if (this._dirty) {
						this.totalDuration();
					}
					var totalDuration = this._totalDuration,
						tl = this._timeline;
					if (time > totalDuration && !uncapped) {
						time = totalDuration;
					}
					this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
					if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
						this._uncache(false);
					}
					//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
					if (tl._timeline) {
						while (tl._timeline) {
							if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
								tl.totalTime(tl._totalTime, true);
							}
							tl = tl._timeline;
						}
					}
				}
				if (this._gc) {
					this._enabled(true, false);
				}
				if (this._totalTime !== time || this._duration === 0) {
					if (_lazyTweens.length) {
						_lazyRender();
					}
					this.render(time, suppressEvents, false);
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
						_lazyRender();
					}
				}
			}
			return this;
		};

		p.progress = p.totalProgress = function(value, suppressEvents) {
			var duration = this.duration();
			return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
		};

		p.startTime = function(value) {
			if (!arguments.length) {
				return this._startTime;
			}
			if (value !== this._startTime) {
				this._startTime = value;
				if (this.timeline) if (this.timeline._sortChildren) {
					this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
				}
			}
			return this;
		};

		p.endTime = function(includeRepeats) {
			return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
		};

		p.timeScale = function(value) {
			if (!arguments.length) {
				return this._timeScale;
			}
			var pauseTime, t;
			value = value || _tinyNum; //can't allow zero because it'll throw the math off
			if (this._timeline && this._timeline.smoothChildTiming) {
				pauseTime = this._pauseTime;
				t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
				this._startTime = t - ((t - this._startTime) * this._timeScale / value);
			}
			this._timeScale = value;
			t = this.timeline;
			while (t && t.timeline) { //must update the duration/totalDuration of all ancestor timelines immediately in case in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
				t._dirty = true;
				t.totalDuration();
				t = t.timeline;
			}
			return this;
		};

		p.reversed = function(value) {
			if (!arguments.length) {
				return this._reversed;
			}
			if (value != this._reversed) {
				this._reversed = value;
				this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
			}
			return this;
		};

		p.paused = function(value) {
			if (!arguments.length) {
				return this._paused;
			}
			var tl = this._timeline,
				raw, elapsed;
			if (value != this._paused) if (tl) {
				if (!_tickerActive && !value) {
					_ticker.wake();
				}
				raw = tl.rawTime();
				elapsed = raw - this._pauseTime;
				if (!value && tl.smoothChildTiming) {
					this._startTime += elapsed;
					this._uncache(false);
				}
				this._pauseTime = value ? raw : null;
				this._paused = value;
				this._active = this.isActive();
				if (!value && elapsed !== 0 && this._initted && this.duration()) {
					raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
					this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
				}
			}
			if (this._gc && !value) {
				this._enabled(true, false);
			}
			return this;
		};


/*
 * ----------------------------------------------------------------
 * SimpleTimeline
 * ----------------------------------------------------------------
 */
		var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
			Animation.call(this, 0, vars);
			this.autoRemoveChildren = this.smoothChildTiming = true;
		});

		p = SimpleTimeline.prototype = new Animation();
		p.constructor = SimpleTimeline;
		p.kill()._gc = false;
		p._first = p._last = p._recent = null;
		p._sortChildren = false;

		p.add = p.insert = function(child, position, align, stagger) {
			var prevTween, st;
			child._startTime = Number(position || 0) + child._delay;
			if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
				child._pauseTime = child._startTime + ((this.rawTime() - child._startTime) / child._timeScale);
			}
			if (child.timeline) {
				child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
			}
			child.timeline = child._timeline = this;
			if (child._gc) {
				child._enabled(true, true);
			}
			prevTween = this._last;
			if (this._sortChildren) {
				st = child._startTime;
				while (prevTween && prevTween._startTime > st) {
					prevTween = prevTween._prev;
				}
			}
			if (prevTween) {
				child._next = prevTween._next;
				prevTween._next = child;
			} else {
				child._next = this._first;
				this._first = child;
			}
			if (child._next) {
				child._next._prev = child;
			} else {
				this._last = child;
			}
			child._prev = prevTween;
			this._recent = child;
			if (this._timeline) {
				this._uncache(true);
			}
			return this;
		};

		p._remove = function(tween, skipDisable) {
			if (tween.timeline === this) {
				if (!skipDisable) {
					tween._enabled(false, true);
				}

				if (tween._prev) {
					tween._prev._next = tween._next;
				} else if (this._first === tween) {
					this._first = tween._next;
				}
				if (tween._next) {
					tween._next._prev = tween._prev;
				} else if (this._last === tween) {
					this._last = tween._prev;
				}
				tween._next = tween._prev = tween.timeline = null;
				if (tween === this._recent) {
					this._recent = this._last;
				}

				if (this._timeline) {
					this._uncache(true);
				}
			}
			return this;
		};

		p.render = function(time, suppressEvents, force) {
			var tween = this._first,
				next;
			this._totalTime = this._time = this._rawPrevTime = time;
			while (tween) {
				next = tween._next; //record it here because the value could change after rendering...
				if (tween._active || (time >= tween._startTime && !tween._paused && !tween._gc)) {
					if (!tween._reversed) {
						tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
					} else {
						tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
					}
				}
				tween = next;
			}
		};

		p.rawTime = function() {
			if (!_tickerActive) {
				_ticker.wake();
			}
			return this._totalTime;
		};

/*
 * ----------------------------------------------------------------
 * TweenLite
 * ----------------------------------------------------------------
 */
		var TweenLite = _class("TweenLite", function(target, duration, vars) {
				Animation.call(this, duration, vars);
				this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)

				if (target == null) {
					throw "Cannot tween a null target.";
				}

				this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;

				var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
					overwrite = this.vars.overwrite,
					i, targ, targets;

				this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];

				if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
					this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					this._propLookup = [];
					this._siblings = [];
					for (i = 0; i < targets.length; i++) {
						targ = targets[i];
						if (!targ) {
							targets.splice(i--, 1);
							continue;
						} else if (typeof(targ) === "string") {
							targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
							if (typeof(targ) === "string") {
								targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
							}
							continue;
						} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
							targets.splice(i--, 1);
							this._targets = targets = targets.concat(_slice(targ));
							continue;
						}
						this._siblings[i] = _register(targ, this, false);
						if (overwrite === 1) if (this._siblings[i].length > 1) {
							_applyOverwrite(targ, this, null, 1, this._siblings[i]);
						}
					}

				} else {
					this._propLookup = {};
					this._siblings = _register(target, this, false);
					if (overwrite === 1) if (this._siblings.length > 1) {
						_applyOverwrite(target, this, null, 1, this._siblings);
					}
				}
				if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative
				}
			}, true),
			_isSelector = function(v) {
				return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
			},
			_autoCSS = function(vars, target) {
				var css = {},
					p;
				for (p in vars) {
					if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
						css[p] = vars[p];
						delete vars[p];
					}
				}
				vars.css = css;
			};

		p = TweenLite.prototype = new Animation();
		p.constructor = TweenLite;
		p.kill()._gc = false;

//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------

		p.ratio = 0;
		p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
		p._notifyPluginsOfEnabled = p._lazy = false;

		TweenLite.version = "1.20.4";
		TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
		TweenLite.defaultOverwrite = "auto";
		TweenLite.ticker = _ticker;
		TweenLite.autoSleep = 120;
		TweenLite.lagSmoothing = function(threshold, adjustedLag) {
			_ticker.lagSmoothing(threshold, adjustedLag);
		};

		TweenLite.selector = window.$ || window.jQuery || function(e) {
			var selector = window.$ || window.jQuery;
			if (selector) {
				TweenLite.selector = selector;
				return selector(e);
			}
			return (typeof(_doc) === "undefined") ? e : (_doc.querySelectorAll ? _doc.querySelectorAll(e) : _doc.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
		};

		var _lazyTweens = [],
			_lazyLookup = {},
			_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
			_relExp = /[\+-]=-?[\.\d]/,
			//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
			_setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val;
				while (pt) {
					val = !pt.blob ? pt.c * v + pt.s : (v === 1 && this.end != null) ? this.end : v ? this.join("") : this.start;
					if (pt.m) {
						val = pt.m(val, this._target || pt.t);
					} else if (val < min) if (val > -min && !pt.blob) { //prevents issues with converting very small numbers to strings in the browser
						val = 0;
					}
					if (!pt.f) {
						pt.t[pt.p] = val;
					} else if (pt.fp) {
						pt.t[pt.p](pt.fp, val);
					} else {
						pt.t[pt.p](val);
					}
					pt = pt._next;
				}
			},
			//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
			_blobDif = function(start, end, filter, pt) {
				var a = [],
					charIndex = 0,
					s = "",
					color = 0,
					startNums, endNums, num, i, l, nonNumbers, currentNum;
				a.start = start;
				a.end = end;
				start = a[0] = start + ""; //ensure values are strings
				end = a[1] = end + "";
				if (filter) {
					filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
					start = a[0];
					end = a[1];
				}
				a.length = 0;
				startNums = start.match(_numbersExp) || [];
				endNums = end.match(_numbersExp) || [];
				if (pt) {
					pt._next = null;
					pt.blob = 1;
					a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
				}
				l = endNums.length;
				for (i = 0; i < l; i++) {
					currentNum = endNums[i];
					nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
					s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
					charIndex += nonNumbers.length;
					if (color) { //sense rgba() values and round them.
						color = (color + 1) % 5;
					} else if (nonNumbers.substr(-5) === "rgba(") {
						color = 1;
					}
					if (currentNum === startNums[i] || startNums.length <= i) {
						s += currentNum;
					} else {
						if (s) {
							a.push(s);
							s = "";
						}
						num = parseFloat(startNums[i]);
						a.push(num);
						a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : 0};
						//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
					}
					charIndex += currentNum.length;
				}
				s += end.substr(charIndex);
				if (s) {
					a.push(s);
				}
				a.setRatio = _setRatio;
				if (_relExp.test(end)) { //if the end string contains relative values, delete it so that on the final render (in _setRatio()), we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
					a.end = null;
				}
				return a;
			},
			//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
			_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
				if (typeof(end) === "function") {
					end = end(index || 0, target);
				}
				var type = typeof(target[prop]),
					getterName = (type !== "function") ? "" : ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3)),
					s = (start !== "get") ? start : !getterName ? target[prop] : funcParam ? target[getterName](funcParam) : target[getterName](),
					isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
					pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
					blob;

				if (typeof(s) !== "number" || (typeof(end) !== "number" && !isRelative)) {
					if (funcParam || isNaN(s) || (!isRelative && isNaN(end)) || typeof(s) === "boolean" || typeof(end) === "boolean") {
						//a blob (string that has multiple numbers in it)
						pt.fp = funcParam;
						blob = _blobDif(s, (isRelative ? (parseFloat(pt.s) + pt.c) + (pt.s + "").replace(/[0-9\-\.]/g, "") : end), stringFilter || TweenLite.defaultStringFilter, pt);
						pt = {t: blob, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: overwriteProp || prop, pr: 0, m: 0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
					} else {
						pt.s = parseFloat(s);
						if (!isRelative) {
							pt.c = (parseFloat(end) - pt.s) || 0;
						}
					}
				}
				if (pt.c) { //only add it to the linked list if there's a change.
					if ((pt._next = this._firstPT)) {
						pt._next._prev = pt;
					}
					this._firstPT = pt;
					return pt;
				}
			},
			_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
			_plugins = TweenLite._plugins = {},
			_tweenLookup = _internals.tweenLookup = {},
			_tweenLookupNum = 0,
			_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1, yoyoEase:1},
			_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
			_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
			_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
			_nextGCFrame = 30,
			_lazyRender = _internals.lazyRender = function() {
				var i = _lazyTweens.length,
					tween;
				_lazyLookup = {};
				while (--i > -1) {
					tween = _lazyTweens[i];
					if (tween && tween._lazy !== false) {
						tween.render(tween._lazy[0], tween._lazy[1], true);
						tween._lazy = false;
					}
				}
				_lazyTweens.length = 0;
			};

		_rootTimeline._startTime = _ticker.time;
		_rootFramesTimeline._startTime = _ticker.frame;
		_rootTimeline._active = _rootFramesTimeline._active = true;
		setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".

		Animation._updateRoot = TweenLite.render = function() {
				var i, a, p;
				if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
					_lazyRender();
				}
				_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
				_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
				if (_lazyTweens.length) {
					_lazyRender();
				}
				if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
					_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
					for (p in _tweenLookup) {
						a = _tweenLookup[p].tweens;
						i = a.length;
						while (--i > -1) {
							if (a[i]._gc) {
								a.splice(i, 1);
							}
						}
						if (a.length === 0) {
							delete _tweenLookup[p];
						}
					}
					//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
					p = _rootTimeline._first;
					if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
						while (p && p._paused) {
							p = p._next;
						}
						if (!p) {
							_ticker.sleep();
						}
					}
				}
			};

		_ticker.addEventListener("tick", Animation._updateRoot);

		var _register = function(target, tween, scrub) {
				var id = target._gsTweenID, a, i;
				if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
					_tweenLookup[id] = {target:target, tweens:[]};
				}
				if (tween) {
					a = _tweenLookup[id].tweens;
					a[(i = a.length)] = tween;
					if (scrub) {
						while (--i > -1) {
							if (a[i] === tween) {
								a.splice(i, 1);
							}
						}
					}
				}
				return _tweenLookup[id].tweens;
			},
			_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
				var func = overwrittenTween.vars.onOverwrite, r1, r2;
				if (func) {
					r1 = func(overwrittenTween, overwritingTween, target, killedProps);
				}
				func = TweenLite.onOverwrite;
				if (func) {
					r2 = func(overwrittenTween, overwritingTween, target, killedProps);
				}
				return (r1 !== false && r2 !== false);
			},
			_applyOverwrite = function(target, tween, props, mode, siblings) {
				var i, changed, curTween, l;
				if (mode === 1 || mode >= 4) {
					l = siblings.length;
					for (i = 0; i < l; i++) {
						if ((curTween = siblings[i]) !== tween) {
							if (!curTween._gc) {
								if (curTween._kill(null, target, tween)) {
									changed = true;
								}
							}
						} else if (mode === 5) {
							break;
						}
					}
					return changed;
				}
				//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
				var startTime = tween._startTime + _tinyNum,
					overlaps = [],
					oCount = 0,
					zeroDur = (tween._duration === 0),
					globalStart;
				i = siblings.length;
				while (--i > -1) {
					if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
						//ignore
					} else if (curTween._timeline !== tween._timeline) {
						globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
						if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
							overlaps[oCount++] = curTween;
						}
					} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
						overlaps[oCount++] = curTween;
					}
				}

				i = oCount;
				while (--i > -1) {
					curTween = overlaps[i];
					if (mode === 2) if (curTween._kill(props, target, tween)) {
						changed = true;
					}
					if (mode !== 2 || (!curTween._firstPT && curTween._initted)) {
						if (mode !== 2 && !_onOverwrite(curTween, tween)) {
							continue;
						}
						if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
							changed = true;
						}
					}
				}
				return changed;
			},
			_checkOverlap = function(tween, reference, zeroDur) {
				var tl = tween._timeline,
					ts = tl._timeScale,
					t = tween._startTime;
				while (tl._timeline) {
					t += tl._startTime;
					ts *= tl._timeScale;
					if (tl._paused) {
						return -100;
					}
					tl = tl._timeline;
				}
				t /= ts;
				return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
			};


//---- TweenLite instance methods -----------------------------------------------------------------------------

		p._init = function() {
			var v = this.vars,
				op = this._overwrittenProps,
				dur = this._duration,
				immediate = !!v.immediateRender,
				ease = v.ease,
				i, initPlugins, pt, p, startVars, l;
			if (v.startAt) {
				if (this._startAt) {
					this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
					this._startAt.kill();
				}
				startVars = {};
				for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
					startVars[p] = v.startAt[p];
				}
				startVars.data = "isStart";
				startVars.overwrite = false;
				startVars.immediateRender = true;
				startVars.lazy = (immediate && v.lazy !== false);
				startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
				startVars.onUpdate = v.onUpdate;
				startVars.onUpdateParams = v.onUpdateParams;
				startVars.onUpdateScope = v.onUpdateScope || v.callbackScope || this;
				this._startAt = TweenLite.to(this.target, 0, startVars);
				if (immediate) {
					if (this._time > 0) {
						this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
					} else if (dur !== 0) {
						return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
					}
				}
			} else if (v.runBackwards && dur !== 0) {
				//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
				if (this._startAt) {
					this._startAt.render(-1, true);
					this._startAt.kill();
					this._startAt = null;
				} else {
					if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
						immediate = false;
					}
					pt = {};
					for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
						if (!_reservedProps[p] || p === "autoCSS") {
							pt[p] = v[p];
						}
					}
					pt.overwrite = 0;
					pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
					pt.lazy = (immediate && v.lazy !== false);
					pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
					this._startAt = TweenLite.to(this.target, 0, pt);
					if (!immediate) {
						this._startAt._init(); //ensures that the initial values are recorded
						this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
						if (this.vars.immediateRender) {
							this._startAt = null;
						}
					} else if (this._time === 0) {
						return;
					}
				}
			}
			this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
			if (v.easeParams instanceof Array && ease.config) {
				this._ease = ease.config.apply(ease, v.easeParams);
			}
			this._easeType = this._ease._type;
			this._easePower = this._ease._power;
			this._firstPT = null;

			if (this._targets) {
				l = this._targets.length;
				for (i = 0; i < l; i++) {
					if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
						initPlugins = true;
					}
				}
			} else {
				initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
			}

			if (initPlugins) {
				TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
			}
			if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
				this._enabled(false, false);
			}
			if (v.runBackwards) {
				pt = this._firstPT;
				while (pt) {
					pt.s += pt.c;
					pt.c = -pt.c;
					pt = pt._next;
				}
			}
			this._onUpdate = v.onUpdate;
			this._initted = true;
		};

		p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
			var p, i, initPlugins, plugin, pt, v;
			if (target == null) {
				return false;
			}

			if (_lazyLookup[target._gsTweenID]) {
				_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
			}

			if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
				_autoCSS(this.vars, target);
			}
			for (p in this.vars) {
				v = this.vars[p];
				if (_reservedProps[p]) {
					if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
						this.vars[p] = v = this._swapSelfInParams(v, this);
					}

				} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {

					//t - target 		[object]
					//p - property 		[string]
					//s - start			[number]
					//c - change		[number]
					//f - isFunction	[boolean]
					//n - name			[string]
					//pg - isPlugin 	[boolean]
					//pr - priority		[number]
					//m - mod           [function | 0]
					this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
					i = plugin._overwriteProps.length;
					while (--i > -1) {
						propLookup[plugin._overwriteProps[i]] = this._firstPT;
					}
					if (plugin._priority || plugin._onInitAllProps) {
						initPlugins = true;
					}
					if (plugin._onDisable || plugin._onEnable) {
						this._notifyPluginsOfEnabled = true;
					}
					if (pt._next) {
						pt._next._prev = pt;
					}

				} else {
					propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
				}
			}

			if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
				return this._initProps(target, propLookup, siblings, overwrittenProps, index);
			}
			if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
				this._kill(propLookup, target);
				return this._initProps(target, propLookup, siblings, overwrittenProps, index);
			}
			if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
				_lazyLookup[target._gsTweenID] = true;
			}
			return initPlugins;
		};

		p.render = function(time, suppressEvents, force) {
			var prevTime = this._time,
				duration = this._duration,
				prevRawPrevTime = this._rawPrevTime,
				isComplete, callback, pt, rawPrevTime;
			if (time >= duration - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
				this._totalTime = this._time = duration;
				this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
				if (!this._reversed ) {
					isComplete = true;
					callback = "onComplete";
					force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
				}
				if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
					if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
						time = 0;
					}
					if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
						force = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
					this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				}

			} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
				this._totalTime = this._time = 0;
				this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
				if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
					callback = "onReverseComplete";
					isComplete = this._reversed;
				}
				if (time < 0) {
					this._active = false;
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
							force = true;
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
				}
				if (!this._initted || (this._startAt && this._startAt.progress())) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately. Also, we check progress() because if startAt has already rendered at its end, we should force a render at its beginning. Otherwise, if you put the playhead directly on top of where a fromTo({immediateRender:false}) starts, and then move it backwards, the from() won't revert its values.
					force = true;
				}
			} else {
				this._totalTime = this._time = time;

				if (this._easeType) {
					var r = time / duration, type = this._easeType, pow = this._easePower;
					if (type === 1 || (type === 3 && r >= 0.5)) {
						r = 1 - r;
					}
					if (type === 3) {
						r *= 2;
					}
					if (pow === 1) {
						r *= r;
					} else if (pow === 2) {
						r *= r * r;
					} else if (pow === 3) {
						r *= r * r * r;
					} else if (pow === 4) {
						r *= r * r * r * r;
					}

					if (type === 1) {
						this.ratio = 1 - r;
					} else if (type === 2) {
						this.ratio = r;
					} else if (time / duration < 0.5) {
						this.ratio = r / 2;
					} else {
						this.ratio = 1 - (r / 2);
					}

				} else {
					this.ratio = this._ease.getRatio(time / duration);
				}
			}

			if (this._time === prevTime && !force) {
				return;
			} else if (!this._initted) {
				this._init();
				if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
					return;
				} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) {
					this._time = this._totalTime = prevTime;
					this._rawPrevTime = prevRawPrevTime;
					_lazyTweens.push(this);
					this._lazy = [time, suppressEvents];
					return;
				}
				//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
				if (this._time && !isComplete) {
					this.ratio = this._ease.getRatio(this._time / duration);
				} else if (isComplete && this._ease._calcEnd) {
					this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
				}
			}
			if (this._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
				this._lazy = false;
			}
			if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
				this._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
			}
			if (prevTime === 0) {
				if (this._startAt) {
					if (time >= 0) {
						this._startAt.render(time, true, force);
					} else if (!callback) {
						callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
					}
				}
				if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
					this._callback("onStart");
				}
			}
			pt = this._firstPT;
			while (pt) {
				if (pt.f) {
					pt.t[pt.p](pt.c * this.ratio + pt.s);
				} else {
					pt.t[pt.p] = pt.c * this.ratio + pt.s;
				}
				pt = pt._next;
			}

			if (this._onUpdate) {
				if (time < 0) if (this._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					this._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
				}
				if (!suppressEvents) if (this._time !== prevTime || isComplete || force) {
					this._callback("onUpdate");
				}
			}
			if (callback) if (!this._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
				if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
					this._startAt.render(time, true, force);
				}
				if (isComplete) {
					if (this._timeline.autoRemoveChildren) {
						this._enabled(false, false);
					}
					this._active = false;
				}
				if (!suppressEvents && this.vars[callback]) {
					this._callback(callback);
				}
				if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
					this._rawPrevTime = 0;
				}
			}
		};

		p._kill = function(vars, target, overwritingTween) {
			if (vars === "all") {
				vars = null;
			}
			if (vars == null) if (target == null || target === this.target) {
				this._lazy = false;
				return this._enabled(false, false);
			}
			target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
			var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
				i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
			if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
				i = target.length;
				while (--i > -1) {
					if (this._kill(vars, target[i], overwritingTween)) {
						changed = true;
					}
				}
			} else {
				if (this._targets) {
					i = this._targets.length;
					while (--i > -1) {
						if (target === this._targets[i]) {
							propLookup = this._propLookup[i] || {};
							this._overwrittenProps = this._overwrittenProps || [];
							overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
							break;
						}
					}
				} else if (target !== this.target) {
					return false;
				} else {
					propLookup = this._propLookup;
					overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
				}

				if (propLookup) {
					killProps = vars || propLookup;
					record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
					if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
						for (p in killProps) {
							if (propLookup[p]) {
								if (!killed) {
									killed = [];
								}
								killed.push(p);
							}
						}
						if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
							return false;
						}
					}

					for (p in killProps) {
						if ((pt = propLookup[p])) {
							if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
								if (pt.f) {
									pt.t[pt.p](pt.s);
								} else {
									pt.t[pt.p] = pt.s;
								}
								changed = true;
							}
							if (pt.pg && pt.t._kill(killProps)) {
								changed = true; //some plugins need to be notified so they can perform cleanup tasks first
							}
							if (!pt.pg || pt.t._overwriteProps.length === 0) {
								if (pt._prev) {
									pt._prev._next = pt._next;
								} else if (pt === this._firstPT) {
									this._firstPT = pt._next;
								}
								if (pt._next) {
									pt._next._prev = pt._prev;
								}
								pt._next = pt._prev = null;
							}
							delete propLookup[p];
						}
						if (record) {
							overwrittenProps[p] = 1;
						}
					}
					if (!this._firstPT && this._initted) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
						this._enabled(false, false);
					}
				}
			}
			return changed;
		};

		p.invalidate = function() {
			if (this._notifyPluginsOfEnabled) {
				TweenLite._onPluginEvent("_onDisable", this);
			}
			this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
			this._notifyPluginsOfEnabled = this._active = this._lazy = false;
			this._propLookup = (this._targets) ? {} : [];
			Animation.prototype.invalidate.call(this);
			if (this.vars.immediateRender) {
				this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
				this.render(Math.min(0, -this._delay)); //in case delay is negative.
			}
			return this;
		};

		p._enabled = function(enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (enabled && this._gc) {
				var targets = this._targets,
					i;
				if (targets) {
					i = targets.length;
					while (--i > -1) {
						this._siblings[i] = _register(targets[i], this, true);
					}
				} else {
					this._siblings = _register(this.target, this, true);
				}
			}
			Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
			if (this._notifyPluginsOfEnabled) if (this._firstPT) {
				return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
			}
			return false;
		};


//----TweenLite static methods -----------------------------------------------------

		TweenLite.to = function(target, duration, vars) {
			return new TweenLite(target, duration, vars);
		};

		TweenLite.from = function(target, duration, vars) {
			vars.runBackwards = true;
			vars.immediateRender = (vars.immediateRender != false);
			return new TweenLite(target, duration, vars);
		};

		TweenLite.fromTo = function(target, duration, fromVars, toVars) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return new TweenLite(target, duration, toVars);
		};

		TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
			return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
		};

		TweenLite.set = function(target, vars) {
			return new TweenLite(target, 0, vars);
		};

		TweenLite.getTweensOf = function(target, onlyActive) {
			if (target == null) { return []; }
			target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
			var i, a, j, t;
			if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
				i = target.length;
				a = [];
				while (--i > -1) {
					a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
				}
				i = a.length;
				//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
				while (--i > -1) {
					t = a[i];
					j = i;
					while (--j > -1) {
						if (t === a[j]) {
							a.splice(i, 1);
						}
					}
				}
			} else if (target._gsTweenID) {
				a = _register(target).concat();
				i = a.length;
				while (--i > -1) {
					if (a[i]._gc || (onlyActive && !a[i].isActive())) {
						a.splice(i, 1);
					}
				}
			}
			return a || [];
		};

		TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
			if (typeof(onlyActive) === "object") {
				vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
				onlyActive = false;
			}
			var a = TweenLite.getTweensOf(target, onlyActive),
				i = a.length;
			while (--i > -1) {
				a[i]._kill(vars, target);
			}
		};



/*
 * ----------------------------------------------------------------
 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
 * ----------------------------------------------------------------
 */
		var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
					this._overwriteProps = (props || "").split(",");
					this._propName = this._overwriteProps[0];
					this._priority = priority || 0;
					this._super = TweenPlugin.prototype;
				}, true);

		p = TweenPlugin.prototype;
		TweenPlugin.version = "1.19.0";
		TweenPlugin.API = 2;
		p._firstPT = null;
		p._addTween = _addPropTween;
		p.setRatio = _setRatio;

		p._kill = function(lookup) {
			var a = this._overwriteProps,
				pt = this._firstPT,
				i;
			if (lookup[this._propName] != null) {
				this._overwriteProps = [];
			} else {
				i = a.length;
				while (--i > -1) {
					if (lookup[a[i]] != null) {
						a.splice(i, 1);
					}
				}
			}
			while (pt) {
				if (lookup[pt.n] != null) {
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
						pt._prev = null;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
					}
				}
				pt = pt._next;
			}
			return false;
		};

		p._mod = p._roundProps = function(lookup) {
			var pt = this._firstPT,
				val;
			while (pt) {
				val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
				if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
					if (pt.f === 2) {
						pt.t._applyPT.m = val;
					} else {
						pt.m = val;
					}
				}
				pt = pt._next;
			}
		};

		TweenLite._onPluginEvent = function(type, tween) {
			var pt = tween._firstPT,
				changed, pt2, first, last, next;
			if (type === "_onInitAllProps") {
				//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
				while (pt) {
					next = pt._next;
					pt2 = first;
					while (pt2 && pt2.pr > pt.pr) {
						pt2 = pt2._next;
					}
					if ((pt._prev = pt2 ? pt2._prev : last)) {
						pt._prev._next = pt;
					} else {
						first = pt;
					}
					if ((pt._next = pt2)) {
						pt2._prev = pt;
					} else {
						last = pt;
					}
					pt = next;
				}
				pt = tween._firstPT = first;
			}
			while (pt) {
				if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
					changed = true;
				}
				pt = pt._next;
			}
			return changed;
		};

		TweenPlugin.activate = function(plugins) {
			var i = plugins.length;
			while (--i > -1) {
				if (plugins[i].API === TweenPlugin.API) {
					_plugins[(new plugins[i]())._propName] = plugins[i];
				}
			}
			return true;
		};

		//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
		_gsDefine.plugin = function(config) {
			if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
			var propName = config.propName,
				priority = config.priority || 0,
				overwriteProps = config.overwriteProps,
				map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
				Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
					function() {
						TweenPlugin.call(this, propName, priority);
						this._overwriteProps = overwriteProps || [];
					}, (config.global === true)),
				p = Plugin.prototype = new TweenPlugin(propName),
				prop;
			p.constructor = Plugin;
			Plugin.API = config.API;
			for (prop in map) {
				if (typeof(config[prop]) === "function") {
					p[map[prop]] = config[prop];
				}
			}
			Plugin.version = config.version;
			TweenPlugin.activate([Plugin]);
			return Plugin;
		};


		//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
		a = window._gsQueue;
		if (a) {
			for (i = 0; i < a.length; i++) {
				a[i]();
			}
			for (p in _defLookup) {
				if (!_defLookup[p].func) {
					window.console.log("GSAP encountered missing dependency: " + p);
				}
			}
		}

		_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated

})((typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window, "TweenLite");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Facebook = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(6);

var _singlePlayer = __webpack_require__(7);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//connect.facebook.net/en_US/sdk.js';
var SDK_GLOBAL = 'FB';
var SDK_GLOBAL_READY = 'fbAsyncInit';
var MATCH_URL = /facebook\.com\/([^/?].+\/)?video(s|\.php)[/?].*$/;
var PLAYER_ID_PREFIX = 'facebook-player-';

var Facebook = exports.Facebook = function (_Component) {
  _inherits(Facebook, _Component);

  function Facebook() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Facebook);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Facebook.__proto__ || Object.getPrototypeOf(Facebook)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unmute');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Facebook, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      if (isReady) {
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
          return FB.XFBML.parse();
        });
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
        FB.init({
          appId: _this2.props.config.facebook.appId,
          xfbml: true,
          version: 'v2.5'
        });
        FB.Event.subscribe('xfbml.render', function (msg) {
          // Here we know the SDK has loaded, even if onReady/onPlay
          // is not called due to a video that cannot be embedded
          _this2.props.onLoaded();
        });
        FB.Event.subscribe('xfbml.ready', function (msg) {
          if (msg.type === 'video' && msg.id === _this2.playerID) {
            _this2.player = msg.instance;
            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);
            _this2.player.subscribe('paused', _this2.props.onPause);
            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);
            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);
            _this2.player.subscribe('error', _this2.props.onError);
            if (!_this2.props.muted) {
              // Player is muted by default
              _this2.callPlayer('unmute');
            }
            _this2.props.onReady();

            // For some reason Facebook have added `visibility: hidden`
            // to the iframe when autoplay fails, so here we set it back
            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
          }
        });
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentPosition');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        width: '100%',
        height: '100%',
        backgroundColor: 'black'
      };
      return _react2['default'].createElement('div', {
        style: style,
        id: this.playerID,
        className: 'fb-video',
        'data-href': this.props.url,
        'data-autoplay': this.props.playing ? 'true' : 'false',
        'data-allowfullscreen': 'true',
        'data-controls': this.props.controls ? 'true' : 'false'
      });
    }
  }]);

  return Facebook;
}(_react.Component);

Facebook.displayName = 'Facebook';

Facebook.canPlay = function (url) {
  return MATCH_URL.test(url);
};

Facebook.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Facebook);

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Streamable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(6);

var _singlePlayer = __webpack_require__(7);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';
var MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;

var Streamable = exports.Streamable = function (_Component) {
  _inherits(Streamable, _Component);

  function Streamable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Streamable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Streamable.__proto__ || Object.getPrototypeOf(Streamable)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unmute');
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Streamable, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);
        _this2.player.setLoop(_this2.props.loop);
        _this2.player.on('ready', _this2.props.onReady);
        _this2.player.on('play', _this2.props.onPlay);
        _this2.player.on('pause', _this2.props.onPause);
        _this2.player.on('seeked', _this2.props.onSeek);
        _this2.player.on('ended', _this2.props.onEnded);
        _this2.player.on('error', _this2.props.onError);
        _this2.player.on('timeupdate', function (_ref2) {
          var duration = _ref2.duration,
              seconds = _ref2.seconds;

          _this2.duration = duration;
          _this2.currentTime = seconds;
        });
        _this2.player.on('buffered', function (_ref3) {
          var percent = _ref3.percent;

          if (_this2.duration) {
            _this2.secondsLoaded = _this2.duration * percent;
          }
        });
        if (_this2.props.muted) {
          _this2.player.mute();
        }
      }, this.props.onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: 'setLoop',
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: 'render',
    value: function render() {
      var id = this.props.url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('iframe', {
        ref: this.ref,
        src: 'https://streamable.com/o/' + id,
        frameBorder: '0',
        scrolling: 'no',
        style: style,
        allowFullScreen: true
      });
    }
  }]);

  return Streamable;
}(_react.Component);

Streamable.displayName = 'Streamable';

Streamable.canPlay = function (url) {
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(Streamable);

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wistia = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(6);

var _singlePlayer = __webpack_require__(7);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
var SDK_GLOBAL = 'Wistia';
var MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;

var Wistia = exports.Wistia = function (_Component) {
  _inherits(Wistia, _Component);

  function Wistia() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Wistia);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Wistia.__proto__ || Object.getPrototypeOf(Wistia)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unmute');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Wistia, [{
    key: 'getID',
    value: function getID(url) {
      return url && url.match(MATCH_URL)[1];
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          muted = _props.muted,
          controls = _props.controls,
          _onReady = _props.onReady,
          onPlay = _props.onPlay,
          onPause = _props.onPause,
          onSeek = _props.onSeek,
          onEnded = _props.onEnded,
          config = _props.config;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
        window._wq = window._wq || [];
        window._wq.push({
          id: _this2.getID(url),
          options: _extends({
            autoPlay: playing,
            silentAutoPlay: 'allow',
            muted: muted,
            controlsVisibleOnLoad: controls
          }, config.wistia.options),
          onReady: function onReady(player) {
            _this2.player = player;
            _this2.unbind();
            _this2.player.bind('play', onPlay);
            _this2.player.bind('pause', onPause);
            _this2.player.bind('seek', onSeek);
            _this2.player.bind('end', onEnded);
            _onReady();
          }
        });
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'unbind',
    value: function unbind() {
      var _props2 = this.props,
          onPlay = _props2.onPlay,
          onPause = _props2.onPause,
          onSeek = _props2.onSeek,
          onEnded = _props2.onEnded;

      this.player.unbind('play', onPlay);
      this.player.unbind('pause', onPause);
      this.player.unbind('seek', onSeek);
      this.player.unbind('end', onEnded);
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.unbind();
      this.callPlayer('remove');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('time', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('volume', fraction);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.callPlayer('playbackRate', rate);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('duration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('time');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var id = this.getID(this.props.url);
      var className = 'wistia_embed wistia_async_' + id;
      var style = {
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('div', { key: id, className: className, style: style });
    }
  }]);

  return Wistia;
}(_react.Component);

Wistia.displayName = 'Wistia';

Wistia.canPlay = function (url) {
  return MATCH_URL.test(url);
};

Wistia.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Wistia);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(6);

var _singlePlayer = __webpack_require__(7);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
var SDK_GLOBAL = 'Twitch';
var MATCH_VIDEO_URL = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
var MATCH_CHANNEL_URL = /(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
var PLAYER_ID_PREFIX = 'twitch-player-';

var Twitch = exports.Twitch = function (_Component) {
  _inherits(Twitch, _Component);

  function Twitch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Twitch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Twitch.__proto__ || Object.getPrototypeOf(Twitch)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
      _this.callPlayer('setMuted', true);
    }, _this.unmute = function () {
      _this.callPlayer('setMuted', false);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Twitch, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      var _props = this.props,
          playsinline = _props.playsinline,
          onError = _props.onError,
          config = _props.config;

      var isChannel = MATCH_CHANNEL_URL.test(url);
      var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];
      if (isReady) {
        if (isChannel) {
          this.player.setChannel(id);
        } else {
          this.player.setVideo('v' + id);
        }
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
        _this2.player = new Twitch.Player(_this2.playerID, _extends({
          video: isChannel ? '' : id,
          channel: isChannel ? id : '',
          height: '100%',
          width: '100%',
          playsinline: playsinline,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted
        }, config.twitch.options));
        var _Twitch$Player = Twitch.Player,
            READY = _Twitch$Player.READY,
            PLAYING = _Twitch$Player.PLAYING,
            PAUSE = _Twitch$Player.PAUSE,
            ENDED = _Twitch$Player.ENDED;

        _this2.player.addEventListener(READY, _this2.props.onReady);
        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);
        _this2.player.addEventListener(PAUSE, _this2.props.onPause);
        _this2.player.addEventListener(ENDED, _this2.props.onEnded);
      }, onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.callPlayer('pause');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('div', { style: style, id: this.playerID });
    }
  }]);

  return Twitch;
}(_react.Component);

Twitch.displayName = 'Twitch';

Twitch.canPlay = function (url) {
  return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
};

Twitch.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Twitch);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mixcloud = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(6);

var _singlePlayer = __webpack_require__(7);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//widget.mixcloud.com/media/js/widgetApi.js';
var SDK_GLOBAL = 'Mixcloud';
var MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;

var Mixcloud = exports.Mixcloud = function (_Component) {
  _inherits(Mixcloud, _Component);

  function Mixcloud() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Mixcloud);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Mixcloud.__proto__ || Object.getPrototypeOf(Mixcloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
      // No volume support
    }, _this.unmute = function () {
      // No volume support
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Mixcloud, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);
        _this2.player.ready.then(function () {
          _this2.player.events.play.on(_this2.props.onPlay);
          _this2.player.events.pause.on(_this2.props.onPause);
          _this2.player.events.ended.on(_this2.props.onEnded);
          _this2.player.events.error.on(_this2.props.error);
          _this2.player.events.progress.on(function (seconds, duration) {
            _this2.currentTime = seconds;
            _this2.duration = duration;
          });
          _this2.props.onReady();
        });
      }, this.props.onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      // No volume support
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          config = _props.config;

      var id = url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      var query = (0, _utils.queryString)(_extends({}, config.mixcloud.options, {
        feed: '/' + id + '/'
      }));
      // We have to give the iframe a key here to prevent a
      // weird dialog appearing when loading a new track
      return _react2['default'].createElement('iframe', {
        key: id,
        ref: this.ref,
        style: style,
        src: 'https://www.mixcloud.com/widget/iframe/?' + query,
        frameBorder: '0'
      });
    }
  }]);

  return Mixcloud;
}(_react.Component);

Mixcloud.displayName = 'Mixcloud';

Mixcloud.canPlay = function (url) {
  return MATCH_URL.test(url);
};

Mixcloud.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Mixcloud);

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePlayer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(6);

var _singlePlayer = __webpack_require__(7);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
var HLS_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/VERSION/hls.min.js';
var HLS_GLOBAL = 'Hls';
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
var DASH_GLOBAL = 'dashjs';
var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;

function canPlay(url) {
  if (url instanceof Array) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = url[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        if (typeof item === 'string' && canPlay(item)) {
          return true;
        }
        if (canPlay(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return false;
  }
  if ((0, _utils.isMediaStream)(url)) {
    return true;
  }
  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
}

function canEnablePIP(url) {
  return canPlay(url) && !!document.pictureInPictureEnabled && !AUDIO_EXTENSIONS.test(url);
}

var FilePlayer = exports.FilePlayer = function (_Component) {
  _inherits(FilePlayer, _Component);

  function FilePlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.onDisablePIP = function (e) {
      var _this$props = _this.props,
          onDisablePIP = _this$props.onDisablePIP,
          playing = _this$props.playing;

      onDisablePIP(e);
      if (playing) {
        _this.play();
      }
    }, _this.onSeek = function (e) {
      _this.props.onSeek(e.target.currentTime);
    }, _this.mute = function () {
      _this.player.muted = true;
    }, _this.unmute = function () {
      _this.player.muted = false;
    }, _this.renderSourceElement = function (source, index) {
      if (typeof source === 'string') {
        return _react2['default'].createElement('source', { key: index, src: source });
      }
      return _react2['default'].createElement('source', _extends({ key: index }, source));
    }, _this.renderTrack = function (track, index) {
      return _react2['default'].createElement('track', _extends({ key: index }, track));
    }, _this.ref = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilePlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListeners();
      if (IOS) {
        this.player.load();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(nextProps)) {
        this.removeListeners();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
        this.addListeners();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      var _props = this.props,
          onReady = _props.onReady,
          onPlay = _props.onPlay,
          onPause = _props.onPause,
          onEnded = _props.onEnded,
          onError = _props.onError,
          playsinline = _props.playsinline,
          onEnablePIP = _props.onEnablePIP;

      this.player.addEventListener('canplay', onReady);
      this.player.addEventListener('play', onPlay);
      this.player.addEventListener('pause', onPause);
      this.player.addEventListener('seeked', this.onSeek);
      this.player.addEventListener('ended', onEnded);
      this.player.addEventListener('error', onError);
      this.player.addEventListener('enterpictureinpicture', onEnablePIP);
      this.player.addEventListener('leavepictureinpicture', this.onDisablePIP);
      if (playsinline) {
        this.player.setAttribute('playsinline', '');
        this.player.setAttribute('webkit-playsinline', '');
        this.player.setAttribute('x5-playsinline', '');
      }
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      var _props2 = this.props,
          onReady = _props2.onReady,
          onPlay = _props2.onPlay,
          onPause = _props2.onPause,
          onEnded = _props2.onEnded,
          onError = _props2.onError,
          onEnablePIP = _props2.onEnablePIP;

      this.player.removeEventListener('canplay', onReady);
      this.player.removeEventListener('play', onPlay);
      this.player.removeEventListener('pause', onPause);
      this.player.removeEventListener('seeked', this.onSeek);
      this.player.removeEventListener('ended', onEnded);
      this.player.removeEventListener('error', onError);
      this.player.removeEventListener('enterpictureinpicture', onEnablePIP);
      this.player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
    }
  }, {
    key: 'shouldUseAudio',
    value: function shouldUseAudio(props) {
      if (props.config.file.forceVideo) {
        return false;
      }
      if (props.config.file.attributes.poster) {
        return false; // Use <video> so that poster is shown
      }
      return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
    }
  }, {
    key: 'shouldUseHLS',
    value: function shouldUseHLS(url) {
      return HLS_EXTENSIONS.test(url) && !IOS || this.props.config.file.forceHLS;
    }
  }, {
    key: 'shouldUseDASH',
    value: function shouldUseDASH(url) {
      return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props$config$file = this.props.config.file,
          hlsVersion = _props$config$file.hlsVersion,
          dashVersion = _props$config$file.dashVersion;

      if (this.shouldUseHLS(url)) {
        (0, _utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
          _this2.hls = new Hls(_this2.props.config.file.hlsOptions);
          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
            _this2.props.onError(e, data, _this2.hls, Hls);
          });
          _this2.hls.loadSource(url);
          _this2.hls.attachMedia(_this2.player);
        });
      }
      if (this.shouldUseDASH(url)) {
        (0, _utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
          _this2.dash = dashjs.MediaPlayer().create();
          _this2.dash.initialize(_this2.player, url, _this2.props.playing);
          _this2.dash.getDebug().setLogToBrowserConsole(false);
        });
      }

      if (url instanceof Array) {
        // When setting new urls (<source>) on an already loaded video,
        // HTMLMediaElement.load() is needed to reset the media element
        // and restart the media resource. Just replacing children source
        // dom nodes is not enough
        this.player.load();
      } else if ((0, _utils.isMediaStream)(url)) {
        try {
          this.player.srcObject = url;
        } catch (e) {
          this.player.src = window.URL.createObjectURL(url);
        }
      }
    }
  }, {
    key: 'play',
    value: function play() {
      var promise = this.player.play();
      if (promise) {
        promise['catch'](this.props.onError);
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.player.removeAttribute('src');
      if (this.hls) {
        this.hls.destroy();
      }
      if (this.dash) {
        this.dash.reset();
      }
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.player.currentTime = seconds;
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: 'enablePIP',
    value: function enablePIP() {
      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
        this.player.requestPictureInPicture();
      }
    }
  }, {
    key: 'disablePIP',
    value: function disablePIP() {
      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
        document.exitPictureInPicture();
      }
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.player.playbackRate = rate;
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.player) return null;
      var _player = this.player,
          duration = _player.duration,
          seekable = _player.seekable;
      // on iOS, live streams return Infinity for the duration
      // so instead we use the end of the seekable timerange

      if (duration === Infinity && seekable.length > 0) {
        return seekable.end(seekable.length - 1);
      }
      return duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      if (!this.player) return null;
      return this.player.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      if (!this.player) return null;
      var buffered = this.player.buffered;

      if (buffered.length === 0) {
        return 0;
      }
      var end = buffered.end(buffered.length - 1);
      var duration = this.getDuration();
      if (end > duration) {
        return duration;
      }
      return end;
    }
  }, {
    key: 'getSource',
    value: function getSource(url) {
      var useHLS = this.shouldUseHLS(url);
      var useDASH = this.shouldUseDASH(url);
      if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH) {
        return undefined;
      }
      if (MATCH_DROPBOX_URL.test(url)) {
        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
      }
      return url;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          url = _props3.url,
          playing = _props3.playing,
          loop = _props3.loop,
          controls = _props3.controls,
          muted = _props3.muted,
          config = _props3.config,
          width = _props3.width,
          height = _props3.height;

      var useAudio = this.shouldUseAudio(this.props);
      var Element = useAudio ? 'audio' : 'video';
      var style = {
        width: width === 'auto' ? width : '100%',
        height: height === 'auto' ? height : '100%'
      };
      return _react2['default'].createElement(
        Element,
        _extends({
          ref: this.ref,
          src: this.getSource(url),
          style: style,
          preload: 'auto',
          autoPlay: playing || undefined,
          controls: controls,
          muted: muted,
          loop: loop
        }, config.file.attributes),
        url instanceof Array && url.map(this.renderSourceElement),
        config.file.tracks.map(this.renderTrack)
      );
    }
  }]);

  return FilePlayer;
}(_react.Component);

FilePlayer.displayName = 'FilePlayer';
FilePlayer.canPlay = canPlay;
FilePlayer.canEnablePIP = canEnablePIP;
exports['default'] = (0, _singlePlayer2['default'])(FilePlayer);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95);
module.exports = __webpack_require__(100);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(96).enable();
  window.Promise = __webpack_require__(98);
}

// fetch() polyfill for making API calls.
__webpack_require__(99);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(18);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(52);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(52);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 99 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_scenemanager_SceneManager_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scenes_StartScreen__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scenes_Intro__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_scenes_HighScores__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scenes_Winner__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__index_css__);
// React
// RAGE CLICK COMPONENTS
// import FSPlayback from "./components/scenes/FSPlayback";
// require('viewport-units-buggyfill').init();
var injectTapEventPlugin=__webpack_require__(303);injectTapEventPlugin();var history=Object(__WEBPACK_IMPORTED_MODULE_2_history__["createMemoryHistory"])({initialEntries:['/','/intro','/play','/win','/replay','/scores'],initialIndex:0});Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_6__store_js__["a" /* store */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Router */],{history:history},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Route */],{path:"/",component:__WEBPACK_IMPORTED_MODULE_8__components_scenes_StartScreen__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Route */],{path:"/intro",component:__WEBPACK_IMPORTED_MODULE_9__components_scenes_Intro__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Route */],{path:"/play",component:__WEBPACK_IMPORTED_MODULE_7__components_scenemanager_SceneManager_js__["a" /* default */],after:"/win"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Route */],{path:"/win",component:__WEBPACK_IMPORTED_MODULE_11__components_scenes_Winner__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Route */],{path:"/scores",component:__WEBPACK_IMPORTED_MODULE_10__components_scenes_HighScores__["a" /* default */]}))),document.getElementById("root"));Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(18),n=__webpack_require__(29),p=__webpack_require__(14),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),l=__webpack_require__(103),B=__webpack_require__(18),C=__webpack_require__(14),ba=__webpack_require__(104),da=__webpack_require__(105),ea=__webpack_require__(106),fa=__webpack_require__(107),ia=__webpack_require__(110),D=__webpack_require__(29);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(14);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(108);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(109);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.Actions = exports.useQueries = exports.useBeforeUnload = exports.useBasename = exports.createMemoryHistory = exports.createHashHistory = exports.createHistory = undefined;

var _LocationUtils = __webpack_require__(13);

Object.defineProperty(exports, 'locationsAreEqual', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.locationsAreEqual;
  }
});

var _createBrowserHistory = __webpack_require__(53);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createHashHistory2 = __webpack_require__(55);

var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);

var _createMemoryHistory2 = __webpack_require__(56);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

var _useBasename2 = __webpack_require__(34);

var _useBasename3 = _interopRequireDefault(_useBasename2);

var _useBeforeUnload2 = __webpack_require__(115);

var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);

var _useQueries2 = __webpack_require__(35);

var _useQueries3 = _interopRequireDefault(_useQueries2);

var _Actions2 = __webpack_require__(19);

var _Actions = _interopRequireWildcard(_Actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createHistory = _createBrowserHistory2.default;
exports.createHashHistory = _createHashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;
exports.useBasename = _useBasename3.default;
exports.useBeforeUnload = _useBeforeUnload3.default;
exports.useQueries = _useQueries3.default;
exports.Actions = _Actions;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(31);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(13);

var _PathUtils = __webpack_require__(11);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(31);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(10);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(13);

var _DOMUtils = __webpack_require__(20);

var _DOMStateStorage = __webpack_require__(54);

var _PathUtils = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(4);

var _invariant2 = _interopRequireDefault(_invariant);

var _DOMUtils = __webpack_require__(20);

var _ExecutionEnvironment = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startListener = function startListener(getPromptMessage) {
  var handleBeforeUnload = function handleBeforeUnload(event) {
    var message = getPromptMessage();

    if (typeof message === 'string') {
      (event || window.event).returnValue = message;
      return message;
    }

    return undefined;
  };

  (0, _DOMUtils.addEventListener)(window, 'beforeunload', handleBeforeUnload);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, 'beforeunload', handleBeforeUnload);
  };
};

/**
 * Returns a new createHistory function that can be used to create
 * history objects that know how to use the beforeunload event in web
 * browsers to cancel navigation.
 */
var useBeforeUnload = function useBeforeUnload(createHistory) {
  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'useBeforeUnload only works in DOM environments') : (0, _invariant2.default)(false) : void 0;

  return function (options) {
    var history = createHistory(options);

    var listeners = [];
    var stopListener = void 0;

    var getPromptMessage = function getPromptMessage() {
      var message = void 0;
      for (var i = 0, len = listeners.length; message == null && i < len; ++i) {
        message = listeners[i].call();
      }return message;
    };

    var listenBeforeUnload = function listenBeforeUnload(listener) {
      if (listeners.push(listener) === 1) stopListener = startListener(getPromptMessage);

      return function () {
        listeners = listeners.filter(function (item) {
          return item !== listener;
        });

        if (listeners.length === 0 && stopListener) {
          stopListener();
          stopListener = null;
        }
      };
    };

    return _extends({}, history, {
      listenBeforeUnload: listenBeforeUnload
    });
  };
};

exports.default = useBeforeUnload;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(117);
var objectAssign = __webpack_require__(18);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(60);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(129);
/* unused harmony reexport IndexLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(130);
/* unused harmony reexport withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(132);
/* unused harmony reexport IndexRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(133);
/* unused harmony reexport IndexRoute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(61);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(12);
/* unused harmony reexport createRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(37);
/* unused harmony reexport RouterContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(39);
/* unused harmony reexport locationShape */
/* unused harmony reexport routerShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(135);
/* unused harmony reexport match */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(63);
/* unused harmony reexport useRouterHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(16);
/* unused harmony reexport formatPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(136);
/* unused harmony reexport applyRouterMiddleware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(137);
/* unused harmony reexport browserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(138);
/* unused harmony reexport hashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(62);
/* unused harmony reexport createMemoryHistory */
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(15);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]
};

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */
var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(18);

var emptyObject = __webpack_require__(29);
var _invariant = __webpack_require__(25);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(14);
var invariant = __webpack_require__(25);
var ReactPropTypesSecret = __webpack_require__(122);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(16);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(36);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(16);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(58);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(12);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(16);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(60);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexLink);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(39);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(21);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRedirect);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(21);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRoute);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(21);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(59);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : Object(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (match);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(15);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(64);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(64);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(40);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(161);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(71);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(149);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(147);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(68);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(151);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(155);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8), __webpack_require__(154)(module)))

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(69);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(70);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(71);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(72);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(162);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(40);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var howlerIntegration=__webpack_require__(166);var mute=true;var soundsMiddleware=function soundsMiddleware(soundsData){howlerIntegration.initialize(soundsData);return function(store){return function(next){return function(action){// Ignore actions that haven't specified a sound.
if(!action.meta){return next(action);}var soundName=action.meta.sound||undefined;var playType=action.meta.op;var channel=action.meta.channel;switch(playType){case"playFx":howlerIntegration.playfx(soundName);break;case"stopVoice":howlerIntegration.stopVoice(soundName,'voice');break;case"mute":mute=!mute;howlerIntegration.muteAudio(mute);store.dispatch({type:"SET_MUTE",mute:mute});break;case"channelStop":howlerIntegration.channelStop(soundName);break;case"stop":howlerIntegration.stop(soundName);break;case"fade":howlerIntegration.fade(soundName,channel);break;default:howlerIntegration.play(soundName,channel);}return next(action);};};};};/* harmony default export */ __webpack_exports__["a"] = (soundsMiddleware);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var Howl=__webpack_require__(74).Howl;var Howler=__webpack_require__(74).Howler;var channelMusic=void 0;var channelVoice=void 0;module.exports={initialize:function initialize(soundsData){var soundOptions=void 0;var soundNames=Object.getOwnPropertyNames(soundsData);this.sounds=soundNames.reduce(function(memo,name){soundOptions=soundsData[name];// Allow strings instead of objects, for when all that is needed is a URL
if(typeof soundOptions==="string"){soundOptions={src:[soundOptions],autoPlay:false};}return Object.assign({},memo,_defineProperty({},name,new Howl(soundOptions)));},{});Howler.volume(0);// audio mute to start
return this.sounds;},muteAudio:function muteAudio(yayNay){if(yayNay)Howler.volume(0);else Howler.volume(1);},playfx:function playfx(soundName,channel){var sound=this.sounds[soundName];sound.play();},play:function play(soundName,channel){var duration=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1000;if(soundName===undefined)return;// no audio to handle, so cancelling
// console.log(soundName);
var sound=this.sounds[soundName];// MUSIC AND DIALOG
if(channel==="music"){// console.log("playing music/dialog channels");
if(channelMusic!==undefined){// fade out music,  if already playing, then play new jam
channelMusic.fade(1,0,duration);channelMusic.once('fade',function(ref){channelMusic.stop();channelMusic=sound;channelMusic.play();channelMusic.fade(0,1,duration);return;});return;}else{// just play new jam
channelMusic=sound;channelMusic.play();return;}}if(channel==="voice"||"dialog"){if(channelVoice!==undefined)channelVoice.stop();channelVoice=sound.play();channelVoice=sound;// save for later
return;}},fade:function fade(soundName,channel){// console.log("fade function yo");
// if (channel === "music") {
// 	if (channelMusic !== undefined) channelMusic.fade(1, 0, 1000);
// }
// if (channel === "voice") {
// 	if (channelVoice !== undefined) channelVoice.fade(1, 0, 1000);
// }
},stopVoice:function stopVoice(){if(channelVoice!==undefined)channelVoice.stop();},stop:function stop(soundName,spriteName){var sound=this.sounds[soundName];if(typeof sound!=="undefined")sound.stop(spriteName);},channelStop:function channelStop(soundName,spriteName){var sound=this.sounds[soundName];sound.stop();}};

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var soundsData={//music tracks
music1:{src:["./audio/beat_level_1_a.mp3"]},music2:{src:["./audio/beat_level_2_a.mp3"]},music3:{src:["./audio/beat_level_3_b.mp3"],loop:true},//start screen sounds
startAnimateLogo:{src:["./audio/start-animate-logo.mp3"]},startThunder:{src:["./audio/start-thunder.mp3"],volume:0.4},startStartPressed:{src:["./audio/start-start-pressed.mp3"]},// hits/punches
hit1:{src:["./audio/hit_1_a.mp3"]},hit2:{src:["./audio/hit_1_b.mp3"]},hit3:{src:["./audio/hit_1_c.mp3"]},hit4:{src:["./audio/hit_1_d.mp3"]},//intro screens sounds
introClick:{src:["./audio/intro-click.mp3"]},introShimmer:{src:["./audio/intro-shimmer.mp3"],volume:0.25},//2D screen sounds
twoDDarkPatternAppear:{src:["./audio/2d-dark-pattern-appear.mp3"]},twoDDarkPatternCorrect:{src:["./audio/2d-dark-pattern-correct.mp3"]},twoDDarkPatternIncorrect:{src:["./audio/2d-dark-pattern-incorrect.mp3"]},twoDRageIncrease:{src:["./audio/2d-rage-increase.mp3"]},boxxieKnockout:{src:["./audio/boxxie-knockout.mp3"]},//3D screen sounds
threeDCountdown:{src:["./audio/3d-countdown.mp3"],volume:0.7},threeDCountdownComplete:{src:["./audio/3d-countdown-complete.mp3"],volume:0.7},threeDSwoosh:{src:["./audio/3d-swoosh.mp3"]},level1_1:{src:["./audio/level1-beginning-1.mp3"]},level1_2:{src:["./audio/level1-beginning-2.mp3"]},level1_3:{src:["./audio/level1-beginning-3.mp3"]},level1_4:{src:["./audio/level1-beginning-4.mp3"]},level1_5:{src:["./audio/level1-ending-1.mp3"]},level2_1:{src:["./audio/level2-beginning-1.mp3"]},level2_2:{src:["./audio/level2-beginning-2.mp3"]},level2_3:{src:["./audio/level2-beginning-3.mp3"]},level2_4:{src:["./audio/level2-beginning-4.mp3"]},level2_5:{src:["./audio/level2-ending-1.mp3"]},level3_1:{src:["./audio/level3-beginning-1.mp3"]},level3_2:{src:["./audio/level3-beginning-2.mp3"]},level3_3:{src:["./audio/level3-beginning-3.mp3"]},level3_4:{src:["./audio/level3-beginning-4.mp3"]},level3_5:{src:["./audio/level3-ending-1.mp3"]},// removing now to test loading times
// level1random1: {
// 	src: ["./audio/level1random1.mp3"]
// },
// level1random2: {
// 	src: ["./audio/level1random2.mp3"]
// },
// level1random3: {
// 	src: ["./audio/level1random3.mp3"]
// },
// level1random4: {
// 	src: ["./audio/level1random4.mp3"]
// },
// level1random5: {
// 	src: ["./audio/level1random5.mp3"]
// },
meetboss:{src:["./audio/binary-omnipresent-satisfaction-system.mp3"]},soundscape:{src:["./audio/soundscape.mp3"],loop:true},dialogMusic:{src:["./audio/waiting_music.mp3"],loop:true},destroyAd1:{src:["./audio/hit_1_a.mp3"],volume:0.4},destroyAd2:{src:["./audio/hit_1_b.mp3"],volume:0.4},destroyAd3:{src:["./audio/hit_1_c.mp3"],volume:0.4},destroyAd4:{src:["./audio/hit_1_d.mp3"]},// destroyAd5: {
// 	src: ["./audio/hit_1_b.mp3"]
// },
// destroyAd6: {
// 	src: ["./audio/hit_1_c.mp3"]
// },
// destroyAd4: {
// 	src: ["./audio/ad-destroy4.mp3"]
// },
// destroyAd5: {
// 	src: ["./audio/ad-destroy5.mp3"]
// },
// windowAppear: {
// 	src: ["./audio/windowAppear.mp3"]
// },
eas:{src:["./audio/eas.mp3"],volume:0.2}};/* harmony default export */ __webpack_exports__["a"] = (soundsData);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__game__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scores__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__patterns__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__patterns2d__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clickSequence__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scene__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__explosions__ = __webpack_require__(175);
// import fx from "./fx";
var rageReducers=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({patterns:__WEBPACK_IMPORTED_MODULE_3__patterns__["a" /* default */],patterns2d:__WEBPACK_IMPORTED_MODULE_4__patterns2d__["a" /* default */],scores:__WEBPACK_IMPORTED_MODULE_2__scores__["a" /* default */],game:__WEBPACK_IMPORTED_MODULE_1__game__["a" /* default */],scene:__WEBPACK_IMPORTED_MODULE_6__scene__["a" /* default */],// fx,
explosions:__WEBPACK_IMPORTED_MODULE_7__explosions__["a" /* default */],clickSequence:__WEBPACK_IMPORTED_MODULE_5__clickSequence__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (rageReducers);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// const calculate = (item, time) => {
// 	switch (item) {
// 		case "popover": // close within 2 seconds to get bonus score
// 			return time < 2000 ? 5000 : 1000;
// 		default:
// 			return 0;
// 	}
// };
var game=function game(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var roundTime=8;switch(action.type){// timer
case"UPDATE_TIME":var time=state.time-1;if(time>0){return Object.assign({},state,{time:time,roundStarted:true});}else{return Object.assign({},state,{time:0,roundOver:true,showBlocker:true});}// case "SET_ROUND":
// 	return Object.assign({}, state, {
// 		currentRound: action.roundNumber
// 	});
// // Ads
case"ROUND_WIN":return Object.assign({},state,{roundOver:true});case"HIDE_BLOCKER":return Object.assign({},state,{showBlocker:false});// set token for playback
case"SET_EMBED_TOKEN":return Object.assign({},state,{token:action.token});case"DELETE_PLAYBACK_TOKEN":return Object.assign({},state,{token:undefined});// set token for playback
case"AUDIO_CHOSEN":return Object.assign({},state,{audioSet:true});// initial player for new game
case"INITIALIZE_USER":return Object.assign({},state,{time:roundTime,score:0,darkPatternsKilled:0,roundOver:false,isGameOver:false,showBlocker:true,showPowerUp:false,roundStarted:false,hazRageClick:false,clicks:0,mute:false});case"INITIALIZE_TIME":return Object.assign({},state,{time:roundTime,roundOver:false,roundStarted:false,clicks:0,hazRageClick:false});case"RAGE_TRIGGER_OFF":return Object.assign({},state,{rageTrigger:false});case"RAGE_CLICK_OFF":return Object.assign({},state,{hazRageClick:false});case"SCORE_INCREASE":// const addScore = calculate(action.item, action.time);
var score=state.score||0;score+=action.value||0;// console.log(action, addScore);
return Object.assign({},state,{score:score});case"SHOW_POWER_UP":return Object.assign({},state,{showPowerUp:true});case"SHAKE_ON":return Object.assign({},state,{shake:true});case"SHAKE_OFF":return Object.assign({},state,{shake:false});case"SET_MUTE":return Object.assign({},state,{mute:action.mute});case"SET_RANK":return Object.assign({},state,{rank:action.rank});case"IS_MOBILE":return Object.assign({},state,{mobile:action.mobile});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (game);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var scores=function scores(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case"SET_HIGH_SCORES":{return Object.assign({},state,{highscores:action.highScores});}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (scores);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var patterns=function patterns(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case"CREATE_DARK_PATTERN":return Object.assign([],state,[].concat(_toConsumableArray(state),[action.patternConfig]));case"DESTROY_DARK_PATTERN":return state.filter(function(el){return el.id!==action.id;});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (patterns);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var patterns=function patterns(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case"CREATE_DARK_PATTERN2D":return Object.assign([],state,[].concat(_toConsumableArray(state),[action.patternConfig]));default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (patterns);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var clickSequence=function clickSequence(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var action=arguments[1];switch(action.type){case"INCREMENT_CLICK_SEQUENCE":return state+1;case"RESET_CLICK_SEQUENCE":return 1;default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (clickSequence);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var scene=function scene(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case"NEXT_SCENE":return Object.assign({},state,action.sceneData);default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (scene);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var explosions=function explosions(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case"CREATE_EXPLOSION":return Object.assign([],state,[].concat(_toConsumableArray(state),[action.explosionConfig]));case"DESTROY_EXPLOSION":return state.filter(function(el){return el.id!==action.id;});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (explosions);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(26).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_sceneManager_js__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__manifest_js__ = __webpack_require__(75);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{nextScene:function nextScene(next){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_sceneManager_js__["a" /* nextScene */])(next));},isMobile:function isMobile(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["i" /* isMobile */])());},initializeUser:function initializeUser(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["h" /* initializeUser */])());}};};var ManagerView=function(_Component){_inherits(ManagerView,_Component);function ManagerView(props){_classCallCheck(this,ManagerView);var _this=_possibleConstructorReturn(this,(ManagerView.__proto__||Object.getPrototypeOf(ManagerView)).call(this,props));_this.state={index:0};_this.after=_this.props.route.after;return _this;}_createClass(ManagerView,[{key:"componentWillMount",value:function componentWillMount(){this.props.isMobile();this.props.initializeUser();__WEBPACK_IMPORTED_MODULE_4__manifest_js__["b" /* manifest */].init.map(function(func){return func();});this.next();}},{key:"next",value:function next(){var index=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;if(index>=__WEBPACK_IMPORTED_MODULE_4__manifest_js__["b" /* manifest */].scenes.length){this.props.router.push(this.after);__WEBPACK_IMPORTED_MODULE_4__manifest_js__["b" /* manifest */].exit.map(function(func){return func();});}else{this.props.nextScene(Object.assign({index:index},__WEBPACK_IMPORTED_MODULE_4__manifest_js__["b" /* manifest */][index]));__WEBPACK_IMPORTED_MODULE_4__manifest_js__["b" /* manifest */].scenes[index].init.map(function(func){return func();});this.setState({index:index});}}},{key:"render",value:function render(){var _this2=this;var scene=__WEBPACK_IMPORTED_MODULE_4__manifest_js__["b" /* manifest */].scenes[this.state.index];var SceneComponent=scene.type;var nextScene=function nextScene(){__WEBPACK_IMPORTED_MODULE_4__manifest_js__["b" /* manifest */].scenes[_this2.state.index].exit.map(function(func){return func();});_this2.next(_this2.state.index+1);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SceneComponent,Object.assign({next:nextScene},scene.data));}}]);return ManagerView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SceneManager=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ManagerView);/* harmony default export */ __webpack_exports__["a"] = (SceneManager);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = nextScene;
// MOBILE DETECT
function nextScene(sceneData){return{type:'NEXT_SCENE',sceneData:sceneData};}

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// <svg version="1.1" x="0px" y="0px" viewBox="0 0 2048 1536" enableBackground="new 0 0 2048 1536" preserveAspectRatio="xMidYMid slice">
var LevelBrenda=function(_Component){_inherits(LevelBrenda,_Component);function LevelBrenda(){_classCallCheck(this,LevelBrenda);return _possibleConstructorReturn(this,(LevelBrenda.__proto__||Object.getPrototypeOf(LevelBrenda)).apply(this,arguments));}_createClass(LevelBrenda,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"levelBrenda"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"brenda",x:"0px",y:"0px",viewBox:"0 0 2048 1536",enableBackground:"new 0 0 2048 1536",preserveAspectRatio:"xMidYMid slice"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"bg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#111D21",points:"2048,900.63 2048,967.94 1690.4399,900.63 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#192F35",points:"2048,864.31 2048,900.63 1690.4399,900.63 1712.15,864.31 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#26434C",points:"2048,302.37 2048,864.31 1712.15,864.31 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1D353D",points:"2048,967.94 2048,1536 0,1536 0,916 108.68,900.63 1690.4399,900.63 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B7884",points:"2048,3.08 2048,302.37 1712.15,864.31 165.35,864.31 1510.46,2.27 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1B272D",points:"2048,0 2048,3.08 1510.46,2.27 1514,0 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2D4D59",points:"1712.15,864.31 1690.4399,900.63 108.68,900.63 165.35,864.31 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1D353D",points:"1514,0 1510.46,2.27 0,0 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#26434C",points:"1510.46,2.27 165.35,864.31 0,864.31 0,0 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#192F35",points:"165.35,864.31 108.68,900.63 0,900.63 0,864.31 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#111D21",points:"108.68,900.63 0,916 0,900.63 \t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"back_wall"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"1569.4127",y:"446.3225",fill:"#2C4B54",width:"119.696",height:"120.1772"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"1614.4127",y:"35.5195",fill:"#2C4B54",width:"193.601",height:"282.4801"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"249.3241",y:"78.9238",fill:"#142A30",width:"249.72",height:"273.5716"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"68.9844",y:"43.7708",fill:"#142A30",width:"115.9688",height:"116.7318"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#142A30",points:"346.9321,636.1669 81.3201,636.1669 78.3177,425.5521 343.9297,425.5521 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_3_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#142A30",points:"2009.71,410.7 2009.71,639.5 1846.51,639.5 1983.26,410.7 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2C4B54",points:"1983.26,410.7 1846.51,639.5 1785.41,639.5 1785.41,410.7 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_4_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2C4B54",points:"1372.688,90.9752 1372.688,735.0552 671.418,735.0552 671.418,540.3952 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#142A30",points:"1372.688,-63.1248 1372.688,90.9752 671.418,540.3952 671.418,-63.1248 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_9_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CEB080",d:"M1739.8141,244.1251c-3.7963-1.0434-3.3296-4.6824-9.8682-7.2149l-0.8232,0.0524 c-0.194-0.8075-0.4352-1.5992-0.713-2.37c3.686-0.4037,7.0839-1.5783,10.1407-3.3558c2.5326,1.4682,5.2959,2.5273,8.2637,3.0726 c0.1101,0.7708,0.1572,1.5835,0.1415,2.4434C1746.8455,242.0172,1743.6104,245.1633,1739.8141,244.1251z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CEB080",d:"M1753.3893,267.6733c-0.3408,0-0.6764,0.0262-1.0015,0.0734c0.0262-1.9977,1.6569-4.1633,3.943-6.8112 c2.6165,2.0345,5.6735,3.5236,9.0082,4.2996c0.2307,1.6465,0.9648,3.1251,2.045,4.2839 c-1.4105-0.2569-4.0427-0.4666-6.5438,0.7393c-0.4772,0.2307-1.1012,0.5034-1.7932,0.7445 C1757.9458,269.0156,1755.8223,267.6733,1753.3893,267.6733z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CEB080",d:"M1729.8516,263.1063c-0.8861-3.3296-1.8876-6.5228-2.8944-9.4434 c1.8038-3.3138,2.8315-7.1153,2.8315-11.158c0-1.9086-0.2307-3.7648-0.666-5.5423l0.8232-0.0524c0,0,8.5782,8.9191,3.1461,19.495 C1732.1587,258.2299,1731.0156,260.516,1729.8516,263.1063z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5E4C49",d:"M1713.5288,115.5826c5.7468,9.134,4.0688,28.0733-4.8397,28.7497 c-11.2052,0.8494-10.9062-9.8734-8.5363-12.9093c-6.6119,3.8696-5.0179,12.8778-1.3685,18.4096 c2.9258,4.4307,10.5446,15.9138,2.37,18.5355c-13.0247,4.1842-11.6351-15.7722-11.6351-15.7722 c-2.9258,4.0846-4.3468,16.9572,1.8929,27.5384c2.4801,4.2,4.2052,9.2337,4.6509,13.9213 c-0.4562,0.0157-0.9229,0.0262-1.3843,0.0262c-20.7692,0-37.6111-16.8366-37.6111-37.6058c0-4.4831,0.7865-8.7775,2.2233-12.7572 c-5.9355-0.6554-11.504-2.5431-16.4329-5.406V50.517c3.4711,6.8374,7.9595,13.0718,13.2711,18.504 c-2.2966,3.5236-3.639,7.7288-3.639,12.2486c0,3.0831,0.624,6.0194,1.7461,8.6936c-6.7798,1.6097-10.9692,8.4104-9.3595,15.1954 c1.6097,6.7797,8.4104,10.9692,15.1954,9.3595c5.5109-1.3109,9.3071-6.0457,9.6741-11.4097 c1.6675,0.3985,3.4031,0.6082,5.191,0.6082c9.2284,0,17.1512-5.5738,20.6014-13.5385c4.5408,0.8599,9.2231,1.3161,14.0104,1.3161 c3.3767,0,6.6958-0.2255,9.9573-0.6607c2.5902,21.9699,21.2621,39.011,43.9293,39.011c13.5071,0,25.6036-6.0509,33.7205-15.5939 v12.4059c-2.952,5.8149-6.764,11.1161-11.2786,15.7303c1.9506,2.994,3.0936,6.5648,3.0936,10.4082 c0,10.5393-8.5416,19.0756-19.0756,19.0756c-7.8442,0-14.582-4.7348-17.5131-11.5041c-3.8591,0.7341-7.839,1.1221-11.9078,1.1221 c-2.8682,0-5.6943-0.194-8.4629-0.5611c-1.0435,8.8666-5.17,16.7894-11.2838,22.6568c-4.6195-1.2951-5.9041-6.549-5.988-10.3453 c-0.3879-17.9377,7.4509-17.8434,8.9978-35.8598C1724.9752,122.9864,1713.8591,115.7924,1713.5288,115.5826z M1683.1432,115.4463 c0-3.6494-2.952-6.6067-6.6014-6.6067c-3.6442,0-6.6014,2.9573-6.6014,6.6067c0,3.6442,2.9573,6.6015,6.6014,6.6015 C1680.1912,122.0478,1683.1432,119.0905,1683.1432,115.4463z M1664.2563,127.1444c0-2.6322-2.134-4.761-4.761-4.761 c-2.6322,0-4.7662,2.1288-4.7662,4.761c0,2.6322,2.134,4.7663,4.7662,4.7663 C1662.1223,131.9107,1664.2563,129.7766,1664.2563,127.1444z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CEB080",d:"M1755.5863,291.1166c-0.8861-4.1423,0.2412-8.594,2.349-12.3587 c0.6869-0.6764,1.2218-1.4996,1.5521-2.4225c2.3857-3.2824,5.4531-5.7206,8.2688-6.4442c1.421,1.3423,3.3348,2.1603,5.4375,2.1603 c4.3834,0,7.9385-3.5498,7.9385-7.9333c0-0.2517-0.0105-0.4929-0.0367-0.7393c6.8584-3.4397,11.7872-10.1617,12.7258-18.1108 c1.1011,0.1468,2.2075,0.2517,3.3348,0.3041v47.4582h-41.25C1755.8328,292.4065,1755.7279,291.7668,1755.5863,291.1166z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#BC5406",d:"M1770.4724,236.281c1.5573-8.4263-2.4121-11.436-2.4121-11.436s0.1836,10.2195-6.4283,8.1746 c-8.2584-2.5588-6.1085-13.895-0.8861-21.131c5.2539-7.2675,5.0913-16.7161,3.2405-19.8831c0,0-0.3357,14.5977-9.5222,10.6703 c-5.7572-2.4591,0.5559-10.2876,2.9783-13.3077c3.0255-3.77,4.7979-10.2089,0.2571-13.4703 c1.5153,2.3647,1.0066,10.1775-7.0786,8.8037c-6.4285-1.0959-6.3656-14.97-1.5731-21.2202 c-0.2675,0.1365-8.8142,4.6195-8.8928,15.1483c-0.0944,13.1976,5.6052,13.6591,4.1108,26.6681 c-0.3671,3.167-2.0187,7.6239-6.7535,7.1677c-4.0427-0.3881-7.1152-4.1476-5.6943-10.4712c0,0-5.7206,5.8779-2.6008,12.3484 c0.4929,1.0225,1.2637,1.9558,2.218,2.8577c4.782,4.5093,14.1101,8.0801,15.3789,17.1091 c0.1101,0.7709,0.1573,1.5835,0.1416,2.4435c-0.1101,5.2644-3.3452,8.4105-7.1415,7.3722 c-3.7963-1.0433-3.3296-4.6824-9.868-7.2148c0,0,8.5781,8.9189,3.146,19.495c-0.9333,1.8247-2.0764,4.1108-3.2405,6.701 c-3.9167,8.7041-8.0801,20.7903-5.4794,29.9243h7.1573h24.3766c-0.0734-0.624-0.1783-1.2637-0.3198-1.9138 c-0.8861-4.1423,0.2411-8.594,2.349-12.3589c0.4719-0.8494,0.991-1.6569,1.552-2.4224c2.3859-3.2825,5.4532-5.7206,8.269-6.4442 c0.2202-0.0577,0.4404-0.0996,0.6606-0.1364c0,0-0.3881-0.1257-1.033-0.2358c-1.4105-0.2571-4.0427-0.4668-6.5438,0.7393 c-0.4772,0.2307-1.1012,0.5034-1.7933,0.7446c-1.8352,0.6292-4.1318,1.0015-5.4164-0.3828 c-0.8756-0.9438-1.2532-1.8877-1.2427-2.8734c0.0262-1.9977,1.6569-4.1632,3.943-6.8112 C1760.9503,255.582,1768.2596,248.2517,1770.4724,236.281z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#33424C",d:"M1763.4357,129.8447c-22.6672,0-41.3391-17.0411-43.9293-39.011 c-3.2615,0.4352-6.5806,0.6607-9.9573,0.6607c-4.7872,0-9.4696-0.4562-14.0104-1.3161 c-3.4502,7.9648-11.373,13.5385-20.6014,13.5385c-1.788,0-3.5236-0.2097-5.191-0.6082 c-7.0209-1.6569-12.7625-6.6172-15.51-13.1452c-1.1221-2.6741-1.7461-5.6105-1.7461-8.6936c0-4.5198,1.3424-8.7251,3.639-12.2486 c-5.3116-5.4322-9.8-11.6666-13.2711-18.504v-4.4621h154.2876h0.0105v68.1959 C1789.0393,123.7938,1776.9427,129.8447,1763.4357,129.8447z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D16F18",d:"M1732.1429,170.3135c1.1273,8.8142-3.5393,13.5542-9.1027,13.5699c-0.8494,0-1.6201-0.1049-2.3123-0.299 c-4.6194-1.295-5.9041-6.549-5.988-10.3452c-0.3879-17.9377,7.4509-17.8433,8.9978-35.8597 c1.2374-14.3932-9.8787-21.5872-10.209-21.7969c5.7468,9.134,4.0688,28.0732-4.8396,28.7496 c-11.2053,0.8495-10.9064-9.8733-8.5364-12.9092c-6.6119,3.8696-5.0179,12.8777-1.3685,18.4095 c2.9259,4.4308,10.5446,15.9138,2.37,18.5355c-13.0247,4.1843-11.6351-15.7722-11.6351-15.7722 c-2.9258,4.0846-4.3468,16.9573,1.8929,27.5385c2.4801,4.2,4.2052,9.2336,4.6509,13.9213 c0.6659,7.0576-1.5784,13.334-8.5469,14.7969c-9.2755,1.9507-7.7288-11.9707-7.7288-11.9707s-5.7939,3.6023-4.74,15.3003 c2.5955,28.8809,27.9999,40.5999,18.6089,48.9893c-0.1941,0.1731-0.3933,0.3198-0.6082,0.4404 c-2.7424,1.5889-7.0735-0.582-9.1865-1.8508c-4.7454-2.8577-10.272-1.6517-10.272-1.6517 c8.7618,2.2494,18.7191,18.2523,14.7917,30.7789c-0.4457,1.4158-0.7603,2.8-0.949,4.1423h36.9398 c-2.6007-9.134,1.5626-21.2202,5.4794-29.9243c-0.8861-3.3296-1.8877-6.5227-2.8943-9.4434 c-1.2271-3.5654-2.4592-6.7378-3.4764-9.2756c-6.0667-15.1167,6.7745-26.196,6.7745-26.196 c-9.239,2.6217-9.0659,7.6501-14.3774,8.5886c-5.3169,0.9333-9.3281-3.77-8.8091-10.9639 c1.2742-17.5759,21.8756-19.7206,27.0508-28.3198C1739.2007,179.0596,1732.1429,170.3135,1732.1429,170.3135z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CEB080",d:"M1673.5897,258.1093c8.7617,2.2494,18.719,18.2523,14.7916,30.7789 c-0.4457,1.4157-0.7603,2.8-0.9491,4.1423h-44.5742v-18.6299h0.0157c2.0449,2.3333,5.0441,3.8015,8.3894,3.8015 c6.161,0,11.1527-4.9917,11.1527-11.158c0-6.161-4.9917-11.1528-11.1527-11.1528c-3.3557,0-6.3655,1.4734-8.4052,3.8225v-35.7077 c1.83,3.6075,4.2,6.8951,6.9999,9.758c-1.2112,1.8614-1.9191,4.0794-1.9191,6.4599c0,6.5385,5.3011,11.8396,11.8397,11.8396 c4.8658,0,9.0448-2.9416,10.8643-7.1415c2.3911,0.4562,4.8607,0.6974,7.3881,0.6974c1.7827,0,3.5341-0.1206,5.2487-0.3513 c0.797,6.7535,4.4727,12.6209,9.7684,16.3437c-2.7423,1.5888-7.0734-0.582-9.1864-1.8509 C1679.1162,256.9033,1673.5897,258.1093,1673.5897,258.1093z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"1815.4714,309.3533 1624.8574,309.3375 1621.9944,311.8491 1818.0197,311.8491  1818.0197,311.6235 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1800.3546,295.8828 1639.801,295.8828 1639.801,295.7991 1636.4138,298.8064 1803.6213,298.8064  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1818.0197,27.2415 1818.0197,27.2677 1815.5919,29.4542 1624.8573,29.4542 1624.8573,29.5801  1622.3038,27.2415 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"#7A5431",points:"1811.6962,305.9345 1811.6962,32.9621 1815.5919,29.4542 1815.7598,29.4542 1815.4714,309.3533  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"#54341E",points:"1815.4714,309.3533 1815.7598,29.4542 1815.5919,29.4542 1818.0197,27.2677 1818.0197,311.6236  1815.4714,309.3532 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1815.5919,29.4542 1811.6962,32.9621 1811.6962,32.9463 1628.5382,32.9463 1624.8573,29.5801  1624.8573,29.4542 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1811.6962,32.9463 1811.6962,32.9621 1803.5531,40.2871 1636.5554,40.2871 1628.5382,32.9463 \t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"1797.1561,114.2508 1797.1561,46.0549 1797.1456,46.0549 1803.5531,40.2871 1803.6212,40.2871  1803.6212,298.8064 1800.3546,295.8829 1797.1561,293.0305 1797.1561,245.5723 1797.1561,126.6567 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"#3F2818",points:"1803.6212,298.8064 1803.6212,40.2871 1803.5531,40.2871 1811.6962,32.9621 1811.6962,305.9686  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"1803.5531,40.2871 1797.1456,46.0549 1642.858,46.0549 1639.801,43.2602 1636.5554,40.2871 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5E4C49",d:"M1784.939,180.213c5.2592,0,9.522,4.2681,9.522,9.5273s-4.2628,9.5273-9.522,9.5273 c-5.2644,0-9.5273-4.2681-9.5273-9.5273C1775.4116,184.4812,1779.6746,180.213,1784.939,180.213z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#33424C",d:"M1676.5417,108.8396c3.6494,0,6.6014,2.9573,6.6014,6.6067c0,3.6442-2.952,6.6015-6.6014,6.6015 c-3.6442,0-6.6014-2.9573-6.6014-6.6015C1669.9403,111.7969,1672.8976,108.8396,1676.5417,108.8396z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#33424C",d:"M1669.7462,103.1085c-0.3669,5.364-4.1632,10.0988-9.6741,11.4097 c-6.785,1.6097-13.5857-2.5798-15.1954-9.3595c-1.6097-6.785,2.5797-13.5857,9.3595-15.1954 C1656.9838,96.4913,1662.7253,101.4516,1669.7462,103.1085z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#33424C",d:"M1659.4954,122.3834c2.627,0,4.761,2.1288,4.761,4.761c0,2.6322-2.134,4.7663-4.761,4.7663 c-2.6322,0-4.7662-2.1341-4.7662-4.7663C1654.7291,124.5122,1656.8632,122.3834,1659.4954,122.3834z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A09772",d:"M1785.8774,142.387c1.9507,2.994,3.0938,6.5648,3.0938,10.4082c0,10.5393-8.5415,19.0756-19.0757,19.0756 c-7.8441,0-14.5819-4.7347-17.5129-11.504c-3.8591,0.7341-7.8389,1.1221-11.9078,1.1221c-2.8682,0-5.6943-0.194-8.4629-0.561 c-1.0433,8.8667-5.17,16.7894-11.2838,22.6567c0.6921,0.1941,1.4629,0.299,2.3123,0.299 c5.5634-0.0157,10.23-4.7557,9.1027-13.5699c0,0,7.0577,8.7461,1.9767,17.1826c-5.1752,8.5992-25.7766,10.7439-27.0508,28.3198 c-0.519,7.1938,3.4922,11.8972,8.8091,10.9639c5.3115-0.9385,5.1384-5.9669,14.3774-8.5886c0,0-12.8412,11.0793-6.7745,26.196 c1.0172,2.5378,2.2494,5.7102,3.4764,9.2756c1.8037-3.3138,2.8313-7.1152,2.8313-11.158c0-1.9087-0.2307-3.7648-0.6658-5.5422 c-0.1941-0.8076-0.4353-1.5994-0.7131-2.3701c3.686-0.4038,7.0837-1.5782,10.1407-3.3557 c2.5326,1.468,5.2958,2.5273,8.2635,3.0725c-1.2688-9.0291-10.5969-12.5999-15.3789-17.1091 c-0.9543-0.9019-1.7251-1.8352-2.218-2.8577c-3.1198-6.4705,2.6008-12.3484,2.6008-12.3484 c-1.4209,6.3236,1.6516,10.0831,5.6943,10.4712c4.7349,0.4562,6.3865-4.0007,6.7535-7.1677 c1.4944-13.009-4.2052-13.4705-4.1108-26.6681c0.0786-10.5288,8.6254-15.0118,8.8928-15.1483 c-4.7925,6.2502-4.8553,20.1243,1.5731,21.2202c8.0852,1.3738,8.5939-6.439,7.0786-8.8037 c4.5408,3.2615,2.7684,9.7003-0.2571,13.4703c-2.4224,3.0201-8.7355,10.8486-2.9783,13.3077 c9.1865,3.9274,9.5222-10.6703,9.5222-10.6703c1.8508,3.167,2.0134,12.6156-3.2405,19.8831 c-5.2224,7.236-7.3723,18.5721,0.8861,21.131c6.6119,2.0449,6.4283-8.1746,6.4283-8.1746s3.9694,3.0098,2.4121,11.436 c-2.2128,11.9707-9.5221,19.301-14.1416,24.6545c2.6165,2.0344,5.6733,3.5234,9.0083,4.2996 c0.2307,1.6465,0.9647,3.125,2.0449,4.2839c0.6449,0.1101,1.033,0.2358,1.033,0.2358c-0.2202,0.0367-0.4404,0.0786-0.6606,0.1364 c1.4209,1.3424,3.3347,2.1603,5.4373,2.1603c4.3835,0,7.9386-3.5498,7.9386-7.9333c0-0.2516-0.0104-0.4928-0.0367-0.7393 c6.8584-3.4397,11.7874-10.1617,12.7258-18.1108c1.1011,0.147,2.2075,0.2517,3.3348,0.3042V126.6567 C1794.2041,132.4717,1790.3921,137.7727,1785.8774,142.387z M1784.939,199.2676c-5.2644,0-9.5273-4.2681-9.5273-9.5272 s4.2629-9.5273,9.5273-9.5273c5.2592,0,9.522,4.2682,9.522,9.5273S1790.1981,199.2676,1784.939,199.2676z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A09772",d:"M1753.3893,267.6733c-0.3408,0-0.6764,0.0261-1.0015,0.0734c-0.0105,0.9857,0.3671,1.9296,1.2427,2.8734 c1.2845,1.3843,3.5812,1.012,5.4164,0.3828C1757.9458,269.0156,1755.8223,267.6733,1753.3893,267.6733z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A09772",d:"M1759.4873,276.3354c-0.561,0.7655-1.0801,1.573-1.552,2.4224 C1758.6222,278.0815,1759.157,277.2583,1759.4873,276.3354z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A09772",d:"M1687.5161,208.8525c6.9685-1.4629,9.2128-7.7393,8.5469-14.7969 c-0.4562,0.0157-0.9229,0.0262-1.3843,0.0262c-20.7692,0-37.6111-16.8367-37.6111-37.6058c0-4.4832,0.7866-8.7775,2.2233-12.7573 c-5.9355-0.6553-11.504-2.543-16.433-5.4059v25.504c7.4091,0.5138,13.2659,6.6853,13.2659,14.2253 s-5.8568,13.7063-13.2659,14.2202v31.7437c1.8301,3.6074,4.2001,6.895,7,9.7581c-1.2112,1.8613-1.9191,4.0793-1.9191,6.4598 c0,6.5385,5.3011,11.8396,11.8397,11.8396c4.8658,0,9.0449-2.9415,10.8643-7.1415c2.3911,0.4561,4.8607,0.6973,7.3881,0.6973 c1.7827,0,3.5341-0.1206,5.2487-0.3513c0.797,6.7537,4.4727,12.621,9.7686,16.3438c0.2148-0.1206,0.4141-0.2673,0.6082-0.4404 c9.391-8.3894-16.0134-20.1084-18.6089-48.9893c-1.054-11.698,4.74-15.3003,4.74-15.3003S1678.2406,210.8032,1687.5161,208.8525z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A09772",d:"M1651.2632,255.8914c-3.3557,0-6.3655,1.4734-8.4053,3.8224v14.6869h0.0159 c2.0449,2.3333,5.0442,3.8015,8.3894,3.8015c6.161,0,11.1528-4.9918,11.1528-11.1581 C1662.416,260.8831,1657.4242,255.8914,1651.2632,255.8914z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5E4C49",d:"M1642.858,163.8169c7.4089,0.5139,13.2659,6.6854,13.2659,14.2254c0,7.54-5.8569,13.7063-13.2659,14.2202 V163.8169z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1642.858,259.7138 1642.858,274.4006 1642.858,293.0305 1639.801,295.799 1639.801,43.2602  1642.858,46.0549 1642.858,50.517 1642.858,138.3129 1642.858,163.8169 1642.858,192.2624 1642.858,224.0061 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1636.5554,40.2871 1639.801,43.2602 1639.801,295.799 1636.4138,298.8064 1636.3928,298.8064  1636.3928,40.2871 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1628.5382,32.9463 1636.5554,40.2871 1636.3928,40.2871 1636.3928,298.8064 1636.4138,298.8064  1624.8573,309.3375 1624.8573,29.5801 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"1621.9944,311.8491 1621.9944,27.2415 1622.3038,27.2415 1624.8573,29.5801 1624.8573,309.3375 \t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1797.1561,293.0305 1642.8579,293.0305 1639.801,295.7991 1639.801,295.8828 1800.3546,295.8828  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1624.8573,309.3375 1624.8573,309.3375 1636.4138,298.8064 1803.6213,298.8064  1815.4714,309.3532 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_13_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"2002.3132,615.8586 1866.8019,615.8586 1868.9366,612.2966 1998.4194,612.2966  2002.3132,615.7709 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"2016.4672,628.3787 1859.3024,628.3787 1866.8019,615.8586 2002.3132,615.8586  2002.3132,615.7709 2011.9287,624.3347 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E130B",points:"2019.5096,631.3585 1857.5183,631.3585 1859.3024,628.3787 2016.4672,628.3787  2019.5096,631.0893 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1868.9366,612.2966 1866.8019,615.8586 1812.7589,615.8586 1816.803,612.1965  1816.803,612.2966 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"1870.9774,608.8912 1994.5946,608.8912 1998.4194,612.2966 1868.9366,612.2966 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"1859.3024,628.3787 1857.5183,631.3585 1795.8318,631.3585 1795.8318,631.1957  1798.9618,628.3599 1798.9618,628.3787 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1829.442,608.8912 1865.024,608.8912 1870.9774,608.8912 1868.9366,612.2966 1816.803,612.2966  1816.803,612.1965 1820.4525,608.8912 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#19151E",d:"M1994.5946,608.8098v0.0814h-123.6172h-5.9534v-0.0876l58.2311-97.1998l12.0944,6.4041 c0,0,24.4204,2.2348,24.9338,2.2348c0.4945,0,31.1813,10.6922,34.3113,11.7814V608.8098z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1866.8019,615.8586 1859.3024,628.3787 1798.9618,628.3787 1798.9618,628.3599  1812.7589,615.8586 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CE5F15",points:"1981.605,424.2134 1981.5549,424.3011 1975.5015,424.3011 1820.4963,424.3011  1820.4963,424.2134 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CE5F15",points:"1994.5884,424.3011 1981.5549,424.3011 1981.605,424.2134 1994.6384,424.2134  1994.6384,424.2572 1994.5946,424.3011 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E130B",points:"1985.6803,417.415 2002.2382,417.415 1994.6384,424.2572 1994.6384,424.2134 1981.605,424.2134  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1990.9325,408.6509 1985.6803,417.415 1812.928,417.415 1803.3563,408.6509 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1995.014,401.8337 1993.4302,404.4755 1798.9618,404.4755 1798.9618,404.632  1795.9069,401.8337 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1990.9325,408.6509 2011.96,408.6509 2011.96,408.6697 2002.2382,417.415 1985.6803,417.415  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"2016.6174,404.4755 1993.4302,404.4755 1995.014,401.8337 2019.5096,401.8337  2019.5096,401.8713 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#B5500B",d:"M1994.5946,424.3011v49.3417h-0.0876c-11.4622-0.3005-29.7979-3.9125-43.4135-8.5074l3.3929-5.6653 c7.8751,0.0313,17.885,0.5133,24.7147,0.5884c13.8033,0.1503,3.5306-5.0268-19.1182-9.9347l15.4185-25.735v-0.0876h6.0535 h13.0334h0.0062V424.3011z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"2011.96,408.6509 1990.9325,408.6509 1993.4302,404.4755 2016.6174,404.4755 2011.96,408.6697  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"1820.4525,424.3011 1816.803,420.9582 1812.928,417.415 1985.6803,417.415 1981.605,424.2134  1820.4963,424.2134 1820.4963,424.3011 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1993.4302,404.4755 1990.9325,408.6509 1803.3563,408.6509 1798.9618,404.632  1798.9618,404.4755 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1875.2905,501.9757l5.6779,0.4007l11.9066,0.8451l4.983,0.6636l0.9515,0.1252h0.0062l1.1519,1.2332 l1.1707-0.0376h0.0062l0.0752,0.5071l1.4148,0.0876l-0.2943-1.3209l9.9661,1.3209l10.9489,5.8031l-58.2311,97.1998v0.0876 h-35.582l2.047-11.0928l2.0596-10.6609l2.9235-1.8905l10.6608,0.6886c0,0-0.1689-8.0817-0.1689-8.6013 c0-0.5133,6.5355-15.9882,6.5355-15.9882l6.3601-18.9178c0,0,1.8718-10.3541,2.7107-15.9756 c0.2692-1.8029,0.4319-3.1238,0.3881-3.4556c-0.1753-1.3772,0.1691-13.4153,0.1691-13.4153l0.3442-5.3273l3.2678-1.1143 l-0.1315,2.141l1.421-0.169l0.1189-2.4539h0.0062l2.886-0.9828l0.5696,0.0376l-0.4445,1.853c0,0,1.5087,0.3005,1.5901,0.169 c0.0376-0.0501,0.2065-0.9077,0.3944-1.9093L1875.2905,501.9757z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CE5F15",d:"M1975.5015,424.3011v0.0876l-15.4185,25.735c-2.7357-0.5947-5.6592-1.1831-8.7391-1.7591 c-28.5458-5.3336-38.1737-12.0381-67.2391-14.2729c-29.0592-2.2348-1.033,5.5026-1.033,5.5026s2.2411,0.8576,19.2622,5.5026 c17.0273,4.645-8.2507,3.6121-36.2832,1.0329c-28.0262-2.5792-19.0933,0.8576-45.5544-10.8299V424.301h155.0051V424.3011z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"2019.5096,401.8713 2019.5096,631.0893 2016.4672,628.3787 2016.8115,628.3787  2016.8115,404.4755 2016.6174,404.4755 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"2016.8115,404.4755 2016.8115,628.3787 2016.4672,628.3787 2011.9287,624.3347  2011.96,624.2971 2011.96,408.6697 2016.6174,404.4755 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"2011.96,408.6697 2011.96,624.2971 2011.9287,624.3347 2002.3132,615.7709 2002.3132,417.415  2002.2382,417.415 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E130B",points:"1994.6196,512.6179 1994.6259,473.6428 1994.6384,424.2572 2002.2382,417.415  2002.3132,417.415 2002.3132,615.7709 1998.4194,612.2966 1994.5946,608.8912 1994.5946,608.8098 1994.6134,532.0303 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CE5F15",points:"1994.6384,424.2572 1994.6259,473.6428 1994.5946,473.6428 1994.5946,424.3011 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"1994.5946",y:"473.6428",fill:"#D86B19",width:"0.0282",height:"38.9751"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EA893F",d:"M1994.6196,512.6179l-0.0062,19.4124c-0.0062-0.0063-0.0126-0.0063-0.0188-0.0063v-19.4061H1994.6196z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1994.6134,532.0303l-0.0188,76.7795V532.024C1994.6008,532.024,1994.6072,532.024,1994.6134,532.0303z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CC6723",d:"M1994.5946,512.6179v19.4061c-3.13-1.0892-33.8168-11.7814-34.3113-11.7814 c-0.5134,0-24.9338-2.2348-24.9338-2.2348l-12.0944-6.4041l3.8248-6.3853c18.0227,4.382,45.3165,9.9222,67.4834,7.4056v-0.0062 h0.0312V512.6179z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C45910",d:"M1994.5946,473.6428v38.9751h-0.0312v0.0062c-22.1669,2.5165-49.4607-3.0236-67.4834-7.4056 l24.0135-40.0831c13.6156,4.5949,31.9513,8.2069,43.4135,8.5074L1994.5946,473.6428L1994.5946,473.6428z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C45910",d:"M1960.083,450.1237c22.6488,4.9079,32.9215,10.085,19.1182,9.9347 c-6.8297-0.0751-16.8396-0.5571-24.7147-0.5884L1960.083,450.1237z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D86B19",d:"M1960.083,450.1237l-5.5966,9.3463c-9.9659-0.0501-16.5015,0.6072-8.8204,3.6809 c1.6965,0.6761,3.512,1.3397,5.4275,1.9844l-24.0135,40.0831c-7.4244-1.8029-13.2712-3.4055-16.5515-4.1754 c-11.2306-2.6355,0.9202-3.5557,8.8329-5.5026c7.9065-1.9469-11.2368-5.0456-22.5863-7.6811h-0.0125 c-0.2505-3.756-0.4445-6.692-0.4445-6.692l-1.9845-0.3944l-0.5133-5.6653l-6.0472-2.0658l-2.6355,0.8576l-1.4335,5.1833 l-2.7357,0.7512l-0.3192,1.2395l-0.5383-0.0376l1.8905-12.0381l-0.7762-1.6714l-2.7043,14.83l-0.4945-0.0626l1.1393-9.0959 l-0.6448-1.2019l-1.9407,12.8081c0,0,1.7654,0.9265,2.7983,1.421l-0.2629,1.0329c-9.4026,0-25.4471,2.9798-39.3193,2.4039 c-13.8723-0.5697,4.9329-5.5026,13.9849-9.3963c9.0583-3.9-17.6533-1.6088-33.1282-0.3443h-0.1565h-0.0125l0.0125-44.4213 c26.4612,11.6875,17.5282,8.2507,45.5544,10.8299c28.0325,2.5791,53.3105,3.612,36.2832-1.0329 c-17.0211-4.645-19.2622-5.5026-19.2622-5.5026s-28.0262-7.7374,1.033-5.5026c29.0654,2.2348,38.6934,8.9394,67.2391,14.2729 C1954.4238,448.9406,1957.3473,449.5291,1960.083,450.1237z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CE5F15",d:"M1954.4865,459.47l-3.3929,5.6653c-1.9155-0.6448-3.731-1.3083-5.4275-1.9844 C1937.985,460.0772,1944.5205,459.4199,1954.4865,459.47z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EA893F",d:"M1927.08,505.2184l-3.8248,6.3853l-10.9489-5.8031l-9.9661-1.3209l-1.8529-8.3509l-3.4305-3.8499 l-0.0062-0.0125c-0.1002-1.5087-0.2003-3.0111-0.288-4.4071h0.0125c11.3495,2.6355,30.4928,5.7342,22.5863,7.6811 c-7.9127,1.9469-20.0635,2.8671-8.8329,5.5026C1913.8087,501.813,1919.6555,503.4156,1927.08,505.2184z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#28212D",points:"1902.3402,504.4798 1902.6345,505.8006 1901.2197,505.713 1901.1445,505.2059  1901.3887,505.1997 1901.0945,504.8867 1901.0883,504.8804 1901.0006,504.2982 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1900.4873,496.1289l1.8529,8.3509l-1.3396-0.1815l-1.1581-7.5246l-2.6605-2.6605 c-0.0438-0.6072-0.0876-1.2207-0.1252-1.8342L1900.4873,496.1289z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#28212D",points:"1901.0945,504.8867 1901.3887,505.1997 1901.1445,505.2059 1901.1383,505.2059 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#28212D",points:"1901.0945,504.8867 1901.1383,505.2059 1899.9677,505.2435 1898.8158,504.0103  1900.4747,504.2294 1901.0883,504.8804 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#28212D",points:"1901.0006,504.2982 1901.0883,504.8804 1900.4747,504.2294 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EA893F",d:"M1899.8425,496.7737l1.1581,7.5246l-0.5259-0.0688l-2.8108-2.9673v-0.0063 c-0.1251-1.8342-0.3066-4.4259-0.4819-7.1427L1899.8425,496.7737z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1900.4747,504.2294l-1.6589-0.2191h-0.0062l-1.0266-1.0955v-0.0063 c-0.0314-0.4319-0.0752-0.9891-0.119-1.6464L1900.4747,504.2294z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EA893F",d:"M1897.783,502.9148l1.0266,1.0955l-0.9515-0.1252 C1897.8456,503.7912,1897.8204,503.4531,1897.783,502.9148z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1894.3336,480.7729l1.9845,0.3944c0,0,0.194,2.9359,0.4445,6.692 c0.0876,1.396,0.1877,2.8984,0.288,4.4071l-0.7762-0.8639l0.3881,2.191l0.5197,0.5196 c0.1753,2.7169,0.3568,5.3085,0.4819,7.1427l-0.7449-0.7888l0.3881,1.9344l0.4758,0.5071v0.0063 c0.0375,0.5384,0.0626,0.8764,0.0751,0.9703l-4.983-0.6636l-11.9066-0.8451l3.2114-20.9148l0.4006-2.6167l2.623,0.5196 L1894.3336,480.7729z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1897.783,502.9085l-0.4758-0.5071l-0.3881-1.9344l0.7449,0.7888v0.0063 C1897.7078,501.9194,1897.7516,502.4766,1897.783,502.9085z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1897.182,494.1131l-0.5197-0.5196l-0.3881-2.191l0.7762,0.8639l0.0062,0.0125 C1897.0944,492.8924,1897.1382,493.5059,1897.182,494.1131z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#28212D",points:"1893.8203,475.1076 1894.3336,480.7729 1887.2035,479.3644 1887.7731,473.0418 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#562C27",points:"1887.7731,473.0418 1887.2035,479.3644 1884.5804,478.8449 1883.7041,479.0827  1885.1376,473.8994 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#562C27",points:"1883.7041,479.0827 1884.5804,478.8449 1884.1798,481.4616 1882.5585,481.2112  1880.6492,481.0735 1880.9684,479.834 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#562C27",d:"M1879.1155,487.058l0.2629-1.0329c0.4319,0.2066,0.7324,0.338,0.7324,0.3005 c0-0.1315,0.601-2.022,0.601-2.022l-0.8389-0.2003l0.3881-1.5212h0.0063l1.7778,0.4319l0.5133-1.8029l1.6213,0.2504 l-3.2114,20.9148l-5.6779-0.4007l0.3318-1.3083l1.1331-0.1565l0.601-1.6777l-1.3083,0.1941l0.288-1.1268l2.0533-0.5697 l0.432-1.421l-2.141,0.6448L1879.1155,487.058z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#28212D",points:"1882.5585,481.2112 1882.0452,483.0141 1880.2673,482.5821 1880.6492,481.0735 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#28212D",points:"1881.2251,467.3264 1882.0013,468.9978 1880.1108,481.0359 1880.6492,481.0735  1880.2673,482.5821 1880.261,482.5821 1878.5208,482.1564 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1879.8729,484.1033l0.8389,0.2003c0,0-0.601,1.8905-0.601,2.022c0,0.0376-0.3005-0.0939-0.7324-0.3005 L1879.8729,484.1033z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D87721",points:"1880.261,482.5821 1879.8729,484.1033 1877.8322,483.615 1878.0199,482.0938  1878.0262,482.0938 1878.5208,482.1564 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1879.8729,484.1033l-0.4945,1.9218c-1.033-0.4945-2.7983-1.421-2.7983-1.421l1.9407-12.8081 l0.6448,1.2019l-1.1393,9.0959h-0.0063l-0.1877,1.5212L1879.8729,484.1033z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EA893F",d:"M1879.1155,487.058l-2.4352,9.4965l-4.1379,1.252l-0.4319,1.8092l-5.2021,0.77l-0.1689,2.7544 l-3.2678,1.1143l-0.3442,5.3273c0,0-0.3444,12.0381-0.1691,13.4153c0.0438,0.3318-0.1189,1.6526-0.3881,3.4556h-0.0063 l-0.1251-0.0188c-3.6058-0.2191-7.4182-0.3944-11.3557-0.5196c-0.1378-6.2413-5.2397-11.2556-11.5123-11.2556 c-6.2788,0-11.3807,5.0143-11.5184,11.2493c-2.5479,0.0876-5.0769,0.2066-7.5747,0.3569h-0.0062l0.0126-46.5435h0.0125h0.1565 c15.4749-1.2645,42.1865-3.5557,33.1282,0.3443c-9.052,3.8937-27.8572,8.8267-13.9849,9.3963 C1853.6683,490.0378,1869.7129,487.058,1879.1155,487.058z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#28212D",points:"1878.8213,495.9098 1878.3893,497.3308 1876.3359,497.9005 1876.6803,496.5545 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#28212D",points:"1877.3563,498.8332 1876.7554,500.5109 1875.6223,500.6674 1876.048,499.0273 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1876.6803,496.5545l-0.3444,1.3459l-2.5916,0.7199c0,0-0.0564,0.3067-0.144,0.77l-1.4899,0.2254 l0.4319-1.8092L1876.6803,496.5545z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EA893F",d:"M1876.3359,497.9005l-0.288,1.1268l-2.4476,0.3631c0.0876-0.4633,0.144-0.77,0.144-0.77 L1876.3359,497.9005z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1876.048,499.0273l-0.4257,1.6401l-2.3162,0.3255c0.1127-0.5884,0.2191-1.1706,0.2942-1.6026 L1876.048,499.0273z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EA893F",d:"M1875.6223,500.6674l-0.3318,1.3083l-2.1409-0.1502c0.0563-0.2754,0.1064-0.5571,0.1565-0.8326 L1875.6223,500.6674z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1872.1105,499.6157l1.4899-0.2254c-0.0751,0.4319-0.1815,1.0141-0.2942,1.6026l-1.5775,0.2254 L1872.1105,499.6157z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1873.3062,500.9929c-0.05,0.2755-0.1002,0.5572-0.1565,0.8326l-1.54-0.1127l0.119-0.4945 L1873.3062,500.9929z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#28212D",d:"M1871.6096,501.7128l1.54,0.1127c-0.1879,1.0016-0.3568,1.8593-0.3944,1.9093 c-0.0814,0.1314-1.5901-0.169-1.5901-0.169L1871.6096,501.7128z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#28212D",points:"1872.1105,499.6157 1871.7286,501.2183 1868.1979,501.7128 1868.1541,502.6581  1868.1478,502.6581 1866.7394,503.1401 1866.9083,500.3857 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#EA893F",points:"1871.7286,501.2183 1871.6096,501.7128 1871.04,501.6753 1868.1541,502.6581  1868.1979,501.7128 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#28212D",points:"1868.1478,502.6581 1868.0289,505.112 1866.6079,505.2811 1866.7394,503.1401 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D87721",d:"M1828.0522,525.9079c7.7374-0.2629,15.6063-0.2253,23.0308,0.0063 c3.9375,0.1252,7.7499,0.3005,11.3557,0.5196l0.1251,0.0188h0.0063c-0.8389,5.6215-2.7107,15.9756-2.7107,15.9756 l-6.3601,18.9178c0,0-6.5355,15.4749-6.5355,15.9882c0,0.5196,0.1689,8.6013,0.1689,8.6013l-10.6608-0.6886l-2.9235,1.8905 l-2.0596,10.6609l-2.047,11.0928h-8.9895v-0.0814l0.0188-82.545h0.0062 C1822.9753,526.1145,1825.5044,525.9955,1828.0522,525.9079z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE088",d:"M1839.5707,514.6586c6.2726,0,11.3745,5.0143,11.5123,11.2556 c-7.4244-0.2316-15.2933-0.2692-23.0308-0.0063C1828.1899,519.6729,1833.2919,514.6586,1839.5707,514.6586z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CEB080",points:"1820.4963,435.3 1820.4839,479.7213 1820.4713,526.2648 1820.4525,608.8098 1820.4525,424.3011  1820.4963,424.3011 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1820.4525,608.8098 1820.4525,608.8912 1816.803,612.1965 1816.803,420.9582  1820.4525,424.3011 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1816.803,420.9582 1816.803,612.1965 1812.7589,615.8586 1812.7339,615.8586 1812.7339,417.415  1812.928,417.415 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1803.3563,408.6509 1812.928,417.415 1812.7339,417.415 1812.7339,615.8586 1812.7589,615.8586  1798.9618,628.3599 1798.9618,404.632 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"1798.9618,404.632 1798.9618,628.3599 1795.8318,631.1957 1795.8318,631.3585  1795.5438,631.3585 1795.5438,401.8337 1795.9069,401.8337 \t\t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"flowers"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"287.2823",y:"93.6369",fill:"#00365E",width:"197.3065",height:"224.763"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_11_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4D7487",d:"M453.3209,112.1828l10.5503,100.9181h-27.7828c0-27.7354-22.4866-50.2219-50.2219-50.2219 s-50.2219,22.4866-50.2219,50.2219h-27.7828l10.5503-100.9181h22.2863l45.068,32.5889l45.2208-32.5889H453.3209z M424.9479,155.2799c7.9786-4.706,11.1932-14.0442,7.1723-20.8529l-28.8947,17.0533 C407.2463,158.289,416.9693,159.9912,424.9479,155.2799z M368.5075,151.4803l-28.8947-17.0533 c-4.0209,6.8087-0.8116,16.1469,7.1723,20.8529C354.7636,159.9912,364.4866,158.289,368.5075,151.4803z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#385E75",points:"443.9247,102.8604 430.9872,112.1828 340.6983,112.1828 327.8082,102.8604 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#385E75",d:"M399.3626,178.3672c-4.1843-1.6284-8.7375-2.519-13.4962-2.519c-5.0169,0-9.8073,0.9907-14.176,2.793 c-5.0433,2.0763-9.5332,5.2277-13.1747,9.1696c-3.8365,4.1421-6.7349,9.1591-8.3738,14.7135 c-0.996,3.3516-1.5283,6.9035-1.5283,10.5766h-12.9692c0-27.7354,22.4866-50.2219,50.2219-50.2219 s50.2219,22.4866,50.2219,50.2219H423.119c0-3.6889-0.5375-7.2566-1.5388-10.6188c-1.8181-6.1341-5.175-11.6043-9.6175-15.9677 C408.3899,183.0047,404.1108,180.2169,399.3626,178.3672z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#07213F",d:"M432.1202,134.427c4.0209,6.8087,0.8063,16.1469-7.1723,20.8529 c-7.9786,4.7113-17.7015,3.0091-21.7224-3.7996L432.1202,134.427z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#385E75",points:"430.9872,112.1828 385.7663,144.7718 340.6983,112.1828 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A2DAE0",d:"M423.1192,213.101h-11.1985v-10.5397h9.3962l0.2635-0.0791 C422.5817,205.8444,423.1192,209.4121,423.1192,213.101z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#509496",d:"M421.5804,202.4822l-0.2635,0.0791h-9.3962v-16.0046l0.0422-0.0422 C416.4054,190.8779,419.7623,196.348,421.5804,202.4822z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A2DAE0",d:"M411.9629,186.5145l-0.0422,0.0422v16.0046h-12.5581v-24.194 C404.1108,180.2169,408.3899,183.0047,411.9629,186.5145z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"399.3626",y:"202.5612",fill:"#509496",width:"12.5581",height:"10.5398"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"385.8665",y:"202.5612",fill:"#A2DAE0",width:"13.4962",height:"10.5398"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#509496",d:"M399.3626,178.3672v24.194h-13.4962v-26.713C390.6252,175.8482,395.1783,176.7388,399.3626,178.3672z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"371.6958",y:"202.5612",fill:"#83BBC4",width:"14.1707",height:"10.5398"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A2DAE0",d:"M385.8665,175.8482v26.713h-14.1707v-23.9094l-0.0053-0.0105 C376.0592,176.839,380.8495,175.8482,385.8665,175.8482z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"358.6054",y:"202.5612",fill:"#A2DAE0",width:"13.0904",height:"10.5398"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#83BBC4",d:"M371.6958,178.6518v23.9094h-13.0904v-14.6661l-0.0896-0.0843 c3.6415-3.9419,8.1314-7.0932,13.1747-9.1696L371.6958,178.6518z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#07213F",d:"M339.6127,134.427l28.8947,17.0533c-4.0209,6.8087-13.7438,8.5108-21.7224,3.7996 C338.8012,150.5739,335.5918,141.2357,339.6127,134.427z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#83BBC4",d:"M358.6054,202.5612v10.5397h-9.9917c0-3.6731,0.5323-7.225,1.5283-10.5766l0.1212,0.0369H358.6054z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A2DAE0",d:"M358.6054,187.8952v14.6661h-8.3422l-0.1212-0.0369c1.6389-5.5544,4.5374-10.5714,8.3738-14.7135 L358.6054,187.8952z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"288.3565",y:"213.1042",fill:"#3C565E",width:"196.5302",height:"103.434"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"288.3565",y:"234.0043",fill:"#245066",width:"196.5302",height:"37.2495"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#203521",d:"M473.278,274.0979l-7.9224,2.9148c-0.0836-1.4782-0.1715-2.9883-0.2634-4.5269 c0.6311-1.5059,1.2886-3.0074,1.9597-4.4885l1.5069-1.7647l-0.9538,0.5544c5.1009-11.0597,10.7079-20.5958,10.7079-20.5958 c0.1888,3.6827,0.5151,7.1641,0.9474,10.4451l0.0548-27.788c-1.2206-1.0241-2.176-2.0209-2.176-2.0209 s-8.8028,24.0963-12.3755,40.3293c-2.4194-38.0821-7.3153-90.4937-16.7333-116.7798l-2.8315,0.7079 c4.0324,13.4877,9.4571,44.6768,13.2817,81.2977c-4.9287-15.1463-16.3492-36.9375-16.3492-36.9375s-5.1911,3.7753-8.0226,3.9326 c0,0-4.0899,47.349-14.3148,61.9785c0,0,18.4048-15.7306,20.7643-47.8209c0,0,11.1647,13.2328,18.6563,26.1501 c0.9596,9.9363,1.7911,20.2,2.4387,30.5613l-25.0277,14.5481l7.8653-9.9103l-22.0968,10.9867 c2.6362-3.116,4.9761-6.1823,5.9624-8.2696c-5.6718,5.5801-13.603,11.0023-13.603,11.0023 c6.1113-16.2433,2.8125-26.9722,2.8125-26.9722c0.4402,7.064-5.0451,23.7575-7.2996,30.2695l-22.091,10.9838l9.4384-8.9664 l-4.5432,1.1051c2.3598-2.9395,4.7548-6.2759,5.2211-8.2221c-3.7706,3.9665-9.7251,7.9957-9.7251,7.9957 c1.1333-10.7941-5.0614-17.3932-5.0614-17.3932c2.3843,4.3691,2.0449,15.0078,1.777,19.5141l-16.77,4.0792l13.2137-5.8203 l-28.7793,6.0769c7.476-7.4933,24.3906-17.9588,24.3906-17.9588c-0.4566-1.0357,0.3673-3.8214,0.3673-3.8214 s-9.8196,1.1962-17.7208,2.9411c15.6609-12.3043,30.394-21.3731,30.394-21.3731l-1.4551-0.9438 c-13.2442,7.76-24.3031,15.7865-33.2383,23.1362c2.3322-2.7693,4.1092-5.1011,4.1092-5.1011s-2.1134-1.1347-2.6181-2.0608 c0,0-5.9463,2.2212-12.1547,3.7933c3.4267-8.1355,6.9108-16.9836,8.6261-23.0711c0,0-5.973,12.3242-12.7503,23.9932 c-1.3467,0.2541-2.644,0.4447-3.8281,0.539c2.5723-4.9724,4.6099-9.659,5.1737-12.8916 c-2.0638,3.5647-4.6942,7.0309-7.3265,10.1061c4.2883-10.3774,9.3118-21.3772,14.4245-31.7253 c7.2536-6.7794,15.7247-12.7705,15.7247-12.7705c-8.0205,22.3836-3.2695,37.0096-3.2695,37.0096 c-0.9493-12.1423,10.5787-45.298,10.5787-45.298c-1.3802-0.707-2.9101-4.3812-2.9101-4.3812s-10.1995,10.5727-17.1423,19.4989 c6.7443-13.227,13.4219-24.8893,18.5501-32.0584l-2.5169-1.1011c-14.0373,22.8462-24.1718,43.2058-31.3936,59.8964 c0.5672-8.3925-0.0826-20.5284-0.4723-26.4355c6.6503-35.6769,9.6643-64.5915,8.8993-73.102l-1.8877-0.1573 c0.0722,17.4855-3.8721,44.1637-8.874,70.5231c-1.1281,0.476-2.5771,0.9685-3.416,0.787c0,0-1.9303,5.257-4.7849,12.1298 c-0.5548-2.2176-1.1593-4.3961-1.8097-6.5247c1.7874-10.533,3.9002-21.0974,6.3-31.2965h-2.045 c-2.4278,8.9445-4.4048,17.6538-6.0174,25.9728c-2.6528-7.4322-5.8801-14.0664-9.5173-19.3525 c-0.2095-8.7827-0.7545-17.0354-1.9262-24.2385l-1.5731,0.6292c0.7527,6.6671,1.179,13.6469,1.4018,20.7653 c-0.2558-0.3216-0.5134-0.6366-0.7726-0.9448l-1.2585,0.7865c0.7061,0.8302,1.4073,1.7347,2.1015,2.7032 c0.3932,15.9624-0.1552,32.5124-0.2845,47.7223c-2.1059-8.9586-6.1036-19.5739-6.1036-19.5739s-2.6545,2.6545-5.9579,2.4186 c0,0,1.1335,12.5964,0.1428,24.9639c-2.9942-5.5305-5.2356-9.2333-5.2356-9.2333s2.3394,4.7474,5.0835,10.954 c-0.4295,4.4264-1.1521,8.7466-2.3206,12.365c0,0,1.9616-2.5994,3.6454-9.3235c2.5145,5.865,5.1059,12.4733,6.4126,17.5111 c-4.9488-3.9421-9.5174-6.1017-9.5174-6.1017l4.9381,8.7788l-1.0306,0.462c-4.313-7.2117-8.7839-12.1116-8.7839-12.1116v16.0492 l-0.0787,0.0353l0.0714,27.8458l186.9993,0.0005l0.0052-55.2175l-7.59,1.4158L473.278,274.0979z M335.7299,270.4904 c-1.923,4.541-3.6262,8.7939-5.125,12.7255c-0.0444-3.5505-0.2388-7.1306-0.5724-10.7019 c1.1632-5.1454,2.2611-10.2367,3.2949-15.2439C334.1641,260.9986,335.1182,265.7768,335.7299,270.4904z M302.6077,253.5992 c0,0,4.7571,8.6793,8.3953,17.608c-0.0113,3.1945,0.0014,6.3214,0.0514,9.3611c-0.1245,0.1383-0.2483,0.2727-0.3712,0.4009 c0,0,0.1337-0.0866,0.3734-0.2574c0.0349,2.0683,0.0881,4.0943,0.162,6.076c-3.6961-9.1964-8.3625-13.3553-8.3625-13.3553 c3.6221,5.2138,7.1829,19.5228,8.9229,27.2785l-1.0745-0.3793c-2.7466-7.5439-6.6506-15.5808-10.0083-21.9654 C301.9207,272.7562,302.8796,264.7214,302.6077,253.5992z M318.6619,266.0638c-0.1265,1.0311-0.2469,2.0493-0.3624,3.0565 c-1.8036,3.4823-3.6355,6.652-5.3796,9.0918c-0.192-17.5038,0.7556-37.3185,0.4719-55.2142 c3.285,5.331,6.3338,12.1131,8.8416,19.786c-0.7881,4.2657-1.4806,8.4198-2.088,12.4394 c-1.9452-5.9212-3.9067-9.0099-3.9067-9.0099C317.7719,250.6758,318.4478,258.0865,318.6619,266.0638z M328.062,258.7556 c1.2458-2.5725,2.4458-5.3895,3.5492-8.4853c0,0,0.1505,0.5469,0.3954,1.4995c-0.9327,4.5927-1.8824,9.1236-2.8336,13.543 C328.8525,263.1096,328.4807,260.9211,328.062,258.7556z M456.6036,280.2328l5.2786-6.1815 c0.0802,1.3839,0.1575,2.7686,0.2308,4.1544L456.6036,280.2328z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M342.4578,211.2527c-2.419,0.9034-7.4207,1.0493-8.4004-0.7087 c-0.9797-1.7581,2.4334-4.7545,4.8524-5.6578s4.425-1.5551,6.1541,1.5476C346.7929,209.5364,344.8768,210.3493,342.4578,211.2527 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M332.3921,220.545c-1.1695-2.0986-1.5609-6.3622,0.4656-7.1189c2.0265-0.7568,5.7035,2.2798,6.873,4.3784 s2.017,4.1896-1.1921,5.8153C335.1651,225.3289,333.5616,222.6436,332.3921,220.545z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M339.7818,217.7577c-2.5375-0.8452-6.3509-3.7567-5.6107-5.535s5.0654-1.6326,7.6029-0.7874 s4.6685,1.6645,3.9426,4.6328C344.9163,219.3405,342.3193,218.6028,339.7818,217.7577z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M322.6705,204.8502c2.5375,0.8452,6.3509,3.7567,5.6107,5.535s-5.7536,1.7498-8.2911,0.9047 c-2.5375-0.8452-3.1571-1.7694-2.5357-5.073C318.0433,203.0859,320.1331,204.005,322.6705,204.8502z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M321.012,211.5699c2.419-0.9034,7.4207-1.0494,8.4004,0.7087c0.9798,1.7581-2.4334,4.7545-4.8524,5.6578 s-3.7061,2.0389-5.4352-1.0638C317.3958,213.7699,318.593,212.4732,321.012,211.5699z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M324.8269,218.358c0.8835-2.1227,4.1435-5.2407,6.2693-4.5327c2.1257,0.708,2.3123,4.974,1.4287,7.0967 c-0.8835,2.1227-2.5286,4.206-5.9879,2.4003C323.0759,221.5156,323.9434,220.4807,324.8269,218.358z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M339.1387,205.0954c-0.8835,2.1227-4.4297,4.9859-6.5555,4.2779 c-2.1257-0.708-2.3123-4.974-1.4287-7.0967s1.8767-4.2951,5.6283-3.0455C340.5343,200.4806,340.0222,202.9727,339.1387,205.0954z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M331.0887,202.7333c1.1695,2.0986,1.5609,6.3622-0.4657,7.1189 c-2.0265,0.7568-5.7034-2.2798-6.873-4.3784s-2.2289-4.4132,1.5517-5.1701 C328.7347,199.6165,329.9192,200.6347,331.0887,202.7333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.1311 -0.9914 0.9914 0.1311 77.9484 512.0358)",fill:"#DD9117",cx:"331.076",cy:"211.5506",rx:"3.2645",ry:"3.8617"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M379.506,197.7392c-1.0559,2.7478-4.8123,6.9133-7.1806,6.1562c-2.3683-0.7571-2.4518-6.15-1.3959-8.8978 s2.0204-4.9406,6.2001-3.6045C381.3092,192.7292,380.5618,194.9915,379.506,197.7392z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M380.1684,214.0447c-2.8271-0.9037-7.0271-4.3416-6.1426-6.6435s6.5187-2.5962,9.3458-1.6925 s5.3967,2.0607,4.3865,6.0821C386.6962,216.0184,382.9955,214.9484,380.1684,214.0447z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M383.3686,205.6262c-2.7457,1.304-8.3717,1.8185-9.4209-0.3446 c-1.0492-2.163,2.4477-5.5257,5.1934-6.8297s5.1516-2.3026,7.2993,0.8967C388.808,202.8756,386.1143,204.3223,383.3686,205.6262z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M358.2672,208.0731c2.7457-1.304,8.3717-1.8185,9.4209,0.3446c1.0492,2.163-2.8758,6.1845-5.6214,7.4884 c-2.7457,1.304-4.0721,0.9903-6.6074-2.4197C353.0565,210.2545,355.5215,209.377,358.2672,208.0731z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M363.1172,215.3279c1.0559-2.7478,4.8123-6.9133,7.1806-6.1562c2.3683,0.7571,2.4518,6.15,1.3959,8.8978 s-1.0193,4.7863-5.1989,3.4502C362.3151,220.1836,362.0614,218.0756,363.1172,215.3279z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M372.2867,218.2252c-1.2524-2.582-1.5661-7.9584,0.734-9.0508c2.3001-1.0924,6.3431,2.5129,7.5956,5.0949 s1.8766,5.744-2.4636,6.9462C373.8101,222.4185,373.5391,220.8072,372.2867,218.2252z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M371.2986,194.9972c1.2524,2.582,1.1107,7.965-1.1895,9.0574c-2.3001,1.0924-6.3431-2.5129-7.5955-5.0949 c-1.2524-2.582-2.465-5.2962,1.5944-7.2241S370.0462,192.4152,371.2986,194.9972z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M362.8799,199.4148c2.8271,0.9037,7.0271,4.3416,6.1426,6.6435s-6.5187,2.5962-9.3458,1.6925 s-5.7659-2.0865-3.5173-5.8043C358.2011,198.5707,360.0528,198.5111,362.8799,199.4148z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.9301 -0.3674 0.3674 0.9301 -50.1832 150.7715)",fill:"#DD9117",cx:"370.9473",cy:"207.2043",rx:"4.359",ry:"4.113"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M408.9877,257.0406c-3.5907,0.4906-10.3377-1.0718-10.9567-4.0517s5.1245-6.2489,8.7152-6.7395 s6.5299-0.7517,7.6223,4.5073C415.4609,256.0157,412.5784,256.55,408.9877,257.0406z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M391.8704,267.3632c-0.7389-3.5571,0.4146-10.0771,3.4226-10.4881 c3.0081-0.411,6.7317,5.4427,7.4705,8.9998c0.7389,3.5571,1.05,6.9881-3.8816,8.2785 C393.6978,275.5099,392.6093,270.9203,391.8704,267.3632z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M402.8503,265.823c-3.0615-2.1683-7.0168-7.8835-5.3274-10.2812 c1.6893-2.3977,7.417-0.6396,10.4785,1.5287s5.5894,4.1532,3.4511,8.3371C409.0951,270.02,405.9118,267.9913,402.8503,265.823z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M385.0405,240.4134c3.0615,2.1684,7.0168,7.8835,5.3275,10.2812 c-1.6894,2.3977-8.3836,0.5701-11.4451-1.5983c-3.0615-2.1683-3.5266-3.7722-1.3964-8.4949 C379.5455,236.1255,381.9791,238.2451,385.0405,240.4134z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M380.1795,249.8793c3.5907-0.4906,10.3378,1.0718,10.9567,4.0517 c0.619,2.9799-5.1245,6.2489-8.7152,6.7395s-5.7587,1.7317-6.8511-3.5273C374.4775,251.8842,376.5888,250.3699,380.1795,249.8793 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M382.6122,261.3966c2.0165-2.8622,7.603-6.3677,10.1677-4.5512s1.1364,8.2672-0.8802,11.1294 s-5.0362,5.3943-8.9527,1.4602C379.0284,265.4986,380.5957,264.2588,382.6122,261.3966z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M406.97,246.6441c-2.0166,2.8622-7.8857,5.8845-10.4503,4.068s-1.1364-8.2672,0.8802-11.1293 c2.0166-2.8622,4.1993-5.7596,8.7256-2.5538C410.6516,240.2346,408.9866,243.7819,406.97,246.6441z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M397.1323,240.2428c0.7389,3.5571-0.4146,10.0771-3.4226,10.4881 c-3.0081,0.411-6.7317-5.4427-7.4705-8.9998s-1.2454-7.3983,4.1087-7.1849C395.2096,234.74,396.3935,236.6857,397.1323,240.2428z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.5915 -0.8063 0.8063 0.5915 -43.5445 420.9068)",fill:"#DD9117",cx:"393.6262",cy:"253.428",rx:"5.0194",ry:"5.3785"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M451.1506,146.4762c-3.663,0.6172-10.5458-1.3483-11.1772-5.0968 c-0.6314-3.7486,5.2277-7.8608,8.8906-8.478s6.6613-0.9456,7.7757,5.67S454.8136,145.8591,451.1506,146.4762z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M433.6888,159.4616c-0.7537-4.4747,0.4229-12.6766,3.4915-13.1936 c3.0686-0.517,6.8671,6.8466,7.6208,11.3213c0.7538,4.4747,1.0711,8.7907-3.9597,10.414 C435.553,169.7098,434.4425,163.9362,433.6888,159.4616z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M444.8897,157.524c-3.1231-2.7277-7.158-9.917-5.4346-12.9333s7.5662-0.8046,10.6893,1.9231 s5.7019,5.2246,3.5205,10.4877C451.2602,162.8037,448.0128,160.2517,444.8897,157.524z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M426.7215,125.56c3.1231,2.7277,7.158,9.9171,5.4347,12.9333s-8.5523,0.7172-11.6754-2.0105 c-3.1231-2.7277-3.5976-4.7453-1.4245-10.6862C421.1159,120.166,423.5984,122.8323,426.7215,125.56z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M421.7627,137.4676c3.663-0.6172,10.5458,1.3483,11.1772,5.0968 c0.6314,3.7486-5.2277,7.8608-8.8906,8.478s-5.8746,2.1784-6.989-4.4372S418.0997,138.0848,421.7627,137.4676z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M424.2443,151.9558c2.0572-3.6005,7.7561-8.0103,10.3724-5.7253 c2.6163,2.2851,1.1593,10.3997-0.8979,14.0002c-2.0571,3.6005-5.1375,6.7858-9.1329,1.8368 C420.5884,157.116,422.1872,155.5563,424.2443,151.9558z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M449.0923,133.3978c-2.0571,3.6005-8.0443,7.4024-10.6606,5.1173s-1.1593-10.3997,0.8979-14.0002 c2.0571-3.6005,4.2838-7.2453,8.9012-3.2126C452.848,125.3351,451.1495,129.7974,449.0923,133.3978z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M439.0566,125.3453c0.7538,4.4747-0.4229,12.6766-3.4915,13.1936 c-3.0686,0.517-6.8671-6.8466-7.6208-11.3213s-1.2704-9.3067,4.1914-9.0383 C437.0952,118.4231,438.3029,120.8707,439.0566,125.3453z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.9861 -0.166 0.166 0.9861 -17.5245 74.2608)",fill:"#DD9117",cx:"435.4774",cy:"141.9644",rx:"5.3253",ry:"6.5053"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M314.4861,195.6906c-1.288,0.5107-3.6647,0.4163-3.8331-0.796s1.9352-3.0832,3.2232-3.5939 s2.3398-0.8691,2.637,1.2702C316.8104,194.7104,315.774,195.1799,314.4861,195.6906z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M308.2065,201.5128c-0.201-1.447,0.324-4.3107,1.403-4.7385s2.3033,1.7422,2.5043,3.1892 s0.2518,2.8766-1.5279,3.8396C308.715,204.8155,308.4075,202.9598,308.2065,201.5128z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M312.1456,199.9341c-1.0529-0.6621-2.3622-2.7538-1.7183-3.9135 c0.6439-1.1597,2.6539-0.8963,3.7068-0.2342s1.9189,1.2913,1.0837,3.2467C314.2972,201.1888,313.1985,200.5962,312.1456,199.9341 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M306.2445,190.6534c1.0529,0.6621,2.3622,2.7538,1.7183,3.9135c-0.6439,1.1597-2.9971,0.9483-4.05,0.2862 c-1.0529-0.6621-1.1906-1.3034-0.3489-3.4868C304.3616,189.297,305.1916,189.9913,306.2445,190.6534z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M304.3468,195.0793c1.288-0.5107,3.6646-0.4163,3.8331,0.796c0.1684,1.2122-1.9353,3.0832-3.2232,3.5939 c-1.288,0.5107-2.0822,1.22-2.3794-0.9194C302.2801,196.4104,303.0589,195.59,304.3468,195.0793z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M305.0121,199.7612c0.7686-1.3843,2.8204-3.3424,3.7025-2.7878c0.882,0.5547,0.2603,3.412-0.5083,4.7964 c-0.7686,1.3843-1.8888,2.7131-3.2155,1.3739C303.6634,201.8036,304.2435,201.1455,305.0121,199.7612z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M313.9491,191.4493c-0.7686,1.3843-2.9127,3.1612-3.7947,2.6066 c-0.882-0.5547-0.2603-3.412,0.5084-4.7964c0.7686-1.3843,1.597-2.7977,3.1536-1.8188 C315.373,188.4196,314.7177,190.065,313.9491,191.4493z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M310.5558,189.5621c0.201,1.4471-0.324,4.3107-1.403,4.7385s-2.3033-1.7422-2.5043-3.1892 c-0.201-1.4471-0.3143-3.0342,1.5897-3.3948C309.967,187.3893,310.3548,188.1151,310.5558,189.5621z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.4085 -0.9127 0.9127 0.4085 4.3922 397.7045)",fill:"#DD9117",cx:"309.058",cy:"195.4633",rx:"2.2753",ry:"1.7762"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M312.4234,212.6109c-0.6134,1.3901-2.5823,3.1617-3.6949,2.3645 c-1.1126-0.7972-0.9475-4.3336-0.3341-5.7238c0.6135-1.3901,1.1617-2.4805,3.1252-1.0736S313.0368,211.2208,312.4234,212.6109z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M312.1221,221.9391c-1.3281-0.9516-3.2214-3.5509-2.7075-4.7154 c0.5139-1.1646,3.2404,0.0188,4.5685,0.9705c1.3281,0.9516,2.5224,2.0064,1.8825,4.1243 C315.1929,224.5448,313.4502,222.8908,312.1221,221.9391z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M313.9848,218.147c-1.3728,0.3101-4.1038-0.7475-4.5272-2.1346c-0.4233-1.3872,1.39-2.745,2.7628-3.0551 s2.5703-0.028,3.4836,2.1166C316.7109,217.4381,315.3576,217.837,313.9848,218.147z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M301.7944,214.677c1.3729-0.3101,4.1039,0.7475,4.5272,2.1346c0.4233,1.3872-1.6213,3.051-2.9942,3.3611 s-2.0002-0.5463-3.0922-2.8705C299.2002,215.0996,300.4215,214.9871,301.7944,214.677z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M303.8557,220.0092c0.6134-1.3902,2.5823-3.1617,3.6949-2.3645s0.9475,3.8613,0.3341,5.2515 c-0.6135,1.3901-0.6734,3.0215-2.6369,1.6145C303.2843,223.1038,303.2423,221.3994,303.8557,220.0092z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M308.1645,223.0767c-0.5053-1.6559-0.4519-4.7465,0.6982-5.0063s2.9613,2.4097,3.4666,4.0656 s0.6858,4.0144-1.4516,4.0185C308.7391,226.1587,308.6698,224.7326,308.1645,223.0767z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M308.5724,209.3089c0.5053,1.6559,0.2321,5.1516-0.9179,5.4114 c-1.1501,0.2598-2.9613-2.4097-3.4667-4.0656c-0.5053-1.6559-0.9864-3.8527,1.0433-4.3111 C307.2608,205.8852,308.067,207.653,308.5724,209.3089z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M304.3469,210.9692c1.3281,0.9516,3.2214,3.5509,2.7075,4.7154 c-0.5139,1.1646-3.2404-0.0188-4.5685-0.9705c-1.3281-0.9516-2.6994-2.0786-1.4742-3.8317 C302.1242,209.2906,303.0189,210.0176,304.3469,210.9692z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.9741 -0.226 0.226 0.9741 -40.9928 75.1969)",fill:"#DD9117",cx:"307.9199",cy:"216.6312",rx:"2.0018",ry:"2.4947"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M351.7854,154.2403c-0.591,3.0226-3.6895,8.0231-6.2437,7.7066s-3.597-5.8301-3.006-8.8527 c0.591-3.0225,1.1871-5.4583,5.6949-4.8998C352.7384,148.753,352.3764,151.2178,351.7854,154.2403z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M355.3572,170.8311c-3.049-0.3778-7.9507-3.0875-7.4556-5.6196 c0.4951-2.5321,6.1995-3.9277,9.2484-3.5499c3.049,0.3778,5.8799,1.0652,5.5616,5.3849 C362.3772,171.5875,358.4062,171.2089,355.3572,170.8311z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M357.1323,161.5776c-2.5738,1.8701-8.2308,3.49-9.6868,1.4758s1.5198-6.1412,4.0937-8.0114 c2.5738-1.8701,4.8547-3.3612,7.6171-0.4977C362.2016,157.7011,359.7061,159.7075,357.1323,161.5776z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M331.9199,168.9601c2.5738-1.8701,8.2308-3.49,9.6868-1.4758s-1.8403,6.8998-4.4141,8.7699 s-3.9847,1.806-7.1805-1.1983C326.9832,172.2086,329.346,170.8302,331.9199,168.9601z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M338.1633,175.4574c0.591-3.0225,3.6895-8.0231,6.2437-7.7066s3.5969,5.8301,3.006,8.8526 c-0.591,3.0226-0.1917,5.1057-4.6994,4.5472C338.2058,180.5921,337.5724,178.4799,338.1633,175.4574z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C6BE79",d:"M348.0464,176.648c-1.7381-2.4044-3.0131-7.8564-0.857-9.423c2.1562-1.5667,6.9271,1.3452,8.6652,3.7496 s2.9372,5.5255-1.2838,7.6009C350.3474,180.652,349.7845,179.0524,348.0464,176.648z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DDDAA6",d:"M342.9129,153.0221c1.7381,2.4044,2.549,7.9516,0.3928,9.5183 c-2.1562,1.5667-6.9271-1.3452-8.6652-3.7496c-1.738-2.4044-3.4588-4.9521,0.3464-7.717 C338.7922,148.3089,341.1749,150.6178,342.9129,153.0221z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D6D29D",d:"M335.0955,159.1864c3.049,0.3778,7.9507,3.0875,7.4556,5.6196s-6.1994,3.9277-9.2484,3.5499 s-6.2616-1.0201-4.6242-5.2688C330.1653,159.2293,332.0466,158.8087,335.0955,159.1864z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.7993 -0.6009 0.6009 0.7993 -30.3428 240.3699)",fill:"#DD9117",cx:"344.6995",cy:"165.6129",rx:"4.5612",ry:"4.2532"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_10_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"513.4683,344.187 513.4683,344.5564 258.5068,344.5564 258.5068,344.333 262.8017,340.4419  262.8017,340.4677 509.2936,340.4677 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"513.4683,67.442 513.4683,344.187 509.2936,340.4677 509.7661,340.4677 509.7661,71.0153  509.4998,71.0153 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"513.4683,67.3904 513.4683,67.442 509.4998,71.0153 262.8017,71.0153 262.8017,71.23  258.6099,67.3904 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"509.7661,71.0153 509.7661,340.4677 509.2936,340.4677 503.066,334.9186 503.109,334.8671  503.109,76.7704 509.4998,71.0153 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"509.4998,71.0153 503.109,76.7704 503.109,76.7447 268.8317,76.7447 262.8017,71.23  262.8017,71.0153 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"509.2936,340.4677 262.8017,340.4677 262.8017,340.4419 281.7336,323.2881 489.8807,323.2881  489.8807,323.1678 503.066,334.9186 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"503.109,76.7704 503.109,334.8671 503.066,334.9186 489.8807,323.1678 489.8807,88.7703  489.7691,88.7703 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"503.109,76.7447 503.109,76.7704 489.7691,88.7703 281.9655,88.7703 268.8317,76.7447 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"489.8807,323.1678 489.8807,323.2881 281.7336,323.2881 287.2826,318.2631 287.2826,318.4005  484.5293,318.4005 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"484.5293,318.4005 479.2896,313.7277 479.2896,98.2191 479.2724,98.2191 489.7691,88.7703  489.8807,88.7703 489.8807,323.1678 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"489.7691,88.7703 479.2724,98.2191 292.2904,98.2191 287.2826,93.6407 281.9655,88.7703 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"479.2896,313.7277 484.5293,318.4005 287.2826,318.4005 287.2826,318.2631 292.2904,313.7277  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"292.2904,98.2191 292.2904,313.7277 287.2826,318.2631 287.2826,93.6407 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"281.9655,88.7703 287.2826,93.6407 287.2826,318.2631 281.7336,323.2881 281.6992,323.2881  281.6992,88.7703 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"268.8317,76.7447 281.9655,88.7703 281.6992,88.7703 281.6992,323.2881 281.7336,323.2881  262.8017,340.4419 262.8017,71.23 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"262.8017,71.23 262.8017,340.4419 258.5068,344.333 258.5068,344.5564 258.1031,344.5564  258.1031,67.3904 258.6099,67.3904 \t\t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1697.1138,558.2552 1697.1138,558.4932 1577.6772,558.4932 1577.6772,558.3494  1580.4445,555.8423 1580.4445,555.8589 1694.4241,555.8589 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1697.1138,438.3152 1697.1138,438.3484 1694.5569,440.6507 1580.4445,440.6507  1580.4445,440.789 1577.7437,438.3152 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1694.7285,440.6507 1694.7285,555.8589 1694.4241,555.8589 1690.4116,552.2838  1690.4393,552.2505 1690.4393,444.3587 1694.5569,440.6507 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1694.7285,440.6507 1694.5569,440.6507 1697.1138,438.3484 1697.1138,558.2552  1694.4241,555.8589 1694.7285,555.8589 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1694.5569,440.6507 1690.4393,444.3587 1690.4393,444.3421 1584.3296,444.3421  1580.4445,440.789 1580.4445,440.6507 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1694.4241,555.8589 1580.4445,555.8589 1580.4445,555.8423 1592.6421,544.7902  1681.9109,544.7902 1681.9109,544.7072 1690.4116,552.2838 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1690.4393,444.3421 1690.4393,444.3587 1681.8445,452.0901 1592.7915,452.0901  1584.3296,444.3421 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#8C5F3A",points:"1681.9109,544.7072 1681.9109,544.7902 1592.6421,544.7902 1596.2173,541.5527  1596.2173,541.6412 1678.4686,541.6412 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1675.0927,527.5397 1675.0927,521.8228 1675.0927,507.5331 1675.0927,499.0877  1675.0927,487.7368 1675.0927,461.9136 1675.0927,458.1779 1675.0815,458.1779 1681.8445,452.0901 1681.9109,452.0901  1681.9109,544.7072 1678.4686,541.6412 1675.0927,538.6305 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1681.9109,452.0901 1681.8445,452.0901 1690.4393,444.3587 1690.4393,552.2505  1690.4116,552.2838 1681.9109,544.7072 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1681.8445,452.0901 1675.0815,458.1779 1599.4438,458.1779 1596.2173,455.2281  1592.7915,452.0901 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1603.5337,538.6305 1675.0927,538.6305 1678.4686,541.6412 1596.2173,541.6412  1596.2173,541.5527 1599.4438,538.6305 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4F6977",points:"1667.5161,527.5397 1675.0927,527.5397 1675.0927,538.6305 1603.5337,538.6305 1607.38,527.5397  1627.2262,527.5397 1643.3975,527.5397 1652.8169,527.5397 1659.9064,527.5397 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#9DD0D1",points:"1675.0927,521.8228 1675.0927,527.5397 1667.5161,527.5397 1667.5161,521.8228  1675.0815,521.8228 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#496E89",d:"M1675.0927,499.0877v8.4454h-0.0553c-2.3245,0-4.9366,0.5756-7.5322,1.6326 c-2.6731,1.0847-5.3296,2.6731-7.632,4.6599c-2.5734,2.2193-4.7097,4.9311-5.9327,7.9805 c-0.7195,1.7876-1.1235,3.6859-1.1235,5.6672v0.0664h-9.4194v-0.0664c0-16.1603,18.8887-28.3856,31.6399-28.3856 L1675.0927,499.0877L1675.0927,499.0877z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#496E89",points:"1651.5662,468.6931 1643.1927,461.9136 1675.0927,461.9136 1675.0927,487.7368 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#38476D",points:"1675.0927,458.1779 1675.0927,461.9136 1643.1927,461.9136 1651.5662,468.6931  1638.0956,468.6931 1627.2262,527.5397 1607.38,527.5397 1603.5337,538.6305 1599.4438,538.6305 1599.4438,458.1779  1675.0815,458.1779 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7ABCC1",d:"M1667.5161,521.8228V509.199l-0.011-0.0332c2.5956-1.0571,5.2078-1.6326,7.5322-1.6326h0.0553v14.2896 h-0.0111H1667.5161z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#62859B",d:"M1650.1771,481.9091c0,0-2.9775,5.4624,2.424,9.1316c5.396,3.6638,11.3455,0.2767,11.3455,0.2767 L1650.1771,481.9091z M1675.0927,487.7368v11.3509h-0.0553c-12.7512,0-31.6399,12.2253-31.6399,28.3856v0.0664h-16.1713 l10.8694-58.8466h13.4706L1675.0927,487.7368z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"1659.9064",y:"521.8228",fill:"#7ABCC1",width:"7.6097",height:"5.717"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#9DD0D1",d:"M1667.5161,521.8228h-7.6097v-7.9584l-0.0332-0.0388c2.3024-1.9868,4.9589-3.5752,7.632-4.6599 l0.011,0.0332V521.8228z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7ABCC1",d:"M1653.9791,521.8228l-0.0387-0.0166c1.223-3.0494,3.3594-5.7612,5.9327-7.9805l0.0332,0.0388v7.9584 h-5.9216L1653.9791,521.8228L1653.9791,521.8228z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#9DD0D1",d:"M1653.9404,521.8062l0.0387,0.0166h0.0056h5.9216v5.717h-7.0895v-0.0664 C1652.8169,525.492,1653.2209,523.5938,1653.9404,521.8062z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#153460",d:"M1652.6011,491.0408c-5.4015-3.6693-2.424-9.1316-2.424-9.1316l13.7694,9.4084 C1663.9465,491.3175,1657.9971,494.7045,1652.6011,491.0408z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1599.4438,458.1779 1599.4438,538.6305 1596.2173,541.5527 1596.2173,455.2281 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1592.7915,452.0901 1596.2173,455.2281 1596.2173,541.5527 1592.6421,544.7902 1592.62,544.7902  1592.62,452.0901 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1584.3296,444.3421 1592.7915,452.0901 1592.62,452.0901 1592.62,544.7902 1592.6421,544.7902  1580.4445,555.8423 1580.4445,440.789 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1577.6772,558.3494 1577.6772,558.4932 1577.4172,558.4932 1577.4172,438.3152  1577.7437,438.3152 1580.4445,440.789 1580.4445,555.8423 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#331F12",points:"74.6388,155.1781 74.6388,155.4161 194.0752,155.4161 194.0752,155.2722 191.308,152.7652  191.308,152.7818 77.3284,152.7818 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#331F12",points:"74.6388,35.2713 74.6388,155.1781 77.3284,152.7818 77.0241,152.7818 77.0241,37.5736  77.1956,37.5736 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"74.6388,35.2381 74.6388,35.2713 77.1956,37.5736 191.308,37.5736 191.308,37.7119  194.0088,35.2381 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"77.0241,37.5736 77.0241,152.7818 77.3284,152.7818 81.3408,149.2066 81.3132,149.1734  81.3132,41.2816 77.1956,37.5736 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"77.1956,37.5736 81.3132,41.2816 81.3132,41.265 187.4229,41.265 191.308,37.7119  191.308,37.5736 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"77.3284,152.7818 191.308,152.7818 191.308,152.7652 179.1104,141.7131 89.8416,141.7131  89.8416,141.6301 81.3408,149.2066 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"81.3132,41.2816 81.3132,149.1734 81.3408,149.2066 89.8416,141.6301 89.8416,49.013  89.908,49.013 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"81.3132,41.265 81.3132,41.2816 89.908,49.013 178.961,49.013 187.4229,41.265 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"89.8416,141.6301 89.8416,141.7131 179.1104,141.7131 175.5352,138.4755 175.5352,138.5641  93.2839,138.5641 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"96.6599,58.8365 96.6599,55.1008 96.6709,55.1008 89.908,49.013 89.8416,49.013  89.8416,141.6301 93.2839,138.5641 96.6599,135.5534 96.6599,124.4626 96.6599,118.7456 96.6599,104.456 96.6599,96.0106  96.6599,84.6597 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#331F12",points:"89.908,49.013 96.6709,55.1008 172.3087,55.1008 175.5352,52.151 178.961,49.013 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"168.2188,135.5534 96.6599,135.5534 93.2839,138.5641 175.5352,138.5641 175.5352,138.4755  172.3087,135.5534 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#324A54",points:"144.5263,124.4626 128.355,124.4626 118.9356,124.4626 111.8461,124.4626 104.2364,124.4626  96.6599,124.4626 96.6599,135.5534 168.2188,135.5534 164.3725,124.4626 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7BB2B2",points:"96.6599,118.7456 96.6599,124.4626 104.2364,124.4626 104.2364,118.7456 96.6709,118.7456 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#509496",d:"M96.6599,104.456v14.2896h0.0111h7.5654v-12.6238l0.0111-0.0332 c-2.5956-1.0571-5.2078-1.6326-7.5322-1.6326H96.6599z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#385E75",d:"M96.6599,96.0106v8.4454h0.0553c2.3244,0,4.9366,0.5756,7.5322,1.6326 c2.6731,1.0847,5.3296,2.6731,7.6318,4.6599c2.5735,2.2193,4.7097,4.9311,5.9328,7.9805 c0.7195,1.7876,1.1235,3.6859,1.1235,5.6672v0.0664h9.4194v-0.0664c0-16.1603-18.8887-28.3856-31.6398-28.3856 C96.7151,96.0106,96.6599,96.0106,96.6599,96.0106z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4D7487",d:"M96.6599,84.6597v11.3509h0.0553c12.7511,0,31.6398,12.2253,31.6398,28.3856v0.0664h16.1713 L133.6569,65.616h-13.4706L96.6599,84.6597z M107.806,88.2348l13.7694-9.4084c0,0,2.9719,5.4679-2.424,9.1317 C113.7554,91.6274,107.806,88.2348,107.806,88.2348z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#385E75",points:"120.1863,65.616 128.5598,58.8365 96.6599,58.8365 96.6599,84.6597 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#243556",points:"96.6599,55.1008 96.6599,58.8365 128.5598,58.8365 120.1863,65.616 133.6569,65.616  144.5263,124.4626 164.3725,124.4626 168.2188,135.5534 172.3087,135.5534 172.3087,55.1008 96.6709,55.1008 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"104.2364",y:"118.7456",fill:"#509496",width:"7.6097",height:"5.717"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7BB2B2",d:"M104.2364,106.1218v12.6238h7.6097v-7.9584l0.0332-0.0387c-2.3023-1.9868-4.9588-3.5752-7.6318-4.6599 L104.2364,106.1218z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#07213F",d:"M121.5754,78.8265l-13.7694,9.4084c0,0,5.9494,3.3925,11.3454-0.2767 C124.5474,84.2944,121.5754,78.8265,121.5754,78.8265z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7BB2B2",d:"M111.8461,118.7456v5.717h7.0895v-0.0664c0-1.9813-0.404-3.8796-1.1235-5.6672l-0.0443,0.0166 C117.7678,118.7456,111.8461,118.7456,111.8461,118.7456z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#509496",d:"M111.8461,110.7873v7.9584h5.9217l0.0443-0.0166c-1.2231-3.0494-3.3593-5.7612-5.9328-7.9805 L111.8461,110.7873z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#331F12",points:"172.3087,55.1008 172.3087,135.5534 175.5352,138.4755 175.5352,52.151 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"178.961,49.013 175.5352,52.151 175.5352,138.4755 179.1104,141.7131 179.1325,141.7131  179.1325,49.013 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"187.4229,41.265 178.961,49.013 179.1325,49.013 179.1325,141.7131 179.1104,141.7131  191.308,152.7652 191.308,37.7119 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"191.308,37.7119 191.308,152.7652 194.0752,155.2722 194.0752,155.4161 194.3353,155.4161  194.3353,35.2381 194.0088,35.2381 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"napoleon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_7_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#577F7B",d:"M1245.2622,97.2575l-5.9929,14.7814c-1.212-0.2558-2.4788-0.603-3.8004-1.0354 c-1.7723-0.5847-3.3253-1.2729-4.6592-2.0464l1.9185-4.4643C1235.6942,98.9506,1241.0598,97.4707,1245.2622,97.2575z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#9B4104",d:"M1292.8342,57.804c-3.4775-3.4958,3.4412-7.345,6.1025-8.8372c3.3254-1.8575,6.5168-6.0295,4.1659-9.7507 c0.4081,2.1743-2.2717,7.7227-7.7653,4.3303c-4.3729-2.698-0.2253-12.8081,5.1221-15.9508c0,0-7.7532,0.6456-10.9689,8.4291 c-3.9648,9.6046,0.0548,11.6266-4.8723,20.677c-1.2059,2.2046-3.7273,4.9697-7.0465,3.24 c-2.4363-1.2668-3.6177-4.1414-2.0586-7.5886c0.2559-0.5664,0.5847-1.145,0.9927-1.7357c0,0-4.1536,1.8209-5.2803,5.7372 c-0.2192,0.7551-0.3289,1.5896-0.2681,2.5032c0.3716,5.7615,10.3171,12.2903,6.3279,21.5964 c-1.6321,3.8126-4.9209,5.1525-7.3876,3.2705c-1.8027-1.3765-1.5287-3.0939-2.832-5.396 c-1.1815,14.7266-5.6093,33.9294-22.0045,34.2827c-0.2803,0.6638-0.5603,1.3459-0.8588,2.0403 c-0.2985,2.4545,0.0243,4.8845,1.2241,7.2172c3.6178-6.3766,9.9579-8.0941,14.9398-8.35 c4.0988-0.2131,7.2841,0.5725,7.2841,0.5725s-2.8503,6.803-7.0526,16.8339c3.6663-0.5785,6.1329-3.6786,6.9308-8.2404 c1.3033-7.4302,10.6095-12.9724,15.6766-11.8031c0,0-2.5032-2.0768-5.6824-1.8698c-1.5164,0.0974-4.6409,0.0487-5.3656-1.8636 c-2.5823-6.7665,13.4781-6.0355,22.4309-20.0922c3.6239-5.6885,1.62-9.0564,1.62-9.0564s-2.8867,7.5094-7.1013,4.0684 c-5.2743-4.3059-0.3594-11.9495,5.5911-15.689c5.9807-3.7516,8.6543-10.6946,8.2402-13.551 C1302.9382,52.8281,1298.3765,63.3767,1292.8342,57.804z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#577F7B",d:"M1239.2693,112.0389l-4.9576,12.2112h-0.0061c-2.3752-3.8552-3.8673-8.3195-4.1962-13.0943 c-0.1097,0.067-0.2194,0.134-0.3351,0.201l1.0354-2.3996c1.3339,0.7735,2.8868,1.4617,4.6592,2.0464 C1236.7905,111.4359,1238.0573,111.7831,1239.2693,112.0389z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1C1A10",d:"M1296.0865,14.9032c-1.8027,6.8578-6.6812,8.9651-10.7983,7.3085 c-4.8296-1.9367-4.1962-7.1014-2.9598-10.3598c5.0854-13.3867,10.8591-10.9688,17.4001-23.8439 c5.3048-10.4328-1.0292-19.1969-1.0292-19.1969c1.5226,8.4839-5.3961,22.0046-12.1869,19.8364 c-8.5509-2.7285-5.116-10.5729-2.4545-12.1138c-6.0538,0.8892-7.5703,8.0332-6.5228,13.2161 c0.8345,4.1536,3.0331,14.9336-3.8004,14.4281c-10.8956-0.8039-3.8856-15.159-3.8856-15.159 c-3.3862,2.1499-8.2952,11.249-6.8456,20.9509c1.4373,9.6594-2.1743,21.7549-11.4865,20.0861 c-7.4486-1.3338-2.1378-11.1698-2.1378-11.1698s-5.3656,0.9257-8.088,9.8969c-6.7299,22.1507,8.5631,38.4365-0.9014,41.8349 c-2.6737,0.9623-5.5544-2.2839-6.8213-3.977c-2.5762-3.4289-6.8334-4.2511-7.0952-4.2937 c5.8041,4.2998,8.3621,19.1116,1.7114,27.1997c-5.7129,6.943-5.4875,14.7387,2.6249,19.4101l-1.0354,2.3996 c-3.0146,1.7845-6.5349,2.8138-10.2927,2.8138c-11.1759,0-20.2384-9.0625-20.2384-20.2445c0-3.8187,1.0598-7.3876,2.8929-10.4389 c-8.9346-5.3534-14.9214-15.1285-14.9214-26.3044c0-8.9163,3.8065-16.9374,9.8785-22.5344 c-2.0585-7.9662-3.1548-16.3162-3.1548-24.9219c0-2.6737,0.1096-5.3169,0.3168-7.9358 c-12.6924-0.8527-23.9901-6.7725-31.9076-15.7437c-2.4728,4.3059-7.1136,7.2049-12.4305,7.2049 c-7.9175,0-14.3368-6.4132-14.3368-14.3307s6.4193-14.3307,14.3368-14.3307c0.5847,0,1.1694,0.0365,1.7358,0.1035 c-0.6395-3.0817-0.9867-6.2731-0.9867-9.5497c0-2.0646,0.1522-4.0988,0.4081-6.0965h201.8965V88.7797v28.5944l-29.0146,18.5026 c-0.469-0.335-0.9258-0.6821-1.3704-1.0475c-0.5055,1.2546-1.2546,2.3813-2.1864,3.3193l-3.7395,2.3874c0,0,0,0-0.0061,0 c-1.0537,0.3776-2.1926,0.5847-3.3802,0.5847c-5.061,0-9.2391-3.7517-9.9333-8.624 c-3.6238,7.0953-10.9932,11.9494-19.5015,11.9494c-6.6689,0-12.6376-2.9843-16.6511-7.6861 c-2.6371,0.7979-5.4265,1.2303-8.3195,1.2303c-0.4081,0-0.8101-0.0061-1.212-0.0305c1.0354-2.4788,2.0221-4.8297,2.9417-7.0344 c3.6665-0.5786,6.1331-3.6786,6.9309-8.2403c1.3033-7.4303,10.6095-12.9725,15.6766-11.8032c0,0-2.5032-2.0768-5.6823-1.8697 c-1.5166,0.0974-4.641,0.0487-5.3657-1.8637c-2.5823-6.7664,13.478-6.0356,22.4309-20.0922 c3.6238-5.6884,1.6201-9.0564,1.6201-9.0564s-2.8868,7.5094-7.1014,4.0684c-5.2743-4.3059-0.3594-11.9493,5.5909-15.6888 c5.9808-3.7517,8.6545-10.6947,8.2404-13.5511c0,0-4.5618,10.5486-10.104,4.9758c-3.4775-3.4959,3.441-7.345,6.1025-8.8372 c3.3254-1.8576,6.5167-6.0295,4.1659-9.7507c0.4081,2.1743-2.2717,7.7226-7.7653,4.3303 c-4.3729-2.698-0.2253-12.8081,5.1221-15.9507c0,0-7.7532,0.6456-10.9689,8.4291c-3.9648,9.6045,0.0548,11.6266-4.8723,20.6769 c-1.2058,2.2047-3.7273,4.9698-7.0465,3.2401c-2.4362-1.2668-3.6177-4.1415-2.0586-7.5886 c2.6067-1.8271,4.8358-2.5884,4.8358-2.5884c-7.6252-0.8222-9.0016,2.9478-13.2101,2.0525 c-4.2146-0.9014-5.7737-5.5849-3.234-10.7556c6.2061-12.6193,22.0898-8.0393,28.5031-12.8568 C1298.6871,23.4846,1296.0865,14.9032,1296.0865,14.9032z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1C1A10",d:"M1267.4922,67.1283c0.0121-4.6165,1.6383-8.1428,3.7334-10.7739 c-0.2192,0.7552-0.329,1.5896-0.2681,2.5032c0.3716,5.7615,10.3171,12.2904,6.328,21.5965 c-1.6322,3.8126-4.921,5.1525-7.3877,3.2705c-1.8027-1.3764-1.5287-3.0939-2.832-5.3961 C1267.413,74.0166,1267.48,70.0883,1267.4922,67.1283z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#BA560C",d:"M1299.7285-11.9919c5.3048-10.4329-1.0293-19.1969-1.0293-19.1969 c1.5227,8.484-5.396,22.0045-12.1868,19.8364c-8.5509-2.7285-5.116-10.5729-2.4545-12.1139 c-6.0538,0.8893-7.5703,8.0333-6.5228,13.2163c0.8345,4.1536,3.0331,14.9336-3.8003,14.428 c-10.8958-0.8038-3.8857-15.1589-3.8857-15.1589c-3.3862,2.1499-8.2952,11.249-6.8456,20.9509 c1.4374,9.6594-2.1743,21.7549-11.4865,20.0862c-7.4486-1.3337-2.1377-11.1698-2.1377-11.1698s-5.3657,0.9257-8.0881,9.8969 c-6.7299,22.1508,8.5631,38.4365-0.9014,41.835c-2.6736,0.9622-5.5544-2.2839-6.8213-3.9771 c-2.5762-3.429-6.8334-4.2511-7.0952-4.2937c5.8042,4.2998,8.3621,19.1116,1.7114,27.1997 c-5.7129,6.943-5.4875,14.7388,2.6249,19.41l1.9186-4.4642c2.9659-5.5422,8.3315-7.0222,12.5339-7.2354 c3.3923-0.1768,6.0295,0.475,6.0295,0.475s-1.072,2.558-2.8381,6.7726c-0.9502,2.2656-2.1012,5.0184-3.3923,8.1062 c16.3953-0.3533,20.823-19.5562,22.0045-34.2827c0.3472-4.312,0.4142-8.2404,0.4264-11.2002 c0.0122-4.6166,1.6382-8.1429,3.7334-10.7739c1.1267-3.9163,5.2803-5.7372,5.2803-5.7372 c-0.408,0.5907-0.7368,1.1693-0.9927,1.7357c2.6067-1.8271,4.8357-2.5884,4.8357-2.5884 c-7.6251-0.8223-9.0015,2.9478-13.21,2.0525c-4.2146-0.9014-5.7737-5.585-3.234-10.7556 c6.2062-12.6194,22.0898-8.0393,28.5031-12.8569c6.2792-4.72,3.6786-13.3013,3.6786-13.3013 c-1.8029,6.8577-6.6813,8.965-10.7982,7.3083c-4.8298-1.9368-4.1963-7.1013-2.96-10.3597 C1287.4138-1.5347,1293.1875,0.8832,1299.7285-11.9919z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1C1E28",d:"M1181.0085,454.4467c7.479,2.3083,14.3673,3.77,20.6708,4.5861c-1.62,0.4385-3.2827,0.7979-5.0001,1.078 c-9.2513,29.1669-22.3639,55.8123-30.1901,70.5389c-2.1499-0.9988-4.1902-2.0829-6.0479-3.2401 c-9.5497-5.9686-2.4666-32.206,3.5934-49.6854c13.3197-2.4788,25.0315-6.9552,25.0315-6.9552 c-6.3462-4.3668-9.5924-10.5364-11.0906-14.3063L1181.0085,454.4467z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#444132",d:"M1242.0343,413.9334c0.4872-1.6809,0.9136-3.368,1.285-5.0489 c6.328,8.8798,13.5999,23.2348,10.3049,39.35c0,0-7.15,6.4558-21.7305,9.7446c4.4948-12.8568,8.4961-27.8453,10.7678-44.4599 L1242.0343,413.9334z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1389.0746,65.758 1389.0746,720.6394 1372.6914,703.0565 1372.6914,76.203 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1378.1484,-77.9752 1382.0341,-82.141 1389.0746,-89.6992 1389.0746,65.758 1372.6914,76.203  1372.6914,-71.8848 1372.5757,-71.9945 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B361D",points:"1389.0746,-89.6992 1382.0341,-82.141 1381.9305,-82.2385 692.2426,-82.2385 692.2426,-82.1898  685.2447,-89.6992 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#382416",points:"1372.6914,703.0565 1389.0746,720.6394 685.2447,720.6394 692.2974,713.0691 695.8237,709.2808  700.9579,703.7812 701.2259,704.0309 1372.6914,704.0309 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#895C2B",points:"1382.0341,-82.141 1378.1484,-77.9752 696.1709,-77.9752 692.2426,-82.1898 692.2426,-82.2385  1381.9305,-82.2385 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B361D",points:"1378.1484,-77.9752 1372.5757,-71.9945 1365.9493,-64.8809 708.3699,-64.8809 696.1709,-77.9752  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B361D",points:"707.9254,696.2961 711.9755,691.9537 712.1886,692.1547 1362.5327,692.1547 1372.6914,703.0565  1372.6914,704.0309 701.2259,704.0309 700.9579,703.7812 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B361D",points:"1372.6914,76.203 1372.6914,703.0565 1362.5327,692.1547 1362.9468,692.1547 1362.9468,82.4213  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1365.9493,-64.8809 1372.5757,-71.9945 1372.6914,-71.8848 1372.6914,76.203 1362.9468,82.4213  1362.9468,-61.6591 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#382416",points:"1362.9468,-61.6591 1358.5312,-56.9207 1352.9708,-50.9522 1151.0743,-50.9522  721.3486,-50.9522 708.3699,-64.8809 1365.9493,-64.8809 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#382416",points:"1362.9468,82.4213 1362.9468,692.1547 1362.5327,692.1547 1358.4216,687.7391  1358.5312,687.7391 1358.5312,85.2351 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"1362.9468,-61.6591 1362.9468,82.4213 1358.5312,85.2351 1358.5312,-56.9207 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1358.4216,687.7391 1362.5327,692.1547 712.1886,692.1547 711.9755,691.9537 715.8976,687.7391  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#382416",points:"1358.5312,85.2351 1358.5312,687.7391 1358.4216,687.7391 1352.9708,681.8923  1352.9708,607.1937 1352.9708,140.1217 1352.9708,117.3741 1352.9708,88.7797 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"1358.5312,-56.9207 1358.5312,85.2351 1352.9708,88.7797 1352.9708,-50.9522 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1358.4216,687.7391 715.8976,687.7391 721.3486,681.8923 1004.8318,681.8923 1014.071,681.8923  1237.5884,681.8923 1352.9708,681.8923 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#444132",d:"M1352.9708,140.1217v467.0721c-55.4652-2.7285-107.1239-7.2963-150.1952-13.0457 c20.3723-21.5599,41.7131-41.7679,41.7131-41.7679l4.8723-17.6621c0,0-3.6543-6.0904-9.7446-7.3085 c-3.2766-0.6578-12.2052-6.6081-19.7512-11.9615c7.5643-2.7346,15.4392-6.6994,21.5782-12.4c0,0-1.827,14.6169,9.1356,21.9254 c0,0-8.5265-13.3989,3.6543-26.7977s23.1434-29.2339,26.1886-37.7604c0,0,0,8.5266,12.1808,18.8802 c0,0-6.6993-11.5717-4.2632-26.1887c2.3691-14.2332,9.9395-42.3221-43.0713-66.8359v-0.0061 c-0.335-5.4022-1.3217-10.2562-2.9113-14.1602c-13.5693-33.3083-56.1533-44.9593-91.1975-49.0155 c12.2052-31.7797,25.4153-66.3243,35.7506-93.4083l0.0305,0.0183l3.2157-8.4839c9.1721,0.5055,20.1166,1.078,20.1166,1.078 s11.8579,1.3825,16.7302-10.7191c1.1511-2.8625,4.0441-9.8421,7.7775-18.8193l81.8732-52.219c0.0061,0,0.0061,0,0.0061,0 c1.425-0.5116,2.698-1.3338,3.7395-2.3874l3.5568-2.2717c5.2195,3.7821,11.6326,6.0173,18.5696,6.0173 C1346.186,141.894,1349.7002,141.2667,1352.9708,140.1217z M1343.0129,177.3157c0-8.3438-6.7664-15.1042-15.1041-15.1042 c-8.3439,0-15.1102,6.7603-15.1102,15.1042c0,8.3438,6.7664,15.1042,15.1102,15.1042 C1336.2466,192.4198,1343.0129,185.6595,1343.0129,177.3157z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2A1D",d:"M1352.9708,117.3741v22.7476c-3.2706,1.145-6.7848,1.7723-10.4451,1.7723 c-6.937,0-13.3501-2.2352-18.5696-6.0173L1352.9708,117.3741z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2A1D",d:"M1327.9088,162.2115c8.3378,0,15.1041,6.7603,15.1041,15.1042c0,8.3438-6.7664,15.1042-15.1041,15.1042 c-8.3439,0-15.1102-6.7603-15.1102-15.1042S1319.5649,162.2115,1327.9088,162.2115z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#444132",d:"M1323.9562,135.8767l-3.5568,2.2717c0.9318-0.9379,1.6809-2.0646,2.1864-3.3193 C1323.0304,135.1945,1323.4872,135.5417,1323.9562,135.8767z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2A1D",d:"M1316.6599,140.5358l3.7395-2.3874C1319.3579,139.202,1318.085,140.0242,1316.6599,140.5358z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#333024",d:"M1316.6538,140.5358l-81.8732,52.219c6.608-15.8898,15.8716-38.0467,22.8755-54.7952 c0.402,0.0244,0.804,0.0305,1.212,0.0305c2.8929,0,5.6824-0.4324,8.3195-1.2303c4.0135,4.7018,9.9822,7.6861,16.6511,7.6861 c8.5083,0,15.8777-4.854,19.5015-11.9494c0.6942,4.8723,4.8723,8.624,9.9333,8.624 C1314.4612,141.1205,1315.6001,140.9134,1316.6538,140.5358z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1C1E28",d:"M1245.2683,386.2709c53.0107,24.5138,45.4404,52.6027,43.0713,66.8359 c-2.4362,14.6169,4.2632,26.1887,4.2632,26.1887c-12.1808-10.3536-12.1808-18.8802-12.1808-18.8802 c-3.0452,8.5266-14.0078,24.3615-26.1886,37.7604s-3.6543,26.7977-3.6543,26.7977c-10.9626-7.3085-9.1356-21.9254-9.1356-21.9254 c-6.139,5.7006-14.0139,9.6655-21.5782,12.4c-6.4679-4.5921-11.9188-8.7458-11.9188-8.7458s13.3501-18.4539,23.9474-48.7231 c14.5804-3.2888,21.7305-9.7446,21.7305-9.7446c3.2949-16.1152-3.9769-30.4702-10.3049-39.35 C1245.0856,400.9853,1245.7068,393.1713,1245.2683,386.2709z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#577F7B",d:"M1260.3663,113.5188l-6.5106,16.0421c-0.4811-0.2375-0.9684-0.5055-1.4617-0.8039 c-3.4836-2.1073-5.7128-4.4399-6.9674-6.8882C1249.0443,115.4921,1255.3844,113.7746,1260.3663,113.5188z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#577F7B",d:"M1253.8557,129.5609l-2.9659,7.3085c-3.6117-1.0354-6.9309-2.7589-9.8116-5.0246l4.1232-9.5741 c0.0731-0.134,0.1462-0.268,0.2253-0.402c1.2546,2.4483,3.4838,4.781,6.9674,6.8882 C1252.8873,129.0554,1253.3746,129.3234,1253.8557,129.5609z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#444132",points:"1251.3892,637.3411 1240.0245,661.2947 1238.3983,672.6654 1237.5884,681.8923  1014.071,681.8923 1080.2491,677.8422 1222.3623,662.4153 1208.5554,653.8887 1236.9792,640.4899 1251.1638,637.2437 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#577F7B",d:"M1250.8898,136.8694l-24.9767,61.5373l-23.1497,14.7692l-9.4279-0.335 c1.3885-3.642,2.6858-7.0466,3.8734-10.1709h0.0061l13.2284,0.3715l30.6346-71.1967 C1243.9589,134.1105,1247.2781,135.834,1250.8898,136.8694z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#444132",points:"1247.4182,616.2075 1248.9043,618.1564 1245.7068,622.4197 1246.3158,630.0327  1246.6813,634.2655 1233.3251,625.4649 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#444132",points:"1247.2781,616.0248 1247.3634,616.1405 1246.7726,616.171 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2A1D",d:"M1245.4266,121.8688c-0.0791,0.134-0.1522,0.268-0.2253,0.402l-4.1232,9.5741 c-1.0415-0.8222-2.0281-1.7114-2.9478-2.6615c2.1621-5.1768,4.2389-10.1405,6.0721-14.5317 C1243.9041,117.1061,1244.2268,119.5361,1245.4266,121.8688z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1C1E28",d:"M1245.2683,386.2709c0.4385,6.9004-0.1827,14.7144-1.949,22.6136 c-4.1902-5.8894-7.9662-9.3731-7.9662-9.3731s-3.0452-9.7446,5.4813-15.226c1.5226,0.6577,3.0026,1.3155,4.4338,1.9794V386.2709z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#333024",d:"M1241.0781,131.8448l-30.6346,71.1967l-13.2284-0.3715c2.4728-6.4924,4.4886-11.7788,5.9138-15.5244 c0.469,0.0244,0.7247,0.0365,0.7247,0.0365s9.8055,1.145,13.8313-8.8615c2.1986-5.4509,11.9919-28.9233,20.4454-49.1373 C1239.05,130.1334,1240.0366,131.0226,1241.0781,131.8448z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#596F72",d:"M1225.9131,198.4067l8.8676-5.6519c-3.7334,8.9772-6.6263,15.9568-7.7775,18.8193 c-4.8723,12.1016-16.7302,10.7191-16.7302,10.7191s-10.9445-0.5725-20.1166-1.078l12.6071-8.0393l6.9918,0.2497l1.8453,3.502 l1.2852-4.2389l2.2108,4.4216l0.7369-5.3413l3.3192,1.2912l-0.1888-4.9758l2.9478,0.1888L1225.9131,198.4067z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#577F7B",d:"M1234.3055,124.2501l-20.8291,51.3359l-2.4362-0.1523l0.1523,4.111l-2.7407-1.0658l-0.609,4.4155 l-1.8271-3.6542l-0.4994,1.6322l-9.897-7.3267l0.9563-2.4849l7.4181,0.2071l25.7805-59.9112 c0.1157-0.067,0.2253-0.134,0.3351-0.201C1230.4382,115.9306,1231.9303,120.3949,1234.3055,124.2501z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#333024",d:"M880.2895,235.686c7.3572,9.635,15.1163,16.2918,22.437,20.89 c-3.7273,2.3509-14.5195,9.6046-20.0069,18.0824c-5.0855,7.8627-13.6912,19.9399-16.7303,42.9007l-10.0674-6.9674 l-18.8802,7.9175c0,0-2.0159,9.2086-6.0478,18.9289c-16.9678-8.1002-14.1723-11.0114-19.5319-11.0114 c-5.4814,0-11.5718,4.2632-11.5718,4.2632h-10.3536c0,0-5.4813,9.7446-20.0983,24.9706 c-11.1089,11.5717-21.8645,20.3297-26.3897,23.8683c-6.9979-4.1232-14.2698-7.0648-21.7-8.2829V-50.9522h429.7258 c-0.2559,1.9977-0.4081,4.0318-0.4081,6.0965c0,3.2766,0.3472,6.468,0.9867,9.5497c-0.5664-0.067-1.1511-0.1035-1.7358-0.1035 c-7.9175,0-14.3368,6.4132-14.3368,14.3307s6.4193,14.3307,14.3368,14.3307c5.3169,0,9.9578-2.899,12.4305-7.2049 c7.9175,8.9711,19.2152,14.891,31.9076,15.7437c-0.2072,2.6189-0.3168,5.2621-0.3168,7.9358 c0,8.6057,1.0963,16.9556,3.1548,24.9219c-6.072,5.5971-9.8785,13.6181-9.8785,22.5344c0,11.1759,5.9868,20.9509,14.9214,26.3044 c-1.8331,3.0513-2.8929,6.6203-2.8929,10.4389c0,11.182,9.0625,20.2445,20.2384,20.2445c3.7578,0,7.2781-1.0293,10.2927-2.8138 l-25.7805,59.9112l-7.4181-0.2071l17.4672-45.6109l-26.1886-21.9254l-13.0518,2.2778l13.6608-6.5411l-0.609-1.2181 l-57.2498,10.3537l5.1647,4.2267l-10.646,1.8637l-31.469,36.6276l-14.818,1.1328l-15.2504,18.1128h-0.0609l-4.5861,5.4387 c0.2498-9.5497-2.0342-18.6853-2.0342-18.6853c4.8723-10.9627-4.8723-28.0158-4.8723-28.0158s-2.4362-17.0531-12.1808-29.8429 c0,0-2.089-2.3509-5.9259,2.8686c-0.5542-0.9927-1.0171-1.7479-1.3826-2.2595c-0.0852-0.1218-0.1887-0.2497-0.3167-0.3837 v-0.0061l0.3107-4.9637c3.3192-3.5994,7.6373-8.6605,9.3304-12.333c2.9172-6.3157,6.3218-12.1503,8.7518-14.0932 s0.4812-2.9173-2.4301-1.9428c-2.9172,0.9684-1.9489-0.4872-11.6692,1.4556c-4.8114,0.9623-8.8005,4.1902-11.8214,8.2708 c-1.9429-7.1379-4.8906-10.7069-14.081-12.5462C998.437,60.8857,983.82,48.7049,983.82,48.7049l10.9627,20.0983 c0,0-26.7977,3.6542-34.1062-5.4813c0,0,1.2181,9.1356,7.3085,12.7898c0,0-18.5026,2.3143-30.1535-7.1501l-0.9075-0.7674 c0.2984,0.268,0.5969,0.5238,0.9075,0.7674l16.3771,13.9287c-12.6802,1.3643-27.9792,2.966-30.0743,2.966 c-3.6542,0-20.7073-4.8723-20.7073-4.8723l-6.6995,9.1356l-0.609,12.7898l1.2181,5.4814l2.1194,0.6639l-1.5104,5.4265 l13.2101,5.0794l-11.992,10.7556l5.4814,11.5717l16.444-6.6994c0,0,17.6621,4.2633,24.3616,9.7446 c6.6994,5.4814,12.7898,15.226,24.9706,11.5717l-10.3536,20.7073l-13.947,12.9725c-7.8688-4.9089-11.6326-9.9273-11.6326-9.9273 c1.4434,5.6641,3.7213,10.5425,6.4741,14.7266l-7.0831,6.5898l-24.5504,44.5938 C890.9903,244.3161,880.6061,235.9479,880.2895,235.686z M1176.252,16.8339c0-5.7128-4.6348-10.3476-10.3475-10.3476 c-5.7189,0-10.3475,4.6348-10.3475,10.3476s4.6287,10.3476,10.3475,10.3476C1171.6172,27.1815,1176.252,22.5467,1176.252,16.8339 z M1134.0334-30.5189c0-3.167-2.5702-5.7371-5.7372-5.7371c-3.1731,0-5.7372,2.5701-5.7372,5.7371s2.5641,5.7371,5.7372,5.7371 C1131.4633-24.7817,1134.0334-27.3519,1134.0334-30.5189z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#6D9390",points:"1202.7634,213.1759 1225.9131,198.4067 1221.9116,208.2731 1218.9639,208.0843  1219.1527,213.0602 1215.8335,211.769 1215.0966,217.1103 1212.8857,212.6887 1211.6006,216.9276 1209.7552,213.4256 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1C1E28",d:"M1231.8938,457.9792c-10.5973,30.2692-23.9474,48.7231-23.9474,48.7231s5.4509,4.1537,11.9188,8.7458 c-13.4536,4.8723-25.9268,5.8712-25.9268,5.8712c-6.4558,1.5165-14.0322,6.1757-21.4077,11.8641 c-2.0646-0.7795-4.0989-1.6201-6.0416-2.5336c7.8262-14.7266,20.9387-41.372,30.1901-70.5389 c1.7174-0.2802,3.3801-0.6395,5.0001-1.078c0.0061,0,0.0061,0,0.0061,0 C1213.9576,460.6163,1224.0128,459.7636,1231.8938,457.9792z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#428D99",points:"1214.0428,125.4499 1196.5757,171.0609 1192.0931,170.933 1192.087,170.933 1161.9944,148.6543  1187.8542,103.5245 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D9390",d:"M1205.5164,180.8725l-0.5664,1.8698l-0.0853-0.1584 C1205.291,181.4632,1205.5164,180.8725,1205.5164,180.8725z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#577F7B",d:"M1195.6194,173.5457l9.897,7.3267c0,0-0.2253,0.5908-0.6517,1.7114l-1.4373-2.7346l-10.0796-0.3593 L1195.6194,173.5457z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#444132",d:"M1201.2469,540.8085c0,0,4.8723-1.2181,1.8271,11.5717c-1.9246,8.0881-16.2858,25.9329-26.5785,37.9492 c-8.5326-1.3521-16.6146-2.7528-24.191-4.1963c3.2157-1.3398,5.0916-2.0829,5.0916-2.0829s3.0452-7.3085,7.3085-9.1356 c4.2633-1.8271,13.3989-0.6091,7.9175-9.7446c-4.6226-7.7043-10.5424-18.4356-12.2904-21.6148v-0.0061 c3.8309-3.5263,7.9845-7.1136,12.1991-10.3658C1186.1854,538.354,1201.2469,540.8085,1201.2469,540.8085z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#577F7B",d:"M1188.6825,202.4324l8.5265,0.2375c-1.1876,3.1244-2.4849,6.5289-3.8734,10.1709l-0.0061-0.0061 l1.9368-5.1098L1188.6825,202.4324z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#577F7B",points:"1196.5757,171.0609 1195.6194,173.5457 1192.0931,170.933 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#577F7B",d:"M1195.6194,173.5457l-2.2716,5.9442l-7.5826-0.2741l-9.9152-5.4387 c3.1001-3.7456,8.3683-3.0635,8.3683-3.0635l7.8688,0.2193h0.0061L1195.6194,173.5457z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#577F7B",d:"M1195.2662,207.725l-1.9368,5.1098l-19.4467-0.6943c0.1401-1.4982,0.6212-3.1183,1.614-4.7931 c3.5142-5.9442,11.0236-4.9758,11.0236-4.9758l2.1621,0.0609L1195.2662,207.725z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#455E60",d:"M1244.2025,114.6516c0.2985-0.6943,0.5785-1.3765,0.8588-2.0403 c1.2911-3.0878,2.4421-5.8406,3.3923-8.1062c1.7661-4.2146,2.8381-6.7726,2.8381-6.7726s-2.6372-0.6517-6.0295-0.475 l-5.9929,14.7812l-4.9575,12.2113h-0.0061l-20.8292,51.3358l-2.4362-0.1521l0.1523,4.1108l-2.7407-1.0657l-0.6091,4.4155 l-1.827-3.6543l-0.4994,1.6323l-0.5664,1.8696l-0.0853-0.1583l-1.4374-2.7345l-10.0796-0.3594l-7.5825-0.2742l-11.9858-0.4324 c-0.3655,3.9039,2.1133,6.7908,3.3558,6.9126c1.4678,0.1462,21.8766,1.2302,25.9938,1.4495 c0.469,0.0244,0.7247,0.0366,0.7247,0.0366s9.8055,1.145,13.8313-8.8616c2.1986-5.4509,11.9919-28.9232,20.4454-49.1372 C1240.2925,124.0065,1242.3693,119.0428,1244.2025,114.6516z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#455E60",d:"M1260.3665,113.5188l-6.5107,16.0421l-2.9661,7.3085l-24.9766,61.5374l8.8676-5.6519 c6.608-15.8899,15.8716-38.0468,22.8755-54.7953c1.0354-2.4789,2.0221-4.8297,2.9418-7.0344 c4.2023-10.0309,7.0526-16.8339,7.0526-16.8339S1264.4652,113.3057,1260.3665,113.5188z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#455E60",d:"M1193.2198,213.1333l0.1096-0.2985l-19.4467-0.6942c-0.3472,3.7516,1.4861,6.7297,3.0026,7.8687 c0.3898,0.2924,0.7614,0.4629,1.0658,0.4934c0.7856,0.0791,6.0964,0.3776,12.1869,0.7125 c0.6639-1.7418,1.3156-3.441,1.949-5.1038l-1.9307,5.1038l12.6071-8.0393l-9.4279-0.335 C1193.293,212.9384,1193.2563,213.0359,1193.2198,213.1333z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#596F72",d:"M1192.824,214.1747l0.3959-1.0415C1193.0919,213.4804,1192.9579,213.8276,1192.824,214.1747z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#596F72",d:"M1192.087,216.1115l-1.9307,5.1037c-0.0061,0-0.0122,0-0.0183,0 C1190.8019,219.4734,1191.4536,217.7741,1192.087,216.1115z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0A4372",d:"M1190.1564,221.2152l-3.2157,8.4839l-0.0305-0.0183v-0.0061c1.1085-2.9051,2.1865-5.7189,3.2157-8.4413 L1190.1564,221.2152z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0A4372",d:"M1190.1564,221.2152l-0.0305,0.0183c0.0061-0.0061,0.0122-0.0122,0.0122-0.0183 C1190.1442,221.2152,1190.1503,221.2152,1190.1564,221.2152z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0A4372",d:"M1182.2815,226.2398l7.8444-5.0063c-1.0292,2.7224-2.1072,5.5362-3.2157,8.4413L1182.2815,226.2398z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6AB5C6",d:"M1127.066,148.5629v0.0061l-33.4119,2.5458l31.469-36.6276l10.646-1.8637h0.0061l8.2281,6.736 l1.218,0.609l29.5688-14.1602l0.0122-0.0061l13.0518-2.2778l-25.8599,45.1298l-3.374-2.4971L1127.066,148.5629z M1112.6196,149.5557l6.3035-0.469l8.21-0.6151l8.1306-0.609l6.6324-0.4933l5.3108-0.3959l6.8456-0.5116 c4.5679-8.8311-2.765-18.3199-14.3124-17.3576c-14.6169,1.2181-26.1887,9.7446-36.0308,21.1154l6.5654-0.4872L1112.6196,149.5557 z M1171.4102,113.8782l-19.4893,8.5266c0,0,4.8723,4.2633,11.5718,0.609 C1170.192,119.3595,1171.4102,113.8782,1171.4102,113.8782z M1136.6949,123.0138l-7.3085-4.2633c0,0-2.4362,3.0452,0.609,4.8723 C1133.0406,125.4499,1136.6949,123.0138,1136.6949,123.0138z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1186.9102,229.6748v0.0061c-10.3353,27.084-23.5454,61.6286-35.7506,93.4083 c-3.7882-0.4385-7.479-0.7856-11.0419-1.0658l9.8665-24.6295l-1.3156-0.3045l-10.9626,23.5515l-18.8864-7.9784l2.6433-5.725 l-13.5999-6.2914l9.1599-18.0032l0.0731,0.0366l24.3616,10.0491l17.7656-41.5182h-1.0171l-9.7872,20.3541l-7.7714-2.491 l9.1965-22.1447l32.4374-20.6891L1186.9102,229.6748z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#577F7B",d:"M1185.7651,179.2159l-11.9858-0.4324c0.1157-1.2363,0.5177-2.5762,1.3337-3.9588 c0.2253-0.3837,0.4751-0.7308,0.7369-1.0475L1185.7651,179.2159z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1C1E28",d:"M1181.0085,454.4467l-3.033,2.0159c-0.7917-2.022-1.0902-3.3558-1.0902-3.3558 C1178.2802,453.5819,1179.6504,454.0265,1181.0085,454.4467z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#02324C",points:"1187.8542,98.0432 1170.2529,106.6001 1170.2468,106.6001 1144.0034,119.3595  1145.2214,119.9685 1174.7903,105.8083 1174.8025,105.8022 1188.4633,99.2612 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#1C1A10",cx:"1165.9044",cy:"16.8339",r:"10.3476"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#02324C",d:"M1151.9209,122.4047l19.4893-8.5266c0,0-1.2181,5.4814-7.9175,9.1356 C1156.7932,126.668,1151.9209,122.4047,1151.9209,122.4047z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#05385B",d:"M1177.9512,220.5027c-0.3044-0.0305-0.676-0.201-1.0658-0.4934 c-1.5165-1.1389-3.3497-4.1171-3.0026-7.8687c0.1401-1.4983,0.6212-3.1184,1.614-4.7932 c3.5142-5.9442,11.0236-4.9758,11.0236-4.9758l2.1621,0.0608l-43.5707-35.038l-13.4902,21.2007l44.2041,32.8455l6.4558,4.7992 l7.8445-5.0063c0.0061-0.006,0.0121-0.0121,0.0121-0.0182C1184.0476,220.8802,1178.7368,220.5818,1177.9512,220.5027z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#05385B",points:"1135.7753,112.6235 1144.0034,119.3595 1187.8542,98.0432 1130.6045,108.3969  1135.7692,112.6235 \t\t\t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1C1E28",d:"M1166.4891,530.6497c1.9427,0.9135,3.9771,1.754,6.0416,2.5336 c-4.2146,3.2523-8.3682,6.8395-12.1991,10.3658c-0.3228-0.5847-0.4994-0.9136-0.4994-0.9136 S1162.4634,538.2139,1166.4891,530.6497z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1C1E28",d:"M1164.0347,477.7242c-6.0599,17.4794-13.1431,43.7169-3.5934,49.6854 c1.8577,1.1572,3.8979,2.2413,6.0479,3.2401c-4.0258,7.5642-6.6569,11.9858-6.6569,11.9858s0.1766,0.3289,0.4994,0.9136v0.0061 c-10.981,10.1222-19.3795,19.7877-19.3795,19.7877c1.218-12.7898,8.5265-24.9706,8.5265-24.9706 c-9.7263,2.5458-18.2163,8.5266-28.4908,14.2941c-22.3274-19.4709-33.2048-39.5693-38.3695-56.0681 c32.4557-22.1508,51.3604-16.7242,68.0785-17.3028C1155.0757,479.1432,1159.6436,478.5464,1164.0347,477.7242z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#135E7C",d:"M1177.1351,185.696c-1.2426-0.1218-3.7213-3.0087-3.3558-6.9126 c0.1157-1.2363,0.5177-2.5762,1.3337-3.9587c0.2253-0.3837,0.4751-0.7308,0.7371-1.0476 c3.0999-3.7456,8.3682-3.0635,8.3682-3.0635l7.8688,0.2192l-30.0927-22.2786l-3.374-2.4971l-9.842,15.4757l-3.6665,5.7615 l43.5707,35.038l8.5265,0.2375h0.0061c2.4727-6.4923,4.4886-11.7788,5.9138-15.5244 C1199.0117,186.9263,1178.6029,185.8423,1177.1351,185.696z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#135E7C",d:"M1131.6216,188.5951l-64.4851,101.3746l-1.7235,2.7163c1.5775,1.6687,3.1974,3.3435,4.8602,4.9879 l0.676-0.4263l3.0085-4.9271l1.0659,1.145l-0.9989,1.821l15.1713-9.6777l-4.6836-2.424l23.7524-38.7775l1.4253,1.425 l-17.6865,29.9769l7.2598,3.3741l5.5178-3.5203l11.4012-19.3796l1.3217,0.207l-9.2878,16.9861l15.3599-9.7932l16.9679-32.267 l2.0342,1.0171l-14.4099,28.3203l19.1361-12.2052l6.6384-15.1041l1.1206,0.9136l-5.2195,12.5706l32.4375-20.6891l-6.4558-4.7992 L1131.6216,188.5951z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A4372",points:"1148.4189,271.5645 1158.2062,251.2104 1159.2233,251.2104 1141.4576,292.7286  1117.0961,282.6794 1117.0229,282.6429 1118.2593,280.2189 1118.3141,280.2433 1140.1421,288.7698 1147.4019,273.6718 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#043A5E",points:"1155.0635,234.3583 1149.8441,246.9288 1147.3043,248.5489 1153.9429,233.4447 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#02324C",d:"M1113.0885,146.2973c-1.0901,1.145-2.0403,2.3022-2.8137,3.435l-6.5654,0.4872 c9.842-11.3708,21.4138-19.8973,36.0308-21.1154c11.5474-0.9623,18.8802,8.5265,14.3124,17.3576l-6.8456,0.5116 c0.8832-1.2059,1.4435-2.4483,1.7114-3.6603c0.4324-1.9306,0.1096-3.8004-0.871-5.3595v-0.0061 c-0.7856-1.2546-1.9976-2.3083-3.5872-3.0269c-1.6931-0.7674-3.8248-1.1633-6.328-1.0232 c-3.033,0.1705-6.1573,0.9075-9.1843,2.0464c-3.6359,1.3703-7.1439,3.3071-10.2074,5.5118 c-2.1256,1.5226-4.0441,3.1731-5.6459,4.8419h-0.0061V146.2973z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0A4372",d:"M1149.9841,297.3938l-9.8665,24.6295c-0.8405-0.067-1.6748-0.1279-2.4971-0.1827l0.0853-1.1998 l10.9626-23.5515L1149.9841,297.3938z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A4372",points:"1149.8441,246.9288 1140.6476,269.0735 1148.4189,271.5645 1147.4019,273.6718  1147.347,273.6413 1138.0104,269.6826 1147.3043,248.5489 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#634A2F",d:"M1128.3267,613.6191c-3.1487,4.2206-10.043,14.0809-14.1724,24.6355c0,0,9.6655,9.1782,27.6992,8.1733 c2.2107-0.1218,4.5496-0.3958,7.0161-0.8647l0.0852-1.1816l1.2059-16.8826 C1145.2885,626.281,1131.7373,622.1821,1128.3267,613.6191z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3C818C",d:"M1148.0474,137.9535c0.9806,1.5591,1.3033,3.4289,0.871,5.3595l-4.6226,0.3837L1148.0474,137.9535z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#56B2AF",d:"M1144.2958,143.6967l4.6226-0.3837c-0.2679,1.212-0.8282,2.4544-1.7114,3.6603l-5.3108,0.3959 L1144.2958,143.6967z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#56B2AF",d:"M1148.0474,137.9474v0.0061l-3.7516,5.7432l-6.4498,0.5359l6.6082-9.3l0.0061-0.0122 C1146.0498,135.6391,1147.2617,136.6928,1148.0474,137.9474z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1A678E",points:"1147.4019,273.6718 1140.1421,288.7698 1118.3141,280.2433 1118.2593,280.2189  1128.1683,260.754 1147.3043,248.5489 1138.0104,269.6826 1147.347,273.6413 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A4372",points:"1145.1118,167.3944 1131.6216,188.5951 1145.0692,167.364 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#02324C",d:"M1145.0692,167.364l-13.4476,21.2311l-74.4185,2.2778c0.0731-2.2778,0.3411-4.8236,0.9197-7.5704 c0.4811-2.2717,0.7247-4.6591,0.804-7.0344v-0.0061c0.2679-0.5664,0.4202-0.8709,0.4202-0.8709l4.2389-5.0307L1145.0692,167.364z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3C818C",d:"M1144.4602,134.9205l-0.0061,0.0122l-6.6082,9.3h-0.0061l-8.0088,0.6699l8.3011-11.0053 C1140.6354,133.7572,1142.7671,134.1531,1144.4602,134.9205z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3C818C",points:"1144.2958,143.6967 1141.8961,147.3692 1135.2637,147.8625 1137.8398,144.2327  1137.8459,144.2327 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#043A5E",points:"1142.5782,232.4337 1128.1683,260.754 1123.5762,263.6835 1140.5441,231.4166 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1140.1177,322.0234c3.5629,0.2802,7.2537,0.6273,11.0419,1.0658 c-7.2657,18.9167-14.1783,36.859-19.9277,51.6587l-0.0243-0.0061l-69.4305-35.3243l15.6097-24.6356l49.5575,20.5794 l1.0171-3.4533l-15.025-6.4984l2.0464-4.4399h0.0061c4.8053,0.0426,10.5729,0.1766,16.9678,0.5177l7.1685,3.0087 L1140.1177,322.0234z M1101.2123,350.3315l10.2014-15.4513l-1.5226-0.9927l-10.1222,15.6827L1101.2123,350.3315z M1096.949,348.5836l10.2014-15.4574l-1.5226-0.9866l-10.1283,15.6828L1096.949,348.5836z M1092.6858,346.8295l10.2014-15.4513 l-1.5227-0.9927l-10.1283,15.6828L1092.6858,346.8295z M1088.4225,345.0816l10.2014-15.4574l-1.5226-0.9867l-10.1223,15.6828 L1088.4225,345.0816z M1084.1592,343.3275l10.2014-15.4513l-1.5226-0.9927l-10.1222,15.6828L1084.1592,343.3275z M1079.8959,341.5796l10.2014-15.4574l-1.5226-0.9866l-10.1222,15.6827L1079.8959,341.5796z M1075.6327,339.8256l10.2014-15.4513 l-1.5227-0.9927l-10.1283,15.6827L1075.6327,339.8256z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0A4372",d:"M1140.1177,322.0234l-0.9927,2.4727l-7.1685-3.0087c1.8394,0.0974,3.7274,0.2132,5.6641,0.3532 C1138.4429,321.8955,1139.2772,321.9564,1140.1177,322.0234z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#56B2AF",d:"M1138.1322,133.8973l-8.3011,11.0053h-0.0061l-8.2343,0.6882l7.3572-9.6472 C1131.9749,134.8047,1135.0992,134.0678,1138.1322,133.8973z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#56B2AF",points:"1137.8398,144.2327 1135.2637,147.8625 1127.1331,148.4716 1129.825,144.9026  1129.8311,144.9026 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0A4372",d:"M1137.7059,320.6408l-0.0853,1.1998c-1.9366-0.1401-3.8247-0.2558-5.6641-0.3532l-14.3489-6.0234 l-0.067-0.0305l1.2789-2.7711L1137.7059,320.6408z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#02324C",d:"M1129.3865,118.7505l7.3085,4.2633c0,0-3.6543,2.4361-6.6995,0.609 S1129.3865,118.7505,1129.3865,118.7505z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#2D2A1D",cx:"1128.2963",cy:"-30.5189",r:"5.7371"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1117.6077,315.464l14.3489,6.0234c-6.3949-0.3411-12.1625-0.475-16.9678-0.5177l2.5519-5.5362 L1117.6077,315.464z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0A4372",d:"M1069.7981,319.368l8.7336-14.0505c0.8586,0.7369,1.7174,1.4556,2.5884,2.1621l-2.491,3.9222 l20.5854,8.0758l10.4755,4.1049l1.2974-2.6371h0.006c1.2426,0.0061,2.5702,0.0122,3.9893,0.0244l-2.0464,4.4399l15.025,6.4984 l-1.0171,3.4533l-49.5575-20.5794l-15.6097,24.6356l69.4305,35.3243l0.0243,0.0061c-0.4446,1.1511-0.8892,2.29-1.3217,3.4045 l-69.3512-36.0916l-21.4808,33.1256l-3.0574-1.4982l31.9928-51.4516L1069.7981,319.368z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1060.559,342.0608l69.3512,36.0916c-8.1306,20.9266-13.6241,34.7639-13.9226,34.7639l-76.9094-37.73 L1060.559,342.0608z M1104.8177,388.1407l1.8271-2.8381l-45.6779-23.1435l-1.8271,2.8381L1104.8177,388.1407z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3C818C",points:"1129.825,144.9026 1127.1331,148.4716 1118.9231,149.0867 1121.5907,145.5908 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3C818C",d:"M1128.9479,135.9437l-7.3572,9.6472l-6.3766,0.5299l3.5264-4.6652 C1121.804,139.2507,1125.312,137.314,1128.9479,135.9437z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0A4372",d:"M1118.8196,312.6624l-1.2789,2.7711l-2.5519,5.5362h-0.0061c-1.4191-0.0122-2.7467-0.0183-3.9893-0.0244 l6.4071-12.9908l-13.8008-6.2975l19.9764-37.9736l4.5922-2.9295l-9.9091,19.4649l-1.2363,2.424l-9.1599,18.0032l13.5999,6.2914 L1118.8196,312.6624z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1123.5762,263.6835l-19.9764,37.9736l13.8008,6.2975l-6.4071,12.9908h-0.006 c-0.3716,0-0.7369,0-1.0963,0c-3.3558,0-6.8517-0.7796-10.4084-2.1499c-6.0721-2.3448-12.3209-6.4193-18.3625-11.3159 l14.1541-22.2665l-3.1427-1.48l4.4948-2.8686l6.0599,2.7285l5.53-10.1161L1123.5762,263.6835z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#444132",d:"M1120.9878,552.6664c3.1731,2.7651,6.5715,5.5118,10.2197,8.2403c0,0-5.9077,7.8323-14.6597,17.041 c-10.4937-2.9478-18.9167-6.0051-24.928-9.1234c-2.1011-1.0902-4.5068-2.2474-7.1683-3.4655 C1099.9333,563.3916,1111.2554,558.1234,1120.9878,552.6664z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#56B2AF",points:"1121.5907,145.5908 1118.9231,149.0867 1112.6196,149.5557 1115.2141,146.1207 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#56B2AF",d:"M1118.7405,141.4555l-3.5264,4.6652l-2.1195,0.1766 C1114.6964,144.6286,1116.6149,142.9781,1118.7405,141.4555z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#043A5E",points:"1117.5042,256.4908 1108.2162,273.4769 1104.7812,275.6633 1116.1825,256.2837 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#042430",d:"M1039.0233,375.2656c28.0828,13.9165,76.1055,37.6508,76.9642,37.6508h-29.2339l-96.8372-47.505h29.2339 l0.4263,0.2132c0.1096,0.0548,0.2436,0.1218,0.4019,0.1949C1022.3356,366.9948,1029.5405,370.5699,1039.0233,375.2656z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#042430",d:"M1039.0781,375.1864l76.9094,37.73c-0.8588,0-48.8815-23.7343-76.9642-37.6508L1039.0781,375.1864z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A372A",d:"M1202.7756,594.1481c-6.7299,7.132-13.3623,14.4099-19.0751,21.152l34.5995,2.4482l28.4727-1.5774 l0.5054-0.1461l0.0853,0.1157l0.1705-0.0122l-0.1157,0.0792l1.4861,1.949l-3.1975,4.2632l0.6091,7.613l0.3654,4.2328 l4.507,2.972l-0.0244,0.0061l0.2253,0.0974l-11.3647,23.9536l-1.6261,11.3707l-0.8099,9.2269h115.3823v-74.6986 C1297.5056,604.4652,1245.8469,599.8975,1202.7756,594.1481z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A372A",d:"M1111.7305,605.0438l19.7876,3.4655c6.8578-0.9197,21.4504-3.0635,34.4045-6.1879 c0,0,4.6045-5.0123,10.573-11.9921c-8.5327-1.3521-16.6145-2.7527-24.191-4.1963 C1144.3201,589.4524,1128.077,596.4746,1111.7305,605.0438z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A372A",d:"M1116.5479,577.9478c-10.4937-2.9478-18.9167-6.0051-24.928-9.1235 c-2.1011-1.0901-4.5068-2.2473-7.1683-3.4653c-11.1698,1.4373-24.4955,1.145-40.9457-2.016 c-26.4689-5.0916-40.495-17.9423-47.8522-31.1888c-15.8715-5.384-27.0596-9.0078-27.0596-9.0078l-52.3774-45.0688 l-101.7095-11.5718c0,0-0.7734-1.5652-2.223-4.2876l-17.2541,11.0054c0.2071,0.5116,4.6713,11.45-3.0574,19.7755 c0,0,9.1356-5.4813,24.3616-3.6542c15.226,1.827,43.8508,11.8762,43.8508,11.8762l27.4067,11.2672l21.9254,20.7074 c0,0-1.0049,0.676-2.6798,1.8331l2.4788-1.3278l-3.8613,12.5889l-0.609,8.5266l4.6713-3.4534L905.053,565.98 c0,0-3.8613,12.5889-3.0452,12.9969c0.81,0.402,0.81,9.3365,0.81,9.3365l-0.3106,1.7053l25.0803-7.1866l77.1409,9.3365 l47.5051,2.4362l36.6763,6.4315C1098.9285,595.22,1108.8435,586.0479,1116.5479,577.9478z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3C818C",d:"M1115.2141,146.1207l-2.5945,3.435l-2.3448,0.1766c0.7734-1.1328,1.7236-2.29,2.8137-3.435h0.0061 L1115.2141,146.1207z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A4372",points:"1111.4137,334.8802 1101.2123,350.3315 1099.7689,349.5702 1109.8911,333.8875 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1110.9874,320.9454l-1.2974,2.6371l-10.4755-4.1049l0.2681-0.6821 c3.5568,1.3704,7.0526,2.1499,10.4084,2.1499C1110.2505,320.9454,1110.6158,320.9454,1110.9874,320.9454z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#043A5E",points:"1092.0037,275.8095 1090.6211,278.1604 1088.3738,281.9669 1092.1315,283.7331  1089.1959,285.6089 1084.5125,283.1849 1108.265,244.4074 1109.6901,245.8326 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A4372",points:"1108.2162,273.4769 1102.6862,283.593 1096.6262,280.8645 1099.2634,279.1836  1101.9736,280.4443 1104.7812,275.6633 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A4372",points:"1107.1504,333.1261 1096.949,348.5836 1095.4995,347.8223 1105.6278,332.1395 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A4372",points:"1106.6449,385.3025 1104.8177,388.1407 1059.1399,364.9972 1060.967,362.159 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1A678E",points:"1099.2634,279.1836 1104.7812,275.6633 1101.9736,280.4443 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A4372",points:"1102.8872,331.3782 1092.6858,346.8295 1091.2362,346.0682 1101.3645,330.3855 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1099.4827,318.7954l-0.2681,0.6821l-20.5854-8.0758l2.491-3.9222 C1087.1617,312.3762,1093.4105,316.4507,1099.4827,318.7954z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#043A5E",points:"1099.2634,279.1836 1096.6262,280.8645 1090.6211,278.1604 1092.0037,275.8095 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A4372",points:"1098.6239,329.6242 1088.4225,345.0816 1086.979,344.3203 1097.1013,328.6375 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1A678E",points:"1096.6262,280.8645 1092.1315,283.7331 1088.3738,281.9669 1090.6211,278.1604 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0A4372",d:"M1095.2742,285.213l-14.1541,22.2665c-0.871-0.7065-1.7297-1.4252-2.5884-2.1621l11.8701-19.0873 l-1.2059-0.6212l2.9355-1.8759L1095.2742,285.213z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A4372",points:"1094.3606,327.8762 1084.1592,343.3275 1082.7158,342.5663 1092.838,326.8835 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1090.4019,286.2301l-11.8701,19.0873c-2.2717-1.9489-4.5009-3.9953-6.6752-6.0904v-0.0061l2.1682-3.9344 l15.1711-9.6776L1090.4019,286.2301z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A4372",points:"1090.0973,326.1222 1079.8959,341.5796 1078.4525,340.8183 1088.5747,325.1356 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1C1E28",d:"M1082.6183,496.5983c5.1647,16.4988,16.0421,36.5972,38.3695,56.0681 c-9.7324,5.457-21.0544,10.7252-36.5363,12.6924c-22.1995-10.1344-62.1159-24.1606-88.7979-33.2048 c-10.2562-18.4417-7.5703-37.6325-7.5703-37.6325c6.0904,13.3989,19.4893,21.3163,19.4893,21.3163 c-10.3537-17.6621-6.6995-39.5875-6.6995-39.5875c4.8723,19.4892,19.4893,24.3615,19.4893,24.3615 c-4.8723-7.3085-3.6542-15.226-3.6542-15.226c18.8802,18.8802,60.2949,15.226,60.2949,15.226 C1078.9215,499.1806,1080.7913,497.8468,1082.6183,496.5983z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A4372",points:"1085.8341,324.3742 1075.6327,339.8256 1074.1831,339.0643 1084.3114,323.3815 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#965947",d:"M1239.6165,527.4097c-3.2766-0.6578-12.2052-6.6082-19.7512-11.9617 c-13.4536,4.8723-25.9268,5.8712-25.9268,5.8712c-6.4558,1.5165-14.0322,6.1757-21.4077,11.8641 c13.6547,5.1707,28.7162,7.6251,28.7162,7.6251s4.8723-1.2181,1.8271,11.5717c-1.9246,8.0881-16.2858,25.933-26.5785,37.9492 c-5.9685,6.9797-10.573,11.9921-10.573,11.9921c-12.9541,3.1244-27.5468,5.2682-34.4045,6.1879 c-2.491,0.3411-3.9648,0.5115-3.9648,0.5115c-0.073,1.6567,0.2131,3.1914,0.7734,4.5984 c3.4106,8.563,16.9618,12.6619,21.8341,13.8799c1.0963,0.2742,1.754,0.4021,1.754,0.4021l18.8801,4.2632 c3.0818-4.7992,7.6008-10.5973,12.9056-16.8643c5.7128-6.7421,12.3452-14.02,19.0751-21.152 c20.3723-21.5599,41.7131-41.7679,41.7131-41.7679l4.8723-17.6621C1249.3611,534.718,1245.7068,528.6277,1239.6165,527.4097z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#965947",d:"M1231.8938,457.9791c4.4946-12.8568,8.4961-27.8452,10.7678-44.4598l-0.6273,0.4142 c-5.658,19.8912-18.661,39.2526-40.3488,45.0992C1213.9575,460.6162,1224.0128,459.7637,1231.8938,457.9791z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#965947",d:"M1039.5471,427.8318c-27.7113,11.2671-66.3853-2.1317-89.5287-24.9707 c-5.5057-5.4326-8.4656-14.3428-10.0492-22.0776l-19.136,12.2051c14.5926,12.4427,53.0229,44.0458,73.9495,50.3737 c26.1887,7.9176,84.0474,16.4441,84.0474,16.4441c1.4191-12.5889,5.0732-30.86,5.0732-30.86 S1071.144,414.9871,1039.5471,427.8318z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1078.5317,305.3174l-8.7336,14.0505l-7.2598-3.2157l9.3182-16.9252 C1074.0309,301.3221,1076.26,303.3685,1078.5317,305.3174z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#444132",d:"M1082.6183,496.5983c-1.827,1.2485-3.6968,2.5823-5.6152,4.0135c0,0-41.4147,3.6542-60.2949-15.226 c0,0-1.2181,7.9175,3.6542,15.226c0,0-14.6169-4.8723-19.4893-24.3615c0,0-3.6542,21.9254,6.6995,39.5875 c0,0-13.3989-7.9175-19.4893-21.3163c0,0-2.6859,19.1909,7.5703,37.6325c-15.8715-5.3839-27.0596-9.0077-27.0596-9.0077 l-52.3774-45.0689L814.507,466.5057c0,0-0.7734-1.5652-2.223-4.2877l108.549-69.2295 c14.5926,12.4427,53.0229,44.0457,73.9495,50.3736c26.1887,7.9175,84.0474,16.4441,84.0474,16.4441 S1075.8945,475.1602,1082.6183,496.5983z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#043A5E",points:"1073.9578,292.3205 1075.0236,293.4655 1074.0248,295.2866 1070.9491,297.2477 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0A4372",d:"M1074.0248,295.2866l-2.1682,3.9344c-0.4446-0.4263-0.8831-0.8588-1.3215-1.2912l0.4141-0.6821 L1074.0248,295.2866z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1C1E28",d:"M1084.4515,565.3588c-11.1698,1.4373-24.4956,1.145-40.9457-2.0159 c-26.4689-5.0916-40.495-17.9423-47.8522-31.1889C1022.3356,541.1982,1062.2521,555.2244,1084.4515,565.3588z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0A4372",d:"M1071.8566,299.2209v0.0061l-9.3182,16.9252l7.2598,3.2157l-1.7845,2.8686l-9.361-4.8662l11.8824-19.4405 C1070.9735,298.3622,1071.412,298.7946,1071.8566,299.2209z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1070.9491,297.2477l-0.4141,0.6821c-0.0914-0.0853-0.1766-0.1705-0.262-0.2558L1070.9491,297.2477z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1070.535,297.9298l-11.8824,19.4405l9.361,4.8662l-31.9928,51.4516l-16.0421-7.8688l-0.4019-0.1949 l-0.4263-0.2132l37.6021-59.1133l13.5206-8.624C1070.3584,297.7592,1070.4436,297.8445,1070.535,297.9298z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1070.2731,297.674l-13.5206,8.624l8.6605-13.612 C1066.9904,294.3547,1068.6105,296.0296,1070.2731,297.674z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A5896",d:"M1063.5858,170.3605l-4.2389,5.0307c0,0-0.1522,0.3045-0.4202,0.8709 c0.0061-0.1523,0.0121-0.3045,0.0121-0.4568v-0.0061l4.5861-5.4387L1063.5858,170.3605L1063.5858,170.3605z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#021C2D",d:"M1057.5198,224.7233c3.636,1.6627,7.0892,4.0379,7.0892,10.7069c0,6.943-3.7456,18.5331-14.9336,38.8141 c-4.6166-5.9077-7.3877-9.9395-7.3877-9.9395s1.5714-9.233,3.4899-22.5649c6.7603-5.0307,8.3256-13.0822,8.3743-19.2578 C1055.0958,223.3712,1056.2104,224.1264,1057.5198,224.7233z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3D94BF",d:"M1058.7318,202.7917l-4.8723,2.4363c0,0,3.0453,4.8723-0.609,8.5265c0,0,0.4202,1.6748,0.6882,4.2633 c0.1279,1.285,0.2253,2.8076,0.2131,4.4641c0.9441,0.8893,2.0586,1.6445,3.3679,2.2413 c3.636,1.6627,7.0894,4.038,7.0894,10.7069c0,6.9431-3.7456,18.5331-14.9337,38.8141 c-2.4849,4.5009-5.3352,9.434-8.5936,14.8362h-0.006c-7.6617,12.7045-17.5708,28.0157-30.2632,46.5184l45.9398-29.3009 l8.6605-13.6119l1.7235-2.7163l64.4851-101.3746l-74.4185,2.2777C1056.9595,198.1875,1058.7318,202.7917,1058.7318,202.7917z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3D94BF",points:"1127.0659,148.563 1127.0659,148.5691 1093.6541,151.1147 1078.8362,152.2476  1063.5859,170.3605 1145.0692,167.364 1145.1118,167.3944 1148.7783,161.6329 1158.6204,146.1572 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3D94BF",d:"M989.9165,365.4114h29.2339l37.6021-59.1134l-45.9398,29.3009 C1004.5456,344.7344,997.6026,354.6497,989.9165,365.4114z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#634A2F",d:"M1053.2505,632.7734v15.226c-28.6249,6.6995-35.9333-6.6994-35.9333-6.6994l17.4612-20.2993 l0.0913,0.0305l0.0183,0.0061L1053.2505,632.7734z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#BC836F",d:"M1235.3531,399.5115c0,0-3.0453-9.7446,5.4813-15.2261c1.5227,0.6577,3.0026,1.3156,4.4338,1.9794 c-0.335-5.4022-1.3215-10.2562-2.9111-14.1602c-13.5695-33.3082-56.1536-44.9592-91.1975-49.0155 c-7.2659,18.9167-14.1785,36.8591-19.9279,51.6587c-0.4446,1.1511-0.8892,2.29-1.3217,3.4045 c-8.1306,20.9266-13.6241,34.7639-13.9226,34.7639h-29.2339l-96.8372-47.5049c7.6861-10.7617,14.6291-20.677,20.8961-29.8125 l-70.8434,45.1846c1.5836,7.7349,4.5435,16.645,10.0492,22.0776c23.1434,22.839,61.8174,36.2378,89.5287,24.9707 c31.5969-12.8447,44.3562,1.1145,44.3562,1.1145s-3.6542,18.2711-5.0732,30.86c0,0-2.9355,15.3539,3.7883,36.7921 c32.4556-22.1509,51.3601-16.7244,68.0784-17.3029c4.3789-0.1522,8.9468-0.7491,13.3379-1.5714 c13.3197-2.4788,25.0315-6.9551,25.0315-6.9551c-6.3462-4.3669-9.5923-10.5364-11.0906-14.3064 c-0.7917-2.022-1.0902-3.3558-1.0902-3.3558c1.3947,0.4751,2.765,0.9197,4.1232,1.34 c7.479,2.3082,14.3672,3.7699,20.6709,4.5859c0.0061,0,0.0061,0,0.0061,0c21.6877-5.8467,34.6908-25.208,40.3488-45.0992 c0.4872-1.681,0.9136-3.368,1.285-5.049C1239.1292,402.9951,1235.3531,399.5115,1235.3531,399.5115z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#BC836F",d:"M1160.3318,543.5552c-10.981,10.1223-19.3796,19.7877-19.3796,19.7877 c1.218-12.7898,8.5265-24.9706,8.5265-24.9706c-9.7264,2.5458-18.2164,8.5266-28.4908,14.2942 c3.1731,2.765,6.5715,5.5117,10.2197,8.2402c0,0-5.9077,7.8323-14.6597,17.041c-7.7043,8.1001-17.6194,17.2722-27.6382,23.0886 c-2.5518,1.4861-5.1099,2.7467-7.6433,3.7212c-23.7527,9.1355-31.061,11.5718-31.061,11.5718l-18.8802,2.436l3.5447,2.2656 l0.0182,0.0061l18.3625,11.7363c0,0,15.226-2.4363,24.3616,1.218c0,0,10.3536-16.4441,33.4971-28.6249 c0.207-0.1096,0.4142-0.2192,0.6213-0.3228c16.3466-8.5692,32.5896-15.5914,40.5741-18.9108 c3.2157-1.3398,5.0916-2.0828,5.0916-2.0828s3.0453-7.3086,7.3085-9.1356c4.2633-1.8271,13.3989-0.609,7.9175-9.7446 C1167.9995,557.4657,1162.0796,546.7344,1160.3318,543.5552z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#042430",d:"M1036.0208,373.6881l3.0574,1.4982l-0.0548,0.0792c-9.4828-4.6957-16.6877-8.2708-19.0447-9.4462 L1036.0208,373.6881z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A678E",d:"M1019.5767,365.6245l0.4019,0.1949C1019.8203,365.7463,1019.6863,365.6793,1019.5767,365.6245z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1C1E28",d:"M936.924,68.1942l0.9075,0.7674C937.5209,68.7179,937.2224,68.4621,936.924,68.1942z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#333024",d:"M920.8332,392.9886l-108.549,69.2295c-6.066-11.3586-24.0083-42.9068-47.6512-65.8006 c0.9136-4.6653,3.301-13.2649,11.5048-24.9219c11.5718-16.4441,28.6248-22.5345,28.6248-22.5345s4.1415,4.8175,12.1138,11.0906 c-7.2537,9.2452-14.55,17.5342-14.55,17.5342s3.6542,4.8723,3.6542,13.3989s-0.609,32.8881-0.609,32.8881l5.2925-3.7639 c1.9611,5.0428,5.6763,12.8629,11.1515,17.1627c0,0,12.1808-14.6169,14.6169-24.3616l-6.9552-6.1817l3.301-2.3448l-8.5266-9.7446 c0,0,3.3619-12.0285,8.3621-23.9718c13.7886,7.9358,32.48,15.4331,55.587,17.2724l9.1356,9.7446l17.6621-9.7446 C914.9986,387.9397,917.1607,389.8581,920.8332,392.9886z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CACDD8",points:"916.8257,114.4811 911.1617,119.5605 911.1556,119.5605 897.9455,114.4811 899.4559,109.0546 \t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#444132",d:"M909.5173,551.3631L905.053,565.98c0,0-3.8613,12.5889-3.0452,12.9969 c0.81,0.402,0.81,9.3366,0.81,9.3366l-0.3106,1.7053l-44.3502,12.7106l-99.0419,11.7545l7.5825-4.245 c0,0,25.2751-8.8311,36.8469-13.0943c11.5718-4.2633,71.5621-18.8802,71.5621-18.8802l-11.2673-9.4401 c0,0,8.222-0.9136,10.6582-7.3085c2.0098-5.2743,24.5016-21.0971,32.34-26.4871l2.4788-1.3277l-3.8613,12.5888l-0.609,8.5266 L909.5173,551.3631z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7F4234",d:"M938.1421,365.6062l-23.1435,22.3335c0,0,2.1621,1.9185,5.8346,5.0488l19.136-12.2051 C938.2761,372.531,938.1421,365.6062,938.1421,365.6062z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7F4234",d:"M855.9218,310.5917l-18.8802,7.9176c0,0-2.0159,9.2086-6.0478,18.9288 c0.3837,0.1888,0.7735,0.3715,1.1755,0.5604c18.2712,8.5265,32.8881,4.8723,32.8881,4.8723 c-0.4385-9.6716-0.0304-18.0337,0.9319-25.3118L855.9218,310.5917z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7F4234",d:"M832.6139,370.6672c-6.2792-3.6116-11.5352-7.3145-15.7375-10.6155 c-7.2537,9.2452-14.55,17.5342-14.55,17.5342s3.6542,4.8723,3.6542,13.3989s-0.609,32.8882-0.609,32.8882l5.2925-3.7639 l18.8132-13.3806l3.301-2.3447l-8.5266-9.7446C824.2518,394.6392,827.6137,382.6106,832.6139,370.6672z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2A1E",d:"M812.2842,462.218l-17.2541,11.0053c-0.0122-0.0122-0.0122-0.0182-0.0122-0.0182 c-26.1887-10.3537-73.6693-12.7898-73.6693-12.7898v-89.1694c7.4302,1.2181,14.7021,4.1597,21.7,8.2829 c-1.4312,1.1145-2.2352,1.7114-2.2352,1.7114s-5.4813,32.8881-9.7446,46.287l6.2975-2.2047 c1.0536,5.5666,3.3862,13.947,8.3195,19.2578c0,0,15.835-9.7446,20.0983-22.5345l-5.3839-4.787l7.211-2.5214l-11.5717-15.835 c0,0,7.3085,3.0452,7.9175,1.2181c0.1766-0.5299,0.3045-1.7845,0.676-3.703 C788.2759,419.3112,806.2181,450.8595,812.2842,462.218z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#544B35",d:"M795.0301,473.2234l-73.6815,46.9935v-28.2655v-31.536c0,0,47.4807,2.4362,73.6693,12.7898 C795.0179,473.2051,795.0179,473.2112,795.0301,473.2234z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C0E14",d:"M1056.9048,157.1138c4.8723-10.9626-4.8723-28.0156-4.8723-28.0156s-2.4363-17.0532-12.1808-29.843 c0,0-2.0891-2.3508-5.926,2.8687c-2.0221,2.7528-4.5312,7.6068-7.4729,16.0116c-8.5266,24.3616-46.287,35.3242-46.287,35.3242 c18.2712,7.3085,38.3694-7.3085,38.3694-7.3085c-16.444,23.7526-40.1965,21.9254-40.1965,21.9254 c8.5266,13.3988,26.1887,10.9628,26.1887,10.9628c-15.226,10.3536-30.452,8.5265-30.452,8.5265 c4.8723,8.5265,18.8802,10.9628,18.8802,10.9628c-21.9559,3.3253-37.3646-2.4302-46.8351-8.3439 c-7.8688-4.9088-11.6326-9.9274-11.6326-9.9274c1.4434,5.6641,3.7213,10.5425,6.4741,14.7266 c12.3453,18.7584,34.3315,23.6429,34.3315,23.6429c-41.9689,4.1962-55.6052,20.7865-56.0194,21.3102 c14.6169-4.8662,35.3121-2.4299,35.3121-2.4299c-18.0641,8.3193-33.3387,9.8665-45.2577,8.6604 c-18.3381-1.8514-28.7223-10.2196-29.0389-10.4814c7.3572,9.635,15.1163,16.2917,22.437,20.89 c18.1372,11.4012,33.5885,10.1649,33.5885,10.1649c-10.9626,8.5265-12.1807,23.7524-12.1807,23.7524 c10.9627-14.0078,28.6248-22.5344,28.6248-22.5344c-8.5266,15.835-7.9175,31.6699-7.9175,31.6699 c2.4362-13.3987,12.7899-25.5796,12.7899-25.5796c-6.6995,20.7073-0.6091,34.1062-0.6091,34.1062 c3.6542-28.0157,23.1435-42.0237,23.1435-42.0237c-5.4813,18.8802,4.8723,21.3164,4.8723,21.3164 c1.2181,12.1807,6.6995,15.226,6.6995,15.226c0.542-32.9491,22.6379-47.6938,41.2197-55.2825 c2.3752-0.9684,4.6896-1.821,6.8944-2.5763c2.3204-0.7979,4.2815-1.8453,5.9259-3.0757 c6.7603-5.0305,8.3256-13.082,8.3743-19.2578c0.0122-1.6565-0.0852-3.1791-0.2131-4.4641 c-0.2681-2.5885-0.6882-4.2633-0.6882-4.2633c3.6543-3.6542,0.609-8.5265,0.609-8.5265l4.8723-2.4363 c0,0-1.7723-4.6042-1.5287-11.9189c0.0731-2.2777,0.3411-4.8235,0.9197-7.5703c0.4812-2.2717,0.7247-4.6592,0.804-7.0344 v-0.0061c0.0061-0.1521,0.0122-0.3044,0.0122-0.4568v-0.006C1059.1886,166.2495,1056.9048,157.1138,1056.9048,157.1138z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C0E14",d:"M937.8315,68.9615l16.3771,13.9287h0.006c9.4401-1.0171,17.4246-1.9064,17.4246-1.9064 s14.6169-6.0903,22.5345-2.436c3.575,1.6504,11.121,5.2864,18.6061,9.166l6.7481-1.7966h0.0061 c1.1389-3.4229,2.8807-6.9736,5.1647-10.0431V75.868c-1.9429-7.1379-4.8906-10.7069-14.081-12.5463 C998.437,60.8857,983.82,48.7048,983.82,48.7048l10.9627,20.0984c0,0-26.7977,3.6543-34.1062-5.4814 c0,0,1.2181,9.1357,7.3085,12.7898C967.985,76.1116,949.4824,78.426,937.8315,68.9615z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C0E14",d:"M983.82,90.1196c0,1.6809,1.3643,3.0452,3.0452,3.0452s3.0452-1.3643,3.0452-3.0452 c0-1.681-1.3643-3.0453-3.0452-3.0453C985.1843,87.0743,983.82,88.4386,983.82,90.1196z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C0E14",d:"M902.83,93.1587c0.3837-0.1096,8.5022-2.5032,7.9053-5.4753c-0.6091-3.0452-4.2633-3.6542-6.6995-3.0452 c0,0,2.4362,1.218,3.0452,3.6543C907.6719,90.6555,903.098,93.0186,902.83,93.1587z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#49341E",d:"M810.6641,420.1091c1.9611,5.0427,5.6763,12.8628,11.1515,17.1627c0,0,12.1808-14.6169,14.6169-24.3616 l-6.9552-6.1818L810.6641,420.1091z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#49341E",d:"M737.3663,425.3225c1.0536,5.5667,3.3862,13.947,8.3195,19.2578c0,0,15.835-9.7446,20.0983-22.5344 l-5.3839-4.7871L737.3663,425.3225z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#AD7260",d:"M1048.1893,66.1416c-2.9172,0.9685-1.9489-0.4871-11.6692,1.4557 c-4.8114,0.9623-8.8007,4.1902-11.8214,8.2708v0.0061c-2.2839,3.0695-4.0258,6.6202-5.1647,10.0431h-0.0061l-6.7481,1.7966 c-7.4851-3.8796-15.0311-7.5156-18.6061-9.166c-7.9175-3.6543-22.5345,2.436-22.5345,2.436s-7.9845,0.8893-17.4246,1.9064 h-0.006c-12.6802,1.3643-27.9792,2.9659-30.0743,2.9659c-3.6542,0-20.7073-4.8723-20.7073-4.8723l-6.6995,9.1357l-0.609,12.7898 l1.2181,5.4813l2.1194,0.6638l17.3698,5.4266l-5.6641,5.0793h-0.0061l-11.992,10.7556l5.4814,11.5718l16.444-6.6995 c0,0,17.6621,4.2632,24.3616,9.7446c6.6994,5.4813,12.7898,15.226,24.9706,11.5718l-10.3536,20.7073l-13.947,12.9725 c9.4706,5.9137,24.8793,11.6692,46.8351,8.3439c0,0-14.0079-2.4363-18.8802-10.9628c0,0,15.226,1.8271,30.452-8.5265 c0,0-17.6621,2.436-26.1887-10.9628c0,0,23.7525,1.8271,40.1965-21.9254c0,0-20.0983,14.6169-38.3694,7.3085 c0,0,37.7604-10.9626,46.287-35.3242c2.9417-8.4048,5.4508-13.2588,7.4729-16.0116c-0.5542-0.9928-1.0171-1.748-1.3824-2.2595 c-0.0853-0.1218-0.1888-0.2498-0.3168-0.3838v-0.0061l0.3105-4.9636c3.3193-3.5994,7.6375-8.6605,9.3306-12.333 c2.9174-6.3158,6.3218-12.1504,8.7518-14.0933C1053.0496,66.1416,1051.1006,65.1672,1048.1893,66.1416z M907.0811,88.2925 c-0.6091-2.4363-3.0452-3.6543-3.0452-3.6543c2.4362-0.609,6.0904,0,6.6995,3.0452c0.5969,2.9722-7.5217,5.3657-7.9053,5.4753 C903.098,93.0186,907.6719,90.6555,907.0811,88.2925z M986.8652,87.0743c1.6809,0,3.0452,1.3643,3.0452,3.0453 c0,1.6809-1.3643,3.0452-3.0452,3.0452c-1.681,0-3.0452-1.3643-3.0452-3.0452C983.82,88.4386,985.1843,87.0743,986.8652,87.0743 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#AD7260",d:"M1045.7776,241.7397c-1.6444,1.2303-3.6055,2.2778-5.9259,3.0757 c-2.2048,0.7552-4.5192,1.6079-6.8944,2.5763c-18.5818,7.5886-40.6777,22.3334-41.2197,55.2825c0,0-5.4814-3.0453-6.6995-15.226 c0,0-10.3536-2.4362-4.8723-21.3164c0,0-19.4893,14.0079-23.1435,42.0237c0,0-6.0904-13.3989,0.6091-34.1062 c0,0-10.3537,12.1809-12.7899,25.5796c0,0-0.609-15.835,7.9175-31.6699c0,0-17.6621,8.5266-28.6248,22.5344 c0,0,1.2181-15.226,12.1807-23.7524c0,0-15.4513,1.2363-33.5885-10.1649c-3.7273,2.351-14.5195,9.6045-20.0069,18.0824 c-5.0855,7.8627-13.6912,19.9399-16.7303,42.9006c-0.9623,7.2781-1.3704,15.6401-0.9319,25.3118 c0,0-14.6169,3.6542-32.8881-4.8723c-0.402-0.189-0.7917-0.3716-1.1755-0.5604c-16.9678-8.1002-14.1723-11.0114-19.5319-11.0114 c-5.4814,0-11.5718,4.2632-11.5718,4.2632h-10.3536c0,0-5.4813,9.7446-20.0983,24.9707 c-11.1089,11.5718-21.8645,20.3296-26.3897,23.8682c-1.4312,1.1145-2.2352,1.7114-2.2352,1.7114s-5.4813,32.8882-9.7446,46.287 l6.2975-2.2047l23.0339-8.0637l7.211-2.5215l-11.5717-15.835c0,0,7.3085,3.0452,7.9175,1.218 c0.1766-0.5298,0.3045-1.7844,0.676-3.7029c0.9136-4.6653,3.301-13.2649,11.5048-24.9219 c11.5718-16.4441,28.6248-22.5344,28.6248-22.5344s4.1415,4.8175,12.1138,11.0906c4.2023,3.301,9.4584,7.0039,15.7375,10.6155 c13.7886,7.9358,32.48,15.4331,55.587,17.2725l9.1356,9.7446l17.6621-9.7446l23.1435-22.3335c0,0,0.134,6.9248,1.8271,15.1772 l70.8434-45.1846c12.6924-18.5027,22.6014-33.814,30.2632-46.5184h0.006c3.2584-5.4022,6.1088-10.3353,8.5936-14.8362 c-4.6166-5.9077-7.3876-9.9396-7.3876-9.9396S1043.8591,255.0718,1045.7776,241.7397z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#AD7260",d:"M975.2935,218.6268c0,0-21.9863-4.8845-34.3315-23.6429l-7.0831,6.5898l-24.5504,44.5938 c11.9189,1.2061,27.1936-0.3411,45.2577-8.6604c0,0-20.6951-2.4363-35.3121,2.4299 C919.6882,239.4133,933.3246,222.823,975.2935,218.6268z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#665D44",d:"M1246.6813,634.2655l-13.3562-8.8007l14.0931-9.2573l0.1157-0.0792l-0.1705,0.0122l-0.5907,0.0304 l-28.4727,1.5774l-34.5995-2.4482c-5.3048,6.267-9.8239,12.0651-12.9056,16.8643l-18.8801-4.2632c0,0-0.6577-0.1279-1.754-0.4021 l-1.2059,16.8826l-0.0852,1.1816c-2.4666,0.469-4.8054,0.7429-7.0161,0.8647c-18.0337,1.0049-27.6992-8.1733-27.6992-8.1733 c4.1294-10.5546,11.0237-20.4149,14.1724-24.6355c-0.5603-1.407-0.8464-2.9417-0.7734-4.5984c0,0,1.4739-0.1704,3.9648-0.5115 l-19.7876-3.4655c-0.2072,0.1035-0.4143,0.2131-0.6213,0.3228c-23.1434,12.1808-33.4971,28.6249-33.4971,28.6249 c-9.1356-3.6543-24.3616-1.218-24.3616-1.218v15.2258c-28.6249,6.6995-35.9333-6.6993-35.9333-6.6993l17.4612-20.2993 l0.0914,0.0304l-3.5447-2.2656l18.8802-2.436c0,0,7.3083-2.4363,31.061-11.5718c2.5334-0.9745,5.0916-2.2351,7.6433-3.7212 l-36.6763-6.4315l-47.5051-2.4362l-77.1409-9.3365l-25.0803,7.1866l-44.3502,12.7107l-99.0419,11.7544l7.5825-4.245 c0,0,25.2751-8.8311,36.8469-13.0944c11.5718-4.2632,71.5621-18.8801,71.5621-18.8801l-11.2673-9.4402 c0,0,8.222-0.9136,10.6582-7.3083c2.0098-5.2744,24.5016-21.0972,32.34-26.4872c1.6749-1.1571,2.6798-1.8331,2.6798-1.8331 l-21.9254-20.7074l-27.4067-11.2672c0,0-28.6249-10.0492-43.8508-11.8762c-15.226-1.8271-24.3616,3.6542-24.3616,3.6542 c7.7287-8.3256,3.2645-19.2639,3.0574-19.7755l-73.6815,46.9934v98.7496v8.9347v53.9912h283.4833h9.2391l66.1782-4.05 l142.1132-15.427l-13.8069-8.5266l28.4238-13.3988l14.1846-3.2462l0.0244-0.0061L1246.6813,634.2655z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"715.8976,687.7391 711.9755,691.9537 707.9254,696.2961 707.9254,500.1917 720.843,491.9514  721.3486,491.9514 721.3486,520.2169 721.3486,618.9664 721.3486,627.9011 721.3486,681.8923 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"721.3486,460.4153 721.3486,491.9514 720.843,491.9514 707.9254,500.1917 707.9254,-64.8809  708.3699,-64.8809 721.3486,-50.9522 721.3486,371.2459 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"696.1709,-77.9752 708.3699,-64.8809 707.9254,-64.8809 707.9254,500.1917 695.7446,507.9569  695.7446,-77.9752 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B361D",points:"707.9254,500.1917 707.9254,696.2961 700.9579,703.7812 695.8237,709.2808 695.7446,709.2078  695.7446,507.9569 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#382416",points:"696.1709,-77.9752 695.7446,-77.9752 695.7446,507.9569 692.2426,510.1921 692.2426,-82.1898 \t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#382416",points:"695.8237,709.2808 692.2974,713.0691 692.2426,713.0143 692.2426,510.1921 695.7446,507.9569  695.7446,709.2078 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#382416",points:"692.2974,713.0691 685.2447,720.6394 685.2447,514.6563 692.2426,510.1921 692.2426,713.0143 \t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"692.2426,-82.1898 692.2426,510.1921 685.2447,514.6563 685.2447,-89.6992 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"castle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_15_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"356.8924,628.7751 356.8924,629.0311 88.4465,629.0311 88.4465,628.8787 91.4943,626.1174  91.4943,626.1356 353.9299,626.1356 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"356.8924,414.879 356.8924,628.7751 353.9299,626.1356 354.2652,626.1356 354.2652,417.4209  354.0701,417.4209 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"356.8924,414.8485 356.8924,414.879 354.0701,417.4209 91.4943,417.4209 91.4943,417.5672  88.5257,414.8485 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"354.2652,417.4209 354.2652,626.1356 353.9299,626.1356 349.5045,622.1918 349.5411,622.1552  349.5411,421.4989 354.0701,417.4209 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"354.0701,417.4209 349.5411,421.4989 349.5411,421.4806 95.7734,421.4806 91.4943,417.5672  91.4943,417.4209 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"353.9299,626.1356 91.4943,626.1356 91.4943,626.1174 104.9352,613.9443 340.1477,613.9443  340.1477,613.8529 349.5045,622.1918 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"349.5411,421.4989 349.5411,622.1552 349.5045,622.1918 340.1477,613.8529 340.1477,430.0145  340.0745,430.0145 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"349.5411,421.4806 349.5411,421.4989 340.0745,430.0145 105.0998,430.0145 95.7734,421.4806  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"340.1477,613.8529 340.1477,613.9443 104.9352,613.9443 108.8669,610.3845 108.8669,610.476  336.3562,610.476 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"336.3562,610.476 332.6378,607.1599 332.6378,436.7197 332.6257,436.7197 340.0745,430.0145  340.1477,430.0145 340.1477,613.8529 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"340.0745,430.0145 332.6257,436.7197 112.4267,436.7197 108.873,433.4646 105.0998,430.0145  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"332.6378,607.1599 336.3562,610.476 108.8669,610.476 108.8669,610.3845 112.4267,607.1599 \t\t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CEB080",points:"332.6378,436.7197 332.6378,607.1599 112.4267,607.1599 112.4267,436.7197 332.6257,436.7197  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"112.4267,436.7197 112.4267,607.1599 108.8669,610.3845 108.8669,433.4707 108.873,433.4646  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"108.873,433.4646 108.8669,433.4707 108.8669,610.3845 104.9352,613.9443 104.9047,613.9443  104.9047,430.0145 105.0998,430.0145 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"95.7734,421.4806 105.0998,430.0145 104.9047,430.0145 104.9047,613.9443 104.9352,613.9443  91.4943,626.1174 91.4943,417.5672 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"91.4943,417.5672 91.4943,626.1174 88.4465,628.8787 88.4465,629.0311 88.1661,629.0311  88.1661,414.8485 88.5257,414.8485 \t\t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_14_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#6B4E2D",points:"272.8328,555.866 309.2665,564.3186 272.8328,574.5958 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#937045",points:"309.0625,567.962 271.8593,578.6006 260.0081,578.2101 272.8328,574.5958 309.2665,564.3186  323.84,563.7357 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#35200F",points:"272.8328,555.866 272.8328,574.5958 260.0081,578.2101 255.4262,576.4962 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#492F17",points:"272.8328,555.866 255.4262,576.4962 226.8272,565.8226 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#937045",points:"255.4262,576.4962 260.0081,578.2101 250.4829,602.6469 227.3752,592.871 216.7249,588.3649  226.8272,565.8226 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#492F17",points:"308.3513,582.3898 307.372,602.2097 287.9484,607.1588 259.227,607.1588 260.0081,578.2101  271.8768,590.6267 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#35200F",points:"260.0081,578.2101 271.8593,578.6006 309.0625,567.962 308.3513,582.3898 271.8768,590.6267  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#684931",d:"M332.6366,524.1949v82.9639h-44.6881l19.4236-4.9492l0.9793-19.8199l0.7112-14.4278l14.7775-4.2263 l-14.5735,0.5829l16.6138-21.6678l-37.8911-5.0016l-15.1564,18.2169l-11.0759-1.7488l-49.8938,10.7377l14.9641,0.9677 l-10.1023,22.5422l10.6503,4.5061l-0.0641,0.1574l0.1457,10.0557l10.2597,4.0747H127.4769 c19.2195-18.689,46.1163-51.9224,67.9999-65.674v-0.0117c20.6244-2.5649,41.721-5.5962,61.5467-8.4059 c15.2031-2.1569,29.6541-4.1797,42.5779-5.7653h0.0233C312.3736,525.7339,323.6302,524.5971,332.6366,524.1949z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#203135",d:"M332.6366,436.7249v87.47c-9.0064,0.4022-20.263,1.539-33.0119,3.1071h-0.0233h-39.5408l-1.9179-9.3271 l-14.2937-2.1452l-0.513-4.955l1.3991-0.7695l-0.4897-12.2417l-2.7631-3.9756v-0.0058l-0.2448-14.865l0.9677-1.3641 l0.1982-5.1473l-2.9147-7.4791l-2.8214,6.6047l0.3906,6.3132l1.265,1.1659l-0.3381,10.2014l-5.0074,3.7891l-2.4309,11.274 l-3.1071-21.5688l-1.9412-0.3906l-0.1108,1.3757l-4.3312,1.3641l-1.4107-8.3011l4.1972-3.6667l0.1982-11.0292l-0.5829-0.682 l-1.0726,9.8167l-3.2703,2.4308l-1.195-7.0477l-2.7223,0.0991l-1.9412,17.5815l-2.8214,3.1129l-0.5538-7.38l0.0699-0.0058 l1.4574-3.0605l-0.2448-7.1876l-0.2915-0.1458l-0.0466,5.3397l-1.1717,2.0111l-0.0933-1.23h-2.2327l-0.5654,4.3662 l-1.912-0.9211l-0.0991-11.4606h-0.6762l-0.6354,12.6265l2.9613,2.5416l-2.0111,15.5237l-3.9348,1.0493h-0.0233l-0.2915-5.2698 l-2.2385-0.1924l-0.1282,6.2899l-2.5416-1.8712l-0.0466-16.0775l-0.7287,0.2915l-0.8744,16.468l4.1156,4.9841l-0.2507,12.1485 l-10.7144,0.6004l-1.1659-7.8697h-3.2062l-1.6031,10.7611v0.0058l-8.5051,0.8919l-2.2968,6.6047h-3.5967 c-15.6169-6.1442-47.3638-15.2031-53.8578-15.547h-0.0758v-75.0301h220.2109V436.7249z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#937045",points:"325.8803,542.6508 309.2665,564.3186 272.8328,555.866 287.9892,537.6492 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2C5163",d:"M260.0606,527.302h39.5408c-12.9238,1.5856-27.3748,3.6083-42.5779,5.7653v-0.0059 c-9.3678-0.373-27.0251-1.6788-50.6399-2.6523v-0.0117c0,0-1.061-2.3959-3.1071-3.0954h41.7501h11.8512H260.0606z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#937045",points:"272.8328,555.866 226.8272,565.8226 211.8632,564.8549 261.757,554.1172 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#6B4E2D",points:"260.0081,578.2101 259.227,607.1588 237.7166,607.1588 227.4568,603.0841 227.3111,593.0284  227.3752,592.871 250.4829,602.6469 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#455D60",d:"M205.6024,530.3799c0.2623,0.0117,0.5246,0.0175,0.7811,0.0292 c23.6149,0.9735,41.2721,2.2793,50.6399,2.6523v0.0059c-19.8258,2.8098-40.9223,5.8411-61.5467,8.4059 c-1.1659,0.14-2.3259,0.2856-3.4801,0.4256l-0.0175-0.1224c2.1977-4.9667,6.0859-9.8458,8.9889-11.5772 C202.5361,530.2574,204.0809,530.3158,205.6024,530.3799z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#203135",points:"255.4204,520.4058 256.8778,527.302 245.0266,527.302 244.1872,519.1467 244.2455,519.1408 \t\t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#203135",points:"225.23,485.8492 224.9618,489.201 221.8723,489.988 221.3651,486.98 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1F2C30",points:"224.9618,489.201 224.9327,489.5916 221.9364,490.3728 221.8723,489.988 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2C5163",d:"M206.3836,530.3974v0.0117c-0.2565-0.0117-0.5188-0.0175-0.7811-0.0292 c-0.0933-0.2274-1.1659-2.664-2.903-3.0779h0.5713h0.0058C205.3226,528.0015,206.3836,530.3974,206.3836,530.3974z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2C5163",d:"M169.9557,527.302h2.2035h7.4791h17.5873h5.4738c1.7372,0.4139,2.8098,2.8505,2.903,3.0779 c-1.5215-0.0641-3.0663-0.1224-4.6344-0.1807c-0.4372-0.0175-0.8802-0.035-1.3291-0.0466 c-8.7441-0.3206-18.2169-0.5771-28.3017-0.7286c-1.3582-0.6471-3.0429-1.3641-4.9783-2.1219h3.5968V527.302z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#203135",points:"204.1043,500.7141 203.8011,503.0575 200.6591,503.7104 200.5542,501.7692 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1F2C30",points:"203.8011,503.0575 203.6962,503.8678 200.6941,504.3575 200.6591,503.7104 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1F2C30",d:"M199.6389,530.1525c0.4489,0.0117,0.8919,0.0292,1.3291,0.0466 c-2.903,1.7314-6.7912,6.6105-8.9889,11.5772l0.0175,0.1224c-3.3228,0.4022-6.628,0.7928-9.91,1.1658l-0.0175-0.1224 C189.2043,535.6147,194.3342,531.7265,199.6389,530.1525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#162528",points:"244.2455,497.8635 241.4824,493.8879 241.7213,508.1292 243.0796,508.3564 243.3361,510.8748  244.7351,510.1052 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#162528",points:"230.5464,504.375 234.044,503.11 234.9185,506.9982 237.3843,507.4062 237.9847,489.3118  232.9772,493.1008 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#162528",points:"221.3651,486.98 225.23,485.8491 225.3874,483.7914 221.0562,485.1555 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#162528",points:"222.4843,493.5906 224.6237,493.4915 224.9327,489.5916 221.9364,490.3728 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#162528",points:"224.0408,462.1584 223.4578,461.4764 222.3853,471.2932 219.1149,473.724 219.6454,476.8544  223.8426,473.1877 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#162528",points:"210.8722,469.6901 210.8256,475.0298 209.6539,477.041 209.8812,480.0897 209.9512,480.0839  211.4085,477.0234 211.1636,469.8358 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#162528",points:"204.7513,467.7955 204.0751,467.7955 203.4397,480.422 206.4011,482.9636 206.7625,480.1771  204.8504,479.2561 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#162528",points:"200.4318,499.5366 200.5541,501.7693 204.1042,500.7141 204.3899,498.4873 200.4551,499.5366  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#162528",points:"200.8165,506.6077 203.4397,505.8323 203.6962,503.8678 200.6941,504.3574 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#162528",points:"195.1853,482.4156 194.4566,482.707 193.5822,499.1752 197.6978,504.1593 197.7736,500.3643  195.2319,498.4932 \t\t\t\t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1F2C30",d:"M195.4768,541.4732v0.0117c-21.8835,13.7516-48.7804,46.9849-67.9999,65.674h-15.0515v-34.7781h0.0758 c9.6185-7.2867,39.156-24.0929,54.8954-27.6896l-0.0058-0.0466c4.8268-0.478,9.7351-1.0085,14.6959-1.5739v-0.0059 c3.282-0.373,6.5872-0.7636,9.91-1.1658C193.1508,541.7589,194.3109,541.6132,195.4768,541.4732z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#455D60",d:"M171.3372,529.4239c10.0849,0.1516,19.5576,0.408,28.3017,0.7286 c-5.3047,1.574-10.4346,5.4622-17.5698,12.7897l0.0175,0.1224v0.0059c-4.9608,0.5654-9.8692,1.0959-14.6959,1.5739 c-20.158,2.017-38.9986,3.212-54.6914,2.8681h-0.274v-17.4882h0.0758C133.6619,529.2606,153.4643,529.1616,171.3372,529.4239z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#131C23",points:"258.1428,517.9749 243.8491,515.8297 243.3361,510.8748 243.0796,508.3564 241.7213,508.1292  241.4824,493.8879 241.4824,493.8821 241.2375,479.0171 242.2052,477.6531 242.4034,472.5056 239.4887,465.0266  236.6672,471.6313 237.0578,477.9446 238.3228,479.1104 237.9847,489.3118 237.3843,507.4062 234.9185,506.9982 234.044,503.11  230.5464,504.375 227.4393,482.8062 225.4981,482.4156 225.3874,483.7914 225.23,485.8491 224.9619,489.201 224.9327,489.5916  224.6237,493.4915 222.4843,493.5906 221.9364,490.3728 221.8723,489.988 221.3651,486.98 221.0562,485.1555 219.6454,476.8544  219.1149,473.724 217.9199,466.6763 215.1976,466.7754 213.2564,484.3568 210.435,487.4697 209.8812,480.0897 209.6539,477.041  209.5605,475.8109 207.3279,475.8109 206.7625,480.1771 206.4011,482.9636 204.3899,498.4873 204.1042,500.7141  203.8011,503.0575 203.6962,503.8678 203.4397,505.8323 200.8165,506.6077 200.6941,504.3574 200.6591,503.7104  200.5541,501.7693 200.4318,499.5366 200.1403,494.2668 197.9018,494.0745 197.7736,500.3643 197.6978,504.1593  197.4471,516.3077 186.7327,516.9082 185.5668,509.0385 182.3606,509.0385 180.7576,519.7996 180.7576,519.8054  172.2524,520.6973 169.9557,527.302 172.1592,527.302 173.8089,522.5393 180.4019,522.0906 180.4136,522.0906 179.6383,527.302  197.2256,527.302 202.6994,527.302 203.2706,527.302 203.2765,527.302 245.0266,527.302 244.1872,519.1467 244.2455,519.1409  255.4204,520.4058 256.8777,527.302 260.0606,527.302 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#203135",points:"180.4136,522.0905 179.6383,527.302 172.1592,527.302 173.8089,522.5394 180.4019,522.0905 \t\t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#684931",d:"M167.3907,544.6444l0.0058,0.0466c-15.7394,3.5967-45.2769,20.4029-54.8954,27.6896h-0.0758v-24.8682 h0.274C128.3921,547.8564,147.2327,546.6614,167.3907,544.6444z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#50575B",d:"M166.3589,527.302c1.9354,0.7578,3.6201,1.4748,4.9783,2.1219 c-17.8729-0.2623-37.6754-0.1633-58.8361,0.6004h-0.0758V511.755h0.0758C118.9951,512.0989,150.742,521.1578,166.3589,527.302z"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"plate"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"1403.6282",y:"699.4727",fill:"#2C4B54",width:"72.5616",height:"23.1667"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_5_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7F3808",points:"1406.63,719.64 1406.63,696.47 1407.92,697.58 1407.92,718.42 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CCA70E",points:"1479.1899,696.47 1479.1899,719.6 1478,718.42 1478,697.58 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CCA70E",points:"1406.63,696.47 1479.1899,696.47 1478,697.58 1407.92,697.58 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7F3808",points:"1479.1899,719.64 1406.63,719.64 1407.92,718.42 1478,718.42 1479.1899,719.6 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"1407.92",y:"697.58",fill:"#D87721",width:"70.08",height:"20.84"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CCA70E",d:"M1471.1899,712.1574c-0.22,0.2301-0.5,0.3501-0.8199,0.3501s-0.6-0.12-0.8199-0.3501 c-0.1001-0.0999-0.17-0.2-0.22-0.3198c-0.0801,0.1499-0.1201,0.3198-0.1201,0.5c0,0.3198,0.1201,0.5999,0.3401,0.8198 c0.22,0.2301,0.5,0.3501,0.8199,0.3501s0.6-0.12,0.8199-0.3501c0.23-0.22,0.3501-0.5,0.3501-0.8198 c0-0.1802-0.04-0.3501-0.1201-0.5C1471.37,711.9575,1471.29,712.0576,1471.1899,712.1574z M1461.86,704.2475 c0.34-0.22,0.78-0.3301,1.3099-0.3301c0.54,0,1.0801,0.0901,1.6301,0.28c0.5499,0.1901,0.99,0.4301,1.3099,0.72l0.9801-1.3899 c-0.1501-0.1201-0.3-0.24-0.4701-0.3401l-0.51,0.73c-0.3199-0.2899-0.76-0.5299-1.3099-0.72c-0.55-0.1899-1.0901-0.28-1.6301-0.28 c-0.5299,0-0.97,0.1101-1.3099,0.3301c-0.35,0.22-0.5199,0.55-0.5199,0.99c0,0.1799,0.0299,0.3501,0.0999,0.5 C1461.52,704.5375,1461.6599,704.3775,1461.86,704.2475z M1466.35,711.6175c-0.72,0.59-1.66,0.89-2.83,0.89 c-1.49,0-2.8401-0.45-4.04-1.3501l-0.49,0.5901c1.3201,1.1699,2.8301,1.76,4.53,1.76c1.1699,0,2.11-0.3,2.83-0.89 c0.7101-0.59,1.0699-1.37,1.0699-2.3199c0-0.1901-0.01-0.3801-0.0399-0.55C1467.29,710.4975,1466.9399,711.1275,1466.35,711.6175z M1459.46,704.8775c-0.03,0.16-0.04,0.3199-0.04,0.49c0,1.01,0.3301,1.76,0.9701,2.24c0.3199,0.26,0.6901,0.4801,1.11,0.64 c0.4099,0.1599,1.02,0.3301,1.8201,0.53c0.7999,0.1899,1.3699,0.3999,1.6899,0.6399c0.1799,0.1301,0.3101,0.28,0.39,0.4701 c0.0699-0.15,0.1-0.3099,0.1-0.49c0-0.42-0.1599-0.75-0.49-0.9901c-0.3201-0.23-0.89-0.4399-1.6899-0.6299 c-0.8-0.2-1.4102-0.3701-1.8201-0.53c-0.4199-0.1699-0.79-0.38-1.11-0.64C1459.86,706.2075,1459.55,705.6375,1459.46,704.8775z M1457.01,712.1574c-0.23,0.2301-0.51,0.3501-0.8301,0.3501c-0.3199,0-0.5898-0.12-0.8199-0.3501 c-0.1-0.0999-0.17-0.2-0.22-0.3198c-0.0699,0.1499-0.11,0.3198-0.11,0.5c0,0.3198,0.11,0.5999,0.33,0.8198 c0.2301,0.2301,0.5,0.3501,0.8199,0.3501c0.3201,0,0.6001-0.12,0.8301-0.3501c0.23-0.22,0.34-0.5,0.34-0.8198 c0-0.1802-0.0399-0.3501-0.11-0.5C1457.1899,711.9575,1457.11,712.0576,1457.01,712.1574z M1447.6699,704.2475 c0.3401-0.22,0.78-0.3301,1.3201-0.3301c0.53,0,1.0801,0.0901,1.63,0.28c0.5499,0.1901,0.98,0.4301,1.3099,0.72l0.98-1.3899 c-0.1499-0.1201-0.2999-0.24-0.47-0.3401l-0.51,0.73c-0.33-0.2899-0.76-0.5299-1.3099-0.72c-0.5499-0.1899-1.1-0.28-1.63-0.28 c-0.54,0-0.98,0.1101-1.3201,0.3301c-0.3398,0.22-0.51,0.55-0.51,0.99c0,0.1799,0.03,0.3501,0.1001,0.5 C1447.3401,704.5375,1447.47,704.3775,1447.6699,704.2475z M1452.1599,711.6175c-0.72,0.59-1.6599,0.89-2.8198,0.89 c-1.5,0-2.8401-0.45-4.04-1.3501h-0.01l-0.49,0.5901c1.3199,1.1699,2.83,1.76,4.54,1.76c1.1599,0,2.0999-0.3,2.8198-0.89 c0.7201-0.59,1.0801-1.37,1.0801-2.3199c0-0.1901-0.01-0.3801-0.04-0.55C1453.11,710.4975,1452.76,711.1275,1452.1599,711.6175z M1445.28,704.8775c-0.03,0.16-0.04,0.3199-0.04,0.49c0,1.01,0.3201,1.76,0.97,2.24c0.3201,0.26,0.6901,0.4801,1.1001,0.64 c0.4199,0.1599,1.03,0.3301,1.83,0.53c0.7999,0.1899,1.36,0.3999,1.6901,0.6399c0.1799,0.1301,0.3099,0.28,0.3899,0.4701 c0.0701-0.15,0.1001-0.3099,0.1001-0.49c0-0.42-0.1602-0.75-0.49-0.9901c-0.3301-0.23-0.8901-0.4399-1.6901-0.6299 c-0.7999-0.2-1.41-0.3701-1.83-0.53c-0.41-0.1699-0.78-0.38-1.1001-0.64C1445.6699,706.2075,1445.36,705.6375,1445.28,704.8775z M1442.8201,712.1574c-0.23,0.2301-0.5,0.3501-0.8201,0.3501c-0.3301,0-0.6-0.12-0.8201-0.3501 c-0.0999-0.0999-0.1799-0.2-0.23-0.3198c-0.0699,0.1499-0.1099,0.3198-0.1099,0.5c0,0.3198,0.1099,0.5999,0.3398,0.8198 c0.2201,0.2301,0.49,0.3501,0.8201,0.3501c0.3201,0,0.5901-0.12,0.8201-0.3501c0.23-0.22,0.3499-0.5,0.3499-0.8198 c0-0.1802-0.0399-0.3501-0.1199-0.5C1443,711.9575,1442.9199,712.0576,1442.8201,712.1574z M1433.5601,703.8975 c1.08,0,2,0.39,2.74,1.16c0.6299,0.6499,0.99,1.4199,1.08,2.2999c0.02-0.16,0.0299-0.33,0.0299-0.5 c0-1.1-0.3699-2.0299-1.1099-2.7999s-1.66-1.16-2.74-1.16c-1.0801,0-1.99,0.39-2.73,1.16c-0.75,0.77-1.1201,1.7-1.1201,2.7999 c0,0.17,0.01,0.34,0.03,0.5c0.0901-0.88,0.46-1.65,1.0901-2.2999C1431.5701,704.2875,1432.48,703.8975,1433.5601,703.8975z M1437.65,710.8775c-1.1,1.0699-2.4701,1.61-4.09,1.61c-1.6201,0-2.98-0.54-4.0801-1.61c-0.98-0.9701-1.53-2.14-1.62-3.52 c-0.0199,0.16-0.0299,0.33-0.0299,0.5c0,1.6,0.5499,2.9401,1.6499,4.02c1.1001,1.0699,2.46,1.61,4.0801,1.61 c1.6199,0,2.99-0.54,4.09-1.61c1.1-1.08,1.65-2.42,1.65-4.02c0-0.17-0.01-0.34-0.03-0.5 C1439.1799,708.7375,1438.63,709.9074,1437.65,710.8775z M1425.96,712.1574c-0.23,0.2301-0.51,0.3501-0.83,0.3501 s-0.59-0.12-0.8199-0.3501c-0.1001-0.0999-0.17-0.2-0.22-0.3198c-0.0701,0.1499-0.1101,0.3198-0.1101,0.5 c0,0.3198,0.1101,0.5999,0.3301,0.8198c0.23,0.2301,0.5,0.3501,0.8199,0.3501s0.6-0.12,0.83-0.3501 c0.22-0.22,0.3401-0.5,0.3401-0.8198c0-0.1802-0.04-0.3501-0.1201-0.5C1426.13,711.9575,1426.0601,712.0576,1425.96,712.1574z M1421.54,705.3675c0-0.16-0.01-0.3099-0.04-0.4601c-0.0901,0.5901-0.35,1.04-0.77,1.3601c-0.1899,0.1499-0.33,0.24-0.3999,0.27 c-0.0701,0.04-0.2001,0.1-0.3901,0.1799c0.3701,0.0801,0.6901,0.21,0.98,0.39 C1421.3301,706.6974,1421.54,706.1075,1421.54,705.3675z M1415.29,708.7075h2.6499c1.29,0,2.05,0.3301,2.25,1.01 c0.0601-0.1599,0.0801-0.35,0.0801-0.5601c0-0.97-0.78-1.45-2.3301-1.45h-2.6499V708.7075z M1421.37,711.3675 c-0.61,0.67-1.66,1.01-3.15,1.01h-4.77v1h4.77c1.49,0,2.54-0.33,3.15-1.01c0.52-0.58,0.78-1.25,0.78-2.01 c0-0.17-0.01-0.34-0.04-0.5C1422.02,710.4174,1421.77,710.9174,1421.37,711.3675z M1419.55,705.1075 c0.0599-0.13,0.08-0.2899,0.08-0.46c0-0.52-0.16-0.89-0.49-1.12c-0.3199-0.23-0.8199-0.3501-1.49-0.3501h-2.36v1.01h2.36 c0.67,0,1.17,0.1101,1.49,0.3401C1419.3401,704.6674,1419.48,704.8575,1419.55,705.1075z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7F3808",d:"M1471.54,711.8326c0,0.1799-0.04,0.3499-0.1201,0.5c-0.0499,0.1199-0.1299,0.22-0.23,0.3198 c-0.22,0.2301-0.5,0.3501-0.8199,0.3501s-0.6-0.12-0.8199-0.3501c-0.1001-0.0999-0.17-0.2-0.22-0.3198 c-0.0801-0.1501-0.1201-0.3201-0.1201-0.5c0-0.3201,0.1201-0.6001,0.3401-0.8201s0.5-0.3401,0.8199-0.3401 s0.6,0.1201,0.8199,0.3401C1471.4199,711.2325,1471.54,711.5125,1471.54,711.8326z M1464.05,706.5025 c-1.1201-0.27-1.8501-0.53-2.1901-0.76c-0.2001-0.13-0.35-0.3-0.42-0.51c-0.0699-0.1499-0.0999-0.3201-0.0999-0.5 c0-0.4399,0.1699-0.77,0.5199-0.99c0.34-0.22,0.78-0.3301,1.3099-0.3301c0.54,0,1.0801,0.0901,1.6301,0.28 c0.5499,0.1901,0.99,0.4301,1.3099,0.72l0.51-0.73l0.4701-0.6599c-0.4901-0.42-1.0901-0.74-1.77-0.97 c-0.6901-0.23-1.3801-0.3401-2.0801-0.3401c-1.0801,0-1.98,0.27-2.72,0.8201c-0.73,0.54-1.1001,1.3199-1.1001,2.33 c0,0.1801,0.01,0.35,0.04,0.51c0.0901,0.76,0.4,1.33,0.9301,1.73c0.3199,0.26,0.6901,0.4701,1.11,0.64 c0.4099,0.1599,1.02,0.3301,1.8201,0.53c0.7999,0.1899,1.3699,0.3999,1.6899,0.6299c0.3301,0.2401,0.49,0.5701,0.49,0.9901 c0,0.1801-0.03,0.34-0.1,0.49c-0.08,0.2001-0.2201,0.38-0.42,0.5199c-0.35,0.25-0.8201,0.3801-1.4099,0.3801 c-1.1801,0-2.3301-0.48-3.4301-1.4301l-1.15,1.39c0.16,0.14,0.3301,0.28,0.49,0.4v0.0099c1.2,0.9001,2.55,1.3501,4.04,1.3501 c1.1699,0,2.11-0.3,2.83-0.89c0.59-0.49,0.9401-1.12,1.03-1.87c0.0299-0.15,0.0399-0.3,0.0399-0.45 c0-0.9501-0.2799-1.67-0.8499-2.16C1466.01,707.1524,1465.1599,706.7725,1464.05,706.5025z M1456.1799,710.6724 c-0.3199,0-0.5898,0.1201-0.8199,0.3401c-0.22,0.22-0.33,0.5-0.33,0.8201c0,0.1799,0.04,0.3499,0.11,0.5 c0.0499,0.1199,0.12,0.22,0.22,0.3198c0.2301,0.2301,0.5,0.3501,0.8199,0.3501c0.3201,0,0.6001-0.12,0.8301-0.3501 c0.1-0.0999,0.1799-0.2,0.23-0.3198c0.0701-0.1501,0.11-0.3201,0.11-0.5c0-0.3201-0.11-0.6001-0.34-0.8201 S1456.5,710.6724,1456.1799,710.6724z M1449.86,706.5025c-1.12-0.27-1.85-0.53-2.1901-0.76c-0.2-0.13-0.3398-0.3-0.4099-0.51 c-0.0701-0.1499-0.1001-0.3201-0.1001-0.5c0-0.4399,0.1702-0.77,0.51-0.99c0.3401-0.22,0.78-0.3301,1.3201-0.3301 c0.53,0,1.0801,0.0901,1.63,0.28c0.5499,0.1901,0.98,0.4301,1.3099,0.72l0.51-0.73l0.47-0.6599c-0.5-0.42-1.0898-0.74-1.7799-0.97 c-0.6801-0.23-1.38-0.3401-2.0699-0.3401c-1.0801,0-1.99,0.27-2.72,0.8201c-0.7301,0.54-1.1001,1.3199-1.1001,2.33 c0,0.1801,0.01,0.35,0.04,0.51c0.08,0.76,0.3899,1.33,0.9299,1.73c0.3201,0.26,0.6901,0.4701,1.1001,0.64 c0.4199,0.1599,1.03,0.3301,1.83,0.53c0.7999,0.1899,1.36,0.3999,1.6901,0.6299c0.3298,0.2401,0.49,0.5701,0.49,0.9901 c0,0.1801-0.03,0.34-0.1001,0.49c-0.08,0.2001-0.22,0.38-0.4199,0.5199c-0.3501,0.25-0.8201,0.3801-1.41,0.3801 c-1.1901,0-2.33-0.48-3.4301-1.4301l-1.1599,1.39c0.1599,0.14,0.33,0.28,0.49,0.4099h0.01c1.2,0.9001,2.54,1.3501,4.04,1.3501 c1.1599,0,2.0999-0.3,2.8198-0.89c0.6001-0.49,0.9501-1.12,1.04-1.87c0.03-0.15,0.04-0.3,0.04-0.45c0-0.9501-0.29-1.67-0.85-2.16 C1451.8201,707.1524,1450.98,706.7725,1449.86,706.5025z M1442,710.6724c-0.3301,0-0.6,0.1201-0.8201,0.3401 c-0.23,0.22-0.3398,0.5-0.3398,0.8201c0,0.1799,0.0399,0.3499,0.1099,0.5c0.05,0.1199,0.1301,0.22,0.23,0.3198 c0.2201,0.2301,0.49,0.3501,0.8201,0.3501c0.3201,0,0.5901-0.12,0.8201-0.3501c0.0999-0.0999,0.1799-0.2,0.23-0.3198 c0.08-0.1501,0.1199-0.3201,0.1199-0.5c0-0.3201-0.1199-0.6001-0.3499-0.8201S1442.3201,710.6724,1442,710.6724z M1437.65,703.3226c1.1,1.0798,1.65,2.4199,1.65,4.0299c0,0.17-0.01,0.34-0.03,0.5c-0.0901,1.38-0.64,2.5499-1.62,3.52 c-1.1,1.0699-2.4701,1.61-4.09,1.61c-1.6201,0-2.98-0.54-4.0801-1.61c-0.98-0.9701-1.53-2.14-1.62-3.52 c-0.0199-0.16-0.0299-0.33-0.0299-0.5c0-1.61,0.5499-2.9501,1.6499-4.0299c1.1001-1.0701,2.46-1.6101,4.0801-1.6101 C1435.1799,701.7125,1436.55,702.2525,1437.65,703.3226z M1437.4099,707.3525c0-1.1-0.3699-2.0299-1.1099-2.7999 s-1.66-1.16-2.74-1.16c-1.0801,0-1.99,0.39-2.73,1.16c-0.75,0.77-1.1201,1.7-1.1201,2.7999c0,0.17,0.01,0.34,0.03,0.5 c0.1001,0.88,0.46,1.65,1.0901,2.29c0.74,0.7699,1.6499,1.16,2.73,1.16c1.08,0,2-0.3901,2.74-1.16 c0.6199-0.64,0.98-1.41,1.08-2.29C1437.4,707.6924,1437.4099,707.5225,1437.4099,707.3525z M1425.13,710.6724 c-0.3199,0-0.59,0.1201-0.8199,0.3401c-0.22,0.22-0.3301,0.5-0.3301,0.8201c0,0.1799,0.04,0.3499,0.1101,0.5 c0.0499,0.1199,0.1199,0.22,0.22,0.3198c0.23,0.2301,0.5,0.3501,0.8199,0.3501s0.6-0.12,0.83-0.3501 c0.1001-0.0999,0.17-0.2,0.22-0.3198c0.0801-0.1501,0.1201-0.3201,0.1201-0.5c0-0.3201-0.1201-0.6001-0.3401-0.8201 C1425.73,710.7925,1425.45,710.6724,1425.13,710.6724z M1421.55,708.1325c0.3999,0.46,0.6,1.0299,0.6,1.72 c0,0.17-0.01,0.33-0.04,0.49c0,0.01,0,0.01,0,0.01c-0.09,0.5599-0.34,1.0599-0.74,1.51c-0.61,0.67-1.66,1.01-3.15,1.01h-4.77 v-9.89v-1h4.24c0.74,0,1.3801,0.0801,1.91,0.26c0.54,0.1799,0.9401,0.4199,1.2001,0.72c0.5,0.5601,0.74,1.1899,0.74,1.9 c0,0.1901-0.01,0.37-0.04,0.5399c-0.0901,0.5901-0.35,1.04-0.77,1.3601c-0.1899,0.1499-0.33,0.24-0.3999,0.27 c-0.0701,0.04-0.2001,0.1-0.3901,0.1799c0.3701,0.0801,0.6901,0.21,0.98,0.39 C1421.1599,707.7425,1421.37,707.9224,1421.55,708.1325z M1419.63,705.1425c0-0.52-0.16-0.89-0.49-1.12 c-0.3199-0.23-0.8199-0.3501-1.49-0.3501h-2.36v1.01v1.8201h2.34c1.08,0,1.72-0.3,1.92-0.9 C1419.61,705.4725,1419.63,705.3126,1419.63,705.1425z M1420.27,709.6524c0-0.97-0.78-1.45-2.3301-1.45h-2.6499v1v1.97h2.8899 c0.67,0,1.1901-0.0999,1.55-0.3199c0.23-0.13,0.39-0.35,0.46-0.64C1420.25,710.0526,1420.27,709.8625,1420.27,709.6524z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"boxes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"right_box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"back"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#512F18",points:"1695.2313,837.5818 1567.578,837.5818 1567.578,823.9032 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B361D",points:"1567.578,823.9032 1567.578,837.5818 1546.3495,837.5818 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B361D",points:"1567.578,823.9032 1546.3495,837.5818 1535.9468,837.5818 1435.8027,823.9032 \t\t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"tentacleR",className:"tentacleR"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"tentacleR2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_28_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#835D93",d:"M1478.6415,771.4497c52.5,8.7,71.205,57.27,66.3149,87.63c-1.785,10.98-21.27,14.1-35.265,10.035 c22.0649-62.37-14.115-82.785-36.375-89.16c-20.1749-5.775-46.47,6.015-64.5601-3.09c-0.0298-0.015-0.0598-0.03-0.0898-0.045 c-1.845-1.05-3.5851-2.205-5.205-3.465c-6.2551-4.8898-10.6652-11.415-12.39-20.025c-0.2551-1.275-0.045-2.31,0.765-2.625 c0.8248-0.3151,2.0249-0.45,3.015,1.305C1410.1365,779.5797,1435.3516,764.2947,1478.6415,771.4497z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#385604",d:"M1473.3164,779.9547c22.26,6.375,58.4399,26.79,36.375,89.16 c-9.585-2.775-16.5751-8.895-13.5601-18.165c12.75-39.12-16.2449-63.495-48.21-64.905c-14.8051-0.645-28.7249-3.27-39.165-9.18 C1426.8464,785.9697,1453.1415,774.1797,1473.3164,779.9547z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1525.8739",cy:"807.043",r:"4.4116"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1505.199",cy:"791.5172",r:"2.5624"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1514.699",cy:"791.5172",r:"3.6874"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1541.106",cy:"835.0492",r:"4.5945"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1523.4489",cy:"821.1422",r:"3.0626"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1537.074",cy:"819.6422",r:"3.0626"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1485.3159",cy:"775.6503",r:"1.6794"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1415.9802",cy:"773.0484",r:"1.4688"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1424.777",cy:"775.189",r:"2.1407"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1408.4802",cy:"769.0485",r:"0.5937"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1404.2465",cy:"763.515",r:"1.4399"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1395.1365",cy:"757.8297",r:"1.2499"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1447.949",cy:"774.3922",r:"2.8125"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1436.1833",cy:"771.064",r:"1.4218"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1470.8346",cy:"774.0797",r:"2.5001"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1458.8877",cy:"776.7766",r:"1.1263"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1460.5425",cy:"771.1146",r:"1.6547"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1491.5427",cy:"783.486",r:"0.9063"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1495.3865",cy:"778.8297",r:"2.25"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1506.8551",cy:"782.736",r:"1.6563"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1528.4121",cy:"849.0296",r:"6.9498"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"tentacleL",className:"tentacleL"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_23_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#385604",d:"M1692.0879,750.817c-0.7075-0.501-0.828-1.8329-0.364-2.7493 c1.7826-3.618,15.8088-24.9141,39.8394-16.5195c21.8737,7.6428,28.1675,31.9671,16.8485,50.3493 c-10.381,16.8492-35.558,17.514-57.7308,16.05c-28.2045-1.8433-35.9148,19.8075-37.6045,48.9972 c-0.3369,5.955-10.8691,6.5096-21.5266,4.7126l-0.0006-0.015c2.1321-30.7357,17.296-54.3221,33.7665-65.5709 c24.8163-16.937,72.6667,21.3671,72.6554-25.9851c-0.0006-0.015-0.001-0.03-0.0015-0.045 c0.1213-1.2799,0.0913-2.5997-0.1031-3.8988c-0.6973-5.0341-3.701-9.9294-9.3937-13.1269 c-15.9609-8.9855-31.9735,6.4501-33.2231,7.6485C1694.3923,751.4886,1692.688,751.2468,1692.0879,750.817z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#835D93",d:"M1737.9711,760.0861c0.0114,47.3522-47.8391,9.0483-72.6554,25.9851 c-16.4705,11.2488-31.6344,34.8351-33.7665,65.5709l0.0006,0.015c-11.5487-1.962-23.2661-6.6647-22.3065-10.2094 c1.8234-6.8163,13.121-58.7873,50.5334-69.4603c27.9-7.947,57.1866,10.2039,71.025,0.546 C1735.0085,769.5828,1737.5222,764.9643,1737.9711,760.0861z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1642.2695",cy:"790.6032",r:"3.1875"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1627.2109",cy:"802.2136",r:"1.7228"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1631.3916",cy:"815.5515",r:"1.9999"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1638.6515",cy:"801.8583",r:"2.6876"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1655.0083",cy:"775.4094",r:"3.5625"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1689.1501",cy:"771.8901",r:"0.7894"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1677.8174",cy:"777.2101",r:"1.5782"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1714.8723",cy:"779.556",r:"1.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1706.8856",cy:"778.023",r:"1.8047"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1730.3881",cy:"775.1801",r:"2.3438"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1617.3391",cy:"820.5341",r:"2.5001"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1619.4319",cy:"836.0343",r:"5.9374"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1624.9552",cy:"811.4922",r:"0.8484"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1637.6022",cy:"809.586",r:"0.6251"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1629.9745",cy:"828.5938",r:"1.8613"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"1666.5944",cy:"781.3926",r:"2.8125"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"front"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#A87543",points:"1754.8817,886.8186 1695.2313,885.8748 1695.2313,837.5818 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#8C6042",points:"1695.2313,885.8748 1695.2313,961.2432 1642.8815,961.2432 1674.9249,885.5494 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#A87543",points:"1695.2313,837.5818 1695.2313,885.8748 1674.9249,885.5494 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#A87543",points:"1695.2313,837.5818 1674.9249,885.5494 1583.6539,884.1068 1535.9468,837.5818  1546.3495,837.5818 1567.578,837.5818 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1674.9249,885.5494 1642.8815,961.2432 1535.9468,961.2432 1535.9468,837.5818  1583.6539,884.1068 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#13282D",points:"1672.1371,979.0766 1487.0137,979.0766 1340.5725,928.0823 1435.8027,928.0823  1435.8027,931.4343 1535.9468,961.2432 1642.8815,961.2432 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B361D",points:"1535.9468,837.5818 1535.9468,961.2432 1435.8027,931.4343 1435.8027,928.0823  1435.8027,911.7352 1435.9763,911.7352 1497.4272,928.8527 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#512F18",points:"1535.9468,837.5818 1497.4272,928.8527 1435.9763,911.7352 1435.8027,911.7352  1435.8027,893.1643 1482.9894,905.5197 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1535.9468,837.5818 1482.9894,905.5197 1435.8027,893.1643 1435.8027,823.9032 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"1435.8027,823.9032 1435.8027,893.1643 1383.8975,879.5834 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_24_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#13282D",points:"-2.166,950.845 -66.7675,921.7387 35.0888,908.5648 147.2496,908.5648 147.2496,921.2473  182.3167,929.9506 209.8219,936.7833 266.4968,950.845 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B361D",points:"147.2496,921.2473 147.2496,908.5648 147.2496,789.6664 203.4965,794.5333 203.544,794.5333  266.4968,799.9709 266.4968,950.845 209.8219,936.7833 209.8219,912.2585 182.396,906.71 182.396,929.6494 182.3167,929.9506 \t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#BF884C",points:"324.646,785.5921 203.544,794.5333 203.4965,794.5333 147.2496,789.6664 284.3791,782.9288 \t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#8C6042",points:"385.9341,789.6664 385.9341,921.2473 266.4968,950.845 266.4968,799.9709 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CC9966",points:"385.9341,789.6664 266.4968,799.9709 203.544,794.5333 324.646,785.5921 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#8C6042",points:"209.8219,912.2585 209.8219,936.7833 182.3167,929.9506 182.396,929.6494 182.396,906.71 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_25_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2B1E13",points:"1878.4008,825.3354 1878.4008,904.3712 1950.1426,918.6644 1950.1426,831.5249 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#512F18",points:"1878.4008,825.3354 1950.1426,831.5249 1987.9559,828.2587 1915.2144,822.8881 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1915.2144,822.8881 1987.9559,828.2587 1987.9845,828.2587 2021.77,825.3354 1939.4012,821.2885  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"1950.1426,831.5249 1950.1426,918.6644 1984.1851,911.8748 1984.1851,898.9719  2000.6588,895.6392 2000.6588,908.58 2021.77,904.3712 2021.77,825.3354 1987.9845,828.2587 1987.9559,828.2587 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#54341E",points:"1984.1851,898.9719 1984.1851,911.8748 2000.6588,908.58 2000.6588,895.6392 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_27_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"570.8215,807.9253 570.8215,923.3417 609.187,916.8894 609.1594,916.8894 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#160E08",points:"570.8215,807.9253 609.1594,916.8894 609.187,916.8894 661.1661,908.1566 660.0676,815.6289 \t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#512F18",points:"570.8215,807.9253 660.0676,815.6289 659.9008,802.0155 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#512F18",points:"570.8215,923.3417 675.5864,944.2141 675.5864,927.5551 675.5028,927.5551 609.187,916.8894 \t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#160E08",points:"609.187,916.8894 675.5028,927.5551 675.5864,927.5551 675.5864,909.9923 661.1661,908.1566 \t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#512F18",points:"659.9008,802.0155 660.0676,815.6289 675.5864,816.9639 780.1842,809.9276 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#140C06",points:"660.0676,815.6289 661.1661,908.1566 675.5864,909.9923 675.5864,816.9639 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"675.5864,927.5551 675.5864,944.2141 780.1842,923.3417 675.5864,909.9923 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3F2818",points:"675.5864,816.9639 675.5864,909.9923 780.1842,923.3417 780.1842,879.0525 757.254,882.3896  757.254,853.8833 780.1842,851.8809 780.1842,809.9276 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#512F18",points:"757.254,853.8833 757.254,882.3896 780.1842,879.0525 780.1842,851.8809 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"left_box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"back_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"412.76,863.9829 420.5746,864.3647 433.5645,840.4344 397.534,839.4417 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B361D",points:"397.534,863.2192 412.76,863.9829 397.534,839.4417 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#512F18",points:"304.55,858.6241 397.534,863.2192 397.534,839.4417 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#A87543",points:"240.8962,864.3647 304.55,858.6241 397.534,839.4417 332.45,845.1442 \t\t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"buzzsaw",className:"buzzsaw"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#6697A3",points:"402.0531,967.1734 395.7277,967.1935 395.9272,1000.0883 379.4558,1000.1404 379.2335,964.9948  387.7206,961.7971 387.6724,946.5783 395.658,945.1737 395.8612,949.2791 397.5388,948.3859 397.5856,963.1293  402.0403,963.1152 403.6846,961.7465 412.192,964.8903 406.2225,967.1602 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#97A9B7",points:"402.0531,967.1734 402.2525,1000.0684 395.9272,1000.0883 395.7277,967.1935 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3B7182",points:"412.192,964.8903 412.3984,1000.0361 402.2525,1000.0684 402.0531,967.1734 406.2225,967.1602  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#3B7182",cx:"395.5406",cy:"908.1411",r:"5.5486"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3B7182",points:"397.5388,948.3859 403.6321,945.1643 403.6846,961.7465 402.0403,963.1152 397.5856,963.1293  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6697A3",d:"M397.4587,923.1003l0.0802,25.2856l-1.6776,0.8932l-0.2032-4.1053l-7.9855,1.4046l-0.0791-24.9844 c-4.2887-2.6497-7.1732-7.3964-7.1905-12.8181c-0.0265-8.3547,6.7372-15.1453,15.0917-15.1719 c4.5816-0.0146,8.6938,2.0016,11.4626,5.2111l1.0504,6.3221l-1.2752,7.8198l-7.1138,6.3639l-7.0201,0.9258l0.0074,2.3621 L397.4587,923.1003z M401.0891,908.1234c-0.0097-3.0596-2.5065-5.5406-5.5662-5.5309c-3.0755,0.0099-5.5406,2.5065-5.531,5.566 c0.0097,3.0597,2.4907,5.5409,5.5662,5.531C398.6177,913.68,401.0989,911.1831,401.0891,908.1234z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3B7182",d:"M397.5388,948.3859l-0.0802-25.2856l-4.8526-0.4919l-0.0074-2.3621l7.0201-0.9258l7.1138-6.3639 l1.2752-7.8198l-1.0504-6.3221c2.3071,2.6402,3.6973,6.0919,3.7091,9.8647c0.0173,5.4218-2.8371,10.1868-7.109,12.8638 l0.0749,23.6212L397.5388,948.3859z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#97A9B7",className:"blade",d:"M387.5932,921.5939l0.0791,24.9843l-4.5314,0.7911l1.0655-3.9666l-12.5931-1.7831l2.256-3.4473 l-11.432-5.5759l3.2099-2.5942l-9.1436-8.8329l3.8477-1.4706l-5.9648-11.221l4.1212-0.2191l-2.2115-12.5171l3.9825,1.0656 l1.7673-12.5772l3.4631,2.2402l5.5759-11.4161l2.5942,3.1941l8.8172-9.1277l1.4866,3.8318l11.2211-5.9487l0.2191,4.1051 l12.517-2.1957l-1.0655,3.9666l12.5772,1.7833l-2.2402,3.4473l11.4162,5.5759l-3.21,2.5944l9.1436,8.8329l-3.8477,1.4706 l5.9648,11.221l-4.1053,0.2191l2.1957,12.517l-3.9825-1.0656l-1.7675,12.5772l-3.4631-2.2402l-5.56,11.4161l-2.5942-3.194 l-8.833,9.1277l-1.4707-3.8318l-3.466,1.8342l-0.0749-23.6212c4.2718-2.6768,7.1261-7.4419,7.109-12.8638 c-0.0119-3.7728-1.402-7.2245-3.7091-9.8647c-2.7686-3.2094-6.8811-5.2257-11.4626-5.2111 c-8.3546,0.0265-15.1182,6.8171-15.0917,15.1719C380.42,914.1973,383.3044,918.9441,387.5932,921.5939z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"front_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B361D",points:"420.5746,1009.4734 420.5746,864.3647 395.4322,951.8755 304.55,940.6487 304.55,941.4124  304.55,961.6513 304.55,993.4224 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#13282D",points:"266.4968,950.8444 222.1538,950.1825 130.0074,976.7094 154.9759,976.7094 212.443,1009.4734  420.5746,1009.4734 304.55,993.4224 304.55,961.6513 304.55,941.4124 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A5431",points:"420.5746,864.3647 420.5746,1009.4734 493.5205,966.2719 493.5205,842.0893 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#512F18",points:"304.55,910.5703 304.55,940.6487 395.4322,951.8755 420.5746,864.3647 385.8241,918.9587 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5B361D",points:"452.4727,805.6211 433.5645,840.4344 420.5746,864.3647 493.5205,842.0893 522.4241,794.5216 \t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#A87543",points:"412.7602,863.9829 397.534,863.2192 304.55,858.6241 261.1,906.0897 304.55,910.5703  385.8241,918.9587 420.5746,864.3647 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"eye",className:"eye"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#455359",cx:"639.3419",cy:"856.0013",r:"26.4128"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#748489",cx:"635.2925",cy:"853.4764",r:"20.642"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#721010",cx:"639.3419",cy:"856.0013",r:"11.3949"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#160E08",cx:"639.3419",cy:"856.0013",r:"5.3252"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#CECAC0",cx:"631.7953",cy:"848.1514",r:"2.8003"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"eyelid",className:"eyelid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#160E08",d:"M600.5203,861.2556c18.4842-8.4938,54.051-17.7006,74.6561-8.4552c0,0-10.7104-35.8901-40.9742-29.5495 C603.9384,829.5914,600.5203,861.2556,600.5203,861.2556z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#160E08",d:"M675.8491,856.0109c-18.4842,8.4938-54.051,17.7006-74.6561,8.4552c0,0,10.7104,35.8901,40.9742,29.5495 C672.4309,887.675,675.8491,856.0109,675.8491,856.0109z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"figure_1_",fill:"#0F1C21",d:"M1137.8595,889.4748c-0.8292-4.561-3.1097-3.1098-3.1097-3.1098 s-1.6586-8.2927-4.9756-18.8658c-3.3171-10.5732-7.6708-34.4146-9.1219-42.2927c-1.4513-7.8781-4.561-10.5732-4.561-10.5732 c3.7317-4.7683-5.3212-31.6505-7.1178-32.3414c-1.7968-0.691-2.7643,0.2763-2.7643,0.2763 c-7.3252-7.8781-41.3252-17.1381-41.3252-17.1381l0.1383-2.0732l-11.1952-4.9756c7.6016-5.3903,23.2196-18.7968,18.2439-65.6505 c-4.9756-46.8536-31.4174-37.0419-37.179-42.7073c-8.2926-8.1544-19.3495-12.439-32.6178-7.0488s-23.0813,23.7724-23.6342,44.7805 s-30.8212,11.1951-30.8212,11.1951s0,14.0975,8.2927,19.4878c0,0-7.4634,0.5529-9.813-0.8293c0,0,4.4228,13.683,17.9675,20.4554 c0,0-6.6342,2.4878-9.6748,0.8293c0,0,10.3658,14.9958,18.7968,17.6219c0,0-9.7439,1.0366-12.5082-0.0693 c0,0,1.1748,10.2968,13.5102,11.6444c0,0-27.0549,5.4939-28.0915,8.811c0,0-1.0366-2.2805-3.6281-2.1768 c-2.5914,0.1036-9.7784,8.5346-14.063,33.9653c0,0-2.626-0.9673-5.9431,10.3659c-3.3171,11.3334-15.3415,46.7846-16.3781,59.4309 c0,0-2.6951,1.4512-2.6951,9.7439s-4.561,15.7561,2.9024,22.3903s32.1342,31.0976,48.0976,37.1097l1.4512-2.2805 c0,0,42.5,24.2561,57.6342,22.3903s57.0123-7.4634,64.2684-28.4025l13.0609-7.4634l1.0366,2.2805 c49.5487-15.7561,44.7804-23.8414,46.2317-29.439C1139.7253,899.2187,1138.6888,894.0358,1137.8595,889.4748z M961.0181,893.2065 c0,0,1.2439,12.8536-2.4878,20.7317c0,0-10.1586-14.5122-14.7195-18.0366c0,0,0.8293-3.5244-0.6219-9.3293l10.5732-25.0854 c0,0,3.5244,18.4512,7.8781,25.7073C961.64,887.1943,959.5668,888.2308,961.0181,893.2065z M1076.2864,913.3162 c-0.4147-6.0122-4.3536-15.7561-4.3536-15.7561c3.317-6.2195,8.7073-25.7073,11.817-36.6951c0,0,3.9391,10.1586,6.4269,19.4879 c2.4878,9.3292,5.1829,9.5366,5.1829,9.5366c-1.2439,7.8781,3.7317,7.6707,3.7317,7.6707 C1094.5303,898.804,1076.2864,913.3162,1076.2864,913.3162z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"chairs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_16_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1954,1338.67 1946.33,1343 1926.65,1347.3101 1947.04,1360.33 1922,1402 1907.75,1429.89  1916,1446 1701.22,1282.0601 1701.22,1282.05 1690.4399,1273.83 1725.5,1202.5 1824.67,1267.33 1822.67,1270.9301  1831.33,1270.9301 1894,1307.67 1933,1324.33 1927,1326.33 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E202B",points:"2063.9299,1198.98 1906.22,1502.12 1683.25,1316.58 1701.22,1282.0601 1916,1446 1965,1348.5  1965,1334.5 1741.15,1205.28 1743.4301,1200.91 1963.5,1329.33 1983.25,1316.25 2044.54,1201.5 2040.91,1189.49 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1743.4301,1200.91 1737.37,1197.38 1742,1193.33 1951.5,1313.5 1963.5,1329.33 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"2040.91,1189.49 2044.54,1201.5 2019,1200 2017,1192.02 2038.5,1181.5 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#313442",d:"M1789,1086.5l114.5,50.5v8l6.5-3.5l107,42.51c0,0-24,8.49-21,7.99s21,0.02,21,0.02l2,7.98l-20,7.92 l20,3.58l-46.34,95l-21.16,7L1742,1193.33l-6.1-9.3199L1789,1086.5z M1899,1146l-104.33-45.67l-7.67,1.3401l-8.67,14l19.3401-6 l79.7799,35.6599l6.2201,0.67l2,7l91,39.02l3,15.9l14-7.17l-9.67-3.37l7.33-10.62h-7.6599L1907.33,1152H1899V1146z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#464956",points:"1797.67,1109.67 1778.33,1115.67 1787,1101.67 1794.67,1100.33 1899,1146 1899,1152  1907.33,1152 1983.67,1186.76 1991.33,1186.76 1984,1197.38 1993.67,1200.75 1979.67,1207.92 1976.67,1192.02 1885.67,1153  1883.67,1146 1877.45,1145.33 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"2038.5,1181.5 2017,1184.01 1910,1141.5 1903.5,1145 1903.5,1137 1789,1086.5 1803,1086.5  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"2038.5,1181.5 2017,1192.02 2017,1184.01 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1824.67,1267.33 1725.5,1202.5 1732,1200 1741.15,1205.28 1965,1334.5 1933,1324.33  1894,1307.67 1831.33,1270.9301 1822.67,1270.9301 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"2044.54,1201.5 1983.25,1316.25 2019,1235.27 2021.77,1230.25 2021.77,1224.75 2027.75,1220  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"2044.54,1201.5 2027.75,1220 2019,1211.5 1999,1207.92 2019,1200 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#212635",points:"2027.75,1220 2021.77,1224.75 2021.77,1230.25 2019,1235.27 1983.25,1316.25 1972.66,1306.5  2019,1211.5 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#292D3D",d:"M2017,1184.01v8.01c0,0-18-0.52-21-0.02S2017,1184.01,2017,1184.01z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1983.25,1316.25 1963.5,1329.33 1951.5,1313.5 1972.66,1306.5 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#212635",points:"1965,1334.5 1965,1348.5 1947.04,1360.33 1926.65,1347.3101 1946.33,1343 1954,1338.67 \t\t\t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1965,1348.5 1916,1446 1907.75,1429.89 1922,1402 1947.04,1360.33 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1965,1334.5 1954,1338.67 1933,1324.33 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1954,1338.67 1927,1326.33 1933,1324.33 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1735.9,1184.01 1742,1193.33 1737.37,1197.38 \t\t\t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_17_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1637.4856,1155.897 1632.1423,1158.9135 1618.432,1161.916 1632.637,1170.9866  1615.1926,1200.0164 1605.2653,1219.446 1611.0127,1230.6693 1461.3844,1116.4591 1461.3844,1116.4521 1453.8744,1110.7256  1478.2993,1061.033 1547.3868,1106.1974 1545.9935,1108.7053 1552.0266,1108.7053 1595.6862,1134.3005 1622.8558,1145.9069  1618.6759,1147.3002 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E202B",points:"1714.0693,1058.5808 1604.1993,1269.7657 1448.8655,1140.5078 1461.3844,1116.4591  1611.0127,1230.6693 1645.1489,1162.7451 1645.1489,1152.9918 1489.202,1062.9697 1490.7904,1059.9253 1644.1039,1149.3901  1657.8629,1140.2778 1700.561,1060.3363 1698.0322,1051.9695 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1698.0322,1051.9695 1700.561,1060.3363 1682.7684,1059.2914 1681.3751,1053.7321  1696.3533,1046.4032 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1700.561,1060.3363 1657.8629,1140.2778 1682.7684,1083.8625 1684.6981,1080.3652  1684.6981,1076.5337 1688.8641,1073.2245 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1700.561,1060.3363 1688.8641,1073.2245 1682.7684,1067.303 1668.8353,1064.8088  1682.7684,1059.2914 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1696.3533,1046.4032 1681.3751,1053.7321 1681.3751,1048.1519 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1696.3533,1046.4032 1681.3751,1048.1519 1606.8326,1018.5369 1602.3044,1020.9752  1602.3044,1015.4019 1522.5371,980.2206 1532.2903,980.2206 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#212635",points:"1688.8641,1073.2245 1684.6981,1076.5337 1684.6981,1080.3652 1682.7684,1083.8625  1657.8629,1140.2778 1650.4854,1133.4855 1682.7684,1067.303 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#313442",d:"M1681.3751,1053.7321l1.3933,5.5593l-13.9331,5.5175l13.9331,2.4941l-32.2831,66.1825l-14.7413,4.8766 l-145.95-83.7174l-4.2495-6.4928l36.9926-67.9312l79.7673,35.1813v5.5732l4.5282-2.4383l74.5425,29.6151 c0,0-16.7198,5.9146-14.6299,5.5663C1668.8353,1053.3698,1681.3751,1053.7321,1681.3751,1053.7321z M1655.3689,1064.8088 l9.7532-4.995l-6.7367-2.3478l5.1066-7.3984h-5.3364l-53.1829-24.2158h-5.8032v-4.18l-72.6824-31.8163l-5.3433,0.9335 l-6.04,9.7532l13.4733-4.1799l55.5795,24.8428l4.3331,0.4667l1.3934,4.8766l63.3959,27.1836L1655.3689,1064.8088z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#292D3D",d:"M1681.3751,1048.1519v5.5802c0,0-12.5398-0.3623-14.6299-0.0139 C1664.6553,1054.0664,1681.3751,1048.1519,1681.3751,1048.1519z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#464956",points:"1665.1221,1059.8138 1655.3689,1064.8088 1653.2789,1053.7321 1589.8831,1026.5485  1588.4896,1021.6718 1584.1565,1021.2051 1528.577,996.3622 1515.1038,1000.5422 1521.1438,990.7889 1526.4871,989.8555  1599.1694,1021.6718 1599.1694,1025.8518 1604.9727,1025.8518 1658.1555,1050.0676 1663.4919,1050.0676 1658.3854,1057.4661  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1657.8629,1140.2778 1644.1039,1149.3901 1635.744,1138.3621 1650.4854,1133.4855 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#212635",points:"1645.1489,1152.9918 1645.1489,1162.7451 1632.637,1170.9866 1618.432,1161.916  1632.1423,1158.9135 1637.4856,1155.897 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1645.1489,1162.7451 1611.0127,1230.6693 1605.2653,1219.446 1615.1926,1200.0164  1632.637,1170.9866 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1645.1489,1152.9918 1637.4856,1155.897 1622.8558,1145.9069 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1645.1489,1152.9918 1622.8558,1145.9069 1595.6862,1134.3005 1552.0266,1108.7053  1545.9935,1108.7053 1547.3868,1106.1974 1478.2993,1061.033 1482.8275,1059.2914 1489.202,1062.9697 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1635.744,1138.3621 1644.1039,1149.3901 1490.7904,1059.9253 1486.5686,1057.4661  1489.7941,1054.6447 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1637.4856,1155.897 1618.6759,1147.3002 1622.8558,1145.9069 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1485.5446,1048.1519 1489.7941,1054.6447 1486.5686,1057.4661 \t\t\t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_18_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1424.7708,1020.4893 1421.3994,1022.3925 1412.7493,1024.287 1421.7115,1030.0098  1410.7053,1048.3256 1404.4419,1060.5845 1408.0681,1067.6655 1313.663,995.6067 1313.663,995.6023 1308.9247,991.9893  1324.3351,960.6366 1367.9246,989.1323 1367.0455,990.7146 1370.8519,990.7146 1398.3982,1006.8634 1415.5403,1014.1862  1412.9031,1015.0653 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E202B",points:"1473.0898,959.0894 1403.7694,1092.3326 1305.7643,1010.7798 1313.663,995.6067  1408.0681,1067.6655 1429.6057,1024.8101 1429.6057,1018.6564 1331.2139,961.8586 1332.2161,959.9377 1428.9464,1016.384  1437.6274,1010.6347 1464.567,960.1971 1462.9714,954.9182 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1462.9714,954.9182 1464.567,960.1971 1453.3411,959.5378 1452.462,956.0302  1461.9122,951.4062 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1464.567,960.1971 1437.6274,1010.6347 1453.3411,975.0405 1454.5586,972.834  1454.5586,970.4164 1457.1871,968.3286 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1464.567,960.1971 1457.1871,968.3286 1453.3411,964.5925 1444.5502,963.019  1453.3411,959.5378 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1461.9122,951.4062 1452.462,956.0302 1452.462,952.5095 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1461.9122,951.4062 1452.462,952.5095 1405.4308,933.8245 1402.5739,935.3629  1402.5739,931.8465 1352.2461,909.6495 1358.3997,909.6495 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#212635",points:"1457.1871,968.3286 1454.5586,970.4164 1454.5586,972.834 1453.3411,975.0405  1437.6274,1010.6347 1432.9727,1006.3492 1453.3411,964.5925 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#313442",d:"M1452.462,956.0302l0.879,3.5076l-8.7909,3.4812l8.7909,1.5735l-20.3684,41.7567l-9.3008,3.0768 l-92.0844-52.8199l-2.6813-4.0966l23.3398-42.8599l50.3278,22.197v3.5164l2.8569-1.5384l47.0312,18.685 c0,0-10.5491,3.7318-9.2305,3.512S1452.462,956.0302,1452.462,956.0302z M1436.0538,963.019l6.1536-3.1516l-4.2504-1.4813 l3.2219-4.668h-3.3669l-33.5548-15.2785h-3.6614v-2.6373l-45.8575-20.074l-3.3713,0.589l-3.8108,6.1536l8.5007-2.6373 l35.0668,15.6741l2.734,0.2945l0.879,3.0768l39.9985,17.151L1436.0538,963.019z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#292D3D",d:"M1452.462,956.0302c0,0-7.9119-0.2286-9.2305-0.0088s9.2305-3.512,9.2305-3.512V956.0302z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#464956",points:"1442.2074,959.8674 1436.0538,963.019 1434.7352,956.0302 1394.7367,938.8792  1393.8577,935.8024 1391.1237,935.5079 1356.0569,919.8338 1347.5562,922.4711 1351.3669,916.3174 1354.7383,915.7285  1400.5958,935.8024 1400.5958,938.4397 1404.2572,938.4397 1437.812,953.7182 1441.179,953.7182 1437.957,958.3862 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1437.6274,1010.6347 1428.9464,1016.384 1423.6719,1009.426 1432.9727,1006.3492 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#212635",points:"1429.6057,1018.6564 1429.6057,1024.8101 1421.7115,1030.0098 1412.7493,1024.287  1421.3994,1022.3925 1424.7708,1020.4893 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1429.6057,1024.8101 1408.0681,1067.6655 1404.4419,1060.5845 1410.7053,1048.3256  1421.7115,1030.0098 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1429.6057,1018.6564 1424.7708,1020.4893 1415.5403,1014.1862 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1429.6057,1018.6564 1415.5403,1014.1862 1398.3982,1006.8634 1370.8519,990.7146  1367.0455,990.7146 1367.9246,989.1323 1324.3351,960.6366 1327.192,959.5378 1331.2139,961.8586 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"1423.6719,1009.426 1428.9464,1016.384 1332.2161,959.9377 1329.5524,958.3862  1331.5875,956.606 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1424.7708,1020.4893 1412.9031,1015.0653 1415.5403,1014.1862 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"1328.9062,952.5095 1331.5875,956.606 1329.5524,958.3862 \t\t\t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"#68665E",points:"1415.5403,1067.6655 1472.5519,955.5997 1480.5,959.5378 1422.573,1073.2245  1415.5403,1069.7073 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"#68665E",points:"1626,1220.1118 1711.6841,1051.6852 1723.6295,1057.6039 1636.5696,1228.4666 1626,1223.1804 \t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"#68665E",points:"1929.6707,1449.1556 2060.9922,1191.0204 2079.3003,1200.0916 1945.87,1461.9603  1929.6707,1453.8585 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_22_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"99.0603,1338.67 106.7303,1343 126.4103,1347.3101 106.0203,1360.33 131.0603,1402  145.3103,1429.89 137.0603,1446 351.8403,1282.0601 351.8403,1282.05 362.6203,1273.83 327.5603,1202.5 228.3903,1267.33  230.3903,1270.9301 221.7303,1270.9301 159.0603,1307.67 120.0603,1324.33 126.0603,1326.33 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E202B",points:"-10.8697,1198.98 146.8403,1502.12 369.8103,1316.58 351.8403,1282.0601 137.0603,1446  88.0603,1348.5 88.0603,1334.5 311.9103,1205.28 309.6303,1200.91 89.5603,1329.33 69.8103,1316.25 8.5203,1201.5  12.1503,1189.49 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"12.1503,1189.49 8.5203,1201.5 34.0603,1200 36.0603,1192.02 14.5603,1181.5 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"8.5203,1201.5 69.8103,1316.25 34.0603,1235.27 31.2903,1230.25 31.2903,1224.75 25.3103,1220  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"8.5203,1201.5 25.3103,1220 34.0603,1211.5 54.0603,1207.92 34.0603,1200 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"14.5603,1181.5 36.0603,1192.02 36.0603,1184.01 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"14.5603,1181.5 36.0603,1184.01 143.0603,1141.5 149.5603,1145 149.5603,1137 264.0603,1086.5  250.0603,1086.5 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#212635",points:"25.3103,1220 31.2903,1224.75 31.2903,1230.25 34.0603,1235.27 69.8103,1316.25  80.4003,1306.5 34.0603,1211.5 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#313442",d:"M36.0603,1192.02l-2,7.98l20,7.92l-20,3.58l46.34,95l21.16,7l209.5-120.17l6.1-9.3199l-53.1-97.51 l-114.5,50.5v8l-6.5-3.5l-107,42.51c0,0,24,8.49,21,7.99S36.0603,1192.02,36.0603,1192.02z M73.3903,1207.92l-14-7.17 l9.67-3.37l-7.33-10.62h7.66l76.34-34.76h8.33v-6l104.33-45.67l7.67,1.3401l8.67,14l-19.34-6l-79.78,35.6599l-6.22,0.67l-2,7 l-91,39.02L73.3903,1207.92z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#292D3D",d:"M36.0603,1192.02c0,0,18-0.52,21-0.02s-21-7.99-21-7.99V1192.02z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#464956",points:"59.3903,1200.75 73.3903,1207.92 76.3903,1192.02 167.3903,1153 169.3903,1146  175.6103,1145.33 255.3903,1109.67 274.7303,1115.67 266.0603,1101.67 258.3903,1100.33 154.0603,1146 154.0603,1152  145.7303,1152 69.3903,1186.76 61.7303,1186.76 69.0603,1197.38 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"69.8103,1316.25 89.5603,1329.33 101.5603,1313.5 80.4003,1306.5 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#212635",points:"88.0603,1334.5 88.0603,1348.5 106.0203,1360.33 126.4103,1347.3101 106.7303,1343  99.0603,1338.67 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"88.0603,1348.5 137.0603,1446 145.3103,1429.89 131.0603,1402 106.0203,1360.33 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"88.0603,1334.5 99.0603,1338.67 120.0603,1324.33 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"88.0603,1334.5 120.0603,1324.33 159.0603,1307.67 221.7303,1270.9301 230.3903,1270.9301  228.3903,1267.33 327.5603,1202.5 321.0603,1200 311.9103,1205.28 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"101.5603,1313.5 89.5603,1329.33 309.6303,1200.91 315.6903,1197.38 311.0603,1193.33 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"99.0603,1338.67 126.0603,1326.33 120.0603,1324.33 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"317.1603,1184.01 311.0603,1193.33 315.6903,1197.38 \t\t\t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_21_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"415.5747,1155.897 420.918,1158.9135 434.6283,1161.916 420.4234,1170.9866  437.8677,1200.0164 447.7951,1219.446 442.0477,1230.6693 591.6759,1116.4591 591.6759,1116.4521 599.1859,1110.7256  574.761,1061.033 505.6735,1106.1974 507.0668,1108.7053 501.0337,1108.7053 457.3741,1134.3005 430.2045,1145.9069  434.3844,1147.3002 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E202B",points:"338.991,1058.5808 448.861,1269.7657 604.1949,1140.5078 591.6759,1116.4591  442.0477,1230.6693 407.9114,1162.7451 407.9114,1152.9918 563.8583,1062.9697 562.27,1059.9253 408.9564,1149.3901  395.1974,1140.2778 352.4992,1060.3363 355.0281,1051.9695 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"355.0281,1051.9695 352.4992,1060.3363 370.2919,1059.2914 371.6852,1053.7321  356.7071,1046.4032 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"352.4992,1060.3363 395.1974,1140.2778 370.2919,1083.8625 368.3622,1080.3652  368.3622,1076.5337 364.1961,1073.2245 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"352.4992,1060.3363 364.1961,1073.2245 370.2919,1067.303 384.225,1064.8088  370.2919,1059.2914 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"356.7071,1046.4032 371.6852,1053.7321 371.6852,1048.1519 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"356.7071,1046.4032 371.6852,1048.1519 446.2276,1018.5369 450.7559,1020.9752  450.7559,1015.4019 530.5233,980.2206 520.77,980.2206 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#212635",points:"364.1961,1073.2245 368.3622,1076.5337 368.3622,1080.3652 370.2919,1083.8625  395.1974,1140.2778 402.575,1133.4855 370.2919,1067.303 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#313442",d:"M371.6852,1053.7321l-1.3933,5.5593l13.9331,5.5175l-13.9331,2.4941l32.2831,66.1825l14.7413,4.8766 l145.9499-83.7174l4.2496-6.4928l-36.9926-67.9312l-79.7674,35.1813v5.5732l-4.5283-2.4383l-74.5424,29.6151 c0,0,16.7198,5.9146,14.6298,5.5663C384.225,1053.3698,371.6852,1053.7321,371.6852,1053.7321z M397.6914,1064.8088 l-9.7532-4.995l6.7367-2.3478l-5.1065-7.3984h5.3364l53.1829-24.2158h5.8032v-4.18l72.6823-31.8163l5.3434,0.9335l6.04,9.7532 l-13.4734-4.1799l-55.5794,24.8428l-4.3332,0.4667l-1.3933,4.8766l-63.3959,27.1836L397.6914,1064.8088z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#292D3D",d:"M371.6852,1053.7321c0,0,12.5398-0.3623,14.6298-0.0139c2.09,0.3483-14.6298-5.5663-14.6298-5.5663 V1053.7321z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#464956",points:"387.9382,1059.8138 397.6914,1064.8088 399.7814,1053.7321 463.1773,1026.5485  464.5706,1021.6718 468.9038,1021.2051 524.4832,996.3622 537.9566,1000.5422 531.9166,990.7889 526.5732,989.8555  453.8909,1021.6718 453.8909,1025.8518 448.0877,1025.8518 394.9048,1050.0676 389.5684,1050.0676 394.6749,1057.4661 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"395.1974,1140.2778 408.9564,1149.3901 417.3163,1138.3621 402.575,1133.4855 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#212635",points:"407.9114,1152.9918 407.9114,1162.7451 420.4234,1170.9866 434.6283,1161.916  420.918,1158.9135 415.5747,1155.897 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"407.9114,1162.7451 442.0477,1230.6693 447.7951,1219.446 437.8677,1200.0164  420.4234,1170.9866 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"407.9114,1152.9918 415.5747,1155.897 430.2045,1145.9069 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"407.9114,1152.9918 430.2045,1145.9069 457.3741,1134.3005 501.0337,1108.7053  507.0668,1108.7053 505.6735,1106.1974 574.761,1061.033 570.2328,1059.2914 563.8583,1062.9697 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"417.3163,1138.3621 408.9564,1149.3901 562.27,1059.9253 566.4917,1057.4661  563.2662,1054.6447 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"415.5747,1155.897 434.3844,1147.3002 430.2045,1145.9069 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"567.5158,1048.1519 563.2662,1054.6447 566.4917,1057.4661 \t\t\t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_20_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"628.2896,1020.4893 631.6609,1022.3925 640.3111,1024.287 631.3488,1030.0098  642.355,1048.3256 648.6185,1060.5845 644.9922,1067.6655 739.3974,995.6067 739.3974,995.6023 744.1357,991.9893  728.7253,960.6366 685.1357,989.1323 686.0148,990.7146 682.2084,990.7146 654.6622,1006.8634 637.52,1014.1862  640.1572,1015.0653 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E202B",points:"579.9705,959.0894 649.291,1092.3326 747.296,1010.7798 739.3974,995.6067 644.9922,1067.6655  623.4546,1024.8101 623.4546,1018.6564 721.8464,961.8586 720.8442,959.9377 624.1139,1016.384 615.4329,1010.6347  588.4933,960.1971 590.0888,954.9182 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"590.0888,954.9182 588.4933,960.1971 599.7192,959.5378 600.5983,956.0302 591.1481,951.4062  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"588.4933,960.1971 615.4329,1010.6347 599.7192,975.0405 598.5017,972.834 598.5017,970.4164  595.8732,968.3286 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"588.4933,960.1971 595.8732,968.3286 599.7192,964.5925 608.5101,963.019 599.7192,959.5378  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"591.1481,951.4062 600.5983,956.0302 600.5983,952.5095 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"591.1481,951.4062 600.5983,952.5095 647.6295,933.8245 650.4865,935.3629 650.4865,931.8465  700.8143,909.6495 694.6606,909.6495 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#212635",points:"595.8732,968.3286 598.5017,970.4164 598.5017,972.834 599.7192,975.0405 615.4329,1010.6347  620.0876,1006.3492 599.7192,964.5925 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#313442",d:"M600.5983,956.0302l-0.8791,3.5076l8.7908,3.4812l-8.7908,1.5735l20.3684,41.7567l9.3008,3.0768 l92.0844-52.8199l2.6812-4.0966l-23.3398-42.8599l-50.3278,22.197v3.5164l-2.8571-1.5384l-47.0311,18.685 c0,0,10.549,3.7318,9.2304,3.512C608.5101,955.8016,600.5983,956.0302,600.5983,956.0302z M617.0065,963.019l-6.1536-3.1516 l4.2504-1.4813l-3.2219-4.668h3.3669l33.5547-15.2785h3.6614v-2.6373l45.8575-20.074l3.3713,0.589l3.8109,6.1536 l-8.5008-2.6373l-35.0668,15.6741l-2.734,0.2945l-0.8791,3.0768l-39.9984,17.151L617.0065,963.019z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#292D3D",d:"M600.5983,952.5095v3.5208c0,0,7.9117-0.2286,9.2304-0.0088 C611.1473,956.2412,600.5983,952.5095,600.5983,952.5095z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#464956",points:"610.8528,959.8674 617.0065,963.019 618.3251,956.0302 658.3235,938.8792 659.2026,935.8024  661.9366,935.5079 697.0034,919.8338 705.5042,922.4711 701.6934,916.3174 698.322,915.7285 652.4645,935.8024  652.4645,938.4397 648.803,938.4397 615.2483,953.7182 611.8814,953.7182 615.1033,958.3862 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"615.4329,1010.6347 624.1139,1016.384 629.3884,1009.426 620.0876,1006.3492 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#212635",points:"623.4546,1018.6564 623.4546,1024.8101 631.3488,1030.0098 640.3111,1024.287  631.6609,1022.3925 628.2896,1020.4893 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"623.4546,1024.8101 644.9922,1067.6655 648.6185,1060.5845 642.355,1048.3256  631.3488,1030.0098 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"623.4546,1018.6564 628.2896,1020.4893 637.52,1014.1862 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"623.4546,1018.6564 637.52,1014.1862 654.6622,1006.8634 682.2084,990.7146 686.0148,990.7146  685.1357,989.1323 728.7253,960.6366 725.8682,959.5378 721.8464,961.8586 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#292D3D",points:"629.3884,1009.426 624.1139,1016.384 720.8442,959.9377 723.5079,958.3862 721.4728,956.606  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"628.2896,1020.4893 640.1572,1015.0653 637.52,1014.1862 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#313442",points:"724.1541,952.5095 721.4728,956.606 723.5079,958.3862 \t\t\t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"#68665E",points:"637.52,1067.6655 580.5085,955.5997 572.5603,959.5378 630.4873,1073.2245 637.52,1069.7073 \t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"#68665E",points:"427.0603,1220.1118 341.3763,1051.6852 329.4308,1057.6039 416.4907,1228.4666  427.0603,1223.1804 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"#68665E",points:"123.3896,1449.1556 -7.932,1191.0204 -26.24,1200.0916 107.1904,1461.9603 123.3896,1453.8585 \t\t "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"table_1_",fill:"#5B361D",points:"2048,1534.5343 -3.4601,1534.5343 795.3208,940 1251.1881,940 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"papers"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4F2F19",points:"1525.3301,1517.0056 1972.6636,1517.0056 1609.2998,1235.2655 1332.7637,1235.2655 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4F2F19",points:"1247.3134,958.651 1140.7306,955.5997 1161.4777,1029.8362 1302.6635,1034.0168 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4F2F19",points:"917.9912,957.2556 809.9912,957.2556 716.1054,1034.0168 870.6398,1034.0168 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4F2F19",points:"836.3116,1057.0056 667.8409,1057.0056 522.4241,1184.0056 767.8853,1184.0056 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_10_copy"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4F4D3B",points:"1529.3333,1510 1976.6667,1510 1613.303,1228.26 1336.7668,1228.26 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4F4D3B",points:"1251.3165,951.6454 1144.7338,948.5941 1165.4808,1022.8306 1306.6666,1027.0112 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4F4D3B",points:"913.988,950.25 805.988,950.25 712.1022,1027.0112 866.6367,1027.0112 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4F4D3B",points:"832.3085,1050 663.8377,1050 518.421,1177 763.8821,1177 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2D271A",points:"1529.3333,1510 1620.5,1510 1394,1228.26 1336.7668,1228.26 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2D271A",points:"1172.6189,949.3923 1144.7338,948.5941 1165.4808,1022.8306 1200.5039,1023.8676 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2D271A",points:"913.988,950.25 888.25,950.25 829.25,1027.0112 866.6367,1027.0112 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{display:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#4F2F19",points:"175.2114,1517.0056 630.5512,1517.0056 787.2007,1235.2655 510.6646,1235.2655  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#4F4D3B",points:"179.2146,1510 626.548,1510 783.1974,1228.26 506.6614,1228.26 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#2D271A",points:"549.5,1510 626.548,1510 783.1974,1228.26 730.5,1228.26 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{display:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#4F2F19",points:"1379.3956,1057.0056 1210.9249,1057.0056 1297.7281,1184.0056  1543.1892,1184.0056 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#4F4D3B",points:"1383.3988,1050 1214.9281,1050 1301.7313,1177 1547.1924,1177 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#2D271A",points:"1255.75,1050 1214.9281,1050 1301.7313,1177 1354.5,1177 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2D271A",points:"832.3085,1050 799.4167,1050 713.5,1177 763.8821,1177 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_11"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A7968",points:"1468.5,1282.5 1662.6334,1301.7012 1666.5,1380 1455.5,1358.5 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#939283",points:"1186.3221,961.2542 1192.5303,987.6136 1264,984.5486 1252.038,959.5378 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#72705F",points:"475.6844,1309.11 461.7638,1381.8652 209.0906,1381.8652 275.9554,1309.2279 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7A7968",points:"512.1934,1336.1633 451.2576,1415.4849 192.806,1415.4849 288.9374,1336.1633 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_6_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#9B8A35",points:"1547.1879,1248.532 1567.5063,1270.9294 1580.3229,1270.2706 1558.4395,1247.9537 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C1A73A",points:"1558.4395,1247.9537 1580.3229,1270.2706 1603.8521,1258.551 1576.7146,1235.0703 \t\t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_12_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#9B8A35",points:"1747.2489,1410.7583 1731.9955,1379.9963 1706.4539,1388.2869 1737.3018,1412.5419 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C1A73A",points:"1747.2489,1410.7583 1781.1227,1388.8317 1746.0024,1364.6658 1731.9955,1379.9963 \t\t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_8_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#9B8A35",points:"825.42,995.59 805.12,1005.17 801.33,1002.64 817.95,990.37 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C1A73A",points:"812.5,976.88 817.95,990.37 801.33,1002.64 792.62,985.88 \t\t\t\t"})))))));}}]);return LevelBrenda;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LevelBrenda);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LevelBoss=function(_Component){_inherits(LevelBoss,_Component);function LevelBoss(){_classCallCheck(this,LevelBoss);return _possibleConstructorReturn(this,(LevelBoss.__proto__||Object.getPrototypeOf(LevelBoss)).apply(this,arguments));}_createClass(LevelBoss,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"levelBoss"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"Layer_1",x:"0px",y:"0px",viewBox:"0 0 792 540",enableBackground:"new 0 0 792 540",preserveAspectRatio:"xMidYMid slice"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#142530",width:"792",height:"540"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"lightning"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"lightning1",fill:"#9A7200",d:"M224.8,171.98l-8.566-1.746l-5.59-6.077l1.389-8.655l-13.531-13.804l-16.942-8.375l-16.45-20.379 l6.711-17.842l8.348,3.11l9.167,12.604l-7.857-14.077l-9.003-3.601l4.174-12.522l-22.998-19.724l6.438-25.644L195.551,0h-10.642 l-29.828,30.527l-7.105,31.128l10.397,8.784l0.32,13.218l6.456,17.839l-4.294,12.102l0.981,1.636l-20.462,17.843l-20.788-0.655 l-18.169,16.041l1.964,14.895l-0.327-13.913l16.942-14.814l21.688,0.245l20.79-18.007l14.403,17.597l-13.34,20.461l-21.116,11.54 l-7.185,20.318l6.379,14.084l0.427,6.486l-16.429,17.943l-4.039,22.06l5.476-20.74l15.38-16.545l0.816,11.535l-6.408,14.448 l5.127,6.991l-3.379-7.107l6.641-14.681l-1.282-21.089l-6.175-13.69l6.37-17.721l20.625-11.131l6.056,12.276 c0,0-0.491,3.274-0.491,3.765s1.801-3.765,1.801-3.765l-5.729-13.586l13.259-19.642l12.89,5.787l-5.033,10.418l-0.751,28.066 l-10.312,12.931l12.167-12.277l0.588-28.339l5.446-9.855l1.047,0.47l12.802,12.678l-1.072,6.364l-9.767,4.365l0.662,39.471 l-13.632,18.642l-4.272,13.982l5.593-13.438l14.44-18.859l-0.826-38.325l8.59-3.802l5.978,6.967l8.675,0.764l2.128,6.166 L224.8,171.98z M160.13,83.425l-0.126-11.607l12.061,10.19l-5.957,16.789L160.13,83.425z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{className:"lightning2",fill:"#9A7200",d:"M711.583,226.75l-27.75-24.5l-31.75,1l-31.252-27.252l1.498-2.498l-8.017-22.592L627.833,130l6.333-11.167 L636.333,102l29-11.333l1.667,11l-5.5,10.667l7.5-10.5l-2-12.667c0,0,2.5-22.667,2.667-23.167 c0.142-0.426-17.463-14.372-22.704-18.512L637.708,0h-7.624l12.499,62.5l-29.25,34.25l4.25,8l-19.375,18.375l6.375,19.125 l-13.75,5.5l-12,21.5l14-19.25l12.75-4.75l10.25,27.25l-25.125,31.125l-27.125,14.125l-2,27.5l23.5,9.75l0.75,20.25l3.25-0.5l-1-22 l-22.75-10.25l2.25-22.75l24.5-11l20.25,30l-8.75,20.75c0,0,2.75,6.5,2.75,5.75s-0.75-5.75-0.75-5.75l9.25-18.75l31.5,17l11,21.5 l2.625-0.75l-11-24.25l-32.25-17.625l-20.375-31.25l21.998-26.877L650.083,206l33.125-0.375l25.875,22.625l-0.5,21.25 L711.583,226.75z M626.667,129.167l-13.145,19.511l-3.952-11.138l21.93-17.04L626.667,129.167z M605.208,125.25l21-19.375 l-4.625-9.25l28.5-33.125l-2.528-12.971L667.833,66L665,88l-30.5,12.667l-2.333,17l-23.462,17.438L605.208,125.25z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{y:"268.667",fill:"#0E1D23",width:"792",height:"271.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_7"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_8_copy_3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"440.8,60.935 478.984,60.935 481.602,41.33 440.8,41.33 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"260.877,230.768 254.899,230.768 234.306,268.646 250.4,268.646 260.877,258.169 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M478.46,64.859H440.8v54.766h-47.978v27.307h87.505V96.315c-3.934,1.077-6.3,1.721-6.3,1.721 L478.46,64.859z M470.069,127.351c0,5.324-4.332,9.656-9.657,9.656c-5.324,0-9.656-4.332-9.656-9.656 c0-4.606,3.245-8.455,7.565-9.416V96.623c-4.32-0.96-7.565-4.809-7.565-9.414c0-5.324,4.332-9.656,9.656-9.656 c5.325,0,9.657,4.332,9.657,9.656c0,4.697-3.374,8.611-7.824,9.471v21.198C466.695,118.738,470.069,122.652,470.069,127.351z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M414.288,11.173c3.161,0,5.732-2.571,5.732-5.732c0-1.046-0.302-2.014-0.793-2.858l-10.599,2.129 c-0.031,0.242-0.074,0.48-0.074,0.73C408.555,8.602,411.127,11.173,414.288,11.173z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M293.45,255.712h-3.467c-2.311,0.74-3.999,2.882-3.999,5.435c0,3.161,2.571,5.732,5.732,5.732 c3.161,0,5.732-2.571,5.732-5.732C297.448,258.594,295.76,256.451,293.45,255.712z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M282.06,261.147c0-4.652,3.308-8.544,7.694-9.454v-85.037l-24.151,44.423h7.549v19.689h-8.35v29.026 l-8.852,8.852h29.696C283.461,266.874,282.06,264.172,282.06,261.147z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"280.271,98.469 273.505,98.469 257.418,117.745 280.271,117.745 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M398.657,30.733c5.325,0,9.657,4.332,9.657,9.657c0,5.324-4.332,9.656-9.657,9.656 c-4.652,0-8.544-3.308-9.454-7.694H315.67l2.361,2.765l-10.18,12.198h84.971V115.7h44.054V-0.962l-13.657,2.743 c0.465,1.13,0.725,2.365,0.725,3.66c0,5.324-4.332,9.656-9.656,9.656c-4.697,0-8.612-3.374-9.472-7.824h-8.945l-13.193,2.65 c-1.616,3.07-4.827,5.174-8.532,5.174c-2.338,0-4.484-0.836-6.156-2.224l-41.638,8.363c-1.326,0.686-2.826,1.08-4.419,1.08 c-0.265,0-0.527-0.013-0.787-0.035l-19.308,3.878l10.479,12.268h76.885C390.112,34.041,394.005,30.733,398.657,30.733z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M313.712,184.423c0,3.161,2.572,5.732,5.733,5.732s5.732-2.571,5.732-5.732s-2.571-5.732-5.732-5.732 C316.285,178.691,313.712,181.262,313.712,184.423z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M458.419-5.289L440.8-1.75v15.972h37.393c0.862-3.878,4.053-6.881,8.026-7.458l1.61-12.053 C487.829-5.289,458.419-5.289,458.419-5.289z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M448.131,239.347h24.605c1.564-3.073,3.22-6.327,4.953-9.731h-29.558v-13.239h36.3 c2.605-5.114,5.319-10.441,8.104-15.903c-2.086-1.408-3.598-3.607-4.095-6.166h-27.057l-42.999,43h-74.445v31.338h113.896 c0,0,3.083-6.068,8.165-16.06h-17.87v-13.239H448.131z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M478.136,18.145H440.8v19.261h41.327l1.636-12.247C480.893,23.905,478.746,21.299,478.136,18.145z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M453.23,171.225l-43,42.998h-66.291v19.161h72.82l42.999-43h28.735c0.957-4.324,4.809-7.573,9.417-7.573 c1.17,0,2.286,0.22,3.324,0.602c2.063-4.044,4.141-8.115,6.221-12.188H453.23z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M392.822,150.855v35.984h-48.883v23.46h64.666l43-42.998h57.854 c11.197-21.924,22.283-43.576,31.003-60.501h-15.749c-0.86,4.449-4.774,7.824-9.472,7.824c-5.324,0-9.656-4.332-9.656-9.656 s4.332-9.656,9.656-9.656c4.605,0,8.454,3.245,9.415,7.565h17.83c8.474-16.425,14.32-27.597,15.161-28.819 c-2.429,1.602-51.621,15.207-73.395,21.182v55.616L392.822,150.855L392.822,150.855z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M515.242,99.235c-3.161,0-5.732,2.571-5.732,5.732s2.571,5.732,5.732,5.732s5.733-2.571,5.733-5.732 S518.403,99.235,515.242,99.235z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M466.145,87.209c0-3.161-2.572-5.732-5.733-5.732s-5.732,2.571-5.732,5.732s2.571,5.732,5.732,5.732 C463.573,92.942,466.145,90.37,466.145,87.209z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M388.899,182.915V61.237h-84.322L284.194,85.66v36.008h-30.051l-17.474,20.938v7.5l73.858-21.66 l-16.349,30.073l38.576-38.575V92.543h-7.414V72.854h19.689v19.689h-8.351v29.026l-43,42.998v87.126 c4.387,0.909,7.694,4.802,7.694,9.454c0,3.025-1.401,5.727-3.585,7.499h13.037l10.477-10.477v-27.401h-7.415v-19.689h19.689 v19.689h-8.35v29.026l-8.852,8.852h23.643v-85.73L388.899,182.915L388.899,182.915z M317.532,92.543h-19.689V72.854h19.689 V92.543z M329.102,184.423c0,5.324-4.332,9.656-9.656,9.656c-5.325,0-9.657-4.332-9.657-9.656c0-4.608,3.25-8.46,7.575-9.417 v-12.064l42.999-42.998V92.543h-7.527V72.854h19.689v19.689h-8.238v29.026l-42.999,42.998v10.386 C325.733,175.817,329.102,179.73,329.102,184.423z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M497.911,186.734c-3.161,0-5.733,2.571-5.733,5.732c0,1.807,0.858,3.403,2.169,4.454 c1.674-3.283,3.369-6.607,5.078-9.958C498.939,186.828,498.438,186.734,497.911,186.734z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M557.753,73.946c-0.007-0.02-0.044,0.021-0.106,0.111C557.716,74.011,557.761,73.972,557.753,73.946z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"487.061,85.399 513.916,59.729 508.782,77.5 534.452,70.392 544.057,41.33 494.864,41.33 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"284.857,39.192 271.147,71.463 280.271,71.463 280.271,57.314 292.236,57.314 298.68,49.065 \t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"278.116,75.386 269.48,75.386 261.341,94.545 263.149,94.545 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"261.077,71.463 277.756,19.654 271.244,13.142 266.295,17.866 259.218,70.303 260.377,71.463 \t\t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"283.672,1.279 274.083,10.432 279.108,15.457 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M331.43,10.953l33.072-5.746c0.126-5.216,4.399-9.423,9.644-9.423c4.099,0,7.593,2.574,8.99,6.185 l25.658-4.458c0.845-0.59,1.79-1.043,2.803-1.339l-72.635-9.507l-12.08,17.717C329.23,5.793,330.93,8.164,331.43,10.953z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"496.018,224.83 490.609,239.402 494.41,243.99 503.045,243.99 520.408,261.352 521.003,236.259  509.575,224.83 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"494.368,247.914 490.564,252.586 485.716,252.586 479.754,268.646 520.235,268.646  520.279,266.772 501.421,247.914 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M541.605,159.647l8.644-32.682l-21.524,35.445l0.623,4.891h3.496 C533.711,163.139,537.266,159.956,541.605,159.647z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M536.563,169.272c0,1.471,0.573,2.801,1.487,3.817l2.441-9.231 C538.217,164.62,536.563,166.746,536.563,169.272z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_8_copy_2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0E1D23",d:"M792,39.562V0h-27.039v51.584h-52.258l-30.184,30.185h-18.993c-0.606-3.12-3.353-5.486-6.648-5.486 c-3.737,0-6.778,3.041-6.778,6.778s3.041,6.778,6.778,6.778c3.235,0,5.939-2.281,6.611-5.316h20.171l30.184-30.185h51.117v13.45 h-46.534l-30.185,30.183H632.36c-0.635-3.084-3.37-5.409-6.639-5.409c-3.737,0-6.778,3.041-6.778,6.78 c0,3.737,3.041,6.778,6.778,6.778c3.264,0,5.994-2.319,6.635-5.394h57.027l30.185-30.183h45.393v16.468h-34.314v25.26h-64.18 v63.121l12.007,13.762L635.75,197l-26.024-7.847c-0.535-3.207-3.309-5.666-6.666-5.666c-3.737,0-6.778,3.041-6.778,6.778 s3.041,6.778,6.778,6.778c3.168,0,5.815-2.194,6.554-5.136l47.831,16.002c0.567,3.169,3.337,5.584,6.666,5.584 c1.783,0,3.389-0.709,4.598-1.84l21.6,7.18l-9.125-10.651h15.784v13.696H594.446c-0.604-3.123-3.351-5.492-6.649-5.492 c-3.737,0-6.778,3.041-6.778,6.778s3.041,6.778,6.778,6.778c3.233,0,5.935-2.278,6.609-5.31h66.538l-32.652,44.034H792V90.729 l-8.384,6.682v-2.094c3.036-0.671,5.318-3.375,5.318-6.61c0-3.737-3.041-6.778-6.779-6.778c-3.737,0-6.778,3.041-6.778,6.778 c0,3.295,2.365,6.041,5.485,6.648v4.235l-17.856,14.122l-14.624-23.946h19.333L792,39.562z M656.878,87.085 c-2.219,0-4.024-1.805-4.024-4.024s1.805-4.024,4.024-4.024s4.025,1.805,4.025,4.024S659.098,87.085,656.878,87.085z M625.722,103.366c-2.219,0-4.024-1.805-4.024-4.024s1.805-4.025,4.024-4.025s4.025,1.806,4.025,4.025 S627.941,103.366,625.722,103.366z M603.06,194.289c-2.219,0-4.024-1.805-4.024-4.024s1.805-4.024,4.024-4.024 s4.024,1.805,4.024,4.024S605.279,194.289,603.06,194.289z M696.968,142.174l-12.299,1.851v-8.646 c3.032-0.674,5.31-3.376,5.31-6.609c0-3.737-3.041-6.778-6.778-6.778c-3.738,0-6.779,3.041-6.779,6.778 c0,3.298,2.369,6.046,5.493,6.65v9.02l-12.694,1.978v-31.392h61.426v2.717l-8.746,16.452h-24.933V142.174z M683.201,132.795 c-2.219,0-4.025-1.806-4.025-4.025s1.806-4.024,4.025-4.024s4.024,1.805,4.024,4.024 C687.225,130.989,685.42,132.795,683.201,132.795z M754.577,197.878l-22.824,15.182h-9.526c-0.604-3.123-3.351-5.492-6.649-5.492 c-3.737,0-6.778,3.041-6.778,6.778s3.041,6.778,6.778,6.778c3.233,0,5.935-2.278,6.609-5.31h5.425l-17.723,11.789h-10.167 v-20.474L754.577,197.878z M719.603,214.346c0,2.219-1.806,4.024-4.025,4.024s-4.024-1.805-4.024-4.024 c0-2.219,1.805-4.024,4.024-4.024S719.603,212.127,719.603,214.346z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0E1D23",d:"M171.028,181.982l2.7,3.26h29.786v-9.293h-29.786l-2.67,3.28h-4.951l-1.75-1.75v-19.995h-12.351 l1.431-3.45l-11.338-18.519h6.357v-8.067h11.609c0.604,3.123,3.351,5.492,6.648,5.492c3.737,0,6.778-3.041,6.778-6.778 c0-3.738-3.041-6.779-6.778-6.779c-3.232,0-5.934,2.278-6.608,5.311h-11.649v-15.65l3.23-2.675v-29.79h-9.293v29.786l3.309,2.694 v15.631h-11.845v-22.175h-25.418v-61.03c3.079-0.638,5.401-3.371,5.401-6.636c0-3.737-3.041-6.778-6.778-6.778 s-6.778,3.041-6.778,6.778c0,3.266,2.322,5.998,5.401,6.636v61.03H89.056v-7.199c3.036-0.671,5.318-3.375,5.318-6.61 c0-3.737-3.041-6.778-6.779-6.778c-3.737,0-6.778,3.041-6.778,6.778c0,3.295,2.365,6.041,5.485,6.648v7.162H73.155V21.667 L55.149,51.584H43.092l-7.667-31.106L13.75,16.917l19.563,34.667H19.228L0,69.5v199.167h190.837l-47.418-27.911h36.066v5.782 h13.821v-13.821h-13.821v5.284h-40.004l-24.264-16.627h35.128v5.862h14.012v-29.051h6.738l2.634,3.18h29.786v-9.293h-29.786 l-2.735,3.359h-6.637v-13.45h6.671V181.982z M166.712,122.135c2.219,0,4.024,1.805,4.024,4.025s-1.805,4.024-4.024,4.024 s-4.024-1.805-4.024-4.024S164.493,122.135,166.712,122.135z M103.036,34.85c0-2.219,1.805-4.024,4.024-4.024 s4.024,1.805,4.024,4.024c0,1.792-1.185,3.296-2.807,3.815h-2.434C104.221,38.146,103.036,36.642,103.036,34.85z M83.571,88.707 c0-2.219,1.805-4.024,4.024-4.024s4.025,1.805,4.025,4.024s-1.806,4.024-4.025,4.024S83.571,90.926,83.571,88.707z M64.428,128.413l23.143-23.143h15.486l-10.053,10.053c-1.145-2.119-3.364-3.574-5.937-3.574c-3.737,0-6.778,3.041-6.778,6.778 c0,2.57,1.438,4.81,3.551,5.959L70.1,138.052L64.428,128.413z M78.252,139.064v-5.095l8.671-8.67 c0.048,0.001,0.095,0.007,0.144,0.007c3.297,0,6.045-2.368,6.649-5.492h14.88c0.604,3.123,3.351,5.492,6.649,5.492 c3.737,0,6.778-3.041,6.778-6.778s-3.041-6.778-6.778-6.778c-3.233,0-5.935,2.278-6.609,5.31H95.162l11.79-11.789h24.149v20.503 l-0.231,6.985L78.252,139.064z M111.22,118.528c0-2.219,1.806-4.024,4.025-4.024s4.024,1.805,4.024,4.024 s-1.805,4.024-4.024,4.024S111.22,120.747,111.22,118.528z M130.24,151.798l-0.445,13.449h-14.199L79.75,156.75L130.24,151.798z M161.602,213.416h-11.257v4.433h-20.006l-2.337-2.338l14.195-34.372l3.958,3.958v12.398c-3.032,0.674-5.31,3.376-5.31,6.609 c0,3.737,3.041,6.778,6.778,6.778c3.738,0,6.779-3.041,6.779-6.778c0-3.298-2.369-6.046-5.492-6.65v-9.603l10.334,10.334h2.36 v15.231H161.602z M161.602,195.431h-1.219l-11.475-11.475v-1.382c3.124-0.604,5.492-3.351,5.492-6.648 c0-3.737-3.041-6.778-6.779-6.778c-0.156,0-0.31,0.013-0.463,0.023l1.465-3.532l12.979,12.979V195.431z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_16",opacity:"0.51"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#BB200F",cx:"505.386",cy:"130.328",r:"2.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#BB200F",cx:"625.731",cy:"99.46",r:"1.992"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#BB200F",cx:"715.431",cy:"214.285",r:"1.992"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#BB200F",cx:"587.889",cy:"223.16",r:"1.992"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#BB200F",cx:"587.889",cy:"238.023",r:"1.992"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#BB200F",cx:"587.889",cy:"252.887",r:"1.992"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#BB200F",d:"M87.5,90.68c-1.1,0-1.992-0.892-1.992-1.992s0.892-1.992,1.992-1.992s1.992,0.892,1.992,1.992 S88.6,90.68,87.5,90.68z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#BB200F",cx:"147.642",cy:"203.967",r:"1.992"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#BB200F",cx:"181.555",cy:"126.107",r:"1.992"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#BB200F",cx:"166.692",cy:"126.107",r:"1.992"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#7FF3E2",cx:"14.75",cy:"168.5",r:"1.992"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#7FF3E2",cx:"25.964",cy:"168.5",r:"1.992"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#7FF3E2",cx:"37.178",cy:"168.5",r:"1.992"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#7FF3E2",cx:"48.392",cy:"168.5",r:"1.992"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#7FF3E2",cx:"407.084",cy:"75.972",r:"1.992"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"smoke"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"bgClouds"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.3827 -0.9239 0.9239 0.3827 99.0094 321.1707)",fill:"#424449",cx:"289.84",cy:"86.496",rx:"9.833",ry:"9.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#424449",cx:"264.167",cy:"55.167",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#424449",cx:"564.829",cy:"16.171",rx:"8.167",ry:"8.167"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#424449",d:"M588.333,31c-2.025,0-3.667,1.642-3.667,3.667s1.642,3.667,3.667,3.667c2.025,0,3.667-1.642,3.667-3.667 S590.358,31,588.333,31z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#424449",d:"M531.96,5c-5.166,0-9.69,2.701-12.27,6.761C515.648,6.269,509.922,2.096,503.273,0H292.218 C291.439,1.933,291,4.039,291,6.25c0,4.159,1.525,7.956,4.034,10.885c-1.367,0.427-2.679,0.974-3.934,1.618 c-0.683-0.412-1.409-0.758-2.172-1.031c0.042-0.291,0.071-0.586,0.071-0.888c0-3.406-2.761-6.167-6.167-6.167 s-6.167,2.761-6.167,6.167c0,0.997,0.242,1.936,0.662,2.769c-2.835,2.227-4.662,5.679-4.662,9.564 c0,4.003,1.942,7.544,4.926,9.761c-0.056,0.684-0.092,1.374-0.092,2.073c0,13.807,11.193,25,25,25 c9.954,0,18.547-5.818,22.57-14.238C330.692,55.086,337.246,57,344.25,57c10.68,0,20.316-4.442,27.183-11.57 c6.462,6.33,15.307,10.237,25.067,10.237c9.772,0,18.626-3.916,25.09-10.259c0.996,0.827,2.066,1.567,3.195,2.217 C422.995,52.067,422,56.916,422,62c0,21.263,17.237,38.5,38.5,38.5c20.917,0,37.925-16.684,38.474-37.468 c10.697-1.815,19.611-8.854,24.03-18.404c1.143,0.608,2.445,0.955,3.829,0.955c4.51,0,8.167-3.656,8.167-8.167 c0-1.264-0.296-2.456-0.808-3.525C541.16,32.816,546.5,26.81,546.5,19.54C546.5,11.51,539.99,5,531.96,5z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_38"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7C746A",d:"M346.5,14.5c-0.733,0-1.44,0.105-2.117,0.284C341.99,11.582,338.18,9.5,333.875,9.5 c-3.323,0-6.348,1.245-8.66,3.28c-1.267-2.112-3.572-3.53-6.215-3.53c-4.004,0-7.25,3.246-7.25,7.25s3.246,7.25,7.25,7.25 c0.621,0,1.22-0.086,1.795-0.233c0.46,6.831,6.132,12.233,13.08,12.233c4.211,0,7.949-1.991,10.351-5.075 C344.949,30.882,345.71,31,346.5,31c4.556,0,8.25-3.694,8.25-8.25S351.056,14.5,346.5,14.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#7C746A",cx:"303.125",cy:"42.125",r:"8.375"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"baseCloud",fill:"#7C746A",d:"M499.833,11.333c-2.446,0-4.586,1.289-5.793,3.221c-0.434-0.35-0.889-0.674-1.358-0.978 c1.224-1.209,1.985-2.887,1.985-4.743c0-3.682-2.985-6.667-6.667-6.667c-2.326,0-4.372,1.193-5.564,2.999 c-1.602-2.239-3.782-4.033-6.323-5.166h-41.008c-0.002,0.003-0.005-0.003-0.008,0c-0.002-0.003-0.005,0.003-0.007,0h-15.178 c-0.014,0.016-0.03-0.016-0.044,0c-0.033-0.016-0.068,0.016-0.102,0h-17.279c-0.077,0.037-0.156-0.038-0.232,0 c-0.02-0.038-0.046,0.037-0.067,0h-42.852c-1.327,2.411-2.086,5.178-2.086,8.125c0,9.32,7.555,16.875,16.875,16.875 c0.266,0,0.525-0.028,0.787-0.04C373.704,27.03,373,29.43,373,32c0,7.732,6.268,14,14,14c6.778,0,12.429-4.817,13.721-11.214 c3.029,1.868,6.584,2.964,10.404,2.964c3.611,0,6.986-0.978,9.904-2.661C420.375,36.941,420,38.924,420,41 c0,9.803,7.947,17.75,17.75,17.75c5.941,0,11.186-2.929,14.408-7.41c1.724,0.967,3.637,1.628,5.667,1.941 c-0.367,1.177-0.565,2.428-0.565,3.725c0,6.904,5.596,12.5,12.5,12.5s12.5-5.596,12.5-12.5c0-5.13-3.094-9.534-7.515-11.46 c0.834-1.331,1.489-2.782,1.929-4.328c2.197,1.135,4.684,1.787,7.328,1.787c8.837,0,16-7.163,16-16 c0-0.681-0.057-1.348-0.139-2.007c3.76-0.016,6.804-3.068,6.804-6.832C506.667,14.393,503.607,11.333,499.833,11.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{id:"cloud6",fill:"#7C746A",cx:"469.429",cy:"57.176",r:"12.33"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{id:"cloud5_1_",fill:"#7C746A",cx:"462.775",cy:"44.016",r:"16.209"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{id:"cloud4",fill:"#7C746A",cx:"499.039",cy:"18.145",r:"7.767"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{id:"cloud3",fill:"#7C746A",cx:"487.829",cy:"9.25",r:"7.767"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{id:"cloud2",fill:"#7C746A",cx:"437.241",cy:"39.125",r:"18.109"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{id:"cloud1",fill:"#7C746A",cx:"481.759",cy:"24.333",r:"18.109"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"sparks",display:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"sparks2",display:"inline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D84D23",points:"501.866,19.845 500.028,22.218 500.884,22.488 502.722,20.115 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E5772E",points:"478.833,34.333 479.333,36.5 483.167,36.167 483.333,35 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E5772E",points:"514.333,35.833 509,38.833 509.167,40.333 517,37.833 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D84D23",d:"M495.375,26.625l-0.25,3.875c0,0,1.25,0.125,1.25-0.25s0.25-4,0.25-4L495.375,26.625z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D84D23",points:"485.667,19 486,26.25 487.417,25.083 489.333,18.25 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D84D23",points:"507.167,46.5 511.583,48.75 511.833,46.917 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D84D23",points:"503.417,29.583 502,32.083 502.583,32.583 505.167,30.25 \t\t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"sparks1",display:"inline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E5772E",points:"482.062,40.265 479.363,46.293 480.434,46.129 483.621,41.597 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E5772E",points:"474.329,48.022 474.497,54.138 475.902,54.69 477.342,46.595 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D84D23",points:"452.917,65.083 449.667,65.083 449.417,63 454.25,63.917 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D84D23",points:"468.583,62 461.667,56.5 462.667,56 467.333,59.833 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D84D23",points:"461.095,45.479 466.293,49.353 467.19,48.895 462.432,43.665 \t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_36"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4E677F",d:"M566.735,274.016c-3.288-9.865-12.508-16.514-22.899-16.514h-23.577l3.36,14.816h20.672 c4.293,0,8.095,2.81,9.351,6.924l19.232,68.675h16.439L566.735,274.016z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M227.429,281.503c-10.391,0-19.623,6.649-22.899,16.514l-12.185,36.615h15.701l9.578-31.39 c1.256-4.113,5.046-6.924,9.351-6.924h37.787l3.36-14.816h-40.693V281.503z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_44"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#142530",d:"M249.75,346H39.5c0,0,20.5-14.667,59.5-14.667c0,0,11.5-11.333,22.833,0c0,0,7.667-9.5,18.167-9.5 S154.333,329,154.333,329s6.167-11.333,24.167-11.333S202.167,332,202.167,332s7.033-8.763,16.083-6.5 c9.5,2.375,10.083,10.833,10.083,10.833S246.667,330.667,249.75,346z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#142530",d:"M153.375,304.375l10.5,23.875c0,0,3.25-0.25,3.25-0.625s-11.375-24-11.375-24L153.375,304.375z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#142530",d:"M169.5,312.75l2.25,12.375c0,0,2.875,0.5,2.875-0.125S172,312,172,312L169.5,312.75z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#142530",d:"M136.625,311.875L135.5,328.5c0,0,3.5,0.875,3.5,0.375S139.625,317,139.625,317L136.625,311.875z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#142530",d:"M543.542,359.375H707.75c0,0-14.75-22.5-46.5-22.5c0,0-7.5-13.5-34.75-13.5s-31.25,19-31.25,19 s-16.75-12.75-33.25-12.75s-23.5,6-23.5,6L543.542,359.375z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#142530",points:"599.875,316.5 603.625,334.75 606.125,334.125 602.25,315.875 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#142530",d:"M602.25,320.875C602.875,321,621.625,329,621.625,329l1.625-1L602,318.625L602.25,320.875z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#142530",points:"622.375,314.125 624.625,328.625 627.75,328.625 624.375,314 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#142530",points:"666.375,317.375 649.125,334.375 650,335.375 667,319.75 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#142530",d:"M652.875,339.25c0.75-0.375,16.25-9.75,16.25-9.75L666,326l-15,11.25L652.875,339.25z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4E677F",d:"M267.907,236.206c-9.734,0-18.272,6.457-20.938,15.82L215.061,367H231.5l27.725-110.035 c1.112-4.317,5.01-7.33,9.459-7.33h6.685l3.049-13.429H267.907z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_45"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#19313F",d:"M263.5,382.75h-167L85.833,362.5l3.5-1.667L94.167,369c0,0,4.5-14.5,26.5-14.5s30.458,5.125,30.458,5.125 s6.875-17.5,26.25-17.5c16.75,0,23.25,10.75,23.25,10.75s3.208-11.042,21.042-11.042S253.5,356,253.5,356L263.5,382.75z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#616D6A",d:"M482.417,59.583L510.75,169.5h-22.625L467.75,70.25c0,0,2.25-4.875,6.688-7.812 C478.875,59.5,482.417,59.583,482.417,59.583z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M486.75,42.833L510.375,127h-24.667l3.958,19.667H537.5L499.25,32.25c0,0-4.146,0.979-7.312,3.813 C488.771,38.896,486.75,42.833,486.75,42.833z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0E1D23",points:"538.667,405.25 258.333,405.25 309.333,170 485.333,170 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_40_copy"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M373,293h46v-46h-46V293z M374,248h44v44h-44V248z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M375.084,290.916h41.832v-41.832h-41.832V290.916z M378.084,252.084h35.832v35.832h-35.832V252.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M477.976,307.474v-3.997c0-0.668-0.26-1.295-0.732-1.768l-2.99-2.991c-0.472-0.472-1.1-0.732-1.769-0.732 h-7.79c-0.238-1.346-1.411-2.375-2.824-2.375c-1.585,0-2.875,1.29-2.875,2.875s1.29,2.875,2.875,2.875 c1.414,0,2.586-1.029,2.824-2.375h7.79c0.401,0,0.777,0.156,1.061,0.439l2.991,2.991c0.279,0.279,0.439,0.666,0.439,1.061v4.021 c-1.299,0.276-2.277,1.431-2.277,2.811c0,1.585,1.29,2.875,2.875,2.875s2.875-1.29,2.875-2.875 C480.448,308.861,479.369,307.672,477.976,307.474z M461.87,300.361c-1.034,0-1.875-0.841-1.875-1.875s0.841-1.875,1.875-1.875 s1.875,0.841,1.875,1.875S462.904,300.361,461.87,300.361z M477.573,312.184c-1.034,0-1.875-0.841-1.875-1.875 s0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875S478.607,312.184,477.573,312.184z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M380.925,296.957c-1.121-1.121-2.945-1.121-4.066,0s-1.121,2.945,0,4.066c1,1,2.556,1.102,3.677,0.318 l7.788,7.788l0.707-0.707l-7.788-7.788C382.026,299.513,381.924,297.957,380.925,296.957z M377.566,300.316 c-0.731-0.731-0.731-1.921,0-2.652s1.92-0.731,2.652,0c0.731,0.731,0.731,1.921,0,2.652S378.297,301.047,377.566,300.316z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M389.612,296.957c-1.121-1.121-2.945-1.121-4.066,0s-1.121,2.945,0,4.066c1,1,2.556,1.102,3.677,0.318 l7.788,7.788l0.707-0.707l-7.788-7.788C390.714,299.513,390.612,297.957,389.612,296.957z M386.253,300.316 c-0.731-0.731-0.731-1.921,0-2.652s1.92-0.731,2.652,0c0.731,0.731,0.731,1.921,0,2.652S386.985,301.047,386.253,300.316z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M398.3,296.957c-1.121-1.121-2.945-1.121-4.066,0s-1.121,2.945,0,4.066c1,1,2.556,1.102,3.677,0.318 l7.788,7.788l0.707-0.707l-7.788-7.788C399.401,299.513,399.299,297.957,398.3,296.957z M394.941,300.316 c-0.731-0.731-0.731-1.921,0-2.652s1.92-0.731,2.652,0c0.731,0.731,0.731,1.921,0,2.652S395.672,301.047,394.941,300.316z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M364.809,261.335v-11.424c0-0.667-0.26-1.295-0.732-1.768l-12.399-12.399 c-0.472-0.472-1.1-0.732-1.768-0.732h-31.576v1h31.576c0.395,0,0.781,0.16,1.061,0.439l12.399,12.399 c0.279,0.279,0.439,0.666,0.439,1.061v11.424c-1.347,0.238-2.375,1.41-2.375,2.824c0,1.585,1.29,2.875,2.875,2.875 s2.875-1.29,2.875-2.875C367.184,262.745,366.155,261.573,364.809,261.335z M364.309,266.035c-1.034,0-1.875-0.841-1.875-1.875 s0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875S365.342,266.035,364.309,266.035z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M363.501,290.428c-1.585,0-2.875,1.29-2.875,2.875s1.29,2.875,2.875,2.875s2.875-1.29,2.875-2.875 S365.087,290.428,363.501,290.428z M363.501,295.178c-1.034,0-1.875-0.841-1.875-1.875s0.841-1.875,1.875-1.875 s1.875,0.841,1.875,1.875S364.535,295.178,363.501,295.178z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M355.689,290.428c-1.585,0-2.875,1.29-2.875,2.875s1.29,2.875,2.875,2.875s2.875-1.29,2.875-2.875 S357.274,290.428,355.689,290.428z M355.689,295.178c-1.034,0-1.875-0.841-1.875-1.875s0.841-1.875,1.875-1.875 s1.875,0.841,1.875,1.875S356.723,295.178,355.689,295.178z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M347.876,290.428c-1.585,0-2.875,1.29-2.875,2.875c0,0.8,0.33,1.524,0.86,2.046l-8.296,8.295 c-0.282,0.283-0.659,0.439-1.06,0.439H307.5v1h29.005c0.669,0,1.297-0.261,1.768-0.732l8.43-8.429 c0.359,0.162,0.755,0.257,1.174,0.257c1.585,0,2.875-1.29,2.875-2.875S349.462,290.428,347.876,290.428z M347.876,295.178 c-1.034,0-1.875-0.841-1.875-1.875s0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875S348.91,295.178,347.876,295.178z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M442.098,231.585c1.55,0,2.806-1.256,2.806-2.806s-1.256-2.806-2.806-2.806s-2.806,1.256-2.806,2.806 S440.548,231.585,442.098,231.585z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M450.681,231.585c1.55,0,2.806-1.256,2.806-2.806c0-1.378-0.996-2.519-2.306-2.755V200.5h-1v25.524 c-1.31,0.237-2.305,1.377-2.305,2.755C447.875,230.329,449.131,231.585,450.681,231.585z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M428.686,272.612h4.048c0.395,0,0.781,0.16,1.061,0.439l4.21,4.21c0.473,0.473,1.1,0.732,1.768,0.732 h33.274c0.401,0,0.777,0.155,1.061,0.438l8.698,8.699l0.707-0.707l-8.698-8.699c-0.472-0.472-1.1-0.731-1.768-0.731h-33.274 c-0.395,0-0.781-0.16-1.061-0.439l-4.21-4.21c-0.473-0.473-1.1-0.732-1.768-0.732h-4.048c-0.237-1.31-1.377-2.306-2.755-2.306 c-1.55,0-2.806,1.256-2.806,2.806s1.256,2.806,2.806,2.806C427.309,274.918,428.45,273.923,428.686,272.612z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M391.952,211.397c1.55,0,2.806-1.256,2.806-2.806c0-0.594-0.187-1.143-0.502-1.597l0.784-0.784 c0.472-0.472,0.732-1.1,0.732-1.768v-17.506h-1v17.506c0,0.401-0.156,0.777-0.439,1.061l-0.784,0.784 c-0.454-0.315-1.003-0.502-1.597-0.502c-1.55,0-2.806,1.256-2.806,2.806S390.402,211.397,391.952,211.397z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M457.926,216.397c1.585,0,2.875-1.29,2.875-2.875s-1.29-2.875-2.875-2.875s-2.875,1.29-2.875,2.875 S456.341,216.397,457.926,216.397z M457.926,211.647c1.034,0,1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875 s-1.875-0.841-1.875-1.875S456.892,211.647,457.926,211.647z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M364.441,286.088c0-1.585-1.29-2.875-2.875-2.875c-0.622,0-1.194,0.203-1.665,0.54l-7.459-7.458 c-0.283-0.283-0.439-0.66-0.439-1.061v-21.572c1.347-0.238,2.375-1.41,2.375-2.824c0-1.585-1.29-2.875-2.875-2.875 s-2.875,1.29-2.875,2.875c0,1.414,1.028,2.586,2.375,2.824v21.572c0,0.668,0.26,1.296,0.732,1.768l7.462,7.462 c-0.318,0.463-0.507,1.021-0.507,1.624c0,1.585,1.29,2.875,2.875,2.875S364.441,287.673,364.441,286.088z M349.628,250.838 c0-1.034,0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875S349.628,251.872,349.628,250.838z M359.691,286.088c0-1.034,0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875 S359.691,287.122,359.691,286.088z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M357.003,286.088c0-1.585-1.29-2.875-2.875-2.875c-0.622,0-1.194,0.203-1.665,0.54l-7.459-7.458 c-0.283-0.283-0.439-0.66-0.439-1.061v-21.572c1.347-0.238,2.375-1.41,2.375-2.824c0-1.585-1.29-2.875-2.875-2.875 s-2.875,1.29-2.875,2.875c0,1.414,1.028,2.586,2.375,2.824v21.572c0,0.668,0.26,1.296,0.732,1.768l7.462,7.462 c-0.318,0.463-0.507,1.021-0.507,1.624c0,1.585,1.29,2.875,2.875,2.875S357.003,287.673,357.003,286.088z M342.191,250.838 c0-1.034,0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875S342.191,251.872,342.191,250.838z M352.253,286.088c0-1.034,0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875 S352.253,287.122,352.253,286.088z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M339.503,250.838c0-1.585-1.29-2.875-2.875-2.875s-2.875,1.29-2.875,2.875 c0,1.414,1.028,2.586,2.375,2.824v21.572c0,0.668,0.26,1.296,0.732,1.768l7.462,7.462c-0.318,0.463-0.507,1.021-0.507,1.624 c0,1.585,1.29,2.875,2.875,2.875s2.875-1.29,2.875-2.875s-1.29-2.875-2.875-2.875c-0.622,0-1.194,0.203-1.665,0.54l-7.459-7.458 c-0.283-0.283-0.439-0.66-0.439-1.061v-21.572C338.475,253.425,339.503,252.253,339.503,250.838z M346.691,284.213 c1.034,0,1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875s-1.875-0.841-1.875-1.875S345.657,284.213,346.691,284.213z M334.753,250.838c0-1.034,0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875 S334.753,251.872,334.753,250.838z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M332.066,250.838c0-1.585-1.29-2.875-2.875-2.875s-2.875,1.29-2.875,2.875 c0,1.414,1.028,2.586,2.375,2.824v21.572c0,0.668,0.26,1.296,0.732,1.768l7.462,7.462c-0.318,0.463-0.507,1.021-0.507,1.624 c0,1.585,1.29,2.875,2.875,2.875s2.875-1.29,2.875-2.875s-1.29-2.875-2.875-2.875c-0.622,0-1.194,0.203-1.665,0.54l-7.459-7.458 c-0.283-0.283-0.439-0.66-0.439-1.061v-21.572C331.038,253.425,332.066,252.253,332.066,250.838z M339.253,284.213 c1.034,0,1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875s-1.875-0.841-1.875-1.875S338.22,284.213,339.253,284.213z M327.316,250.838c0-1.034,0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875 S327.316,251.872,327.316,250.838z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M333.043,301.413l5.617-5.617c0.417,0.236,0.891,0.381,1.403,0.381c1.585,0,2.875-1.29,2.875-2.875 s-1.29-2.875-2.875-2.875s-2.875,1.29-2.875,2.875c0,0.71,0.268,1.352,0.697,1.855l-5.55,5.549 c-0.282,0.283-0.659,0.439-1.06,0.439h-23.317v1h23.317C331.945,302.146,332.573,301.885,333.043,301.413z M340.064,291.428 c1.034,0,1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875s-1.875-0.841-1.875-1.875S339.03,291.428,340.064,291.428z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M327.689,299.101l3.253-3.253c0.394,0.204,0.835,0.33,1.309,0.33c1.585,0,2.875-1.29,2.875-2.875 s-1.29-2.875-2.875-2.875s-2.875,1.29-2.875,2.875c0,0.747,0.294,1.422,0.762,1.934l-3.157,3.157 c-0.282,0.283-0.659,0.439-1.061,0.439h-17.588v1h17.588C326.59,299.833,327.219,299.572,327.689,299.101z M332.251,291.428 c1.034,0,1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875s-1.875-0.841-1.875-1.875S331.218,291.428,332.251,291.428z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M375.535,235.71l-9.325-9.325c-2.078-2.078-4.84-3.222-7.778-3.222h-37.599c-2.209,0-4,1.791-4,4 s1.791,4,4,4h37.599c0.79,0,1.563,0.32,2.121,0.879l9.325,9.325c0.781,0.781,1.805,1.171,2.829,1.171s2.047-0.391,2.829-1.171 C377.097,239.805,377.097,237.273,375.535,235.71z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M408.138,218.018c0.283,0.284,0.439,0.66,0.439,1.061v2.882c-1.31,0.236-2.306,1.377-2.306,2.755 c0,1.55,1.256,2.806,2.806,2.806s2.806-1.256,2.806-2.806c0-1.378-0.995-2.519-2.305-2.755v-2.882 c0-0.668-0.26-1.296-0.732-1.768l-3.117-3.117c-0.279-0.279-0.439-0.666-0.439-1.061v-26.196h-1v26.196 c0,0.667,0.26,1.295,0.732,1.768L408.138,218.018z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M413.434,215.395c-0.328,0.467-0.523,1.032-0.523,1.645c0,1.585,1.29,2.875,2.875,2.875 s2.875-1.29,2.875-2.875s-1.29-2.875-2.875-2.875c-0.612,0-1.178,0.196-1.645,0.523l-5.392-5.392 c-0.283-0.283-0.439-0.66-0.439-1.061v-21.298h-1v21.298c0,0.668,0.26,1.296,0.732,1.768L413.434,215.395z M415.786,215.165 c1.034,0,1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875s-1.875-0.841-1.875-1.875S414.752,215.165,415.786,215.165z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M395.424,222.367c-1.347,0.238-2.375,1.41-2.375,2.824c0,1.585,1.29,2.875,2.875,2.875 s2.875-1.29,2.875-2.875c0-1.414-1.029-2.586-2.375-2.824v-2.601c0-0.401,0.156-0.778,0.439-1.061l0.991-0.991 c0.473-0.472,0.732-1.1,0.732-1.768v-29.008h-1v29.008c0,0.401-0.156,0.778-0.439,1.061l-0.991,0.991 c-0.472,0.472-0.732,1.1-0.732,1.768V222.367z M397.799,225.192c0,1.034-0.841,1.875-1.875,1.875s-1.875-0.841-1.875-1.875 s0.841-1.875,1.875-1.875S397.799,224.158,397.799,225.192z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M357.438,210.25v7.813c0,0.552,0.448,1,1,1s1-0.448,1-1v-7.813c0-0.552-0.448-1-1-1 S357.438,209.698,357.438,210.25z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M352.688,210.25v7.813c0,0.552,0.448,1,1,1s1-0.448,1-1v-7.813c0-0.552-0.448-1-1-1 S352.688,209.698,352.688,210.25z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M347.938,210.25v7.813c0,0.552,0.448,1,1,1s1-0.448,1-1v-7.813c0-0.552-0.448-1-1-1 S347.938,209.698,347.938,210.25z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M343.188,210.25v7.813c0,0.552,0.448,1,1,1s1-0.448,1-1v-7.813c0-0.552-0.448-1-1-1 S343.188,209.698,343.188,210.25z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M339.438,219.063c0.552,0,1-0.448,1-1v-7.813c0-0.552-0.448-1-1-1s-1,0.448-1,1v7.813 C338.438,218.615,338.885,219.063,339.438,219.063z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M334.688,219.063c0.552,0,1-0.448,1-1v-7.813c0-0.552-0.448-1-1-1s-1,0.448-1,1v7.813 C333.688,218.615,334.135,219.063,334.688,219.063z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M329.938,219.063c0.552,0,1-0.448,1-1v-7.813c0-0.552-0.448-1-1-1s-1,0.448-1,1v7.813 C328.938,218.615,329.385,219.063,329.938,219.063z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M390.232,240.638c1.585,0,2.875-1.29,2.875-2.875s-1.29-2.875-2.875-2.875 c-0.6,0-1.157,0.186-1.618,0.502l-12.696-12.696c0.328-0.467,0.523-1.032,0.523-1.645c0-1.585-1.29-2.875-2.875-2.875 s-2.875,1.29-2.875,2.875s1.29,2.875,2.875,2.875c0.612,0,1.178-0.196,1.644-0.523l12.692,12.692 c-0.34,0.472-0.545,1.046-0.545,1.671C387.357,239.348,388.647,240.638,390.232,240.638z M390.232,235.888 c1.034,0,1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875s-1.875-0.841-1.875-1.875S389.199,235.888,390.232,235.888z M371.691,221.048c0-1.034,0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875 S371.691,222.082,371.691,221.048z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M368.295,203.71l10.891,10.891c0.472,0.472,1.1,0.732,1.768,0.732h2.019 c0.331,1.223,1.439,2.13,2.765,2.13c1.585,0,2.875-1.29,2.875-2.875s-1.29-2.875-2.875-2.875c-1.498,0-2.718,1.156-2.849,2.62 h-1.934c-0.401,0-0.777-0.156-1.061-0.439l-10.891-10.891c-0.472-0.472-1.1-0.732-1.768-0.732h-27.609v1h27.609 C367.635,203.271,368.012,203.427,368.295,203.71z M385.737,212.713c1.034,0,1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875 s-1.875-0.841-1.875-1.875S384.704,212.713,385.737,212.713z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M431.339,213.279c-0.328,0.467-0.523,1.032-0.523,1.645c0,1.585,1.29,2.875,2.875,2.875 s2.875-1.29,2.875-2.875s-1.29-2.875-2.875-2.875c-0.612,0-1.178,0.196-1.645,0.523l-8.452-8.453 c-0.279-0.279-0.439-0.666-0.439-1.061v-13.601h-1v13.601c0,0.667,0.26,1.295,0.732,1.768L431.339,213.279z M433.69,213.049 c1.034,0,1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875s-1.875-0.841-1.875-1.875S432.656,213.049,433.69,213.049z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M426.825,216.33c0.283,0.284,0.439,0.66,0.439,1.061v8.632c-1.31,0.236-2.306,1.377-2.306,2.755 c0,1.55,1.256,2.806,2.806,2.806s2.806-1.256,2.806-2.806c0-1.378-0.995-2.519-2.305-2.755v-8.632 c0-0.668-0.26-1.296-0.732-1.768l-7.992-7.992c-0.279-0.279-0.439-0.666-0.439-1.061v-17.946h-1v17.946 c0,0.667,0.26,1.295,0.732,1.768L426.825,216.33z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M431.485,246.626c0.315-0.454,0.502-1.003,0.502-1.597c0-1.55-1.256-2.806-2.806-2.806 s-2.806,1.256-2.806,2.806s1.256,2.806,2.806,2.806c0.594,0,1.143-0.187,1.597-0.502l4.453,4.453 c0.472,0.472,1.1,0.732,1.768,0.732h12.424c0.668,0,1.296-0.26,1.768-0.732l16.431-16.431c0.279-0.279,0.666-0.439,1.061-0.439 h6.194v-1h-6.194c-0.668,0-1.295,0.26-1.768,0.732l-16.431,16.431c-0.283,0.283-0.66,0.439-1.061,0.439h-12.424 c-0.4,0-0.777-0.156-1.061-0.439L431.485,246.626z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M466.937,240.983l-17.829,17.83c-0.283,0.283-0.66,0.439-1.061,0.439h-13.908 c-0.4,0-0.777-0.156-1.062-0.439l-4.254-4.254c0.328-0.467,0.523-1.032,0.523-1.645c0-1.585-1.29-2.875-2.875-2.875 s-2.875,1.29-2.875,2.875s1.29,2.875,2.875,2.875c0.612,0,1.178-0.196,1.645-0.523l4.254,4.255 c0.474,0.472,1.102,0.731,1.769,0.731h13.908c0.668,0,1.296-0.26,1.768-0.732l17.829-17.83c0.284-0.283,0.661-0.439,1.062-0.439 h7.17v-1h-7.17C468.038,240.251,467.41,240.511,466.937,240.983z M426.472,254.79c-1.034,0-1.875-0.841-1.875-1.875 s0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875S427.506,254.79,426.472,254.79z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M472.484,272.034h-24.579c-0.238-1.346-1.411-2.375-2.824-2.375c-1.585,0-2.875,1.29-2.875,2.875 s1.29,2.875,2.875,2.875c1.414,0,2.586-1.029,2.824-2.375h24.579c0.395,0,0.781,0.16,1.061,0.439l8.459,8.46l0.707-0.707 l-8.459-8.46C473.779,272.294,473.152,272.034,472.484,272.034z M445.081,274.409c-1.034,0-1.875-0.841-1.875-1.875 s0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875S446.115,274.409,445.081,274.409z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M480.426,290.715c-0.395,0-0.781-0.16-1.061-0.439l-6.426-6.426c-0.473-0.473-1.1-0.732-1.768-0.732 h-25.687c-0.238-1.346-1.411-2.375-2.824-2.375c-1.585,0-2.875,1.29-2.875,2.875s1.29,2.875,2.875,2.875 c1.414,0,2.586-1.029,2.824-2.375h25.687c0.395,0,0.781,0.16,1.061,0.439l6.426,6.426c0.473,0.473,1.1,0.732,1.768,0.732h3.387 v-1H480.426z M442.66,285.492c-1.034,0-1.875-0.841-1.875-1.875s0.841-1.875,1.875-1.875s1.875,0.841,1.875,1.875 S443.694,285.492,442.66,285.492z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M431.829,285.466c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l50.353,50.353 c0.586,0.586,1.354,0.879,2.121,0.879s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L431.829,285.466z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M407.898,235.855c-0.328,0.467-0.523,1.032-0.523,1.645c0,1.585,1.29,2.875,2.875,2.875 s2.875-1.29,2.875-2.875s-1.29-2.875-2.875-2.875c-0.612,0-1.178,0.196-1.645,0.523l-6.26-6.26 c-0.283-0.284-0.439-0.66-0.439-1.061V187h-1v40.828c0,0.668,0.26,1.296,0.732,1.768L407.898,235.855z M410.25,235.625 c1.034,0,1.875,0.841,1.875,1.875s-0.841,1.875-1.875,1.875s-1.875-0.841-1.875-1.875S409.216,235.625,410.25,235.625z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M379.254,202.746c0.585,0.586,1.354,0.879,2.121,0.879s1.536-0.293,2.121-0.879 c1.172-1.171,1.172-3.071,0-4.242l-11.125-11.125c-1.171-1.172-3.071-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242 L379.254,202.746z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#082B3A",d:"M442.598,221.162c0-0.395,0.16-0.781,0.439-1.061l3.071-3.071c0.473-0.472,0.732-1.1,0.732-1.768V197.75 h-1v17.512c0,0.395-0.16,0.781-0.439,1.061l-3.071,3.071c-0.473,0.472-0.732,1.1-0.732,1.768v4.812h0.5h0.5V221.162z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_40"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M324.882,244.569H291.57v1h33.311c0.247,1.804,1.782,3.204,3.653,3.204c2.042,0,3.704-1.662,3.704-3.704 s-1.662-3.704-3.704-3.704C326.664,241.366,325.129,242.765,324.882,244.569z M331.238,245.069c0,1.491-1.213,2.704-2.704,2.704 s-2.704-1.213-2.704-2.704s1.213-2.704,2.704-2.704S331.238,243.579,331.238,245.069z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M331.8,233.823c2.042,0,3.704-1.662,3.704-3.704c0-2.042-1.662-3.704-3.704-3.704 c-1.871,0-3.406,1.399-3.653,3.204h-34.806v1h34.806C328.394,232.424,329.929,233.823,331.8,233.823z M331.8,227.416 c1.491,0,2.704,1.213,2.704,2.704s-1.213,2.704-2.704,2.704s-2.704-1.213-2.704-2.704 C329.096,228.628,330.309,227.416,331.8,227.416z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M332.587,281.731c-1.916,0-3.478,1.468-3.667,3.335h-5.549c-0.854,0-1.657,0.333-2.261,0.937 l-4.036,4.035c-0.604,0.604-0.937,1.407-0.937,2.262v10.664c-1.805,0.247-3.204,1.782-3.204,3.653 c0,2.042,1.662,3.704,3.704,3.704c2.042,0,3.704-1.662,3.704-3.704c0-1.871-1.399-3.406-3.204-3.653V292.3 c0-0.588,0.229-1.14,0.644-1.555l4.036-4.035c0.415-0.415,0.967-0.644,1.554-0.644h5.575c0.302,1.741,1.814,3.072,3.64,3.072 c2.042,0,3.704-1.661,3.704-3.703S334.629,281.731,332.587,281.731z M319.343,306.616c0,1.491-1.213,2.704-2.704,2.704 s-2.704-1.213-2.704-2.704c0-1.49,1.213-2.703,2.704-2.703C318.13,303.913,319.343,305.126,319.343,306.616z M332.587,288.139 c-1.491,0-2.704-1.213-2.704-2.703c0-1.491,1.213-2.704,2.704-2.704s2.704,1.213,2.704,2.704 C335.291,286.926,334.078,288.139,332.587,288.139z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M357.993,291.49c-2.042,0-3.704,1.662-3.704,3.704s1.662,3.704,3.704,3.704 c2.042,0,3.704-1.662,3.704-3.704S360.035,291.49,357.993,291.49z M357.993,297.898c-1.491,0-2.704-1.213-2.704-2.704 s1.213-2.704,2.704-2.704s2.704,1.213,2.704,2.704S359.483,297.898,357.993,297.898z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M302.966,275.05c2.042,0,3.704-1.662,3.704-3.704s-1.662-3.703-3.704-3.703 c-1.871,0-3.406,1.399-3.653,3.203h-15.015v1h15.015C299.56,273.65,301.096,275.05,302.966,275.05z M302.966,268.643 c1.491,0,2.704,1.212,2.704,2.703s-1.213,2.704-2.704,2.704s-2.704-1.213-2.704-2.704 C300.263,269.855,301.476,268.643,302.966,268.643z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M364.323,222.394c-2.042,0-3.704,1.662-3.704,3.704s1.662,3.704,3.704,3.704 c2.042,0,3.704-1.662,3.704-3.704S366.365,222.394,364.323,222.394z M364.323,228.801c-1.491,0-2.704-1.213-2.704-2.704 s1.213-2.704,2.704-2.704s2.704,1.213,2.704,2.704S365.813,228.801,364.323,228.801z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M364.323,211.855c-2.042,0-3.704,1.662-3.704,3.704s1.662,3.704,3.704,3.704 c2.042,0,3.704-1.662,3.704-3.704S366.365,211.855,364.323,211.855z M364.323,218.263c-1.491,0-2.704-1.213-2.704-2.704 s1.213-2.704,2.704-2.704s2.704,1.213,2.704,2.704S365.813,218.263,364.323,218.263z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M364.323,201.317c-1.095,0-2.07,0.486-2.748,1.244l-11.325-11.325c-0.409-0.409-0.644-0.976-0.644-1.554 v-39.125h-1v39.125c0,0.842,0.341,1.666,0.937,2.261l11.463,11.463c-0.24,0.49-0.387,1.034-0.387,1.615 c0,2.042,1.662,3.704,3.704,3.704c2.042,0,3.704-1.662,3.704-3.704C368.026,202.979,366.365,201.317,364.323,201.317z M364.323,207.724c-1.491,0-2.704-1.213-2.704-2.704s1.213-2.704,2.704-2.704s2.704,1.213,2.704,2.704 S365.813,207.724,364.323,207.724z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M364.323,190.779c-0.973,0-1.852,0.385-2.514,1l-7.597-7.597c-0.409-0.409-0.644-0.976-0.644-1.554 v-31.453h-1v31.453c0,0.842,0.341,1.666,0.937,2.261l7.669,7.669c-0.345,0.563-0.555,1.218-0.555,1.925 c0,2.042,1.662,3.704,3.704,3.704c2.042,0,3.704-1.662,3.704-3.704S366.365,190.779,364.323,190.779z M364.323,197.186 c-1.491,0-2.704-1.213-2.704-2.704s1.213-2.704,2.704-2.704s2.704,1.213,2.704,2.704S365.813,197.186,364.323,197.186z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M364.323,180.24c-1.023,0-1.95,0.417-2.621,1.09l-4.37-4.371c-0.415-0.415-0.644-0.967-0.644-1.554 V151.68h-1v23.725c0,0.854,0.333,1.657,0.937,2.261l4.48,4.48c-0.3,0.535-0.486,1.142-0.486,1.797 c0,2.042,1.662,3.704,3.704,3.704c2.042,0,3.704-1.662,3.704-3.704S366.365,180.24,364.323,180.24z M364.323,186.647 c-1.491,0-2.704-1.213-2.704-2.704s1.213-2.704,2.704-2.704s2.704,1.213,2.704,2.704S365.813,186.647,364.323,186.647z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M451.36,328.333c-2.09,0-3.785,1.695-3.785,3.785s1.695,3.785,3.785,3.785s3.785-1.695,3.785-3.785 C455.145,330.027,453.45,328.333,451.36,328.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M451.36,339.911c-2.09,0-3.785,1.695-3.785,3.785s1.695,3.785,3.785,3.785 c1.919,0,3.488-1.433,3.734-3.285h34.412v-1h-34.412C454.847,341.344,453.279,339.911,451.36,339.911z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M349.983,278.387c-0.864,0-1.652,0.301-2.289,0.789l-5.994-5.995c-0.604-0.604-1.408-0.937-2.261-0.937 H322.68c-0.842,0-1.666,0.342-2.261,0.937l-22.165,22.164c-0.415,0.416-0.966,0.645-1.554,0.645h-8.355v1h8.355 c0.855,0,1.658-0.333,2.261-0.938l22.164-22.164c0.409-0.409,0.976-0.644,1.554-0.644h16.758c0.587,0,1.139,0.229,1.554,0.644 l5.994,5.995c-0.488,0.637-0.789,1.424-0.789,2.289c0,2.09,1.695,3.785,3.785,3.785s3.785-1.695,3.785-3.785 C353.767,280.081,352.073,278.387,349.983,278.387z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M471.94,349.765c-2.042,0-3.704,1.661-3.704,3.703s1.662,3.704,3.704,3.704s3.703-1.662,3.703-3.704 S473.982,349.765,471.94,349.765z M471.94,356.172c-1.491,0-2.704-1.213-2.704-2.704c0-1.49,1.213-2.703,2.704-2.703 c1.49,0,2.703,1.213,2.703,2.703C474.644,354.959,473.431,356.172,471.94,356.172z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M421.604,213.617c2.042,0,3.704-1.662,3.704-3.704s-1.662-3.704-3.704-3.704 c-1.871,0-3.406,1.399-3.653,3.204h-29.255c-0.854,0-1.657,0.333-2.261,0.937l-10.177,10.177 c-0.617-0.461-1.375-0.744-2.203-0.744c-2.042,0-3.704,1.662-3.704,3.704c0,2.042,1.662,3.704,3.704,3.704 s3.704-1.662,3.704-3.704c0-0.854-0.302-1.631-0.789-2.258l10.172-10.172c0.415-0.415,0.967-0.644,1.554-0.644h29.255 C418.198,212.217,419.733,213.617,421.604,213.617z M374.054,226.19c-1.491,0-2.704-1.213-2.704-2.704s1.213-2.704,2.704-2.704 s2.704,1.213,2.704,2.704C376.758,224.978,375.545,226.19,374.054,226.19z M421.604,207.209c1.491,0,2.704,1.213,2.704,2.704 s-1.213,2.704-2.704,2.704c-1.49,0-2.703-1.213-2.703-2.704S420.113,207.209,421.604,207.209z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M374.054,217.158c2.042,0,3.704-1.662,3.704-3.704c0-0.853-0.302-1.63-0.789-2.257l10.172-10.172 c0.416-0.416,0.967-0.644,1.554-0.644h29.255c0.247,1.805,1.782,3.204,3.653,3.204c2.042,0,3.704-1.662,3.704-3.704 c0-2.042-1.662-3.704-3.704-3.704c-1.871,0-3.406,1.399-3.653,3.204h-29.255c-0.854,0-1.657,0.333-2.261,0.937l-10.177,10.177 c-0.618-0.461-1.375-0.744-2.203-0.744c-2.042,0-3.704,1.662-3.704,3.704S372.012,217.158,374.054,217.158z M421.604,197.177 c1.491,0,2.704,1.213,2.704,2.704s-1.213,2.704-2.704,2.704c-1.49,0-2.703-1.213-2.703-2.704 C418.9,198.39,420.113,197.177,421.604,197.177z M374.054,210.75c1.491,0,2.704,1.213,2.704,2.704s-1.213,2.704-2.704,2.704 s-2.704-1.213-2.704-2.704S372.563,210.75,374.054,210.75z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M374.054,207.125c2.042,0,3.704-1.662,3.704-3.704c0-0.853-0.302-1.63-0.789-2.257l10.172-10.172 c0.415-0.415,0.967-0.644,1.554-0.644h29.255c0.247,1.804,1.782,3.204,3.653,3.204c2.042,0,3.704-1.662,3.704-3.704 s-1.662-3.704-3.704-3.704c-1.871,0-3.406,1.399-3.653,3.204h-29.255c-0.854,0-1.657,0.333-2.261,0.937l-10.177,10.177 c-0.618-0.461-1.375-0.744-2.203-0.744c-2.042,0-3.704,1.662-3.704,3.704S372.012,207.125,374.054,207.125z M421.604,187.145 c1.491,0,2.704,1.213,2.704,2.704s-1.213,2.704-2.704,2.704c-1.49,0-2.703-1.213-2.703-2.704S420.113,187.145,421.604,187.145z M374.054,200.718c1.491,0,2.704,1.213,2.704,2.704s-1.213,2.704-2.704,2.704s-2.704-1.213-2.704-2.704 S372.563,200.718,374.054,200.718z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M374.054,197.093c2.042,0,3.704-1.662,3.704-3.704c0-0.854-0.302-1.631-0.789-2.258l10.172-10.172 c0.415-0.415,0.967-0.644,1.554-0.644h29.255c0.247,1.804,1.782,3.204,3.653,3.204c2.042,0,3.704-1.662,3.704-3.704 s-1.662-3.704-3.704-3.704c-1.871,0-3.406,1.399-3.653,3.204h-29.255c-0.854,0-1.657,0.333-2.261,0.937l-10.177,10.177 c-0.617-0.461-1.375-0.744-2.203-0.744c-2.042,0-3.704,1.662-3.704,3.704C370.351,195.431,372.012,197.093,374.054,197.093z M421.604,177.112c1.491,0,2.704,1.213,2.704,2.704s-1.213,2.704-2.704,2.704c-1.49,0-2.703-1.213-2.703-2.704 S420.113,177.112,421.604,177.112z M374.054,190.685c1.491,0,2.704,1.213,2.704,2.704s-1.213,2.704-2.704,2.704 s-2.704-1.213-2.704-2.704C371.351,191.898,372.563,190.685,374.054,190.685z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M441.022,241.343l12.579-12.579c2.538-2.54,3.937-5.915,3.937-9.505v-50.718c0-2.209-1.791-4-4-4 s-4,1.791-4,4v50.718c0,1.454-0.566,2.82-1.594,3.848l-12.578,12.578c-1.562,1.562-1.562,4.095,0,5.657 c0.78,0.781,1.805,1.171,2.828,1.171S440.242,242.124,441.022,241.343z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M470.203,282.227l-4.204,4.205c-0.409,0.409-0.976,0.644-1.554,0.644h-3.871 c-0.247-1.852-1.815-3.285-3.734-3.285c-2.09,0-3.785,1.695-3.785,3.785s1.695,3.785,3.785,3.785 c1.919,0,3.487-1.433,3.734-3.285h3.871c0.842,0,1.666-0.342,2.261-0.937l4.204-4.205c0.415-0.415,0.967-0.644,1.555-0.644 h35.336v-1h-35.336C471.61,281.29,470.807,281.623,470.203,282.227z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M476.81,286.304l-7.385,7.385c-0.622-0.474-1.39-0.766-2.231-0.766c-2.042,0-3.703,1.661-3.703,3.703 s1.661,3.704,3.703,3.704s3.704-1.662,3.704-3.704c0-0.841-0.292-1.608-0.766-2.23l7.384-7.384 c0.415-0.415,0.967-0.644,1.554-0.644h28.73v-1h-28.73C478.217,285.367,477.413,285.7,476.81,286.304z M467.194,299.329 c-1.49,0-2.703-1.213-2.703-2.704c0-1.49,1.213-2.703,2.703-2.703c1.491,0,2.704,1.213,2.704,2.703 C469.898,298.116,468.686,299.329,467.194,299.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M467.116,271.606l-1.338-1.337c-0.604-0.604-1.407-0.937-2.261-0.937h-3.666 c-0.247-1.804-1.783-3.204-3.654-3.204c-2.042,0-3.703,1.662-3.703,3.704c0,2.042,1.661,3.704,3.703,3.704 c1.871,0,3.406-1.399,3.654-3.203h3.666c0.587,0,1.139,0.229,1.554,0.644l1.338,1.337c0.595,0.596,1.419,0.938,2.261,0.938 h39.131v-1H468.67C468.092,272.251,467.525,272.017,467.116,271.606z M456.198,272.536c-1.49,0-2.703-1.213-2.703-2.704 s1.213-2.704,2.703-2.704c1.491,0,2.704,1.213,2.704,2.704S457.689,272.536,456.198,272.536z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M484.187,268.453c-0.587,0-1.139-0.229-1.554-0.644l-1.046-1.046c0.488-0.637,0.789-1.424,0.789-2.289 c0-2.09-1.695-3.785-3.785-3.785s-3.785,1.695-3.785,3.785s1.695,3.785,3.785,3.785c0.864,0,1.652-0.301,2.289-0.789l1.046,1.046 c0.604,0.604,1.407,0.937,2.261,0.937h23.614v-1H484.187z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M465.815,220.267h10.538c0.553,0,1-0.448,1-1s-0.447-1-1-1h-10.538c-0.553,0-1,0.448-1,1 S465.263,220.267,465.815,220.267z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M465.815,213.859h10.538c0.553,0,1-0.448,1-1s-0.447-1-1-1h-10.538c-0.553,0-1,0.448-1,1 S465.263,213.859,465.815,213.859z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M465.815,207.452h10.538c0.553,0,1-0.448,1-1s-0.447-1-1-1h-10.538c-0.553,0-1,0.448-1,1 S465.263,207.452,465.815,207.452z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M465.815,201.045h10.538c0.553,0,1-0.448,1-1s-0.447-1-1-1h-10.538c-0.553,0-1,0.448-1,1 S465.263,201.045,465.815,201.045z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M465.815,194.637h10.538c0.553,0,1-0.448,1-1s-0.447-1-1-1h-10.538c-0.553,0-1,0.448-1,1 S465.263,194.637,465.815,194.637z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M465.815,188.23h10.538c0.553,0,1-0.448,1-1s-0.447-1-1-1h-10.538c-0.553,0-1,0.448-1,1 S465.263,188.23,465.815,188.23z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M465.815,181.823h10.538c0.553,0,1-0.448,1-1s-0.447-1-1-1h-10.538c-0.553,0-1,0.448-1,1 S465.263,181.823,465.815,181.823z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M439.241,265.859c2.042,0,3.704-1.662,3.704-3.704c0-0.824-0.28-1.579-0.737-2.195l17.349-17.349 c0.622,0.474,1.389,0.766,2.23,0.766c2.042,0,3.704-1.662,3.704-3.704s-1.662-3.704-3.704-3.704s-3.703,1.662-3.703,3.704 c0,0.841,0.292,1.608,0.766,2.23l-17.343,17.343c-0.628-0.491-1.409-0.796-2.266-0.796c-2.042,0-3.703,1.662-3.703,3.704 S437.199,265.859,439.241,265.859z M461.787,236.971c1.491,0,2.704,1.213,2.704,2.704s-1.213,2.704-2.704,2.704 c-1.49,0-2.703-1.213-2.703-2.704S460.297,236.971,461.787,236.971z M439.241,259.452c1.491,0,2.704,1.213,2.704,2.704 s-1.213,2.704-2.704,2.704c-1.49,0-2.703-1.213-2.703-2.704S437.751,259.452,439.241,259.452z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M469.671,249.639v2.851c-1.642,0.379-2.873,1.846-2.873,3.602c0,2.042,1.662,3.704,3.704,3.704 s3.703-1.662,3.703-3.704c0-1.984-1.572-3.596-3.534-3.687v-2.766c0-0.587,0.229-1.139,0.644-1.554l14.691-14.691 c0.604-0.604,0.937-1.408,0.937-2.261V193.89h-1v37.243c0,0.587-0.229,1.139-0.644,1.554l-14.691,14.691 C470.004,247.982,469.671,248.785,469.671,249.639z M473.205,256.092c0,1.491-1.213,2.704-2.703,2.704 c-1.491,0-2.704-1.213-2.704-2.704s1.213-2.704,2.704-2.704C471.992,253.388,473.205,254.601,473.205,256.092z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M483.793,306.326l-11.514,11.514c-0.622-0.474-1.39-0.767-2.23-0.767c-2.042,0-3.703,1.662-3.703,3.704 s1.661,3.703,3.703,3.703s3.704-1.661,3.704-3.703c0-0.841-0.293-1.608-0.767-2.23l11.514-11.514 c0.415-0.415,0.967-0.644,1.554-0.644H504.4v-1h-18.347C485.2,305.39,484.396,305.723,483.793,306.326z M470.049,323.48 c-1.49,0-2.703-1.213-2.703-2.703c0-1.491,1.213-2.704,2.703-2.704c1.491,0,2.704,1.213,2.704,2.704 C472.753,322.268,471.54,323.48,470.049,323.48z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M479.056,300.859l-10.78,10.78c-0.409,0.409-0.976,0.644-1.554,0.644h-11.628 c-0.247-1.852-1.815-3.285-3.734-3.285c-2.09,0-3.785,1.695-3.785,3.785s1.695,3.785,3.785,3.785 c1.919,0,3.487-1.433,3.734-3.285h11.628c0.842,0,1.666-0.342,2.261-0.937l10.78-10.78c0.409-0.41,0.976-0.645,1.554-0.645 h24.208v-1h-24.208C480.475,299.922,479.65,300.264,479.056,300.859z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M298.93,287.505l24.051-24.05c0.415-0.416,0.967-0.644,1.554-0.644h18.761 c0.587,0,1.139,0.229,1.554,0.644l5.85,5.85c-0.474,0.622-0.766,1.389-0.766,2.23c0,2.042,1.662,3.704,3.704,3.704 s3.704-1.662,3.704-3.704s-1.662-3.704-3.704-3.704c-0.841,0-1.608,0.293-2.231,0.767l-5.85-5.85 c-0.604-0.604-1.407-0.937-2.261-0.937h-18.761c-0.854,0-1.658,0.333-2.261,0.937l-24.051,24.05 c-0.416,0.415-0.967,0.644-1.554,0.644h-9.672v1h9.672C297.522,288.441,298.325,288.108,298.93,287.505z M353.637,268.831 c1.491,0,2.704,1.212,2.704,2.704s-1.213,2.704-2.704,2.704s-2.704-1.213-2.704-2.704S352.146,268.831,353.637,268.831z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M337.25,239.523l5.679,5.678c0.604,0.604,1.407,0.937,2.261,0.937h5.442 c0.247,1.851,1.815,3.285,3.734,3.285c2.09,0,3.785-1.695,3.785-3.785s-1.695-3.785-3.785-3.785 c-1.919,0-3.487,1.433-3.734,3.285h-5.442c-0.587,0-1.139-0.229-1.554-0.644l-5.679-5.678c-0.604-0.604-1.407-0.937-2.261-0.937 h-44.884v1h44.884C336.274,238.879,336.841,239.114,337.25,239.523z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M347.993,214.408c0.586,0.586,1.354,0.879,2.122,0.879s1.536-0.293,2.121-0.878 c1.172-1.172,1.172-3.071,0-4.243l-20.121-20.122c-1.172-1.171-3.072-1.172-4.243,0c-1.172,1.172-1.172,3.071,0,4.243 L347.993,214.408z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M451.089,278.372c0.415-0.415,0.967-0.644,1.554-0.644h55.073v-1h-55.073 c-0.854,0-1.657,0.333-2.261,0.937l-8.556,8.555c-0.622-0.474-1.39-0.766-2.23-0.766c-2.042,0-3.704,1.661-3.704,3.703 s1.662,3.704,3.704,3.704s3.704-1.662,3.704-3.704c0-0.841-0.293-1.608-0.767-2.23L451.089,278.372z M439.596,291.861 c-1.491,0-2.704-1.213-2.704-2.704c0-1.49,1.213-2.703,2.704-2.703s2.704,1.213,2.704,2.703 C442.3,290.648,441.087,291.861,439.596,291.861z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M442.777,207.763V165.17h-1v42.593c0,0.586-0.229,1.139-0.645,1.554l-16.726,16.726 c-0.409,0.409-0.976,0.644-1.554,0.644h-15.566c-0.247-1.804-1.783-3.204-3.654-3.204c-2.042,0-3.703,1.662-3.703,3.704 s1.661,3.704,3.703,3.704c1.871,0,3.406-1.399,3.654-3.204h15.566c0.842,0,1.666-0.341,2.261-0.937l16.726-16.726 C442.444,209.419,442.777,208.616,442.777,207.763z M403.634,229.89c-1.49,0-2.703-1.213-2.703-2.704s1.213-2.704,2.703-2.704 c1.491,0,2.704,1.213,2.704,2.704S405.125,229.89,403.634,229.89z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M487.216,252.329c0.586,0.586,1.354,0.879,2.121,0.879s1.535-0.293,2.121-0.879l15.007-15.007 c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0l-15.007,15.007 C486.044,249.258,486.044,251.157,487.216,252.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1D4A68",d:"M468.039,336.697l-4.144-4.144c-0.604-0.604-1.407-0.937-2.261-0.937h-6.49v0.5v0.5h6.49 c0.587,0,1.139,0.229,1.554,0.644l4.144,4.144c0.604,0.604,1.407,0.937,2.261,0.937h23.622v-1h-23.622 C469.006,337.341,468.454,337.112,468.039,336.697z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_15_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_16_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#8192A7",d:"M492.16,135.5l62.17,269.75h-17.35l-40.05-191.28c0,0-8.79-59.97-100.31-59.97 c-91.51,0-100.29,59.97-100.29,59.97l-39.85,191.28H239.5l61.74-269.75H492.16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4E677F",d:"M496.93,213.97l40.05,191.28h-28.31l-30.13-178.98c0,0-7.17-50.34-81.9-50.34 c-74.72,0-81.89,50.34-81.89,50.34l-29.97,178.98h-28.3l39.85-191.28c0,0,8.78-59.97,100.29-59.97 C488.14,154,496.93,213.97,496.93,213.97z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#194268",d:"M478.54,226.27l30.13,178.98h-6.84L474.95,235.1c0,0-6.86-48.12-78.28-48.12S318.4,235.1,318.4,235.1 l-26.73,170.15h-6.89l29.97-178.98c0,0,7.17-50.34,81.89-50.34C471.37,175.93,478.54,226.27,478.54,226.27z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4E677F",d:"M486.51,111l5.65,24.5H301.24l5.61-24.51l0.03,0.01H486.5H486.51z M484.12,122.72 c0-1.77-1.64-3.21-3.67-3.21c-2.02,0-3.66,1.44-3.66,3.21s1.64,3.21,3.66,3.21C482.48,125.93,484.12,124.49,484.12,122.72z M470.24,122.72c0-1.77-1.65-3.21-3.67-3.21c-2.03,0-3.67,1.44-3.67,3.21s1.64,3.21,3.67,3.21 C468.59,125.93,470.24,124.49,470.24,122.72z M456.35,122.72c0-1.77-1.64-3.21-3.67-3.21c-2.02,0-3.66,1.44-3.66,3.21 s1.64,3.21,3.66,3.21C454.71,125.93,456.35,124.49,456.35,122.72z M442.47,122.72c0-1.77-1.65-3.21-3.67-3.21 c-2.03,0-3.67,1.44-3.67,3.21s1.64,3.21,3.67,3.21C440.82,125.93,442.47,124.49,442.47,122.72z M428.58,122.72 c0-1.77-1.64-3.21-3.67-3.21c-2.02,0-3.66,1.44-3.66,3.21s1.64,3.21,3.66,3.21C426.94,125.93,428.58,124.49,428.58,122.72z M414.7,122.72c0-1.77-1.65-3.21-3.67-3.21c-2.03,0-3.67,1.44-3.67,3.21s1.64,3.21,3.67,3.21 C413.05,125.93,414.7,124.49,414.7,122.72z M400.81,122.72c0-1.77-1.64-3.21-3.67-3.21c-2.02,0-3.66,1.44-3.66,3.21 s1.64,3.21,3.66,3.21C399.17,125.93,400.81,124.49,400.81,122.72z M386.92,122.72c0-1.77-1.64-3.21-3.66-3.21 c-2.03,0-3.67,1.44-3.67,3.21s1.64,3.21,3.67,3.21C385.28,125.93,386.92,124.49,386.92,122.72z M373.04,122.72 c0-1.77-1.64-3.21-3.67-3.21c-2.02,0-3.66,1.44-3.66,3.21s1.64,3.21,3.66,3.21C371.4,125.93,373.04,124.49,373.04,122.72z M359.15,122.72c0-1.77-1.64-3.21-3.66-3.21c-2.03,0-3.67,1.44-3.67,3.21s1.64,3.21,3.67,3.21 C357.51,125.93,359.15,124.49,359.15,122.72z M345.27,122.72c0-1.77-1.64-3.21-3.67-3.21c-2.02,0-3.66,1.44-3.66,3.21 s1.64,3.21,3.66,3.21C343.63,125.93,345.27,124.49,345.27,122.72z M331.38,122.72c0-1.77-1.64-3.21-3.66-3.21 c-2.03,0-3.67,1.44-3.67,3.21s1.64,3.21,3.67,3.21C329.74,125.93,331.38,124.49,331.38,122.72z M317.5,122.72 c0-1.77-1.64-3.21-3.67-3.21c-2.02,0-3.66,1.44-3.66,3.21s1.64,3.21,3.66,3.21C315.86,125.93,317.5,124.49,317.5,122.72z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#8192A7",points:"485.17,105.17 486.51,111 486.5,111 306.88,111 306.85,110.99 308.18,105.17 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7A8985",d:"M480.45,119.51c2.03,0,3.67,1.44,3.67,3.21s-1.64,3.21-3.67,3.21c-2.02,0-3.66-1.44-3.66-3.21 C476.79,120.95,478.43,119.51,480.45,119.51z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7A8985",cx:"466.57",cy:"122.72",rx:"3.67",ry:"3.21"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7A8985",d:"M452.68,119.51c2.03,0,3.67,1.44,3.67,3.21s-1.64,3.21-3.67,3.21c-2.02,0-3.66-1.44-3.66-3.21 C449.02,120.95,450.66,119.51,452.68,119.51z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7A8985",cx:"438.8",cy:"122.72",rx:"3.67",ry:"3.21"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7A8985",d:"M424.91,119.51c2.03,0,3.67,1.44,3.67,3.21s-1.64,3.21-3.67,3.21c-2.02,0-3.66-1.44-3.66-3.21 C421.25,120.95,422.89,119.51,424.91,119.51z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7A8985",cx:"411.03",cy:"122.72",rx:"3.67",ry:"3.21"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7A8985",d:"M397.14,119.51c2.03,0,3.67,1.44,3.67,3.21s-1.64,3.21-3.67,3.21c-2.02,0-3.66-1.44-3.66-3.21 C393.48,120.95,395.12,119.51,397.14,119.51z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7A8985",d:"M383.26,119.51c2.02,0,3.66,1.44,3.66,3.21s-1.64,3.21-3.66,3.21c-2.03,0-3.67-1.44-3.67-3.21 C379.59,120.95,381.23,119.51,383.26,119.51z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7A8985",d:"M369.37,119.51c2.03,0,3.67,1.44,3.67,3.21s-1.64,3.21-3.67,3.21c-2.02,0-3.66-1.44-3.66-3.21 C365.71,120.95,367.35,119.51,369.37,119.51z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7A8985",d:"M355.49,119.51c2.02,0,3.66,1.44,3.66,3.21s-1.64,3.21-3.66,3.21c-2.03,0-3.67-1.44-3.67-3.21 C351.82,120.95,353.46,119.51,355.49,119.51z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7A8985",d:"M341.6,119.51c2.03,0,3.67,1.44,3.67,3.21s-1.64,3.21-3.67,3.21c-2.02,0-3.66-1.44-3.66-3.21 C337.94,120.95,339.58,119.51,341.6,119.51z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7A8985",d:"M327.72,119.51c2.02,0,3.66,1.44,3.66,3.21s-1.64,3.21-3.66,3.21c-2.03,0-3.67-1.44-3.67-3.21 C324.05,120.95,325.69,119.51,327.72,119.51z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7A8985",d:"M313.83,119.51c2.03,0,3.67,1.44,3.67,3.21s-1.64,3.21-3.67,3.21c-2.02,0-3.66-1.44-3.66-3.21 C310.17,120.95,311.81,119.51,313.83,119.51z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{fill:"none",stroke:"#000000",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round",x1:"256.48",y1:"405.25",x2:"256.08",y2:"407.16"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{fill:"none",stroke:"#000000",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round",x1:"537.38",y1:"407.16",x2:"536.98",y2:"405.25"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"head_2_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#8192A7",d:"M436.142,30.111h-78.934l-9.626,75.06h98.186L436.142,30.111z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4E677F",d:"M396.68,67.266h-0.01c-23.772,0-39.191,19.935-41.56,37.905h83.131 C435.872,87.201,420.452,67.266,396.68,67.266z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M411.968,77.36c2.966,1.6,5.67,3.624,8.049,5.923v0.01l1.701,21.879h-8.353L411.968,77.36z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M396.68,73.421c2.653,0,5.214,0.334,7.644,0.942l-0.01,0.051l0.759,30.758h-8.393V73.421z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M429.139,96.667c1.164,2.804,1.954,5.69,2.329,8.504h-1.498L429.139,96.667z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M381.372,77.36c2.389-1.296,4.951-2.318,7.654-2.997v0.051l-0.749,30.758h-8.292L381.372,77.36z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M364.202,96.687c2.015-4.86,5.133-9.527,9.122-13.394l-1.691,21.879h-8.251L364.202,96.687z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M421.718,105.171h8.251l-0.83-8.504l-0.01-0.02c-2.015-4.85-5.123-9.497-9.112-13.354L421.718,105.171z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M404.314,74.414l0.759,30.758h8.292l-1.397-27.811c-2.379-1.296-4.941-2.318-7.644-2.997L404.314,74.414 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M389.026,74.414l-0.749,30.758h8.393v-31.75c-2.653,0-5.204,0.334-7.644,0.942V74.414z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M373.324,83.293l-1.691,21.879h8.353l1.387-27.811C378.406,78.959,375.713,80.984,373.324,83.293z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M363.382,105.171l0.82-8.484c-1.154,2.804-1.944,5.67-2.318,8.484H363.382z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7FB7CB",points:"365.674,27.221 396.669,48.135 396.681,48.113 396.681,48.135 427.676,27.221 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{display:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"302.335",y:"155.013",display:"inline",fill:"none",width:"192.667",height:"28.167"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"eyes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M428.788,49.29c-0.407-1.04-1.112-1.925-2.033-2.607l-19.204,13.058c2.511,2.834,7.844,3.551,13.07,1.507 C426.767,58.833,430.438,53.487,428.788,49.29z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M364.562,49.29c-1.65,4.197,2.009,9.542,8.167,11.958c5.214,2.045,10.559,1.327,13.07-1.507 l-19.204-13.058C365.662,47.365,364.969,48.25,364.562,49.29z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"plane"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_2_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#162E38",d:"M792,540H0l348.38-237.34h0.76h9.73h0.8h11.87h0.79h10.71h0.79h11.77h0.8h11.47h0.8h11.03h0.8h11.54h0.79 h10.34h0.79L792,540z M675.15,523h78.12L459.78,314.46h-13.97L675.15,523z M588.55,527.75h78.69l-102.4-98h-49.45L588.55,527.75z M574.47,527.75l-67.38-98h-49.22l37.94,98H574.47z M510.91,423.75h47.66l-52.33-50.08h-32.72L510.91,423.75z M502.96,423.75 l-62.65-91.13h-20.04l35.28,91.13H502.96z M471.03,370.33h31.72l-50.95-48.76h-17.18L471.03,370.33z M481.73,527.75L476.56,512 h-73.98l0.46,15.75H481.73z M472.66,500.12l-54.96-167.5h-20.42l4.95,167.5h30.99l-0.47-4.81c-10.64-0.74-18.92-5.86-18.92-12.06 c0-6.71,9.69-12.17,21.59-12.17S457,476.54,457,483.25c0,5.42-6.32,10.02-15.02,11.59l1.45,5.28H472.66z M444.59,313.34h13.63 l-14.17-10.06h-10.53L444.59,313.34z M433.64,320.26h16.79l-17.74-16.98h-11.72L433.64,320.26z M447.04,483.25 c0-3.61-5.21-6.55-11.62-6.55s-11.62,2.94-11.62,6.55s5.21,6.55,11.62,6.55C441.83,489.8,447.04,486.86,447.04,483.25z M439.02,330.75l-11.2-16.29h-14.59l6.31,16.29H439.02z M427.05,313.34l-6.92-10.06h-11.22l3.89,10.06H427.05z M417.09,330.75 l-8.23-25.06h-12.37l0.74,25.06H417.09z M408.66,305.06l-0.59-1.78h-11.65l0.05,1.78H408.66z M395.29,313.34l0.29-10.06h-11.95 l-3.29,10.06H395.29z M394.13,352.5l1.12-38.04h-15.28l-12.43,38.04H394.13z M393.32,379.81l0.71-23.98h-27.58l-22.2,67.92h47.78 l1.16-39.25h-20.44c0,0,3.11-12.52,3.79-15.17c-4.42-0.53-7.71-2.38-7.71-4.59c0-2.61,4.6-4.74,10.25-4.74s10.25,2.13,10.25,4.74 c0,2.39-3.85,4.37-8.83,4.69l-1.25,10.38H393.32z M388.96,527.75l2.89-98h-49.56l-32.04,98H388.96z M384.6,364.74 c0-1.41-2.47-2.55-5.52-2.55c-3.04,0-5.52,1.14-5.52,2.55s2.48,2.55,5.52,2.55C382.13,367.29,384.6,366.15,384.6,364.74z M372.19,330.75l10.6-27.47H371.9l-18.89,27.47H372.19z M356.92,370.33l14.55-37.71h-19.75l-25.93,37.71H356.92z M369.74,305.06 l1.33-1.78h-12.06l-1.86,1.78H369.74z M321,370.33l48.27-64.64H356.5l-67.47,64.64L321,370.33L321,370.33z M324.03,334.25 l34.15-30.97h-9.92l-43.62,30.97H324.03z M328.15,444.88l27.48-71.21H323.5L217.6,527.65h78.61l28.71-74.4h-25.98l-22.34,44.56 c6.56,1.93,11.07,5.73,11.36,10.35c0.44,7.21-9.61,13.72-22.41,14.51c-12.79,0.78-23.56-4.45-24.01-11.66 c-0.44-7.21,9.61-13.72,22.41-14.51c0.48-0.03,0.95-0.05,1.42-0.06l29.51-51.56L328.15,444.88L328.15,444.88z M284.24,370.33 l37.72-34.21H302l-48.19,34.21H284.24z M255.78,457.67l62.73-84h-32.96l-87.66,84H255.78z M225.34,423.75l55.23-50.08h-31.46 l-70.55,50.08H225.34z M265.18,516.63c6.89-0.43,12.3-3.93,12.07-7.81c-0.24-3.89-6.04-6.7-12.93-6.28 c-6.89,0.42-12.3,3.93-12.07,7.81C252.49,514.24,258.29,517.05,265.18,516.63z M203.45,527.75l46.05-61.67h-60.4l-64.36,61.67 H203.45z M141.13,500.12l77.59-70.37h-48.61l-99.12,70.37H141.13z M110.66,527.75L128.02,512H54.25l-22.18,15.75H110.66z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#194268",d:"M753.27,523h-78.12L445.81,314.46h13.97L753.27,523z M712.95,506.22c0.64-6.83-8.68-13.31-20.79-14.46 c-12.1-1.14-22.48,3.48-23.12,10.31c-0.65,6.82,8.68,13.3,20.78,14.45C701.93,517.66,712.3,513.04,712.95,506.22z M568.27,403.23 c0-0.93-1.54-1.69-3.43-1.69c-1.9,0-3.44,0.76-3.44,1.69c0,0.94,1.54,1.7,3.44,1.7C566.73,404.93,568.27,404.17,568.27,403.23z M546.74,387.48c0-0.8-1.3-1.44-2.91-1.44s-2.92,0.64-2.92,1.44c0,0.79,1.31,1.43,2.92,1.43S546.74,388.27,546.74,387.48z M540.41,382.22c0-0.74-1.22-1.33-2.71-1.33c-1.5,0-2.71,0.59-2.71,1.33s1.21,1.34,2.71,1.34 C539.19,383.56,540.41,382.96,540.41,382.22z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#162E38",d:"M692.16,491.76c12.11,1.15,21.43,7.63,20.79,14.46c-0.65,6.82-11.02,11.44-23.13,10.3 c-12.1-1.15-21.43-7.63-20.78-14.45C669.68,495.24,680.06,490.62,692.16,491.76z M702.81,505.26c0.35-3.68-4.67-7.17-11.19-7.78 c-6.52-0.62-12.1,1.87-12.45,5.54c-0.35,3.68,4.67,7.17,11.19,7.78C696.88,511.42,702.47,508.93,702.81,505.26z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#194268",d:"M691.62,497.48c6.52,0.61,11.54,4.1,11.19,7.78c-0.34,3.67-5.93,6.16-12.45,5.54 c-6.52-0.61-11.54-4.1-11.19-7.78C679.52,499.35,685.1,496.86,691.62,497.48z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"667.24,527.75 588.55,527.75 515.39,429.75 564.84,429.75 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0F4B60",points:"507.09,429.75 574.47,527.75 495.81,527.75 457.87,429.75 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M564.84,401.54c1.89,0,3.43,0.76,3.43,1.69c0,0.94-1.54,1.7-3.43,1.7c-1.9,0-3.44-0.76-3.44-1.7 C561.4,402.3,562.94,401.54,564.84,401.54z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#194268",points:"558.57,423.75 510.91,423.75 473.52,373.67 506.24,373.67 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D53A25",d:"M543.83,386.04c1.61,0,2.91,0.64,2.91,1.44c0,0.79-1.3,1.43-2.91,1.43s-2.92-0.64-2.92-1.43 C540.91,386.68,542.22,386.04,543.83,386.04z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M537.7,380.89c1.49,0,2.71,0.59,2.71,1.33s-1.22,1.34-2.71,1.34c-1.5,0-2.71-0.6-2.71-1.34 S536.2,380.89,537.7,380.89z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#194268",d:"M440.31,332.62l62.65,91.13h-47.41l-35.28-91.13H440.31z M485.41,416.35l-6.21-8.94l-15.3,0.05l3.5,8.96 L485.41,416.35z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104B59",points:"502.75,370.33 471.03,370.33 434.62,321.57 451.8,321.57 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#162E38",points:"479.2,407.41 485.41,416.35 467.4,416.42 463.9,407.46 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#194268",points:"476.56,512 481.73,527.75 403.04,527.75 402.58,512 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M417.7,332.62l54.96,167.5h-29.23l-1.45-5.28c8.7-1.57,15.02-6.17,15.02-11.59 c0-6.71-9.68-12.17-21.58-12.17s-21.59,5.46-21.59,12.17c0,6.2,8.28,11.32,18.92,12.06l0.47,4.81h-30.99l-4.95-167.5H417.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104B59",points:"458.22,313.34 444.59,313.34 433.52,303.28 444.05,303.28 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"450.43,320.26 433.64,320.26 420.97,303.28 432.69,303.28 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D53A25",d:"M435.42,476.7c6.41,0,11.62,2.94,11.62,6.55s-5.21,6.55-11.62,6.55s-11.62-2.94-11.62-6.55 S429.01,476.7,435.42,476.7z M441.13,482.88c0-1.65-2.45-2.99-5.46-2.99c-3.02,0-5.46,1.34-5.46,2.99c0,1.64,2.44,2.98,5.46,2.98 C438.68,485.86,441.13,484.52,441.13,482.88z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M435.67,479.89c3.01,0,5.46,1.34,5.46,2.99c0,1.64-2.45,2.98-5.46,2.98c-3.02,0-5.46-1.34-5.46-2.98 C430.21,481.23,432.65,479.89,435.67,479.89z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104B59",points:"427.82,314.46 439.02,330.75 419.54,330.75 413.23,314.46 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0F4B60",d:"M420.13,303.28l6.92,10.06H412.8l-3.89-10.06H420.13z M423,310.79c0-0.88-1.93-1.6-4.29-1.6 c-2.37,0-4.29,0.72-4.29,1.6c0,0.89,1.92,1.61,4.29,1.61C421.07,312.4,423,311.68,423,310.79z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#162E38",d:"M418.71,309.19c2.36,0,4.29,0.72,4.29,1.6c0,0.89-1.93,1.61-4.29,1.61c-2.37,0-4.29-0.72-4.29-1.61 C414.42,309.91,416.34,309.19,418.71,309.19z M421.02,310.79c0-0.47-1.04-0.86-2.31-0.86c-1.28,0-2.31,0.39-2.31,0.86 c0,0.48,1.03,0.87,2.31,0.87C419.98,311.66,421.02,311.27,421.02,310.79z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M418.71,309.93c1.27,0,2.31,0.39,2.31,0.86c0,0.48-1.04,0.87-2.31,0.87c-1.28,0-2.31-0.39-2.31-0.87 C416.4,310.32,417.43,309.93,418.71,309.93z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0F4B60",d:"M408.86,305.69l8.23,25.06h-19.86l-0.74-25.06H408.86z M408.08,326.7c0-0.4-0.72-0.73-1.62-0.73 s-1.63,0.33-1.63,0.73c0,0.4,0.73,0.73,1.63,0.73S408.08,327.1,408.08,326.7z M406.64,320.91c0-0.27-0.49-0.49-1.1-0.49 c-0.61,0-1.1,0.22-1.1,0.49s0.49,0.49,1.1,0.49C406.15,321.4,406.64,321.18,406.64,320.91z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104B59",points:"408.07,303.28 408.66,305.06 396.47,305.06 396.42,303.28 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D53A25",d:"M406.46,325.97c0.9,0,1.62,0.33,1.62,0.73c0,0.4-0.72,0.73-1.62,0.73s-1.63-0.33-1.63-0.73 S405.56,325.97,406.46,325.97z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7FF3E2",cx:"405.54",cy:"320.91",rx:"1.1",ry:"0.49"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#194268",points:"395.58,303.28 395.29,313.34 380.34,313.34 383.63,303.28 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"395.25,314.46 394.13,352.5 367.54,352.5 379.97,314.46 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104B59",d:"M394.03,355.83l-0.71,23.98h-14.07l1.25-10.38c4.98-0.32,8.83-2.3,8.83-4.69c0-2.61-4.6-4.74-10.25-4.74 s-10.25,2.13-10.25,4.74c0,2.21,3.29,4.06,7.71,4.59c-0.68,2.65-3.79,15.17-3.79,15.17h20.44l-1.16,39.25h-47.78l22.2-67.92 L394.03,355.83L394.03,355.83z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#194268",points:"391.85,429.75 388.96,527.75 310.25,527.75 342.29,429.75 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#104B59",cx:"379.08",cy:"364.74",rx:"5.52",ry:"2.55"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#194268",d:"M382.79,303.28l-10.6,27.47h-19.18l18.89-27.47H382.79z M366.19,328.56l1.03-2.37h-4.81l-1.47,2.37 H366.19z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0F4B60",points:"371.47,332.62 356.92,370.33 325.79,370.33 351.72,332.62 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0F4B60",points:"371.07,303.28 369.74,305.06 357.15,305.06 359.01,303.28 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#194268",d:"M369.27,305.69L321,370.33h-31.97l67.47-64.64H369.27z M319.5,355.59c0-0.51-0.84-0.93-1.88-0.93 s-1.89,0.42-1.89,0.93c0,0.52,0.85,0.93,1.89,0.93S319.5,356.11,319.5,355.59z M316.44,359.34c0-0.54-0.88-0.97-1.96-0.97 s-1.96,0.43-1.96,0.97c0,0.53,0.88,0.97,1.96,0.97S316.44,359.87,316.44,359.34z M312.7,363.72c0-0.6-0.99-1.09-2.21-1.09 s-2.21,0.49-2.21,1.09c0,0.61,0.99,1.1,2.21,1.1S312.7,364.33,312.7,363.72z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D53A25",points:"367.22,326.19 366.19,328.56 360.94,328.56 362.41,326.19 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"358.18,303.28 324.03,334.25 304.64,334.25 348.26,303.28 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M355.63,373.67l-27.48,71.21h-33.27l-29.51,51.56c-0.47,0.01-0.94,0.03-1.42,0.06 c-12.8,0.79-22.85,7.3-22.41,14.51c0.45,7.21,11.22,12.44,24.01,11.66c12.8-0.79,22.85-7.3,22.41-14.51 c-0.29-4.62-4.8-8.42-11.36-10.35l22.34-44.56h25.98l-28.71,74.4H217.6l105.9-153.98L355.63,373.67L355.63,373.67z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104B59",points:"321.96,336.12 284.24,370.33 253.81,370.33 302,336.12 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#194268",points:"318.51,373.67 255.78,457.67 197.89,457.67 285.55,373.67 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M317.62,354.66c1.04,0,1.88,0.42,1.88,0.93c0,0.52-0.84,0.93-1.88,0.93s-1.89-0.41-1.89-0.93 C315.73,355.08,316.58,354.66,317.62,354.66z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7FF3E2",cx:"314.48",cy:"359.34",rx:"1.96",ry:"0.97"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D53A25",d:"M310.49,362.63c1.22,0,2.21,0.49,2.21,1.09c0,0.61-0.99,1.1-2.21,1.1s-2.21-0.49-2.21-1.1 C308.28,363.12,309.27,362.63,310.49,362.63z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104056",points:"280.57,373.67 225.34,423.75 178.56,423.75 249.11,373.67 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#104056",d:"M277.25,508.82c0.23,3.88-5.18,7.38-12.07,7.81c-6.89,0.42-12.69-2.39-12.93-6.28 c-0.23-3.88,5.18-7.39,12.07-7.81C271.21,502.12,277.01,504.93,277.25,508.82z M270.63,509.5c0-1.65-2.45-2.98-5.46-2.98 c-3.02,0-5.46,1.33-5.46,2.98s2.44,2.98,5.46,2.98C268.18,512.48,270.63,511.15,270.63,509.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#D53A25",cx:"265.17",cy:"509.5",rx:"5.46",ry:"2.98"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#104B59",points:"249.5,466.08 203.45,527.75 124.74,527.75 189.1,466.08 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0F4B60",d:"M218.72,429.75l-77.59,70.37H70.99l99.12-70.37H218.72z M125.5,494.79c10.05-1.17,17.7-6.72,17.04-12.39 c-0.65-5.67-9.37-9.33-19.42-8.16c-10.05,1.16-17.69,6.72-17.04,12.38C106.74,492.29,115.45,495.95,125.5,494.79z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#162E38",d:"M142.54,482.4c0.66,5.67-6.99,11.22-17.04,12.39c-10.05,1.16-18.76-2.5-19.42-8.17 c-0.65-5.66,6.99-11.22,17.04-12.38C133.17,473.07,141.89,476.73,142.54,482.4z M124.95,490.05c5.42-0.63,9.53-3.62,9.18-6.68 c-0.36-3.05-5.05-5.02-10.46-4.39c-5.41,0.63-9.53,3.62-9.17,6.67C114.85,488.7,119.54,490.67,124.95,490.05z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0F4B60",d:"M134.13,483.37c0.35,3.06-3.76,6.05-9.18,6.68c-5.41,0.62-10.1-1.35-10.45-4.4 c-0.36-3.05,3.76-6.04,9.17-6.67C129.08,478.35,133.77,480.32,134.13,483.37z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#194268",points:"128.02,512 110.66,527.75 32.07,527.75 54.25,512 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7FF3E2",cx:"319.729",cy:"408.657",rx:"3.333",ry:"1.824"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7FF3E2",cx:"176.428",cy:"511.737",rx:"6.74",ry:"3.688"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7FF3E2",cx:"189.116",cy:"497.55",rx:"6.74",ry:"3.688"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7FF3E2",cx:"323.333",cy:"401.917",rx:"3",ry:"1.417"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7FF3E2",cx:"350.75",cy:"305.25",rx:"0.917",ry:"0.25"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7FF3E2",cx:"347.25",cy:"307.833",rx:"1.167",ry:"0.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7FF3E2",cx:"551.619",cy:"443.071",rx:"5.381",ry:"2.655"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#7FF3E2",cx:"478.25",cy:"362.083",rx:"2.917",ry:"1.417"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#616D6A",d:"M501.417,95.333c0,0,7.167-7,18.167-2.333l3.917,11.75c0,0-10.333-4.083-19.083,1.083L501.417,95.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M556.938,291.125c4.375,1.5,11.875-0.625,14-3.375l3.25,10.438c-1.938,5.812-10.562,4.812-14.25,3.562 L556.938,291.125z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M244.167,262.083c4.167,3.167,9.083,3.833,13.333,1.917l-2.167,8.5c0,0-5.333,3.167-13.25-3.083"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M357.554,164.176l8.209-1.836c1.786-0.399,3.187-0.237,3.716,2.129c0.414,1.849-0.536,2.752-2.382,3.395 l0.007,0.031c2.012-0.417,3.242-0.067,3.704,2.001c0.529,2.365-0.805,3.239-3.593,3.863l-7.159,1.601L357.554,164.176z M362.67,167.852l2.146-0.48c0.658-0.147,0.993-0.633,0.884-1.119c-0.144-0.642-0.591-0.805-1.312-0.644l-2.115,0.473 L362.67,167.852z M363.56,171.83l1.942-0.434c0.971-0.217,1.352-0.5,1.195-1.205c-0.13-0.579-0.485-0.845-1.363-0.649 l-2.177,0.487L363.56,171.83z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M372.042,169.829c-0.207-0.923,0.094-1.271,1.285-1.537l0.862-0.193c1.206-0.27,1.626-0.084,1.833,0.84 l0.123,0.549c0.207,0.924-0.094,1.271-1.3,1.541l-0.862,0.193c-1.191,0.266-1.611,0.081-1.817-0.843L372.042,169.829z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M382.965,159.594c4.272-0.34,6.063,0.918,6.398,5.127c0.339,4.256-1.042,6.524-5.443,6.874 c-4.401,0.35-6.124-1.671-6.462-5.927C377.122,161.46,378.692,159.934,382.965,159.594z M385.237,165.692 c-0.112-1.408-0.427-2.333-1.963-2.211c-1.536,0.122-1.701,1.086-1.589,2.493c0.135,1.697,0.769,2.387,1.97,2.291 C384.855,168.171,385.372,167.389,385.237,165.692z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M389.977,168.388c-0.01-0.946,0.356-1.224,1.576-1.237l0.883-0.01c1.236-0.013,1.608,0.256,1.618,1.202 l0.006,0.562c0.01,0.947-0.356,1.224-1.592,1.237l-0.883,0.01c-1.22,0.013-1.592-0.255-1.603-1.202L389.977,168.388z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M414.526,168.407c0.494,0.217,1.425,0.603,3.814,1.17c0.89,0.212,1.341,0.187,1.489-0.438 c0.145-0.609-0.021-0.813-0.942-1.032l-0.984-0.234c-2.014-0.479-3.428-1.194-2.641-4.505c0.757-3.186,3.293-3.029,5.792-2.435 c1.64,0.39,3.505,1.08,4.44,1.451l-0.787,3.311c-1.028-0.327-2.13-0.754-3.568-1.096c-1.296-0.308-1.703-0.19-1.841,0.388 c-0.1,0.422,0.059,0.724,1.012,0.95c3.373,0.802,4.351,1.48,3.694,4.244c-0.761,3.202-2.782,3.167-5.547,2.51 c-1.546-0.367-3.109-0.871-4.611-1.426L414.526,168.407z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M424.826,171.681c0.219-0.921,0.641-1.101,1.829-0.819l0.859,0.204c1.202,0.286,1.498,0.637,1.279,1.558 l-0.13,0.547c-0.219,0.922-0.641,1.101-1.843,0.816l-0.859-0.204c-1.188-0.282-1.484-0.633-1.265-1.554L424.826,171.681z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M396.982,167.47c0.521,0.14,1.499,0.38,3.947,0.58c0.912,0.074,1.354-0.018,1.406-0.658 c0.051-0.624-0.143-0.8-1.087-0.878l-1.008-0.082c-2.063-0.168-3.569-0.662-3.292-4.054c0.266-3.264,2.797-3.492,5.357-3.283 c1.68,0.137,3.628,0.537,4.609,0.762l-0.277,3.392c-1.065-0.167-2.22-0.423-3.693-0.543c-1.328-0.108-1.713,0.07-1.761,0.662 c-0.035,0.432,0.168,0.706,1.144,0.786c3.455,0.282,4.525,0.804,4.294,3.636c-0.268,3.28-2.271,3.552-5.103,3.32 c-1.584-0.129-3.205-0.391-4.773-0.712L396.982,167.47z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M407.811,169.137c0.077-0.943,0.467-1.186,1.684-1.086l0.88,0.072c1.231,0.101,1.577,0.403,1.5,1.346 l-0.046,0.561c-0.077,0.944-0.467,1.186-1.698,1.085l-0.88-0.072c-1.217-0.099-1.562-0.401-1.485-1.345L407.811,169.137z"}))))));}}]);return LevelBoss;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LevelBoss);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sample__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_sample__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LevelKenny=function(_Component){_inherits(LevelKenny,_Component);function LevelKenny(props){_classCallCheck(this,LevelKenny);var _this=_possibleConstructorReturn(this,(LevelKenny.__proto__||Object.getPrototypeOf(LevelKenny)).call(this,props));_this.state={kenny1:false,kenny2:false,kenny3:false,kenny4:false,kenny5:false,kenny6:false,currentKenny:''};return _this;}_createClass(LevelKenny,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].delayedCall(3,function(){return _this2.popAKenny();});}},{key:'getRandomArbitrary',value:function getRandomArbitrary(min,max){return Math.random()*(max-min)+min;}},{key:'getRandomKenny',value:function getRandomKenny(){var availableKenny=[1,2,3,4,5,6];var rando='';do{rando='kenny'+__WEBPACK_IMPORTED_MODULE_2_lodash_sample___default()(availableKenny);}while(this.state.currentKenny===rando);return rando;}},{key:'popAKenny',value:function popAKenny(){var _setState,_this3=this;var randomKenny=this.getRandomKenny();this.setState((_setState={},_defineProperty(_setState,randomKenny,true),_defineProperty(_setState,'currentKenny',randomKenny),_setState));__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].delayedCall(this.getRandomArbitrary(1,2),function(){return _this3.hideAKenny();});}},{key:'hideAKenny',value:function hideAKenny(){var _this4=this;this.setState(_defineProperty({},this.state.currentKenny,false),function(){return _this4.popAKenny();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].killAll(true,true,true,true);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'levelKenny'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',x:'0px',y:'0px',viewBox:'0 0 2048 1536',enableBackground:'new 0 0 2048 1536',preserveAspectRatio:'xMidYMid slice'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'kenny'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'floor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'floor_1_',fill:'#697A7C',width:'2048',height:'1536'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'plane'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#607172',points:'946.269,846.079 181.302,1536 253.907,1536 954.446,846.079 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#607172',points:'1104.306,846.079 1097.391,846.079 1799.44,1536 1872.045,1536 \t\t\t'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'ceiling'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'ceiling_1_',fill:'#D2DBDB',width:'2048',height:'714.593'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'tiles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1283.385,490.107 1155.062,490.107 1118.254,568.27 1210.784,568.27 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1414.257,490.107 1285.933,490.107 1212.621,568.27 1305.152,568.27 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'831.557,364.708 748.557,188.941 482.32,188.941 645.809,364.708 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1545.128,490.107 1416.804,490.107 1306.989,568.27 1399.519,568.27 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1021.643,490.107 893.319,490.107 929.518,568.27 1022.049,568.27 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1020.992,364.708 1020.078,188.941 753.842,188.941 835.244,364.708 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'2048,183.898 2048,40.625 1847.013,183.898 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'2048,216.672 1883.025,308.63 2048,219.923 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'2048,364.708 2048,222.625 1782.418,364.708 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1592.984,364.708 1778.731,364.708 2048,213.97 2048,188.941 1839.929,188.941 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1551.273,488.186 2048,488.186 2048,367.607 1776.992,367.607 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'642.122,364.708 477.035,188.941 210.799,188.941 456.374,364.708 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'759.901,490.107 631.577,490.107 740.783,568.27 833.314,568.27 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'890.772,490.107 762.448,490.107 835.151,568.27 927.681,568.27 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'629.029,490.107 501.216,490.107 646.784,568.27 738.946,568.27 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1152.514,490.107 1024.191,490.107 1023.886,568.27 1116.417,568.27 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1400.83,367.607 1287.735,488.186 1416.939,488.186 1585.25,367.607 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1212.749,367.607 1155.967,488.186 1285.17,488.186 1397.169,367.607 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1209.088,367.607 1024.668,367.607 1024.198,488.186 1153.402,488.186 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'456.764,367.607 273.077,367.607 497.637,488.186 626.327,488.186 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1419.504,488.186 1548.708,488.186 1773.331,367.607 1588.911,367.607 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1291.6,188.941 1025.364,188.941 1024.679,364.708 1210.426,364.708 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'648.506,367.607 760.661,488.186 889.864,488.186 832.926,367.607 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'460.425,367.607 628.892,488.186 758.096,488.186 644.845,367.607 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1399.861,364.708 1563.122,188.941 1296.885,188.941 1214.114,364.708 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'892.429,488.186 1021.633,488.186 1021.007,367.607 836.587,367.607 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'none',points:'1589.296,364.708 1834.644,188.941 1568.407,188.941 1403.549,364.708 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#B4BEC1',d:'M501.216,490.107h127.813l109.917,78.163h1.837l-109.206-78.163h128.324l73.413,78.163h1.837\t\t\t\t\tl-72.703-78.163h128.324l36.91,78.163h1.837l-36.199-78.163h128.324l0.406,78.163h1.837l0.305-78.163h128.324l-36.098,78.163\t\t\t\t\th1.837l36.808-78.163h128.324l-72.601,78.163h1.837l73.312-78.163h128.324l-109.105,78.163h1.837l109.815-78.163h128.324\t\t\t\t\tl-145.609,78.163h1.837l146.319-78.163H2048v-1.922h-496.727l225.719-120.578H2048v-2.899h-265.582l100.606-56.078\t\t\t\t\tl-104.294,56.078h-185.747l246.945-175.768H2048v-5.042h-200.987L2048,40.625v-4.804l-206.318,148.078h-268.545L1745.308,0h-7\t\t\t\t\tl-170.502,183.898H1299.26L1385.703,0h-7l-84.774,183.898h-268.545L1026.099,0h-7l0.954,183.898H751.507L666.494,0h-7\t\t\t\t\tl86.682,183.898H477.63L306.89,0h-7l172.41,183.898H203.754L0,37.63v4.87l198.423,141.398H0v5.042h205.513l247.174,175.768\t\t\t\t\tH267.678L0,220.626v3.708l262.746,140.375H0v2.899h268.18l226.026,120.578H0v1.922h497.809l146.518,78.163h2.457\t\t\t\t\tL501.216,490.107z M1285.17,488.186h-129.204l56.782-120.578h184.42L1285.17,488.186z M1287.735,488.186l113.094-120.578h184.42\t\t\t\t\tl-168.311,120.578H1287.735z M1773.331,367.607l-224.623,120.578h-129.204l169.407-120.578H1773.331z M1568.407,188.941h266.236\t\t\t\t\tl-245.347,175.768h-185.747L1568.407,188.941z M1296.885,188.941h266.236l-163.26,175.768h-185.747L1296.885,188.941z\t\t\t\t\t M1025.364,188.941H1291.6l-81.174,175.768h-185.747L1025.364,188.941z M1024.668,367.607h184.42l-55.686,120.578h-129.204\t\t\t\t\tL1024.668,367.607z M628.892,488.186L460.425,367.607h184.42l113.251,120.578H628.892z M760.661,488.186L648.506,367.607h184.42\t\t\t\t\tl56.939,120.578H760.661z M1021.633,488.186H892.429l-55.843-120.578h184.42L1021.633,488.186z M1020.078,188.941l0.913,175.768\t\t\t\t\tH835.244l-81.402-175.768H1020.078z M748.557,188.941l83,175.768H645.809L482.32,188.941H748.557z M210.799,188.941h266.236\t\t\t\t\tl165.087,175.768H456.374L210.799,188.941z M497.637,488.186l-224.56-120.578h183.686l169.563,120.578H497.637z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#B4BEC1',points:'2048,222.625 2048,219.923 1883.025,308.63 1782.418,364.708 \t\t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'lights'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'XMLID_2_'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFF5E6',points:'2048,186.285 2048,219.605 1916.69,290.11 1866.5,290.11 \t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFF5E6',points:'1681.55,416.11 1515.67,505 1488,505 1644.57,416.11 \t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFF5E6',points:'1674.37,101.12 1490.05,290.11 1430.42,290.11 1591.21,101.12 \t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFF5E6',points:'1367.17,416.11 1280.47,505 1247.6,505 1323.23,416.11 \t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFF5E6',points:'1063.91,101.12 1052.33,290.11 994.23,290.11 982.87,101.12 \t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFF5E6',points:'1044.62,416.11 1039.17,505 1007.14,505 1001.8,416.11 \t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFF5E6',points:'727.66,416.11 802.06,505 769.2,505 683.74,416.11 \t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFF5E6',points:'464.04,101.12 622.21,290.11 562.61,290.11 380.92,101.12 \t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFF5E6',points:'559.3,505 534.22,505 369.65,416.11 403.17,416.11 \t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFF5E6',points:'181.85,290.11 136.37,290.11 0,216.173 0,185.943 \t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#AEB6B7',points:'2048,164.775 1799.44,312.31 1898.9,312.31 2048,234.625 2048,219.605 1916.69,290.11 \t\t\t\t\t\t\t1866.5,290.11 2048,186.285 \t\t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#AEB6B7',d:'M1651.15,399.61L1454.97,515.1h55.39l221.28-115.49H1651.15z M1515.67,505H1488l156.57-88.89h36.98\t\t\t\t\t\t\tL1515.67,505z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#AEB6B7',d:'M1582.89,68.13l-195.13,244.18h99.46l214.66-211.19l33.53-32.99H1582.89z M1490.05,290.11h-59.63\t\t\t\t\t\t\tl160.79-188.99h83.16L1490.05,290.11z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#AEB6B7',d:'M1317.99,399.61L1225.7,515.1h55.39l117.39-115.49H1317.99z M1280.47,505h-32.87l75.63-88.89h43.94\t\t\t\t\t\t\tL1280.47,505z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#AEB6B7',d:'M948.31,68.13l25.64,244.18h99.46l27.42-244.18H948.31z M1052.33,290.11h-58.1l-11.36-188.99h81.04\t\t\t\t\t\t\tL1052.33,290.11z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#AEB6B7',d:'M983.11,399.61l12.13,115.49h55.39l12.97-115.49H983.11z M1039.17,505h-32.03l-5.34-88.89h42.82\t\t\t\t\t\t\tL1039.17,505z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#AEB6B7',d:'M730.02,399.61h-80.49L765.67,515.1h55.39L730.02,399.61z M769.2,505l-85.46-88.89h43.92l74.4,88.89\t\t\t\t\t\t\tH769.2z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#AEB6B7',d:'M468.7,68.13H316.18l245.56,244.18h99.46L468.7,68.13z M562.61,290.11L380.92,101.12h83.12\t\t\t\t\t\t\tl158.17,188.99H562.61z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#AEB6B7',d:'M395.7,399.61h-80.49L535.6,515.1h55.39L395.7,399.61z M534.22,505l-164.57-88.89h33.52L559.3,505\t\t\t\t\t\t\tH534.22z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#AEB6B7',points:'0,164.693 0,185.943 181.85,290.11 136.37,290.11 0,216.173 0,234.333 148.63,312.31 \t\t\t\t\t\t\t248.09,312.31 \t\t\t\t\t\t'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'walls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#909FA3',points:'1023.099,770.334 2048,888 2048,416.108 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#909FA3',points:'1023.099,770.334 0,416.108 0,888 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'440',y:'568.27',fill:'#7C8284',width:'1166.667',height:'269.355'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'848.75',y:'668.121',fill:'#949B9B',width:'171.704',height:'100.091'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'1232.105',y:'668.121',fill:'#949B9B',width:'171.704',height:'100.091'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'620.212',y:'668.121',fill:'#949B9B',width:'171.704',height:'100.091'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'door'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#998C55',d:'M1142.17,763.171c0-2.12,1.71-3.84,3.83-3.84c1.32,0,2.47,0.66,3.16,1.68\t\t\t\t\tc-0.61-0.43-1.36-0.68-2.16-0.68c-2.12,0-3.83,1.72-3.83,3.84c0,0.8,0.25,1.54,0.67,2.16\t\t\t\t\tC1142.83,765.641,1142.17,764.481,1142.17,763.171z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#991F39',d:'M1127.95,721.621h-0.92v4.08l-3.17-4.08h-0.93v5.46h0.93v-3.99l3.09,3.99h1V721.621z M1110.97,725.561\t\t\t\t\tc0-0.34-0.1-0.63-0.3-0.86c-0.2-0.23-0.47-0.38-0.81-0.46c0.1-0.04,0.16-0.07,0.2-0.09c0.03-0.02,0.1-0.06,0.2-0.13\t\t\t\t\tc0.27-0.21,0.41-0.53,0.41-0.96c0-0.35-0.13-0.67-0.38-0.95c-0.13-0.15-0.33-0.27-0.6-0.36c-0.26-0.09-0.58-0.13-0.96-0.13\t\t\t\t\th-2.12v5.46h2.39c0.75,0,1.27-0.17,1.58-0.51C1110.84,726.281,1110.97,725.951,1110.97,725.561z M1137.23,721.621l-2.41,5.46\t\t\t\t\th0.99l0.55-1.24h2.73l0.55,1.24h0.98l-2.4-5.46H1137.23z M1117.82,721.621v5.46h3.93v-0.87h-3.01v-1.46h2.62v-0.82h-2.62v-1.45\t\t\t\t\th2.92v-0.86H1117.82z M1115.31,725.101c0.79-0.24,1.18-0.81,1.18-1.71c0-0.62-0.18-1.07-0.54-1.35\t\t\t\t\tc-0.36-0.28-0.95-0.42-1.79-0.42h-2.03v5.46h0.92v-1.84h1.21l1.31,1.84h1.17L1115.31,725.101z M1129.47,727.081h1.81\t\t\t\t\tc1.05,0,1.84-0.25,2.35-0.74c0.51-0.5,0.76-1.17,0.76-2.02s-0.26-1.51-0.79-1.99c-0.52-0.48-1.28-0.71-2.26-0.71h-1.87V727.081z\t\t\t\t\t M1155.12,702.001v135.74h-63.2v-135.74H1155.12z M1150.83,764.171c0-1.32-0.66-2.48-1.67-3.16c-0.69-1.02-1.84-1.68-3.16-1.68\t\t\t\t\tc-2.12,0-3.83,1.72-3.83,3.84c0,1.31,0.66,2.47,1.67,3.16c0.69,1.01,1.84,1.67,3.16,1.67\t\t\t\t\tC1149.12,768.001,1150.83,766.281,1150.83,764.171z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#6B2030',d:'M1146,767.001c2.12,0,3.83-1.72,3.83-3.83c0-0.8-0.25-1.55-0.67-2.16c1.01,0.68,1.67,1.84,1.67,3.16\t\t\t\t\tc0,2.11-1.71,3.83-3.83,3.83c-1.32,0-2.47-0.66-3.16-1.67C1144.45,766.751,1145.2,767.001,1146,767.001z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#998C55',d:'M1149.83,763.171c0,2.11-1.71,3.83-3.83,3.83c-0.8,0-1.55-0.25-2.16-0.67\t\t\t\t\tc-0.42-0.62-0.67-1.36-0.67-2.16c0-2.12,1.71-3.84,3.83-3.84c0.8,0,1.55,0.25,2.16,0.68\t\t\t\t\tC1149.58,761.621,1149.83,762.371,1149.83,763.171z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#841A2C',d:'M1109.46,722.641c0.16,0.12,0.24,0.3,0.24,0.56c0,0.46-0.33,0.68-1,0.68h-1.17v-1.41h1.18\t\t\t\t\tC1109.05,722.471,1109.3,722.531,1109.46,722.641z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#FFFFFF',d:'M1137.73,722.731l-1,2.26h1.99L1137.73,722.731z M1138.22,721.621l2.4,5.46h-0.98l-0.55-1.24h-2.73\t\t\t\t\tl-0.55,1.24h-0.99l2.41-5.46H1138.22z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#FFFFFF',d:'M1110.03,725.461c0-0.48-0.39-0.72-1.17-0.72h-1.33v1.49h1.45c0.34,0,0.6-0.05,0.78-0.16\t\t\t\t\tC1109.94,725.961,1110.03,725.761,1110.03,725.461z M1110.67,723.061c0,0.43-0.14,0.75-0.41,0.96c-0.1,0.07-0.17,0.11-0.2,0.13\t\t\t\t\tc-0.04,0.02-0.1,0.05-0.2,0.09c0.34,0.08,0.61,0.23,0.81,0.46c0.2,0.23,0.3,0.52,0.3,0.86c0,0.39-0.13,0.72-0.39,1.01\t\t\t\t\tc-0.31,0.34-0.83,0.51-1.58,0.51h-2.39v-5.46h2.12c0.38,0,0.7,0.04,0.96,0.13c0.27,0.09,0.47,0.21,0.6,0.36\t\t\t\t\tC1110.54,722.391,1110.67,722.711,1110.67,723.061z M1108.7,723.881c0.67,0,1-0.22,1-0.68c0-0.26-0.08-0.44-0.24-0.56\t\t\t\t\tc-0.16-0.11-0.41-0.17-0.75-0.17h-1.18v1.41H1108.7z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#841A2C',d:'M1113.05,724.411v-1.96h1.17c0.5,0,0.84,0.07,1.04,0.2c0.19,0.13,0.29,0.38,0.29,0.74\t\t\t\t\tc0,0.35-0.1,0.61-0.29,0.77c-0.18,0.17-0.54,0.25-1.06,0.25H1113.05z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFFFFF',points:'1122.93,727.081 1122.93,721.621 1123.86,721.621 1127.03,725.701 1127.03,721.621 \t\t\t\t\t1127.95,721.621 1127.95,727.081 1126.95,727.081 1123.86,723.091 1123.86,727.081 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#841A2C',d:'M1107.53,726.231v-1.49h1.33c0.78,0,1.17,0.24,1.17,0.72c0,0.3-0.09,0.5-0.27,0.61\t\t\t\t\tc-0.18,0.11-0.44,0.16-0.78,0.16H1107.53z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#841A2C',d:'M1131.31,722.471c1.44,0,2.15,0.62,2.15,1.87c0,0.62-0.17,1.09-0.53,1.4c-0.35,0.32-0.85,0.47-1.51,0.47\t\t\t\t\th-1.03v-3.74H1131.31z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#FFFFFF',d:'M1133.46,724.341c0-1.25-0.71-1.87-2.15-1.87h-0.92v3.74h1.03c0.66,0,1.16-0.15,1.51-0.47\t\t\t\t\tC1133.29,725.431,1133.46,724.961,1133.46,724.341z M1129.47,727.081v-5.46h1.87c0.98,0,1.74,0.23,2.26,0.71\t\t\t\t\tc0.53,0.48,0.79,1.14,0.79,1.99s-0.25,1.52-0.76,2.02c-0.51,0.49-1.3,0.74-2.35,0.74H1129.47z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#FFFFFF',d:'M1115.55,723.391c0-0.36-0.1-0.61-0.29-0.74c-0.2-0.13-0.54-0.2-1.04-0.2h-1.17v1.96h1.15\t\t\t\t\tc0.52,0,0.88-0.08,1.06-0.25C1115.45,724.001,1115.55,723.741,1115.55,723.391z M1112.13,727.081v-5.46h2.03\t\t\t\t\tc0.84,0,1.43,0.14,1.79,0.42c0.36,0.28,0.54,0.73,0.54,1.35c0,0.9-0.39,1.47-1.18,1.71l1.43,1.98h-1.17l-1.31-1.84h-1.21v1.84\t\t\t\t\tH1112.13z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFFFFF',points:'1118.74,723.931 1121.36,723.931 1121.36,724.751 1118.74,724.751 1118.74,726.211 \t\t\t\t\t1121.75,726.211 1121.75,727.081 1117.82,727.081 1117.82,721.621 1121.66,721.621 1121.66,722.481 1118.74,722.481 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#841A2C',points:'1136.73,724.991 1137.73,722.731 1138.72,724.991 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#6B2030',points:'1090.19,837.741 1090.19,699.461 1155.12,699.461 1155.12,702.001 1091.92,702.001 \t\t\t\t\t1091.92,837.741 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#697A7C',points:'1090.19,838.621 1090.19,837.741 1091.92,837.741 1155.12,837.741 1156.87,838.621 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#4F4B3B',points:'1156.87,698.531 1156.87,838.621 1155.12,837.741 1155.12,702.001 1155.12,699.461 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#DBDAD1',points:'1084,692.501 1084,838.621 1082.89,837.381 1082.89,693.921 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#3A3729',points:'1090.19,698.531 1156.87,698.531 1155.12,699.461 1090.19,699.461 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C0CBCC',points:'1163.51,692.501 1163.51,838.621 1156.87,838.621 1156.87,698.531 1090.19,698.531 \t\t\t\t\t1090.19,699.461 1090.19,837.741 1090.19,838.621 1084,838.621 1084,692.501 \t\t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'kenny2',ref:'kenny2',className:'kenny '+(this.state.kenny2?'kenny2':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M650.229,592.157c1.042,0.292,1.639,1.374,1.347,2.416c-0.139,0.478-0.445,0.863-0.83,1.108l-2.648-0.518\t\t\t\tc-0.332-0.464-0.451-1.075-0.285-1.666C648.112,592.456,649.194,591.858,650.229,592.157z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'650.169,624.68 648.291,634.933 648.736,623.951 649.247,624.236 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#3A2B15',points:'653.083,588.812 652.213,587.326 649.592,585.056 649.247,584.38 650.096,581.918 \t\t\t\t650.72,582.097 652.864,585.056 653.667,588.6 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M650.72,582.097l-0.624-0.179l-0.849,2.462l-0.982-0.252l0.869-3.358l0.113-4.605l-3.975-2.475\t\t\t\tl1.261-2.044l6.079,3.816l0.471,3.318l-1.626,1.991l2.621-0.909l0.571,1.633l-0.113,3.384c0,0-0.066,2.402-0.126,3.749\t\t\t\tl-0.743-0.027l-0.803-3.544L650.72,582.097z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'648.179,642.611 647.615,643.48 642.385,641.987 634.561,634.223 636.944,632.465 \t\t\t\t644.847,640.965 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFFFFF',points:'645.756,610.572 644.96,612.019 641.576,611.979 637.103,611.295 635.252,608.906 \t\t\t\t641.443,609.855 646.121,609.915 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#A86538',points:'643.129,604.746 642.246,605.131 640.175,604.852 641.058,604.606 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M636.492,590.591c1.248,0.113,2.163,1.214,2.051,2.455c-0.053,0.571-0.312,1.075-0.703,1.44l-3.112-0.013\t\t\t\tc-0.478-0.458-0.75-1.122-0.69-1.832C634.15,591.394,635.252,590.478,636.492,590.591z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CB814F',points:'634.588,605.874 632.378,608.482 631.973,607.181 633.241,605.874 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M651.576,594.573c0.292-1.042-0.305-2.124-1.347-2.416c-1.035-0.299-2.117,0.299-2.416,1.34\t\t\t\tc-0.166,0.591-0.047,1.201,0.285,1.666l2.648,0.518C651.132,595.435,651.437,595.05,651.576,594.573z M635.915,608.356\t\t\t\tl7.466,0.79l0.418-2.873l2.98-0.796l0.995-1.812l-3.975-9.37l0.498-1.905l2.966-4.4l1.002-3.862l0.982,0.252l0.345,0.677\t\t\t\tl2.621,2.27l0.869,1.486l0.584-0.212l0.743,0.027c-0.013,0.405-0.027,0.717-0.04,0.836c-0.06,0.511-1.759,5.116-1.759,5.116\t\t\t\tl-0.053,6.311l-1.042,4.207l-2.794,10.239l-4.765,5.992l-2.329,0.657l-2.588,0.325l3.929-3.053l0.246-2.907l-3.152-2.714\t\t\t\tl5.289-0.332l0.929-1.573l-0.524-1.161l0.365-0.657l-4.678-0.06l-6.191-0.949c0,0-0.418-0.431-0.69-0.551\t\t\t\tC634.289,608.236,635.915,608.356,635.915,608.356z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#750C27',d:'M632.637,652.983c1.095,0,1.978,0.883,1.978,1.978c0,1.088-0.883,1.971-1.978,1.971\t\t\t\tc-1.088,0-1.971-0.883-1.971-1.971C630.666,653.866,631.549,652.983,632.637,652.983z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M636.406,585.634c-0.405,0.192-3.232,2.356-3.232,2.356l-0.538-0.71c0,0,1.745-2.986,3.278-4.061\t\t\t\tc1.533-1.082,3.809-2.031,3.962-1.991c0.146,0.04,0.922,0,0.922,0l-0.199,3.066C640.6,584.293,636.811,585.441,636.406,585.634z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#750C27',d:'M629.876,665.705c1.088,0,1.971,0.883,1.971,1.978c0,1.088-0.883,1.971-1.971,1.971\t\t\t\tc-1.095,0-1.978-0.883-1.978-1.971C627.899,666.587,628.781,665.705,629.876,665.705z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M636.3,579.661c-1.938,0.299-8.182-0.63-8.182-0.63l-1.035,6.603l-2.654,2.794l-1.367,4.785l-1.38,2.767\t\t\t\tl-1.34-3.59l-1.739-2.927h-2.528l-0.564-3.351l-1.38-5.01l0.883-8.043l-2.11,0.909l3.019-4.645l8.507-9.171l11.401-1.168\t\t\t\tl11.122,3.066l2.508,4.579c0,0,2.96-0.538,4.207-0.206c1.248,0.332,4.519,4.645,4.519,4.645l-1.367,8.846l-2.283,4.964\t\t\t\tl0.113-3.384l-0.571-1.633l-2.621,0.909l1.626-1.991l-0.471-3.318l-6.079-3.816l-1.261,2.044l-1.394,2.27\t\t\t\tC643.878,575.958,638.238,579.363,636.3,579.661z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M617.945,599.848l-1.055-0.113l-1.048,1.161l-1.772-6.689l0.776-2.542l2.157-0.836l1.606,1.34\t\t\t\tl1.599,4.685l-0.717,0.723c0,0-0.053,1.659-0.246,1.878c-0.192,0.226,1.573,1.958,1.573,1.958s-0.717,0.538-1.108,0.63\t\t\t\tC619.325,602.144,617.945,599.848,617.945,599.848z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'624.136,640.76 627.866,633.858 629.564,633.858 630.693,647.655 629.969,648.424 \t\t\t\t627.209,640.76 624.8,643.115 618.602,645.723 618.164,645.219 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CB814F',points:'616.677,619.093 616.598,615.337 618.164,611.84 619.245,606.272 619.743,608.721 \t\t\t\t620.738,610.692 633.904,621.747 639.041,622.311 637.368,626.93 633.088,632.611 632.312,638.656 631.217,638.795 \t\t\t\t630.951,632.538 619.478,622.67 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#E4A270',d:'M642.246,605.131l0.883-0.385l-2.07-0.139l-0.883,0.246L642.246,605.131z M632.378,608.482l2.21-2.608\t\t\t\th-1.347l-1.267,1.307L632.378,608.482z M639.877,581.227c-0.153-0.04-2.429,0.909-3.962,1.991\t\t\t\tc-1.533,1.075-3.278,4.061-3.278,4.061l0.538,0.71c0,0,2.827-2.163,3.232-2.356c0.405-0.193,4.194-1.341,4.194-1.341l0.199-3.066\t\t\t\tC640.799,581.227,640.023,581.267,639.877,581.227z M614.846,591.666l-0.776,2.542l1.772,6.689l1.048-1.161l1.055,0.113\t\t\t\tc0,0,1.38,2.296,1.765,2.197c0.392-0.093,1.108-0.63,1.108-0.63s-1.765-1.732-1.573-1.958c0.192-0.219,0.246-1.878,0.246-1.878\t\t\t\tl0.717-0.723l-1.599-4.685l-1.606-1.34L614.846,591.666z M643.381,609.145l-7.466-0.79c0,0-1.626-0.119-1.354,0\t\t\t\tc0.272,0.119,0.69,0.551,0.69,0.551l1.851,2.389l4.473,0.684l3.384,0.04l0.796-1.447l0.524,1.161l-0.929,1.573l-5.289,0.332\t\t\t\tl3.152,2.714l-0.246,2.907l-3.929,3.053l-5.136-0.564l-13.166-11.056l-0.995-1.971l-0.498-2.449l-2.568,0.027l-2.11-2.429\t\t\t\tl-0.591-5.534l-1.075-5.07l1.175-3.073l1.997-0.73h2.528l1.739,2.927l1.34,3.59l1.38-2.767l1.367-4.785l2.654-2.794l1.035-6.603\t\t\t\tc0,0,6.245,0.929,8.182,0.63c1.938-0.299,7.578-3.703,7.578-3.703l1.394-2.27l3.975,2.475l-0.113,4.605l-0.869,3.358\t\t\t\tl-1.002,3.862l-2.966,4.4l-0.498,1.905l3.975,9.37l-0.995,1.812l-2.98,0.796L643.381,609.145z M638.543,593.046\t\t\t\tc0.113-1.241-0.803-2.343-2.051-2.455c-1.241-0.113-2.343,0.803-2.455,2.051c-0.06,0.71,0.212,1.374,0.69,1.832l3.112,0.013\t\t\t\tC638.231,594.121,638.49,593.617,638.543,593.046z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#991F39',d:'M634.561,634.223l7.824,7.764l5.229,1.493l0.564-0.869l-3.331-1.646l-7.904-8.501L634.561,634.223z\t\t\t\t M627.866,633.858l-3.729,6.902l-5.972,4.459l0.438,0.504l6.198-2.608l2.409-2.356l2.761,7.665l0.723-0.77l-1.128-13.796H627.866\t\t\t\tz M631.217,638.795l1.095-0.139l0.776-6.045l4.28-5.68l1.672-4.619l2.588-0.325l2.329-0.657l4.778,2.621l-0.445,10.983\t\t\t\tl1.878-10.253l8.016,3.869l4.247,9.423l0.664,12.808l-5.999,28.316l-82.944-9.443l2.23-23.007l2.508-10.863l6.45-6.828\t\t\t\tl23.339-5.727l5.926-8.926l1.991,1.035l0.08,3.756l2.8,3.577l11.474,9.868L631.217,638.795z M616.677,643.48l-7.061-17.838\t\t\t\tl-0.491,1.287l2.15,6.596L616.677,643.48z M634.614,654.961c0-1.095-0.883-1.978-1.978-1.978c-1.088,0-1.971,0.883-1.971,1.978\t\t\t\tc0,1.088,0.883,1.971,1.971,1.971C633.732,656.932,634.614,656.049,634.614,654.961z M631.847,667.682\t\t\t\tc0-1.095-0.883-1.978-1.971-1.978c-1.095,0-1.978,0.883-1.978,1.978c0,1.088,0.883,1.971,1.978,1.971\t\t\t\tC630.965,669.653,631.847,668.771,631.847,667.682z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'609.616,625.643 616.677,643.48 611.275,633.526 609.125,626.93 \t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'kenny3',ref:'kenny3',className:'kenny '+(this.state.kenny3?'kenny3':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M943.62,720.745l-2.105,4.03l-1.91,2.013l0.608-1.609l-0.004-0.877l-1.412,0.007l1.111-0.69l0.313-1.674\t\t\t\tl-2.298-2.83l-0.941,0.776l-1.042,0.863c0,0-3.269,0.714-4.25,0.54c-0.981-0.174-3.831-1.642-3.831-1.642l-1.578,3.005\t\t\t\tl-1.734,0.909l-1.44,2.077l-1.117,1.105l-0.057-1.946l-0.357-1.692l-1.216-0.414l0.277-1.704l0.156-2.635l1.741-3.723\t\t\t\tl-1.163,0.092l2.215-1.738l5.588-3.018l5.676,1.305l4.843,3.293l0.457,2.612c0,0,1.514,0.227,2.058,0.586\t\t\t\tC942.753,718.136,943.62,720.745,943.62,720.745z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M936.343,729.583c0.453,0.311,0.563,0.929,0.252,1.382c-0.145,0.207-0.355,0.342-0.58,0.397l-1.188-0.682\t\t\t\tc-0.084-0.278-0.041-0.591,0.135-0.848C935.276,729.38,935.894,729.27,936.343,729.583z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'928.41,749.834 930.421,744.626 930.62,744.847 930.991,745.211 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M938.578,728.436l0.194-1.835l-0.546-1.774l-0.271-0.188l-0.811,1.045l-0.431-0.282l0.968-1.472\t\t\t\tl0.808-2.196l-1.506-1.841l0.941-0.776l2.298,2.83l-0.313,1.674l-1.111,0.69l1.412-0.007l0.004,0.877l-0.608,1.609\t\t\t\tc0,0-0.425,1.144-0.674,1.782L938.578,728.436z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#3A2B15',points:'938.265,728.443 938.087,727.585 937.198,726.065 937.143,725.683 937.955,724.638 \t\t\t\t938.225,724.826 938.772,726.6 938.578,728.436 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'927.099,753.507 926.686,753.833 924.416,752.259 921.925,747.245 923.358,746.789 \t\t\t\t925.767,752.17 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFFFFF',points:'931.178,737.706 930.559,738.271 928.938,737.698 926.899,736.637 926.4,735.185 \t\t\t\t929.221,736.655 931.461,737.449 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#A86538',points:'930.868,734.474 930.381,734.515 929.431,734.042 929.896,734.068 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M929.994,726.582c0.581,0.258,0.841,0.938,0.584,1.516c-0.119,0.266-0.326,0.466-0.574,0.577\t\t\t\tl-1.494-0.516c-0.155-0.298-0.177-0.662-0.032-0.994C928.736,726.585,929.416,726.325,929.994,726.582z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CB814F',points:'926.577,733.619 925.088,734.511 925.106,733.819 925.929,733.398 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M936.015,731.362c0.225-0.055,0.435-0.19,0.58-0.397c0.311-0.453,0.201-1.071-0.252-1.382\t\t\t\tc-0.449-0.313-1.067-0.203-1.381,0.249c-0.176,0.257-0.219,0.57-0.135,0.848L936.015,731.362z M937.092,731.138l-1.058,3.026\t\t\t\tl-1.19,1.852l-3.019,4.466l-3.272,2.101l-1.227-0.065l-1.298-0.267l2.388-0.825l0.593-1.354l-1.07-1.824l2.597,0.706l0.704-0.604\t\t\t\tl-0.062-0.644l0.283-0.256l-2.24-0.794l-2.822-1.47c0,0-0.127-0.275-0.242-0.378c-0.111-0.102,0.651,0.222,0.651,0.222\t\t\t\tl3.46,1.602l0.671-1.313l1.566,0.106l0.775-0.708l-0.381-5.157l0.551-0.834l2.146-1.63l1.114-1.693l0.431,0.282l0.055,0.382\t\t\t\tl0.889,1.52l0.178,0.858l0.312-0.008l0.353,0.134c-0.073,0.192-0.13,0.34-0.156,0.396\t\t\t\tC938.662,729.201,937.092,731.138,937.092,731.138z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#750C27',d:'M917.929,755.95c0.526,0.179,0.806,0.748,0.627,1.275c-0.178,0.523-0.747,0.803-1.273,0.624\t\t\t\tc-0.523-0.178-0.803-0.747-0.625-1.27C916.837,756.052,917.406,755.772,917.929,755.95z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M933.597,722.785L933,724.226c0,0-2.01-0.068-2.236-0.042c-0.226,0.026-1.936,0.605-1.936,0.605\t\t\t\tl-0.145-0.43c0,0,1.328-1.15,2.241-1.416c0.914-0.269,2.165-0.356,2.231-0.309C933.218,722.677,933.597,722.785,933.597,722.785z\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#750C27',d:'M914.52,761.615c0.523,0.178,0.803,0.747,0.624,1.273c-0.178,0.523-0.747,0.803-1.27,0.625\t\t\t\tc-0.526-0.179-0.806-0.748-0.628-1.271C913.424,761.716,913.993,761.436,914.52,761.615z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#991F39',d:'M911.336,739.044l-0.448,0.531l-0.043,3.525l0.965,5.669L911.336,739.044z M912.369,750.163l3.407-0.24\t\t\t\tl1.544-0.738l0.073,4.137l0.474-0.252l1.716-6.818l-0.814-0.277l-2.926,2.707l-3.602,1.167L912.369,750.163z M921.925,747.245\t\t\t\tl2.491,5.014l2.27,1.574l0.413-0.326l-1.332-1.337l-2.409-5.381L921.925,747.245z M921.48,746.229l2.988-2.031l1.56-1.947\t\t\t\tl1.298,0.267l1.227,0.065l1.868,2.042l-2.011,5.208l2.581-4.622l3.221,3.172l0.5,5.226l-1.777,6.267l-7.519,12.633\t\t\t\tl-38.336-18.115l4.838-10.697l2.984-4.813l4.219-2.228l12.159,1.066l4.31-3.322l0.788,0.824l-0.576,1.819l0.761,2.178\t\t\t\tl3.902,6.622l-0.897,3.052l0.549,0.112L921.48,746.229z M918.556,757.225c0.179-0.526-0.101-1.095-0.627-1.275\t\t\t\tc-0.523-0.178-1.092,0.102-1.271,0.628c-0.178,0.523,0.102,1.092,0.625,1.27C917.809,758.028,918.378,757.748,918.556,757.225z\t\t\t\t M915.143,762.889c0.179-0.526-0.101-1.095-0.624-1.273c-0.526-0.179-1.095,0.101-1.275,0.627\t\t\t\tc-0.178,0.523,0.102,1.092,0.628,1.271C914.397,763.692,914.965,763.412,915.143,762.889z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M919.561,727.997l-0.489-0.227l-0.694,0.387l0.243-3.506l0.789-1.095l1.174-0.049l0.553,0.907\t\t\t\tl0.002,2.514l-0.463,0.23c0,0-0.297,0.789-0.425,0.863c-0.129,0.077,0.436,1.199,0.436,1.199s-0.433,0.141-0.636,0.122\t\t\t\tC919.849,729.327,919.561,727.997,919.561,727.997z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'912.369,750.163 912.241,749.848 915.842,748.682 918.768,745.975 919.582,746.252 \t\t\t\t917.866,753.07 917.392,753.322 917.319,749.185 915.776,749.923 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CB814F',points:'916.563,739.221 915.802,737.043 916.378,735.224 917.704,733.799 919.135,731.299 \t\t\t\t918.972,732.561 919.13,733.668 923.651,741.139 926.028,742.251 924.468,744.198 921.48,746.229 920.117,749.008 \t\t\t\t919.568,748.896 920.465,745.844 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'911.336,739.044 911.81,748.769 910.845,743.1 910.888,739.576 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#E4A270',d:'M918.621,724.651l-0.243,3.506l0.694-0.387l0.489,0.227c0,0,0.288,1.33,0.489,1.345\t\t\t\tc0.203,0.019,0.636-0.122,0.636-0.122s-0.565-1.122-0.436-1.199c0.128-0.074,0.425-0.863,0.425-0.863l0.463-0.23l-0.002-2.514\t\t\t\tl-0.553-0.907l-1.174,0.049L918.621,724.651z M925.088,734.511l1.489-0.892l-0.648-0.22l-0.823,0.421L925.088,734.511z\t\t\t\t M930.381,734.515l0.487-0.041l-0.973-0.406l-0.465-0.026L930.381,734.515z M933.154,722.634\t\t\t\tc-0.066-0.047-1.317,0.04-2.231,0.309c-0.913,0.266-2.241,1.416-2.241,1.416l0.145,0.43c0,0,1.71-0.579,1.936-0.605\t\t\t\tc0.226-0.026,2.236,0.042,2.236,0.042l0.598-1.442C933.597,722.785,933.218,722.677,933.154,722.634z M920.361,722.698\t\t\t\tl1.216,0.414l0.357,1.692l0.057,1.946l1.117-1.105l1.44-2.077l1.734-0.909l1.578-3.005c0,0,2.85,1.469,3.831,1.642\t\t\t\tc0.981,0.174,4.25-0.54,4.25-0.54l1.042-0.863l1.506,1.841l-0.808,2.196l-0.968,1.472l-1.114,1.693l-2.146,1.63l-0.551,0.834\t\t\t\tl0.381,5.157l-0.775,0.708l-1.566-0.106l-0.671,1.313l-3.46-1.602c0,0-0.762-0.324-0.651-0.222\t\t\t\tc0.115,0.103,0.242,0.378,0.242,0.378l0.499,1.452l2.039,1.061l1.621,0.573l0.62-0.565l0.062,0.644l-0.704,0.604l-2.597-0.706\t\t\t\tl1.07,1.824l-0.593,1.354l-2.388,0.825l-2.377-1.112l-4.521-7.471l-0.157-1.107l0.163-1.262l-1.239-0.408l-0.617-1.513\t\t\t\tl0.622-2.758l0.313-2.614l1.068-1.285L920.361,722.698z M930.578,728.098c0.257-0.578-0.003-1.258-0.584-1.516\t\t\t\tc-0.578-0.257-1.258,0.003-1.516,0.584c-0.145,0.332-0.123,0.695,0.032,0.994l1.494,0.516\t\t\t\tC930.252,728.564,930.459,728.364,930.578,728.098z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'back-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#8C9393',points:'920,754.67 920,849.13 825.5,920.12 825.5,739.91 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#516168',points:'920,728.43 920,754.67 825.5,739.91 825.5,739.88 825.5,689.74 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#5E6867',points:'825.5,739.91 825.5,920.12 737.67,920.12 737.54,739.88 825.29,739.88 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#5E5A49',points:'825.5,739.88 825.5,739.91 825.29,739.88 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#38494F',points:'825.29,739.88 737.54,739.88 737.5,689.74 825.5,689.74 825.5,739.88 \t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'back-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'back_right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#536768',points:'1216.67,878.75 1167.5,851.54 1173.51,851.54 1173.51,853 1175.92,854.41 1179.42,854.41 \t\t\t\t\t1179.8,851.54 1216.67,851.54 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#5E6867',points:'1216.75,753.74 1216.75,851.54 1216.67,851.54 1216.67,809.44 1216.67,803.64 1216.67,795.31 \t\t\t\t\t1167.5,795.31 1167.5,799.65 1167.5,851.54 1131.33,851.54 1131.33,753.74 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'1131.33',y:'726.84',fill:'#38494F',width:'85.42',height:'26.9'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#EFE7D0',points:'1216.67,795.31 1216.67,803.64 1167.5,795.31 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#434747',points:'1186.14,803.36 1216.67,809.44 1216.67,851.54 1179.8,851.54 1184.41,816.41 1184.41,816.4 \t\t\t\t\t1186.08,803.64 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#605539',points:'1186.14,803.36 1186.08,803.64 1184.41,816.4 1178.35,806.89 1178.61,801.86 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#756A4C',points:'1184.41,816.41 1179.8,851.54 1176.07,851.54 1178.35,806.89 1184.41,816.4 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#756A4C',points:'1179.8,851.54 1179.42,854.41 1175.92,854.41 1176.07,851.54 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#AFA589',points:'1178.61,801.86 1178.35,806.89 1173.51,805.5 1173.51,800.85 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C6BFA8',points:'1178.35,806.89 1176.07,851.54 1173.51,851.54 1173.51,805.5 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C6BFA8',points:'1176.07,851.54 1175.92,854.41 1173.51,853 1173.51,851.54 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#434747',points:'1173.51,805.5 1173.51,851.54 1167.5,851.54 1167.5,799.65 1173.51,800.85 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C6BFA8',points:'1173.51,800.85 1167.5,799.65 1167.5,795.31 1216.67,803.64 1216.67,809.44 1186.14,803.36 \t\t\t\t\t1178.61,801.86 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#949B9B',points:'1131.33,753.74 1131.33,851.54 1127.33,848.54 1127.33,754.37 1131.32,753.74 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#516168',points:'1131.33,726.84 1131.33,753.74 1131.32,753.74 1127.33,754.37 1127.33,728.49 \t\t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'mid-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'center_left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#949B9B',points:'737.5,726.17 737.5,986.22 722.67,997.37 722.67,723.86 737.47,726.17 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#516168',points:'737.5,653.72 737.5,726.17 737.47,726.17 722.67,723.86 722.67,647.65 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#6B7574',points:'722.67,723.86 722.67,997.37 577.5,997.37 577.5,859.33 577.5,846.08 434,846.08 434,723.75 \t\t\t\t\t464.34,723.75 468.18,813.59 484.25,812.42 484.31,812.42 551.16,811.48 547.36,761.8 547.35,761.65 545.8,723.75 \t\t\t\t\t721.96,723.75 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#38494F',points:'722.67,647.65 722.67,723.86 721.96,723.75 545.8,723.75 545.14,707.55 463.73,709.36 \t\t\t\t\t464.34,723.75 434,723.75 434,647.65 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#536768',points:'577.5,997.37 577.5,1003.25 434,1083.25 434,1038.08 502,1038.08 570,1003.15 570,997.37 \t\t\t\t\t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#5A6362',points:'577.5,859.33 577.5,997.37 570,997.37 570,869.25 570,860.82 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C6BFA8',points:'577.5,846.08 577.5,859.33 570,860.82 570,860.8 502,874.35 434.5,887.81 434,887.91 \t\t\t\t\t434,870.39 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#EFE7D0',points:'577.5,846.08 434,870.39 434,846.08 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#968E81',points:'570,997.37 570,1003.15 502,1038.08 502,997.37 508.5,997.37 508.5,1027.08 564.75,999.25 \t\t\t\t\t564.75,997.37 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#968E81',points:'570,869.25 570,997.37 564.75,997.37 564.75,941.83 564.75,936.17 564.75,876 508.5,890 \t\t\t\t\t508.5,956.22 508.5,963 508.5,997.37 502,997.37 502,886 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#898074',points:'570,860.82 570,869.25 502,886 502,874.37 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#AFA784',points:'570,860.8 570,860.82 502,874.37 502,874.35 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C6BFA8',points:'564.75,997.37 564.75,999.25 508.5,1027.08 508.5,997.37 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#C6BFA8',d:'M564.75,941.83v55.54H508.5V963L564.75,941.83z M543.17,980.79c0-2.8-1.61-5.06-3.59-5.06\t\t\t\t\tc-1.98,0-3.58,2.26-3.58,5.06c0,2.79,1.6,5.06,3.58,5.06C541.56,985.85,543.17,983.58,543.17,980.79z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#968E81',points:'564.75,936.17 564.75,941.83 508.5,963 508.5,956.22 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#C6BFA8',d:'M564.75,876v60.17l-56.25,20.05V890L564.75,876z M543.17,915.06c0-2.8-1.61-5.06-3.59-5.06\t\t\t\t\tc-1.98,0-3.58,2.26-3.58,5.06c0,2.79,1.6,5.06,3.58,5.06C541.56,920.12,543.17,917.85,543.17,915.06z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#5A6362',points:'547.36,761.8 551.16,811.48 484.31,812.42 529.76,809.12 549.3,809.31 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#949B9B',points:'547.35,761.65 547.36,761.8 549.3,809.31 529.76,809.12 520.75,780 483,740.88 472.53,723.75 \t\t\t\t\t545.8,723.75 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#889191',points:'545.14,707.55 545.8,723.75 472.53,723.75 463.73,709.36 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#5E5A49',d:'M539.58,910c1.98,0,3.59,2.26,3.59,5.06c0,2.79-1.61,5.06-3.59,5.06c-1.98,0-3.58-2.27-3.58-5.06\t\t\t\t\tC536,912.26,537.6,910,539.58,910z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#5E5A49',d:'M539.58,975.73c1.98,0,3.59,2.26,3.59,5.06c0,2.79-1.61,5.06-3.59,5.06c-1.98,0-3.58-2.27-3.58-5.06\t\t\t\t\tC536,977.99,537.6,975.73,539.58,975.73z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#747F7F',points:'520.75,780 529.76,809.12 484.31,812.42 484.25,812.42 468.18,813.59 464.34,723.75 \t\t\t\t\t472.53,723.75 483,740.88 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'434',y:'997.37',fill:'#7F7869',width:'68',height:'40.71'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#7F7869',points:'502,886 502,997.37 434,997.37 434,975.73 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#70665B',points:'502,874.37 502,886 434,975.73 434,887.91 434.5,887.81 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#AFA784',points:'502,874.35 502,874.37 434.5,887.81 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#747F7F',points:'472.53,723.75 464.34,723.75 463.73,709.36 \t\t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'computer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#182528',points:'1264.006,787.555 1204.114,784.306 1204.114,736.492 1264.006,724.987 \t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#E5E2D8',points:'1261.047,782.882 1206.591,781.405 1206.591,739.464 1261.047,730.624 \t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'computer_1_'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#182528',points:'329.625,804.93 493.575,799.559 493.575,676.03 329.625,665.932 \t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#E5E2D8',points:'340.343,794.325 483.95,790.973 483.95,685.777 340.343,677.724 \t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'kenny4',ref:'kenny4',className:'kenny '+(this.state.kenny4?'kenny4':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#3A2B15',points:'1580.503,415.681 1579.105,422.545 1580.227,422.943 1581.852,420.029 1586.809,415.544 \t\t\t\t1587.446,414.225 1585.705,409.515 1584.51,409.886 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M1585.88,429.257c-1.996,0.607-3.102,2.717-2.495,4.713c0.289,0.915,0.893,1.644,1.646,2.101l5.082-1.109\t\t\t\tc0.62-0.909,0.825-2.091,0.48-3.223C1589.973,429.744,1587.863,428.638,1585.88,429.257z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'1587.362,491.943 1591.413,511.626 1590.094,490.476 1589.121,491.047 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M1583.035,407.359l-5.103-1.642l-1.019,3.17l0.36,6.519c0,0,0.229,4.628,0.401,7.222l1.431-0.082\t\t\t\tl1.399-6.864l4.007-5.795l1.195-0.372l1.741,4.71l1.882-0.527l-1.817-6.436l-0.411-8.872l7.558-4.938l-2.516-3.887l-11.556,7.61\t\t\t\tl-0.781,6.416L1583.035,407.359z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'1591.953,526.42 1593.077,528.072 1603.093,524.975 1617.847,509.68 1613.182,506.391 \t\t\t\t1598.305,523.108 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFFFFF',points:'1595.275,464.564 1596.871,467.319 1603.392,467.1 1611.985,465.594 1615.453,460.912 \t\t\t\t1603.559,463.001 1594.544,463.313 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#A86538',points:'1600.083,453.223 1601.813,453.928 1605.792,453.303 1604.08,452.867 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CB814F',points:'1608.713,486.909 1612.13,495.741 1620.62,506.523 1622.37,518.13 1624.486,518.353 \t\t\t\t1624.735,506.28 1646.436,486.777 1651.683,479.765 1651.679,472.522 1648.513,465.847 1646.194,455.161 1645.338,459.915 \t\t\t\t1643.502,463.743 1618.589,485.606 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M1612.291,425.661c-2.4,0.27-4.119,2.432-3.849,4.819c0.126,1.098,0.646,2.059,1.416,2.746l5.998-0.156\t\t\t\tc0.902-0.903,1.398-2.193,1.253-3.559C1616.84,427.11,1614.678,425.391,1612.291,425.661z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M1612.249,416.102c0.789,0.367,6.315,4.405,6.315,4.405l1.019-1.392c0,0-3.49-5.683-6.489-7.69\t\t\t\tc-3-2.021-7.427-3.754-7.72-3.671c-0.28,0.083-1.778,0.039-1.778,0.039l0.513,5.901\t\t\t\tC1604.109,413.695,1611.461,415.748,1612.249,416.102z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CB814F',points:'1616.605,455.038 1620.974,459.972 1621.699,457.448 1619.201,454.982 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M1585.03,436.071c-0.752-0.457-1.357-1.186-1.646-2.101c-0.607-1.996,0.499-4.106,2.495-4.713\t\t\t\tc1.983-0.619,4.093,0.487,4.712,2.482c0.345,1.131,0.14,2.313-0.48,3.223L1585.03,436.071z M1581.39,434.026l0.368,12.162\t\t\t\tl2.185,8.066l5.815,19.619l9.436,11.35l4.517,1.168l5.002,0.518l-7.701-5.719l-0.595-5.579l5.961-5.377l-10.208-0.417\t\t\t\tl-1.857-2.992l0.962-2.26l-0.731-1.251l9.015-0.312l11.894-2.089c0,0,0.775-0.849,1.307-1.091\t\t\t\tc0.519-0.242-2.609,0.057-2.609,0.057l-14.357,1.836l-0.927-5.521l-5.789-1.409l-1.995-3.45l7.281-18.228l-1.039-3.65\t\t\t\tl-5.902-8.356l-2.094-7.402l-1.882,0.527l-0.637,1.319l-4.957,4.485l-1.626,2.915l-1.122-0.398l-1.431,0.082\t\t\t\tc0.042,0.78,0.081,1.38,0.112,1.61C1577.922,425.22,1581.39,434.026,1581.39,434.026z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#750C27',d:'M1622.345,545.759c-2.11,0.046-3.775,1.784-3.729,3.895c0.046,2.098,1.784,3.762,3.895,3.716\t\t\t\tc2.098-0.046,3.762-1.784,3.716-3.882C1626.181,547.378,1624.443,545.714,1622.345,545.759z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#750C27',d:'M1628.201,570.164c-2.098,0.046-3.762,1.784-3.716,3.895c0.046,2.098,1.784,3.762,3.882,3.716\t\t\t\tc2.11-0.046,3.775-1.784,3.729-3.882C1632.05,571.782,1630.312,570.118,1628.201,570.164z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M1645.908,442.025c0.38,0.427-2.949,3.839-2.949,3.839s1.404,1.006,2.163,1.169\t\t\t\tc0.746,0.176,3.31-4.308,3.31-4.308l2.029-0.262l2.07,2.194l3.134-12.968l-1.603-4.866l-4.192-1.521l-3.039,2.651l-2.886,9.098\t\t\t\tl1.412,1.364C1645.355,438.415,1645.527,441.611,1645.908,442.025z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'1649.093,531.176 1649.916,530.198 1638.217,521.841 1630.725,508.696 1627.464,508.767 \t\t\t\t1625.869,535.407 1627.296,536.86 1632.294,521.97 1637.037,526.41 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#991F39',d:'M1617.847,509.68l-14.754,15.294l-10.016,3.098l-1.124-1.652l6.352-3.312l14.877-16.717L1617.847,509.68z\t\t\t\t M1624.486,518.353l-2.116-0.223l-1.75-11.607l-8.489-10.782l-3.417-8.832l-5.002-0.518l-4.517-1.168l-9.099,5.253l1.319,21.15\t\t\t\tl-4.051-19.683l-15.289,7.794l-7.79,18.342l-0.741,24.714l12.753,54.327l159.477-21.688l-5.265-44.253l-5.292-20.833\t\t\t\tl-12.72-12.891l-45.227-10.058l-11.797-16.955l-3.794,2.079l0.004,7.243l-5.247,7.012l-21.701,19.502L1624.486,518.353z\t\t\t\t M1638.217,521.841l11.7,8.357l-0.823,0.978l-12.056-4.766l-4.742-4.44l-4.999,14.89l-1.427-1.453l1.595-26.64l3.262-0.071\t\t\t\tL1638.217,521.841z M1665.556,492.119l1.013,2.435l-3.88,12.805l-9.981,19.413L1665.556,492.119z M1618.617,549.654\t\t\t\tc-0.046-2.111,1.618-3.849,3.729-3.895c2.098-0.046,3.836,1.618,3.882,3.729c0.046,2.098-1.618,3.836-3.716,3.882\t\t\t\tC1620.401,553.416,1618.662,551.752,1618.617,549.654z M1624.485,574.058c-0.046-2.11,1.618-3.849,3.716-3.895\t\t\t\tc2.111-0.046,3.849,1.618,3.895,3.729c0.046,2.098-1.618,3.836-3.729,3.882C1626.269,577.82,1624.531,576.156,1624.485,574.058z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'1665.556,492.119 1652.708,526.772 1662.689,507.359 1666.569,494.554 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M1579.805,403.591l0.781-6.416l11.556-7.61l2.516,3.887l2.781,4.316c0,0,11.015,6.325,14.763,6.819\t\t\t\tc3.747,0.494,15.745-1.559,15.745-1.559l2.273,12.684l5.234,5.273l2.836,9.165l2.777,5.276l2.433-6.976l3.228-5.714l4.873-0.106\t\t\t\tl0.946-6.483l2.45-9.715l-2.039-15.466l4.106,1.664l-6.028-8.827l-16.771-17.32l-22.037-1.772l-21.296,6.377l-4.642,8.931\t\t\t\tc0,0-5.74-0.911-8.118-0.22c-2.391,0.692-8.515,9.144-8.515,9.144l3.007,16.993l4.609,9.472l-0.36-6.519l1.019-3.17l5.103,1.642\t\t\t\tL1579.805,403.591z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#E4A270',d:'M1605.374,407.755c0.292-0.083,4.72,1.65,7.72,3.671c3,2.008,6.489,7.69,6.489,7.69l-1.019,1.392\t\t\t\tc0,0-5.527-4.039-6.315-4.405c-0.788-0.354-8.14-2.408-8.14-2.408l-0.513-5.901\t\t\t\tC1603.596,407.794,1605.095,407.838,1605.374,407.755z M1601.813,453.928l-1.73-0.705l3.998-0.356l1.712,0.436L1601.813,453.928z\t\t\t\t M1620.974,459.972l-4.369-4.934l2.597-0.057l2.498,2.467L1620.974,459.972z M1643.5,428.448l-2.433,6.976l-2.777-5.276\t\t\t\tl-2.836-9.165l-5.234-5.273l-2.273-12.684c0,0-11.997,2.053-15.745,1.559c-3.748-0.494-14.763-6.819-14.763-6.819l-2.781-4.316\t\t\t\tl-7.558,4.938l0.411,8.872l1.817,6.436l2.094,7.402l5.902,8.356l1.039,3.65l-7.281,18.228l1.995,3.45l5.789,1.409l0.927,5.521\t\t\t\tl14.357-1.836c0,0,3.129-0.299,2.609-0.057c-0.532,0.242-1.307,1.091-1.307,1.091l-3.468,4.683l-8.592,1.505l-6.522,0.219\t\t\t\tl-1.596-2.755l-0.962,2.26l1.857,2.992l10.208,0.417l-5.961,5.377l0.595,5.579l7.701,5.719l9.877-1.303l24.912-21.863\t\t\t\tl1.836-3.828l0.856-4.754l4.951-0.057l3.965-4.77l0.906-10.692l1.859-9.818l-2.393-5.873l-3.881-1.323l-4.873,0.106\t\t\t\tL1643.5,428.448z M1654.061,426.823l1.603,4.866l-3.134,12.968l-2.07-2.194l-2.029,0.262c0,0-2.564,4.484-3.31,4.308\t\t\t\tc-0.759-0.163-2.163-1.169-2.163-1.169s3.33-3.413,2.949-3.839c-0.38-0.414-0.552-3.61-0.552-3.61l-1.412-1.364l2.886-9.098\t\t\t\tl3.039-2.651L1654.061,426.823z M1608.442,430.48c-0.27-2.387,1.449-4.549,3.849-4.819c2.387-0.27,4.549,1.449,4.819,3.849\t\t\t\tc0.145,1.366-0.352,2.657-1.253,3.559l-5.998,0.156C1609.089,432.539,1608.568,431.578,1608.442,430.48z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'kenny1',ref:'kenny1',className:'kenny '+(this.state.kenny1?'kenny1':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M510.742,642.315l-9.194,17.599l-8.342,8.792l2.656-7.026l-0.018-3.831l-6.168,0.031l4.851-3.014\t\t\t\tl1.368-7.309l-10.037-12.358l-4.109,3.391l-4.549,3.77c0,0-14.279,3.117-18.561,2.359c-4.283-0.758-16.732-7.173-16.732-7.173\t\t\t\tl-6.894,13.126l-7.571,3.969l-6.291,9.07l-4.877,4.824l-0.249-8.497l-1.559-7.388l-5.309-1.807l1.211-7.441l0.683-11.508\t\t\t\tl7.603-16.259l-5.081,0.401l9.675-7.592l24.407-13.183l24.79,5.701l21.151,14.383l1.995,11.409c0,0,6.613,0.992,8.987,2.561\t\t\t\tC506.955,630.919,510.742,642.315,510.742,642.315z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#3A2B15',points:'489.567,667.887 488.72,675.903 487.356,675.936 486.579,672.188 482.697,665.549 \t\t\t\t482.456,663.881 485.999,659.318 487.181,660.14 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M478.959,680.915c1.979,1.358,2.46,4.056,1.102,6.035c-0.634,0.904-1.55,1.494-2.534,1.734l-5.19-2.98\t\t\t\tc-0.365-1.213-0.179-2.58,0.591-3.702C474.3,680.029,476.999,679.548,478.959,680.915z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'455.586,749.17 444.314,769.358 453.098,746.613 453.967,747.577 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M480.574,662.649l4.226-6.43l3.529-9.591l-6.578-8.039l4.109-3.391l10.037,12.358l-1.368,7.309\t\t\t\tl-4.851,3.014l6.168-0.031l0.018,3.831l-2.656,7.026c0,0-1.856,4.997-2.945,7.783l-1.542-0.587l0.847-8.016l-2.386-7.747\t\t\t\tl-1.182-0.822l-3.544,4.563L480.574,662.649z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'438.588,785.401 436.783,786.824 426.869,779.95 415.988,758.053 422.248,756.063 \t\t\t\t432.769,779.564 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFFFFF',points:'447.858,711.801 457.639,715.27 456.403,716.389 453.697,718.858 446.618,716.355 \t\t\t\t437.714,711.723 435.534,705.382 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#A86538',points:'455.064,702.28 452.921,702.453 448.772,700.388 450.801,700.503 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CB814F',points:'433.909,736.241 427.096,744.745 414.043,753.628 408.096,765.754 405.697,765.264 \t\t\t\t409.612,751.933 392.571,723.01 389.247,713.497 391.765,705.552 397.553,699.328 403.805,688.409 403.095,693.921 \t\t\t\t403.781,698.757 423.527,731.385 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M451.232,667.807c2.539,1.129,3.675,4.097,2.551,6.622c-0.519,1.161-1.423,2.035-2.507,2.521\t\t\t\tl-6.526-2.253c-0.676-1.303-0.773-2.891-0.14-4.34C445.739,667.819,448.707,666.684,451.232,667.807z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CB814F',points:'436.308,698.54 429.804,702.437 429.883,699.416 433.479,697.577 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M480.061,686.951c1.358-1.979,0.877-4.678-1.102-6.035c-1.96-1.367-4.659-0.886-6.031,1.088\t\t\t\tc-0.771,1.122-0.956,2.489-0.591,3.702l5.19,2.98C478.511,688.444,479.427,687.854,480.061,686.951z M434.478,703.732\t\t\t\tc-0.486-0.445,2.843,0.968,2.843,0.968l15.113,6.995l2.932-5.735l6.84,0.462l3.385-3.093l-1.664-22.523l2.407-3.644l9.374-7.119\t\t\t\tl4.865-7.394l1.882,1.232l0.241,1.668l3.882,6.64l0.777,3.748l1.364-0.033l1.542,0.587c-0.317,0.841-0.568,1.486-0.681,1.727\t\t\t\tc-0.491,1.03-7.35,9.487-7.35,9.487l-4.622,13.215l-5.195,8.09l-13.186,19.505l-14.289,9.178l-5.361-0.285l-5.667-1.167\t\t\t\tl10.432-3.602l2.593-5.928l-4.679-7.953l11.344,3.084l3.075-2.639l-0.271-2.813l1.236-1.119l-9.782-3.47l-12.324-6.418\t\t\t\tC435.534,705.382,434.978,704.183,434.478,703.732z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#750C27',d:'M398.537,796.073c2.299,0.783,3.522,3.267,2.739,5.566c-0.778,2.285-3.262,3.508-5.562,2.725\t\t\t\tc-2.285-0.778-3.508-3.262-2.73-5.548C393.768,796.518,396.252,795.295,398.537,796.073z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M464.36,657.519c0,0-8.778-0.298-9.765-0.183c-0.988,0.115-8.457,2.642-8.457,2.642l-0.635-1.88\t\t\t\tc0,0,5.8-5.023,9.787-6.185c3.992-1.176,9.455-1.555,9.743-1.349c0.278,0.188,1.937,0.659,1.937,0.659L464.36,657.519z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#750C27',d:'M383.647,820.814c2.285,0.778,3.508,3.262,2.725,5.562c-0.778,2.285-3.262,3.508-5.548,2.73\t\t\t\tc-2.299-0.783-3.522-3.267-2.744-5.552C378.863,821.254,381.348,820.032,383.647,820.814z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#991F39',d:'M398.263,783.493l7.493-29.778l-3.554-1.21l-12.779,11.822l-15.73,5.096l0.559,1.372l14.88-1.046\t\t\t\tl6.743-3.225l0.318,18.069L398.263,783.493z M392.571,723.01l17.041,28.924l-3.916,13.331l2.399,0.49l5.947-12.126l13.054-8.883\t\t\t\tl6.813-8.504l5.667,1.167l5.361,0.285l8.16,8.92l-8.784,22.745l11.272-20.188l14.069,13.854l2.183,22.824l-7.761,27.37\t\t\t\tl-32.838,55.175l-167.43-79.119l21.128-46.721l13.033-21.019l18.426-9.729l53.105,4.656l18.824-14.507l3.441,3.597l-2.518,7.944\t\t\t\tL392.571,723.01z M415.988,758.053l10.88,21.897l9.914,6.873l1.806-1.422l-5.819-5.837l-10.521-23.501L415.988,758.053z\t\t\t\t M369.743,722.237l-1.956,2.32l-0.186,15.394l4.214,24.76L369.743,722.237z M401.277,801.64c0.783-2.299-0.44-4.784-2.739-5.566\t\t\t\tc-2.285-0.778-4.77,0.445-5.552,2.744c-0.778,2.285,0.445,4.77,2.73,5.548C398.014,805.148,400.499,803.925,401.277,801.64z\t\t\t\t M386.372,826.376c0.783-2.299-0.44-4.784-2.725-5.562c-2.299-0.783-4.784,0.44-5.566,2.739c-0.778,2.285,0.445,4.77,2.744,5.552\t\t\t\tC383.11,829.884,385.594,828.661,386.372,826.376z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'405.756,753.715 398.263,783.493 396.194,784.593 395.876,766.524 389.133,769.749 \t\t\t\t374.253,770.795 373.694,769.423 389.423,764.328 402.202,752.505 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M408.676,674.097c-0.565,0.336,1.903,5.235,1.903,5.235s-1.889,0.617-2.778,0.532\t\t\t\tc-0.879-0.066-2.137-5.874-2.137-5.874l-2.135-0.991l-3.032,1.689l1.061-15.314l3.447-4.782l5.127-0.214l2.414,3.963l0.01,10.982\t\t\t\tl-2.022,1.007C410.534,670.329,409.237,673.775,408.676,674.097z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'369.743,722.237 371.815,764.71 367.601,739.95 367.787,724.556 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#E4A270',d:'M429.804,702.437l6.505-3.897l-2.829-0.963l-3.596,1.839L429.804,702.437z M401.559,659.374\t\t\t\tl-1.061,15.314l3.032-1.689l2.135,0.991c0,0,1.257,5.808,2.137,5.874c0.889,0.085,2.778-0.532,2.778-0.532\t\t\t\ts-2.469-4.899-1.903-5.235c0.561-0.322,1.858-3.768,1.858-3.768l2.022-1.007l-0.01-10.982l-2.414-3.963l-5.127,0.214\t\t\t\tL401.559,659.374z M466.969,651.223c0,0-1.659-0.471-1.937-0.659c-0.287-0.207-5.75,0.173-9.743,1.349\t\t\t\tc-3.988,1.162-9.787,6.185-9.787,6.185l0.635,1.88c0,0,7.469-2.527,8.457-2.642c0.988-0.115,9.765,0.183,9.765,0.183\t\t\t\tL466.969,651.223z M452.921,702.453l2.142-0.173l-4.262-1.777l-2.029-0.115L452.921,702.453z M437.321,704.7\t\t\t\tc0,0-3.329-1.413-2.843-0.968c0.5,0.45,1.056,1.65,1.056,1.65l2.18,6.34l8.904,4.632l7.079,2.503l2.706-2.469l0.271,2.813\t\t\t\tl-3.075,2.639l-11.344-3.084l4.679,7.953l-2.593,5.928l-10.432,3.602l-10.383-4.856l-19.745-32.628l-0.686-4.836l0.71-5.512\t\t\t\tl-5.412-1.78l-2.695-6.609l2.716-12.044l1.366-11.415l4.663-5.613l4.716-0.105l5.309,1.807l1.559,7.388l0.249,8.497l4.877-4.824\t\t\t\tl6.291-9.07l7.571-3.969l6.894-13.126c0,0,12.449,6.415,16.732,7.173c4.283,0.758,18.561-2.359,18.561-2.359l4.549-3.77\t\t\t\tl6.578,8.039l-3.529,9.591l-4.226,6.43l-4.865,7.394l-9.374,7.119l-2.407,3.644l1.664,22.523l-3.385,3.093l-6.84-0.462\t\t\t\tl-2.932,5.735L437.321,704.7z M453.783,674.429c1.124-2.525-0.012-5.493-2.551-6.622c-2.525-1.124-5.493,0.012-6.622,2.551\t\t\t\tc-0.633,1.448-0.536,3.036,0.14,4.34l6.526,2.253C452.36,676.464,453.264,675.59,453.783,674.429z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'kenny5',ref:'kenny5',className:'kenny '+(this.state.kenny5?'kenny5':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#3A2B15',points:'1188.925,740.265 1189.861,742.211 1190.211,742.1 1190.067,741.081 1190.448,739.056 \t\t\t\t1190.358,738.614 1189.053,737.782 1188.829,738.096 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M1192.775,742.596c-0.377,0.521-0.255,1.245,0.266,1.622c0.241,0.171,0.526,0.237,0.796,0.209\t\t\t\tl1.041-1.219c-0.017-0.339-0.187-0.667-0.483-0.881C1193.87,741.953,1193.146,742.075,1192.775,742.596z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'1204.82,757.71 1209.482,761.788 1205.217,756.841 1205.085,757.162 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M1187.996,737.75l-1.559,0.548l0.341,0.968l1.303,1.533c0,0,0.918,1.093,1.444,1.698l0.336-0.287\t\t\t\tl-0.936-1.946l-0.096-2.169l0.224-0.314l1.305,0.832l0.364-0.48l-1.645-1.241l-1.754-2.102l0.935-2.621l-1.342-0.485\t\t\t\tl-1.419,4.022l1.004,1.721L1187.996,737.75z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'1212.371,765.319 1212.955,765.515 1214.837,762.888 1215.609,756.384 1213.851,756.446 \t\t\t\t1213.314,763.323 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFFFFF',points:'1201.661,749.514 1202.566,749.893 1204.126,748.624 1205.955,746.653 1205.934,744.857 \t\t\t\t1203.403,747.587 1201.248,749.343 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#A86538',points:'1200.728,745.834 1201.284,745.684 1202.144,744.79 1201.643,745.001 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CB814F',points:'1209.124,752.496 1211.608,754.027 1215.702,755.092 1218.294,757.616 1218.855,757.276 \t\t\t\t1216.667,754.266 1218.36,745.434 1218.342,742.735 1216.991,740.957 1214.97,739.908 1212.41,737.717 1213.085,739.044 \t\t\t\t1213.348,740.326 1211.306,750.335 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M1198.589,736.792c-0.539,0.513-0.558,1.365-0.047,1.9c0.235,0.246,0.542,0.385,0.859,0.41l1.444-1.156\t\t\t\tc0.053-0.39-0.065-0.799-0.356-1.107C1199.976,736.3,1199.125,736.281,1198.589,736.792z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M1196.798,734.453c0.262-0.057,2.371-0.095,2.371-0.095l-0.009-0.531c0,0-1.916-0.745-3.026-0.679\t\t\t\tc-1.113,0.063-2.523,0.462-2.579,0.537c-0.053,0.072-0.429,0.341-0.429,0.341l1.225,1.353\t\t\t\tC1194.351,735.379,1196.538,734.513,1196.798,734.453z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CB814F',points:'1205.122,743.201 1207.114,743.598 1206.822,742.843 1205.749,742.703 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M1193.836,744.427c-0.27,0.028-0.554-0.038-0.796-0.209c-0.521-0.377-0.643-1.101-0.266-1.622\t\t\t\tc0.371-0.521,1.096-0.643,1.62-0.269c0.295,0.214,0.465,0.542,0.483,0.881L1193.836,744.427z M1192.561,744.604l2.357,2.917\t\t\t\tl2.039,1.573l5.083,3.733l4.432,1.028l1.327-0.555l1.325-0.805l-2.956,0.031l-1.186-1.259l0.462-2.431l-2.584,1.8l-1.013-0.389\t\t\t\tl-0.185-0.734l-0.413-0.171l2.155-1.756l2.531-2.729c0,0,0.032-0.353,0.118-0.511c0.083-0.156-0.63,0.5-0.63,0.5l-3.183,3.126\t\t\t\tl-1.256-1.183l-1.684,0.733l-1.133-0.475l-1.609-5.832l-0.935-0.702l-3.006-0.952l-1.893-1.427l-0.364,0.48l0.09,0.443\t\t\t\tl-0.381,2.025l0.144,1.019l-0.35,0.111l-0.336,0.287c0.156,0.183,0.277,0.324,0.327,0.374\t\t\t\tC1190.069,743.088,1192.561,744.604,1192.561,744.604z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#750C27',d:'M1223.437,764.404c-0.51,0.405-0.594,1.141-0.19,1.651c0.402,0.506,1.139,0.591,1.649,0.187\t\t\t\tc0.506-0.402,0.591-1.139,0.189-1.645C1224.68,764.086,1223.943,764.002,1223.437,764.404z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#750C27',d:'M1229.422,769.304c-0.506,0.402-0.591,1.139-0.187,1.649c0.402,0.507,1.139,0.591,1.646,0.189\t\t\t\tc0.51-0.405,0.594-1.141,0.192-1.648C1230.668,768.984,1229.932,768.9,1229.422,769.304z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M1209.891,734.545c0.173,0.034-0.009,1.492-0.009,1.492s0.532-0.015,0.749-0.116\t\t\t\tc0.216-0.096,0.01-1.674,0.01-1.674l0.449-0.442l0.917,0.153l-1.647-3.768l-1.3-0.896l-1.313,0.408l-0.252,1.217l0.987,2.771\t\t\t\tl0.601,0.072C1209.083,733.762,1209.721,734.515,1209.891,734.545z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'1227.286,755.839 1227.306,755.446 1222.876,755.574 1218.588,753.743 1217.8,754.368 \t\t\t\t1222.373,761.206 1222.994,761.296 1221.447,756.709 1223.438,756.916 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#991F39',d:'M1215.609,756.384l-0.772,6.504l-1.882,2.627l-0.584-0.196l0.942-1.997l0.537-6.876L1215.609,756.384z\t\t\t\t M1218.855,757.276l-0.561,0.34l-2.593-2.523l-4.093-1.065l-2.485-1.532l-1.325,0.805l-1.327,0.555l-1.255,2.985l4.265,4.947\t\t\t\tl-4.662-4.078l-2.301,4.762l1.505,5.955l4.423,6.206l13.254,10.961l35.112-35.042l-9.539-9.883l-5.181-4.129l-5.525-0.795\t\t\t\tl-12.978,5.958l-6.056-1.964l-0.544,1.217l1.351,1.777l0.018,2.699l-1.694,8.832L1218.855,757.276z M1222.876,755.574l4.43-0.128\t\t\t\tl-0.02,0.393l-3.848,1.076l-1.991-0.206l1.547,4.587l-0.621-0.091l-4.573-6.837l0.787-0.625L1222.876,755.574z M1224.05,743.183\t\t\t\tl0.702,0.409l1.434,3.867l1.167,6.626L1224.05,743.183z M1223.247,766.055c-0.405-0.51-0.32-1.246,0.19-1.651\t\t\t\tc0.506-0.402,1.243-0.318,1.648,0.192c0.402,0.506,0.318,1.243-0.189,1.645C1224.386,766.646,1223.649,766.561,1223.247,766.055z\t\t\t\t M1229.235,770.953c-0.405-0.51-0.32-1.246,0.187-1.649c0.51-0.405,1.246-0.32,1.651,0.19c0.402,0.507,0.317,1.243-0.192,1.648\t\t\t\tC1230.374,771.544,1229.637,771.459,1229.235,770.953z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'1224.05,743.183 1227.353,754.084 1226.186,747.458 1224.752,743.592 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M1186.501,737.427l-1.004-1.721l1.419-4.022l1.342,0.485l1.487,0.541c0,0,3.883-0.5,4.895-1.077\t\t\t\tc1.012-0.577,3.575-3.317,3.575-3.317l2.922,2.69l2.268,0.319l2.404,1.722l1.665,0.778l-0.703-2.166l-0.272-2.004l1.177-0.934\t\t\t\tl-0.976-1.768l-1.209-2.842l-3.382-3.417l1.318-0.357l-3.125-1.044l-7.345-1.127l-5.74,3.671l-4.04,5.534l0.525,3.058\t\t\t\tc0,0-1.579,0.846-2.034,1.459c-0.458,0.615-0.387,3.832-0.387,3.832l3.905,3.612l2.896,1.467l-1.303-1.533l-0.341-0.968\t\t\t\tl1.559-0.548L1186.501,737.427z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#E4A270',d:'M1193.554,733.685c0.056-0.075,1.466-0.474,2.579-0.537c1.111-0.066,3.026,0.679,3.026,0.679l0.009,0.531\t\t\t\tc0,0-2.109,0.038-2.371,0.095c-0.26,0.06-2.447,0.926-2.447,0.926l-1.225-1.353\t\t\t\tC1193.125,734.026,1193.501,733.757,1193.554,733.685z M1201.284,745.684l-0.556,0.149l0.915-0.832l0.501-0.212L1201.284,745.684\t\t\t\tz M1207.114,743.598l-1.992-0.397l0.627-0.498l1.073,0.14L1207.114,743.598z M1206.771,731.661l0.703,2.166l-1.665-0.778\t\t\t\tl-2.404-1.722l-2.268-0.319l-2.922-2.69c0,0-2.563,2.74-3.575,3.317c-1.012,0.577-4.895,1.077-4.895,1.077l-1.487-0.541\t\t\t\tl-0.935,2.621l1.754,2.102l1.645,1.241l1.893,1.427l3.006,0.952l0.935,0.702l1.609,5.832l1.133,0.475l1.684-0.733l1.256,1.183\t\t\t\tl3.183-3.126c0,0,0.713-0.656,0.63-0.5c-0.086,0.159-0.118,0.511-0.118,0.511l0.021,1.796l-1.829,1.971l-1.56,1.269l-0.905-0.379\t\t\t\tl0.185,0.734l1.013,0.389l2.584-1.8l-0.462,2.431l1.186,1.259l2.956-0.031l2.182-2.16l2.042-10.01l-0.262-1.282l-0.676-1.327\t\t\t\tl1.205-0.937l0.085-1.91l-1.77-2.794l-1.373-2.757l-1.682-0.996l-1.199,0.398l-1.177,0.934L1206.771,731.661z M1209.061,729.294\t\t\t\tl1.3,0.896l1.647,3.768l-0.917-0.153l-0.449,0.442c0,0,0.206,1.579-0.01,1.674c-0.217,0.101-0.749,0.116-0.749,0.116\t\t\t\ts0.182-1.458,0.009-1.492c-0.17-0.031-0.808-0.783-0.808-0.783l-0.601-0.072l-0.987-2.771l0.252-1.217L1209.061,729.294z\t\t\t\t M1198.542,738.692c-0.511-0.536-0.492-1.387,0.047-1.9c0.536-0.511,1.387-0.492,1.9,0.047c0.29,0.308,0.409,0.718,0.356,1.107\t\t\t\tl-1.444,1.156C1199.084,739.077,1198.778,738.938,1198.542,738.692z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'front'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#536768',points:'2048,1246 2048,1291.5 1791.5,1291.5 1728,1246 1737,1246 1745.23,1251.16 1761.67,1251.16 \t\t\t\t1762.09,1246 1778.16,1246 1778.88,1273.35 1791.5,1281.67 1818.33,1281.67 1822.02,1246 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#5E6867',points:'2048,1001.5 2048,1246 1822.02,1246 1847.33,1001.5 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#877D5C',points:'2048,951.87 2048,1001.5 1847.33,1001.5 1791.5,1001.5 1791.5,951.87 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#EFE7D0',points:'2048,938.96 2048,951.87 1791.5,951.87 1736.67,938.96 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#788281',points:'2048,671.9 2048,938.96 1736.67,938.96 1736.72,985.16 1737,1246 1728,1246 1657,1246 \t\t\t\t1656.22,671.9 1769.94,671.9 1777.73,866.08 1782.52,865.99 1782.7,869.05 1833.19,865 1833.22,865 1973.68,859.86 \t\t\t\t1973.69,853.73 1982.35,853.04 1974.25,721.1 1974.25,671.9 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#38494F',points:'2048,511 2048,671.9 1974.25,671.9 1974.25,610.27 1967.45,610.27 1967,603 1919.23,608.38 \t\t\t\t1767.42,612.89 1767.91,621.17 1769.94,671.9 1656.22,671.9 1656,511 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#B2B0A3',points:'1974.25,721.1 1982.35,853.04 1973.69,853.73 1833.22,865 1833.19,865 1782.7,869.05 1828,801.5 \t\t\t\t1875.81,671.9 1971.23,671.9 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#5E6867',points:'1974.25,671.9 1974.25,721.1 1971.23,671.9 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#2E3E42',points:'1974.25,610.27 1974.25,671.9 1971.23,671.9 1967.45,610.27 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#5E6867',points:'1973.69,853.73 1973.68,859.86 1833.22,865 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#B2B0A3',points:'1967.45,610.27 1971.23,671.9 1875.81,671.9 1877.25,668 1919.23,608.38 1967,603 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#949B9B',points:'1919.23,608.38 1877.25,668 1875.81,671.9 1770.94,671.9 1767.91,621.17 1767.42,612.89 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#949B9B',points:'1875.81,671.9 1828,801.5 1782.7,869.05 1782.52,865.99 1770.94,671.9 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#877D5C',points:'1822.02,1246 1818.33,1281.67 1791.5,1281.67 1791.5,1001.5 1847.33,1001.5 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C6BFA8',points:'1778.16,1246 1774.23,1095.64 1771.62,995.67 1791,1001.5 1791.5,1001.5 1791.5,1281.67 \t\t\t\t1778.88,1273.35 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C6BFA8',points:'1791.5,951.87 1791.5,1001.5 1791,1001.5 1771.62,995.67 1756.19,991.02 1736.72,985.16 \t\t\t\t1736.67,938.96 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#5E6867',points:'1770.94,671.9 1782.52,865.99 1777.73,866.08 1769.94,671.9 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#5E6867',points:'1774.23,1095.64 1778.16,1246 1762.09,1246 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#756A4C',points:'1762.09,1246 1761.67,1251.16 1745.23,1251.16 1756.19,991.02 1771.62,995.67 1774.23,1095.64 \t\t\t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#38494F',points:'1767.91,621.17 1770.94,671.9 1769.94,671.9 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C6BFA8',points:'1756.19,991.02 1745.23,1251.16 1737,1246 1736.72,985.16 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#949B9B',points:'1311.5,739.52 1311.5,725.62 1655.7,671.9 1656.22,671.9 1657,1246 1311.5,986.74 1311.5,919.95 \t\t\t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#516168',points:'1656,511 1656.22,671.9 1655.7,671.9 1311.5,725.62 1311.5,689.34 1311.5,652.72 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'1222.5',y:'739.52',fill:'#6B7574',width:'89',height:'180.43'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#38494F',points:'1311.5,725.62 1311.5,739.52 1222.5,739.52 1222.5,689.34 1311.5,689.34 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#949B9B',points:'1222.5,739.52 1222.5,919.95 1216.67,915.58 1216.73,740.41 1222.48,739.52 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#516168',points:'1222.5,689.34 1222.5,739.52 1222.48,739.52 1216.73,740.41 1216.75,691.74 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#949B9B',points:'434.67,678.73 434.67,1213.72 0,1536 0,611 433.46,678.73 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#516168',points:'434.67,529.75 434.67,678.73 433.46,678.73 0,611 0,351 \t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'stapler'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'XMLID_1_'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#5E6867',points:'1942.25,937.25 1861.26,938.33 1847.38,936.79 1931.25,935.42 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#465150',points:'1931.25,935.42 1933.46,923.79 1944.88,926 1942.25,937.25 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#7A898C',points:'1861.26,944.21 1861.26,938.33 1942.25,937.25 1944.88,926 1971.75,925 1971.75,942 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#979EA0',points:'1861.26,938.33 1861.26,944.21 1847.38,942.04 1847.38,936.79 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#465150',points:'1971.75,925 1944.88,926 1933.46,923.79 1960.38,922.81 \t\t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'XMLID_3_'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#6B2030',points:'1872.811,886.463 1924.077,898.784 1896.866,892.324 1896.846,892.322 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#991F39',points:'1975.623,911.031 1949.003,904.78 1924.077,898.784 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#991F39',points:'1863.844,918.464 1871.777,897.073 1896.846,892.322 1896.866,892.324 1924.077,898.784 \t\t\t\t\t1949.003,904.78 1975.623,911.031 1974.749,923.495 1963.746,922.996 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#7A898C',points:'1861.34,917.869 1863.844,918.464 1963.746,922.996 1963.189,929.121 1859.681,929.121 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#B71C45',points:'1896.846,892.322 1871.777,897.073 1849.519,891.427 1872.811,886.463 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#979EA0',points:'1861.34,917.869 1859.681,929.121 1847.386,926.305 1848.575,914.826 \t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#6B2030',points:'1871.777,897.073 1863.844,918.464 1861.34,917.869 1848.575,914.826 1840.131,912.808 \t\t\t\t\t1849.519,891.427 \t\t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{fill:'#5E6867',cx:'1956.875',cy:'931.625',r:'3.125'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'XMLID_5_'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CEAD24',points:'383,644.996 393,665.336 352.52,669.826 352.52,669.836 336,671.666 333.14,663.206 \t\t\t\t328.67,649.996 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#B29312',points:'385.33,601.996 383,644.996 328.67,649.996 329.6,612.656 330,596.336 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CEAD24',points:'353.1,671.666 358.25,687.916 303.5,693.396 301,685.666 326.67,667.726 333.14,675.786 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#B29312',points:'352.52,669.836 353.1,671.666 333.14,675.786 326.67,667.726 333.14,663.206 336,671.666 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#8C7A22',points:'328.67,649.996 333.14,663.206 326.67,667.726 328.67,612.656 329.59,612.656 329.6,612.656 \t\t\t\t\t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#B29312',points:'328.67,612.656 326.67,667.726 301,685.666 301,612.656 \t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'XMLID_8_'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#9B8010',points:'1276.668,715.503 1276.688,724.133 1260.927,725.585 1261.136,719.25 1261.258,715.499 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C1A11E',points:'1260.927,725.585 1276.688,724.133 1279.193,729.779 1268.753,731.747 1263.355,732.764 \t\t\t\t1262.408,729.961 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#7F6C19',points:'1260.844,719.25 1261.136,719.25 1260.927,725.585 1262.408,729.961 1260.294,730.7 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#9B8010',points:'1251.759,733.682 1251.68,719.25 1260.844,719.25 1260.294,730.7 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#9B8010',points:'1262.408,734.129 1260.294,730.7 1262.408,729.961 1263.355,732.764 1268.753,731.747 \t\t\t\t1269.057,732.754 1269.021,732.764 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C1A11E',points:'1260.294,730.7 1262.408,734.129 1269.021,732.764 1269.057,732.754 1270.058,736.038 \t\t\t\t1252.588,736.243 1251.759,733.682 \t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'XMLID_6_'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CEAD24',d:'M253.63,623.38l-79.91-10.83c0,0-12.39-44.22-14.05-60.88l69.66,18\t\t\t\tC229.33,569.67,246.02,611,253.63,623.38z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#B29312',points:'229.33,547.33 229.33,569.67 159.67,551.67 158,522.67 \t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'XMLID_7_'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CEAD24',points:'123.72,602.49 120.33,579.67 150.38,584.73 161.02,617.16 130.96,612.94 125.15,612.13 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CEAD24',points:'132.44,623.38 143.83,639.67 105.39,636.85 95.17,621.76 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#B29312',points:'131.44,616.35 132.44,623.38 95.17,621.76 93.83,599.67 122.65,602.39 123.25,615.25 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#8C7A22',points:'130.96,612.94 131.44,616.35 123.25,615.25 122.65,602.39 123.72,602.49 125.15,612.13 \t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'XMLID_9_'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#9B8010',points:'1295.5,745.06 1309.49,744.37 1309.81,747.93 1291.67,746.63 1290.93,736.08 1294.83,735.95 \t\t\t\t1294.83,735.96 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C1A11E',points:'1309.81,747.93 1311,750.06 1292.96,749.81 1291.67,746.63 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#C1A11E',points:'1311.67,742.62 1309.34,742.74 1296.88,743.38 1295.64,735.92 1294.83,731 1311.67,729.96 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#7F6C19',points:'1309.49,744.37 1295.5,745.06 1294.83,735.96 1294.83,735.95 1295.64,735.92 1296.88,743.38 \t\t\t\t1309.34,742.74 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#9B8010',points:'1311.67,723.86 1311.67,729.96 1294.83,731 1294.44,724.86 \t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'kenny6',ref:'kenny6',className:'kenny  '+(this.state.kenny6?'kenny6':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#991F39',d:'M2012.637,914.566l-24.798-32.151l-20.855,27.701l2.108,40.208l20.556,45.533l71.3,87.345\t\t\t\tl270.359-180.704l-48.775-75.688l-28.07-33.14l-34.52-12.135l-91.035,21.816l-36.447-20.332l-5.046,7.137l6.427,13.148\t\t\t\tl-3.314,17.383l-22.122,54.643l10.247,22.143l-4.04,1.471l-13.464-19.525l-24.969-12.055l-14.032-13.009l-9.542,3.492\t\t\t\tl-9.238,1.881L1991.5,877.33L2012.637,914.566z M2129.979,813.442l3.997,3.524l4.302,26.689l-0.919,44.095L2129.979,813.442z\t\t\t\t M2030.232,942.955l-3.504-2.004l8.599-11.643l12.199-43.539l11.387,1.838l-13.237,40.846L2030.232,942.955z M2095.733,959.51\t\t\t\tc-1.954-3.792-0.472-8.423,3.319-10.376c3.768-1.942,8.399-0.461,10.353,3.331c1.942,3.768,0.461,8.4-3.308,10.342\t\t\t\tC2102.306,964.76,2097.675,963.279,2095.733,959.51z M2128.015,998.623c-1.954-3.792-0.473-8.423,3.296-10.365\t\t\t\tc3.791-1.954,8.422-0.473,10.376,3.319c1.942,3.768,0.461,8.4-3.331,10.353\t\t\t\tC2134.588,1003.872,2129.957,1002.391,2128.015,998.623z M2096.276,927.213l-20.712-49.786l5.859-3.02l25.252,17.231l28.65,4.807\t\t\t\tl-0.628,2.505l-26.116,2.029l-12.545-3.859l4.118,31.466L2096.276,927.213z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M1864.414,711.076l20.518,28.191l16.762,13.115l-6.43-11.518l-0.96-6.659l10.722-1.541l-9.205-3.981\t\t\t\tl-4.266-12.342l14.24-24.059l8.013,4.828l8.875,5.372c0,0,25.606,1.723,32.849-0.701s27.208-16.783,27.208-16.783l15.367,21.016\t\t\t\tl14.177,4.937l13.271,14.128l9.717,7.119l-1.764-14.823l0.798-13.236l8.755-4.512l-4.027-12.611l-4.161-19.812l-17.408-26.275\t\t\t\tl8.93-0.617l-18.767-10.685l-45.8-16.588l-41.584,16.311l-33.018,30.45l-0.515,20.331c0,0-11.231,3.432-14.936,6.795\t\t\t\tC1868.046,690.302,1864.414,711.076,1864.414,711.076z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M1894.305,734.204l0.96,6.659l6.43,11.518c0,0,4.516,8.2,7.127,12.758l2.526-1.418l-3.543-13.703\t\t\t\tl2.141-14.073l1.84-1.734l7.334,7.009l2.951-2.626l-9.002-10.076l-8.609-15.746l9.347-15.664l-8.013-4.828l-14.24,24.059\t\t\t\tl4.266,12.342l9.205,3.981L1894.305,734.204z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M1911.347,763.721l-2.526,1.418c0.768,1.378,1.371,2.434,1.63,2.824\t\t\t\tc1.119,1.663,15.219,14.579,15.219,14.579l11.445,21.758l11.115,12.709l27.945,30.471l27.191,12.248l9.238-1.881l9.542-3.492\t\t\t\tl-19.05-3.56l-6.025-9.604l6.06-15.046l-18.906,8.289l-6.023-3.788l-0.257-4.957l-2.436-1.624l16.093-8.555l19.746-14.334\t\t\t\tc0,0,0.655-2.228,1.407-3.139c0.729-0.899-4.688,2.416-4.688,2.416l-24.442,16.056l-6.575-9.204l-11.761,2.571l-6.68-4.497\t\t\t\tl-2.933-39.551l-5.122-5.707l-18.122-9.942l-10.361-11.586l-2.951,2.626l0.013,2.96l-5.027,12.536l-0.369,6.733L1911.347,763.721\t\t\t\tz M1929.243,780.672c-2.87-3.087-2.732-7.898,0.354-10.768c3.052-2.881,7.863-2.743,10.756,0.331\t\t\t\tc1.628,1.749,2.304,4.076,1.984,6.277l-8.245,6.517C1932.322,782.866,1930.578,782.078,1929.243,780.672z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#3A2B15',points:'1907.805,750.018 1911.347,763.721 1913.737,763.449 1914.106,756.716 1919.133,744.18 \t\t\t\t1919.12,741.22 1911.786,734.211 1909.945,735.945 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M1929.597,769.904c-3.087,2.87-3.224,7.681-0.354,10.768c1.335,1.406,3.079,2.194,4.85,2.357l8.245-6.517\t\t\t\tc0.32-2.201-0.356-4.528-1.984-6.277C1937.46,767.16,1932.649,767.023,1929.597,769.904z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'1987.839,882.415 2012.637,914.566 1991.5,877.33 1990.239,879.23 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#E4A270',d:'M1904.46,712.773l8.609,15.746l9.002,10.076l10.361,11.586l18.122,9.942l5.122,5.707l2.933,39.551\t\t\t\tl6.68,4.497l11.761-2.571l6.575,9.204l24.442-16.056c0,0,5.417-3.315,4.688-2.416c-0.752,0.911-1.407,3.139-1.407,3.139\t\t\t\tl-2.148,11.576l-14.268,10.348l-11.648,6.177l-5.339-3.588l0.257,4.957l6.023,3.788l18.906-8.289l-6.06,15.046l6.025,9.604\t\t\t\tl19.05,3.56l16.779-11.118l25.862-61.776l-0.058-8.578l-2.658-9.39l8.94-4.491l2.973-12.176l-7.831-20.218l-5.324-19.474\t\t\t\tl-9.55-8.543l-8.219,1.037l-8.755,4.512l-0.798,13.236l1.764,14.823l-9.717-7.119l-13.271-14.128l-14.177-4.937l-15.367-21.016\t\t\t\tc0,0-19.965,14.36-27.208,16.783s-32.849,0.701-32.849,0.701l-8.875-5.372L1904.46,712.773z M1980.391,800.582l-3.766,0.254\t\t\t\tl6.944-4.189l3.494-0.725L1980.391,800.582z M1948.907,725.492l-6.16-10.261c0,0,2.76-1.248,3.194-1.646\t\t\t\tc0.458-0.41,10.032-1.186,17.271-0.176c7.226,0.987,18.598,8.213,18.598,8.213l-0.617,3.43c0,0-13.614-2.435-15.371-2.402\t\t\t\tC1964.077,722.706,1948.907,725.492,1948.907,725.492z M1971.649,752.13c-2.605-4.096-1.4-9.544,2.719-12.161\t\t\t\tc4.096-2.605,9.544-1.4,12.161,2.719c1.474,2.352,1.716,5.135,0.878,7.574l-10.753,5.6\t\t\t\tC1974.648,755.296,1972.852,754.012,1971.649,752.13z M2020.54,794.578l-12.306-5.087l4.665-2.404l6.722,2.265L2020.54,794.578z\t\t\t\t M2052.92,749.683c-1.522,0.377-4.963-0.205-4.963-0.205s3.022-9.147,1.953-9.585c-1.057-0.415-4.201-6.065-4.201-6.065\t\t\t\tl-3.772-1.226l-2.822-19.077l3.169-7.507l8.96-0.953l7.224,7.415l5.801,26.324l-5.703-2.15l-3.452,2.273\t\t\t\tC2055.112,738.928,2054.43,749.341,2052.92,749.683z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'2026.728,940.951 2030.232,942.955 2045.675,928.454 2058.912,887.608 2047.525,885.769 \t\t\t\t2035.326,929.308 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#FFFFFF',points:'1975.509,824.065 1977.945,825.688 1983.284,829.277 1994.932,823.1 2009.2,812.752 \t\t\t\t2011.348,801.176 1991.602,815.51 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#A86538',points:'1976.625,800.836 1980.391,800.582 1987.062,795.922 1983.568,796.647 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M1942.747,715.232l6.16,10.261c0,0,15.169-2.786,16.914-2.842c1.757-0.033,15.371,2.402,15.371,2.402\t\t\t\tl0.617-3.43c0,0-11.372-7.226-18.598-8.213c-7.238-1.01-16.813-0.234-17.271,0.176\t\t\t\tC1945.507,713.984,1942.747,715.232,1942.747,715.232z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CB814F',points:'2022.146,854.354 2036.179,867.363 2061.148,879.418 2074.612,898.943 2078.652,897.472 \t\t\t\t2068.405,875.329 2090.527,820.686 2093.841,803.304 2087.415,790.156 2075.751,780.841 2062.071,763.492 2064.729,772.882 \t\t\t\t2064.787,781.46 2038.925,843.236 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#3A2B15',d:'M1974.369,739.969c-4.119,2.617-5.324,8.065-2.719,12.161c1.202,1.881,2.998,3.166,5.005,3.731\t\t\t\tl10.753-5.6c0.837-2.438,0.595-5.221-0.878-7.574C1983.913,738.57,1978.464,737.364,1974.369,739.969z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#CB814F',points:'2008.234,789.49 2020.54,794.578 2019.62,789.352 2012.899,787.087 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#750C27',d:'M2099.052,949.134c-3.792,1.954-5.273,6.585-3.319,10.376c1.942,3.768,6.573,5.25,10.365,3.296\t\t\t\tc3.768-1.942,5.25-6.573,3.308-10.342C2107.451,948.673,2102.82,947.192,2099.052,949.134z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#750C27',d:'M2131.311,988.258c-3.769,1.942-5.25,6.573-3.296,10.365c1.942,3.768,6.573,5.25,10.341,3.308\t\t\t\tc3.792-1.954,5.273-6.585,3.331-10.353C2139.733,987.786,2135.102,986.304,2131.311,988.258z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'2075.564,877.427 2096.276,927.213 2100.154,928.588 2096.036,897.121 2108.581,900.98 \t\t\t\t2134.697,898.951 2135.325,896.446 2106.676,891.639 2081.423,874.408 \t\t\t'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#CB814F',d:'M2047.957,749.478c0,0,3.441,0.582,4.963,0.205c1.51-0.342,2.193-10.756,2.193-10.756l3.452-2.273\t\t\t\tl5.703,2.15l-5.801-26.324l-7.224-7.415l-8.96,0.953l-3.169,7.507l2.822,19.077l3.772,1.226c0,0,3.144,5.65,4.201,6.065\t\t\t\tC2050.979,740.331,2047.957,749.478,2047.957,749.478z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#750C27',points:'2129.979,813.442 2137.358,887.75 2138.278,843.655 2133.976,816.966 \t\t\t'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null)))));}}]);return LevelKenny;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LevelKenny);

/***/ }),
/* 182 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var arraySample = __webpack_require__(76),
    values = __webpack_require__(77);

/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */
function baseSample(collection) {
  return arraySample(values(collection));
}

module.exports = baseSample;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(185);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(187),
    baseKeys = __webpack_require__(200),
    isArrayLike = __webpack_require__(82);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(188),
    isArguments = __webpack_require__(189),
    isArray = __webpack_require__(44),
    isBuffer = __webpack_require__(193),
    isIndex = __webpack_require__(195),
    isTypedArray = __webpack_require__(196);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(190),
    isObjectLike = __webpack_require__(23);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(22),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(78);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(79),
    stubFalse = __webpack_require__(194);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),
/* 194 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(197),
    baseUnary = __webpack_require__(198),
    nodeUtil = __webpack_require__(199);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(22),
    isLength = __webpack_require__(81),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 198 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(80);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(201),
    nativeKeys = __webpack_require__(202);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(203);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 203 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(22),
    isObject = __webpack_require__(83);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__darkpatterns2d_Pattern2d__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__darkpatterns2d_Avatar__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__darkpatterns2d_RageEngage__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hud_Hud__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// const mapStateToProps = state => ({});
var mapStateToProps=function mapStateToProps(state){var g=state.game;return{isMobile:g.mobile};};var mapDispatchToProps=function mapDispatchToProps(dispatch,state){return{// isMobile
// isMobile: () => dispatch(isMobile()),
// starts the music
dialogMusic:function dialogMusic(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["d" /* dialogMusic */])());},// fades out music
fadeMusic:function fadeMusic(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["e" /* fadeMusic */])());},// play the voice audio
voiceStatic:function voiceStatic(audioToPlay){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["u" /* voiceStatic */])(audioToPlay));},// boom
playSndFx:function playSndFx(sfx){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["l" /* playSndFx */])(sfx));}};};var TwoDView=function(_Component){_inherits(TwoDView,_Component);function TwoDView(props){_classCallCheck(this,TwoDView);var _this=_possibleConstructorReturn(this,(TwoDView.__proto__||Object.getPrototypeOf(TwoDView)).call(this,props));_this.addClickedOk=function(e){_this.setState({showAd:false,hideBubble:true});_this.shake();_this.nextAd();};_this.story=function(p){var i=0;var c=p.rounds.length;function step(){i+=this.ended()?0:1;return this;}function current(){var index=i;var ended=this.ended();var data=p.rounds[index];return{index:index,data:data,ended:ended};}function ended(){return i>=c;}return{step:step,current:current,ended:ended};}(props);// console.log(this.story);
_this.state={showAd:false,shake:false,hideBubble:false,sceneEnded:false,speaking:false};return _this;}_createClass(TwoDView,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;if(this.props.round!==3)this.props.dialogMusic();__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(2,function(){return _this2.playDarkPatternAudio();});}},{key:"shake",value:function shake(){var _this3=this;this.setState({shake:true});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(0.4,function(){return _this3.setState({shake:false});});}},{key:"nextAd",value:function nextAd(){var _this4=this;this.story.step();if(this.story.ended()){this.setState({sceneEnded:true});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(0.75,function(){return _this4.props.playSndFx('twoDRageIncrease');});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(1.25,function(){return _this4.props.playSndFx('twoDRageIncrease');});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(1.75,function(){return _this4.props.playSndFx('twoDRageIncrease');});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(2.25,function(){return _this4.props.playSndFx('twoDRageIncrease');});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(2.75,function(){return _this4.props.playSndFx('threeDSwoosh');});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(4,function(){return _this4.props.next();});}else{this.setState({hideBubble:false});this.playDarkPatternAudio();}}},{key:"playDarkPatternAudio",value:function playDarkPatternAudio(){var _this5=this;var data=this.story.current().data;this.props.voiceStatic(data.audio);this.setState({speaking:true});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(data.adDelay,function(){_this5.setState({showAd:true,speaking:false});});}},{key:"setDatTextSon",value:function setDatTextSon(){return{__html:this.story.current().data.bubbleText};}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.props.fadeMusic();}},{key:"render",value:function render(){// returns the current data from the manifest along with the index for the round
var scene=this.story.current();// has the scene ended?
var ended=this.story.ended();// the scene data from the manifest
var data=scene.data;// the index of the current round
var index=scene.index;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"darkpatterns2dbg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bodyWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"body "+(this.state.shake?'shake-hard':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__hud_Hud__["a" /* default */],{countdown:this.countdown,hideScore:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"svgwrap"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",viewBox:"0 0 1020.866 1653",enableBackground:"new 0 0 1020.866 1653"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Layer_2_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{y:"-0.1",fill:"#ABABAB",width:"1035.5",height:"1676.3"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"8.6",y:"1442",fill:"#5C5F63",width:"1020.9",height:"222"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"44.6",y:"1263",fill:"#83878C",width:"180",height:"161"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"241.4",y:"1263",fill:"#83878C",width:"180",height:"161"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"435.1",y:"1263",fill:"#83878C",width:"180",height:"161"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"631.9",y:"1263",fill:"#83878C",width:"180",height:"161"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"820.6",y:"1263",fill:"#83878C",width:"180",height:"161"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#C8CBCE",strokeWidth:"4",strokeMiterlimit:"10",points:"178.9,1488 186.7,1480 194.5,1488  202.2,1480 210,1488 217.8,1480 225.6,1488 233.4,1480 241.2,1488 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#C8CBCE",strokeWidth:"4",strokeMiterlimit:"10",points:"281.9,1488 289.7,1480 297.5,1488  305.2,1480 313,1488 320.8,1480 328.6,1488 336.4,1480 344.2,1488 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#C8CBCE",strokeWidth:"4",strokeMiterlimit:"10",points:"384.9,1488 392.7,1480 400.5,1488  408.2,1480 416,1488 423.8,1480 431.6,1488 439.4,1480 447.2,1488 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#C8CBCE",strokeWidth:"4",strokeMiterlimit:"10",points:"487.9,1488 495.7,1480 503.5,1488  511.2,1480 519,1488 526.8,1480 534.6,1488 542.4,1480 550.2,1488 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#C8CBCE",strokeWidth:"4",strokeMiterlimit:"10",points:"590.9,1488 598.7,1480 606.5,1488  614.2,1480 622,1488 629.8,1480 637.6,1488 645.4,1480 653.2,1488 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#C8CBCE",strokeWidth:"4",strokeMiterlimit:"10",points:"693.9,1488 701.7,1480 709.5,1488  717.2,1480 725,1488 732.8,1480 740.6,1488 748.4,1480 756.2,1488 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#C8CBCE",strokeWidth:"4",strokeMiterlimit:"10",points:"796.9,1488 804.7,1480 812.5,1488  820.2,1480 828,1488 835.8,1480 843.6,1488 851.4,1480 859.2,1488 \t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"sidebar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"688.5",y:"465.023",fill:"#9C9DA0",width:"313.1",height:"457.977"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"730.3,514.007 738.1,506.007  745.9,514.007 753.6,506.007 761.4,514.007 769.2,506.007 777,514.007 784.7,506.007 792.5,514.007 800.3,506.007 808.1,514.007  815.9,506.007 823.6,514.007 831.4,506.007 839.2,514.007 847,506.007 854.8,514.007 862.5,506.007 870.3,514.007 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"730.3,552.007 738.1,544.007  745.9,552.007 753.6,544.007 761.4,552.007 769.2,544.007 777,552.007 784.7,544.007 792.5,552.007 800.3,544.007 808.1,552.007  815.9,544.007 823.6,552.007 831.4,544.007 839.2,552.007 847,544.007 854.8,552.007 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"730.3,590.007 738.1,582.007  745.9,590.007 753.6,582.007 761.4,590.007 769.2,582.007 777,590.007 784.7,582.007 792.5,590.007 800.3,582.007 808.1,590.007  815.9,582.007 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"730.3,628.007 738.1,620.007  745.9,628.007 753.6,620.007 761.4,628.007 769.2,620.007 777,628.007 784.7,620.007 792.5,628.007 800.3,620.007 808.1,628.007  815.9,620.007 823.6,628.007 831.4,620.007 839.2,628.007 847,620.007 854.8,628.007 862.5,620.007 870.3,628.007 878.1,620.007 \t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"730.3,666.007 738.1,658.007  745.9,666.007 753.6,658.007 761.4,666.007 769.2,658.007 777,666.007 784.7,658.007 792.5,666.007 800.3,658.007 808.1,666.007  815.9,658.007 823.6,666.007 831.4,658.007 839.2,666.007 847,658.007 854.8,666.007 862.5,658.007 870.3,666.007 878.1,658.007  885.9,666.007 893.6,658.007 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"730.3,704.007 738.1,696.007  745.9,704.007 753.6,696.007 761.4,704.007 769.2,696.007 777,704.007 784.7,696.007 792.5,704.007 800.3,696.007 808.1,704.007  815.9,696.007 823.6,704.007 831.4,696.007 839.2,704.007 847,696.007 854.8,704.007 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"730.3,742.007 738.1,734.007  745.9,742.007 753.6,734.007 761.4,742.007 769.2,734.007 777,742.007 784.7,734.007 792.5,742.007 800.3,734.007 808.1,742.007  815.9,734.007 823.6,742.007 831.4,734.007 839.2,742.007 847,734.007 854.8,742.007 862.5,734.007 870.3,742.007 878.1,734.007  885.9,742.007 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"730.3,780.007 738.1,772.007  745.9,780.007 753.6,772.007 761.4,780.007 769.2,772.007 777,780.007 784.7,772.007 792.5,780.007 800.3,772.007 808.1,780.007  815.9,772.007 823.6,780.007 831.4,772.007 839.2,780.007 847,772.007 854.8,780.007 862.5,772.007 870.3,780.007 878.1,772.007  885.9,780.007 893.6,772.007 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"730.3,818.007 738.1,810.007  745.9,818.007 753.6,810.007 761.4,818.007 769.2,810.007 777,818.007 784.7,810.007 792.5,818.007 800.3,810.007 808.1,818.007  815.9,810.007 823.6,818.007 831.4,810.007 839.2,818.007 847,810.007 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"730.3,856.007 738.1,848.007  745.9,856.007 753.6,848.007 761.4,856.007 769.2,848.007 777,856.007 784.7,848.007 792.5,856.007 800.3,848.007 808.1,856.007 \t "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"content_x5F_2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"479,982 486.8,990 494.5,982 502.3,990  510.1,982 517.9,990 525.6,982 533.4,990 541.2,982 549,990 556.8,982 564.5,990 572.3,982 580.1,990 587.9,982 595.7,990  603.4,982 611.2,990 619,982 626.8,990 634.5,982 642.3,990 650.1,982 658.2,990 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,990 43.4,982 51.2,990 58.9,982  66.7,990 74.5,982 82.3,990 90.1,982 97.8,990 105.6,982 113.4,990 121.2,982 128.9,990 136.7,982 144.5,990 152.3,982 160.1,990  167.8,982 175.6,990 183.4,982 191.2,990 199,982 206.7,990 214.5,982 222.3,990 230.1,982 237.8,990 245.6,982 253.4,990  261.2,982 269,990 276.7,982 284.5,990 292.3,982 300.1,990 307.9,982 315.6,990 323.4,982 331.2,990 339,982 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"479,1009 486.8,1017 494.5,1009  502.3,1017 510.1,1009 517.9,1017 525.6,1009 533.4,1017 541.2,1009 549,1017 556.8,1009 564.5,1017 572.3,1009 580.1,1017  587.9,1009 595.7,1017 603.4,1009 611.2,1017 619,1009 626.8,1017 634.5,1009 642.3,1017 650.1,1009 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,1017 43.4,1009 51.2,1017  58.9,1009 66.7,1017 74.5,1009 82.3,1017 90.1,1009 97.8,1017 105.6,1009 113.4,1017 121.2,1009 128.9,1017 136.7,1009  144.5,1017 152.3,1009 160.1,1017 167.8,1009 175.6,1017 183.4,1009 191.2,1017 199,1009 206.7,1017 214.5,1009 222.3,1017  230.1,1009 237.8,1017 245.6,1009 253.4,1017 261.2,1009 269,1017 276.7,1009 284.5,1017 292.3,1009 300.1,1017 307.9,1009  315.6,1017 323.4,1009 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"479,1036 486.8,1044 494.5,1036  502.3,1044 510.1,1036 517.9,1044 525.6,1036 533.4,1044 541.2,1036 549,1044 556.8,1036 564.5,1044 572.3,1036 580.1,1044  587.9,1036 595.7,1044 603.4,1036 611.2,1044 619,1036 626.8,1044 634.5,1036 642.3,1044 650.1,1036 658.2,1044 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,1044 43.4,1036 51.2,1044  58.9,1036 66.7,1044 74.5,1036 82.3,1044 90.1,1036 97.8,1044 105.6,1036 113.4,1044 121.2,1036 128.9,1044 136.7,1036  144.5,1044 152.3,1036 160.1,1044 167.8,1036 175.6,1044 183.4,1036 191.2,1044 199,1036 206.7,1044 214.5,1036 222.3,1044  230.1,1036 237.8,1044 245.6,1036 253.4,1044 261.2,1036 269,1044 276.7,1036 284.5,1044 292.3,1036 300.1,1044 307.9,1036  315.6,1044 323.4,1036 331.2,1044 339,1036 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"479,1063 486.8,1071 494.5,1063  502.3,1071 510.1,1063 517.9,1071 525.6,1063 533.4,1071 541.2,1063 549,1071 556.8,1063 564.5,1071 572.3,1063 580.1,1071  587.9,1063 595.7,1071 603.4,1063 611.2,1071 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,1071 43.4,1063 51.2,1071  58.9,1063 66.7,1071 74.5,1063 82.3,1071 90.1,1063 97.8,1071 105.6,1063 113.4,1071 121.2,1063 128.9,1071 136.7,1063  144.5,1071 152.3,1063 160.1,1071 167.8,1063 175.6,1071 183.4,1063 191.2,1071 199,1063 206.7,1071 214.5,1063 222.3,1071  230.1,1063 237.8,1071 245.6,1063 253.4,1071 261.2,1063 269,1071 276.7,1063 284.5,1071 292.3,1063 300.1,1071 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"479,1090 486.8,1098 494.5,1090  502.3,1098 510.1,1090 517.9,1098 525.6,1090 533.4,1098 541.2,1090 549,1098 556.8,1090 564.5,1098 572.3,1090 580.1,1098  587.9,1090 595.7,1098 603.4,1090 611.2,1098 619,1090 626.8,1098 634.5,1090 642.3,1098 650.1,1090 658.2,1098 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,1098 43.4,1090 51.2,1098  58.9,1090 66.7,1098 74.5,1090 82.3,1098 90.1,1090 97.8,1098 105.6,1090 113.4,1098 121.2,1090 128.9,1098 136.7,1090  144.5,1098 152.3,1090 160.1,1098 167.8,1090 175.6,1098 183.4,1090 191.2,1098 199,1090 206.7,1098 214.5,1090 222.3,1098  230.1,1090 237.8,1098 245.6,1090 253.4,1098 261.2,1090 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"362.3,1125 370.1,1117 377.9,1125  385.6,1117 393.4,1125 401.2,1117 409,1125 416.7,1117 424.5,1125 432.3,1117 440.1,1125 447.9,1117 455.6,1125 463.4,1117  471.2,1125 479,1117 486.8,1125 494.5,1117 502.3,1125 510.1,1117 517.9,1125 525.6,1117 533.4,1125 541.2,1117 549,1125  556.8,1117 564.5,1125 572.3,1117 580.1,1125 587.9,1117 595.7,1125 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,1125 43.4,1117 51.2,1125  58.9,1117 66.7,1125 74.5,1117 82.3,1125 90.1,1117 97.8,1125 105.6,1117 113.4,1125 121.2,1117 128.9,1125 136.7,1117  144.5,1125 152.3,1117 160.1,1125 167.8,1117 175.6,1125 183.4,1117 191.2,1125 199,1117 206.7,1125 214.5,1117 222.3,1125  230.1,1117 237.8,1125 245.6,1117 253.4,1125 261.2,1117 269,1125 276.7,1117 284.5,1125 292.3,1117 300.1,1125 307.9,1117  315.6,1125 323.4,1117 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"362.3,1152 370.1,1144 377.9,1152  385.6,1144 393.4,1152 401.2,1144 409,1152 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,1152 43.4,1144 51.2,1152  58.9,1144 66.7,1152 74.5,1144 82.3,1152 90.1,1144 97.8,1152 105.6,1144 113.4,1152 121.2,1144 128.9,1152 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"361.6",y:"979",fill:"#83878C",width:"100",height:"106"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#73787F",points:"461.6,1085 361.6,1085 376.1,1047.5 446.1,1047.5 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#73787F",points:"435.6,1048 386.6,1048 398.1,1015 424.7,1015 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A5A8AD",d:"M420,1035c2.7-0.5,4.6-3,4.1-5.8l-9.9,1.7C414.7,1033.6,417.3,1035.4,420,1035z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A5A8AD",d:"M402.1,1034.9c2.7,0.6,5.4-1.1,5.9-3.8l-9.8-2.1C397.7,1031.7,399.4,1034.4,402.1,1034.9z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"362.3,564 370.1,556 377.9,564  385.6,556 393.4,564 401.2,556 409,564 416.7,556 424.5,564 432.3,556 440.1,564 447.9,556 455.6,564 463.4,556 471.2,564  479,556 486.8,564 494.5,556 502.3,564 510.1,556 517.9,564 525.6,556 533.4,564 541.2,556 549,564 556.8,556 564.5,564  572.3,556 580.1,564 587.9,556 595.7,564 603.4,556 611.2,564 619,556 626.8,564 634.5,556 642.3,564 650.1,556 658.2,564 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,564 43.4,556 51.2,564 58.9,556  66.7,564 74.5,556 82.3,564 90.1,556 97.8,564 105.6,556 113.4,564 121.2,556 128.9,564 136.7,556 144.5,564 152.3,556 160.1,564  167.8,556 175.6,564 183.4,556 191.2,564 199,556 206.7,564 214.5,556 222.3,564 230.1,556 237.8,564 245.6,556 253.4,564  261.2,556 269,564 276.7,556 284.5,564 292.3,556 300.1,564 307.9,556 315.6,564 323.4,556 331.2,564 339,556 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"362.3,591 370.1,583 377.9,591  385.6,583 393.4,591 401.2,583 409,591 416.7,583 424.5,591 432.3,583 440.1,591 447.9,583 455.6,591 463.4,583 471.2,591  479,583 486.8,591 494.5,583 502.3,591 510.1,583 517.9,591 525.6,583 533.4,591 541.2,583 549,591 556.8,583 564.5,591  572.3,583 580.1,591 587.9,583 595.7,591 603.4,583 611.2,591 619,583 626.8,591 634.5,583 642.3,591 650.1,583 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,591 43.4,583 51.2,591 58.9,583  66.7,591 74.5,583 82.3,591 90.1,583 97.8,591 105.6,583 113.4,591 121.2,583 128.9,591 136.7,583 144.5,591 152.3,583 160.1,591  167.8,583 175.6,591 183.4,583 191.2,591 199,583 206.7,591 214.5,583 222.3,591 230.1,583 237.8,591 245.6,583 253.4,591  261.2,583 269,591 276.7,583 284.5,591 292.3,583 300.1,591 307.9,583 315.6,591 323.4,583 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"362.3,618 370.1,610 377.9,618  385.6,610 393.4,618 401.2,610 409,618 416.7,610 424.5,618 432.3,610 440.1,618 447.9,610 455.6,618 463.4,610 471.2,618  479,610 486.8,618 494.5,610 502.3,618 510.1,610 517.9,618 525.6,610 533.4,618 541.2,610 549,618 556.8,610 564.5,618  572.3,610 580.1,618 587.9,610 595.7,618 603.4,610 611.2,618 619,610 626.8,618 634.5,610 642.3,618 650.1,610 658.2,618 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,618 43.4,610 51.2,618 58.9,610  66.7,618 74.5,610 82.3,618 90.1,610 97.8,618 105.6,610 113.4,618 121.2,610 128.9,618 136.7,610 144.5,618 152.3,610 160.1,618  167.8,610 175.6,618 183.4,610 191.2,618 199,610 206.7,618 214.5,610 222.3,618 230.1,610 237.8,618 245.6,610 253.4,618  261.2,610 269,618 276.7,610 284.5,618 292.3,610 300.1,618 307.9,610 315.6,618 323.4,610 331.2,618 339,610 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"362.3,645 370.1,637 377.9,645  385.6,637 393.4,645 401.2,637 409,645 416.7,637 424.5,645 432.3,637 440.1,645 447.9,637 455.6,645 463.4,637 471.2,645  479,637 486.8,645 494.5,637 502.3,645 510.1,637 517.9,645 525.6,637 533.4,645 541.2,637 549,645 556.8,637 564.5,645  572.3,637 580.1,645 587.9,637 595.7,645 603.4,637 611.2,645 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,645 43.4,637 51.2,645 58.9,637  66.7,645 74.5,637 82.3,645 90.1,637 97.8,645 105.6,637 113.4,645 121.2,637 128.9,645 136.7,637 144.5,645 152.3,637 160.1,645  167.8,637 175.6,645 183.4,637 191.2,645 199,637 206.7,645 214.5,637 222.3,645 230.1,637 237.8,645 245.6,637 253.4,645  261.2,637 269,645 276.7,637 284.5,645 292.3,637 300.1,645 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"362.3,672 370.1,664 377.9,672  385.6,664 393.4,672 401.2,664 409,672 416.7,664 424.5,672 432.3,664 440.1,672 447.9,664 455.6,672 463.4,664 471.2,672  479,664 486.8,672 494.5,664 502.3,672 510.1,664 517.9,672 525.6,664 533.4,672 541.2,664 549,672 556.8,664 564.5,672  572.3,664 580.1,672 587.9,664 595.7,672 603.4,664 611.2,672 619,664 626.8,672 634.5,664 642.3,672 650.1,664 658.2,672 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,672 43.4,664 51.2,672 58.9,664  66.7,672 74.5,664 82.3,672 90.1,664 97.8,672 105.6,664 113.4,672 121.2,664 128.9,672 136.7,664 144.5,672 152.3,664 160.1,672  167.8,664 175.6,672 183.4,664 191.2,672 199,664 206.7,672 214.5,664 222.3,672 230.1,664 237.8,672 245.6,664 253.4,672  261.2,664 269,672 276.7,664 284.5,672 292.3,664 300.1,672 307.9,664 315.6,672 323.4,664 331.2,672 339,664 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"362.3,699 370.1,691 377.9,699  385.6,691 393.4,699 401.2,691 409,699 416.7,691 424.5,699 432.3,691 440.1,699 447.9,691 455.6,699 463.4,691 471.2,699  479,691 486.8,699 494.5,691 502.3,699 510.1,691 517.9,699 525.6,691 533.4,699 541.2,691 549,699 556.8,691 564.5,699  572.3,691 580.1,699 587.9,691 595.7,699 603.4,691 611.2,699 619,691 626.8,699 634.5,691 642.3,699 650.1,691 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,699 43.4,691 51.2,699 58.9,691  66.7,699 74.5,691 82.3,699 90.1,691 97.8,699 105.6,691 113.4,699 121.2,691 128.9,699 136.7,691 144.5,699 152.3,691 160.1,699  167.8,691 175.6,699 183.4,691 191.2,699 199,691 206.7,699 214.5,691 222.3,699 230.1,691 237.8,699 245.6,691 253.4,699  261.2,691 269,699 276.7,691 284.5,699 292.3,691 300.1,699 307.9,691 315.6,699 323.4,691 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"362.3,726 370.1,718 377.9,726  385.6,718 393.4,726 401.2,718 409,726 416.7,718 424.5,726 432.3,718 440.1,726 447.9,718 455.6,726 463.4,718 471.2,726  479,718 486.8,726 494.5,718 502.3,726 510.1,718 517.9,726 525.6,718 533.4,726 541.2,718 549,726 556.8,718 564.5,726  572.3,718 580.1,726 587.9,718 595.7,726 603.4,718 611.2,726 619,718 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,726 43.4,718 51.2,726 58.9,718  66.7,726 74.5,718 82.3,726 90.1,718 97.8,726 105.6,718 113.4,726 121.2,718 128.9,726 136.7,718 144.5,726 152.3,718 160.1,726  167.8,718 175.6,726 183.4,718 191.2,726 199,718 206.7,726 214.5,718 222.3,726 230.1,718 237.8,726 245.6,718 253.4,726  261.2,718 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"362.3,753 370.1,745 377.9,753  385.6,745 393.4,753 401.2,745 409,753 416.7,745 424.5,753 432.3,745 440.1,753 447.9,745 455.6,753 463.4,745 471.2,753  479,745 486.8,753 494.5,745 502.3,753 510.1,745 517.9,753 525.6,745 533.4,753 541.2,745 549,753 556.8,745 564.5,753  572.3,745 580.1,753 587.9,745 595.7,753 603.4,745 611.2,753 619,745 626.8,753 634.5,745 642.3,753 650.1,745 658.2,753 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,753 43.4,745 51.2,753 58.9,745  66.7,753 74.5,745 82.3,753 90.1,745 97.8,753 105.6,745 113.4,753 121.2,745 128.9,753 136.7,745 144.5,753 152.3,745 160.1,753  167.8,745 175.6,753 183.4,745 191.2,753 199,745 206.7,753 214.5,745 222.3,753 230.1,745 237.8,753 245.6,745 253.4,753  261.2,745 269,753 276.7,745 284.5,753 292.3,745 300.1,753 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"362.3,780 370.1,772 377.9,780  385.6,772 393.4,780 401.2,772 409,780 416.7,772 424.5,780 432.3,772 440.1,780 447.9,772 455.6,780 463.4,772 471.2,780  479,772 486.8,780 494.5,772 502.3,780 510.1,772 517.9,780 525.6,772 533.4,780 541.2,772 549,780 556.8,772 564.5,780  572.3,772 580.1,780 587.9,772 595.7,780 603.4,772 611.2,780 619,772 626.8,780 634.5,772 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,780 43.4,772 51.2,780 58.9,772  66.7,780 74.5,772 82.3,780 90.1,772 97.8,780 105.6,772 113.4,780 121.2,772 128.9,780 136.7,772 144.5,780 152.3,772 160.1,780  167.8,772 175.6,780 183.4,772 191.2,780 199,772 206.7,780 214.5,772 222.3,780 230.1,772 237.8,780 245.6,772 253.4,780  261.2,772 269,780 276.7,772 284.5,780 292.3,772 300.1,780 307.9,772 315.6,780 323.4,772 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"362.3,807 370.1,799 377.9,807  385.6,799 393.4,807 401.2,799 409,807 416.7,799 424.5,807 432.3,799 440.1,807 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#8D9093",strokeWidth:"4",strokeMiterlimit:"10",points:"35.6,807 43.4,799 51.2,807 58.9,799  66.7,807 74.5,799 82.3,807 90.1,799 97.8,807 105.6,799 113.4,807 121.2,799 128.9,807 136.7,799 144.5,807 152.3,799 \t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"featured_area"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"35.6",y:"144",fill:"#717577",width:"965",height:"279"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#83878C",points:"1000.6,423 443.267,423 345.803,372.116 1000.6,302 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#686A6D",points:"477.1,358 679.5,336.1 828.2,423 753.475,423 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"box_2_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4F5256",points:"765.4,324 943.3,374 943.3,223.7 765.5,204 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#686A6D",points:"765.4,324 623.1,360.2 623.1,218.1 765.5,204 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#888A8C",points:"602.1,189.8 737.3,182.6 765.5,204 623.1,218.1 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#696C70",points:"837.8,157.2 986,150.5 943.3,223.7 800.2,247.6 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#585B5E",points:"800.2,423 800.2,247.6 623.1,218.1 623.1,360.3 770.7,423 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7C7E82",points:"800.2,247.6 800.2,423 828.3,423 943.3,374.1 943.3,223.7 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#616468",points:"938.5,243.3 935,232.6 931.5,244.7 933.7,243.3 933.7,256 936.4,255.2 936.4,242.8 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4C4E51",points:"648.6,266.9 641,239.3 633.5,263.2 638,262.2 638,279.7 643.9,281.3 643.9,263.6 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_4_",fill:"#4C4E51",d:"M734.6,281.5v78.7c0,0.4-0.2,0.6-0.4,0.7l-32.2,3.9v-0.1L672.6,339 c-0.2-0.2-0.3-0.5-0.3-0.8V267c0-0.3,0.1-0.6,0.3-0.7l29.4-9.2l32.2,23.6C734.4,280.8,734.6,281.1,734.6,281.5z M731.9,293.7v-4.2 c0-0.4-0.1-0.8-0.3-0.9l-7.7-4.8c-0.2-0.1-0.3,0.2-0.3,0.6v36.8c0,0.5,0.1,0.9,0.3,0.9l1.8,0.5c0.2,0,0.3-0.3,0.3-0.7v-14.8 l5.2,2.2c0.1,0.1,0.3-0.2,0.3-0.7v-4.2c0-0.4-0.1-0.8-0.3-0.9L726,301v-9.9l5.6,3.2C731.8,294.4,731.9,294.1,731.9,293.7z M731.1,352.3c0.3,0,0.5-1,0.3-1.7l-2-8.8l1.8-7.4c0.2-0.7,0-1.7-0.3-1.8l-0.9-0.2c-0.1,0-0.3,0.2-0.3,0.5l-1.3,6.3l-1.4-6.8 c-0.1-0.3-0.2-0.6-0.4-0.6l-1-0.2c-0.3-0.1-0.5,1-0.3,1.8l2,8.3l-2.1,8.9c-0.2,0.8,0,1.8,0.3,1.8h0.9c0.1,0,0.3-0.2,0.4-0.6 l1.6-7.6l1.6,7.6c0.1,0.3,0.2,0.5,0.3,0.5L731.1,352.3z M719.4,353.2c2.5-0.1,4.3-4.5,4.3-11.3s-1.8-11.4-4.3-11.9 c-2.7-0.5-4.7,3.9-4.7,11.2C714.7,348.6,716.7,353.2,719.4,353.2z M722.1,288.1v-4.6c0-0.5-0.1-0.9-0.3-1l-9.4-5.9 c-0.2-0.1-0.4,0.2-0.4,0.7v40.9c0,0.5,0.2,1,0.4,1l2.2,0.6c0.2,0,0.4-0.3,0.4-0.8v-16.4l6.4,2.7c0.2,0.1,0.3-0.3,0.3-0.7V300 c0-0.5-0.1-0.9-0.3-1l-6.4-3v-11l6.8,3.9C722,288.8,722.1,288.5,722.1,288.1z M713.5,346.3c0-3-0.8-5.3-2.1-5.8v-0.1 c1-0.7,1.6-2.4,1.6-5c0-5.1-1.8-6.2-3.5-6.5l-3.2-0.5c-0.3-0.1-0.6,0.5-0.6,1.3v21.9c0,0.8,0.3,1.4,0.6,1.4l3.6-0.1 C711.7,352.8,713.5,351.2,713.5,346.3z M709.6,302.4v-26.7c0-0.5-0.2-1.1-0.4-1.2l-2.5-1.5c-0.2-0.1-0.4,0.2-0.4,0.7v27.2 c0,4.4-1,10-4.4,8.9l0,0v-51.7l-29.2,9.1v71l29.2,25.6v-46.1l0,0C706.4,318.8,709.6,313,709.6,302.4z M719.4,334.5 c-1.6-0.2-2.6,2.7-2.6,6.9c0,4.2,1.1,7.3,2.6,7.3s2.5-2.9,2.5-6.9S720.9,334.7,719.4,334.5z M709.7,343l-1.7-0.1v5.5h2 c0.7,0,1.4-0.7,1.4-2.8C711.5,343.4,710.5,343,709.7,343z M709.6,333.4l-1.5-0.2v5.2l1.6,0.1c0.7,0.1,1.3-0.6,1.3-2.5 C711,334.1,710.3,333.5,709.6,333.4z M697.7,298.5v-26.7c0-0.5-0.2-0.9-0.4-0.9l-2.4,0.4c-0.2,0-0.4,0.5-0.4,1v25.9 c0,10.2,3,17.7,7.4,19.3v-7.8C698.7,308.9,697.7,302.9,697.7,298.5z M698.3,348.2c0.2,1-0.1,1.8-0.5,1.5l-1.2-0.9 c-0.2-0.2-0.4-0.6-0.5-1.2l-0.7-4.6l-3.5-2.4l-0.6,3.5c-0.1,0.4-0.3,0.6-0.4,0.5l-1-0.7c-0.3-0.2-0.6-1.3-0.4-2l3.2-17.7 c0.1-0.4,0.3-0.7,0.5-0.6l1,0.5c0.2,0.1,0.4,0.5,0.5,1L698.3,348.2z M694.7,338.3l-1.1-7.8l-1.1,6.4L694.7,338.3z M692.8,271.7 l-9.5,1.6c-0.2,0-0.3,0.4-0.3,0.8v4.3c0,0.4,0.1,0.8,0.3,0.8l3.2-0.3v31.3c0,0.5,0.1,0.9,0.3,0.9l1.9,0.7c0.2,0.1,0.3-0.3,0.3-0.8 v-32.4l3.8-0.3c0.2,0,0.4-0.4,0.4-0.9v-4.9C693.2,272.1,693,271.7,692.8,271.7z M685.1,319.9l-0.8-0.4c-0.2-0.1-0.4,0.3-0.4,0.9 v12.8l0,0l-2.8-14.7c-0.1-0.4-0.2-0.6-0.3-0.7l-1.3-0.6c-0.2-0.1-0.3,0.3-0.3,0.9v16.7c0,0.6,0.2,1.2,0.3,1.3l0.7,0.5 c0.2,0.1,0.4-0.2,0.4-0.8v-12.6l0,0l2.8,15.2c0.1,0.4,0.2,0.7,0.3,0.8l1.4,1c0.2,0.2,0.4-0.2,0.4-0.8v-18.2 C685.5,320.6,685.3,320,685.1,319.9z M678.8,273.2c-2,0.4-3.9,3.8-3.9,10.5c0,11.6,5.1,8,5.1,15.6c0,3.2-1.1,4.5-2,4.2 c-0.8-0.2-1.5-1.4-1.9-3.3c-0.1-0.3-0.2-0.4-0.3-0.1l-0.9,2.5l-0.1,0.4c-0.1,0.2-0.1,0.7,0,1c0.1,0.2,0.1,0.4,0.2,0.5 c0.8,2.7,1.9,4,3.1,4.5c2.2,0.8,4.2-2.3,4.2-10c0-12.9-5.4-9.1-5.4-15.8c0-3.1,0.9-4.4,1.8-4.5c0.7-0.1,1.4,0.6,1.8,2 c0.1,0.3,0.3,0.3,0.4,0l1.2-3.8c0.1-0.3,0.1-0.9,0-1.1C681,273.7,679.8,273,678.8,273.2z M677.2,316.2l-0.6-0.3 c-0.2-0.1-0.3,0.3-0.3,0.9v16c0,0.6,0.1,1.1,0.3,1.2l0.6,0.5c0.2,0.1,0.3-0.2,0.3-0.8v-16.3C677.5,316.8,677.4,316.3,677.2,316.2z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_3_",fill:"#616468",d:"M913.9,271.2v72.1c0,0.3-0.1,0.7-0.3,0.8l-30.1,26.2v-0.1l-33.4-3.7c-0.2,0-0.4-0.3-0.4-0.7 v-79.4c0-0.4,0.2-0.7,0.4-0.9l33.4-24.1l30.1,9.1C913.7,270.6,913.9,270.8,913.9,271.2z M911.6,283.5v-3.8c0-0.4-0.1-0.7-0.2-0.7 l-6.7-1.1c-0.2,0-0.3,0.3-0.3,0.7v34.8c0,0.4,0.1,0.8,0.3,0.7l1.6-0.6c0.1,0,0.3-0.4,0.3-0.9v-13.9l4.6-0.6c0.1,0,0.2-0.3,0.2-0.7 v-3.9c0-0.4-0.1-0.7-0.2-0.7l-4.6,0.2v-9.3l4.9,0.4C911.5,284.2,911.6,283.9,911.6,283.5z M910.8,338.1c0.3-0.2,0.4-1.2,0.3-1.8 l-1.8-6.9l1.5-7.9c0.1-0.7,0-1.6-0.3-1.5l-0.7,0.3c-0.1,0.1-0.2,0.3-0.3,0.7l-1.1,6.6l-1.2-5.5c-0.1-0.3-0.2-0.4-0.3-0.4l-0.9,0.4 c-0.3,0.1-0.5,1.2-0.3,1.9l1.8,6.6l-1.9,9.7c-0.2,0.9,0,1.7,0.3,1.5l0.8-0.6c0.1-0.1,0.2-0.4,0.3-0.8l1.4-8.1l1.4,6.1 c0.1,0.3,0.2,0.4,0.3,0.3L910.8,338.1z M900.4,346.3c2.3-1.7,3.9-7.1,3.9-13.5s-1.6-9.8-3.9-8.7c-2.5,1.1-4.4,6.6-4.4,13.7 C896,345.1,897.9,348.2,900.4,346.3z M902.9,282.7v-4.4c0-0.4-0.1-0.8-0.3-0.8l-8.8-1.4c-0.2,0-0.4,0.4-0.4,0.9v40 c0,0.5,0.2,0.9,0.4,0.8l2.1-0.7c0.2-0.1,0.3-0.5,0.3-1v-15.9l6-0.8c0.2,0,0.3-0.4,0.3-0.9v-4.4c0-0.4-0.1-0.8-0.3-0.8l-6,0.3V283 l6.3,0.5C902.8,283.5,902.9,283.2,902.9,282.7z M894.9,343.6c0-2.9-0.8-4.7-2-4.3v-0.1c0.9-1.3,1.6-3.4,1.6-5.9 c0-4.9-1.7-5-3.4-4.2l-3.2,1.5c-0.3,0.2-0.6,0.9-0.6,1.7v21.9c0,0.8,0.3,1.2,0.6,1l3.5-2.6C893.1,351.2,894.9,348.3,894.9,343.6z M891.1,302.9v-26.3c0-0.5-0.2-1-0.4-1l-2.4-0.4c-0.2,0-0.4,0.4-0.4,0.9v27.1c0,4.4-1,10.5-4.4,11.4l0,0v-52.2l-33.1,24v79 l33.1,3.7v-46.6l0,0C888,321,891.1,313.3,891.1,302.9z M900.4,328.5c-1.5,0.8-2.5,4.2-2.5,8.3c0,4.1,1,6.3,2.5,5.3 c1.4-1,2.3-4.4,2.3-8.2C902.7,330,901.8,327.7,900.4,328.5z M891.2,342.9l-1.6,1v5.5l1.9-1.3c0.7-0.5,1.4-1.6,1.4-3.7 C892.9,342.2,891.9,342.4,891.2,342.9z M891.1,333.5l-1.5,0.8v5.1l1.6-0.9c0.7-0.4,1.3-1.4,1.3-3.3 C892.5,333.3,891.7,333.1,891.1,333.5z M879,305.7v-27.3c0-0.5-0.2-0.9-0.4-0.7l-2.5,1.6c-0.2,0.1-0.4,0.7-0.4,1.2v26.8 c0,10.6,3.2,16.4,7.8,15.3v-7.9C880,315.7,879,310.2,879,305.7z M879.6,356.2c0.2,0.9-0.1,1.9-0.6,1.9h-1.3 c-0.2,0-0.4-0.3-0.5-0.9l-0.7-4.3l-3.8,0.1l-0.7,4.1c-0.1,0.5-0.3,0.8-0.5,0.8h-1.1c-0.4,0-0.6-0.9-0.5-1.8l3.6-20.8 c0.1-0.5,0.3-0.9,0.5-0.9l1.1-0.2c0.2,0,0.4,0.2,0.5,0.7L879.6,356.2z M875.7,348.6l-1.2-7.3l-1.2,7.4L875.7,348.6z M873.7,280.7 l-10.7,6.7c-0.2,0.1-0.3,0.6-0.3,1.1v4.6c0,0.5,0.1,0.8,0.3,0.7l3.7-2.1V325c0,0.5,0.2,0.8,0.3,0.8l2.2-0.6c0.2,0,0.4-0.5,0.4-1 V290l4.2-2.3c0.2-0.1,0.4-0.6,0.4-1.2v-5.1C874.1,280.9,873.9,280.6,873.7,280.7z M865,336.1l-0.9,0.2c-0.3,0-0.5,0.6-0.5,1.3 v13.8l0,0l-3.2-13.9c-0.1-0.3-0.2-0.5-0.4-0.5l-1.6,0.3c-0.2,0-0.4,0.6-0.4,1.2v18.2c0,0.6,0.2,1.2,0.4,1.2h0.8 c0.2,0,0.4-0.5,0.4-1.2V343l0,0l3.3,14.3c0.1,0.4,0.2,0.6,0.4,0.6h1.6c0.3,0,0.5-0.5,0.5-1.2v-19.5 C865.5,336.6,865.3,336,865,336.1z M857.6,289.7c-2.4,1.5-4.7,6.4-4.7,13.8c0,12.8,6.1,5.6,6.1,13.9c0,3.5-1.3,5.6-2.3,5.9 c-0.9,0.3-1.8-0.6-2.3-2.4c-0.1-0.3-0.3-0.3-0.4,0.1l-1.1,3.4l-0.2,0.6c-0.1,0.3-0.1,0.8,0,1.1c0.1,0.2,0.1,0.3,0.2,0.5 c1,2.4,2.3,3.1,3.8,2.8c2.6-0.7,5-5.3,5-13.7c0-13.9-6.4-6.5-6.4-13.8c0-3.4,1-5.3,2.1-5.9c0.8-0.5,1.6-0.2,2.2,1.1 c0.1,0.3,0.3,0.2,0.4-0.3l1.4-4.8c0.1-0.4,0.1-1,0-1.2C860.2,289.1,858.9,288.9,857.6,289.7z M855.7,337.7l-0.7,0.1 c-0.2,0-0.4,0.6-0.4,1.2v17.6c0,0.6,0.2,1.1,0.4,1.1h0.7c0.2,0,0.4-0.5,0.4-1.1v-17.8C856.1,338.2,855.9,337.7,855.7,337.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4C4E51",points:"800.2,423 800.2,412.1 623.1,342.6 623.1,360.1 771.3,423 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#616468",points:"800.2,412.5 800.2,423 828.2,423 943.3,374.1 943.3,356.1 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7C8084",points:"724.4,276.3 560.6,238.9 623.1,218.1 800.2,247.6 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#ABABAB",points:"869.6,405.3 869.6,367.7 880.4,365.6 884.6,369.7 896,367.1 896,394.1 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#B5BFC4",points:"926,149 921.2,153.6 893.9,154.7 895,153 911.9,150.1 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#8C9499",points:"921.2,153.6 915,172.2 903.8,168.6 902.2,165.7 899.4,168.8 895,169.7 890.1,172.4 893.9,154.7 \t\t "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"8.6",y:"11",fill:"#9C9DA0",width:"1020.9",height:"114"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"logo",fill:"#717577",d:"M126.3,36v66.7c0,0.3-0.2,0.6-0.5,0.7L81.3,117v-0.1l-44.9-13.7c-0.3-0.1-0.5-0.4-0.5-0.7V36 c0-0.3,0.2-0.6,0.5-0.7L81.3,21l44.6,14.3C126.1,35.4,126.3,35.7,126.3,36z M122.8,46.9v-3.5c0-0.4-0.2-0.7-0.3-0.7l-10.3-2.5 c-0.2-0.1-0.4,0.2-0.4,0.6v31.7c0,0.4,0.2,0.7,0.4,0.7l2.5-0.1c0.2,0,0.4-0.3,0.4-0.7V59.7l7,0.6c0.2,0,0.3-0.3,0.3-0.6v-3.6 c0-0.4-0.2-0.7-0.3-0.7l-7-0.9V46l7.4,1.5C122.6,47.5,122.8,47.2,122.8,46.9z M121.7,96.9c0.4-0.1,0.6-1,0.4-1.6l-2.7-6.9l2.4-6.8 c0.2-0.6,0-1.5-0.4-1.4l-1.1,0.1c-0.2,0-0.4,0.2-0.4,0.5l-1.7,5.7l-1.9-5.4c-0.1-0.3-0.3-0.4-0.5-0.4l-1.4,0.1 c-0.5,0-0.7,1-0.5,1.6l2.7,6.5l-2.9,8.3c-0.2,0.7,0,1.6,0.5,1.5l1.2-0.3c0.2,0,0.4-0.3,0.5-0.6l2.1-7l2.1,6 c0.1,0.3,0.3,0.4,0.4,0.4L121.7,96.9z M105.9,101.2c3.5-0.8,5.9-5.2,5.9-11s-2.4-9.4-5.9-9.1c-3.7,0.3-6.5,4.7-6.5,11.1 S102.2,102,105.9,101.2z M109.7,44.2v-4c0-0.4-0.2-0.8-0.4-0.8l-13-3.2c-0.3-0.1-0.5,0.2-0.5,0.7v35.9c0,0.4,0.2,0.8,0.5,0.8 l3.1-0.1c0.3,0,0.5-0.4,0.5-0.8V58.3l8.8,0.8c0.2,0,0.4-0.3,0.4-0.7v-4c0-0.4-0.2-0.8-0.4-0.8l-8.8-1.2v-9.6l9.4,1.9 C109.5,44.8,109.7,44.6,109.7,44.2z M97.8,97c0-2.6-1.1-4.4-2.9-4.5v-0.1c1.4-0.9,2.3-2.6,2.3-4.9c0-4.4-2.5-4.9-4.9-4.7l-4.6,0.4 c-0.5,0-0.8,0.6-0.8,1.3V104c0,0.7,0.4,1.1,0.8,1l5.1-1.2C95.2,103.2,97.8,101.2,97.8,97z M92.2,59.5V36c0-0.5-0.2-0.9-0.6-1 l-3.5-0.9c-0.3-0.1-0.6,0.2-0.6,0.7v24c0,3.9-1.5,9.1-6.3,9l0,0v-46L36.8,36.1v66.3L81.3,116V75l0,0C87.7,74.8,92.2,68.8,92.2,59.5 z M105.9,85c-2.2,0.3-3.7,3.1-3.7,6.8c0,3.7,1.5,6,3.7,5.5c2.1-0.4,3.5-3.2,3.5-6.7C109.4,87.1,108,84.7,105.9,85z M92.4,95.2 L90,95.6v4.9l2.8-0.6c1-0.2,2-1,2-2.8C94.9,95.1,93.4,95,92.4,95.2z M92.2,86.8L90.1,87v4.6l2.3-0.3c0.9-0.1,1.9-0.9,1.9-2.6 C94.2,87,93.2,86.7,92.2,86.8z M75,59V35.1c0-0.5-0.3-0.8-0.6-0.7l-3.5,0.9c-0.3,0.1-0.5,0.5-0.5,1v23.4c0,9.2,4.5,15.1,10.9,15.4 v-7C76.5,68,75,62.9,75,59z M75.9,103.4c0.2,0.9-0.2,1.7-0.8,1.5l-1.8-0.4c-0.3-0.1-0.6-0.4-0.7-0.9l-1-3.9l-5.2-1.1l-0.9,3.4 c-0.1,0.4-0.4,0.6-0.7,0.6l-1.5-0.4c-0.5-0.1-0.8-1-0.6-1.7l4.9-17c0.1-0.4,0.4-0.7,0.7-0.6l1.5,0.1c0.3,0,0.6,0.3,0.7,0.8 L75.9,103.4z M70.5,95.5l-1.7-6.7l-1.6,6.1L70.5,95.5z M67.8,36l-14.4,3.5c-0.2,0.1-0.4,0.4-0.4,0.8v3.9c0,0.4,0.2,0.7,0.4,0.6 l4.9-1v28.6c0,0.4,0.2,0.8,0.5,0.8l2.9,0.1c0.3,0,0.5-0.3,0.5-0.8V43.2l5.7-1.1c0.3-0.1,0.5-0.5,0.5-0.9v-4.4 C68.3,36.2,68.1,35.9,67.8,36z M56,81.7l-1.2-0.1c-0.3,0-0.6,0.4-0.6,1v11.8l0,0l-4.3-12.7c-0.1-0.3-0.3-0.5-0.5-0.5L47.3,81 c-0.3,0-0.5,0.4-0.5,0.9v15.4c0,0.5,0.2,1,0.5,1.1l1,0.2c0.3,0.1,0.6-0.3,0.6-0.9V86.2l0,0l4.3,13.1c0.1,0.3,0.3,0.6,0.5,0.6 l2.2,0.5c0.4,0.1,0.6-0.3,0.6-0.9V82.8C56.7,82.2,56.4,81.7,56,81.7z M46.2,40.4c-3.1,0.8-6.1,4.4-6.1,10.6 c0,10.8,7.9,6.1,7.9,13.2c0,3-1.6,4.4-3.1,4.5c-1.2,0-2.3-0.9-3-2.6c-0.1-0.3-0.4-0.3-0.5,0L40,68.7l-0.2,0.4 c-0.1,0.2-0.1,0.7,0,0.9c0.1,0.2,0.2,0.3,0.2,0.5c1.3,2.3,3,3.2,4.8,3.3c3.4,0.1,6.6-3.3,6.6-10.4c0-11.8-8.4-7-8.4-13.2 c0-2.8,1.4-4.3,2.8-4.6c1.1-0.2,2.1,0.2,2.8,1.4c0.1,0.3,0.4,0.2,0.6-0.1l1.8-3.7c0.2-0.3,0.1-0.8,0-1C49.7,40.4,47.9,40,46.2,40.4 z M43.8,80.6l-1-0.1c-0.3,0-0.5,0.4-0.5,0.9v14.8c0,0.5,0.2,1,0.5,1.1l1,0.2c0.3,0.1,0.5-0.3,0.5-0.8V81.6 C44.3,81.1,44.1,80.6,43.8,80.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#848484",strokeWidth:"4",strokeMiterlimit:"10",points:"321.6,94 329.4,86 337.2,94 345,86  352.7,94 360.5,86 368.3,94 376.1,86 383.9,94 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#848484",strokeWidth:"4",strokeMiterlimit:"10",points:"424.6,94 432.4,86 440.2,94 448,86  455.7,94 463.5,86 471.3,94 479.1,86 486.9,94 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#848484",strokeWidth:"4",strokeMiterlimit:"10",points:"527.6,94 535.4,86 543.2,94 551,86  558.7,94 566.5,86 574.3,94 582.1,86 589.9,94 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#848484",strokeWidth:"4",strokeMiterlimit:"10",points:"630.6,94 638.4,86 646.2,94 654,86  661.7,94 669.5,86 677.3,94 685.1,86 692.9,94 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#848484",strokeWidth:"4",strokeMiterlimit:"10",points:"733.6,94 741.4,86 749.2,94 757,86  764.7,94 772.5,86 780.3,94 788.1,86 795.9,94 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#848484",strokeWidth:"4",strokeMiterlimit:"10",points:"836.6,94 844.4,86 852.2,94 860,86  867.7,94 875.5,86 883.3,94 891.1,86 898.9,94 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#848484",strokeWidth:"4",strokeMiterlimit:"10",points:"939.6,94 947.4,86 955.2,94 963,86  970.7,94 978.5,86 986.3,94 994.1,86 1001.9,94 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"save"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"528.6",y:"31",fill:"#ABABAB",width:"384",height:"26"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"912.6",y:"31",fill:"#717577",width:"88",height:"26"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"none",stroke:"#ABABAB",strokeWidth:"4",strokeMiterlimit:"10",points:"932.6,47 938.4,41 944.3,47 950.1,41  956,47 961.8,41 967.6,47 973.5,41 979.3,47 \t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"73.6",y:"186",fill:"none",width:"439",height:"213"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"matrix(1 0 0 1 73.6 214.6396)",fill:"#9B9B9B",fontFamily:"'montserratblack'",fontSize:"40px"},"WELCOME TO THE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"matrix(1 0 0 1 73.6 262.6396)",fill:"#9B9B9B",fontFamily:"'montserratblack'",fontSize:"40px"},"STUFF IN A BOX"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"matrix(1 0 0 1 73.6 310.6396)",fill:"#9B9B9B",fontFamily:"'montserratblack'",fontSize:"40px"},"CUSTOMER SUPPORT"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"matrix(1 0 0 1 73.6 358.6396)",fill:"#9B9B9B",fontFamily:"'montserratblack'",fontSize:"40px"},"INTERNET PAGE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"34.6",y:"465",fill:"none",width:"627",height:"82"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"matrix(1 0 0 1 34.6 487.9116)",fill:"#848484",fontFamily:"'montserratblack'",fontSize:"32px"},"I AM TRAPPED BENEATH A TINY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"matrix(1 0 0 1 34.6 526.3116)",fill:"#848484",fontFamily:"'montserratblack'",fontSize:"32px"},"AVALANCHE OF DELIVERY BOXES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"34.6",y:"883",fill:"none",width:"627",height:"67"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"matrix(1 0 0 1 34.6 905.9116)",fill:"#848484",fontFamily:"'montserratblack'",fontSize:"32px"},"MY S.I.A.B ORDER HAS FILLED"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"matrix(1 0 0 1 34.6 944.3116)",fill:"#848484",fontFamily:"'montserratblack'",fontSize:"32px"},"ME WITH EXISTENTIAL DREAD"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#686A6D",points:"345.803,372.116 349.85,423 443.267,423 "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"redVignette vignette"+index,version:"1.1",id:"box",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 1024 768",preserveAspectRatio:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"s5",fill:"#CC0000",width:"1024",height:"768"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"s4",fill:"#CC0000",d:"M0,768h288.838l7.763-76l-68.994-14.604l11.554-28l-32.35,13L191.847,603 l-17.306-51.916l16.945-30l-33.121-3l33.121-47L107.89,454l84.366-105.916l-40.051-24.99L180.294,283l-17.673-105l30.767-8 l-13.051-47l29.226,2l-13.864-36l50.836-18l-11.554-55l27.772-16H0V768z M1024,0H777.037L724.97,23.108l27.61,57.316l-6.054,47.998 l52.067-19.499l-17.923,61.178l31.482,13.499l-16.622,54.408l74.744-0.41l-35.385,80.526l37.166,26.086l-45.372,53.88l21.795,74.996 L802.941,485l23.741,42.083l-41.389,58.816l19.374,71.996l-66.597,10.499l14.022,55l-68.511,7.997L702.865,768H1024V0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"s3",fill:"#CC0000",d:"M1024,768H772.846l-8.073-57l62.968,12l-4.036-57l55.702,4l-28.255-98l41.171-11 l-22.604-56l26.64-27l-5.651-74l8.88-46l-46.015-53l15.489-41.904l-18.25-33.606l22.604-58L823.704,138l6.611-95.393l-112.61,3 L769.772,0H1024V768z M0,768h239.627l16.175-59l-76.255,11l0.385-48.924l-61.232,9L156.441,600l-31.962-38.418L158.751,483 l-36.584-56.412L141.806,373l-62.385-61.906L160.292,276l-42.364-69l46.985-27l-19.642-32.897l55.458-10l-35.431-66l86.268,19 L231.925,0H0V768z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"s2",fill:"#CC0000",d:"M1024,0H793.989l-8.137,76l72.311,14.604l-12.109,28l33.906-13L895.643,165l44.4,33 l-17.76,30l34.713,3l-34.713,47l61.353,36l-62.161,87l36.328,28l-50.051,56l18.522,105l-32.246,8l13.679,47l-30.631-2l14.531,36 l-53.28,18l12.109,55l-29.107,16H1024V0z M0,768h215.002l-22.36-66.925l-39.281-13.499l5.777-47.998l-49.679,19.499l4.46-76 L92.76,570l19.622-40.008l-53.77-3l7.518-47L44.596,454l52.49-53.974L73.137,339l55.299-56l-20.132-57.402l36.97-43.498 l-18.485-71.996l63.542-10.499l-13.379-55l65.368-7.997L223.922,0H0V768z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"s1",fill:"#CC0000",d:"M0,0h168.684l-33.121,67l-61.62,6l9.243,65l-46.985-9l21.567,58l-19.256,36l16.175,82 l-43.904,53l8.473,46l-5.392,74l25.418,27l-21.567,56l39.283,11L30.04,670l53.147-4l-3.851,57l60.079-12l-7.702,57H0V0z M1024,0 H885.955l-35.52,64l90.415-19l-37.135,66l58.124,10l-5.651,59l49.244,27l-44.4,69l41.171,29l-21.797,68l9.687,70l-27.448,40 l20.989,62l-18.567,55l12.109,42l-50.051,22l13.724,56l-79.921-11l16.953,59H1024V0z"})),ended&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__darkpatterns2d_RageEngage__["a" /* default */],null))),this.state.showAd&&data.adText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__darkpatterns2d_Pattern2d__["a" /* default */],{adText:data.adText,adClicked:this.addClickedOk,index:index,round:this.props.round}),!this.state.sceneEnded&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"popoverSimple"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bubbleWrapper "+(this.state.hideBubble?'hide':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bubble"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{dangerouslySetInnerHTML:this.setDatTextSon()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bubble-arrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"Layer_1",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 45.255 22.627",preserveAspectRatio:"xMinYMin slice"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#ffffff",points:"0,0 22.627,22.627 45.255,0 "})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__darkpatterns2d_Avatar__["a" /* default */],{round:this.props.round,look:index,speaking:this.state.speaking})));}}]);return TwoDView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var TwoD=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TwoDView);/* harmony default export */ __webpack_exports__["a"] = (TwoD);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Round1__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Round2__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Round3__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Round4__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Round5__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Round6__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Round7__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Round8__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Round9__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SimpleDarkPattern2d__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_actionCreators_js__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{pattern2dIn:function pattern2dIn(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_actionCreators_js__["j" /* pattern2dIn */])());},pattern2dOut:function pattern2dOut(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_actionCreators_js__["k" /* pattern2dOut */])());},stopVoice:function stopVoice(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__actions_actionCreators_js__["q" /* stopVoice */])());}};};var Pattern2dView=function(_Component){_inherits(Pattern2dView,_Component);function Pattern2dView(){_classCallCheck(this,Pattern2dView);return _possibleConstructorReturn(this,(Pattern2dView.__proto__||Object.getPrototypeOf(Pattern2dView)).apply(this,arguments));}_createClass(Pattern2dView,[{key:"componentDidMount",value:function componentDidMount(){this.props.pattern2dIn();this.allowInput=true;}},{key:"userClosedAd",value:function userClosedAd(){// throttle input - so doesn't allow user to skip anything
if(this.allowInput){this.allowInput=false;this.props.stopVoice();this.props.adClicked();}}},{key:"backupMarkup",value:function backupMarkup(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SimpleDarkPattern2d__["a" /* default */],{adComplete:this.userClosedAd.bind(this),adText:""});}},{key:"getDarkPattern",value:function getDarkPattern(){// LEVEL 1
if(this.props.index===0&&this.props.round===1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Round1__["a" /* default */],{adComplete:this.userClosedAd.bind(this)});}if(this.props.index===1&&this.props.round===1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Round2__["a" /* default */],{adComplete:this.userClosedAd.bind(this)});}if(this.props.index===2&&this.props.round===1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Round3__["a" /* default */],{adComplete:this.userClosedAd.bind(this)});}// LEVEL 2
if(this.props.index===0&&this.props.round===2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Round4__["a" /* default */],{adComplete:this.userClosedAd.bind(this)});}if(this.props.index===1&&this.props.round===2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Round5__["a" /* default */],{adComplete:this.userClosedAd.bind(this)});}if(this.props.index===2&&this.props.round===2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Round6__["a" /* default */],{adComplete:this.userClosedAd.bind(this)});}// LEVEL 3
if(this.props.index===0&&this.props.round===3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Round7__["a" /* default */],{adComplete:this.userClosedAd.bind(this)});}if(this.props.index===1&&this.props.round===3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Round8__["a" /* default */],{adComplete:this.userClosedAd.bind(this)});}if(this.props.index===2&&this.props.round===3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Round9__["a" /* default */],{adComplete:this.userClosedAd.bind(this)});}return this.backupMarkup();}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.props.pattern2dOut();}},{key:"render",value:function render(){return this.getDarkPattern();}}]);return Pattern2dView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Pattern2d=Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(Pattern2dView);/* harmony default export */ __webpack_exports__["a"] = (Pattern2d);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{twoDDarkPatternIncorrect:function twoDDarkPatternIncorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["t" /* twoDDarkPatternIncorrect */])());},twoDDarkPatternCorrect:function twoDDarkPatternCorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["s" /* twoDDarkPatternCorrect */])());}};};var Round1View=function(_Component){_inherits(Round1View,_Component);function Round1View(props){_classCallCheck(this,Round1View);var _this=_possibleConstructorReturn(this,(Round1View.__proto__||Object.getPrototypeOf(Round1View)).call(this,props));_this.state={shake:false,done:false};return _this;}_createClass(Round1View,[{key:"clicked",value:function clicked(){var _this2=this;this.props.twoDDarkPatternCorrect();this.setState({// shake: true,
done:true});__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].delayedCall(0.5,function(){return _this2.props.adComplete();});}},{key:"shake",value:function shake(){var _this3=this;this.setState({shake:true});__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].delayedCall(0.6,function(){_this3.setState({shake:false});});this.props.twoDDarkPatternIncorrect();}},{key:"render",value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"floatingad "+(this.state.shake?'shake':'')+" "+(this.state.done?'out':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"Layer_1",x:"0px",y:"0px",viewBox:"0 0 495.192 382.678",enableBackground:"new 0 0 495.192 382.678"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME",onClick:function onClick(e){return _this4.shake();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_3_",fill:"#FFFFFF",width:"495.192",height:"382.678"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"16.369",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"35.325",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"474.289",y:"15.666",transform:"matrix(0.7071 0.7071 -0.7071 0.7071 155.8294 -329.5406)",fill:"#B2AFAA",width:"2.833",height:"15.333"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"474.289",y:"15.666",transform:"matrix(-0.7071 0.7071 -0.7071 -0.7071 828.5784 -296.5436)",fill:"#B2AFAA",width:"2.833",height:"15.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M64.374,26.672c0,2.179-1.801,3.457-5.186,3.457h-6.806V17.525h6.446c3.313,0,4.934,1.351,4.934,3.295 c0,1.206-0.612,2.178-1.692,2.737C63.492,24.061,64.374,25.141,64.374,26.672z M55.912,20.1v2.431h2.449 c1.188,0,1.8-0.414,1.8-1.225c0-0.792-0.612-1.206-1.8-1.206H55.912z M60.773,26.276c0-0.864-0.648-1.278-1.873-1.278h-2.989 v2.557h2.989C60.125,27.554,60.773,27.14,60.773,26.276z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M65.036,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554c0,3.781-2.971,6.554-7.004,6.554 S65.036,27.608,65.036,23.827z M75.444,23.827c0-2.179-1.495-3.601-3.403-3.601s-3.403,1.422-3.403,3.601s1.494,3.601,3.403,3.601 S75.444,26.006,75.444,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M87.881,30.129l-2.611-3.907l-2.575,3.907h-4.069l4.591-6.374l-4.393-6.23h4.015l2.521,3.637l2.484-3.637 h3.854l-4.394,6.086l4.682,6.518H87.881z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M100.517,30.129l-2.611-3.907l-2.575,3.907h-4.069l4.591-6.374l-4.393-6.23h4.015l2.521,3.637l2.485-3.637 h3.853l-4.393,6.086l4.681,6.518H100.517z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M104.907,17.525h3.565v12.604h-3.565V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M120.588,27.374v2.755h-10.119V17.525h9.885v2.755h-6.356v2.125h5.6v2.665h-5.6v2.305H120.588z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M135.167,27.68h-5.33l-0.991,2.449h-3.637l5.563-12.604h3.511l5.582,12.604h-3.709L135.167,27.68z M134.123,25.051l-1.621-4.033l-1.621,4.033H134.123z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M139.448,28.994l1.17-2.629c1.116,0.738,2.701,1.242,4.159,1.242c1.477,0,2.053-0.414,2.053-1.026 c0-1.999-7.166-0.541-7.166-5.222c0-2.25,1.836-4.087,5.582-4.087c1.639,0,3.331,0.378,4.573,1.099l-1.098,2.646 c-1.207-0.648-2.395-0.972-3.493-0.972c-1.494,0-2.035,0.504-2.035,1.134c0,1.927,7.148,0.486,7.148,5.132 c0,2.196-1.836,4.069-5.582,4.069C142.689,30.381,140.636,29.822,139.448,28.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M156.297,25.555l-1.332,1.422v3.151h-3.529V17.525h3.529v5.24l4.879-5.24h3.925l-5.15,5.582l5.42,7.022 h-4.141L156.297,25.555z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M163.279,28.994l1.17-2.629c1.117,0.738,2.701,1.242,4.159,1.242c1.477,0,2.053-0.414,2.053-1.026 c0-1.999-7.166-0.541-7.166-5.222c0-2.25,1.836-4.087,5.582-4.087c1.639,0,3.331,0.378,4.573,1.099l-1.098,2.646 c-1.207-0.648-2.395-0.972-3.493-0.972c-1.494,0-2.035,0.504-2.035,1.134c0,1.927,7.148,0.486,7.148,5.132 c0,2.196-1.837,4.069-5.582,4.069C166.521,30.381,164.468,29.822,163.279,28.994z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"9.162",y:"44.319",fill:"#BF45D1",width:"476.867",height:"330.796"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#9A2D9E",points:"486.03,212.591 9.162,291.638 9.162,375.115 486.03,375.115 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#771E7F",points:"486.03,345.59 9.162,346.845 9.162,375.115 486.03,375.115 \t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004966",d:"M85.897,200.862l12.063-35.083l-12.511-7.111L69.778,195.41L85.897,200.862z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M186.355,303.422c3.125,0.892,5.844,3.205,7.336,5.782l4.638,8.238l0,0 c-1.522-2.739-4.069-4.849-7.336-5.782c-6.463-1.846-13.22,1.909-15.066,8.373c-0.832,2.912-0.537,5.915,0.651,8.482 l-4.232-7.507c-1.33-2.607-1.929-6.158-1.057-9.212C173.135,305.332,179.892,301.577,186.355,303.422z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#003647",d:"M185.304,331.314c-3.764-1.075-6.21-4.616-5.977-8.39l0.903,0.335L185.304,331.314z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004966",d:"M176.507,328.494c-1.187-2.567-1.502-5.499-0.651-8.482c1.846-6.463,8.602-10.218,15.066-8.373 c3.267,0.933,5.814,3.043,7.336,5.782s1.969,6.016,1.036,9.283l-3.764-1.075c1.156-4.048-0.945-8.259-4.709-9.871 c-0.335-0.172-0.619-0.254-0.974-0.355c-4.404-1.257-8.969,1.28-10.226,5.683c-0.183,0.639-0.274,1.228-0.294,1.836 c-0.233,3.774,2.213,7.315,5.977,8.39l-1.075,3.764C180.678,334.064,177.928,331.589,176.507,328.494L176.507,328.494z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#003647",d:"M190.679,316.794l0.142-1.035c3.764,1.613,5.865,5.823,4.709,9.871L190.679,316.794z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#003647",cx:"175.02",cy:"304.306",r:"10.087"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004966",d:"M184.739,307.005c-0.246,0.885-0.611,1.703-1.059,2.456c-1.86,0.91-4.043,1.177-6.195,0.579 c-4.669-1.297-7.403-6.133-6.106-10.802c0.598-2.152,1.952-3.885,3.691-5.009c0.876,0.005,1.765,0.113,2.65,0.359 C183.087,296.078,186.23,301.638,184.739,307.005z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#0C91BF",cx:"180.259",cy:"300.547",r:"1.97"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#00435E",cx:"154.123",cy:"227.447",r:"10.087"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00517A",d:"M151.477,217.714c0.886-0.241,1.776-0.344,2.652-0.344c1.732,1.134,3.077,2.874,3.663,5.029 c1.271,4.676-1.489,9.497-6.165,10.769c-2.155,0.586-4.337,0.307-6.192-0.613c-0.444-0.756-0.805-1.575-1.046-2.461 C142.928,224.718,146.101,219.175,151.477,217.714z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#36B7FF",cx:"151.292",cy:"222.667",r:"1.97"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M155.303,232.771c3.493-0.95,5.592-0.267,5.592-0.267l17.326,63.723c0,0-1.081,1.444-4.868,2.473 s-5.681,0.395-5.681,0.395l-17.326-63.723C150.346,235.373,151.81,233.721,155.303,232.771z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M175.99,288.307l0.071-0.019l0.916,3.368l-10.549,2.868l-0.916-3.368L175.99,288.307z M173.243,278.204 l0.071-0.019l0.916,3.368l-0.071,0.019l-10.478,2.849l-0.916-3.368L173.243,278.204z M170.496,268.101l0.071-0.019l0.916,3.368 l-0.071,0.019l-10.478,2.849l-0.916-3.368L170.496,268.101z M167.729,257.921l0.071-0.019l0.916,3.368l-0.071,0.019l-10.478,2.849 l-0.916-3.368L167.729,257.921z M164.982,247.818l0.071-0.019l0.916,3.368l-0.071,0.019l-10.478,2.849l-0.916-3.368 L164.982,247.818z M162.235,237.715l0.071-0.019l0.916,3.368l-0.071,0.019l-10.478,2.849l-0.916-3.368L162.235,237.715z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#99710E",points:"178.571,201.616 173.83,286.163 85.964,278.657 85.964,188.183 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#725006",points:"85.964,278.657 24.094,283.398 20.934,196.48 85.964,188.183 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#332204",points:"58.703,206.91 52.856,204.223 54.2,202.643 40.372,203.828 42.505,205.172 36.263,210.071  39.977,215.286 36.026,227.533 40.372,227.138 37.606,233.38 62.259,226.664 58.703,223.74 65.894,217.972 61.706,213.468  63.919,206.357 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#442C01",points:"173.83,286.163 118.914,287.348 24.094,283.398 85.964,278.657 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E0AD3B",points:"20.934,196.48 9.185,199.649 9.185,204.311 64.788,198.06 85.964,188.183 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"logo_1_",fill:"#2D2619",d:"M159.681,228.542l-0.627,26.935c-0.004,0.166-0.07,0.247-0.198,0.242l-18.405,7.559l0,0 l-27.837-5.328c-0.225-0.007-0.371-0.192-0.367-0.372l0.957-41.13c0.004-0.18,0.158-0.345,0.383-0.323l27.955,0.285l17.955,11.782 C159.623,228.287,159.685,228.376,159.681,228.542z M158.363,232.686l0.033-1.416c0.004-0.167-0.057-0.338-0.121-0.344l-3.655-1.893 c-0.065-0.005-0.132,0.073-0.136,0.241l-0.316,13.591c-0.004,0.168,0.057,0.339,0.123,0.343l0.912,0.054 c0.065,0.004,0.134-0.16,0.138-0.327l0.125-5.358l2.513,0.591c0.064,0.004,0.131-0.075,0.135-0.241l0.035-1.5 c0.004-0.167-0.059-0.255-0.121-0.343l-2.507-0.851l0.084-3.6l2.628,1.211C158.293,232.931,158.361,232.77,158.363,232.686z M157.499,253.165c0.131-0.078,0.203-0.409,0.144-0.661l-0.902-2.88l0.905-2.794c0.07-0.247,0.014-0.584-0.115-0.591l-0.387-0.021 c-0.065-0.003-0.131,0.076-0.135,0.243l-0.703,2.389l-0.661-2.294c-0.063-0.087-0.126-0.174-0.191-0.178l-0.522,0.056 c-0.195-0.01-0.27,0.405-0.211,0.66l0.911,2.812l-1.122,3.471c-0.073,0.333-0.016,0.67,0.182,0.595l0.459-0.149 c0.065,0.003,0.134-0.162,0.201-0.243l0.849-2.977l0.718,2.539c0.063,0.086,0.061,0.17,0.125,0.172L157.499,253.165z M151.583,255.194c1.391-0.452,2.349-2.262,2.408-4.779c0.059-2.517-0.822-4.076-2.204-3.981c-1.455,0.092-2.693,1.975-2.76,4.852 S150.053,255.643,151.583,255.194z M153.604,230.463l0.039-1.68c0.004-0.168-0.058-0.342-0.121-0.431l-5.231-2.739 c-0.131-0.097-0.202,0.067-0.206,0.237l-0.383,16.46c-0.004,0.17,0.059,0.343,0.192,0.351l1.331,0.079 c0.133,0.008,0.203-0.157,0.207-0.327l0.15-6.429l3.544,0.926c0.065,0.005,0.198-0.07,0.202-0.238l0.041-1.765 c0.004-0.168-0.058-0.341-0.189-0.351l-3.538-1.194l0.1-4.314l3.724,1.657C153.531,230.794,153.601,230.631,153.604,230.463z M148.245,253.372c0.028-1.186-0.421-1.969-1.223-2.005l0,0c0.611-0.398,1.029-1.142,1.055-2.244 c0.047-2.034-1.015-2.344-2.091-2.23l-2.095,0.148c-0.203-0.01-0.414,0.321-0.42,0.577l-0.215,9.228 c-0.008,0.342,0.191,0.52,0.396,0.441l2.309-0.688C147.042,256.297,148.2,255.32,148.245,253.372z M146.24,236.002l0.255-10.975 c0.006-0.255-0.124-0.438-0.257-0.535l-1.6-0.829c-0.133-0.098-0.272,0.061-0.276,0.231l-0.266,11.443 c-0.044,1.879-0.776,4.226-3.086,3.906l0,0l0.524-22.489l-27.656-0.239l-0.95,40.815l27.535,5.433l0.468-20.086l0,0 C143.987,242.942,146.139,240.341,146.24,236.002z M151.75,248.034c-0.861,0.126-1.485,1.362-1.522,2.967 c-0.037,1.604,0.534,2.642,1.397,2.424c0.86-0.217,1.414-1.456,1.449-2.969C153.041,249.025,152.54,247.99,151.75,248.034z M145.921,252.596l-1.082,0.211l-0.054,2.301l1.286-0.292c0.404-0.07,0.883-0.476,0.903-1.325 C146.995,252.556,146.392,252.53,145.921,252.596z M145.945,248.679l-0.946,0.125l-0.05,2.13l1.013-0.125 c0.404-0.067,0.881-0.385,0.899-1.15C146.814,248.806,146.347,248.699,145.945,248.679z M137.957,234.466l0.281-12.082 c0.006-0.259-0.128-0.444-0.266-0.457l-1.873-0.089c-0.139-0.013-0.282,0.147-0.288,0.407l-0.28,12.046 c-0.111,4.766,2.244,8.029,5.468,8.391l0.08-3.433C138.609,239.089,137.911,236.451,137.957,234.466z M137.851,256.832 c0.128,0.436-0.089,0.86-0.432,0.763l-0.965-0.205c-0.208-0.007-0.343-0.184-0.406-0.446l-0.51-2.01l-2.858-0.455l-0.535,1.81 c-0.076,0.259-0.219,0.341-0.431,0.334l-0.845-0.116c-0.283-0.01-0.483-0.541-0.333-0.885l3.027-8.937 c0.076-0.257,0.218-0.337,0.358-0.33l0.836,0.13c0.139,0.007,0.345,0.191,0.408,0.455L137.851,256.832z M135.097,252.922 l-0.828-3.422l-0.985,3.174L135.097,252.922z M134.28,221.929l-8.744-0.284c-0.144-0.013-0.292,0.15-0.299,0.414l-0.051,2.205 c-0.006,0.265,0.134,0.454,0.278,0.466l3.157,0.099l-0.365,15.699c-0.006,0.263,0.132,0.447,0.275,0.456l1.774,0.194 c0.142,0.008,0.287-0.158,0.293-0.42l0.368-15.812l3.24,0.109c0.14,0.012,0.284-0.149,0.29-0.41l0.055-2.345 C134.625,222.135,134.49,221.948,134.28,221.929z M126.783,245.369l-0.716-0.126c-0.216-0.011-0.438,0.241-0.444,0.506l-0.154,6.606 l0,0l-2.653-7.283c-0.068-0.181-0.212-0.277-0.357-0.285l-1.456-0.166c-0.219-0.012-0.372,0.247-0.378,0.513l-0.209,8.97 c-0.008,0.355,0.132,0.627,0.351,0.635l0.728,0.115c0.219,0.008,0.368-0.164,0.377-0.518l0.155-6.645l0,0l2.728,7.459 c0.068,0.179,0.21,0.272,0.352,0.366l1.362,0.225c0.215,0.008,0.434-0.161,0.442-0.512l0.215-9.225 C127.133,245.739,126.998,245.38,126.783,245.369z M120.823,220.943c-2.207-0.026-4.471,1.649-4.558,5.409 c-0.152,6.535,5.641,4.644,5.546,8.723c-0.039,1.685-1.227,2.407-2.179,2.344c-0.882-0.058-1.679-0.735-2.173-1.752 c-0.07-0.184-0.292-0.199-0.368-0.114l-1.074,1.451l-0.155,0.259c-0.078,0.174-0.083,0.353-0.013,0.537 c0.072,0.094,0.144,0.189,0.142,0.278c0.931,1.491,2.175,2.104,3.498,2.273c2.412,0.234,4.561-1.494,4.653-5.469 c0.156-6.713-5.737-4.957-5.652-8.614c0.039-1.695,1.013-2.324,2.04-2.235c0.731,0.064,1.455,0.394,1.946,1.236 c0.069,0.183,0.287,0.202,0.364,0.031l1.278-1.839c0.149-0.164,0.083-0.435,0.014-0.619 C123.147,221.513,121.992,221.051,120.823,220.943z M118.514,244.309l-0.662-0.125c-0.222-0.012-0.376,0.248-0.382,0.516 l-0.206,8.838c-0.006,0.268,0.133,0.63,0.355,0.639l0.662,0.114c0.221,0.008,0.372-0.164,0.381-0.521l0.207-8.907 C118.876,244.596,118.735,244.32,118.514,244.309z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E0AD3B",points:"189.633,234.012 178.571,201.616 85.964,188.183 100.74,222.16 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_12_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2D2619",points:"174.57,271.807 173.827,286.164 85.962,278.658 85.938,278.658 85.938,262.065 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E180E",points:"85.938,262.065 85.938,278.658 24.092,283.399 23.649,270.093 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#332204",points:"130.055,286.295 85.016,282.607 63.682,284.056 58.15,292.616 76.653,286.558 86.86,297.225  91.008,286.295 111.091,296.369 116.491,291.167 126.565,295.974 130.45,290.641 139.8,292.616 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#03222B",d:"M103.193,325.681c0,0-9.559-0.327-9.846-0.341c-9.504-0.411-17.828,9.302-18.471,21.723 c-0.495,12.487,6.8,22.846,16.452,23.322c9.652,0.477,9.846,0.341,9.846,0.341c9.652,0.477,17.976-9.236,18.471-21.723 S112.844,326.158,103.193,325.681z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00374C",d:"M100.713,341.328L100.713,341.328c-1.572-3.455-4.398-5.691-7.785-5.866 c-5.283-0.309-9.837,5.128-10.147,12.011c-0.31,6.882,3.725,12.589,9.008,12.898c3.388,0.176,6.381-1.957,8.238-5.129 c1.114-1.903,1.808-4.26,1.909-6.881C102.144,345.697,101.601,343.323,100.713,341.328z M93.347,325.34 c9.652,0.477,16.948,10.835,16.452,23.322s-8.819,22.2-18.471,21.723c-9.652-0.477-16.948-10.835-16.452-23.322 C75.519,334.641,83.843,324.929,93.347,325.34z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#01090C",d:"M100.713,341.328c0.889,1.995,1.431,4.37,1.33,6.991c-0.142,2.514-0.836,4.871-1.909,6.881 c-0.99,0.626-1.954,0.996-3.084,0.937c-3.388-0.176-6.023-3.837-5.747-8.247c0.168-4.369,3.138-7.845,6.525-7.669 C98.809,340.214,99.807,340.569,100.713,341.328L100.713,341.328z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_5_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#006382",points:"117.571,286.266 115.427,301.515 97.139,305.489 97.838,283.298 103.978,282.348 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004966",d:"M97.838,283.298l-0.699,22.191l-0.055,0.008l-11.135-1.61c-0.377-10.459-0.667-18.642-0.667-18.642 L97.838,283.298z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M97.139,305.489l-1.335,42.317c-0.157,4.013-3.502,5.944-5.811,5.363 c-1.547-1.044-2.356-3.133-2.458-5.363c-0.079-1.892-0.95-26.18-1.586-43.919l11.135,1.61L97.139,305.489z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M98.262,326.996c0,0-1.005,19.238-1.139,21.304c-0.196,3.007-2.45,5.858-5.238,5.56 c-0.722-0.071-1.351-0.314-1.892-0.691c2.309,0.581,5.654-1.351,5.811-5.363l1.335-42.317l18.288-3.973l-3.863,27.397 l-1.673-1.178l-0.927-1.845l-9.085-0.393L98.262,326.996z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#513600",points:"133.479,283.924 86.333,279.842 60.521,282.146 56.438,289.455 72.9,285.636 73.69,295.382  96.737,286.295 108.457,291.958 115.832,287.348 133.084,296.83 128.738,288.27 142.698,290.377 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_2_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M56.968,308.385c2.398,2.407,3.677,6.04,3.784,9.17l-0.071,9.219c-0.218-3.018-1.499-5.981-3.785-8.276 c-5.076-5.093-13.345-5.107-18.438-0.031c-2.574,2.566-3.865,5.86-3.871,9.212l0,0l0.073-10.113 c0.061-3.185,1.408-6.758,3.871-9.212C43.623,303.279,51.893,303.292,56.968,308.385z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00435E",d:"M54.54,323.746l0.672-0.781c2.173,3.412,1.719,7.993-1.248,10.949L54.54,323.746z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#035B77",d:"M60.737,326.718c0.273,3.632-1.018,7.374-3.816,10.162l-2.956-2.966 c2.966-2.956,3.421-7.537,1.248-10.949c-0.334-0.559-0.725-1.063-1.227-1.567c-3.458-3.47-9.046-3.479-12.515-0.021 c-0.28,0.279-0.504,0.502-0.728,0.837c-2.688,3.46-2.473,8.489,0.707,11.679l-2.966,2.956c-2.566-2.574-3.845-5.873-3.84-9.225 c0.006-3.352,1.296-6.647,3.871-9.212c5.093-5.076,13.362-5.062,18.438,0.031C59.294,320.793,60.519,323.701,60.737,326.718 L60.737,326.718z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00435E",d:"M41.449,333.893c-3.179-3.19-3.394-8.219-0.707-11.679l0.669,0.895L41.449,333.893z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#035B77",cx:"47.812",cy:"301.901",r:"10.79"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M47.812,291.11c-0.983,0-1.93,0.143-2.835,0.389c-1.47,1.657-2.37,3.831-2.37,6.22 c0,5.184,4.202,9.386,9.386,9.386c2.389,0,4.563-0.9,6.22-2.37c0.246-0.905,0.389-1.852,0.389-2.835 C58.602,295.941,53.772,291.11,47.812,291.11z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#36B7FF",cx:"47.483",cy:"299.201",r:"2.107"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#035B77",cx:"47.812",cy:"216.695",r:"10.79"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M47.812,205.905c-0.983,0-1.93,0.143-2.835,0.389c-1.47,1.657-2.37,3.831-2.37,6.22 c0,5.184,4.202,9.386,9.386,9.386c2.389,0,4.563-0.9,6.22-2.37c0.246-0.905,0.389-1.852,0.389-2.835 C58.602,210.736,53.772,205.905,47.812,205.905z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#36B7FF",cx:"49.393",cy:"210.966",r:"2.107"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M53.936,223.816v70.642c0,0-1.778,1.187-5.976,1.187s-5.719-1.187-5.719-1.187v-70.642 c0,0,1.975-1.294,5.847-1.294S53.936,223.816,53.936,223.816z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#035B77",d:"M53.936,285.657v3.733H42.242v-3.733h0.079H53.936z M53.936,274.457v3.733H42.321h-0.079v-3.733h0.079 H53.936z M53.936,263.257v3.733H42.321h-0.079v-3.733h0.079H53.936z M53.936,251.972v3.733H42.321h-0.079v-3.733h0.079H53.936z M53.936,240.771v3.733H42.321h-0.079v-3.733h0.079H53.936z M53.936,229.571v3.733H42.321h-0.079v-3.733h0.079H53.936z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36B7FF",points:"117.349,132.153 86.81,195.346 134.967,209.513 161.861,155.527 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M82.385,119.932L62.631,162.6l17.344,12.695c-0.002-0.008,0.024-0.033,0.064-0.066 c0.007,0.03,0.013,0.056,0.015,0.066l6.756,20.051l30.619-63.114L82.385,119.932z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M88.989,135.981c0,0-5.569-2.359-5.735-2.432c-5.517-2.396-12.632,1.452-15.826,8.639 c-3.122,7.26-1.162,15.028,4.428,17.496c5.59,2.468,5.735,2.432,5.735,2.432c5.59,2.468,12.704-1.379,15.826-8.639 C96.539,146.217,94.579,138.449,88.989,135.981z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M83.98,144.656L83.98,144.656c-0.145-2.396-1.307-4.356-3.267-5.227 c-3.049-1.379-6.969,0.799-8.712,4.791c-1.742,3.993-0.653,8.276,2.396,9.655c1.96,0.871,4.211,0.29,6.026-1.162 c1.089-0.871,2.033-2.105,2.686-3.63C83.835,147.56,84.052,146.035,83.98,144.656z M83.254,133.548 c5.59,2.468,7.55,10.236,4.428,17.496c-3.122,7.26-10.236,11.107-15.826,8.639c-5.59-2.468-7.55-10.236-4.428-17.496 C70.622,135,77.736,131.153,83.254,133.548z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00374C",d:"M83.98,144.656c0.073,1.379-0.145,2.904-0.799,4.428c-0.653,1.452-1.597,2.686-2.686,3.63 c-0.726,0.145-1.379,0.145-2.033-0.145c-1.96-0.871-2.686-3.63-1.525-6.171c1.089-2.541,3.63-3.92,5.59-3.049 C83.109,143.567,83.617,144.002,83.98,144.656L83.98,144.656z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M109.841,157.69c-0.576,0.907-1.047,2.01-1.219,3.206c-0.694,4.485,2.378,8.588,6.863,9.282 c4.485,0.694,8.588-2.378,9.282-6.863c0.172-1.196,0.048-2.285-0.175-3.373L109.841,157.69z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M108.622,160.895c-0.396,2.559,0.437,4.99,2.055,6.738c0.286,0.076,0.579,0.14,0.878,0.186 c4.485,0.694,8.588-2.378,9.282-6.863c0.078-0.546,0.089-1.067,0.063-1.579l-11.059-1.688 C109.266,158.596,108.794,159.7,108.622,160.895z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M140.938,166.292c-0.941,0.21-1.883,0.629-2.719,1.257c-3.137,2.303-3.866,6.802-1.458,9.938 c2.303,3.137,6.802,3.866,9.938,1.458c0.836-0.628,1.464-1.361,1.986-2.198L140.938,166.292z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M138.219,167.549c-3.137,2.303-3.866,6.801-1.458,9.938c0.362,0.493,0.782,0.918,1.238,1.289 c1.649,0.129,3.35-0.311,4.771-1.402c0.836-0.628,1.464-1.361,1.986-2.198l-5.945-8.023 C138.61,167.275,138.411,167.405,138.219,167.549z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00374C",d:"M95.754,188.728l38.243,12.311c0,0,1.65-5.397-5.253-7.671c-6.925-2.281-12.026-3.961-23.693-7.673 C99.296,183.831,95.754,188.728,95.754,188.728z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#003647",cx:"91.799",cy:"347.346",rx:"2.276",ry:"3.082"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton",ref:"actionbutton",onClick:function onClick(e){return _this4.clicked();},className:"darkPatternPulse"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M470.903,234.093v44.694c0,3.43-2.806,6.236-6.236,6.236H205.858c-3.43,0-6.236-2.806-6.236-6.236v-44.694 c0-3.43,2.806-6.236,6.236-6.236h258.808C468.096,227.856,470.903,230.663,470.903,234.093z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M224.683,255.789v-9.254h5.671v9.085c0,2.572,0.985,3.533,2.573,3.533c1.586,0,2.572-0.962,2.572-3.533 v-9.085h5.576v9.254c0,5.047-3.028,7.955-8.196,7.955C227.711,263.744,224.683,260.836,224.683,255.789z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M260.264,246.535v16.825h-4.663l-6.394-7.643v7.643h-5.528v-16.825h4.663l6.394,7.643v-7.643H260.264z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M261.957,262.014l1.827-4.134c1.586,0.937,3.702,1.538,5.552,1.538c1.611,0,2.187-0.337,2.187-0.914 c0-2.115-9.302-0.408-9.302-6.681c0-3.124,2.62-5.672,7.836-5.672c2.259,0,4.59,0.481,6.345,1.467l-1.707,4.11 c-1.658-0.842-3.22-1.25-4.686-1.25c-1.659,0-2.187,0.48-2.187,1.057c0,2.02,9.301,0.337,9.301,6.537 c0,3.076-2.619,5.672-7.835,5.672C266.476,263.744,263.64,263.047,261.957,262.014z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M278.67,255.789v-9.254h5.671v9.085c0,2.572,0.986,3.533,2.573,3.533c1.586,0,2.572-0.962,2.572-3.533 v-9.085h5.576v9.254c0,5.047-3.028,7.955-8.195,7.955C281.699,263.744,278.67,260.836,278.67,255.789z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M314.251,258.72c0,2.933-2.476,4.639-7.114,4.639h-9.47v-16.825h8.989c4.639,0,6.803,1.851,6.803,4.398 c0,1.563-0.794,2.86-2.332,3.629C313.097,255.284,314.251,256.726,314.251,258.72z M303.244,250.501v2.5h2.643 c1.274,0,1.851-0.433,1.851-1.251s-0.577-1.25-1.851-1.25H303.244z M308.53,258.072c0-0.865-0.624-1.322-1.875-1.322h-3.412v2.644 h3.412C307.906,259.393,308.53,258.938,308.53,258.072z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M315.198,262.014l1.827-4.134c1.586,0.937,3.702,1.538,5.552,1.538c1.611,0,2.187-0.337,2.187-0.914 c0-2.115-9.302-0.408-9.302-6.681c0-3.124,2.62-5.672,7.836-5.672c2.259,0,4.59,0.481,6.345,1.467l-1.707,4.11 c-1.658-0.842-3.22-1.25-4.686-1.25c-1.659,0-2.187,0.48-2.187,1.057c0,2.02,9.301,0.337,9.301,6.537 c0,3.076-2.619,5.672-7.835,5.672C319.717,263.744,316.881,263.047,315.198,262.014z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M331.382,254.947c0-5.168,3.966-8.797,9.374-8.797c3.293,0,5.888,1.202,7.546,3.365l-3.58,3.197 c-0.986-1.25-2.163-1.971-3.678-1.971c-2.355,0-3.941,1.634-3.941,4.206s1.586,4.207,3.941,4.207c1.515,0,2.692-0.721,3.678-1.972 l3.58,3.197c-1.659,2.163-4.254,3.365-7.546,3.365C335.348,263.744,331.382,260.115,331.382,254.947z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M357.157,259.129h-1.538v4.23h-5.672v-16.825h8.1c4.686,0,7.667,2.452,7.667,6.346 c0,2.428-1.154,4.254-3.172,5.288l3.532,5.191h-6.056L357.157,259.129z M357.685,250.91h-2.067v3.941h2.067 c1.563,0,2.307-0.746,2.307-1.971C359.992,251.654,359.248,250.91,357.685,250.91z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M367.862,246.535h5.672v16.825h-5.672V246.535z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M392.862,258.72c0,2.933-2.476,4.639-7.114,4.639h-9.47v-16.825h8.989c4.639,0,6.803,1.851,6.803,4.398 c0,1.563-0.794,2.86-2.332,3.629C391.708,255.284,392.862,256.726,392.862,258.72z M381.854,250.501v2.5h2.643 c1.274,0,1.851-0.433,1.851-1.251s-0.577-1.25-1.851-1.25H381.854z M387.141,258.072c0-0.865-0.624-1.322-1.875-1.322h-3.412 v2.644h3.412C386.517,259.393,387.141,258.938,387.141,258.072z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M408.854,259.081v4.278h-13.988v-16.825h13.676v4.278h-8.099v1.972h7.114v4.085h-7.114v2.211H408.854z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M417.756,251.679c0-0.746-0.721-1.13-1.611-1.13c-1.033,0-1.994,0.625-2.499,1.634l-4.278-2.139 c1.225-2.307,3.653-3.893,7.498-3.893c3.774,0,6.586,1.586,6.586,4.591c0,3.677-3.847,4.326-3.847,6.176h-4.951 C414.655,254.01,417.756,253.145,417.756,251.679z M413.958,260.715c0-1.611,1.298-2.836,3.172-2.836 c1.875,0,3.173,1.225,3.173,2.836c0,1.586-1.298,2.885-3.173,2.885C415.257,263.6,413.958,262.302,413.958,260.715z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M431.946,253.049c0-1.851,1.37-3.076,3.174-3.076c1.802,0,3.172,1.225,3.172,3.076 c0,1.826-1.37,3.124-3.172,3.124C433.316,256.173,431.946,254.875,431.946,253.049z M431.946,260.476 c0-1.851,1.37-3.076,3.174-3.076c1.802,0,3.172,1.225,3.172,3.076c0,1.826-1.37,3.124-3.172,3.124 C433.316,263.6,431.946,262.302,431.946,260.476z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M439.907,256.774c0-4.398,1.129-8.364,3.196-11.248h5.192c-2.164,3.846-3.076,7.378-3.076,11.248 c0,3.869,0.912,7.402,3.076,11.248h-5.192C441.037,265.138,439.907,261.172,439.907,256.774z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M241.926,130.758c0-5.405,4.136-9.237,9.77-9.237c3.273,0,5.912,1.193,7.638,3.35l-3.197,2.893 c-1.116-1.345-2.486-2.081-4.187-2.081c-2.919,0-4.949,2.03-4.949,5.075s2.03,5.075,4.949,5.075c1.7,0,3.07-0.736,4.187-2.081 l3.197,2.893c-1.726,2.157-4.364,3.35-7.638,3.35C246.062,139.995,241.926,136.163,241.926,130.758z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M272.399,136.188h-7.511l-1.396,3.451h-5.126l7.841-17.763h4.948l7.866,17.763h-5.228L272.399,136.188z M270.927,132.484l-2.283-5.684l-2.284,5.684H270.927z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M296.58,121.877v17.763h-4.137l-7.841-9.465v9.465h-4.923v-17.763h4.136l7.842,9.465v-9.465H296.58z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M298.453,130.758c0-5.405,4.137-9.237,9.77-9.237c3.273,0,5.913,1.193,7.639,3.35l-3.197,2.893 c-1.117-1.345-2.487-2.081-4.188-2.081c-2.918,0-4.948,2.03-4.948,5.075s2.03,5.075,4.948,5.075c1.7,0,3.07-0.736,4.188-2.081 l3.197,2.893c-1.726,2.157-4.365,3.35-7.639,3.35C302.59,139.995,298.453,136.163,298.453,130.758z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M331.591,135.757v3.882H317.33v-17.763h13.931v3.882h-8.957v2.994h7.892v3.756h-7.892v3.248H331.591z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M333.619,121.877h5.024v13.779h8.476v3.984h-13.5V121.877z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M364.47,133.27v6.369h-5.024v-6.445l-6.775-11.317h5.304l4.212,7.054l4.213-7.054h4.872L364.47,133.27z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M370.101,130.758c0-5.329,4.188-9.237,9.871-9.237c5.685,0,9.871,3.908,9.871,9.237 s-4.187,9.237-9.871,9.237C374.289,139.995,370.101,136.087,370.101,130.758z M384.768,130.758c0-3.07-2.105-5.075-4.796-5.075 c-2.689,0-4.796,2.005-4.796,5.075s2.106,5.075,4.796,5.075C382.663,135.833,384.768,133.828,384.768,130.758z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M391.565,131.722v-9.846h5.024v9.693c0,3.045,1.269,4.263,3.375,4.263c2.081,0,3.35-1.218,3.35-4.263 v-9.693h4.948v9.846c0,5.303-3.096,8.272-8.349,8.272S391.565,137.026,391.565,131.722z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M418.663,134.92h-2.74v4.72h-5.024v-17.763h8.12c4.847,0,7.892,2.512,7.892,6.572 c0,2.614-1.269,4.542-3.477,5.608l3.832,5.583h-5.38L418.663,134.92z M418.714,125.835h-2.791v5.202h2.791 c2.081,0,3.121-0.964,3.121-2.588C421.835,126.799,420.795,125.835,418.714,125.835z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M216.478,168.487l1.649-3.705c1.573,1.04,3.807,1.75,5.862,1.75c2.081,0,2.893-0.583,2.893-1.446 c0-2.816-10.1-0.761-10.1-7.359c0-3.172,2.588-5.76,7.866-5.76c2.309,0,4.695,0.533,6.445,1.548l-1.548,3.73 c-1.7-0.914-3.375-1.371-4.923-1.371c-2.106,0-2.867,0.711-2.867,1.599c0,2.715,10.074,0.685,10.074,7.232 c0,3.096-2.588,5.735-7.866,5.735C221.046,170.441,218.153,169.654,216.478,168.487z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M233.223,162.168v-9.846h5.024v9.693c0,3.045,1.269,4.263,3.375,4.263c2.081,0,3.35-1.218,3.35-4.263 v-9.693h4.948v9.846c0,5.303-3.096,8.272-8.349,8.272C236.319,170.441,233.223,167.471,233.223,162.168z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M269.457,165.213c0,3.07-2.538,4.872-7.309,4.872h-9.592v-17.763h9.085c4.669,0,6.952,1.903,6.952,4.644 c0,1.7-0.862,3.07-2.385,3.857C268.214,161.534,269.457,163.056,269.457,165.213z M257.53,155.951v3.426h3.451 c1.675,0,2.537-0.583,2.537-1.726c0-1.116-0.862-1.7-2.537-1.7H257.53z M264.382,164.655c0-1.218-0.914-1.802-2.639-1.802h-4.213 v3.603h4.213C263.467,166.456,264.382,165.873,264.382,164.655z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M270.062,168.487l1.649-3.705c1.573,1.04,3.807,1.75,5.862,1.75c2.081,0,2.893-0.583,2.893-1.446 c0-2.816-10.1-0.761-10.1-7.359c0-3.172,2.589-5.76,7.866-5.76c2.31,0,4.695,0.533,6.446,1.548l-1.548,3.73 c-1.7-0.914-3.375-1.371-4.924-1.371c-2.105,0-2.867,0.711-2.867,1.599c0,2.715,10.074,0.685,10.074,7.232 c0,3.096-2.588,5.735-7.866,5.735C274.631,170.441,271.737,169.654,270.062,168.487z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M286.046,161.204c0-5.405,4.137-9.237,9.77-9.237c3.273,0,5.913,1.193,7.639,3.35l-3.197,2.893 c-1.117-1.345-2.487-2.081-4.188-2.081c-2.918,0-4.948,2.03-4.948,5.075s2.03,5.075,4.948,5.075c1.7,0,3.07-0.736,4.188-2.081 l3.197,2.893c-1.726,2.157-4.365,3.35-7.639,3.35C290.182,170.441,286.046,166.609,286.046,161.204z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M312.687,165.365h-2.74v4.72h-5.024v-17.763h8.12c4.847,0,7.892,2.512,7.892,6.572 c0,2.614-1.269,4.542-3.477,5.608l3.832,5.583h-5.38L312.687,165.365z M312.738,156.281h-2.791v5.202h2.791 c2.081,0,3.121-0.964,3.121-2.588C315.859,157.245,314.819,156.281,312.738,156.281z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M322.936,152.322h5.024v17.763h-5.024V152.322z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M346.788,158.895c0,4.035-3.045,6.547-7.892,6.547H335.8v4.644h-5.024v-17.763h8.12 C343.743,152.322,346.788,154.835,346.788,158.895z M341.713,158.895c0-1.649-1.04-2.614-3.121-2.614H335.8v5.202h2.791 C340.673,161.483,341.713,160.519,341.713,158.895z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M351.81,156.306h-5.456v-3.984h15.91v3.984h-5.431v13.779h-5.023V156.306z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M363.378,152.322h5.024v17.763h-5.024V152.322z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M370.303,161.204c0-5.329,4.188-9.237,9.871-9.237c5.685,0,9.871,3.908,9.871,9.237 c0,5.329-4.187,9.237-9.871,9.237C374.491,170.441,370.303,166.532,370.303,161.204z M384.97,161.204 c0-3.07-2.105-5.075-4.796-5.075c-2.689,0-4.796,2.005-4.796,5.075s2.106,5.075,4.796,5.075 C382.865,166.279,384.97,164.274,384.97,161.204z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M408.82,152.322v17.763h-4.136l-7.841-9.465v9.465h-4.923v-17.763h4.136l7.842,9.465v-9.465H408.82z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M422.011,156.306h-5.456v-3.984h15.91v3.984h-5.431v13.779h-5.023V156.306z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M432.412,161.204c0-5.329,4.188-9.237,9.871-9.237c5.685,0,9.871,3.908,9.871,9.237 c0,5.329-4.187,9.237-9.871,9.237C436.599,170.441,432.412,166.532,432.412,161.204z M447.079,161.204 c0-3.07-2.105-5.075-4.796-5.075c-2.689,0-4.796,2.005-4.796,5.075s2.106,5.075,4.796,5.075 C444.973,166.279,447.079,164.274,447.079,161.204z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M225.802,198.932l1.649-3.704c1.573,1.039,3.807,1.75,5.862,1.75c2.081,0,2.893-0.584,2.893-1.446 c0-2.816-10.1-0.761-10.1-7.359c0-3.172,2.588-5.76,7.866-5.76c2.309,0,4.695,0.533,6.445,1.548l-1.548,3.73 c-1.7-0.914-3.375-1.37-4.923-1.37c-2.106,0-2.867,0.71-2.867,1.599c0,2.715,10.074,0.685,10.074,7.232 c0,3.096-2.588,5.734-7.866,5.734C230.37,200.886,227.477,200.099,225.802,198.932z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M246.227,186.752h-5.456v-3.984h15.911v3.984h-5.431v13.779h-5.024V186.752z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M257.365,192.614v-9.846h5.024v9.693c0,3.045,1.269,4.263,3.375,4.263c2.081,0,3.35-1.218,3.35-4.263 v-9.693h4.948v9.846c0,5.304-3.096,8.272-8.349,8.272S257.365,197.918,257.365,192.614z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M281.722,186.651v3.908h7.841v3.883h-7.841v6.09h-5.024v-17.763h13.932v3.882H281.722z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M297.25,186.651v3.908h7.841v3.883h-7.841v6.09h-5.024v-17.763h13.931v3.882H297.25z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M314.375,182.768h5.024v17.763h-5.024V182.768z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M339.113,182.768v17.763h-4.136l-7.841-9.465v9.465h-4.923v-17.763h4.136l7.842,9.465v-9.465H339.113z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M360.425,197.08h-7.512l-1.396,3.451h-5.126l7.841-17.763h4.948l7.867,17.763h-5.228L360.425,197.08z M358.953,193.375l-2.283-5.684l-2.284,5.684H358.953z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M391.226,195.659c0,3.07-2.538,4.872-7.309,4.872h-9.592v-17.763h9.084c4.669,0,6.953,1.903,6.953,4.644 c0,1.7-0.862,3.07-2.385,3.857C389.982,191.98,391.226,193.502,391.226,195.659z M379.299,186.397v3.426h3.451 c1.675,0,2.537-0.583,2.537-1.726c0-1.116-0.862-1.7-2.537-1.7H379.299z M386.151,195.101c0-1.219-0.914-1.803-2.64-1.803h-4.212 v3.604h4.212C385.237,196.902,386.151,196.318,386.151,195.101z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M392.161,191.65c0-5.329,4.188-9.237,9.871-9.237c5.685,0,9.871,3.908,9.871,9.237 s-4.187,9.237-9.871,9.237C396.348,200.886,392.161,196.978,392.161,191.65z M406.828,191.65c0-3.07-2.105-5.075-4.796-5.075 c-2.689,0-4.796,2.005-4.796,5.075c0,3.071,2.106,5.075,4.796,5.075C404.722,196.724,406.828,194.72,406.828,191.65z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M424.36,200.531l-3.68-5.506l-3.628,5.506h-5.735l6.471-8.983l-6.191-8.78h5.658l3.553,5.126l3.502-5.126 h5.431l-6.191,8.577l6.597,9.186H424.36z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M437.551,187.995c0-1.015-0.938-1.624-2.232-1.624c-1.37,0-2.513,0.686-3.172,1.827l-3.781-2.03 c1.345-2.259,3.807-3.756,7.536-3.756c3.908,0,6.699,1.675,6.699,4.771c0,3.959-4.161,4.542-4.161,6.877h-4.517 C433.924,190.736,437.551,189.899,437.551,187.995z M433.314,198.095c0-1.498,1.167-2.614,2.867-2.614s2.894,1.116,2.894,2.614 c0,1.471-1.193,2.664-2.894,2.664S433.314,199.566,433.314,198.095z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M83.415,57.84c-37.269,0-67.481,12.648-67.481,28.25c0,11.478,16.36,21.35,39.843,25.77l10.989,15.98 l-1.42-14.533c5.753,0.668,11.808,1.033,18.07,1.033c37.269,0,67.481-12.648,67.481-28.25S120.684,57.84,83.415,57.84z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M62.605,80.041h-3.55l-0.66,1.631h-2.423l3.706-8.396h2.339l3.718,8.396h-2.471L62.605,80.041z M61.909,78.29l-1.08-2.687l-1.08,2.687H61.909z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M69.722,79.442h-1.295v2.231h-2.375v-8.396h3.838c2.291,0,3.73,1.188,3.73,3.106 c0,1.235-0.6,2.147-1.643,2.65l1.811,2.639h-2.542L69.722,79.442z M69.746,75.148h-1.319v2.458h1.319 c0.983,0,1.475-0.456,1.475-1.223C71.221,75.604,70.729,75.148,69.746,75.148z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M81.312,79.838v1.835h-6.74v-8.396h6.584v1.835h-4.233v1.416h3.73v1.775h-3.73v1.535H81.312z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M89.905,78.662v3.01H87.53v-3.046l-3.202-5.349h2.506l1.991,3.334l1.991-3.334h2.303L89.905,78.662z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M92.571,77.475c0-2.519,1.979-4.366,4.666-4.366s4.666,1.847,4.666,4.366s-1.979,4.366-4.666,4.366 S92.571,79.993,92.571,77.475z M99.504,77.475c0-1.451-0.995-2.398-2.267-2.398s-2.267,0.947-2.267,2.398s0.995,2.399,2.267,2.399 S99.504,78.926,99.504,77.475z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M102.723,77.931v-4.654h2.375v4.582c0,1.439,0.6,2.015,1.595,2.015c0.983,0,1.583-0.576,1.583-2.015 v-4.582h2.339v4.654c0,2.506-1.463,3.91-3.946,3.91S102.723,80.437,102.723,77.931z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M43.168,87.677h2.375v6.513h4.006v1.883h-6.381V87.677z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M56.868,94.237v1.835h-6.741v-8.396h6.584v1.835h-4.233v1.416h3.73v1.775h-3.73v1.535H56.868z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M63.456,94.442h-3.55l-0.66,1.631h-2.423l3.706-8.396h2.339l3.718,8.396h-2.471L63.456,94.442z M62.761,92.69l-1.08-2.687l-1.08,2.687H62.761z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M74.951,87.677l-3.598,8.396h-2.339l-3.586-8.396h2.567l2.278,5.469l2.327-5.469H74.951z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M75.088,87.677h2.375v8.396h-2.375V87.677z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M86.783,87.677v8.396h-1.955l-3.706-4.474v4.474h-2.327v-8.396h1.955l3.706,4.474v-4.474H86.783z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M93.732,91.695h2.099v3.478c-0.972,0.695-2.303,1.067-3.526,1.067c-2.674,0-4.629-1.811-4.629-4.366 s1.955-4.366,4.677-4.366c1.571,0,2.843,0.54,3.67,1.535l-1.511,1.367c-0.576-0.635-1.235-0.935-2.039-0.935 c-1.439,0-2.398,0.947-2.398,2.398c0,1.416,0.959,2.399,2.375,2.399c0.444,0,0.864-0.084,1.283-0.276V91.695z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M107.699,96.072l-0.024-4.45l-2.159,3.622h-1.055l-2.147-3.502v4.33h-2.195v-8.396h1.955l2.95,4.846 l2.878-4.846h1.955l0.024,8.396H107.699z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M117.947,94.237v1.835h-6.741v-8.396h6.584v1.835h-4.233v1.416h3.73v1.775h-3.73v1.535H117.947z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M122.294,90.148c0-0.479-0.444-0.768-1.056-0.768c-0.647,0-1.187,0.324-1.499,0.864l-1.787-0.959 c0.636-1.067,1.799-1.775,3.562-1.775c1.847,0,3.167,0.792,3.167,2.255c0,1.871-1.967,2.147-1.967,3.25h-2.135 C120.578,91.443,122.294,91.047,122.294,90.148z M120.291,94.921c0-0.708,0.552-1.235,1.355-1.235 c0.804,0,1.367,0.528,1.367,1.235c0,0.696-0.563,1.259-1.367,1.259C120.842,96.18,120.291,95.617,120.291,94.921z"})))));}}]);return Round1View;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Round1=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(Round1View);/* harmony default export */ __webpack_exports__["a"] = (Round1);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{twoDDarkPatternIncorrect:function twoDDarkPatternIncorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["t" /* twoDDarkPatternIncorrect */])());},twoDDarkPatternCorrect:function twoDDarkPatternCorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["s" /* twoDDarkPatternCorrect */])());}};};var Round2View=function(_Component){_inherits(Round2View,_Component);function Round2View(props){_classCallCheck(this,Round2View);var _this=_possibleConstructorReturn(this,(Round2View.__proto__||Object.getPrototypeOf(Round2View)).call(this,props));_this.onHover=function(e){if(_this.state.allowUpdate&&_this.state.currentEvade<=4){_this.setState({currentEvade:_this.state.currentEvade+1,allowUpdate:false});// don't allow hover for a short spell
__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].delayedCall(0.5,function(){_this.setState({allowUpdate:true});});}};_this.state={currentEvade:0,allowUpdate:true,shake:false,done:false};return _this;}_createClass(Round2View,[{key:"clicked",value:function clicked(){var _this2=this;if(this.state.currentEvade>4){this.setState({done:true});this.props.twoDDarkPatternCorrect();__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].delayedCall(0.5,function(){return _this2.props.adComplete();});}}},{key:"shake",value:function shake(){var _this3=this;this.setState({shake:true});__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].delayedCall(0.4,function(){return _this3.setState({shake:false});});this.props.twoDDarkPatternIncorrect();}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].killAll(true,true,true,true);}},{key:"render",value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"floatingad "+(this.state.shake?'shake':'')+" "+(this.state.done?'out':'')+" evade"+this.state.currentEvade,onMouseOver:this.onHover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"Layer_1",x:"0px",y:"0px",viewBox:"0 0 495.192 382.678",enableBackground:"new 0 0 495.192 382.678"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_2_",fill:"#FFFFFF",width:"495.192",height:"382.678"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"16.369",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"35.325",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"474.289",y:"15.666",transform:"matrix(0.7071 0.7071 -0.7071 0.7071 155.8294 -329.5406)",fill:"#B2AFAA",width:"2.833",height:"15.333"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"474.289",y:"15.666",transform:"matrix(-0.7071 0.7071 -0.7071 -0.7071 828.5784 -296.5436)",fill:"#B2AFAA",width:"2.833",height:"15.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M51.735,23.827c0-3.835,2.935-6.554,6.932-6.554c2.323,0,4.195,0.846,5.419,2.377l-2.269,2.053 c-0.792-0.955-1.765-1.477-2.971-1.477c-2.07,0-3.511,1.44-3.511,3.601s1.44,3.601,3.511,3.601c1.207,0,2.179-0.522,2.971-1.477 l2.269,2.053c-1.225,1.53-3.097,2.376-5.419,2.376C54.669,30.381,51.735,27.662,51.735,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M64.208,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554 c0,3.781-2.971,6.554-7.004,6.554S64.208,27.608,64.208,23.827z M74.615,23.827c0-2.179-1.495-3.601-3.403-3.601 s-3.403,1.422-3.403,3.601s1.494,3.601,3.403,3.601S74.615,26.006,74.615,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M91.536,17.525v12.604h-2.935l-5.563-6.716v6.716h-3.493V17.525h2.935l5.563,6.716v-6.716H91.536z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M97.077,20.279v2.773h5.564v2.755h-5.564v4.321h-3.565V17.525h9.885v2.755H97.077z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M104.528,17.525h3.565v12.604h-3.565V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M115.6,26.779h-1.944v3.349h-3.565V17.525h5.762c3.439,0,5.6,1.783,5.6,4.664 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L115.6,26.779z M115.636,20.334h-1.98v3.691h1.98 c1.477,0,2.214-0.684,2.214-1.836C117.85,21.018,117.112,20.334,115.636,20.334z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M134.249,30.129l-0.036-6.68l-3.241,5.438h-1.584l-3.223-5.258v6.5h-3.295V17.525h2.935l4.429,7.274 l4.321-7.274h2.935l0.036,12.604H134.249z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M156.191,26.672c0,2.179-1.8,3.457-5.186,3.457h-6.806V17.525h6.446c3.312,0,4.933,1.351,4.933,3.295 c0,1.206-0.612,2.178-1.692,2.737C155.309,24.061,156.191,25.141,156.191,26.672z M147.729,20.1v2.431h2.449 c1.188,0,1.8-0.414,1.8-1.225c0-0.792-0.612-1.206-1.8-1.206H147.729z M152.59,26.276c0-0.864-0.648-1.278-1.873-1.278h-2.989 v2.557h2.989C151.942,27.554,152.59,27.14,152.59,26.276z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M156.854,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554 c0,3.781-2.971,6.554-7.004,6.554S156.854,27.608,156.854,23.827z M167.261,23.827c0-2.179-1.495-3.601-3.403-3.601 s-3.403,1.422-3.403,3.601s1.494,3.601,3.403,3.601S167.261,26.006,167.261,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M179.698,30.129l-2.611-3.907l-2.575,3.907h-4.069l4.591-6.374l-4.393-6.23h4.015l2.521,3.637 l2.485-3.637h3.853l-4.393,6.086l4.681,6.518H179.698z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M192.334,30.129l-2.611-3.907l-2.575,3.907h-4.069l4.591-6.374l-4.393-6.23h4.015l2.521,3.637 l2.484-3.637h3.854l-4.394,6.086l4.682,6.518H192.334z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M196.724,17.525h3.565v12.604h-3.565V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M212.404,27.374v2.755h-10.119V17.525h9.885v2.755h-6.356v2.125h5.6v2.665h-5.6v2.305H212.404z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M226.984,27.68h-5.33l-0.99,2.449h-3.637l5.563-12.604h3.511l5.582,12.604h-3.709L226.984,27.68z M225.94,25.051l-1.621-4.033l-1.621,4.033H225.94z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M244.139,26.672c0,2.179-1.801,3.457-5.186,3.457h-6.806V17.525h6.446c3.313,0,4.934,1.351,4.934,3.295 c0,1.206-0.612,2.178-1.692,2.737C243.257,24.061,244.139,25.141,244.139,26.672z M235.676,20.1v2.431h2.449 c1.188,0,1.8-0.414,1.8-1.225c0-0.792-0.612-1.206-1.8-1.206H235.676z M240.538,26.276c0-0.864-0.648-1.278-1.873-1.278h-2.989 v2.557h2.989C239.89,27.554,240.538,27.14,240.538,26.276z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M253.893,27.68h-5.329l-0.991,2.449h-3.637l5.563-12.604h3.512l5.581,12.604h-3.709L253.893,27.68z M252.849,25.051l-1.621-4.033l-1.62,4.033H252.849z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M271.049,17.525v12.604h-2.936l-5.563-6.716v6.716h-3.493V17.525h2.936l5.563,6.716v-6.716H271.049z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M273.025,17.525h5.96c4.177,0,7.04,2.431,7.04,6.302s-2.863,6.302-7.04,6.302h-5.96V17.525z M278.841,27.284c2.143,0,3.583-1.278,3.583-3.457s-1.44-3.457-3.583-3.457h-2.251v6.914H278.841z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M286.705,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554 c0,3.781-2.971,6.554-7.004,6.554S286.705,27.608,286.705,23.827z M297.111,23.827c0-2.179-1.494-3.601-3.402-3.601 c-1.909,0-3.403,1.422-3.403,3.601s1.494,3.601,3.403,3.601C295.617,27.428,297.111,26.006,297.111,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M314.032,17.525v12.604h-2.935l-5.563-6.716v6.716h-3.493V17.525h2.935l5.563,6.716v-6.716H314.032z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M327.387,30.129l-0.036-6.68l-3.24,5.438h-1.585l-3.223-5.258v6.5h-3.295V17.525h2.935l4.43,7.274 l4.321-7.274h2.935l0.036,12.604H327.387z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M342.759,27.374v2.755H332.64V17.525h9.885v2.755h-6.355v2.125h5.6v2.665h-5.6v2.305H342.759z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M356.188,17.525v12.604h-2.936l-5.563-6.716v6.716h-3.493V17.525h2.936l5.563,6.716v-6.716H356.188z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M360.847,20.352h-3.872v-2.827h11.29v2.827h-3.854v9.777h-3.564V20.352z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"BG"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"9.162",y:"44.319",fill:"#D14545",width:"476.867",height:"330.796"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#9E312D",points:"9.162,212.591 486.03,291.638 486.03,375.115 9.162,375.115       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7F201E",points:"9.162,345.59 486.03,346.845 486.03,375.115 9.162,375.115        "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"BOXXIE_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#004966",points:"42.259,222.548 33.228,237.03 45.399,240.775         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C91BF",points:"164.946,375.115 169.528,375.115 168.361,373.118 168.248,373.184         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C91BF",points:"165.136,367.862 165.249,367.796 163.788,365.299 162.97,369.129      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#004763",points:"162.97,369.129 161.692,375.115 164.946,375.115 168.248,373.184 168.361,373.118  165.249,367.796 165.136,367.862         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M105.777,338.13l-1.071,5.966c5.212,1.204,9.618-2.742,10.963-10.231l2.421-13.481l-3.679-1.086 l-2.303,12.824C111.526,335.357,109.64,339.202,105.777,338.13z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#99710E",points:"88.523,359.448 91.62,360.373 91.104,354.175         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M104.68,344.092c-5.515-1.52-8.727-7.847-7.241-16.124l2.332-12.989l-8.146-2.404l-4.551,25.345 c-0.082,0.456-0.381,0.706-0.626,0.653l-3.044-0.821c-0.247-0.054-0.438-0.413-0.356-0.87l4.577-25.488l-9.629-2.841l-0.264,0.276 c-0.181,0.277-0.556,0.186-0.626-0.153c-0.062-0.159-0.134-0.304-0.207-0.447l-5.625-1.66c-0.649,0.548-1.159,1.443-1.397,2.768 c-1.142,6.36,9.622,4.896,7.526,16.572c-1.241,6.913-5.461,9.346-9.608,8.281c-2.263-0.655-4.268-2.061-5.489-4.918 c0.028-0.156-0.072-0.34-0.173-0.524c-0.073-0.34-0.017-0.651,0.168-0.934l0.341-0.41l2.269-2.241 c0.156-0.127,0.539-0.04,0.611,0.3c0.587,1.909,1.793,3.308,3.317,3.648c1.647,0.367,3.915-0.57,4.441-3.5 c1.274-7.094-9.352-5.368-7.312-16.733c0.245-1.364,0.637-2.533,1.128-3.541l-4.925-1.453l-10.444,58.162l35.893,13.07h11.393 l5.574-31.04C104.618,344.083,104.649,344.085,104.68,344.092z M65.485,341.897l-2.782,15.491c-0.111,0.62-0.422,0.88-0.806,0.805 l-1.124-0.379c-0.385-0.075-0.53-0.746-0.446-1.211l2.76-15.372c0.084-0.466,0.423-0.878,0.807-0.797l1.121,0.398 C65.397,340.914,65.569,341.432,65.485,341.897z M79.589,346.131l-2.881,16.044c-0.11,0.611-0.538,0.845-0.911,0.773l-2.316-0.762 c-0.223-0.201-0.445-0.403-0.516-0.734l-2.736-13.76l-2.075,11.557c-0.111,0.616-0.419,0.876-0.798,0.802l-1.239-0.399 c-0.381-0.074-0.551-0.586-0.441-1.204l2.801-15.601c0.083-0.463,0.42-0.873,0.799-0.793l2.496,0.686 c0.252,0.053,0.476,0.26,0.546,0.594l2.652,13.434l2.063-11.489c0.083-0.46,0.538-0.841,0.912-0.762l1.215,0.414 C79.533,345.009,79.672,345.672,79.589,346.131z M94.404,369.16l-1.629-0.62c-0.361-0.069-0.548-0.415-0.588-0.889l-0.343-3.648 l-4.865-1.57l-1.425,3.014c-0.204,0.431-0.475,0.536-0.842,0.466l-1.443-0.432c-0.491-0.094-0.696-1.076-0.341-1.636l7.712-14.778 c0.203-0.428,0.472-0.529,0.715-0.478l1.425,0.454c0.242,0.05,0.55,0.428,0.589,0.905l1.999,17.998 C95.471,368.742,94.977,369.424,94.404,369.16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M105.66,338.096l3.646-20.302l-5.392-1.591l-2.286,12.732C101.013,332.353,101.506,337.083,105.66,338.096 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M112.267,352.807l-3.697-0.311c-0.352-0.073-0.81,0.448-0.89,0.894l-2.882,16.05 c-0.107,0.594,0.193,0.959,0.572,0.877l4.217-0.574c1.967-0.234,4.254-1.623,4.862-5.012c0.37-2.063-0.2-3.552-1.59-3.831 c1.175-0.528,2.107-1.715,2.451-3.631C115.947,353.729,114.177,352.9,112.267,352.807z M112.198,364.591 c-0.265,1.477-1.211,2.057-1.936,2.068l-2.324,0.161l0.719-4.002l1.946-0.073C111.444,362.758,112.489,362.966,112.198,364.591z M113.043,357.874c-0.239,1.33-1.158,1.756-1.882,1.763l-1.802-0.057l0.665-3.705l1.684,0.039 C112.407,356.058,113.192,356.373,113.043,357.874z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M122.516,353.582c-2.565-0.235-5.238,2.716-6.137,7.719c-0.899,5.004,0.609,7.885,3.401,7.516 c2.55-0.411,4.715-3.31,5.501-7.688C126.068,356.753,124.955,353.792,122.516,353.582z M123.669,360.953 c-0.472,2.631-1.776,4.642-3.336,4.788c-1.565,0.146-2.28-1.82-1.779-4.61s1.926-4.78,3.463-4.765 C123.409,356.503,124.002,358.446,123.669,360.953z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M105.66,338.096l-0.001,0.008c0.041,0.012,0.078,0.016,0.118,0.027l0-0.001 C105.736,338.121,105.701,338.105,105.66,338.096z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M104.705,344.101l0.001-0.004c-0.008-0.002-0.017-0.003-0.025-0.005 C104.689,344.095,104.696,344.098,104.705,344.101z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M132.637,355.864c0.19-0.411,0.182-1.015-0.041-1.062l-0.67-0.142c-0.112-0.024-0.25,0.098-0.302,0.388 l-1.876,3.978l-0.53-4.184c-0.086-0.169-0.173-0.338-0.285-0.362l-0.927-0.044c-0.338-0.071-0.582,0.634-0.548,1.095l0.826,5.155 l-2.902,5.753c-0.218,0.561-0.209,1.166,0.156,1.087l0.842-0.136c0.113,0.022,0.278-0.247,0.417-0.37l2.29-4.965l0.563,4.628 c0.086,0.167,0.06,0.313,0.172,0.335l0.836-0.135c0.25-0.101,0.466-0.658,0.432-1.115l-0.792-5.273L132.637,355.864z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M127.761,348.631l1.577,0.342c0.112,0.024,0.277-0.242,0.329-0.534l1.673-9.319l4.227,1.714 c0.111,0.025,0.248-0.095,0.3-0.384l0.468-2.609c0.052-0.29-0.033-0.46-0.118-0.631l-4.145-2.167l1.124-6.261l4.258,2.827 c0.085,0.171,0.248-0.093,0.274-0.237l0.442-2.463c0.052-0.29-0.007-0.606-0.118-0.633l-4.57-3.348l-1.616-0.477l-4.228,23.547 C127.588,348.29,127.648,348.607,127.761,348.631z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M116.747,345.938l2.302,0.499c0.23,0.05,0.397-0.22,0.45-0.514l2.008-11.181l5.935,2.579 c0.113,0.026,0.366-0.069,0.418-0.361l0.551-3.069c0.052-0.292-0.008-0.611-0.234-0.663l-5.852-3.046l1.347-7.503l6.05,3.904 c0.086,0.173,0.252-0.092,0.304-0.384l0.391-2.176l-9.588-2.829l-4.324,24.079C116.454,345.568,116.516,345.888,116.747,345.938z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#99710E",points:"181.445,282.627 143.15,270.846 143.15,270.846       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M51.009,363.042c-0.391-0.073-0.596-0.435-0.54-0.748l10.55-58.75l-21.011-6.2l-16.561-63.322 L8.495,330.082v45.033h76.267L51.009,363.042z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M132.745,371.341c-0.052,0.289-0.189,0.412-0.412,0.369l-14.203,3.405h43.561l1.279-5.986l0.818-3.83 l6.314-29.564l-29.405-8.677L132.745,371.341z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#725006",points:"8.495,238.353 8.495,330.082 23.446,234.021      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E0AD3B",points:"8.495,233.61 8.495,238.353 23.446,234.021       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M73.279,325.611c-0.526,2.93-2.795,3.868-4.441,3.5c-1.524-0.34-2.731-1.739-3.317-3.648 c-0.072-0.34-0.455-0.426-0.611-0.3l-2.269,2.241l-0.341,0.41c-0.184,0.283-0.24,0.594-0.168,0.934 c0.1,0.184,0.201,0.368,0.173,0.524c1.22,2.856,3.225,4.263,5.489,4.918c4.147,1.064,8.367-1.368,9.608-8.281 c2.097-11.675-8.668-10.212-7.526-16.572c0.238-1.325,0.748-2.22,1.397-2.768l-4.177-1.233c-0.492,1.007-0.884,2.177-1.128,3.541 C63.927,320.243,74.553,318.517,73.279,325.611z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M77.731,308.83l0.264-0.276l-1.097-0.324c0.073,0.143,0.144,0.288,0.207,0.447 C77.175,309.016,77.551,309.107,77.731,308.83z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M104.68,344.092c0.008,0.002,0.017,0.003,0.025,0.005l1.071-5.966c-0.04-0.011-0.077-0.015-0.118-0.027 l0.001-0.008c-4.154-1.013-4.647-5.742-4.033-9.161l2.286-12.732l-4.142-1.222l-2.332,12.989 C95.953,336.246,99.166,342.572,104.68,344.092z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M110.603,362.744l-1.946,0.073l-0.719,4.002l2.324-0.161c0.725-0.012,1.67-0.591,1.936-2.068 C112.489,362.966,111.444,362.758,110.603,362.744z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M93.367,349.949c-0.039-0.477-0.347-0.855-0.589-0.905l-1.425-0.454c-0.242-0.051-0.512,0.05-0.715,0.478 l-7.712,14.778c-0.355,0.56-0.15,1.542,0.341,1.636l1.443,0.432c0.367,0.07,0.639-0.035,0.842-0.466l1.425-3.014l4.865,1.57 l0.343,3.648c0.04,0.474,0.226,0.821,0.588,0.889l1.629,0.62c0.573,0.264,1.067-0.418,0.962-1.214L93.367,349.949z M88.523,359.448l2.581-5.273l0.516,6.198L88.523,359.448z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M83.404,337.753l3.044,0.821c0.245,0.053,0.544-0.197,0.626-0.653l4.551-25.345l-4.001-1.181 l-4.577,25.488C82.965,337.34,83.157,337.699,83.404,337.753z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M79.161,344.931l-1.215-0.414c-0.373-0.078-0.829,0.303-0.912,0.762l-2.063,11.489l-2.652-13.434 c-0.07-0.334-0.294-0.541-0.546-0.594l-2.496-0.686c-0.38-0.08-0.716,0.33-0.799,0.793l-2.801,15.601 c-0.111,0.618,0.06,1.13,0.441,1.204l1.239,0.399c0.38,0.073,0.688-0.186,0.798-0.802l2.075-11.557l2.736,13.76 c0.07,0.331,0.293,0.532,0.516,0.734l2.316,0.762c0.373,0.072,0.801-0.162,0.911-0.773l2.881-16.044 C79.672,345.672,79.533,345.009,79.161,344.931z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M65.015,340.833l-1.121-0.398c-0.384-0.081-0.723,0.331-0.807,0.797l-2.76,15.372 c-0.084,0.466,0.061,1.137,0.446,1.211l1.124,0.379c0.384,0.074,0.695-0.186,0.806-0.805l2.782-15.491 C65.569,341.432,65.397,340.914,65.015,340.833z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M122.017,356.366c-1.537-0.015-2.962,1.975-3.463,4.765s0.214,4.756,1.779,4.61 c1.561-0.146,2.864-2.157,3.336-4.788C124.002,358.446,123.409,356.503,122.017,356.366z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M111.709,355.914l-1.684-0.039l-0.665,3.705l1.802,0.057c0.724-0.007,1.643-0.433,1.882-1.763 C113.192,356.373,112.407,356.058,111.709,355.914z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M132.745,371.341l7.952-44.284l-7.213-2.129l4.57,3.348c0.111,0.027,0.17,0.343,0.118,0.633l-0.442,2.463 c-0.026,0.145-0.189,0.409-0.274,0.237l-4.258-2.827l-1.124,6.261l4.145,2.167c0.085,0.171,0.17,0.341,0.118,0.631l-0.468,2.609 c-0.052,0.29-0.189,0.41-0.3,0.384l-4.227-1.714l-1.673,9.319c-0.052,0.291-0.217,0.558-0.329,0.534l-1.577-0.342 c-0.113-0.024-0.173-0.341-0.121-0.632l4.228-23.547l-1.45-0.428l-0.391,2.176c-0.052,0.292-0.218,0.557-0.304,0.384l-6.05-3.904 l-1.347,7.503l5.852,3.046c0.226,0.053,0.287,0.371,0.234,0.663l-0.551,3.069c-0.052,0.292-0.305,0.387-0.418,0.361l-5.935-2.579 l-2.008,11.181c-0.053,0.294-0.221,0.564-0.45,0.514l-2.302-0.499c-0.231-0.05-0.293-0.37-0.24-0.665l4.324-24.079l-2.741-0.809 l-2.421,13.481c-1.345,7.489-5.751,11.434-10.963,10.231l-0.001,0.004c-0.008-0.002-0.016-0.006-0.025-0.008 c-0.031-0.007-0.062-0.01-0.093-0.017l-5.574,31.04h19.118l14.203-3.405C132.556,371.753,132.693,371.63,132.745,371.341z M115.312,357.267c-0.344,1.917-1.276,3.103-2.451,3.631c1.39,0.28,1.96,1.768,1.59,3.831c-0.609,3.389-2.896,4.779-4.862,5.012 l-4.217,0.574c-0.379,0.081-0.679-0.283-0.572-0.877l2.882-16.05c0.08-0.446,0.538-0.967,0.89-0.894l3.697,0.311 C114.177,352.9,115.947,353.729,115.312,357.267z M119.781,368.818c-2.792,0.369-4.299-2.512-3.401-7.516 c0.899-5.004,3.572-7.954,6.137-7.719c2.439,0.21,3.552,3.171,2.766,7.548C124.496,365.507,122.331,368.407,119.781,368.818z M130.659,366.883l-0.836,0.135c-0.112-0.022-0.086-0.167-0.172-0.335l-0.563-4.628l-2.29,4.965 c-0.139,0.123-0.304,0.392-0.417,0.37l-0.842,0.136c-0.365,0.079-0.373-0.526-0.156-1.087l2.902-5.753l-0.826-5.155 c-0.034-0.461,0.209-1.166,0.548-1.095l0.927,0.044c0.113,0.024,0.199,0.193,0.285,0.362l0.53,4.184l1.876-3.978 c0.052-0.29,0.19-0.412,0.302-0.388l0.67,0.142c0.223,0.047,0.23,0.651,0.041,1.062l-2.339,4.631l0.792,5.273 C131.124,366.225,130.908,366.783,130.659,366.883z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M105.777,338.13L105.777,338.13c3.863,1.072,5.749-2.772,6.33-6.006l2.303-12.824l-5.104-1.506 l-3.646,20.302C105.701,338.105,105.736,338.121,105.777,338.13z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M62.171,303.884l-1.152-0.34l-10.55,58.75c-0.056,0.313,0.149,0.675,0.54,0.748l33.753,12.073h2.858 l-35.893-13.07L62.171,303.884z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E0AD3B",points:"61.019,303.544 62.171,303.884 67.096,305.337 71.273,306.57 76.898,308.23 77.995,308.553  87.624,311.395 91.625,312.576 99.772,314.98 103.914,316.202 109.306,317.793 114.41,319.299 118.089,320.385 120.831,321.194  130.419,324.023 131.869,324.451 133.484,324.928 140.697,327.057 170.103,335.734 191.953,342.182 181.445,282.627  143.15,270.846 127.967,292.268 47.756,254.456 45.399,240.775 33.228,237.03 23.446,234.021 40.007,297.343        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M47.756,254.456l80.211,37.812l15.183-21.421l0,0l46.429-65.506l-71.347-52.894l-0.049,0.071l0.165,0.089 L47.756,254.456z M128.577,277.213l-63.411-31.88c0,0,7.513-7.585,17.052-2.768c19.357,9.648,27.805,13.967,39.273,19.83 C132.924,268.241,128.577,277.213,128.577,277.213z M138.571,228.436c0.25-1.184,0.672-2.328,1.25-3.395 c0.385-0.711,0.84-1.387,1.36-2.016c1.04-1.259,2.339-2.331,3.865-3.123c0.192-0.102,0.39-0.181,0.585-0.272 c0.185-0.085,0.368-0.181,0.555-0.258v0c1.294-0.532,2.636-0.84,3.947-0.925l10.682,20.355c-1.14,1.319-2.433,2.428-4.064,3.297 c-5.551,3.034-12.34,1.263-15.928-3.627c-0.081-0.109-0.163-0.217-0.241-0.329c-0.086-0.126-0.169-0.252-0.251-0.382 c-0.187-0.292-0.367-0.59-0.529-0.903c-0.001-0.001-0.002-0.003-0.002-0.004c-1.047-1.915-1.523-3.98-1.497-6.009 C138.313,230.031,138.404,229.225,138.571,228.436z M122.713,208.855c-2.43,7.64-10.426,11.888-18.066,9.458 c-3.282-1.044-5.931-3.118-7.701-5.746c0,0,0,0,0,0c0-0.001-0.001-0.001-0.001-0.002c-0.095-0.141-0.183-0.285-0.272-0.429 c-0.124-0.199-0.242-0.4-0.356-0.604c-0.109-0.195-0.213-0.391-0.312-0.591c-0.112-0.226-0.219-0.454-0.319-0.685 c-0.062-0.144-0.126-0.287-0.183-0.433c-0.122-0.308-0.23-0.621-0.331-0.937c-0.044-0.138-0.085-0.277-0.125-0.417 c-0.095-0.334-0.18-0.672-0.25-1.013c-0.023-0.114-0.041-0.228-0.062-0.343c-0.061-0.338-0.111-0.678-0.148-1.021 c-0.009-0.083-0.018-0.167-0.025-0.25c-0.033-0.374-0.047-0.75-0.05-1.129c-0.001-0.088-0.003-0.175-0.002-0.262 c0.004-0.399,0.028-0.799,0.067-1.201c0.008-0.087,0.018-0.174,0.028-0.261c0.047-0.411,0.111-0.822,0.195-1.235 c0.013-0.066,0.03-0.131,0.044-0.197c0.096-0.437,0.207-0.874,0.345-1.31c0.11-0.36,0.241-0.709,0.38-1.053 c0.109-0.271,0.227-0.536,0.352-0.796c0.392-0.815,0.853-1.58,1.359-2.278c0.145-0.201,0.294-0.396,0.446-0.585 c0.152-0.19,0.306-0.374,0.462-0.552l25.135,7.937C123.418,204.879,123.338,206.815,122.713,208.855z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M47.756,254.456l70.593-101.85l-0.165-0.089L60.52,121.615l-14.687,22.032 c1.035-0.214,2.069-0.348,3.091-0.396c1.346-0.064,2.672,0.018,3.959,0.254c1.93,0.353,3.772,1.05,5.455,2.115 c0.27,0.173,9.35,5.803,9.35,5.803c9.087,5.827,10.398,19.919,2.977,31.742c-7.421,11.824-20.885,16.607-29.972,10.78 c0,0-0.263,0.024-9.35-5.803c-1.704-1.093-3.134-2.476-4.285-4.08c-0.384-0.535-0.736-1.094-1.057-1.675 c-0.321-0.581-0.611-1.185-0.869-1.807c-0.258-0.623-0.485-1.265-0.68-1.924c-0.208-0.703-0.377-1.427-0.513-2.165l-9.491,14.237 L41.272,217.6c-0.001-0.015,0.051-0.051,0.13-0.098c0.004,0.055,0.007,0.1,0.008,0.12l0.849,4.926l3.14,18.227L47.756,254.456z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M39.781,145.821c1.329-0.686,2.684-1.241,4.046-1.659C42.465,144.58,41.11,145.135,39.781,145.821z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M61.314,177.363c-7.421,11.824-20.885,16.607-29.972,10.78c-1.704-1.093-3.134-2.476-4.285-4.08 c1.151,1.604,2.581,2.987,4.285,4.08c9.087,5.827,9.35,5.803,9.35,5.803c9.087,5.827,22.551,1.044,29.972-10.78 c7.421-11.824,6.11-25.915-2.977-31.742c0,0-9.08-5.63-9.35-5.803c-1.684-1.065-3.525-1.762-5.455-2.115 c1.93,0.353,3.772,1.05,5.455,2.115C67.424,151.447,68.736,165.539,61.314,177.363z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M25.131,180.58c-0.258-0.623-0.485-1.265-0.68-1.924C24.645,179.315,24.872,179.957,25.131,180.58z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M27.057,184.063c-0.384-0.535-0.736-1.094-1.057-1.675C26.321,182.969,26.674,183.528,27.057,184.063z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M52.882,143.505c-1.287-0.235-2.613-0.318-3.959-0.254C50.269,143.187,51.595,143.269,52.882,143.505z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M35.797,161.191c-4.126,6.496-3.389,14.269,1.559,17.505c3.172,2.045,7.238,1.653,10.79-0.367 c-1.235,0.034-2.324-0.155-3.339-0.809c-3.185-2.053-3.702-7.066-0.985-11.185c2.591-4.139,7.401-5.857,10.586-3.804 c0.955,0.538,1.723,1.436,2.179,2.675c0.397-4.221-1.098-7.958-4.282-10.011C47.357,151.958,39.923,154.695,35.797,161.191z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M48.923,143.251c-1.022,0.048-2.055,0.182-3.091,0.396c-0.668,0.138-1.338,0.309-2.006,0.514 C45.529,143.639,47.241,143.331,48.923,143.251z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M25.131,180.58c0.258,0.623,0.548,1.226,0.869,1.807c0.321,0.581,0.674,1.141,1.057,1.675 c1.151,1.604,2.581,2.987,4.285,4.08c9.087,5.827,22.551,1.044,29.972-10.78c7.421-11.824,6.11-25.915-2.977-31.743 c-1.684-1.065-3.525-1.762-5.455-2.115c-1.287-0.235-2.613-0.318-3.959-0.254c-1.682,0.08-3.394,0.388-5.096,0.91 c-1.362,0.418-2.717,0.973-4.046,1.659c-0.997,0.514-1.978,1.102-2.937,1.76c-0.639,0.439-1.267,0.909-1.882,1.409 c-0.308,0.25-0.612,0.508-0.913,0.773c-2.106,1.857-4.037,4.082-5.683,6.636c-3.943,6.281-5.421,13.203-4.578,19.185 c0.043,0.305,0.095,0.606,0.15,0.906c0.135,0.738,0.305,1.462,0.513,2.165C24.646,179.315,24.872,179.957,25.131,180.58z M52.305,155.194c3.185,2.053,4.68,5.79,4.282,10.011c-0.248,2.427-1.042,5.029-2.597,7.513c-1.535,2.357-3.518,4.255-5.675,5.606 c-0.057,0.002-0.113,0.002-0.17,0.003c-3.552,2.02-7.618,2.412-10.79,0.367c-4.948-3.236-5.685-11.008-1.559-17.505 C39.923,154.695,47.357,151.958,52.305,155.194z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00374C",d:"M54.408,162.53c-3.185-2.053-7.995-0.336-10.586,3.804c-2.718,4.12-2.2,9.132,0.985,11.185 c1.015,0.654,2.104,0.843,3.339,0.809c0.057-0.002,0.112-0.001,0.17-0.003c2.157-1.351,4.14-3.249,5.675-5.606 c1.555-2.484,2.349-5.086,2.597-7.513C56.131,163.966,55.362,163.068,54.408,162.53z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M95.172,208.885c-0.044-0.138-0.085-0.277-0.125-0.417C95.087,208.608,95.128,208.747,95.172,208.885z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M95.686,210.255c-0.062-0.144-0.126-0.287-0.183-0.433C95.56,209.968,95.623,210.111,95.686,210.255z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M94.577,203.249c0.008-0.087,0.018-0.174,0.028-0.261C94.595,203.075,94.586,203.162,94.577,203.249z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M94.797,207.455c-0.023-0.114-0.041-0.229-0.062-0.343C94.756,207.226,94.774,207.341,94.797,207.455z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M94.8,201.754c0.013-0.066,0.03-0.131,0.044-0.197C94.83,201.623,94.813,201.688,94.8,201.754z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M94.588,206.091c-0.009-0.083-0.018-0.167-0.025-0.25C94.57,205.925,94.579,206.008,94.588,206.091z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M94.512,204.713c-0.001-0.087-0.003-0.175-0.002-0.262C94.509,204.538,94.512,204.625,94.512,204.713z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M95.569,199.194c0.109-0.271,0.227-0.536,0.352-0.796C95.796,198.658,95.679,198.923,95.569,199.194z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M96.317,211.531c-0.108-0.195-0.213-0.391-0.312-0.591C96.104,211.14,96.208,211.336,96.317,211.531z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M96.945,212.565c-0.095-0.141-0.183-0.285-0.272-0.429C96.762,212.279,96.85,212.424,96.945,212.565z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M97.726,195.535c0.152-0.19,0.306-0.374,0.462-0.552l18.845,5.951c-0.093,0.9-0.254,1.808-0.539,2.739 c-2.43,7.64-10.426,11.888-18.066,9.458c-0.51-0.162-1.003-0.353-1.482-0.563c1.77,2.628,4.419,4.703,7.701,5.746 c7.64,2.43,15.636-1.817,18.066-9.458c0.625-2.041,0.705-3.976,0.611-5.935l-25.135-7.937 C98.032,195.161,97.878,195.345,97.726,195.535z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M116.495,203.672c0.285-0.931,0.446-1.839,0.539-2.739l-18.845-5.951 c-0.156,0.178-0.311,0.362-0.462,0.552c-0.152,0.19-0.301,0.385-0.446,0.585c-0.506,0.698-0.966,1.463-1.359,2.278 c-0.125,0.26-0.243,0.525-0.352,0.796c-0.139,0.344-0.27,0.693-0.38,1.053c-0.139,0.436-0.25,0.873-0.345,1.31 c-0.014,0.066-0.031,0.131-0.044,0.197c-0.084,0.412-0.148,0.824-0.195,1.235c-0.01,0.087-0.019,0.174-0.028,0.261 c-0.039,0.402-0.063,0.803-0.067,1.201c-0.001,0.088,0.002,0.175,0.002,0.262c0.003,0.378,0.017,0.755,0.05,1.129 c0.007,0.084,0.016,0.167,0.025,0.25c0.036,0.343,0.087,0.683,0.148,1.021c0.021,0.114,0.039,0.229,0.062,0.343 c0.07,0.342,0.155,0.679,0.25,1.013c0.04,0.14,0.081,0.279,0.125,0.417c0.1,0.316,0.209,0.629,0.331,0.937 c0.058,0.146,0.121,0.289,0.183,0.433c0.1,0.231,0.207,0.46,0.319,0.685c0.099,0.199,0.203,0.396,0.312,0.591 c0.114,0.204,0.232,0.406,0.356,0.604c0.09,0.144,0.178,0.289,0.272,0.429c0,0.001,0.001,0.001,0.001,0.002c0,0,0,0,0,0 c0.479,0.21,0.972,0.401,1.482,0.563C106.069,215.56,114.065,211.313,116.495,203.672z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M139.799,236.853c0.001,0.001,0.002,0.003,0.002,0.004C139.801,236.855,139.8,236.854,139.799,236.853 c-1.047-1.915-1.523-3.98-1.497-6.009C138.276,232.873,138.752,234.937,139.799,236.853z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M140.582,238.142c-0.087-0.125-0.169-0.253-0.251-0.382C140.412,237.889,140.496,238.016,140.582,238.142z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M150.319,238.287c-2.777,1.518-5.864,1.826-8.708,1.152c-0.277-0.307-0.537-0.632-0.787-0.968 c3.587,4.89,10.377,6.662,15.928,3.627c1.631-0.869,2.924-1.978,4.064-3.297l-10.682-20.355c-1.31,0.085-2.653,0.393-3.947,0.925 l8.197,15.619C153.243,236.31,151.949,237.418,150.319,238.287z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M145.045,219.901c0.192-0.102,0.39-0.182,0.585-0.272C145.435,219.721,145.237,219.799,145.045,219.901 c-1.525,0.792-2.825,1.864-3.865,3.123C142.22,221.766,143.52,220.694,145.045,219.901z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M139.821,225.041c0.385-0.711,0.84-1.387,1.36-2.016C140.66,223.654,140.206,224.33,139.821,225.041z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M139.802,236.856c0.163,0.313,0.342,0.611,0.529,0.903c0.082,0.129,0.164,0.257,0.251,0.382 c0.078,0.112,0.16,0.22,0.241,0.329c0.25,0.336,0.51,0.661,0.787,0.968c2.844,0.674,5.931,0.367,8.708-1.152 c1.631-0.869,2.925-1.978,4.064-3.297l-8.197-15.619v0c-0.187,0.077-0.37,0.173-0.555,0.258c-0.195,0.09-0.393,0.17-0.585,0.272 c-1.525,0.792-2.825,1.864-3.865,3.123c-0.52,0.629-0.974,1.305-1.36,2.016c-0.578,1.066-0.999,2.211-1.25,3.395 c-0.167,0.789-0.258,1.595-0.268,2.407c-0.026,2.03,0.45,4.094,1.497,6.009C139.8,236.854,139.801,236.855,139.802,236.856z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00374C",d:"M82.218,242.565c-9.539-4.817-17.052,2.768-17.052,2.768l63.411,31.88c0,0,4.347-8.972-7.085-14.818 C110.024,256.532,101.575,252.213,82.218,242.565z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#B4E6FF",d:"M96.134,229.502c0,3.75,4.011,5.791,6.491,5.791c2.48,0,2.491-2.04,2.491-5.791 c0-3.75-2.491-12.455-2.491-12.455S96.134,225.751,96.134,229.502z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M229.851,92.164h-7.511l-1.396,3.451h-5.126l7.841-17.763h4.948l7.866,17.763h-5.228L229.851,92.164z M228.38,88.46l-2.284-5.684l-2.284,5.684H228.38z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M244.896,90.896h-2.74v4.72h-5.024V77.853h8.12c4.847,0,7.892,2.512,7.892,6.572 c0,2.614-1.269,4.542-3.477,5.608l3.832,5.583h-5.38L244.896,90.896z M244.946,81.811h-2.791v5.202h2.791 c2.081,0,3.121-0.964,3.121-2.588C248.068,82.776,247.028,81.811,244.946,81.811z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M269.406,91.733v3.882h-14.261V77.853h13.931v3.882h-8.957v2.994h7.892v3.756h-7.892v3.248H269.406z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M287.571,89.246v6.369h-5.024V89.17l-6.775-11.317h5.304l4.212,7.054l4.212-7.054h4.872L287.571,89.246z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M293.201,86.734c0-5.329,4.188-9.237,9.871-9.237c5.685,0,9.871,3.908,9.871,9.237 s-4.187,9.237-9.871,9.237C297.388,95.971,293.201,92.063,293.201,86.734z M307.868,86.734c0-3.07-2.105-5.075-4.796-5.075 c-2.689,0-4.796,2.005-4.796,5.075s2.106,5.075,4.796,5.075C305.762,91.809,307.868,89.804,307.868,86.734z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M314.666,87.698v-9.846h5.024v9.693c0,3.045,1.269,4.263,3.375,4.263c2.081,0,3.35-1.218,3.35-4.263 v-9.693h4.948v9.846c0,5.303-3.096,8.272-8.349,8.272S314.666,93.002,314.666,87.698z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M339.706,86.734c0-5.405,4.137-9.237,9.77-9.237c3.273,0,5.913,1.193,7.639,3.35l-3.197,2.893 c-1.117-1.345-2.487-2.081-4.188-2.081c-2.918,0-4.948,2.03-4.948,5.075s2.03,5.075,4.948,5.075c1.7,0,3.07-0.736,4.188-2.081 l3.197,2.893c-1.726,2.157-4.365,3.35-7.639,3.35C343.842,95.971,339.706,92.139,339.706,86.734z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M372.843,91.733v3.882h-14.261V77.853h13.931v3.882h-8.957v2.994h7.892v3.756h-7.892v3.248H372.843z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M382.635,90.896h-2.74v4.72h-5.024V77.853h8.12c4.847,0,7.892,2.512,7.892,6.572 c0,2.614-1.269,4.542-3.477,5.608l3.832,5.583h-5.38L382.635,90.896z M382.686,81.811h-2.791v5.202h2.791 c2.081,0,3.121-0.964,3.121-2.588C385.807,82.776,384.767,81.811,382.686,81.811z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M396.412,81.837h-5.456v-3.984h15.91v3.984h-5.431v13.779h-5.023V81.837z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M418.994,92.164h-7.512l-1.396,3.451h-5.126l7.841-17.763h4.948l7.867,17.763h-5.228L418.994,92.164z M417.521,88.46l-2.283-5.684l-2.284,5.684H417.521z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M426.273,77.853h5.024v17.763h-5.024V77.853z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M451.013,77.853v17.763h-4.137l-7.841-9.465v9.465h-4.923V77.853h4.136l7.842,9.465v-9.465H451.013z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M251.645,119.692v6.369h-5.025v-6.445l-6.775-11.317h5.303l4.212,7.054l4.213-7.054h4.872L251.645,119.692 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M257.276,117.18c0-5.329,4.187-9.237,9.871-9.237c5.684,0,9.871,3.908,9.871,9.237 c0,5.329-4.188,9.237-9.871,9.237C261.463,126.417,257.276,122.508,257.276,117.18z M271.943,117.18 c0-3.07-2.106-5.075-4.796-5.075c-2.69,0-4.796,2.005-4.796,5.075s2.105,5.075,4.796,5.075 C269.837,122.255,271.943,120.25,271.943,117.18z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M278.74,118.144v-9.846h5.024v9.693c0,3.045,1.269,4.263,3.375,4.263c2.081,0,3.35-1.218,3.35-4.263 v-9.693h4.948v9.846c0,5.303-3.096,8.272-8.349,8.272S278.74,123.447,278.74,118.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M332.557,108.299l-5.761,17.763h-5.379l-3.4-10.81l-3.553,10.81h-5.38l-5.76-17.763h5.177l3.577,11.343 l3.756-11.343h4.618l3.578,11.444l3.73-11.444H332.557z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M344.885,122.61h-7.512l-1.396,3.451h-5.126l7.841-17.763h4.948l7.866,17.763h-5.227L344.885,122.61z M343.413,118.905l-2.283-5.684l-2.284,5.684H343.413z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M369.064,108.299v17.763h-4.136l-7.841-9.465v9.465h-4.923v-17.763h4.136l7.842,9.465v-9.465H369.064z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M375.634,112.282h-5.456v-3.984h15.91v3.984h-5.431v13.779h-5.023V112.282z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M397.605,112.282h-5.456v-3.984h15.91v3.984h-5.431v13.779h-5.023V112.282z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M408.006,117.18c0-5.329,4.188-9.237,9.871-9.237c5.685,0,9.871,3.908,9.871,9.237 c0,5.329-4.187,9.237-9.871,9.237C412.193,126.417,408.006,122.508,408.006,117.18z M422.673,117.18 c0-3.07-2.105-5.075-4.796-5.075c-2.689,0-4.796,2.005-4.796,5.075s2.106,5.075,4.796,5.075 C420.567,122.255,422.673,120.25,422.673,117.18z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M241.926,147.626c0-5.405,4.136-9.237,9.77-9.237c3.273,0,5.912,1.193,7.638,3.35l-3.197,2.893 c-1.116-1.345-2.486-2.081-4.187-2.081c-2.919,0-4.949,2.03-4.949,5.075s2.03,5.075,4.949,5.075c1.7,0,3.07-0.736,4.187-2.081 l3.197,2.893c-1.726,2.157-4.364,3.35-7.638,3.35C246.062,156.862,241.926,153.03,241.926,147.626z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M272.399,153.056h-7.511l-1.396,3.451h-5.126l7.841-17.763h4.948l7.866,17.763h-5.228L272.399,153.056z M270.927,149.351l-2.283-5.684l-2.284,5.684H270.927z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M296.58,138.744v17.763h-4.137l-7.841-9.465v9.465h-4.923v-17.763h4.136l7.842,9.465v-9.465H296.58z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M298.453,147.626c0-5.405,4.137-9.237,9.77-9.237c3.273,0,5.913,1.193,7.639,3.35l-3.197,2.893 c-1.117-1.345-2.487-2.081-4.188-2.081c-2.918,0-4.948,2.03-4.948,5.075s2.03,5.075,4.948,5.075c1.7,0,3.07-0.736,4.188-2.081 l3.197,2.893c-1.726,2.157-4.365,3.35-7.639,3.35C302.59,156.862,298.453,153.03,298.453,147.626z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M331.591,152.625v3.882H317.33v-17.763h13.931v3.882h-8.957v2.994h7.892v3.756h-7.892v3.248H331.591z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M333.619,138.744h5.024v13.779h8.476v3.984h-13.5V138.744z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M364.47,150.138v6.369h-5.024v-6.445l-6.775-11.317h5.304l4.212,7.054l4.213-7.054h4.872L364.47,150.138z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M370.101,147.626c0-5.329,4.188-9.237,9.871-9.237c5.685,0,9.871,3.908,9.871,9.237 s-4.187,9.237-9.871,9.237C374.289,156.862,370.101,152.954,370.101,147.626z M384.768,147.626c0-3.07-2.105-5.075-4.796-5.075 c-2.689,0-4.796,2.005-4.796,5.075s2.106,5.075,4.796,5.075C382.663,152.701,384.768,150.696,384.768,147.626z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M391.565,148.59v-9.846h5.024v9.693c0,3.045,1.269,4.263,3.375,4.263c2.081,0,3.35-1.218,3.35-4.263 v-9.693h4.948v9.846c0,5.303-3.096,8.272-8.349,8.272S391.565,153.893,391.565,148.59z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M418.663,151.787h-2.74v4.72h-5.024v-17.763h8.12c4.847,0,7.892,2.512,7.892,6.572 c0,2.614-1.269,4.542-3.477,5.608l3.832,5.583h-5.38L418.663,151.787z M418.714,142.703h-2.791v5.202h2.791 c2.081,0,3.121-0.964,3.121-2.588C421.835,143.667,420.795,142.703,418.714,142.703z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M204.846,185.354l1.649-3.705c1.573,1.04,3.807,1.75,5.862,1.75c2.081,0,2.893-0.583,2.893-1.446 c0-2.816-10.1-0.761-10.1-7.359c0-3.172,2.588-5.76,7.866-5.76c2.309,0,4.694,0.533,6.445,1.548l-1.548,3.73 c-1.7-0.914-3.375-1.37-4.923-1.37c-2.106,0-2.867,0.71-2.867,1.599c0,2.715,10.074,0.685,10.074,7.232 c0,3.096-2.588,5.735-7.866,5.735C209.414,187.308,206.521,186.521,204.846,185.354z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M221.591,179.035v-9.846h5.024v9.693c0,3.045,1.269,4.263,3.375,4.263c2.081,0,3.35-1.218,3.35-4.263 v-9.693h4.948v9.846c0,5.303-3.096,8.272-8.348,8.272C224.687,187.308,221.591,184.339,221.591,179.035z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M257.824,182.08c0,3.07-2.537,4.872-7.308,4.872h-9.592V169.19h9.084c4.669,0,6.953,1.903,6.953,4.644 c0,1.7-0.863,3.07-2.386,3.857C256.581,178.401,257.824,179.924,257.824,182.08z M245.898,172.818v3.426h3.451 c1.675,0,2.538-0.583,2.538-1.726c0-1.116-0.863-1.7-2.538-1.7H245.898z M252.749,181.522c0-1.218-0.913-1.802-2.639-1.802h-4.212 v3.603h4.212C251.836,183.323,252.749,182.74,252.749,181.522z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M258.43,185.354l1.649-3.705c1.573,1.04,3.807,1.75,5.861,1.75c2.081,0,2.894-0.583,2.894-1.446 c0-2.816-10.1-0.761-10.1-7.359c0-3.172,2.588-5.76,7.866-5.76c2.309,0,4.694,0.533,6.445,1.548l-1.548,3.73 c-1.7-0.914-3.375-1.37-4.923-1.37c-2.106,0-2.867,0.71-2.867,1.599c0,2.715,10.073,0.685,10.073,7.232 c0,3.096-2.588,5.735-7.866,5.735C262.998,187.308,260.105,186.521,258.43,185.354z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M274.414,178.071c0-5.405,4.137-9.237,9.77-9.237c3.273,0,5.913,1.193,7.639,3.35l-3.197,2.893 c-1.117-1.345-2.487-2.081-4.188-2.081c-2.918,0-4.948,2.03-4.948,5.075s2.03,5.075,4.948,5.075c1.7,0,3.07-0.736,4.188-2.081 l3.197,2.893c-1.726,2.157-4.365,3.35-7.639,3.35C278.55,187.308,274.414,183.476,274.414,178.071z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M301.055,182.233h-2.74v4.72h-5.024V169.19h8.12c4.847,0,7.892,2.512,7.892,6.572 c0,2.614-1.269,4.542-3.477,5.608l3.832,5.583h-5.38L301.055,182.233z M301.106,173.148h-2.791v5.202h2.791 c2.081,0,3.121-0.964,3.121-2.588C304.227,174.112,303.187,173.148,301.106,173.148z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M311.304,169.19h5.024v17.763h-5.024V169.19z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M335.155,175.762c0,4.035-3.045,6.547-7.892,6.547h-3.096v4.644h-5.024V169.19h8.12 C332.11,169.19,335.155,171.702,335.155,175.762z M330.08,175.762c0-1.649-1.04-2.614-3.121-2.614h-2.791v5.202h2.791 C329.04,178.35,330.08,177.386,330.08,175.762z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M340.177,173.174h-5.456v-3.984h15.91v3.984h-5.431v13.779h-5.023V173.174z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M351.746,169.19h5.024v17.763h-5.024V169.19z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M358.672,178.071c0-5.329,4.188-9.237,9.871-9.237c5.685,0,9.871,3.908,9.871,9.237 s-4.187,9.237-9.871,9.237C362.859,187.308,358.672,183.4,358.672,178.071z M373.339,178.071c0-3.07-2.105-5.075-4.796-5.075 c-2.689,0-4.796,2.005-4.796,5.075s2.106,5.075,4.796,5.075C371.233,183.146,373.339,181.141,373.339,178.071z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M397.187,169.19v17.763h-4.136l-7.841-9.465v9.465h-4.923V169.19h4.136l7.842,9.465v-9.465H397.187z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M418.5,183.501h-7.512l-1.396,3.451h-5.126l7.841-17.763h4.948l7.867,17.763h-5.228L418.5,183.501z M417.027,179.797l-2.283-5.684l-2.284,5.684H417.027z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M442.679,169.19v17.763h-4.137l-7.841-9.465v9.465h-4.923V169.19h4.136l7.842,9.465v-9.465H442.679z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M445.466,169.19h8.399c5.887,0,9.922,3.426,9.922,8.881s-4.035,8.881-9.922,8.881h-8.399V169.19z M453.663,182.943c3.02,0,5.05-1.802,5.05-4.872s-2.03-4.872-5.05-4.872h-3.172v9.744H453.663z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M261.564,203.517v3.908h7.841v3.882h-7.841v6.091h-5.024v-17.763h13.932v3.882H261.564z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M279.833,212.678h-2.741v4.72h-5.024v-17.763h8.12c4.847,0,7.893,2.512,7.893,6.572 c0,2.613-1.27,4.542-3.477,5.607l3.831,5.583h-5.379L279.833,212.678z M279.883,203.593h-2.792v5.202h2.792 c2.08,0,3.121-0.964,3.121-2.588C283.005,204.558,281.964,203.593,279.883,203.593z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M290.081,199.635h5.024v17.763h-5.024V199.635z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M312.181,213.515v3.883h-14.261v-17.763h13.931v3.882h-8.957v2.994h7.892v3.756h-7.892v3.248H312.181z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M331.109,199.635v17.763h-4.137l-7.841-9.465v9.465h-4.923v-17.763h4.136l7.842,9.465v-9.465H331.109z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M333.897,199.635h8.399c5.887,0,9.922,3.426,9.922,8.881c0,5.456-4.035,8.882-9.922,8.882h-8.399V199.635z M342.093,213.388c3.02,0,5.05-1.802,5.05-4.872s-2.03-4.872-5.05-4.872h-3.172v9.744H342.093z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M352.849,215.799l1.649-3.705c1.573,1.04,3.806,1.751,5.861,1.751c2.081,0,2.893-0.584,2.893-1.446 c0-2.816-10.1-0.762-10.1-7.359c0-3.172,2.589-5.76,7.867-5.76c2.309,0,4.694,0.533,6.445,1.548l-1.548,3.73 c-1.7-0.914-3.375-1.371-4.923-1.371c-2.106,0-2.868,0.711-2.868,1.6c0,2.715,10.074,0.685,10.074,7.231 c0,3.096-2.588,5.735-7.866,5.735C357.417,217.754,354.524,216.966,352.849,215.799z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M386.646,199.635v17.763h-5.024v-6.928h-6.852v6.928h-5.024v-17.763h5.024v6.674h6.852v-6.674H386.646z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M389.434,199.635h5.024v17.763h-5.024V199.635z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M413.286,206.208c0,4.034-3.045,6.547-7.892,6.547h-3.096v4.644h-5.024v-17.763h8.12 C410.241,199.635,413.286,202.147,413.286,206.208z M408.211,206.208c0-1.649-1.04-2.614-3.121-2.614h-2.791v5.202h2.791 C407.171,208.796,408.211,207.832,408.211,206.208z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M268.304,230.081l-5.761,17.763h-5.38l-3.4-10.81l-3.552,10.81h-5.38l-5.76-17.763h5.176l3.578,11.343 l3.756-11.343h4.618l3.578,11.444l3.729-11.444H268.304z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M269.34,230.081h5.024v17.763h-5.024V230.081z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M280.961,234.065h-5.456v-3.984h15.91v3.984h-5.431v13.778h-5.023V234.065z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M309.429,230.081v17.763h-5.024v-6.927h-6.852v6.927h-5.024v-17.763h5.024v6.674h6.852v-6.674H309.429z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M335.738,242.971c0,3.07-2.537,4.872-7.308,4.872h-9.592v-17.763h9.084c4.669,0,6.953,1.903,6.953,4.644 c0,1.7-0.862,3.07-2.386,3.857C334.495,239.293,335.738,240.815,335.738,242.971z M323.812,233.71v3.426h3.451 c1.675,0,2.537-0.584,2.537-1.726c0-1.116-0.862-1.7-2.537-1.7H323.812z M330.664,242.414c0-1.219-0.914-1.802-2.64-1.802h-4.212 v3.603h4.212C329.75,244.215,330.664,243.632,330.664,242.414z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M336.674,238.963c0-5.329,4.188-9.237,9.871-9.237c5.685,0,9.871,3.908,9.871,9.237 c0,5.328-4.187,9.236-9.871,9.236C340.862,248.199,336.674,244.291,336.674,238.963z M351.341,238.963 c0-3.07-2.105-5.075-4.796-5.075c-2.689,0-4.796,2.005-4.796,5.075s2.106,5.075,4.796,5.075 C349.236,244.038,351.341,242.033,351.341,238.963z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M368.873,247.843l-3.68-5.506l-3.629,5.506h-5.734l6.471-8.982l-6.191-8.78h5.658l3.553,5.126l3.502-5.126 h5.431l-6.192,8.577l6.598,9.186H368.873z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M386.683,247.843l-3.68-5.506l-3.629,5.506h-5.734l6.471-8.982l-6.191-8.78h5.658l3.553,5.126l3.502-5.126 h5.431l-6.192,8.577l6.598,9.186H386.683z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M392.873,230.081h5.024v17.763h-5.024V230.081z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M414.973,243.962v3.882h-14.261v-17.763h13.931v3.883h-8.957v2.994h7.892v3.756h-7.892v3.248H414.973z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M424.156,235.308c0-1.015-0.938-1.624-2.232-1.624c-1.37,0-2.513,0.686-3.172,1.827l-3.781-2.03 c1.345-2.259,3.807-3.756,7.536-3.756c3.908,0,6.699,1.675,6.699,4.771c0,3.959-4.161,4.543-4.161,6.877h-4.517 C420.528,238.049,424.156,237.212,424.156,235.308z M419.919,245.408c0-1.497,1.167-2.614,2.867-2.614s2.894,1.117,2.894,2.614 c0,1.472-1.193,2.664-2.894,2.664S419.919,246.88,419.919,245.408z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#FFFFFF",cx:"94.283",cy:"87.141",rx:"68.938",ry:"34.235"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{fill:"#FFFFFF",points:"111.196,111.581 95.036,135.081 97.333,111.581  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M60.742,68.08h3.97c2.782,0,4.689,1.619,4.689,4.197c0,2.579-1.907,4.198-4.689,4.198h-3.97V68.08z M64.616,74.58c1.427,0,2.387-0.852,2.387-2.303s-0.959-2.303-2.387-2.303h-1.499v4.605H64.616z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M70.222,72.277c0-2.519,1.979-4.365,4.666-4.365s4.666,1.847,4.666,4.365s-1.979,4.366-4.666,4.366 S70.222,74.796,70.222,72.277z M77.154,72.277c0-1.451-0.995-2.398-2.267-2.398s-2.267,0.947-2.267,2.398 s0.995,2.399,2.267,2.399S77.154,73.728,77.154,72.277z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M88.794,68.08v8.396h-1.955l-3.706-4.474v4.474h-2.327V68.08h1.955l3.706,4.474V68.08H88.794z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M92.697,68.811c0,0.336-0.048,0.6-0.384,1.379l-0.768,1.751h-1.427l0.564-1.954 c-0.432-0.204-0.708-0.612-0.708-1.176c0-0.815,0.576-1.343,1.367-1.343C92.121,67.468,92.697,67.996,92.697,68.811z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M95.925,69.963h-2.579V68.08h7.52v1.883H98.3v6.513h-2.375V69.963z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M110.875,72.097h2.099v3.479c-0.972,0.695-2.303,1.067-3.526,1.067c-2.674,0-4.629-1.812-4.629-4.366 s1.955-4.365,4.677-4.365c1.571,0,2.843,0.54,3.67,1.535l-1.511,1.367c-0.576-0.636-1.235-0.936-2.039-0.936 c-1.439,0-2.398,0.947-2.398,2.398c0,1.415,0.959,2.399,2.375,2.399c0.444,0,0.864-0.084,1.283-0.276V72.097z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M114.058,72.277c0-2.519,1.979-4.365,4.666-4.365s4.666,1.847,4.666,4.365s-1.979,4.366-4.666,4.366 S114.058,74.796,114.058,72.277z M120.99,72.277c0-1.451-0.995-2.398-2.267-2.398s-2.267,0.947-2.267,2.398 s0.995,2.399,2.267,2.399S120.99,73.728,120.99,72.277z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M124.246,75.324c0-0.708,0.563-1.235,1.367-1.235s1.355,0.527,1.355,1.235 c0,0.695-0.551,1.259-1.355,1.259S124.246,76.019,124.246,75.324z M124.258,68.08h2.71l-0.456,5.337h-1.811L124.258,68.08z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M49.686,88.572c0,1.451-1.199,2.303-3.454,2.303h-4.534v-8.396h4.294c2.207,0,3.286,0.899,3.286,2.195 c0,0.804-0.408,1.451-1.127,1.823C49.098,86.833,49.686,87.552,49.686,88.572z M44.049,84.195v1.619h1.631 c0.792,0,1.199-0.276,1.199-0.816c0-0.527-0.408-0.803-1.199-0.803H44.049z M47.287,88.308c0-0.575-0.432-0.852-1.247-0.852 h-1.991v1.703h1.991C46.856,89.16,47.287,88.884,47.287,88.308z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M50.495,86.677c0-2.519,1.979-4.366,4.666-4.366s4.666,1.848,4.666,4.366s-1.979,4.365-4.666,4.365 S50.495,89.196,50.495,86.677z M57.427,86.677c0-1.451-0.995-2.398-2.267-2.398s-2.267,0.947-2.267,2.398 s0.995,2.398,2.267,2.398S57.427,88.129,57.427,86.677z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M66.08,90.875l-1.739-2.603l-1.715,2.603h-2.71l3.058-4.245l-2.926-4.15h2.675l1.679,2.423l1.655-2.423 h2.566l-2.926,4.054l3.118,4.342H66.08z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M74.864,90.875l-1.739-2.603l-1.715,2.603h-2.71l3.058-4.245l-2.926-4.15h2.675l1.679,2.423l1.655-2.423 h2.566l-2.926,4.054l3.118,4.342H74.864z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M78.154,82.479h2.375v8.396h-2.375V82.479z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M88.963,89.04v1.835h-6.741v-8.396h6.584v1.835h-4.233v1.416h3.73v1.774h-3.73v1.535H88.963z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M106.947,82.479l-2.723,8.396h-2.542l-1.607-5.109l-1.679,5.109h-2.542l-2.723-8.396h2.447l1.691,5.361 l1.775-5.361h2.183l1.691,5.409l1.763-5.409H106.947z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M107.806,82.479h2.375v8.396h-2.375V82.479z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M111.874,82.479h2.375v6.513h4.006v1.883h-6.381V82.479z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M119.194,82.479h2.375v6.513h4.006v1.883h-6.381V82.479z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M137.993,88.572c0,1.451-1.199,2.303-3.454,2.303h-4.534v-8.396h4.294c2.207,0,3.286,0.899,3.286,2.195 c0,0.804-0.408,1.451-1.127,1.823C137.405,86.833,137.993,87.552,137.993,88.572z M132.357,84.195v1.619h1.631 c0.792,0,1.199-0.276,1.199-0.816c0-0.527-0.408-0.803-1.199-0.803H132.357z M135.595,88.308c0-0.575-0.432-0.852-1.248-0.852 h-1.991v1.703h1.991C135.163,89.16,135.595,88.884,135.595,88.308z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M145.974,89.04v1.835h-6.74v-8.396h6.584v1.835h-4.233v1.416h3.73v1.774h-3.73v1.535H145.974z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M62.281,103.643h-3.55l-0.66,1.632h-2.423l3.706-8.396h2.339l3.718,8.396h-2.471L62.281,103.643z M61.586,101.892l-1.08-2.687l-1.08,2.687H61.586z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M66.088,96.88h2.375v6.513h4.006v1.883h-6.381V96.88z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M73.408,96.88h2.375v6.513h4.006v1.883h-6.381V96.88z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M89.844,103.643h-3.55l-0.66,1.632h-2.423l3.706-8.396h2.339l3.718,8.396h-2.471L89.844,103.643z M89.149,101.892l-1.08-2.687l-1.08,2.687H89.149z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M93.651,96.88h2.375v6.513h4.006v1.883h-6.381V96.88z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M100.408,101.077c0-2.519,1.979-4.365,4.666-4.365s4.666,1.847,4.666,4.365s-1.979,4.366-4.666,4.366 S100.408,103.595,100.408,101.077z M107.34,101.077c0-1.451-0.995-2.398-2.267-2.398s-2.267,0.947-2.267,2.398 s0.995,2.399,2.267,2.399S107.34,102.528,107.34,101.077z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M118.979,96.88v8.396h-1.955l-3.706-4.474v4.474h-2.327V96.88h1.955l3.706,4.474V96.88H118.979z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M127.404,103.44v1.835h-6.74V96.88h6.584v1.835h-4.233v1.415h3.73v1.775h-3.73v1.535H127.404z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M128.332,104.124c0-0.708,0.563-1.235,1.367-1.235s1.355,0.527,1.355,1.235 c0,0.695-0.551,1.259-1.355,1.259S128.332,104.819,128.332,104.124z M128.343,96.88h2.71l-0.456,5.337h-1.811L128.343,96.88z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton_1_",ref:"actionbutton",onClick:function onClick(e){return _this4.clicked();},className:"darkPatternPulse"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M470.903,278.715v44.694c0,3.43-2.806,6.236-6.236,6.236H205.858c-3.43,0-6.236-2.806-6.236-6.236v-44.694 c0-3.43,2.806-6.236,6.236-6.236h258.808C468.096,272.478,470.903,275.285,470.903,278.715z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M226.571,306.163h-5.33l-0.99,2.449h-3.637l5.563-12.604h3.511l5.582,12.604h-3.709L226.571,306.163z M225.526,303.534l-1.62-4.033l-1.62,4.033H225.526z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M243.906,305.155c0,2.179-1.801,3.457-5.186,3.457h-6.806v-12.604h6.445c3.313,0,4.934,1.35,4.934,3.295 c0,1.206-0.612,2.179-1.692,2.736C243.024,302.544,243.906,303.625,243.906,305.155z M235.443,298.583v2.431h2.449 c1.188,0,1.801-0.414,1.801-1.225c0-0.792-0.612-1.206-1.801-1.206H235.443z M240.305,304.758c0-0.864-0.648-1.278-1.873-1.278 h-2.989v2.557h2.989C239.657,306.037,240.305,305.623,240.305,304.758z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M254.201,306.163h-5.33l-0.99,2.449h-3.637l5.563-12.604h3.511l5.582,12.604h-3.709L254.201,306.163z M253.156,303.534l-1.62-4.033l-1.62,4.033H253.156z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M271.895,296.008v12.604h-2.935l-5.563-6.716v6.716h-3.493v-12.604h2.935l5.563,6.716v-6.716H271.895z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M274.413,296.008h5.959c4.178,0,7.041,2.431,7.041,6.302s-2.863,6.302-7.041,6.302h-5.959V296.008z M280.228,305.767c2.143,0,3.583-1.278,3.583-3.457s-1.44-3.457-3.583-3.457h-2.251v6.914H280.228z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M288.632,302.31c0-3.781,2.971-6.555,7.004-6.555s7.004,2.773,7.004,6.555s-2.971,6.554-7.004,6.554 S288.632,306.091,288.632,302.31z M299.039,302.31c0-2.179-1.495-3.602-3.403-3.602s-3.403,1.423-3.403,3.602 s1.495,3.601,3.403,3.601S299.039,304.489,299.039,302.31z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M316.5,296.008v12.604h-2.935l-5.564-6.716v6.716h-3.492v-12.604h2.935l5.563,6.716v-6.716H316.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M331.006,304.092v4.52h-3.565v-4.573l-4.808-8.03h3.764l2.988,5.005l2.989-5.005h3.457L331.006,304.092z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M335.54,302.31c0-3.781,2.971-6.555,7.004-6.555s7.004,2.773,7.004,6.555s-2.971,6.554-7.004,6.554 S335.54,306.091,335.54,302.31z M345.947,302.31c0-2.179-1.495-3.602-3.403-3.602s-3.403,1.423-3.403,3.602 s1.495,3.601,3.403,3.601S345.947,304.489,345.947,302.31z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M351.307,302.994v-6.985h3.565v6.878c0,2.16,0.899,3.024,2.395,3.024c1.477,0,2.377-0.864,2.377-3.024 v-6.878h3.511v6.985c0,3.764-2.197,5.87-5.924,5.87C353.504,308.864,351.307,306.758,351.307,302.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M371.073,305.262h-1.945v3.35h-3.564v-12.604h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L371.073,305.262z M371.108,298.817h-1.98v3.69h1.98 c1.477,0,2.215-0.684,2.215-1.836C373.323,299.501,372.585,298.817,371.108,298.817z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M387.685,298.762v2.773h5.563v2.755h-5.563v4.321h-3.564v-12.604h9.885v2.754H387.685z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M401.186,305.262h-1.944v3.35h-3.564v-12.604h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L401.186,305.262z M401.222,298.817h-1.98v3.69h1.98 c1.477,0,2.215-0.684,2.215-1.836C403.437,299.501,402.699,298.817,401.222,298.817z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M408.997,296.008h3.564v12.604h-3.564V296.008z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M425.217,305.857v2.755h-10.119v-12.604h9.885v2.754h-6.356v2.125h5.6v2.665h-5.6v2.305H425.217z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M439.186,296.008v12.604h-2.935l-5.563-6.716v6.716h-3.493v-12.604h2.935l5.563,6.716v-6.716H439.186z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M441.703,296.008h5.959c4.178,0,7.04,2.431,7.04,6.302s-2.862,6.302-7.04,6.302h-5.959V296.008z M447.518,305.767c2.143,0,3.583-1.278,3.583-3.457s-1.44-3.457-3.583-3.457h-2.251v6.914H447.518z"}))))));}}]);return Round2View;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Round2=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(Round2View);/* harmony default export */ __webpack_exports__["a"] = (Round2);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{twoDDarkPatternIncorrect:function twoDDarkPatternIncorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["t" /* twoDDarkPatternIncorrect */])());},twoDDarkPatternCorrect:function twoDDarkPatternCorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["s" /* twoDDarkPatternCorrect */])());}};};var Round3View=function(_Component){_inherits(Round3View,_Component);function Round3View(props){_classCallCheck(this,Round3View);var _this=_possibleConstructorReturn(this,(Round3View.__proto__||Object.getPrototypeOf(Round3View)).call(this,props));_this.state={shake:false,yesWords:[],done:false};_this.attempts=_this.getRandomInt(3,5);return _this;}_createClass(Round3View,[{key:"getRandomInt",value:function getRandomInt(min,max){return Math.floor(Math.random()*(max-min+1))+min;}},{key:"buttonAttempt",value:function buttonAttempt(stuff){var _this2=this;// console.log(stuff)
if(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,stuff)===false){// hide what you just clicked
var joined=this.state.yesWords.concat(stuff);this.setState({yesWords:joined});this.attempts-=1;if(this.attempts<=0){this.setState({done:true});this.props.twoDDarkPatternCorrect();__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].delayedCall(1,function(){return _this2.props.adComplete();});}else{this.props.twoDDarkPatternIncorrect();}}}},{key:"shake",value:function shake(){var _this3=this;this.setState({shake:true});__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].delayedCall(0.6,function(){_this3.setState({shake:false});});this.props.twoDDarkPatternIncorrect();}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].killAll(true,true,true,true);}},{key:"render",value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"floatingad "+(this.state.shake?'shake':'')+" "+(this.state.done?'out':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"Layer_1",x:"0px",y:"0px",viewBox:"0 0 495 382",enableBackground:"new 0 0 495 382"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_2_",onClick:function onClick(e){return _this4.shake();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_4_",fill:"#FFFFFF",width:"495.192",height:"382.678"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"16.369",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"35.325",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"474.289",y:"15.666",transform:"matrix(0.7071 0.7071 -0.7071 0.7071 155.8294 -329.5406)",fill:"#B2AFAA",width:"2.833",height:"15.333"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"474.289",y:"15.666",transform:"matrix(-0.7071 0.7071 -0.7071 -0.7071 828.5784 -296.5436)",fill:"#B2AFAA",width:"2.833",height:"15.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"frame_text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M51.735,23.827c0-3.835,2.935-6.554,6.932-6.554c2.323,0,4.195,0.846,5.419,2.377l-2.269,2.053 c-0.792-0.955-1.765-1.477-2.971-1.477c-2.07,0-3.511,1.44-3.511,3.601s1.44,3.601,3.511,3.601c1.207,0,2.179-0.522,2.971-1.477 l2.269,2.053c-1.225,1.53-3.097,2.376-5.419,2.376C54.669,30.38,51.735,27.662,51.735,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M64.208,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554c0,3.781-2.971,6.554-7.004,6.554 S64.208,27.607,64.208,23.827z M74.615,23.827c0-2.179-1.495-3.601-3.403-3.601s-3.403,1.422-3.403,3.601s1.494,3.601,3.403,3.601 S74.615,26.005,74.615,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M91.536,17.524v12.604h-2.935l-5.563-6.716v6.716h-3.493V17.524h2.935l5.563,6.716v-6.716H91.536z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M97.077,20.279v2.773h5.564v2.755h-5.564v4.321h-3.565V17.524h9.885v2.755H97.077z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M104.528,17.524h3.565v12.604h-3.565V17.524z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M115.6,26.779h-1.944v3.349h-3.565V17.524h5.762c3.439,0,5.6,1.783,5.6,4.664 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L115.6,26.779z M115.636,20.333h-1.98v3.691h1.98 c1.477,0,2.214-0.684,2.214-1.836C117.85,21.018,117.112,20.333,115.636,20.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M134.249,30.128l-0.036-6.68l-3.241,5.438h-1.584l-3.223-5.258v6.5h-3.295V17.524h2.935l4.429,7.274 l4.321-7.274h2.935l0.036,12.604H134.249z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M149.709,26.779h-1.944v3.349h-3.565V17.524h5.762c3.439,0,5.6,1.783,5.6,4.664 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L149.709,26.779z M149.745,20.333h-1.98v3.691h1.98 c1.477,0,2.214-0.684,2.214-1.836C151.96,21.018,151.222,20.333,149.745,20.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M167.098,27.373v2.755h-10.119V17.524h9.885v2.755h-6.356v2.125h5.6v2.665h-5.6v2.305H167.098z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M171.218,20.352h-3.872v-2.827h11.29v2.827h-3.853v9.777h-3.565V20.352z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M189.544,27.373v2.755h-10.119V17.524h9.885v2.755h-6.356v2.125h5.6v2.665h-5.6v2.305H189.544z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M202.973,17.524v12.604h-2.935l-5.563-6.716v6.716h-3.493V17.524h2.935l5.563,6.716v-6.716H202.973z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M207.632,20.352h-3.871v-2.827h11.289v2.827h-3.853v9.777h-3.565V20.352z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M215.839,17.524h3.565v12.604h-3.565V17.524z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M220.753,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554 c0,3.781-2.971,6.554-7.004,6.554S220.753,27.607,220.753,23.827z M231.159,23.827c0-2.179-1.494-3.601-3.403-3.601 s-3.403,1.422-3.403,3.601s1.494,3.601,3.403,3.601S231.159,26.005,231.159,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M248.08,17.524v12.604h-2.935l-5.563-6.716v6.716h-3.493V17.524h2.935l5.563,6.716v-6.716H248.08z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M266.116,22.188c0,2.863-2.161,4.646-5.6,4.646h-2.197v3.295h-3.564V17.524h5.762 C263.955,17.524,266.116,19.307,266.116,22.188z M262.514,22.188c0-1.17-0.738-1.854-2.214-1.854h-1.981v3.691h1.981 C261.776,24.024,262.514,23.34,262.514,22.188z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M272.81,26.779h-1.945v3.349H267.3V17.524h5.762c3.438,0,5.6,1.783,5.6,4.664 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L272.81,26.779z M272.846,20.333h-1.981v3.691h1.981 c1.476,0,2.214-0.684,2.214-1.836C275.06,21.018,274.322,20.333,272.846,20.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M279.432,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554 c0,3.781-2.971,6.554-7.004,6.554S279.432,27.607,279.432,23.827z M289.839,23.827c0-2.179-1.494-3.601-3.402-3.601 c-1.909,0-3.403,1.422-3.403,3.601s1.494,3.601,3.403,3.601C288.344,27.428,289.839,26.005,289.839,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M303.213,23.557h3.151v5.221c-1.459,1.044-3.457,1.603-5.294,1.603c-4.016,0-6.95-2.719-6.95-6.554 c0-3.835,2.935-6.554,7.022-6.554c2.358,0,4.267,0.811,5.51,2.305l-2.27,2.053c-0.864-0.954-1.854-1.404-3.061-1.404 c-2.16,0-3.601,1.422-3.601,3.601c0,2.125,1.44,3.601,3.564,3.601c0.666,0,1.297-0.126,1.927-0.414V23.557z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M313.597,26.779h-1.944v3.349h-3.565V17.524h5.762c3.439,0,5.6,1.783,5.6,4.664 c0,1.854-0.899,3.223-2.467,3.979l2.72,3.961h-3.817L313.597,26.779z M313.633,20.333h-1.98v3.691h1.98 c1.477,0,2.215-0.684,2.215-1.836C315.848,21.018,315.11,20.333,313.633,20.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M329.312,27.68h-5.329l-0.991,2.449h-3.637l5.563-12.604h3.512l5.581,12.604h-3.709L329.312,27.68z M328.268,25.051l-1.621-4.033l-1.62,4.033H328.268z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M345.855,30.128l-0.036-6.68l-3.241,5.438h-1.584l-3.224-5.258v6.5h-3.295V17.524h2.936l4.429,7.274 l4.321-7.274h2.936l0.035,12.604H345.855z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M359.37,20.279v2.773h5.564v2.755h-5.564v4.321h-3.564V17.524h9.885v2.755H359.37z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M374.78,27.68h-5.329l-0.991,2.449h-3.637l5.563-12.604h3.512l5.581,12.604h-3.709L374.78,27.68z M373.736,25.051l-1.621-4.033l-1.62,4.033H373.736z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M379.943,17.524h3.565v12.604h-3.565V17.524z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M385.505,17.524h3.565v9.777h6.014v2.827h-9.579V17.524z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M395.711,24.511v-6.986h3.565v6.878c0,2.161,0.9,3.025,2.395,3.025c1.477,0,2.377-0.864,2.377-3.025 v-6.878h3.511v6.986c0,3.763-2.196,5.87-5.924,5.87C397.908,30.38,395.711,28.274,395.711,24.511z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M414.936,26.779h-1.944v3.349h-3.564V17.524h5.762c3.438,0,5.6,1.783,5.6,4.664 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L414.936,26.779z M414.972,20.333h-1.98v3.691h1.98 c1.477,0,2.215-0.684,2.215-1.836C417.187,21.018,416.449,20.333,414.972,20.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M432.325,27.373v2.755h-10.118V17.524h9.885v2.755h-6.356v2.125h5.6v2.665h-5.6v2.305H432.325z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"BG_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"9.162",y:"44.319",fill:"#E3C80B",width:"476.867",height:"330.796"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#B09F04",points:"486.03,212.591 9.162,291.638 9.162,375.115 486.03,375.115   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#918100",points:"486.03,345.59 9.162,346.845 9.162,375.115 486.03,375.115    "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"69.918",y:"38.261",transform:"matrix(0.9995 0.0329 -0.0329 0.9995 4.6646 -8.4628)",fill:"#FFFFFF",width:"378.935",height:"198.385"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"allbuttons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"affirmative",ref:"affirmative",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"affirmative")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('affirmative');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M238.081,146.705l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008L86.59,175.947 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008L232.8,142.34 C235.78,142.438,238.157,144.402,238.081,146.705z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M104.203,162.091l-5.327-0.175l-1.07,2.414l-3.635-0.119l5.975-12.414l3.509,0.116l5.164,12.78 l-3.707-0.122L104.203,162.091z M103.246,159.43l-1.487-4.084l-1.752,3.978L103.246,159.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M113.71,155.002l-0.091,2.771l5.561,0.183l-0.091,2.754l-5.561-0.183l-0.142,4.318l-3.563-0.117 l0.415-12.597l9.88,0.325l-0.09,2.754L113.71,155.002z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M125.26,155.382l-0.091,2.771l5.561,0.184l-0.091,2.754l-5.561-0.184l-0.142,4.318l-3.563-0.117 l0.415-12.597l9.88,0.325l-0.09,2.754L125.26,155.382z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M133.337,152.891l3.563,0.117l-0.415,12.597l-3.563-0.118L133.337,152.891z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M144.637,162.523l-1.944-0.064l-0.11,3.347l-3.563-0.117l0.415-12.597l5.759,0.189 c3.437,0.113,5.538,1.966,5.443,4.846c-0.061,1.854-1.005,3.191-2.596,3.896l2.587,4.048l-3.815-0.126L144.637,162.523z M144.886,156.082l-1.98-0.065l-0.122,3.689l1.98,0.065c1.476,0.049,2.236-0.611,2.274-1.763 C147.077,156.839,146.362,156.131,144.886,156.082z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M163.707,166.501l0.184-6.677l-3.418,5.328l-1.584-0.052l-3.048-5.361l-0.214,6.496l-3.293-0.108 l0.415-12.597l2.933,0.097l4.188,7.415l4.558-7.127l2.934,0.097l-0.379,12.598L163.707,166.501z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M178.017,164.522l-5.327-0.175l-1.07,2.414l-3.635-0.119l5.975-12.414l3.509,0.116l5.164,12.78 l-3.707-0.122L178.017,164.522z M177.06,161.861l-1.487-4.085l-1.752,3.979L177.06,161.861z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M186.01,157.454l-3.869-0.128l0.093-2.825l11.283,0.372l-0.093,2.825l-3.851-0.127l-0.322,9.771 l-3.563-0.117L186.01,157.454z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M194.845,154.916l3.563,0.118l-0.415,12.597l-3.563-0.118L194.845,154.916z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M213.685,155.537l-5.813,12.419l-3.509-0.116l-4.966-12.773l3.851,0.127l3.149,8.318l3.761-8.091 L213.685,155.537z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M224.207,165.737l-0.09,2.753l-10.113-0.333l0.415-12.597l9.879,0.326l-0.09,2.754l-6.353-0.21 l-0.07,2.123l5.597,0.185l-0.087,2.663l-5.597-0.185l-0.076,2.304L224.207,165.737z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"definitely",ref:"definitely",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"definitely")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('definitely');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M311.027,192.631l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008l-124.957-4.115 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008l124.957,4.115 C308.726,188.364,311.103,190.328,311.027,192.631z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M188.807,198.241l5.957,0.196c4.175,0.138,6.956,2.661,6.829,6.53c-0.127,3.869-3.068,6.204-7.243,6.066 l-5.957-0.196L188.807,198.241z M194.298,208.186c2.142,0.07,3.624-1.159,3.695-3.337c0.071-2.178-1.326-3.503-3.468-3.573 l-2.249-0.074l-0.228,6.91L194.298,208.186z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M213.456,208.907l-0.09,2.753l-10.114-0.333l0.415-12.597l9.88,0.325l-0.09,2.754l-6.353-0.209 l-0.07,2.123l5.597,0.185l-0.087,2.663l-5.597-0.185l-0.076,2.304L213.456,208.907z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M219.229,202l-0.091,2.771l5.561,0.184l-0.091,2.754l-5.561-0.184l-0.142,4.318l-3.563-0.117 l0.415-12.597l9.88,0.325l-0.09,2.754L219.229,202z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M227.305,199.508l3.563,0.118l-0.415,12.596l-3.563-0.117L227.305,199.508z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M245.389,200.104l-0.415,12.597l-2.934-0.097l-5.34-6.895l-0.221,6.712l-3.491-0.115l0.415-12.597 l2.934,0.097l5.34,6.896l0.221-6.713L245.389,200.104z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M247.904,200.187l3.563,0.117l-0.415,12.597l-3.563-0.117L247.904,200.187z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M256.591,203.301l-3.869-0.128l0.093-2.825l11.283,0.372l-0.093,2.825l-3.851-0.127l-0.321,9.771 l-3.563-0.117L256.591,203.301z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M275.216,210.941l-0.091,2.753l-10.113-0.333l0.414-12.597l9.88,0.325l-0.09,2.754l-6.353-0.209 l-0.07,2.123l5.597,0.184l-0.088,2.663l-5.597-0.184l-0.076,2.304L275.216,210.941z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M277.516,201.162l3.562,0.117l-0.321,9.771l6.011,0.198l-0.093,2.825l-9.574-0.315L277.516,201.162z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M293.695,209.784l-0.148,4.517l-3.563-0.117l0.15-4.57l-4.54-8.185l3.761,0.124l2.823,5.101l3.151-4.904 l3.455,0.113L293.695,209.784z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"exactly",ref:"exactly",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"exactly")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('exactly');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M434.907,196.71l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008l-104.968-3.457 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008l104.968,3.457 C432.606,192.443,434.983,194.408,434.907,196.71z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M344.965,213.238l-0.091,2.753l-10.113-0.333l0.414-12.597l9.88,0.325l-0.09,2.754l-6.353-0.209 l-0.07,2.123l5.597,0.184l-0.088,2.663l-5.597-0.184l-0.076,2.304L344.965,213.238z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M354.696,216.314l-2.481-3.991l-2.701,3.82l-4.067-0.134l4.798-6.219l-4.186-6.371l4.014,0.132 l2.399,3.718l2.603-3.553l3.852,0.127l-4.591,5.938l4.465,6.667L354.696,216.314z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M367.839,214.297l-5.327-0.175l-1.07,2.414l-3.635-0.119l5.975-12.414l3.51,0.116l5.164,12.78 l-3.707-0.122L367.839,214.297z M366.881,211.635l-1.486-4.084l-1.753,3.978L366.881,211.635z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M372.838,210.607c0.126-3.833,3.148-6.454,7.144-6.323c2.321,0.077,4.165,0.984,5.339,2.554l-2.335,1.977 c-0.761-0.979-1.716-1.533-2.921-1.573c-2.069-0.067-3.557,1.324-3.627,3.484c-0.071,2.159,1.32,3.646,3.39,3.714 c1.206,0.04,2.194-0.449,3.018-1.377l2.2,2.125c-1.273,1.491-3.174,2.274-5.494,2.197 C375.554,217.254,372.711,214.44,372.838,210.607z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M389.45,207.676l-3.869-0.128l0.093-2.824l11.283,0.371l-0.093,2.825l-3.852-0.127l-0.321,9.771 l-3.563-0.117L389.45,207.676z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M398.285,205.139l3.563,0.117l-0.322,9.771l6.011,0.198l-0.093,2.825l-9.573-0.315L398.285,205.139z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M414.464,213.76l-0.148,4.517l-3.563-0.117l0.15-4.57l-4.54-8.185l3.761,0.124l2.823,5.102l3.151-4.905 l3.455,0.114L414.464,213.76z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"bokay",ref:"bokay",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"bokay")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('bokay');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M166.687,187.878l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008l-74.984-2.469 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008l74.984,2.469 C164.386,183.61,166.763,185.575,166.687,187.878z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M102.672,204.555c-0.072,2.178-1.914,3.396-5.296,3.285l-6.802-0.225l0.415-12.597l6.442,0.213 c3.312,0.108,4.886,1.513,4.822,3.455c-0.04,1.206-0.684,2.157-1.781,2.68C101.876,201.919,102.722,203.026,102.672,204.555z M99.086,204.041c0.028-0.863-0.605-1.299-1.829-1.339l-2.987-0.099l-0.084,2.556l2.987,0.099 C98.396,205.298,99.057,204.905,99.086,204.041z M94.43,197.709l-0.08,2.43l2.447,0.081c1.188,0.039,1.813-0.355,1.839-1.165 c0.026-0.792-0.571-1.226-1.759-1.265L94.43,197.709z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M103.966,201.753c0.125-3.779,3.185-6.453,7.216-6.32c4.031,0.133,6.909,3.002,6.785,6.781 c-0.125,3.779-3.185,6.452-7.216,6.319C106.72,208.4,103.842,205.532,103.966,201.753z M114.369,202.095 c0.071-2.178-1.376-3.649-3.284-3.712c-1.907-0.062-3.448,1.31-3.519,3.487c-0.072,2.178,1.375,3.648,3.282,3.711 C112.756,205.644,114.297,204.273,114.369,202.095z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M124.636,204.163l-1.378,1.377l-0.104,3.149l-3.527-0.116l0.415-12.597l3.527,0.116l-0.172,5.236 l5.049-5.076l3.923,0.13l-5.331,5.408l5.186,7.197l-4.139-0.137L124.636,204.163z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M141.083,206.83l-5.327-0.176l-1.07,2.415l-3.635-0.12l5.975-12.413l3.509,0.115l5.164,12.78 l-3.707-0.122L141.083,206.83z M140.126,204.169l-1.487-4.085l-1.752,3.978L140.126,204.169z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M152.808,205.144l-0.148,4.517l-3.563-0.117l0.15-4.57l-4.541-8.185l3.761,0.123l2.823,5.102l3.152-4.904 l3.455,0.113L152.808,205.144z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"correct",ref:"correct",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"correct")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('correct');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M298.851,103.481l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008l-102.969-3.391 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008l102.969,3.391 C296.55,99.214,298.927,101.178,298.851,103.481z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M196.322,116.046c0.126-3.833,3.148-6.454,7.144-6.323c2.321,0.077,4.165,0.984,5.338,2.554l-2.335,1.978 c-0.761-0.979-1.715-1.534-2.921-1.574c-2.069-0.067-3.556,1.324-3.627,3.484c-0.071,2.159,1.321,3.646,3.39,3.714 c1.206,0.04,2.194-0.449,3.018-1.377l2.2,2.125c-1.274,1.491-3.174,2.274-5.495,2.197 C199.04,122.693,196.196,119.879,196.322,116.046z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M209.329,116.474c0.124-3.779,3.185-6.453,7.215-6.32c4.031,0.133,6.91,3.002,6.786,6.781 c-0.125,3.779-3.186,6.452-7.217,6.319C212.083,123.121,209.205,120.253,209.329,116.474z M219.731,116.817 c0.071-2.178-1.375-3.648-3.283-3.712c-1.907-0.062-3.448,1.311-3.52,3.488c-0.071,2.178,1.375,3.647,3.283,3.71 C218.118,120.366,219.659,118.994,219.731,116.817z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M230.606,120.129l-1.944-0.064l-0.11,3.347l-3.563-0.117l0.415-12.597l5.758,0.189 c3.437,0.113,5.538,1.966,5.443,4.846c-0.061,1.854-1.005,3.191-2.596,3.896l2.587,4.048l-3.815-0.126L230.606,120.129z M230.854,113.688l-1.979-0.065l-0.122,3.689l1.979,0.065c1.476,0.049,2.236-0.611,2.274-1.763 C233.045,114.445,232.33,113.737,230.854,113.688z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M243.919,120.568l-1.943-0.064l-0.11,3.347l-3.563-0.117l0.415-12.597l5.759,0.189 c3.437,0.113,5.538,1.966,5.443,4.846c-0.062,1.854-1.006,3.191-2.597,3.896l2.588,4.048l-3.816-0.126L243.919,120.568z M244.167,114.126l-1.979-0.065l-0.122,3.689l1.979,0.065c1.476,0.049,2.235-0.611,2.273-1.763 C246.358,114.883,245.643,114.175,244.167,114.126z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M261.819,121.751l-0.091,2.753l-10.113-0.333l0.414-12.597l9.88,0.325l-0.09,2.754l-6.353-0.209 l-0.07,2.123l5.597,0.185l-0.088,2.663l-5.597-0.185l-0.076,2.304L261.819,121.751z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M263.247,118.249c0.126-3.833,3.147-6.454,7.144-6.322c2.321,0.076,4.164,0.983,5.338,2.553l-2.335,1.978 c-0.761-0.979-1.715-1.533-2.921-1.573c-2.069-0.068-3.556,1.324-3.627,3.484c-0.071,2.159,1.321,3.646,3.391,3.714 c1.205,0.04,2.194-0.45,3.018-1.378l2.2,2.125c-1.274,1.491-3.174,2.274-5.495,2.198 C265.964,124.896,263.12,122.082,263.247,118.249z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M279.858,115.32l-3.868-0.128l0.093-2.825l11.282,0.372l-0.093,2.825l-3.851-0.127l-0.322,9.771 l-3.562-0.117L279.858,115.32z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"truly",ref:"truly",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"truly")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('truly');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M167.448,53.929l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008l-70.986-2.338 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008l70.986,2.338 C165.147,49.662,167.523,51.626,167.448,53.929z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M99.592,64.158l-3.87-0.128l0.093-2.825l11.284,0.372l-0.093,2.825l-3.851-0.127l-0.322,9.771 l-3.563-0.117L99.592,64.158z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M113.629,71.051l-1.943-0.063l-0.11,3.347l-3.563-0.117l0.415-12.597l5.759,0.189 c3.437,0.113,5.538,1.965,5.443,4.845c-0.061,1.854-1.005,3.191-2.596,3.896l2.587,4.048l-3.815-0.126L113.629,71.051z M113.877,64.61l-1.979-0.064l-0.122,3.689l1.979,0.064c1.476,0.049,2.236-0.611,2.274-1.763 C116.068,65.367,115.353,64.659,113.877,64.61z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M121.402,69.038l0.23-6.982l3.563,0.117l-0.226,6.874c-0.071,2.159,0.8,3.053,2.294,3.103 c1.476,0.048,2.404-0.786,2.475-2.945l0.226-6.874l3.509,0.115l-0.23,6.982c-0.124,3.761-2.389,5.794-6.114,5.671 C123.404,74.976,121.278,72.799,121.402,69.038z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M135.88,62.524l3.563,0.117l-0.322,9.771l6.01,0.198l-0.093,2.825l-9.574-0.315L135.88,62.524z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M152.059,71.146l-0.148,4.517l-3.563-0.117l0.15-4.57l-4.541-8.185l3.761,0.123l2.823,5.102l3.151-4.904 l3.455,0.113L152.059,71.146z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"verily",ref:"verily",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"verily")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('verily');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M278.443,57.584l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008l-93.974-3.095 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008l93.974,3.095 C276.142,53.317,278.518,55.281,278.443,57.584z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M206.714,64.857l-5.813,12.419l-3.509-0.116l-4.966-12.773l3.851,0.127l3.149,8.318l3.761-8.091 L206.714,64.857z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M217.237,75.057l-0.09,2.754l-10.114-0.334l0.415-12.596l9.88,0.325l-0.09,2.754l-6.352-0.21l-0.07,2.123 l5.596,0.185l-0.087,2.663l-5.596-0.185l-0.076,2.304L217.237,75.057z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M224.739,74.711l-1.943-0.064l-0.11,3.347l-3.563-0.117l0.415-12.597l5.759,0.189 c3.437,0.113,5.538,1.966,5.443,4.846c-0.061,1.854-1.005,3.191-2.596,3.896l2.587,4.048l-3.815-0.126L224.739,74.711z M224.987,68.269l-1.979-0.065l-0.122,3.689l1.979,0.065c1.476,0.049,2.235-0.611,2.273-1.763 C227.178,69.026,226.463,68.318,224.987,68.269z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M232.849,65.717l3.563,0.117l-0.415,12.597l-3.563-0.117L232.849,65.717z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M238.948,65.919l3.563,0.117l-0.322,9.771l6.01,0.197l-0.093,2.825l-9.574-0.314L238.948,65.919z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M255.127,74.54l-0.148,4.517l-3.563-0.117l0.15-4.57l-4.54-8.185l3.761,0.124l2.823,5.102l3.151-4.905 l3.455,0.114L255.127,74.54z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"sure",ref:"sure",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"sure")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('sure');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M358.852,60.232l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008l-63.99-2.107 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008l63.99,2.107 C356.551,55.965,358.928,57.929,358.852,60.232z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M297.075,79.308l1.256-2.589c1.093,0.774,2.659,1.331,4.116,1.379c1.477,0.049,2.065-0.346,2.086-0.958 c0.065-1.998-7.145-0.775-6.99-5.455c0.074-2.25,1.969-4.024,5.713-3.901c1.637,0.054,3.316,0.487,4.534,1.248l-1.185,2.609 c-1.184-0.687-2.361-1.05-3.459-1.086c-1.494-0.05-2.051,0.437-2.071,1.066c-0.063,1.925,7.128,0.721,6.976,5.363 c-0.072,2.196-1.97,4.007-5.713,3.884C300.269,80.8,298.235,80.175,297.075,79.308z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M309.636,75.236l0.229-6.982l3.563,0.118l-0.227,6.874c-0.071,2.159,0.801,3.053,2.294,3.102 c1.476,0.049,2.403-0.786,2.476-2.945l0.226-6.874l3.509,0.116l-0.229,6.982c-0.124,3.761-2.389,5.794-6.114,5.671 C311.638,81.174,309.512,78.997,309.636,75.236z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M329.316,78.154l-1.943-0.063l-0.11,3.347l-3.563-0.117l0.415-12.597l5.759,0.189 c3.438,0.113,5.537,1.966,5.443,4.846c-0.062,1.854-1.006,3.19-2.596,3.896l2.586,4.047l-3.814-0.125L329.316,78.154z M329.564,71.714l-1.979-0.065l-0.122,3.689l1.98,0.065c1.475,0.048,2.235-0.612,2.273-1.764 C331.756,72.469,331.04,71.761,329.564,71.714z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M347.216,79.339l-0.091,2.753l-10.113-0.333l0.414-12.597l9.881,0.325l-0.091,2.754l-6.353-0.209 l-0.07,2.123l5.597,0.184l-0.087,2.663l-5.598-0.184l-0.076,2.304L347.216,79.339z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"next",ref:"next",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"next")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('next');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M439.314,62.882l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008l-63.99-2.107 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008l63.99,2.107 C437.013,58.615,439.39,60.579,439.314,62.882z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M389.06,70.862l-0.414,12.597l-2.934-0.097l-5.34-6.895l-0.221,6.712l-3.491-0.115l0.414-12.597 l2.934,0.097l5.34,6.896l0.221-6.713L389.06,70.862z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M401.365,81.122l-0.091,2.753l-10.113-0.333l0.414-12.597l9.88,0.325l-0.09,2.754l-6.353-0.209 l-0.07,2.123l5.597,0.185l-0.088,2.662l-5.597-0.184l-0.076,2.304L401.365,81.122z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M411.096,84.198l-2.48-3.991l-2.702,3.82l-4.067-0.134l4.799-6.219l-4.186-6.371l4.013,0.132l2.4,3.718 l2.603-3.553l3.852,0.127l-4.592,5.938l4.465,6.667L411.096,84.198z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M418.865,74.672l-3.869-0.127l0.093-2.825l11.283,0.371l-0.093,2.825l-3.851-0.127l-0.322,9.771 l-3.562-0.117L418.865,74.672z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"absolutely",ref:"absolutely",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"absolutely")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('absolutely');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M437.826,108.058l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008l-124.957-4.115 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008l124.957,4.115 C435.525,103.791,437.902,105.755,437.826,108.058z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M317.191,123.881l-5.326-0.176l-1.071,2.415l-3.635-0.12l5.976-12.414l3.509,0.116l5.164,12.78 l-3.707-0.122L317.191,123.881z M316.234,121.219l-1.487-4.084l-1.752,3.978L316.234,121.219z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M334.91,123.455c-0.071,2.178-1.913,3.396-5.297,3.284l-6.802-0.224l0.414-12.597l6.443,0.212 c3.311,0.109,4.886,1.513,4.821,3.455c-0.039,1.206-0.683,2.158-1.781,2.68C334.114,120.818,334.961,121.926,334.91,123.455z M331.324,122.941c0.028-0.863-0.606-1.299-1.829-1.34l-2.987-0.098l-0.085,2.556l2.987,0.098 C330.633,124.197,331.296,123.805,331.324,122.941z M326.669,116.609l-0.08,2.43l2.447,0.08c1.188,0.039,1.812-0.354,1.839-1.164 c0.026-0.792-0.571-1.227-1.759-1.266L326.669,116.609z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M335.8,125.809l1.256-2.589c1.092,0.774,2.659,1.331,4.117,1.379c1.476,0.049,2.064-0.347,2.085-0.959 c0.065-1.998-7.145-0.774-6.99-5.454c0.073-2.25,1.97-4.024,5.713-3.901c1.638,0.054,3.316,0.487,4.534,1.248l-1.185,2.609 c-1.185-0.688-2.361-1.051-3.459-1.087c-1.493-0.049-2.051,0.438-2.071,1.067c-0.063,1.925,7.129,0.721,6.977,5.363 c-0.072,2.196-1.97,4.007-5.713,3.884C338.995,127.301,336.961,126.676,335.8,125.809z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M347.844,121.035c0.124-3.779,3.185-6.453,7.216-6.32s6.909,3.002,6.784,6.781 c-0.124,3.779-3.185,6.452-7.215,6.319C350.598,127.683,347.72,124.815,347.844,121.035z M358.246,121.378 c0.072-2.178-1.375-3.649-3.282-3.712c-1.908-0.062-3.448,1.31-3.521,3.487c-0.071,2.178,1.376,3.648,3.283,3.711 C356.634,124.927,358.174,123.556,358.246,121.378z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M363.919,115.259l3.563,0.117l-0.322,9.771l6.011,0.198l-0.093,2.825l-9.573-0.315L363.919,115.259z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M374.429,122.595l0.229-6.982l3.563,0.117l-0.227,6.874c-0.071,2.159,0.801,3.053,2.294,3.103 c1.476,0.049,2.404-0.786,2.476-2.945l0.226-6.874l3.51,0.115l-0.23,6.982c-0.123,3.761-2.389,5.794-6.113,5.672 C376.432,128.533,374.305,126.356,374.429,122.595z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M391.299,118.988l-3.869-0.127l0.093-2.825l11.283,0.371l-0.093,2.825l-3.851-0.127l-0.322,9.771 l-3.563-0.117L391.299,118.988z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M409.924,126.628l-0.091,2.753l-10.113-0.333l0.414-12.597l9.88,0.325l-0.09,2.754l-6.353-0.209 l-0.07,2.123l5.597,0.185l-0.088,2.663l-5.597-0.185l-0.076,2.304L409.924,126.628z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M412.222,116.85l3.563,0.117l-0.322,9.771l6.012,0.197l-0.093,2.825l-9.574-0.314L412.222,116.85z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M428.402,125.471l-0.148,4.517l-3.563-0.117l0.15-4.57l-4.541-8.185l3.761,0.124l2.823,5.101l3.151-4.904 l3.455,0.114L428.402,125.471z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"uhhuh",ref:"uhhuh",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"uhhuh")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('uhhuh');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M179.601,99.554l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008l-84.979-2.798 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008l84.979,2.798 C177.3,95.287,179.677,97.251,179.601,99.554z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M92.781,113.32l0.23-6.982l3.563,0.117l-0.226,6.874c-0.071,2.159,0.8,3.053,2.294,3.103 c1.475,0.048,2.403-0.786,2.475-2.945l0.226-6.874l3.509,0.115l-0.23,6.982c-0.124,3.761-2.389,5.794-6.113,5.672 C94.784,119.259,92.658,117.081,92.781,113.32z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M119.245,107.201l-0.415,12.597l-3.563-0.117l0.162-4.912l-4.859-0.16l-0.162,4.912l-3.563-0.117 l0.415-12.597l3.563,0.117l-0.156,4.733l4.859,0.16l0.156-4.733L119.245,107.201z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M121.383,112.173l5.254,0.173l-0.086,2.627l-5.254-0.173L121.383,112.173z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M141.085,107.921l-0.415,12.597l-3.563-0.117l0.162-4.912l-4.859-0.16l-0.162,4.912l-3.563-0.117 l0.415-12.597l3.563,0.117l-0.156,4.733l4.859,0.16l0.156-4.733L141.085,107.921z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M143.262,114.983l0.23-6.982l3.563,0.117l-0.226,6.874c-0.071,2.159,0.8,3.053,2.294,3.103 c1.475,0.049,2.403-0.786,2.475-2.945l0.226-6.874l3.509,0.115l-0.23,6.982c-0.124,3.761-2.388,5.794-6.113,5.672 C145.265,120.921,143.138,118.743,143.262,114.983z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M169.725,108.864l-0.415,12.597l-3.563-0.118l0.162-4.912l-4.858-0.159l-0.162,4.912l-3.564-0.118 l0.415-12.597l3.564,0.118l-0.156,4.733l4.858,0.159l0.156-4.733L169.725,108.864z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"precisely",ref:"precisely",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"precisely")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('precisely');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M368.627,151.004l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008l-114.962-3.786 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008l114.962,3.786 C366.326,146.737,368.702,148.701,368.627,151.004z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M267.175,161.965c-0.094,2.861-2.312,4.571-5.749,4.458l-2.195-0.072l-0.108,3.293l-3.563-0.117 l0.415-12.597l5.758,0.189C265.17,157.233,267.27,159.084,267.175,161.965z M263.577,161.846c0.038-1.17-0.677-1.878-2.152-1.926 l-1.979-0.065l-0.122,3.689l1.979,0.065C262.778,163.657,263.539,162.997,263.577,161.846z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M274.255,166.791l-1.943-0.063l-0.11,3.347l-3.562-0.117l0.414-12.597l5.759,0.189 c3.438,0.113,5.538,1.966,5.443,4.845c-0.061,1.854-1.005,3.191-2.596,3.896l2.587,4.048l-3.815-0.126L274.255,166.791z M274.504,160.351l-1.98-0.065l-0.121,3.689l1.979,0.065c1.476,0.048,2.236-0.612,2.274-1.764 C276.694,161.107,275.978,160.399,274.504,160.351z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M292.155,167.976l-0.091,2.753l-10.113-0.334l0.414-12.596l9.88,0.325l-0.09,2.754l-6.353-0.21 l-0.07,2.123l5.597,0.185l-0.088,2.663l-5.597-0.185l-0.076,2.304L292.155,167.976z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M293.582,164.474c0.127-3.833,3.149-6.454,7.145-6.323c2.321,0.077,4.165,0.984,5.338,2.554l-2.334,1.978 c-0.762-0.979-1.716-1.534-2.922-1.574c-2.069-0.067-3.556,1.324-3.627,3.484c-0.071,2.159,1.321,3.646,3.391,3.714 c1.206,0.04,2.194-0.449,3.018-1.378l2.2,2.126c-1.274,1.491-3.174,2.274-5.495,2.197 C296.299,171.12,293.456,168.307,293.582,164.474z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M307.714,158.633l3.563,0.117l-0.414,12.597l-3.563-0.117L307.714,158.633z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M312.553,170.268l1.256-2.588c1.092,0.773,2.659,1.331,4.116,1.379c1.476,0.048,2.065-0.347,2.085-0.959 c0.066-1.998-7.145-0.775-6.99-5.455c0.074-2.25,1.97-4.024,5.713-3.9c1.638,0.054,3.317,0.487,4.535,1.248l-1.185,2.609 c-1.185-0.688-2.361-1.051-3.46-1.087c-1.493-0.049-2.05,0.437-2.07,1.066c-0.063,1.925,7.129,0.721,6.976,5.363 c-0.072,2.196-1.969,4.007-5.712,3.884C315.747,171.76,313.714,171.135,312.553,170.268z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M335.242,169.394l-0.091,2.753l-10.113-0.333l0.414-12.597l9.88,0.325l-0.09,2.754l-6.353-0.209 l-0.07,2.123l5.597,0.185l-0.088,2.663l-5.597-0.185l-0.076,2.304L335.242,169.394z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M337.541,159.615l3.563,0.117l-0.322,9.771l6.012,0.198l-0.093,2.825l-9.574-0.315L337.541,159.615z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M353.719,168.237l-0.148,4.517l-3.562-0.117l0.15-4.57l-4.541-8.185l3.761,0.124l2.823,5.102l3.152-4.904 l3.455,0.113L353.719,168.237z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"yes",ref:"yes",className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()("darkPatternPulse","buttonq "+(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,"yes")?'hide':'')),onClick:function onClick(e){return _this4.buttonAttempt('yes');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M436.338,153.234l-0.988,30.006c-0.076,2.303-2.577,4.107-5.557,4.008l-51.996-1.712 c-2.981-0.098-5.357-2.063-5.281-4.365l0.988-30.006c0.076-2.303,2.577-4.107,5.557-4.008l51.996,1.712 C434.038,148.967,436.414,150.931,436.338,153.234z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M394.5,169.58l-0.148,4.517l-3.562-0.117l0.15-4.57l-4.541-8.186l3.761,0.124l2.823,5.102l3.151-4.904 l3.455,0.113L394.5,169.58z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M410.22,171.863l-0.091,2.753l-10.113-0.333l0.414-12.597l9.881,0.325l-0.091,2.754l-6.353-0.209 l-0.07,2.123l5.597,0.184l-0.088,2.663l-5.596-0.184l-0.076,2.304L410.22,171.863z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M411.261,173.519l1.256-2.589c1.092,0.774,2.659,1.331,4.116,1.379c1.477,0.049,2.065-0.347,2.086-0.959 c0.065-1.998-7.145-0.774-6.99-5.454c0.074-2.25,1.97-4.024,5.713-3.901c1.638,0.054,3.316,0.487,4.534,1.248l-1.185,2.609 c-1.185-0.688-2.361-1.051-3.459-1.087c-1.494-0.049-2.051,0.438-2.071,1.067c-0.063,1.925,7.129,0.721,6.976,5.363 c-0.072,2.196-1.969,4.007-5.712,3.884C414.455,175.011,412.422,174.386,411.261,173.519z"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004966",d:"M258.325,262.054l-15.342-19.775l6.44-7.265l18.007,20.049L258.325,262.054z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_14_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M202.519,249.642c0.584-2.113,0.207-4.492-0.753-6.257l-3.115-5.565l0,0 c1.043,1.839,1.363,4.047,0.753,6.257c-1.208,4.371-5.744,6.943-10.115,5.735c-1.969-0.544-3.595-1.769-4.656-3.355l2.837,5.075 c1.035,1.682,2.869,3.274,4.934,3.845C196.775,256.585,201.311,254.013,202.519,249.642z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#003647",d:"M186.086,240.448c-0.703,2.546,0.476,5.198,2.732,6.39l0.125-0.638L186.086,240.448z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004966",d:"M184.619,246.505c1.061,1.586,2.639,2.797,4.656,3.355c4.371,1.208,8.907-1.364,10.115-5.735 c0.611-2.209,0.29-4.418-0.753-6.257c-1.043-1.839-2.773-3.248-4.982-3.858l-0.703,2.546c2.738,0.757,4.424,3.446,4.031,6.18 c-0.018,0.253-0.071,0.446-0.138,0.686c-0.823,2.978-3.888,4.716-6.866,3.893c-0.432-0.119-0.803-0.274-1.161-0.476 c-2.256-1.192-3.435-3.844-2.732-6.39l-2.546-0.703C182.877,242.146,183.336,244.599,184.619,246.505L184.619,246.505z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#003647",d:"M196.337,242.453l0.646,0.282c0.394-2.735-1.293-5.424-4.031-6.18L196.337,242.453z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#003647",cx:"198.027",cy:"255.859",r:"6.805"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004966",d:"M199.887,249.313c-0.596-0.169-1.195-0.246-1.787-0.253c-1.177,0.752-2.098,1.915-2.51,3.365 c-0.894,3.145,0.931,6.418,4.076,7.312c1.449,0.412,2.923,0.241,4.182-0.366c0.305-0.506,0.555-1.056,0.725-1.652 C205.6,254.104,203.502,250.341,199.887,249.313z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#0C91BF",cx:"202.033",cy:"254.163",r:"1.329"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#00435E",cx:"234.951",cy:"294.898",r:"6.805"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00517A",d:"M239.627,299.842c0.45-0.426,0.822-0.902,1.13-1.407c-0.045-1.396-0.574-2.782-1.609-3.877 c-2.246-2.375-5.993-2.479-8.368-0.233c-1.095,1.035-1.701,2.39-1.823,3.781c0.279,0.521,0.624,1.017,1.05,1.467 C232.589,302.304,236.896,302.424,239.627,299.842z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#36B7FF",cx:"236.709",cy:"298.208",r:"1.329"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M232.299,292.348c1.774-1.678,2.118-3.127,2.118-3.127l-30.612-32.366c0,0-1.211,0.115-3.134,1.935 c-1.923,1.819-2.224,3.133-2.224,3.133l30.612,32.366C229.059,294.289,230.525,294.026,232.299,292.348z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M202.261,265.955l-1.618-1.711l5.358-5.068l1.618,1.711l-0.036,0.034L202.261,265.955z M207.114,271.087 l-1.618-1.711l5.322-5.033l0.036-0.034l1.618,1.711l-0.036,0.034L207.114,271.087z M211.968,276.218l-1.618-1.711l5.322-5.033 l0.036-0.034l1.618,1.711l-0.036,0.034L211.968,276.218z M216.858,281.389l-1.618-1.711l5.322-5.033l0.036-0.034l1.618,1.711 l-0.036,0.034L216.858,281.389z M221.712,286.521l-1.618-1.711l5.322-5.033l0.036-0.034l1.618,1.711l-0.036,0.034L221.712,286.521 z M226.565,291.652l-1.618-1.711l5.322-5.033l0.036-0.034l1.618,1.711l-0.036,0.034L226.565,291.652z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#99710E",points:"210.657,277.521 232.094,330.474 286.565,306.549 266.865,248.779 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#725006",points:"286.565,306.549 327.102,296.104 310.195,239.917 266.865,248.779 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#332204",points:"288.349,254.801 291.497,251.812 290.296,251.095 299.383,248.841 298.313,250.164 303.366,251.933  302.13,256.071 307.32,263.031 304.459,263.725 307.584,267.109 290.38,268.188 292.014,265.547 286.166,263.43 287.86,259.642  284.898,255.583 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#442C01",points:"232.094,330.474 267.418,319.273 327.102,296.104 286.565,306.549 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E0AD3B",points:"310.195,239.917 318.387,239.382 319.402,242.359 282.537,250.475 266.865,248.779 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"logo_3_",fill:"#2D2619",d:"M258.448,274.887l7.833,16.402c0.048,0.101,0.033,0.17-0.046,0.206l-8.773,10.16l0,0 l-18.378,5.279c-0.138,0.064-0.282-0.002-0.334-0.112l-11.961-25.046c-0.052-0.11-0.01-0.256,0.132-0.311l16.911-8.35l14.397,1.618 C258.335,274.752,258.4,274.786,258.448,274.887z M258.918,277.784l-0.412-0.862c-0.048-0.101-0.137-0.186-0.178-0.17l-2.777-0.025 c-0.041,0.017-0.057,0.084-0.009,0.186l3.952,8.276c0.049,0.102,0.138,0.187,0.178,0.169l0.565-0.246 c0.04-0.018,0.032-0.137-0.017-0.239l-1.558-3.263l1.693-0.41c0.04-0.017,0.056-0.085,0.007-0.186l-0.436-0.913 c-0.048-0.101-0.113-0.135-0.177-0.169l-1.769,0.252l-1.047-2.192l1.951-0.072C258.95,277.952,258.942,277.834,258.918,277.784z M264.64,290.372c0.055-0.087-0.002-0.308-0.115-0.442l-1.421-1.458l-0.307-1.958c-0.033-0.17-0.17-0.355-0.249-0.32l-0.239,0.105 c-0.04,0.018-0.056,0.086-0.007,0.188l0.305,1.652l-1.097-1.179c-0.064-0.033-0.129-0.067-0.169-0.049l-0.297,0.193 c-0.121,0.053-0.039,0.326,0.074,0.461l1.405,1.414l0.382,2.431c0.057,0.222,0.195,0.408,0.291,0.302l0.231-0.23 c0.04-0.018,0.031-0.138,0.047-0.208l-0.397-2.05l1.206,1.31c0.064,0.033,0.088,0.084,0.128,0.065L264.64,290.372z M261.698,293.396 c0.699-0.696,0.724-2.078-0.007-3.61c-0.732-1.533-1.737-2.203-2.54-1.724c-0.848,0.499-1.019,2.01-0.182,3.762 C259.805,293.575,260.914,294.133,261.698,293.396z M255.376,277.896l-0.489-1.023c-0.049-0.102-0.139-0.188-0.204-0.223 l-3.983-0.054c-0.109-0.018-0.101,0.102-0.052,0.205l4.787,10.023c0.049,0.103,0.14,0.189,0.223,0.153l0.825-0.358 c0.082-0.036,0.074-0.157,0.025-0.26l-1.87-3.915l2.415-0.523c0.041-0.017,0.098-0.103,0.049-0.205l-0.513-1.075 c-0.049-0.102-0.139-0.188-0.22-0.154l-2.493,0.36l-1.255-2.627l2.746-0.138C255.433,278.117,255.425,277.998,255.376,277.896z M259.134,293.317c-0.345-0.722-0.854-1.057-1.347-0.834l0,0c0.247-0.426,0.271-1.001-0.049-1.672 c-0.592-1.239-1.325-1.102-1.938-0.705l-1.216,0.728c-0.125,0.056-0.151,0.319-0.077,0.475l2.684,5.619 c0.099,0.208,0.273,0.254,0.373,0.145l1.18-1.118C259.301,295.444,259.701,294.503,259.134,293.317z M252.632,283.474l-3.192-6.683 c-0.074-0.155-0.208-0.225-0.317-0.244l-1.216-0.011c-0.11-0.018-0.145,0.119-0.096,0.223l3.328,6.968 c0.546,1.144,0.821,2.78-0.667,3.292l0,0l-6.54-13.695l-16.717,8.286l11.869,24.854l18.228-5.123l-5.841-12.231l0,0 C253.392,288.337,253.894,286.116,252.632,283.474z M259.616,289.036c-0.48,0.338-0.478,1.273-0.012,2.25 c0.467,0.977,1.127,1.427,1.579,1.033c0.452-0.393,0.407-1.307-0.033-2.228C260.695,289.239,260.078,288.769,259.616,289.036z M257.498,293.558l-0.587,0.457l0.669,1.401l0.685-0.568c0.222-0.165,0.386-0.556,0.139-1.073 C258.133,293.207,257.762,293.375,257.498,293.558z M256.319,291.194l-0.531,0.363l0.62,1.297l0.571-0.384 c0.223-0.164,0.413-0.501,0.191-0.966C256.881,291.005,256.567,291.083,256.319,291.194z M247.179,285.074l-3.514-7.357 c-0.075-0.158-0.212-0.228-0.3-0.194l-1.154,0.518c-0.088,0.035-0.125,0.175-0.049,0.333l3.503,7.335 c1.386,2.902,3.798,4.148,5.849,3.383l-0.998-2.091C248.981,287.658,247.756,286.283,247.179,285.074z M253.933,298.568 c0.21,0.223,0.209,0.545-0.028,0.591l-0.643,0.171c-0.127,0.059-0.263-0.007-0.381-0.145l-0.92-1.055l-1.859,0.597l0.23,1.252 c0.033,0.179-0.028,0.272-0.157,0.332l-0.544,0.188c-0.173,0.08-0.456-0.178-0.47-0.431l-0.903-6.302 c-0.033-0.178,0.029-0.269,0.115-0.307l0.543-0.177c0.086-0.038,0.266,0.01,0.384,0.149L253.933,298.568z M251.083,297.054 l-1.542-1.807l0.375,2.21L251.083,297.054z M241.144,278.65l-5.349,2.494c-0.091,0.036-0.13,0.179-0.053,0.34l0.641,1.343 c0.077,0.161,0.219,0.232,0.309,0.196l1.93-0.903l4.565,9.56c0.077,0.16,0.216,0.229,0.304,0.19l1.127-0.424 c0.088-0.038,0.125-0.182,0.049-0.342l-4.598-9.629l1.983-0.922c0.088-0.035,0.125-0.176,0.05-0.335l-0.682-1.428 C241.415,278.668,241.277,278.597,241.144,278.65z M243.778,295.042l-0.469,0.142c-0.133,0.059-0.19,0.279-0.113,0.44l1.921,4.022 l0,0l-3.817-3.575c-0.096-0.088-0.212-0.102-0.302-0.063l-0.927,0.344c-0.136,0.06-0.148,0.262-0.071,0.424l2.608,5.462 c0.103,0.216,0.27,0.337,0.405,0.275l0.473-0.152c0.134-0.062,0.172-0.211,0.069-0.427l-1.932-4.046l0,0l3.915,3.657 c0.095,0.087,0.209,0.1,0.323,0.113l0.888-0.28c0.132-0.061,0.212-0.229,0.11-0.443l-2.683-5.617 C244.101,295.158,243.91,294.984,243.778,295.042z M232.745,282.158c-1.336,0.657-2.188,2.355-1.095,4.645 c1.9,3.979,4.811,1.076,5.997,3.559c0.49,1.026-0.005,1.822-0.597,2.075c-0.549,0.234-1.234,0.069-1.842-0.392 c-0.098-0.089-0.236-0.031-0.256,0.043l-0.204,1.201l-0.014,0.203c0.006,0.129,0.058,0.238,0.156,0.327 c0.072,0.035,0.144,0.069,0.17,0.124c1.015,0.614,1.95,0.603,2.798,0.302c1.523-0.594,2.29-2.289,1.134-4.71 c-1.952-4.088-4.964-1.235-6.027-3.462c-0.493-1.032-0.099-1.708,0.547-1.967c0.46-0.184,0.996-0.206,1.548,0.151 c0.097,0.089,0.234,0.034,0.228-0.092l0.209-1.496c0.04-0.144-0.083-0.287-0.18-0.377 C234.318,281.793,233.481,281.867,232.745,282.158z M238.478,296.925l-0.436,0.127c-0.137,0.06-0.15,0.264-0.073,0.427l2.57,5.382 c0.078,0.163,0.272,0.339,0.408,0.276l0.433-0.133c0.136-0.062,0.174-0.212,0.07-0.429l-2.59-5.424 C238.783,296.987,238.614,296.864,238.478,296.925z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E0AD3B",points:"210.648,300.616 210.657,277.521 266.865,248.779 264.828,273.692 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_13_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2D2619",points:"228.5,321.471 232.094,330.473 286.565,306.548 286.58,306.543 282.967,295.947        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E180E",points:"282.967,295.947 286.58,306.543 327.102,296.103 324.494,287.514      "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#332204",points:"260.075,321.027 288.03,308.865 301.968,305.145 307.364,309.406 294.23,309.567 290.036,318.6  285.007,312.524 274.377,323.33 269.797,321.184 264.411,326.447 260.769,323.888 255.228,327.185 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#03222B",d:"M265.895,356.077c0.334,8.424,5.95,14.977,12.461,14.655c0,0,0.131,0.091,6.642-0.23 c6.511-0.322,11.433-7.31,11.099-15.734c-0.434-8.38-6.05-14.932-12.461-14.655c-0.193,0.01-6.642,0.23-6.642,0.23 C270.482,340.664,265.56,347.652,265.895,356.077z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00374C",d:"M277.842,355.643c0.068,1.768,0.536,3.358,1.288,4.642c1.253,2.14,3.272,3.579,5.558,3.46 c3.564-0.208,6.286-4.058,6.077-8.701c-0.209-4.643-3.281-8.311-6.846-8.103c-2.285,0.118-4.192,1.627-5.252,3.958l0,0 C278.067,352.245,277.701,353.847,277.842,355.643z M296.097,354.768c0.334,8.424-4.588,15.412-11.099,15.734 c-6.512,0.322-12.127-6.231-12.461-14.655c-0.334-8.424,4.588-15.412,11.099-15.734 C290.047,339.836,295.663,346.388,296.097,354.768z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#01090C",d:"M278.667,350.899c-0.6,1.346-0.965,2.948-0.897,4.716c0.096,1.696,0.564,3.286,1.288,4.642 c0.668,0.422,1.318,0.672,2.08,0.632c2.285-0.118,4.063-2.589,3.877-5.564c-0.113-2.947-2.117-5.292-4.402-5.174 C279.951,350.147,279.278,350.387,278.667,350.899L278.667,350.899z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_11_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#006382",points:"267.291,313.751 268.742,324.044 281.08,326.719 280.609,311.749 276.461,311.108      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004966",d:"M280.609,311.749l0.471,14.971l0.037,0.011l7.512-1.086c0.254-7.056,0.45-12.582,0.45-12.582 L280.609,311.749z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M281.117,326.73l-0.037-0.011l0.895,28.548c0.111,2.707,2.363,4.016,3.92,3.618 c1.044-0.705,1.595-2.114,1.658-3.618c0.058-1.277,0.646-17.657,1.075-29.624L281.117,326.73z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M280.323,341.229c0,0,0.673,12.979,0.763,14.372c0.132,2.029,1.658,3.952,3.533,3.751 c0.487-0.053,0.911-0.212,1.277-0.466c-1.557,0.397-3.809-0.911-3.92-3.618l-0.895-28.548l-12.338-2.675l2.606,18.478l1.123-0.795 l0.63-1.24l6.124-0.27L280.323,341.229z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#513600",points:"257.372,320.259 286.587,307.386 303.571,303.237 307.769,307.015 296.426,308.161 298.044,314.556  281.349,313.772 275.098,319.94 269.386,318.602 260.435,328.413 261.346,322.001 252.891,326.386 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_10_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M359.524,247.821c1.935,1.23,4.515,1.543,6.591,1.157l6.062-1.389c-2.02,0.295-4.158-0.116-6.003-1.289 c-4.094-2.602-5.307-8.047-2.705-12.141c1.315-2.069,3.297-3.399,5.505-3.891l0,0l-6.651,1.52 c-2.089,0.504-4.247,1.912-5.505,3.891C354.217,239.774,355.43,245.219,359.524,247.821z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00435E",d:"M369.29,243.985l-0.417,0.556c2.564,0.935,5.515-0.032,7.031-2.416L369.29,243.985z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#035B77",d:"M372.149,247.634c2.432-0.349,4.709-1.744,6.139-3.994l-2.384-1.515 c-1.516,2.384-4.467,3.351-7.031,2.416c-0.417-0.139-0.806-0.323-1.211-0.58c-2.789-1.773-3.609-5.452-1.836-8.241 c0.143-0.225,0.257-0.405,0.445-0.601c1.888-2.274,5.232-2.865,7.796-1.235l1.516-2.384c-2.069-1.315-4.429-1.678-6.636-1.186 s-4.19,1.822-5.505,3.891c-2.602,4.094-1.389,9.539,2.705,12.141C368.036,247.546,370.13,247.93,372.149,247.634L372.149,247.634 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00435E",d:"M374.067,233.884c-2.564-1.63-5.908-1.039-7.796,1.235l0.687,0.31L374.067,233.884z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#035B77",cx:"353.919",cy:"242.734",r:"7.279"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M346.812,244.305c-0.143-0.647-0.187-1.292-0.157-1.924c0.877-1.21,2.178-2.119,3.752-2.467 c3.415-0.755,6.795,1.402,7.55,4.816c0.348,1.574,0.071,3.137-0.656,4.442c-0.56,0.294-1.163,0.526-1.811,0.669 C351.565,250.709,347.679,248.231,346.812,244.305z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#36B7FF",cx:"352.093",cy:"242.91",r:"1.422"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#035B77",cx:"297.792",cy:"255.14",r:"7.279"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M290.684,256.712c-0.143-0.647-0.187-1.292-0.157-1.924c0.877-1.21,2.178-2.119,3.752-2.467 c3.415-0.755,6.795,1.402,7.55,4.816c0.348,1.574,0.071,3.137-0.656,4.442c-0.56,0.294-1.163,0.526-1.811,0.669 C295.437,263.116,291.551,260.637,290.684,256.712z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#36B7FF",cx:"294.248",cy:"257.016",r:"1.422"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M303.374,258.137l46.534-10.286c0,0,0.523-1.344-0.088-4.109c-0.611-2.765-1.614-3.594-1.614-3.594 l-46.534,10.286c0,0-0.565,1.49-0.001,4.04C302.234,257.025,303.374,258.137,303.374,258.137z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#035B77",d:"M342.419,241.482l-0.012-0.052l2.459-0.544l1.703,7.704l-2.459,0.544L342.419,241.482z M335.042,243.112 l-0.012-0.052l2.459-0.544l0.012,0.052l1.691,7.651l-2.459,0.544L335.042,243.112z M327.664,244.743l-0.012-0.052l2.459-0.544 l0.012,0.052l1.691,7.651l-2.459,0.544L327.664,244.743z M320.23,246.386l-0.012-0.052l2.459-0.544l0.012,0.052l1.691,7.651 l-2.459,0.544L320.23,246.386z M312.852,248.017l-0.012-0.052l2.459-0.544l0.012,0.052l1.691,7.651l-2.459,0.544L312.852,248.017z M305.474,249.648l-0.012-0.052l2.459-0.544l0.012,0.052l1.691,7.651l-2.459,0.544L305.474,249.648z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36B7FF",points:"225.814,224.373 259.074,258.074 231.409,277.606 202.481,248.991         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M245.479,208.956l21.904,22.944l-8.31,11.883c-0.001-0.006-0.023-0.016-0.055-0.028 c0.002,0.021,0.004,0.038,0.005,0.046l0.052,14.274l-33.294-33.633L245.479,208.956z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M245.738,232.778c3.574,3.956,8.955,4.863,11.987,2.07c0,0,0.101-0.008,3.132-2.802 c3.032-2.793,2.592-8.18-0.982-12.136c-3.605-3.894-8.985-4.801-11.986-2.07c-0.09,0.083-3.132,2.802-3.132,2.802 C241.724,223.435,242.164,228.822,245.738,232.778z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M251.364,227.729c0.749,0.831,1.62,1.414,2.505,1.733c1.475,0.532,3.039,0.413,4.1-0.57 c1.647-1.545,1.409-4.517-0.573-6.687c-1.982-2.17-4.959-2.707-6.606-1.163c-1.062,0.983-1.377,2.488-0.948,4.049l0,0 C250.098,225.987,250.569,226.913,251.364,227.729z M259.875,219.911c3.574,3.956,4.014,9.343,0.982,12.136 c-3.032,2.793-8.412,1.886-11.986-2.07c-3.574-3.956-4.014-9.343-0.982-12.136C250.89,215.109,256.271,216.017,259.875,219.911z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00374C",d:"M249.844,225.091c0.254,0.897,0.725,1.823,1.474,2.654c0.733,0.785,1.605,1.367,2.505,1.733 c0.495-0.065,0.912-0.208,1.266-0.535c1.062-0.983,0.925-2.903-0.37-4.272c-1.249-1.385-3.171-1.713-4.233-0.73 C250.163,224.206,249.933,224.595,249.844,225.091L249.844,225.091z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M236.168,239.045c0.565,0.454,1.106,1.055,1.477,1.781c1.42,2.713,0.352,6.001-2.361,7.421 c-2.713,1.42-6.001,0.352-7.421-2.361c-0.37-0.726-0.528-1.449-0.623-2.192L236.168,239.045z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M237.645,240.826c0.81,1.548,0.808,3.281,0.155,4.75c-0.166,0.111-0.339,0.215-0.52,0.31 c-2.713,1.42-6.001,0.352-7.421-2.361c-0.169-0.331-0.289-0.662-0.384-0.994l6.694-3.486 C236.733,239.498,237.275,240.1,237.645,240.826z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M218.185,251.308c0.647-0.071,1.339-0.008,2.01,0.211c2.504,0.788,3.95,3.501,3.095,6.028 c-0.788,2.504-3.501,3.95-6.028,3.095c-0.671-0.219-1.231-0.55-1.747-0.971L218.185,251.308z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M220.195,251.519c2.504,0.788,3.95,3.501,3.095,6.028c-0.124,0.393-0.299,0.757-0.51,1.093 c-1.025,0.442-2.207,0.531-3.352,0.143c-0.671-0.219-1.231-0.55-1.747-0.971l2.049-6.417 C219.886,251.429,220.041,251.469,220.195,251.519z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00374C",d:"M251.922,255.796l-21.739,16.188c0,0-2.229-3.087,1.684-6.042c3.925-2.965,6.817-5.148,13.458-10.059 C248.594,253.44,251.922,255.796,251.922,255.796z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#003647",cx:"284.681",cy:"354.959",rx:"1.536",ry:"2.079"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M199.976,272.087l-18.139,5.067c-11.216-10.139-31.544-16.914-54.762-16.914 c-35.342,0-63.992,15.698-63.992,35.062s28.65,35.062,63.992,35.062c35.342,0,63.992-15.698,63.992-35.062 c0-3.906-1.183-7.658-3.334-11.167L199.976,272.087z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"BUBBLE"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M85.599,279.267h3.97c2.782,0,4.689,1.619,4.689,4.198c0,2.578-1.907,4.197-4.689,4.197h-3.97V279.267z M89.473,285.768c1.427,0,2.387-0.852,2.387-2.303s-0.959-2.303-2.387-2.303h-1.499v4.605H89.473z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M95.079,283.465c0-2.519,1.979-4.366,4.666-4.366s4.666,1.848,4.666,4.366s-1.979,4.365-4.666,4.365 S95.079,285.984,95.079,283.465z M102.011,283.465c0-1.451-0.995-2.398-2.267-2.398s-2.267,0.947-2.267,2.398 s0.995,2.398,2.267,2.398S102.011,284.916,102.011,283.465z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M113.651,279.267v8.396h-1.955l-3.706-4.474v4.474h-2.327v-8.396h1.955l3.706,4.474v-4.474H113.651z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M117.554,279.999c0,0.335-0.048,0.6-0.384,1.379l-0.768,1.751h-1.427l0.564-1.955 c-0.432-0.204-0.708-0.611-0.708-1.175c0-0.816,0.576-1.344,1.367-1.344C116.978,278.656,117.554,279.183,117.554,279.999z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M120.782,281.151h-2.579v-1.884h7.52v1.884h-2.566v6.512h-2.375V281.151z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M130.107,279.267h2.375v6.513h4.006v1.883h-6.381V279.267z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M144.167,285.828v1.835h-6.74v-8.396h6.584v1.835h-4.233v1.416h3.73v1.774h-3.73v1.535H144.167z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M151.115,286.032h-3.55l-0.66,1.631h-2.423l3.706-8.396h2.339l3.718,8.396h-2.471L151.115,286.032z M150.42,284.281l-1.08-2.687l-1.08,2.687H150.42z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M162.97,279.267l-3.598,8.396h-2.339l-3.586-8.396h2.566l2.279,5.47l2.327-5.47H162.97z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M170.207,285.828v1.835h-6.74v-8.396h6.584v1.835h-4.233v1.416h3.73v1.774h-3.73v1.535H170.207z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M92.819,299.76c0,1.451-1.199,2.303-3.454,2.303h-4.534v-8.396h4.294c2.207,0,3.286,0.899,3.286,2.194 c0,0.804-0.408,1.451-1.127,1.823C92.231,298.021,92.819,298.741,92.819,299.76z M87.182,295.382v1.619h1.631 c0.792,0,1.199-0.275,1.199-0.815c0-0.527-0.408-0.804-1.199-0.804H87.182z M90.421,299.497c0-0.576-0.432-0.852-1.248-0.852 h-1.991v1.703h1.991C89.988,300.348,90.421,300.072,90.421,299.497z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M93.628,297.865c0-2.519,1.979-4.365,4.666-4.365s4.666,1.847,4.666,4.365s-1.979,4.366-4.666,4.366 S93.628,300.383,93.628,297.865z M100.56,297.865c0-1.451-0.995-2.398-2.267-2.398s-2.267,0.947-2.267,2.398 s0.995,2.399,2.267,2.399S100.56,299.316,100.56,297.865z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M109.213,302.063l-1.739-2.603l-1.715,2.603h-2.71l3.058-4.246l-2.926-4.149h2.674l1.679,2.423 l1.655-2.423h2.566l-2.926,4.054l3.118,4.342H109.213z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M117.997,302.063l-1.739-2.603l-1.715,2.603h-2.71l3.058-4.246l-2.926-4.149h2.674l1.679,2.423 l1.655-2.423h2.566l-2.926,4.054l3.118,4.342H117.997z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M121.287,293.667h2.375v8.396h-2.375V293.667z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M132.095,300.228v1.835h-6.74v-8.396h6.584v1.835h-4.233v1.415h3.73v1.775h-3.73v1.535H132.095z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M150.08,293.667l-2.723,8.396h-2.542l-1.607-5.109l-1.679,5.109h-2.542l-2.723-8.396h2.447l1.691,5.361 l1.775-5.361h2.183l1.691,5.409l1.763-5.409H150.08z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M150.939,293.667h2.375v8.396h-2.375V293.667z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M156.794,295.55h-2.579v-1.883h7.52v1.883h-2.566v6.513h-2.375V295.55z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M170.614,293.667v8.396h-2.375v-3.274h-3.238v3.274h-2.375v-8.396h2.375v3.154h3.238v-3.154H170.614z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M98.414,309.951h-2.579v-1.884h7.52v1.884h-2.566v6.512h-2.375V309.951z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M112.235,308.067v8.396h-2.375v-3.274h-3.238v3.274h-2.375v-8.396h2.375v3.154h3.238v-3.154H112.235z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M120.66,314.627v1.835h-6.741v-8.396h6.584v1.835h-4.233v1.416H120v1.774h-3.73v1.535H120.66z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M133.463,314.16c0,1.451-1.199,2.303-3.454,2.303h-4.534v-8.396h4.294c2.207,0,3.286,0.899,3.286,2.195 c0,0.804-0.408,1.451-1.127,1.823C132.875,312.42,133.463,313.14,133.463,314.16z M127.826,309.783v1.619h1.631 c0.792,0,1.199-0.276,1.199-0.816c0-0.527-0.408-0.803-1.199-0.803H127.826z M131.064,313.896c0-0.575-0.432-0.852-1.248-0.852 h-1.991v1.703h1.991C130.632,314.747,131.064,314.472,131.064,313.896z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M134.271,312.265c0-2.519,1.979-4.366,4.666-4.366s4.666,1.848,4.666,4.366s-1.979,4.365-4.666,4.365 S134.271,314.784,134.271,312.265z M141.203,312.265c0-1.451-0.995-2.398-2.267-2.398s-2.267,0.947-2.267,2.398 s0.995,2.398,2.267,2.398S141.203,313.716,141.203,312.265z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M144.267,315.707l0.779-1.752c0.744,0.492,1.799,0.828,2.771,0.828c0.983,0,1.367-0.276,1.367-0.684 c0-1.331-4.773-0.36-4.773-3.479c0-1.499,1.223-2.723,3.718-2.723c1.091,0,2.219,0.252,3.046,0.732l-0.731,1.763 c-0.804-0.432-1.595-0.647-2.327-0.647c-0.995,0-1.355,0.336-1.355,0.755c0,1.284,4.761,0.324,4.761,3.419 c0,1.463-1.223,2.71-3.718,2.71C146.426,316.63,145.059,316.258,144.267,315.707z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M152.031,315.707l0.779-1.752c0.744,0.492,1.799,0.828,2.771,0.828c0.983,0,1.367-0.276,1.367-0.684 c0-1.331-4.773-0.36-4.773-3.479c0-1.499,1.223-2.723,3.718-2.723c1.091,0,2.219,0.252,3.046,0.732l-0.731,1.763 c-0.804-0.432-1.595-0.647-2.327-0.647c-0.995,0-1.355,0.336-1.355,0.755c0,1.284,4.761,0.324,4.761,3.419 c0,1.463-1.223,2.71-3.718,2.71C154.19,316.63,152.822,316.258,152.031,315.707z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M159.987,315.311c0-0.707,0.563-1.235,1.367-1.235s1.355,0.528,1.355,1.235 c0,0.696-0.552,1.26-1.355,1.26S159.987,316.007,159.987,315.311z M159.999,308.067h2.711l-0.456,5.338h-1.811L159.999,308.067z"}))))));}}]);return Round3View;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Round3=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(Round3View);/* harmony default export */ __webpack_exports__["a"] = (Round3);

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(211),
    baseIsNaN = __webpack_require__(212),
    strictIndexOf = __webpack_require__(213);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(22),
    isArray = __webpack_require__(44),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(216);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(217);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(83),
    isSymbol = __webpack_require__(218);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(22),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{twoDDarkPatternIncorrect:function twoDDarkPatternIncorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["t" /* twoDDarkPatternIncorrect */])());},twoDDarkPatternCorrect:function twoDDarkPatternCorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["s" /* twoDDarkPatternCorrect */])());}};};var Round4View=function(_Component){_inherits(Round4View,_Component);function Round4View(props){_classCallCheck(this,Round4View);var _this=_possibleConstructorReturn(this,(Round4View.__proto__||Object.getPrototypeOf(Round4View)).call(this,props));_this.state={shake:false,yesWords:[]};return _this;}_createClass(Round4View,[{key:"done",value:function done(){var _this2=this;this.props.twoDDarkPatternCorrect();__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(0.5,function(){return _this2.props.adComplete();});}},{key:"shake",value:function shake(){var _this3=this;this.setState({shake:true});__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(0.6,function(){_this3.setState({shake:false});});this.props.twoDDarkPatternIncorrect();}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].killAll(true,true,true,true);}},{key:"render",value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"floatingad "+(this.state.shake?'shake':'')+" "+(this.state.done?'out':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"_x32_-1",x:"0px",y:"0px",viewBox:"0 0 495.192 459.5",enableBackground:"new 0 0 495.192 459.5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font",{horizAdvX:"1000"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font-face",{fontFamily:"Montserrat-Black",unitsPerEm:"1000",underlinePosition:"-100",underlineThickness:"50"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("missing-glyph",{horizAdvX:"587",d:"M40,0l507,0l0,700l-507,0M120,70l0,560l347,0l0,-560z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"A",horizAdvX:"806",d:"M581,0l244,0l-306,700l-232,0l-306,-700l240,0l47,122l266,0M333,292l68,176l68,-176z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"B",horizAdvX:"773",d:"M617,366C681,398 714,452 714,517C714,623 624,700 431,700l-374,0l0,-700l394,0C644,0 747,71 747,193C747,276 699,336 617,366M399,535C452,535 476,517 476,483C476,449 452,431 399,431l-110,0l0,104M431,165l-142,0l0,110l142,0C483,275 509,256 509,220C509,184 483,165 431,165z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"C",horizAdvX:"744",d:"M419,-16C556,-16 664,34 733,124l-149,133C543,205 494,175 431,175C333,175 267,243 267,350C267,457 333,525 431,525C494,525 543,495 584,443l149,133C664,666 556,716 419,716C194,716 29,565 29,350C29,135 194,-16 419,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"D",horizAdvX:"826",d:"M57,0l345,0C636,0 797,133 797,350C797,567 636,700 402,700l-345,0M293,184l0,332l99,0C491,516 559,457 559,350C559,243 491,184 392,184z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"E",horizAdvX:"673",d:"M289,178l0,92l296,0l0,170l-296,0l0,82l337,0l0,178l-569,0l0,-700l582,0l0,178z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"I",horizAdvX:"350",d:"M57,0l236,0l0,700l-236,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"L",horizAdvX:"617",d:"M57,0l552,0l0,183l-316,0l0,517l-236,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"N",horizAdvX:"804",d:"M517,700l0,-318l-266,318l-194,0l0,-700l230,0l0,318l266,-318l194,0l0,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"O",horizAdvX:"848",d:"M424,-16C652,-16 819,138 819,350C819,562 652,716 424,716C196,716 29,562 29,350C29,138 196,-16 424,-16M424,175C337,175 267,241 267,350C267,459 337,525 424,525C511,525 581,459 581,350C581,241 511,175 424,175z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"P",horizAdvX:"743",d:"M394,700l-337,0l0,-700l236,0l0,172l101,0C589,172 713,274 713,436C713,598 589,700 394,700M379,354l-86,0l0,164l86,0C444,518 475,487 475,436C475,385 444,354 379,354z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"R",horizAdvX:"745",d:"M476,0l252,0l-147,216C665,259 713,335 713,436C713,598 589,700 394,700l-337,0l0,-700l236,0l0,176l64,0M475,436C475,385 444,354 379,354l-86,0l0,164l86,0C444,518 475,487 475,436z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"S",horizAdvX:"657",d:"M318,-16C535,-16 644,92 644,220C644,478 257,408 257,492C257,516 279,536 348,536C409,536 474,519 543,484l71,171C541,696 444,716 350,716C133,716 24,610 24,480C24,219 411,290 411,202C411,178 387,164 320,164C243,164 155,189 89,228l-76,-172C83,13 201,-16 318,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"T",horizAdvX:"654",d:"M209,0l236,0l0,517l205,0l0,183l-646,0l0,-183l205,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"U",horizAdvX:"784",d:"M392,-16C607,-16 733,105 733,315l0,385l-232,0l0,-378C501,215 460,175 394,175C328,175 287,215 287,322l0,378l-236,0l0,-385C51,105 177,-16 392,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"W",horizAdvX:"1206",d:"M972,700l-129,-403l-122,403l-217,0l-129,-398l-122,398l-243,0l224,-700l253,0l119,374l113,-374l253,0l224,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"X",horizAdvX:"762",d:"M770,0l-258,362l243,338l-254,0l-116,-176l-119,176l-265,0l244,-347l-253,-353l269,0l118,187l121,-187z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"Y",horizAdvX:"710",d:"M737,700l-228,0l-144,-242l-143,242l-249,0l264,-443l0,-257l236,0l0,254z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"?",horizAdvX:"606",d:"M207,268l206,0C413,345 573,372 573,525C573,650 456,716 299,716C139,716 38,650 -13,554l178,-89C186,507 226,533 269,533C306,533 336,517 336,486C336,425 207,389 207,268M310,-10C388,-10 442,44 442,110C442,177 388,228 310,228C232,228 178,177 178,110C178,44 232,-10 310,-10z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:" ",horizAdvX:"300"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font",{horizAdvX:"1000"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font-face",{fontFamily:"Montserrat-BlackItalic",unitsPerEm:"1000",underlinePosition:"-100",underlineThickness:"50"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("missing-glyph",{horizAdvX:"587",d:"M-15,0l507,0l140,700l-507,0M79,70l112,560l347,0l-112,-560z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"N",horizAdvX:"804",d:"M602,700l-65,-326l-201,326l-194,0l-140,-700l230,0l65,326l201,-326l194,0l140,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"O",horizAdvX:"848",d:"M396,-16C653,-16 837,156 837,403C837,587 700,716 482,716C225,716 41,544 41,297C41,113 178,-16 396,-16M416,175C330,175 279,230 279,311C279,426 346,525 462,525C548,525 599,470 599,389C599,274 532,175 416,175z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"T",horizAdvX:"654",d:"M154,0l236,0l103,517l205,0l37,183l-646,0l-37,-183l205,0z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font",{horizAdvX:"1000"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font-face",{fontFamily:"Montserrat-ExtraBold",unitsPerEm:"1000",underlinePosition:"-100",underlineThickness:"50"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("missing-glyph",{horizAdvX:"587",d:"M40,0l507,0l0,700l-507,0M120,70l0,560l347,0l0,-560z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"A",horizAdvX:"786",d:"M594,0l206,0l-310,700l-195,0l-309,-700l202,0l55,136l296,0M301,282l90,224l90,-224z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"C",horizAdvX:"738",d:"M419,-14C548,-14 652,33 720,118l-126,114C550,179 496,150 429,150C314,150 234,230 234,350C234,470 314,550 429,550C496,550 550,521 594,468l126,114C652,667 548,714 419,714C197,714 34,563 34,350C34,137 197,-14 419,-14z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"E",horizAdvX:"672",d:"M266,153l0,128l311,0l0,148l-311,0l0,118l353,0l0,153l-549,0l0,-700l562,0l0,153z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"I",horizAdvX:"339",d:"M70,0l198,0l0,700l-198,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"L",horizAdvX:"610",d:"M70,0l532,0l0,157l-334,0l0,543l-198,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"N",horizAdvX:"806",d:"M542,700l0,-373l-309,373l-163,0l0,-700l194,0l0,373l309,-373l163,0l0,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"O",horizAdvX:"846",d:"M423,-14C647,-14 812,140 812,350C812,560 647,714 423,714C199,714 34,560 34,350C34,140 199,-14 423,-14M423,150C317,150 234,229 234,350C234,471 317,550 423,550C529,550 612,471 612,350C612,229 529,150 423,150z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"T",horizAdvX:"635",d:"M219,0l198,0l0,543l214,0l0,157l-627,0l0,-157l215,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"?",horizAdvX:"597",d:"M212,255l178,0C390,347 554,370 554,526C554,648 444,714 290,714C143,714 46,655 -7,566l149,-80C168,531 213,558 267,558C318,558 355,534 355,494C355,419 212,386 212,255M301,-9C368,-9 415,38 415,96C415,155 368,199 301,199C234,199 188,155 188,96C188,38 234,-9 301,-9z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"base_9_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_3_",onClick:function onClick(e){return _this4.shake();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_4_",fill:"#FFFFFF",width:"495.192",height:"459.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"16.369",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"35.325",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"468.036",y:"21.913",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 122.8338 343.2053)",fill:"#B2AFAA",width:"15.333",height:"2.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"474.292",y:"15.663",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 122.8355 343.2098)",fill:"#B2AFAA",width:"2.833",height:"15.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M51.644,23.827c0-3.871,2.971-6.59,7.022-6.59c2.466,0,4.411,0.9,5.653,2.521l-2.683,2.395 c-0.738-0.937-1.621-1.477-2.755-1.477c-1.765,0-2.953,1.225-2.953,3.151s1.188,3.15,2.953,3.15c1.134,0,2.017-0.54,2.755-1.476 l2.683,2.395c-1.242,1.62-3.187,2.521-5.653,2.521C54.615,30.417,51.644,27.698,51.644,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M73.949,27.932h-4.79l-0.846,2.196h-4.321l5.51-12.604h4.177l5.51,12.604h-4.394L73.949,27.932z M72.778,24.871l-1.224-3.169l-1.225,3.169H72.778z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M92.292,17.525v12.604h-3.493l-4.79-5.726v5.726h-4.141V17.525h3.493l4.789,5.726v-5.726H92.292z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M93.835,23.827c0-3.871,2.971-6.59,7.022-6.59c2.466,0,4.411,0.9,5.653,2.521l-2.683,2.395 c-0.738-0.937-1.621-1.477-2.755-1.477c-1.765,0-2.953,1.225-2.953,3.151s1.188,3.15,2.953,3.15c1.134,0,2.017-0.54,2.755-1.476 l2.683,2.395c-1.242,1.62-3.187,2.521-5.653,2.521C96.807,30.417,93.835,27.698,93.835,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M118.211,26.923v3.205h-10.479V17.525h10.245v3.205h-6.068v1.477h5.33v3.061h-5.33v1.656H118.211z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M119.846,17.525h4.249v9.309h5.69v3.295h-9.939V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M130.952,17.525h4.249v9.309h5.69v3.295h-9.939V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M150.826,27.932h-4.79l-0.846,2.196h-4.321l5.51-12.604h4.177l5.51,12.604h-4.394L150.826,27.932z M149.655,24.871l-1.224-3.169l-1.225,3.169H149.655z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M158.852,20.82h-3.691v-3.295h11.631v3.295h-3.691v9.309h-4.249V20.82z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M167.887,17.525h4.249v12.604h-4.249V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M173.683,23.827c0-3.817,3.007-6.59,7.112-6.59s7.112,2.772,7.112,6.59s-3.007,6.59-7.112,6.59 S173.683,27.644,173.683,23.827z M183.622,23.827c0-1.963-1.26-3.151-2.827-3.151s-2.827,1.188-2.827,3.151s1.26,3.15,2.827,3.15 S183.622,25.79,183.622,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M201.875,17.525v12.604h-3.493l-4.79-5.726v5.726h-4.141V17.525h3.493l4.789,5.726v-5.726H201.875z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M208.946,21.377c0-0.558-0.54-0.846-1.207-0.846c-0.774,0-1.494,0.468-1.873,1.225l-3.205-1.603 c0.918-1.729,2.737-2.917,5.618-2.917c2.827,0,4.933,1.188,4.933,3.438c0,2.755-2.881,3.241-2.881,4.628h-3.709 C206.624,23.125,208.946,22.476,208.946,21.377z M206.102,28.148c0-1.206,0.972-2.125,2.376-2.125c1.405,0,2.377,0.919,2.377,2.125 c0,1.188-0.972,2.16-2.377,2.16C207.074,30.308,206.102,29.336,206.102,28.148z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"9.162",y:"44.319",fill:"#DB2103",width:"476.867",height:"407.618"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#EA4800",points:"240,44.319 486.029,44.319 486.029,451.937 240,451.937 261,402 234.5,407.5 268.5,279.5  222.5,252.5 260,124 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"39",y:"65.833",fill:"none",width:"417",height:"101.167"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M81.586,66.972h9.312c6.316,0,10.662,3.59,10.662,9.448s-4.346,9.447-10.662,9.447h-9.312V66.972z M90.629,80.9c2.672,0,4.508-1.592,4.508-4.48c0-2.889-1.835-4.481-4.508-4.481h-2.672V80.9H90.629z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M103.132,76.42c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S103.132,82.142,103.132,76.42z M118.032,76.42c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C116.143,81.144,118.032,79.362,118.032,76.42z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M146.113,79.011v6.856h-6.37V78.93l-7.126-11.958h6.721l3.86,6.532l3.887-6.532h6.154L146.113,79.011z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M152.488,76.42c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S152.488,82.142,152.488,76.42z M167.388,76.42c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C165.499,81.144,167.388,79.362,167.388,76.42z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M175.978,77.364V66.972h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 V66.972h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C179.379,86.299,175.978,83.033,175.978,77.364z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M236.152,66.972l-6.046,18.895h-6.829l-3.05-10.095l-3.212,10.095h-6.829l-6.046-18.895h6.559l3.293,10.743 l3.482-10.743h5.857l3.293,10.878l3.482-10.878H236.152z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M249.765,82.574h-7.18l-1.269,3.293h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L249.765,82.574z M248.011,77.985l-1.835-4.751l-1.835,4.751H248.011z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M277.277,66.972v18.895h-5.236l-7.18-8.583v8.583h-6.208V66.972h5.237l7.18,8.584v-8.584H277.277z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M284.462,71.912h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V71.912z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M310.22,71.912h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V71.912z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M322.749,76.42c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S322.749,82.142,322.749,76.42z M337.648,76.42c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C335.759,81.144,337.648,79.362,337.648,76.42z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M375.419,66.972l-3.779,18.895h-5.237l-5.425-8.8l-1.755,8.8h-6.208l3.779-18.895h5.237l5.425,8.8 l1.754-8.8H375.419z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M375.776,77.85c0-6.667,4.966-11.31,11.904-11.31c5.884,0,9.582,3.482,9.582,8.449 c0,6.667-4.966,11.31-11.904,11.31C379.474,86.299,375.776,82.817,375.776,77.85z M390.837,75.367c0-2.187-1.376-3.671-3.698-3.671 c-3.131,0-4.94,2.672-4.94,5.777c0,2.186,1.377,3.671,3.698,3.671C389.029,81.144,390.837,78.471,390.837,75.367z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M404.232,71.912h-5.533l0.999-4.94h17.438l-0.999,4.94h-5.533l-2.78,13.955h-6.371L404.232,71.912z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M143.861,108.82c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C148.315,118.699,143.861,114.623,143.861,108.82z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M177.311,114.974h-7.18l-1.269,3.293h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L177.311,114.974z M175.556,110.385l-1.835-4.751l-1.835,4.751H175.556z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M204.822,99.372v18.895h-5.236l-7.18-8.583v8.583h-6.208V99.372h5.237l7.18,8.584v-8.584H204.822z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M207.149,108.82c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C211.603,118.699,207.149,114.623,207.149,108.82z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M243.703,113.462v4.805h-15.71V99.372h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H243.703z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M246.164,99.372h6.37v13.956h8.53v4.939h-14.9V99.372z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M282.151,111.411v6.856h-6.37v-6.937l-7.126-11.958h6.721l3.86,6.532l3.887-6.532h6.154L282.151,111.411z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M288.526,108.82c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S288.526,114.542,288.526,108.82z M303.426,108.82c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C301.537,113.544,303.426,111.762,303.426,108.82z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M312.016,109.764V99.372h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 V99.372h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C315.418,118.699,312.016,115.433,312.016,109.764z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M341.444,113.516h-1.728v4.751h-6.37V99.372h9.097c5.264,0,8.611,2.753,8.611,7.126 c0,2.727-1.296,4.778-3.563,5.938l3.968,5.831h-6.802L341.444,113.516z M342.038,104.285h-2.322v4.427h2.322 c1.754,0,2.591-0.836,2.591-2.213C344.629,105.122,343.793,104.285,342.038,104.285z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M95.06,149.155l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.371-8.8,6.371C100.134,151.099,96.949,150.316,95.06,149.155z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M113.824,142.164v-10.392h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 v-10.203h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C117.225,151.099,113.824,147.833,113.824,142.164z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M153.779,145.458c0,3.293-2.78,5.209-7.99,5.209h-10.635v-18.895h10.095c5.21,0,7.639,2.079,7.639,4.94 c0,1.754-0.891,3.212-2.618,4.076C152.483,141.597,153.779,143.217,153.779,145.458z M141.416,136.226v2.807h2.969 c1.431,0,2.079-0.486,2.079-1.404c0-0.917-0.648-1.403-2.079-1.403H141.416z M147.355,144.729c0-0.972-0.702-1.484-2.105-1.484 h-3.833v2.969h3.833C146.653,146.213,147.355,145.7,147.355,144.729z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M154.837,149.155l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.371-8.8,6.371C159.912,151.099,156.727,150.316,154.837,149.155z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M173.008,141.22c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C177.462,151.099,173.008,147.023,173.008,141.22z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M201.949,145.917h-1.728v4.75h-6.37v-18.895h9.097c5.264,0,8.611,2.753,8.611,7.126 c0,2.727-1.296,4.778-3.563,5.938l3.968,5.831h-6.802L201.949,145.917z M202.543,136.685h-2.322v4.427h2.322 c1.754,0,2.591-0.836,2.591-2.213C205.135,137.522,204.298,136.685,202.543,136.685z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M213.966,131.772h6.37v18.895h-6.37V131.772z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M241.124,138.898c0,4.373-3.347,7.126-8.611,7.126h-2.727v4.643h-6.37v-18.895h9.097 C237.776,131.772,241.124,134.525,241.124,138.898z M234.699,138.898c0-1.376-0.837-2.213-2.591-2.213h-2.322v4.427h2.322 C233.862,141.111,234.699,140.275,234.699,138.898z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M246.905,136.712h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V136.712z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M260.46,131.772h6.37v18.895h-6.37V131.772z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M269.154,141.22c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S269.154,146.942,269.154,141.22z M284.054,141.22c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C282.165,145.943,284.054,144.162,284.054,141.22z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M311.431,131.772v18.895h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H311.431z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M341.238,145.458c0,3.293-2.78,5.209-7.99,5.209h-10.635v-18.895h10.095c5.21,0,7.639,2.079,7.639,4.94 c0,1.754-0.891,3.212-2.618,4.076C339.942,141.597,341.238,143.217,341.238,145.458z M328.875,136.226v2.807h2.969 c1.431,0,2.079-0.486,2.079-1.404c0-0.917-0.648-1.403-2.079-1.403H328.875z M334.814,144.729c0-0.972-0.702-1.484-2.105-1.484 h-3.833v2.969h3.833C334.112,146.213,334.814,145.7,334.814,144.729z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M342.728,141.22c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S342.728,146.942,342.728,141.22z M357.628,141.22c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C355.739,145.943,357.628,144.162,357.628,141.22z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M377.663,150.667l-3.266-5.048l-3.186,5.048h-7.261l6.829-9.528l-6.586-9.367h7.153l3.212,4.751 l3.131-4.751h6.856l-6.559,9.124l6.964,9.771H377.663z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M393,137.548c0-0.836-0.81-1.269-1.809-1.269c-1.161,0-2.241,0.702-2.808,1.835l-4.805-2.402 c1.377-2.591,4.103-4.373,8.422-4.373c4.238,0,7.396,1.781,7.396,5.155c0,4.13-4.319,4.859-4.319,6.938h-5.561 C389.518,140.167,393,139.195,393,137.548z M388.735,147.698c0-1.809,1.458-3.185,3.563-3.185s3.563,1.376,3.563,3.185 c0,1.782-1.458,3.239-3.563,3.239S388.735,149.48,388.735,147.698z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"bot"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_27_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M377.39,321.87c3.802-1.329,7.044-4.544,8.775-7.828l4.688-9.872c-1.792,3.107-4.69,5.606-8.314,6.873 c-8.047,2.811-16.876-1.447-19.686-9.494c-1.42-4.068-1.095-8.249,0.63-11.828l0,0l-5.148,10.827 c-1.581,3.429-1.99,7.937-0.63,11.828C360.515,320.422,369.344,324.681,377.39,321.87z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00435E",d:"M382.737,304.228l0.313,1.18c4.081-2.517,5.964-7.639,4.326-12.326L382.737,304.228z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0483AF",d:"M390.884,304.259c2.168-3.734,2.724-8.393,1.18-12.813l-4.686,1.637 c1.637,4.686-0.245,9.808-4.326,12.326c-0.645,0.424-1.323,0.759-2.119,1.038c-5.482,1.915-11.448-0.963-13.362-6.444 c-0.155-0.442-0.278-0.796-0.344-1.269c-1.08-5.08,1.748-10.334,6.789-12.094l-1.637-4.686 c-4.068,1.42-7.137,4.279-8.863,7.857c-1.726,3.579-2.052,7.761-0.63,11.828c2.811,8.047,11.64,12.305,19.686,9.494 C386.283,309.835,389.092,307.365,390.884,304.259L390.884,304.259z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00435E",d:"M374.014,286.638c-5.04,1.761-7.868,7.015-6.789,12.094l1.176-0.609L374.014,286.638z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.0448 -0.999 0.999 0.0448 22.1362 674.2856)",fill:"#0483AF",cx:"363.671",cy:"325.567",rx:"14.607",ry:"14.607"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M364.326,310.973c1.329,0.06,2.602,0.31,3.811,0.698c1.888,2.33,2.973,5.325,2.828,8.556 c-0.314,7.011-6.252,12.439-13.263,12.124c-3.231-0.145-6.117-1.494-8.268-3.583c-0.278-1.239-0.414-2.528-0.354-3.858 C349.44,316.852,356.265,310.612,364.326,310.973z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"356.801",cy:"318.007",r:"2.852"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.0448 -0.999 0.999 0.0448 -68.8745 672.4163)",fill:"#0483AF",cx:"317.188",cy:"372.225",rx:"14.607",ry:"14.607"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M317.843,357.631c1.329,0.06,2.602,0.31,3.811,0.698c1.888,2.33,2.973,5.325,2.828,8.556 c-0.314,7.011-6.252,12.439-13.263,12.124c-3.231-0.145-6.116-1.494-8.268-3.583c-0.278-1.239-0.414-2.528-0.354-3.858 C302.957,363.51,309.782,357.269,317.843,357.631z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"310.318",cy:"364.664",r:"2.852"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_26_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M322.771,376.882c-2.972,4.163-2.93,7.737-2.93,7.737c1.674,1.168,3.667,2.379,5.907,3.531 c0.075-3.993,3.808-12.091,7.073-13.63c-2.579-1.327-4.167-2.415-4.228-2.46C328.592,372.06,325.742,372.726,322.771,376.882z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M332.82,374.52c-3.265,1.539-6.998,9.637-7.073,13.63c1.585,0.823,3.298,1.617,5.11,2.353l0.008-0.027 c-0.604-4.553,3.582-12.484,5.74-14.017l0.062-0.15C335.232,375.707,333.929,375.092,332.82,374.52z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M336.605,376.458c-2.158,1.533-6.343,9.464-5.74,14.017l-0.008,0.027 c3.993,1.627,8.481,2.964,13.185,3.648c-2.131-3.257-1.141-12.453,1.221-15.264c-3.136-0.558-6.079-1.54-8.595-2.579 L336.605,376.458z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M345.262,378.886c-2.361,2.812-3.352,12.007-1.221,15.264c1.549,0.23,3.13,0.384,4.721,0.455 c0.667,0.03,1.335,0.046,2.004,0.041l0-0.146c-5.326-5.461-0.833-15.12-0.833-15.12l0-0.007 C348.348,379.338,346.782,379.163,345.262,378.886z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M349.933,379.381c0,0-4.493,9.658,0.833,15.12l0,0.146c4.679,0.001,9.442-0.774,14.045-2.636 l-0.006-0.014c-3.06-1.641-6.197-9.33-5.984-14.076l-0.013-0.028c-2.906,1.144-5.926,1.552-8.875,1.482L349.933,379.381z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M358.808,377.892l0.013,0.028c-0.213,4.746,2.924,12.435,5.984,14.076l0.006,0.014 c1.475-0.595,2.934-1.303,4.365-2.144c-3.72-2.144-6.695-10.473-6.553-13.956C361.381,376.734,360.105,377.387,358.808,377.892 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M369.099,332.425c-3.62,3.089-4.773,6.582-4.773,6.582c0.666,0.831,1.276,1.666,1.838,2.499 c1.665-3.581,8.349-9.172,12.431-8.885c-0.73-1.105-1.511-2.164-2.329-3.189C376.266,329.432,372.719,329.336,369.099,332.425z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M362.623,375.912c-0.142,3.482,2.833,11.811,6.553,13.956c2.724-1.577,5.356-3.596,7.851-6.131 c1.306-1.327,2.484-2.75,3.534-4.263c-5.533-2.086-12.218-7.344-13.106-8.052c-0.43,0.587-0.886,1.116-1.353,1.597 C364.985,374.152,363.821,375.109,362.623,375.912z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M366.164,341.506c1.227,1.824,2.218,3.651,2.993,5.461c3.621-3.577,8.182-5.294,13.919-5.267 l0.255-0.107c-1.272-3.149-2.863-6.179-4.736-8.972C374.514,332.334,367.829,337.925,366.164,341.506z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M369.355,368.178c-0.548,1.201-1.196,2.293-1.9,3.243c0.887,0.708,7.573,5.966,13.106,8.052l0.007,0 c0.997-1.431,1.886-2.937,2.646-4.505l-13.852-6.791L369.355,368.178z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M369.362,368.179l13.852,6.791c1.648-3.373,2.746-7.035,3.26-10.904 c-2.002-1.935-7.472-4.033-15.174-2.763C370.977,363.843,370.287,366.173,369.362,368.179z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M369.157,346.967c0.536,1.243,0.968,2.481,1.31,3.707c3.526-3.156,10.042-5.141,14.582-3.9l0.049-0.012 c-0.5-1.742-1.091-3.475-1.767-5.169l-0.255,0.107C377.34,341.673,372.778,343.39,369.157,346.967z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M370.467,350.674c0.738,2.637,1.055,5.2,1.03,7.622l0.042,0.002c4.852-2.303,10.273-1.907,15.268,0.511 c0.001-1.114-0.046-2.237-0.134-3.369c-0.239-2.893-0.777-5.807-1.574-8.677l-0.049,0.012 C380.509,345.533,373.993,347.518,370.467,350.674z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M371.497,358.296c-0.004,1.03-0.077,2.037-0.198,3.006c7.703-1.27,13.172,0.828,15.174,2.763 c0.23-1.717,0.343-3.466,0.333-5.256c-4.996-2.417-10.416-2.814-15.268-0.511L371.497,358.296z"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#004763",points:"271.3,347.34 268.053,313.95 242.547,313.95 236.75,343.63 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_25_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#99710E",d:"M346.097,389.137l-2.88,51.747l-106.777-7.346v-102.2l23.382,39.073L346.097,389.137z M302.913,402.75 c0.007,0.007,0.021,0.007,0.028,0.007v-0.007C302.934,402.757,302.927,402.757,302.913,402.75z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#725006",d:"M236.44,331.338v102.2h-0.028l-75.189,5.12l-3.061-87.954l47.865-9.857L236.44,331.338z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2D2619",d:"M343.495,440.919l-0.883,10.838H236.44h-0.028v-23.602h0.028l106.777,12.73L343.495,440.919z M315.782,416.83c1.036-0.285,1.704-1.906,1.746-3.889c-0.035-1.878-0.64-3.235-1.6-3.172c-1.036,0.167-1.795,1.781-1.836,3.889 C314.043,415.758,314.739,417.115,315.782,416.83z M310.161,416.92c0.021-1.224-0.703-1.259-1.273-1.176l-1.308,0.278 l-0.07,3.012l1.558-0.383C309.556,418.562,310.134,418.033,310.161,416.92z M310.022,411.898 c-0.056-1.12-0.619-1.259-1.106-1.287l-1.141,0.167l-0.063,2.789l1.224-0.16C309.424,413.317,310.001,412.899,310.022,411.898z M303.038,398.257c2.727,0.348,3.589-2.692,3.645-5.127l0.209-9.662l-3.61-0.522l-0.327,15.304 c-2.915-0.271-3.749-3.687-3.694-6.261l0.209-9.593l-2.929-0.424l-0.209,9.787c-0.132,6.233,2.699,10.497,6.581,10.991 c0.014,0.007,0.021,0.007,0.028,0L303.038,398.257z M290.295,419.709l3.659-11.707c0.09-0.341,0.264-0.445,0.431-0.438 l1.016,0.174c0.167,0.007,0.417,0.25,0.487,0.598l3.249,12.959c0.153,0.57-0.104,1.127-0.522,1.002l-1.169-0.271 c-0.25-0.007-0.41-0.236-0.487-0.584l-0.619-2.629l-3.45-0.598l-0.647,2.372c-0.09,0.341-0.264,0.445-0.522,0.438l-1.023-0.153 C290.357,420.857,290.114,420.162,290.295,419.709z M293.62,415.849l2.191,0.327l-1.002-4.487L293.62,415.849z M287.874,400.531 l2.142,0.25c0.174,0.014,0.348-0.202,0.355-0.549l0.41-19.095l-2.824-0.41l-0.417,19.206 C287.533,400.274,287.7,400.517,287.874,400.531z M272.723,396.719c1.127,1.955,2.629,2.762,4.229,2.977 c2.908,0.313,5.509-1.955,5.621-7.165c0.188-8.793-6.935-6.497-6.831-11.283c0.021-1.002,0.271-1.718,0.654-2.191l-2.956-0.424 c-0.23,0.793-0.369,1.697-0.39,2.72c-0.181,8.563,6.817,6.087,6.706,11.436c-0.049,2.205-1.482,3.151-2.636,3.068 c-1.064-0.077-2.024-0.96-2.622-2.296c-0.083-0.243-0.355-0.257-0.445-0.146l-1.301,1.899l-0.188,0.341 c-0.09,0.23-0.097,0.459-0.014,0.703C272.64,396.483,272.723,396.608,272.723,396.719z M281.001,379.976l0.146-0.23l-0.765-0.111 c0.056,0.097,0.118,0.195,0.174,0.299C280.639,380.177,280.904,380.198,281.001,379.976z M280.535,405.512l-1.76-0.216 c-0.264-0.014-0.445,0.32-0.452,0.668l-0.25,11.756c-0.014,0.466,0.153,0.821,0.417,0.835l0.883,0.146 c0.264,0.014,0.445-0.209,0.452-0.675l0.188-8.709l3.297,9.773c0.083,0.236,0.257,0.355,0.424,0.48l1.649,0.299 c0.257,0.007,0.522-0.216,0.536-0.675l0.257-12.09c0.007-0.348-0.153-0.814-0.417-0.828l-0.863-0.167 c-0.257-0.014-0.529,0.313-0.536,0.661l-0.188,8.66l-3.207-9.544C280.89,405.651,280.716,405.526,280.535,405.512z M274.97,404.726c-0.264-0.021-0.452,0.32-0.459,0.675l-0.25,11.582c-0.007,0.348,0.16,0.821,0.431,0.835l0.8,0.146 c0.264,0.014,0.445-0.209,0.459-0.682l0.25-11.672c0.007-0.348-0.16-0.71-0.431-0.723L274.97,404.726z M268.202,422.276 l0.946-44.262l0.814,0.118l-0.939,43.817l33.271,7.116l0.563-26.315c0.021,0,0.035,0,0.056,0 c0.007,0.007,0.021,0.007,0.028,0.007c0.146,0.007,0.285,0.014,0.424,0.014c3.422,0,5.795-3.346,5.906-8.772l0.216-10.156 l1.941,0.278l-0.39,18.149c-0.007,0.223,0.07,0.445,0.236,0.459l1.607,0.104c0.16,0.007,0.243-0.209,0.25-0.431l0.181-8.424 l4.278,1.21c0.083,0.007,0.243-0.09,0.243-0.313l0.056-2.309c0-0.223-0.077-0.445-0.23-0.459l-4.278-1.565l0.125-5.655 l4.494,2.17c0.083,0.118,0.167-0.097,0.167-0.313l0.035-1.642l1.029,0.146l-0.383,17.745c0,0.223,0.07,0.445,0.153,0.452 l1.099,0.07c0.077,0.007,0.16-0.209,0.167-0.431l0.153-7.019l3.033,0.772c0.077,0.007,0.16-0.097,0.167-0.313l0.042-1.969 c0.007-0.216-0.07-0.334-0.146-0.445l-3.033-1.12l0.104-4.716l3.172,1.586c0.077,0.118,0.16-0.097,0.16-0.202l0.042-1.857 c0-0.223-0.07-0.445-0.146-0.452l-3.436-1.934l5.092,0.737l-0.716,33.369c-0.007,0.216-0.083,0.32-0.236,0.313l-22.239,9.906 l-33.64-6.977C268.369,422.749,268.195,422.513,268.202,422.276z M319.483,417.546l0.556-0.195 c0.077,0.007,0.16-0.209,0.243-0.32l1.023-3.895l0.87,3.325c0.077,0.111,0.077,0.223,0.153,0.223l0.55-0.195 c0.16-0.097,0.243-0.536,0.174-0.863l-1.092-3.777l1.092-3.659c0.09-0.327,0.021-0.765-0.139-0.772l-0.466-0.028 c-0.077-0.007-0.16,0.097-0.16,0.313l-0.849,3.13l-0.8-3.005c-0.077-0.111-0.153-0.223-0.23-0.23l-0.633,0.07 c-0.237-0.014-0.327,0.536-0.257,0.87l1.106,3.68l-1.356,4.549C319.177,417.205,319.246,417.643,319.483,417.546z M312.638,414.026c-0.077,3.77,1.245,5.711,3.089,5.127c1.683-0.598,2.838-2.97,2.915-6.267c0.07-3.297-0.995-5.342-2.664-5.217 C314.217,407.793,312.721,410.256,312.638,414.026z M305.668,421.316c-0.014,0.445,0.23,0.682,0.48,0.577l2.789-0.904 c1.308-0.397,2.706-1.676,2.755-4.229c0.035-1.551-0.508-2.581-1.475-2.622c0.737-0.522,1.245-1.496,1.273-2.943 c0.056-2.664-1.224-3.075-2.525-2.922l-2.532,0.195c-0.243-0.014-0.501,0.417-0.508,0.751L305.668,421.316z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E180E",points:"236.412,428.154 236.412,451.757 161.682,451.757 161.223,438.658 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#332204",points:"207.126,364.47 212.191,370.376 203.502,377.931 207.801,381.763 178.008,390.563  181.354,382.383 176.102,382.904 180.874,366.856 176.387,360.018 183.928,353.605 181.354,351.838 198.063,350.287  196.435,352.36 203.502,355.88 209.805,355.156 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E0AD3B",d:"M361.707,391.391l-107.41-15.526l-17.857-44.527l111.897,17.606L361.707,391.391z M108.409,357.078 l102.446-12.795l25.585-12.945l-78.577,10.873L108.409,357.078z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"191.609",y:"271.74",transform:"matrix(0.9973 -0.0736 0.0736 0.9973 -20.2377 19.5007)",fill:"#004859",width:"125.944",height:"25.428"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"194.914",y:"265.36",transform:"matrix(0.9973 -0.0736 0.0736 0.9973 -20.2377 19.5007)",fill:"#006382",width:"119.335",height:"38.186"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"201.73",y:"242.775",transform:"matrix(0.9973 -0.0736 0.0736 0.9973 -20.2377 19.5007)",fill:"#36B7FF",width:"105.702",height:"83.358"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M302.076,312.579l-90.348,6.665c0,0,4.97-11.348,21.205-12.545c10.254-0.756,38.366-2.83,47.595-3.511 C296.507,302.008,302.076,312.579,302.076,312.579z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0483AF",d:"M267.702,266.937c-1.202,1.766-1.986,3.852-2.191,6.13c-0.644,7.143,4.624,13.456,11.767,14.1 c7.143,0.644,13.456-4.624,14.1-11.767c0.205-2.278-0.193-4.471-1.059-6.423L267.702,266.937z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M267.702,266.937c-1.202,1.766-1.986,3.852-2.191,6.13c-0.029,0.322-0.033,0.64-0.038,0.958 c1.85,4.17,5.841,7.242,10.707,7.681c7.143,0.644,13.456-4.624,14.1-11.767c0.028-0.315,0.043-0.629,0.048-0.94 c-0.003-0.008-0.006-0.015-0.009-0.023L267.702,266.937z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0483AF",d:"M239.599,269.595c1.36,1.647,2.334,3.651,2.749,5.901c1.302,7.053-3.359,13.826-10.412,15.128 c-7.053,1.302-13.826-3.359-15.128-10.412c-0.415-2.249-0.222-4.469,0.46-6.494L239.599,269.595z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M239.599,269.595l-22.331,4.124c-0.003,0.008-0.004,0.016-0.007,0.024 c0.034,0.31,0.078,0.62,0.135,0.932c1.302,7.053,8.076,11.714,15.128,10.412c4.804-0.887,8.494-4.315,9.95-8.639 c-0.035-0.316-0.068-0.633-0.126-0.951C241.933,273.246,240.959,271.242,239.599,269.595z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004859",d:"M214.311,315.412l84.998-6.27c-3.081-2.969-8.964-6.679-18.781-5.954 c-9.228,0.681-37.341,2.755-47.595,3.511C222.959,307.434,217.241,311.999,214.311,315.412z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_24_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M116.304,337.115c-4.027,0.04-8.167-1.885-10.91-4.387l-7.759-7.696 c2.74,2.315,6.313,3.683,10.153,3.645c8.523-0.086,15.384-7.086,15.298-15.609c-0.044-4.308-1.768-8.131-4.605-10.913l0,0 l8.515,8.438c2.65,2.69,4.564,6.792,4.605,10.913C131.687,330.027,124.826,337.03,116.304,337.115z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00435E",d:"M105.289,322.332l0.106,1.217c-4.693-0.983-8.202-5.163-8.251-10.127L105.289,322.332z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0483AF",d:"M97.636,325.126c-3.306-2.777-5.41-6.971-5.456-11.653l4.964-0.05c0.05,4.964,3.558,9.144,8.251,10.127 c0.751,0.18,1.502,0.266,2.345,0.257c5.807-0.058,10.443-4.789,10.384-10.595c-0.005-0.469-0.008-0.843-0.107-1.311 c-0.708-5.145-5.15-9.128-10.489-9.074l-0.05-4.964c4.308-0.044,8.165,1.604,11.003,4.385 c2.837,2.781,4.563,6.605,4.605,10.913c0.086,8.523-6.775,15.524-15.298,15.609C103.855,328.81,100.375,327.44,97.636,325.126 L97.636,325.126z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00435E",d:"M107.528,302.827c5.338-0.053,9.781,3.93,10.489,9.074l-1.313-0.174L107.528,302.827z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.94 -0.3413 0.3413 0.94 -107.1558 64.2852)",fill:"#0483AF",cx:"129.131",cy:"336.697",rx:"14.607",ry:"14.607"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M124.146,322.966c-1.251,0.454-2.39,1.074-3.428,1.805c-1.105,2.788-1.246,5.97-0.142,9.01 c2.395,6.597,9.684,10.002,16.28,7.607c3.04-1.104,5.391-3.253,6.82-5.89c-0.105-1.265-0.361-2.536-0.815-3.787 C140.108,324.128,131.73,320.212,124.146,322.966z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"133.428",cy:"327.43",r:"2.852"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.94 -0.3413 0.3413 0.94 -114.1108 86.0217)",fill:"#0483AF",cx:"187.433",cy:"367.333",rx:"14.607",ry:"14.607"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M182.447,353.601c-1.251,0.454-2.39,1.074-3.428,1.805c-1.105,2.788-1.246,5.97-0.142,9.01 c2.395,6.597,9.684,10.002,16.28,7.607c3.04-1.104,5.391-3.253,6.82-5.89c-0.105-1.265-0.361-2.536-0.815-3.787 C198.409,354.763,190.031,350.848,182.447,353.601z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"191.73",cy:"358.065",r:"2.852"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_19_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M183.497,373.445c4.08,3.085,5.108,6.508,5.108,6.508c-1.249,1.615-2.789,3.366-4.582,5.134 c-1.265-3.789-7.247-10.401-10.823-10.894c2.065-2.037,3.255-3.55,3.3-3.611C176.501,370.583,179.419,370.367,183.497,373.445z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M173.201,374.194c3.576,0.493,9.558,7.105,10.823,10.894c-1.267,1.259-2.664,2.529-4.173,3.772 l-0.016-0.024c-0.785-4.525-7.149-10.844-9.666-11.661l-0.105-0.125C171.254,376.048,172.313,375.071,173.201,374.194z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M170.169,377.175c2.517,0.818,8.881,7.136,9.666,11.661l0.016,0.024 c-3.325,2.746-7.207,5.362-11.492,7.421c1.06-3.745-2.633-12.224-5.726-14.202c2.826-1.47,5.341-3.286,7.432-5.03 L170.169,377.175z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M162.632,382.079c3.094,1.978,6.787,10.457,5.726,14.202c-1.41,0.682-2.872,1.302-4.37,1.846 c-0.628,0.228-1.26,0.443-1.9,0.638l-0.043-0.14c3.45-6.803-3.723-14.678-3.723-14.678l-0.002-0.007 C159.823,383.432,161.265,382.798,162.632,382.079z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M158.322,383.948c0,0,7.174,7.875,3.723,14.678l0.043,0.14c-4.465,1.399-9.242,2.083-14.19,1.681 l0.002-0.015c2.43-2.481,3.125-10.755,1.504-15.221l0.004-0.031c3.115,0.223,6.119-0.29,8.912-1.238L158.322,383.948z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M149.408,385.179l-0.004,0.031c1.621,4.466,0.926,12.741-1.504,15.221l-0.002,0.015 c-1.586-0.127-3.189-0.366-4.806-0.742c2.909-3.158,3.26-11.996,2.083-15.276C146.606,384.842,148.019,385.084,149.408,385.179 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M126.001,344.864c4.378,1.866,6.521,4.855,6.521,4.855c-0.387,0.992-0.72,1.971-1.007,2.934 c-2.659-2.92-10.709-6.258-14.518-4.764c0.367-1.273,0.796-2.517,1.269-3.739C118.267,344.149,121.623,342.997,126.001,344.864 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M145.176,384.428c1.176,3.281,0.825,12.118-2.083,15.276c-3.07-0.691-6.186-1.832-9.324-3.504 c-1.643-0.876-3.192-1.883-4.646-3.012c4.656-3.644,9.465-10.66,10.101-11.601c0.586,0.431,1.179,0.801,1.768,1.119 C142.395,383.455,143.792,384.021,145.176,384.428z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M131.515,352.653c-0.626,2.107-1.025,4.147-1.224,6.106c-4.524-2.331-9.391-2.607-14.857-0.867 l-0.276-0.026c0.273-3.385,0.886-6.753,1.839-9.978C120.806,346.395,128.856,349.733,131.515,352.653z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M136.441,379.06c0.882,0.982,1.827,1.831,2.783,2.527c-0.635,0.941-5.444,7.956-10.101,11.601 l-0.007,0.002c-1.379-1.068-2.678-2.239-3.871-3.508l11.189-10.62L136.441,379.06z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M136.434,379.062l-11.189,10.62c-2.581-2.726-4.722-5.893-6.37-9.432 c1.332-2.445,5.925-6.081,13.655-7.171C133.598,375.408,134.952,377.425,136.434,379.062z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M130.291,358.758c-0.14,1.346-0.183,2.656-0.142,3.929c-4.308-1.959-11.119-1.905-15.081,0.636 l-0.051,0.004c-0.044-1.812,0.002-3.642,0.141-5.461l0.276,0.026C120.9,356.151,125.766,356.427,130.291,358.758z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M130.149,362.688c0.084,2.737,0.547,5.278,1.295,7.582l-0.039,0.014 c-5.319-0.748-10.373,1.25-14.418,5.05c-0.334-1.063-0.625-2.149-0.879-3.255c-0.636-2.833-0.994-5.774-1.09-8.751l0.051-0.004 C119.029,360.782,125.841,360.729,130.149,362.688z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M131.443,370.27c0.312,0.982,0.682,1.921,1.087,2.81c-7.73,1.09-12.323,4.726-13.655,7.171 c-0.733-1.569-1.364-3.205-1.889-4.916c4.045-3.8,9.099-5.798,14.418-5.05L131.443,370.27z"})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"btn_x5F_1_2_",className:"darkPatternPulse",onClick:function onClick(e){return _this4.shake();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M238.691,180.916v36.073c0,2.768-1.619,5.033-3.599,5.033H85.744c-1.979,0-3.599-2.265-3.599-5.033 v-36.073c0-2.768,1.619-5.033,3.599-5.033h149.348C237.071,175.882,238.691,178.148,238.691,180.916z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M138.933,200.637v6.418h-5.963v-6.494l-6.671-11.194h6.292l3.614,6.115l3.639-6.115h5.761L138.933,200.637 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M161.066,202.557v4.498H146.36v-17.688h14.377v4.498h-8.515v2.072h7.479v4.296h-7.479v2.324H161.066z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M162.252,205.64l1.92-4.346c1.667,0.985,3.891,1.617,5.837,1.617c1.693,0,2.299-0.354,2.299-0.96 c0-2.224-9.779-0.429-9.779-7.024c0-3.285,2.754-5.963,8.238-5.963c2.375,0,4.826,0.505,6.671,1.542l-1.794,4.321 c-1.744-0.884-3.386-1.314-4.927-1.314c-1.744,0-2.299,0.505-2.299,1.112c0,2.123,9.779,0.354,9.779,6.873 c0,3.234-2.754,5.963-8.237,5.963C167.003,207.459,164.021,206.726,162.252,205.64z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M186.508,194.774c0-0.784-0.758-1.188-1.693-1.188c-1.087,0-2.098,0.657-2.628,1.718l-4.498-2.249 c1.289-2.426,3.841-4.093,7.884-4.093c3.967,0,6.924,1.667,6.924,4.826c0,3.866-4.043,4.548-4.043,6.494h-5.206 C183.249,197.225,186.508,196.315,186.508,194.774z M182.516,204.275c0-1.693,1.365-2.982,3.336-2.982 c1.971,0,3.335,1.289,3.335,2.982c0,1.667-1.364,3.032-3.335,3.032C183.881,207.308,182.516,205.943,182.516,204.275z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"btn_x5F_2_2_",className:"darkPatternPulse",onClick:function onClick(e){return _this4.done();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton_2_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M416.96,180.916v36.073c0,2.768-1.619,5.033-3.599,5.033H264.013c-1.979,0-3.599-2.265-3.599-5.033 v-36.073c0-2.768,1.619-5.033,3.599-5.033h149.348C415.34,175.882,416.96,178.148,416.96,180.916z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M329.154,189.367v17.688h-4.902l-6.722-8.035v8.035h-5.812v-17.688h4.902l6.722,8.036v-8.036H329.154z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M331.325,198.211c0-5.357,4.22-9.249,9.98-9.249c5.762,0,9.981,3.891,9.981,9.249 c0,5.356-4.22,9.248-9.981,9.248C335.545,207.459,331.325,203.567,331.325,198.211z M345.273,198.211 c0-2.754-1.77-4.422-3.968-4.422s-3.967,1.668-3.967,4.422c0,2.754,1.769,4.422,3.967,4.422S345.273,200.965,345.273,198.211z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M359.75,194.774c0-0.784-0.758-1.188-1.692-1.188c-1.087,0-2.098,0.657-2.628,1.718l-4.498-2.249 c1.288-2.426,3.841-4.093,7.884-4.093c3.967,0,6.924,1.667,6.924,4.826c0,3.866-4.043,4.548-4.043,6.494h-5.206 C356.49,197.225,359.75,196.315,359.75,194.774z M355.758,204.275c0-1.693,1.364-2.982,3.335-2.982 c1.972,0,3.336,1.289,3.336,2.982c0,1.667-1.364,3.032-3.336,3.032C357.122,207.308,355.758,205.943,355.758,204.275z"})))));}}]);return Round4View;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Round4=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(Round4View);/* harmony default export */ __webpack_exports__["a"] = (Round4);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{twoDDarkPatternIncorrect:function twoDDarkPatternIncorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["t" /* twoDDarkPatternIncorrect */])());},twoDDarkPatternCorrect:function twoDDarkPatternCorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["s" /* twoDDarkPatternCorrect */])());}};};var Round5View=function(_Component){_inherits(Round5View,_Component);function Round5View(props){_classCallCheck(this,Round5View);var _this=_possibleConstructorReturn(this,(Round5View.__proto__||Object.getPrototypeOf(Round5View)).call(this,props));_this.state={shake:false,yesWords:[]};return _this;}_createClass(Round5View,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].set('#btn_x5F_1_1_',{transformOrigin:'center center'});}},{key:"done",value:function done(){var _this2=this;this.props.twoDDarkPatternCorrect();__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(0.5,function(){return _this2.props.adComplete();});}},{key:"shake",value:function shake(){var _this3=this;this.setState({shake:true});__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(0.6,function(){_this3.setState({shake:false});});this.props.twoDDarkPatternIncorrect();}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].killAll(true,true,true,true);}},{key:"render",value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"floatingad "+(this.state.shake?'shake':'')+" "+(this.state.done?'out':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"_x32_-2",x:"0px",y:"0px",viewBox:"0 0 687 399.452",enableBackground:"new 0 0 687 399.452"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font",{horizAdvX:"1000"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font-face",{fontFamily:"Montserrat-Black",unitsPerEm:"1000",underlinePosition:"-100",underlineThickness:"50"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("missing-glyph",{horizAdvX:"587",d:"M40,0l507,0l0,700l-507,0M120,70l0,560l347,0l0,-560z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"A",horizAdvX:"806",d:"M581,0l244,0l-306,700l-232,0l-306,-700l240,0l47,122l266,0M333,292l68,176l68,-176z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"B",horizAdvX:"773",d:"M617,366C681,398 714,452 714,517C714,623 624,700 431,700l-374,0l0,-700l394,0C644,0 747,71 747,193C747,276 699,336 617,366M399,535C452,535 476,517 476,483C476,449 452,431 399,431l-110,0l0,104M431,165l-142,0l0,110l142,0C483,275 509,256 509,220C509,184 483,165 431,165z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"C",horizAdvX:"744",d:"M419,-16C556,-16 664,34 733,124l-149,133C543,205 494,175 431,175C333,175 267,243 267,350C267,457 333,525 431,525C494,525 543,495 584,443l149,133C664,666 556,716 419,716C194,716 29,565 29,350C29,135 194,-16 419,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"D",horizAdvX:"826",d:"M57,0l345,0C636,0 797,133 797,350C797,567 636,700 402,700l-345,0M293,184l0,332l99,0C491,516 559,457 559,350C559,243 491,184 392,184z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"E",horizAdvX:"673",d:"M289,178l0,92l296,0l0,170l-296,0l0,82l337,0l0,178l-569,0l0,-700l582,0l0,178z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"F",horizAdvX:"644",d:"M626,522l0,178l-569,0l0,-700l236,0l0,224l292,0l0,178l-292,0l0,120z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"G",horizAdvX:"769",d:"M520,192C491,180 463,175 434,175C333,175 267,245 267,350C267,458 333,525 437,525C499,525 550,499 594,448l151,133C674,668 563,716 425,716C194,716 29,565 29,350C29,135 194,-16 420,-16C523,-16 640,15 725,73l0,296l-205,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"H",horizAdvX:"804",d:"M511,700l0,-248l-218,0l0,248l-236,0l0,-700l236,0l0,258l218,0l0,-258l236,0l0,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"I",horizAdvX:"350",d:"M57,0l236,0l0,700l-236,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"L",horizAdvX:"617",d:"M57,0l552,0l0,183l-316,0l0,517l-236,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"N",horizAdvX:"804",d:"M517,700l0,-318l-266,318l-194,0l0,-700l230,0l0,318l266,-318l194,0l0,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"O",horizAdvX:"848",d:"M424,-16C652,-16 819,138 819,350C819,562 652,716 424,716C196,716 29,562 29,350C29,138 196,-16 424,-16M424,175C337,175 267,241 267,350C267,459 337,525 424,525C511,525 581,459 581,350C581,241 511,175 424,175z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"P",horizAdvX:"743",d:"M394,700l-337,0l0,-700l236,0l0,172l101,0C589,172 713,274 713,436C713,598 589,700 394,700M379,354l-86,0l0,164l86,0C444,518 475,487 475,436C475,385 444,354 379,354z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"R",horizAdvX:"745",d:"M476,0l252,0l-147,216C665,259 713,335 713,436C713,598 589,700 394,700l-337,0l0,-700l236,0l0,176l64,0M475,436C475,385 444,354 379,354l-86,0l0,164l86,0C444,518 475,487 475,436z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"S",horizAdvX:"657",d:"M318,-16C535,-16 644,92 644,220C644,478 257,408 257,492C257,516 279,536 348,536C409,536 474,519 543,484l71,171C541,696 444,716 350,716C133,716 24,610 24,480C24,219 411,290 411,202C411,178 387,164 320,164C243,164 155,189 89,228l-76,-172C83,13 201,-16 318,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"T",horizAdvX:"654",d:"M209,0l236,0l0,517l205,0l0,183l-646,0l0,-183l205,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"U",horizAdvX:"784",d:"M392,-16C607,-16 733,105 733,315l0,385l-232,0l0,-378C501,215 460,175 394,175C328,175 287,215 287,322l0,378l-236,0l0,-385C51,105 177,-16 392,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"W",horizAdvX:"1206",d:"M972,700l-129,-403l-122,403l-217,0l-129,-398l-122,398l-243,0l224,-700l253,0l119,374l113,-374l253,0l224,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"X",horizAdvX:"762",d:"M770,0l-258,362l243,338l-254,0l-116,-176l-119,176l-265,0l244,-347l-253,-353l269,0l118,187l121,-187z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"Y",horizAdvX:"710",d:"M737,700l-228,0l-144,-242l-143,242l-249,0l264,-443l0,-257l236,0l0,254z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"!",horizAdvX:"314",d:"M67,268l180,0l45,432l-270,0M157,-10C235,-10 289,44 289,110C289,177 235,228 157,228C79,228 25,177 25,110C25,44 79,-10 157,-10z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"?",horizAdvX:"606",d:"M207,268l206,0C413,345 573,372 573,525C573,650 456,716 299,716C139,716 38,650 -13,554l178,-89C186,507 226,533 269,533C306,533 336,517 336,486C336,425 207,389 207,268M310,-10C388,-10 442,44 442,110C442,177 388,228 310,228C232,228 178,177 178,110C178,44 232,-10 310,-10z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:" ",horizAdvX:"300"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font",{horizAdvX:"1000"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font-face",{fontFamily:"Montserrat-BlackItalic",unitsPerEm:"1000",underlinePosition:"-100",underlineThickness:"50"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("missing-glyph",{horizAdvX:"587",d:"M-15,0l507,0l140,700l-507,0M79,70l112,560l347,0l-112,-560z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"A",horizAdvX:"806",d:"M535,0l235,0l-166,700l-232,0l-446,-700l249,0l70,122l267,0M342,292l103,179l34,-179z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"C",horizAdvX:"744",d:"M400,-16C529,-16 633,19 718,123l-139,133C531,198 478,175 423,175C336,175 279,230 279,312C279,437 357,525 468,525C532,525 578,495 608,443l170,133C727,666 617,716 483,716C224,716 41,543 41,297C41,111 183,-16 400,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"E",horizAdvX:"673",d:"M675,522l36,178l-569,0l-140,-700l582,0l36,178l-351,0l18,92l297,0l34,170l-296,0l16,82z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"L",horizAdvX:"617",d:"M2,0l552,0l37,183l-316,0l103,517l-236,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"N",horizAdvX:"804",d:"M602,700l-65,-326l-201,326l-194,0l-140,-700l230,0l65,326l201,-326l194,0l140,700z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font",{horizAdvX:"1000"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font-face",{fontFamily:"Montserrat-ExtraBold",unitsPerEm:"1000",underlinePosition:"-100",underlineThickness:"50"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("missing-glyph",{horizAdvX:"587",d:"M40,0l507,0l0,700l-507,0M120,70l0,560l347,0l0,-560z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"A",horizAdvX:"786",d:"M594,0l206,0l-310,700l-195,0l-309,-700l202,0l55,136l296,0M301,282l90,224l90,-224z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"B",horizAdvX:"769",d:"M608,365C668,396 702,450 702,517C702,625 612,700 428,700l-358,0l0,-700l378,0C636,0 736,71 736,192C736,277 687,337 608,365M402,557C468,557 502,534 502,490C502,445 468,422 402,422l-136,0l0,135M432,143l-166,0l0,142l166,0C500,285 536,262 536,214C536,166 500,143 432,143z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"E",horizAdvX:"672",d:"M266,153l0,128l311,0l0,148l-311,0l0,118l353,0l0,153l-549,0l0,-700l562,0l0,153z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"I",horizAdvX:"339",d:"M70,0l198,0l0,700l-198,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"M",horizAdvX:"954",d:"M884,0l-2,700l-163,0l-240,-404l-246,404l-163,0l0,-700l183,0l0,361l179,-292l88,0l180,302l2,-371z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"N",horizAdvX:"806",d:"M542,700l0,-373l-309,373l-163,0l0,-700l194,0l0,373l309,-373l163,0l0,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"O",horizAdvX:"846",d:"M423,-14C647,-14 812,140 812,350C812,560 647,714 423,714C199,714 34,560 34,350C34,140 199,-14 423,-14M423,150C317,150 234,229 234,350C234,471 317,550 423,550C529,550 612,471 612,350C612,229 529,150 423,150z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"P",horizAdvX:"737",d:"M390,700l-320,0l0,-700l198,0l0,183l122,0C581,183 701,282 701,441C701,601 581,700 390,700M378,339l-110,0l0,205l110,0C460,544 501,506 501,441C501,377 460,339 378,339z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"R",horizAdvX:"740",d:"M503,0l212,0l-151,220C651,262 701,338 701,441C701,601 581,700 390,700l-320,0l0,-700l198,0l0,186l108,0M501,441C501,377 460,339 378,339l-110,0l0,205l110,0C460,544 501,506 501,441z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"T",horizAdvX:"635",d:"M219,0l198,0l0,543l214,0l0,157l-627,0l0,-157l215,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"V",horizAdvX:"766",d:"M584,700l-194,-456l-190,456l-214,0l299,-700l195,0l300,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"X",horizAdvX:"737",d:"M740,0l-260,362l244,338l-214,0l-138,-202l-140,202l-223,0l244,-346l-255,-354l226,0l143,217l145,-217z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"?",horizAdvX:"597",d:"M212,255l178,0C390,347 554,370 554,526C554,648 444,714 290,714C143,714 46,655 -7,566l149,-80C168,531 213,558 267,558C318,558 355,534 355,494C355,419 212,386 212,255M301,-9C368,-9 415,38 415,96C415,155 368,199 301,199C234,199 188,155 188,96C188,38 234,-9 301,-9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:" ",horizAdvX:"291"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"base_8_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_1_",onClick:function onClick(e){return _this4.shake();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_1_",fill:"#FFFFFF",width:"687",height:"399.452"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"16.369",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"35.325",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"659.844",y:"21.913",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 179.013 478.834)",fill:"#B2AFAA",width:"15.333",height:"2.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"666.1",y:"15.663",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 179.0148 478.8386)",fill:"#B2AFAA",width:"2.833",height:"15.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"approve",enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M60.737,27.932h-4.79l-0.846,2.196H50.78l5.51-12.604h4.177l5.51,12.604h-4.394L60.737,27.932z M59.566,24.871l-1.224-3.169l-1.225,3.169H59.566z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M78.468,22.278c0,2.917-2.233,4.754-5.744,4.754h-1.819v3.097h-4.249V17.525h6.068 C76.235,17.525,78.468,19.361,78.468,22.278z M74.183,22.278c0-0.918-0.559-1.477-1.729-1.477h-1.549v2.953h1.549 C73.624,23.754,74.183,23.197,74.183,22.278z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M91.662,22.278c0,2.917-2.233,4.754-5.744,4.754H84.1v3.097h-4.249V17.525h6.068 C89.429,17.525,91.662,19.361,91.662,22.278z M87.377,22.278c0-0.918-0.559-1.477-1.729-1.477H84.1v2.953h1.549 C86.818,23.754,87.377,23.197,87.377,22.278z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M98.446,26.959h-1.152v3.169h-4.249V17.525h6.068c3.511,0,5.744,1.836,5.744,4.753 c0,1.818-0.864,3.188-2.377,3.962l2.647,3.889h-4.537L98.446,26.959z M98.842,20.801h-1.549v2.953h1.549 c1.17,0,1.729-0.558,1.729-1.477C100.571,21.36,100.013,20.801,98.842,20.801z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M105.95,23.827c0-3.817,3.007-6.59,7.112-6.59s7.112,2.772,7.112,6.59s-3.007,6.59-7.112,6.59 S105.95,27.644,105.95,23.827z M115.889,23.827c0-1.963-1.26-3.151-2.827-3.151s-2.827,1.188-2.827,3.151s1.26,3.15,2.827,3.15 S115.889,25.79,115.889,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M134.736,17.525l-5.33,12.604h-4.177l-5.33-12.604h4.574l3.007,7.364l3.079-7.364H134.736z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M145.625,26.923v3.205h-10.479V17.525h10.245v3.205h-6.068v1.477h5.33v3.061h-5.33v1.656H145.625z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M165.083,26.654c0,2.196-1.855,3.475-5.33,3.475h-7.094V17.525h6.734c3.475,0,5.096,1.386,5.096,3.295 c0,1.17-0.594,2.143-1.747,2.719C164.219,24.079,165.083,25.159,165.083,26.654z M156.837,20.496v1.872h1.98 c0.954,0,1.387-0.323,1.387-0.936s-0.433-0.937-1.387-0.937H156.837z M160.798,26.167c0-0.648-0.468-0.99-1.404-0.99h-2.557v1.98 h2.557C160.33,27.158,160.798,26.816,160.798,26.167z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M166.069,23.827c0-3.817,3.007-6.59,7.112-6.59s7.112,2.772,7.112,6.59s-3.007,6.59-7.112,6.59 S166.069,27.644,166.069,23.827z M176.008,23.827c0-1.963-1.26-3.151-2.827-3.151s-2.827,1.188-2.827,3.151s1.26,3.15,2.827,3.15 S176.008,25.79,176.008,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M189.364,30.128l-2.179-3.367l-2.125,3.367h-4.843l4.555-6.355l-4.393-6.248h4.771l2.143,3.169l2.088-3.169 h4.574l-4.375,6.086l4.646,6.518H189.364z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M203.08,30.128l-2.179-3.367l-2.125,3.367h-4.843l4.555-6.355l-4.393-6.248h4.771l2.143,3.169l2.088-3.169 h4.574l-4.375,6.086l4.646,6.518H203.08z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M208.46,17.525h4.249v12.604h-4.249V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M225.239,26.923v3.205H214.76V17.525h10.245v3.205h-6.068v1.477h5.33v3.061h-5.33v1.656H225.239z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M235.01,20.82h-3.691v-3.295h11.632v3.295h-3.691v9.309h-4.249V20.82z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M243.361,23.827c0-3.817,3.007-6.59,7.112-6.59s7.112,2.772,7.112,6.59s-3.007,6.59-7.112,6.59 S243.361,27.644,243.361,23.827z M253.3,23.827c0-1.963-1.26-3.151-2.827-3.151s-2.827,1.188-2.827,3.151s1.26,3.15,2.827,3.15 S253.3,25.79,253.3,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M264.53,26.959h-1.152v3.169h-4.249V17.525h6.068c3.511,0,5.744,1.836,5.744,4.753 c0,1.818-0.864,3.188-2.377,3.962l2.647,3.889h-4.538L264.53,26.959z M264.927,20.801h-1.549v2.953h1.549 c1.17,0,1.729-0.558,1.729-1.477C266.655,21.36,266.097,20.801,264.927,20.801z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M283.792,30.128l-0.036-5.744l-2.737,4.609h-1.873l-2.737-4.411v5.546h-3.871V17.525h3.493l4.105,6.716 l3.997-6.716h3.493l0.036,12.604H283.792z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M300.19,26.923v3.205h-10.479V17.525h10.245v3.205h-6.068v1.477h5.33v3.061h-5.33v1.656H300.19z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M314.249,17.525v12.604h-3.493l-4.79-5.726v5.726h-4.141V17.525h3.493l4.789,5.726v-5.726H314.249z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M319.033,20.82h-3.691v-3.295h11.632v3.295h-3.691v9.309h-4.249V20.82z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M333.631,21.377c0-0.558-0.54-0.846-1.207-0.846c-0.774,0-1.494,0.468-1.873,1.225l-3.205-1.603 c0.918-1.729,2.737-2.917,5.618-2.917c2.827,0,4.933,1.188,4.933,3.438c0,2.755-2.881,3.241-2.881,4.628h-3.709 C331.309,23.125,333.631,22.476,333.631,21.377z M330.787,28.148c0-1.206,0.972-2.125,2.376-2.125s2.377,0.919,2.377,2.125 c0,1.188-0.973,2.16-2.377,2.16S330.787,29.336,330.787,28.148z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"9.162",y:"44.319",fill:"#E29E44",width:"668.675",height:"347.57"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#EFB259",points:"240,44.319 677.837,44.319 677.837,391.889 313.667,391.889 261,341.952 234.5,347.452  268.5,279.5 222.5,252.5 260,124 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"351.833",y:"65.333",fill:"none",width:"303.333",height:"242.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"doyou"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M353.714,66.716h11.387c7.723,0,13.037,4.39,13.037,11.552s-5.313,11.552-13.037,11.552h-11.387V66.716z M364.771,83.747c3.268,0,5.512-1.947,5.512-5.479c0-3.531-2.244-5.479-5.512-5.479h-3.268v10.958H364.771z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M380.048,78.268c0-6.997,5.512-12.08,13.037-12.08c7.525,0,13.037,5.083,13.037,12.08 s-5.512,12.08-13.037,12.08C385.56,90.347,380.048,85.265,380.048,78.268z M398.267,78.268c0-3.598-2.311-5.776-5.182-5.776 c-2.872,0-5.182,2.178-5.182,5.776s2.31,5.776,5.182,5.776C395.956,84.043,398.267,81.865,398.267,78.268z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M432.585,81.436v8.383h-7.789v-8.482l-8.713-14.621h8.218l4.72,7.987l4.752-7.987h7.525L432.585,81.436z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M440.371,78.268c0-6.997,5.512-12.08,13.037-12.08c7.525,0,13.037,5.083,13.037,12.08 s-5.512,12.08-13.037,12.08C445.883,90.347,440.371,85.265,440.371,78.268z M458.59,78.268c0-3.598-2.311-5.776-5.182-5.776 c-2.872,0-5.182,2.178-5.182,5.776s2.31,5.776,5.182,5.776C456.279,84.043,458.59,81.865,458.59,78.268z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M469.081,79.423V66.716h7.789v12.476c0,3.531,1.354,4.852,3.532,4.852s3.531-1.32,3.531-4.852V66.716h7.657 v12.707c0,6.931-4.159,10.924-11.254,10.924C473.24,90.347,469.081,86.354,469.081,79.423z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M514.952,84.01h-2.112v5.809h-7.789V66.716h11.123c6.436,0,10.528,3.367,10.528,8.713 c0,3.333-1.584,5.842-4.356,7.261l4.852,7.129h-8.317L514.952,84.01z M515.678,72.723h-2.838v5.413h2.838 c2.146,0,3.168-1.023,3.168-2.707S517.824,72.723,515.678,72.723z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M548.844,83.944v5.875h-19.208V66.716h18.78v5.875h-11.123v2.707h9.769v5.611h-9.769v3.036H548.844z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M567.587,85.793h-8.779l-1.551,4.026h-7.921l10.099-23.104h7.657l10.1,23.104h-8.053L567.587,85.793z M565.442,80.182l-2.244-5.809l-2.244,5.809H565.442z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M578.442,66.716h7.789v17.063h10.43v6.04h-18.219V66.716z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M598.803,66.716h7.789v17.063h10.43v6.04h-18.219V66.716z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M630.584,81.436v8.383h-7.789v-8.482l-8.713-14.621h8.218l4.72,7.987l4.752-7.987h7.525L630.584,81.436z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M391.307,106.315l-7.393,23.104h-8.35l-3.729-12.344l-3.928,12.344h-8.35l-7.393-23.104h8.02l4.027,13.136 l4.257-13.136h7.162l4.027,13.301l4.257-13.301H391.307z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M407.936,125.393h-8.779l-1.551,4.026h-7.921l10.099-23.104h7.657l10.1,23.104h-8.053L407.936,125.393z M405.79,119.782l-2.244-5.809l-2.244,5.809H405.79z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M441.564,106.315v23.104h-6.403l-8.779-10.496v10.496h-7.591v-23.104h6.403l8.779,10.496v-10.496H441.564z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M450.339,112.355h-6.766v-6.04h21.321v6.04h-6.766v17.063h-7.789V112.355z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M481.82,112.355h-6.766v-6.04h21.321v6.04h-6.766v17.063h-7.789V112.355z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M497.131,117.867c0-6.997,5.512-12.08,13.037-12.08c7.525,0,13.037,5.083,13.037,12.08 s-5.512,12.08-13.037,12.08C502.643,129.947,497.131,124.864,497.131,117.867z M515.35,117.867c0-3.598-2.311-5.776-5.182-5.776 c-2.872,0-5.182,2.178-5.182,5.776s2.31,5.776,5.182,5.776C513.039,123.643,515.35,121.465,515.35,117.867z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M352.79,157.467c0-7.096,5.446-12.08,12.872-12.08c4.521,0,8.086,1.65,10.363,4.621l-4.917,4.39 c-1.354-1.716-2.971-2.707-5.05-2.707c-3.234,0-5.413,2.245-5.413,5.776c0,3.532,2.178,5.776,5.413,5.776 c2.079,0,3.696-0.99,5.05-2.707l4.917,4.39c-2.277,2.971-5.842,4.621-10.363,4.621C358.236,169.547,352.79,164.563,352.79,157.467z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M393.68,164.993H384.9l-1.551,4.026h-7.921l10.099-23.104h7.657l10.1,23.104h-8.053L393.68,164.993z M391.534,159.382l-2.244-5.809l-2.244,5.809H391.534z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M427.308,145.916v23.104h-6.403l-8.779-10.496v10.496h-7.591v-23.104h6.403l8.779,10.496v-10.496H427.308z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M430.142,157.467c0-7.096,5.446-12.08,12.872-12.08c4.521,0,8.086,1.65,10.363,4.621l-4.917,4.39 c-1.354-1.716-2.971-2.707-5.05-2.707c-3.234,0-5.413,2.245-5.413,5.776c0,3.532,2.178,5.776,5.413,5.776 c2.079,0,3.696-0.99,5.05-2.707l4.917,4.39c-2.277,2.971-5.842,4.621-10.363,4.621 C435.588,169.547,430.142,164.563,430.142,157.467z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M474.827,163.144v5.875h-19.208v-23.104h18.78v5.875h-11.123v2.707h9.769v5.611h-9.769v3.036H474.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M477.827,145.916h7.789v17.063h10.43v6.04h-18.219V145.916z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M521.817,160.636v8.383h-7.789v-8.482l-8.713-14.621h8.218l4.72,7.987l4.752-7.987h7.525L521.817,160.636z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M529.602,157.467c0-6.997,5.512-12.08,13.037-12.08c7.525,0,13.037,5.083,13.037,12.08 s-5.512,12.08-13.037,12.08C535.114,169.547,529.602,164.464,529.602,157.467z M547.821,157.467c0-3.598-2.311-5.776-5.182-5.776 c-2.872,0-5.182,2.178-5.182,5.776s2.31,5.776,5.182,5.776C545.51,163.243,547.821,161.065,547.821,157.467z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M558.312,158.623v-12.707h7.789v12.476c0,3.531,1.354,4.852,3.532,4.852s3.531-1.32,3.531-4.852v-12.476 h7.657v12.707c0,6.931-4.159,10.925-11.254,10.925C562.471,169.547,558.312,165.554,558.312,158.623z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M594.284,163.21h-2.112v5.809h-7.789v-23.104h11.123c6.436,0,10.528,3.367,10.528,8.713 c0,3.333-1.584,5.842-4.356,7.261l4.852,7.129h-8.317L594.284,163.21z M595.01,151.922h-2.838v5.413h2.838 c2.146,0,3.168-1.023,3.168-2.707S597.155,151.922,595.01,151.922z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M352.262,206.771l2.508-5.677c2.178,1.287,5.083,2.112,7.624,2.112c2.211,0,3.003-0.462,3.003-1.254 c0-2.904-12.773-0.561-12.773-9.175c0-4.291,3.598-7.789,10.76-7.789c3.103,0,6.304,0.66,8.713,2.013l-2.344,5.644 c-2.277-1.155-4.422-1.716-6.436-1.716c-2.277,0-3.003,0.66-3.003,1.452c0,2.772,12.772,0.462,12.772,8.977 c0,4.225-3.597,7.789-10.759,7.789C358.467,209.147,354.572,208.19,352.262,206.771z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M375.197,198.223v-12.707h7.789v12.476c0,3.531,1.354,4.852,3.532,4.852s3.531-1.32,3.531-4.852v-12.476 h7.657v12.707c0,6.931-4.159,10.924-11.254,10.924C379.356,209.147,375.197,205.154,375.197,198.223z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M424.041,202.249c0,4.027-3.4,6.37-9.77,6.37h-13.004v-23.104h12.344c6.37,0,9.34,2.542,9.34,6.04 c0,2.146-1.089,3.928-3.202,4.984C422.457,197.53,424.041,199.51,424.041,202.249z M408.925,190.961v3.433h3.63 c1.749,0,2.542-0.594,2.542-1.716s-0.792-1.716-2.542-1.716H408.925z M416.186,201.358c0-1.188-0.858-1.815-2.574-1.815h-4.687 v3.63h4.687C415.328,203.173,416.186,202.546,416.186,201.358z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M425.324,206.771l2.508-5.677c2.178,1.287,5.083,2.112,7.624,2.112c2.211,0,3.003-0.462,3.003-1.254 c0-2.904-12.773-0.561-12.773-9.175c0-4.291,3.598-7.789,10.76-7.789c3.103,0,6.304,0.66,8.713,2.013l-2.344,5.644 c-2.277-1.155-4.422-1.716-6.436-1.716c-2.277,0-3.003,0.66-3.003,1.452c0,2.772,12.772,0.462,12.772,8.977 c0,4.225-3.597,7.789-10.759,7.789C431.529,209.147,427.634,208.19,425.324,206.771z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M447.533,197.067c0-7.096,5.446-12.08,12.872-12.08c4.521,0,8.086,1.65,10.363,4.621l-4.917,4.39 c-1.354-1.716-2.971-2.707-5.05-2.707c-3.234,0-5.413,2.245-5.413,5.776c0,3.532,2.178,5.776,5.413,5.776 c2.079,0,3.696-0.99,5.05-2.707l4.917,4.39c-2.277,2.971-5.842,4.621-10.363,4.621 C452.979,209.147,447.533,204.164,447.533,197.067z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M482.911,202.81h-2.112v5.809h-7.789v-23.104h11.123c6.436,0,10.528,3.367,10.528,8.713 c0,3.333-1.584,5.842-4.356,7.261l4.852,7.129h-8.317L482.911,202.81z M483.637,191.522h-2.838v5.413h2.838 c2.146,0,3.168-1.023,3.168-2.707S485.782,191.522,483.637,191.522z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M497.594,185.516h7.789v23.104h-7.789V185.516z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M530.795,194.229c0,5.347-4.092,8.713-10.528,8.713h-3.333v5.677h-7.789v-23.104h11.123 C526.703,185.516,530.795,188.882,530.795,194.229z M522.94,194.229c0-1.683-1.023-2.707-3.168-2.707h-2.838v5.413h2.838 C521.917,196.936,522.94,195.912,522.94,194.229z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M537.855,191.556h-6.766v-6.04h21.321v6.04h-6.766v17.063h-7.789V191.556z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M554.42,185.516h7.789v23.104h-7.789V185.516z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M565.045,197.067c0-6.997,5.512-12.08,13.037-12.08c7.525,0,13.037,5.083,13.037,12.08 s-5.512,12.08-13.037,12.08C570.557,209.147,565.045,204.064,565.045,197.067z M583.264,197.067c0-3.598-2.311-5.776-5.182-5.776 c-2.872,0-5.182,2.178-5.182,5.776s2.31,5.776,5.182,5.776C580.954,202.843,583.264,200.665,583.264,197.067z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M616.727,185.516v23.104h-6.403l-8.779-10.496v10.496h-7.591v-23.104h6.403l8.779,10.496v-10.496H616.727z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M376.488,241.849c0,4.027-3.4,6.37-9.77,6.37h-13.004v-23.104h12.344c6.37,0,9.34,2.542,9.34,6.04 c0,2.146-1.089,3.928-3.202,4.984C374.903,237.129,376.488,239.11,376.488,241.849z M361.372,230.562v3.433h3.63 c1.749,0,2.542-0.594,2.542-1.716s-0.792-1.716-2.542-1.716H361.372z M368.632,240.958c0-1.188-0.858-1.815-2.574-1.815h-4.687 v3.63h4.687C367.774,242.773,368.632,242.146,368.632,240.958z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M378.299,236.667c0-6.997,5.512-12.08,13.037-12.08c7.525,0,13.037,5.083,13.037,12.08 s-5.512,12.08-13.037,12.08C383.811,248.748,378.299,243.665,378.299,236.667z M396.518,236.667c0-3.598-2.311-5.776-5.182-5.776 c-2.872,0-5.182,2.178-5.182,5.776s2.31,5.776,5.182,5.776C394.207,242.443,396.518,240.265,396.518,236.667z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M421.003,248.219l-3.994-6.172l-3.895,6.172h-8.878l8.35-11.651l-8.053-11.453h8.746l3.928,5.809 l3.828-5.809h8.383l-8.02,11.156l8.515,11.948H421.003z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M439.747,232.179c0-1.023-0.99-1.551-2.211-1.551c-1.419,0-2.74,0.858-3.433,2.244l-5.875-2.938 c1.684-3.168,5.017-5.347,10.298-5.347c5.182,0,9.043,2.178,9.043,6.304c0,5.05-5.281,5.941-5.281,8.482h-6.799 C435.489,235.38,439.747,234.192,439.747,232.179z M434.532,244.589c0-2.211,1.782-3.895,4.356-3.895s4.356,1.683,4.356,3.895 c0,2.178-1.782,3.96-4.356,3.96S434.532,246.767,434.532,244.589z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M459.58,232.179c0-1.023-0.99-1.551-2.211-1.551c-1.419,0-2.74,0.858-3.433,2.244l-5.875-2.938 c1.684-3.168,5.017-5.347,10.298-5.347c5.182,0,9.043,2.178,9.043,6.304c0,5.05-5.281,5.941-5.281,8.482h-6.799 C455.322,235.38,459.58,234.192,459.58,232.179z M454.365,244.589c0-2.211,1.782-3.895,4.356-3.895s4.356,1.683,4.356,3.895 c0,2.178-1.782,3.96-4.356,3.96S454.365,246.767,454.365,244.589z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M469.213,225.116h8.911l-1.485,14.258h-5.941L469.213,225.116z M469.312,244.589 c0-2.211,1.782-3.895,4.356-3.895c2.575,0,4.357,1.683,4.357,3.895c0,2.178-1.782,3.96-4.357,3.96 C471.095,248.549,469.312,246.767,469.312,244.589z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M489.939,232.179c0-1.023-0.99-1.551-2.211-1.551c-1.419,0-2.74,0.858-3.433,2.244l-5.875-2.938 c1.684-3.168,5.017-5.347,10.298-5.347c5.182,0,9.043,2.178,9.043,6.304c0,5.05-5.281,5.941-5.281,8.482h-6.799 C485.681,235.38,489.939,234.192,489.939,232.179z M484.724,244.589c0-2.211,1.782-3.895,4.356-3.895s4.356,1.683,4.356,3.895 c0,2.178-1.782,3.96-4.356,3.96S484.724,246.767,484.724,244.589z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M509.772,232.179c0-1.023-0.99-1.551-2.211-1.551c-1.419,0-2.74,0.858-3.433,2.244l-5.875-2.938 c1.684-3.168,5.017-5.347,10.298-5.347c5.182,0,9.043,2.178,9.043,6.304c0,5.05-5.281,5.941-5.281,8.482h-6.799 C505.514,235.38,509.772,234.192,509.772,232.179z M504.557,244.589c0-2.211,1.782-3.895,4.356-3.895s4.356,1.683,4.356,3.895 c0,2.178-1.782,3.96-4.356,3.96S504.557,246.767,504.557,244.589z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_18_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E0A04B",d:"M292.93,353.614c4.024,0.177,8.227-1.606,11.053-4.013l8.016-7.428 c-2.817,2.22-6.435,3.466-10.271,3.298c-8.515-0.376-15.134-7.606-14.758-16.121c0.191-4.304,2.044-8.066,4.974-10.75l0,0 l-8.798,8.144c-2.74,2.598-4.793,6.632-4.974,10.75C277.797,346.007,284.416,353.239,292.93,353.614z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E29E44",d:"M304.442,339.215l-0.147,1.212c4.724-0.823,8.373-4.881,8.591-9.841L304.442,339.215z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F7C472",d:"M311.995,342.267c3.399-2.663,5.644-6.783,5.85-11.46l-4.959-0.219c-0.219,4.959-3.867,9.017-8.591,9.84 c-0.756,0.154-1.51,0.214-2.352,0.177c-5.801-0.256-10.274-5.142-10.017-10.942c0.021-0.468,0.037-0.842,0.151-1.306 c0.882-5.118,5.458-8.948,10.792-8.712l0.219-4.959c-4.304-0.191-8.215,1.325-11.146,4.008 c-2.931,2.683-4.785,6.445-4.974,10.75c-0.376,8.515,6.243,15.745,14.758,16.121 C305.654,345.737,309.179,344.487,311.995,342.267L311.995,342.267z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E29E44",d:"M302.868,319.645c-5.333-0.235-9.909,3.594-10.792,8.712l1.318-0.129L302.868,319.645z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(1 -0.001 0.001 1 -0.355 0.2827)",fill:"#E29E44",cx:"281.212",cy:"353.447",rx:"14.607",ry:"14.607"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F7C472",d:"M295.82,353.432c0.001,1.331-0.191,2.613-0.523,3.838c-2.241,1.992-5.183,3.214-8.417,3.217 c-7.018,0.007-12.712-5.676-12.719-12.694c-0.003-3.234,1.212-6.179,3.2-8.424c1.225-0.334,2.507-0.529,3.837-0.53 C289.266,338.831,295.812,345.363,295.82,353.432z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFE1A4",cx:"288.449",cy:"346.238",r:"2.852"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(1 -0.001 0.001 1 -0.3105 0.2337)",fill:"#BA782A",cx:"232.474",cy:"309.15",rx:"14.607",ry:"14.607"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F7C472",d:"M247.083,309.135c0.001,1.331-0.191,2.613-0.523,3.839c-2.241,1.992-5.183,3.214-8.417,3.217 c-7.018,0.007-12.712-5.676-12.719-12.694c-0.003-3.234,1.212-6.178,3.2-8.424c1.225-0.334,2.507-0.529,3.837-0.53 C240.528,294.535,247.075,301.067,247.083,309.135z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"239.712",cy:"301.941",r:"2.852"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_17_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M228.077,314.94c-4.295-2.778-7.863-2.573-7.863-2.573c-1.09,1.726-2.208,3.772-3.256,6.062 c3.993-0.108,12.253,3.25,13.94,6.441c1.208-2.638,2.222-4.273,2.263-4.336C233.161,320.534,232.365,317.718,228.077,314.94z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M230.898,324.87c-1.687-3.191-9.947-6.55-13.94-6.441c-0.75,1.622-1.464,3.368-2.116,5.212l0.028,0.007 c4.521-0.811,12.635,3.006,14.265,5.091l0.153,0.056C229.822,327.334,230.377,326.005,230.898,324.87z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M229.135,328.74c-1.63-2.085-9.745-5.903-14.265-5.091l-0.028-0.007 c-1.443,4.064-2.572,8.607-3.04,13.338c3.156-2.278,12.387-1.71,15.304,0.52c0.414-3.159,1.26-6.144,2.182-8.704L229.135,328.74 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EFB259",d:"M227.105,337.5c-2.917-2.23-12.148-2.798-15.304-0.52c-0.158,1.558-0.24,3.144-0.239,4.737 c0.001,0.668,0.015,1.336,0.051,2.003l0.146-0.007c5.212-5.57,15.066-1.525,15.066-1.525h0.007 C226.795,340.602,226.898,339.03,227.105,337.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F7C472",d:"M226.825,342.188c0,0-9.854-4.046-15.066,1.525l-0.146,0.007c0.213,4.674,1.206,9.397,3.276,13.909 l0.014-0.007c1.499-3.132,9.036-6.617,13.787-6.622l0.028-0.014c-1.276-2.851-1.821-5.848-1.887-8.798H226.825z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EFB259",d:"M228.719,350.986L228.691,351c-4.751,0.005-12.288,3.49-13.787,6.622l-0.014,0.007 c0.662,1.446,1.436,2.871,2.342,4.262c1.972-3.814,10.156-7.168,13.641-7.186C229.994,353.503,229.283,352.259,228.719,350.986z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EFB259",d:"M274.61,359.183c-3.252-3.475-6.794-4.466-6.794-4.466c-0.799,0.703-1.606,1.351-2.412,1.95 c3.654,1.499,9.545,7.92,9.445,12.011c1.07-0.78,2.092-1.609,3.079-2.473C277.928,366.205,277.862,362.658,274.61,359.183z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F7C472",d:"M230.872,354.706c-3.485,0.017-11.669,3.372-13.641,7.186c1.7,2.649,3.838,5.185,6.484,7.562 c1.386,1.244,2.861,2.355,4.421,3.335c1.831-5.622,6.777-12.542,7.443-13.461c-0.606-0.403-1.156-0.834-1.657-1.278 C232.738,356.985,231.729,355.866,230.872,354.706z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F7C472",d:"M265.404,356.667c-1.766,1.31-3.545,2.383-5.318,3.24c3.739,3.453,5.663,7.931,5.899,13.663l0.118,0.25 c3.087-1.415,6.042-3.143,8.746-5.142C274.949,364.588,269.058,358.166,265.404,356.667z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EFB259",d:"M238.906,361.076c-1.225-0.493-2.345-1.09-3.327-1.75c-0.667,0.919-5.613,7.838-7.443,13.461v0.007 c1.476,0.931,3.021,1.75,4.621,2.437l6.149-14.148L238.906,361.076z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F7C472",d:"M238.906,361.083l-6.149,14.148c3.445,1.492,7.153,2.421,11.042,2.757 c1.841-2.089,3.686-7.649,2.065-15.285C243.31,362.498,240.952,361.916,238.906,361.083z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EFB259",d:"M260.086,359.907c-1.217,0.592-2.434,1.081-3.644,1.478c3.315,3.377,5.596,9.796,4.564,14.388 l0.014,0.049c1.718-0.579,3.421-1.249,5.083-2.002l-0.118-0.25C265.749,367.839,263.825,363.361,260.086,359.907z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F7C472",d:"M256.443,361.386c-2.601,0.858-5.146,1.292-7.567,1.378l0,0.042c2.523,4.742,2.375,10.175,0.189,15.276 c1.113-0.05,2.233-0.148,3.36-0.289c2.879-0.372,5.766-1.042,8.596-1.97l-0.014-0.049 C262.038,371.181,259.757,364.763,256.443,361.386z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EFB259",d:"M248.876,362.764c-1.029,0.043-2.038,0.016-3.012-0.06c1.622,7.636-0.223,13.196-2.065,15.285 c1.725,0.151,3.478,0.184,5.266,0.092c2.186-5.101,2.334-10.534-0.189-15.276L248.876,362.764z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D38B3D",points:"189.3,287.507 186.053,254.117 160.547,254.117 154.75,283.797 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_16_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E29E44",d:"M264.097,329.304l-2.88,51.747l-106.777-7.346v-102.2l23.382,39.073L264.097,329.304z M220.913,342.918 c0.007,0.007,0.021,0.007,0.028,0.007v-0.007C220.934,342.925,220.927,342.925,220.913,342.918z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D38B3D",d:"M154.44,271.506v102.2h-0.028l-75.189,5.12l-3.061-87.954l47.865-9.857L154.44,271.506z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D38B3D",d:"M261.495,381.086l-0.883,10.838H154.44h-0.028v-23.602h0.028l106.777,12.73L261.495,381.086z M233.782,356.997c1.036-0.285,1.704-1.906,1.746-3.889c-0.035-1.878-0.64-3.235-1.6-3.172c-1.036,0.167-1.795,1.781-1.836,3.889 C232.043,355.926,232.739,357.282,233.782,356.997z M228.161,357.087c0.021-1.224-0.703-1.259-1.273-1.176l-1.308,0.278 l-0.07,3.012l1.558-0.383C227.556,358.729,228.134,358.2,228.161,357.087z M228.022,352.065c-0.056-1.12-0.619-1.259-1.106-1.287 l-1.141,0.167l-0.063,2.789l1.224-0.16C227.424,353.484,228.001,353.067,228.022,352.065z M221.038,338.424 c2.727,0.348,3.589-2.692,3.645-5.127l0.209-9.662l-3.61-0.522l-0.327,15.304c-2.915-0.271-3.749-3.687-3.694-6.261l0.209-9.593 l-2.929-0.424l-0.209,9.787c-0.132,6.233,2.699,10.497,6.581,10.991c0.014,0.007,0.021,0.007,0.028,0L221.038,338.424z M208.295,359.877l3.659-11.707c0.09-0.341,0.264-0.445,0.431-0.438l1.016,0.174c0.167,0.007,0.417,0.25,0.487,0.598l3.249,12.959 c0.153,0.57-0.104,1.127-0.522,1.002l-1.169-0.271c-0.25-0.007-0.41-0.236-0.487-0.584l-0.619-2.629l-3.45-0.598l-0.647,2.372 c-0.09,0.341-0.264,0.445-0.522,0.438l-1.023-0.153C208.357,361.025,208.114,360.329,208.295,359.877z M211.62,356.016 l2.191,0.327l-1.002-4.487L211.62,356.016z M205.874,340.699l2.142,0.25c0.174,0.014,0.348-0.202,0.355-0.55l0.41-19.095 l-2.824-0.41L205.54,340.1C205.533,340.441,205.7,340.685,205.874,340.699z M190.723,336.887c1.127,1.955,2.629,2.762,4.229,2.977 c2.908,0.313,5.509-1.955,5.621-7.165c0.188-8.793-6.935-6.497-6.831-11.283c0.021-1.002,0.271-1.718,0.654-2.191l-2.956-0.424 c-0.23,0.793-0.369,1.697-0.39,2.72c-0.181,8.563,6.817,6.087,6.706,11.436c-0.049,2.205-1.482,3.151-2.636,3.068 c-1.064-0.077-2.024-0.96-2.622-2.296c-0.083-0.243-0.355-0.257-0.445-0.146l-1.301,1.899l-0.188,0.341 c-0.09,0.23-0.097,0.459-0.014,0.703C190.64,336.65,190.723,336.775,190.723,336.887z M199.001,320.143l0.146-0.23l-0.765-0.111 c0.056,0.097,0.118,0.195,0.174,0.299C198.639,320.345,198.904,320.366,199.001,320.143z M198.535,345.679l-1.76-0.216 c-0.264-0.014-0.445,0.32-0.452,0.668l-0.25,11.756c-0.014,0.466,0.153,0.821,0.417,0.835l0.883,0.146 c0.264,0.014,0.445-0.209,0.452-0.675l0.188-8.709l3.297,9.773c0.083,0.236,0.257,0.355,0.424,0.48l1.649,0.299 c0.257,0.007,0.522-0.216,0.536-0.675l0.257-12.09c0.007-0.348-0.153-0.814-0.417-0.828l-0.863-0.167 c-0.257-0.014-0.529,0.313-0.536,0.661l-0.188,8.66l-3.207-9.544C198.89,345.818,198.716,345.693,198.535,345.679z M192.97,344.893c-0.264-0.021-0.452,0.32-0.459,0.675l-0.25,11.582c-0.007,0.348,0.16,0.821,0.431,0.835l0.8,0.146 c0.264,0.014,0.445-0.209,0.459-0.682l0.25-11.672c0.007-0.348-0.16-0.71-0.431-0.723L192.97,344.893z M186.202,362.444 l0.946-44.262l0.814,0.118l-0.939,43.817l33.271,7.116l0.563-26.315c0.021,0,0.035,0,0.056,0c0.007,0.007,0.021,0.007,0.028,0.007 c0.146,0.007,0.285,0.014,0.424,0.014c3.422,0,5.795-3.346,5.906-8.772l0.216-10.156l1.941,0.278l-0.39,18.149 c-0.007,0.223,0.07,0.445,0.236,0.459l1.607,0.104c0.16,0.007,0.243-0.209,0.25-0.431l0.181-8.424l4.278,1.21 c0.083,0.007,0.243-0.09,0.243-0.313l0.056-2.309c0-0.223-0.077-0.445-0.23-0.459l-4.278-1.565l0.125-5.655l4.494,2.17 c0.083,0.118,0.167-0.097,0.167-0.313l0.035-1.642l1.03,0.146l-0.383,17.745c0,0.223,0.07,0.445,0.153,0.452l1.099,0.07 c0.077,0.007,0.16-0.209,0.167-0.431l0.153-7.019l3.033,0.772c0.077,0.007,0.16-0.097,0.167-0.313l0.042-1.969 c0.007-0.216-0.07-0.334-0.146-0.445l-3.033-1.12l0.104-4.716l3.172,1.586c0.077,0.118,0.16-0.097,0.16-0.202l0.042-1.857 c0-0.223-0.07-0.445-0.146-0.452l-3.436-1.934l5.092,0.737l-0.717,33.369c-0.007,0.216-0.083,0.32-0.236,0.313l-22.239,9.906 l-33.64-6.977C186.369,362.917,186.195,362.68,186.202,362.444z M237.483,357.714l0.556-0.195c0.077,0.007,0.16-0.209,0.243-0.32 l1.023-3.895l0.87,3.325c0.077,0.111,0.077,0.223,0.153,0.223l0.55-0.195c0.16-0.097,0.243-0.536,0.174-0.863l-1.092-3.777 l1.092-3.659c0.09-0.327,0.021-0.765-0.139-0.772l-0.466-0.028c-0.077-0.007-0.16,0.097-0.16,0.313l-0.849,3.13l-0.8-3.005 c-0.077-0.111-0.153-0.223-0.23-0.23l-0.633,0.07c-0.237-0.014-0.327,0.536-0.257,0.87l1.106,3.68l-1.356,4.549 C237.177,357.373,237.246,357.811,237.483,357.714z M230.638,354.194c-0.077,3.77,1.245,5.711,3.089,5.127 c1.683-0.598,2.838-2.97,2.915-6.267c0.07-3.297-0.995-5.342-2.664-5.217C232.217,347.961,230.721,350.423,230.638,354.194z M223.668,361.484c-0.014,0.445,0.23,0.682,0.48,0.577l2.789-0.904c1.308-0.396,2.706-1.676,2.755-4.229 c0.035-1.551-0.508-2.581-1.475-2.622c0.737-0.522,1.245-1.496,1.273-2.943c0.056-2.664-1.224-3.075-2.525-2.922l-2.532,0.195 c-0.243-0.014-0.501,0.417-0.508,0.751L223.668,361.484z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C17638",points:"154.412,368.322 154.412,391.924 79.682,391.924 79.223,378.826 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C17638",points:"125.126,304.638 130.191,310.544 121.502,318.098 125.801,321.931 96.008,330.73 99.354,322.55  94.102,323.072 98.874,307.024 94.387,300.186 101.928,293.772 99.354,292.005 116.063,290.454 114.435,292.527 121.502,296.047  127.805,295.324 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EFB259",d:"M279.707,331.558l-107.41-15.526l-17.857-44.526l111.897,17.606L279.707,331.558z M26.409,297.246 l102.446-12.795l25.585-12.945l-78.577,10.872L26.409,297.246z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_15_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DB9542",d:"M168.147,353.968c2.998,2.689,7.378,3.978,11.09,3.91l10.909-0.657 c-3.586-0.071-7.173-1.403-10.032-3.967c-6.344-5.693-6.874-15.48-1.182-21.824c2.878-3.206,6.697-4.939,10.664-5.154l0,0 l-11.967,0.714c-3.766,0.27-7.912,2.086-10.664,5.154C161.274,338.488,161.802,348.277,168.147,353.968z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CE8D41",d:"M186.18,350.14l-0.883,0.844c4.174,2.36,9.569,1.539,12.883-2.157L186.18,350.14z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F2B864",d:"M190.082,357.291c4.316,0.098,8.666-1.663,11.792-5.148l-3.695-3.315 c-3.315,3.695-8.71,4.518-12.883,2.157c-0.682-0.361-1.303-0.792-1.931-1.355c-4.322-3.878-4.68-10.492-0.802-14.813 c0.313-0.349,0.563-0.628,0.946-0.914c3.929-3.397,9.895-3.455,13.869,0.112l3.315-3.695c-3.206-2.878-7.191-4.187-11.159-3.973 c-3.968,0.215-7.788,1.947-10.664,5.154c-5.692,6.344-5.162,16.132,1.182,21.824 C182.979,355.951,186.498,357.221,190.082,357.291L190.082,357.291z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CE8D41",d:"M197.378,334.013c-3.974-3.565-9.94-3.507-13.869-0.112l1.101,0.736L197.378,334.013z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.0081 -1 1 0.0081 -195.125 509.1029)",fill:"#E29E44",cx:"159.055",cy:"352.906",rx:"14.607",ry:"14.607"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F2B864",d:"M173.663,353.024c-0.011,1.331-0.215,2.611-0.558,3.834c-2.259,1.972-5.212,3.166-8.446,3.14 c-7.018-0.057-12.66-5.791-12.603-12.809c0.026-3.234,1.268-6.167,3.276-8.394c1.228-0.323,2.511-0.506,3.842-0.496 C167.241,338.364,173.728,344.956,173.663,353.024z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFE1A4",cx:"166.358",cy:"345.763",r:"2.852"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.0081 -1 1 0.0081 -198.3311 416.3951)",fill:"#E29E44",cx:"110.722",cy:"308.168",rx:"14.607",ry:"14.607"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F2B864",d:"M125.33,308.286c-0.011,1.331-0.215,2.611-0.558,3.834c-2.259,1.972-5.212,3.166-8.446,3.14 c-7.018-0.057-12.66-5.791-12.603-12.809c0.026-3.234,1.268-6.167,3.276-8.394c1.228-0.323,2.511-0.506,3.842-0.496 C118.908,293.626,125.395,300.218,125.33,308.286z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFE1A4",cx:"118.025",cy:"301.025",r:"2.852"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_14_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F2B864",d:"M106.273,313.918c-4.269-2.817-7.839-2.644-7.839-2.644c-1.106,1.716-2.242,3.752-3.311,6.032 c3.994-0.072,12.223,3.361,13.881,6.568c1.232-2.627,2.26-4.253,2.303-4.315C111.305,319.558,110.535,316.735,106.273,313.918z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E29E44",d:"M109.003,323.873c-1.658-3.206-9.887-6.64-13.881-6.568c-0.764,1.615-1.495,3.355-2.164,5.193 l0.028,0.007c4.528-0.77,12.608,3.121,14.218,5.221l0.153,0.057C107.904,326.327,108.472,325.003,109.003,323.873z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F2B864",d:"M107.204,327.727c-1.611-2.1-9.691-5.991-14.218-5.221l-0.028-0.007c-1.48,4.051-2.65,8.584-3.161,13.31 c3.176-2.249,12.402-1.597,15.299,0.659c0.443-3.155,1.316-6.132,2.261-8.684L107.204,327.727z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E29E44",d:"M105.096,336.468c-2.896-2.256-12.122-2.908-15.299-0.659c-0.173,1.557-0.269,3.142-0.282,4.735 c-0.005,0.668,0.003,1.336,0.032,2.004l0.146-0.006c5.262-5.523,15.079-1.388,15.079-1.388l0.007,0 C104.757,339.568,104.875,337.996,105.096,336.468z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F2B864",d:"M104.772,341.154c0,0-9.817-4.135-15.079,1.388l-0.146,0.006c0.171,4.676,1.12,9.407,3.15,13.938 l0.014-0.007c1.528-3.118,9.096-6.535,13.847-6.497l0.028-0.014c-1.25-2.862-1.768-5.865-1.807-8.814L104.772,341.154z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E29E44",d:"M106.586,349.968l-0.028,0.014c-4.751-0.038-12.319,3.379-13.847,6.497l-0.014,0.007 c0.649,1.452,1.41,2.884,2.303,4.283c2.006-3.796,10.221-7.076,13.706-7.061C107.839,352.497,107.14,351.246,106.586,349.968z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DB9542",d:"M152.401,358.582c-3.22-3.504-6.753-4.528-6.753-4.528c-0.806,0.696-1.618,1.336-2.429,1.928 c3.64,1.532,9.473,8.007,9.335,12.096c1.078-0.77,2.107-1.59,3.101-2.444C155.655,365.634,155.622,362.086,152.401,358.582z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F2B864",d:"M108.706,353.707c-3.485-0.014-11.699,3.265-13.706,7.061c1.676,2.664,3.791,5.22,6.415,7.62 c1.374,1.256,2.84,2.381,4.39,3.375c1.882-5.606,6.89-12.48,7.566-13.393c-0.602-0.408-1.148-0.844-1.645-1.293 C110.551,356.004,109.552,354.876,108.706,353.707z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F2B864",d:"M143.219,355.983c-1.777,1.293-3.567,2.35-5.347,3.191c3.707,3.487,5.591,7.982,5.774,13.716 l0.116,0.251c3.1-1.387,6.07-3.088,8.792-5.063C152.691,363.989,146.859,357.515,143.219,355.983z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E29E44",d:"M116.681,360.151c-1.22-0.504-2.335-1.111-3.311-1.78c-0.675,0.913-5.684,7.787-7.566,13.393l0,0.007 c1.467,0.944,3.005,1.777,4.599,2.479l6.277-14.092L116.681,360.151z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F2B864",d:"M116.681,360.158l-6.277,14.092c3.431,1.523,7.131,2.485,11.017,2.858 c1.86-2.072,3.755-7.615,2.203-15.265C121.073,361.612,118.72,361.009,116.681,360.158z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E29E44",d:"M137.871,359.174c-1.222,0.581-2.443,1.059-3.657,1.445c3.284,3.407,5.506,9.846,4.433,14.429 l0.014,0.049c1.723-0.563,3.432-1.217,5.101-1.955l-0.116-0.251C143.462,367.156,141.579,362.661,137.871,359.174z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F2B864",d:"M134.215,360.619c-2.608,0.835-5.158,1.245-7.579,1.309l0,0.042c2.48,4.764,2.283,10.196,0.05,15.277 c1.113-0.04,2.234-0.128,3.362-0.258c2.883-0.345,5.775-0.99,8.613-1.892l-0.014-0.049 C139.721,370.465,137.498,364.027,134.215,360.619z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E29E44",d:"M126.635,361.928c-1.03,0.033-2.038-0.003-3.011-0.087c1.552,7.651-0.343,13.194-2.203,15.265 c1.724,0.167,3.476,0.216,5.265,0.14c2.232-5.081,2.429-10.512-0.05-15.277L126.635,361.928z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#EFB259",points:"164.373,186.25 187.008,280.836 251.105,253.816 232.631,172.305 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E29E44",d:"M116.139,203.791l16.212,63.105l29.742-1.584c-0.009-0.007-0.003-0.056,0.011-0.127 c0.034,0.026,0.063,0.049,0.074,0.058l24.83,15.593l-22.48-94.572L116.139,203.791z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EFB259",d:"M137.297,215.222c0,0-8.044,2.351-8.286,2.419c-8.021,2.266-12.282,12.633-9.408,23.146 c3.015,10.528,11.929,17.145,20.091,14.892c8.162-2.253,8.286-2.419,8.286-2.419c8.162-2.253,12.423-12.618,9.408-23.146 C154.373,219.587,145.459,212.97,137.297,215.222z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D38B3D",d:"M139.528,228.923L139.528,228.923c-2.256-2.444-5.222-3.528-8.089-2.745 c-4.481,1.193-6.778,6.968-5.148,12.779c1.632,5.812,6.555,9.453,11.036,8.26c2.867-0.784,4.773-3.381,5.448-6.53 c0.405-1.889,0.336-4.041-0.3-6.25C141.918,232.166,140.814,230.34,139.528,228.923z M129.009,217.64 c8.162-2.253,17.076,4.364,20.091,14.892c3.015,10.528-1.246,20.893-9.408,23.146c-8.162,2.253-17.076-4.364-20.091-14.892 C116.727,230.273,120.988,219.908,129.009,217.64z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C17638",d:"M139.528,228.923c1.287,1.416,2.391,3.243,3.025,5.452c0.572,2.131,0.641,4.282,0.3,6.25 c-0.652,0.792-1.353,1.365-2.309,1.627c-2.867,0.784-6.065-1.54-7.047-5.285c-1.059-3.681,0.458-7.389,3.325-8.173 C137.638,228.518,138.565,228.539,139.528,228.923L139.528,228.923z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E29E44",d:"M178.706,220.235c0.177,1.478,0.639,3.075,1.503,4.509c3.188,5.421,10.081,7.131,15.503,3.943 c5.421-3.188,7.131-10.081,3.943-15.503c-0.864-1.434-1.952-2.494-3.145-3.466L178.706,220.235z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M180.208,224.743c1.819,3.093,4.844,4.971,8.113,5.429c0.374-0.169,0.744-0.357,1.105-0.57 c5.421-3.188,7.131-10.081,3.943-15.503c-0.395-0.654-0.84-1.223-1.317-1.75l-13.347,7.885 C178.883,221.712,179.345,223.31,180.208,224.743z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E29E44",d:"M219.617,202.201c-0.826,1.05-1.469,2.326-1.816,3.733c-1.347,5.222,1.815,10.689,7.149,11.943 c5.222,1.347,10.689-1.815,11.943-7.149c0.346-1.407,0.378-2.744,0.204-4.1L219.617,202.201z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M217.802,205.934c-1.347,5.222,1.814,10.688,7.149,11.943c0.821,0.212,1.644,0.299,2.459,0.298 c1.883-1.307,3.322-3.271,3.89-5.687c0.346-1.407,0.378-2.744,0.204-4.1l-13.414-3.397 C217.981,205.297,217.882,205.611,217.802,205.934z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D38B3D",d:"M190.803,265.892l51.831-20.319c0,0-2.961-7.238-12.363-3.626c-9.431,3.624-16.378,6.294-32.152,12.539 C190.31,257.532,190.803,265.892,190.803,265.892z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#EFB259",cx:"119.039",cy:"121.302",rx:"70.396",ry:"35.969"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#EFB259",points:"106.762,152.496 108.388,173.833 88.676,150.667 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"68.333",y:"102.333",fill:"none",width:"102.667",height:"55.333"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"howwill"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M95.392,102.794v7.701h-2.597v-2.838h-2.398v2.838H87.8v-7.701h2.597v2.729h2.398v-2.729H95.392z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M96.336,106.645c0-2.333,1.837-4.026,4.346-4.026s4.346,1.694,4.346,4.026s-1.837,4.027-4.346,4.027 S96.336,108.978,96.336,106.645z M102.409,106.645c0-1.199-0.771-1.925-1.728-1.925s-1.727,0.726-1.727,1.925 s0.77,1.925,1.727,1.925S102.409,107.844,102.409,106.645z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M118.228,102.794l-2.464,7.701h-2.783l-1.243-4.115l-1.309,4.115h-2.784l-2.464-7.701h2.673l1.342,4.379 l1.419-4.379h2.387l1.342,4.434l1.419-4.434H118.228z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M134.794,102.794l-2.464,7.701h-2.783l-1.243-4.115l-1.309,4.115h-2.784l-2.464-7.701h2.673l1.342,4.379 l1.419-4.379h2.387l1.342,4.434l1.419-4.434H134.794z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M135.364,102.794h2.597v7.701h-2.597V102.794z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M139.214,102.794h2.597v5.688h3.477v2.013h-6.073V102.794z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M146.001,102.794h2.597v5.688h3.477v2.013h-6.073V102.794z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M89.127,121.572c0,1.342-1.133,2.124-3.256,2.124h-4.335v-7.701h4.115c2.124,0,3.113,0.847,3.113,2.013 c0,0.715-0.363,1.31-1.067,1.662C88.599,119.999,89.127,120.659,89.127,121.572z M84.088,117.81v1.144h1.21 c0.583,0,0.847-0.198,0.847-0.572s-0.264-0.572-0.847-0.572H84.088z M86.508,121.275c0-0.396-0.286-0.605-0.858-0.605h-1.562v1.21 h1.562C86.223,121.88,86.508,121.671,86.508,121.275z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M89.73,119.845c0-2.333,1.837-4.026,4.346-4.026s4.346,1.694,4.346,4.026s-1.837,4.026-4.346,4.026 S89.73,122.177,89.73,119.845z M95.804,119.845c0-1.199-0.771-1.925-1.728-1.925s-1.727,0.726-1.727,1.925s0.77,1.925,1.727,1.925 S95.804,121.044,95.804,119.845z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M103.966,123.695l-1.332-2.057l-1.298,2.057h-2.959l2.783-3.884l-2.684-3.817h2.915l1.31,1.937l1.276-1.937 h2.794l-2.673,3.719l2.838,3.982H103.966z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M112.348,123.695l-1.332-2.057l-1.298,2.057h-2.959l2.783-3.884l-2.684-3.817h2.915l1.31,1.937l1.276-1.937 h2.794l-2.673,3.719l2.838,3.982H112.348z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M115.636,115.994h2.597v7.701h-2.597V115.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M125.889,121.737v1.958h-6.403v-7.701h6.26v1.958h-3.708v0.902h3.256v1.871h-3.256v1.012H125.889z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M132.785,117.953v1.32h3.212v1.958h-3.212v2.464h-2.597v-7.701h6.26v1.958H132.785z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M137.272,115.994h2.597v7.701h-2.597V115.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M148.714,115.994v7.701h-2.134l-2.927-3.499v3.499h-2.53v-7.701h2.134l2.927,3.499v-3.499H148.714z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M149.966,115.994h3.796c2.574,0,4.345,1.463,4.345,3.851s-1.771,3.851-4.345,3.851h-3.796V115.994z M153.652,121.671c1.089,0,1.837-0.649,1.837-1.826s-0.748-1.826-1.837-1.826h-1.089v3.652H153.652z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M108.821,134.101v2.794h-2.596v-2.828l-2.904-4.874h2.739l1.573,2.663l1.584-2.663h2.509L108.821,134.101z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M111.417,133.045c0-2.333,1.837-4.026,4.346-4.026s4.346,1.694,4.346,4.026s-1.837,4.026-4.346,4.026 S111.417,135.377,111.417,133.045z M117.49,133.045c0-1.199-0.771-1.925-1.728-1.925s-1.727,0.726-1.727,1.925 s0.77,1.925,1.727,1.925S117.49,134.244,117.49,133.045z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M120.987,133.43v-4.236h2.596v4.159c0,1.177,0.451,1.617,1.177,1.617s1.177-0.44,1.177-1.617v-4.159h2.552 v4.236c0,2.31-1.386,3.641-3.751,3.641S120.987,135.74,120.987,133.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE1A4",d:"M132.747,131.549c0-0.341-0.33-0.517-0.737-0.517c-0.473,0-0.913,0.286-1.144,0.748l-1.958-0.979 c0.561-1.056,1.672-1.782,3.433-1.782c1.727,0,3.014,0.726,3.014,2.101c0,1.683-1.76,1.98-1.76,2.828h-2.266 C131.327,132.616,132.747,132.22,132.747,131.549z M131.008,135.686c0-0.737,0.594-1.298,1.452-1.298 c0.858,0,1.452,0.561,1.452,1.298c0,0.726-0.594,1.32-1.452,1.32C131.602,137.005,131.008,136.412,131.008,135.686z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"btn_x5F_1_1_",className:"darkPatternPulse",onClick:function onClick(e){return _this4.shake();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton_4_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M657,298.178v36.073c0,2.768-3.113,5.033-6.919,5.033h-287.16c-3.806,0-6.919-2.265-6.919-5.033v-36.073 c0-2.768,3.113-5.033,6.919-5.033H650.08C653.885,293.144,657,295.409,657,298.178z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"355.5",y:"305.569",fill:"none",width:"301.5",height:"28.212"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ignore"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M398.896,306.628h5.963v17.688h-5.963V306.628z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M419.438,314.992h5.18v7.479c-2.148,1.466-5.104,2.249-7.707,2.249c-5.71,0-9.88-3.815-9.88-9.248 c0-5.433,4.169-9.249,10.006-9.249c3.487,0,6.292,1.213,8.086,3.411l-3.815,3.361c-1.112-1.289-2.401-1.946-3.967-1.946 c-2.628,0-4.296,1.693-4.296,4.422c0,2.653,1.668,4.422,4.22,4.422c0.732,0,1.44-0.126,2.173-0.43V314.992z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M444.603,306.628v17.688h-4.902l-6.722-8.035v8.035h-5.812v-17.688h4.902l6.722,8.036v-8.036H444.603z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M446.774,315.472c0-5.357,4.22-9.249,9.981-9.249s9.981,3.891,9.981,9.249c0,5.356-4.22,9.248-9.981,9.248 S446.774,320.829,446.774,315.472z M460.722,315.472c0-2.754-1.769-4.422-3.967-4.422s-3.967,1.668-3.967,4.422 c0,2.754,1.769,4.422,3.967,4.422S460.722,318.226,460.722,315.472z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M476.488,319.869h-1.617v4.447h-5.963v-17.688h8.516c4.927,0,8.061,2.578,8.061,6.671 c0,2.552-1.213,4.473-3.335,5.559l3.714,5.458h-6.368L476.488,319.869z M477.043,311.227h-2.173v4.144h2.173 c1.643,0,2.426-0.783,2.426-2.072S478.686,311.227,477.043,311.227z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M502.437,319.818v4.498H487.73v-17.688h14.378v4.498h-8.516v2.072h7.479v4.296h-7.479v2.324H502.437z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M529.749,319.439c0,3.083-2.603,4.877-7.479,4.877h-9.956v-17.688h9.45c4.877,0,7.151,1.946,7.151,4.624 c0,1.643-0.833,3.007-2.451,3.816C528.536,315.826,529.749,317.342,529.749,319.439z M518.176,310.797v2.628h2.779 c1.339,0,1.946-0.455,1.946-1.314c0-0.859-0.606-1.314-1.946-1.314H518.176z M523.735,318.757c0-0.91-0.657-1.39-1.971-1.39h-3.588 v2.779h3.588C523.078,320.146,523.735,319.667,523.735,318.757z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M531.137,315.472c0-5.357,4.22-9.249,9.981-9.249s9.981,3.891,9.981,9.249c0,5.356-4.22,9.248-9.981,9.248 S531.137,320.829,531.137,315.472z M545.085,315.472c0-2.754-1.769-4.422-3.967-4.422s-3.967,1.668-3.967,4.422 c0,2.754,1.769,4.422,3.967,4.422S545.085,318.226,545.085,315.472z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M563.833,324.316l-3.058-4.725l-2.981,4.725h-6.797l6.393-8.92l-6.166-8.768h6.696l3.007,4.447l2.931-4.447 h6.418l-6.14,8.541l6.519,9.147H563.833z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M583.086,324.316l-3.058-4.725l-2.981,4.725h-6.797l6.393-8.92l-6.166-8.768h6.696l3.007,4.447l2.931-4.447 h6.418l-6.14,8.541l6.519,9.147H583.086z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M590.64,306.628h5.963v17.688h-5.963V306.628z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M614.188,319.818v4.498h-14.706v-17.688h14.378v4.498h-8.516v2.072h7.479v4.296h-7.479v2.324H614.188z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"hitarea",fillOpacity:"0",fill:"#0db5ff",x:"357",y:"349.663",width:"299",height:"37.693",onClick:function onClick(e){return _this4.done();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cancel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FCCB83",d:"M472.133,367.461c0-3.938,2.93-6.707,7.075-6.707c2.145,0,3.905,0.8,4.722,2.241l-2.721,2.129 c-0.48-0.833-1.217-1.312-2.241-1.312c-1.777,0-3.025,1.409-3.025,3.409c0,1.312,0.912,2.193,2.305,2.193 c0.881,0,1.729-0.368,2.497-1.296l2.225,2.129c-1.36,1.665-3.024,2.225-5.09,2.225 C474.405,372.471,472.133,370.438,472.133,367.461z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FCCB83",d:"M491.416,370.262h-4.273l-1.121,1.953h-3.985l7.139-11.205h3.714l2.657,11.205h-3.762L491.416,370.262z M490.888,367.541l-0.544-2.865l-1.648,2.865H490.888z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FCCB83",d:"M509.435,361.01l-2.241,11.205h-3.104l-3.218-5.218l-1.04,5.218h-3.682l2.24-11.205h3.105l3.218,5.218 l1.04-5.218H509.435z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FCCB83",d:"M509.637,367.461c0-3.938,2.93-6.707,7.075-6.707c2.145,0,3.905,0.8,4.722,2.241l-2.721,2.129 c-0.48-0.833-1.217-1.312-2.241-1.312c-1.777,0-3.025,1.409-3.025,3.409c0,1.312,0.912,2.193,2.305,2.193 c0.881,0,1.729-0.368,2.497-1.296l2.225,2.129c-1.36,1.665-3.024,2.225-5.09,2.225 C511.909,372.471,509.637,370.438,509.637,367.461z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FCCB83",d:"M526.295,363.859l-0.256,1.312h4.737l-0.544,2.721h-4.754l-0.288,1.473h5.618l-0.576,2.849h-9.315 l2.24-11.205h9.108l-0.576,2.849H526.295z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FCCB83",d:"M533.925,361.01h3.778l-1.649,8.275h5.059l-0.593,2.929h-8.835L533.925,361.01z"}))));}}]);return Round5View;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Round5=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(Round5View);/* harmony default export */ __webpack_exports__["a"] = (Round5);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{twoDDarkPatternIncorrect:function twoDDarkPatternIncorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["t" /* twoDDarkPatternIncorrect */])());},twoDDarkPatternCorrect:function twoDDarkPatternCorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["s" /* twoDDarkPatternCorrect */])());}};};var Round6View=function(_Component){_inherits(Round6View,_Component);function Round6View(props){_classCallCheck(this,Round6View);var _this=_possibleConstructorReturn(this,(Round6View.__proto__||Object.getPrototypeOf(Round6View)).call(this,props));_this.state={shake:false,yesWords:[]};return _this;}_createClass(Round6View,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].set('#btn_x5F_1_1_',{transformOrigin:'center center'});}},{key:"hoverOff",value:function hoverOff(){__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].set('#underline',{opacity:0});}},{key:"hoverOn",value:function hoverOn(){__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].set('#underline',{opacity:1});}},{key:"done",value:function done(){var _this2=this;this.props.twoDDarkPatternCorrect();__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(0.5,function(){return _this2.props.adComplete();});}},{key:"shake",value:function shake(){var _this3=this;this.setState({shake:true});__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(0.6,function(){_this3.setState({shake:false});});this.props.twoDDarkPatternIncorrect();}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].killAll(true,true,true,true);}},{key:"render",value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"floatingad "+(this.state.shake?'shake':'')+" "+(this.state.done?'out':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"_x32_-3",x:"0px",y:"0px",viewBox:"0 0 687 399.452",enableBackground:"new 0 0 687 399.452"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"base_7_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_2_",onClick:function onClick(e){return _this4.shake();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_2_",fill:"#FFFFFF",width:"687",height:"399.452"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"16.369",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"35.325",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"659.84",y:"21.917",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 179.0086 478.8322)",fill:"#B2AFAA",width:"15.333",height:"2.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"666.095",y:"15.668",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 179.0101 478.8366)",fill:"#B2AFAA",width:"2.833",height:"15.333"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"9.162",y:"44.319",fill:"#8905C6",width:"668.675",height:"347.57"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#5F1AC1",points:"631,44.319 677.837,44.319 677.837,391.889 81,391.889        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#371BBF",points:"677.837,266 677.837,391.889 284,391.889         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_23_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#20536D",d:"M221.104,361.205c1.18-3.851,4.267-7.215,7.482-9.072l9.683-5.067c-3.035,1.911-5.42,4.903-6.546,8.574 c-2.497,8.15,2.1,16.807,10.25,19.304c4.12,1.261,8.285,0.775,11.795-1.088l0,0l-10.619,5.563 c-3.366,1.712-7.854,2.296-11.795,1.088C223.205,378.011,218.606,369.354,221.104,361.205z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A3849",d:"M238.525,355.178l-1.192-0.267c2.357-4.176,7.402-6.256,12.149-4.801L238.525,355.178z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#668A9E",d:"M238.178,347.039c3.647-2.311,8.281-3.047,12.758-1.676l-1.454,4.746 c-4.746-1.454-9.792,0.625-12.149,4.801c-0.398,0.661-0.708,1.351-0.955,2.157c-1.701,5.552,1.406,11.402,6.957,13.103 c0.448,0.137,0.806,0.247,1.282,0.295c5.118,0.882,10.259-2.147,11.822-7.253l4.746,1.454c-1.261,4.12-3.999,7.297-7.508,9.161 c-3.51,1.863-7.676,2.351-11.795,1.088c-8.15-2.497-12.747-11.154-10.25-19.304 C232.785,351.852,235.144,348.949,238.178,347.039L238.178,347.039z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A3849",d:"M256.44,363.213c-1.564,5.104-6.704,8.134-11.822,7.253l0.563-1.199L256.44,363.213z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#20536D",cx:"217.346",cy:"372.28",rx:"14.607",ry:"14.607"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#668A9E",d:"M222.243,358.542c-1.254-0.447-2.526-0.695-3.792-0.792c-2.628,1.445-4.763,3.808-5.849,6.855 c-2.356,6.611,1.092,13.879,7.703,16.235c3.046,1.086,6.228,0.926,9.009-0.195c0.725-1.042,1.338-2.185,1.785-3.438 C233.806,369.607,229.843,361.251,222.243,358.542z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#7A97A0",cx:"226.554",cy:"367.897",r:"2.852"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_22_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#668A9E",d:"M201.028,392.004l-16.62-0.009c0.115-0.24,0.23-0.479,0.351-0.717c1.314-2.589,2.912-5.084,4.734-7.44 l0.041,0.029C193.845,384.392,198.68,388.087,201.028,392.004z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A3849",d:"M193.278,379.914c5.322,2.141,8.897,5.453,10.9,10.133c-0.649,0.64-1.257,1.288-1.811,1.954l-1.338,0.003 c-2.348-3.916-7.183-7.611-11.493-8.136l-0.041-0.029c1.121-1.425,2.322-2.806,3.588-4.12L193.278,379.914z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#1A3849",d:"M209.722,376.603c2.186,4.228,1.934,7.897,1.934,7.897c-0.93,0.518-1.811,1.061-2.645,1.62 c-0.189-3.944-4.268-11.646-8.156-12.921c1.094-0.747,2.217-1.433,3.361-2.074C204.216,371.126,207.537,372.376,209.722,376.603z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#668A9E",d:"M209.011,386.12c-0.002,0.007-0.002,0.007-0.002,0.007c-1.832,1.223-3.43,2.536-4.831,3.92 c-2.002-4.679-5.578-7.992-10.9-10.133l-0.196-0.195c2.367-2.435,4.985-4.641,7.774-6.519 C204.743,374.474,208.822,382.176,209.011,386.12z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#A834F4",cx:"76.029",cy:"305.974",rx:"46.268",ry:"23.641"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#A834F4",points:"67.96,326.476 69.028,340.5 56.073,325.274       "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"31.722",y:"373.532",fill:"#1A3849",width:"140.556",height:"18.357"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"35.54",y:"362.107",fill:"#20536D",width:"132.919",height:"29.782"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"40.035",y:"348.006",fill:"#668A9E",width:"123.93",height:"43.883"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#297691",d:"M114.592,367.889c-0.22,0.624-0.416,1.262-0.556,1.927c-1.699,8.108,3.496,16.059,11.605,17.758 c8.108,1.699,16.059-3.496,17.758-11.605c0.139-0.665,0.216-1.328,0.265-1.988L114.592,367.889z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M118.333,368.673c-0.164,0.463-0.309,0.937-0.413,1.431c-1.262,6.022,2.597,11.926,8.618,13.188 c6.022,1.262,11.926-2.597,13.188-8.618c0.104-0.494,0.16-0.986,0.197-1.476L118.333,368.673z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#297691",d:"M89.408,367.889c0.22,0.624,0.416,1.262,0.556,1.927c1.699,8.108-3.496,16.059-11.605,17.758 c-8.108,1.699-16.059-3.496-17.758-11.605c-0.139-0.665-0.216-1.328-0.265-1.988L89.408,367.889z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M85.667,368.673c0.164,0.463,0.309,0.937,0.413,1.431c1.262,6.022-2.597,11.926-8.618,13.188 c-6.022,1.262-11.926-2.597-13.188-8.618c-0.104-0.494-0.16-0.986-0.197-1.476L85.667,368.673z"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"42.702",y:"293.507",fill:"none",width:"67.478",height:"36.368"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"missyou"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M54.375,303.844c0,0.955-0.789,1.515-2.272,1.515h-2.982v-5.522h2.824c1.452,0,2.162,0.591,2.162,1.443 c0,0.529-0.269,0.955-0.742,1.199C53.988,302.7,54.375,303.173,54.375,303.844z M50.667,300.964v1.065h1.073 c0.521,0,0.789-0.182,0.789-0.537c0-0.347-0.268-0.528-0.789-0.528H50.667z M52.797,303.67c0-0.379-0.284-0.561-0.821-0.561 h-1.309v1.121h1.309C52.513,304.23,52.797,304.049,52.797,303.67z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M54.902,302.597c0-1.656,1.302-2.872,3.069-2.872s3.069,1.215,3.069,2.872 c0,1.657-1.302,2.872-3.069,2.872S54.902,304.254,54.902,302.597z M59.462,302.597c0-0.955-0.655-1.578-1.491-1.578 c-0.836,0-1.491,0.623-1.491,1.578s0.655,1.578,1.491,1.578C58.807,304.175,59.462,303.552,59.462,302.597z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M65.148,305.358l-1.144-1.712l-1.128,1.712h-1.783l2.012-2.792l-1.925-2.729h1.759l1.104,1.593 l1.089-1.593h1.688l-1.925,2.666l2.051,2.856H65.148z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M70.921,305.358l-1.144-1.712l-1.128,1.712h-1.783l2.012-2.792l-1.925-2.729h1.759l1.104,1.593 l1.089-1.593h1.688l-1.925,2.666l2.051,2.856H70.921z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M73.082,299.836h1.562v5.522h-1.562V299.836z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M80.189,304.151v1.207h-4.434v-5.522h4.331v1.207h-2.785v0.931h2.453v1.167h-2.453v1.01H80.189z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M92.012,299.836l-1.791,5.522h-1.672l-1.057-3.361l-1.104,3.361h-1.672l-1.791-5.522h1.609l1.112,3.526 l1.168-3.526h1.436l1.112,3.558l1.16-3.558H92.012z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M92.57,299.836h1.562v5.522H92.57V299.836z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M95.244,299.836h1.562v4.283h2.635v1.239h-4.197V299.836z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M100.055,299.836h1.562v4.283h2.635v1.239h-4.197V299.836z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M60.488,314.823l-0.016-2.927l-1.42,2.382h-0.694l-1.412-2.303v2.848h-1.444v-5.522h1.286l1.941,3.187 l1.893-3.187h1.286l0.016,5.522H60.488z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M63.026,309.301h1.562v5.522h-1.562V309.301z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M65.313,314.326l0.513-1.152c0.489,0.324,1.184,0.544,1.823,0.544c0.646,0,0.899-0.181,0.899-0.45 c0-0.875-3.14-0.236-3.14-2.288c0-0.986,0.805-1.791,2.446-1.791c0.718,0,1.459,0.166,2.003,0.481l-0.481,1.16 c-0.529-0.284-1.049-0.426-1.531-0.426c-0.655,0-0.891,0.221-0.891,0.497c0,0.844,3.132,0.213,3.132,2.249 c0,0.962-0.805,1.783-2.446,1.783C66.733,314.933,65.834,314.688,65.313,314.326z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M70.416,314.326l0.513-1.152c0.489,0.324,1.184,0.544,1.823,0.544c0.646,0,0.899-0.181,0.899-0.45 c0-0.875-3.14-0.236-3.14-2.288c0-0.986,0.805-1.791,2.446-1.791c0.718,0,1.459,0.166,2.003,0.481l-0.481,1.16 c-0.529-0.284-1.049-0.426-1.531-0.426c-0.655,0-0.891,0.221-0.891,0.497c0,0.844,3.132,0.213,3.132,2.249 c0,0.962-0.805,1.783-2.446,1.783C71.836,314.933,70.937,314.688,70.416,314.326z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M81.159,312.843v1.98h-1.562v-2.004l-2.106-3.518h1.649l1.309,2.193l1.31-2.193h1.515L81.159,312.843z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M83.146,312.062c0-1.657,1.302-2.872,3.069-2.872s3.069,1.215,3.069,2.872s-1.302,2.872-3.069,2.872 S83.146,313.718,83.146,312.062z M87.706,312.062c0-0.955-0.655-1.578-1.491-1.578c-0.836,0-1.491,0.623-1.491,1.578 s0.655,1.578,1.491,1.578C87.051,313.64,87.706,313.016,87.706,312.062z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M90.055,312.361v-3.061h1.562v3.013c0,0.947,0.395,1.326,1.049,1.326c0.647,0,1.041-0.379,1.041-1.326 v-3.013h1.539v3.061c0,1.649-0.962,2.572-2.596,2.572C91.017,314.933,90.055,314.01,90.055,312.361z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M95.915,314.002c0-0.537,0.395-0.884,0.899-0.884c0.513,0,0.899,0.347,0.899,0.884 c0,0.521-0.387,0.891-0.899,0.891C96.31,314.894,95.915,314.523,95.915,314.002z"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"29",y:"65.333",fill:"none",width:"626.167",height:"204.667"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"okayareyou"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M29.87,77.094c0-6.36,5.01-10.979,11.849-10.979c6.84,0,11.85,4.62,11.85,10.979s-5.01,10.979-11.85,10.979 C34.88,88.073,29.87,83.454,29.87,77.094z M46.429,77.094c0-3.27-2.1-5.25-4.71-5.25c-2.61,0-4.709,1.98-4.709,5.25 s2.1,5.25,4.709,5.25C44.33,82.343,46.429,80.364,46.429,77.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M64.7,80.633l-1.59,1.77v5.19H56.15V66.594h6.959v7.62l6.9-7.62h7.71l-8.4,9.239l8.82,11.76h-8.19 L64.7,80.633z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M92.36,83.934h-7.98l-1.41,3.66h-7.2l9.18-20.999h6.959l9.18,20.999h-7.32L92.36,83.934z M90.41,78.833 l-2.04-5.28l-2.04,5.28H90.41z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M113.36,79.974v7.62h-7.08v-7.709l-7.92-13.29h7.47l4.29,7.26l4.32-7.26h6.839L113.36,79.974z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M119.871,83.994c0-2.31,1.71-3.84,3.96-3.84c2.25,0,3.959,1.53,3.959,3.84c0,2.28-1.71,3.899-3.959,3.899 C121.581,87.893,119.871,86.273,119.871,83.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M153.409,83.934h-7.98l-1.41,3.66h-7.2L146,66.594h6.959l9.18,20.999h-7.32L153.409,83.934z M151.459,78.833l-2.04-5.28l-2.04,5.28H151.459z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M172.279,82.313h-1.92v5.28h-7.08V66.594h10.109c5.85,0,9.57,3.06,9.57,7.919c0,3.03-1.44,5.31-3.96,6.6 l4.41,6.479h-7.56L172.279,82.313z M172.939,72.054h-2.58v4.92h2.58c1.95,0,2.88-0.93,2.88-2.46 C175.819,72.984,174.889,72.054,172.939,72.054z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M203.089,82.253v5.34h-17.459V66.594h17.069v5.34h-10.11v2.46h8.88v5.1h-8.88v2.76H203.089z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M227.298,79.974v7.62h-7.08v-7.709l-7.92-13.29h7.47l4.29,7.26l4.32-7.26h6.839L227.298,79.974z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M234.378,77.094c0-6.36,5.01-10.979,11.85-10.979c6.839,0,11.849,4.62,11.849,10.979 s-5.01,10.979-11.849,10.979C239.388,88.073,234.378,83.454,234.378,77.094z M250.938,77.094c0-3.27-2.1-5.25-4.709-5.25 c-2.61,0-4.71,1.98-4.71,5.25s2.1,5.25,4.71,5.25C248.838,82.343,250.938,80.364,250.938,77.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M260.478,78.144V66.594h7.08v11.339c0,3.21,1.229,4.41,3.209,4.41s3.21-1.2,3.21-4.41V66.594h6.96v11.549 c0,6.3-3.78,9.93-10.23,9.93C264.258,88.073,260.478,84.443,260.478,78.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M292.338,77.094c0-6.45,4.95-10.979,11.699-10.979c4.11,0,7.35,1.5,9.42,4.2l-4.47,3.99 c-1.229-1.56-2.7-2.46-4.589-2.46c-2.94,0-4.92,2.04-4.92,5.25s1.98,5.25,4.92,5.25c1.89,0,3.36-0.9,4.589-2.459l4.47,3.99 c-2.07,2.7-5.31,4.2-9.42,4.2C297.288,88.073,292.338,83.543,292.338,77.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M314.208,77.094c0-6.36,5.01-10.979,11.849-10.979c6.84,0,11.85,4.62,11.85,10.979 s-5.01,10.979-11.85,10.979C319.218,88.073,314.208,83.454,314.208,77.094z M330.767,77.094c0-3.27-2.1-5.25-4.71-5.25 c-2.61,0-4.709,1.98-4.709,5.25s2.1,5.25,4.709,5.25C328.667,82.343,330.767,80.364,330.767,77.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M359.237,87.593l-0.06-9.57l-4.56,7.68h-3.12l-4.56-7.35v9.24h-6.45V66.594h5.82l6.84,11.189l6.66-11.189 h5.82l0.06,20.999H359.237z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M388.787,74.514c0,4.86-3.72,7.92-9.57,7.92h-3.03v5.16h-7.08V66.594h10.109 C385.067,66.594,388.787,69.654,388.787,74.514z M381.647,74.514c0-1.53-0.93-2.46-2.88-2.46h-2.58v4.92h2.58 C380.717,76.974,381.647,76.044,381.647,74.514z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M391.098,66.594h7.08v15.509h9.479v5.49h-16.559V66.594z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M427.067,82.253v5.34h-17.459V66.594h17.069v5.34h-10.11v2.46h8.88v5.1h-8.88v2.76H427.067z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M434.356,72.084h-6.149v-5.49h19.379v5.49h-6.149v15.509h-7.08V72.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M466.876,82.253v5.34h-17.459V66.594h17.069v5.34h-10.11v2.46h8.88v5.1h-8.88v2.76H466.876z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M469.606,66.594h7.08v15.509h9.479v5.49h-16.559V66.594z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M498.495,79.974v7.62h-7.08v-7.709l-7.92-13.29h7.47l4.29,7.26l4.32-7.26h6.839L498.495,79.974z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M514.995,85.914l2.28-5.16c1.98,1.17,4.62,1.92,6.93,1.92c2.01,0,2.73-0.42,2.73-1.14 c0-2.64-11.61-0.51-11.61-8.34c0-3.9,3.27-7.08,9.78-7.08c2.82,0,5.73,0.6,7.92,1.83l-2.13,5.13c-2.07-1.05-4.02-1.56-5.85-1.56 c-2.07,0-2.73,0.6-2.73,1.32c0,2.52,11.61,0.42,11.61,8.16c0,3.84-3.27,7.08-9.78,7.08 C520.635,88.073,517.095,87.203,514.995,85.914z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M535.845,78.144V66.594h7.08v11.339c0,3.21,1.23,4.41,3.209,4.41c1.98,0,3.21-1.2,3.21-4.41V66.594h6.96 v11.549c0,6.3-3.78,9.93-10.229,9.93C539.625,88.073,535.845,84.443,535.845,78.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M568.544,82.313h-1.92v5.28h-7.08V66.594h10.109c5.85,0,9.57,3.06,9.57,7.919c0,3.03-1.44,5.31-3.96,6.6 l4.41,6.479h-7.56L568.544,82.313z M569.205,72.054h-2.58v4.92h2.58c1.95,0,2.88-0.93,2.88-2.46 C572.084,72.984,571.154,72.054,569.205,72.054z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M599.354,82.253v5.34h-17.459V66.594h17.069v5.34h-10.11v2.46h8.88v5.1h-8.88v2.76H599.354z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M43.189,119.974v7.62h-7.08v-7.709l-7.92-13.29h7.47l4.29,7.26l4.32-7.26h6.839L43.189,119.974z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M50.27,117.094c0-6.36,5.01-10.979,11.85-10.979c6.839,0,11.849,4.62,11.849,10.979 s-5.01,10.979-11.849,10.979C55.28,128.073,50.27,123.454,50.27,117.094z M66.829,117.094c0-3.27-2.1-5.25-4.709-5.25 c-2.61,0-4.71,1.98-4.71,5.25s2.1,5.25,4.71,5.25C64.729,122.343,66.829,120.364,66.829,117.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M76.37,118.144v-11.549h7.08v11.339c0,3.21,1.229,4.41,3.209,4.41s3.21-1.2,3.21-4.41v-11.339h6.96v11.549 c0,6.3-3.78,9.93-10.23,9.93C80.149,128.073,76.37,124.443,76.37,118.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M143.238,106.594l-6.72,20.999h-7.589l-3.39-11.22l-3.57,11.22h-7.59l-6.72-20.999h7.29l3.66,11.939 l3.87-11.939h6.509l3.66,12.089l3.87-12.089H143.238z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M158.359,123.934h-7.98l-1.41,3.66h-7.2l9.18-20.999h6.959l9.18,20.999h-7.32L158.359,123.934z M156.409,118.833l-2.04-5.28l-2.04,5.28H156.409z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M188.929,106.594v20.999h-5.82l-7.979-9.54v9.54h-6.9v-20.999h5.82l7.979,9.54v-9.54H188.929z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M196.909,112.084h-6.149v-5.49h19.379v5.49h-6.149v15.509h-7.08V112.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M225.528,112.084h-6.149v-5.49h19.379v5.49h-6.149v15.509h-7.08V112.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M239.448,117.094c0-6.36,5.01-10.979,11.849-10.979c6.84,0,11.85,4.62,11.85,10.979 s-5.01,10.979-11.85,10.979C244.458,128.073,239.448,123.454,239.448,117.094z M256.007,117.094c0-3.27-2.1-5.25-4.71-5.25 c-2.61,0-4.709,1.98-4.709,5.25s2.1,5.25,4.709,5.25C253.908,122.343,256.007,120.364,256.007,117.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0DB5FF",d:"M274.547,118.144v-11.549h7.08v11.339c0,3.21,1.229,4.41,3.209,4.41s3.21-1.2,3.21-4.41v-11.339h6.96 v11.549c0,6.3-3.78,9.93-10.23,9.93C278.327,128.073,274.547,124.443,274.547,118.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0DB5FF",d:"M318.947,106.594v20.999h-5.82l-7.979-9.54v9.54h-6.9v-20.999h5.82l7.979,9.54v-9.54H318.947z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0DB5FF",d:"M321.047,125.914l2.28-5.16c1.98,1.17,4.62,1.92,6.93,1.92c2.01,0,2.73-0.42,2.73-1.14 c0-2.64-11.609-0.51-11.609-8.34c0-3.9,3.27-7.08,9.779-7.08c2.82,0,5.73,0.6,7.92,1.83l-2.13,5.13c-2.07-1.05-4.02-1.56-5.85-1.56 c-2.07,0-2.73,0.6-2.73,1.32c0,2.52,11.61,0.42,11.61,8.16c0,3.84-3.27,7.08-9.78,7.08 C326.687,128.073,323.147,127.203,321.047,125.914z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0DB5FF",d:"M341.897,118.144v-11.549h7.08v11.339c0,3.21,1.229,4.41,3.209,4.41s3.21-1.2,3.21-4.41v-11.339h6.96 v11.549c0,6.3-3.78,9.93-10.23,9.93C345.677,128.073,341.897,124.443,341.897,118.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0DB5FF",d:"M386.296,121.804c0,3.66-3.09,5.79-8.88,5.79h-11.819v-20.999h11.22c5.79,0,8.489,2.31,8.489,5.49 c0,1.95-0.99,3.57-2.91,4.53C384.856,117.514,386.296,119.313,386.296,121.804z M372.557,111.544v3.12h3.3 c1.59,0,2.31-0.54,2.31-1.56s-0.72-1.56-2.31-1.56H372.557z M379.157,120.994c0-1.08-0.78-1.65-2.34-1.65h-4.26v3.3h4.26 C378.376,122.644,379.157,122.074,379.157,120.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0DB5FF",d:"M387.467,125.914l2.28-5.16c1.98,1.17,4.62,1.92,6.93,1.92c2.01,0,2.73-0.42,2.73-1.14 c0-2.64-11.609-0.51-11.609-8.34c0-3.9,3.27-7.08,9.779-7.08c2.82,0,5.73,0.6,7.92,1.83l-2.13,5.13c-2.07-1.05-4.02-1.56-5.85-1.56 c-2.07,0-2.73,0.6-2.73,1.32c0,2.52,11.61,0.42,11.61,8.16c0,3.84-3.27,7.08-9.78,7.08 C393.107,128.073,389.567,127.203,387.467,125.914z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0DB5FF",d:"M407.657,117.094c0-6.45,4.95-10.979,11.699-10.979c4.11,0,7.35,1.5,9.42,4.2l-4.47,3.99 c-1.229-1.56-2.7-2.46-4.589-2.46c-2.94,0-4.92,2.04-4.92,5.25s1.98,5.25,4.92,5.25c1.89,0,3.36-0.9,4.589-2.459l4.47,3.99 c-2.07,2.7-5.31,4.2-9.42,4.2C412.607,128.073,407.657,123.543,407.657,117.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0DB5FF",d:"M439.816,122.313h-1.92v5.28h-7.08v-20.999h10.109c5.85,0,9.57,3.06,9.57,7.919c0,3.03-1.44,5.31-3.96,6.6 l4.41,6.479h-7.56L439.816,122.313z M440.477,112.054h-2.58v4.92h2.58c1.95,0,2.88-0.93,2.88-2.46 C443.356,112.984,442.426,112.054,440.477,112.054z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0DB5FF",d:"M453.167,106.594h7.08v20.999h-7.08V106.594z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0DB5FF",d:"M484.365,121.804c0,3.66-3.09,5.79-8.88,5.79h-11.819v-20.999h11.22c5.79,0,8.489,2.31,8.489,5.49 c0,1.95-0.99,3.57-2.91,4.53C482.925,117.514,484.365,119.313,484.365,121.804z M470.625,111.544v3.12h3.3 c1.59,0,2.31-0.54,2.31-1.56s-0.72-1.56-2.31-1.56H470.625z M477.226,120.994c0-1.08-0.78-1.65-2.34-1.65h-4.26v3.3h4.26 C476.445,122.644,477.226,122.074,477.226,120.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0DB5FF",d:"M504.315,122.253v5.34h-17.459v-20.999h17.069v5.34h-10.11v2.46h8.88v5.1h-8.88v2.76H504.315z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M523.125,111.934v3.6h8.76v5.34h-8.76v6.72h-7.08v-20.999h17.069v5.34H523.125z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M544.364,122.313h-1.92v5.28h-7.08v-20.999h10.109c5.85,0,9.57,3.06,9.57,7.919c0,3.03-1.44,5.31-3.96,6.6 l4.41,6.479h-7.56L544.364,122.313z M545.024,112.054h-2.58v4.92h2.58c1.95,0,2.88-0.93,2.88-2.46 C547.904,112.984,546.974,112.054,545.024,112.054z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M556.875,117.094c0-6.36,5.01-10.979,11.85-10.979c6.839,0,11.849,4.62,11.849,10.979 s-5.01,10.979-11.849,10.979C561.884,128.073,556.875,123.454,556.875,117.094z M573.434,117.094c0-3.27-2.1-5.25-4.709-5.25 c-2.61,0-4.71,1.98-4.71,5.25s2.1,5.25,4.71,5.25C571.334,122.343,573.434,120.364,573.434,117.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M601.903,127.593l-0.06-9.57l-4.56,7.68h-3.12l-4.56-7.35v9.24h-6.45v-20.999h5.82l6.84,11.189l6.66-11.189 h5.82l0.06,20.999H601.903z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"underline",fill:"#0DB5FF",d:"M273.018,131.343v-1.5h232.318v1.5H273.018z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M43.189,159.974v7.62h-7.08v-7.709l-7.92-13.29h7.47l4.29,7.26l4.32-7.26h6.839L43.189,159.974z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M50.27,157.094c0-6.36,5.01-10.979,11.85-10.979c6.839,0,11.849,4.62,11.849,10.979 s-5.01,10.979-11.849,10.979C55.28,168.073,50.27,163.454,50.27,157.094z M66.829,157.094c0-3.27-2.1-5.25-4.709-5.25 c-2.61,0-4.71,1.98-4.71,5.25s2.1,5.25,4.71,5.25C64.729,162.343,66.829,160.364,66.829,157.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M76.37,158.144v-11.549h7.08v11.339c0,3.21,1.229,4.41,3.209,4.41s3.21-1.2,3.21-4.41v-11.339h6.96v11.549 c0,6.3-3.78,9.93-10.23,9.93C80.149,168.073,76.37,164.443,76.37,158.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M109.069,162.313h-1.92v5.28h-7.08v-20.999h10.109c5.85,0,9.57,3.06,9.57,7.919c0,3.03-1.44,5.31-3.96,6.6 l4.41,6.479h-7.56L109.069,162.313z M109.729,152.054h-2.58v4.92h2.58c1.95,0,2.88-0.93,2.88-2.46 C112.609,152.984,111.679,152.054,109.729,152.054z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M130.1,165.914l2.28-5.16c1.98,1.17,4.62,1.92,6.93,1.92c2.01,0,2.73-0.42,2.73-1.14 c0-2.64-11.61-0.51-11.61-8.34c0-3.9,3.27-7.08,9.78-7.08c2.82,0,5.73,0.6,7.92,1.83l-2.13,5.13c-2.07-1.05-4.02-1.56-5.85-1.56 c-2.07,0-2.73,0.6-2.73,1.32c0,2.52,11.61,0.42,11.61,8.16c0,3.84-3.27,7.08-9.78,7.08 C135.739,168.073,132.199,167.203,130.1,165.914z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M150.949,158.144v-11.549h7.08v11.339c0,3.21,1.23,4.41,3.209,4.41c1.98,0,3.21-1.2,3.21-4.41v-11.339h6.96 v11.549c0,6.3-3.78,9.93-10.229,9.93C154.729,168.073,150.949,164.443,150.949,158.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M195.349,161.804c0,3.66-3.09,5.79-8.88,5.79h-11.819v-20.999h11.22c5.79,0,8.489,2.31,8.489,5.49 c0,1.95-0.99,3.57-2.91,4.53C193.909,157.514,195.349,159.313,195.349,161.804z M181.609,151.544v3.12h3.3 c1.59,0,2.31-0.54,2.31-1.56s-0.72-1.56-2.31-1.56H181.609z M188.209,160.994c0-1.08-0.78-1.65-2.34-1.65h-4.26v3.3h4.26 C187.429,162.644,188.209,162.074,188.209,160.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M196.52,165.914l2.28-5.16c1.98,1.17,4.62,1.92,6.93,1.92c2.01,0,2.73-0.42,2.73-1.14 c0-2.64-11.61-0.51-11.61-8.34c0-3.9,3.27-7.08,9.78-7.08c2.82,0,5.73,0.6,7.92,1.83l-2.13,5.13c-2.07-1.05-4.02-1.56-5.85-1.56 c-2.07,0-2.73,0.6-2.73,1.32c0,2.52,11.61,0.42,11.61,8.16c0,3.84-3.27,7.08-9.78,7.08 C202.159,168.073,198.619,167.203,196.52,165.914z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M216.709,157.094c0-6.45,4.95-10.979,11.699-10.979c4.11,0,7.35,1.5,9.42,4.2l-4.47,3.99 c-1.23-1.56-2.7-2.46-4.59-2.46c-2.94,0-4.92,2.04-4.92,5.25s1.98,5.25,4.92,5.25c1.89,0,3.36-0.9,4.59-2.459l4.47,3.99 c-2.07,2.7-5.31,4.2-9.42,4.2C221.659,168.073,216.709,163.543,216.709,157.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M248.869,162.313h-1.92v5.28h-7.08v-20.999h10.109c5.85,0,9.57,3.06,9.57,7.919c0,3.03-1.44,5.31-3.96,6.6 l4.41,6.479h-7.56L248.869,162.313z M249.529,152.054h-2.58v4.92h2.58c1.95,0,2.88-0.93,2.88-2.46 C252.409,152.984,251.479,152.054,249.529,152.054z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M262.219,146.594h7.08v20.999h-7.08V146.594z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M292.397,154.514c0,4.86-3.72,7.92-9.57,7.92h-3.03v5.16h-7.08v-20.999h10.109 C288.678,146.594,292.397,149.654,292.397,154.514z M285.258,154.514c0-1.53-0.93-2.46-2.88-2.46h-2.58v4.92h2.58 C284.328,156.974,285.258,156.044,285.258,154.514z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M298.818,152.084h-6.149v-5.49h19.379v5.49h-6.149v15.509h-7.08V152.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M313.878,146.594h7.08v20.999h-7.08V146.594z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M323.538,157.094c0-6.36,5.01-10.979,11.85-10.979c6.839,0,11.849,4.62,11.849,10.979 s-5.01,10.979-11.849,10.979C328.547,168.073,323.538,163.454,323.538,157.094z M340.097,157.094c0-3.27-2.1-5.25-4.709-5.25 c-2.61,0-4.71,1.98-4.71,5.25s2.1,5.25,4.71,5.25C337.997,162.343,340.097,160.364,340.097,157.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M370.517,146.594v20.999h-5.82l-7.979-9.54v9.54h-6.9v-20.999h5.82l7.979,9.54v-9.54H370.517z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M387.496,152.084h-6.149v-5.49h19.379v5.49h-6.149v15.509h-7.08V152.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M401.417,157.094c0-6.36,5.01-10.979,11.85-10.979c6.839,0,11.849,4.62,11.849,10.979 s-5.01,10.979-11.849,10.979C406.426,168.073,401.417,163.454,401.417,157.094z M417.976,157.094c0-3.27-2.1-5.25-4.709-5.25 c-2.61,0-4.71,1.98-4.71,5.25s2.1,5.25,4.71,5.25C415.876,162.343,417.976,160.364,417.976,157.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M435.376,165.914l2.28-5.16c1.98,1.17,4.62,1.92,6.93,1.92c2.01,0,2.73-0.42,2.73-1.14 c0-2.64-11.61-0.51-11.61-8.34c0-3.9,3.27-7.08,9.78-7.08c2.82,0,5.73,0.6,7.92,1.83l-2.13,5.13c-2.07-1.05-4.02-1.56-5.85-1.56 c-2.07,0-2.73,0.6-2.73,1.32c0,2.52,11.61,0.42,11.61,8.16c0,3.84-3.27,7.08-9.78,7.08 C441.016,168.073,437.476,167.203,435.376,165.914z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M460.666,152.084h-6.149v-5.49h19.379v5.49h-6.149v15.509h-7.08V152.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M475.246,158.144v-11.549h7.08v11.339c0,3.21,1.229,4.41,3.209,4.41s3.21-1.2,3.21-4.41v-11.339h6.96 v11.549c0,6.3-3.78,9.93-10.23,9.93C479.025,168.073,475.246,164.443,475.246,158.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M506.025,151.934v3.6h8.76v5.34h-8.76v6.72h-7.08v-20.999h17.069v5.34H506.025z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M525.345,151.934v3.6h8.76v5.34h-8.76v6.72h-7.08v-20.999h17.069v5.34H525.345z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M546.585,146.594h7.08v20.999h-7.08V146.594z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M577.784,146.594v20.999h-5.82l-7.979-9.54v9.54h-6.9v-20.999h5.82l7.979,9.54v-9.54H577.784z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M604.513,163.934h-7.98l-1.41,3.66h-7.2l9.18-20.999h6.959l9.18,20.999h-7.32L604.513,163.934z M602.563,158.833l-2.04-5.28l-2.04,5.28H602.563z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M51.409,201.804c0,3.66-3.09,5.79-8.88,5.79H30.71v-20.999h11.22c5.79,0,8.489,2.31,8.489,5.49 c0,1.95-0.99,3.57-2.91,4.53C49.969,197.514,51.409,199.313,51.409,201.804z M37.669,191.544v3.12h3.3c1.59,0,2.31-0.54,2.31-1.56 s-0.72-1.56-2.31-1.56H37.669z M44.27,200.994c0-1.08-0.78-1.65-2.34-1.65h-4.26v3.3h4.26 C43.489,202.644,44.27,202.074,44.27,200.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M53.06,197.094c0-6.36,5.01-10.979,11.85-10.979c6.839,0,11.849,4.62,11.849,10.979 s-5.01,10.979-11.849,10.979C58.07,208.073,53.06,203.454,53.06,197.094z M69.619,197.094c0-3.27-2.1-5.25-4.709-5.25 c-2.61,0-4.71,1.98-4.71,5.25s2.1,5.25,4.71,5.25C67.52,202.343,69.619,200.364,69.619,197.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M91.879,207.593l-3.63-5.61l-3.54,5.61H76.64l7.589-10.589l-7.32-10.41h7.95l3.57,5.28l3.48-5.28h7.62 l-7.29,10.14l7.74,10.859H91.879z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M124.759,203.934h-7.98l-1.41,3.66h-7.2l9.18-20.999h6.959l9.18,20.999h-7.32L124.759,203.934z M122.809,198.833l-2.04-5.28l-2.04,5.28H122.809z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M155.329,186.594v20.999h-5.82l-7.979-9.54v9.54h-6.9v-20.999h5.82l7.979,9.54v-9.54H155.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M158.749,186.594h10.35c7.02,0,11.85,3.99,11.85,10.5s-4.83,10.5-11.85,10.5h-10.35V186.594z M168.798,202.074c2.97,0,5.01-1.77,5.01-4.98s-2.04-4.98-5.01-4.98h-2.97v9.96H168.798z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M213.228,186.594v20.999h-5.82l-7.979-9.54v9.54h-6.9v-20.999h5.82l7.979,9.54v-9.54H213.228z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M215.808,197.094c0-6.36,5.01-10.979,11.85-10.979c6.839,0,11.849,4.62,11.849,10.979 s-5.01,10.979-11.849,10.979C220.818,208.073,215.808,203.454,215.808,197.094z M232.367,197.094c0-3.27-2.1-5.25-4.709-5.25 c-2.61,0-4.71,1.98-4.71,5.25s2.1,5.25,4.71,5.25C230.268,202.343,232.367,200.364,232.367,197.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M246.348,192.084h-6.149v-5.49h19.379v5.49h-6.149v15.509h-7.08V192.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M269.567,197.094c0-6.45,4.95-10.979,11.699-10.979c4.11,0,7.35,1.5,9.42,4.2l-4.47,3.99 c-1.229-1.56-2.7-2.46-4.589-2.46c-2.94,0-4.92,2.04-4.92,5.25s1.98,5.25,4.92,5.25c1.89,0,3.36-0.9,4.589-2.459l4.47,3.99 c-2.07,2.7-5.31,4.2-9.42,4.2C274.517,208.073,269.567,203.543,269.567,197.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M291.438,197.094c0-6.36,5.01-10.979,11.849-10.979c6.84,0,11.85,4.62,11.85,10.979 s-5.01,10.979-11.85,10.979C296.447,208.073,291.438,203.454,291.438,197.094z M307.997,197.094c0-3.27-2.1-5.25-4.71-5.25 c-2.61,0-4.709,1.98-4.709,5.25s2.1,5.25,4.709,5.25C305.897,202.343,307.997,200.364,307.997,197.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M338.417,186.594v20.999h-5.82l-7.979-9.54v9.54h-6.9v-20.999h5.82l7.979,9.54v-9.54H338.417z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M346.396,192.084h-6.149v-5.49h19.379v5.49h-6.149v15.509h-7.08V192.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M361.457,186.594h7.08v20.999h-7.08V186.594z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M392.655,186.594v20.999h-5.82l-7.979-9.54v9.54h-6.9v-20.999h5.82l7.979,9.54v-9.54H392.655z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M395.896,198.144v-11.549h7.08v11.339c0,3.21,1.23,4.41,3.209,4.41c1.98,0,3.21-1.2,3.21-4.41v-11.339h6.96 v11.549c0,6.3-3.78,9.93-10.229,9.93C399.675,208.073,395.896,204.443,395.896,198.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M437.055,202.253v5.34h-17.459v-20.999h17.069v5.34h-10.11v2.46h8.88v5.1h-8.88v2.76H437.055z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M453.344,192.084h-6.149v-5.49h19.379v5.49h-6.149v15.509h-7.08V192.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M467.265,197.094c0-6.36,5.01-10.979,11.849-10.979c6.84,0,11.85,4.62,11.85,10.979 s-5.01,10.979-11.85,10.979C472.274,208.073,467.265,203.454,467.265,197.094z M483.824,197.094c0-3.27-2.1-5.25-4.71-5.25 c-2.61,0-4.709,1.98-4.709,5.25s2.1,5.25,4.709,5.25C481.724,202.343,483.824,200.364,483.824,197.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M511.543,202.313h-1.92v5.28h-7.08v-20.999h10.109c5.85,0,9.57,3.06,9.57,7.919c0,3.03-1.44,5.31-3.96,6.6 l4.41,6.479h-7.56L511.543,202.313z M512.204,192.054h-2.58v4.92h2.58c1.95,0,2.88-0.93,2.88-2.46 C515.083,192.984,514.153,192.054,512.204,192.054z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M542.353,202.253v5.34h-17.459v-20.999h17.069v5.34h-10.11v2.46h8.88v5.1h-8.88v2.76H542.353z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M544.243,197.094c0-6.45,4.95-10.979,11.699-10.979c4.11,0,7.35,1.5,9.42,4.2l-4.47,3.99 c-1.229-1.56-2.7-2.46-4.589-2.46c-2.94,0-4.92,2.04-4.92,5.25s1.98,5.25,4.92,5.25c1.89,0,3.36-0.9,4.589-2.459l4.47,3.99 c-2.07,2.7-5.31,4.2-9.42,4.2C549.193,208.073,544.243,203.543,544.243,197.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M584.862,202.253v5.34h-17.459v-20.999h17.069v5.34h-10.11v2.46h8.88v5.1h-8.88v2.76H584.862z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M587.592,186.594h7.08v20.999h-7.08V186.594z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M620.531,186.594l-8.879,20.999h-6.96l-8.879-20.999h7.62l5.01,12.27l5.13-12.27H620.531z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M638.681,202.253v5.34h-17.459v-20.999h17.069v5.34h-10.11v2.46h8.88v5.1h-8.88v2.76H638.681z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M29.39,245.914l2.28-5.16c1.98,1.17,4.62,1.92,6.93,1.92c2.01,0,2.73-0.42,2.73-1.14 c0-2.64-11.609-0.51-11.609-8.34c0-3.9,3.27-7.08,9.779-7.08c2.82,0,5.73,0.6,7.92,1.83l-2.13,5.13c-2.07-1.05-4.02-1.56-5.85-1.56 c-2.07,0-2.73,0.6-2.73,1.32c0,2.52,11.61,0.42,11.61,8.16c0,3.84-3.27,7.08-9.78,7.08C35.03,248.073,31.49,247.203,29.39,245.914z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M54.68,232.084H48.53v-5.49h19.379v5.49H61.76v15.509h-7.08V232.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M69.26,238.144v-11.549h7.08v11.339c0,3.21,1.23,4.41,3.209,4.41c1.98,0,3.21-1.2,3.21-4.41v-11.339h6.96 v11.549c0,6.3-3.78,9.93-10.229,9.93C73.04,248.073,69.26,244.443,69.26,238.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M100.04,231.934v3.6h8.76v5.34h-8.76v6.72h-7.08v-20.999h17.069v5.34H100.04z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M119.359,231.934v3.6h8.76v5.34h-8.76v6.72h-7.08v-20.999h17.069v5.34H119.359z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M147.679,231.934v3.6h8.76v5.34h-8.76v6.72h-7.08v-20.999h17.069v5.34H147.679z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M168.918,242.313h-1.92v5.28h-7.08v-20.999h10.109c5.85,0,9.57,3.06,9.57,7.919c0,3.03-1.44,5.31-3.96,6.6 l4.41,6.479h-7.56L168.918,242.313z M169.579,232.054h-2.58v4.92h2.58c1.95,0,2.88-0.93,2.88-2.46 C172.458,232.984,171.528,232.054,169.579,232.054z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M181.429,237.094c0-6.36,5.01-10.979,11.85-10.979c6.839,0,11.849,4.62,11.849,10.979 s-5.01,10.979-11.849,10.979C186.439,248.073,181.429,243.454,181.429,237.094z M197.988,237.094c0-3.27-2.1-5.25-4.709-5.25 c-2.61,0-4.71,1.98-4.71,5.25s2.1,5.25,4.71,5.25C195.889,242.343,197.988,240.364,197.988,237.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M226.458,247.593l-0.06-9.57l-4.56,7.68h-3.12l-4.56-7.35v9.24h-6.45v-20.999h5.82l6.84,11.189l6.66-11.189 h5.82l0.06,20.999H226.458z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M244.008,245.914l2.28-5.16c1.98,1.17,4.62,1.92,6.93,1.92c2.01,0,2.73-0.42,2.73-1.14 c0-2.64-11.609-0.51-11.609-8.34c0-3.9,3.27-7.08,9.779-7.08c2.82,0,5.73,0.6,7.92,1.83l-2.13,5.13c-2.07-1.05-4.02-1.56-5.85-1.56 c-2.07,0-2.73,0.6-2.73,1.32c0,2.52,11.61,0.42,11.61,8.16c0,3.84-3.27,7.08-9.78,7.08 C249.648,248.073,246.108,247.203,244.008,245.914z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M269.298,232.084h-6.149v-5.49h19.379v5.49h-6.149v15.509h-7.08V232.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M283.878,238.144v-11.549h7.08v11.339c0,3.21,1.23,4.41,3.209,4.41c1.98,0,3.21-1.2,3.21-4.41v-11.339h6.96 v11.549c0,6.3-3.78,9.93-10.229,9.93C287.658,248.073,283.878,244.443,283.878,238.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M314.658,231.934v3.6h8.76v5.34h-8.76v6.72h-7.08v-20.999h17.069v5.34H314.658z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M333.978,231.934v3.6h8.76v5.34h-8.76v6.72h-7.08v-20.999h17.069v5.34H333.978z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M355.217,226.594h7.08v20.999h-7.08V226.594z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M386.416,226.594v20.999h-5.82l-7.979-9.54v9.54h-6.9v-20.999h5.82l7.979,9.54v-9.54H386.416z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M413.146,243.934h-7.98l-1.41,3.66h-7.2l9.18-20.999h6.959l9.18,20.999h-7.32L413.146,243.934z M411.195,238.833l-2.04-5.28l-2.04,5.28H411.195z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M452.715,241.804c0,3.66-3.09,5.79-8.88,5.79h-11.819v-20.999h11.22c5.79,0,8.489,2.31,8.489,5.49 c0,1.95-0.99,3.57-2.91,4.53C451.275,237.514,452.715,239.313,452.715,241.804z M438.975,231.544v3.12h3.3 c1.59,0,2.31-0.54,2.31-1.56s-0.72-1.56-2.31-1.56H438.975z M445.575,240.994c0-1.08-0.78-1.65-2.34-1.65h-4.26v3.3h4.26 C444.795,242.644,445.575,242.074,445.575,240.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M454.366,237.094c0-6.36,5.01-10.979,11.85-10.979c6.839,0,11.849,4.62,11.849,10.979 s-5.01,10.979-11.849,10.979C459.375,248.073,454.366,243.454,454.366,237.094z M470.925,237.094c0-3.27-2.1-5.25-4.709-5.25 c-2.61,0-4.71,1.98-4.71,5.25s2.1,5.25,4.71,5.25C468.825,242.343,470.925,240.364,470.925,237.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M493.185,247.593l-3.63-5.61l-3.54,5.61h-8.069l7.589-10.589l-7.32-10.41h7.95l3.57,5.28l3.48-5.28h7.62 l-7.29,10.14l7.74,10.859H493.185z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M510.225,233.014c0-0.93-0.9-1.41-2.01-1.41c-1.29,0-2.49,0.78-3.12,2.04l-5.34-2.67 c1.53-2.88,4.56-4.86,9.36-4.86c4.709,0,8.22,1.98,8.22,5.729c0,4.59-4.8,5.4-4.8,7.71h-6.18 C506.355,235.924,510.225,234.844,510.225,233.014z M505.485,244.293c0-2.01,1.62-3.54,3.96-3.54c2.34,0,3.959,1.53,3.959,3.54 c0,1.98-1.62,3.6-3.959,3.6C507.105,247.893,505.485,246.273,505.485,244.293z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"approve",enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M60.827,27.679h-5.33l-0.991,2.449H50.87l5.563-12.604h3.511l5.582,12.604h-3.709L60.827,27.679z M59.783,25.051l-1.621-4.033l-1.621,4.033H59.783z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M77.892,22.188c0,2.863-2.161,4.646-5.6,4.646h-2.197v3.295H66.53V17.525h5.762 C75.73,17.525,77.892,19.307,77.892,22.188z M74.29,22.188c0-1.17-0.738-1.854-2.215-1.854h-1.98v3.691h1.98 C73.552,24.025,74.29,23.34,74.29,22.188z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M90.978,22.188c0,2.863-2.161,4.646-5.6,4.646h-2.197v3.295h-3.564V17.525h5.762 C88.816,17.525,90.978,19.307,90.978,22.188z M87.376,22.188c0-1.17-0.738-1.854-2.215-1.854h-1.98v3.691h1.98 C86.638,24.025,87.376,23.34,87.376,22.188z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M98.212,26.78h-1.945v3.349h-3.564V17.525h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L98.212,26.78z M98.247,20.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C100.462,21.018,99.724,20.333,98.247,20.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M105.373,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554s-2.971,6.554-7.004,6.554 S105.373,27.608,105.373,23.827z M115.78,23.827c0-2.179-1.495-3.602-3.403-3.602s-3.403,1.423-3.403,3.602 s1.495,3.601,3.403,3.601S115.78,26.005,115.78,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M133.6,17.525l-5.401,12.604h-3.511l-5.384-12.604h3.854l3.421,8.21l3.493-8.21H133.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M144.454,27.374v2.755h-10.119V17.525h9.885v2.755h-6.356v2.124h5.6v2.665h-5.6v2.305H144.454z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M151.02,23.827c0-3.835,2.935-6.554,6.932-6.554c2.323,0,4.195,0.846,5.42,2.376l-2.269,2.053 c-0.792-0.954-1.765-1.477-2.971-1.477c-2.071,0-3.512,1.44-3.512,3.602c0,2.16,1.44,3.601,3.512,3.601 c1.206,0,2.179-0.521,2.971-1.477l2.269,2.053c-1.225,1.531-3.097,2.377-5.42,2.377C153.954,30.38,151.02,27.662,151.02,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M164.7,24.511v-6.986h3.565v6.878c0,2.16,0.899,3.024,2.395,3.024c1.477,0,2.377-0.864,2.377-3.024v-6.878 h3.511v6.986c0,3.763-2.197,5.869-5.924,5.869C166.896,30.38,164.7,28.274,164.7,24.511z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M178.073,28.994l1.171-2.628c1.116,0.737,2.7,1.242,4.159,1.242c1.477,0,2.053-0.414,2.053-1.026 c0-1.999-7.167-0.54-7.167-5.222c0-2.251,1.837-4.087,5.582-4.087c1.639,0,3.331,0.378,4.573,1.098l-1.098,2.647 c-1.207-0.648-2.396-0.973-3.493-0.973c-1.495,0-2.035,0.504-2.035,1.135c0,1.926,7.148,0.485,7.148,5.131 c0,2.197-1.837,4.069-5.582,4.069C181.314,30.38,179.262,29.823,178.073,28.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M193.104,20.351h-3.871v-2.826h11.289v2.826h-3.854v9.777h-3.564V20.351z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M201.022,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554s-2.971,6.554-7.004,6.554 S201.022,27.608,201.022,23.827z M211.43,23.827c0-2.179-1.495-3.602-3.403-3.602s-3.403,1.423-3.403,3.602 s1.495,3.601,3.403,3.601S211.43,26.005,211.43,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M228.277,30.128l-0.036-6.68l-3.24,5.438h-1.585l-3.223-5.258v6.5h-3.295V17.525h2.935l4.43,7.273 l4.321-7.273h2.935l0.036,12.604H228.277z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M244.188,27.374v2.755H234.07V17.525h9.885v2.755h-6.356v2.124h5.6v2.665h-5.6v2.305H244.188z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M251.675,26.78h-1.944v3.349h-3.564V17.525h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L251.675,26.78z M251.711,20.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C253.926,21.018,253.188,20.333,251.711,20.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M263.84,28.994l1.171-2.628c1.116,0.737,2.7,1.242,4.159,1.242c1.477,0,2.053-0.414,2.053-1.026 c0-1.999-7.167-0.54-7.167-5.222c0-2.251,1.837-4.087,5.582-4.087c1.639,0,3.331,0.378,4.573,1.098l-1.099,2.647 c-1.206-0.648-2.395-0.973-3.492-0.973c-1.495,0-2.035,0.504-2.035,1.135c0,1.926,7.148,0.485,7.148,5.131 c0,2.197-1.837,4.069-5.582,4.069C267.081,30.38,265.028,29.823,263.84,28.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M284.812,27.679h-5.33l-0.99,2.449h-3.637l5.563-12.604h3.511l5.582,12.604h-3.709L284.812,27.679z M283.768,25.051l-1.62-4.033l-1.62,4.033H283.768z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M292.568,20.351h-3.871v-2.826h11.289v2.826h-3.854v9.777h-3.564V20.351z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M301.315,17.525h3.564v12.604h-3.564V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M306.534,28.994l1.171-2.628c1.116,0.737,2.7,1.242,4.159,1.242c1.477,0,2.053-0.414,2.053-1.026 c0-1.999-7.167-0.54-7.167-5.222c0-2.251,1.837-4.087,5.582-4.087c1.639,0,3.331,0.378,4.573,1.098l-1.098,2.647 c-1.207-0.648-2.396-0.973-3.493-0.973c-1.495,0-2.035,0.504-2.035,1.135c0,1.926,7.148,0.485,7.148,5.131 c0,2.197-1.837,4.069-5.582,4.069C309.775,30.38,307.723,29.823,306.534,28.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M322.627,20.28v2.772h5.563v2.755h-5.563v4.321h-3.564V17.525h9.885v2.755H322.627z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M338.577,27.679h-5.33l-0.99,2.449h-3.637l5.563-12.604h3.511l5.582,12.604h-3.709L338.577,27.679z M337.532,25.051l-1.62-4.033l-1.62,4.033H337.532z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M343.451,23.827c0-3.835,2.935-6.554,6.932-6.554c2.323,0,4.195,0.846,5.42,2.376l-2.269,2.053 c-0.792-0.954-1.765-1.477-2.971-1.477c-2.071,0-3.512,1.44-3.512,3.602c0,2.16,1.44,3.601,3.512,3.601 c1.206,0,2.179-0.521,2.971-1.477l2.269,2.053c-1.225,1.531-3.097,2.377-5.42,2.377C346.386,30.38,343.451,27.662,343.451,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M359.959,20.351h-3.871v-2.826h11.289v2.826h-3.854v9.777h-3.564V20.351z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M368.706,17.525h3.564v12.604h-3.564V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M374.159,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554s-2.971,6.554-7.004,6.554 S374.159,27.608,374.159,23.827z M384.566,23.827c0-2.179-1.495-3.602-3.403-3.602s-3.403,1.423-3.403,3.602 s1.495,3.601,3.403,3.601S384.566,26.005,384.566,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M402.026,17.525v12.604h-2.935l-5.563-6.716v6.716h-3.493V17.525h2.935l5.563,6.716v-6.716H402.026z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M409.78,17.525h5.959c4.178,0,7.041,2.431,7.041,6.302s-2.863,6.302-7.041,6.302h-5.959V17.525z M415.596,27.284c2.143,0,3.583-1.278,3.583-3.457s-1.44-3.457-3.583-3.457h-2.251v6.914H415.596z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M424.648,17.525h3.564v12.604h-3.564V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M429.867,28.994l1.171-2.628c1.116,0.737,2.7,1.242,4.159,1.242c1.477,0,2.053-0.414,2.053-1.026 c0-1.999-7.167-0.54-7.167-5.222c0-2.251,1.837-4.087,5.582-4.087c1.639,0,3.331,0.378,4.573,1.098l-1.099,2.647 c-1.206-0.648-2.395-0.973-3.492-0.973c-1.495,0-2.035,0.504-2.035,1.135c0,1.926,7.148,0.485,7.148,5.131 c0,2.197-1.837,4.069-5.582,4.069C433.108,30.38,431.056,29.823,429.867,28.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M450.84,27.679h-5.33l-0.99,2.449h-3.637l5.563-12.604h3.511l5.582,12.604h-3.709L450.84,27.679z M449.795,25.051l-1.62-4.033l-1.62,4.033H449.795z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M455.66,28.994l1.171-2.628c1.116,0.737,2.7,1.242,4.159,1.242c1.477,0,2.053-0.414,2.053-1.026 c0-1.999-7.167-0.54-7.167-5.222c0-2.251,1.837-4.087,5.582-4.087c1.639,0,3.331,0.378,4.573,1.098l-1.099,2.647 c-1.206-0.648-2.395-0.973-3.492-0.973c-1.495,0-2.035,0.504-2.035,1.135c0,1.926,7.148,0.485,7.148,5.131 c0,2.197-1.837,4.069-5.582,4.069C458.901,30.38,456.849,29.823,455.66,28.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M470.691,20.351h-3.871v-2.826h11.289v2.826h-3.854v9.777h-3.564V20.351z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M489.558,27.374v2.755h-10.119V17.525h9.885v2.755h-6.356v2.124h5.6v2.665h-5.6v2.305H489.558z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M497.044,26.78h-1.945v3.349h-3.564V17.525h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L497.044,26.78z M497.079,20.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C499.294,21.018,498.556,20.333,497.079,20.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M509.895,21.234c0-0.721-0.666-1.152-1.584-1.152c-0.973,0-1.782,0.486-2.251,1.296l-2.683-1.44 c0.954-1.603,2.701-2.665,5.348-2.665c2.772,0,4.753,1.188,4.753,3.385c0,2.809-2.952,3.223-2.952,4.879h-3.205 C507.32,23.178,509.895,22.584,509.895,21.234z M506.888,28.4c0-1.062,0.828-1.854,2.035-1.854c1.206,0,2.053,0.792,2.053,1.854 c0,1.044-0.847,1.891-2.053,1.891C507.716,30.291,506.888,29.444,506.888,28.4z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"btn_x5F_1",className:"darkPatternPulse",onClick:function onClick(e){return _this4.shake();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton_3_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M653.002,326.18v36.073c0,2.768-1.758,5.033-3.908,5.033H486.908c-2.149,0-3.908-2.265-3.908-5.033V326.18 c0-2.768,1.758-5.033,3.908-5.033h162.185C651.243,321.146,653.002,323.412,653.002,326.18z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"487.5",y:"333.571",fill:"none",width:"165.502",height:"28.212"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cancel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M515.677,343.475c0-5.433,4.169-9.249,9.854-9.249c3.462,0,6.191,1.263,7.935,3.538l-3.765,3.361 c-1.036-1.314-2.274-2.072-3.866-2.072c-2.476,0-4.144,1.718-4.144,4.422c0,2.704,1.668,4.422,4.144,4.422 c1.592,0,2.83-0.758,3.866-2.072l3.765,3.361c-1.744,2.274-4.473,3.538-7.935,3.538 C519.846,352.723,515.677,348.907,515.677,343.475z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M546.983,349.235h-6.722l-1.188,3.083h-6.064l7.732-17.688h5.862l7.732,17.688h-6.166L546.983,349.235z M545.34,344.94l-1.718-4.447l-1.718,4.447H545.34z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M572.729,334.63v17.688h-4.902l-6.722-8.035v8.035h-5.812V334.63h4.902l6.722,8.036v-8.036H572.729z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M574.9,343.475c0-5.433,4.169-9.249,9.854-9.249c3.462,0,6.191,1.263,7.935,3.538l-3.765,3.361 c-1.036-1.314-2.274-2.072-3.866-2.072c-2.476,0-4.144,1.718-4.144,4.422c0,2.704,1.668,4.422,4.144,4.422 c1.592,0,2.83-0.758,3.866-2.072l3.765,3.361c-1.744,2.274-4.473,3.538-7.935,3.538C579.07,352.723,574.9,348.907,574.9,343.475z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M609.112,347.82v4.498h-14.706V334.63h14.378v4.498h-8.516v2.072h7.479v4.296h-7.479v2.324H609.112z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M611.41,334.63h5.963v13.064h7.985v4.624H611.41V334.63z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"btn_x5F_2",className:"darkPatternPulse",onClick:function onClick(e){return _this4.shake();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton_5_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M468.018,326.18v36.073c0,2.768-2.007,5.033-4.46,5.033H278.46c-2.453,0-4.46-2.265-4.46-5.033V326.18 c0-2.768,2.007-5.033,4.46-5.033h185.098C466.011,321.146,468.018,323.412,468.018,326.18z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"274",y:"333.571",fill:"none",width:"194.018",height:"28.212"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"continue"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M300.417,343.475c0-5.433,4.169-9.249,9.854-9.249c3.462,0,6.191,1.263,7.935,3.538l-3.765,3.361 c-1.036-1.314-2.274-2.072-3.866-2.072c-2.476,0-4.144,1.718-4.144,4.422c0,2.704,1.668,4.422,4.144,4.422 c1.592,0,2.83-0.758,3.866-2.072l3.765,3.361c-1.744,2.274-4.473,3.538-7.935,3.538 C304.585,352.723,300.417,348.907,300.417,343.475z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M318.835,343.475c0-5.357,4.22-9.249,9.981-9.249s9.981,3.891,9.981,9.249c0,5.356-4.22,9.248-9.981,9.248 S318.835,348.831,318.835,343.475z M332.784,343.475c0-2.754-1.769-4.422-3.967-4.422s-3.967,1.668-3.967,4.422 c0,2.754,1.769,4.422,3.967,4.422S332.784,346.229,332.784,343.475z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M358.403,334.63v17.688h-4.902l-6.722-8.035v8.035h-5.812V334.63h4.902l6.722,8.036v-8.036H358.403z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M365.123,339.254h-5.18v-4.624h16.324v4.624h-5.18v13.064h-5.963V339.254z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M377.806,334.63h5.963v17.688h-5.963V334.63z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M404.083,334.63v17.688h-4.902l-6.722-8.035v8.035h-5.812V334.63h4.902l6.722,8.036v-8.036H404.083z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M406.81,344.359v-9.729h5.963v9.551c0,2.704,1.036,3.715,2.704,3.715c1.668,0,2.704-1.011,2.704-3.715 v-9.551h5.862v9.729c0,5.306-3.184,8.364-8.617,8.364S406.81,349.665,406.81,344.359z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M441.477,347.82v4.498h-14.706V334.63h14.377v4.498h-8.515v2.072h7.479v4.296h-7.479v2.324H441.477z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"hitarea",x:"249.482",y:"95",opacity:"0",fill:"#FFFFFF",width:"258.253",height:"42",onMouseOut:function onMouseOut(e){return _this4.hoverOff();},onMouseOver:function onMouseOver(e){return _this4.hoverOn();},onClick:function onClick(e){return _this4.done();}})));}}]);return Round6View;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Round6=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(Round6View);/* harmony default export */ __webpack_exports__["a"] = (Round6);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{twoDDarkPatternIncorrect:function twoDDarkPatternIncorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["t" /* twoDDarkPatternIncorrect */])());},twoDDarkPatternCorrect:function twoDDarkPatternCorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["s" /* twoDDarkPatternCorrect */])());}};};var Round6View=function(_Component){_inherits(Round6View,_Component);function Round6View(props){_classCallCheck(this,Round6View);var _this=_possibleConstructorReturn(this,(Round6View.__proto__||Object.getPrototypeOf(Round6View)).call(this,props));_this.state={shake:false,currentUnit:1};return _this;}_createClass(Round6View,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].set('#btn_x5F_1_1_',{transformOrigin:'center center'});}},{key:"done",value:function done(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(0.5,function(){return _this2.props.adComplete();});}},{key:"advance",value:function advance(btnNum){var _this3=this;this.props.twoDDarkPatternCorrect();this.setState({currentUnit:this.state.currentUnit+1});__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(0.2,function(){return _this3.checkForComplete();});}},{key:"checkForComplete",value:function checkForComplete(){// console.log(this.state.currentUnit);
if(this.state.currentUnit>=6)this.done();}},{key:"shake",value:function shake(){var _this4=this;this.setState({shake:true});__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(0.6,function(){_this4.setState({shake:false});});this.props.twoDDarkPatternIncorrect();}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].killAll(true,true,true,true);}},{key:"render",value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"floatingad "+(this.state.shake?'shake':'')+" "+(this.state.done?'out':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"_x33_-1",x:"0px",y:"0px",viewBox:"0 0 641.859 654.667",enableBackground:"new 0 0 641.859 654.667"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font",{horizAdvX:"1000"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font-face",{fontFamily:"Montserrat-Black",unitsPerEm:"1000",underlinePosition:"-100",underlineThickness:"50"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("missing-glyph",{horizAdvX:"587",d:"M40,0l507,0l0,700l-507,0M120,70l0,560l347,0l0,-560z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"A",horizAdvX:"806",d:"M581,0l244,0l-306,700l-232,0l-306,-700l240,0l47,122l266,0M333,292l68,176l68,-176z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"B",horizAdvX:"773",d:"M617,366C681,398 714,452 714,517C714,623 624,700 431,700l-374,0l0,-700l394,0C644,0 747,71 747,193C747,276 699,336 617,366M399,535C452,535 476,517 476,483C476,449 452,431 399,431l-110,0l0,104M431,165l-142,0l0,110l142,0C483,275 509,256 509,220C509,184 483,165 431,165z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"C",horizAdvX:"744",d:"M419,-16C556,-16 664,34 733,124l-149,133C543,205 494,175 431,175C333,175 267,243 267,350C267,457 333,525 431,525C494,525 543,495 584,443l149,133C664,666 556,716 419,716C194,716 29,565 29,350C29,135 194,-16 419,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"D",horizAdvX:"826",d:"M57,0l345,0C636,0 797,133 797,350C797,567 636,700 402,700l-345,0M293,184l0,332l99,0C491,516 559,457 559,350C559,243 491,184 392,184z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"E",horizAdvX:"673",d:"M289,178l0,92l296,0l0,170l-296,0l0,82l337,0l0,178l-569,0l0,-700l582,0l0,178z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"F",horizAdvX:"644",d:"M626,522l0,178l-569,0l0,-700l236,0l0,224l292,0l0,178l-292,0l0,120z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"G",horizAdvX:"769",d:"M520,192C491,180 463,175 434,175C333,175 267,245 267,350C267,458 333,525 437,525C499,525 550,499 594,448l151,133C674,668 563,716 425,716C194,716 29,565 29,350C29,135 194,-16 420,-16C523,-16 640,15 725,73l0,296l-205,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"H",horizAdvX:"804",d:"M511,700l0,-248l-218,0l0,248l-236,0l0,-700l236,0l0,258l218,0l0,-258l236,0l0,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"I",horizAdvX:"350",d:"M57,0l236,0l0,700l-236,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"K",horizAdvX:"765",d:"M517,0l273,0l-294,392l280,308l-257,0l-230,-254l0,254l-232,0l0,-700l232,0l0,173l53,59z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"L",horizAdvX:"617",d:"M57,0l552,0l0,183l-316,0l0,517l-236,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"M",horizAdvX:"954",d:"M897,0l-2,700l-194,0l-222,-373l-228,373l-194,0l0,-700l215,0l0,308l152,-245l104,0l152,256l2,-319z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"N",horizAdvX:"804",d:"M517,700l0,-318l-266,318l-194,0l0,-700l230,0l0,318l266,-318l194,0l0,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"O",horizAdvX:"848",d:"M424,-16C652,-16 819,138 819,350C819,562 652,716 424,716C196,716 29,562 29,350C29,138 196,-16 424,-16M424,175C337,175 267,241 267,350C267,459 337,525 424,525C511,525 581,459 581,350C581,241 511,175 424,175z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"P",horizAdvX:"743",d:"M394,700l-337,0l0,-700l236,0l0,172l101,0C589,172 713,274 713,436C713,598 589,700 394,700M379,354l-86,0l0,164l86,0C444,518 475,487 475,436C475,385 444,354 379,354z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"R",horizAdvX:"745",d:"M476,0l252,0l-147,216C665,259 713,335 713,436C713,598 589,700 394,700l-337,0l0,-700l236,0l0,176l64,0M475,436C475,385 444,354 379,354l-86,0l0,164l86,0C444,518 475,487 475,436z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"S",horizAdvX:"657",d:"M318,-16C535,-16 644,92 644,220C644,478 257,408 257,492C257,516 279,536 348,536C409,536 474,519 543,484l71,171C541,696 444,716 350,716C133,716 24,610 24,480C24,219 411,290 411,202C411,178 387,164 320,164C243,164 155,189 89,228l-76,-172C83,13 201,-16 318,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"T",horizAdvX:"654",d:"M209,0l236,0l0,517l205,0l0,183l-646,0l0,-183l205,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"U",horizAdvX:"784",d:"M392,-16C607,-16 733,105 733,315l0,385l-232,0l0,-378C501,215 460,175 394,175C328,175 287,215 287,322l0,378l-236,0l0,-385C51,105 177,-16 392,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"V",horizAdvX:"786",d:"M573,700l-171,-409l-167,409l-254,0l296,-700l232,0l296,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"W",horizAdvX:"1206",d:"M972,700l-129,-403l-122,403l-217,0l-129,-398l-122,398l-243,0l224,-700l253,0l119,374l113,-374l253,0l224,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"X",horizAdvX:"762",d:"M770,0l-258,362l243,338l-254,0l-116,-176l-119,176l-265,0l244,-347l-253,-353l269,0l118,187l121,-187z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"Y",horizAdvX:"710",d:"M737,700l-228,0l-144,-242l-143,242l-249,0l264,-443l0,-257l236,0l0,254z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:",",horizAdvX:"304",d:"M152,248C76,248 20,198 20,120C20,67 45,28 85,9l-50,-169l140,0l70,149C280,64 284,88 284,120C284,198 228,248 152,248z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"!",horizAdvX:"314",d:"M67,268l180,0l45,432l-270,0M157,-10C235,-10 289,44 289,110C289,177 235,228 157,228C79,228 25,177 25,110C25,44 79,-10 157,-10z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:".",horizAdvX:"304",d:"M152,-10C227,-10 284,44 284,120C284,197 227,248 152,248C77,248 20,197 20,120C20,44 77,-10 152,-10z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"\u2019",horizAdvX:"304",d:"M152,752C76,752 20,702 20,624C20,571 45,532 85,513l-50,-169l140,0l70,149C280,568 284,592 284,624C284,702 228,752 152,752z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:" ",horizAdvX:"300"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font",{horizAdvX:"1000"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font-face",{fontFamily:"Montserrat-ExtraBold",unitsPerEm:"1000",underlinePosition:"-100",underlineThickness:"50"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("missing-glyph",{horizAdvX:"587",d:"M40,0l507,0l0,700l-507,0M120,70l0,560l347,0l0,-560z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"A",horizAdvX:"786",d:"M594,0l206,0l-310,700l-195,0l-309,-700l202,0l55,136l296,0M301,282l90,224l90,-224z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"E",horizAdvX:"672",d:"M266,153l0,128l311,0l0,148l-311,0l0,118l353,0l0,153l-549,0l0,-700l562,0l0,153z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"H",horizAdvX:"806",d:"M538,700l0,-263l-270,0l0,263l-198,0l0,-700l198,0l0,273l270,0l0,-273l198,0l0,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"I",horizAdvX:"339",d:"M70,0l198,0l0,700l-198,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"L",horizAdvX:"610",d:"M70,0l532,0l0,157l-334,0l0,543l-198,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"O",horizAdvX:"846",d:"M423,-14C647,-14 812,140 812,350C812,560 647,714 423,714C199,714 34,560 34,350C34,140 199,-14 423,-14M423,150C317,150 234,229 234,350C234,471 317,550 423,550C529,550 612,471 612,350C612,229 529,150 423,150z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"R",horizAdvX:"740",d:"M503,0l212,0l-151,220C651,262 701,338 701,441C701,601 581,700 390,700l-320,0l0,-700l198,0l0,186l108,0M501,441C501,377 460,339 378,339l-110,0l0,205l110,0C460,544 501,506 501,441z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"S",horizAdvX:"647",d:"M316,-14C524,-14 626,90 626,212C626,470 229,390 229,497C229,532 259,560 342,560C403,560 469,542 536,506l61,147C528,693 434,714 343,714C135,714 33,612 33,487C33,227 431,308 431,197C431,163 399,140 317,140C236,140 148,168 86,209l-65,-146C87,17 201,-14 316,-14z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"T",horizAdvX:"635",d:"M219,0l198,0l0,543l214,0l0,157l-627,0l0,-157l215,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"U",horizAdvX:"786",d:"M393,-14C600,-14 722,103 722,312l0,388l-195,0l0,-382C527,198 477,150 395,150C312,150 262,198 262,318l0,382l-198,0l0,-388C64,103 186,-14 393,-14z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"W",horizAdvX:"1184",d:"M979,700l-147,-451l-141,451l-182,0l-148,-447l-141,447l-204,0l227,-700l212,0l140,426l134,-426l212,0l227,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"Y",horizAdvX:"693",d:"M713,700l-192,0l-166,-278l-166,278l-209,0l267,-446l0,-254l198,0l0,251z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"?",horizAdvX:"597",d:"M212,255l178,0C390,347 554,370 554,526C554,648 444,714 290,714C143,714 46,655 -7,566l149,-80C168,531 213,558 267,558C318,558 355,534 355,494C355,419 212,386 212,255M301,-9C368,-9 415,38 415,96C415,155 368,199 301,199C234,199 188,155 188,96C188,38 234,-9 301,-9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:" ",horizAdvX:"291"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"b1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"base_14_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_14_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_15_",y:"0",fill:"#FFFFFF",width:"495.192",height:"352.333"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"16.369",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"35.325",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"468.036",y:"21.913",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 122.8338 343.2053)",fill:"#B2AFAA",width:"15.333",height:"2.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"474.292",y:"15.663",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 122.8355 343.2098)",fill:"#B2AFAA",width:"2.833",height:"15.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"whereis",enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M72.152,17.525l-4.087,12.604h-3.817l-2.413-7.67l-2.521,7.67h-3.817L51.41,17.525h3.673l2.539,8.048 l2.665-8.048h3.277l2.539,8.12l2.646-8.12H72.152z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M85.416,17.525v12.604h-3.565v-4.915h-4.861v4.915h-3.564V17.525h3.564v4.735h4.861v-4.735H85.416z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M98.052,27.374v2.755H87.933V17.525h9.885v2.755h-6.356v2.124h5.6v2.665h-5.6v2.305H98.052z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M105.538,26.78h-1.945v3.349h-3.564V17.525h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L105.538,26.78z M105.573,20.334h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C107.788,21.018,107.05,20.334,105.573,20.334z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M123.466,27.374v2.755h-10.118V17.525h9.885v2.755h-6.356v2.124h5.6v2.665h-5.6v2.305H123.466z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M130.681,17.525h3.564v12.604h-3.564V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M135.899,28.994l1.171-2.628c1.116,0.737,2.7,1.242,4.159,1.242c1.477,0,2.053-0.414,2.053-1.026 c0-1.999-7.167-0.54-7.167-5.222c0-2.251,1.837-4.087,5.582-4.087c1.639,0,3.331,0.378,4.573,1.098l-1.098,2.647 c-1.207-0.648-2.396-0.973-3.493-0.973c-1.495,0-2.035,0.504-2.035,1.135c0,1.926,7.148,0.485,7.148,5.131 c0,2.197-1.837,4.069-5.582,4.069C139.141,30.38,137.088,29.823,135.899,28.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M160.417,25.609v4.52h-3.565v-4.573l-4.808-8.03h3.764l2.988,5.005l2.989-5.005h3.457L160.417,25.609z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M164.95,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554s-2.971,6.554-7.004,6.554 S164.95,27.608,164.95,23.827z M175.357,23.827c0-2.179-1.495-3.602-3.403-3.602s-3.403,1.423-3.403,3.602s1.495,3.601,3.403,3.601 S175.357,26.005,175.357,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M180.718,24.511v-6.986h3.565v6.878c0,2.16,0.899,3.024,2.395,3.024c1.477,0,2.377-0.864,2.377-3.024 v-6.878h3.511v6.986c0,3.763-2.197,5.869-5.924,5.869C182.914,30.38,180.718,28.274,180.718,24.511z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M200.483,26.78h-1.945v3.349h-3.564V17.525h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L200.483,26.78z M200.519,20.334h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C202.733,21.018,201.995,20.334,200.519,20.334z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M213.531,17.525h3.564v9.776h6.014v2.827h-9.578V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M223.664,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554s-2.971,6.554-7.004,6.554 S223.664,27.608,223.664,23.827z M234.071,23.827c0-2.179-1.495-3.602-3.403-3.602s-3.403,1.423-3.403,3.602 s1.495,3.601,3.403,3.601S234.071,26.005,234.071,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M245.752,25.609v4.52h-3.565v-4.573l-4.808-8.03h3.764l2.988,5.005l2.989-5.005h3.457L245.752,25.609z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M259.126,27.679h-5.33l-0.99,2.449h-3.637l5.563-12.604h3.511l5.582,12.604h-3.709L259.126,27.679z M258.081,25.051l-1.62-4.033l-1.62,4.033H258.081z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M264.829,17.525h3.564v9.776h6.014v2.827h-9.578V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M277.321,20.351h-3.871v-2.826h11.289v2.826h-3.854v9.777h-3.564V20.351z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M292.515,25.609v4.52h-3.565v-4.573l-4.808-8.03h3.764l2.988,5.005l2.989-5.005h3.457L292.515,25.609z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M303.367,21.234c0-0.721-0.666-1.152-1.584-1.152c-0.973,0-1.782,0.486-2.251,1.296l-2.683-1.44 c0.954-1.603,2.701-2.665,5.348-2.665c2.772,0,4.753,1.188,4.753,3.385c0,2.809-2.952,3.223-2.952,4.879h-3.205 C300.793,23.178,303.367,22.585,303.367,21.234z M300.36,28.4c0-1.062,0.828-1.854,2.035-1.854c1.206,0,2.053,0.792,2.053,1.854 c0,1.044-0.847,1.891-2.053,1.891C301.188,30.291,300.36,29.444,300.36,28.4z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"9.162",y:"44.319",fill:"#DB2103",width:"476.867",height:"297.348"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E84215",points:"486.029,160.333 486.029,341.667 9.162,341.937 9.162,180.333 286.667,237 206.667,124.333 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AA1000",points:"486.029,253.165 478.044,247.42 483.292,222.525 472.078,186.431 433.186,184 356.95,203.667  377.132,279.24 404.828,274.82 412.488,288.373 367.557,309.292 368.441,341.667 486.029,341.667 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M433.749,216.483c0.233,0.657,0.366,1.361,0.366,2.097c0,3.475-2.817,6.292-6.292,6.292 c-3.475,0-6.292-2.817-6.292-6.292c0-0.737,0.133-1.44,0.366-2.097H433.749z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M390.334,223.614c0.533,0.449,1.004,0.989,1.376,1.624c1.758,2.997,0.753,6.853-2.244,8.611 c-2.998,1.758-6.853,0.753-8.611-2.244c-0.373-0.635-0.614-1.31-0.746-1.994L390.334,223.614z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"31.333",y:"65.833",fill:"none",width:"412.667",height:"187.167"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"okay"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M32.784,85.432c0-10.601,8.351-18.301,19.751-18.301c11.401,0,19.751,7.701,19.751,18.301 s-8.351,18.301-19.751,18.301C41.134,103.733,32.784,96.033,32.784,85.432z M60.385,85.432c0-5.45-3.5-8.75-7.851-8.75 c-4.35,0-7.851,3.3-7.851,8.75s3.5,8.75,7.851,8.75C56.885,94.183,60.385,90.882,60.385,85.432z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M90.834,91.333l-2.65,2.95v8.65H76.583V67.931h11.601v12.701l11.501-12.701h12.851L98.534,83.332 l14.701,19.601H99.584L90.834,91.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M136.935,96.833h-13.301l-2.35,6.101h-12.001l15.301-35.002h11.601l15.301,35.002h-12.201L136.935,96.833z M133.685,88.332l-3.4-8.8l-3.4,8.8H133.685z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M171.935,90.232v12.701h-11.801V90.083l-13.201-22.151h12.451l7.15,12.101l7.201-12.101h11.4 L171.935,90.232z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M185.882,67.931h13.501l-2.25,21.601h-9L185.882,67.931z M186.032,97.433c0-3.35,2.7-5.9,6.601-5.9 c3.9,0,6.6,2.55,6.6,5.9c0,3.3-2.7,6-6.6,6C188.732,103.433,186.032,100.733,186.032,97.433z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M201.582,67.931h13.501l-2.25,21.601h-9L201.582,67.931z M201.732,97.433c0-3.35,2.7-5.9,6.601-5.9 c3.9,0,6.6,2.55,6.6,5.9c0,3.3-2.7,6-6.6,6C204.432,103.433,201.732,100.733,201.732,97.433z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M63.617,116.438l-6.046,18.895h-6.829l-3.05-10.095l-3.212,10.095H37.65l-6.046-18.895h6.559l3.293,10.743 l3.482-10.743h5.857l3.293,10.878l3.482-10.878H63.617z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M80.739,130.528v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H80.739z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M103.797,125.373h5.534v7.99c-2.294,1.566-5.453,2.403-8.233,2.403c-6.1,0-10.554-4.076-10.554-9.879 c0-5.804,4.454-9.879,10.689-9.879c3.725,0,6.721,1.295,8.638,3.644l-4.076,3.59c-1.188-1.376-2.564-2.079-4.238-2.079 c-2.807,0-4.589,1.809-4.589,4.724c0,2.834,1.782,4.724,4.508,4.724c0.783,0,1.539-0.135,2.321-0.459V125.373z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M127.772,130.528v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H127.772z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M134.336,121.378h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V121.378z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M155.991,116.438h6.37v18.895h-6.37V116.438z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M169.543,121.378h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V121.378z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M181.155,132.094c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455 c0,2.052-1.539,3.509-3.563,3.509S181.155,134.146,181.155,132.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M217.085,116.438v18.895h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H217.085z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M219.412,125.886c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S219.412,131.608,219.412,125.886z M234.312,125.886c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C232.423,130.609,234.312,128.828,234.312,125.886z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M246.897,121.378h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V121.378z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M284.261,130.528v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H284.261z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M306.643,116.438l-7.99,18.895h-6.262l-7.99-18.895h6.856l4.508,11.04l4.616-11.04H306.643z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M322.979,130.528v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H322.979z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M333.538,130.583h-1.728v4.75h-6.37v-18.895h9.097c5.264,0,8.611,2.753,8.611,7.126 c0,2.727-1.296,4.778-3.563,5.938l3.968,5.831h-6.802L333.538,130.583z M334.132,121.351h-2.322v4.427h2.322 c1.754,0,2.591-0.836,2.591-2.213C336.723,122.188,335.886,121.351,334.132,121.351z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M356.514,128.477v6.856h-6.37v-6.937l-7.126-11.958h6.721l3.86,6.532l3.887-6.532h6.154L356.514,128.477z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M362.889,125.886c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S362.889,131.608,362.889,125.886z M377.789,125.886c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C375.9,130.609,377.789,128.828,377.789,125.886z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M405.166,116.438v18.895h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H405.166z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M423.958,130.528v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H423.958z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M63.617,148.838l-6.046,18.895h-6.829l-3.05-10.095l-3.212,10.095H37.65l-6.046-18.895h6.559l3.293,10.743 l3.482-10.743h5.857l3.293,10.878l3.482-10.878H63.617z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M77.23,164.44h-7.18l-1.269,3.293h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L77.23,164.44z M75.476,159.851L73.64,155.1l-1.835,4.751H75.476z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M104.742,148.838v18.895h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H104.742z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M111.927,153.778h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V153.778z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M124.294,166.221l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.37-8.8,6.37C129.369,168.165,126.184,167.382,124.294,166.221z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M164.196,164.44h-7.18l-1.269,3.293h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L164.196,164.44z M162.441,159.851l-1.835-4.751l-1.835,4.751H162.441z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M202.747,148.838l-6.046,18.895h-6.829l-3.05-10.095l-3.212,10.095h-6.829l-6.046-18.895h6.559 l3.293,10.743l3.482-10.743h5.857l3.293,10.878l3.482-10.878H202.747z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M219.87,162.928v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H219.87z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M221.143,166.221l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.37-8.8,6.37C226.218,168.165,223.032,167.382,221.143,166.221z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M239.313,158.286c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S239.313,164.008,239.313,158.286z M254.213,158.286c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C252.324,163.009,254.213,161.228,254.213,158.286z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M279.836,167.733l-0.054-8.611l-4.103,6.91h-2.807l-4.103-6.613v8.314h-5.803v-18.895h5.237l6.154,10.068 l5.992-10.068h5.237l0.054,18.895H279.836z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M304.433,162.928v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H304.433z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M313.806,166.221l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.37-8.8,6.37C318.881,168.165,315.695,167.382,313.806,166.221z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M336.565,153.778h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V153.778z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M349.688,159.23v-10.392h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 v-10.203h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C353.089,168.165,349.688,164.898,349.688,159.23z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M377.388,153.643v3.239h7.882v4.805h-7.882v6.046h-6.37v-18.895h15.359v4.805H377.388z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M394.776,153.643v3.239h7.882v4.805h-7.882v6.046h-6.37v-18.895h15.359v4.805H394.776z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M404.525,164.494c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455 c0,2.052-1.539,3.509-3.563,3.509S404.525,166.545,404.525,164.494z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M32.116,190.686c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C36.57,200.565,32.116,196.489,32.116,190.686z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M52.96,181.238h6.37v13.956h8.53v4.939h-14.9V181.238z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M69.619,181.238h6.37v18.895h-6.37V181.238z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M78.312,190.686c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C82.767,200.565,78.312,196.489,78.312,190.686z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M106.849,193.871l-1.431,1.592v4.67h-6.262v-18.895h6.262v6.856l6.208-6.856h6.937l-7.558,8.314 l7.936,10.581h-7.369L106.849,193.871z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M146.536,181.238v18.895h-6.37v-6.964h-5.885v6.964h-6.37v-18.895h6.37v6.694h5.885v-6.694H146.536z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M165.328,195.328v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H165.328z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M175.887,195.382h-1.728v4.75h-6.37v-18.895h9.097c5.264,0,8.611,2.753,8.611,7.126 c0,2.727-1.296,4.778-3.563,5.938l3.968,5.831h-6.802L175.887,195.382z M176.481,186.15h-2.322v4.427h2.322 c1.754,0,2.591-0.836,2.591-2.213C179.072,186.987,178.235,186.15,176.481,186.15z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M203.614,195.328v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H203.614z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M205.346,196.894c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455 c0,2.052-1.539,3.509-3.563,3.509S205.346,198.945,205.346,196.894z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M213.554,196.894c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455 c0,2.052-1.539,3.509-3.563,3.509S213.554,198.945,213.554,196.894z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M221.761,196.894c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455 c0,2.052-1.539,3.509-3.563,3.509S221.761,198.945,221.761,196.894z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"b1_x5F_b",className:"darkPatternPulse",onClick:function onClick(e){return _this5.advance(1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton_6_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M362.667,282.573v36.073c0,2.768-3.451,5.033-7.669,5.033H36.72c-4.218,0-7.669-2.265-7.669-5.033 v-36.073c0-2.768,3.451-5.033,7.669-5.033h318.277C359.215,277.539,362.667,279.805,362.667,282.573z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"28.667",y:"289.964",fill:"none",width:"260.667",height:"28.212"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"unsubscribe"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M62.458,300.752v-9.729h5.963v9.551c0,2.704,1.036,3.715,2.704,3.715c1.668,0,2.704-1.011,2.704-3.715 v-9.551h5.862v9.729c0,5.306-3.184,8.364-8.617,8.364S62.458,306.058,62.458,300.752z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M99.854,291.023v17.688h-4.902l-6.722-8.035v8.035h-5.812v-17.688h4.902l6.722,8.036v-8.036H99.854z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M101.621,307.296l1.92-4.346c1.667,0.985,3.891,1.617,5.837,1.617c1.693,0,2.299-0.354,2.299-0.96 c0-2.224-9.779-0.429-9.779-7.024c0-3.285,2.754-5.963,8.238-5.963c2.375,0,4.826,0.505,6.671,1.542l-1.794,4.321 c-1.744-0.884-3.386-1.314-4.927-1.314c-1.744,0-2.299,0.505-2.299,1.112c0,2.123,9.779,0.354,9.779,6.873 c0,3.234-2.754,5.963-8.237,5.963C106.371,309.116,103.389,308.383,101.621,307.296z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M119.18,300.752v-9.729h5.963v9.551c0,2.704,1.036,3.715,2.704,3.715c1.668,0,2.704-1.011,2.704-3.715 v-9.551h5.862v9.729c0,5.306-3.184,8.364-8.617,8.364S119.18,306.058,119.18,300.752z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M156.576,303.835c0,3.083-2.603,4.877-7.479,4.877h-9.956v-17.688h9.45c4.877,0,7.151,1.946,7.151,4.624 c0,1.643-0.833,3.007-2.451,3.816C155.363,300.221,156.576,301.737,156.576,303.835z M145.003,295.193v2.628h2.779 c1.339,0,1.946-0.455,1.946-1.314c0-0.859-0.606-1.314-1.946-1.314H145.003z M150.562,303.152c0-0.91-0.657-1.39-1.971-1.39h-3.588 v2.779h3.588C149.905,304.542,150.562,304.062,150.562,303.152z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M157.56,307.296l1.92-4.346c1.667,0.985,3.891,1.617,5.837,1.617c1.693,0,2.299-0.354,2.299-0.96 c0-2.224-9.779-0.429-9.779-7.024c0-3.285,2.754-5.963,8.237-5.963c2.375,0,4.827,0.505,6.671,1.542l-1.794,4.321 c-1.743-0.884-3.386-1.314-4.927-1.314c-1.744,0-2.299,0.505-2.299,1.112c0,2.123,9.779,0.354,9.779,6.873 c0,3.234-2.754,5.963-8.238,5.963C162.31,309.116,159.328,308.383,157.56,307.296z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M174.563,299.868c0-5.433,4.169-9.249,9.854-9.249c3.462,0,6.191,1.263,7.935,3.538l-3.765,3.361 c-1.036-1.314-2.274-2.072-3.866-2.072c-2.476,0-4.144,1.718-4.144,4.422c0,2.704,1.668,4.422,4.144,4.422 c1.592,0,2.83-0.758,3.866-2.072l3.765,3.361c-1.744,2.274-4.473,3.538-7.935,3.538C178.733,309.116,174.563,305.3,174.563,299.868 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M201.649,304.264h-1.617v4.447h-5.963v-17.688h8.516c4.927,0,8.061,2.578,8.061,6.671 c0,2.552-1.213,4.473-3.335,5.559l3.714,5.458h-6.368L201.649,304.264z M202.205,295.623h-2.173v4.144h2.173 c1.643,0,2.426-0.783,2.426-2.072S203.848,295.623,202.205,295.623z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M212.892,291.023h5.963v17.688h-5.963V291.023z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M239.17,303.835c0,3.083-2.603,4.877-7.479,4.877h-9.956v-17.688h9.45c4.877,0,7.151,1.946,7.151,4.624 c0,1.643-0.834,3.007-2.451,3.816C237.957,300.221,239.17,301.737,239.17,303.835z M227.597,295.193v2.628h2.779 c1.339,0,1.946-0.455,1.946-1.314c0-0.859-0.606-1.314-1.946-1.314H227.597z M233.156,303.152c0-0.91-0.657-1.39-1.971-1.39h-3.588 v2.779h3.588C232.499,304.542,233.156,304.062,233.156,303.152z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M255.972,304.213v4.498h-14.706v-17.688h14.377v4.498h-8.515v2.072h7.479v4.296h-7.479v2.324H255.972z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"313.934,294.667 342.06,294.667 327.997,309 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"b1_x5F_o_1_",opacity:"0.68",fill:"#898989",width:"495.192",height:"352.333",className:"dpseq "+(this.state.currentUnit<=1?'hide':'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"b2",className:"dpseq "+(this.state.currentUnit<2?'hide':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"base_13_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_13_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_14_",x:"146.667",y:"338.333",fill:"#FFFFFF",width:"495.192",height:"316.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"155.829",y:"346.652",fill:"#0857B5",width:"476.867",height:"297.348"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0A75CC",points:"632.696,500 632.696,644 155.829,644 155.829,522 218,529.667 204,507 463.333,519 440,483.667 \t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F1F2F2",d:"M241.05,511.737l-36.284-18.941c-3.619-4.428-14.421-9.856-14.421-9.856 c8.271-5.866,18.998,1.126,18.998,1.126l36.264,18.948L241.05,511.737z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#414042",d:"M247.685,499.015l-1.349,2.575l-7.347,14.069c-0.168,0.316-0.049,0.717,0.267,0.885 c0.316,0.168,0.717,0.049,0.884-0.267l2.509-4.827c-0.469,0.912-0.115,2.045,0.805,2.535l3.319,1.738 c0.912,0.469,2.045,0.115,2.535-0.805c-0.469,0.912-0.115,2.045,0.805,2.535l3.319,1.738c0.912,0.469,2.045,0.115,2.535-0.805 c-0.469,0.912-0.115,2.045,0.805,2.535l3.319,1.738c0.912,0.469,2.045,0.115,2.535-0.805c-0.469,0.912-0.115,2.045,0.805,2.535 l3.319,1.738c0.912,0.469,2.045,0.115,2.535-0.805c-0.469,0.912-0.115,2.045,0.805,2.535l3.319,1.738 c0.912,0.469,2.045,0.115,2.535-0.805l3.57-6.835c0.469-0.912,0.115-2.045-0.805-2.535l-3.319-1.738 c-0.912-0.469-2.045-0.115-2.535,0.805c0.469-0.912,0.115-2.045-0.805-2.535l-3.319-1.738c-0.912-0.469-2.045-0.115-2.535,0.805 c0.469-0.912,0.115-2.045-0.805-2.535l-3.319-1.738c-0.912-0.469-2.045-0.115-2.535,0.805c0.469-0.912,0.115-2.045-0.805-2.535 l-3.319-1.738c-0.912-0.469-2.045-0.115-2.535,0.805c0.469-0.912,0.115-2.045-0.805-2.535l-3.319-1.738 c-0.912-0.469-2.045-0.115-2.535,0.805l2.61-5.003c0.168-0.316,0.049-0.717-0.267-0.884S247.853,498.699,247.685,499.015z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M271.479,521.121c0.074-0.12,0.148-0.239,0.23-0.338l-2.389,4.575c-0.469,0.912-1.623,1.274-2.535,0.805 l3.932-7.522C271.601,519.096,271.949,520.209,271.479,521.121z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M246.26,504.601c0.469-0.912,1.623-1.274,2.535-0.805l3.326,1.759l-1.376,2.631 c-0.007-0.021-0.028-0.013-0.035-0.034l-3.319-1.738c-0.8-0.416-1.748-0.197-2.292,0.439L246.26,504.601z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M264.813,517.632c0.477-0.891,0.122-2.024-0.749-2.508l1.375-2.631c0.919,0.49,1.274,1.623,0.805,2.535 l-1.181,2.259C264.961,517.393,264.887,517.512,264.813,517.632z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M252.906,508.097c0.49-0.919,1.623-1.274,2.535-0.805l3.34,1.731l-1.375,2.631 c-0.007-0.021-0.028-0.013-0.035-0.034l-3.319-1.738c-0.8-0.416-1.748-0.197-2.292,0.439L252.906,508.097z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M272.89,518.523c0.469-0.912,1.623-1.274,2.535-0.805l3.319,1.738l-1.376,2.631 c-0.007-0.021-0.028-0.013-0.035-0.034l-3.319-1.738c-0.8-0.416-1.748-0.197-2.305,0.467L272.89,518.523z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M266.224,515.034c0.49-0.919,1.623-1.274,2.535-0.805l3.319,1.738l-1.376,2.631 c-0.007-0.021-0.028-0.013-0.035-0.034l-3.319-1.738c-0.8-0.416-1.748-0.197-2.313,0.446L266.224,515.034z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M264.813,517.632c0.074-0.12,0.148-0.239,0.23-0.338l-2.389,4.575c-0.469,0.912-1.623,1.274-2.535,0.805 l3.932-7.522C264.942,515.628,265.29,516.74,264.813,517.632z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M258.154,514.163c0.04-0.084,0.101-0.176,0.162-0.267l-2.3,4.497c-0.469,0.912-1.623,1.274-2.535,0.805 l3.932-7.522C258.284,512.159,258.631,513.272,258.154,514.163z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M271.479,521.121c0.469-0.912,0.122-2.024-0.749-2.508l1.376-2.631c0.912,0.469,1.274,1.623,0.805,2.535 l-1.181,2.259C271.628,520.882,271.533,521.009,271.479,521.121z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M278.138,524.589c0.477-0.891,0.122-2.024-0.749-2.508l1.376-2.631c0.912,0.469,1.274,1.623,0.805,2.535 l-1.376,2.631L278.138,524.589z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M273.437,529.61l3.932-7.522c0.878,0.505,1.225,1.617,0.749,2.508l0.035,0.034l-2.194,4.203 C275.51,529.739,274.356,530.101,273.437,529.61z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M258.154,514.163c0.469-0.912,0.122-2.024-0.749-2.508l1.375-2.631c0.8,0.416,1.186,1.375,0.924,2.213 l0,0l-1.368,2.652C258.255,513.987,258.215,514.071,258.154,514.163z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M251.495,510.694c0.074-0.12,0.148-0.239,0.23-0.338l-2.389,4.575c-0.49,0.919-1.623,1.274-2.535,0.805 l3.932-7.522C251.638,508.663,251.965,509.782,251.495,510.694z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M251.495,510.694c0.469-0.912,0.122-2.024-0.749-2.508l1.376-2.631c0.912,0.469,1.274,1.623,0.805,2.535 l-1.181,2.259C251.644,510.455,251.562,510.554,251.495,510.694z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262428",d:"M258.316,513.896l1.368-2.652c-0.033,0.105-0.066,0.21-0.126,0.301c0.469-0.912,1.623-1.274,2.535-0.805 l3.319,1.738l-1.376,2.631c-0.007-0.021-0.028-0.013-0.035-0.034l-3.319-1.738C259.869,512.95,258.859,513.191,258.316,513.896z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#BFDFEF",d:"M190.316,482.926c8.271-5.866,18.998,1.126,18.998,1.126l36.292,18.962l-1.973,3.775 c0,0-28.899-14.867-32.803-16.678s-11.837-4.269-13.154-2.986C193.921,484.749,190.316,482.926,190.316,482.926z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F1F2F2",d:"M631.745,577.633c0,0-18.347-21.582-23.178-26.319s-8.183-1.82-10.249,0.219 c-2.066,2.039-49.142,43.705-49.142,43.705l4.733,5.175l4.21-3.503c7.919,4.251,11.855,18.564,11.855,18.564 C607.787,606.712,631.745,577.633,631.745,577.633z M599.165,566.929c-1.66-1.815-1.56-4.643,0.282-6.329s4.643-1.56,6.329,0.282 c1.66,1.815,1.56,4.643-0.282,6.329C603.651,568.896,600.85,568.772,599.165,566.929z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#BFDFEF",d:"M571.311,614.052c37.825-11.361,58.55-36.139,58.55-36.139l-3.113-3.621c0,0-18.682,25-56.48,36.336 L571.311,614.052z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#603913",d:"M518.958,634.173l-0.372-0.406c4.295-2.485,20.173-12.381,35.987-32.519l0.174,0.19 c0.471,0.515,1.276,0.525,1.764,0.079c0.488-0.446,0.525-1.276,0.079-1.764l-6.443-7.044c-0.471-0.515-1.276-0.525-1.764-0.079 c-0.488,0.446-0.547,1.197-0.128,1.709l-35.789,32.736c-0.473-0.463-1.227-0.47-1.714-0.024 c-0.515,0.471-0.525,1.276-0.079,1.764l6.443,7.044c0.471,0.515,1.276,0.525,1.764,0.079 C519.367,635.491,519.428,634.688,518.958,634.173z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_8_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2891AD",points:"589.13,482.24 597.1,644 583.1,644 573.27,559.52 576.99,549.24 564.85,545.09 578.02,534.82  565.03,531.21 568.94,520.4 566.24,482.24 589.07,482.24 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"566.24",y:"460",fill:"#3A2E26",width:"22.83",height:"22.24"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#41AACE",points:"573.27,559.52 583.1,644 551.03,644 548.51,642.09 558.84,636.86 547.31,632.05 556.74,625.68  556.74,625.62 550.55,625.62 537.88,482.24 566.24,482.24 568.94,520.4 565.03,531.21 578.02,534.82 564.85,545.09  576.99,549.24 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3A2E26",points:"566.24,460 566.24,482.24 537.88,482.24 537.87,482.24 537.87,482.18 526.27,482.18 526.27,460  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#71DFEA",points:"558.84,636.86 548.51,642.09 551.03,644 550.97,644 548.45,642.09 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"550.55",y:"625.62",fill:"#71DFEA",width:"6.19",height:"0.06"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#71DFEA",d:"M550.55,625.68h6.19l-9.43,6.37l11.53,4.81l-10.39,5.23l2.52,1.91h-9.96l-17.74-104.13h-6.79 c0,0-14.18-7.4-14.18-24.22c0.14,0,0.28-0.01,0.42-0.02c5.01-0.33,10.87-6.6,10.87-13.32c0-6.64,0-19.1,0-20.07h12.68h11.6 l12.68,143.38V625.68z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#71DFEA",points:"537.88,482.24 550.55,625.62 537.87,482.24 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"526.27",y:"482.18",fill:"#3A2E26",width:"11.6",height:"0.06"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EAC654",d:"M526.27,482.18v0.06h-12.68c0-0.04,0-0.06,0-0.06H526.27z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EAC654",d:"M526.27,460v22.18h-12.68c0,0,0,0.02,0,0.06h-0.06h-11.29h-12.99V460H526.27z M520.98,478.03v-13.94 v-0.06h-6.24h-20.2v0.06v13.94h8.9H520.98z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AD5A21",points:"520.98,464.09 520.98,478.03 503.44,478.03 514.69,464.09 514.74,464.09 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AD5A21",points:"520.98,464.03 520.98,464.09 514.74,464.09 514.69,464.09 514.74,464.03 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2891AD",points:"516.42,539.87 498.64,644 485.64,644 494.42,583.56 500.07,576.28 490.78,575.08 502.42,566.55  502.4,566.55 502.48,566.49 493.47,564.99 502.72,556.93 486.54,558.67 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3A2E26",points:"514.74,464.03 514.69,464.09 494.54,464.09 494.54,464.03 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3A2E26",points:"514.69,464.09 503.44,478.03 494.54,478.03 494.54,464.09 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#2891AD",d:"M513.53,482.24c0,0,0,13.22,0,20.13c0,6.69-5.81,12.88-10.81,13.26c-0.14,0.01-0.28,0.02-0.42,0.02 c-0.02,0-0.04,0-0.06,0c0-16.83,0-33.41,0-33.41H513.53z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2891AD",points:"502.72,556.93 486.43,558.74 486.54,558.67 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2891AD",points:"502.48,566.49 502.4,566.55 493.4,565.05 493.47,564.99 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2891AD",points:"500.07,576.28 494.42,583.56 500.01,576.34 490.7,575.14 490.78,575.08 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#41AACE",d:"M489.25,482.24h12.99c0,0,0,16.58,0,33.41c0,16.82,14.18,24.22,14.18,24.22l-29.99,18.81l0.11-0.01 l-0.11,0.07l16.29-1.81l-9.25,8.06l-0.07,0.06l9,1.5l-11.64,8.53h0.02l-0.08,0.06l9.31,1.2l-5.59,7.22L485.64,644h-29.7 l11.26-1.49l-12.56-12.44h12.5h0.06l-5.29-7.99l10.28-139.84h17H489.25z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3A2E26",points:"489.19,460 489.19,482.24 472.19,482.24 472.13,482.24 458.43,482.24 458.43,460 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#71DFEA",points:"472.13,482.24 461.85,622.08 467.14,630.07 454.64,630.07 454.58,630.07 467.14,642.51  455.88,644 444.05,644 458.43,482.24 \t\t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_7_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#F3E700",points:"340.577,523.256 359.62,530.879 357.24,539.417 375.739,571.281 364.132,567.658  348.505,540.708 343.144,538.011 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D8930B",points:"364.132,567.658 375.739,571.281 341.035,582.14 330.658,578.422 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#EAA60F",points:"340.577,523.256 343.144,538.011 348.505,540.708 364.132,567.658 330.658,578.422  334.245,570.173 356.153,563.657 345.628,545.373 336.816,542.576 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#F3E700",points:"301.682,526.523 320.725,534.146 318.342,542.684 334.245,570.173 330.658,578.422  330.533,578.389 310.791,544.634 306.295,539.053 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#F3E700",points:"341.035,582.14 377.833,644 369.52,644 369.471,644 330.637,578.565 330.658,578.422 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D8930B",points:"330.637,578.565 370.333,644 362.167,644 329.345,588.138 329.303,588.169 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#F3E700",points:"330.658,578.422 330.637,578.565 330.587,578.477 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#F3E700",points:"330.658,578.422 330.587,578.477 330.533,578.389 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#EAA60F",points:"330.587,578.477 330.637,578.565 329.303,588.169 300.967,609.746 282.547,577.842  273.735,575.046 277.496,555.726 282.486,571.228 287.424,574.524 302.319,599.077 321.056,585.825 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#F3E700",points:"330.533,578.389 330.587,578.477 321.056,585.825 302.319,599.077 287.424,574.524  282.486,571.228 277.496,555.726 296.539,563.349 294.159,571.886 304.761,590.132 322.495,576.214 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#EAA60F",points:"310.791,544.634 330.533,578.389 322.495,576.214 322.554,576.169 306.733,548.639  297.921,545.843 301.682,526.523 306.295,539.053 \t\t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E5E5E5",d:"M433.972,556.701c29.403-21.567,39.509,24.246,48.298,10.681c8.77-13.589-20.351-37.45-25.746-43.599 c-5.396-6.149-10.004-24.199-10.004-24.199c-21.826-52.487-44.239-8.014-54.671-0.362c-10.432,7.652-59.583,15.671-16.077,52.255 c0,0,15.832,9.818,20.077,16.811c4.244,6.993,18.256,41.937,33.835,37.63C445.261,601.609,404.594,578.25,433.972,556.701z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.8063 -0.5914 0.5914 0.8063 -241.6312 341.3208)",fill:"#F6B2B5",cx:"400.401",cy:"539.645",rx:"7.673",ry:"4.58"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.9836 -0.1805 0.1805 0.9836 -88.297 80.0912)",fill:"#231F20",cx:"396.015",cy:"525.307",rx:"10.618",ry:"11.718"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"396.439",cy:"519.46",r:"3.034"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.8063 -0.5914 0.5914 0.8063 -224.4308 353.6397)",fill:"#F6B2B5",cx:"427.813",cy:"519.539",rx:"7.673",ry:"4.58"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.4676 -0.884 0.884 0.4676 -230.5689 639.3182)",fill:"#231F20",cx:"415.43",cy:"511.06",rx:"10.618",ry:"11.718"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"414.954",cy:"505.88",r:"3.034"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#890D03",d:"M428.568,527.911c6.174,8.418,6.655,18.578,1.067,22.676s-15.134,0.588-21.308-7.829L428.568,527.911z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#D21306",d:"M424.425,543.785c-2.974,2.181-4.996,4.956-5.695,7.423c4.01,1.595,7.979,1.525,10.881-0.604 c2.854-2.093,4.125-5.792,3.854-9.983C430.88,540.416,427.495,541.534,424.425,543.785z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"418.057",cy:"485.973",r:"4.699"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"428.103",cy:"484.432",r:"2.35"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"178",y:"368.167",fill:"none",width:"412.667",height:"98.167"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"still"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M178.351,386.689l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.371-8.8,6.371C183.426,388.632,180.24,387.849,178.351,386.689z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M201.11,374.245h-5.534v-4.94h17.438v4.94h-5.534V388.2h-6.37V374.245z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M214.665,369.305h6.37V388.2h-6.37V369.305z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M224.115,369.305h6.37v13.956h8.53v4.939h-14.9V369.305z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M240.773,369.305h6.37v13.956h8.53v4.939h-14.9V369.305z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M257.244,384.961c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455 c0,2.052-1.539,3.509-3.563,3.509S257.244,387.013,257.244,384.961z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M305.294,369.305l-6.046,18.895h-6.829l-3.05-10.095l-3.212,10.095h-6.829l-6.046-18.895h6.559 l3.293,10.743l3.482-10.743h5.857l3.293,10.878l3.482-10.878H305.294z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M322.417,383.396v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H322.417z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M337.08,374.245h-5.534v-4.94h17.438v4.94h-5.534V388.2h-6.37V374.245z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M369.26,369.305V388.2h-6.37v-6.964h-5.885v6.964h-6.37v-18.895h6.37V376h5.885v-6.694H369.26z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M372.342,369.305h6.37V388.2h-6.37V369.305z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M400.417,369.305V388.2h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H400.417z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M411.192,381.938l-1.431,1.592v4.67H403.5v-18.895h6.262v6.856l6.208-6.856h6.937l-7.558,8.314 l7.936,10.581h-7.369L411.192,381.938z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M443.483,381.344v6.856h-6.37v-6.937l-7.126-11.958h6.721l3.86,6.532l3.887-6.532h6.154L443.483,381.344z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M449.858,378.753c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S449.858,384.475,449.858,378.753z M464.758,378.753c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C462.869,383.477,464.758,381.695,464.758,378.753z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M473.348,379.697v-10.392h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 v-10.203h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C476.749,388.632,473.348,385.366,473.348,379.697z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M515.653,384.907h-7.18l-1.269,3.293h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L515.653,384.907z M513.898,380.318l-1.835-4.751l-1.835,4.751H513.898z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M532.637,383.45h-1.728v4.75h-6.37v-18.895h9.097c5.264,0,8.611,2.753,8.611,7.126 c0,2.727-1.296,4.778-3.563,5.938l3.968,5.831h-6.802L532.637,383.45z M533.231,374.218h-2.322v4.427h2.322 c1.754,0,2.591-0.836,2.591-2.213C535.823,375.055,534.986,374.218,533.231,374.218z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M560.364,383.396v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H560.364z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M196.409,420.6l-0.054-8.611l-4.103,6.91h-2.808l-4.103-6.613v8.314h-5.804v-18.895h5.237l6.154,10.068 l5.992-10.068h5.237l0.054,18.895H196.409z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M218.172,417.307h-7.18l-1.269,3.293h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L218.172,417.307z M216.417,412.718l-1.835-4.751l-1.835,4.751H216.417z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M234.751,414.338l-1.431,1.592v4.67h-6.262v-18.895h6.262v6.856l6.208-6.856h6.937l-7.558,8.314 l7.936,10.581h-7.369L234.751,414.338z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M247.713,401.705h6.37V420.6h-6.37V401.705z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M275.788,401.705V420.6h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H275.788z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M291.368,410.64h5.534v7.99c-2.294,1.566-5.453,2.402-8.233,2.402c-6.1,0-10.554-4.076-10.554-9.879 c0-5.804,4.454-9.879,10.689-9.879c3.725,0,6.721,1.295,8.638,3.644l-4.076,3.59c-1.188-1.376-2.564-2.079-4.238-2.079 c-2.807,0-4.589,1.809-4.589,4.724c0,2.834,1.782,4.724,4.508,4.724c0.783,0,1.539-0.135,2.321-0.459V410.64z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M320.608,417.307h-7.18l-1.269,3.293h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L320.608,417.307z M318.854,412.718l-1.835-4.751l-1.835,4.751H318.854z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M354.465,420.6l-0.054-8.611l-4.103,6.91h-2.807l-4.103-6.613v8.314h-5.803v-18.895h5.237l6.154,10.068 l5.992-10.068h5.237l0.054,18.895H354.465z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M363.353,401.705h6.37V420.6h-6.37V401.705z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M371.615,419.088l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.37-8.8,6.37C376.689,421.032,373.504,420.249,371.615,419.088z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M394.374,406.645h-5.534v-4.94h17.438v4.94h-5.534V420.6h-6.37V406.645z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M419.86,417.307h-7.18l-1.269,3.293h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L419.86,417.307z M418.105,412.718l-1.835-4.751l-1.835,4.751H418.105z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M436.439,414.338l-1.431,1.592v4.67h-6.262v-18.895h6.262v6.856l6.208-6.856h6.937l-7.558,8.314 l7.936,10.581h-7.369L436.439,414.338z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M465.111,415.795v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H465.111z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M466.627,401.705h7.288l-1.215,11.661h-4.858L466.627,401.705z M466.708,417.631 c0-1.809,1.458-3.185,3.563-3.185s3.563,1.376,3.563,3.185c0,1.782-1.458,3.239-3.563,3.239S466.708,419.413,466.708,417.631z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M484.15,401.705h6.37v13.956h8.53v4.939h-14.9V401.705z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M499.783,411.153c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S499.783,416.875,499.783,411.153z M514.683,411.153c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C512.793,415.876,514.683,414.095,514.683,411.153z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M522.679,411.153c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S522.679,416.875,522.679,411.153z M537.579,411.153c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C535.689,415.876,537.579,414.095,537.579,411.153z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M554.023,414.338l-1.431,1.592v4.67h-6.262v-18.895h6.262v6.856l6.208-6.856h6.937l-7.558,8.314 l7.936,10.581h-7.369L554.023,414.338z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M192.414,449.707h-7.18L183.965,453h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L192.414,449.707z M190.66,445.118l-1.835-4.751l-1.835,4.751H190.66z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M204.459,439.045h-5.534v-4.94h17.438v4.94h-5.534V453h-6.37V439.045z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M238.989,449.707h-7.18L230.54,453h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L238.989,449.707z M237.234,445.118l-1.835-4.751l-1.835,4.751H237.234z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M247.875,434.105h6.37v13.956h8.53V453h-14.9V434.105z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M264.534,434.105h6.37v13.956h8.53V453h-14.9V434.105z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M293.396,439.045h-5.534v-4.94h17.438v4.94h-5.534V453h-6.37V439.045z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M325.575,434.105V453h-6.37v-6.964h-5.885V453h-6.37v-18.895h6.37v6.694h5.885v-6.694H325.575z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M344.368,448.195V453h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H344.368z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M354.172,443.553c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C358.626,453.432,354.172,449.356,354.172,443.553 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M373.855,443.553c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S373.855,449.275,373.855,443.553z M388.755,443.553c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C386.866,448.276,388.755,446.495,388.755,443.553z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M396.751,443.553c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S396.751,449.275,396.751,443.553z M411.651,443.553c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C409.762,448.276,411.651,446.495,411.651,443.553z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M420.403,434.105h6.37v13.956h8.53V453h-14.9V434.105z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M443.974,451.488l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.371-8.8,6.371C449.049,453.432,445.863,452.649,443.974,451.488z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M466.733,439.045H461.2v-4.94h17.438v4.94h-5.534V453h-6.37V439.045z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M479.856,444.497v-10.392h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 v-10.203h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C483.258,453.432,479.856,450.166,479.856,444.497z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M507.557,438.91v3.239h7.882v4.805h-7.882V453h-6.37v-18.895h15.359v4.805H507.557z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M524.944,438.91v3.239h7.882v4.805h-7.882V453h-6.37v-18.895h15.359v4.805H524.944z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M535.557,434.105h7.288l-1.215,11.661h-4.858L535.557,434.105z M535.638,450.031 c0-1.809,1.458-3.185,3.563-3.185s3.563,1.376,3.563,3.185c0,1.782-1.458,3.239-3.563,3.239S535.638,451.813,535.638,450.031z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"b2_x5F_b",className:"darkPatternPulse",onClick:function onClick(e){return _this5.advance(2);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton_7_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M470,584.906v36.073c0,2.768-3.044,5.033-6.765,5.033H182.483c-3.721,0-6.765-2.265-6.765-5.033 v-36.073c0-2.768,3.044-5.033,6.765-5.033h280.752C466.955,579.872,470,582.138,470,584.906z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"175.333",y:"592.298",fill:"none",width:"233.333",height:"28.212"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"dontcare"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M208.623,593.357h8.717c5.913,0,9.981,3.36,9.981,8.844s-4.068,8.844-9.981,8.844h-8.717V593.357z M217.088,606.396c2.501,0,4.22-1.49,4.22-4.194s-1.718-4.194-4.22-4.194h-2.501v8.389H217.088z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M228.785,602.201c0-5.356,4.22-9.248,9.981-9.248s9.981,3.892,9.981,9.248c0,5.357-4.22,9.248-9.981,9.248 S228.785,607.559,228.785,602.201z M242.733,602.201c0-2.754-1.769-4.422-3.967-4.422s-3.967,1.668-3.967,4.422 s1.769,4.422,3.967,4.422S242.733,604.955,242.733,602.201z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M268.354,593.357v17.688h-4.902l-6.722-8.035v8.035h-5.812v-17.688h4.902l6.722,8.035v-8.035H268.354z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M276.968,595.277c0,0.809-0.101,1.415-0.985,3.311l-1.769,3.765h-3.538l1.264-4.271 c-1.011-0.479-1.643-1.465-1.643-2.805c0-1.971,1.415-3.234,3.335-3.234S276.968,593.307,276.968,595.277z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M283.258,597.981h-5.18v-4.624h16.324v4.624h-5.18v13.063h-5.963V597.981z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M302.813,602.201c0-5.433,4.169-9.248,9.854-9.248c3.462,0,6.191,1.264,7.935,3.537l-3.765,3.361 c-1.036-1.314-2.274-2.072-3.866-2.072c-2.476,0-4.144,1.718-4.144,4.422s1.668,4.422,4.144,4.422c1.592,0,2.83-0.758,3.866-2.072 l3.765,3.361c-1.744,2.274-4.473,3.537-7.935,3.537C306.983,611.449,302.813,607.634,302.813,602.201z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M334.12,607.963h-6.722l-1.188,3.082h-6.064l7.732-17.688h5.862l7.732,17.688h-6.166L334.12,607.963z M332.477,603.667l-1.718-4.447l-1.718,4.447H332.477z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M350.012,606.598h-1.617v4.447h-5.963v-17.688h8.516c4.927,0,8.061,2.577,8.061,6.671 c0,2.552-1.213,4.473-3.335,5.559l3.714,5.458h-6.368L350.012,606.598z M350.567,597.956h-2.173v4.145h2.173 c1.643,0,2.426-0.784,2.426-2.072C352.993,598.739,352.21,597.956,350.567,597.956z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M375.96,606.548v4.497h-14.706v-17.688h14.378v4.498h-8.516v2.071h7.479v4.296h-7.479v2.325H375.96z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"420.569,597 448.694,597 434.631,611.333 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"b2_x5F_o_1_",opacity:"0.68",fill:"#898989",points:"349.742,338.333 328.467,316.649 307.192,338.333  146.667,338.333 146.667,654.667 641.859,654.667 641.859,338.333 \t",className:"dpseq "+(this.state.currentUnit<=2?'hide':'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"b3",className:"dpseq "+(this.state.currentUnit<3?'hide':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"base_12_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_12_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_13_",x:"239.04",y:"253.512",fill:"#FFFFFF",width:"358.96",height:"316.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"248.202",y:"261.831",fill:"#CC0995",width:"340.635",height:"297.348"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#BF0060",points:"587.508,416.508 588.837,559.179 248.202,559.179 248.202,480 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"270.374",y:"283.345",fill:"none",width:"212.626",height:"194.321"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"noneed"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M290.537,284.484v18.895h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H290.537z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M292.864,293.932c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S292.864,299.654,292.864,293.932z M307.764,293.932c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C305.875,298.656,307.764,296.874,307.764,293.932z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M343.24,284.484v18.895h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H343.24z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M362.033,298.575v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H362.033z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M380.204,298.575v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H380.204z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M382.665,284.484h9.312c6.316,0,10.662,3.59,10.662,9.448s-4.346,9.447-10.662,9.447h-9.312V284.484z M391.707,298.413c2.672,0,4.508-1.592,4.508-4.48c0-2.889-1.835-4.481-4.508-4.481h-2.672v8.961H391.707z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M417.169,289.424h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V289.424z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M429.698,293.932c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S429.698,299.654,429.698,293.932z M444.598,293.932c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C442.708,298.656,444.598,296.874,444.598,293.932z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M290.537,330.57c0,3.293-2.78,5.209-7.99,5.209h-10.635v-18.895h10.095c5.21,0,7.639,2.079,7.639,4.94 c0,1.754-0.891,3.212-2.618,4.076C289.242,326.71,290.537,328.329,290.537,330.57z M278.174,321.338v2.807h2.969 c1.431,0,2.079-0.486,2.079-1.404c0-0.917-0.648-1.403-2.079-1.403H278.174z M284.113,329.841c0-0.972-0.702-1.484-2.105-1.484 h-3.833v2.969h3.833C283.411,331.326,284.113,330.813,284.113,329.841z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M308.493,330.975v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H308.493z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M327.151,331.029h-1.728v4.75h-6.37v-18.895h9.097c5.264,0,8.611,2.753,8.611,7.126 c0,2.727-1.296,4.778-3.563,5.938l3.968,5.831h-6.802L327.151,331.029z M327.746,321.797h-2.322v4.427h2.322 c1.754,0,2.591-0.836,2.591-2.213C330.337,322.634,329.5,321.797,327.746,321.797z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M339.006,327.276v-10.392h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 v-10.203h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C342.408,336.211,339.006,332.945,339.006,327.276z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M360.336,316.884h9.312c6.316,0,10.662,3.59,10.662,9.448s-4.346,9.447-10.662,9.447h-9.312V316.884z M369.379,330.813c2.672,0,4.508-1.592,4.508-4.48c0-2.889-1.835-4.481-4.508-4.481h-2.672v8.961H369.379z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M398.348,330.975v4.805h-15.71v-18.895h15.359v4.805H388.9v2.213h7.99v4.589h-7.99v2.483H398.348z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M400.081,332.54c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455c0,2.052-1.539,3.509-3.563,3.509 S400.081,334.592,400.081,332.54z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M271.912,349.284h6.37v13.956h8.53v4.939h-14.9V349.284z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M287.545,358.732c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S287.545,364.454,287.545,358.732z M302.445,358.732c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C300.556,363.456,302.445,361.674,302.445,358.732z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M310.441,358.732c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S310.441,364.454,310.441,358.732z M325.341,358.732c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C323.452,363.456,325.341,361.674,325.341,358.732z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M341.786,361.917l-1.431,1.592v4.67h-6.262v-18.895h6.262v6.856l6.208-6.856h6.937l-7.558,8.314 l7.936,10.581h-7.369L341.786,361.917z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M360.875,364.94c0,0.864-0.108,1.512-1.053,3.536l-1.89,4.022h-3.779l1.35-4.562 c-1.08-0.513-1.754-1.565-1.754-2.996c0-2.105,1.511-3.455,3.563-3.455C359.363,361.485,360.875,362.835,360.875,364.94z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M382.284,361.323v6.856h-6.37v-6.937l-7.126-11.958h6.721l3.86,6.532l3.887-6.532h6.154L382.284,361.323z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M388.659,358.732c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S388.659,364.454,388.659,358.732z M403.559,358.732c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C401.67,363.456,403.559,361.674,403.559,358.732z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M412.149,359.676v-10.392h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 v-10.203h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C415.55,368.611,412.149,365.345,412.149,359.676z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M439.606,351.335c0,0.864-0.108,1.512-1.053,3.536l-1.89,4.022h-3.779l1.35-4.562 c-1.08-0.513-1.754-1.566-1.754-2.997c0-2.105,1.511-3.455,3.563-3.455C438.095,347.88,439.606,349.23,439.606,351.335z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M449.784,363.428h-1.728v4.751h-6.37v-18.895h9.097c5.264,0,8.611,2.753,8.611,7.126 c0,2.727-1.296,4.778-3.563,5.938l3.968,5.831h-6.802L449.784,363.428z M450.378,354.197h-2.322v4.427h2.322 c1.754,0,2.591-0.836,2.591-2.213C452.97,355.034,452.133,354.197,450.378,354.197z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M477.511,363.375v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H477.511z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M271.75,392.077v-10.392h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 v-10.203h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C275.151,401.011,271.75,397.745,271.75,392.077z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M310.788,388.811c0,4.373-3.347,7.126-8.611,7.126h-2.727v4.643h-6.37v-18.895h9.097 C307.44,381.685,310.788,384.438,310.788,388.811z M304.363,388.811c0-1.376-0.837-2.213-2.591-2.213h-2.322v4.427h2.322 C303.526,391.024,304.363,390.188,304.363,388.811z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M311.954,399.068l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.37-8.8,6.37C317.028,401.011,313.843,400.229,311.954,399.068z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M346.59,395.775v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H346.59z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M353.154,386.625h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V386.625z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M371.082,386.625h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V386.625z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M384.636,381.685h6.37v18.895h-6.37V381.685z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M412.711,381.685v18.895h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H412.711z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M428.291,390.619h5.534v7.99c-2.294,1.566-5.453,2.402-8.233,2.402c-6.1,0-10.554-4.076-10.554-9.879 c0-5.804,4.454-9.879,10.689-9.879c3.725,0,6.721,1.295,8.638,3.644l-4.076,3.59c-1.188-1.376-2.564-2.079-4.238-2.079 c-2.807,0-4.589,1.809-4.589,4.724c0,2.834,1.782,4.724,4.508,4.724c0.783,0,1.539-0.135,2.321-0.459V390.619z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M290.537,427.77c0,3.293-2.78,5.209-7.99,5.209h-10.635v-18.895h10.095c5.21,0,7.639,2.079,7.639,4.94 c0,1.754-0.891,3.212-2.618,4.076C289.242,423.91,290.537,425.529,290.537,427.77z M278.174,418.539v2.807h2.969 c1.431,0,2.079-0.486,2.079-1.404c0-0.917-0.648-1.403-2.079-1.403H278.174z M284.113,427.041c0-0.972-0.702-1.484-2.105-1.484 h-3.833v2.969h3.833C283.411,428.526,284.113,428.013,284.113,427.041z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M292.027,423.532c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S292.027,429.254,292.027,423.532z M306.927,423.532c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C305.038,428.256,306.927,426.474,306.927,423.532z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M326.962,432.98l-3.266-5.048l-3.186,5.048h-7.261l6.829-9.528l-6.586-9.367h7.153l3.212,4.751l3.131-4.751 h6.856l-6.559,9.124l6.964,9.771H326.962z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M347.536,432.98l-3.266-5.048l-3.186,5.048h-7.261l6.829-9.528l-6.586-9.367h7.153l3.212,4.751l3.131-4.751 h6.856l-6.559,9.124l6.964,9.771H347.536z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M355.612,414.085h6.37v18.895h-6.37V414.085z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M380.772,428.175v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H380.772z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M382.504,429.74c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455c0,2.052-1.539,3.509-3.563,3.509 S382.504,431.792,382.504,429.74z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M390.711,429.74c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455c0,2.052-1.539,3.509-3.563,3.509 S390.711,431.792,390.711,429.74z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M398.919,429.74c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455c0,2.052-1.539,3.509-3.563,3.509 S398.919,431.792,398.919,429.74z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"409.641,565.828 460.04,565.828 434.841,591.512 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#BF0060",d:"M574.63,381.59l1.897,2.865l1.248-0.919c0,0-1.155-5.514-1.419-5.509s-6.348,0.195-6.348,0.195 l-0.89,1.729l-0.601-1.148l-2.386-0.747l-2.117,0.636l-14.349-6.646l8.817-6.025l-11.565-2.346l8.565-7.654l-14.25,6.5 l-18.594,13.438l-3.906-2.188l-1.573,0.038l4.965-11.806l-4.275-0.832l0.008-0.025l-19.75-4l-8.75,24.75l19.5,7.5l3.171-9.954 l0.954,0.079l1.84,2.086l-3.34,2.414l0.5,14.875l3.772-7.904l1,1.632l-1.565,15.504l-1.041,0.729l-0.667,3.333l0.702,0.855 l-3.619,1.56l-0.833,5.5l1.75,2.167l1.583-0.5l-1.083-2.833l1.417-2.667l5.5,0.083l0.917,2.667l-2.167,2.667l1.25,0.917 c0,0,4.917-2.75,4.833-3c-0.083-0.25-2.083-6-2.083-6l-1.916-0.332l0.916-0.916v-2.5l-1.24-1.83l1.195-9.121l7.502,12.241 l9.125-5.682v4.182l2.135-2.463l0.839,5.641c-3.395,1.115-5.849,4.305-5.849,8.073c0,4.694,3.806,8.5,8.5,8.5 c4.694,0,8.5-3.806,8.5-8.5c0-3.364-1.959-6.263-4.794-7.641l2.62-12.247l0.549,0.137l-0.085-2.305l0.245-1.146l5.84-1.549 l-2.98-0.347l9.48-5.903l-8.461-11.029l9.079,3.882l0.384,1.211l2.982,1.632l1.026-0.415l0.407,3.92l5,2.439l2.591-1.023 l-0.004-1.66l-3.028,0.187l-2.122-2.149l1.723-5.224L574.63,381.59z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"500.875,373.94 505.625,371.065 505.5,373.315 503.812,374.315 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"498.417,375.919 496,380.419 498.667,379.502 499.417,377.169 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"b3_x5F_b",className:"darkPatternPulse",onClick:function onClick(e){return _this5.advance(3);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton_8_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M562.374,500.085v36.073c0,2.768-3.044,5.033-6.765,5.033H274.856c-3.721,0-6.765-2.265-6.765-5.033 v-36.073c0-2.768,3.044-5.033,6.765-5.033h280.752C559.329,495.051,562.374,497.317,562.374,500.085z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"277.715",y:"511.48",fill:"none",width:"233.333",height:"28.212"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"unsubscribenow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M288.942,519.593v-7.314h4.483v7.181c0,2.033,0.779,2.792,2.033,2.792s2.033-0.76,2.033-2.792v-7.181h4.407 v7.314c0,3.989-2.394,6.288-6.478,6.288S288.942,523.583,288.942,519.593z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M317.06,512.279v13.298h-3.686l-5.053-6.041v6.041h-4.369v-13.298h3.685l5.054,6.041v-6.041H317.06z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M318.392,524.513l1.444-3.268c1.253,0.741,2.925,1.216,4.388,1.216c1.273,0,1.729-0.266,1.729-0.722 c0-1.672-7.352-0.323-7.352-5.281c0-2.47,2.071-4.483,6.193-4.483c1.786,0,3.628,0.38,5.015,1.159l-1.349,3.249 c-1.311-0.665-2.545-0.988-3.705-0.988c-1.311,0-1.729,0.38-1.729,0.836c0,1.596,7.352,0.266,7.352,5.167 c0,2.432-2.071,4.483-6.193,4.483C321.963,525.881,319.722,525.33,318.392,524.513z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M331.597,519.593v-7.314h4.483v7.181c0,2.033,0.779,2.792,2.033,2.792s2.033-0.76,2.033-2.792v-7.181h4.407 v7.314c0,3.989-2.394,6.288-6.478,6.288S331.597,523.583,331.597,519.593z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M359.715,521.911c0,2.318-1.957,3.667-5.623,3.667h-7.485v-13.298h7.105c3.666,0,5.376,1.462,5.376,3.476 c0,1.235-0.627,2.261-1.843,2.869C358.803,519.194,359.715,520.334,359.715,521.911z M351.014,515.414v1.976h2.09 c1.007,0,1.462-0.342,1.462-0.988s-0.456-0.988-1.462-0.988H351.014z M355.193,521.398c0-0.684-0.494-1.045-1.481-1.045h-2.698 v2.089h2.698C354.7,522.442,355.193,522.082,355.193,521.398z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M360.458,524.513l1.444-3.268c1.253,0.741,2.925,1.216,4.388,1.216c1.273,0,1.729-0.266,1.729-0.722 c0-1.672-7.352-0.323-7.352-5.281c0-2.47,2.071-4.483,6.193-4.483c1.786,0,3.628,0.38,5.015,1.159l-1.349,3.249 c-1.311-0.665-2.545-0.988-3.705-0.988c-1.311,0-1.729,0.38-1.729,0.836c0,1.596,7.352,0.266,7.352,5.167 c0,2.432-2.071,4.483-6.193,4.483C364.029,525.881,361.788,525.33,360.458,524.513z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M373.245,518.928c0-4.084,3.135-6.953,7.409-6.953c2.603,0,4.654,0.95,5.965,2.66l-2.831,2.527 c-0.779-0.988-1.709-1.558-2.906-1.558c-1.862,0-3.116,1.292-3.116,3.325s1.254,3.324,3.116,3.324c1.197,0,2.127-0.57,2.906-1.558 l2.831,2.527c-1.311,1.709-3.362,2.659-5.965,2.659C376.379,525.881,373.245,523.013,373.245,518.928z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M393.612,522.233h-1.216v3.344h-4.483v-13.298h6.402c3.705,0,6.06,1.938,6.06,5.015 c0,1.918-0.912,3.362-2.507,4.179l2.792,4.104h-4.788L393.612,522.233z M394.029,515.737h-1.633v3.115h1.633 c1.235,0,1.824-0.589,1.824-1.558S395.264,515.737,394.029,515.737z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M402.067,512.279h4.483v13.298h-4.483V512.279z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M421.825,521.911c0,2.318-1.957,3.667-5.623,3.667h-7.485v-13.298h7.105c3.666,0,5.376,1.462,5.376,3.476 c0,1.235-0.627,2.261-1.843,2.869C420.913,519.194,421.825,520.334,421.825,521.911z M413.125,515.414v1.976h2.09 c1.007,0,1.462-0.342,1.462-0.988s-0.456-0.988-1.462-0.988H413.125z M417.304,521.398c0-0.684-0.494-1.045-1.481-1.045h-2.698 v2.089h2.698C416.81,522.442,417.304,522.082,417.304,521.398z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M434.46,522.196v3.381h-11.056v-13.298h10.809v3.381h-6.402v1.558h5.623v3.229h-5.623v1.748H434.46z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M454.999,512.279v13.298h-3.686l-5.053-6.041v6.041h-4.369v-13.298h3.685l5.054,6.041v-6.041H454.999z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M456.634,518.928c0-4.027,3.173-6.953,7.504-6.953c4.332,0,7.504,2.926,7.504,6.953 s-3.172,6.953-7.504,6.953C459.807,525.881,456.634,522.956,456.634,518.928z M467.121,518.928c0-2.071-1.33-3.325-2.983-3.325 s-2.982,1.254-2.982,3.325s1.33,3.324,2.982,3.324S467.121,520.999,467.121,518.928z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M494.441,512.279l-4.255,13.298h-4.806l-2.147-7.105l-2.261,7.105h-4.806l-4.255-13.298h4.616l2.318,7.561 l2.451-7.561h4.122l2.318,7.656l2.451-7.656H494.441z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M495.242,512.279h5.129l-0.855,8.207h-3.419L495.242,512.279z M495.299,523.487 c0-1.272,1.026-2.242,2.507-2.242c1.482,0,2.508,0.969,2.508,2.242c0,1.254-1.026,2.28-2.508,2.28 C496.325,525.767,495.299,524.741,495.299,523.487z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"523.829,514.667 542.191,514.667 533.01,524.024 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"b3_x5F_o_1_",opacity:"0.68",fill:"#898989",points:"413.616,569.828 434.892,591.512 456.167,569.828 598,569.828  598,253.495 239.04,253.495 239.04,569.828 \t",className:"dpseq "+(this.state.currentUnit<=3?'hide':'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"b4",className:"dpseq "+(this.state.currentUnit<4?'hide':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"base_11_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_11_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_12_",x:"100.508",y:"273.15",fill:"#FFFFFF",width:"358.96",height:"210.249"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"109.67",y:"281.469",fill:"#D10000",width:"340.635",height:"191.263"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C60000",points:"448.975,330.061 450.304,472.732 109.67,472.732 109.67,367.553 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"131.841",y:"302.983",fill:"none",width:"306.825",height:"100.017"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"idontlike"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M133.38,304.122h6.37v18.895h-6.37V304.122z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M150.929,304.122h9.312c6.316,0,10.662,3.59,10.662,9.448s-4.346,9.447-10.662,9.447h-9.312V304.122z M159.972,318.05c2.672,0,4.508-1.592,4.508-4.48c0-2.889-1.835-4.481-4.508-4.481h-2.672v8.961H159.972z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M172.475,313.569c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S172.475,319.292,172.475,313.569z M187.375,313.569c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C185.486,318.293,187.375,316.511,187.375,313.569z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M214.752,304.122v18.895h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H214.752z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M223.962,306.173c0,0.863-0.108,1.511-1.053,3.536l-1.89,4.022h-3.779l1.35-4.562 c-1.08-0.513-1.754-1.566-1.754-2.996c0-2.105,1.511-3.455,3.563-3.455C222.45,302.718,223.962,304.068,223.962,306.173z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M230.685,309.062h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V309.062z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M252.339,304.122h6.37v13.956h8.53v4.939h-14.9V304.122z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M268.998,304.122h6.37v18.895h-6.37V304.122z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M286.14,316.754l-1.431,1.592v4.67h-6.262v-18.895h6.262v6.856l6.208-6.856h6.937l-7.558,8.314 l7.936,10.581h-7.369L286.14,316.754z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M314.812,318.212v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H314.812z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M336.602,316.161v6.856h-6.37v-6.937l-7.126-11.958h6.721l3.86,6.532l3.887-6.532h6.154L336.602,316.161z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M342.977,313.569c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S342.977,319.292,342.977,313.569z M357.877,313.569c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C355.988,318.293,357.877,316.511,357.877,313.569z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M366.466,314.514v-10.392h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 v-10.203h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C369.868,323.449,366.466,320.182,366.466,314.514z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M395.894,318.266h-1.728v4.75h-6.37v-18.895h9.097c5.264,0,8.611,2.753,8.611,7.126 c0,2.727-1.296,4.778-3.563,5.938l3.968,5.831h-6.802L395.894,318.266z M396.488,309.034h-2.322v4.427h2.322 c1.754,0,2.591-0.836,2.591-2.213C399.08,309.871,398.243,309.034,396.488,309.034z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M137.483,341.461h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V341.461z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M150.012,345.969c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S150.012,351.691,150.012,345.969z M164.912,345.969c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C163.022,350.693,164.912,348.911,164.912,345.969z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M192.289,336.522v18.895h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H192.289z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M211.081,350.612v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H211.081z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M212.813,352.177c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455 c0,2.052-1.539,3.509-3.563,3.509S212.813,354.229,212.813,352.177z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M228.932,353.905l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.37-8.8,6.37C234.006,355.848,230.821,355.065,228.932,353.905z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M260.733,352.124h-7.18l-1.269,3.293h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L260.733,352.124z M258.979,347.535l-1.835-4.751l-1.835,4.751H258.979z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M279.634,348.561v6.856h-6.37v-6.937l-7.126-11.958h6.721l3.86,6.532l3.887-6.532h6.154L279.634,348.561z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M299.778,341.461h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V341.461z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M331.958,336.522v18.895h-6.37v-6.964h-5.885v6.964h-6.37v-18.895h6.37v6.694h5.885v-6.694H331.958z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M350.75,350.612v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H350.75z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M150.25,387.816l-0.054-8.611l-4.103,6.91h-2.808l-4.103-6.613v8.314h-5.804v-18.895h5.237l6.154,10.068 l5.992-10.068H156l0.054,18.895H150.25z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M172.013,384.523h-7.18l-1.269,3.293h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L172.013,384.523z M170.259,379.935l-1.835-4.751l-1.835,4.751H170.259z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M193.127,377.856h5.534v7.99c-2.294,1.566-5.453,2.403-8.233,2.403c-6.1,0-10.554-4.076-10.554-9.879 c0-5.804,4.454-9.879,10.689-9.879c3.725,0,6.721,1.295,8.638,3.644l-4.076,3.59c-1.188-1.376-2.564-2.079-4.238-2.079 c-2.807,0-4.589,1.809-4.589,4.724c0,2.834,1.782,4.724,4.508,4.724c0.783,0,1.539-0.135,2.321-0.459V377.856z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M201.393,368.921h6.37v18.895h-6.37V368.921z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M210.086,378.369c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C214.541,388.249,210.086,384.172,210.086,378.369 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M269.774,368.921l-6.046,18.895h-6.829l-3.05-10.095l-3.212,10.095h-6.829l-6.046-18.895h6.559 l3.293,10.743l3.482-10.743h5.857l3.293,10.878l3.482-10.878H269.774z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M270.161,378.369c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S270.161,384.091,270.161,378.369z M285.061,378.369c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C283.172,383.093,285.061,381.311,285.061,378.369z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M301.911,383.066h-1.728v4.75h-6.37v-18.895h9.097c5.264,0,8.611,2.753,8.611,7.126 c0,2.727-1.296,4.778-3.563,5.938l3.968,5.831h-6.802L301.911,383.066z M302.505,373.834h-2.322v4.427h2.322 c1.754,0,2.591-0.836,2.591-2.213C305.096,374.671,304.259,373.834,302.505,373.834z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M313.928,368.921h9.312c6.316,0,10.662,3.59,10.662,9.448s-4.346,9.447-10.662,9.447h-9.312V368.921z M322.97,382.85c2.672,0,4.508-1.592,4.508-4.48c0-2.889-1.835-4.481-4.508-4.481h-2.672v8.961H322.97z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M334.691,384.577c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455 c0,2.052-1.539,3.509-3.563,3.509S334.691,386.629,334.691,384.577z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"271.108,479.381 321.508,479.381 296.308,505.065 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"b4_x5F_b",className:"darkPatternPulse",onClick:function onClick(e){return _this5.advance(4);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton_9_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M423.841,413.638v36.073c0,2.768-3.044,5.033-6.765,5.033H136.324c-3.721,0-6.765-2.265-6.765-5.033 v-36.073c0-2.768,3.044-5.033,6.765-5.033h280.752C420.796,408.604,423.841,410.87,423.841,413.638z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"139.183",y:"425.033",fill:"none",width:"233.333",height:"28.212"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"unsubscribeplease"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M144.116,432.716v-6.932h4.249v6.806c0,1.927,0.738,2.647,1.927,2.647s1.926-0.72,1.926-2.647v-6.806h4.177 v6.932c0,3.781-2.269,5.96-6.14,5.96S144.116,436.498,144.116,432.716z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M170.76,425.784v12.604h-3.493l-4.79-5.726v5.726h-4.141v-12.604h3.493l4.789,5.726v-5.726H170.76z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M172.015,437.38l1.369-3.097c1.188,0.702,2.773,1.152,4.159,1.152c1.207,0,1.639-0.252,1.639-0.685 c0-1.584-6.968-0.306-6.968-5.005c0-2.341,1.962-4.25,5.87-4.25c1.692,0,3.439,0.36,4.753,1.099l-1.278,3.079 c-1.242-0.63-2.413-0.937-3.511-0.937c-1.242,0-1.638,0.36-1.638,0.792c0,1.513,6.968,0.252,6.968,4.897 c0,2.305-1.963,4.25-5.87,4.25C175.4,438.676,173.276,438.154,172.015,437.38z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M184.526,432.716v-6.932h4.249v6.806c0,1.927,0.738,2.647,1.927,2.647c1.188,0,1.926-0.72,1.926-2.647 v-6.806h4.177v6.932c0,3.781-2.269,5.96-6.14,5.96S184.526,436.498,184.526,432.716z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M211.169,434.913c0,2.197-1.855,3.475-5.33,3.475h-7.094v-12.604h6.734c3.475,0,5.096,1.387,5.096,3.295 c0,1.17-0.594,2.143-1.747,2.719C210.305,432.338,211.169,433.419,211.169,434.913z M202.923,428.755v1.873h1.98 c0.954,0,1.387-0.324,1.387-0.937c0-0.612-0.433-0.936-1.387-0.936H202.923z M206.884,434.427c0-0.648-0.468-0.99-1.404-0.99 h-2.557v1.981h2.557C206.416,435.418,206.884,435.075,206.884,434.427z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M211.867,437.38l1.369-3.097c1.188,0.702,2.773,1.152,4.159,1.152c1.207,0,1.639-0.252,1.639-0.685 c0-1.584-6.968-0.306-6.968-5.005c0-2.341,1.962-4.25,5.87-4.25c1.693,0,3.439,0.36,4.753,1.099l-1.278,3.079 c-1.242-0.63-2.413-0.937-3.511-0.937c-1.243,0-1.639,0.36-1.639,0.792c0,1.513,6.968,0.252,6.968,4.897 c0,2.305-1.962,4.25-5.87,4.25C215.252,438.676,213.128,438.154,211.867,437.38z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M223.981,432.086c0-3.871,2.971-6.59,7.022-6.59c2.467,0,4.411,0.9,5.653,2.521l-2.683,2.395 c-0.738-0.936-1.621-1.476-2.755-1.476c-1.765,0-2.953,1.224-2.953,3.151c0,1.926,1.188,3.151,2.953,3.151 c1.134,0,2.017-0.54,2.755-1.477l2.683,2.395c-1.242,1.621-3.187,2.521-5.653,2.521 C226.953,438.676,223.981,435.958,223.981,432.086z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M243.279,435.219h-1.152v3.169h-4.249v-12.604h6.068c3.511,0,5.744,1.837,5.744,4.754 c0,1.818-0.864,3.187-2.377,3.961l2.647,3.889h-4.537L243.279,435.219z M243.675,429.062h-1.549v2.953h1.549 c1.17,0,1.729-0.558,1.729-1.476C245.404,429.62,244.846,429.062,243.675,429.062z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M251.287,425.784h4.249v12.604h-4.249V425.784z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M270.011,434.913c0,2.197-1.854,3.475-5.33,3.475h-7.094v-12.604h6.734c3.475,0,5.096,1.387,5.096,3.295 c0,1.17-0.594,2.143-1.747,2.719C269.146,432.338,270.011,433.419,270.011,434.913z M261.764,428.755v1.873h1.98 c0.955,0,1.386-0.324,1.386-0.937c0-0.612-0.432-0.936-1.386-0.936H261.764z M265.725,434.427c0-0.648-0.468-0.99-1.404-0.99 h-2.557v1.981h2.557C265.257,435.418,265.725,435.075,265.725,434.427z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M281.98,435.183v3.205h-10.479v-12.604h10.245v3.205h-6.068v1.477h5.33v3.061h-5.33v1.656H281.98z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M287.882,436.228c0,0.576-0.072,1.008-0.703,2.359l-1.26,2.683h-2.521l0.9-3.043 c-0.72-0.342-1.17-1.044-1.17-1.999c0-1.404,1.009-2.305,2.377-2.305S287.882,434.823,287.882,436.228z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M306.478,430.538c0,2.917-2.233,4.753-5.744,4.753h-1.819v3.097h-4.249v-12.604h6.068 C304.245,425.784,306.478,427.621,306.478,430.538z M302.192,430.538c0-0.918-0.559-1.477-1.729-1.477h-1.549v2.953h1.549 C301.634,432.014,302.192,431.456,302.192,430.538z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M307.86,425.784h4.249v9.309h5.69v3.295h-9.939V425.784z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M329.445,435.183v3.205h-10.479v-12.604h10.245v3.205h-6.068v1.477h5.33v3.061h-5.33v1.656H329.445z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M339.668,436.191h-4.79l-0.846,2.197h-4.321l5.51-12.604h4.177l5.51,12.604h-4.394L339.668,436.191z M338.498,433.131l-1.224-3.169l-1.225,3.169H338.498z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M344.795,437.38l1.369-3.097c1.188,0.702,2.773,1.152,4.159,1.152c1.207,0,1.639-0.252,1.639-0.685 c0-1.584-6.968-0.306-6.968-5.005c0-2.341,1.962-4.25,5.87-4.25c1.692,0,3.439,0.36,4.753,1.099l-1.278,3.079 c-1.242-0.63-2.413-0.937-3.511-0.937c-1.242,0-1.638,0.36-1.638,0.792c0,1.513,6.968,0.252,6.968,4.897 c0,2.305-1.963,4.25-5.87,4.25C348.181,438.676,346.056,438.154,344.795,437.38z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M367.893,435.183v3.205h-10.479v-12.604h10.245v3.205h-6.068v1.477h5.33v3.061h-5.33v1.656H367.893z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"385.296,428.22 403.659,428.22 394.477,437.577 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"b4_x5F_o_1_",opacity:"0.68",fill:"#898989",points:"275.084,483.381 296.359,505.065 317.634,483.381  459.467,483.381 459.467,273.15 100.508,273.15 100.508,483.381 \t",className:"dpseq "+(this.state.currentUnit<=4?'hide':'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"b5",className:"dpseq "+(this.state.currentUnit<5?'hide':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"base_10_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_10_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_11_",x:"130.508",y:"183.15",fill:"#FFFFFF",width:"358.96",height:"210.249"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"139.67",y:"191.469",fill:"#006A6D",width:"340.635",height:"191.263"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#005B70",points:"480.304,240.061 480.304,382.732 139.67,382.732 139.67,277.553 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"161.841",y:"212.983",fill:"none",width:"306.825",height:"62.017"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"oncemore"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M162.624,223.569c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S162.624,229.292,162.624,223.569z M177.524,223.569c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C175.635,228.293,177.524,226.511,177.524,223.569z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M204.901,214.122v18.895h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H204.901z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M207.228,223.569c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C211.682,233.449,207.228,229.373,207.228,223.569 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M243.781,228.212v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H243.781z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M271.212,233.017l-0.054-8.611l-4.103,6.91h-2.808l-4.103-6.613v8.314h-5.804v-18.895h5.237l6.154,10.068 l5.992-10.068h5.237l0.054,18.895H271.212z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M279.344,223.569c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S279.344,229.292,279.344,223.569z M294.244,223.569c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C292.354,228.293,294.244,226.511,294.244,223.569z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M311.093,228.266h-1.728v4.75h-6.37v-18.895h9.097c5.264,0,8.611,2.753,8.611,7.126 c0,2.727-1.296,4.778-3.563,5.938l3.968,5.831h-6.802L311.093,228.266z M311.688,219.034h-2.322v4.427h2.322 c1.754,0,2.591-0.836,2.591-2.213C314.279,219.871,313.442,219.034,311.688,219.034z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M338.82,228.212v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H338.82z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M347.679,229.777c0,0.864-0.108,1.512-1.053,3.536l-1.89,4.022h-3.779l1.35-4.562 c-1.08-0.513-1.754-1.565-1.754-2.996c0-2.105,1.511-3.455,3.563-3.455C346.167,226.322,347.679,227.672,347.679,229.777z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M388.603,214.122l-6.046,18.895h-6.829l-3.05-10.095l-3.212,10.095h-6.829l-6.046-18.895h6.559 l3.293,10.743l3.482-10.743h5.857L379.075,225l3.482-10.878H388.603z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M390.015,214.122h6.37v18.895h-6.37V214.122z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M403.568,219.062h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V219.062z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M435.748,214.122v18.895h-6.37v-6.964h-5.885v6.964h-6.37v-18.895h6.37v6.694h5.885v-6.694H435.748z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M169.75,251.326v3.239h7.882v4.805h-7.882v6.046h-6.37v-18.895h15.359v4.805H169.75z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M196.478,260.612v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H196.478z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M214.648,260.612v4.805h-15.71v-18.895h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H214.648z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M217.109,246.522h6.37v13.956h8.53v4.939h-14.9V246.522z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M233.768,246.522h6.37v18.895h-6.37V246.522z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M261.843,246.522v18.895h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H261.843z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M277.423,255.456h5.534v7.99c-2.294,1.566-5.453,2.402-8.233,2.402c-6.1,0-10.554-4.076-10.554-9.879 c0-5.804,4.454-9.879,10.689-9.879c3.725,0,6.721,1.295,8.638,3.644l-4.076,3.59c-1.188-1.376-2.564-2.079-4.238-2.079 c-2.807,0-4.589,1.809-4.589,4.724c0,2.834,1.782,4.724,4.508,4.724c0.783,0,1.539-0.135,2.321-0.459V255.456z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M284.959,262.177c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455 c0,2.052-1.539,3.509-3.563,3.509S284.959,264.229,284.959,262.177z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M293.167,262.177c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455 c0,2.052-1.539,3.509-3.563,3.509S293.167,264.229,293.167,262.177z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M301.375,262.177c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455 c0,2.052-1.539,3.509-3.563,3.509S301.375,264.229,301.375,262.177z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"301.108,389.381 351.508,389.381 326.308,415.065 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"b5_x5F_b",className:"darkPatternPulse",onClick:function onClick(e){return _this5.advance(5);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton_10_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#66BA02",d:"M453.841,296.959v55.031c0,4.223-3.044,7.678-6.765,7.678H166.324c-3.721,0-6.765-3.455-6.765-7.678 v-55.031c0-4.223,3.044-7.678,6.765-7.678h280.752C450.796,289.28,453.841,292.736,453.841,296.959z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"185.333",y:"307.71",fill:"none",width:"243.333",height:"51.967"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"sugarontop"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M192.441,315.395v-6.932h4.249v6.806c0,1.927,0.738,2.647,1.927,2.647c1.188,0,1.926-0.72,1.926-2.647 v-6.806h4.177v6.932c0,3.781-2.269,5.96-6.14,5.96S192.441,319.176,192.441,315.395z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M219.084,308.463v12.604h-3.493l-4.79-5.726v5.726h-4.141v-12.604h3.493l4.789,5.726v-5.726H219.084z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M220.34,320.058l1.369-3.097c1.188,0.703,2.773,1.152,4.159,1.152c1.207,0,1.639-0.252,1.639-0.684 c0-1.584-6.968-0.306-6.968-5.005c0-2.341,1.962-4.249,5.87-4.249c1.693,0,3.439,0.36,4.753,1.098l-1.278,3.079 c-1.242-0.63-2.413-0.936-3.511-0.936c-1.243,0-1.639,0.36-1.639,0.792c0,1.512,6.968,0.252,6.968,4.897 c0,2.305-1.962,4.249-5.87,4.249C223.725,321.355,221.601,320.833,220.34,320.058z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M232.851,315.395v-6.932h4.249v6.806c0,1.927,0.738,2.647,1.927,2.647s1.926-0.72,1.926-2.647v-6.806h4.177 v6.932c0,3.781-2.269,5.96-6.14,5.96S232.851,319.176,232.851,315.395z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M259.494,317.591c0,2.197-1.854,3.475-5.33,3.475h-7.094v-12.604h6.734c3.475,0,5.096,1.386,5.096,3.295 c0,1.17-0.594,2.143-1.747,2.719C258.63,315.017,259.494,316.097,259.494,317.591z M251.248,311.434v1.873h1.98 c0.955,0,1.386-0.324,1.386-0.937c0-0.612-0.432-0.936-1.386-0.936H251.248z M255.208,317.105c0-0.648-0.468-0.991-1.404-0.991 h-2.557v1.981h2.557C254.741,318.096,255.208,317.753,255.208,317.105z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M260.192,320.058l1.369-3.097c1.188,0.703,2.773,1.152,4.159,1.152c1.207,0,1.639-0.252,1.639-0.684 c0-1.584-6.968-0.306-6.968-5.005c0-2.341,1.962-4.249,5.87-4.249c1.692,0,3.439,0.36,4.753,1.098l-1.278,3.079 c-1.242-0.63-2.413-0.936-3.511-0.936c-1.242,0-1.638,0.36-1.638,0.792c0,1.512,6.968,0.252,6.968,4.897 c0,2.305-1.963,4.249-5.87,4.249C263.577,321.355,261.453,320.833,260.192,320.058z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M272.306,314.765c0-3.871,2.971-6.59,7.022-6.59c2.466,0,4.411,0.9,5.653,2.521l-2.683,2.395 c-0.738-0.936-1.621-1.476-2.755-1.476c-1.765,0-2.953,1.224-2.953,3.151c0,1.926,1.188,3.151,2.953,3.151 c1.134,0,2.017-0.54,2.755-1.477l2.683,2.395c-1.242,1.62-3.187,2.521-5.653,2.521 C275.277,321.355,272.306,318.636,272.306,314.765z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M291.604,317.897h-1.152v3.169h-4.249v-12.604h6.068c3.511,0,5.744,1.836,5.744,4.753 c0,1.819-0.864,3.187-2.377,3.961l2.647,3.889h-4.538L291.604,317.897z M292,311.74h-1.549v2.953H292 c1.17,0,1.729-0.558,1.729-1.477C293.729,312.298,293.17,311.74,292,311.74z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M299.612,308.463h4.249v12.604h-4.249V308.463z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M318.336,317.591c0,2.197-1.854,3.475-5.33,3.475h-7.094v-12.604h6.734c3.475,0,5.096,1.386,5.096,3.295 c0,1.17-0.594,2.143-1.747,2.719C317.472,315.017,318.336,316.097,318.336,317.591z M310.089,311.434v1.873h1.98 c0.955,0,1.386-0.324,1.386-0.937c0-0.612-0.432-0.936-1.386-0.936H310.089z M314.05,317.105c0-0.648-0.468-0.991-1.404-0.991 h-2.557v1.981h2.557C313.583,318.096,314.05,317.753,314.05,317.105z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M330.305,317.861v3.205h-10.479v-12.604h10.245v3.205h-6.068v1.477h5.33v3.061h-5.33v1.656H330.305z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M336.207,318.906c0,0.576-0.072,1.008-0.703,2.359l-1.26,2.683h-2.521l0.9-3.043 c-0.72-0.342-1.17-1.044-1.17-1.999c0-1.404,1.009-2.305,2.377-2.305S336.207,317.501,336.207,318.906z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M354.803,313.216c0,2.917-2.233,4.754-5.744,4.754h-1.819v3.097h-4.249v-12.604h6.068 C352.57,308.463,354.803,310.299,354.803,313.216z M350.518,313.216c0-0.918-0.559-1.476-1.729-1.476h-1.549v2.953h1.549 C349.959,314.692,350.518,314.134,350.518,313.216z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M356.186,308.463h4.249v9.309h5.69v3.295h-9.939V308.463z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M377.771,317.861v3.205h-10.479v-12.604h10.245v3.205h-6.068v1.477h5.33v3.061h-5.33v1.656H377.771z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M387.994,318.87h-4.79l-0.846,2.197h-4.321l5.51-12.604h4.177l5.51,12.604h-4.394L387.994,318.87z M386.823,315.809l-1.224-3.169l-1.225,3.169H386.823z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M393.121,320.058l1.369-3.097c1.188,0.703,2.773,1.152,4.159,1.152c1.207,0,1.639-0.252,1.639-0.684 c0-1.584-6.968-0.306-6.968-5.005c0-2.341,1.962-4.249,5.87-4.249c1.692,0,3.439,0.36,4.753,1.098l-1.278,3.079 c-1.242-0.63-2.413-0.936-3.511-0.936c-1.242,0-1.638,0.36-1.638,0.792c0,1.512,6.968,0.252,6.968,4.897 c0,2.305-1.963,4.249-5.87,4.249C396.506,321.355,394.381,320.833,393.121,320.058z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M416.218,317.861v3.205h-10.479v-12.604h10.245v3.205h-6.068v1.477h5.33v3.061h-5.33v1.656H416.218z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M422.12,318.906c0,0.576-0.072,1.008-0.703,2.359l-1.26,2.683h-2.521l0.9-3.043 c-0.72-0.342-1.17-1.044-1.17-1.999c0-1.404,1.009-2.305,2.377-2.305S422.12,317.501,422.12,318.906z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M224.612,330.063l-4.033,12.604h-4.555l-2.035-6.734l-2.143,6.734h-4.555l-4.033-12.604h4.375l2.197,7.166 l2.323-7.166h3.907l2.197,7.256l2.322-7.256H224.612z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M225.542,330.063h4.249v12.604h-4.249V330.063z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M234.579,333.357h-3.691v-3.295h11.632v3.295h-3.691v9.309h-4.249V333.357z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M256.038,330.063v12.604h-4.25v-4.646h-3.925v4.646h-4.249v-12.604h4.249v4.465h3.925v-4.465H256.038z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M262.693,341.658l1.369-3.097c1.188,0.703,2.773,1.152,4.159,1.152c1.207,0,1.639-0.252,1.639-0.684 c0-1.584-6.968-0.306-6.968-5.005c0-2.341,1.962-4.249,5.87-4.249c1.693,0,3.439,0.36,4.753,1.098l-1.278,3.079 c-1.242-0.63-2.413-0.936-3.511-0.936c-1.243,0-1.639,0.36-1.639,0.792c0,1.512,6.968,0.252,6.968,4.897 c0,2.305-1.962,4.249-5.87,4.249C266.079,342.954,263.954,342.432,262.693,341.658z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M275.204,336.994v-6.932h4.249v6.806c0,1.927,0.738,2.647,1.927,2.647s1.926-0.72,1.926-2.647v-6.806h4.177 v6.932c0,3.781-2.269,5.96-6.14,5.96S275.204,340.775,275.204,336.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M297.76,336.022h3.691v5.33c-1.53,1.044-3.637,1.603-5.491,1.603c-4.069,0-7.041-2.719-7.041-6.59 s2.971-6.59,7.13-6.59c2.485,0,4.483,0.864,5.762,2.431l-2.719,2.395c-0.792-0.918-1.71-1.386-2.827-1.386 c-1.873,0-3.061,1.206-3.061,3.151c0,1.891,1.188,3.151,3.007,3.151c0.522,0,1.026-0.09,1.548-0.306V336.022z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M311.854,340.469h-4.79l-0.846,2.197h-4.321l5.51-12.604h4.177l5.51,12.604H312.7L311.854,340.469z M310.684,337.408l-1.224-3.169l-1.225,3.169H310.684z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M323.175,339.497h-1.152v3.169h-4.249v-12.604h6.068c3.511,0,5.744,1.836,5.744,4.753 c0,1.819-0.864,3.187-2.377,3.961l2.647,3.889h-4.538L323.175,339.497z M323.571,333.339h-1.549v2.953h1.549 c1.17,0,1.729-0.558,1.729-1.477C325.3,333.897,324.741,333.339,323.571,333.339z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M336.079,336.364c0-3.817,3.007-6.59,7.112-6.59s7.112,2.772,7.112,6.59c0,3.817-3.007,6.59-7.112,6.59 S336.079,340.181,336.079,336.364z M346.018,336.364c0-1.963-1.26-3.151-2.827-3.151s-2.827,1.188-2.827,3.151 c0,1.962,1.26,3.151,2.827,3.151S346.018,338.327,346.018,336.364z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M364.271,330.063v12.604h-3.493l-4.79-5.726v5.726h-4.141v-12.604h3.493l4.789,5.726v-5.726H364.271z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M374.455,333.357h-3.691v-3.295h11.632v3.295h-3.691v9.309h-4.249V333.357z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M382.806,336.364c0-3.817,3.007-6.59,7.112-6.59s7.112,2.772,7.112,6.59c0,3.817-3.007,6.59-7.112,6.59 S382.806,340.181,382.806,336.364z M392.745,336.364c0-1.963-1.26-3.151-2.827-3.151s-2.827,1.188-2.827,3.151 c0,1.962,1.26,3.151,2.827,3.151S392.745,338.327,392.745,336.364z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M410.386,334.815c0,2.917-2.233,4.754-5.744,4.754h-1.819v3.097h-4.249v-12.604h6.068 C408.153,330.063,410.386,331.899,410.386,334.815z M406.101,334.815c0-0.918-0.559-1.476-1.729-1.476h-1.549v2.953h1.549 C405.542,336.292,406.101,335.734,406.101,334.815z"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"b5_x5F_o_1_",opacity:"0.68",fill:"#898989",points:"305.084,393.381 326.359,415.065 347.634,393.381  489.467,393.381 489.467,183.15 130.508,183.15 130.508,393.381 \t",className:"dpseq "+(this.state.currentUnit<=5?'hide':'')}))));}}]);return Round6View;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Round6=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(Round6View);/* harmony default export */ __webpack_exports__["a"] = (Round6);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{twoDDarkPatternIncorrect:function twoDDarkPatternIncorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["t" /* twoDDarkPatternIncorrect */])());},twoDDarkPatternCorrect:function twoDDarkPatternCorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["s" /* twoDDarkPatternCorrect */])());}};};var Round8View=function(_Component){_inherits(Round8View,_Component);function Round8View(props){_classCallCheck(this,Round8View);var _this=_possibleConstructorReturn(this,(Round8View.__proto__||Object.getPrototypeOf(Round8View)).call(this,props));_this.state={shake:false,yesWords:[],done:false};_this.attempts=_this.getRandomInt(1,3);return _this;}_createClass(Round8View,[{key:"getRandomInt",value:function getRandomInt(min,max){return Math.floor(Math.random()*(max-min+1))+min;}},{key:"advance",value:function advance(stuff){var _this2=this;if(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(this.state.yesWords,stuff)===false){// hide what you just clicked
var joined=this.state.yesWords.concat(stuff);this.setState({yesWords:joined});this.attempts-=1;if(this.attempts<=0){this.setState({done:true});this.props.twoDDarkPatternCorrect();__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].delayedCall(1,function(){return _this2.props.adComplete();});}else{this.props.twoDDarkPatternIncorrect();}}}},{key:"shake",value:function shake(){var _this3=this;this.setState({shake:true});__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].delayedCall(0.6,function(){_this3.setState({shake:false});});this.props.twoDDarkPatternIncorrect();}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].killAll(true,true,true,true);}},{key:"render",value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"floatingad "+(this.state.shake?'shake':'')+" "+(this.state.done?'out':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"_x33_-2",x:"0px",y:"0px",viewBox:"0 0 495.125 459.5",enableBackground:"new 0 0 495.125 459.5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font",{horizAdvX:"1000"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font-face",{fontFamily:"Montserrat-Black",unitsPerEm:"1000",underlinePosition:"-100",underlineThickness:"50"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("missing-glyph",{horizAdvX:"587",d:"M40,0l507,0l0,700l-507,0M120,70l0,560l347,0l0,-560z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"A",horizAdvX:"806",d:"M581,0l244,0l-306,700l-232,0l-306,-700l240,0l47,122l266,0M333,292l68,176l68,-176z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"B",horizAdvX:"773",d:"M617,366C681,398 714,452 714,517C714,623 624,700 431,700l-374,0l0,-700l394,0C644,0 747,71 747,193C747,276 699,336 617,366M399,535C452,535 476,517 476,483C476,449 452,431 399,431l-110,0l0,104M431,165l-142,0l0,110l142,0C483,275 509,256 509,220C509,184 483,165 431,165z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"C",horizAdvX:"744",d:"M419,-16C556,-16 664,34 733,124l-149,133C543,205 494,175 431,175C333,175 267,243 267,350C267,457 333,525 431,525C494,525 543,495 584,443l149,133C664,666 556,716 419,716C194,716 29,565 29,350C29,135 194,-16 419,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"E",horizAdvX:"673",d:"M289,178l0,92l296,0l0,170l-296,0l0,82l337,0l0,178l-569,0l0,-700l582,0l0,178z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"F",horizAdvX:"644",d:"M626,522l0,178l-569,0l0,-700l236,0l0,224l292,0l0,178l-292,0l0,120z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"G",horizAdvX:"769",d:"M520,192C491,180 463,175 434,175C333,175 267,245 267,350C267,458 333,525 437,525C499,525 550,499 594,448l151,133C674,668 563,716 425,716C194,716 29,565 29,350C29,135 194,-16 420,-16C523,-16 640,15 725,73l0,296l-205,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"H",horizAdvX:"804",d:"M511,700l0,-248l-218,0l0,248l-236,0l0,-700l236,0l0,258l218,0l0,-258l236,0l0,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"I",horizAdvX:"350",d:"M57,0l236,0l0,700l-236,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"K",horizAdvX:"765",d:"M517,0l273,0l-294,392l280,308l-257,0l-230,-254l0,254l-232,0l0,-700l232,0l0,173l53,59z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"L",horizAdvX:"617",d:"M57,0l552,0l0,183l-316,0l0,517l-236,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"N",horizAdvX:"804",d:"M517,700l0,-318l-266,318l-194,0l0,-700l230,0l0,318l266,-318l194,0l0,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"O",horizAdvX:"848",d:"M424,-16C652,-16 819,138 819,350C819,562 652,716 424,716C196,716 29,562 29,350C29,138 196,-16 424,-16M424,175C337,175 267,241 267,350C267,459 337,525 424,525C511,525 581,459 581,350C581,241 511,175 424,175z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"P",horizAdvX:"743",d:"M394,700l-337,0l0,-700l236,0l0,172l101,0C589,172 713,274 713,436C713,598 589,700 394,700M379,354l-86,0l0,164l86,0C444,518 475,487 475,436C475,385 444,354 379,354z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"R",horizAdvX:"745",d:"M476,0l252,0l-147,216C665,259 713,335 713,436C713,598 589,700 394,700l-337,0l0,-700l236,0l0,176l64,0M475,436C475,385 444,354 379,354l-86,0l0,164l86,0C444,518 475,487 475,436z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"S",horizAdvX:"657",d:"M318,-16C535,-16 644,92 644,220C644,478 257,408 257,492C257,516 279,536 348,536C409,536 474,519 543,484l71,171C541,696 444,716 350,716C133,716 24,610 24,480C24,219 411,290 411,202C411,178 387,164 320,164C243,164 155,189 89,228l-76,-172C83,13 201,-16 318,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"T",horizAdvX:"654",d:"M209,0l236,0l0,517l205,0l0,183l-646,0l0,-183l205,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"U",horizAdvX:"784",d:"M392,-16C607,-16 733,105 733,315l0,385l-232,0l0,-378C501,215 460,175 394,175C328,175 287,215 287,322l0,378l-236,0l0,-385C51,105 177,-16 392,-16z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"V",horizAdvX:"786",d:"M573,700l-171,-409l-167,409l-254,0l296,-700l232,0l296,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"X",horizAdvX:"762",d:"M770,0l-258,362l243,338l-254,0l-116,-176l-119,176l-265,0l244,-347l-253,-353l269,0l118,187l121,-187z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:".",horizAdvX:"304",d:"M152,-10C227,-10 284,44 284,120C284,197 227,248 152,248C77,248 20,197 20,120C20,44 77,-10 152,-10z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:" ",horizAdvX:"300"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font",{horizAdvX:"1000"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("font-face",{fontFamily:"Montserrat-ExtraBold",unitsPerEm:"1000",underlinePosition:"-100",underlineThickness:"50"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("missing-glyph",{horizAdvX:"587",d:"M40,0l507,0l0,700l-507,0M120,70l0,560l347,0l0,-560z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"A",horizAdvX:"786",d:"M594,0l206,0l-310,700l-195,0l-309,-700l202,0l55,136l296,0M301,282l90,224l90,-224z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"B",horizAdvX:"769",d:"M608,365C668,396 702,450 702,517C702,625 612,700 428,700l-358,0l0,-700l378,0C636,0 736,71 736,192C736,277 687,337 608,365M402,557C468,557 502,534 502,490C502,445 468,422 402,422l-136,0l0,135M432,143l-166,0l0,142l166,0C500,285 536,262 536,214C536,166 500,143 432,143z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"E",horizAdvX:"672",d:"M266,153l0,128l311,0l0,148l-311,0l0,118l353,0l0,153l-549,0l0,-700l562,0l0,153z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"F",horizAdvX:"642",d:"M619,547l0,153l-549,0l0,-700l198,0l0,240l309,0l0,153l-309,0l0,154z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"H",horizAdvX:"806",d:"M538,700l0,-263l-270,0l0,263l-198,0l0,-700l198,0l0,273l270,0l0,-273l198,0l0,700z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"I",horizAdvX:"339",d:"M70,0l198,0l0,700l-198,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"K",horizAdvX:"752",d:"M540,0l230,0l-301,390l286,310l-218,0l-271,-291l0,291l-196,0l0,-700l196,0l0,175l74,79z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"M",horizAdvX:"954",d:"M884,0l-2,700l-163,0l-240,-404l-246,404l-163,0l0,-700l183,0l0,361l179,-292l88,0l180,302l2,-371z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"O",horizAdvX:"846",d:"M423,-14C647,-14 812,140 812,350C812,560 647,714 423,714C199,714 34,560 34,350C34,140 199,-14 423,-14M423,150C317,150 234,229 234,350C234,471 317,550 423,550C529,550 612,471 612,350C612,229 529,150 423,150z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"R",horizAdvX:"740",d:"M503,0l212,0l-151,220C651,262 701,338 701,441C701,601 581,700 390,700l-320,0l0,-700l198,0l0,186l108,0M501,441C501,377 460,339 378,339l-110,0l0,205l110,0C460,544 501,506 501,441z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"T",horizAdvX:"635",d:"M219,0l198,0l0,543l214,0l0,157l-627,0l0,-157l215,0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:"X",horizAdvX:"737",d:"M740,0l-260,362l244,338l-214,0l-138,-202l-140,202l-223,0l244,-346l-255,-354l226,0l143,217l145,-217z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("glyph",{unicode:" ",horizAdvX:"291"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"base_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_6_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_8_",fill:"#FFFFFF",width:"495.192",height:"459.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"16.369",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"35.325",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"468.036",y:"21.913",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 122.8338 343.2053)",fill:"#B2AFAA",width:"15.333",height:"2.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"474.292",y:"15.663",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 122.8355 343.2098)",fill:"#B2AFAA",width:"2.833",height:"15.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"affirm",enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M60.827,27.679h-5.33l-0.991,2.449H50.87l5.563-12.604h3.511l5.582,12.604h-3.709L60.827,27.679z M59.783,25.051l-1.621-4.033l-1.621,4.033H59.783z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M70.095,20.28v2.772h5.563v2.755h-5.563v4.321H66.53V17.525h9.885v2.755H70.095z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M81.65,20.28v2.772h5.563v2.755H81.65v4.321h-3.564V17.525h9.885v2.755H81.65z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M89.642,17.525h3.564v12.604h-3.564V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M101.253,26.78h-1.945v3.349h-3.564V17.525h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L101.253,26.78z M101.288,20.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C103.503,21.018,102.765,20.333,101.288,20.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M120.441,30.128l-0.036-6.68l-3.24,5.438h-1.585l-3.223-5.258v6.5h-3.295V17.525h2.935l4.43,7.273 l4.321-7.273h2.935l0.036,12.604H120.441z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M143.463,26.671c0,2.179-1.801,3.457-5.186,3.457h-6.806V17.525h6.445c3.313,0,4.934,1.351,4.934,3.295 c0,1.206-0.612,2.179-1.692,2.736C142.581,24.061,143.463,25.141,143.463,26.671z M135,20.099v2.431h2.449 c1.188,0,1.801-0.414,1.801-1.224c0-0.793-0.612-1.207-1.801-1.207H135z M139.862,26.275c0-0.864-0.648-1.278-1.873-1.278H135 v2.557h2.989C139.214,27.553,139.862,27.139,139.862,26.275z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M144.665,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554s-2.971,6.554-7.004,6.554 S144.665,27.608,144.665,23.827z M155.072,23.827c0-2.179-1.495-3.602-3.403-3.602s-3.403,1.423-3.403,3.602 s1.495,3.601,3.403,3.601S155.072,26.005,155.072,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M168.049,30.128l-2.61-3.907l-2.575,3.907h-4.069l4.592-6.374l-4.394-6.229h4.015l2.521,3.637l2.484-3.637 h3.854l-4.394,6.086l4.682,6.518H168.049z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M181.225,30.128l-2.61-3.907l-2.575,3.907h-4.069l4.592-6.374l-4.394-6.229h4.015l2.521,3.637l2.484-3.637 h3.854l-4.394,6.086l4.682,6.518H181.225z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M186.154,17.525h3.564v12.604h-3.564V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M202.374,27.374v2.755h-10.118V17.525h9.885v2.755h-6.356v2.124h5.6v2.665h-5.6v2.305H202.374z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M221.58,17.525v12.604h-3.565v-4.915h-4.861v4.915h-3.564V17.525h3.564v4.735h4.861v-4.735H221.58z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M234.216,27.374v2.755h-10.119V17.525h9.885v2.755h-6.356v2.124h5.6v2.665h-5.6v2.305H234.216z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M244.637,27.679h-5.33l-0.99,2.449h-3.637l5.563-12.604h3.511l5.582,12.604h-3.709L244.637,27.679z M243.592,25.051l-1.62-4.033l-1.62,4.033H243.592z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M255.849,26.78h-1.944v3.349h-3.564V17.525h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L255.849,26.78z M255.885,20.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C258.1,21.018,257.361,20.333,255.885,20.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M266.163,20.351h-3.871v-2.826h11.289v2.826h-3.854v9.777h-3.564V20.351z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M286.901,26.671c0,2.179-1.801,3.457-5.186,3.457h-6.806V17.525h6.445c3.313,0,4.934,1.351,4.934,3.295 c0,1.206-0.612,2.179-1.692,2.736C286.02,24.061,286.901,25.141,286.901,26.671z M278.438,20.099v2.431h2.449 c1.188,0,1.801-0.414,1.801-1.224c0-0.793-0.612-1.207-1.801-1.207H278.438z M283.3,26.275c0-0.864-0.647-1.278-1.872-1.278h-2.989 v2.557h2.989C282.652,27.553,283.3,27.139,283.3,26.275z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M294.261,26.78h-1.944v3.349h-3.564V17.525h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L294.261,26.78z M294.297,20.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C296.512,21.018,295.773,20.333,294.297,20.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M312.19,27.374v2.755h-10.118V17.525h9.885v2.755h-6.356v2.124h5.6v2.665h-5.6v2.305H312.19z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M322.612,27.679h-5.33l-0.99,2.449h-3.637l5.563-12.604h3.511l5.582,12.604h-3.709L322.612,27.679z M321.567,25.051l-1.62-4.033l-1.62,4.033H321.567z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M333.177,25.555l-1.333,1.422v3.151h-3.528V17.525h3.528v5.239l4.88-5.239h3.925l-5.149,5.581l5.42,7.022 h-4.142L333.177,25.555z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"9.162",y:"44.319",fill:"#CE1300",width:"476.867",height:"407.618"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#DB2103",points:"44,44.319 486.029,44.319 486.029,451.937 159.867,451.937 166,417.667 130,423.667 138,345  97.333,356.333 105.333,175.667 34.667,194.333 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#EA4800",points:"240,44.319 486.029,44.319 486.029,451.937 240,451.937 261,402 234.5,407.5 268.5,279.5  222.5,252.5 260,124 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#F75819",points:"427.333,44.319 486.029,44.319 486.029,451.937 279.367,451.937 325.333,366.333 292,329  377.333,282.333 444,148.333 378.667,179 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"384,382.333 294.681,399.667 398,395.667 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"341.012,278.682 294.681,359.683 359.679,280.015 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"208.345,318.314 226.349,359.683 219.343,320.314 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"96.66,263.337 193.333,359.683 117.327,263.337 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"126.85,410.833 193.333,398.845 134.953,398.27 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"boxxie"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"208.965",y:"377.25",fill:"#082428",width:"75.316",height:"43.191"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"197.936",y:"431.624",fill:"#082428",width:"97.373",height:"20.376"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#082428",points:"254.731,441.48 238.515,441.48 240.346,413.004 252.9,413.004 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#082428",points:"295.219,431.624 335.129,443.081 288.247,438.507 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#082428",points:"197.845,431.624 183.506,438.507 198.829,438.965 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M256.608,382.303c-0.366,0.498-0.678,1.047-0.909,1.652c-1.383,3.618,0.43,7.672,4.048,9.055 c3.618,1.383,7.672-0.43,9.055-4.048c0.231-0.605,0.365-1.222,0.424-1.837L256.608,382.303z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M236.637,382.303c0.366,0.498,0.678,1.047,0.909,1.652c1.383,3.618-0.43,7.672-4.048,9.055 c-3.618,1.383-7.672-0.43-9.055-4.048c-0.231-0.605-0.365-1.222-0.424-1.837L236.637,382.303z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"39",y:"65.833",fill:"none",width:"417",height:"139.167"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"clickthe"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M63.402,76.42c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C67.856,86.299,63.402,82.223,63.402,76.42z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M84.246,66.972h6.37v13.956h8.53v4.939h-14.9V66.972z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M100.905,66.972h6.37v18.895h-6.37V66.972z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M109.599,76.42c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C114.053,86.299,109.599,82.223,109.599,76.42z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M138.135,79.605l-1.431,1.592v4.67h-6.262V66.972h6.262v6.856l6.208-6.856h6.937l-7.558,8.314l7.936,10.581 h-7.369L138.135,79.605z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M163.3,71.912h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V71.912z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M195.479,66.972v18.895h-6.37v-6.964h-5.885v6.964h-6.37V66.972h6.37v6.694h5.885v-6.694H195.479z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M214.272,81.062v4.805h-15.71V66.972h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H214.272z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M224.67,77.364V66.972h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 V66.972h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C228.072,86.299,224.67,83.033,224.67,77.364z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M264.625,66.972v18.895h-5.236l-7.18-8.583v8.583H246V66.972h5.237l7.18,8.584v-8.584H264.625z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M266.521,84.355l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.371-8.8,6.371C271.595,86.299,268.41,85.516,266.521,84.355z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M285.285,77.364V66.972h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 V66.972h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C288.686,86.299,285.285,83.033,285.285,77.364z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M325.24,80.658c0,3.293-2.78,5.209-7.99,5.209h-10.635V66.972h10.095c5.21,0,7.639,2.079,7.639,4.94 c0,1.754-0.891,3.212-2.618,4.076C323.944,76.797,325.24,78.417,325.24,80.658z M312.877,71.426v2.807h2.969 c1.431,0,2.079-0.486,2.079-1.404c0-0.917-0.648-1.403-2.079-1.403H312.877z M318.815,79.929c0-0.972-0.702-1.484-2.105-1.484 h-3.833v2.969h3.833C318.114,81.414,318.815,80.9,318.815,79.929z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M326.298,84.355l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.371-8.8,6.371C331.373,86.299,328.188,85.516,326.298,84.355z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M344.469,76.42c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C348.923,86.299,344.469,82.223,344.469,76.42z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M373.41,81.117h-1.728v4.75h-6.37V66.972h9.097c5.264,0,8.611,2.753,8.611,7.126 c0,2.727-1.296,4.778-3.563,5.938l3.968,5.831h-6.802L373.41,81.117z M374.004,71.885h-2.322v4.427h2.322 c1.754,0,2.591-0.836,2.591-2.213C376.596,72.722,375.759,71.885,374.004,71.885z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M385.427,66.972h6.37v18.895h-6.37V66.972z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M413.502,80.658c0,3.293-2.78,5.209-7.99,5.209h-10.635V66.972h10.095c5.209,0,7.639,2.079,7.639,4.94 c0,1.754-0.891,3.212-2.618,4.076C412.207,76.797,413.502,78.417,413.502,80.658z M401.139,71.426v2.807h2.969 c1.431,0,2.079-0.486,2.079-1.404c0-0.917-0.648-1.403-2.079-1.403H401.139z M407.078,79.929c0-0.972-0.702-1.484-2.105-1.484 h-3.833v2.969h3.833C406.376,81.414,407.078,80.9,407.078,79.929z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M431.458,81.062v4.805h-15.71V66.972h15.359v4.805h-9.097v2.213H430v4.589h-7.99v2.483H431.458z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M61.607,99.372h6.37v18.895h-6.37V99.372z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M70.301,108.82c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C74.755,118.699,70.301,114.623,70.301,108.82z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M89.984,108.82c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S89.984,114.542,89.984,108.82z M104.884,108.82c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C102.995,113.543,104.884,111.762,104.884,108.82z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M132.261,99.372v18.895h-5.236l-7.18-8.583v8.583h-6.208V99.372h5.237l7.18,8.584v-8.584H132.261z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M147.546,104.312h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V104.312z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M160.075,108.82c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S160.075,114.542,160.075,108.82z M174.975,108.82c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C173.085,113.543,174.975,111.762,174.975,108.82z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M190.639,116.755l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.37-8.8,6.37C195.713,118.699,192.528,117.916,190.639,116.755z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M213.398,104.312h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V104.312z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M225.927,108.82c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S225.927,114.542,225.927,108.82z M240.827,108.82c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C238.938,113.543,240.827,111.762,240.827,108.82z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M267.287,106.498c0,4.373-3.347,7.126-8.611,7.126h-2.727v4.643h-6.37V99.372h9.097 C263.939,99.372,267.287,102.125,267.287,106.498z M260.862,106.498c0-1.376-0.837-2.213-2.591-2.213h-2.322v4.427h2.322 C260.025,108.711,260.862,107.875,260.862,106.498z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M285.837,113.516h-1.728v4.751h-6.37V99.372h9.097c5.264,0,8.611,2.753,8.611,7.126 c0,2.727-1.296,4.778-3.563,5.938l3.968,5.831h-6.802L285.837,113.516z M286.432,104.285h-2.322v4.427h2.322 c1.754,0,2.591-0.836,2.591-2.213C289.023,105.122,288.186,104.285,286.432,104.285z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M313.564,113.462v4.805h-15.71V99.372h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H313.564z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M315.27,108.82c0-5.804,4.454-9.879,10.527-9.879c3.698,0,6.613,1.35,8.476,3.779l-4.022,3.59 c-1.106-1.403-2.429-2.213-4.13-2.213c-2.645,0-4.427,1.835-4.427,4.724c0,2.888,1.782,4.724,4.427,4.724 c1.701,0,3.023-0.81,4.13-2.213l4.022,3.59c-1.862,2.429-4.778,3.779-8.476,3.779C319.724,118.699,315.27,114.623,315.27,108.82z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M351.823,113.462v4.805h-15.71V99.372h15.359v4.805h-9.097v2.213h7.99v4.589h-7.99v2.483H351.823z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M354.284,99.372h6.37v18.895h-6.37V99.372z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M383.924,99.372l-7.99,18.895h-6.262l-7.99-18.895h6.856l4.508,11.04l4.616-11.04H383.924z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M384.55,99.372h6.37v18.895h-6.37V99.372z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M412.625,99.372v18.895h-5.236l-7.18-8.583v8.583H394V99.372h5.237l7.18,8.584v-8.584H412.625z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M428.205,108.307h5.534v7.99c-2.294,1.566-5.453,2.402-8.233,2.402c-6.1,0-10.554-4.076-10.554-9.879 c0-5.804,4.454-9.879,10.689-9.879c3.725,0,6.721,1.295,8.638,3.644l-4.076,3.59c-1.188-1.376-2.564-2.079-4.238-2.079 c-2.807,0-4.589,1.809-4.589,4.724c0,2.834,1.782,4.724,4.508,4.724c0.783,0,1.539-0.135,2.321-0.459V108.307z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M78.589,149.155l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.371-8.8,6.371C83.664,151.099,80.479,150.316,78.589,149.155z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M101.349,136.712h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V136.712z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M114.472,142.164v-10.392h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 v-10.203h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C117.873,151.099,114.472,147.833,114.472,142.164z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M142.172,136.577v3.239h7.882v4.805h-7.882v6.046h-6.37v-18.895h15.359v4.805H142.172z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M159.56,136.577v3.239h7.882v4.805h-7.882v6.046h-6.37v-18.895h15.359v4.805H159.56z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M178.677,131.772h6.37v18.895h-6.37V131.772z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M206.751,131.772v18.895h-5.236l-7.18-8.583v8.583h-6.208v-18.895h5.237l7.18,8.584v-8.584H206.751z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M230.809,147.374h-7.18l-1.269,3.293h-6.478l8.26-18.895h6.262l8.26,18.895h-6.586L230.809,147.374z M229.055,142.785l-1.835-4.751l-1.835,4.751H229.055z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M266.42,145.458c0,3.293-2.78,5.209-7.99,5.209h-10.635v-18.895h10.095c5.21,0,7.639,2.079,7.639,4.94 c0,1.754-0.891,3.212-2.618,4.076C265.125,141.597,266.42,143.217,266.42,145.458z M254.058,136.226v2.807h2.969 c1.431,0,2.079-0.486,2.079-1.404c0-0.917-0.648-1.403-2.079-1.403H254.058z M259.996,144.729c0-0.972-0.702-1.484-2.105-1.484 h-3.833v2.969h3.833C259.294,146.213,259.996,145.7,259.996,144.729z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M267.911,141.22c0-5.723,4.508-9.879,10.662-9.879s10.662,4.157,10.662,9.879 c0,5.722-4.508,9.879-10.662,9.879S267.911,146.942,267.911,141.22z M282.811,141.22c0-2.942-1.889-4.724-4.238-4.724 c-2.348,0-4.238,1.782-4.238,4.724c0,2.942,1.89,4.724,4.238,4.724C280.921,145.943,282.811,144.162,282.811,141.22z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M302.846,150.667l-3.266-5.048l-3.186,5.048h-7.261l6.829-9.528l-6.586-9.367h7.153l3.212,4.751 l3.131-4.751h6.856l-6.559,9.124l6.964,9.771H302.846z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M318.374,149.155l2.051-4.643c1.782,1.053,4.157,1.728,6.235,1.728c1.809,0,2.457-0.378,2.457-1.026 c0-2.375-10.446-0.459-10.446-7.504c0-3.509,2.942-6.37,8.799-6.37c2.538,0,5.156,0.54,7.126,1.646l-1.917,4.616 c-1.863-0.945-3.617-1.404-5.264-1.404c-1.863,0-2.457,0.54-2.457,1.188c0,2.267,10.446,0.378,10.446,7.342 c0,3.455-2.942,6.371-8.8,6.371C323.448,151.099,320.263,150.316,318.374,149.155z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M341.133,136.712h-5.534v-4.94h17.438v4.94h-5.534v13.955h-6.37V136.712z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M354.255,142.164v-10.392h6.371v10.203c0,2.889,1.106,3.968,2.888,3.968c1.781,0,2.888-1.08,2.888-3.968 v-10.203h6.262v10.392c0,5.668-3.401,8.935-9.205,8.935C357.657,151.099,354.255,147.833,354.255,142.164z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M381.956,136.577v3.239h7.882v4.805h-7.882v6.046h-6.37v-18.895h15.359v4.805H381.956z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M399.343,136.577v3.239h7.882v4.805h-7.882v6.046h-6.37v-18.895h15.359v4.805H399.343z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M409.093,147.428c0-2.078,1.539-3.455,3.563-3.455s3.563,1.377,3.563,3.455 c0,2.052-1.539,3.509-3.563,3.509S409.093,149.479,409.093,147.428z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"icon_x5F_5_1_",className:"darkPatternPulse",onClick:function onClick(e){return _this4.advance(1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"356.512",cy:"241.015",r:"49.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"package_1_",fill:"#0062FF",d:"M391.937,219.017h-34.861l-6.002,9.989l-6.775-9.989h-21.32l11.152,14.563v30.689h49.408 v-31.244L391.937,219.017z M378.872,259.602h-24.761v-24.887h24.761V259.602z M360.138,237.796l6.355,6.355l6.355-6.355l3.299,3.3 l-6.354,6.354l6.354,6.354l-3.299,3.3l-6.355-6.355l-6.355,6.355l-3.299-3.3l6.354-6.354l-6.354-6.354L360.138,237.796z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"icon_x5F_4_1_",className:"darkPatternPulse",onClick:function onClick(e){return _this4.advance(2);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"414.333",cy:"360.167",r:"49.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"sad_1_",fill:"#0062FF",d:"M414.24,337.667c-13.05,0-23.667,10.617-23.667,23.667c0,13.05,10.617,23.667,23.667,23.667 s23.667-10.617,23.667-23.667C437.908,348.285,427.291,337.667,414.24,337.667z M414.24,379.087 c-9.789,0-17.752-7.963-17.752-17.752c0-9.789,7.963-17.752,17.752-17.752c9.789,0,17.752,7.963,17.752,17.752 C431.993,371.124,424.029,379.087,414.24,379.087z M424.989,369.552l-2.788,2.788c-4.389-4.389-11.532-4.389-15.921,0l-2.788-2.788 C409.418,363.624,419.062,363.624,424.989,369.552z M417.386,356.652c0-1.972,1.599-3.571,3.571-3.571 c1.972,0,3.571,1.599,3.571,3.571s-1.599,3.571-3.571,3.571C418.984,360.223,417.386,358.624,417.386,356.652z M403.953,356.652 c0-1.972,1.599-3.571,3.571-3.571s3.571,1.599,3.571,3.571s-1.599,3.571-3.571,3.571S403.953,358.624,403.953,356.652z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"icon_x5F_3_1_",className:"darkPatternPulse",onClick:function onClick(e){return _this4.advance(3);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"228.679",cy:"281.981",r:"49.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"box_1_",fill:"#0062FF",d:"M253.551,271.78c-1.39-2.337-4.292-5.123-10.228-5.123h-4.335v-1.997h3.79l3.002-6.001h-10.792 v7.998h-20.736c-5.935,0-8.837,2.786-10.228,5.123c-1.466,2.465-1.518,4.899-1.519,5.179v17.365h25.477v11.75h8.002v-11.75h19.084 v-17.375C255.069,276.679,255.016,274.245,253.551,271.78z M221.562,284.982l-3.241,3.241l-3.919-3.919l-3.919,3.919l-3.241-3.241 l3.919-3.919l-3.919-3.919l3.241-3.241l3.919,3.919l3.919-3.919l3.241,3.241l-3.919,3.919L221.562,284.982z M250.07,289.324h-24.07 v-12.375c-0.001-0.27-0.053-2.703-1.519-5.168c-0.024-0.04-0.052-0.082-0.077-0.123h10.586v9.333h3.999v-9.333h4.335 c6.292,0,6.724,4.446,6.747,5.301V289.324z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"icon_x5F_2_1_",className:"darkPatternPulse",onClick:function onClick(e){return _this4.advance(4);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.5",cy:"378.5",r:"49.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"heart_1_",fill:"#0062FF",d:"M109.107,391.967h7.369c-5.582,5.597-11.423,9.352-11.889,9.647l-2.754-0.053 c-0.675-0.465-12.677-8.814-18.739-18.728h-6.343l-4.003-2.5l4.003-2.5h3.912c-0.64-1.807-1.014-3.629-1.014-5.434 c0-7.25,5.898-13.147,13.147-13.147c4.21,0,8.03,2.004,10.454,5.179c2.423-3.175,6.243-5.179,10.454-5.179 c7.25,0,13.147,5.898,13.147,13.147c0,0.592-0.045,1.182-0.109,1.769h-5.042c0.09-0.59,0.152-1.18,0.152-1.769 c0-4.493-3.655-8.147-8.147-8.147c-3.906,0-7.269,2.783-7.998,6.617h-4.912c-0.729-3.834-4.092-6.617-7.998-6.617 c-4.493,0-8.147,3.655-8.147,8.147c0,8.559,12.387,19.452,18.643,24.061C104.611,395.542,106.75,393.974,109.107,391.967z M132.495,376.252c-1.421,0-2.654,0.765-3.341,1.898l-10.737-0.816l-1.001-5.248h-2.998l-1.001,5.748h-8.835v5h8.835l1.001,5.749 h2.998l1.001-5.249l10.948-0.832c0.714,0.956,1.845,1.584,3.13,1.584c2.163,0,3.917-1.754,3.917-3.917 C136.412,378.006,134.658,376.252,132.495,376.252z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"icon_x5F_1_1_",className:"darkPatternPulse",onClick:function onClick(e){return _this4.advance(5);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"111.5",cy:"227.5",r:"49.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"x_1_",fill:"#0062FF",d:"M125.182,235.357l-9.116-9.113l5.449-5.449c1.617,0.102,3.275-0.615,4.255-2.227 c0.877-1.443,0.867-3.33-0.034-4.759c-1.647-2.612-5.141-2.894-7.188-0.848c-1.013,1.013-1.435,2.38-1.306,3.703l-5.378,5.378 l-6.085-6.085c0.158-1.652-0.541-3.371-2.179-4.385c-1.448-0.896-3.351-0.895-4.791,0.012c-2.613,1.647-2.896,5.141-0.849,7.188 c0.975,0.975,2.277,1.403,3.552,1.32l16.391,16.388h-13.259c-1.069-1.228-2.754-1.905-4.596-1.458 c-1.644,0.399-2.974,1.741-3.348,3.391c-0.682,3.011,1.589,5.681,4.483,5.681c1.423,0,2.678-0.658,3.523-1.672h17.547 C125.944,242.425,127.791,237.965,125.182,235.357z"}))));}}]);return Round8View;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Round8=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(Round8View);/* harmony default export */ __webpack_exports__["a"] = (Round8);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{twoDDarkPatternIncorrect:function twoDDarkPatternIncorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["t" /* twoDDarkPatternIncorrect */])());},twoDDarkPatternCorrect:function twoDDarkPatternCorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["s" /* twoDDarkPatternCorrect */])());},playSndFx:function playSndFx(sfx){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["l" /* playSndFx */])(sfx));}};};var Round9View=function(_Component){_inherits(Round9View,_Component);function Round9View(props){_classCallCheck(this,Round9View);var _this=_possibleConstructorReturn(this,(Round9View.__proto__||Object.getPrototypeOf(Round9View)).call(this,props));_this.state={shake:false,done:false,hits:0,show:false};_this.attempts=3;return _this;}_createClass(Round9View,[{key:"getRandomInt",value:function getRandomInt(min,max){return Math.floor(Math.random()*(max-min+1))+min;}},{key:"hitBoxxie",value:function hitBoxxie(){var _this2=this;if(this.state.hits>=3){// console.log('hit limit for boxxie met')
return;}// console.log('hit boxxie')
this.setState({hits:this.state.hits+1,show:true});this.props.playSndFx("hit"+this.getRandomInt(1,4));__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(0.35,function(){_this2.setState({show:false});});if(this.state.hits===3)this.props.playSndFx('boxxieKnockout');}},{key:"unsubscribe",value:function unsubscribe(){var _this3=this;if(this.state.hits>=3){this.props.playSndFx('introClick');this.props.twoDDarkPatternCorrect();__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(1,function(){return _this3.props.adComplete();});}}},{key:"shake",value:function shake(){var _this4=this;this.setState({shake:true});__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(0.6,function(){_this4.setState({shake:false});});this.props.twoDDarkPatternIncorrect();}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].killAll(true,true,true,true);}},{key:"render",value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"floatingad "+(this.state.shake?'shake':'')+" "+(this.state.done?'out':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"_x33_-3",x:"0px",y:"0px",viewBox:"0 0 621.757 628",enableBackground:"new 0 0 621.757 628"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"base_3_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_9_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_10_",fill:"#FFFFFF",width:"621.757",height:"628"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"16.369",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"35.325",cy:"23.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"594.597",y:"21.917",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 159.8998 432.6987)",fill:"#B2AFAA",width:"15.333",height:"2.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"600.853",y:"15.667",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 159.9013 432.703)",fill:"#B2AFAA",width:"2.833",height:"15.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"boxxiebashing",enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M64.374,26.671c0,2.179-1.801,3.457-5.186,3.457h-6.806V17.525h6.446c3.313,0,4.934,1.351,4.934,3.295 c0,1.206-0.612,2.179-1.692,2.736C63.492,24.061,64.374,25.141,64.374,26.671z M55.912,20.099v2.431h2.449 c1.188,0,1.8-0.414,1.8-1.224c0-0.793-0.612-1.207-1.8-1.207H55.912z M60.773,26.275c0-0.864-0.648-1.278-1.873-1.278h-2.989v2.557 H58.9C60.125,27.553,60.773,27.139,60.773,26.275z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M65.576,23.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554s-2.971,6.554-7.004,6.554 S65.576,27.608,65.576,23.827z M75.983,23.827c0-2.179-1.495-3.602-3.403-3.602s-3.403,1.423-3.403,3.602s1.495,3.601,3.403,3.601 S75.983,26.005,75.983,23.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M88.96,30.128l-2.61-3.907l-2.575,3.907h-4.069l4.592-6.374l-4.394-6.229h4.016l2.521,3.637l2.484-3.637 h3.854l-4.394,6.086l4.682,6.518H88.96z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M102.136,30.128l-2.61-3.907l-2.575,3.907h-4.069l4.592-6.374l-4.394-6.229h4.016l2.521,3.637l2.484-3.637 h3.854l-4.394,6.086l4.682,6.518H102.136z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M107.065,17.525h3.564v12.604h-3.564V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M123.286,27.374v2.755h-10.119V17.525h9.885v2.755h-6.356v2.124h5.6v2.665h-5.6v2.305H123.286z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M142.491,26.671c0,2.179-1.801,3.457-5.186,3.457H130.5V17.525h6.445c3.313,0,4.934,1.351,4.934,3.295 c0,1.206-0.612,2.179-1.692,2.736C141.609,24.061,142.491,25.141,142.491,26.671z M134.028,20.099v2.431h2.449 c1.188,0,1.801-0.414,1.801-1.224c0-0.793-0.612-1.207-1.801-1.207H134.028z M138.89,26.275c0-0.864-0.647-1.278-1.872-1.278 h-2.989v2.557h2.989C138.242,27.553,138.89,27.139,138.89,26.275z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M152.786,27.679h-5.33l-0.99,2.449h-3.637l5.563-12.604h3.511l5.582,12.604h-3.709L152.786,27.679z M151.741,25.051l-1.62-4.033l-1.62,4.033H151.741z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M157.606,28.994l1.171-2.628c1.116,0.737,2.7,1.242,4.159,1.242c1.477,0,2.053-0.414,2.053-1.026 c0-1.999-7.167-0.54-7.167-5.222c0-2.251,1.837-4.087,5.582-4.087c1.639,0,3.331,0.378,4.573,1.098l-1.098,2.647 c-1.207-0.648-2.396-0.973-3.493-0.973c-1.495,0-2.035,0.504-2.035,1.135c0,1.926,7.148,0.485,7.148,5.131 c0,2.197-1.837,4.069-5.582,4.069C160.848,30.38,158.795,29.823,157.606,28.994z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M182.126,17.525v12.604h-3.565v-4.915h-4.861v4.915h-3.564V17.525h3.564v4.735h4.861v-4.735H182.126z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M184.643,17.525h3.564v12.604h-3.564V17.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M202.735,17.525v12.604h-2.935l-5.563-6.716v6.716h-3.493V17.525h2.935l5.563,6.716v-6.716H202.735z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M213.696,23.556h3.15v5.222c-1.458,1.045-3.457,1.603-5.293,1.603c-4.016,0-6.95-2.719-6.95-6.554 s2.935-6.554,7.022-6.554c2.358,0,4.267,0.811,5.509,2.305l-2.269,2.053c-0.864-0.955-1.854-1.405-3.061-1.405 c-2.161,0-3.602,1.423-3.602,3.602c0,2.124,1.44,3.601,3.565,3.601c0.666,0,1.296-0.126,1.927-0.414V23.556z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"9.162",y:"44.319",fill:"#25043D",width:"603.432",height:"572.767"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#370A51",points:"54,44.319 612.594,44.319 612.594,617.086 204.873,617.086 192.615,513.591 110.119,513.591  195.615,408.596 56.122,455.094 163,103 92.12,194.333 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#25043D",points:"300.279,44.319 612.594,44.319 612.594,617.086 300.279,617.086 312.609,516.591 276.665,516.761  314.109,330.6 235.449,319.792 373,152 250,156 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#370A51",points:"513.36,44.319 612.594,44.319 612.594,617.086 387.605,617.086 513.599,470.093 399.605,429.595  518.099,297.602 449.102,275.103 522.288,148.333 487.292,179 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"32",y:"66",fill:"none",width:"566",height:"167"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"itscome"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M69.422,67.43h8.023v23.798h-8.023V67.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M86.49,73.651h-6.969V67.43h21.961v6.222h-6.969v17.576H86.49V73.651z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M102.062,89.324l2.584-5.847c2.244,1.326,5.235,2.176,7.853,2.176c2.278,0,3.094-0.476,3.094-1.292 c0-2.992-13.157-0.578-13.157-9.451c0-4.419,3.706-8.023,11.083-8.023c3.196,0,6.493,0.68,8.975,2.074l-2.414,5.813 c-2.346-1.19-4.555-1.768-6.629-1.768c-2.346,0-3.094,0.68-3.094,1.496c0,2.856,13.156,0.476,13.156,9.247 c0,4.352-3.706,8.023-11.083,8.023C108.454,91.771,104.442,90.786,102.062,89.324z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M135.144,79.329c0-7.309,5.609-12.443,13.259-12.443c4.657,0,8.329,1.7,10.675,4.76l-5.065,4.521 c-1.394-1.768-3.06-2.788-5.202-2.788c-3.332,0-5.575,2.312-5.575,5.949s2.244,5.95,5.575,5.95c2.142,0,3.808-1.02,5.202-2.788 l5.065,4.521c-2.346,3.06-6.018,4.76-10.675,4.76C140.753,91.771,135.144,86.638,135.144,79.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M159.929,79.329c0-7.207,5.677-12.443,13.429-12.443s13.429,5.236,13.429,12.443 c0,7.208-5.677,12.443-13.429,12.443S159.929,86.536,159.929,79.329z M178.695,79.329c0-3.706-2.38-5.949-5.337-5.949 s-5.337,2.244-5.337,5.949s2.38,5.95,5.337,5.95S178.695,83.034,178.695,79.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M210.96,91.228l-0.068-10.845l-5.167,8.703h-3.536l-5.167-8.329v10.471h-7.309V67.43h6.595l7.751,12.681 l7.547-12.681h6.595l0.068,23.798H210.96z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M241.935,85.176v6.051h-19.786V67.43h19.344v6.052h-11.457v2.788h10.063v5.779h-10.063v3.128H241.935z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M260.398,73.651h-6.969V67.43h21.961v6.222h-6.969v17.576h-8.023V73.651z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M276.174,79.329c0-7.207,5.677-12.443,13.429-12.443s13.429,5.236,13.429,12.443 c0,7.208-5.677,12.443-13.429,12.443S276.174,86.536,276.174,79.329z M294.94,79.329c0-3.706-2.38-5.949-5.337-5.949 s-5.337,2.244-5.337,5.949s2.38,5.95,5.337,5.95S294.94,83.034,294.94,79.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M321.325,73.651h-6.97V67.43h21.962v6.222h-6.969v17.576h-8.023V73.651z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M361.851,67.43v23.798h-8.023v-8.771h-7.411v8.771h-8.023V67.43h8.023v8.432h7.411V67.43H361.851z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M365.729,67.43h8.023v23.798h-8.023V67.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M376.133,89.324l2.584-5.847c2.244,1.326,5.235,2.176,7.853,2.176c2.278,0,3.094-0.476,3.094-1.292 c0-2.992-13.157-0.578-13.157-9.451c0-4.419,3.706-8.023,11.083-8.023c3.195,0,6.493,0.68,8.975,2.074l-2.414,5.813 c-2.346-1.19-4.555-1.768-6.629-1.768c-2.346,0-3.093,0.68-3.093,1.496c0,2.856,13.157,0.476,13.157,9.247 c0,4.352-3.706,8.023-11.083,8.023C382.524,91.771,378.513,90.786,376.133,89.324z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M399.388,87.148c0-2.618,1.938-4.352,4.488-4.352s4.488,1.734,4.488,4.352c0,2.583-1.938,4.419-4.488,4.419 S399.388,89.731,399.388,87.148z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M409.724,87.148c0-2.618,1.938-4.352,4.488-4.352s4.488,1.734,4.488,4.352c0,2.583-1.938,4.419-4.488,4.419 S409.724,89.731,409.724,87.148z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M420.059,87.148c0-2.618,1.938-4.352,4.488-4.352s4.488,1.734,4.488,4.352c0,2.583-1.938,4.419-4.488,4.419 S420.059,89.731,420.059,87.148z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M441.852,67.43h8.023v23.798h-8.023V67.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M461.775,73.481v4.08h9.927v6.051h-9.927v7.615h-8.023V67.43h19.344v6.052H461.775z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M499.991,82.592v8.635h-8.023V82.49l-8.975-15.061h8.465l4.861,8.228l4.896-8.228h7.751L499.991,82.592z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M508.016,79.329c0-7.207,5.678-12.443,13.429-12.443s13.429,5.236,13.429,12.443 c0,7.208-5.678,12.443-13.429,12.443S508.016,86.536,508.016,79.329z M526.782,79.329c0-3.706-2.38-5.949-5.337-5.949 s-5.337,2.244-5.337,5.949s2.38,5.95,5.337,5.95S526.782,83.034,526.782,79.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M537.595,80.519V67.43h8.023v12.851c0,3.638,1.394,4.998,3.638,4.998c2.244,0,3.638-1.36,3.638-4.998V67.43 h7.887v13.089c0,7.139-4.284,11.253-11.593,11.253S537.595,87.658,537.595,80.519z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M170.432,128.292l3.978,6.936h-8.329l-3.366-5.983h-1.972l-1.19,5.983h-8.023l4.76-23.798h10.675 c6.29,0,9.893,2.89,9.893,7.819C176.857,123.499,174.477,126.762,170.432,128.292z M165.74,117.617h-2.686l-1.122,5.576h3.297 c2.21,0,3.501-1.156,3.501-3.162C168.731,118.331,167.576,117.617,165.74,117.617z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M188.282,117.481l-0.544,2.788h10.063l-1.156,5.779h-10.097l-0.612,3.128h11.933l-1.224,6.051h-19.786 l4.76-23.798h19.344l-1.224,6.052H188.282z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M217.079,131.08h-9.077l-2.38,4.147h-8.465l15.162-23.798h7.888l5.643,23.798h-7.989L217.079,131.08z M215.957,125.301l-1.156-6.085l-3.501,6.085H215.957z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M231.904,111.43h8.023l-3.501,17.577h10.743l-1.258,6.221h-18.766L231.904,111.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M252.882,111.43h8.023l-3.501,17.577h10.743l-1.258,6.221h-18.766L252.882,111.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M282.562,126.592l-1.7,8.635h-8.023l1.734-8.737l-5.95-15.061h8.057l3.23,8.228l6.629-8.228h8.057 L282.562,126.592z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M341.651,111.43l-7.615,23.798h-8.602l-3.841-12.715l-4.046,12.715h-8.601l-7.615-23.798h8.261 l4.147,13.531l4.386-13.531h7.377l4.147,13.701l4.386-13.701H341.651z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M358.79,131.08h-9.043l-1.598,4.147h-8.159l10.403-23.798h7.887l10.403,23.798h-8.295L358.79,131.08z M356.58,125.301l-2.312-5.983l-2.312,5.983H356.58z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M393.435,111.43v23.798h-6.595l-9.043-10.811v10.811h-7.819V111.43h6.595l9.043,10.811V111.43H393.435z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M402.48,117.651h-6.969v-6.222h21.961v6.222h-6.969v17.576h-8.023V117.651z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M434.916,117.651h-6.969v-6.222h21.961v6.222h-6.969v17.576h-8.023V117.651z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M450.692,123.329c0-7.207,5.677-12.443,13.429-12.443s13.429,5.236,13.429,12.443 c0,7.208-5.677,12.443-13.429,12.443S450.692,130.536,450.692,123.329z M469.458,123.329c0-3.706-2.38-5.949-5.337-5.949 s-5.337,2.244-5.337,5.949s2.38,5.95,5.337,5.95S469.458,127.034,469.458,123.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M52.863,168.519V155.43h8.023v12.851c0,3.638,1.394,4.998,3.638,4.998c2.244,0,3.638-1.36,3.638-4.998 V155.43h7.887v13.089c0,7.139-4.284,11.253-11.593,11.253S52.863,175.658,52.863,168.519z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M103.18,155.43v23.798h-6.595l-9.043-10.811v10.811h-7.819V155.43h6.595l9.043,10.811V155.43H103.18z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M105.562,177.324l2.584-5.847c2.244,1.326,5.235,2.176,7.853,2.176c2.278,0,3.094-0.476,3.094-1.292 c0-2.992-13.157-0.578-13.157-9.451c0-4.419,3.706-8.023,11.083-8.023c3.196,0,6.493,0.68,8.975,2.074l-2.414,5.813 c-2.346-1.19-4.555-1.768-6.629-1.768c-2.346,0-3.094,0.68-3.094,1.496c0,2.856,13.156,0.476,13.156,9.247 c0,4.352-3.706,8.023-11.083,8.023C111.954,179.771,107.942,178.786,105.562,177.324z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M129.192,168.519V155.43h8.023v12.851c0,3.638,1.394,4.998,3.638,4.998c2.244,0,3.638-1.36,3.638-4.998 V155.43h7.887v13.089c0,7.139-4.284,11.253-11.593,11.253S129.192,175.658,129.192,168.519z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M179.509,172.666c0,4.148-3.501,6.562-10.063,6.562h-13.395V155.43h12.714c6.562,0,9.621,2.618,9.621,6.222 c0,2.21-1.122,4.045-3.297,5.133C177.877,167.805,179.509,169.845,179.509,172.666z M163.939,161.04v3.536h3.739 c1.802,0,2.618-0.612,2.618-1.768s-0.815-1.768-2.618-1.768H163.939z M171.418,171.748c0-1.224-0.884-1.87-2.652-1.87h-4.827v3.74 h4.827C170.534,173.618,171.418,172.972,171.418,171.748z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M180.837,177.324l2.584-5.847c2.244,1.326,5.235,2.176,7.853,2.176c2.278,0,3.094-0.476,3.094-1.292 c0-2.992-13.157-0.578-13.157-9.451c0-4.419,3.706-8.023,11.083-8.023c3.196,0,6.493,0.68,8.975,2.074l-2.414,5.813 c-2.346-1.19-4.555-1.768-6.629-1.768c-2.346,0-3.094,0.68-3.094,1.496c0,2.856,13.156,0.476,13.156,9.247 c0,4.352-3.706,8.023-11.083,8.023C187.229,179.771,183.217,178.786,180.837,177.324z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M203.719,167.329c0-7.309,5.609-12.443,13.259-12.443c4.658,0,8.329,1.7,10.675,4.76l-5.065,4.521 c-1.394-1.768-3.06-2.788-5.202-2.788c-3.332,0-5.575,2.312-5.575,5.949s2.244,5.95,5.575,5.95c2.142,0,3.808-1.02,5.202-2.788 l5.065,4.521c-2.346,3.06-6.017,4.76-10.675,4.76C209.329,179.771,203.719,174.638,203.719,167.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M240.166,173.244h-2.176v5.983h-8.023V155.43h11.457c6.629,0,10.845,3.468,10.845,8.976 c0,3.434-1.632,6.017-4.488,7.479l4.998,7.343h-8.567L240.166,173.244z M240.914,161.617h-2.924v5.576h2.924 c2.209,0,3.264-1.054,3.264-2.788C244.177,162.671,243.123,161.617,240.914,161.617z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M255.296,155.43h8.023v23.798h-8.023V155.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M290.654,172.666c0,4.148-3.501,6.562-10.063,6.562h-13.395V155.43h12.714c6.562,0,9.621,2.618,9.621,6.222 c0,2.21-1.122,4.045-3.297,5.133C289.022,167.805,290.654,169.845,290.654,172.666z M275.083,161.04v3.536h3.739 c1.802,0,2.618-0.612,2.618-1.768s-0.815-1.768-2.618-1.768H275.083z M282.562,171.748c0-1.224-0.884-1.87-2.652-1.87h-4.827v3.74 h4.827C281.679,173.618,282.562,172.972,282.562,171.748z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M313.264,173.176v6.051h-19.786V155.43h19.344v6.052h-11.457v2.788h10.063v5.779h-10.063v3.128H313.264z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M324.417,175.148c0,1.088-0.136,1.904-1.326,4.454l-2.38,5.065h-4.759l1.7-5.746 c-1.36-0.646-2.21-1.972-2.21-3.773c0-2.652,1.904-4.352,4.488-4.352S324.417,172.496,324.417,175.148z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M351.377,170.592v8.635h-8.023v-8.737l-8.975-15.061h8.465l4.861,8.228l4.896-8.228h7.751L351.377,170.592z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M359.402,167.329c0-7.207,5.678-12.443,13.429-12.443s13.429,5.236,13.429,12.443 c0,7.208-5.678,12.443-13.429,12.443S359.402,174.536,359.402,167.329z M378.168,167.329c0-3.706-2.38-5.949-5.337-5.949 s-5.337,2.244-5.337,5.949s2.38,5.95,5.337,5.95S378.168,171.034,378.168,167.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M388.982,168.519V155.43h8.023v12.851c0,3.638,1.394,4.998,3.638,4.998c2.244,0,3.638-1.36,3.638-4.998 V155.43h7.887v13.089c0,7.139-4.284,11.253-11.593,11.253S388.982,175.658,388.982,168.519z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M423.559,158.014c0,1.088-0.136,1.904-1.326,4.454l-2.38,5.065h-4.759l1.7-5.746 c-1.36-0.646-2.209-1.972-2.209-3.773c0-2.652,1.903-4.352,4.487-4.352S423.559,155.362,423.559,158.014z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M426.177,155.43h8.023v17.577h10.743v6.221h-18.766V155.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M447.155,155.43h8.023v17.577h10.743v6.221h-18.766V155.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M501.79,155.43v23.798h-8.023v-8.771h-7.411v8.771h-8.023V155.43h8.023v8.432h7.411v-8.432H501.79z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M521.884,175.08h-9.043l-1.598,4.147h-8.159l10.403-23.798h7.887l10.403,23.798h-8.295L521.884,175.08z M519.674,169.301l-2.312-5.983l-2.312,5.983H519.674z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M557.141,155.43l-10.063,23.798h-7.887l-10.063-23.798h8.635l5.677,13.905l5.813-13.905H557.141z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M577.711,173.176v6.051h-19.786V155.43h19.344v6.052h-11.457v2.788h10.063v5.779h-10.063v3.128H577.711z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M59.34,205.651h-6.97v-6.222h21.962v6.222h-6.969v17.576H59.34V205.651z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M75.116,211.329c0-7.207,5.678-12.443,13.429-12.443s13.429,5.236,13.429,12.443 c0,7.208-5.678,12.443-13.429,12.443S75.116,218.536,75.116,211.329z M93.882,211.329c0-3.706-2.38-5.949-5.337-5.949 s-5.337,2.244-5.337,5.949s2.38,5.95,5.337,5.95S93.882,215.034,93.882,211.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M114.147,211.329c0-7.309,5.609-12.443,13.259-12.443c4.657,0,8.329,1.7,10.675,4.76l-5.065,4.521 c-1.394-1.768-3.06-2.788-5.202-2.788c-3.332,0-5.575,2.312-5.575,5.949s2.244,5.95,5.575,5.95c2.142,0,3.808-1.02,5.202-2.788 l5.065,4.521c-2.346,3.06-6.018,4.76-10.675,4.76C119.757,223.771,114.147,218.638,114.147,211.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M140.395,199.43h8.023v17.577h10.743v6.221h-18.766V199.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M161.373,199.43h8.023v23.798h-8.023V199.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M172.32,211.329c0-7.309,5.609-12.443,13.259-12.443c4.657,0,8.329,1.7,10.675,4.76l-5.065,4.521 c-1.394-1.768-3.06-2.788-5.202-2.788c-3.332,0-5.575,2.312-5.575,5.949s2.244,5.95,5.575,5.95c2.142,0,3.808-1.02,5.202-2.788 l5.065,4.521c-2.346,3.06-6.018,4.76-10.675,4.76C177.93,223.771,172.32,218.638,172.32,211.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M208.257,215.34l-1.802,2.006v5.881h-7.887V199.43h7.887v8.635l7.819-8.635h8.737l-9.519,10.471 l9.995,13.327h-9.281L208.257,215.34z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M239.945,205.651h-6.969v-6.222h21.961v6.222h-6.969v17.576h-8.023V205.651z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M280.471,199.43v23.798h-8.023v-8.771h-7.411v8.771h-8.023V199.43h8.023v8.432h7.411v-8.432H280.471z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M294.547,217.244h-2.176v5.983h-8.023V199.43h11.457c6.629,0,10.845,3.468,10.845,8.976 c0,3.434-1.632,6.017-4.488,7.479l4.998,7.343h-8.567L294.547,217.244z M295.295,205.617h-2.924v5.576h2.924 c2.209,0,3.264-1.054,3.264-2.788C298.559,206.671,297.505,205.617,295.295,205.617z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M308.726,211.329c0-7.207,5.677-12.443,13.429-12.443s13.429,5.236,13.429,12.443 c0,7.208-5.677,12.443-13.429,12.443S308.726,218.536,308.726,211.329z M327.492,211.329c0-3.706-2.38-5.949-5.337-5.949 s-5.337,2.244-5.337,5.949s2.38,5.95,5.337,5.95S327.492,215.034,327.492,211.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M338.306,212.519V199.43h8.023v12.851c0,3.638,1.394,4.998,3.638,4.998s3.638-1.36,3.638-4.998V199.43 h7.887v13.089c0,7.139-4.284,11.253-11.593,11.253S338.306,219.658,338.306,212.519z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M380.906,210.683h6.969v10.063c-2.89,1.972-6.867,3.026-10.369,3.026c-7.683,0-13.292-5.133-13.292-12.443 c0-7.309,5.609-12.443,13.463-12.443c4.691,0,8.465,1.632,10.879,4.59l-5.134,4.521c-1.496-1.734-3.229-2.618-5.337-2.618 c-3.536,0-5.779,2.278-5.779,5.949c0,3.57,2.244,5.95,5.677,5.95c0.986,0,1.938-0.17,2.924-0.578V210.683z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M414.769,199.43v23.798h-8.023v-8.771h-7.411v8.771h-8.023V199.43h8.023v8.432h7.411v-8.432H414.769z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M452.304,216.666c0,4.148-3.501,6.562-10.063,6.562h-13.395V199.43h12.714c6.562,0,9.621,2.618,9.621,6.222 c0,2.21-1.122,4.045-3.297,5.133C450.672,211.805,452.304,213.845,452.304,216.666z M436.734,205.04v3.536h3.739 c1.802,0,2.618-0.612,2.618-1.768s-0.815-1.768-2.618-1.768H436.734z M444.213,215.748c0-1.224-0.884-1.87-2.652-1.87h-4.827v3.74 h4.827C443.329,217.618,444.213,216.972,444.213,215.748z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M454.176,211.329c0-7.207,5.677-12.443,13.429-12.443s13.429,5.236,13.429,12.443 c0,7.208-5.677,12.443-13.429,12.443S454.176,218.536,454.176,211.329z M472.942,211.329c0-3.706-2.38-5.949-5.337-5.949 s-5.337,2.244-5.337,5.949s2.38,5.95,5.337,5.95S472.942,215.034,472.942,211.329z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M498.171,223.228l-4.114-6.357l-4.012,6.357H480.9l8.601-12.001l-8.295-11.797h9.009l4.046,5.983 l3.943-5.983h8.635l-8.261,11.491l8.771,12.307H498.171z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M524.078,223.228l-4.113-6.357l-4.012,6.357h-9.145l8.601-12.001l-8.295-11.797h9.009l4.046,5.983 l3.943-5.983h8.635l-8.261,11.491l8.771,12.307H524.078z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M534.246,199.43h8.023v23.798h-8.023V199.43z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M565.932,217.176v6.051h-19.786V199.43h19.344v6.052h-11.457v2.788h10.063v5.779h-10.063v3.128H565.932z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M567.838,199.43h9.179l-1.53,14.687h-6.119L567.838,199.43z M567.94,219.488 c0-2.278,1.835-4.011,4.487-4.011s4.488,1.733,4.488,4.011c0,2.244-1.836,4.08-4.488,4.08S567.94,221.731,567.94,219.488z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"btn_x5F_1_3_",className:"darkPatternPulse",onClick:function onClick(e){return _this5.unsubscribe();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"actionbutton_12_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#DB2103",d:"M541,522.142v60.787c0,4.665-4.864,8.481-10.809,8.481H81.59c-5.945,0-10.809-3.816-10.809-8.481v-60.787 c0-4.665,4.864-8.481,10.809-8.481h448.599C536.135,513.66,541,517.477,541,522.142z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"79.259",y:"539.278",fill:"none",width:"452.608",height:"35.136"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cancel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M105.683,551.613c0-6.764,5.191-11.515,12.271-11.515c4.311,0,7.708,1.573,9.88,4.405l-4.688,4.185 c-1.29-1.637-2.832-2.58-4.814-2.58c-3.083,0-5.16,2.14-5.16,5.506c0,3.367,2.077,5.506,5.16,5.506 c1.982,0,3.524-0.943,4.814-2.579l4.688,4.185c-2.171,2.831-5.569,4.404-9.88,4.404 C110.875,563.129,105.683,558.378,105.683,551.613z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M144.669,558.787h-8.37l-1.479,3.839h-7.551l9.628-22.024h7.299l9.628,22.024h-7.677L144.669,558.787z M142.624,553.438l-2.14-5.538l-2.139,5.538H142.624z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M176.734,540.602v22.024h-6.104l-8.369-10.006v10.006h-7.237v-22.024h6.104l8.369,10.005v-10.005H176.734z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M179.442,551.613c0-6.764,5.191-11.515,12.271-11.515c4.311,0,7.709,1.573,9.88,4.405l-4.688,4.185 c-1.29-1.637-2.832-2.58-4.813-2.58c-3.083,0-5.16,2.14-5.16,5.506c0,3.367,2.077,5.506,5.16,5.506 c1.982,0,3.524-0.943,4.813-2.579l4.688,4.185c-2.171,2.831-5.569,4.404-9.88,4.404 C184.634,563.129,179.442,558.378,179.442,551.613z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M222.047,557.025v5.601h-18.312v-22.024h17.903v5.601h-10.604v2.58h9.313v5.349h-9.313v2.895H222.047z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M224.912,540.602h7.425v16.267h9.942v5.758h-17.368V540.602z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M252.383,560.864l2.391-5.412c2.077,1.227,4.845,2.014,7.268,2.014c2.108,0,2.863-0.44,2.863-1.195 c0-2.77-12.177-0.535-12.177-8.747c0-4.09,3.43-7.425,10.257-7.425c2.958,0,6.01,0.629,8.307,1.919l-2.234,5.38 c-2.171-1.101-4.216-1.636-6.136-1.636c-2.171,0-2.863,0.629-2.863,1.384c0,2.644,12.177,0.44,12.177,8.559 c0,4.027-3.43,7.425-10.257,7.425C258.298,563.129,254.585,562.217,252.383,560.864z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M274.252,552.715v-12.113h7.426v11.893c0,3.367,1.29,4.625,3.366,4.625s3.367-1.258,3.367-4.625v-11.893 h7.3v12.113c0,6.607-3.964,10.414-10.729,10.414C278.217,563.129,274.252,559.322,274.252,552.715z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M320.822,556.554c0,3.838-3.241,6.072-9.313,6.072h-12.396v-22.024h11.768c6.072,0,8.904,2.422,8.904,5.758 c0,2.045-1.038,3.744-3.052,4.751C319.312,552.054,320.822,553.941,320.822,556.554z M306.411,545.793v3.271h3.461 c1.667,0,2.422-0.565,2.422-1.636c0-1.069-0.755-1.636-2.422-1.636H306.411z M313.333,555.704c0-1.133-0.818-1.73-2.454-1.73 h-4.468v3.461h4.468C312.515,557.435,313.333,556.837,313.333,555.704z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M322.052,560.864l2.391-5.412c2.077,1.227,4.845,2.014,7.268,2.014c2.108,0,2.863-0.44,2.863-1.195 c0-2.77-12.177-0.535-12.177-8.747c0-4.09,3.43-7.425,10.257-7.425c2.958,0,6.01,0.629,8.307,1.919l-2.234,5.38 c-2.171-1.101-4.216-1.636-6.136-1.636c-2.171,0-2.863,0.629-2.863,1.384c0,2.644,12.177,0.44,12.177,8.559 c0,4.027-3.43,7.425-10.257,7.425C327.967,563.129,324.254,562.217,322.052,560.864z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M343.229,551.613c0-6.764,5.191-11.515,12.271-11.515c4.311,0,7.709,1.573,9.88,4.405l-4.688,4.185 c-1.29-1.637-2.832-2.58-4.813-2.58c-3.083,0-5.16,2.14-5.16,5.506c0,3.367,2.077,5.506,5.16,5.506 c1.982,0,3.524-0.943,4.813-2.579l4.688,4.185c-2.171,2.831-5.569,4.404-9.88,4.404 C348.421,563.129,343.229,558.378,343.229,551.613z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M376.961,557.088h-2.014v5.538h-7.425v-22.024h10.603c6.136,0,10.037,3.209,10.037,8.306 c0,3.178-1.51,5.569-4.153,6.923l4.625,6.796h-7.929L376.961,557.088z M377.653,546.328h-2.706v5.16h2.706 c2.045,0,3.021-0.975,3.021-2.58C380.674,547.303,379.698,546.328,377.653,546.328z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M390.965,540.602h7.425v22.024h-7.425V540.602z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M422.619,548.907c0,5.098-3.901,8.307-10.037,8.307h-3.178v5.412h-7.425v-22.024h10.603 C418.717,540.602,422.619,543.811,422.619,548.907z M415.13,548.907c0-1.604-0.976-2.58-3.021-2.58h-2.706v5.16h2.706 C414.155,551.487,415.13,550.513,415.13,548.907z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M429.354,546.359h-6.45v-5.758h20.325v5.758h-6.45v16.267h-7.426V546.359z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M445.152,540.602h7.425v22.024h-7.425V540.602z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M455.284,551.613c0-6.67,5.254-11.515,12.428-11.515c7.174,0,12.428,4.845,12.428,11.515 c0,6.671-5.254,11.516-12.428,11.516C460.539,563.129,455.284,558.284,455.284,551.613z M472.652,551.613 c0-3.43-2.202-5.506-4.94-5.506c-2.737,0-4.939,2.076-4.939,5.506s2.202,5.506,4.939,5.506 C470.45,557.119,472.652,555.043,472.652,551.613z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M504.559,540.602v22.024h-6.104l-8.369-10.006v10.006h-7.237v-22.024h6.104l8.369,10.005v-10.005H504.559z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"scared_1_",onClick:function onClick(e){return _this5.hitBoxxie();},className:""+(this.state.hits===3?'boxxieKnockOut':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"bot_8_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36B7FF",points:"304.142,259.249 294.667,382.663 373.333,399.663 383,286.996 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M231.667,277.996l-5.4,78.396l38.436,9.978c-0.009-0.012,0.019-0.073,0.065-0.157 c0.032,0.047,0.06,0.087,0.071,0.103l29.828,16.346l9.667-123.333L231.667,277.996z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#36B7FF",d:"M253.385,292.716c0,0-11.171-0.255-11.506-0.267c-11.107-0.354-20.702,11.104-21.288,25.622 c-0.413,14.595,8.248,26.598,19.529,27.026c11.281,0.428,11.506,0.267,11.506,0.267c11.281,0.428,20.875-11.027,21.288-25.622 C273.327,305.147,264.666,293.144,253.385,292.716z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M250.696,311.027L250.696,311.027c-1.882-4.016-5.214-6.589-9.173-6.749 c-6.176-0.29-11.423,6.122-11.695,14.165c-0.27,8.044,4.52,14.657,10.695,14.946c3.959,0.16,7.429-2.372,9.556-6.103 c1.276-2.238,2.056-5,2.138-8.064C252.427,316.113,251.76,313.346,250.696,311.027z M241.878,292.448 c11.281,0.428,19.942,12.431,19.529,27.026s-10.007,26.05-21.288,25.622c-11.281-0.428-19.942-12.431-19.529-27.026 C221.176,303.551,230.77,292.096,241.878,292.448z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00374C",d:"M250.696,311.027c1.065,2.318,1.73,5.086,1.646,8.148c-0.132,2.938-0.912,5.701-2.138,8.064 c-1.148,0.744-2.269,1.189-3.59,1.137c-3.959-0.16-7.087-4.403-6.825-9.557c0.138-5.106,3.561-9.206,7.521-9.046 C248.458,309.751,249.627,310.152,250.696,311.027L250.696,311.027z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00374C",d:"M312.413,360.213l27.836,5.119l23.93,10.574l-0.942-10.625l-21.834-4.691l-18.77-9.603L312.413,360.213z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#006382",points:"339.936,310.036 313.986,298.052 319.075,304.527 307.947,303.377 317.345,307.729  313.358,312.506 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M356.384,307.84c-1.088,0.957-2.004,2.145-2.657,3.541c-2.534,5.42-0.194,11.868,5.227,14.402 c5.42,2.534,11.868,0.194,14.402-5.227c0.653-1.397,0.977-2.861,1.013-4.31L356.384,307.84z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M353.727,311.381c-2.534,5.42-0.193,11.868,5.227,14.402c0.521,0.243,1.053,0.428,1.588,0.583 c2.896-0.838,5.432-2.864,6.809-5.81c0.653-1.397,0.977-2.861,1.013-4.31l-13.73-6.418 C354.297,310.316,353.986,310.827,353.727,311.381z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#00374C",points:"373.333,399.663 317.333,393.663 257.333,379.33 226.267,356.393 264.703,366.371  294.667,382.663 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#006382",points:"283,415.326 275.667,379.326 310.5,389.326 319.333,417.659 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_6_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M453.264,397.324c-0.479-5.652,1.79-11.668,5.015-15.783l9.994-11.704 c-2.963,4.091-4.509,9.253-4.054,14.641c1.015,11.961,11.567,20.861,23.527,19.846c6.046-0.514,11.234-3.336,14.842-7.613l0,0 l-10.957,12.844c-3.499,4.004-9.059,7.123-14.842,7.613C464.832,418.184,454.279,409.284,453.264,397.324z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00435E",d:"M472.868,380.304l-1.698,0.276c0.888-6.694,6.39-12.06,13.356-12.65L472.868,380.304z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M468.142,369.849c3.553-4.934,9.222-8.329,15.792-8.886l0.591,6.965 c-6.965,0.591-12.468,5.956-13.356,12.65c-0.174,1.073-0.215,2.137-0.115,3.32c0.691,8.149,7.822,14.163,15.97,13.471 c0.657-0.056,1.183-0.1,1.829-0.288c7.152-1.534,12.279-8.191,11.642-15.683l6.965-0.591 c0.514,6.046-1.396,11.635-5.003,15.913c-3.608,4.277-8.796,7.102-14.842,7.613c-11.961,1.015-22.512-7.885-23.527-19.846 C463.621,378.97,465.179,373.938,468.142,369.849L468.142,369.849z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00435E",d:"M500.496,381.4c0.636,7.491-4.492,14.148-11.642,15.683l0.107-1.862L500.496,381.4z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#0C91BF",cx:"459.007",cy:"419.447",rx:"20.586",ry:"20.586"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M465.395,399.859c-1.784-0.579-3.587-0.876-5.374-0.962c-3.643,2.142-6.556,5.558-7.962,9.894 c-3.051,9.409,2.103,19.508,11.512,22.559c4.336,1.406,8.811,1.052,12.684-0.641c0.979-1.498,1.796-3.132,2.374-4.917 C482.135,414.978,476.212,403.367,465.395,399.859z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"471.861",cy:"412.918",r:"4.02"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_5_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M362.751,427.572c-7.434,1.076-11.183,4.75-11.183,4.75c0.461,2.963,1.202,6.306,2.254,9.851 c4.305-3.984,16.664-8.243,21.642-6.355c-1.22-4.077-1.678-6.866-1.693-6.976 C373.771,428.842,370.185,426.496,362.751,427.572z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M375.464,435.817c-4.978-1.888-17.337,2.371-21.642,6.355l-0.008,0.007 c0.737,2.518,1.634,5.14,2.702,7.803l0.037-0.019c4.21-5.272,16.881-8.895,20.691-8.156l0.231-0.093 C376.646,439.588,375.984,437.575,375.464,435.817z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M377.244,441.807c-3.809-0.739-16.481,2.884-20.691,8.156l-0.037,0.019 c2.336,5.897,5.47,12.005,9.521,17.69c1.291-5.582,12.043-13.865,17.438-14.215c-2.6-3.901-4.548-8.02-6.001-11.744 L377.244,441.807z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M383.476,453.458c-5.395,0.35-16.147,8.632-17.438,14.215c1.33,1.877,2.765,3.703,4.306,5.463 c0.646,0.738,1.307,1.463,1.991,2.167l0.155-0.149c0.384-11.196,15.199-16.246,15.199-16.246l0.008-0.007 C386.13,457.189,384.725,455.351,383.476,453.458z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M387.688,458.907c0,0-14.815,5.051-15.199,16.246l-0.155,0.149c4.751,4.964,10.403,9.236,17.06,12.22 l0.009-0.021c-1.359-4.919,3.603-16.049,8.853-20.643l0.025-0.049c-4.165-1.921-7.664-4.709-10.586-7.908L387.688,458.907z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M398.282,466.809l-0.025,0.049c-5.251,4.595-10.213,15.724-8.853,20.643l-0.009,0.021 c2.13,0.96,4.362,1.789,6.714,2.46c-1.496-6.13,4.31-17.754,8.148-21.139C402.124,468.361,400.128,467.678,398.282,466.809z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M456.953,431.552c-6.946-0.709-11.821,1.616-11.821,1.616c-0.205,1.55-0.472,3.06-0.785,4.501 c5.482-1.879,18.202-0.467,22.05,4.147c0.423-1.89,0.767-3.793,1.016-5.695C467.414,436.122,463.907,432.254,456.953,431.552z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M404.256,468.843c-3.838,3.386-9.644,15.009-8.148,21.139c4.432,1.28,9.254,2.028,14.47,2.093 c2.742,0.031,5.448-0.166,8.117-0.574c-3.399-7.98-4.626-20.427-4.776-22.087c-1.051,0.133-2.077,0.202-3.053,0.188 C408.522,469.576,406.317,469.306,404.256,468.843z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M444.347,437.669c-0.688,3.154-1.62,6.06-2.753,8.721c7.472,0.208,13.926,3.302,19.724,9.4 l0.373,0.162c2.048-4.548,3.646-9.313,4.706-14.136C462.549,437.202,449.829,435.79,444.347,437.669z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M419.289,468.136c-1.837,0.63-3.647,1.06-5.37,1.278c0.15,1.661,1.377,14.107,4.776,22.087 c2.538-0.388,5.032-0.982,7.473-1.761l-6.872-21.597L419.289,468.136z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M419.296,468.144l6.872,21.597c5.237-1.678,10.244-4.24,14.87-7.61 c0.034-4.102-3.296-12.034-12.48-18.915C425.534,465.454,422.371,467.082,419.296,468.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M441.594,446.391c-0.78,1.823-1.655,3.538-2.594,5.148c6.943,0.535,15.644,5.436,18.939,11.513 l0.056,0.033c1.355-2.299,2.592-4.685,3.697-7.131l-0.373-0.162C455.52,449.693,449.066,446.599,441.594,446.391z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M439,451.539c-2.054,3.454-4.459,6.399-7.053,8.833l0.04,0.046 c7.386,2.794,12.477,8.968,14.964,16.728c1.183-1.13,2.32-2.329,3.438-3.579c2.826-3.193,5.371-6.722,7.605-10.483 l-0.056-0.033C454.644,456.975,445.943,452.074,439,451.539z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M431.947,460.372c-1.097,1.042-2.239,1.986-3.389,2.844c9.185,6.881,12.515,14.813,12.48,18.915 c2.04-1.5,4.019-3.164,5.914-4.985c-2.487-7.76-7.578-13.934-14.964-16.728L431.947,460.372z"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"body_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_4_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#006382",points:"341.108,540.502 335.522,580.08 288.057,590.373 289.871,532.799 305.828,530.333 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004966",d:"M289.871,532.799l-1.814,57.575l-0.143,0.042l-28.9-4.179c-0.978-27.146-1.731-48.384-1.731-48.384 L289.871,532.799z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M287.222,616.992l0.835-26.622l-0.143,0.042l-28.9-4.179c0.349,9.73,0.725,20.22,1.104,30.759 L287.222,616.992L287.222,616.992z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C91BF",points:"330.318,616.992 335.522,580.08 288.057,590.373 287.222,616.992 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#332204",points:"352.8,559.309 277.139,560.072 241.778,565.687 233.831,580.597 263.783,567.834  282.398,583.823 287.683,565.227 322.68,578.744 330.908,569.374 348.426,575.75 354.108,566.394 369.996,568.224 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#99710E",points:"421.059,412.752 425.783,552.459 278.13,553.435 264.615,404.703 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#725006",points:"278.13,553.435 175.66,570.605 157.406,428.197 264.615,404.703 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#442C01",points:"425.783,552.459 334.378,562.729 175.66,570.605 278.13,553.435 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#332204",points:"220.899,436.705 222.583,428.492 216.083,427.159 197.167,430.992 200.108,433.292  192.096,442.912 196.863,453.152 191.791,477.201 197.37,476.425 193.819,488.682 225.463,475.494 220.899,469.753  230.129,458.426 224.753,449.582 227.594,435.619 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.9876 -0.1569 0.1569 0.9876 -67.7515 36.9212)",fill:"#006382",cx:"199.98",cy:"447.594",rx:"22.484",ry:"22.484"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0C91BF",d:"M196.447,425.398c-2.023,0.321-3.925,0.925-5.707,1.727c-2.484,3.891-3.625,8.659-2.844,13.576 c1.695,10.669,11.716,17.943,22.385,16.248c4.917-0.781,9.097-3.344,12.026-6.911c0.21-1.943,0.195-3.939-0.126-5.962 C220.232,431.813,208.712,423.45,196.447,425.398z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.9876 -0.1569 0.1569 0.9876 -65.7646 37.9591)",fill:"#21ABE8",cx:"207.548",cy:"435.528",rx:"4.391",ry:"4.391"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E0AD3B",points:"157.406,428.197 138.286,435.187 138.982,442.851 230.776,424.149 264.615,404.703 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"logo_1_",fill:"#2D2619",d:"M393.579,459.879l2.978,44.374c0.018,0.273-0.08,0.417-0.294,0.428l-29.564,15.216l0,0 l-47.219-4.54c-0.376,0.023-0.647-0.259-0.668-0.556l-4.548-67.759c-0.02-0.296,0.212-0.591,0.59-0.589l46.662-3.768 l31.703,16.648C393.444,459.468,393.561,459.605,393.579,459.879z M392,466.891l-0.156-2.333 c-0.018-0.275-0.146-0.547-0.253-0.547l-6.378-2.558c-0.109,0.002-0.209,0.14-0.191,0.417l1.503,22.39 c0.018,0.277,0.146,0.549,0.256,0.545l1.529-0.049c0.109-0.003,0.2-0.283,0.181-0.558l-0.592-8.827l4.279,0.591 c0.107-0.003,0.207-0.143,0.189-0.417l-0.166-2.471c-0.018-0.275-0.137-0.41-0.253-0.546l-4.308-1.019l-0.398-5.931l4.564,1.593 C391.92,467.304,392.009,467.029,392,466.891z M393.619,500.687c0.207-0.148,0.277-0.703,0.141-1.108l-1.934-4.598l1.092-4.73 c0.08-0.417-0.064-0.962-0.28-0.954l-0.649,0.024c-0.109,0.005-0.207,0.145-0.189,0.42l-0.815,4.034l-1.445-3.671 c-0.118-0.133-0.236-0.267-0.345-0.264l-0.862,0.171c-0.327,0.013-0.39,0.707-0.253,1.117l1.939,4.485l-1.353,5.876 c-0.072,0.558,0.073,1.104,0.392,0.951l0.743-0.315c0.109-0.005,0.199-0.287,0.299-0.43l0.971-5.023l1.577,4.065 c0.118,0.132,0.127,0.27,0.234,0.264L393.619,500.687z M384.056,504.919c2.252-0.954,3.579-4.075,3.302-8.221 c-0.278-4.147-1.98-6.576-4.27-6.21c-2.413,0.372-4.196,3.655-3.878,8.395C379.527,503.622,381.571,505.889,384.056,504.919z M383.732,463.957l-0.186-2.768c-0.018-0.277-0.148-0.553-0.266-0.69l-9.133-3.71c-0.233-0.14-0.327,0.141-0.308,0.421 l1.82,27.117c0.019,0.28,0.15,0.555,0.373,0.548l2.231-0.072c0.223-0.007,0.315-0.289,0.296-0.569l-0.71-10.591l6.049,0.985 c0.109-0.002,0.32-0.145,0.301-0.422l-0.195-2.908c-0.018-0.277-0.148-0.552-0.368-0.548l-6.079-1.427l-0.478-7.107l6.458,2.16 C383.659,464.513,383.752,464.234,383.732,463.957z M378.217,502.43c-0.13-1.954-0.996-3.173-2.339-3.111l0,0 c0.959-0.747,1.545-2.033,1.424-3.849c-0.225-3.351-2.043-3.7-3.82-3.349l-3.472,0.561c-0.34,0.014-0.642,0.59-0.614,1.012 l1.02,15.203c0.038,0.563,0.396,0.826,0.726,0.665l3.748-1.481C376.648,507.421,378.433,505.639,378.217,502.43z M372.278,474.179l-1.214-18.081c-0.028-0.42-0.272-0.701-0.509-0.841l-2.792-1.12c-0.236-0.141-0.445,0.142-0.426,0.422 l1.266,18.852c0.207,3.096-0.663,7.065-4.563,6.889l0,0l-2.486-37.05l-46.157,3.798l4.513,67.241l46.731,4.759l-2.22-33.091l0,0 C369.558,485.929,372.758,481.327,372.278,474.179z M383.265,493.124c-1.417,0.338-2.273,2.464-2.095,5.108 c0.178,2.642,1.285,4.262,2.692,3.773c1.402-0.487,2.141-2.608,1.973-5.1C385.566,494.557,384.576,492.932,383.265,493.124z M374.225,501.507l-1.773,0.511l0.254,3.791l2.101-0.675c0.663-0.176,1.401-0.916,1.308-2.315 C376.01,501.278,375.001,501.327,374.225,501.507z M373.68,495.064l-1.559,0.349l0.235,3.509l1.671-0.359 c0.664-0.171,1.412-0.766,1.327-2.027C375.148,495.141,374.354,495.036,373.68,495.064z M358.236,472.909l-1.336-19.904 c-0.029-0.427-0.28-0.711-0.512-0.711l-3.137,0.138c-0.234,0-0.448,0.284-0.419,0.713l1.333,19.845 c0.527,7.852,4.942,12.859,10.372,12.966l-0.379-5.656C360.014,480.41,358.456,476.179,358.236,472.909z M361.4,509.693 c0.279,0.697-0.02,1.427-0.606,1.32l-1.64-0.191c-0.348,0.02-0.6-0.25-0.744-0.672l-1.151-3.227l-4.834-0.315l-0.622,3.057 c-0.088,0.437-0.314,0.594-0.669,0.614l-1.426-0.063c-0.473,0.026-0.886-0.816-0.688-1.404l3.713-15.15 c0.088-0.434,0.313-0.587,0.548-0.597l1.414,0.087c0.233-0.01,0.604,0.262,0.748,0.686L361.4,509.693z M356.223,503.683 l-1.892-5.5l-1.168,5.367L356.223,503.683z M350.231,452.857l-14.625,0.858c-0.242,0-0.465,0.291-0.437,0.726l0.244,3.633 c0.03,0.437,0.291,0.726,0.533,0.724l5.28-0.316l1.736,25.863c0.029,0.433,0.287,0.715,0.527,0.708l2.987,0.05 c0.238-0.008,0.455-0.303,0.426-0.735l-1.748-26.049l5.42-0.312c0.235-0.001,0.451-0.288,0.422-0.718l-0.259-3.863 C350.837,453.143,350.584,452.856,350.231,452.857z M341.23,492.526l-1.213-0.099c-0.362,0.015-0.694,0.463-0.665,0.899 l0.73,10.883l0,0l-5.512-11.571c-0.14-0.287-0.395-0.423-0.638-0.414l-2.453-0.052c-0.367,0.013-0.583,0.462-0.554,0.901 l0.991,14.778c0.04,0.585,0.314,1.011,0.68,0.991l1.231,0.079c0.366-0.02,0.589-0.325,0.551-0.909l-0.734-10.947l0,0 l5.664,11.849c0.14,0.284,0.391,0.415,0.642,0.548l2.305,0.163c0.36-0.019,0.7-0.33,0.661-0.909l-1.02-15.198 C341.869,493.081,341.59,492.512,341.23,492.526z M327.642,453.275c-3.684,0.292-7.21,3.388-6.793,9.583 c0.723,10.766,10.101,6.78,10.552,13.499c0.187,2.776-1.687,4.143-3.284,4.184c-1.48,0.038-2.91-0.954-3.886-2.551 c-0.144-0.292-0.517-0.283-0.631-0.132l-1.574,2.548l-0.22,0.449c-0.104,0.298-0.086,0.593,0.059,0.885 c0.134,0.144,0.268,0.289,0.278,0.435c1.775,2.31,3.941,3.129,6.173,3.207c4.057,0.019,7.383-3.147,6.943-9.696 c-0.743-11.059-10.308-7.28-10.712-13.304c-0.188-2.792,1.342-3.974,3.068-3.983c1.229-0.006,2.485,0.427,3.43,1.737 c0.142,0.29,0.509,0.289,0.612-0.004l1.857-3.217c0.224-0.292,0.073-0.728-0.069-1.02 C331.603,453.86,329.607,453.275,327.642,453.275z M327.282,492.037l-1.123-0.105c-0.372,0.014-0.59,0.465-0.56,0.906 l0.977,14.56c0.03,0.441,0.316,1.016,0.687,0.997l1.121,0.087c0.37-0.02,0.596-0.326,0.558-0.914l-0.985-14.674 C327.928,492.454,327.652,492.021,327.282,492.037z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E0AD3B",points:"444.346,464.332 421.059,412.752 264.615,404.703 294.332,458.319 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_3_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2D2619",points:"424.865,528.747 425.784,552.46 278.132,553.436 278.092,553.44 275.613,526.162 \t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#1E180E",points:"275.613,526.162 278.092,553.44 175.662,570.606 172.924,548.8 \t\t\t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#513600",points:"358.156,554.893 278.923,555.327 236.221,563.026 230.504,575.66 257.386,566.887  260.16,582.789 297.237,564.359 317.628,571.892 329.238,563.196 359.425,576.169 350.899,562.756 374.494,564.104 \t\t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_2_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#006382",d:"M186.222,340.594c6.202-1.55,11.792-6.162,15.005-11.102l8.84-14.925 c-3.283,4.652-8.225,8.182-14.138,9.66c-13.127,3.277-26.466-4.733-29.743-17.86c-1.656-6.635-0.536-13.198,2.71-18.605l0,0 l-9.706,16.368c-2.995,5.192-4.295,12.258-2.71,18.605C159.757,335.86,173.096,343.872,186.222,340.594z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00435E",d:"M197.23,313.481l0.324,1.911c6.816-3.388,10.534-11.211,8.624-18.857L197.23,313.481z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M210.103,314.712c3.968-5.588,5.522-12.872,3.721-20.083l-7.645,1.908 c1.908,7.645-1.808,15.469-8.624,18.857c-1.081,0.576-2.201,1.009-3.499,1.333c-8.943,2.233-17.957-3.18-20.188-12.122 c-0.18-0.722-0.325-1.299-0.36-2.056c-0.971-8.187,4.26-16.082,12.484-18.134l-1.908-7.645 c-6.635,1.656-11.901,5.729-15.149,11.136c-3.246,5.408-4.368,11.97-2.71,18.605c3.277,13.127,16.616,21.136,29.743,17.86 C202.023,322.858,206.821,319.362,210.103,314.712L210.103,314.712z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00435E",d:"M185.99,284.414c-8.222,2.053-13.453,9.948-12.484,18.134l1.947-0.792L185.99,284.414z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{transform:"matrix(0.0275 -0.9996 0.9996 0.0275 -186.2708 493.5407)",fill:"#0C91BF",cx:"160.517",cy:"342.503",rx:"23.204",ry:"23.204"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M183.72,343.13c-0.058,2.113-0.421,4.141-1.004,6.072c-3.649,3.062-8.376,4.869-13.512,4.727 c-11.144-0.306-19.929-9.588-19.623-20.732c0.141-5.136,2.204-9.756,5.463-13.232c1.96-0.475,4.004-0.727,6.118-0.669 C173.972,319.648,184.072,330.317,183.72,343.13z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#FFFFFF",cx:"172.283",cy:"331.35",rx:"4.531",ry:"4.531"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M186.954,448.159c1.562,8.321-0.99,13.659-0.99,13.659c-3.328,0.588-7.164,1.017-11.328,1.187 c2.681-6.044,2.718-20.778-1.11-25.399c4.793-0.185,7.935-0.713,8.057-0.737C181.582,436.868,185.391,439.838,186.954,448.159 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M173.525,437.605c3.828,4.621,3.791,19.355,1.11,25.399l-0.004,0.011 c-2.954,0.131-6.078,0.131-9.307-0.037l0.007-0.047c4.089-6.412,3.334-21.247,1.157-25.041l0.015-0.28 C169.072,437.719,171.461,437.691,173.525,437.605z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M166.488,437.89c2.177,3.794,2.932,18.629-1.157,25.041l-0.007,0.047 c-7.141-0.343-14.798-1.458-22.339-3.707c5.483-3.412,10.398-17.899,8.805-23.781c5.109,1.351,10.212,1.927,14.713,2.12 L166.488,437.89z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M151.79,435.49c1.593,5.882-3.321,20.369-8.805,23.781c-2.487-0.735-4.957-1.599-7.396-2.601 c-1.023-0.42-2.036-0.861-3.037-1.334l0.102-0.219c11.801-4.49,11.788-22.133,11.788-22.133l0.004-0.011 C146.842,434.019,149.315,434.847,151.79,435.49z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M144.442,432.984c0,0,0.013,17.643-11.788,22.133l-0.102,0.219 c-7.027-3.258-13.642-7.729-19.252-13.742l0.019-0.017c5.742-0.344,15.804-9.693,18.791-16.968l0.043-0.045 c3.567,3.742,7.817,6.458,12.293,8.408L144.442,432.984z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M132.153,424.565l-0.043,0.045c-2.987,7.275-13.048,16.624-18.791,16.968l-0.019,0.017 c-1.8-1.921-3.498-4-5.071-6.264c7.083-0.639,17.364-11.068,19.577-16.396C129.097,421.033,130.554,422.913,132.153,424.565z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M148.371,349.136c3.288,7.15,2.585,13.197,2.585,13.197c-1.579,0.783-3.092,1.618-4.515,2.478 c0.006-6.532-6.137-19.584-12.461-22.006c1.862-1.14,3.766-2.2,5.704-3.16C139.684,339.645,145.087,341.976,148.371,349.136z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M127.806,418.934c-2.212,5.328-12.493,15.757-19.577,16.396c-2.981-4.261-5.536-9.131-7.507-14.67 c-1.032-2.913-1.809-5.871-2.347-8.867c9.75,0.717,23.473-2.511,25.299-2.957c0.242,1.17,0.542,2.289,0.913,3.325 C125.469,414.652,126.56,416.905,127.806,418.934z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M146.441,364.811c-3.113,1.883-5.873,3.937-8.298,6.115c-2.945-7.893-8.598-13.649-17.216-17.61 l-0.309-0.339c4.104-3.842,8.604-7.284,13.362-10.172C140.305,345.227,146.447,358.279,146.441,364.811z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M123.08,402.643c-0.003,2.19,0.199,4.276,0.594,6.193c-1.826,0.445-15.548,3.674-25.299,2.957 c-0.511-2.848-0.786-5.725-0.846-8.612l25.54-0.543L123.08,402.643z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M123.07,402.639l-25.54,0.543c-0.119-6.198,0.789-12.472,2.696-18.634 c4.363-1.532,14.037-0.871,24.724,6.416C123.665,395.004,123.081,398.972,123.07,402.639z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M138.143,370.926c-1.66,1.497-3.171,3.055-4.545,4.644c-3.101-7.21-11.501-14.704-19.182-16.003 l-0.055-0.048c1.958-2.283,4.052-4.473,6.258-6.542l0.309,0.339C129.545,357.277,135.197,363.033,138.143,370.926z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#21ABE8",d:"M133.598,375.57c-2.935,3.45-5.2,7.088-6.85,10.742l-0.064-0.026 c-5.673-6.86-14.113-10.039-23.296-9.863c0.774-1.674,1.638-3.323,2.564-4.972c2.375-4.178,5.212-8.179,8.409-11.932 l0.055,0.048C122.097,360.866,130.496,368.36,133.598,375.57z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#004763",d:"M126.748,386.312c-0.711,1.55-1.303,3.112-1.798,4.651c-10.687-7.288-20.361-7.948-24.724-6.416 c0.856-2.723,1.91-5.439,3.161-8.124c9.183-0.175,17.624,3.004,23.296,9.863L126.748,386.312z"})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"bubble_1_",className:"dpseq "+(this.state.hits>0?'hide':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#690BA0",cx:"525.539",cy:"284.795",rx:"70.396",ry:"35.969"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#690BA0",points:"527.744,316.826 513.077,340.492 555.901,314.159 \t\t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"474.833",y:"273.832",fill:"none",width:"102.667",height:"55.333"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"canwe"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M484.604,278.144c0-2.365,1.815-4.026,4.291-4.026c1.507,0,2.695,0.55,3.454,1.54l-1.639,1.463 c-0.451-0.572-0.99-0.902-1.683-0.902c-1.078,0-1.804,0.748-1.804,1.925s0.726,1.925,1.804,1.925c0.693,0,1.232-0.33,1.683-0.902 l1.639,1.463c-0.759,0.99-1.947,1.54-3.454,1.54C486.419,282.17,484.604,280.509,484.604,278.144z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M498.234,280.652h-2.927l-0.517,1.342h-2.64l3.366-7.701h2.553l3.366,7.701h-2.684L498.234,280.652z M497.519,278.782l-0.748-1.937l-0.748,1.937H497.519z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M509.443,274.293v7.701h-2.134l-2.927-3.499v3.499h-2.53v-7.701h2.134l2.927,3.499v-3.499H509.443z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M526.526,274.293l-2.464,7.701h-2.783l-1.243-4.115l-1.309,4.115h-2.784l-2.464-7.701h2.673l1.342,4.379 l1.419-4.379h2.387l1.342,4.434l1.419-4.434H526.526z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M533.5,280.036v1.958h-6.403v-7.701h6.26v1.958h-3.708v0.902h3.256v1.871h-3.256v1.012H533.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M539.472,276.306h-2.255v-2.013h7.107v2.013h-2.255v5.688h-2.596V276.306z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M549.856,280.652h-2.927l-0.517,1.342h-2.64l3.366-7.701h2.553l3.366,7.701h-2.684L549.856,280.652z M549.141,278.782l-0.748-1.937l-0.748,1.937H549.141z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M553.475,274.293h2.597v5.688h3.477v2.013h-6.073V274.293z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M563.397,279.442l-0.583,0.649v1.903h-2.553v-7.701h2.553v2.794l2.53-2.794h2.827l-3.081,3.389l3.235,4.312 h-3.003L563.397,279.442z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M488.845,293.852h-2.927l-0.517,1.342h-2.64l3.366-7.701h2.553l3.366,7.701h-2.684L488.845,293.852z M488.13,291.981l-0.748-1.937l-0.748,1.937H488.13z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M500.055,293.07c0,1.342-1.133,2.124-3.256,2.124h-4.335v-7.701h4.115c2.124,0,3.113,0.847,3.113,2.013 c0,0.715-0.363,1.31-1.067,1.662C499.526,291.497,500.055,292.157,500.055,293.07z M495.016,289.308v1.144h1.21 c0.583,0,0.847-0.198,0.847-0.572s-0.264-0.572-0.847-0.572H495.016z M497.436,292.773c0-0.396-0.286-0.605-0.858-0.605h-1.562 v1.21h1.562C497.15,293.378,497.436,293.169,497.436,292.773z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M500.658,291.343c0-2.333,1.837-4.026,4.346-4.026s4.346,1.694,4.346,4.026s-1.837,4.027-4.346,4.027 S500.658,293.676,500.658,291.343z M506.731,291.343c0-1.199-0.771-1.925-1.728-1.925s-1.727,0.726-1.727,1.925 s0.77,1.925,1.727,1.925S506.731,292.542,506.731,291.343z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M510.229,291.729v-4.236h2.596v4.159c0,1.177,0.451,1.617,1.177,1.617s1.177-0.44,1.177-1.617v-4.159h2.552 v4.236c0,2.31-1.386,3.642-3.751,3.642S510.229,294.039,510.229,291.729z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M520.481,289.506h-2.255v-2.013h7.107v2.013h-2.255v5.688h-2.596V289.506z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M530.975,289.506h-2.255v-2.013h7.107v2.013h-2.255v5.688h-2.596V289.506z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M544.087,287.493v7.701h-2.597v-2.838h-2.398v2.838h-2.597v-7.701h2.597v2.729h2.398v-2.729H544.087z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M545.34,287.493h2.597v7.701h-2.597V287.493z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M548.706,294.578l0.836-1.892c0.726,0.429,1.694,0.704,2.542,0.704c0.737,0,1.001-0.154,1.001-0.418 c0-0.968-4.257-0.187-4.257-3.059c0-1.43,1.199-2.596,3.586-2.596c1.034,0,2.101,0.22,2.904,0.671l-0.781,1.881 c-0.759-0.385-1.474-0.572-2.145-0.572c-0.759,0-1.001,0.22-1.001,0.484c0,0.924,4.257,0.154,4.257,2.992 c0,1.408-1.199,2.597-3.586,2.597C550.774,295.37,549.476,295.051,548.706,294.578z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M556.032,287.493h2.97l-0.495,4.753h-1.98L556.032,287.493z M556.065,293.984 c0-0.737,0.594-1.298,1.452-1.298c0.858,0,1.453,0.561,1.453,1.298c0,0.726-0.594,1.32-1.453,1.32 C556.659,295.304,556.065,294.71,556.065,293.984z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M562.941,289.847c0-0.341-0.33-0.517-0.737-0.517c-0.473,0-0.913,0.286-1.144,0.748l-1.958-0.979 c0.561-1.056,1.672-1.782,3.433-1.782c1.727,0,3.014,0.726,3.014,2.101c0,1.683-1.76,1.98-1.76,2.828h-2.266 C561.521,290.914,562.941,290.518,562.941,289.847z M561.203,293.984c0-0.737,0.594-1.298,1.452-1.298 c0.858,0,1.452,0.561,1.452,1.298c0,0.726-0.594,1.32-1.452,1.32C561.796,295.304,561.203,294.71,561.203,293.984z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M566.152,287.493h2.97l-0.495,4.753h-1.98L566.152,287.493z M566.185,293.984 c0-0.737,0.594-1.298,1.452-1.298c0.858,0,1.453,0.561,1.453,1.298c0,0.726-0.594,1.32-1.453,1.32 C566.779,295.304,566.185,294.71,566.185,293.984z"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"blocker",y:"617.086",fill:"#FFFFFF",width:"621.317",height:"10.914"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"hit_x5F_1_1_",className:"dpseq "+(this.state.hits===1&&this.state.show?'':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"bg_2_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"9.162",y:"44.319",fill:"#BC0D0D",width:"603.432",height:"572.767"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#EA0C0C",points:"499,90 383,234 413,98 344,212 342,64 305,300 238,90 226,152 123,64 190,289 54,246 148,353  83,349 144,385 27,433 180,416 79,531 158,509 140,534 268,513 223,602 319,551 394,599 359,465 567,565 457,462 564,416 493,412  545,337 419,328 543,185 438,231 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"bot_1_",fill:"#2D0202",d:"M566,247l-11.333,12.667L515.333,261l-12.667-30.667L518,211.667L508.667,205l-21.333,15.333 l1.333,34l-13.333,17.333l7.333,24l-38.667,69l-44.333,31L321.333,395l-4.667-30.667l70-24.667l-33.333-105.333L248.667,251 l-38,30.667l14.667,74.667L264,375.667l7.333,28.667l-97.333,22l-16.924,11.398l-34.409-2.065l-1.333-14l21.733-20.123 c6.973,2.643,15.933,5.873,17.6,5.457c2.667-0.667,26.667-20,26.667-20l-2.504-6.385l10.504-2.948l11.333-12L202,339 c0,0-13.121,14.192-23.582,25.267L174,353l-5.503-0.892L194,316.333l-37.333-0.667l-20,26.667l5.069,13.179L126,369 c0,0,1.457,6.263,3.212,13.002l-37.879,29.664L98,462.333c0,0,59.568,8.326,74.637,10.049L186,569.667l59.75-5.282l-2.416,17.948 l13.827-5.617L258.667,617H332l11.827-45.781L358,577l1.333-14.667l12,6l-8.517-14.297l64.517-5.703V427L440,426.333l-11.983-15.75 L468,376.333l36.333-67L530,309l3.333-25.333l28-7.333l15.333-10.667L566,247z M348,269.5l-3,4l10-2.5l-3.25,4.25l7.75,3l-28-1.25 L348,269.5z M270,294.333l7.667-6.667l-11.667-1l30.667-4.333L270,294.333z M308,320.5l11.25-2.5l15.5-4l12.5-8l9.25,1l12.25,11 l-31.25-0.25l-16,4.5l-14.25,11.5L308,320.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"flash_2_",fill:"#FFFFFF",points:"312.568,313.212 307,378.5 292.649,368.14 296.5,386.5 241.5,344 289,403.5  251,406.167 280.577,424.878 199,498.5 289.027,441.779 279.369,473.77 304.721,438.158 314.982,521.455 318.604,446.608  325.243,465.923 327.658,432.725 385,459.887 329.468,418.842 365,395 331.279,401.338 351,362 319.207,392.284 \t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"hit_x5F_2_1_",className:"dpseq "+(this.state.hits===2&&this.state.show?'':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"bg_4_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"9.162",y:"44.319",fill:"#DB6300",width:"603.432",height:"572.767"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FF9E10",points:"579,527 456.211,442.9 583,423 478.566,404.102 566,338 390.926,364.301 574,246 461,253 504,190  402.975,249.406 450,84 376,220 357,142 319,225 257,78 282,259 198,173 230,250 63,140 226,341 146,314 190,366 51,390 183,418  51,579 284,492 201,577 291,521 274,596 360,544 483,602 487,551 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"bot_6_",fill:"#2D1401",d:"M559.952,525.327l-13.838-2.81l-2.915-20.519c0,0-6.064-2.138-12.691-4.28l-4.653-47.887 l-24.084-11.241l-1.583-8.785l56.674,31.262l-92.497-70.679l-52.018-7.981l34.249-32.957l-20.663-78.655l-47.655-10.651 l-101.214,31.443l12.968,72.053l-27.156-4.166l-80.11,26.016l73.299,17.29l-6.119,39.617l-4.252,3.777l-76.091,21.594 l-21.642-12.704l-19.955,8.946l-32.762-9.189l-19.867,17.191l4.318,10.626l21.716-10.581l26.889,19.439l-10.427,37.949 l-14.951,8.083l15.681,14.708l13.935-12.438l13.633-25.533l25.415,2.638l6.282-24.888l67.206-18.068l-7.403,47.93l95.386,27.801 L312,582.333l13.827-5.617L327.333,617h73.333l11.827-45.781L426.667,577l-3.333-11.333L440,568.333l-8.114-6.588l45.535-3.364 l16.18-74.971l10.677,2.779l2.305,12.707c-5.977,4.459-13.517,10.278-14.062,11.908c-0.871,2.607,2.531,33.237,2.531,33.237 l6.73,1.321l-3.16,10.442l4.027,16.007l24.995,10.399c0,0-4.914-18.693-8.63-33.467l11.876,2.331l3.711-4.161l16.458,40.735 l20.63-31.123L559.952,525.327z M297.75,347l5.5-8.25L293.5,337l9.5-2.75l-6-4.75l25.5,5L297.75,347z M349,331l20.5-16l-4,9h14 L349,331z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"flash_4_",fill:"#FFFFFF",points:"510.481,448.606 414.21,440.532 448.362,424.214 402.818,429.03 465.794,369.959  375.082,421.568 379.781,382.734 361.043,416.847 253.557,313.231 331.406,426.594 286.742,416.854 336.864,444.069  221.547,458.419 325.52,459.927 293.324,476.408 338.542,466.621 308.921,534.839 364.353,471.164 430.593,551.16 388.695,472.597  443.832,493.37 400.928,458.75 \t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"hit_x5F_3_1_",className:"dpseq "+(this.state.hits===3&&this.state.show?'':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"bg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"9.162",y:"44.319",fill:"#BF0037",width:"603.432",height:"572.767"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#D60057",points:"499,90 383,234 413,98 344,212 342,64 305,300 238,90 226,152 123,64 190,289 54,246 148,353  83,349 144,385 27,433 180,416 79,531 158,509 140,534 268,513 223,602 319,551 394,599 359,465 567,565 457,462 564,416 493,412  545,337 419,328 543,185 438,231 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"bot_3_",fill:"#330017",d:"M552.664,449.074l-14.105-0.646l-6.039-19.826c0,0-6.321-1.179-13.199-2.276L500.5,377.5 l-66.968-23.33l-5.081-12.021l58.104,17.481l-99.831-48.685l-31.272,3.379L381.78,275.9L366,226.333l-97.341-49.419 l-63.993,100.752l58.113,46.671l-62.223,6.723l-64.275,47.276l69.263-1.12l3.152,28.532l-5.166,7.91l-16.109,74.496l-24.546,7.51 l3.897,25.253L141.949,535.8l-11.731,14.535l15.469,14.931l7.331-15.334l37.385-12.299l20.75,25.89l-9.49,22.215l10.827,3.785 l16.184-20.696l-10.805-32.265l7.944-20.375l-13.763-20.985l4.416-19.133l3.093,27.993l55.108,2.396l-9.493,22.659L279,523.5 l28.5,93.5H386l-7.507-87.448l14.173,5.781l-10.333-23.5L399,514.5l-13.918-13.166l55.924-21.494l-4.75-81.033l16.213,0.165 l-5.906-13.974L482.5,396l13.364,35.173c-5.22,5.326-11.774,12.237-12.061,13.931c-0.46,2.71,7.616,32.452,7.616,32.452 l6.853,0.269l-1.515,10.804l6.443,15.197l26.298,6.428c0,0-7.733-17.714-13.679-31.74l12.093,0.475l3.026-4.682l22.532,37.716 l15.594-33.927L552.664,449.074z M275.5,303.5l-27.75-32.25l-12.75-7l4.75-4.25L281,286L275.5,303.5z M254.188,224.191l8.93-4.477 l-12.01-9.269l30.442,14.651L254.188,224.191z M322.697,254.647l-9.143-5.473l1.119,7.974l-15.655-23.313l27.648,10.543 l-10.071,1.468L322.697,254.647z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"flash_1_",fill:"#FFFFFF",points:"335,397 300,386.667 313,368 282.348,372.459 442,228 265.333,352.667 266,309  238.667,340.667 209,293 218.03,369.37 162,356 223.037,388.868 52,404 212.905,406.474 184,424.667 224.667,414 208,481  247.932,419.197 355,552 269.86,420.922 305,430 280.802,405.559 \t"}))));}}]);return Round9View;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Round9=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(Round9View);/* harmony default export */ __webpack_exports__["a"] = (Round9);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{twoDDarkPatternIncorrect:function twoDDarkPatternIncorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["t" /* twoDDarkPatternIncorrect */])());},twoDDarkPatternCorrect:function twoDDarkPatternCorrect(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["s" /* twoDDarkPatternCorrect */])());}};};var SimpleDarkPattern2dView=function(_Component){_inherits(SimpleDarkPattern2dView,_Component);function SimpleDarkPattern2dView(props){_classCallCheck(this,SimpleDarkPattern2dView);var _this=_possibleConstructorReturn(this,(SimpleDarkPattern2dView.__proto__||Object.getPrototypeOf(SimpleDarkPattern2dView)).call(this,props));_this.state={shake:false,done:false};return _this;}_createClass(SimpleDarkPattern2dView,[{key:"clicked",value:function clicked(){var _this2=this;this.props.twoDDarkPatternCorrect();this.setState({// shake: true,
done:true});__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].delayedCall(0.5,function(){return _this2.props.adComplete();});}},{key:"shake",value:function shake(){var _this3=this;this.setState({shake:true});__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].delayedCall(0.4,function(){return _this3.setState({shake:false});});this.props.twoDDarkPatternIncorrect();}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].killAll(true,true,true,true);}},{key:"render",value:function render(){var childStyles={zIndex:this.props.z,left:this.props.x+"%",top:this.props.y+"%"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"floatingad "+(this.state.shake?'shake':'')+" "+(this.state.done?'out':'')+" ",style:childStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"borderTop"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dot"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dot"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dot"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.props.adText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"buttons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"yes",onClick:this.clicked.bind(this)},"Yes")));}}]);return SimpleDarkPattern2dView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SimpleDarkPattern2d=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(SimpleDarkPattern2dView);/* harmony default export */ __webpack_exports__["a"] = (SimpleDarkPattern2d);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Kenny=function(_Component){_inherits(Kenny,_Component);function Kenny(){_classCallCheck(this,Kenny);return _possibleConstructorReturn(this,(Kenny.__proto__||Object.getPrototypeOf(Kenny)).apply(this,arguments));}_createClass(Kenny,[{key:"render",// constructor(props) {
// 	super( props );
// 	this.state = {
// 		twitterAccount: "",
// 		ranking: 0
// 	};
// }	
// componentDidMount () {
//     console.log(this.props);
// }
// getAvatar () {
//     this.kenny();
// }
value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"kenny",x:"0px",y:"0px",viewBox:"0 0 164.248 122",enableBackground:"new 0 0 164.248 122"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"speaking",className:""+(this.props.speaking?'show':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.248",cy:"61",r:"61"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E4A270",d:"M82.207,24.333l5.125,24.584l-4.75,11.458L83.707,63l3.041,1l-2.875,2.667L83.04,70.25L86,81.938 l5.711,2.292l4.977,2.895l19.187-10.063l2.063-4.875l0.814-5.325l3.207,0.387l2.982-2.752l1.505-6.857l2.048-6.2l-1.047-4.022 l-2.394-1.191l-3.178-0.35l-2.584,3.428l-2.177,4.315l0.134-5.62l-2-5v-6l-3-8c0,0-7.613,0.651-10,0s-7-6-7-6l-5.925-3.319 L82.207,24.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CB814F",points:"91.709,84.23 90.061,106.625 99.873,108.187 121.498,85.062 120.816,78.592 119.327,73.998  118.75,66.862 117.787,69.871 116.267,72.196 98.226,84.233 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CB814F",d:"M117.442,60.554c0.39,0.373,0.827,0.693,1.3,0.952c0.47,0.17,2.526-2.517,2.526-2.517L122.6,59l1.153,1.6 l3.147-8.149l-0.621-3.293l-2.588-1.346l-2.191,1.461l-2.661,5.659l0.8,1.006c-0.084,0.795-0.065,1.598,0.056,2.389 C119.9,58.628,117.442,60.554,117.442,60.554z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CB814F",d:"M93.123,67.5l-2.416-0.792l-2.334,0.667l-1.159-0.484l0.757-3.424l-3.635-1.4l-1-2.417l6.287-11.2 L89.266,46l-2.6-3.162L86.324,40.7l4.008-6.112l-4.585,2.5l-0.32-2l4.321-2.913L96.415,30l-6.781,0.924l-4.483,2.251L84.8,30.759 l0.5-5.78l5.326-2.562l-1.3-2.736l-8.148,3.942l-1.049,4.095l1.763,2.72l-3.16-1.5L77.8,30.913l-0.334,4.249 c0,0-0.25,3.028-0.361,4.725c-0.031,0.511-0.057,0.895-0.057,1.047c0,0.649,1.489,6.656,1.489,6.656l-0.8,7.919l0.716,5.417 l2.095,13.223l5.135,8.178l2.83,1.138l3.2,0.765L88.061,82l-1.656-2.156l0.062-3.25l4.188-1.688l-3.5-0.312l-1.719-1.875L86.123,71 l9.782-0.156L93.123,67.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#A86538",points:"89.014,61.645 90.067,62.25 92.709,62.188 91.628,61.757 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CB814F",points:"99.564,64.24 101.982,67.816 102.661,66.241 101.252,64.427 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#991F39",d:"M103.248,122c19.146,0.015,37.184-8.974,48.7-24.269l-22.305-8.155l-6.187-12.007l-3.372-1.236l0.734,2.259 l-0.628,4.7l-4,4.1l-15.746,10.777l-1.207,7.807l-1.354-0.318l-0.137-7.686l-4.579-7.721l-1.458-6.021l-3.2-0.765l-2.83-1.138 l-6.352,2.626l-1.9,0.708L66.847,89.4l-6.627,11.228l-0.5,3.087C71.174,115.425,86.868,122.017,103.248,122z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"77.455,108.415 78.042,109.582 84.804,108.434 95.677,99.782 92.934,97.248 81.85,106.82 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"101.991,100.015 98.67,117.154 99.47,118.219 103.999,108.993 106.683,112.287 114.093,116.405  114.711,115.842 107.842,109.417 104.121,100.25 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"128.133,92.483 116.816,113.859 124.964,102.128 128.58,94.158 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"77.431,85.661 78.375,98.783 79.328,84.953 78.649,85.231 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3A2B15",points:"77.844,37.178 75.979,41.375 76.65,41.779 78.089,40.143 81.884,37.972 82.476,37.218  82.031,33.966 81.208,34.035 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M93.679,39.23l1.913,3.37c0,0,4.931-0.781,5.5-0.778s4.96,0.889,4.96,0.889l0.22-1.1 c0,0-3.616-2.433-5.955-2.806c-1.848-0.288-3.727-0.317-5.583-0.084C94.394,38.914,94.041,39.084,93.679,39.23z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M74.8,17.346l0.491,11.277l2.175,6.539l0.334-4.249l0.934-1.977l3.16,1.5l-1.763-2.72l1.049-4.095 l8.148-3.942l1.3,2.736l1.433,3.038c0,0,6.6,5.047,8.988,5.69s10.344,0.341,10.344,0.341l0.384,8.428l2.941,3.87l1.062,6.179 l1.339,3.659l2.177-4.315l2.584-3.428l3.178,0.35l1.162-4.124l2.423-6.089l0.006-10.2l2.519,1.432L128.019,21l-9.4-12.673 l-14.13-3.04L90.126,7.594L86.347,13c0,0-3.635-1.1-5.247-0.853S74.8,17.346,74.8,17.346z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M95.331,49.46c0,0,5.044,0.048,7.354,0.8c-1.755-1.321-3.638-2.462-5.621-3.408L95.331,49.46z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M84.77,48.958c-1.76,0.004-3.511,0.244-5.208,0.712c1.215-1.14,2.549-2.146,3.979-3L84.77,48.958z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M31.661,59.834l-31.65-0.567L0,62.539l31.628-0.271C31.574,61.457,31.586,60.643,31.661,59.834z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M32.868,69.489l-28.99,15.59l1.088,2.984l28.7-16.528C33.338,70.879,33.071,70.194,32.868,69.489z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M37.787,78.1c-0.3-0.328-0.323-0.385-0.6-0.731l-21.13,29.208l1.99,2.156L38.589,78.9 C38.306,78.649,38.039,78.382,37.787,78.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M38.8,43.49L18.379,13.267L16.374,15.4l21.079,29.48C37.848,44.367,38.3,43.901,38.8,43.49z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M33.843,50.588L5.155,33.8l-1.109,2.969l28.921,16.09C33.196,52.079,33.489,51.32,33.843,50.588z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M87.457,68.542l1.791,0.416l1.959-0.583l4.7,2.469L91.5,72.312l-3.125-0.062l-2.187-1.219 c0,0,0.448-1.479,0.479-1.573S87.457,68.542,87.457,68.542z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"upset",className:""+(!this.props.speaking&&this.props.look===3?'show':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.248",cy:"61",r:"61"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E4A270",d:"M82.207,24.333l1,6.959l1.541,5.125l0.334,4.625l1.541,6l0.709,1.875l-4.75,11.458L83.707,63l3.041,1 l-2.875,2.667L83.04,70.25l1.167,2.667l4.833,1.208l-2.875,2.542l0.417,4.208l5.127,3.355l4.977,2.895l19.187-10.063l2.063-4.875 l0.814-5.325l3.207,0.387l2.982-2.752l1.505-6.857l2.048-6.2l-1.047-4.022l-2.394-1.191l-3.178-0.35l-2.584,3.428l-2.177,4.315 l0.136-5.62l-2-5v-6l-3-8c0,0-7.613,0.651-10,0s-7-6-7-6l-5.925-3.319L82.207,24.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CB814F",points:"91.709,84.23 90.061,106.625 99.873,108.187 121.498,85.062 120.816,78.592 119.327,73.998  118.75,66.862 117.787,69.871 116.267,72.196 98.226,84.233 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CB814F",d:"M117.442,60.554c0.39,0.373,0.827,0.693,1.3,0.952c0.47,0.17,2.526-2.517,2.526-2.517L122.6,59l1.153,1.6 l3.147-8.149l-0.621-3.293l-2.588-1.346l-2.191,1.461l-2.661,5.659l0.8,1.006c-0.084,0.795-0.065,1.598,0.056,2.389 C119.9,58.628,117.442,60.554,117.442,60.554z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CB814F",d:"M97.873,67.438l-7.75-0.594l-1.218,0.417l-1.16-0.483l0.226-3.311l-3.635-1.4l-1-2.417l6.287-11.2 L89.266,46l-2.6-3.162l-1.239-7.758l4.613-1.663l10.042-0.334l-10.157-0.909l-4.774,1L84.8,30.759l0.5-5.78l5.326-2.562l-1.3-2.736 l-8.148,3.942l-1.049,4.095l1.763,2.72l-3.16-1.5L77.8,30.913l-0.334,4.249c0,0-0.25,3.028-0.361,4.725 c-0.031,0.511-0.057,0.895-0.057,1.047c0,0.649,1.489,6.656,1.489,6.656l-0.8,7.919l0.716,5.417l2.095,13.223l5.135,8.178 l2.83,1.138l3.2,0.765l-4.494-4.369l0.085-3.67l4.327-2.975l-6.584-1.147l0.2-1.986L99.1,68.9L97.873,67.438z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#A86538",points:"89.014,61.645 90.067,62.25 92.709,62.188 91.628,61.757 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CB814F",points:"99.564,64.24 101.982,67.816 102.661,66.241 101.252,64.427 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#991F39",d:"M103.248,122c19.146,0.015,37.184-8.974,48.7-24.269l-22.305-8.155l-6.187-12.007l-3.372-1.236l0.734,2.259 l-0.628,4.7l-4,4.1l-15.746,10.777l-1.207,7.807l-1.354-0.318l-0.137-7.686l-4.579-7.721l-1.458-6.021l-3.2-0.765l-2.83-1.138 l-6.352,2.626l-1.9,0.708L66.847,89.4l-6.627,11.228l-0.5,3.087C71.174,115.425,86.868,122.017,103.248,122z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"77.455,108.415 78.042,109.582 84.804,108.434 95.677,99.782 92.934,97.248 81.85,106.82 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"101.991,100.015 98.67,117.154 99.47,118.219 103.999,108.993 106.683,112.287 114.093,116.405  114.711,115.842 107.842,109.417 104.121,100.25 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"128.133,92.483 116.816,113.859 124.964,102.128 128.58,94.158 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"77.431,85.661 78.375,98.783 79.328,84.953 78.649,85.231 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CB814F",d:"M98.168,41.4c-2.63-0.047-4.801,2.044-4.852,4.674c-0.029,1.163,0.372,2.295,1.127,3.18l6.527,0.692 c1.153-0.876,1.842-2.232,1.87-3.68C102.884,43.636,100.798,41.463,98.168,41.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#AD6432",d:"M78.528,49.353l5.554-0.449c1.493-1.653,1.364-4.203-0.289-5.696c-1.653-1.493-4.203-1.364-5.696,0.289 c-0.154,0.17-0.293,0.353-0.415,0.547c0.4,1.739,0.851,3.547,0.851,3.547l-0.164,1.61C78.424,49.25,78.471,49.308,78.528,49.353z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3A2B15",points:"81.753,43.636 77.363,44.984 77.042,44.269 78.839,43.037 81.45,39.53 82.269,39.033  85.444,39.864 85.277,40.674 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M81.853,44.883c-1.34,0.23-2.242,1.501-2.014,2.842c0.098,0.591,0.41,1.125,0.878,1.5l3.39-0.274 c0.906-1.017,0.815-2.576-0.202-3.482c-0.559-0.498-1.314-0.714-2.052-0.589V44.883z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M94.793,39.1l3.56-1.529c0,0,3.457,3.6,3.913,3.943s4.489,2.289,4.489,2.289l-0.491,1.011 c0,0-4.351-0.247-6.44-1.362c-1.647-0.887-3.162-2-4.5-3.307C95.17,39.786,94.992,39.436,94.793,39.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M99.29,44.819c-1.572-0.027-2.869,1.223-2.9,2.795c-0.017,0.695,0.223,1.371,0.674,1.9l3.9,0.414 c0.689-0.524,1.101-1.334,1.118-2.2C102.107,46.157,100.861,44.858,99.29,44.819z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3A2B15",points:"85.248,68.083 84.478,69.229 84.248,71.25 90.061,70.5 99.061,71.188 99.103,68.896 97.623,68.083  90.419,68.292 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"85.248,68.083 85.483,69.453 89.936,69.672 97.592,69.516 99.092,68.891 97.623,68.083  90.419,68.292 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M74.8,17.346l0.491,11.277l2.175,6.539l0.334-4.249l0.934-1.977l3.389,6.564l-0.312-8.125l-0.636-3.752 l8.148-3.942l1.3,2.736l1.433,3.038c0,0,7.057,6.569,9.444,7.212s9.888-1.181,9.888-1.181l0.384,8.428l2.941,3.87l1.062,6.179 l1.339,3.659l2.177-4.315l2.584-3.428l3.178,0.35l1.162-4.124l2.423-6.089l0.006-10.2l5.106-1.373L128.019,21l-6.136-8.275 l3.74-4.6l-7,0.2l-14.13-3.04l-5.2,0.834L98,4l-4.314-1.875L94.413,4.6l-1.081,3.233l-3.206-0.239l-1.5-4.344L86.347,13 c0,0-3.635-1.1-5.247-0.853S74.8,17.346,74.8,17.346z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CB814F",points:"87.665,36.667 88.332,42.375 89.707,41.625 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3A2B15",points:"89.323,19.681 90.998,26.833 95.082,32.667 102.582,35.417 95.748,30.833 95.165,25.083 \t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"worried",className:""+(!this.props.speaking&&this.props.look===2?'show':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.248",cy:"61",r:"61"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E4A270",d:"M82.207,24.333l1,6.959l1.541,5.125l0.334,4.625l1.541,6l0.709,1.875l-4.75,11.458L83.707,63l3.041,1 l-2.875,2.667L83.04,70.25l1.167,2.667l4.833,1.208l-2.875,2.542l0.417,4.208l5.127,3.355l4.977,2.895l19.187-10.063l2.063-4.875 l0.814-5.325l3.207,0.387l2.982-2.752l1.505-6.857l2.048-6.2l-1.047-4.022l-2.394-1.191l-3.178-0.35l-2.584,3.428l-2.177,4.315 l0.136-5.62l-2-5v-6l-3-8c0,0-7.613,0.651-10,0s-7-6-7-6l-5.925-3.319L82.207,24.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CB814F",points:"91.709,84.23 90.061,106.625 99.873,108.187 121.498,85.062 120.816,78.592 119.327,73.998  118.75,66.862 117.787,69.871 116.267,72.196 98.226,84.233 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CB814F",d:"M117.442,60.554c0.39,0.373,0.827,0.693,1.3,0.952c0.47,0.17,2.526-2.517,2.526-2.517L122.6,59l1.153,1.6 l3.147-8.149l-0.621-3.293l-2.588-1.346l-2.191,1.461l-2.661,5.659l0.8,1.006c-0.084,0.795-0.065,1.598,0.056,2.389 C119.9,58.628,117.442,60.554,117.442,60.554z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CB814F",d:"M97.873,67.438l-7.75-0.594l-1.218,0.417l-1.16-0.483l0.226-3.311l-3.635-1.4l-1-2.417l6.287-11.2 L89.266,46l-2.6-3.162l-1.239-7.758l4.613-1.663l10.042-0.334l-10.157-0.909l-4.774,1L84.8,30.759l0.5-5.78l5.326-2.562l-1.3-2.736 l-8.148,3.942l-1.049,4.095l1.763,2.72l-3.16-1.5L77.8,30.913l-0.334,4.249c0,0-0.25,3.028-0.361,4.725 c-0.031,0.511-0.057,0.895-0.057,1.047c0,0.649,1.489,6.656,1.489,6.656l-0.8,7.919l0.716,5.417l2.095,13.223l5.135,8.178 l2.83,1.138l3.2,0.765l-4.494-4.369l0.085-3.67l4.327-2.975l-6.584-1.147l0.2-1.986L99.1,68.9L97.873,67.438z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#A86538",points:"89.014,61.645 90.067,62.25 92.709,62.188 91.628,61.757 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CB814F",points:"99.564,64.24 101.982,67.816 102.661,66.241 101.252,64.427 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#991F39",d:"M103.248,122c19.146,0.015,37.184-8.974,48.7-24.269l-22.305-8.155l-6.187-12.007l-3.372-1.236l0.734,2.259 l-0.628,4.7l-4,4.1l-15.746,10.777l-1.207,7.807l-1.354-0.318l-0.137-7.686l-4.579-7.721l-1.458-6.021l-3.2-0.765l-2.83-1.138 l-6.352,2.626l-1.9,0.708L66.847,89.4l-6.627,11.228l-0.5,3.087C71.174,115.425,86.868,122.017,103.248,122z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"77.455,108.415 78.042,109.582 84.804,108.434 95.677,99.782 92.934,97.248 81.85,106.82 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"101.991,100.015 98.67,117.154 99.47,118.219 103.999,108.993 106.683,112.287 114.093,116.405  114.711,115.842 107.842,109.417 104.121,100.25 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"128.133,92.483 116.816,113.859 124.964,102.128 128.58,94.158 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"77.431,85.661 78.375,98.783 79.328,84.953 78.649,85.231 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3A2B15",points:"78.236,36.122 75.516,39.823 76.085,40.362 77.841,39.071 82.013,37.762 82.752,37.152  83.013,33.881 82.194,33.772 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M81.853,44.883c-1.34,0.23-2.242,1.501-2.014,2.842c0.098,0.591,0.41,1.125,0.878,1.5l3.39-0.274 c0.906-1.017,0.815-2.576-0.202-3.482c-0.559-0.498-1.314-0.714-2.052-0.589V44.883z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M93.936,39.982l3.3-2.026c0,0,3.941,3.067,4.44,3.339s4.772,1.619,4.772,1.619l-0.34,1.071 c0,0-4.341,0.382-6.569-0.421c-1.758-0.64-3.417-1.524-4.929-2.625C94.406,40.606,94.181,40.286,93.936,39.982z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M99.29,44.819c-1.572-0.027-2.869,1.223-2.9,2.795c-0.017,0.695,0.223,1.371,0.674,1.9l3.9,0.414 c0.689-0.524,1.101-1.334,1.118-2.2C102.107,46.157,100.861,44.858,99.29,44.819z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3A2B15",points:"85.248,68.083 84.894,69.354 85.082,70.667 89.96,70.927 97.936,70.625 99.103,68.896  97.623,68.083 90.419,68.292 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"85.248,68.083 85.665,70.167 90.123,70.021 97.498,69.708 99.123,68.854 97.623,68.083  90.419,68.292 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M74.8,17.346l0.491,11.277l2.175,6.539l0.334-4.249l0.934-1.977l3.16,1.5l-1.763-2.72l1.049-4.095 l8.148-3.942l1.3,2.736l1.433,3.038c0,0,6.6,5.047,8.988,5.69s10.344,0.341,10.344,0.341l0.384,8.428l2.941,3.87l1.062,6.179 l1.339,3.659l2.177-4.315l2.584-3.428l3.178,0.35l1.162-4.124l2.423-6.089l0.006-10.2l2.519,1.432L128.019,21l-9.4-12.673 l-14.13-3.04L90.126,7.594L86.347,13c0,0-3.635-1.1-5.247-0.853S74.8,17.346,74.8,17.346z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"happy",className:""+(!this.props.speaking&&this.props.look<2?'show':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.248",cy:"61",r:"61"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E4A270",d:"M82.207,24.333l1,6.959l1.541,5.125l0.334,4.625l1.541,6l0.709,1.875l-4.75,11.458L83.707,63l3.041,1 l-2.875,2.667L83.04,70.25l1.167,2.667l4.833,1.208l-2.875,2.542l0.417,4.208l5.127,3.355l4.977,2.895l19.187-10.063l2.063-4.875 l0.814-5.325l3.207,0.387l2.982-2.752l1.505-6.857l2.048-6.2l-1.047-4.022l-2.394-1.191l-3.178-0.35l-2.584,3.428l-2.177,4.315 l0.136-5.62l-2-5v-6l-3-8c0,0-7.613,0.651-10,0s-7-6-7-6l-5.925-3.319L82.207,24.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CB814F",points:"91.709,84.23 90.061,106.625 99.873,108.187 121.498,85.062 120.816,78.592 119.327,73.998  118.75,66.862 117.787,69.871 116.267,72.196 98.226,84.233 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CB814F",d:"M117.442,60.554c0.39,0.373,0.827,0.693,1.3,0.952c0.47,0.17,2.526-2.517,2.526-2.517L122.6,59l1.153,1.6 l3.147-8.149l-0.621-3.293l-2.588-1.346l-2.191,1.461l-2.661,5.659l0.8,1.006c-0.084,0.795-0.065,1.598,0.056,2.389 C119.9,58.628,117.442,60.554,117.442,60.554z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#CB814F",d:"M99.53,67.187l-9.407-0.343l-1.218,0.417l-1.16-0.483l0.226-3.311l-3.635-1.4l-1-2.417l6.287-11.2 L89.266,46l-3.11-5.925l-0.729-4.99L84.8,30.759l0.5-5.78l5.326-2.562l-1.3-2.736l-11.411,5.236l-0.454,10.245 c0,0-0.25,3.028-0.361,4.725c-0.031,0.511-0.057,0.895-0.057,1.047c0,0.649,1.489,6.656,1.489,6.656l-0.8,7.919l0.716,5.417 l2.095,13.223l5.135,8.178l2.83,1.138l3.2,0.765l-4.494-4.369l0.085-3.67l4.327-2.975l-6.584-1.147l-0.947-2.1l0.818-1.383 l12.382,0.049L99.53,67.187z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#A86538",points:"89.014,61.645 90.067,62.25 92.709,62.188 91.628,61.757 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CB814F",points:"99.564,64.24 101.982,67.816 102.661,66.241 101.252,64.427 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#991F39",d:"M103.248,122c19.146,0.015,37.184-8.974,48.7-24.269l-22.305-8.155l-6.187-12.007l-3.372-1.236l0.734,2.259 l-0.628,4.7l-4,4.1l-15.746,10.777l-1.207,7.807l-1.354-0.318l-0.137-7.686l-4.579-7.721l-1.458-6.021l-3.2-0.765l-2.83-1.138 l-6.352,2.626l-1.9,0.708L66.847,89.4l-6.627,11.228l-0.5,3.087C71.174,115.425,86.868,122.017,103.248,122z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"77.455,108.415 78.042,109.582 84.804,108.434 95.677,99.782 92.934,97.248 81.85,106.82 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"101.991,100.015 98.67,117.154 99.47,118.219 103.999,108.993 106.683,112.287 114.093,116.405  114.711,115.842 107.842,109.417 104.121,100.25 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"128.133,92.483 116.816,113.859 124.964,102.128 128.58,94.158 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#750C27",points:"77.431,85.661 78.375,98.783 79.328,84.953 78.649,85.231 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#3A2B15",points:"79.541,35.618 78.035,39.957 78.738,40.304 80.034,38.552 83.634,36.07 84.16,35.269  83.444,32.066 82.629,32.204 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M81.853,44.883c-1.34,0.23-2.242,1.501-2.014,2.842c0.098,0.591,0.41,1.125,0.878,1.5l3.39-0.274 c0.906-1.017,0.815-2.576-0.202-3.482c-0.559-0.498-1.314-0.714-2.052-0.589V44.883z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M95.185,32.486l-0.174,3.871c0,0,4.591,1.963,5.071,2.268s3.727,3.392,3.727,3.392l0.772-0.816 c0,0-1.767-3.984-3.548-5.544c-1.411-1.229-2.987-2.253-4.683-3.043C95.959,32.597,95.57,32.554,95.185,32.486z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M99.29,44.819c-1.572-0.027-2.869,1.223-2.9,2.795c-0.017,0.695,0.223,1.371,0.674,1.9l3.9,0.414 c0.689-0.524,1.101-1.334,1.118-2.2C102.107,46.157,100.861,44.858,99.29,44.819z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"84.547,67.712 84.914,68.586 85.719,70.519 89.96,70.927 95.661,70.689 98.313,67.95  90.419,68.292 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3A2B15",d:"M74.8,17.346l0.491,11.277l2.337,3.939L78.686,28l2.489-4.377L86.582,21l2.083,3.083l3.417,2.417 c2.922,1.477,5.927,2.785,9,3.917c2.387,0.65,10.3,1.069,10.3,1.069l0.384,8.428l2.941,3.87l1.062,6.179l1.339,3.659l2.177-4.315 l2.584-3.428l3.178,0.35l1.162-4.124l2.423-6.089l0.006-10.2L128.019,21l-9.4-12.673l-14.13-3.04L90.126,7.594L86.347,13 c0,0-3.635-1.1-5.247-0.853S74.8,17.346,74.8,17.346z"})));}}]);return Kenny;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (Kenny);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Brenda=function(_Component){_inherits(Brenda,_Component);function Brenda(){_classCallCheck(this,Brenda);return _possibleConstructorReturn(this,(Brenda.__proto__||Object.getPrototypeOf(Brenda)).apply(this,arguments));}_createClass(Brenda,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"Brenda",x:"0px",y:"0px",viewBox:"0 0 164.248 122",enableBackground:"new 0 0 164.248 122"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"speaking",className:""+(this.props.speaking?'show':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.248",cy:"61",r:"61"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#182021",d:"M74.034,89.84l-0.088-1.313l11.344-4.9c-0.336-0.531-1.053-1.766-1.167-1.958 c-3.25,1.041-7.109-0.291-7.75-1.917c-2.166-5.5-6.541-12.833-6-24.042c0.09-2.295,0.468-4.569,1.125-6.77 c-0.345-2.115-1.208-2.877-1.093-5.157c0.146-2.911,1.373-7.291,1.76-9.281C69.5,29.75,70.84,22.7,74.5,19.917 c8.875-6.75,16.558-3.342,18.535-3.184c5.253-5.166,12.258-7.88,20.663-4.465s14.621,15.059,14.971,28.367 s19.524,7.092,19.524,7.092s0,8.93-5.253,12.345c0,0,4.728,0.35,6.216-0.525c-2.077,5.569-6.128,10.18-11.382,12.958 c0,0,4.2,1.576,6.129,0.525c0,0-6.567,9.5-11.907,11.163c0,0,6.173,0.657,7.924-0.044c0,0-0.744,6.523-8.558,7.376 c0,0,12.577,3.314,20.418,6.421c-20.392,26.802-58.651,31.998-85.453,11.606c-4.732-3.6-8.912-7.873-12.407-12.684 C64.161,93.023,74.034,89.84,74.034,89.84z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"speedlines"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M31.661,59.834l-31.65-0.567L0,62.539l31.628-0.271C31.574,61.457,31.586,60.643,31.661,59.834z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M32.868,69.489l-28.99,15.59l1.088,2.984l28.7-16.528C33.338,70.879,33.071,70.194,32.868,69.489z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M37.787,78.1c-0.3-0.328-0.323-0.385-0.6-0.731l-21.13,29.208l1.99,2.156L38.589,78.9 C38.306,78.649,38.039,78.382,37.787,78.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M38.8,43.49L18.379,13.267L16.374,15.4l21.079,29.48C37.848,44.367,38.3,43.901,38.8,43.49z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M33.843,50.588L5.155,33.8l-1.109,2.969l28.921,16.09C33.196,52.079,33.489,51.32,33.843,50.588z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M75.836,48.346c0.015-0.283,0.009-0.567-0.018-0.85c-0.184-1.817-1.143-3.208-2.143-3.107 s-1.66,1.656-1.477,3.473c0.011,0.229,0.041,0.456,0.092,0.68L75.836,48.346z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M91.332,48.542c0.092-0.279,0.2-0.25,0.223-0.558c0.251-1.777-0.987-3.421-2.764-3.672 c-1.777-0.251-3.421,0.987-3.672,2.764c-0.02,0.141-0.031,0.284-0.032,0.426c-0.018,0.298,0,0.598,0.054,0.892L91.332,48.542z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M77.082,65.39l1.583-0.1l2.167-0.167l3.791,3.708l-3.583,1.794l-3.583,0.333l-0.959-2 c0,0-0.239-1.958-0.208-2.108S77.082,65.39,77.082,65.39z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"upset",className:""+(!this.props.speaking&&this.props.look===3?'show':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.248",cy:"61",r:"61"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#182021",d:"M131.36,91.525c7.826-3.369,9.388-9.858,9.388-9.858c-2.235,0.885-4.629,1.297-7.031,1.208 C146.138,76.265,145.748,68,145.748,68c-4.685,2.868-10.253,3.934-15.666,3c15-6.167,18.109-23.273,18.109-23.273 s-19.174,6.216-19.524-7.092c-0.263-10-3.843-19.067-9.175-24.4c5.251,0.921,10.336,3.749,12.83,10.6 c6.377,17.515,18.508,11.3,18.508,11.3s-10.586,3.315-15.957-12.7C129.263,8.7,108.555,6.387,98.018,12.944l0.016,0.016 c-1.552,0.864-2.995,1.91-4.3,3.115c0.634-4.42,6.7-7.887,6.7-7.887c-4.405,0.352-7.746,4.119-7.57,8.534l-0.1-0.007 c-1.105-3.83,0.884-8.907,0.884-8.907c-3.2,3.4-2.868,6.687-1.993,8.89c-4.291,0.08-13.9,1.841-18.72,13.454 c-2.685,6.473-7.56,9.6-10.185,8.1c-0.5,2.75,3.375,5.875,6.733,5.537V43.8c-2.583,3.331-17.042,23.806,3.182,40.367 c-8.19-9.88-9.622-23.721-3.626-35.067c-1.494,25.405,7.485,33.069,12,36.271l-7.092,3.152l0.088,1.313 c0,0-9.873,3.183-20.114,7.028c19.798,27.244,57.933,33.281,85.177,13.483c4.809-3.495,9.081-7.674,12.681-12.405 C143.937,94.839,131.36,91.525,131.36,91.525z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"113.665,59.729 108.478,57.814 102.915,58.104 97.728,59.917 95.665,64.292 105.45,61.507  115.79,64.042 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M95.462,38.3c1.427,0.22,2.58,1.278,2.92,2.681c0.069,0.301,0.098,0.61,0.086,0.918L91.8,43.521 c-0.152-0.269-0.267-0.557-0.344-0.856C91.307,42.072,95.462,38.3,95.462,38.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M115.119,37.04c0,0,4.722,5.014,4.585,5.518c-0.105,0.366-0.257,0.716-0.453,1.043l-8.167-2.219 C111.057,39.091,112.832,37.181,115.119,37.04z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"worried",className:""+(!this.props.speaking&&this.props.look===2?'show':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.248",cy:"61",r:"61"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#182021",d:"M132.463,89.84l0.088-1.313l-7.092-3.152c2.916-2.068,7.695-6,10.31-15.369 c2.979,1.119,6.229-0.756,7.729-3.881c-6.875-0.875-5.724-15.2-6.482-22.338c-2.562-24.855-18.086-27.2-22.928-27.083 c0.53-4.482,6.723-8.016,6.723-8.016c-6.365,0.881-7.394,5.776-7.543,7.861c-1.728-1.697-3.724-3.099-5.907-4.149l0.054-0.067 c-11.083-5.583-31.5-1.416-35.583,15.75c-3.909,16.434-14.75,14.084-14.75,14.084s12.64,5.1,17.416-12.917 c1.308-5.599,5.588-10.025,11.139-11.521c-4.569,5.443-7.567,13.783-7.807,22.906c-0.35,13.308-19.524,7.092-19.524,7.092 s0,8.93,5.253,12.345c0,0-4.728,0.35-6.216-0.525c2.077,5.569,6.128,10.18,11.382,12.958c0,0-4.2,1.576-6.129,0.525 c0,0,6.567,9.5,11.907,11.163c0,0-6.173,0.657-7.924-0.044c0,0,0.744,6.523,8.558,7.376c0,0-12.577,3.314-20.418,6.421 c20.393,26.801,58.652,31.996,85.453,11.603c4.731-3.6,8.91-7.872,12.405-12.681C142.336,93.023,132.463,89.84,132.463,89.84z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"96.998,64 114.436,63.688 114.686,68.688 97.436,66.563 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M114.584,43.147c-1.334,0.55-2.205,1.851-2.206,3.294c0.004,0.309,0.049,0.616,0.133,0.913h6.866 c0.254-0.869,0.146-1.804-0.3-2.592L114.584,43.147z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M96.7,42.106l-5.6,2.643c-0.32,0.831-0.359,1.745-0.11,2.6h8.463C100.077,45.147,98.867,42.843,96.7,42.106 z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"happy",className:""+(!this.props.speaking&&this.props.look<2?'show':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.248",cy:"61",r:"61"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#182021",d:"M132.463,89.84l0.088-1.313l-7.092-3.152c4.815-3.415,14.709-11.907,11.557-41.588 c-2.684-26.037-19.6-27.37-23.552-27.054c-5.253-5.166-12.258-7.88-20.663-4.465S78.18,27.327,77.83,40.635 s-19.524,7.092-19.524,7.092s0,8.93,5.253,12.345c0,0-4.728,0.35-6.216-0.525c2.077,5.569,6.128,10.18,11.382,12.958 c0,0-4.2,1.576-6.129,0.525c0,0,6.567,9.5,11.907,11.163c0,0-6.173,0.657-7.924-0.044c0,0,0.744,6.523,8.558,7.376 c0,0-12.577,3.314-20.418,6.421c20.393,26.801,58.652,31.996,85.453,11.603c4.731-3.6,8.91-7.872,12.405-12.681 C142.336,93.023,132.463,89.84,132.463,89.84z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M99.456,47.354c0.656-2.337-0.707-4.763-3.044-5.419c-2.337-0.656-4.763,0.707-5.419,3.044 c-0.218,0.777-0.218,1.598,0,2.375H99.456z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M121.005,47.354c0.666-2.337-0.689-4.771-3.026-5.437c-2.337-0.666-4.771,0.689-5.437,3.026 c-0.225,0.788-0.225,1.624,0,2.412H121.005z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"96.998,64 117.623,64 105.686,68.625 97.436,66.563 \t"})));}}]);return Brenda;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (Brenda);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Boss=function(_Component){_inherits(Boss,_Component);function Boss(){_classCallCheck(this,Boss);return _possibleConstructorReturn(this,(Boss.__proto__||Object.getPrototypeOf(Boss)).apply(this,arguments));}_createClass(Boss,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"Boss",x:"0px",y:"0px",viewBox:"0 0 164.248 122",enableBackground:"new 0 0 164.248 122"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"speaking",className:""+(this.props.speaking?'show':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.248",cy:"61",r:"61"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"head"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#8192A7",d:"M137.164,30.042H68.821L60.486,95.03H145.5L137.164,30.042z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#203342",points:"136.686,95.03 128.748,77.917 112.082,66.75 96.582,65.417 84.082,70.583 75.832,79.333  70.623,95.03 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF7900",d:"M121.662,57.437c-4.861,0.135-9-2.015-10.215-5.061l19.488-5.016c0.549,0.805,0.858,1.749,0.893,2.722 C131.942,53.988,127.381,57.27,121.662,57.437z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF7900",d:"M75.139,47.159L94.511,52.6c-1.283,3.019-5.478,5.079-10.324,4.834c-5.725-0.291-10.2-3.677-10-7.579 C74.239,48.884,74.57,47.948,75.139,47.159z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7FB7CB",points:"76.405,24.44 103.263,42.562 103.273,42.543 103.273,42.562 130.13,24.44 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"speedlines"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M31.661,59.834l-31.65-0.567L0,62.539l31.628-0.271C31.574,61.457,31.586,60.643,31.661,59.834z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M32.868,69.489l-28.99,15.59l1.088,2.984l28.7-16.528C33.338,70.879,33.071,70.194,32.868,69.489z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M37.787,78.1c-0.3-0.328-0.323-0.385-0.6-0.731l-21.13,29.208l1.99,2.156L38.589,78.9 C38.306,78.649,38.039,78.382,37.787,78.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M38.8,43.49L18.379,13.267L16.374,15.4l21.079,29.48C37.848,44.367,38.3,43.901,38.8,43.49z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ED8F14",d:"M33.843,50.588L5.155,33.8l-1.109,2.969l28.921,16.09C33.196,52.079,33.489,51.32,33.843,50.588z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4E677F",points:"103.274,81.25 103.274,67.518 103.273,67.518 103.273,81.25 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M123.606,81.25l-0.4-5.177v-0.008c-2.076-2.017-4.417-3.741-6.959-5.124l0.518,10.309L123.606,81.25z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7FF3E2",points:"103.274,67.518 103.273,67.518 103.274,67.518 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M109.928,81.25l-0.317-12.872l0.009-0.044c0.091,0.023,0.179,0.053,0.269,0.077v-0.032l0.009-0.045 c-2.166-0.542-4.39-0.816-6.623-0.816V81.25H109.928z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M89.217,81.25h6.8l0.328-12.872v-0.043c-2.311,0.586-4.539,1.459-6.632,2.6v0.014l0.024-0.014L89.217,81.25 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M82.757,76.073c-1.624,1.579-3.09,3.313-4.377,5.177h3.976L82.757,76.073z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M123.217,76.072l0.4,5.178h3.983C126.311,79.385,124.843,77.651,123.217,76.072z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M116.747,81.25l-0.519-10.318l0.016,0.009v-0.01c-2.009-1.094-4.143-1.94-6.355-2.52l0.317,12.839H116.747z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M116.747,81.25h0.015l-0.518-10.309l-0.016-0.009L116.747,81.25z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M109.611,68.378l0.317,12.872h0.278l-0.317-12.839c-0.09-0.024-0.178-0.054-0.269-0.077L109.611,68.378z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M96.341,68.38l-0.313,12.87h7.245V67.518c-2.335,0-4.661,0.274-6.932,0.816l0,0V68.38L96.341,68.38z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7FB7CB",points:"96.341,68.378 96.013,81.25 96.028,81.25 96.341,68.38 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M89.708,70.946c-2.54,1.384-4.878,3.109-6.951,5.126l-0.4,5.178h6.837L89.708,70.946z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M89.217,81.25l0.515-10.318l-0.024,0.014l-0.514,10.3L89.217,81.25z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4E677F",d:"M134.409,81.25C128.492,70.707,117.55,62.1,103,62.1h-0.008c-14.554,0-25.5,8.6-31.413,19.148 c-2.417,4.257-4.009,8.932-4.69,13.78h5.96c0.351-2.526,1.025-4.997,2.008-7.351c1.83-4.358,4.517-8.305,7.9-11.606l-0.4,5.177l0,0 l0.4-5.178c2.073-2.017,4.411-3.742,6.951-5.126V70.93c2.093-1.141,4.321-2.014,6.632-2.6l0,0c2.271-0.542,4.597-0.816,6.932-0.816 l0,0c2.233,0,4.457,0.274,6.623,0.816l-0.009,0.045v0.032c2.212,0.58,4.346,1.426,6.355,2.52v0.01 c2.542,1.383,4.883,3.107,6.959,5.124v0.008l0.4,5.177h0.014l-0.4-5.178c3.381,3.289,6.066,7.225,7.895,11.572l0.009,0.017l0,0 c0.989,2.358,1.668,4.835,2.019,7.368h5.963C138.418,90.179,136.826,85.505,134.409,81.25z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5C7793",d:"M52.6,95c18.781,27.973,56.683,35.425,84.656,16.644c6.576-4.415,12.229-10.068,16.644-16.644H52.6z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"upset",className:"hide"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.248",cy:"61",r:"61"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"head-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#425E7A",d:"M137.164,30.042H68.821L60.486,95.03H145.5L137.164,30.042z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF3600",d:"M123.742,57.119c-4.529,1.771-9.15,1.149-11.326-1.306L129.057,44.5c0.789,0.571,1.399,1.355,1.761,2.259 C132.248,50.393,129.067,55.026,123.742,57.119z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#203342",d:"M103,62.1h-0.008c-20.65,0-34.045,17.317-36.1,32.928H139.1C137.041,79.42,123.647,62.1,103,62.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF7900",d:"M116.228,70.932c2.548,1.385,4.895,3.112,6.975,5.133v0.008l1.475,18.958h-7.238L116.228,70.932z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF7900",d:"M103.273,67.518c2.233,0,4.458,0.274,6.624,0.816l-0.009,0.045l0.659,26.651h-7.273L103.273,67.518 L103.273,67.518z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF7900",d:"M131.122,87.662c0.989,2.359,1.668,4.836,2.019,7.369h-1.3L131.122,87.662z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF7900",d:"M89.709,70.932c2.093-1.141,4.321-2.014,6.632-2.6v0.045l-0.649,26.651h-7.185L89.709,70.932z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF7900",d:"M74.853,87.679c1.822-4.363,4.509-8.311,7.9-11.606l-1.462,18.958h-7.149L74.853,87.679z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF3600",d:"M124.691,95.03h7.149l-0.719-7.369l-0.009-0.017c-1.821-4.352-4.507-8.289-7.895-11.572L124.691,95.03z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF3600",d:"M109.611,68.378l0.658,26.652h7.185l-1.21-24.1c-2.09-1.142-4.315-2.016-6.624-2.6L109.611,68.378z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF3600",d:"M96.341,68.378L95.662,95.03h7.611V67.518c-2.335,0-4.661,0.274-6.932,0.816V68.378z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF3600",d:"M82.757,76.072l-1.465,18.959h7.238l1.2-24.1C87.182,72.318,84.836,74.048,82.757,76.072z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF3600",d:"M74.142,95.03l0.711-7.351c-0.983,2.354-1.657,4.825-2.008,7.351H74.142z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#203342",points:"76.405,35.448 103.263,53.571 103.273,53.552 103.273,53.571 130.13,35.448 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF7900",d:"M121.915,54.083c2.624-0.001,4.75-2.128,4.75-4.752c0-0.946-0.283-1.87-0.812-2.655L118,52.017 C118.884,53.31,120.349,54.083,121.915,54.083z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA300",d:"M121.921,51.354c1.11,0.001,2.011-0.899,2.011-2.009c0-0.401-0.12-0.794-0.344-1.126l-3.324,2.26 C120.638,51.027,121.258,51.354,121.921,51.354z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF3600",d:"M75.166,46.757c0.362-0.904,0.973-1.686,1.761-2.257l16.641,11.313c-2.176,2.455-6.8,3.077-11.326,1.306 C76.917,55.026,73.736,50.393,75.166,46.757z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF7900",d:"M84.069,54.083c-2.624-0.001-4.75-2.128-4.75-4.752c0-0.946,0.283-1.87,0.812-2.655l7.854,5.341 C87.101,53.31,85.635,54.083,84.069,54.083z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA300",d:"M84.223,51.209c-0.976,0-1.768-0.792-1.768-1.768c0-0.352,0.105-0.696,0.302-0.988l2.923,1.987 C85.351,50.921,84.806,51.209,84.223,51.209z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#203342",d:"M52.6,95c18.781,27.973,56.683,35.425,84.656,16.644c6.576-4.415,12.229-10.068,16.644-16.644H52.6z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"worried",className:""+(!this.props.speaking&&this.props.look===2?'show':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.248",cy:"61",r:"61"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"head-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5A7E91",d:"M137.164,30.042H68.821L60.486,95.03H145.5L137.164,30.042z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA300",d:"M123.742,57.119c-4.529,1.771-9.15,1.149-11.326-1.306L129.057,44.5c0.789,0.571,1.399,1.355,1.761,2.259 C132.248,50.393,129.067,55.026,123.742,57.119z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA300",d:"M76.927,44.5l16.641,11.312c-2.175,2.456-6.808,3.077-11.325,1.306c-5.336-2.093-8.506-6.725-7.077-10.362 C75.524,45.851,76.136,45.068,76.927,44.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#355468",d:"M103,62.1h-0.008c-20.65,0-34.045,17.317-36.1,32.928H139.1C137.041,79.42,123.647,62.1,103,62.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA300",d:"M116.228,70.932c2.548,1.385,4.895,3.112,6.975,5.133v0.008l1.475,18.958h-7.238L116.228,70.932z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA300",d:"M103.273,67.518c2.233,0,4.458,0.274,6.624,0.816l-0.009,0.045l0.659,26.651h-7.273L103.273,67.518 L103.273,67.518z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA300",d:"M131.122,87.662c0.989,2.359,1.668,4.836,2.019,7.369h-1.3L131.122,87.662z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA300",d:"M89.709,70.932c2.093-1.141,4.321-2.014,6.632-2.6v0.045l-0.649,26.651h-7.185L89.709,70.932z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA300",d:"M74.853,87.679c1.822-4.363,4.509-8.311,7.9-11.606l-1.462,18.958h-7.149L74.853,87.679z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#458C7E",d:"M124.691,95.03h7.149l-0.719-7.369l-0.009-0.017c-1.821-4.352-4.507-8.289-7.895-11.572L124.691,95.03z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#458C7E",d:"M109.611,68.378l0.658,26.652h7.185l-1.21-24.1c-2.09-1.142-4.315-2.016-6.624-2.6L109.611,68.378z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#458C7E",d:"M96.341,68.378L95.662,95.03h7.611V67.518c-2.335,0-4.661,0.274-6.932,0.816V68.378z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#458C7E",d:"M82.757,76.072l-1.465,18.959h7.238l1.2-24.1C87.182,72.318,84.836,74.048,82.757,76.072z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#458C7E",d:"M74.142,95.03l0.711-7.351c-0.983,2.354-1.657,4.825-2.008,7.351H74.142z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4A8C9E",points:"76.405,28.443 103.263,46.565 103.273,46.546 103.273,46.565 130.13,28.443 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#355468",d:"M52.6,95c18.781,27.973,56.683,35.425,84.656,16.644c6.576-4.415,12.229-10.068,16.644-16.644H52.6z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"happy",className:""+(!this.props.speaking&&this.props.look<2?'show':'hide')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFFFFF",cx:"103.248",cy:"61",r:"61"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"head-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#8192A7",d:"M137.164,30.042H68.821L60.486,95.03H145.5L137.164,30.042z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M121.481,57.431c-4.863-0.01-8.936-2.281-10.061-5.363l19.628-4.434c0.525,0.82,0.807,1.773,0.812,2.747 C131.859,54.288,127.2,57.434,121.481,57.431z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M74.907,47.705l19.663,4.283c-1.1,3.09-5.167,5.4-10.019,5.439c-5.732,0.051-10.4-3.062-10.434-6.97 C74.11,49.483,74.385,48.527,74.907,47.705z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4E677F",d:"M103,62.1h-0.008c-20.65,0-34.045,17.317-36.1,32.928H139.1C137.041,79.42,123.647,62.1,103,62.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M116.228,70.932c2.548,1.385,4.895,3.112,6.975,5.133v0.008l1.475,18.958h-7.238L116.228,70.932z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M103.273,67.518c2.233,0,4.458,0.274,6.624,0.816l-0.009,0.045l0.659,26.651h-7.273L103.273,67.518 L103.273,67.518z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M131.122,87.662c0.989,2.359,1.668,4.836,2.019,7.369h-1.3L131.122,87.662z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M89.709,70.932c2.093-1.141,4.321-2.014,6.632-2.6v0.045l-0.649,26.651h-7.185L89.709,70.932z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FF3E2",d:"M74.853,87.679c1.822-4.363,4.509-8.311,7.9-11.606l-1.462,18.958h-7.149L74.853,87.679z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M124.691,95.03h7.149l-0.719-7.369l-0.009-0.017c-1.821-4.352-4.507-8.289-7.895-11.572L124.691,95.03z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M109.611,68.378l0.658,26.652h7.185l-1.21-24.1c-2.09-1.142-4.315-2.016-6.624-2.6L109.611,68.378z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M96.341,68.378L95.662,95.03h7.611V67.518c-2.335,0-4.661,0.274-6.932,0.816V68.378z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M82.757,76.072l-1.465,18.959h7.238l1.2-24.1C87.182,72.318,84.836,74.048,82.757,76.072z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7FB7CB",d:"M74.142,95.03l0.711-7.351c-0.983,2.354-1.657,4.825-2.008,7.351H74.142z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7FB7CB",points:"76.405,24.44 103.263,42.562 103.273,42.543 103.273,42.562 130.13,24.44 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5C7793",d:"M52.6,95c18.781,27.973,56.683,35.425,84.656,16.644c6.576-4.415,12.229-10.068,16.644-16.644H52.6z"})));}}]);return Boss;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (Boss);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RageEngage=function(_Component){_inherits(RageEngage,_Component);function RageEngage(props){_classCallCheck(this,RageEngage);var _this=_possibleConstructorReturn(this,(RageEngage.__proto__||Object.getPrototypeOf(RageEngage)).call(this,props));_this.state={show:""};return _this;}_createClass(RageEngage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;setTimeout(function(e){_this2.setState({show:"show"});},200);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"rageEngage"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"reRAGE",className:this.state.show},"RAGE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"reENGAGE",className:this.state.show},"ENGAGE!!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"Layer_1",xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",viewBox:"0 0 1024 768",enableBackground:"new 0 0 1024 768",preserveAspectRatio:"xMidYMid slice"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{ref:"cracks",id:"cracks",className:this.state.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"c1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0E0E0F",points:"507.659,336.079 516.326,340.746 517.326,334.413 510.993,335.079 507.659,323.079  486.993,315.079 505.993,325.079         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0E0E0F",points:"502.659,408.746 544.326,406.413 527.993,395.079         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0E0E0F",d:"M581.417,409.013l-27.965-11.344l-2.409-5.867l7.95-3.557l-6.5-19.5l2.5-5.5l13-3l5-21l-8.5,19.5 l-17.75-2.477v-7.023l-25.25,3.5l3-11.5l-0.5-23l1-14.5l-4.5,13v24.5l-1.535,4.386l-13.298-7.886l-19.333,12.333l2.559,5.964 c-0.897,1.714-2.029,3.876-3.181,6.08l-13.044-1.044l-13.333-11l-22.667-7.667l19,10l13.333,16l12.95,0.909 c-1.03,1.975-1.784,3.426-1.95,3.758c-0.667,1.333-2.667,20-2.667,20l7.709,4.049l-6.741,6.482 c-0.026-0.365-0.051-0.614-0.051-0.614l-14.75,2l-4.5,9.25l6.25-7.75c0,0,6.059,0.238,9.905,0.139l-1.155,1.111 c0,0-6.25,21.75-6.5,22.5s-0.75,6.75-0.75,6.75l-9-0.25l-11.25,14.75l12.75-11.25l9,0.5l1.75,13.5l0.25-24l5.25-20.5l13.96-10.298 l10.63,5.583l-0.09,1.215l28.5-16l11.5,6.5l8.33-3.726l3.844,6.66l8.528,3.366l-0.441,7.842l2.021-7.785l17.974,7.609 l7.092,11.014L581.417,409.013z M487.159,393.413l-3.167-20.167l19.833,7.667L487.159,393.413z M516.368,357.871l-23.875-1.375 l-1.875-4.875l17.375-10.875l9.25,7.125L516.368,357.871z M543.159,372.246c0,0-13.667-2.333-12.333-2.5 c1.333-0.167,19.667-4.167,19.667-4.167L543.159,372.246z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"c2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0E0E0F",points:"502.659,408.746 544.326,406.413 527.993,395.079         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0E0E0F",d:"M760,499.667l-59-66.333L712,432l64-18.667L700,429l-53-15.667l-64.828-2.701l-0.755-1.619l-7.464-3.028 l2.38-13.985l-1.847-16.62L583.5,372l-19-2.5L588,361l93-28l77-21.5l-75.5,14l-97,30.5l-17.086,2.476l4.579-19.23l-8.5,19.5 l-14.693-2.05l7.867-12.362L548,336l11-24.667l-15,18l-8-3l-11.691,6.461l-0.316-14.548l1-14.5l-4.5,13v22.185l-10.826-6.265 L503,315.333l-7.333-9.667L482,300l15.333,16l1,17.667l0.899,1.734L492,336.333l-20.667-13.667L442.667,302l26.667,24.333 l3.333,11.333L485,346l1.792,3.782l-0.466,0.297l1.155,2.691l-5.814,4.896l-21.543-6.93l-0.797-0.658l-4.084-1.381L425.5,285 l-5-18.5l-71.333,5.333l-31.667-2l32,6.167l65-4.5l6.5,22l17.315,49.473l-1.656-0.56l1.79,0.942L442,353.5l9.182,5.073 l2.568,29.177l22.75,8l2.788-1.64l5.525,2.902l-7.147,1.655l-1.612,2.439l-11.388,0.228l-9.333,10L441,398l12.333,18.333l13.667-4 l1.462,0.258l-3.796,5.742l-3,13.667l-1.81,4.805l-2.114-0.059l-11.25,14.75l11.727-10.347L453,455l-11.333,57.333l-123.333,26 l122-21.333L409,610.667L376,632l40-19.667l21.667-55L459,597l1.333,10l1-6.333l21.333,49L492,708.333l-5.333-60l-11-27L442,544 l6.333-25.667l21.154-67.989l0.506,3.901l0.06-5.718l3.198-10.278l8.25-23.75l15.589-11.042l2.994,1.572l-0.09,1.215l28.5-16 l11.5,6.5l3.67-1.642l11.67,13.563l4.95,1.707l-0.029,0.514l0.125-0.481l14.288,4.927l9.004,0.693l3.67,5.699l-2.618-5.618 l67.944,5.226L696,433.667L759,504l51,44.667L760,499.667z M567.131,378.138l2.535,15.528l-2.678,8.302l-11.599-12.111 l3.603-1.612l-2.091-6.272L567.131,378.138z M483.993,373.246l3.506,1.355c-0.594,1.66-1.458,4.073-2.29,6.388L483.993,373.246z M491.289,376.066l4.631,1.79l-1.419,10.049l-7.342,5.507l-1.485-9.459C487.383,381.588,489.536,378.552,491.289,376.066z M492.493,356.496l-1.324-3.443l-0.053-1.743l3.693-2.311l4.509,7.891L492.493,356.496z M465.5,386.75l16.004-17.319l0.366,0.03 c-0.992,1.901-1.716,3.295-1.878,3.619c-0.562,1.125-2.074,14.586-2.533,18.768L465.5,386.75z M511.432,357.587 c-2.727-4.905-6.564-11.645-7.926-14.033l4.486-2.808l9.25,7.129l-0.875,9.996L511.432,357.587z M572.03,407.232l7.802,3.303 L575,410.333L572.03,407.232z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"c4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0E0E0F",d:"M862.156,102.191l23.388-60.865L961.5,24.5l17-24.5H974l-14,21l-73.069,16.715L902,0h-6.5l-40.198,104.58 L819.667,117l3.082,102.316L742.333,303l-167.82,39.598l-1.184-5.404l-8.759,0.256l-5.651-1.454L588.667,302l-38.013,30.962 l1.694-10.762l-13.507-6.479l-10.404-0.974l-1.87,2.976C518.498,272.78,499,169,499,169l-46.704-22.96l10.138-33.734L503,121.667 L570.333,93l14-93h-4.667H515h-4l2,43l26.68,56.757L501.667,117l-37.758-9.6L476.5,65.5l-7-65.5H465h-57.5h-4l17,24l48.986,20.171 L471.5,64l-26.081,78.658L320,81l-33.2-40.745L306,0h-5.5l-16.857,36.379L254,0h-3h-10l59,94l25.194,12.974 c-35.827-0.081-133.839,1.359-135.527,1.359c-2,0-31.333-16.667-31.333-16.667L159.5,55.5L141.5,0H121l23.333,56.333l4.667,32 l-43.333-26L0,49.667V63l100.5,13l75,45l169.696,0.466l13.265,94.568L292,238l-45,60l-27.102-8.569L220.5,253L204,189l-4.5-36.5 l-8,38.5l7.5,32l-22.5-4.5l-78.5-55l74.5,69l28.5,6l5,15l-3.008,30.586L111,255L0,129v103l130.333,83l119.333,8l46-46.667 l114.667-0.667l41.596,88.726l-7.943-5.051l-4.358,0.531c0,0,6.769,11.689,7.692,12.552c0.924,0.863,0.434,8.074,0.434,8.074 l-3.434,1.394l5.672,7.597l-10.215,5.797l1.877,8.808l0.891,1.384L323,469.667l-62.667,52l70.667-42l100.667-28l-10,55.333 l-2.895,9.648l-104.439,19.685l-51.333,62l-12.667,11.333l1.017,29.836l-71.017,24.831l-62,103.667H166l38-75l72.333-24.667 l-16,78.667l42,21h10L329,741l-1.265-87.896L418,624l19.864-62.431L475,637.667l3.902,28.235l-77.236,57.765L391,768h30.667v-35 l48-32.667l8.667,23.333l30,44.333h47.333l-58-52.333l-12.667-84l-40.32-91.519l26.789-99.349l9.58,1.009l16.234,8.259 l-5.006,8.055l9.034,8.13c0,0,9.897-14.99,11.686-17.613c1.789-2.623,5.612-6.568,5.612-6.568l9.083-2.94L600,552l35,127l27,89 h167l-90.244-70.906L751,675.667L857,768h10.667L748.333,661l-16.989,30.271L717,680l-25-116L559.807,428.057 c4.344-1.778,8.653-3.633,8.885-4.09c0.135-0.266,1.065-2.093,2.336-4.592L695,461l21.82-3.637l86.847,96.97L969,555.667 l55,40.667v-6.667V582l-40-44l-65.684-0.401l10.803-77.163L1024,488v-27L898,352l-175,65l-139.93-23.762 c2.757-7.781,6.337-18.023,6.337-18.023l196.259-57.549l11.625-18.246l61.042,12.913L962,286.5l62,1V282l-61.667-5L860,296.5 l-28.333-6.833l36-45.333l0.667-50.667l81.463-43.995L1024,157v-16.667l-58.06-2.931L977.5,110l46.5-10l-56,1l-11.322,35.935 l-29.381-1.483L928,132.5l13.5-21.5l-4.47-14.199L1024,61v-7.333v-8L862.156,102.191z M874.84,122.402l-5.378,10.129 l-17.128-0.865L874.84,122.402z M403.187,201.252l11.985-47.941L467,180l9.246,122.509L410,199L403.187,201.252z M369.293,129.684 l29.285,15.081l-23.557,65.796l-3.245,1.072L369.293,129.684z M451.798,419.857l-0.42,0.325l0.2-0.666L451.798,419.857z M416.536,524.104l-8.869,29.563l-0.787,0.944L401,527L416.536,524.104z M331.5,560.5l54-0.5l7.663,11.071L371,597.667 L289.11,626.3L288.5,603L331.5,560.5z M256.333,612.333c2-1.333,10.667-8.667,10.667-8.667l9.72,26.965l-20.87,7.297 C255.485,625.196,255.388,612.963,256.333,612.333z M764.392,449.435L845,436l32.271,9.375l-67.851,74.952 C796.318,499.68,774.498,465.305,764.392,449.435z M820,537l59.558-74.243l22.497,47.038l-7.322,27.661L820,537z M904.868,499.165 l-19.385-43.795l4.951-6.171l25.685,7.462L904.868,499.165z M850.5,237l-40.828,46.73l-2.053-0.521L838.333,235L835,138.333 l29.817,2.945L857,156L850.5,237z M868.5,176.5l2.5-19l6.973-14.922l21.328,2.107L905,159.5L868.5,176.5z M931,112.5 l-26.553,21.798l-22.083-1.115l8.03-17.183l35.926-14.789L931,112.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0E0E0F",d:"M637,139l8,29.333L703,195l-0.667,34l7.333-32L689,178.333l62-38.667l56.667-114L816.333,0H809 l-9.333,25.667l-37.333,76L749,0h-7.333L755,106.333l-7.333,22l-21.491,14.409l-77.71-124.461L649,0h-12l-4,131l-37.333,52.667 l-5.333,74c0,0,8-69.333,10-70.667C602.333,185.667,637,139,637,139z M647.456,52.878l72.109,94.296L689,167.667l-35.333-4 L645,137L647.456,52.878z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0E0E0F",d:"M245,471l52.84-49.431L325.5,418l44-30l35.5,1.5l-36-5L321.5,410l-18,3H240l20-32l40-29.5L256.5,374 l-32.52,43.36L82,456l-82,6v11l23.993-1.887l34.096,22.428L0,578.5V608l65.903-109.32l59.618,39.215 C115.651,554.149,66,670,66,670l-66,5v17l72-14l66-133L245,471z M204.58,430.725L243,419l42,0.5L238.333,466l-50.26,31.601 L204.58,430.725z M63.981,467.968L89,466l95.255-29.071c-0.713,12.795-2.815,49.936-4.048,65.618l-49.847,31.341L63.981,467.968z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"c6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0E0E0F",d:"M1024,172.333V0H741.667l-13.294,41.17l-21.629-8.984L731,0H511l-23.333,11.667L476.5,65.5l-7-65.5h-66 l38.833,65l-80.667,36.667l-11.884-5.894L337,0H0v63l100.5,13l1.31,0.786L98,163.5l50,67.5l32.608,46.008L0,129v639h166l38-75 l72.333-24.667l-16,78.667l33.926,21h261.202L553,716l30.521-4.883L555.462,768h0.275H589l52.262-66.122l0.647-0.104L662,768h362 V304c0,0-50,25-53,26c-2.452,0.817-63.028-17.74-85.068-24.544L962,286.5l62,1V282l-61.667-5l-21.293,4.057l17.785-10.411 L1024,256v-28v-1.188v-3.146L946.333,215l-12.362-7.417C951.139,198.418,991.428,177,993,177C995,177,1024,172.333,1024,172.333z M180.206,502.547l-22.769,14.316L131,501l1.278-20.875L134,480l50.172-41.59C183.391,452.376,181.395,487.429,180.206,502.547z M171.676,350.395l-26.539-34.402l41.473,2.78L171.676,350.395z M188.073,497.601l16.507-66.875l27.304-8.333l8.665-0.407 l-35.009,64.633L188.073,497.601z M209.63,495.461L245,471l1.367-1.279l2.626-0.758l5.252,28.884L209.63,495.461z M331.281,352.955l-34.163,0.67L300,351.5l-4.157,2.15l-3.585,0.07l-24.222-18.895l36.639,0.643L335,351L331.281,352.955z M517.699,528.979l17.414,17.725c-0.306,8.008-0.661,17.069-1.008,25.561l-22.991-35.675L517.699,528.979z M462.434,112.305 L503,121.667l11.296-4.809l-6.92,96.883C502.615,188.243,499,169,499,169l-46.704-22.96L462.434,112.305z M369.293,129.684 l29.285,15.081l-23.557,65.796l-3.245,1.072L369.293,129.684z M372.555,275.886l37.779-0.22l17.859,38.094l-41.971,5.079 L372.555,275.886z M438,696l-34.338,26.147l-16.712-47.66L409,680l23.513-45.755L452,648L438,696z M444.751,168.542L467,180 l2.672,35.405L444.751,168.542z M497.667,715.667l-7.962-52.803l21.358-14.239L528,675l-15.906,53.684L497.667,715.667z M542,273 l-9.741-100.748l14.121-5.346l5.355,89.806L542,273z M611.223,660.12l-51.906-27.89L561,614l-8.197-12.72l11.57-24.793 l38.938,39.633l8.855,42.263L611.223,660.12z M925.562,162.759c1.625,7.228,2.861,12.69,3.28,14.544l-24.896,12.265l-13.275-7.965 L925.562,162.759z M751,139.667l30.663-61.686c3.552,11.113,6.924,21.721,9.828,30.886l-42.835,57.922l-3.792-23.295L751,139.667z M685.824,77.196l11.991-25.799l18.36,26.072L695,91.667L685.824,77.196z M702.018,312.513l37.316-87.262l82.485-36.83 l0.931,30.895L742.333,303L702.018,312.513z M834,344l-51.065-25.532l2.732-0.801l11.625-18.246l61.042,12.913l13.173-3.283 L834,344z M908.771,287.206L860,296.5l-28.333-6.833l17.588-22.148c18.522,1.781,55.848,2.698,81.079,3.134 C922.571,276.724,914.898,282.644,908.771,287.206z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"c7"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#0E0E0F",width:"1024",height:"768"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"hand",className:this.state.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"hand_x5F_base",fill:"#47403C",d:"M555.381,421.05l-10.407-2.602l-1.561-3.642l-10.927-2.081l-0.947-9.611l-3.242-2.123 l-7.004-0.718l-2.633,0.937l0.036-19.446l-4.683-6.244c0,0-2.602-0.52-3.122-0.52c-0.354,0-4.683,5.724-4.683,5.724l-0.364,42.585 l-2.628,12.436l-10.797-15.735l-8.326-2.081l-0.177,0.146l-2.945,2.456l9.283,20.58l1.644,8.039l3.476,5.667l4.85,9.944 l8.846,5.724l-0.52,9.366h42.669l-0.52-5.724l0.713-1.899l5.531-14.752l0.52-17.172l1.561-5.724l-2.099-6.75L555.381,421.05z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"glove",fill:"#242B42",d:"M530.612,419.057l-0.468-1.998l-4.595-1.212l-4.251,1.041l-0.26,1.301l4.772,2.685l5.027-0.864 L530.612,419.057z M548.096,454.176l-0.078-2.258l-0.094-2.862l-0.088-2.862l-4.074-3.466l-11.968-3.903l-13.009-0.437 l-6.941,1.738v2.685v2.342v6.078L548.096,454.176z M509.475,419.552l1.358,1.852l5.047-0.687l0.489-2.264l0.146-0.661l-2.305-1.931 l-3.887,0.614l-1.218,2.571L509.475,419.552z M544.016,423.871l-0.172-1.436l-3.814-1.904l-2.95,0.083l0.515,1.124l1.306,2.867 h5.203L544.016,423.871z M549.412,426.165l1.025,1.821l3.991,0.432l0.26-1.301l0.172-0.864l-3.382-2.43 c0,0-2.253,1.129-2.602,1.389L549.412,426.165z M518.956,414.369l3.554-7.68l2.794-0.791l6.671,1.629l0.51,5.198l1.561,5.547 l3.273-4.626l6.093,1.16l1.561,3.642l1.649,4.766l3.741-3.419l5.016,1.254l1.561,6.765l2.081,6.765l-1.561,5.724l-0.52,17.172 l-6.504,5.589l-0.151-0.005l0.057-2.076h-0.036l-1.93-0.104l0.151-3.71l-1.212-1.259l-35.644-2.43l-0.245,5.432l-0.146-0.01 l-7.675-2.992l-7.415-13.399l-2.456-6.395l7.035-3.939l2.446,3.57l5.854-11.312v-12.119l9.757-1.15L518.956,414.369z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"strap_x5F_shadow",fill:"#101421",points:"548.377,460.878 548.184,465.623 545.406,467.746 511.062,467.096  511.427,458.911     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"glove_x5F_shadows",fill:"#171B2D",d:"M518.758,407.75l3.752-1.062l-3.554,7.68l-0.13-3.205l-0.088-3.335v-0.078H518.758z M550.437,463.063l-0.151-0.005l-0.109,3.783l-3.991,3.122l5.203,2.253l0.021,0.01l5.531-14.752L550.437,463.063z M544.974,418.448 l1.649,4.766l3.741-3.419L544.974,418.448z M550.307,460.982l-1.93-0.104l-0.193,4.746l-2.779,2.123l-34.343-0.65l0.364-8.185 l-0.146-0.01l-7.675-2.992l-7.415-13.399l-2.456-6.395l-4.579,2.56l1.098,2.435l0.687,3.351h0.005l1.904-0.432l3.991,3.122 l0.26,3.903l-1.728,3.762l4.85,9.944l8.846,5.724l37.117-0.52l3.991-3.122l0.109-3.783l0.057-2.076h-0.035V460.982z M511.671,453.478l-0.245,5.432l36.95,1.967l0.151-3.71l-1.212-1.259L511.671,453.478z M543.761,442.728l-11.968-3.903 l-13.009-0.437l-6.941,1.738v2.685l6.765-0.864l13.009,0.781l11.796,3.122l4.511,3.205l-0.088-2.862L543.761,442.728z M532.485,412.725l1.561,5.547l3.273-4.626L532.485,412.725z M505.947,412.683h-0.016l-0.088,10.626l-2.628,12.436l5.854-11.312 v-12.119L505.947,412.683z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"skin",fill:"#FFDEBB",d:"M554.689,427.118l-0.26,1.301l-3.991-0.432l-1.025-1.821l2.628-0.479L554.689,427.118z M543.064,423.043l-3.335-1.561l-2.133,0.255l1.306,2.867h5.203l-0.088-0.734L543.064,423.043z M529.275,417.928l-3.856-0.869 l-4.381,1.129l4.772,2.685l5.027-0.864l-0.224-0.952L529.275,417.928z M516.354,418.448l-2.513-1.431l-2.779,0.26l-1.587,2.274 l1.358,1.852l5.047-0.687l0.489-2.264L516.354,418.448z M522.51,406.689l2.794-0.791l6.671,1.629l-0.437-4.413l-3.242-2.123 l-6.442-0.661l0.666,6.338L522.51,406.689z M512.842,387.748l-1.681-0.531l0.161-0.51l3.559-0.349l1.821-5.896l0.65-0.489 l1.343,1.79l-0.036,19.445l0.078,6.541v0.078l0.088,3.335l-9.757,1.15v-7.134l-1.301-15.741L512.842,387.748z M550.963,477.071 l0.255,2.779h-42.669l0.219-3.908h0.042l37.814-0.609l4.335,1.738H550.963z M548.018,451.917l0.078,2.258l-36.253-2.945v-6.078 h0.088l10.756-0.692l13.352,1.041c0,0,8.674,2.862,8.934,3.034C545.208,448.696,547.565,451.397,548.018,451.917z M514.013,375.52 l3.341,4.454l-0.65,0.489l-4.772-1.738l-3.034,0.437l0.172,6.676l2.253,0.869l-0.161,0.51l-3.263-1.03l-0.65-6.874 c1.27-1.691,3.289-4.314,3.642-4.314C511.411,374.999,514.013,375.52,514.013,375.52z M500.77,432.175l-7.035,3.939l-2.799-7.29 l-6.905-10.615l-0.114-0.135l0.177-0.146l8.326,2.081L500.77,432.175z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"skin_x5F_shadows",fill:"#DDAE87",d:"M521.854,400.33l0.666,6.338l-0.01,0.021l-3.752,1.062h-0.021l-0.078-6.541 l2.633-0.937L521.854,400.33z M551.478,423.824c0,0-2.253,1.129-2.602,1.389l0.536,0.952l2.628-0.479l2.649,1.431l0.172-0.864 L551.478,423.824z M551.39,472.216l-5.203-2.253l-37.117,0.52l-0.302,5.458h0.042l37.814-0.609l4.335,1.738h0.005l-0.265-2.945 l0.713-1.899L551.39,472.216z M543.413,445.85l-11.796-3.122l-13.009-0.781l-6.765,0.864v2.342h0.088l10.756-0.692l13.352,1.041 c0,0,8.674,2.862,8.934,3.034c0.234,0.161,2.591,2.862,3.044,3.382l-0.094-2.862L543.413,445.85z M540.03,420.53l-2.95,0.083 l0.515,1.124l2.133-0.255l3.335,1.561l0.952,0.827l-0.172-1.436L540.03,420.53z M530.144,417.059l-4.595-1.212l-4.251,1.041 l-0.26,1.301l4.381-1.129l3.856,0.869l1.337,1.129L530.144,417.059z M514.211,415.862l-3.887,0.614l-1.218,2.571l0.369,0.505 l1.587-2.274l2.779-0.26l2.513,1.431l0.016,0.005l0.146-0.661L514.211,415.862z M511.161,387.217l-3.263-1.03l-0.65-6.874 c-0.604,0.812-1.041,1.41-1.041,1.41l-0.276,31.96h0.016l3.122-0.369v-7.134l-1.301-15.741l5.073-1.691L511.161,387.217z M492.85,444.029l-1.904,0.432h-0.005l0.957,4.688l3.476,5.667l1.728-3.762l-0.26-3.903L492.85,444.029z M484.03,418.209 l-0.114-0.135l-2.945,2.456l0.635,1.41l2.055-1.067l3.205,4.506l-0.52,3.211l-1.093,1.431l3.903,8.653l4.579-2.56l-2.799-7.29 L484.03,418.209z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"nails",fill:"#7F3819",d:"M516.703,380.463l-1.821,5.896l-3.559,0.349l-2.253-0.869l-0.172-6.676l3.034-0.437 L516.703,380.463z M481.605,421.94l3.648,8.081l1.093-1.431l0.52-3.211l-3.205-4.506L481.605,421.94z"}))));}}]);return RageEngage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RageEngage);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Score=function(_Component){_inherits(Score,_Component);function Score(){_classCallCheck(this,Score);return _possibleConstructorReturn(this,(Score.__proto__||Object.getPrototypeOf(Score)).apply(this,arguments));}_createClass(Score,[{key:"formatScore",value:function formatScore(){var s=this.props.score+"";if(s.length<9){var dif=9-s.length;var c="";for(var i=0;i<dif;i++){c=c+"0";}return c;}return'';}},{key:"render",value:function render(){var score=this.props.score;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"score"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,this.formatScore()),""+(score===0?'':score));}}]);return Score;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Score);

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_darkPatterns_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scenemanager_manifest_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__darkpatterns_createPatterns_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__darkpatterns_PatternManager_js__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hud_Hud__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RoundStartText__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RoundEndText__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_timer_js__ = __webpack_require__(285);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { TweenMax } from "gsap";
var seq=function seq(p){var i=0;var c=p.length-1;var ended=function ended(){return i>c;};return{step:function step(){i=ended()?0:i+1;},current:function current(){return p[i];}};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fadeMusic:function fadeMusic(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["e" /* fadeMusic */])());},gameMusic:function gameMusic(track){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["f" /* gameMusic */])(track));},voiceStatic:function voiceStatic(track){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["u" /* voiceStatic */])(track));},createPattern:function createPattern(config){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_darkPatterns_js__["a" /* createDarkPattern */])(config));},playSndFx:function playSndFx(fx){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["l" /* playSndFx */])(fx));}};};var ThreeDView=function(_Component){_inherits(ThreeDView,_Component);function ThreeDView(props){_classCallCheck(this,ThreeDView);var _this=_possibleConstructorReturn(this,(ThreeDView.__proto__||Object.getPrototypeOf(ThreeDView)).call(this,props));var adseq=seq(props.seq);var ticksPerSecond=props.bpm/60*__WEBPACK_IMPORTED_MODULE_4__scenemanager_manifest_js__["a" /* frameRate */];_this.state={gameStart:false,gameEnd:false,countdown:props.duration};_this.timer=Object(__WEBPACK_IMPORTED_MODULE_11__lib_timer_js__["a" /* default */])(ticksPerSecond,"GAME_TIMER_id_");_this.updateCycle=_this.timer.add(function(delta){if(adseq.current()&&_this.state.countdown>=props.speed/2){props.createPattern(Object(__WEBPACK_IMPORTED_MODULE_6__darkpatterns_createPatterns_js__["a" /* createClickerPattern */])(props.speed));}adseq.step();_this.setState({countdown:_this.state.countdown-delta/1000});});_this.startGame=function(){_this.timer.start();_this.setState({gameStart:true});};return _this;}_createClass(ThreeDView,[{key:"componentDidMount",value:function componentDidMount(){// if level 3, don't play music, it should already be playing...
if(this.props.round!==3)this.props.gameMusic(this.props.music);this.props.voiceStatic(this.props.intro);// this.startGame();
}},{key:"componentWillUpdate",value:function componentWillUpdate(){if(this.state.countdown<=0&&!this.state.gameEnd){this.props.voiceStatic(this.props.outro);this.timer.stop();this.timer.remove(this.updateCycle);this.setState({gameEnd:true});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.props.fadeMusic();}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bodyWrapper",style:Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers_js__["a" /* maxSceneWidth */])()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"body rc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RoundStartText__["a" /* default */],{duration:this.props.introDelay,introPrompt:this.props.introPrompt,introBubble:this.props.introBubble,avatar:this.props.avatar,round:this.props.round,playSndFx:this.props.playSndFx,callback:this.startGame}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__hud_Hud__["a" /* default */],{countdown:this.state.countdown,hideScore:false}),this.state.gameStart&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__darkpatterns_PatternManager_js__["a" /* default */],null),this.state.gameEnd&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__RoundEndText__["a" /* default */],{duration:this.props.outroDelay,text:this.props.outroBubble,avatar:this.props.avatar,round:this.props.round,callback:this.props.next}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.environment,null)));}}]);return ThreeDView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ThreeD=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(ThreeDView);/* harmony default export */ __webpack_exports__["a"] = (ThreeD);

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createClickerPattern; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Images_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sample__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sample__);
// import PalmBasic from "../../svg/adstyle.svg";
// import EmptyBox from './../../svg/box-power-down.svg';
var allAds=[__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x1"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x2"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x3"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x4"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x5"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x6"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x7"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x8"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x9"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x10"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x11"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x12"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x13"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x14"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x15"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad3x4x16"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x1"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x2"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x3"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x4"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x5"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x6"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x7"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x8"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x9"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x10"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x11"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x12"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x13"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x14"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x15"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x16"],__WEBPACK_IMPORTED_MODULE_0__Images_js__["Ad4x3x17"]];var zIndex=20000;var index=0;var prefix="CLICKER_";var randomLane=function randomLane(){return Math.floor(1+Math.random()*4);};var randomvTranslate=function randomvTranslate(){return-(Math.floor(Math.random()*10)*70);};var randomvRotate=function randomvRotate(){return Math.floor(Math.random()*4*(Math.random()>0.5?1:-1));};var scoreValue=function scoreValue(){return Math.floor(Math.random()*500)+500;};var createClickerPattern=function createClickerPattern(){var speed=arguments.length>0&&arguments[0]!==undefined?arguments[0]:5;var lane=arguments.length>1&&arguments[1]!==undefined?arguments[1]:randomLane();var vTranslate=arguments.length>2&&arguments[2]!==undefined?arguments[2]:randomvTranslate();var vRotation=arguments.length>3&&arguments[3]!==undefined?arguments[3]:randomvRotate();var value=arguments.length>4&&arguments[4]!==undefined?arguments[4]:scoreValue();return{animationDuration:speed,lane:lane,vTranslate:vTranslate,vRotation:vRotation,value:value,image:__WEBPACK_IMPORTED_MODULE_1_lodash_sample___default()(allAds),// Ad3x4x1,
id:prefix+index++,z:zIndex--};};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bot.3aa5cb8f.gif";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_1.181caf26.svg";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_2.11263beb.svg";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_3.5ffbfc95.svg";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_4.9f0cb3ba.svg";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_5.5ef3c769.svg";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_6.4e8759f6.svg";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_7.daaa1d3d.svg";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_8.ab5fceba.svg";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_9.a1594912.svg";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_10.73428cfd.svg";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_11.697d1b8c.svg";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_12.35638be1.svg";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_13.85be712b.svg";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_14.6a265528.svg";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_15.27233ffa.svg";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_3x4_16.c84d57ac.svg";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_1.d26891bd.svg";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_2.e865407f.svg";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_3.2df8e4d1.svg";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_4.1441f3e3.svg";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_5.89f19d08.svg";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_6.45bcb9a5.svg";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_7.ca87b289.svg";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_8.f3131515.svg";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_9.1b422170.svg";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_10.2054673d.svg";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_11.ae4893a2.svg";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_12.95283734.svg";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_13.84c04dfc.svg";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_14.7433812c.svg";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_15.ddbfb17d.svg";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_16.76e3bb51.svg";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ads_4x3_17.de0366ef.svg";

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/digital-ocean.dabd0dca.png";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/donors-choose.84ba382c.png";

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAEsCAMAAADaaRXwAAAC9FBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9JxXEjAAAA/HRSTlMAOK/x7IwiFCkkIFBgBCpdSxo/WTkhTltcNwdq/v/jPSbN+31H7poI+eBIeWnwpiMKu/xAHoHyMRbi2hELzkoS367oc4ntHT711eYuNGEf5P1o94KnATXr4Sg72XqFh42RQ2JJknI2e9vPbEZlaxDqDBxVOgbU+FHEcMzLA7aI1vREZtgNqsIClYrcswUXufNjDkzF+p+dT969CSUVnKupjqO0G1iAPO8vqLVtocBvoDCXGFPdsXwr06THZLBChsae15Sbw1oy9nR4fsp1J1QPyb9XpVLR56KQE3ZBX39uZ+m4wdLlVjMsRYtNGbp3mIPImS2tXnG8lreT0KywZk5XAAALYElEQVR4AezBQQEAAAQEMJz+maXw21Y8AgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADoSbLHvl14xXVvbRx/KBRCW5wa5YmnQYpLSyOVuFNuSTXugsXzxpXchrjeuLu7uxFP6u7ubq/tw4JzrsycmXPODMNa5fMn8AVmfnvtfasv3Mqvij+Mu+32O7wCYEZgUHAIjAkIDQuHfXfeFXS3s4LuuTcCJt0XyRJVq8GNqtdgzVowqnYdkvfXhXH3RZHRMTAkluQDsOeuOBoSXxem3M4yPglwm8QkkskpMCa1DhVpMCwhiiL9QRjwUAbJh+vBtvoNaFBDmPHIo1Q9Bre57XGKRjCmMUs0aQqjmjWnosUjcF61OJItW8G21k1oUBuYcTc1NavDXdq2I5n5BAzxz6IQf4NRXuks8WQ2nNb+KZJPPwPbnq1DY55rCzOepyYqBe6SmmEiSAeWymhrNghjXRXEy4ei5mMdOzmlc8cqsBwkq0uFClIvmmW6mg6S1c2lQboHwM16UJPcs0IF6UXRuzdFn3pmg/DhVFcG6QsXq9evf063XGjCqcnLh6ZgQE7QQE8GGTSYIixhCMVQ00E4zJVBhsO1+v8XxYj+UI0cRVUvqPJHjyE5Nmmc54KMTyY5YSImUUwuNBGkzsNUTKm4Qf7OUt2h8n2BpaYWocy06RRixkxPBZlVgyIWCKVitokgvb0mU9G3ogaZSVUjqJ6ZM5cia159qOazTHq4h4IsoFiYCkT8g2K6iSDRixY/RTEjpWIGWTKYqoUhUC1quHTZ8hVehVCFZ1G1MtsjQUauUv/b3EUxNtx4kKdXY00mRQO/ChmkXyQ1Q6FjLTXPNfVIkHUU6zdA+LWg2GgiSGrZW2ZTkeUgzeJcHmQ8NdwMHVuoiVrniSDZU6jNcp6giPM3FSR/KxUdLQepHu3yINtITV/o2E5qxnkiyI4hJJOrocS0DIqdpoJgVwZF5m6rQYpGuDxIw0hq1kDHaGr23OmJIN0p9qLUPor1gaaCoFo6Rdx+i0Hy+7g8iN8Bqh4tgI4u1ByEB4K0Xa/9bYrFLSlqmQuCHCoOTatwQXCYql7QdYRloo56IsgxiuOJKHOC4uRqc0GwlIr5FS8ITrHUaehLPUOh/QzLOUhEVYqzUJ07T9HfZJB6c6i4UPGCoLgFxcmLcMTvdB7FpQHwRJDLkSSr+kGTRFFjkLkguNJSe8pUrCAIuZqTc7YATtjRNeeBmGvwRBC/F/7j7+HZuRRnTQZBcE0Kn+oeDOJ55oOMp6haAJWYQ3G9rskgSKPixkQTQSqDBAyjGA2NuElFP7NBsl+kYoWJIJVBXqJY3woaMXEMxSizQVDvZSruqAxiOEj2copJ+Dc5FOdbmw2C9nEUcT0rgxgN0iyKZPMd+Dd+r1AcNB0Eh6k4sKQyiLEgRa9SbLKzjjFkh+kgeI2KI5VBjAVpFUUyqhv+Q0I7ip3mg4ycSkWvihDk9bsuFG9rXQQTJtZu9Mbl2hHlFuQUxXHYcJoio7rpIPB9mIo1ng/y0gtzSWZN9YVhb9aIIhl15sFyCrJrBsVbsCF8BsXb5oOgYU2KdoHmg7wDV3iXpZ7zh0ELsijEe+3LJ8jbFCcT7Y88D1wzHwSbqUgqNB1kPFygdU2WGRYBQxb7UI1ZrzyCLHmFIgc23TWX4l0LQfAqFadNB3l/R1NfhxYXQtcR8yvyHalpVB5Bnqd4dBps+4DiuVkWglwbQUWO2SDMO7nHoUf/EQo9M6hZCkM+pCZppPuD5H9IcRl23JFJcdVCEFT5iGJujNkgzjmZCB3NqVkGQzKoOTDI/UGeoMh7BnYElPQatshCELyk7dK4L0iWL3QMoeZJGBJNTYMitwcp3Opg9XMzFV2sBMHzVEwtdGeQQ0XQ4UPNKRhyiJqpI90e5PZkknN7wq5p7SiOWApS9wgVfzcXZGGNAw4NHvUs9HQ3v9PTiJqzcHeQgFUUkxyeKCQ/ayUIVj9NxcdmgiQlDLrmUD3ou/MjllkJY/wGs8yNQW4PUm2unamJ5kodimWWguATbwqf/SaCHIYrhPpQiFX1YdCneyjEIT+4M4g2Vpwc4PgOtE4rS0HwBBUHdnnqpY5nbmkeFZXV5Pn6MKzgxIwhUUNm3PoI3B4kMJNk8lXoujeZ4n5rQdCZikmeGy4GVDn6mVcuzChcXW1caCrg/iCfU5xcBH2TKBYWWAuSP52Ki5Xjdx0F3k4NRr6IpOhlLQiq51HM+KwyiH37KMZEwIHsvRQZD1kLgpS5FHu+rAxiz+vRFFty86/pw2gq+lsMggtUjLhWGUT3yZP34csH9F1/j4qXX7cYBMuoeK0yiG3ZL9OYYKtB6tegov9fOEhkDuzqSoO+KrIYBO19KOKO/iWDrF5IMvkw7MkeRqPetBoENyMpBj/kySBew6ec+DocTpidNu/Wmf5wEf86JJuPgz0x5ynOt9jjhN55VNxiOQg6UHEkwGNBXu+eTjH2m3pw4JNRVDx6Ga7hReG9A3YsWkXRZ12IrxNu27GMYkhPy0ECkqhI81SQ/FEsNf116Lq3JUs1hkuEUfjMgh33ZpIcexROWjyDYpm1INrpfuYCDwX5lqpO0LPoBlW74QLZr1F8B3u+pzgEp+2kyKtiOQhC11M0/8QjQQoepcrnB+j4mJpbCuHYolzoijhO8T3sCEymCILTQjMpulsPguFUTK7niSADqOFb0PEaNa/sh0Ptfxz2tW63T6n4SfcMO3oQnDbyR4qWqdaDYCcVSz0R5AI1zIGOedQwBo74Pu7oaHktRc0rsG11HsVmGDCUiuEuCJL4HRX3eSDIeGr4DnS8Ss2Qdc59YtesBrty91CsCtDL9VEuDEg8TvF0iPUgSHiF4nwX3FveQUKHUJUZDB2x1Bx4CI4soGJPKuwppt4+VX40xUUYMj6Soo3lIOILKqp+mVDeQYq2UvVyPaj83vhuzJikeyKgujeLqhVwqOBDKh4rhG1X2lE8Z6/szxTNn4Ehi3pTHM+1HERcpGJ7eLtyDoIFVK2BKnghFZlbfaHqwDILr8CxuyJ13yxHqNgG20aOoZgPgy5T8ZL1IOIgFXtmlHcQbF7PEkNyoNpxnqX65EK1k0I8XRvOeJslViTChilUtPCDbWFzSc71gkGz8ih+yXZFkF0HWKLcgyB0Uh753t67oBo5h6rG0Dxwxptc+Gt1OGVkPEv8dgX/btA3VNSMgW2LzmjzJEM6UdHMehBxb7pngogdDRu2AjRdqPGeBk3dnsGfJcBZg66zREYjKDTPfsASabBjNsX52TDsthkUX7kkCIKcDLIN7vY1NTWfhWmpWynEmVr+UKVsbMIS8QGwrXA5xXeFMO60dgVqOQiOORekEdwtlpqsozDv2haWannp959fejb0i5/v/yOOQqxcBDuqZZo+THowkuJJ1wRZNMqpIAvfzunhlDdynoEpxdTUrAYLCi83oarmkCFztdBpI2FH4TcUE0bChJF/UtRp7ZIgSMhwHMSQGTdhxhfUeBfAEq/pkbShwVXY5Z9HsRamNMyk6AEb1s0g+Z4vDOgyl6Ldftg260Ma1A5m1D1A1Tew6uNlc/lvRlyMgH2fUKz3gykRkyliYcM5ijF+MOI+iscTYFvEczQoHaYMjGOpGktgXcrzm/KoanHqbC70zNpL8g2Y9FkWmbcYNiz608RXordJbimCHRdo0D6Yc/QVljhTAJdYVOXNs72Ki4t7NfpiYAEcmTU+7aaF/MUXAmFT/vi/vRUBg2YXz6wHuwYUxxY7r1ZQAExqeuG6t/emsFxUHP/fHhwIAAAAAAD5vzaCqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqoCd4h9H9FY2ocAAAAASUVORK5CYII="

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/segment.6b0c2898.png";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/teespring.9227ce89.png";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chris.481808ce.png";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dan.171b9093.png";

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_darkPatterns_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_clickSequence_js__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_explosions_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClickerPattern_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Explosion_js__ = __webpack_require__(282);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{patterns:state.patterns,explosions:state.explosions,clickSequence:state.clickSequence,isMobile:state.game.mobile};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{patternClicked:function patternClicked(id,e,z,o,v,m,isMobile){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_darkPatterns_js__["b" /* destroyDarkPattern */])(id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_clickSequence_js__["a" /* incrementClickSequence */])());if(e&&z){if(isMobile){if(e.touches===undefined)return;var touch=e.touches[0];if(touch===undefined)return;dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_explosions_js__["a" /* createExplosion */])({x:touch.pageX-o.x,y:touch.pageY-o.y,value:v,z:z,id:id}));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_explosions_js__["a" /* createExplosion */])({x:e.clientX-o.x,y:e.clientY-o.y,value:v,z:z,id:id}));}// console.log(v, m);
// if (m === 0) m =1;
dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_actionCreators_js__["a" /* addScore */])("popover",v*m));}},removeDarkPattern:function removeDarkPattern(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_darkPatterns_js__["c" /* removeDarkPattern */])(id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_clickSequence_js__["b" /* resetClickSequence */])());}};};var PatternDisplay=function(_Component){_inherits(PatternDisplay,_Component);function PatternDisplay(){_classCallCheck(this,PatternDisplay);return _possibleConstructorReturn(this,(PatternDisplay.__proto__||Object.getPrototypeOf(PatternDisplay)).apply(this,arguments));}_createClass(PatternDisplay,[{key:"render",value:function render(){var _this2=this;var props=this.props;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:"flyingads",className:"flyingads"},props.explosions.map(function(el,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Explosion_js__["a" /* default */],{width:200*el.z,height:200*el.z,score:el.value,top:el.y,left:el.x,key:el.id,id:el.id});}),props.patterns.map(function(el,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ClickerPattern_js__["a" /* default */],{image:el.image,animationDuration:el.animationDuration,vTranslate:el.vTranslate,vRotation:el.vRotation,lane:el.lane,patternClicked:function patternClicked(e,progress){if(progress===undefined){// remove this thing, no audio or fx
_this2.props.removeDarkPattern(el.id);return;}if(!_this2.refs.flyingads)return;var rect=_this2.refs.flyingads.getBoundingClientRect();var multiplier=Math.floor(_this2.props.clickSequence/10)+1;var screenoffset={x:rect.left+window.scrollX,y:rect.top+window.scrollY};_this2.props.patternClicked(el.id,e,progress,screenoffset,el.value,multiplier,_this2.props.isMobile);},bg:el.bg,key:el.id,id:el.id,z:el.z// imageDead={el.imageDead}
});}));}}]);return PatternDisplay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PatternManager=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(PatternDisplay);/* harmony default export */ __webpack_exports__["a"] = (PatternManager);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = incrementClickSequence;
/* harmony export (immutable) */ __webpack_exports__["b"] = resetClickSequence;
function incrementClickSequence(){return{type:"INCREMENT_CLICK_SEQUENCE"};}function resetClickSequence(){return{type:"RESET_CLICK_SEQUENCE"};}

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClickerPattern=function(_Component){_inherits(ClickerPattern,_Component);function ClickerPattern(props){_classCallCheck(this,ClickerPattern);var _this=_possibleConstructorReturn(this,(ClickerPattern.__proto__||Object.getPrototypeOf(ClickerPattern)).call(this,props));_this.state={init:Date.now()};_this.tref=undefined;_this.progress=function(){return(Date.now()-_this.state.init)/(_this.props.animationDuration*1000);};return _this;}_createClass(ClickerPattern,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var duration=this.props.animationDuration*0.74;this.tref=setTimeout(function(){return _this2.props.patternClicked();},duration*1000);}},{key:"handleClick",value:function handleClick(e){e.preventDefault();e.stopPropagation();this.props.patternClicked(e,this.progress(),true);clearTimeout(this.tref);}},{key:"handleTap",value:function handleTap(e){e.preventDefault();e.stopPropagation();this.props.patternClicked(e,this.progress(),true);clearTimeout(this.tref);}},{key:"render",value:function render(){var _this3=this;var childStyles={animation:"moveit "+this.props.animationDuration+"s ease-out forwards",zIndex:this.props.z};var panelStyles={backgroundImage:"url( "+this.props.image+" )",backgroundSize:'contain',transform:"translateY( "+this.props.vTranslate+"px ) rotateZ("+this.props.vRotation+"deg)"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"child lane"+this.props.lane,style:childStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"panel",onMouseDown:function onMouseDown(e){return _this3.handleClick(e);},onTouchStart:function onTouchStart(e){return _this3.handleTap(e);},style:panelStyles}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shadow"}));}}]);return ClickerPattern;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ClickerPattern);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_explosions_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Images__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sample__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_sample__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{clickSequence:state.clickSequence};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{destroyExplosion:function destroyExplosion(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_explosions_js__["b" /* destroyExplosion */])(id));}};};var ExplosionView=function(_Component){_inherits(ExplosionView,_Component);function ExplosionView(){_classCallCheck(this,ExplosionView);return _possibleConstructorReturn(this,(ExplosionView.__proto__||Object.getPrototypeOf(ExplosionView)).apply(this,arguments));}_createClass(ExplosionView,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(0.3,function(){return _this2.props.destroyExplosion(_this2.props.id);});}},{key:"render",value:function render(){var width=this.props.width;var height=this.props.height;var x=this.props.left-width/2;var y=this.props.top-height/2;var randomExplosion=__WEBPACK_IMPORTED_MODULE_5_lodash_sample___default()([__WEBPACK_IMPORTED_MODULE_4__Images__["ExplosionImg1"],__WEBPACK_IMPORTED_MODULE_4__Images__["ExplosionImg2"],__WEBPACK_IMPORTED_MODULE_4__Images__["ExplosionImg3"]]);var multiplier=Math.floor(this.props.clickSequence/10)+1;var m=this.props.score;var explosionStyles={width:width+"px",height:height+"px",top:y+"px",left:x+"px"};var numberStyles={"top":height/2-20+"px","left":width/-4+"px"};var n='';if(multiplier>1){n+="x";n+=multiplier;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"explosionOffset",style:explosionStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"explosionNumber",style:numberStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"explosionNumberDigits"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,m),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"explosionNumberMultiplier"},n)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"explosionNumberShadow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,m),multiplier>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"explosionMultiplierShadow"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:randomExplosion,alt:"explosion"}));}}]);return ExplosionView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Explosion=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ExplosionView);/* harmony default export */ __webpack_exports__["a"] = (Explosion);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__darkpatterns2d_Avatar__ = __webpack_require__(46);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoundStartText=function(_Component){_inherits(RoundStartText,_Component);function RoundStartText(props){_classCallCheck(this,RoundStartText);var _this=_possibleConstructorReturn(this,(RoundStartText.__proto__||Object.getPrototypeOf(RoundStartText)).call(this,props));_this.state={subText:props.duration,timerKey:undefined};_this.countDown=function(){var subText=_this.state.subText;var key=setTimeout(function(){var newsubText=subText-1;if(newsubText>=1)_this.props.playSndFx('threeDCountdown');else _this.props.playSndFx('threeDCountdownComplete');_this.setState({subText:newsubText<1?"GO!":newsubText});if(newsubText>0){_this.countDown();}else{_this.props.callback();}},1000);_this.setState({timerKey:key});};return _this;}_createClass(RoundStartText,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var key=setTimeout(function(){_this2.countDown();},1000);this.setState({timerKey:key});}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.state.timerKey);}},{key:'render',value:function render(){var animationStyles={animationDuration:this.props.duration+1+'s'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'game-placard-wrapper',style:animationStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'game-placard',style:animationStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-game-placard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'avatar3dintro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__darkpatterns2d_Avatar__["a" /* default */],{round:this.props.round,look:3,speaking:false,className:'avatarIcon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'avatarSays'},this.props.introBubble)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ragecountdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info'},this.props.introPrompt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subText jump-'+this.state.subText},this.state.subText)))));}}]);return RoundStartText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RoundStartText);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__darkpatterns2d_Avatar__ = __webpack_require__(46);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoundEndText=function(_Component){_inherits(RoundEndText,_Component);function RoundEndText(props){_classCallCheck(this,RoundEndText);var _this=_possibleConstructorReturn(this,(RoundEndText.__proto__||Object.getPrototypeOf(RoundEndText)).call(this,props));_this.state={timerKey:undefined};return _this;}_createClass(RoundEndText,[{key:"componentDidMount",value:function componentDidMount(){// console.log( this.props.duration );
this.setState({timerKey:setTimeout(this.props.callback,this.props.duration*1000)});}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearTimeout(this.state.timerKey);}},{key:"render",value:function render(){var animationStyles={animationDuration:this.props.duration-1+"s"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"game-placard-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"game-placard",style:animationStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner-game-placard end-placard"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"avatar3dintro"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__darkpatterns2d_Avatar__["a" /* default */],{round:this.props.round,look:3,speaking:false,className:"avatarIcon"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"avatarSays"},this.props.text)))));}}]);return RoundEndText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RoundEndText);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var abs=Math.abs;var floor=Math.floor;var random=Math.random;var raf=window.requestAnimationFrame;var ruid=function ruid(){return floor(random()*10000000);};var timer=function timer(){var frameRate=arguments.length>0&&arguments[0]!==undefined?arguments[0]:60;var ID=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"TIMER_id_";//PRIVATE
var listeners={};var _initial=0;var frameDelta=0;var run=false;var last=0;var update=function update(time){var delta=time-last;if(delta>=frameDelta){last=time;if(run){for(var el in listeners){listeners[el](delta);}}}raf(update);};//PUBLIC
var initial=function initial(){return _initial;};var running=function running(){return run;};var delta=function delta(){return frameDelta;};var stop=function stop(){return reset();};var start=function start(){return!(run=true);};var remove=function remove(id){return delete listeners[id];};var add=function add(func){var uid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:ruid();var id=ID+uid;listeners[id]=func;return id;};var setFrameRate=function setFrameRate(){var rate=arguments.length>0&&arguments[0]!==undefined?arguments[0]:60;var r=abs(rate);frameRate=r>60?60:r===0?0.000000001:r;frameDelta=floor(1000/frameRate);return frameRate;};var reset=function reset(){_initial=0;last=0;run=false;};//get starting timestamp
raf(update);_initial=last;//calculate the framerate and frame delta, safety checks
setFrameRate(frameRate);//pass along public functions
return{start:start,stop:stop,setFrameRate:setFrameRate,add:add,remove:remove,running:running,delta:delta,initial:initial};};/* harmony default export */ __webpack_exports__["a"] = (timer);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Images_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{siteDownMusic:function siteDownMusic(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["o" /* siteDownMusic */])());},siteDownMusicStop:function siteDownMusicStop(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["p" /* siteDownMusicStop */])());}};};var SiteDownView=function(_Component){_inherits(SiteDownView,_Component);function SiteDownView(){_classCallCheck(this,SiteDownView);return _possibleConstructorReturn(this,(SiteDownView.__proto__||Object.getPrototypeOf(SiteDownView)).apply(this,arguments));}_createClass(SiteDownView,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;setTimeout(function(){_this2.props.siteDownMusicStop();_this2.props.next();},1500);this.props.siteDownMusic();}},{key:"render",value:function render(){var imgStyles={animation:"travel 4s cubic-bezier(.22,.48,.61,.99) forwards"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"darkpatterns2dbg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bodyWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"site_down"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"overbot_texture"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"color_flickr"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"technical_difficulty"},"Sorry, We are experiencing technical difficulties :("),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"graphic"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_1__Images_js__["bot"],alt:"bot",style:imgStyles})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"technical_reason"},"Don't be sad human. It will all be over soon.")))));}}]);return SiteDownView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SiteDown=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(SiteDownView);/* harmony default export */ __webpack_exports__["a"] = (SiteDown);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){var g=state.game;return{isMobile:g.mobile};};var mapDispatchToProps=function mapDispatchToProps(dispatch,state){return{// boom
playSndFx:function playSndFx(sfx){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["l" /* playSndFx */])(sfx));},gameMusic:function gameMusic(track){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_actionCreators_js__["f" /* gameMusic */])(track));}};};var MeetBossView=function(_Component){_inherits(MeetBossView,_Component);function MeetBossView(props){_classCallCheck(this,MeetBossView);var _this=_possibleConstructorReturn(this,(MeetBossView.__proto__||Object.getPrototypeOf(MeetBossView)).call(this,props));_this.state={shake:false,in:true};return _this;}_createClass(MeetBossView,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.props.gameMusic("music3");// play music immediately
__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(1.5,function(){return _this2.shake();});__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(2,function(){return _this2.shake();});__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(1.75,function(){return _this2.hello();});__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(3,function(){return _this2.out();});__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(5,function(){return _this2.animateout();});}},{key:"hello",value:function hello(){this.props.playSndFx('meetboss');}},{key:"animateout",value:function animateout(){this.props.next();}},{key:"shake",value:function shake(){var _this3=this;this.setState({shake:true});__WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].delayedCall(0.25,function(){return _this3.setState({shake:false});});}},{key:"out",value:function out(){this.setState({in:false});}},{key:"render",value:function render(){// const imgStyles = { animation: `travel 4s cubic-bezier(.22,.48,.61,.99) forwards` };
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"darkpatterns2dbg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bodyWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"body "+(this.state.shake?'shake':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"meetboss"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"blocker "+(this.state.in?'in':'')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bossright"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"textleft"})))));}}]);return MeetBossView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var MeetBoss=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(){return mapStateToProps;},mapDispatchToProps)(MeetBossView);/* harmony default export */ __webpack_exports__["a"] = (MeetBoss);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hud_Hud__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AudioNotice__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Images_js__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getHighScores:function getHighScores(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["g" /* getHighScores */])());},toggleMute:function toggleMute(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["r" /* toggleMute */])());},audioChosen:function audioChosen(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["b" /* audioChosen */])());},deletePlaybackToken:function deletePlaybackToken(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["c" /* deletePlaybackToken */])());},setMute:function setMute(mute){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["n" /* setMute */])(mute));},gameMusic:function gameMusic(music){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["f" /* gameMusic */])(music));},playSndFx:function playSndFx(sfx){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["l" /* playSndFx */])(sfx));}};};var mapStateToProps=function mapStateToProps(state){var g=state.game;return{mute:g.mute,token:state.game.token,audioSet:g.audioSet,showDebug:false};};var StartScreenView=function(_Component){_inherits(StartScreenView,_Component);function StartScreenView(props){_classCallCheck(this,StartScreenView);var _this=_possibleConstructorReturn(this,(StartScreenView.__proto__||Object.getPrototypeOf(StartScreenView)).call(this,props));_this.rageIn=function(e){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to([_this.refs.triangle,_this.refs.click,_this.refs.rage],0.2,{scaleX:1.15,scaleY:1.15,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut});};_this.rageOut=function(e){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to([_this.refs.triangle,_this.refs.click,_this.refs.rage],0.5,{scaleX:1,scaleY:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});};_this.rageGo=function(e){e.stopImmediatePropagation();_this.refs.click.removeEventListener('mouseover',_this.rageIn);_this.refs.click.removeEventListener('mouseout',_this.rageOut);_this.refs.click.removeEventListener('click',_this.rageGo);__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(1,function(){return _this.props.playSndFx('startAnimateLogo');});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to([_this.refs.triangle,_this.refs.click,_this.refs.rage],1,{scaleX:1,scaleY:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut,onComplete:_this.animateOut(true)});};_this.startAnimation=function(option){_this.props.audioChosen();// console.log(this.props);
_this.waitForLogo();if(option==='yes')_this.props.toggleMute();};_this.errorCount=0;_this.assetLoaderErrorLog=[];_this.cache={};_this.out=false;_this.state={successCount:0,soundQueue:[],assetsLoaded:false,imageArray:[],assetLoaderErrorLog:[],errorCount:0,startScreenReady:false};return _this;}_createClass(StartScreenView,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;// console.log(this.props);
// console.log(this.props);
this.checkMute();this.props.getHighScores();this.prepForIntroAnimation();if(this.props.audioSet)__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(1,function(){return _this2.animateLogo();});this.getImagesToLoad();}},{key:"checkMute",value:function checkMute(){var isMuteSet=this.props.mute;if(isMuteSet===undefined){// console.log('setting mute');
this.props.setMute(true);}}},{key:"prepForIntroAnimation",value:function prepForIntroAnimation(){// hide background lightning and bg as a whole
__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set('.animatedBg',{autoAlpha:0});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set([this.refs.glint1,this.refs.glint2,this.refs.glint3],{autoAlpha:0});// button glints
__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set([this.refs.bottom],{autoAlpha:0,y:50,transformOrigin:"50% 50%"});var bgLightning=[this.refs.lightning1,this.refs.lightning2,this.refs.lightning3,this.refs.lightning4];__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.forEach(bgLightning,function(lightning){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(lightning,{autoAlpha:0});});}},{key:"getRandomInt",value:function getRandomInt(min,max){return Math.floor(Math.random()*(max-min+1))+min;}},{key:"getRandomArbitrary",value:function getRandomArbitrary(min,max){return Math.random()*(max-min)+min;}},{key:"doLightning",value:function doLightning(){var _this3=this;if(this.out)return;var bgLightning=[this.refs.lightning4,this.refs.lightning1,this.refs.lightning2,this.refs.lightning3];__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.forEach(bgLightning,function(lightning,index){if(index<=1)__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(lightning,{x:0-_this3.getRandomInt(0,900)});else __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(lightning,{x:_this3.getRandomInt(0,900)});// TweenMax.to(lightning, this.getRandomArbitrary(0.2, 0.4), {delay: this.getRandomInt(1,5), autoAlpha: 1, yoyo: true, repeat: 1})
__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(_this3.getRandomInt(1,5),function(){_this3.showLightning(lightning);_this3.props.playSndFx('startThunder');});});if(!this.out)__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(5,function(){return _this3.doLightning();});}},{key:"showLightning",value:function showLightning(lightning){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(this.refs.sky,{fill:'#ffffff'});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(lightning,this.getRandomArbitrary(0.2,0.4),{autoAlpha:1,yoyo:true,repeat:1});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(this.refs.sky,0.3,{fill:'#000000',ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut,delay:0.1});}},{key:"animateLogo",value:function animateLogo(){var _this4=this;__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(1,function(){return _this4.doLightning();});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to('.animatedBg',1,{autoAlpha:1,delay:0.3});var flames=this.refs.flames.childNodes;__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.forEach(flames,function(flame){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(flame,{scaleX:0,scaleY:0,opacity:0,y:150,transformOrigin:"50% 50%"});});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(this.refs.container,{visibility:"visible"});__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.forEach(flames,function(flame,index){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(flame,0.25,{opacity:1,delay:index*0.05,scaleX:1,scaleY:1,y:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(flame,_this4.getRandomArbitrary(1,3),{rotation:_this4.getRandomArbitrary(-4,4),delay:_this4.getRandomArbitrary(1,1.5),ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut,transformOrigin:"50% 100%",yoyo:true,repeat:-1,repeatDelay:0.25});});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set([this.refs.triangle],{scaleX:0,scaleY:0,opacity:0,y:-50,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set([this.refs.click],{y:200,opacity:0,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set([this.refs.rage],{scaleX:2,scaleY:2,opacity:0,y:50,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to([this.refs.triangle,this.refs.rage,this.refs.click],0.6,{scaleX:1,scaleY:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut,delay:0.5,transformOrigin:"50% 50%",opacity:1,y:0,onComplete:function onComplete(){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(0.6,function(){return _this4.addHover();});}});}},{key:"addHover",value:function addHover(){var _this5=this;if(this.state.assetsLoaded===false){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(1,function(){return _this5.addHover();});return;}// console.log('adding hover stuff');
__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to([this.refs.bottom],0.75,{ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut,transformOrigin:"50% 50%",autoAlpha:1,delay:0.2,y:0});// add event listeners for start/click
if(this.out)return;// abort if animating out already
this.refs.click.addEventListener('mouseover',this.rageIn);this.refs.click.addEventListener('mouseout',this.rageOut);this.refs.click.addEventListener('click',this.rageGo);this.animateGlints();}},{key:"animateGlints",value:function animateGlints(){var _this6=this;if(this.out)return;// TweenMax.set([this.refs.glint1, this.refs.glint2], {autoAlpha: 0});
__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set([this.refs.glint1],{autoAlpha:0.3});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set([this.refs.glint2],{autoAlpha:0.3,delay:0.1});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set([this.refs.glint3],{autoAlpha:0.3,delay:0.2});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(this.refs.glint3,0.25,{x:275,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut,opacity:0,delay:0.2,onComplete:function onComplete(){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(_this6.refs.glint3,{x:0});}});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(this.refs.glint2,0.2,{x:275,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut,opacity:0,delay:0.1,onComplete:function onComplete(){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(_this6.refs.glint2,{x:0});}});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(this.refs.glint1,0.3,{x:275,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut,opacity:0,onComplete:function onComplete(){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(_this6.refs.glint1,{x:0});}});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(this.getRandomArbitrary(2,5),function(){return _this6.animateGlints();});}},{key:"getImagesToLoad",value:function getImagesToLoad(){var _this7=this;var imageArray=[];for(var property in __WEBPACK_IMPORTED_MODULE_7__Images_js__){imageArray.push(__WEBPACK_IMPORTED_MODULE_7__Images_js__[property]);}this.setState({imageArray:imageArray},function(){return _this7.loadAllAssets();});}},{key:"isDone",value:function isDone(){if(this.state.imageArray.length===this.state.successCount+this.state.errorCount){this.setState({assetsLoaded:true,startScreenReady:true});this.props.gameMusic('soundscape');// console.log('assets loaded!');
return true;}return false;}},{key:"loadAllAssets",value:function loadAllAssets(){var _this8=this;// console.log('loadAllAssets!');
var path="";var img=null;return new Promise(function(resolve){if(_this8.state.imageArray.length===0&&_this8.state.soundQueue.length===0){resolve();}for(var i=0;i<_this8.state.imageArray.length;i++){path=_this8.state.imageArray[i];img=new Image();img.addEventListener("load",function(e){_this8.setState({successCount:_this8.state.successCount+1},function(){if(_this8.isDone())resolve();});},false);img.addEventListener("error",function(error){_this8.assetLoaderErrorLog.push({assetType:"image",description:"Could not load image. The provided url may be invalid.",url:error.currentTarget.src});_this8.setState({errorCount:_this8.state.errorCount+1},function(){if(_this8.isDone())resolve();});},false);img.src=path;_this8.cache[path]=img;}});}},{key:"animateOut",value:function animateOut(play){var _this9=this;this.props.playSndFx('introClick');this.out=true;__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].killAll(true,true,true,true);__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(this.refs.bottom,0.5,{autoAlpha:0});var flames=this.refs.flames.childNodes;__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.forEach(flames,function(flame,index){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(flame,0.25,{delay:index*0.01+0.15,autoAlpha:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut,transformOrigin:"50% 50%"});});var logo=[this.refs.triangle,this.refs.rage,this.refs.click];__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.forEach(logo,function(el,index){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(el,0.25,{scaleX:0,scaleY:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeIn,delay:0.15*index,opacity:0,transformOrigin:"50% 50%",y:50});});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(this.refs.startscreen,0.3,{delay:0.55,autoAlpha:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeIn});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(1.6,function(){__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].killAll(true,true,true);_this9.props.deletePlaybackToken();if(play)_this9.props.router.push("/intro");// else this.props.router.push("/scores")
});}},{key:"quickJump",value:function quickJump(destination){this.out=true;__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].killAll(true,true,true,true);this.props.router.push(destination);}},{key:"waitForLogo",value:function waitForLogo(){var _this10=this;__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].delayedCall(5,function(){return _this10.animateLogo();});}},{key:"render",value:function render(){var _this11=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"startscreen",ref:"startscreen"},this.props.showDebug&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"debugMenu"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(e){return _this11.quickJump("/intro");}},"Intro"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(e){return _this11.quickJump("/play");}},"GamePlay"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(e){return _this11.quickJump("/win");}},"WinScreen"))),this.props.audioSet!==true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AudioNotice__["a" /* default */],{callback:this.startAnimation,startScreenReady:this.state.startScreenReady,successCount:this.state.successCount,imageCount:this.state.imageArray.length}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"animatedBg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__hud_Hud__["a" /* default */],{hideScore:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"start_screen",width:"100%",height:"100%",x:"0px",y:"0px",viewBox:"0 0 1024 768",enableBackground:"new 0 0 1024 768",preserveAspectRatio:"xMidYMin slice"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"SOLID",ref:"sky",fill:"#000000",width:"1024",height:"768"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"ground",y:"350",width:"1024",height:"418"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"back"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"494.613,323.607 435.542,332.629 430.064,303.216 489.603,295.198 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"494.613,323.607 509.08,350.786 513.697,340.382 495.154,311.107 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"435.542,332.629 411.668,343.539 415.355,377.305 439.456,364.811 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"439.456,364.811 509.08,350.786 519.378,385.292 442.52,403.913 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"509.08,350.786 493.972,354.568 494.613,323.607 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"494.613,323.607 493.972,354.568 439.456,364.811 435.542,332.629 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"383.947,320.545 434.174,334.303 441.621,305.325 390.859,292.538 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"383.947,320.545 367.681,346.688 359.076,326.163 379.55,298.204 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"434.174,334.303 443.159,316.469 433.755,361.247 428.1,366.147 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"428.1,366.147 367.681,346.688 355.081,380.421 422.408,404.954 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"367.681,346.688 382.499,351.479 383.947,320.545 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"383.947,320.545 382.499,351.479 428.1,366.147 434.174,334.303 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"358.099,326.903 310.227,326.335 309.731,302.37 357.842,303.793 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"358.099,326.903 365.992,350.275 370.997,342.652 360.156,317.093 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"310.227,326.335 289.933,331.847 288.446,359.02 309.126,352.285 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"309.126,352.285 365.992,350.275 369.634,378.894 306.451,383.594 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"365.992,350.275 353.556,351.295 358.099,326.903 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"358.099,326.903 353.556,351.295 309.126,352.285 310.227,326.335 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"262.18,366.381 262.001,399.972 294.257,361.184 296.445,333.142 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"262.18,366.381 217.982,343.308 222.116,373.812 262.001,399.972 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"296.445,333.142 257.579,316.869 271.295,290.324 311.038,305.686 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"257.579,316.869 217.982,343.308 201.261,319.971 243.081,296.634 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"296.445,333.142 262.18,366.381 274.308,360.982 303.972,330.642 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#181610",d:"M262.18,366.381c-0.56-0.022-44.198-23.073-44.198-23.073l-22.586-6.371l54.444,29.65L262.18,366.381z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"257.579,316.869 258.883,348.137 247.182,358.663 217.982,343.308 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"258.883,348.137 273.812,355.096 296.445,333.142 257.579,316.869 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"258.883,348.137 247.182,358.663 262.18,366.381 273.812,355.096 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"215.563,322.913 155.811,322.204 155.192,292.291 215.243,294.068 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"215.563,322.913 225.415,352.084 231.663,342.57 218.131,310.668 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"155.811,322.204 130.481,329.084 128.624,363 154.437,354.593 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"154.437,354.593 225.415,352.084 229.962,387.806 151.098,393.673 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"225.415,352.084 209.893,353.358 215.563,322.913 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"215.563,322.913 209.893,353.358 154.437,354.593 155.811,322.204 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"58.117,368.944 55.093,405.383 -4.237,388.785 -3.996,355.516 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"58.117,368.944 72.729,327.97 69.119,359.542 55.093,405.383 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"72.729,327.97 76.625,302.894 24.789,295.19 21.197,319.497 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"21.197,319.497 -3.996,355.516 -28.808,340.147 0.41,305.071 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"72.729,327.97 58.117,368.944 66.31,363.335 80.036,321.076 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"58.117,368.944 -3.996,355.516 -16.188,355.652 55.347,371.801 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"72.729,327.97 61.751,358.756 23.533,349.863 21.197,319.497 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"21.197,319.497 23.533,349.863 17.284,360.115 -3.996,355.516 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"23.533,349.863 61.751,358.756 58.117,368.944 17.284,360.115 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"644.307,361.12 640.52,406.758 566.212,385.97 566.513,344.303 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"644.307,361.12 662.606,309.803 658.085,349.345 640.52,406.758 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"662.606,309.803 667.486,278.397 602.565,268.748 598.066,299.192 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"598.066,299.192 566.513,344.303 535.438,325.054 572.032,281.124 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"662.606,309.803 644.307,361.12 654.568,354.096 671.758,301.169 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"644.307,361.12 566.513,344.303 551.244,344.473 640.837,364.699 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"662.606,309.803 648.858,348.361 600.993,337.222 598.066,299.192 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"598.066,299.192 600.993,337.222 593.165,350.063 566.513,344.303 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"600.993,337.222 648.858,348.361 644.307,361.12 593.165,350.063 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"827.969,322.101 768.218,321.392 767.598,291.479 827.649,293.255 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"827.969,322.101 837.821,351.272 844.069,341.758 830.537,309.856 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"768.218,321.392 742.887,328.271 741.03,362.187 766.843,353.781 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"766.843,353.781 837.821,351.272 842.368,386.993 763.504,392.861 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"837.821,351.272 822.3,352.546 827.969,322.101 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"827.969,322.101 822.3,352.546 766.843,353.781 768.218,321.392 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"100.244,366.055 100.065,399.646 132.321,360.858 134.509,332.816 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"100.244,366.055 56.046,342.982 60.18,373.486 100.065,399.646 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"134.509,332.816 95.643,316.543 109.359,289.998 149.102,305.36 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"95.643,316.543 56.046,342.982 39.325,319.645 81.145,296.308 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"134.509,332.816 100.244,366.055 112.372,360.656 142.036,330.315 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#181610",d:"M100.244,366.055c-0.56-0.022-44.198-23.073-44.198-23.073l-22.586-6.371l54.444,29.65L100.244,366.055z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"95.643,316.543 96.947,347.81 85.246,358.337 56.046,342.982 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"96.947,347.81 111.876,354.77 134.509,332.816 95.643,316.543 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"96.947,347.81 85.246,358.337 100.244,366.055 111.876,354.77 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"674.972,509.948 675.065,545.355 733.62,533.936 735.967,501.804 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"674.972,509.948 664.046,469.266 665.082,500.02 675.065,545.355 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"664.046,469.266 662.23,444.759 712.861,441.343 714.443,465.084 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"714.443,465.084 735.967,501.804 761.108,488.893 735.627,452.771 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"664.046,469.266 674.972,509.948 667.498,503.899 657.528,462.045 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"674.972,509.948 735.967,501.804 747.725,502.881 677.425,512.921 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"664.046,469.266 672.255,499.833 709.833,494.213 714.443,465.084 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"714.443,465.084 709.833,494.213 715.07,504.594 735.967,501.804 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"709.833,494.213 672.255,499.833 674.972,509.948 715.07,504.594 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"172.5,413.8 222.727,427.558 230.175,398.58 179.413,385.793 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"172.5,413.8 156.234,439.943 147.63,419.418 168.103,391.459 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"222.727,427.558 231.713,409.724 222.308,454.502 216.653,459.403 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"216.653,459.403 156.234,439.943 143.634,473.676 210.962,498.21 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"156.234,439.943 171.053,444.734 172.5,413.8 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"172.5,413.8 171.053,444.734 216.653,459.403 222.727,427.558 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"637.17,466.494 577.418,465.785 576.799,435.872 636.85,437.648 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"637.17,466.494 647.022,495.665 653.27,486.151 639.738,454.249 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"577.418,465.785 552.088,472.665 550.231,506.581 576.044,498.174 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"576.044,498.174 647.022,495.665 651.569,531.387 572.705,537.254 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"647.022,495.665 631.5,496.939 637.17,466.494 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"637.17,466.494 631.5,496.939 576.044,498.174 577.418,465.785 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"118.929,464.537 118.75,498.127 151.006,459.34 153.193,431.298 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"118.929,464.537 74.731,441.464 78.865,471.967 118.75,498.127 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"153.193,431.298 114.328,415.025 128.044,388.48 167.786,403.842 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"114.328,415.025 74.731,441.464 58.01,418.126 99.83,394.79 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"153.193,431.298 118.929,464.537 131.057,459.137 160.721,428.797 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#181610",d:"M118.929,464.537c-0.56-0.022-44.198-23.073-44.198-23.073l-22.586-6.371l54.444,29.65L118.929,464.537z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"114.328,415.025 115.631,446.292 103.931,456.819 74.731,441.464 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"115.631,446.292 130.561,453.252 153.193,431.298 114.328,415.025 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"115.631,446.292 103.931,456.819 118.929,464.537 130.561,453.252 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"871.216,393.296 871.309,428.702 929.864,417.283 932.212,385.151 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"871.216,393.296 860.291,352.613 861.326,383.367 871.309,428.702 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"860.291,352.613 858.474,328.106 909.106,324.69 910.688,348.431 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"910.688,348.431 932.212,385.151 957.353,372.241 931.871,336.118 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"860.291,352.613 871.216,393.296 863.743,387.247 853.772,345.392 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"871.216,393.296 932.212,385.151 943.969,386.228 873.669,396.268 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"860.291,352.613 868.499,383.18 906.078,377.56 910.688,348.431 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"910.688,348.431 906.078,377.56 911.315,387.941 932.212,385.151 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"906.078,377.56 868.499,383.18 871.216,393.296 911.315,387.941 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"588.751,345.148 638.978,358.906 646.426,329.928 595.663,317.141 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"588.751,345.148 572.485,371.291 563.881,350.767 584.354,322.808 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"638.978,358.906 647.964,341.072 638.559,385.85 632.904,390.751 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"632.904,390.751 572.485,371.291 559.885,405.024 627.213,429.558 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"572.485,371.291 587.304,376.082 588.751,345.148 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"588.751,345.148 587.304,376.082 632.904,390.751 638.978,358.906 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"819.934,378.993 760.182,378.284 759.563,348.371 819.613,350.147 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"819.934,378.993 829.785,408.164 836.034,398.65 822.501,366.748 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"760.182,378.284 734.851,385.164 732.995,419.08 758.808,410.673 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"758.808,410.673 829.785,408.164 834.332,443.886 755.468,449.753 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"829.785,408.164 814.264,409.438 819.934,378.993 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"819.934,378.993 814.264,409.438 758.808,410.673 760.182,378.284 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"724.137,373.753 721.113,410.191 661.783,393.594 662.024,360.325 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"724.137,373.753 738.748,332.779 735.138,364.351 721.113,410.191 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"738.748,332.779 742.645,307.702 690.809,299.999 687.217,324.306 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"687.217,324.306 662.024,360.325 637.212,344.955 666.429,309.88 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"738.748,332.779 724.137,373.753 732.33,368.144 746.056,325.885 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"724.137,373.753 662.024,360.325 649.831,360.461 721.366,376.61 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"738.748,332.779 727.771,363.565 689.553,354.671 687.217,324.306 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"687.217,324.306 689.553,354.671 683.304,364.924 662.024,360.325 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"689.553,354.671 727.771,363.565 724.137,373.753 683.304,364.924 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"970.125,464.521 967.101,500.959 907.771,484.362 908.011,451.093 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"970.125,464.521 984.736,423.547 981.126,455.119 967.101,500.959 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"984.736,423.547 988.632,398.47 936.796,390.767 933.204,415.074 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"933.204,415.074 908.011,451.093 883.2,435.723 912.417,400.648 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"984.736,423.547 970.125,464.521 978.318,458.912 992.043,416.653 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"970.125,464.521 908.011,451.093 895.819,451.229 967.354,467.378 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"984.736,423.547 973.758,454.333 935.541,445.439 933.204,415.074 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"933.204,415.074 935.541,445.439 929.291,455.692 908.011,451.093 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"935.541,445.439 973.758,454.333 970.125,464.521 929.291,455.692 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"810.049,446.136 860.276,459.894 867.723,430.916 816.961,418.129 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"810.049,446.136 793.783,472.279 785.178,451.755 805.652,423.796 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"860.276,459.894 869.261,442.06 859.857,486.838 854.202,491.739 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"854.202,491.739 793.783,472.279 781.183,506.012 848.51,530.546 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"793.783,472.279 808.601,477.07 810.049,446.136 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"810.049,446.136 808.601,477.07 854.202,491.739 860.276,459.894 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"280.753,493.454 280.846,528.86 339.401,517.441 341.749,485.309 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"280.753,493.454 269.828,452.771 270.864,483.525 280.846,528.86 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"269.828,452.771 268.012,428.264 318.643,424.849 320.225,448.59 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"320.225,448.59 341.749,485.309 366.89,472.399 341.408,436.277 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"269.828,452.771 280.753,493.454 273.28,487.405 263.309,445.55 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"280.753,493.454 341.749,485.309 353.507,486.386 283.206,496.427 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"269.828,452.771 278.036,483.338 315.615,477.718 320.225,448.59 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"320.225,448.59 315.615,477.718 320.852,488.099 341.749,485.309 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"315.615,477.718 278.036,483.338 280.753,493.454 320.852,488.099 \t\t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"479.063,402.19 479.156,437.597 537.71,426.177 540.058,394.046 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"479.063,402.19 468.137,361.508 469.173,392.262 479.156,437.597 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"468.137,361.508 466.321,337.001 516.952,333.585 518.534,357.326 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"518.534,357.326 540.058,394.046 565.199,381.135 539.718,345.013 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"468.137,361.508 479.063,402.19 471.589,396.141 461.618,354.287 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"479.063,402.19 540.058,394.046 551.816,395.123 481.515,405.163 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"468.137,361.508 476.346,392.075 513.924,386.454 518.534,357.326 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"518.534,357.326 513.924,386.454 519.161,396.835 540.058,394.046 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"513.924,386.454 476.346,392.075 479.063,402.19 519.161,396.835 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"360.235,402.929 300.483,402.22 299.864,372.307 359.915,374.084 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"360.235,402.929 370.087,432.101 376.335,422.586 362.803,390.684 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"300.483,402.22 275.153,409.1 273.296,443.016 299.109,434.61 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"299.109,434.61 370.087,432.101 374.634,467.822 295.769,473.689 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"370.087,432.101 354.565,433.374 360.235,402.929 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"360.235,402.929 354.565,433.374 299.109,434.61 300.483,402.22 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"66.9,429.482 63.876,465.92 4.546,449.323 4.787,416.053 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"66.9,429.482 81.511,388.508 77.902,420.08 63.876,465.92 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"81.511,388.508 85.408,363.431 33.572,355.728 29.98,380.035 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"29.98,380.035 4.787,416.053 -20.025,400.684 9.193,365.609 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"81.511,388.508 66.9,429.482 75.093,423.873 88.819,381.614 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"66.9,429.482 4.787,416.053 -7.405,416.189 64.13,432.339 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"81.511,388.508 70.534,419.293 32.316,410.4 29.98,380.035 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"29.98,380.035 32.316,410.4 26.067,420.653 4.787,416.053 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"32.316,410.4 70.534,419.293 66.9,429.482 26.067,420.653 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"623.706,457.906 619.918,503.544 545.611,482.756 545.912,441.089 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"623.706,457.906 642.005,406.589 637.484,446.131 619.918,503.544 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"642.005,406.589 646.885,375.183 581.964,365.534 577.465,395.978 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"577.465,395.978 545.912,441.089 514.837,421.84 551.43,377.909 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"642.005,406.589 623.706,457.906 633.967,450.882 651.157,397.955 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"623.706,457.906 545.912,441.089 530.642,441.259 620.235,461.485 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"642.005,406.589 628.256,445.146 580.391,434.008 577.465,395.978 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"577.465,395.978 580.391,434.008 572.564,446.849 545.912,441.089 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"580.391,434.008 628.256,445.146 623.706,457.906 572.564,446.849 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"235.341,383.024 285.568,396.782 293.015,367.805 242.253,355.017 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"235.341,383.024 219.075,409.167 210.47,388.643 230.944,360.684 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"285.568,396.782 294.553,378.948 285.149,423.726 279.494,428.627 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"279.494,428.627 219.075,409.167 206.475,442.9 273.802,467.434 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"219.075,409.167 233.893,413.959 235.341,383.024 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"235.341,383.024 233.893,413.959 279.494,428.627 285.568,396.782 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"849.835,415.713 849.928,451.12 908.482,439.701 910.83,407.569 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"849.835,415.713 838.909,375.031 839.945,405.785 849.928,451.12 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"838.909,375.031 837.093,350.524 887.724,347.108 889.306,370.849 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"889.306,370.849 910.83,407.569 935.971,394.658 910.49,358.536 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"838.909,375.031 849.835,415.713 842.361,409.664 832.39,367.81 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"849.835,415.713 910.83,407.569 922.588,408.646 852.287,418.686 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"838.909,375.031 847.118,405.598 884.696,399.978 889.306,370.849 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"889.306,370.849 884.696,399.978 889.933,410.359 910.83,407.569 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"884.696,399.978 847.118,405.598 849.835,415.713 889.933,410.359 \t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"510.711,317.812 560.938,331.57 568.386,302.592 517.623,289.805 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"510.711,317.812 494.445,343.955 485.84,323.43 506.314,295.471 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"560.938,331.57 569.924,313.736 560.519,358.514 554.864,363.414 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"554.864,363.414 494.445,343.955 481.845,377.688 549.173,402.221 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"494.445,343.955 509.263,348.746 510.711,317.812 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"510.711,317.812 509.263,348.746 554.864,363.414 560.938,331.57 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"692.646,433.186 689.622,469.625 630.292,453.028 630.532,419.758 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"692.646,433.186 707.257,392.212 703.647,423.784 689.622,469.625 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"707.257,392.212 711.153,367.136 659.317,359.432 655.725,383.74 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"655.725,383.74 630.532,419.758 605.721,404.389 634.938,369.313 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"707.257,392.212 692.646,433.186 700.839,427.578 714.565,385.319 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"692.646,433.186 630.532,419.758 618.34,419.894 689.875,436.044 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"707.257,392.212 696.279,422.998 658.062,414.105 655.725,383.74 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"655.725,383.74 658.062,414.105 651.812,424.358 630.532,419.758 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"658.062,414.105 696.279,422.998 692.646,433.186 651.812,424.358 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{display:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",points:"286.031,305.698 287.198,339.269 317.874,299.22 318.936,271.113 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#0C0A07",points:"286.031,305.698 240.944,284.415 246.297,314.728 287.198,339.269 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#181610",points:"318.936,271.113 279.45,256.41 292.091,229.337 332.417,243.094 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#181610",points:"279.45,256.41 240.944,284.415 223.301,261.766 264.152,236.772 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#181610",points:"318.936,271.113 286.031,305.698 297.933,299.817 326.357,268.312 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{display:"inline",fill:"#181610",d:"M286.031,305.698c-0.56,0-45.087-21.283-45.087-21.283l-22.824-5.461l55.589,27.444 L286.031,305.698z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#0C0A07",points:"279.45,256.41 282.005,287.6 270.736,298.587 240.944,284.415 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",points:"282.005,287.6 297.201,293.956 318.936,271.113 279.45,256.41 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#241B0D",points:"282.005,287.6 270.736,298.587 286.031,305.698 297.201,293.956 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"977.658,350.877 1027.885,364.635 1035.333,335.657 984.571,322.87 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"977.658,350.877 961.393,377.02 952.788,356.496 973.261,328.537 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"1027.885,364.635 1036.871,346.801 1027.466,391.579 1021.811,396.48 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"1021.811,396.48 961.393,377.02 948.792,410.753 1016.12,435.287 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"961.393,377.02 976.211,381.811 977.658,350.877 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"977.658,350.877 976.211,381.811 1021.811,396.48 1027.885,364.635 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"465.043,426.765 465.136,462.172 523.69,450.753 526.038,418.621 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"465.043,426.765 454.117,386.083 455.153,416.837 465.136,462.172 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"454.117,386.083 452.301,361.576 502.932,358.16 504.514,381.901 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"504.514,381.901 526.038,418.621 551.179,405.71 525.698,369.588 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"454.117,386.083 465.043,426.765 457.569,420.716 447.598,378.862 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"465.043,426.765 526.038,418.621 537.796,419.698 467.496,429.738 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"454.117,386.083 462.326,416.65 499.904,411.03 504.514,381.901 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"504.514,381.901 499.904,411.03 505.141,421.411 526.038,418.621 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"499.904,411.03 462.326,416.65 465.043,426.765 505.141,421.411 \t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"mid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"657.101,653.183 659.535,710.139 753.001,687.99 754.704,636.145 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"657.101,653.183 636.898,588.439 640.549,637.849 659.535,710.139 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"636.898,588.439 632.395,549.13 713.63,540.367 717.707,578.459 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"717.707,578.459 754.704,636.145 794.318,613.753 750.992,557.283 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"636.898,588.439 657.101,653.183 644.687,643.934 625.945,577.242 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"657.101,653.183 754.704,636.145 773.69,637.119 661.238,657.808 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"636.898,588.439 652.077,637.085 712.17,625.618 717.707,578.459 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"717.707,578.459 712.17,625.618 721.265,641.981 754.704,636.145 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"712.17,625.618 652.077,637.085 657.101,653.183 721.265,641.981 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"216.309,526.971 298.002,545.864 308.114,498.764 225.623,481.468 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"216.309,526.971 191.828,570.079 176.66,537.615 207.794,491.313 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"298.002,545.864 311.307,516.593 299.067,589.238 290.285,597.487 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"290.285,597.487 191.828,570.079 173.733,625.162 283.633,660.287 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"191.828,570.079 215.977,576.831 216.309,526.971 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"216.309,526.971 215.977,576.831 290.285,597.487 298.002,545.864 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"590.419,566.503 494.245,569.218 491.319,521.134 588.043,520.117 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"590.419,566.503 608.151,612.798 617.589,597.088 593.76,546.637 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"494.245,569.218 453.937,581.921 453.139,636.604 494.124,621.415 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"494.124,621.415 608.151,612.798 617.771,669.973 491.273,684.502 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"608.151,612.798 583.262,615.848 590.419,566.503 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"590.419,566.503 583.262,615.848 494.124,621.415 494.245,569.218 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"89.768,589.803 91.647,643.856 141.038,579.373 142.748,534.118 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"89.768,589.803 17.174,555.535 25.792,604.343 91.647,643.856 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"142.748,534.118 79.172,510.446 99.525,466.855 164.454,489.005 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"79.172,510.446 17.174,555.535 -11.233,519.069 54.541,478.827 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"142.748,534.118 89.768,589.803 108.931,580.334 154.696,529.609 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262015",d:"M89.768,589.803c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L89.768,589.803z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"79.172,510.446 83.286,560.664 65.141,578.355 17.174,555.535 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"83.286,560.664 107.753,570.897 142.748,534.118 79.172,510.446 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"83.286,560.664 65.141,578.355 89.768,589.803 107.753,570.897 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"921.297,505.271 923.731,562.227 1017.197,540.077 1018.901,488.233 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"921.297,505.271 901.095,440.526 904.746,489.936 923.731,562.227 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"901.095,440.526 896.592,401.217 977.827,392.454 981.904,430.547 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"981.904,430.547 1018.901,488.233 1058.514,465.84 1015.189,409.371 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"901.095,440.526 921.297,505.271 908.884,496.021 890.142,429.33 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"921.297,505.271 1018.901,488.233 1037.886,489.206 925.435,509.895 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"901.095,440.526 916.273,489.172 976.367,477.705 981.904,430.547 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"981.904,430.547 976.367,477.705 985.462,494.068 1018.901,488.233 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"976.367,477.705 916.273,489.172 921.297,505.271 985.462,494.068 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"141.717,571.094 144.151,628.05 237.617,605.901 239.321,554.056 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"141.717,571.094 121.515,506.349 125.166,555.76 144.151,628.05 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"121.515,506.349 117.012,467.04 198.247,458.278 202.324,496.37 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"202.324,496.37 239.321,554.056 278.934,531.663 235.609,475.194 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"121.515,506.349 141.717,571.094 129.304,561.845 110.562,495.153 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"141.717,571.094 239.321,554.056 258.306,555.03 145.855,575.719 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"121.515,506.349 136.693,554.995 196.787,543.529 202.324,496.37 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"202.324,496.37 196.787,543.529 205.882,559.892 239.321,554.056 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"196.787,543.529 136.693,554.995 141.717,571.094 205.882,559.892 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"-27.592,556.21 -25.158,613.166 68.308,591.016 70.012,539.172 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"-27.592,556.21 -47.794,491.465 -44.143,540.876 -25.158,613.166 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"-47.794,491.465 -52.297,452.156 28.938,443.393 33.015,481.486 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"33.015,481.486 70.012,539.172 109.625,516.779 66.3,460.31 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"-47.794,491.465 -27.592,556.21 -40.005,546.961 -58.747,480.269 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"-27.592,556.21 70.012,539.172 88.997,540.145 -23.454,560.834 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"-47.794,491.465 -32.616,540.111 27.477,528.645 33.015,481.486 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"33.015,481.486 27.477,528.645 36.573,545.008 70.012,539.172 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"27.477,528.645 -32.616,540.111 -27.592,556.21 36.573,545.008 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"497.251,433.944 578.944,452.837 589.056,405.737 506.564,388.441 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"497.251,433.944 472.77,477.052 457.602,444.588 488.736,398.286 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"578.944,452.837 592.249,423.566 580.008,496.211 571.227,504.461 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"571.227,504.461 472.77,477.052 454.675,532.135 564.574,567.26 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"472.77,477.052 496.918,483.804 497.251,433.944 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"497.251,433.944 496.918,483.804 571.227,504.461 578.944,452.837 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"878.803,413.939 782.629,416.654 779.703,368.569 876.426,367.553 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"878.803,413.939 896.535,460.234 905.973,444.524 882.143,394.073 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"782.629,416.654 742.321,429.356 741.523,484.04 782.508,468.851 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"782.508,468.851 896.535,460.234 906.155,517.409 779.657,531.937 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"896.535,460.234 871.646,463.284 878.803,413.939 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"878.803,413.939 871.646,463.284 782.508,468.851 782.629,416.654 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"912.292,490.686 816.118,493.401 813.192,445.317 909.916,444.3 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"912.292,490.686 930.024,536.981 939.463,521.271 915.633,470.82 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"816.118,493.401 775.811,506.104 775.012,560.787 815.998,545.598 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"815.998,545.598 930.024,536.981 939.644,594.156 813.146,608.685 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"930.024,536.981 905.136,540.031 912.292,490.686 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"912.292,490.686 905.136,540.031 815.998,545.598 816.118,493.401 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"746.674,453.552 744.16,512.37 647.639,489.496 645.879,435.957 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"746.674,453.552 767.537,386.691 763.766,437.716 744.16,512.37 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"767.537,386.691 772.187,346.096 688.296,337.048 684.086,376.385 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"684.086,376.385 645.879,435.957 604.971,412.832 649.713,354.517 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"767.537,386.691 746.674,453.552 759.493,444 778.848,375.128 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"746.674,453.552 645.879,435.957 626.273,436.962 742.401,458.328 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"767.537,386.691 751.862,436.927 689.804,425.086 684.086,376.385 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"684.086,376.385 689.804,425.086 680.411,441.984 645.879,435.957 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"689.804,425.086 751.862,436.927 746.674,453.552 680.411,441.984 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"994.126,636.815 991.612,695.633 895.091,672.759 893.331,619.22 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"994.126,636.815 1014.988,569.954 1011.218,620.979 991.612,695.633 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"1014.988,569.954 1019.638,529.359 935.748,520.311 931.537,559.648 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"931.537,559.648 893.331,619.22 852.423,596.095 897.164,537.78 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"1014.988,569.954 994.126,636.815 1006.945,627.263 1026.299,558.391 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"994.126,636.815 893.331,619.22 873.725,620.225 989.852,641.591 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"1014.988,569.954 999.314,620.19 937.256,608.349 931.537,559.648 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"931.537,559.648 937.256,608.349 927.863,625.247 893.331,619.22 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"937.256,608.349 999.314,620.19 994.126,636.815 927.863,625.247 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"350.846,468.29 352.726,522.343 402.117,457.86 403.827,412.605 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"350.846,468.29 278.252,434.022 286.871,482.83 352.726,522.343 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"403.827,412.605 340.25,388.933 360.604,345.342 425.532,367.492 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"340.25,388.933 278.252,434.022 249.846,397.556 315.62,357.314 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"403.827,412.605 350.846,468.29 370.009,458.821 415.775,408.096 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262015",d:"M350.846,468.29c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L350.846,468.29z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"340.25,388.933 344.365,439.151 326.22,456.842 278.252,434.022 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"344.365,439.151 368.832,449.385 403.827,412.605 340.25,388.933 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"344.365,439.151 326.22,456.842 350.846,468.29 368.832,449.385 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"638.3,502.71 640.179,556.763 689.571,492.28 691.28,447.025 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"638.3,502.71 565.706,468.442 574.325,517.25 640.179,556.763 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"691.28,447.025 627.704,423.353 648.057,379.762 712.986,401.912 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"627.704,423.353 565.706,468.442 537.299,431.976 603.074,391.734 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"691.28,447.025 638.3,502.71 657.463,493.241 703.229,442.516 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262015",d:"M638.3,502.71c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L638.3,502.71z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"627.704,423.353 631.818,473.571 613.673,491.262 565.706,468.442 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"631.818,473.571 656.285,483.805 691.28,447.025 627.704,423.353 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"631.818,473.571 613.673,491.262 638.3,502.71 656.285,483.805 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"765.281,534.107 767.161,588.159 816.552,523.676 818.262,478.421 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"765.281,534.107 692.687,499.839 701.306,548.646 767.161,588.159 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"818.262,478.421 754.685,454.749 775.039,411.158 839.967,433.309 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"754.685,454.749 692.687,499.839 664.281,463.373 730.055,423.13 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"818.262,478.421 765.281,534.107 784.445,524.638 830.21,473.912 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262015",d:"M765.281,534.107c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L765.281,534.107z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"754.685,454.749 758.8,504.968 740.655,522.658 692.687,499.839 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"758.8,504.968 783.267,515.201 818.262,478.421 754.685,454.749 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"758.8,504.968 740.655,522.658 765.281,534.107 783.267,515.201 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"1056.068,574.11 1057.948,628.162 1107.339,563.679 1109.048,518.425 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"1056.068,574.11 983.474,539.842 992.093,588.649 1057.948,628.162 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"1109.048,518.425 1045.472,494.753 1065.825,451.162 1130.754,473.312 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"1045.472,494.753 983.474,539.842 955.068,503.376 1020.842,463.134 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"1109.048,518.425 1056.068,574.11 1075.231,564.641 1120.997,513.916 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262015",d:"M1056.068,574.11c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L1056.068,574.11z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"1045.472,494.753 1049.587,544.971 1031.442,562.662 983.474,539.842 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"1049.587,544.971 1074.054,555.204 1109.048,518.425 1045.472,494.753 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"1049.587,544.971 1031.442,562.662 1056.068,574.11 1074.054,555.204 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"209.939,394.403 113.765,397.118 110.839,349.034 207.563,348.017 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"209.939,394.403 227.671,440.698 237.109,424.988 213.28,374.538 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"113.765,397.118 73.457,409.821 72.659,464.504 113.644,449.315 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"113.644,449.315 227.671,440.698 237.291,497.873 110.793,512.402 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"227.671,440.698 202.782,443.749 209.939,394.403 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"209.939,394.403 202.782,443.749 113.644,449.315 113.765,397.118 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"435.964,564.254 433.45,623.072 336.929,600.198 335.169,546.659 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"435.964,564.254 456.827,497.393 453.056,548.418 433.45,623.072 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"456.827,497.393 461.477,456.798 377.586,447.75 373.376,487.087 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"373.376,487.087 335.169,546.659 294.261,523.534 339.003,465.219 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"456.827,497.393 435.964,564.254 448.783,554.702 468.138,485.83 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"435.964,564.254 335.169,546.659 315.563,547.664 431.691,569.03 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"456.827,497.393 441.152,547.629 379.094,535.788 373.376,487.087 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"373.376,487.087 379.094,535.788 369.702,552.686 335.169,546.659 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"379.094,535.788 441.152,547.629 435.964,564.254 369.702,552.686 \t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"front"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"712.282,748.881 715.692,828.673 846.632,797.643 849.019,725.012 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"712.282,748.881 683.98,658.178 689.094,727.399 715.692,828.673 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"683.98,658.178 677.671,603.108 791.477,590.833 797.188,644.198 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"797.188,644.198 849.019,725.012 904.515,693.641 843.819,614.531 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"683.98,658.178 712.282,748.881 694.891,735.924 668.635,642.493 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"712.282,748.881 849.019,725.012 875.616,726.376 718.079,755.36 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"683.98,658.178 705.244,726.328 789.431,710.264 797.188,644.198 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"797.188,644.198 789.431,710.264 802.173,733.188 849.019,725.012 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#594421",points:"789.431,710.264 705.244,726.328 712.282,748.881 802.173,733.188 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"174.726,670.864 289.173,697.332 303.339,631.348 187.773,607.117 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"174.726,670.864 140.429,731.256 119.18,685.776 162.796,620.91 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"289.173,697.332 307.812,656.325 290.664,758.097 278.362,769.654 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"278.362,769.654 140.429,731.256 115.079,808.424 269.042,857.632 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"140.429,731.256 174.26,740.716 174.726,670.864 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"174.726,670.864 174.26,740.716 278.362,769.654 289.173,697.332 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"618.865,627.447 484.132,631.251 480.032,563.888 615.536,562.464 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"618.865,627.447 643.707,692.304 656.929,670.296 623.545,599.617 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"484.132,631.251 427.663,649.047 426.545,725.655 483.962,704.375 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"483.962,704.375 643.707,692.304 657.184,772.403 479.968,792.756 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"643.707,692.304 608.839,696.577 618.865,627.447 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"618.865,627.447 608.839,696.577 483.962,704.375 484.132,631.251 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"33.767,784.746 36.401,860.47 105.595,770.133 107.989,706.734 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"33.767,784.746 -67.932,736.738 -55.858,805.114 36.401,860.47 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"107.989,706.734 18.923,673.571 47.437,612.503 138.398,643.534 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"18.923,673.571 -67.932,736.738 -107.728,685.652 -15.582,629.275 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"107.989,706.734 33.767,784.746 60.614,771.481 124.729,700.417 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#494232",d:"M33.767,784.746c-1.263,0-101.7-48.007-101.7-48.007l-51.482-12.318L5.974,786.325L33.767,784.746z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"18.923,673.571 24.687,743.924 -0.733,768.707 -67.932,736.738 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"24.687,743.924 58.964,758.26 107.989,706.734 18.923,673.571 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#594421",points:"24.687,743.924 -0.733,768.707 33.767,784.746 58.964,758.26 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"697.971,609.134 825.708,638.676 841.519,565.029 712.534,537.984 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"697.971,609.134 659.692,676.539 635.975,625.777 684.657,553.379 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"825.708,638.676 846.512,592.907 827.373,706.497 813.642,719.396 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"813.642,719.396 659.692,676.539 631.398,762.668 803.24,817.591 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"659.692,676.539 697.451,687.097 697.971,609.134 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"697.971,609.134 697.451,687.097 813.642,719.396 825.708,638.676 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"440.277,836.726 436.756,919.126 301.535,887.082 299.07,812.077 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"440.277,836.726 469.505,743.058 464.223,814.542 436.756,919.126 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"469.505,743.058 476.019,686.188 358.494,673.511 352.595,728.62 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"352.595,728.62 299.07,812.077 241.76,779.68 304.441,697.984 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"469.505,743.058 440.277,836.726 458.236,823.345 485.351,726.86 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"440.277,836.726 299.07,812.077 271.604,813.485 434.291,843.417 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"469.505,743.058 447.546,813.436 360.606,796.847 352.595,728.62 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"352.595,728.62 360.606,796.847 347.448,820.52 299.07,812.077 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#594421",points:"360.606,796.847 447.546,813.436 440.277,836.726 347.448,820.52 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"1026.287,746.416 1022.766,828.816 887.545,796.772 885.08,721.767 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"1026.287,746.416 1055.514,652.748 1050.232,724.231 1022.766,828.816 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"1055.514,652.748 1062.029,595.878 944.503,583.201 938.605,638.31 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"938.605,638.31 885.08,721.766 827.77,689.37 890.45,607.674 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"1055.514,652.748 1026.287,746.416 1044.246,733.035 1071.361,636.549 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"1026.287,746.416 885.08,721.766 857.614,723.175 1020.301,753.107 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"1055.514,652.748 1033.555,723.126 946.616,706.537 938.605,638.31 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"938.605,638.31 946.616,706.537 933.458,730.209 885.08,721.767 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#594421",points:"946.616,706.537 1033.555,723.126 1026.287,746.416 933.458,730.209 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"400.489,717.376 395.785,827.448 215.155,784.642 211.862,684.449 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"400.489,717.376 439.531,592.252 432.476,687.742 395.785,827.448 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"439.531,592.252 448.234,516.284 291.241,499.35 283.361,572.966 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"283.361,572.966 211.862,684.449 135.306,641.173 219.035,532.042 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"439.531,592.252 400.489,717.376 424.479,699.502 460.699,570.614 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"400.489,717.376 211.862,684.449 175.171,686.331 392.492,726.314 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"439.531,592.252 410.198,686.265 294.063,664.105 283.362,572.966 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"283.362,572.966 294.063,664.105 276.485,695.727 211.862,684.449 \t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#594421",points:"294.063,664.105 410.198,686.265 400.489,717.376 276.485,695.727 \t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"lightning4",ref:"lightning4",fill:"#FF5910",d:"M745.8,309.5L751,299l15.6,0.6l12.2-11l14.4,8.7l-10,67.9l21.4,36.7l6.9,25.1l-4.5-25.8\tl-21-36.7l10.1-68.8l-16.5-10l0.4-12.1l25.6-19.7l2-0.6l7.5,18.7l-3.9,50l17.4,25l-15.4-25.3l4.3-49.8l-6-19.9l24.2-7.4l19.2,37.9\tl-13.2,22.8c0,0,2.2,8,2.4,7.1c0.1-0.9,0-6.8,0-6.8l13.5-20.5l35.6,23.3l7.1,34.7l-13.7,23.1l-7.3,37.6l7.3,26.3L879,442l9.8-11.8\tl-7.2-26.5l4-20.3l24.4,32l4.3,38.8l-2.2-40.1l-25.6-33.8l2.7-13.2l14.5-23.6l-8.2-37.7l-36.7-23.4l-19.2-39.3l31.4-29.8l32.9,36.6\tl38.9,3.2l27.2,31l-4.4,24.9l6.8-26l-28.7-32.6l-38.3-2.9L874,210.9l2.1-2.7l-10.8-36.6l21.3-16.1l3.5-23.4l20.4-13.3l-6.8-56.5\tL857,0h-9.1l51.3,64.3l6.5,52.7l-47.2,30.4l1.6,21.9l-16.8,4.4l-17.1,23.2l19.1-20.3l15.5-3.7l11.2,34.6l-35.3,34.1l-31.7,9\tL776.6,272l-0.2,14.8l-11.2,10.3l-15.7,0.5L745.8,309.5z M864.2,168.2l-0.9-18.7l23.7-15.4l-2.8,20.6L864.2,168.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"lightning3",ref:"lightning3",fill:"#FF5910",d:"M122.8,389.4l-6.2-30.8l31.7-41.8l48.5-5.9l39.6-48.7l41.8,36.4l-20.6,49.7L230,369.7\tl1.9,39.5l2.7-1.2l-1.7-36.8l25.5-19.7l17.1,25.9c0,0,0.2,7.5,0.4,8.6c0.2,1.1,2.5-9.1,2.5-9.1l-18.1-28L282,300l39.5,8.9l9,34\tl-30.4,20.7l1.8,13.2l2.7-1.2l-1.2-10.8l30.7-20.8l-9.9-37.4l-42.6-10.1L233.7,255l8.3-44l23.7,3.6l25.4,24.4l-23-28.2l-25.4-4.4\tL247,180l-33.3-22.8l3-14.1l-51.4-41.9L167,0h-5.8l-1,79.2c-6.6,7.4-28.6,32.3-28.3,32.8c0.4,0.7,9.9,33.1,9.9,33.1l0.4,19\tl13.6,13.4L145,163.4l-0.4-16.5l45.2,9l7.5,24l12.1,14.6l25.1,27l-5.4,34.2l4.9,4.2l-39,47.7l-48.4,6.7l-32.7,43.5L122.8,389.4z\t M201.7,181.5l36.3,19.1l-2.9,17.2l-24.2-25L201.7,181.5z M238.7,196.9L200,177.6l-7.8-24.2l-47.7-10.6l-9.8-31.3l25.5-27.8\tl-0.3,19.5l51.2,41.5L208,158l33.3,23.5L238.7,196.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"lightning2",ref:"lightning2",fill:"#FFA227",d:"M283.7,414.9L290,395l-28.3-41.3l-38.4-26.2l-31.9-61.4l30.5-41.3l19.1,11.8l16.4,35.7\tl-12.5-38.7l-20.5-13.4l11.9-28.5l-49.6-61.8L219,62.3l97.3-63l-14.8,0.3l-87.8,58l-34.4,72.5l21.4,26.9l-5.8,32.9l21.3,31.1\tl-30.7,44l1.6,4.5L129,304.8l-52.5-13.2l-52.9,30.7L21,360.2l5.2-35.3l50.2-29.2l53.5,13.1l60.4-34.3l28.6,53.9l-43.2,44l-59.6,14.9\tL88.3,434l8.8,38l-2.3,18.9l-49.4,33.7l-20.9,52.6l23.1-50l47-31.9l-3.7,29l-21.6,32.2l7.8,20.2l-4.8-19.3l21.6-31.9l7-53.5l-8-37\tl25-43.2l58.1-15.2l8.9,33.4c0,0-2.8,7.9-3.1,9.1c-0.2,1.2,6.3-8.4,6.3-8.4l-7.4-36.5l42.6-42l29,20.7l-16.9,23.9l-16.6,68.5\tl-32,26.7l34.5-25.6l17.2-68.6l18.4-21.7l2.4,1.7l25.4,37.7l-4.9,16.4l-26.5,6l-15.9,88.8c1-0.8,2-1.6,3-2.4\tc0.5-0.4,1.1-0.8,1.6-1.1l14.6-81.9l23.1-5.1l11.3,20.2l21.1,6.2l2.2,16.3l0.4-17.6l-20.8-7.6L283.7,414.9z M198.7,190l5.4-28.8\tl24.8,31.2l-9.6,24.5L198.7,190z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"lightning1",ref:"lightning1",fill:"#FFA227",d:"M1015,411.4l-66.8-35.8l-65.1,19.9L806,358.2l3.7-8.2l-26.8-40l15.9-48.7l6.7-25.6\tl-4.5-34.6l51.8-37.8l9.1,21l-5.3,24.1l9.4-24.8l-10.6-24.2c0,0-6.9-46.4-6.9-47.5c0.1-0.9-42.3-19.4-54.9-24.9L751.3,0l-8.6-0.4\tl57.2,118l-40.3,83l12,16L743,264.8l20.9,30.8L734.4,316l-12.6,49.1l17.7-45.7l27.9-18.4l36.2,50.7l-36.2,80.5l-47.8,37.7l5.5,31.5\tc1.6-0.3,3.3-0.2,4.6,0.5l-5.4-30.7l44.6-34.4l56.1,49.1l-6.5,45.9c0,0,8.9,11.5,8.5,10s-4.5-11.1-4.5-11.1l6.4-42.7l43.8,10\tl0.3,0.8c1.4-0.4,2.7-0.6,4.1-0.4l-1.6-3.9l-47.4-10.9L773,433.1l31.5-70.5l78.5,38.3l64.6-20.9l64.5,34.2l10.2,42.6L1015,411.4z\t M763.4,281.5l-12.1-17.8l28.3-49.1l-11.8-15l40.3-82.4l-11.9-24.5l48.5,20.1l5.9,45.3l-54,41.3l4.3,35.1L763.4,281.5z M766.4,285.9\tl34.7-45.5l-5.1,19.8L780.1,306L766.4,285.9z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"rc-logo",ref:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"Layer_1",x:"0px",y:"0px",viewBox:"0 0 1024 768",enableBackground:"new 0 0 1024 768",preserveAspectRatio:"xMidYMid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"flames",ref:"flames"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E70728",d:"M740.634,58.166c4.765,29.172-12.546,52.694-73.058,53.185c-60.512,0.491-87.273,52.905-91.797,99.46 c-4.524,46.554-43.567,72.721-88.961,63.46c-45.391-9.161-46.673-42.337-42.368-65.875c4.208-23.435,50.412-54.415,49.107-98.496 s-40.669-52.419-40.669-52.419s22.226,17.45,16.718,40.923s-34.239,43.132-86.486,45.679s-89.251,40.158-81.94,97.867 s-0.198,71.037-14.224,73.753c-14.026,2.716-29.153-18.245-16.012-50.848c-63.357,5.777-52.149,103.888-101.265,90.536 c-18.155-4.965-25.516-50.867-0.656-66.109s69.094-45.164,29.256-99.909c3.222,31.118-16.447,56.111-59.179,69.181 s-68.236,40.337-67.491,65.526c1.867,63.072,73.743,67.948,72.177,136.724c-1.563,65.475-57.215,101.737-18.44,178.023 s148.253,90.853,261.555,35.176c113.302-55.677,219.06-51.905,312.198-21.547c93.136,30.257,191.007,71.779,230.917,0.567 c29.554-52.697-23.425-91.747-19.924-139.071c3.504-47.224,51.365-66.149,51.365-66.149c-63.102,0.868-84.753,40.025-91.311,58.427 c-17.263,48.832,22.102,104.492-33.793,98.743c-52.181-5.358-52.994-59.858-45.669-92.889 c20.908-94.66,150.822-113.012,153.423-177.217c2.335-59.695-41.878-72.993-41.878-72.993s10.768,12.287,11.65,42.074 c0.731,24.689-18.531,39.766-40.722,40.423c-17.792,0.527-36.692-12.72-37.379-35.91c-0.876-29.587,24.469-31.838,22.744-73.205 s-44.293-63.317-44.509-87.521s24.239-32.832,24.239-32.832s-38.217-6.772-48.122,23.634c-10.187,31.015,7.387,56.906,1.185,80.6 c-4.23,15.932-17.971,35.047-45.668,32.165c-27.095-2.799-44.236-27.603-38.691-56.58c11.513-60.567,61.309-61.441,60.211-98.525 C766.125,67.615,740.634,58.166,740.634,58.166z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF5910",d:"M506.25,137.114c-34.391,35.939-71.998-2.262-104.947,23.346s-9.713,93.578-38.8,92.475 c-20.492-0.77-38.115-18.696-29.247-50.207c0,0-25.724,15.737-16.922,57.963c5.77,28.111,31.177,27.183,26.898,55.772 c-4.285,28.69-29.646,19.201-38.39,61.641c-7.045,34.43,15.101,39.21,11.646,67.45c-3.437,27.941-26.298,41.15-47.334,37.842 c-21.036-3.308-33.942-18.136-31.957-42.059c1.979-23.823,24.503-25.131,29.412-67.108c4.809-41.983-30.59-52.795-30.59-52.795 s12.191,18.29,5.396,40.612s-63.846,37.519-71.983,84.705c-8.137,47.187,10.012,69.553,35.614,86.471s44.342,21.687,47.201,40.2 c3.122,20.733-13.901,33.503-9.126,55.04c6.757,29.976,57.803,48.572,106.012,27.317c48.209-21.256,156.344-70.154,308.17-20.658 c72.182,23.515,90.29-18.044,94.044-34.944c10.576-47.737-28.244-79.301-13.711-110.06c22.472-47.299,86.98-13.139,103.646-57.292 c11.258-29.66-14.496-53.801-6.861-79.978c7.536-26.184,27.568-34.158,32.192-57.016c4.63-22.957-3.866-37.812-13.687-42.629 c0,0,6.604,24.356-2.048,36.243c-8.646,11.787-35.867-0.021-51.492,28.967c-15.619,28.888-7.397,43.325-14.347,55.218 c-6.95,11.892-31.105,34.64-53.079,23.859c-22.074-10.788-24.444-35.582-11.628-54.825c13.926-20.978,16.843-51.857,3.366-86.558 c-13.377-34.695-21.142-58.121-14.567-72.04s17.148-26.088,35.069-27.481c0,0-45.281-14.632-67.515,20.759 s-20.198,67.178-25.4,83.187s-33.229,54.347-61.378,44.585c-22.46-7.806-30.009-37.931-22.716-63.428 c6.651-23.233,28.817-30.073,28.817-30.073c-84.602-10.659-87.926,59.069-74.48,81.344c12.073,20.186,21.645,53.242,0.402,61.343 c-16.933,6.464-33.279-1.363-29.83-29.504c3.455-28.24-6.531-41.684-29.955-43.639c-23.324-1.948-46.014-22.192-43.761-47.2 c2.271-25.308,18.721-36.912,46.794-45.289C502.233,177.642,506.25,137.114,506.25,137.114z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA127",d:"M661.354,269.816c-17.615,6.657-16.196,22.208-11.367,37.465s-5.587,31.742-37.645,36.35 s-62.005,5.68-71.846,35.89c-9.844,30.309,14.858,40.28,11.382,68.485c-3.476,28.206-18.294,38.251-34.118,38.761 c-15.823,0.51-31.599-10.184-31.226-31.883s15.683-37.932,4.586-63.988c-13.607-32.237-41.14-31.59-52.192-36.535 s-17.611-16.053-15.924-28.507c-14.023,16.673-12.001,35.345-5.765,43.942c7.574,10.64,20.656,56.567-31.561,46.644 c-31.133-5.868-41.519-35.504-20.583-52.463c14.674-11.851,32.325-26.11,34.228-48.762c2.844-33.628-31.917-32.205-31.04-50.786 c0.597-12.788,11.316-13.255,11.316-13.255s-22.452-1.897-22.99,18.696c-0.421,16.795,20.872,17.355,16.362,33.723 c-7.218,26.289-71.41,5.689-85.57,52.572c-27.212,90.299,90.413,75.138,80.722,132.765c-3.428,20.203-17.821,32.663-42.378,30.901 c-24.657-1.765-67.683-17.707-49.372-40.35c29.442-36.404-21.65-59.999-7.378-81.467c-25.295,9.12-1.243,40.08-16.621,48.808 s-29.299,22.102-25.624,42.326c3.675,20.223-7.334,26.785-17.13,23.28c-9.793-3.605-12.618-22.202,0.379-34.805 c13.1-12.7,13.218-29.404,2.24-39.949c3.188,23.01-31.862,14.419-39.213,35.301c-14.155,40.28,34.704,48.799,23.33,96.169 c-20.67,85.8,95.801,72.404,151.558,35.915c55.754-36.389,135.944-44.507,205.915-19.926s138.26,55.012,154.903,21.612 c13.546-27.093-5.099-48.481-9.502-54.92c-4.406-6.34-11.481-23.367-0.066-39.821c11.416-16.454,11.246-33.567-6.717-47.931 s-21.574-26.982-8.014-38.367c0,0-24.248-2.053-29.537,20.094c-5.292,22.246,12.721,25.306,8.54,43.986 c-5.326,23.346-38.219,25.827-52.605,12.275c-14.384-13.652-25.514-48.314,4.598-77.294c30.213-28.977,73.408-37.842,72.923-80.277 C687.733,299.948,642.355,298.54,661.354,269.816z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF5910",d:"M295.675,79.881c-76.874,24.25-11.725,75.351-42.271,112.062 C330.324,161.293,254.391,113.746,295.675,79.881z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FF5910",d:"M946.145,142.92c45.32,66.683-37.582,66.38-36.253,114.174C868.548,185.392,957.495,195.066,946.145,142.92 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E70728",d:"M599.042,38.844c15.15,57.402-73.738,40.043-48.235,99.408c0.358-21.998,42.169-21.938,62.312-39.133 C633.159,82.022,623.733,43.471,599.042,38.844z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E70728",d:"M167.895,195.963c4.171-44.234-19.31-39.742-33.395-46.488c-14.184-6.748-21.408-22.676-9.881-41.378 c-26.903,11.433-22.941,48.107-15.978,56.03C124.334,181.902,147.282,156.398,167.895,195.963z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E70728",d:"M1001.274,340.143c-35.422,26.898-16.238,41.065-11.633,56.12c4.602,14.955-2.263,31.093-23.734,35.312 c29.991,8.203,47.343-5.484,45.006-24.516C1007.973,381.942,984.955,366.803,1001.274,340.143z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA127",d:"M737.713,325.591c21.493,43.703-61.707,48.09-27.116,108.995c-2.996-27.6,22.904-24.996,40.005-39.194 C773.905,375.896,771.51,340.896,737.713,325.591z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA127",d:"M168.743,366.31c-7.586,20.105,12.312,18.391,10.924,35.792c-1.488,17.401-15.787,19.611,2.028,41.398 c0,0-4.41-14.797,12.186-20.108s19.582-26.313,7.374-38.105C188.948,373.496,170.255,383.209,168.743,366.31z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFA127",d:"M719.698,542.122c-13.391-24.951,1.132-46.004,25.906-53.195c18.88-5.469,37.946-14.739,38.179-33.139 c20.009,29.827,0.091,52.3-23.294,56.485C735.804,516.563,718.326,522.426,719.698,542.122z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"triangle",ref:"triangle",transform:"matrix(1,0,0,1,0,0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#822193",points:"831.7,369.2 831.7,388.9 512,684.1 512,664.3 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#351138",points:"831.7,369.2 512,664.3 192.3,369.2 512,369.2 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#640F6D",points:"512,664.3 512,684.1 192.3,388.9 192.3,369.2 \t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"click",ref:"click",transform:"matrix(1,0,0,1,0,0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#19A1F4",d:"M688.5,582.646v-31.692v-23.379v0v-4.396c0-12.988-10.6-23.579-23.6-23.679H361.8 c-13,0-23.7,10.69-23.7,23.679v4.396H338v30.173c0.033-0.013,0.067-0.025,0.1-0.038v10.12v9.9v9.891 c0,12.988,10.7,23.679,23.7,23.679h303c13,0,23.7-10.69,23.7-23.679l0.1-4.951L688.5,582.646z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#008DD3",d:"M688.5,550.954v32.971h-0.2c-132.9,42.662-240.5-50.455-350.2-6.194l0,0v-20.082 c77.8-31.572,257.8,38.965,350.3-6.794L688.5,550.954L688.5,550.954z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#19A1F4",d:"M688.5,527.575v23.379h-0.2c-92.4,45.759-272.5-24.778-350.3,6.794v-30.173h3.6 c0,0,6.1-18.384,26.2-18.384h290.8c19.9,0,26.2,18.384,26.2,18.384H688.5L688.5,527.575z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0083B7",d:"M688.5,587.621c0,12.988-10.7,23.679-23.7,23.679h-303c-13,0-23.7-10.69-23.7-23.679v-9.791l0,0 c109.7-44.36,217.3,48.756,350.2,6.195h0.2V587.621z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#85DDFF",d:"M661.7,504.396c12.8,0,23.2,10.391,23.2,23.179c0,0-6.3-18.384-26.2-18.384H367.9 c-20.2,0-26.2,18.384-26.2,18.384c0-12.689,10.4-23.179,23.2-23.179L661.7,504.396L661.7,504.396z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#19A1F4",d:"M688.5,523.179v4.396h-3.6c0-12.689-10.4-23.179-23.2-23.179H364.9c-12.7,0-23.2,10.391-23.2,23.179h-3.6 v-4.396c0-12.988,10.7-23.679,23.7-23.679h303.1C677.9,499.6,688.5,510.19,688.5,523.179z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"GlintGroup"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"SVGID_1_",d:"M664.9,499.6H361.8c-13,0-23.7,10.69-23.7,23.679v4.396l0,0v30.173v20.082l0,0v9.791 c0,12.988,10.7,23.679,23.7,23.679h303.1c13,0,23.7-10.69,23.7-23.679v-3.597l0,0v-32.971v-23.379v-4.396 C688.5,510.19,677.9,499.6,664.9,499.6z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("clipPath",{id:"SVGID_2_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use",{href:"#SVGID_1_",overflow:"visible"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"glint3",ref:"glint3",clipPath:"url(#SVGID_2_)",fill:"#FFFFFF",points:"432.4,463.532 379.5,463.532 339.5,639.375 392.4,639.375 \t\t\t\t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"SVGID_3_",d:"M664.9,499.6H361.8c-13,0-23.7,10.69-23.7,23.679v4.396l0,0v30.173v20.082l0,0v9.791 c0,12.988,10.7,23.679,23.7,23.679h303.1c13,0,23.7-10.69,23.7-23.679v-3.597l0,0v-32.971v-23.379v-4.396 C688.5,510.19,677.9,499.6,664.9,499.6z M684,525.477"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("clipPath",{id:"SVGID_4_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use",{href:"#SVGID_3_",overflow:"visible"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"glint2",ref:"glint2",clipPath:"url(#SVGID_4_)",fill:"#FFFFFF",points:"432.4,463.532 379.5,463.532 339.5,639.375 392.4,639.375 \t\t\t\t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"SVGID_5_",d:"M664.9,499.6H361.8c-13,0-23.7,10.69-23.7,23.679v4.396l0,0v30.173v20.082l0,0v9.791 c0,12.988,10.7,23.679,23.7,23.679h303.1c13,0,23.7-10.69,23.7-23.679v-3.597l0,0v-32.971v-23.379v-4.396 C688.5,510.19,677.9,499.6,664.9,499.6z M684,525.477"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("clipPath",{id:"SVGID_6_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use",{href:"#SVGID_5_",overflow:"visible"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"glint1",ref:"glint1",clipPath:"url(#SVGID_6_)",fill:"#FFFFFF",points:"432.4,463.532 379.5,463.532 339.5,639.375 392.4,639.375 \t\t\t\t\t\t"})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"TextGroup"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#B6E5FF",d:"M448.8,547.657c-2.3-0.3-5.7-1.099-11.6-1.099c-6.1,0-9.8,1.698-9.8,8.093c0,6.594,4.2,7.693,9.7,7.693 c3.8,0,7.6-0.699,11.7-1.499v13.688c-5.6,1.499-10.9,2.698-16.4,2.698c-16.9,0-23.4-7.793-23.4-24.178 c0-14.787,6.2-23.079,23-23.079c6.2,0,13.6,2.098,16.7,2.997L448.8,547.657L448.8,547.657z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#B6E5FF",d:"M456,531.072h17.4v30.573H491v14.487h-35V531.072z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#B6E5FF",d:"M498.2,531.072h17.4v45.06h-17.4L498.2,531.072L498.2,531.072z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#B6E5FF",d:"M562.3,547.657c-2.3-0.3-5.7-1.099-11.6-1.099c-6.1,0-9.8,1.698-9.8,8.093c0,6.594,4.2,7.693,9.7,7.693 c3.8,0,7.6-0.699,11.7-1.499v13.688c-5.6,1.499-10.9,2.698-16.4,2.698c-16.9,0-23.4-7.793-23.4-24.178 c0-14.787,6.2-23.079,23-23.079c6.2,0,13.6,2.098,16.7,2.997L562.3,547.657L562.3,547.657z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#B6E5FF",d:"M569.5,531.072h16.9v17.484h0.2l10-17.484h20.6l-16.6,21.88l17.1,23.179h-21l-10.1-17.684h-0.2v17.684 h-16.9L569.5,531.072L569.5,531.072z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"rage",ref:"rage",transform:"matrix(1,0,0,1,0,0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{opacity:"0.3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M731.6,369.2L731.6,369.2c-1.2-0.4-2.4-0.7-3.6-1C729.2,368.5,730.4,368.8,731.6,369.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M805.1,461.9l0.1-0.1c-0.4,0.5-0.8,1-1.3,1.5C804.3,462.9,804.7,462.4,805.1,461.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M503.1,463.5c-2.4,0-4.8,0-7.3,0.1c-3.2,0.1-6.5,0.1-9.7,0.2c3.2-0.1,6.4-0.2,9.7-0.2 C498.3,463.5,500.7,463.5,503.1,463.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M289.4,429.4c0.5,0,1,0.1,1.6,0.2C290.4,429.5,289.8,429.4,289.4,429.4l-10.2,20l0,0L289.4,429.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M477.9,464.2c-1.5,0.1-3,0.2-4.4,0.2c-1.4,0.1-2.8,0.2-4.1,0.3c1.3-0.1,2.7-0.2,4.1-0.3 C474.8,464.3,476.4,464.2,477.9,464.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M457.6,387.3l-5,13.6l6.1-0.2C458.3,395.9,458,391.4,457.6,387.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M510.8,463.5c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.9,0c0.3,0,0.6,0,0.9,0C510.5,463.5,510.7,463.5,510.8,463.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M736.7,370.9c3.3,1.3,6.4,2.7,9.3,4.2C743.2,373.6,740.1,372.2,736.7,370.9c-1.7-0.6-3.4-1.2-5.1-1.7l0,0 C733.4,369.7,735.1,370.3,736.7,370.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"669.3,421.6 668.4,418.9 662.6,402.6 650.7,369.2 650.7,369.2 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M340.4,369.6c-0.1-0.1-0.2-0.3-0.4-0.4l0,0C340.1,369.3,340.3,369.4,340.4,369.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M592.6,373.5c0.4,1.6,0.8,3.3,1.1,4.9c0.2,1.3,0.4,2.5,0.6,3.7c-0.2-1.1-0.4-2.4-0.6-3.7 C593.4,376.8,593,375.1,592.6,373.5s-0.9-3-1.5-4.3l0,0C591.7,370.5,592.2,371.9,592.6,373.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M302.1,434.3c0.7,0.5,1.3,1.1,1.9,1.7l-0.1-0.1C303.4,435.2,302.8,434.7,302.1,434.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M513.2,434.6c-0.5-1.3-0.8-2.4-1.1-3.4c0.4,1.5,1,3.5,1.9,5.6c1.2,2.9,2.9,6.3,5.3,9.9c-2.4-3.6-4.1-7-5.2-9.9 C513.7,436,513.4,435.3,513.2,434.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M511.2,426.7c0,0.1,0,0.1,0,0.1c0-0.1,0-0.2,0-0.3C511.2,426.6,511.2,426.7,511.2,426.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M511.3,427.4c0,0.1,0,0.1,0,0.2s0,0.2,0,0.2c0-0.1,0-0.2,0-0.2S511.3,427.5,511.3,427.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M640.1,475.5l-13.6-11.6c-0.1,0.2-0.6,0.9-1.5,2c1-1.1,1.4-1.9,1.5-2L640.1,475.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M511.1,424.2v0.1c0-0.1,0-0.2,0-0.2V424.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M602.8,438.7c0-0.1,0-0.2,0-0.3c-0.1,0.6-0.2,1.1-0.4,1.7C602.6,439.6,602.7,439.2,602.8,438.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M511.2,425.6L511.2,425.6v-0.1V425.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M765.2,387.6c-0.5-0.4-1.1-0.9-1.7-1.4c-1.2-0.9-2.6-2-4.3-3.2c1.6,1.2,3.1,2.2,4.2,3.2 C764.1,386.7,764.6,387.2,765.2,387.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M597.2,442.5l-17.4-1.5l-11-23.9l2.8-17.1l0,0l18.8,1c0-0.1,0-0.1,0-0.2c-0.2-1.3-0.4-2.8-0.7-4.3s-0.6-3.1-1-4.6 c-0.9-3.3-2.1-5.9-3.6-8s-3.2-3.6-5.1-4.7s-3.9-1.8-5.8-2.2c-2-0.4-4-0.6-5.8-0.6c-2,0-3.8,0.3-5.6,1c-1.7,0.7-3.3,1.6-4.7,2.9 c-1.2,1.1-2.2,2.4-3,3.9c0,0,0,0,0,0.1c0.1,3.2,0.3,7,0.5,11c0.1,1.3,0.2,2.6,0.2,3.9c0.2,3.4,0.5,6.9,0.8,10.2 c0.4,4.6,0.9,9.1,1.4,12.6c0.4,2.3,0.8,5.1,1.7,8.1c0.1,0.5,0.3,1,0.5,1.5c0.8,2.5,2,5.1,3.6,7.5c1.9,2.9,4.5,5.5,8.1,7.4 s8.1,3.1,13.8,3.3c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c5.5,0,9.2-1.3,11.7-3.2 c-0.2-1-0.4-2-0.6-2.7C597.4,443.2,597.3,442.6,597.2,442.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M583.2,425.2l-4.9-10.7L583.2,425.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"689.9,479.7 689.9,479.7 689.5,478.6 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M584.6,477.6L584.6,477.6L584.6,477.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M602.3,440.7l-0.1,0.2c0,0,0,0,0-0.1C602.3,440.7,602.3,440.7,602.3,440.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M602.6,430.9c-0.1-0.4-0.1-0.7-0.2-1c0.1,0.4,0.2,0.9,0.3,1.4C602.7,431.1,602.6,431,602.6,430.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M594.9,387.6c0-0.2-0.1-0.7-0.1-1.4c-0.1-0.5-0.1-1-0.2-1.7c0.1,0.6,0.1,1.2,0.2,1.7C594.9,387,594.9,387.4,594.9,387.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M564.7,475c-5.1-1.1-9.7-2.5-13.9-4.1C554.9,472.6,559.5,473.9,564.7,475z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M380.9,378c-2.9,5.7-6.8,10.5-11.1,14.6c-4.4,4.1-9.2,7.5-13.8,10.2c4.6-2.7,9.4-6.1,13.8-10.2 C374.2,388.5,378.1,383.7,380.9,378z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M384.1,370.2c-0.1,0.2-0.2,0.5-0.2,0.7c0.1-0.2,0.1-0.3,0.2-0.5C384.1,370.4,384.1,370.3,384.1,370.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M357.7,437.8c0,0.4,0,0.8,0,1.3c0-0.3,0-0.5,0-0.8C357.7,438.1,357.7,437.9,357.7,437.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"460.9,428.3 457.1,428.6 432,430.1 432,430.1 460.9,428.4 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M295.7,430.9c0.4,0.1,0.8,0.3,1.2,0.5c-0.2-0.1-0.4-0.2-0.7-0.3C296,431,295.8,431,295.7,430.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M403.5,472.9c-3.3,0.9-6.4,1.8-9.5,2.7c-5.6,1.7-10.7,3.3-15.3,4.7c4.6-1.5,9.8-3.1,15.4-4.7 C397,474.7,400.2,473.8,403.5,472.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M362.7,485.7c-0.5,0.2-1,0.3-1.4,0.5c-0.9,0.3-1.6,0.6-2.3,0.8c0.7-0.2,1.4-0.5,2.3-0.8 C361.8,486,362.3,485.8,362.7,485.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M421.8,457.4l-4.3,11.6c-2.3,0.6-4.5,1.2-6.7,1.8c2.2-0.6,4.4-1.2,6.7-1.8L421.8,457.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M355.3,424.3L355.3,424.3c0,0.1,0.1,0.2,0.1,0.3C355.3,424.5,355.3,424.4,355.3,424.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M335.5,411.8L335.5,411.8L335.5,411.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M331.2,382.2l-7.9,16.2c3-1.5,6-3.4,8.7-5.8c2.9-2.6,5.5-5.7,7.6-9.5c-2-0.4-4-0.7-5.5-0.8 C332.5,382.2,331.5,382.2,331.2,382.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M341.8,409.6c-0.6,0.3-1.2,0.5-1.8,0.7C340.6,410.1,341.2,409.9,341.8,409.6c0.5-0.2,1.1-0.4,1.6-0.7 C342.9,409.2,342.3,409.4,341.8,409.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M355.7,455.5c-0.2,0.8-0.3,1.6-0.5,2.4C355.3,457.1,355.5,456.3,355.7,455.5L355.7,455.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M326.2,482.5c2-0.5,4.1-1,6.2-1.5c1.2-0.3,2.4-0.6,3.6-0.9c-1.2,0.3-2.4,0.6-3.6,0.9C330.3,481.5,328.2,482,326.2,482.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M341.3,371.1c-0.2-0.4-0.5-0.8-0.7-1.2C340.8,370.2,341.1,370.6,341.3,371.1L341.3,371.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"301.1,404.4 301.1,404.4 311.6,383 302.2,402.1 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M357.2,490.3l6.8,10.5c0.3-0.1,2.2-0.8,5.3-1.9c3.1-1.1,7.4-2.5,12.7-4.3c5.3-1.7,11.5-3.7,18.3-5.7 c6.9-2,14.4-4.2,22.3-6.2l13.7-37l26-1.6l0.3,3.2l1.6,18l0,0l2.7,13.8c2.6-0.3,5.5-0.6,8.8-0.8s6.7-0.4,10.3-0.5 c3.6-0.1,7.3-0.2,11-0.3c3.7-0.1,7.3-0.1,10.8-0.1c0.5,0,1,0,1.5,0s1,0,1.5,0s1,0,1.4,0c0.5,0,0.9,0,1.4,0l-0.1-13.8 c-0.2,0-0.5,0-0.7,0c0.2,0,0.5,0,0.7,0l-6.1-27.2l-5-22.4l-2.9-13l-7.2-31.8H421l-12.5,22.9L391.4,423l-21.9,39.9l-7.1,13 c0.5-2,1-4,1.5-6.2c1.1-5.3,1.9-11,1.9-16.4c0-5.5-0.9-10.7-3.1-14.9l-7.4-14.2c2.4-1.1,5-2.4,7.8-3.9c4.7-2.7,9.7-6.1,14.2-10.3 c4.5-4.2,8.5-9.3,11.3-15.4c0.9-2,1.6-3.9,2.2-5.6c0.5-1.8,0.9-3.4,1.1-4.9s0.2-3,0.1-4.3s-0.4-2.5-0.8-3.7l-2.4-7H340 c0.1,0.1,0.2,0.3,0.4,0.4c-0.1-0.1-0.2-0.3-0.4-0.4h-75l0.5,0.7l8,2.6c-3.5,5.6-7.8,12.6-12.7,20.5c-4.7,7.6-10,16.1-15.5,25 l34,31.4l10.2-20c0.5,0,1,0.1,1.6,0.2c-0.6-0.1-1.1-0.2-1.6-0.2l-10.2,20l13.3,12.3l8.5-16.7c0.9,0.1,2.1,0.3,3.5,0.6 c1.3,0.3,2.8,0.8,4.3,1.5c0,1.8-0.2,3.7-0.8,5.9c-0.4,1.6-1,3.3-1.9,5.1c-2,4.3-3.7,8-5.2,11.3l29.6,27.4 c3.6-0.9,7.3-1.9,11.4-2.8C346.5,492.8,351.5,491.6,357.2,490.3z M510.3,463.5c0.2,0,0.3,0,0.5,0 C510.7,463.5,510.5,463.5,510.3,463.5c-0.3,0-0.6,0-0.9,0C509.7,463.5,510,463.5,510.3,463.5z M495.8,463.6c2.4,0,4.9-0.1,7.3-0.1 C500.7,463.5,498.3,463.5,495.8,463.6c-3.2,0.1-6.5,0.1-9.7,0.2C489.3,463.7,492.6,463.6,495.8,463.6z M473.4,464.4 c1.4-0.1,2.9-0.2,4.4-0.2C476.4,464.2,474.8,464.3,473.4,464.4s-2.8,0.2-4.1,0.3C470.6,464.6,472,464.5,473.4,464.4z M457.6,387.3 c0.3,4.1,0.7,8.6,1.1,13.4l-6.1,0.2L457.6,387.3z M432,430.1l25.1-1.5l3.9-0.2l0,0L432,430.1L432,430.1z M417.5,469.1l4.3-11.6 L417.5,469.1c-2.3,0.6-4.5,1.2-6.7,1.8C413,470.2,415.2,469.7,417.5,469.1z M394,475.6c3-0.9,6.2-1.8,9.5-2.7 C400.2,473.8,397,474.7,394,475.6c-5.6,1.7-10.7,3.3-15.3,4.7C383.3,478.9,388.4,477.3,394,475.6z M361.3,486.2 c0.4-0.2,0.9-0.3,1.4-0.5C362.3,485.8,361.8,486,361.3,486.2c-0.9,0.3-1.6,0.6-2.3,0.8C359.7,486.7,360.5,486.5,361.3,486.2z M357.7,437.8c0,0.2,0,0.3,0,0.5c0,0.3,0,0.5,0,0.8C357.7,438.6,357.7,438.2,357.7,437.8z M384.1,370.2c0,0.1,0,0.2-0.1,0.2 c0,0.2-0.1,0.3-0.2,0.5C384,370.7,384.1,370.5,384.1,370.2z M369.8,392.6c4.3-4.1,8.2-8.9,11.1-14.6 C378.1,383.7,374.2,388.5,369.8,392.6c-4.4,4.1-9.2,7.5-13.8,10.2C360.6,400.1,365.4,396.8,369.8,392.6z M295.7,430.9 c0.2,0.1,0.4,0.1,0.6,0.2s0.4,0.2,0.7,0.3C296.5,431.2,296.1,431,295.7,430.9z M355.3,424.3c0,0.1,0.1,0.2,0.1,0.3 C355.3,424.5,355.3,424.4,355.3,424.3L355.3,424.3z M355.7,455.5L355.7,455.5c-0.2,0.8-0.3,1.6-0.5,2.4 C355.3,457.1,355.5,456.3,355.7,455.5z M341.3,371.1L341.3,371.1c-0.2-0.4-0.5-0.8-0.7-1.2C340.8,370.2,341.1,370.6,341.3,371.1z M302.1,434.3c0.6,0.5,1.2,1,1.8,1.5l0.1,0.1C303.5,435.3,302.8,434.8,302.1,434.3z M301.1,404.4L301.1,404.4l1.1-2.2l9.4-19.1 L301.1,404.4z M332.4,480.9c-2.1,0.5-4.2,1-6.2,1.5C328.2,482,330.3,481.5,332.4,480.9c1.2-0.3,2.4-0.6,3.6-0.9 C334.8,480.4,333.6,480.7,332.4,480.9z M335.5,411.8L335.5,411.8L335.5,411.8L335.5,411.8z M332,392.6c-2.7,2.4-5.7,4.3-8.7,5.8 l7.9-16.2c0.3,0,1.3,0,2.9,0.1c1.5,0.1,3.5,0.3,5.5,0.8C337.5,386.9,334.9,390,332,392.6z M340,410.3c0.6-0.2,1.2-0.4,1.8-0.7 c0.5-0.2,1.1-0.4,1.6-0.7c-0.5,0.2-1.1,0.5-1.6,0.7C341.2,409.9,340.6,410.1,340,410.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M727,450.3l6.5,0.8l11.8-15.2l-26.7-3.3l0,0l26.7,3.3l2-13.5l1.6-10.7l-39.9-4.6l-2.2-0.2l-10.3-22.3l-0.3-0.7 c3,0.3,6.5,0.6,10.5,1c6.8,0.7,13.1,2.4,18.9,4.5c5.7,2.2,10.8,4.8,15.1,7.4s7.7,5.1,10.2,7.1s3.9,3.3,4.2,3.6l12.9-17.6 c-0.1-0.1-0.6-0.5-1.3-1.2c0.7,0.6,1.1,1,1.3,1.2l-13.1-20.8h-23.1c1.7,0.5,3.5,1.1,5.1,1.7c3.3,1.3,6.4,2.7,9.3,4.2 c-2.9-1.5-6-2.9-9.3-4.2c-1.7-0.6-3.4-1.2-5.1-1.7h-80.9l11.8,33.4l5.8,16.3l1,2.7L650.9,369h-59.7c0.6,1.3,1.1,2.7,1.5,4.3 c0.4,1.6,0.8,3.3,1.1,4.9c0.2,1.3,0.4,2.5,0.6,3.7c-0.2-1.1-0.4-2.4-0.6-3.7c-0.3-1.6-0.7-3.3-1.1-4.9c-0.4-1.6-0.9-3-1.5-4.3 h-77.4c-1.5,3.4-2.3,6.9-2.3,10.4c0,4.6,0,9.5-0.1,14.5c0,0.1,0,0.1,0,0.2c-0.1,4.2-0.1,8.5-0.2,12.4c0,0.6,0,1.2,0,1.8 c-0.1,4.5-0.1,8.7-0.1,12c0,0.9,0,1.7,0,2.4l0.3,15.7c0,0.5,0,1,0,1.5s0,0.9,0.1,1.3c0,0.4,0,0.8,0.1,1.1c0,0.3,0.1,0.6,0.1,0.8 c0.2,1.1,0.8,4.3,2.5,8.7c1.8,4.4,4.7,9.8,9.4,15.2c4.8,5.4,11.3,10.8,20.4,15.1c9.1,4.3,20.7,7.4,35.5,8.3c0.5,0,1,0.1,1.5,0.1 s1,0,1.5,0.1c0.5,0,1,0,1.4,0c0.5,0,0.9,0,1.4,0c6.9,0,12.6-0.8,17.2-2c4.6-1.2,8.2-2.8,10.8-4.4c2.7-1.6,4.5-3.2,5.7-4.5 s1.7-2.2,1.8-2.3l45.6,39.2l8.2-11.7l0,0l-9.5-31.5l-15.4-50.7l-4.1-13.7l-1.6-5l-30-1.7l-15.4-0.8l32.1-16.6l4.5-13.7l3.7,2.4 L681,492.7c4.6,1,9.2,2,13.7,3.1l37.5-34.6L727,450.3z M763.4,386.2c0.6,0.5,1.2,1,1.7,1.4C764.6,387.2,764.1,386.7,763.4,386.2 c-1.2-0.9-2.6-2-4.3-3.2C760.8,384.2,762.2,385.3,763.4,386.2z M511.1,424.2v-0.1c0,0.1,0,0.2,0,0.2 C511.1,424.3,511.1,424.3,511.1,424.2z M511.2,425.6v-0.1V425.6L511.2,425.6z M511.2,426.7c0,0,0-0.1,0-0.2 C511.2,426.6,511.2,426.7,511.2,426.7C511.2,426.8,511.2,426.8,511.2,426.7z M511.3,427.6c0-0.1,0-0.1,0-0.2 C511.3,427.5,511.3,427.6,511.3,427.6c0,0.1,0,0.2,0,0.2C511.4,427.8,511.3,427.7,511.3,427.6z M514,436.8 c-0.9-2.2-1.5-4.1-1.9-5.6c0.3,1,0.6,2.1,1.1,3.4C513.4,435.3,513.7,436,514,436.8c1.2,2.9,2.9,6.3,5.2,9.9 C516.9,443.1,515.2,439.7,514,436.8z M626.6,463.8l13.6,11.6L626.6,463.8c-0.1,0.2-0.6,0.9-1.5,2C626,464.8,626.5,464,626.6,463.8 z M602.8,438.7c-0.1,0.5-0.2,0.9-0.3,1.3c0.1-0.6,0.3-1.1,0.4-1.7C602.8,438.5,602.8,438.6,602.8,438.7z M602.6,430.9 c0,0.1,0,0.3,0.1,0.4c-0.1-0.5-0.2-1-0.3-1.4C602.5,430.2,602.6,430.5,602.6,430.9z M602.3,440.7v0.1c0,0,0,0,0,0.1V440.7z M594.8,386.3c0.1,0.7,0.1,1.1,0.1,1.4C594.9,387.4,594.9,387,594.8,386.3c-0.1-0.5-0.1-1-0.2-1.7 C594.7,385.2,594.7,385.8,594.8,386.3z M550.7,470.9c4.2,1.6,8.8,3,13.9,4.1C559.5,473.9,554.9,472.6,550.7,470.9z M584.6,477.6 L584.6,477.6L584.6,477.6L584.6,477.6z M586.5,449.8c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0s-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0 c-5.7-0.1-10.2-1.4-13.8-3.3s-6.2-4.5-8.1-7.4c-1.6-2.4-2.8-4.9-3.6-7.5c-0.2-0.5-0.3-1-0.5-1.5c-0.9-3-1.3-5.8-1.7-8.1 c-0.5-3.6-1-8-1.4-12.6c-0.3-3.3-0.5-6.8-0.8-10.2c-0.1-1.3-0.2-2.6-0.2-3.9c-0.2-4-0.4-7.8-0.5-11c0,0,0,0,0-0.1 c0.8-1.5,1.8-2.8,3-3.9c1.4-1.3,2.9-2.2,4.7-2.9c1.7-0.7,3.6-1,5.6-1c1.8,0,3.8,0.1,5.8,0.6c2,0.4,4,1.1,5.8,2.2 c1.9,1.1,3.6,2.6,5.1,4.7s2.7,4.7,3.6,8c0.4,1.5,0.7,3.1,1,4.6s0.5,3,0.7,4.3c0,0.1,0,0.1,0,0.2l-18.8-1l0,0l-2.8,17.1l11,23.9 l17.4,1.5c0.1,0.1,0.2,0.7,0.4,1.5c0.2,0.7,0.4,1.6,0.6,2.7C595.7,448.5,592,449.8,586.5,449.8z M583.2,425.2L583.2,425.2 l-4.9-10.7L583.2,425.2z M689.9,479.7l-0.4-1L689.9,479.7L689.9,479.7z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"_x33_d_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7975BB",points:"645.4,342.4 638.8,361.7 623.1,351.6 628.8,331.7 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#775FA6",points:"281.3,347.9 293.3,367 265.5,358.1 252,338.5 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M341.3,359.2l8.9,18.5c-0.9-1.9-2.5-3.2-4.3-4.3c-1.9-1-4.1-1.7-6.2-2.2s-4.1-0.7-5.7-0.8 c-1.6-0.1-2.6-0.1-2.9-0.1l-10-18.9c0.3,0,1.4,0,3.1,0.1c1.6,0.1,3.8,0.4,6,0.9s4.5,1.2,6.5,2.3 C338.7,355.8,340.4,357.3,341.3,359.2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M384.6,345.1l6.7,19.2c0.4,1.1,0.6,2.3,0.8,3.7c0.1,1.3,0.1,2.7-0.1,4.3c-0.2,1.5-0.6,3.2-1.1,4.9 c-0.5,1.8-1.3,3.6-2.2,5.6l-6.9-18.3c1-2.1,1.7-4.1,2.3-5.9s1-3.6,1.2-5.2s0.3-3.1,0.1-4.5C385.3,347.5,385,346.3,384.6,345.1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M594.9,375.9l-4,17.7c0-0.1-0.1-0.6-0.1-1.4c-0.1-0.8-0.2-1.9-0.4-3.2c-0.2-1.3-0.4-2.8-0.7-4.3 s-0.6-3.1-1-4.6c-0.9-3.3-2.1-5.9-3.6-8s-3.2-3.6-5.1-4.7s-3.9-1.8-5.8-2.2c-2-0.4-4-0.6-5.8-0.6c-2,0-3.8,0.3-5.6,1 c-1.7,0.7-3.3,1.6-4.7,2.9s-2.5,2.8-3.4,4.6c-0.9,1.8-1.5,3.8-1.7,6.1l2-18.4c0.3-2.4,0.9-4.5,1.8-6.4c0.9-1.9,2.1-3.5,3.6-4.8 c1.4-1.3,3.1-2.4,4.9-3.1c1.8-0.7,3.8-1.1,5.9-1.1c1.9,0,4,0.1,6.1,0.6c2.1,0.4,4.2,1.2,6.2,2.3c2,1.2,3.8,2.8,5.4,4.9 c1.6,2.2,2.9,4.9,3.8,8.4c0.4,1.6,0.8,3.3,1.1,4.9s0.5,3.2,0.7,4.5c0.2,1.4,0.3,2.5,0.4,3.4C594.9,375.3,594.9,375.8,594.9,375.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7760A6",points:"636.8,354.3 630.6,373 590.9,393.6 594.9,375.9 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M767.8,378.1l-12.9,17.6c-0.3-0.2-1.7-1.6-4.2-3.6s-5.9-4.5-10.2-7.1s-9.4-5.3-15.1-7.4 c-5.7-2.2-12.1-3.9-18.9-4.5c-6.8-0.7-12-1.2-15.9-1.6c-4-0.4-6.7-0.6-8.6-0.8c-1.9-0.2-3-0.3-3.5-0.3c-0.6,0-0.7,0-0.7,0 l8.7-18.9c0,0,0.1,0,0.8,0s1.7,0.1,3.7,0.3c2,0.2,4.9,0.4,9.1,0.9s9.7,0.9,16.8,1.7c7.2,0.7,13.8,2.5,19.9,4.8s11.4,5.1,15.9,7.8 c4.5,2.7,8.2,5.4,10.8,7.5C766,376.4,767.6,377.9,767.8,378.1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#744990",points:"455.9,353 459,371.8 446.2,406.5 442.4,389.6 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7971B8",points:"321.2,351.4 331.2,370.3 312.1,409.4 301.1,392.5 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M381.8,364.5l6.9,18.3c-2.8,6.1-6.8,11.2-11.3,15.4c-4.5,4.3-9.5,7.7-14.2,10.3c-4.7,2.7-9.1,4.6-12.4,5.9 s-5.6,1.9-6,2l-9.3-16.5c0.4-0.1,2.8-0.8,6.3-2.2c3.5-1.3,8.1-3.4,13.1-6.2c4.9-2.8,10.2-6.4,14.9-10.9 C374.6,376.3,378.8,370.9,381.8,364.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#73448A",points:"583.2,413.3 579.8,429.1 568.8,405.2 571.6,388.2 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7867AE",points:"601.6,414.9 597.2,430.6 579.8,429.1 583.2,413.3 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7867AD",points:"461,416.5 463.8,432.1 436.3,433.8 432,418.3 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#786AB0",points:"745.3,424 733.5,439.2 708.1,436.1 718.5,420.7 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M306,426.3l10.8,15.1c-1-1.4-2.3-2.7-3.7-3.7c-1.4-1-2.9-1.8-4.4-2.5s-2.9-1.1-4.3-1.5 c-1.3-0.3-2.5-0.6-3.5-0.6l-11.6-15.6c1,0.1,2.2,0.3,3.7,0.7c1.4,0.4,3,0.9,4.5,1.6c1.6,0.7,3.1,1.6,4.6,2.6 C303.6,423.5,304.9,424.8,306,426.3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M602.4,428.6l-4.4,15c0.4-1.4,0.6-2.9,0.6-4.4c0-1.4-0.1-2.8-0.3-4.1c-0.2-1.2-0.4-2.3-0.6-3.1 c-0.2-0.8-0.4-1.3-0.4-1.5l4.4-15.7c0.1,0.2,0.2,0.7,0.5,1.6c0.2,0.8,0.5,2,0.7,3.2c0.2,1.3,0.3,2.8,0.3,4.3 C603,425.5,602.8,427.1,602.4,428.6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M803.8,451.5L789,465.3c0.5-0.5,1-1,1.4-1.6s0.7-1.2,1-1.9c0.3-0.7,0.5-1.4,0.6-2.1 c0.1-0.8,0.1-1.6,0.1-2.4l15-14.3c0.1,0.9,0,1.8-0.1,2.6c-0.1,0.8-0.3,1.6-0.6,2.3c-0.3,0.7-0.6,1.4-1.1,2 C804.9,450.4,804.4,451,803.8,451.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M513.3,451.7l0.1,13.8c-0.5,0-0.9,0-1.4,0s-1,0-1.4,0c-0.5,0-1,0-1.5,0s-1,0-1.5,0c-3.5,0-7.1,0-10.8,0.1 c-3.7,0.1-7.4,0.1-11,0.3c-3.6,0.1-7.1,0.3-10.3,0.5c-3.2,0.2-6.2,0.5-8.8,0.8l-2.7-13.8c2.7-0.3,5.8-0.6,9.2-0.8 c3.4-0.2,7-0.4,10.8-0.5s7.7-0.2,11.6-0.3c3.9-0.1,7.7-0.1,11.4-0.1c0.5,0,1.1,0,1.6,0s1,0,1.5,0s1,0,1.5,0 C512.3,451.7,512.8,451.7,513.3,451.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#744990",points:"432,418.3 436.3,433.8 422.6,470.8 417.5,457.2 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_2_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7971B8",d:"M362.7,426.6c2.2,4.2,3.1,9.5,3.1,14.9c0,5.5-0.8,11.2-1.9,16.4c-1.1,5.2-2.5,10.1-3.7,13.7 s-2.2,6.1-2.4,6.6l-8.6-13.2c0.2-0.6,1.3-3.2,2.5-7c1.3-3.8,2.8-8.9,3.9-14.4c1.2-5.5,2-11.6,2-17.3c0-5.8-0.9-11.2-3.2-15.7 L362.7,426.6z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M626.6,452l-5.7,13.8c-0.1,0.2-0.6,1.1-1.8,2.3c-1.2,1.3-3,2.9-5.7,4.5s-6.2,3.2-10.8,4.4 c-4.6,1.2-10.3,2-17.2,2c-0.5,0-0.9,0-1.4,0s-0.9,0-1.4,0s-1,0-1.5-0.1c-0.5,0-1,0-1.5-0.1c-14.8-0.9-26.4-4-35.5-8.3 s-15.7-9.7-20.4-15.1c-4.8-5.4-7.7-10.9-9.4-15.2c-1.8-4.4-2.4-7.6-2.5-8.7c0-0.2-0.1-0.5-0.1-0.8s0-0.7-0.1-1.1 c0-0.4,0-0.8-0.1-1.3c0-0.5,0-1,0-1.5l-0.3-15.9c0,0.6,0,1.1,0,1.6s0,1,0.1,1.4c0,0.4,0,0.8,0.1,1.1c0,0.3,0.1,0.6,0.1,0.9 c0.2,1.1,0.8,4.6,2.7,9.2s4.9,10.3,10,16c5,5.7,12,11.4,21.6,15.9s21.9,7.8,37.5,8.8c0.5,0,1,0.1,1.6,0.1c0.5,0,1,0,1.5,0.1 s1,0,1.5,0s1,0,1.5,0c7.3,0,13.3-0.8,18.2-2.1c4.9-1.2,8.6-2.9,11.4-4.6s4.8-3.4,6-4.7C625.9,453.1,626.5,452.2,626.6,452"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#755399",points:"689.9,467.8 680.9,480.8 638.8,361.7 645.4,342.4 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M349.2,465.1l8.6,13.2c-5.9,1.4-11.2,2.6-15.9,3.8c-4.8,1.2-9.1,2.2-13.4,3.4c-4.2,1.1-8.4,2.3-12.7,3.5 c-4.3,1.3-8.9,2.7-13.9,4.3L290.3,481c5.3-1.7,10.1-3.2,14.7-4.5s8.9-2.5,13.4-3.7s9.1-2.3,14.1-3.5 C337.5,467.9,342.9,466.6,349.2,465.1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M417.5,457.2l5.1,13.6c-7.9,2.1-15.4,4.2-22.3,6.2s-13.1,4-18.3,5.7c-5.3,1.7-9.6,3.2-12.7,4.3 c-3.1,1.1-4.9,1.8-5.3,1.9l-8.2-12.6c0.4-0.1,2.3-0.8,5.6-2c3.2-1.1,7.8-2.7,13.3-4.5s12.1-3.9,19.3-6 C401.2,461.6,409.2,459.4,417.5,457.2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7972B8",points:"289.4,417.5 301,433.1 265.4,503.3 251.8,491.5 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#765CA2",points:"674.7,493.3 666.5,505 620.9,465.8 626.6,452 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M251.8,491.5l13.6,11.8c-11.3,3.8-21.4,7.3-30.4,10.6s-16.7,6.2-23,8.8c-6.4,2.5-11.4,4.6-14.9,6.1 s-5.5,2.4-5.9,2.5L173.6,521c0.4-0.2,2.5-1.1,6.2-2.7c3.7-1.6,9-3.7,15.7-6.4s14.9-5.8,24.3-9.2 C229.2,499.3,239.9,495.5,251.8,491.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#702A71",d:"M858.5,525.2l-17.6,10.1c-1-0.5-6.3-3-14.9-6.9c-8.7-3.8-20.8-9-35.3-14.6c-14.6-5.6-31.6-11.7-50.2-17.5 c-18.6-5.8-38.7-11.2-59.4-15.6l8.9-13c21.9,4.6,43.1,10.3,62.7,16.4c19.6,6.1,37.5,12.5,52.9,18.4s28.1,11.3,37.3,15.4 C851.9,522.1,857.5,524.8,858.5,525.2"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#70CEEF",d:"M385.4,349.3c-0.2-4.2-1.9-7.3-4.4-9.7c-0.054-0.022-0.113-0.038-0.167-0.059 c-2.497-2.368-6.068-4.049-10.133-4.941c-4.2-1.1-8.9-1.5-13.8-1.5c-0.2,0-0.4,0-0.6,0s-0.4,0-0.6,0s-0.4,0-0.6,0s-0.4,0-0.6,0 c-5.2,0.2-14,0.6-24.3,1.1c-10.2,0.5-22,1.2-33.3,1.8c-11.3,0.6-22,1.2-30.2,1.7c-8.1,0.5-13.8,0.8-14.8,0.9l29.4,9.3 c-2.7,4.4-46.1,74.7-55.8,90.2c-3.755,5.969-7.416,11.933-11.075,17.724c-0.142,0.125-0.283,0.252-0.425,0.376 c-8.4,13.4-16.3,26.2-22.9,36.7c-9.6,15.3-16.3,26-17.5,28c0.4-0.2,2.5-1.1,6.2-2.7c3.7-1.6,9-3.8,15.7-6.4s14.9-5.8,24.3-9.2 c9.5-3.5,20.2-7.2,32.1-11.2l37.5-74c1.7,0.2,4.2,0.7,6.9,1.7c2.6,1,5.4,2.5,7.7,4.7c2.3,2.2,4,5.1,4.6,8.7 c0.5,3.7-0.1,8.1-2.6,13.6c-3.8,8.2-6.6,14.4-8.8,19.2s-3.7,8.1-4.7,10.4s-1.6,3.6-1.9,4.3c-0.3,0.7-0.4,0.9-0.4,0.9 c5.4-1.7,10.1-3.2,14.7-4.5s8.9-2.5,13.4-3.7c4.5-1.1,9.1-2.3,14.1-3.5s10.5-2.5,16.8-4c0.3-0.8,2.1-5.2,3.9-11.3 c1.9-6.2,3.8-14,4.4-21.9s0-15.7-3.2-21.6c-1.6-2.9-3.7-5.3-6.5-7.2l-0.157,0.21c-3.174-1.943-7.124-3.113-12.143-3.31 c0.4-0.2,2.8-0.8,6.3-2.2s8.2-3.4,13.1-6.2c4.9-2.8,10.1-6.4,14.9-10.9c1.2-1.2,2.4-2.4,3.5-3.6l0,0c2-2.2,3.9-4.7,5.6-7.4 c1.1-1.6,2.1-3.4,2.9-5.2C384.6,358.4,385.7,353.4,385.4,349.3z M332.1,381c-3.3,2.8-7,5-10.7,6.7s-7.5,2.8-11,3.6 s-6.7,1.2-9.2,1.4l2.6-5.2c0.022-0.201,0.037-0.434,0.039-0.685l2.961-6.015l14.4-29.4c0.3,0,2.2,0,4.8,0.3c2.6,0.3,5.7,0.8,8.6,2 s5.4,2.9,6.7,5.5c1.2,2.6,1.2,6.1-1,10.7c-0.3,0.6-0.6,1.2-0.9,1.8l0,0C337.8,374.6,332.6,380.6,332.1,381z M373.312,377.175 c0.139-0.265,0.21-0.556,0.193-0.841C373.524,376.616,373.453,376.906,373.312,377.175z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#70CEEF",d:"M485.9,329.7l-50.5,0.9l-79.5,145.8c0.4-0.1,2.3-0.9,5.6-2c3.2-1.1,7.8-2.7,13.3-4.5s12.1-3.9,19.3-6 c7.2-2.2,15.2-4.4,23.5-6.6l14.5-39l29-1.8l3.2,36.9c2.7-0.3,5.8-0.6,9.2-0.8c3.4-0.2,7-0.4,10.8-0.5s7.7-0.2,11.6-0.3 c3.9-0.1,7.7-0.1,11.4-0.1c0.6,0,1.1,0,1.6,0s1,0,1.5,0s1,0,1.5,0c0.5,0,1,0,1.5,0L485.9,329.7z M458.6,388.7l-16.1,0.6l-0.2,0.2 l13.6-36.6C455.9,353.1,458.2,383.8,458.6,388.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#70CEEF",d:"M816.2,457.6L816.2,457.6l-9.1-14.6c0.2,2.9-0.6,5.2-2,7.2c-1.4,1.9-3.5,3.3-6,4.4c-2.5,1-5.4,1.7-8.5,2.2 c-1.418,0.213-2.888,0.323-4.371,0.406c-0.62-0.094-1.258-0.14-1.929-0.106c-1.1,0.1-2.2,0.1-3.2,0.1c-1.2,0-2.4-0.1-3.6-0.1 s-2.3-0.1-3.4-0.2s-2.1-0.2-3.1-0.3c-1-0.1-1.9-0.3-2.7-0.4c-2.6-0.5-6.1-1-9.9-1.7c-3.7-0.6-7.8-1.3-11.5-2 c-3.8-0.6-7.2-1.2-9.8-1.7c-2.5-0.4-4.3-0.8-4.6-0.8l-5.8-12.2c-0.016,0.002-0.03,0.001-0.046,0.003L718.5,420.7l26.7,3.3l3.6-24.2 l-42.2-4.6l-20.2-43.9c0.1,0,0.2,0,0.8,0s1.7,0.1,3.7,0.3c2,0.2,4.9,0.5,9.1,0.9c4.2,0.4,9.6,1,16.8,1.7s13.9,2.5,19.9,4.8 s11.4,5.1,15.9,7.8s8.2,5.4,10.8,7.5s4.1,3.5,4.4,3.8l-25.7-40.9l-113.2-5.6l16.488,10.628c-0.029-0.01-0.059-0.018-0.088-0.028 l44.5,125.6c21.9,4.6,43.1,10.3,62.7,16.4c19.6,6.1,37.6,12.5,52.9,18.4c15.4,6,28.1,11.3,37.3,15.4c9.2,4,14.8,6.7,15.8,7.2 L816.2,457.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#70CEEF",d:"M655.7,430.7L644,392.1l-72.3-4l11.585,25.168c-0.029,0.011-0.057,0.021-0.085,0.032l18.3,1.6 c0.1,0.3,0.6,1.9,1,4.1s0.7,5.1,0.2,7.9s-1.7,5.5-4.2,7.6c-2.6,2-6.4,3.4-12.1,3.4c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0s-0.1,0-0.2,0 c-0.1,0-0.1,0-0.2,0c-5.7-0.2-10.2-1.4-13.8-3.3s-6.2-4.5-8.1-7.4c-2-2.9-3.2-6-4.1-9c-0.477-1.716-0.856-3.427-1.151-5.057 c0.051-0.016,0.099-0.026,0.151-0.043c-0.2-1-0.4-1.9-0.5-2.8c-0.6-3.6-1-8.1-1.4-12.6c-0.4-4.7-0.7-9.6-1-14.2 c-0.2-3.6-0.4-7.1-0.5-10.1c0,0-0.2-1.7-0.1-2.4c-0.1-2.5-0.4-7.3-0.4-7.7c0-2.7,0.5-5.2,1.3-7.4s2-4,3.5-5.6s3.3-2.8,5.2-3.6 c1.9-0.9,4.1-1.3,6.3-1.3c1.9,0,4,0.2,6.1,0.6s4.2,1.1,6.2,2.3c2,1.1,3.8,2.7,5.4,4.9c1.6,2.2,2.9,4.9,3.8,8.4 c0.893,0.893,0.913,0.96,0,0.1c0.4,1.6,0.8,3.3,1.1,4.9c0.2,1,0.4,1.9,0.5,2.8c0,0,0.033,0.161,0.129,0.412 c0.031,0.457,0.094,0.904,0.171,1.288c0.2,1.4,0.3,2.5,0.4,3.4c0.1,0.9,0.1,1.4,0.1,1.5l6.7-3.5l35.2-18.2c-0.2-0.3-1.5-1.9-4.3-4 c-2.4-2.2-6-5.1-10.8-8c-1.5-1-1.7-1.3-4.8-3c-3.7-2-8.1-3.8-13.1-5.6c-7.4-2.4-16.1-4.3-26.3-5c-0.6,0-1.2-0.1-1.8-0.1 c-0.6-0.1-1.2-0.1-1.8-0.1c-0.5,0-1.1,0-1.7,0c-0.5,0-1.1,0-1.7,0c-9.2,0-17.4,1.3-24.7,3.5c-4.5,1.4-8.7,3.2-12.4,5.2 c0,0-4.6,2.7-6.5,4.1c-5.1,3.8-9,8.1-11.7,12.6c-1.8,3-3,6.2-3.6,9.3h0.1c0.03,0.056,0.061,0.103,0.091,0.154 c-0.292,1.482-0.391,2.964-0.391,4.446c0.031,0.119,0.065,0.22,0.1,0.322c0,4.508-0.002,9.293-0.1,14.178 c-0.1,4.2-0.5,22.9-0.5,26.2c0,3.4,0.1,5.9,0.3,7.2c0.2,1.2,0.8,4.6,2.7,9.2s5,10.4,10,16.1c5.1,5.7,12,11.4,21.6,15.9 s21.9,7.8,37.5,8.8c0.6,0.1,1.1,0.1,1.6,0.1c0.5,0.1,1,0.1,1.5,0.1s1,0,1.5,0s1,0,1.5,0c7.4,0,13.3-0.9,18.2-2.1 c4.8-1.3,8.6-2.9,11.4-4.6s4.8-3.4,6-4.7c1.2-1.4,1.8-2.3,1.9-2.5l48.1,41.2L655.7,430.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A6EEFF",d:"M816.2,457.6l42.3,67.6c-1-0.5-6.6-3.2-15.8-7.2c-9.2-4.1-21.9-9.4-37.3-15.4 c-15.3-5.9-33.3-12.3-52.9-18.4c-19.6-6.1-40.8-11.8-62.7-16.4l-13.3-37.6l0.2-0.1c8.6-5.9,12.3-26.5,24.8-16.1 c12.4,10.3,14,25,25.2,23.8l5.8,12.2c0.3,0,2.1,0.4,4.6,0.8c2.6,0.5,6,1.1,9.8,1.7c3.7,0.7,7.8,1.4,11.5,2c3.8,0.7,7.3,1.2,9.9,1.7 c0.8,0.1,1.7,0.3,2.7,0.4s2,0.2,3.1,0.3c1.1,0.1,2.2,0.2,3.4,0.2s2.4,0.1,3.6,0.1c1,0,2.1,0,3.2-0.1l0,0c5.9-0.3,9.5,5,16.7,4.6 C807.8,461.6,813.5,455.4,816.2,457.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#70CEEF",d:"M807.1,443l9.1,14.6c-2.7-2.2-8.4,4-15.1,4.3c-7.2,0.3-10.8-5-16.7-4.6l0,0c2.1-0.1,4.2-0.2,6.2-0.5 c3.1-0.5,6-1.2,8.5-2.2c2.5-1.1,4.6-2.5,6-4.4C806.5,448.2,807.3,445.9,807.1,443z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#B6E5FF",d:"M750.6,350.7l17.2,27.4c-0.3-0.3-1.8-1.7-4.4-3.8c-2.6-2.1-6.3-4.8-10.8-7.5s-9.9-5.5-15.9-7.8 s-12.7-4.1-19.9-4.8c-7.2-0.7-12.6-1.3-16.8-1.7c-4.2-0.4-7.1-0.7-9.1-0.9c-2-0.2-3.1-0.3-3.7-0.3c-0.6,0-0.7,0-0.8,0l14.4,31 c-10.6,15.7-35-18.1-45.2-11l-10.3-29.1c11.7,4.1,23.1-4.8,38.2-4.3c1.1,0,2.2,0.1,3.3,0.2C703.7,340.2,731.5,353.9,750.6,350.7 L750.6,350.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E3FBFF",d:"M742.1,337.2l8.5,13.5l0,0c-19.1,3.1-46.9-10.5-63.6-12.5c-1.1-0.1-2.2-0.2-3.3-0.2l0.2-3.6L742.1,337.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#70CEEF",d:"M748.8,399.8l-3.6,24.2l-26.7-3.3l8.2,17.2c-11.2,1.2-12.7-13.5-25.2-23.8c-12.5-10.4-16.3,10.2-24.8,16.1 l-0.2,0.1l-19.8-56l0,0c3.5-1.2,7.2,0.4,12.8,7.6c5.7,7.2,10.5,5.7,14.8,6s6.5,4.8,10.4,4.2c3.9-0.6,3.8-6.1,8.3-4.6l0,0l3.6,7.7 L748.8,399.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5CBBE5",d:"M700.9,382.4l2.3,4.9l0,0c-4.5-1.5-4.4,4-8.3,4.6c-4,0.6-6.2-3.9-10.4-4.2c-4.3-0.3-9.1,1.2-14.8-6 s-9.4-8.8-12.8-7.6l0,0l-1-2.8C665.9,364.4,690.3,398.2,700.9,382.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E3FBFF",d:"M683.9,334.4l-0.2,3.6c-15.1-0.4-26.6,8.5-38.2,4.3l-16.6-10.7L683.9,334.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A6EEFF",d:"M655.7,430.7l19,62.5L626.6,452c-0.1,0.2-0.7,1.1-1.9,2.5c-1.2,1.3-3.2,3-6,4.7s-6.6,3.3-11.4,4.6 c-4.9,1.2-10.8,2.1-18.2,2.1c-0.5,0-1,0-1.5,0s-1,0-1.5,0s-1,0-1.5-0.1c-0.5,0-1,0-1.6-0.1c-15.6-1-27.9-4.3-37.5-8.8 S529,446.7,523.9,441c-5-5.7-8.1-11.5-10-16.1s-2.5-8-2.7-9.2c-0.2-1.3-0.3-3.8-0.3-7.2c0-3.3,0-7.4,0.1-12c0-0.7,0-1.4,0-2.1 c6,11,18.3-0.6,28.3,5.4c10,6.1,10.4,15.9,19.1,13.1c0.3,1.7,0.7,3.5,1.2,5.3c0.9,3,2.1,6.1,4.1,9c1.9,2.9,4.5,5.5,8.1,7.4 s8.1,3.1,13.8,3.3c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0s0.1,0,0.2,0c5.7,0,9.5-1.4,12.1-3.4c2.5-2.1,3.7-4.8,4.2-7.6 c0.5-2.8,0.2-5.7-0.2-7.9c-0.4-2.2-0.9-3.8-1-4.1l-18.3-1.6c16.9-6.3,29.5-13.1,41.7-0.6C637,425.1,648,433.5,655.7,430.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#70CEEF",d:"M644,392.1l11.7,38.6c-7.7,2.8-18.7-5.6-30.7-18c-12.2-12.5-24.8-5.7-41.7,0.6l-11.6-25.2L644,392.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A6EEFF",d:"M636.8,354.3L618,364c-8.6,3.3-22.1,1-25.5-2.4c-0.9-3.5-2.2-6.2-3.8-8.4c-1.6-2.2-3.4-3.8-5.4-4.9 c-2-1.2-4.1-1.9-6.2-2.3c-2.1-0.4-4.2-0.6-6.1-0.6c-2.2,0-4.4,0.4-6.3,1.3c-1.9,0.8-3.7,2-5.2,3.6s-2.7,3.4-3.5,5.6 s-1.3,4.7-1.3,7.4c0,0.4,0,0.9,0,1.4h-0.1c-7.7,4-10.4-5.3-24.3-5c-13.8,0.3-16.7,7.1-18.6,3.5h-0.1c0.6-3.1,1.8-6.3,3.6-9.3 c2.7-4.5,6.6-8.8,11.7-12.6c1.9-1.4,4-2.7,6.2-4l0.1,0.2c16.9-1.2,40.9,5.1,54.3,2.8c13.3-2.3,19.9-3.3,29.1-0.8v-0.1 c1.9,0.9,3.6,1.9,5.1,2.9c4.8,2.9,8.4,5.8,10.8,8C635.3,352.4,636.6,354,636.8,354.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5CBBE5",d:"M618,364l-16.4,8.5l0,0c-6.6,1.4-7.5-3.1-7.5-3.1c-0.1-0.9-0.3-1.8-0.5-2.8c-0.3-1.6-0.7-3.3-1.1-4.9 C596,365,609.4,367.3,618,364z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E3FBFF",d:"M616.9,339.3L616.9,339.3c-9.3-2.4-15.8-1.4-29.1,0.9s-37.3-3.9-54.3-2.8l-0.1-0.2c3.7-2,7.9-3.8,12.4-5.2 c7.3-2.2,15.5-3.5,24.7-3.5c0.6,0,1.2,0,1.7,0c0.6,0,1.2,0,1.7,0c0.6,0,1.2,0,1.8,0.1c0.6,0,1.2,0.1,1.8,0.1 c10.2,0.7,18.9,2.6,26.3,5C608.8,335.5,613.2,337.3,616.9,339.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#42A5E2",d:"M601.6,372.5l-6.7,3.5c0-0.1,0-0.6-0.1-1.5s-0.2-2-0.4-3.4c-0.1-0.5-0.2-1.1-0.2-1.7 C594.1,369.3,595,373.9,601.6,372.5L601.6,372.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#70CEEF",d:"M558.1,410.3c0.1,0.9,0.3,1.8,0.5,2.8c-8.7,2.8-9.1-7.1-19.1-13.1c-9.9-6-22.3,5.5-28.3-5.4 c0.1-3.9,0.1-8.1,0.2-12.3c0.1-5,0.1-9.9,0.1-14.5c1.2,5,5.8-5.4,18.7-5.7c12.8-0.2,19.6,16.9,24.9,11.3h0.1 c0.1,3,0.3,6.5,0.5,10.1c0.3,4.6,0.6,9.5,1,14.2C557.1,402.2,557.5,406.7,558.1,410.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5CBBE5",d:"M555.1,373.4L555.1,373.4c-5.4,5.5-12.2-11.6-25-11.3c-12.8,0.2-17.4,10.7-18.7,5.7c0-1.5,0.1-3,0.4-4.5 h0.1c1.9,3.6,4.8-3.1,18.6-3.5c13.8-0.3,16.5,9.1,24.3,5h0.1c0,1.5,0.1,3.7,0.2,6.2C555,371.7,555.1,372.5,555.1,373.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A6EEFF",d:"M503.2,406.5l10.2,45.2c-0.5,0-1,0-1.5,0s-1,0-1.5,0s-1,0-1.5,0s-1,0-1.6,0c-3.7,0-7.5,0-11.4,0.1 s-7.8,0.2-11.6,0.3c-3.8,0.1-7.4,0.3-10.8,0.5s-6.5,0.5-9.2,0.8l-3.2-36.9l-29,1.8l-14.5,39c-8.3,2.2-16.3,4.4-23.5,6.6 c-7.2,2.1-13.8,4.2-19.3,6s-10.1,3.4-13.3,4.5c-3.3,1.1-5.2,1.9-5.6,2l36.4-66.7c7.5-9.5,15.5-16.3,26.4-15.1 c11,1.2,9.2,6.9,24.5,5.9s21.4-13.5,34.9-16.1C484.1,383.1,497.7,382.2,503.2,406.5L503.2,406.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#70CEEF",d:"M494.2,366.9l8.9,39.5l0,0c-5.4-24.3-19-23.4-25.2-22.2c-13.5,2.6-19.6,15.1-34.9,16.1s-13.5-4.8-24.5-5.9 c-10.9-1.1-18.9,5.6-26.4,15.1l21-38.3c6.1,0,9.5,2.4,16.6,1.7c7.1-0.7,15.5-4.2,19.2-1.5l0,0l-6.6,18.1l0.2-0.2l16.1-0.6 c-0.4-4.9-0.8-9.5-1.1-13.7c0-0.5-0.1-1-0.1-1.4C460.2,376.1,481.7,378.2,494.2,366.9L494.2,366.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5CBBE5",d:"M494,365.6l0.3,1.3h-0.1c-12.4,11.2-34,9.1-36.7,6.7c-0.3-3.3-0.5-6.4-0.7-9 C462.4,363.8,473.5,372.7,494,365.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A6EEFF",d:"M488.6,341.8l5.4,23.8c-20.5,7-31.6-1.9-37.2-1c0-0.3,0-0.5-0.1-0.8c-0.2-3.2-0.5-5.8-0.6-7.7 c-0.1-1.9-0.2-3-0.2-3.2l-4.5,12.1c-3.8,0.2-13.3,5.8-21.8,6.2c-8.4,0.3-7.6-5.2-14-4.4l16.1-29.4c12.9,6.6,9.8,17.1,29.2,10.8 C480.2,342,478.6,334.5,488.6,341.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E3FBFF",d:"M485.9,329.7l2.7,12.1c-10-7.3-8.4,0.2-27.7,6.4c-19.4,6.2-16.3-4.2-29.2-10.8l3.7-6.8L485.9,329.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5CBBE5",d:"M451.4,365.1l-2.3,6.4l0,0c-3.8-2.7-12.2,0.7-19.2,1.5c-7.1,0.7-10.5-1.7-16.6-1.7l2.4-4.4 c6.5-0.7,5.6,4.8,14,4.4C438.1,371,447.6,365.3,451.4,365.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A6EEFF",d:"M385.4,349.3c0.3,4.1-0.8,9.1-3.6,15.3c-0.8,1.8-1.8,3.6-2.9,5.2c-8.4,7.1-34.6,5.8-39.4,2l-0.1-0.1 c0.3-0.6,0.6-1.2,0.9-1.8c2.2-4.6,2.2-8.1,1-10.7c-1.3-2.6-3.8-4.3-6.7-5.5c-2.9-1.2-6-1.7-8.6-2s-4.5-0.3-4.8-0.3l-14.4,29.4 c-17.8-7.1-43.9,12.2-50.7,7.9c1.6-2.6,3.2-5.1,4.7-7.5c10.2-16.4,17.8-28.9,20.5-33.3l-14.2-4.5c26.1-1.8,26.8,0,47.8,2 s52.4-11.4,66.1-5.8C383.5,342,385.2,345.1,385.4,349.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5CBBE5",d:"M378.9,369.8c-1.7,2.7-3.6,5.2-5.6,7.4c0.6-1.1,0-2.6-3.1-2.3c-3.2,0.4-9.6,7.3-18.6,7.2 c-9-0.1-7.4-5.9-9.5-6.5s-4.8,1.4-8.5,3.9l-0.1-0.1c2.3-2.2,4.3-4.8,5.9-7.7l0.1,0.1C344.3,375.5,370.5,376.9,378.9,369.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E3FBFF",d:"M380.9,339.6c-13.6-5.6-45,7.7-66.1,5.8c-21-2-21.7-3.8-47.8-2l-15.1-4.8c1-0.1,6.7-0.4,14.8-0.9 c8.2-0.5,18.9-1.1,30.2-1.7c11.3-0.6,23.1-1.3,33.3-1.8c10.3-0.5,19.1-0.9,24.3-1.1c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0s0.4,0,0.6,0 s0.4,0,0.6,0c4.9,0,9.6,0.4,13.8,1.5C374.8,335.5,378.4,337.2,380.9,339.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#70CEEF",d:"M370.2,374.9c3.1-0.4,3.7,1.2,3.1,2.3c-1.1,1.2-2.3,2.4-3.5,3.6c-4.8,4.5-10,8.1-14.9,10.9 s-9.6,4.8-13.1,6.2c-3.5,1.4-5.9,2-6.3,2.2c5.1,0.2,9.1,1.4,12.3,3.4l-0.3,0.4c-8.1,11.6-33.8,14.1-60.7,6.2 c-26.9-7.9-48.6,25.2-72.8,46.4l0,0c3.8-6,7.6-12.2,11.5-18.4c9.7-15.5,19.4-31.2,28.1-45.1c4.2,5.4,30.8-10.9,41.7-11.2 c8.5-0.3,8.7,3.9,8.5,5.7l-2.6,5.2c2.5-0.2,5.7-0.6,9.2-1.4s7.3-1.9,11-3.6s7.4-3.9,10.7-6.7c0.5-0.4,1-0.9,1.5-1.4l0.1,0.1 c3.7-2.6,6.4-4.6,8.5-3.9c2.1,0.6,0.5,6.4,9.5,6.5C360.6,382.2,367,375.3,370.2,374.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#A6EEFF",d:"M354.3,410.4c3.2,5.9,3.8,13.7,3.2,21.6c-0.6,7.9-2.5,15.7-4.4,21.9c-1.8,6.1-3.6,10.5-3.9,11.3 c-6.3,1.5-11.8,2.8-16.8,4s-9.6,2.4-14.1,3.5c-4.5,1.2-8.8,2.4-13.4,3.7c-4.6,1.3-9.3,2.8-14.7,4.5c0,0,0.1-0.2,0.4-0.9 c0.3-0.7,0.9-2,1.9-4.3s2.5-5.6,4.7-10.4s5-11,8.8-19.2c2.5-5.5,3.1-9.9,2.6-13.6c-0.6-3.6-2.3-6.5-4.6-8.7 c-2.3-2.2-5.1-3.7-7.7-4.7c-2.7-1-5.2-1.5-6.9-1.7l-37.5,74c-11.9,4-22.6,7.7-32.1,11.2c-9.4,3.4-17.6,6.6-24.3,9.2 c-6.7,2.6-12,4.8-15.7,6.4c-3.7,1.6-5.8,2.5-6.2,2.7c1.2-2,7.9-12.7,17.5-28c6.6-10.5,14.5-23.3,22.9-36.7l0,0 c24.2-21.2,45.9-54.3,72.8-46.4s52.5,5.4,60.7-6.2l0.3-0.4C350.6,405.1,352.7,407.5,354.3,410.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#5CBBE5",d:"M306.8,380.8l-3.2,6.5c0.3-1.8,0-6-8.5-5.7c-10.8,0.4-37.4,16.6-41.7,11.2c0.9-1.4,1.7-2.8,2.6-4.1 C262.9,393,289,373.7,306.8,380.8z"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bottom",ref:"bottom"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btnPill hover start",ref:"startbutton",onClick:function onClick(e){return _this11.animateOut(true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Start Game")),this.props.token!==undefined&&// show if token available
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btnPill hover leaderboard",ref:"playback",onClick:function onClick(e){return _this11.quickJump('/win');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"View Playback"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"legalese"},"\xA9 FullStory v0.41"));}}]);return StartScreenView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var StartScreen=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(){return mapStateToProps;},mapDispatchToProps)(StartScreenView);/* harmony default export */ __webpack_exports__["a"] = (StartScreen);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AudioNotice=function(_Component){_inherits(AudioNotice,_Component);function AudioNotice(props){_classCallCheck(this,AudioNotice);var _this=_possibleConstructorReturn(this,(AudioNotice.__proto__||Object.getPrototypeOf(AudioNotice)).call(this,props));_this.callBackMade=false;_this.state={selectedOption:'',selectionMade:false,gameReady:false,killSelf:false};return _this;}_createClass(AudioNotice,[{key:"handleOptionChange",value:function handleOptionChange(changeEvent){var _this2=this;this.setState({selectedOption:changeEvent.target.value.toString(),selectionMade:true});__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].delayedCall(0.2,function(){return _this2.isTimeToGo();});}},{key:"isTimeToGo",value:function isTimeToGo(){if(this.state.gameReady){if(this.state.selectionMade&&this.callBackMade===false){this.props.callback(this.state.selectedOption);this.callBackMade=true;__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to('.audio-notice',0.5,{scale:0,autoAlpha:0,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["Back"].easeOut,delay:0.5,onComplete:this.cleanUp()});}}}},{key:"cleanUp",value:function cleanUp(){__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].killAll(true,true,true,true);}},{key:"componentDidMount",value:function componentDidMount(){var _this3=this;// initialize art
__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].set('#speedlines, .radio1, .radio2, .turnOnAudio',{autoAlpha:0});__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].set(['#headphones'],{scale:0,transformOrigin:'center center'});__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(['#headphones'],0.65,{scale:1,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["Back"].easeOut,transformOrigin:'center center',delay:1,onComplete:function onComplete(){return _this3.doSecondary();}});}},{key:"getRandomInt",value:function getRandomInt(min,max){return Math.floor(Math.random()*(max-min+1))+min;}},{key:"getRandomArbitrary",value:function getRandomArbitrary(min,max){return Math.random()*(max-min)+min;}},{key:"doSecondary",value:function doSecondary(){this.speedLines();__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(['#headphones'],0.175,{x:"+=3",y:"+=3",rotation:"-=3",transformOrigin:'center center',ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["Back"].easeOut,yoyo:true,repeat:-1});}},{key:"speedLines",value:function speedLines(){var _this4=this;var speedlines=this.refs.speedlines.childNodes;speedlines.forEach(function(line){__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].set(line,{scaleX:0,scaleY:0,autoAlpha:0,transformOrigin:"50% 50%"});__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(line,_this4.getRandomArbitrary(0.1,0.3),{scaleX:1,scaleY:1,autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["Back"].easeOut,delay:0.175,transformOrigin:"50% 50%",onComplete:function onComplete(){__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(line,0.175,{ease:__WEBPACK_IMPORTED_MODULE_1_gsap__["Back"].easeOut,transformOrigin:"50% 50%",x:"+=3",y:"+=3",yoyo:true,repeat:-1});}});__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(['.radio1, .radio2, .turnOnAudio'],1,{autoAlpha:1});});__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].set('#speedlines',{autoAlpha:1});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this5=this;if(nextProps.startScreenReady){this.setState({gameReady:true});__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].delayedCall(0.2,function(){return _this5.isTimeToGo();});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){}},{key:"render",value:function render(){var barStyles={width:this.props.successCount/this.props.imageCount*100+"%"};var loaderinfo=this.props.successCount<1?'LOADING AUDIO':'LOADING IMAGES';if(this.state.gameReady)loaderinfo="ALL ASSETS LOADED!";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"audio-notice"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"headphone-art",x:"0px",y:"0px",viewBox:"0 0 385.607 185.404",enableBackground:"new 0 0 385.607 185.404"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"headphones"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#42403D",points:"247.699,56.163 252.773,85.485 238.765,78.396 235.603,54.622 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#070401",points:"252.773,85.485 244.559,87.578 242.737,86.396 234.365,81.885 232.003,80.489 238.765,78.396 \t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E51130",points:"244.289,128.984 238.529,130.683 235.423,118.655 238.213,109.53 247.552,109.316  251.198,115.549 246.911,128.207 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#6D6356",points:"241.229,38.442 247.699,56.163 235.603,54.622 228.29,28.597 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FF61BB",points:"244.964,108.011 247.552,109.316 238.213,109.53 232.205,104.163 241.431,106.21 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#182433",points:"244.964,108.011 241.431,106.21 242.05,96.804 242.287,96.815 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#182433",points:"244.289,128.984 239.282,141.631 224.689,140.775 215.676,120.68 230.056,89.243 233.522,90.627  232.205,104.163 228.233,113.4 227.693,121.344 230.484,129.501 238.529,130.683 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AA0909",points:"233.522,90.627 234.365,81.885 242.737,86.396 242.05,96.804 241.431,106.21 232.205,104.163 \t\t "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#070401",points:"239.282,141.631 224.903,145.276 211.907,145.715 224.689,140.775 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2E2E2E",points:"235.603,54.622 238.765,78.396 232.003,80.489 230.967,55.319 225.825,37.722 224.07,31.691  212.121,23.117 184.971,26.628 170.49,37.879 155.154,60.664 148.268,85.98 145.455,84.157 152.904,59.685 168.093,36.338  183.711,23.961 213.527,20.158 228.29,28.597 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AA0909",points:"235.423,118.655 238.529,130.683 230.484,129.501 227.693,121.344 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FF3386",points:"238.213,109.53 235.423,118.655 228.233,113.4 232.205,104.163 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AA0909",points:"235.423,118.655 227.693,121.344 228.233,113.4 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#42403D",points:"230.056,89.243 215.676,120.68 199.463,121.13 212.346,89.243 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#070401",points:"224.07,31.691 225.825,37.722 225.758,37.744 213.809,37.182 184.971,26.628 212.121,23.117 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2E2E2E",points:"215.676,120.68 224.689,140.775 211.907,145.715 199.463,121.13 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#070401",points:"213.809,37.182 185.815,47.027 170.49,37.879 184.971,26.628 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#070401",points:"185.815,47.027 171.896,65.446 155.154,60.664 170.49,37.879 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#182433",d:"M152.679,107.099l-2.048,4.501l-1.08,2.374l0.743,4.354l0.54,3.15l-0.011,0.09h0.023l1.238,7.212 l0.281,1.643l8.022,3.24l4.501-2.959l4.354-13.637l-2.667-12.523l-11.252-3.229L152.679,107.099z M177.072,103.701 c0.191,0.563-0.191,24.191-0.191,24.191l-11.814,15.752l-21.558-7.876l-4.883-23.437l9.564-20.624l2.329,0.338l8.99,1.316 l11.747,1.721C171.255,95.083,176.881,103.139,177.072,103.701z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#182433",points:"171.896,65.446 165.708,88.377 160.78,87.814 152.487,86.543 148.268,85.98 155.154,60.664 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#070401",points:"166.574,104.545 169.241,117.068 160.24,122.132 159.542,111.724 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#070401",points:"169.241,117.068 164.887,130.705 160.24,122.132 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#070401",points:"166.574,104.545 159.542,111.724 158.293,110.88 152.679,107.099 155.323,101.316 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#070401",points:"165.067,143.645 153.253,142.711 134.125,136.714 143.509,135.768 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#070401",points:"160.24,122.132 164.887,130.705 160.386,133.664 152.364,130.424 152.082,128.781  152.364,128.736 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AA0909",points:"160.78,87.814 159.52,93.294 159.508,93.361 150.518,92.045 150.518,92.033 152.487,86.543 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2E2E2E",points:"154.963,120.759 155.885,120.579 156.583,113.412 158.293,110.88 159.542,111.724 160.24,122.132  152.364,128.736 152.082,128.781 150.845,121.569 151.88,121.366 152.87,121.175 153.883,120.973 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2E2E2E",points:"153.084,112.354 152.094,112.05 151.238,111.791 150.631,111.6 152.679,107.099 158.293,110.88  156.583,113.412 155.672,113.13 154.828,112.883 153.883,112.59 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AA0909",points:"156.583,113.412 155.885,120.579 154.963,120.759 155.672,113.13 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E51130",points:"155.672,113.13 154.963,120.759 153.883,120.973 154.828,112.894 154.828,112.883 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AA0909",points:"154.828,112.883 154.828,112.894 153.883,120.973 152.87,121.175 153.883,112.59 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E51130",points:"153.883,112.59 152.87,121.175 151.88,121.366 151.869,121.333 153.084,112.354 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AA0909",points:"153.084,112.354 151.869,121.333 151.88,121.366 150.845,121.569 150.833,121.479 152.094,112.05  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#E51130",points:"152.094,112.05 150.833,121.479 150.293,118.328 150.327,118.328 151.238,111.791 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AA0909",points:"151.238,111.791 150.327,118.328 150.293,118.328 149.551,113.974 150.631,111.6 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#42403D",points:"148.189,91.707 138.625,112.331 128.69,112.14 138.817,93.575 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#2E2E2E",points:"138.625,112.331 143.509,135.768 134.125,136.714 128.69,112.14 \t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"speedlines",ref:"speedlines"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFEA92",points:"263.407,102.484 349.201,95.452 363.828,101.922 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFEA92",points:"257.5,123.019 335.417,135.396 348.638,129.208 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFEA92",points:"125.013,105.579 103.635,96.578 76.349,94.89 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFEA92",points:"120.793,126.394 105.322,123.581 80.006,134.833 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFEA92",points:"116.011,114.017 21.779,89.826 27.686,99.39 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFEA92",points:"262.001,86.17 289.849,57.197 283.661,47.914 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFEA92",d:"M133.451,86.732L81.975,23.161c0,0-19.69,0.844-18.565,2.25C64.535,26.817,133.451,86.732,133.451,86.732z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFEA92",points:"289.567,88.42 360.171,65.635 337.949,68.167 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFEA92",d:"M251.031,137.927l12.658,10.126c0,0,17.721,1.406,16.877,0.844S251.031,137.927,251.031,137.927z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFEA92",points:"127.263,152.273 124.169,165.494 139.359,148.617 \t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"To ensure you get the full game experience, please do the following: "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Turn off your ad blocker or white-list this page, then reload the page. "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Use headphones while playing\u2014this game uses tons of music and sound.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"turnOnAudio"},"TURN ON AUDIO?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"radioGroup"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"radio radio1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"radio",value:"yes",checked:this.state.selectedOption==='yes',onChange:this.handleOptionChange.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null),"Yup")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"radio radio2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"radio",value:"no",checked:this.state.selectedOption==='no',onChange:this.handleOptionChange.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null),"Nope"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"progress"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"status"},loaderinfo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"holder"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bar",style:barStyles}))));}}]);return AudioNotice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AudioNotice);

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(45)(module)))

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap_TextPlugin__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap_TextPlugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap_TextPlugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hud_Hud__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// eslint-disable-line no-unused-vars
var mapDispatchToProps=function mapDispatchToProps(dispatch){return{playSndFx:function playSndFx(sfx){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["l" /* playSndFx */])(sfx));}};};var IntroView=function(_Component){_inherits(IntroView,_Component);function IntroView(){_classCallCheck(this,IntroView);return _possibleConstructorReturn(this,(IntroView.__proto__||Object.getPrototypeOf(IntroView)).apply(this,arguments));}_createClass(IntroView,[{key:"componentDidMount",value:function componentDidMount(){this.animate();}},{key:"animate",value:function animate(){var _this2=this;__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(['#boxes','#unsubscribe','#weirdstuff','#subscribe','#introtext'],{autoAlpha:0});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(['#unsubscribe-error-message2','#unsubscribe-error-message',"#unsubscribe-cursor-red"],{alpha:0});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(['#legend','#light'],{autoAlpha:0});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(['#smash'],{autoAlpha:0});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(['#tv'],{autoAlpha:0});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(['#eye'],{autoAlpha:0});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(['#front','#mid','#back'],{autoAlpha:0});// SO HAPPY
var tlSoHappy=new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]();tlSoHappy.set('#arm',{rotation:-45,transformOrigin:'90% 100%',x:-10});tlSoHappy.to(['#introtext','#tv'],.5,{autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});tlSoHappy.to('#introtext',2,{autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut},'-=1.5');tlSoHappy.to('#arm',0.65,{rotation:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut});tlSoHappy.to(['#introtext','#sohappy'],0.5,{autoAlpha:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeIn,delay:1});// // SUBSCRIBE BUTTON
var tlSubscribe=new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]();tlSubscribe.to(['#introtext','#subscribe'],.5,{autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});tlSubscribe.from('#cursor',1,{x:-800,y:-500,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});tlSubscribe.to('#cursor',0.5,{x:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut},'-=1');tlSubscribe.add(function(){return _this2.clickBonanza();});tlSubscribe.to('#cursor',0.2,{scale:0.9,transformOrigin:'top left',yoyo:true,repeat:1});tlSubscribe.to('#subscribeButton',0.1,{ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut,scale:0.9,transformOrigin:'center center',yoyo:true,repeat:1},'-=0.3');tlSubscribe.to(['#subscribe',"#introtext"],0.5,{autoAlpha:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeIn,delay:0.5});// WEIRD STUFF
var tlWeridStuff=new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]();tlWeridStuff.to(['#introtext','#weirdstuff'],1,{autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});tlWeridStuff.to('#tentacleL',3,{rotationZ:25,transformOrigin:"100% 100%"},'-=1.5');tlWeridStuff.to('#tentacleR',4,{rotationZ:5,transformOrigin:"0% 100%",ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeInOut},'-=1.5');tlWeridStuff.set('#eye',{autoAlpha:1},'-=3');tlWeridStuff.to('#mover',1,{x:10,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut},'-=2');tlWeridStuff.to('#mover',2,{x:-5,y:3,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});tlWeridStuff.to('#tentacleL',2,{rotationZ:5,transformOrigin:"100% 100%",ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeInOut},'-=3.5');tlWeridStuff.to('#tentacleR',3,{rotationZ:10,transformOrigin:"0% 100%",ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeInOut},'-=3.5');tlWeridStuff.to(['#introtext','#weirdstuff'],1,{autoAlpha:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeIn},'-=2.5');// UNSUBSCRIBE ERROR
var tlUnsubscribe=new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]();tlUnsubscribe.to(['#introtext','#unsubscribe'],0.5,{autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});tlUnsubscribe.from('#unsubscribe-cursor',0.5,{x:-800,y:-500,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});tlUnsubscribe.to('#unsubscribe-cursor',1,{x:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});tlUnsubscribe.add(function(){return _this2.clickBonanza();});tlUnsubscribe.to('#unsubscribe-cursor',0.2,{scale:0.9,transformOrigin:'top left',yoyo:true,repeat:1});tlUnsubscribe.to('#unsubscribe-button',0.1,{ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut,scale:0.9,transformOrigin:'center center',yoyo:true,repeat:1},'-=.2');tlUnsubscribe.to('#unsubscribe-button',0.1,{alpha:0.5,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});tlUnsubscribe.set('#unsubscribe-error-message',{autoAlpha:1});tlUnsubscribe.add(function(){return _this2.props.playSndFx('twoDDarkPatternIncorrect');});tlUnsubscribe.from('#unsubscribe-error-message',.3,{transformOrigin:'center center',scaleX:0,scaleY:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut});tlUnsubscribe.to('#unsubscribe-cursor',2,{x:50,y:65,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut,delay:1.5},'-=1');tlUnsubscribe.to(['#introtext','#unsubscribe'],0.5,{autoAlpha:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeIn,delay:3});tlUnsubscribe.to('#unsubscribe-error-message',0,{autoAlpha:0});// BOXES
var tlBoxes=new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]();tlBoxes.to('#introtext',0.5,{autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});tlBoxes.set('#boxes',{autoAlpha:1});tlBoxes.to('#front',1,{autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeInOut});tlBoxes.to('#mid',1,{autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeInOut});tlBoxes.to('#back',1,{autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeInOut});tlBoxes.to(['#introtext',"#boxes"],0.5,{autoAlpha:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeIn});// LEGEND TELLS OF LEGEND
var tlLegend=new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]();tlLegend.to(['#introtext','#legend'],0.5,{autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});tlLegend.set('#light',{scaleX:0,scaleY:0,autoAlpha:1,transformOrigin:"50% 50%"});tlLegend.set('#fingerbang',{rotationY:-45,scaleX:0.5,scaleY:0.5,transformOrigin:"50% 50%"});tlLegend.add(function(){return _this2.introShimmer();});tlLegend.to(['#light'],0.5,{scaleY:2,scaleX:0.02,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Power2"].easeIn,transformOrigin:"50% 50%"});tlLegend.to(['#light'],0.2,{scaleX:1.32,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut,transformOrigin:"50% 50%",delay:0.4});tlLegend.to('#fingerbang',3,{transformOrigin:"50% 50%",scaleX:1,scaleY:1},'-=1');tlLegend.to(['#light'],2,{autoAlpha:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeIn,transformOrigin:"50% 50%"},'-=2');tlLegend.to(['#introtext',"#legend"],0.5,{autoAlpha:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeIn});// UNSUBSCRIBE
var tlUnsubscribe2=new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]();tlUnsubscribe2.to('#introtext',0.5,{autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut});tlUnsubscribe2.set('#unsubscribe-cursor',{clearProps:'all'});tlUnsubscribe2.to('#unsubscribe-button',0,{autoAlpha:1});tlUnsubscribe2.to('#unsubscribe-cursor',0,{x:-800,y:-500});tlUnsubscribe2.to('#unsubscribe',0.5,{autoAlpha:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut,delay:0.5});tlUnsubscribe2.to('#unsubscribe-cursor',0.5,{x:0,y:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeOut},'-=0.5');tlUnsubscribe2.add(function(){return _this2.clickBonanza();});tlUnsubscribe2.to('#unsubscribe-cursor',0.2,{scale:0.9,transformOrigin:'top left',yoyo:true,repeat:1,delay:0.1});tlUnsubscribe2.to('#unsubscribe-button',0.2,{scale:0.9,transformOrigin:'center center',yoyo:true,repeat:1},'-=0.2');tlUnsubscribe2.to(['#unsubscribe-button','#unsubscribe-cursor'],0.07,{scale:0.9,transformOrigin:'center center',yoyo:true,repeat:50,delay:.25,onRepeat:function onRepeat(){return _this2.clickBonanza();}});tlUnsubscribe2.to('#unsubscribe-cursor-red',3,{alpha:1},'-=3');tlUnsubscribe2.to('#unsubscribe-cursor',3.5,{x:-140,y:-15},'-=3');tlUnsubscribe2.to('#unsubscribe-cursor',0,{autoAlpha:0});tlUnsubscribe2.set('#unsubscribe-error-message2',{autoAlpha:1},'-=1');tlUnsubscribe2.add(function(){return _this2.props.playSndFx('twoDDarkPatternIncorrect');});tlUnsubscribe2.from('#unsubscribe-error-message2',0.7,{transformOrigin:'center center',scaleX:0,scaleY:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut});tlUnsubscribe2.to('#unsubscribe-error-message2',0,{autoAlpha:1,delay:3});//To delay the intro ending too quickly
this.tl=new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]({});// this.tl.timeScale(4)
this.tl.set('#introtext',{text:'Subscribing to Stuff In a Box made you so happy.'});this.tl.add(tlSoHappy);this.tl.set('#introtext',{text:'Stuff! In boxes! Each one a new surprise.'});this.tl.add(tlSubscribe);this.tl.set('#introtext',{text:'But this wasn\'t the sort of stuff you expected.'});this.tl.add(tlWeridStuff);this.tl.set('#introtext',{text:'You tried to cut and run, but nothing worked.'},13);this.tl.add(tlUnsubscribe,13);this.tl.set('#introtext',{text:'The stuff never stopped. Neither did the boxes.'});this.tl.add(tlBoxes);this.tl.set('#introtext',{text:'Legend tells of a force capable of defeating the most evil online experiences.'});this.tl.add(tlLegend);this.tl.set('#introtext',{text:'It\'s time to stop the stuff. It\'s time to unsubscribe.'});this.tl.add(tlUnsubscribe2);this.tl.add(function(){return _this2.animateOut();});}// tick (happenstance) {
//     // console.log(happenstance);
// }
},{key:"clickBonanza",value:function clickBonanza(){this.props.playSndFx('introClick');}},{key:"introShimmer",value:function introShimmer(){this.props.playSndFx('introShimmer');}},{key:"animateOut",value:function animateOut(){this.props.router.push("/play");}},{key:"skip",value:function skip(){this.tl.kill();// kill all timelines so audio doesn't play thru
__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].killAll(true,true,true,true);this.animateOut();}},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"darkpatterns2dbg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bodyWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"body frameBorder intro-animation"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__hud_Hud__["a" /* default */],{hideScore:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"intro-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{id:"introtext"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"skip"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{onClick:function onClick(e){return _this3.skip();}},"Skip")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{version:"1.1",id:"intro",x:"0px",y:"0px",viewBox:"0 0 1024 768",enableBackground:"new 0 0 1024 768",preserveAspectRatio:"xMidYMid meet"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"sohappy"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"tv"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"277.726",y:"167.738",fill:"#383838",width:"468.549",height:"252.525"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{opacity:"0.1",fill:"#FFFFFF",d:"M410,323c152.954,0,283.687-37.945,336.274-91.523v-60.74c0-1.65-1.35-3-3-3H280.726 c-1.65,0-3,1.35-3,3v142.289C318.686,319.464,363.308,323,410,323z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"287.5",y:"178.5",fill:"#FFFFFF",width:"449",height:"227"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"283",y:"412",fill:"#E94343",width:"4",height:"4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_3_",fill:"#991F39",d:"M678.54,232.19v113.036c0,0.533-0.345,0.988-0.863,1.145l-75.514,23.184v-0.11l-76-23.247 c-0.502-0.157-0.847-0.627-0.847-1.161V232.269c0-0.533,0.329-0.988,0.831-1.161l76.016-24.298l75.53,24.235 C678.195,231.202,678.54,231.673,678.54,232.19z M672.548,250.684v-6.008c0-0.627-0.267-1.176-0.58-1.255l-17.396-4.282 c-0.392-0.094-0.69,0.376-0.69,1.051v53.788c0,0.674,0.298,1.224,0.69,1.208l4.157-0.11c0.361,0,0.659-0.549,0.659-1.208v-21.537 l11.875,1.035c0.314,0.031,0.58-0.439,0.58-1.067v-6.039c0-0.612-0.267-1.145-0.58-1.192l-11.875-1.553v-14.384l12.58,2.557 C672.282,251.751,672.548,251.296,672.548,250.684z M670.666,335.501c0.674-0.173,1.082-1.694,0.69-2.667l-4.58-11.686 l4.031-11.592c0.376-1.098-0.031-2.494-0.706-2.431l-1.945,0.173c-0.314,0.031-0.596,0.361-0.753,0.878l-2.965,9.741l-3.184-9.192 c-0.173-0.471-0.471-0.753-0.8-0.722l-2.306,0.204c-0.769,0.078-1.239,1.678-0.784,2.761l4.502,11.09l-4.894,14.024 c-0.424,1.239,0.031,2.667,0.8,2.478l2.086-0.486c0.329-0.078,0.643-0.471,0.816-1.02l3.592-11.859l3.577,10.196 c0.157,0.439,0.439,0.674,0.737,0.596L670.666,335.501z M643.889,342.701c5.898-1.427,10.008-8.753,10.008-18.651 c0-9.914-4.11-15.875-10.008-15.357c-6.227,0.549-10.98,7.922-10.98,18.808C632.909,338.402,637.662,344.206,643.889,342.701z M650.289,246.057v-6.729c0-0.675-0.314-1.318-0.706-1.412l-22.008-5.412c-0.486-0.11-0.878,0.408-0.878,1.176v60.832 c0,0.753,0.392,1.365,0.878,1.349l5.302-0.125c0.471-0.016,0.831-0.627,0.831-1.365v-24.282l14.98,1.318 c0.392,0.031,0.722-0.502,0.722-1.192v-6.745c0-0.69-0.329-1.302-0.722-1.349l-14.98-1.961v-16.204l15.875,3.2 C649.976,247.233,650.289,246.747,650.289,246.057z M630.148,335.579c0-4.455-1.945-7.498-4.91-7.608v-0.094 c2.337-1.506,3.875-4.376,3.875-8.235c0-7.514-4.282-8.392-8.376-8.016l-7.733,0.706c-0.784,0.078-1.427,1.067-1.427,2.227v32.926 c0,1.161,0.643,1.945,1.427,1.757l8.612-2.055C625.724,346.199,630.148,342.779,630.148,335.579z M620.752,272.096v-39.843 c0-0.784-0.424-1.522-0.941-1.647l-5.929-1.459c-0.549-0.141-0.988,0.408-0.988,1.208v40.769c0,6.667-2.463,15.373-10.667,15.263 c-0.016,0-0.031,0-0.063,0v-77.993l-75.342,24.094v112.33l75.342,23.059v-69.585c0.016,0,0.047,0,0.063,0 C613.081,297.947,620.752,287.845,620.752,272.096z M643.889,315.265c-3.702,0.439-6.196,5.239-6.196,11.451 c0,6.196,2.494,10.18,6.196,9.396c3.592-0.753,5.882-5.506,5.882-11.388C649.772,318.857,647.481,314.857,643.889,315.265z M621.081,332.536l-4.016,0.706v8.251l4.737-0.988c1.616-0.345,3.404-1.757,3.404-4.831 C625.207,332.348,622.775,332.238,621.081,332.536z M620.674,318.308l-3.608,0.424v7.749l3.843-0.58 c1.6-0.235,3.231-1.49,3.231-4.329C624.14,318.638,622.305,318.104,620.674,318.308z M591.575,271.218v-40.534 c0-0.8-0.455-1.349-0.988-1.208l-5.929,1.443c-0.518,0.125-0.925,0.847-0.925,1.631v39.624c0,15.639,7.624,25.679,18.431,26.055 v-11.843C594.022,286.465,591.575,277.822,591.575,271.218z M593.018,346.465c0.408,1.459-0.282,2.824-1.302,2.588l-3.043-0.722 c-0.565-0.141-1.051-0.753-1.271-1.553l-1.71-6.682l-8.847-1.82l-1.506,5.694c-0.188,0.69-0.643,1.067-1.145,0.941l-2.51-0.596 c-0.847-0.204-1.427-1.71-1.082-2.871l8.267-28.8c0.204-0.706,0.659-1.129,1.161-1.082l2.463,0.235 c0.518,0.047,0.988,0.549,1.192,1.302L593.018,346.465z M583.936,333.163l-2.824-11.357l-2.729,10.353L583.936,333.163z M579.277,232.222l-24.471,5.961c-0.392,0.094-0.706,0.722-0.706,1.412v6.682c0,0.69,0.314,1.176,0.706,1.098l8.345-1.678v48.502 c0,0.706,0.345,1.286,0.784,1.302l4.941,0.125c0.455,0.016,0.816-0.58,0.816-1.318v-49.914l9.584-1.914 c0.486-0.11,0.894-0.8,0.894-1.569v-7.514C580.171,232.629,579.763,232.112,579.277,232.222z M559.387,309.697l-1.992-0.173 c-0.58-0.063-1.051,0.69-1.051,1.663v19.969h-0.047l-7.216-21.569c-0.188-0.533-0.486-0.863-0.831-0.894l-3.514-0.314 c-0.518-0.047-0.925,0.659-0.925,1.569v26.133c0,0.926,0.408,1.757,0.925,1.882l1.773,0.424c0.518,0.11,0.941-0.533,0.941-1.474 v-19.655l0.047,0.016l7.326,22.228c0.188,0.565,0.518,0.957,0.863,1.051l3.702,0.863c0.596,0.141,1.067-0.549,1.067-1.537v-28.282 C560.454,310.606,559.983,309.759,559.387,309.697z M542.775,239.735c-5.302,1.333-10.306,7.482-10.306,18.024 c0,18.259,13.475,10.4,13.475,22.384c0,5.02-2.792,7.529-5.192,7.545c-2.024,0.031-3.922-1.553-5.145-4.361 c-0.235-0.502-0.627-0.549-0.878-0.078l-2.322,4.345l-0.392,0.753c-0.22,0.424-0.235,1.129-0.016,1.569 c0.141,0.267,0.267,0.533,0.408,0.784c2.149,3.843,5.114,5.475,8.22,5.569c5.835,0.188,11.137-5.522,11.137-17.6 c0-20.031-14.212-11.906-14.212-22.431c0-4.816,2.306-7.216,4.674-7.718c1.82-0.376,3.624,0.345,4.831,2.4 c0.251,0.439,0.706,0.345,0.957-0.204l3.075-6.353c0.282-0.58,0.251-1.396-0.063-1.773 C548.642,239.688,545.661,239.014,542.775,239.735z M538.634,307.83l-1.631-0.157c-0.471-0.047-0.863,0.643-0.863,1.522v25.145 c0,0.878,0.392,1.678,0.863,1.788l1.631,0.392c0.486,0.11,0.878-0.518,0.878-1.412v-25.584 C539.512,308.63,539.12,307.861,538.634,307.83z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"subscriber"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"body_2_",points:"650.147,458.408 640.016,455.888 634.935,455.503 626.846,464.705 613.118,465.844 605.5,460.214  598.633,456.371 579.867,451.29 565.644,446.506 564.257,449.434 558.075,475.636 550,536 317,536 320,426 341.371,361.017  366.172,341.493 421.168,315.612 430.669,300.813 431.681,282.33 427.235,277.91 426.611,270.72 419.519,255.212 409.934,226.243  410.499,222.706 409.855,189.406 432.393,151.806 442.556,148.329 463.655,145.795 478.951,151.489 487.686,154.482  519.251,182.937 520.42,191.898 519.456,203.903 517.077,216.048 520.411,226.19 509.802,253.129 507.362,257.252  503.197,279.315 498.971,282.194 499.998,307.308 506.168,316.875 528.326,333.463 544.903,343.6 560.109,350.852  593.562,371.701 634.401,397.494 639.87,403.566 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"arm",d:"M638.075,403.324c0,0,2.766,1.606,4.676,0.5c0.626-3.526-0.582-7.056-1.282-10.554 c-2.645-13.229-9.991-39.177-9.991-39.177s-6.113-16.516-10.95-23.964c-1.106-1.703-2.289-3.276-4.239-4.091 c-5.235-2.186-8.554-6.167-10.692-11.307c-1.472-3.538-3.359-6.827-6.218-9.385c-4.107,0.427-6.386,0.312-8.222-1.128 c-1.399-1.097-4.036-5.948-4.036-5.948l-7.112-5.714l-1.838-7.488l-5.041-5.967l0.323-6.808l-0.947-6.812l3.853-5.483l8.841-4.194 l-1.597-14.52l0.589-9.839l9.017-2.948l4.054,8.169l0.89,7.933l1.965,7.534l6.965-1.555l4.213,7.893c0,0,1.044,2.448,1.936,3.457 c1.913,2.164,3.106,4.703,4.001,7.42c3.39,10.295,9.054,19.638,12.549,29.893c0.209,0.612,0.647,1.168,1.061,1.684 c5.869,7.328,14.525,23.852,14.525,23.852l14.892,22.4l19.3,31.341l19.978,50.649l3.494,20.037l-9.947,12.822l-24.69,1.391 l-20.359-5.191L638.075,403.324z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"subscribe"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"subscribeButton"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#008DD3",d:"M817.25,274.995v42.269h-0.2c-133.183,56.204-501.388-59.948-610.2-7.942l0,0v-25.746 c77.8-40.476,517.8,49.955,610.3-8.71L817.25,274.995L817.25,274.995z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#19A1F4",d:"M817.25,256.6V280h-0.2c-92.4,45.8-532.5-24.8-610.3,6.8v-30.2h3.6c0,0,6.1-18.4,26.2-18.4h550.8 c19.9,0,26.2,18.4,26.2,18.4L817.25,256.6L817.25,256.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0083B7",d:"M817.25,316.7c0,13-10.7,23.7-23.7,23.7h-563c-13,0-23.7-10.7-23.7-23.7v-9.8l0,0 c109.7-44.4,477.3,48.8,610.2,6.2h0.2V316.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#85DDFF",d:"M790.45,233.4c12.8,0,23.2,10.4,23.2,23.2c0,0-6.3-18.4-26.2-18.4h-550.8c-20.2,0-26.2,18.4-26.2,18.4 c0-12.7,10.4-23.2,23.2-23.2L790.45,233.4L790.45,233.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#19A1F4",d:"M817.25,252.2v4.4h-3.6c0-12.7-10.4-23.2-23.2-23.2h-556.8c-12.7,0-23.2,10.4-23.2,23.2h-3.6v-4.4 c0-13,10.7-23.7,23.7-23.7h563.1C806.65,228.6,817.25,239.2,817.25,252.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M283.941,308.479l5.655-12.797c4.91,2.902,11.458,4.762,17.187,4.762c4.985,0,6.771-1.042,6.771-2.827 c0-6.547-28.794-1.265-28.794-20.684c0-9.672,8.11-17.559,24.256-17.559c6.993,0,14.21,1.488,19.642,4.538l-5.282,12.723 c-5.134-2.604-9.97-3.869-14.509-3.869c-5.134,0-6.771,1.488-6.771,3.274c0,6.25,28.794,1.042,28.794,20.237 c0,9.523-8.11,17.559-24.255,17.559C297.93,313.836,289.15,311.678,283.941,308.479z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M335.655,289.209v-28.645h17.559v28.124c0,7.961,3.05,10.937,7.961,10.937 c4.91,0,7.961-2.976,7.961-10.937v-28.124h17.261v28.645c0,15.625-9.374,24.627-25.371,24.627 C345.029,313.836,335.655,304.833,335.655,289.209z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M445.774,298.286c0,9.077-7.663,14.359-22.022,14.359h-29.314v-52.081h27.826 c14.359,0,21.056,5.729,21.056,13.615c0,4.836-2.455,8.854-7.217,11.235C442.203,287.646,445.774,292.11,445.774,298.286z M411.698,272.84v7.738h8.185c3.943,0,5.729-1.339,5.729-3.869s-1.785-3.869-5.729-3.869L411.698,272.84L411.698,272.84z M428.066,296.277c0-2.679-1.934-4.092-5.803-4.092h-10.565v8.184h10.565C426.133,300.369,428.066,298.956,428.066,296.277z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M448.68,308.479l5.655-12.797c4.91,2.902,11.458,4.762,17.187,4.762c4.985,0,6.771-1.042,6.771-2.827 c0-6.547-28.794-1.265-28.794-20.684c0-9.672,8.11-17.559,24.256-17.559c6.993,0,14.21,1.488,19.642,4.538l-5.282,12.723 c-5.134-2.604-9.97-3.869-14.509-3.869c-5.134,0-6.771,1.488-6.771,3.274c0,6.25,28.794,1.042,28.794,20.237 c0,9.523-8.11,17.559-24.255,17.559C462.668,313.836,453.889,311.678,448.68,308.479z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M498.756,286.605c0-15.997,12.276-27.231,29.018-27.231c10.192,0,18.229,3.72,23.361,10.416 l-11.086,9.896c-3.05-3.869-6.695-6.101-11.383-6.101c-7.292,0-12.202,5.06-12.202,13.021s4.91,13.02,12.202,13.02 c4.688,0,8.333-2.232,11.383-6.101l11.086,9.896c-5.133,6.696-13.169,10.416-23.361,10.416 C511.032,313.836,498.756,302.601,498.756,286.605z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M578.519,299.551h-4.762v13.095h-17.559v-52.081h25.073c14.508,0,23.734,7.589,23.734,19.642 c0,7.515-3.571,13.169-9.821,16.369l10.937,16.071h-18.749L578.519,299.551z M580.155,274.105h-6.398v12.202h6.398 c4.836,0,7.143-2.306,7.143-6.101C587.298,276.412,584.991,274.105,580.155,274.105z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M611.632,260.564h17.559v52.081h-17.559V260.564z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M689.012,298.286c0,9.077-7.663,14.359-22.022,14.359h-29.314v-52.081h27.826 c14.359,0,21.056,5.729,21.056,13.615c0,4.836-2.455,8.854-7.217,11.235C685.44,287.646,689.012,292.11,689.012,298.286z M654.936,272.84v7.738h8.185c3.943,0,5.729-1.339,5.729-3.869s-1.785-3.869-5.729-3.869L654.936,272.84L654.936,272.84z M671.304,296.277c0-2.679-1.934-4.092-5.803-4.092h-10.565v8.184h10.565C669.37,300.369,671.304,298.956,671.304,296.277z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M738.493,299.402v13.244h-43.302v-52.081h42.334v13.243h-25.073v6.101h22.023v12.648h-22.023v6.845 L738.493,299.402L738.493,299.402z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"cursor",fill:"#FFFFFF",d:"M815.211,427.237c-11.37,10.448-22.569,20.739-34.211,31.437c0-54.982,0-109.545,0-164.176 c36.886,40.296,73.832,80.656,110.777,121.017c-0.037,0.162-0.073,0.324-0.11,0.485c-15.292,0-30.584,0-46.41,0 c6.919,15.392,13.606,30.27,20.398,45.378c-9.272,4.122-18.458,8.206-27.799,12.359 C830.284,458.188,822.778,442.776,815.211,427.237z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"unsubscribe"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"unsubscribe-button",ref:"unsubscribe"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#C70600",d:"M847.25,282v33h-0.2c-132.9,42.7-560.5-50.5-670.2-6.2l0,0v-28.1c77.8-31.6,577.8,39,670.3-6.8L847.25,282 L847.25,282z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E81E14",d:"M847.25,256.6V280h-0.2c-92.4,45.8-592.5-24.8-670.3,6.8v-30.2h3.6c0,0,6.1-18.4,26.2-18.4h610.8 c19.9,0,26.2,18.4,26.2,18.4L847.25,256.6L847.25,256.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#AB0200",d:"M847.25,316.7c0,13-10.7,23.7-23.7,23.7h-623c-13,0-23.7-10.7-23.7-23.7v-9.8l0,0 c109.7-44.4,537.3,48.8,670.2,6.2h0.2V316.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F36C6B",d:"M820.45,233.4c12.8,0,23.2,10.4,23.2,23.2c0,0-6.3-18.4-26.2-18.4h-610.8c-20.2,0-26.2,18.4-26.2,18.4 c0-12.7,10.4-23.2,23.2-23.2L820.45,233.4L820.45,233.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#E81E14",d:"M847.25,252.2v4.4h-3.6c0-12.7-10.4-23.2-23.2-23.2h-616.8c-12.7,0-23.2,10.4-23.2,23.2h-3.6v-4.4 c0-13,10.7-23.7,23.7-23.7h623.1C836.65,228.6,847.25,239.2,847.25,252.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Unsubscribe"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M227.689,289.209v-28.645h17.559v28.124c0,7.961,3.051,10.937,7.961,10.937 c4.91,0,7.961-2.976,7.961-10.937v-28.124h17.262v28.645c0,15.625-9.375,24.627-25.371,24.627S227.689,304.833,227.689,289.209z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M337.809,260.564v52.081h-14.434l-19.791-23.66v23.66h-17.111v-52.081h14.434l19.791,23.66v-23.66H337.809 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M343.021,308.479l5.654-12.797c4.91,2.902,11.459,4.762,17.188,4.762c4.984,0,6.77-1.042,6.77-2.827 c0-6.547-28.793-1.265-28.793-20.684c0-9.672,8.109-17.559,24.256-17.559c6.992,0,14.209,1.488,19.641,4.538l-5.281,12.723 c-5.135-2.604-9.971-3.869-14.51-3.869c-5.133,0-6.77,1.488-6.77,3.274c0,6.25,28.793,1.042,28.793,20.237 c0,9.523-8.109,17.559-24.254,17.559C357.01,313.836,348.23,311.678,343.021,308.479z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M394.734,289.209v-28.645h17.559v28.124c0,7.961,3.051,10.937,7.961,10.937s7.961-2.976,7.961-10.937 v-28.124h17.262v28.645c0,15.625-9.375,24.627-25.371,24.627S394.734,304.833,394.734,289.209z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M504.854,298.286c0,9.077-7.662,14.359-22.021,14.359h-29.314v-52.081h27.826 c14.359,0,21.055,5.729,21.055,13.615c0,4.836-2.455,8.854-7.217,11.235C501.283,287.646,504.854,292.11,504.854,298.286z M470.777,272.84v7.738h8.186c3.943,0,5.729-1.339,5.729-3.869s-1.785-3.869-5.729-3.869L470.777,272.84L470.777,272.84z M487.146,296.277c0-2.679-1.934-4.092-5.803-4.092h-10.566v8.184h10.566C485.213,300.369,487.146,298.956,487.146,296.277z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M507.76,308.479l5.654-12.797c4.91,2.902,11.459,4.762,17.188,4.762c4.984,0,6.77-1.042,6.77-2.827 c0-6.547-28.793-1.265-28.793-20.684c0-9.672,8.109-17.559,24.256-17.559c6.992,0,14.209,1.488,19.641,4.538l-5.281,12.723 c-5.135-2.604-9.971-3.869-14.51-3.869c-5.133,0-6.77,1.488-6.77,3.274c0,6.25,28.793,1.042,28.793,20.237 c0,9.523-8.109,17.559-24.254,17.559C521.748,313.836,512.969,311.678,507.76,308.479z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M557.836,286.605c0-15.997,12.275-27.231,29.018-27.231c10.191,0,18.229,3.72,23.361,10.416l-11.086,9.896 c-3.051-3.869-6.695-6.101-11.383-6.101c-7.293,0-12.203,5.06-12.203,13.021s4.91,13.02,12.203,13.02 c4.688,0,8.332-2.232,11.383-6.101l11.086,9.896c-5.133,6.696-13.17,10.416-23.361,10.416 C570.111,313.836,557.836,302.601,557.836,286.605z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M637.598,299.551h-4.762v13.095h-17.559v-52.081h25.074c14.508,0,23.734,7.589,23.734,19.642 c0,7.515-3.572,13.169-9.822,16.369l10.938,16.071h-18.75L637.598,299.551z M639.234,274.105h-6.398v12.202h6.398 c4.836,0,7.143-2.306,7.143-6.101C646.377,276.412,644.07,274.105,639.234,274.105z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M670.711,260.564h17.559v52.081h-17.559V260.564z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M748.09,298.286c0,9.077-7.662,14.359-22.021,14.359h-29.314v-52.081h27.826 c14.359,0,21.055,5.729,21.055,13.615c0,4.836-2.455,8.854-7.217,11.235C744.52,287.646,748.09,292.11,748.09,298.286z M714.014,272.84v7.738h8.186c3.943,0,5.729-1.339,5.729-3.869s-1.785-3.869-5.729-3.869L714.014,272.84L714.014,272.84z M730.383,296.277c0-2.679-1.934-4.092-5.803-4.092h-10.566v8.184h10.566C728.449,300.369,730.383,298.956,730.383,296.277z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M797.572,299.402v13.244H754.27v-52.081h42.334v13.243h-25.072v6.101h22.023v12.648h-22.023v6.845 L797.572,299.402L797.572,299.402z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"unsubscribe-cursor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"unsubscribe-cursor-white",fill:"#FFFFFF",d:"M815.211,427.237c-11.37,10.448-22.569,20.739-34.211,31.437c0-54.982,0-109.545,0-164.176 c36.886,40.296,73.832,80.656,110.777,121.017c-0.037,0.162-0.073,0.324-0.11,0.485c-15.292,0-30.584,0-46.41,0 c6.919,15.392,13.606,30.27,20.398,45.378c-9.272,4.122-18.458,8.206-27.799,12.359 C830.284,458.188,822.778,442.776,815.211,427.237z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"unsubscribe-cursor-red",fill:"#FF0000",d:"M815.211,427.237c-11.37,10.448-22.569,20.739-34.211,31.437c0-54.982,0-109.545,0-164.176 c36.886,40.296,73.832,80.656,110.777,121.017c-0.037,0.162-0.073,0.324-0.11,0.485c-15.292,0-30.584,0-46.41,0 c6.919,15.392,13.606,30.27,20.398,45.378c-9.272,4.122-18.458,8.206-27.799,12.359 C830.284,458.188,822.778,442.776,815.211,427.237z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"unsubscribe-error-message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_2_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_1_",x:"264.404",y:"98",fill:"#FFFFFF",width:"495.192",height:"382.678"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"280.773",cy:"121.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"299.729",cy:"121.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"732.44",y:"119.913",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 130.9794 558.8707)",fill:"#B2AFAA",width:"15.333",height:"2.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"738.696",y:"113.663",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 130.9812 558.8752)",fill:"#B2AFAA",width:"2.833",height:"15.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"matrix(1 0 0 1 315.5261 128.1285)",fill:"#7D6D7F",fontFamily:"'Montserrat-ExtraBold'",fontSize:"18px"},"ERROR")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"BG_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"273.566",y:"142.319",fill:"#E81E14",width:"476.867",height:"330.796"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C70600",points:"273.566,310.591 750.434,389.638 750.434,473.115 273.566,473.115         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AB0200",points:"273.566,443.59 750.434,444.845 750.434,473.115 273.566,473.115      "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"error"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_2_",x:"264.404",y:"98",fill:"#FFFFFF",width:"495.192",height:"382.678"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"280.773",cy:"121.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"299.729",cy:"121.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"732.44",y:"119.913",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 130.9794 558.8707)",fill:"#B2AFAA",width:"15.333",height:"2.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"738.696",y:"113.663",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 130.9812 558.8752)",fill:"#B2AFAA",width:"2.833",height:"15.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M326.905,125.374v2.755h-10.119v-12.604h9.885v2.755h-6.356v2.124h5.6v2.665h-5.6v2.305H326.905z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M334.391,124.78h-1.944v3.349h-3.564v-12.604h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L334.391,124.78z M334.427,118.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C336.642,119.018,335.904,118.333,334.427,118.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M347.711,124.78h-1.944v3.349h-3.564v-12.604h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L347.711,124.78z M347.748,118.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C349.962,119.018,349.224,118.333,347.748,118.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M354.874,121.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554s-2.971,6.554-7.004,6.554 S354.874,125.608,354.874,121.827z M365.281,121.827c0-2.179-1.495-3.602-3.403-3.602s-3.403,1.423-3.403,3.602 s1.495,3.601,3.403,3.601S365.281,124.005,365.281,121.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M376.26,124.78h-1.945v3.349h-3.564v-12.604h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L376.26,124.78z M376.295,118.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C378.51,119.018,377.772,118.333,376.295,118.333z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"BG"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"273.566",y:"142.319",fill:"#E81E14",width:"476.867",height:"330.796"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C70600",points:"273.566,310.591 750.434,389.638 750.434,473.115 273.566,473.115             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AB0200",points:"273.566,443.59 750.434,444.845 750.434,473.115 273.566,473.115          "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M385.538,205.968v-13.375h6.825v13.167c0,4.136,1.723,5.791,4.584,5.791c2.826,0,4.55-1.655,4.55-5.791 v-13.167h6.722v13.375c0,7.204-4.206,11.237-11.341,11.237S385.538,213.172,385.538,205.968z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M432.42,206.037v10.686h-6.549v-9.617c0-2.688-1.172-3.826-3.068-3.826c-2.103,0-3.723,1.31-3.723,4.412 v9.031h-6.549V198.04h6.239v2.034c1.482-1.551,3.584-2.344,5.929-2.344C429.077,197.73,432.42,200.246,432.42,206.037z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M443.661,198.729h4.447v4.895h-4.274v13.099h-6.549v-13.099h-2.723v-4.895h2.723v-0.482 c0-4.481,2.792-7.411,7.79-7.411c1.586,0,3.275,0.31,4.343,0.965l-1.62,4.619c-0.551-0.31-1.275-0.551-1.964-0.551 c-1.379,0-2.172,0.792-2.172,2.447V198.729z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M449.143,207.347c0-5.618,4.447-9.617,10.548-9.617c6.17,0,10.547,3.999,10.547,9.617 c0,5.653-4.377,9.686-10.547,9.686C453.589,217.033,449.143,213,449.143,207.347z M463.62,207.347 c0-2.826-1.689-4.412-3.929-4.412c-2.206,0-3.93,1.586-3.93,4.412c0,2.861,1.724,4.481,3.93,4.481 C461.931,211.828,463.62,210.208,463.62,207.347z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M485.787,197.73v5.894c-0.586-0.069-1-0.103-1.482-0.103c-2.654,0-4.481,1.344-4.481,4.619v8.583h-6.549 V198.04h6.239v2.241C480.857,198.592,483.029,197.73,485.787,197.73z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M501.955,215.964c-1.137,0.724-2.826,1.068-4.55,1.068c-4.792,0-7.583-2.344-7.583-7.135v-6.273h-2.723 v-4.895h2.723v-4.86h6.549v4.86h4.274v4.895h-4.274v6.205c0,1.379,0.793,2.137,1.965,2.137c0.724,0,1.448-0.207,1.999-0.586 L501.955,215.964z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M524.12,198.04v18.683h-6.238v-1.999c-1.414,1.551-3.413,2.309-5.55,2.309 c-4.584,0-7.928-2.62-7.928-8.548V198.04h6.549v9.376c0,2.896,1.137,4.033,3.103,4.033c1.93,0,3.516-1.275,3.516-4.412v-8.997 H524.12z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M548.217,206.037v10.686h-6.549v-9.617c0-2.688-1.172-3.826-3.067-3.826c-2.104,0-3.723,1.31-3.723,4.412 v9.031h-6.55V198.04h6.239v2.034c1.482-1.551,3.585-2.344,5.929-2.344C544.874,197.73,548.217,200.246,548.217,206.037z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M569.833,206.347v10.375h-6.102v-2.413c-0.931,1.792-2.792,2.723-5.515,2.723 c-4.481,0-6.963-2.516-6.963-5.756c0-3.447,2.517-5.584,8.307-5.584h3.724c-0.104-1.896-1.379-2.964-3.965-2.964 c-1.792,0-3.791,0.621-5.066,1.62l-2.206-4.447c2.137-1.413,5.308-2.171,8.238-2.171 C566.352,197.73,569.833,200.418,569.833,206.347z M563.284,210.725v-1.62h-2.827c-2.103,0-2.86,0.758-2.86,1.896 c0,1.103,0.896,1.896,2.447,1.896C561.491,212.896,562.767,212.207,563.284,210.725z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M586.863,215.964c-1.138,0.724-2.826,1.068-4.55,1.068c-4.791,0-7.583-2.344-7.583-7.135v-6.273h-2.724 v-4.895h2.724v-4.86h6.549v4.86h4.274v4.895h-4.274v6.205c0,1.379,0.793,2.137,1.965,2.137c0.724,0,1.447-0.207,1.999-0.586 L586.863,215.964z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M607.823,209.036h-13.581c0.551,1.896,2.171,2.999,4.584,2.999c1.827,0,3.033-0.517,4.309-1.62 l3.447,3.585c-1.792,2-4.412,3.033-7.963,3.033c-6.652,0-10.961-4.102-10.961-9.686c0-5.618,4.378-9.617,10.271-9.617 c5.516,0,9.997,3.516,9.997,9.686C607.927,207.898,607.857,208.519,607.823,209.036z M594.139,205.589h7.652 c-0.345-1.965-1.793-3.206-3.826-3.206C595.931,202.383,594.518,203.624,594.139,205.589z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M610.963,191.146h6.55v25.577h-6.55V191.146z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M641.436,198.04l-8.066,19.441c-1.965,4.826-4.723,6.239-8.41,6.239c-1.965,0-4.171-0.655-5.412-1.689 l2.275-4.584c0.758,0.689,1.861,1.103,2.896,1.103c1.275,0,1.999-0.482,2.551-1.585l-7.997-18.924h6.722l4.584,11.41l4.619-11.41 H641.436z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M414.939,233.963l-7.824,24.129h-7.308l-4.619-14.684l-4.826,14.684h-7.308l-7.825-24.129h7.032 l4.86,15.408l5.102-15.408h6.273l4.86,15.546l5.067-15.546H414.939z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M434.696,250.405h-13.581c0.552,1.896,2.172,2.999,4.584,2.999c1.827,0,3.034-0.517,4.309-1.62 l3.447,3.585c-1.792,2-4.412,3.033-7.962,3.033c-6.653,0-10.961-4.102-10.961-9.686c0-5.618,4.377-9.617,10.272-9.617 c5.515,0,9.996,3.516,9.996,9.686C434.799,249.268,434.73,249.888,434.696,250.405z M421.012,246.958h7.652 c-0.344-1.965-1.792-3.206-3.826-3.206S421.391,244.993,421.012,246.958z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M464.344,253.404h-10.203l-1.896,4.688h-6.963l10.651-24.129h6.722l10.686,24.129h-7.101L464.344,253.404z M462.345,248.372l-3.103-7.721l-3.102,7.721H462.345z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M487.476,239.099v5.894c-0.586-0.069-1-0.103-1.482-0.103c-2.654,0-4.481,1.344-4.481,4.619v8.583h-6.549 v-18.683h6.239v2.241C482.547,239.961,484.718,239.099,487.476,239.099z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M508.987,250.405h-13.581c0.552,1.896,2.172,2.999,4.584,2.999c1.827,0,3.034-0.517,4.309-1.62 l3.447,3.585c-1.792,2-4.412,3.033-7.962,3.033c-6.653,0-10.961-4.102-10.961-9.686c0-5.618,4.377-9.617,10.272-9.617 c5.515,0,9.996,3.516,9.996,9.686C509.091,249.268,509.022,249.888,508.987,250.405z M495.303,246.958h7.652 c-0.344-1.965-1.792-3.206-3.826-3.206S495.682,244.993,495.303,246.958z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M522.262,247.337v-13.375h6.825v13.167c0,4.136,1.724,5.791,4.584,5.791c2.827,0,4.55-1.655,4.55-5.791 v-13.167h6.722v13.375c0,7.204-4.205,11.237-11.34,11.237C526.467,258.574,522.262,254.542,522.262,247.337z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M569.144,247.406v10.686h-6.549v-9.617c0-2.688-1.172-3.826-3.067-3.826c-2.104,0-3.723,1.31-3.723,4.412 v9.031h-6.55v-18.683h6.239v2.034c1.482-1.551,3.585-2.344,5.929-2.344C565.801,239.099,569.144,241.615,569.144,247.406z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M590.76,247.716v10.375h-6.102v-2.413c-0.931,1.792-2.792,2.723-5.515,2.723 c-4.481,0-6.963-2.516-6.963-5.756c0-3.447,2.517-5.584,8.307-5.584h3.724c-0.104-1.896-1.379-2.964-3.965-2.964 c-1.792,0-3.791,0.621-5.066,1.62l-2.206-4.447c2.137-1.413,5.308-2.171,8.238-2.171 C587.278,239.099,590.76,241.788,590.76,247.716z M584.211,252.094v-1.62h-2.827c-2.103,0-2.86,0.758-2.86,1.896 c0,1.103,0.896,1.896,2.447,1.896C582.418,254.266,583.693,253.576,584.211,252.094z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M615.821,248.716c0,5.963-4.102,9.686-9.169,9.686c-2.447,0-4.273-0.689-5.515-2.171v1.861h-6.239v-25.577 h6.55v8.514c1.274-1.31,3.033-1.93,5.204-1.93C611.72,239.099,615.821,242.787,615.821,248.716z M609.203,248.716 c0-2.826-1.724-4.412-3.93-4.412s-3.929,1.586-3.929,4.412c0,2.861,1.723,4.481,3.929,4.481S609.203,251.577,609.203,248.716z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M618.857,232.515h6.55v25.577h-6.55V232.515z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M648.641,250.405H635.06c0.551,1.896,2.171,2.999,4.584,2.999c1.827,0,3.033-0.517,4.309-1.62l3.447,3.585 c-1.792,2-4.412,3.033-7.963,3.033c-6.652,0-10.961-4.102-10.961-9.686c0-5.618,4.378-9.617,10.271-9.617 c5.516,0,9.997,3.516,9.997,9.686C648.744,249.268,648.675,249.888,648.641,250.405z M634.956,246.958h7.652 c-0.345-1.965-1.793-3.206-3.826-3.206C636.748,243.752,635.335,244.993,634.956,246.958z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M382.245,280.744h-7.411v-5.412h21.613v5.412h-7.376v18.717h-6.825V280.744z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M395.622,290.085c0-5.618,4.447-9.617,10.548-9.617c6.17,0,10.547,3.999,10.547,9.617 c0,5.653-4.377,9.686-10.547,9.686C400.069,299.771,395.622,295.738,395.622,290.085z M410.099,290.085 c0-2.826-1.689-4.412-3.929-4.412c-2.206,0-3.93,1.586-3.93,4.412c0,2.861,1.724,4.481,3.93,4.481 C408.41,294.566,410.099,292.946,410.099,290.085z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M451.845,284.26c0,5.481-4.136,8.893-10.72,8.893h-4.206v6.308h-6.825v-24.129h11.03 C447.709,275.332,451.845,278.745,451.845,284.26z M444.951,284.26c0-2.24-1.413-3.55-4.24-3.55h-3.792v7.066h3.792 C443.538,287.776,444.951,286.466,444.951,284.26z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M467.533,280.468v5.894c-0.586-0.069-1-0.103-1.482-0.103c-2.654,0-4.481,1.344-4.481,4.619v8.583h-6.549 v-18.683h6.239v2.241C462.604,281.33,464.775,280.468,467.533,280.468z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M468.879,290.085c0-5.618,4.447-9.617,10.548-9.617c6.17,0,10.547,3.999,10.547,9.617 c0,5.653-4.377,9.686-10.547,9.686C473.326,299.771,468.879,295.738,468.879,290.085z M483.356,290.085 c0-2.826-1.689-4.412-3.929-4.412c-2.206,0-3.93,1.586-3.93,4.412c0,2.861,1.724,4.481,3.93,4.481 C481.667,294.566,483.356,292.946,483.356,290.085z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M491.838,290.085c0-5.618,4.447-9.617,10.72-9.617c4.24,0,7.48,1.896,8.755,5.136l-5.067,2.585 c-0.896-1.758-2.206-2.517-3.723-2.517c-2.275,0-4.067,1.586-4.067,4.412c0,2.896,1.792,4.481,4.067,4.481 c1.517,0,2.827-0.758,3.723-2.517l5.067,2.585c-1.275,3.24-4.515,5.136-8.755,5.136 C496.285,299.771,491.838,295.772,491.838,290.085z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M532.585,291.774h-13.581c0.551,1.896,2.171,2.999,4.584,2.999c1.827,0,3.033-0.517,4.309-1.62 l3.447,3.585c-1.792,2-4.412,3.033-7.963,3.033c-6.652,0-10.961-4.102-10.961-9.686c0-5.618,4.378-9.617,10.271-9.617 c5.516,0,9.997,3.516,9.997,9.686C532.688,290.637,532.619,291.257,532.585,291.774z M518.9,288.327h7.652 c-0.345-1.965-1.793-3.206-3.826-3.206C520.692,285.122,519.279,286.362,518.9,288.327z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M534.241,297.841l1.965-4.481c1.724,1.068,4.24,1.724,6.515,1.724c2.206,0,2.931-0.483,2.931-1.275 c0-2.517-11.03,0.345-11.03-7.135c0-3.516,3.24-6.205,9.1-6.205c2.62,0,5.515,0.551,7.377,1.585l-1.965,4.447 c-1.861-1.034-3.723-1.379-5.378-1.379c-2.206,0-2.999,0.621-2.999,1.31c0,2.585,10.996-0.207,10.996,7.204 c0,3.447-3.171,6.135-9.237,6.135C539.343,299.771,536.068,298.979,534.241,297.841z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M553.099,297.841l1.965-4.481c1.724,1.068,4.24,1.724,6.515,1.724c2.206,0,2.931-0.483,2.931-1.275 c0-2.517-11.03,0.345-11.03-7.135c0-3.516,3.24-6.205,9.1-6.205c2.62,0,5.515,0.551,7.377,1.585l-1.965,4.447 c-1.861-1.034-3.723-1.379-5.378-1.379c-2.206,0-2.999,0.621-2.999,1.31c0,2.585,10.996-0.207,10.996,7.204 c0,3.447-3.171,6.135-9.237,6.135C558.2,299.771,554.926,298.979,553.099,297.841z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M588.916,280.744h-7.411v-5.412h21.612v5.412h-7.376v18.717h-6.825V280.744z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M625.25,288.775v10.686h-6.549v-9.617c0-2.688-1.172-3.826-3.067-3.826c-2.104,0-3.723,1.31-3.723,4.412 v9.031h-6.55v-25.577h6.55v8.618c1.447-1.344,3.412-2.034,5.618-2.034C621.907,280.468,625.25,282.984,625.25,288.775z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M648.624,291.774h-13.581c0.551,1.896,2.171,2.999,4.584,2.999c1.827,0,3.033-0.517,4.309-1.62 l3.447,3.585c-1.792,2-4.412,3.033-7.963,3.033c-6.652,0-10.961-4.102-10.961-9.686c0-5.618,4.378-9.617,10.271-9.617 c5.516,0,9.997,3.516,9.997,9.686C648.728,290.637,648.658,291.257,648.624,291.774z M634.939,288.327h7.652 c-0.345-1.965-1.793-3.206-3.826-3.206C636.731,285.122,635.318,286.362,634.939,288.327z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M358.82,334.419h-3.723v6.411h-6.825v-24.129h11.03c6.583,0,10.72,3.413,10.72,8.928 c0,3.55-1.723,6.17-4.722,7.618l5.205,7.583h-7.308L358.82,334.419z M358.889,322.079h-3.792v7.066h3.792 c2.827,0,4.24-1.31,4.24-3.516C363.128,323.389,361.715,322.079,358.889,322.079z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M392.465,333.144h-13.581c0.552,1.896,2.172,2.999,4.584,2.999c1.827,0,3.034-0.517,4.309-1.62 l3.447,3.585c-1.792,2-4.412,3.033-7.962,3.033c-6.653,0-10.961-4.102-10.961-9.686c0-5.618,4.377-9.617,10.272-9.617 c5.515,0,9.996,3.516,9.996,9.686C392.569,332.006,392.5,332.626,392.465,333.144z M378.781,329.696h7.652 c-0.344-1.965-1.792-3.206-3.826-3.206S379.16,327.731,378.781,329.696z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M415.356,322.147v25.37h-6.549v-8.341c-1.275,1.31-3.034,1.964-5.205,1.964 c-5.067,0-9.169-3.723-9.169-9.651s4.102-9.651,9.169-9.651c2.447,0,4.274,0.689,5.515,2.171v-1.861H415.356z M408.91,331.489 c0-2.827-1.723-4.447-3.929-4.447s-3.93,1.62-3.93,4.447s1.724,4.447,3.93,4.447S408.91,334.315,408.91,331.489z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M439.212,322.147v18.683h-6.239v-1.999c-1.413,1.551-3.413,2.309-5.549,2.309 c-4.584,0-7.928-2.62-7.928-8.548v-10.444h6.549v9.376c0,2.896,1.137,4.033,3.102,4.033c1.931,0,3.516-1.275,3.516-4.412v-8.997 H439.212z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M462.413,333.144h-13.581c0.552,1.896,2.172,2.999,4.584,2.999c1.827,0,3.034-0.517,4.309-1.62 l3.447,3.585c-1.792,2-4.412,3.033-7.962,3.033c-6.653,0-10.961-4.102-10.961-9.686c0-5.618,4.377-9.617,10.272-9.617 c5.515,0,9.996,3.516,9.996,9.686C462.516,332.006,462.447,332.626,462.413,333.144z M448.729,329.696h7.652 c-0.344-1.965-1.792-3.206-3.826-3.206S449.107,327.731,448.729,329.696z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M464.07,339.21l1.965-4.481c1.723,1.068,4.24,1.724,6.515,1.724c2.206,0,2.93-0.483,2.93-1.275 c0-2.517-11.03,0.345-11.03-7.135c0-3.516,3.24-6.205,9.1-6.205c2.62,0,5.515,0.551,7.376,1.585l-1.965,4.447 c-1.861-1.034-3.723-1.379-5.377-1.379c-2.206,0-2.999,0.621-2.999,1.31c0,2.585,10.996-0.207,10.996,7.204 c0,3.447-3.171,6.135-9.238,6.135C469.172,341.14,465.897,340.348,464.07,339.21z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M497.301,340.072c-1.137,0.724-2.826,1.068-4.55,1.068c-4.792,0-7.583-2.344-7.583-7.135v-6.273h-2.723 v-4.895h2.723v-4.86h6.549v4.86h4.274v4.895h-4.274v6.205c0,1.379,0.793,2.137,1.965,2.137c0.724,0,1.448-0.207,1.999-0.586 L497.301,340.072z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M523.087,332.178v8.652h-6.825v-8.755l-9.203-15.374h7.204l5.722,9.583l5.723-9.583h6.618L523.087,332.178 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M530.501,331.454c0-5.618,4.446-9.617,10.548-9.617c6.17,0,10.548,3.999,10.548,9.617 c0,5.653-4.378,9.686-10.548,9.686C534.947,341.14,530.501,337.107,530.501,331.454z M544.979,331.454 c0-2.826-1.689-4.412-3.93-4.412c-2.206,0-3.93,1.586-3.93,4.412c0,2.861,1.724,4.481,3.93,4.481 C543.289,335.936,544.979,334.315,544.979,331.454z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M574.279,322.147v18.683h-6.238v-1.999c-1.414,1.551-3.413,2.309-5.55,2.309 c-4.585,0-7.928-2.62-7.928-8.548v-10.444h6.549v9.376c0,2.896,1.138,4.033,3.103,4.033c1.93,0,3.516-1.275,3.516-4.412v-8.997 H574.279z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M611.787,316.701v24.129h-6.825v-9.41h-9.307v9.41h-6.825v-24.129h6.825v9.066h9.307v-9.066H611.787z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M633.816,330.455v10.375h-6.102v-2.413c-0.931,1.792-2.792,2.723-5.515,2.723 c-4.481,0-6.963-2.516-6.963-5.756c0-3.447,2.517-5.584,8.307-5.584h3.724c-0.104-1.896-1.379-2.964-3.965-2.964 c-1.792,0-3.791,0.621-5.066,1.62l-2.206-4.447c2.137-1.413,5.308-2.171,8.238-2.171 C630.335,321.837,633.816,324.526,633.816,330.455z M627.268,334.833v-1.62h-2.827c-2.103,0-2.86,0.758-2.86,1.896 c0,1.103,0.896,1.896,2.447,1.896C625.475,337.004,626.75,336.314,627.268,334.833z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M657.293,322.147l-7.722,18.683h-6.756l-7.687-18.683h6.722l4.48,11.41l4.723-11.41H657.293z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M677.46,333.144h-13.581c0.551,1.896,2.171,2.999,4.584,2.999c1.827,0,3.033-0.517,4.309-1.62l3.447,3.585 c-1.792,2-4.412,3.033-7.963,3.033c-6.652,0-10.961-4.102-10.961-9.686c0-5.618,4.378-9.617,10.271-9.617 c5.516,0,9.997,3.516,9.997,9.686C677.563,332.006,677.494,332.626,677.46,333.144z M663.775,329.696h7.652 c-0.345-1.965-1.793-3.206-3.826-3.206C665.567,326.491,664.154,327.731,663.775,329.696z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M426.388,375.788h-3.723v6.411h-6.825V358.07h11.03c6.583,0,10.72,3.413,10.72,8.928 c0,3.55-1.723,6.17-4.722,7.618l5.205,7.583h-7.308L426.388,375.788z M426.457,363.448h-3.792v7.066h3.792 c2.827,0,4.24-1.31,4.24-3.516C430.697,364.758,429.284,363.448,426.457,363.448z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M460.034,374.513h-13.581c0.552,1.896,2.172,2.999,4.584,2.999c1.827,0,3.034-0.517,4.309-1.62 l3.447,3.585c-1.792,2-4.412,3.033-7.962,3.033c-6.653,0-10.961-4.102-10.961-9.686c0-5.618,4.377-9.617,10.272-9.617 c5.515,0,9.996,3.516,9.996,9.686C460.137,373.375,460.068,373.996,460.034,374.513z M446.35,371.065h7.652 c-0.344-1.965-1.792-3.206-3.826-3.206S446.729,369.101,446.35,371.065z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M482.924,363.517v25.37h-6.549v-8.342c-1.275,1.31-3.034,1.964-5.205,1.964 c-5.067,0-9.169-3.723-9.169-9.651s4.102-9.651,9.169-9.651c2.447,0,4.274,0.689,5.515,2.171v-1.861H482.924z M476.479,372.858 c0-2.827-1.723-4.447-3.929-4.447s-3.93,1.62-3.93,4.447s1.724,4.447,3.93,4.447S476.479,375.685,476.479,372.858z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M506.781,363.517v18.683h-6.239V380.2c-1.413,1.551-3.413,2.309-5.549,2.309 c-4.584,0-7.928-2.62-7.928-8.548v-10.444h6.549v9.376c0,2.896,1.137,4.033,3.102,4.033c1.931,0,3.516-1.275,3.516-4.412v-8.997 H506.781z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M529.981,374.513H516.4c0.551,1.896,2.171,2.999,4.584,2.999c1.827,0,3.033-0.517,4.309-1.62l3.447,3.585 c-1.792,2-4.412,3.033-7.963,3.033c-6.652,0-10.961-4.102-10.961-9.686c0-5.618,4.378-9.617,10.271-9.617 c5.516,0,9.997,3.516,9.997,9.686C530.085,373.375,530.016,373.996,529.981,374.513z M516.297,371.065h7.652 c-0.345-1.965-1.793-3.206-3.826-3.206C518.089,367.86,516.676,369.101,516.297,371.065z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M531.639,380.579l1.965-4.481c1.724,1.068,4.24,1.724,6.515,1.724c2.206,0,2.931-0.483,2.931-1.275 c0-2.517-11.03,0.345-11.03-7.135c0-3.516,3.24-6.205,9.1-6.205c2.62,0,5.515,0.551,7.377,1.585l-1.965,4.447 c-1.861-1.034-3.723-1.379-5.378-1.379c-2.206,0-2.999,0.621-2.999,1.31c0,2.585,10.996-0.207,10.996,7.204 c0,3.447-3.171,6.135-9.237,6.135C536.74,382.509,533.466,381.717,531.639,380.579z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M564.869,381.441c-1.138,0.724-2.826,1.068-4.55,1.068c-4.791,0-7.583-2.344-7.583-7.135v-6.273h-2.724 v-4.895h2.724v-4.86h6.549v4.86h4.274v4.895h-4.274v6.205c0,1.379,0.793,2.137,1.965,2.137c0.724,0,1.447-0.207,1.999-0.586 L564.869,381.441z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M585.829,374.513h-13.581c0.551,1.896,2.171,2.999,4.584,2.999c1.827,0,3.033-0.517,4.309-1.62 l3.447,3.585c-1.792,2-4.412,3.033-7.963,3.033c-6.652,0-10.961-4.102-10.961-9.686c0-5.618,4.378-9.617,10.271-9.617 c5.516,0,9.997,3.516,9.997,9.686C585.933,373.375,585.863,373.996,585.829,374.513z M572.145,371.065h7.652 c-0.345-1.965-1.793-3.206-3.826-3.206C573.937,367.86,572.523,369.101,572.145,371.065z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M608.823,356.623v25.577h-6.239v-1.861c-1.24,1.482-3.067,2.171-5.48,2.171 c-5.102,0-9.203-3.723-9.203-9.686c0-5.929,4.102-9.617,9.203-9.617c2.172,0,3.93,0.621,5.171,1.93v-8.514H608.823z M602.378,372.823c0-2.826-1.689-4.412-3.896-4.412c-2.24,0-3.93,1.586-3.93,4.412c0,2.861,1.689,4.481,3.93,4.481 C600.688,377.305,602.378,375.685,602.378,372.823z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M416.425,418.881h-10.203l-1.896,4.688h-6.963l10.651-24.129h6.722l10.686,24.129h-7.101L416.425,418.881z M414.426,413.848l-3.103-7.721l-3.102,7.721H414.426z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M439.765,422.81c-1.137,0.725-2.826,1.069-4.55,1.069c-4.792,0-7.583-2.345-7.583-7.136v-6.273h-2.723 v-4.895h2.723v-4.86h6.549v4.86h4.274v4.895h-4.274v6.205c0,1.378,0.793,2.137,1.965,2.137c0.724,0,1.448-0.207,1.999-0.586 L439.765,422.81z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M457.76,404.852h-7.411v-5.412h21.613v5.412h-7.376v18.717h-6.825V404.852z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M494.094,412.883v10.686h-6.549v-9.617c0-2.688-1.172-3.826-3.068-3.826c-2.103,0-3.723,1.311-3.723,4.412 v9.031h-6.549v-25.576h6.549v8.617c1.448-1.345,3.413-2.034,5.619-2.034C490.75,404.575,494.094,407.092,494.094,412.883z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M497.475,399.336c0-1.965,1.585-3.481,3.999-3.481c2.413,0,3.998,1.413,3.998,3.378 c0,2.068-1.585,3.585-3.998,3.585C499.061,402.817,497.475,401.301,497.475,399.336z M498.199,404.886h6.549v18.683h-6.549 V404.886z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M507.507,421.948l1.965-4.481c1.723,1.069,4.239,1.724,6.515,1.724c2.206,0,2.93-0.482,2.93-1.275 c0-2.516-11.03,0.345-11.03-7.135c0-3.516,3.24-6.205,9.1-6.205c2.62,0,5.516,0.552,7.377,1.586l-1.965,4.446 c-1.861-1.034-3.723-1.379-5.377-1.379c-2.206,0-2.999,0.621-2.999,1.311c0,2.585,10.996-0.207,10.996,7.204 c0,3.447-3.172,6.136-9.238,6.136C512.608,423.879,509.333,423.086,507.507,421.948z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M543.324,404.852h-7.411v-5.412h21.612v5.412h-7.376v18.717h-6.825V404.852z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M558.666,399.336c0-1.965,1.586-3.481,3.998-3.481c2.413,0,3.999,1.413,3.999,3.378 c0,2.068-1.586,3.585-3.999,3.585C560.252,402.817,558.666,401.301,558.666,399.336z M559.39,404.886h6.55v18.683h-6.55V404.886z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M602.064,412.883v10.686h-6.55v-9.617c0-2.688-1.103-3.826-2.826-3.826c-1.896,0-3.274,1.275-3.274,4.171 v9.272h-6.55v-9.617c0-2.688-1.068-3.826-2.826-3.826c-1.931,0-3.309,1.275-3.309,4.171v9.272h-6.55v-18.683h6.239v1.965 c1.413-1.517,3.378-2.275,5.584-2.275c2.551,0,4.723,0.931,6.032,2.931c1.482-1.861,3.792-2.931,6.48-2.931 C598.858,404.575,602.064,407.092,602.064,412.883z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M625.475,415.882h-13.581c0.551,1.896,2.171,2.999,4.584,2.999c1.827,0,3.033-0.518,4.309-1.62 l3.447,3.585c-1.792,1.999-4.412,3.033-7.963,3.033c-6.652,0-10.961-4.103-10.961-9.687c0-5.618,4.378-9.617,10.271-9.617 c5.516,0,9.997,3.517,9.997,9.687C625.578,414.744,625.509,415.364,625.475,415.882z M611.79,412.435h7.652 c-0.345-1.965-1.793-3.206-3.826-3.206C613.582,409.229,612.169,410.47,611.79,412.435z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"unsubscribe-error-message2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_2_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_1_",x:"264.404",y:"98",fill:"#FFFFFF",width:"495.192",height:"382.678"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"280.773",cy:"121.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"299.729",cy:"121.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"732.44",y:"119.913",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 130.9794 558.8707)",fill:"#B2AFAA",width:"15.333",height:"2.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"738.696",y:"113.663",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 130.9812 558.8752)",fill:"#B2AFAA",width:"2.833",height:"15.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M326.905,125.374v2.755h-10.119v-12.604h9.885v2.755h-6.356v2.124h5.6v2.665h-5.6v2.305H326.905z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M334.391,124.78h-1.944v3.349h-3.564v-12.604h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L334.391,124.78z M334.427,118.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C336.642,119.018,335.904,118.333,334.427,118.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M347.711,124.78h-1.944v3.349h-3.564v-12.604h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L347.711,124.78z M347.748,118.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C349.962,119.018,349.224,118.333,347.748,118.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M354.875,121.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554s-2.971,6.554-7.004,6.554 S354.875,125.608,354.875,121.827z M365.282,121.827c0-2.179-1.495-3.602-3.403-3.602s-3.403,1.423-3.403,3.602 s1.495,3.601,3.403,3.601S365.282,124.005,365.282,121.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M376.26,124.78h-1.945v3.349h-3.564v-12.604h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L376.26,124.78z M376.295,118.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C378.51,119.018,377.772,118.333,376.295,118.333z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"BG_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"273.566",y:"142.319",fill:"#E81E14",width:"476.867",height:"330.796"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C70600",points:"273.566,310.591 750.434,389.638 750.434,473.115 273.566,473.115     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AB0200",points:"273.566,443.59 750.434,444.845 750.434,473.115 273.566,473.115  "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"error"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"FRAME_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"frame_2_",x:"264.404",y:"98",fill:"#FFFFFF",width:"495.192",height:"382.678"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"280.773",cy:"121.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#B2AFAA",cx:"299.729",cy:"121.332",r:"6.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"732.44",y:"119.913",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 130.9794 558.8707)",fill:"#B2AFAA",width:"15.333",height:"2.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"738.696",y:"113.663",transform:"matrix(0.7071 -0.7071 0.7071 0.7071 130.9812 558.8752)",fill:"#B2AFAA",width:"2.833",height:"15.333"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M326.905,125.374v2.755h-10.119v-12.604h9.885v2.755h-6.356v2.124h5.6v2.665h-5.6v2.305H326.905z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M334.391,124.78h-1.944v3.349h-3.564v-12.604h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L334.391,124.78z M334.427,118.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C336.642,119.018,335.904,118.333,334.427,118.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M347.711,124.78h-1.944v3.349h-3.564v-12.604h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L347.711,124.78z M347.748,118.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C349.962,119.018,349.224,118.333,347.748,118.333z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M354.875,121.827c0-3.781,2.971-6.554,7.004-6.554s7.004,2.773,7.004,6.554s-2.971,6.554-7.004,6.554 S354.875,125.608,354.875,121.827z M365.282,121.827c0-2.179-1.495-3.602-3.403-3.602s-3.403,1.423-3.403,3.602 s1.495,3.601,3.403,3.601S365.282,124.005,365.282,121.827z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7D6D7F",d:"M376.26,124.78h-1.945v3.349h-3.564v-12.604h5.762c3.438,0,5.6,1.782,5.6,4.663 c0,1.854-0.9,3.223-2.467,3.979l2.719,3.961h-3.817L376.26,124.78z M376.295,118.333h-1.98v3.691h1.98 c1.477,0,2.215-0.685,2.215-1.837C378.51,119.018,377.772,118.333,376.295,118.333z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"BG"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"273.566",y:"142.319",fill:"#E81E14",width:"476.867",height:"330.796"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C70600",points:"273.566,310.591 750.434,389.638 750.434,473.115 273.566,473.115         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AB0200",points:"273.566,443.59 750.434,444.845 750.434,473.115 273.566,473.115      "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{enableBackground:"new    "},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M406.343,198.006h-7.411v-5.412h21.613v5.412h-7.376v18.717h-6.825V198.006z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M434.921,197.73v5.894c-0.586-0.069-1-0.103-1.482-0.103c-2.654,0-4.481,1.344-4.481,4.619v8.583h-6.549 V198.04h6.239v2.241C429.992,198.592,432.164,197.73,434.921,197.73z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M454.984,206.347v10.375h-6.101v-2.413c-0.931,1.792-2.792,2.723-5.515,2.723 c-4.481,0-6.963-2.516-6.963-5.756c0-3.447,2.516-5.584,8.307-5.584h3.723c-0.104-1.896-1.379-2.964-3.964-2.964 c-1.792,0-3.792,0.621-5.067,1.62l-2.206-4.447c2.137-1.413,5.309-2.171,8.238-2.171 C451.503,197.73,454.984,200.418,454.984,206.347z M448.435,210.725v-1.62h-2.827c-2.103,0-2.861,0.758-2.861,1.896 c0,1.103,0.896,1.896,2.447,1.896C446.643,212.896,447.918,212.207,448.435,210.725z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M479.012,206.037v10.686h-6.549v-9.617c0-2.688-1.172-3.826-3.068-3.826c-2.103,0-3.723,1.31-3.723,4.412 v9.031h-6.549V198.04h6.239v2.034c1.482-1.551,3.584-2.344,5.929-2.344C475.668,197.73,479.012,200.246,479.012,206.037z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M481.635,215.103l1.965-4.481c1.723,1.068,4.24,1.724,6.515,1.724c2.206,0,2.93-0.483,2.93-1.275 c0-2.517-11.03,0.345-11.03-7.135c0-3.516,3.24-6.205,9.1-6.205c2.62,0,5.515,0.551,7.376,1.585l-1.965,4.447 c-1.861-1.034-3.723-1.379-5.377-1.379c-2.206,0-2.999,0.621-2.999,1.31c0,2.585,10.996-0.207,10.996,7.204 c0,3.447-3.171,6.135-9.238,6.135C486.736,217.033,483.461,216.24,481.635,215.103z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M509.109,198.729h4.447v4.895h-4.274v13.099h-6.549v-13.099h-2.723v-4.895h2.723v-0.482 c0-4.481,2.792-7.411,7.79-7.411c1.586,0,3.275,0.31,4.343,0.965l-1.62,4.619c-0.551-0.31-1.275-0.551-1.964-0.551 c-1.379,0-2.172,0.792-2.172,2.447V198.729z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M534.756,209.036h-13.581c0.551,1.896,2.171,2.999,4.584,2.999c1.827,0,3.033-0.517,4.309-1.62l3.447,3.585 c-1.792,2-4.412,3.033-7.963,3.033c-6.652,0-10.961-4.102-10.961-9.686c0-5.618,4.378-9.617,10.271-9.617 c5.516,0,9.997,3.516,9.997,9.686C534.859,207.898,534.79,208.519,534.756,209.036z M521.071,205.589h7.652 c-0.345-1.965-1.793-3.206-3.826-3.206C522.863,202.383,521.45,203.624,521.071,205.589z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M550.407,197.73v5.894c-0.586-0.069-1-0.103-1.482-0.103c-2.654,0-4.48,1.344-4.48,4.619v8.583h-6.55 V198.04h6.239v2.241C545.478,198.592,547.649,197.73,550.407,197.73z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M565.609,197.73v5.894c-0.586-0.069-1-0.103-1.482-0.103c-2.654,0-4.48,1.344-4.48,4.619v8.583h-6.55 V198.04h6.239v2.241C560.68,198.592,562.852,197.73,565.609,197.73z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M567.576,192.491c0-1.965,1.586-3.481,3.998-3.481c2.413,0,3.999,1.413,3.999,3.378 c0,2.068-1.586,3.585-3.999,3.585C569.162,195.972,567.576,194.455,567.576,192.491z M568.3,198.04h6.55v18.683h-6.55V198.04z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M598.979,206.037v10.686h-6.549v-9.617c0-2.688-1.172-3.826-3.067-3.826c-2.104,0-3.723,1.31-3.723,4.412 v9.031h-6.55V198.04h6.239v2.034c1.482-1.551,3.585-2.344,5.929-2.344C595.636,197.73,598.979,200.246,598.979,206.037z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M623.455,198.04v15.27c0,7.066-3.998,10.41-10.961,10.41c-3.585,0-6.997-0.828-9.272-2.448l2.378-4.584 c1.552,1.241,4.103,2,6.309,2c3.516,0,4.998-1.585,4.998-4.516v-0.621c-1.275,1.482-3.172,2.206-5.55,2.206 c-4.964,0-9.169-3.516-9.169-9.031c0-5.481,4.205-8.997,9.169-8.997c2.585,0,4.584,0.827,5.859,2.585v-2.275H623.455z M616.975,206.727c0-2.275-1.723-3.792-4.067-3.792c-2.344,0-4.102,1.517-4.102,3.792s1.758,3.826,4.102,3.826 C615.252,210.553,616.975,209.001,616.975,206.727z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M427.544,249.44v8.652h-6.825v-8.755l-9.204-15.374h7.204l5.722,9.583l5.722-9.583h6.618L427.544,249.44z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M434.958,248.716c0-5.618,4.447-9.617,10.548-9.617c6.17,0,10.547,3.999,10.547,9.617 c0,5.653-4.377,9.686-10.547,9.686C439.405,258.402,434.958,254.369,434.958,248.716z M449.435,248.716 c0-2.826-1.689-4.412-3.929-4.412c-2.206,0-3.93,1.586-3.93,4.412c0,2.861,1.724,4.481,3.93,4.481 C447.746,253.197,449.435,251.577,449.435,248.716z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M478.737,239.409v18.683h-6.239v-1.999c-1.413,1.551-3.413,2.309-5.549,2.309 c-4.584,0-7.928-2.62-7.928-8.548v-10.444h6.549v9.376c0,2.896,1.137,4.033,3.102,4.033c1.931,0,3.516-1.275,3.516-4.412v-8.997 H478.737z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M498.422,239.375h-7.411v-5.412h21.613v5.412h-7.376v18.717h-6.825V239.375z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M511.798,248.716c0-5.618,4.447-9.617,10.547-9.617c6.17,0,10.548,3.999,10.548,9.617 c0,5.653-4.378,9.686-10.548,9.686C516.245,258.402,511.798,254.369,511.798,248.716z M526.275,248.716 c0-2.826-1.688-4.412-3.93-4.412c-2.206,0-3.929,1.586-3.929,4.412c0,2.861,1.723,4.481,3.929,4.481 C524.587,253.197,526.275,251.577,526.275,248.716z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M545.03,246.027c0-7.238,5.688-12.547,13.409-12.547c7.721,0,13.408,5.309,13.408,12.547 c0,7.239-5.688,12.547-13.408,12.547C550.718,258.574,545.03,253.266,545.03,246.027z M564.954,246.027 c0-4.171-2.861-6.894-6.515-6.894c-3.654,0-6.516,2.723-6.516,6.894s2.861,6.894,6.516,6.894 C562.093,252.921,564.954,250.198,564.954,246.027z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M594.773,239.409v18.683h-6.238v-1.999c-1.414,1.551-3.413,2.309-5.55,2.309 c-4.585,0-7.928-2.62-7.928-8.548v-10.444h6.549v9.376c0,2.896,1.138,4.033,3.103,4.033c1.93,0,3.516-1.275,3.516-4.412v-8.997 H594.773z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M611.494,239.099v5.894c-0.586-0.069-1-0.103-1.482-0.103c-2.654,0-4.48,1.344-4.48,4.619v8.583h-6.55 v-18.683h6.239v2.241C606.564,239.961,608.736,239.099,611.494,239.099z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M376.419,294.773h-10.203l-1.896,4.688h-6.963l10.651-24.129h6.722l10.686,24.129h-7.101L376.419,294.773z M374.42,289.741l-3.103-7.721l-3.102,7.721H374.42z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M416.993,280.778l-6.652,18.683h-6.342l-3.516-10.168l-3.654,10.168h-6.342l-6.653-18.683h6.205 l3.826,11.306l3.964-11.306h5.584l3.861,11.41l3.964-11.41H416.993z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M435.852,289.085v10.375h-6.101v-2.413c-0.931,1.792-2.792,2.723-5.515,2.723 c-4.481,0-6.963-2.516-6.963-5.756c0-3.447,2.516-5.584,8.307-5.584h3.723c-0.104-1.896-1.379-2.964-3.964-2.964 c-1.792,0-3.792,0.621-5.067,1.62l-2.206-4.447c2.137-1.413,5.309-2.171,8.238-2.171 C432.371,280.468,435.852,283.157,435.852,289.085z M429.303,293.463v-1.62h-2.827c-2.103,0-2.861,0.758-2.861,1.896 c0,1.103,0.896,1.896,2.447,1.896C427.51,295.635,428.786,294.945,429.303,293.463z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M452.503,280.468v5.894c-0.586-0.069-1-0.103-1.482-0.103c-2.654,0-4.481,1.344-4.481,4.619v8.583h-6.549 v-18.683h6.239v2.241C447.574,281.33,449.746,280.468,452.503,280.468z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M474.875,273.884v25.577h-6.239V297.6c-1.241,1.482-3.068,2.171-5.481,2.171 c-5.102,0-9.203-3.723-9.203-9.686c0-5.929,4.102-9.617,9.203-9.617c2.172,0,3.93,0.621,5.17,1.93v-8.514H474.875z M468.43,290.085 c0-2.826-1.689-4.412-3.895-4.412c-2.241,0-3.93,1.586-3.93,4.412c0,2.861,1.689,4.481,3.93,4.481 C466.741,294.566,468.43,292.946,468.43,290.085z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M527.272,275.332l-7.824,24.129h-7.308l-4.619-14.684l-4.826,14.684h-7.308l-7.825-24.129h7.032 l4.86,15.408l5.102-15.408h6.273l4.861,15.546l5.066-15.546H527.272z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M545.547,289.085v10.375h-6.102v-2.413c-0.931,1.792-2.792,2.723-5.515,2.723 c-4.481,0-6.963-2.516-6.963-5.756c0-3.447,2.517-5.584,8.307-5.584h3.724c-0.104-1.896-1.379-2.964-3.965-2.964 c-1.792,0-3.791,0.621-5.066,1.62l-2.206-4.447c2.137-1.413,5.308-2.171,8.238-2.171 C542.065,280.468,545.547,283.157,545.547,289.085z M538.998,293.463v-1.62h-2.827c-2.103,0-2.86,0.758-2.86,1.896 c0,1.103,0.896,1.896,2.447,1.896C537.205,295.635,538.48,294.945,538.998,293.463z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M562.577,298.703c-1.138,0.724-2.826,1.068-4.55,1.068c-4.791,0-7.583-2.344-7.583-7.135v-6.273h-2.724 v-4.895h2.724v-4.86h6.549v4.86h4.274v4.895h-4.274v6.205c0,1.379,0.793,2.137,1.965,2.137c0.724,0,1.447-0.207,1.999-0.586 L562.577,298.703z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M563.371,290.085c0-5.618,4.446-9.617,10.72-9.617c4.24,0,7.48,1.896,8.756,5.136l-5.067,2.585 c-0.896-1.758-2.206-2.517-3.723-2.517c-2.275,0-4.067,1.586-4.067,4.412c0,2.896,1.792,4.481,4.067,4.481 c1.517,0,2.826-0.758,3.723-2.517l5.067,2.585c-1.275,3.24-4.516,5.136-8.756,5.136 C567.817,299.771,563.371,295.772,563.371,290.085z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M605.151,288.775v10.686h-6.549v-9.617c0-2.688-1.172-3.826-3.067-3.826c-2.104,0-3.723,1.31-3.723,4.412 v9.031h-6.55v-25.577h6.55v8.618c1.447-1.344,3.412-2.034,5.618-2.034C601.809,280.468,605.151,282.984,605.151,288.775z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M608.533,275.229c0-1.965,1.586-3.481,3.998-3.481c2.413,0,3.999,1.413,3.999,3.378 c0,2.068-1.586,3.585-3.999,3.585C610.119,278.71,608.533,277.193,608.533,275.229z M609.257,280.778h6.55v18.683h-6.55V280.778z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M639.936,288.775v10.686h-6.549v-9.617c0-2.688-1.172-3.826-3.067-3.826c-2.104,0-3.723,1.31-3.723,4.412 v9.031h-6.55v-18.683h6.239v2.034c1.482-1.551,3.585-2.344,5.929-2.344C636.593,280.468,639.936,282.984,639.936,288.775z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M664.412,280.778v15.27c0,7.066-3.998,10.41-10.961,10.41c-3.585,0-6.997-0.828-9.272-2.448l2.378-4.584 c1.552,1.241,4.103,2,6.309,2c3.516,0,4.998-1.585,4.998-4.516v-0.621c-1.275,1.482-3.172,2.206-5.55,2.206 c-4.964,0-9.169-3.516-9.169-9.031c0-5.481,4.205-8.997,9.169-8.997c2.585,0,4.584,0.827,5.859,2.585v-2.275H664.412z M657.932,289.465c0-2.275-1.723-3.792-4.067-3.792c-2.344,0-4.102,1.517-4.102,3.792s1.758,3.826,4.102,3.826 C656.209,293.291,657.932,291.74,657.932,289.465z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M351.152,328.766c0-7.342,5.619-12.547,13.271-12.547c4.446,0,8.031,1.62,10.375,4.55l-4.343,3.93 c-1.517-1.827-3.378-2.827-5.688-2.827c-3.964,0-6.722,2.758-6.722,6.894s2.757,6.894,6.722,6.894c2.309,0,4.171-1,5.688-2.827 l4.343,3.93c-2.344,2.93-5.929,4.55-10.375,4.55C356.771,341.312,351.152,336.108,351.152,328.766z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M396.759,322.147v18.683h-6.239v-1.999c-1.413,1.551-3.413,2.309-5.549,2.309 c-4.584,0-7.928-2.62-7.928-8.548v-10.444h6.549v9.376c0,2.896,1.137,4.033,3.102,4.033c1.931,0,3.516-1.275,3.516-4.412v-8.997 H396.759z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M399.484,339.21l1.965-4.481c1.723,1.068,4.24,1.724,6.515,1.724c2.206,0,2.93-0.483,2.93-1.275 c0-2.517-11.03,0.345-11.03-7.135c0-3.516,3.24-6.205,9.1-6.205c2.62,0,5.515,0.551,7.376,1.585l-1.965,4.447 c-1.861-1.034-3.723-1.379-5.377-1.379c-2.206,0-2.999,0.621-2.999,1.31c0,2.585,10.996-0.207,10.996,7.204 c0,3.447-3.171,6.135-9.238,6.135C404.586,341.14,401.311,340.348,399.484,339.21z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M432.715,340.072c-1.137,0.724-2.826,1.068-4.55,1.068c-4.792,0-7.583-2.344-7.583-7.135v-6.273h-2.723 v-4.895h2.723v-4.86h6.549v4.86h4.274v4.895h-4.274v6.205c0,1.379,0.793,2.137,1.965,2.137c0.724,0,1.448-0.207,1.999-0.586 L432.715,340.072z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M433.51,331.454c0-5.618,4.447-9.617,10.548-9.617c6.17,0,10.547,3.999,10.547,9.617 c0,5.653-4.377,9.686-10.547,9.686C437.957,341.14,433.51,337.107,433.51,331.454z M447.987,331.454 c0-2.826-1.689-4.412-3.929-4.412c-2.206,0-3.93,1.586-3.93,4.412c0,2.861,1.724,4.481,3.93,4.481 C446.298,335.936,447.987,334.315,447.987,331.454z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M489.525,330.145v10.686h-6.549v-9.617c0-2.688-1.103-3.826-2.827-3.826c-1.896,0-3.274,1.275-3.274,4.171 v9.272h-6.549v-9.617c0-2.688-1.069-3.826-2.827-3.826c-1.93,0-3.309,1.275-3.309,4.171v9.272h-6.549v-18.683h6.239v1.965 c1.413-1.517,3.378-2.275,5.584-2.275c2.551,0,4.722,0.931,6.032,2.93c1.482-1.861,3.792-2.93,6.48-2.93 C486.319,321.837,489.525,324.354,489.525,330.145z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M512.935,333.144h-13.581c0.552,1.896,2.172,2.999,4.584,2.999c1.827,0,3.034-0.517,4.309-1.62l3.447,3.585 c-1.792,2-4.412,3.033-7.962,3.033c-6.653,0-10.961-4.102-10.961-9.686c0-5.618,4.377-9.617,10.272-9.617 c5.515,0,9.996,3.516,9.996,9.686C513.038,332.006,512.969,332.626,512.935,333.144z M499.25,329.696h7.652 c-0.344-1.965-1.792-3.206-3.826-3.206S499.629,327.731,499.25,329.696z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M528.586,321.837v5.894c-0.586-0.069-1-0.103-1.482-0.103c-2.654,0-4.48,1.344-4.48,4.619v8.583h-6.55 v-18.683h6.239v2.241C523.656,322.699,525.828,321.837,528.586,321.837z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M539.997,338.659l2.241-5.033c2.137,1.413,5.17,2.378,7.962,2.378c2.826,0,3.93-0.793,3.93-1.965 c0-3.826-13.719-1.034-13.719-9.996c0-4.309,3.516-7.825,10.686-7.825c3.137,0,6.377,0.724,8.755,2.103l-2.103,5.067 c-2.31-1.241-4.584-1.861-6.687-1.861c-2.861,0-3.896,0.965-3.896,2.171c0,3.688,13.685,0.931,13.685,9.824 c0,4.206-3.516,7.79-10.686,7.79C546.202,341.312,542.272,340.244,539.997,338.659z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M582.674,333.144h-13.581c0.551,1.896,2.171,2.999,4.584,2.999c1.827,0,3.033-0.517,4.309-1.62l3.447,3.585 c-1.792,2-4.412,3.033-7.963,3.033c-6.652,0-10.961-4.102-10.961-9.686c0-5.618,4.378-9.617,10.271-9.617 c5.516,0,9.997,3.516,9.997,9.686C582.777,332.006,582.708,332.626,582.674,333.144z M568.989,329.696h7.652 c-0.345-1.965-1.793-3.206-3.826-3.206C570.781,326.491,569.368,327.731,568.989,329.696z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M598.325,321.837v5.894c-0.586-0.069-1-0.103-1.482-0.103c-2.654,0-4.48,1.344-4.48,4.619v8.583h-6.55 v-18.683h6.239v2.241C593.396,322.699,595.567,321.837,598.325,321.837z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M621.284,322.147l-7.722,18.683h-6.756l-7.687-18.683h6.722l4.48,11.41l4.723-11.41H621.284z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M622.252,316.598c0-1.965,1.586-3.481,3.998-3.481c2.413,0,3.999,1.413,3.999,3.378 c0,2.068-1.586,3.585-3.999,3.585C623.838,320.08,622.252,318.562,622.252,316.598z M622.976,322.147h6.55v18.683h-6.55V322.147z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M632.594,331.454c0-5.618,4.446-9.617,10.72-9.617c4.24,0,7.48,1.896,8.756,5.136l-5.067,2.585 c-0.896-1.758-2.206-2.517-3.723-2.517c-2.275,0-4.067,1.586-4.067,4.412c0,2.896,1.792,4.481,4.067,4.481 c1.517,0,2.826-0.758,3.723-2.517l5.067,2.585c-1.275,3.24-4.516,5.136-8.756,5.136C637.04,341.14,632.594,337.142,632.594,331.454 z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M673.34,333.144h-13.581c0.551,1.896,2.171,2.999,4.584,2.999c1.827,0,3.033-0.517,4.309-1.62l3.447,3.585 c-1.792,2-4.412,3.033-7.963,3.033c-6.652,0-10.961-4.102-10.961-9.686c0-5.618,4.378-9.617,10.271-9.617 c5.516,0,9.997,3.516,9.997,9.686C673.443,332.006,673.374,332.626,673.34,333.144z M659.655,329.696h7.652 c-0.345-1.965-1.793-3.206-3.826-3.206C661.447,326.491,660.034,327.731,659.655,329.696z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M402.173,358.07h11.409c7.997,0,13.478,4.654,13.478,12.064c0,7.411-5.48,12.064-13.478,12.064h-11.409 V358.07z M413.306,376.753c4.102,0,6.86-2.447,6.86-6.618s-2.758-6.618-6.86-6.618h-4.309v13.236H413.306z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M449.33,374.513h-13.581c0.552,1.896,2.172,2.999,4.584,2.999c1.827,0,3.034-0.517,4.309-1.62l3.447,3.585 c-1.792,2-4.412,3.033-7.962,3.033c-6.653,0-10.961-4.102-10.961-9.686c0-5.618,4.377-9.617,10.272-9.617 c5.515,0,9.996,3.516,9.996,9.686C449.434,373.375,449.365,373.996,449.33,374.513z M435.646,371.065h7.652 c-0.344-1.965-1.792-3.206-3.826-3.206S436.025,369.101,435.646,371.065z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M473.393,372.858c0,5.929-4.102,9.651-9.169,9.651c-2.172,0-3.93-0.655-5.205-1.964v8.342h-6.549v-25.37 h6.239v1.861c1.241-1.482,3.068-2.171,5.515-2.171C469.291,363.207,473.393,366.929,473.393,372.858z M466.775,372.858 c0-2.827-1.724-4.447-3.93-4.447s-3.93,1.62-3.93,4.447s1.724,4.447,3.93,4.447S466.775,375.685,466.775,372.858z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M493.526,371.824v10.375h-6.101v-2.413c-0.931,1.792-2.792,2.723-5.515,2.723 c-4.481,0-6.963-2.516-6.963-5.756c0-3.447,2.516-5.584,8.307-5.584h3.723c-0.104-1.896-1.379-2.964-3.964-2.964 c-1.792,0-3.792,0.621-5.067,1.62l-2.206-4.447c2.137-1.413,5.309-2.171,8.238-2.171 C490.044,363.207,493.526,365.895,493.526,371.824z M486.977,376.202v-1.62h-2.827c-2.103,0-2.861,0.758-2.861,1.896 c0,1.103,0.896,1.896,2.447,1.896C485.184,378.373,486.459,377.684,486.977,376.202z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M510.177,363.207v5.894c-0.586-0.069-1-0.103-1.482-0.103c-2.654,0-4.481,1.344-4.481,4.619v8.583h-6.549 v-18.683h6.239v2.241C505.248,364.068,507.419,363.207,510.177,363.207z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M526.345,381.441c-1.138,0.724-2.826,1.068-4.55,1.068c-4.791,0-7.583-2.344-7.583-7.135v-6.273h-2.724 v-4.895h2.724v-4.86h6.549v4.86h4.274v4.895h-4.274v6.205c0,1.379,0.793,2.137,1.965,2.137c0.724,0,1.447-0.207,1.999-0.586 L526.345,381.441z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M560.747,371.514v10.686h-6.55v-9.617c0-2.688-1.103-3.826-2.826-3.826c-1.896,0-3.274,1.275-3.274,4.171 v9.272h-6.55v-9.617c0-2.688-1.068-3.826-2.826-3.826c-1.931,0-3.309,1.275-3.309,4.171v9.272h-6.55v-18.683h6.239v1.965 c1.413-1.517,3.378-2.275,5.584-2.275c2.551,0,4.723,0.931,6.032,2.93c1.482-1.861,3.792-2.93,6.48-2.93 C557.541,363.207,560.747,365.723,560.747,371.514z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M584.156,374.513h-13.581c0.551,1.896,2.171,2.999,4.584,2.999c1.827,0,3.033-0.517,4.309-1.62l3.447,3.585 c-1.792,2-4.412,3.033-7.963,3.033c-6.652,0-10.961-4.102-10.961-9.686c0-5.618,4.378-9.617,10.271-9.617 c5.516,0,9.997,3.516,9.997,9.686C584.26,373.375,584.19,373.996,584.156,374.513z M570.472,371.065h7.652 c-0.345-1.965-1.793-3.206-3.826-3.206C572.264,367.86,570.851,369.101,570.472,371.065z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M607.184,371.514v10.686h-6.549v-9.617c0-2.688-1.172-3.826-3.067-3.826c-2.104,0-3.723,1.31-3.723,4.412 v9.031h-6.55v-18.683h6.239v2.034c1.482-1.551,3.585-2.344,5.929-2.344C603.841,363.207,607.184,365.723,607.184,371.514z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M624.181,381.441c-1.138,0.724-2.826,1.068-4.55,1.068c-4.791,0-7.583-2.344-7.583-7.135v-6.273h-2.724 v-4.895h2.724v-4.86h6.549v4.86h4.274v4.895h-4.274v6.205c0,1.379,0.793,2.137,1.965,2.137c0.724,0,1.447-0.207,1.999-0.586 L624.181,381.441z"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"weirdstuff"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"weapons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#553A28",points:"882.561,309.754 882.561,363.537 833.741,375.635 833.741,313.966 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#95704A",points:"882.561,309.754 833.741,313.966 808.01,311.743 857.509,308.089 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#886136",points:"857.509,308.089 808.01,311.743 807.99,311.743 784.999,309.754 841.05,307 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#24150B",points:"833.741,313.966 833.741,375.635 810.576,369.887 810.576,359.863 799.365,357.595  799.365,366.971 799.333,367.094 784.999,363.537 784.999,358.353 784.999,309.754 807.99,311.743 808.01,311.743 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#553A28",points:"810.576,359.863 810.576,369.887 799.333,367.094 799.365,366.971 799.365,357.595 \t\t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_24_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#553A28",points:"807.56,316.284 807.56,381.092 748.733,395.67 748.733,321.359 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#95704A",points:"807.56,316.284 748.733,321.359 717.727,318.681 777.374,314.277 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#886136",points:"777.374,314.277 717.727,318.681 717.703,318.681 690,316.284 757.541,312.965 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#24150B",points:"748.733,321.359 748.733,395.67 720.819,388.744 720.819,376.665 707.311,373.932  707.311,385.23 707.272,385.378 690,381.092 690,374.845 690,316.284 717.703,318.681 717.727,318.681 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#553A28",points:"720.819,376.665 720.819,388.744 707.272,385.378 707.311,385.23 707.311,373.932 \t\t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"back_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4F361F",points:"820.957,342.488 824.666,342.669 830.83,331.313 813.731,330.841 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#301C0F",points:"813.731,342.125 820.957,342.488 813.731,330.841 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#26160B",points:"769.604,339.945 813.731,342.125 813.731,330.841 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7D5631",points:"739.396,342.669 769.604,339.945 813.731,330.841 782.844,333.548 \t\t\t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_26_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#72818C",d:"M844.394,297.784l0.679,5.992l-1.85-0.618l-1.211,5.908l-1.573-1.164l-2.971,5.244l-1.132-1.589 l-4.45,4.069l-0.589-1.862l-5.489,2.491l0.021-1.955l-1.852,0.213l4.081-10.441c2.362-0.442,4.442-2.044,5.379-4.441 c0.652-1.668,0.639-3.434,0.081-5.001c-0.663-1.899-2.128-3.505-4.153-4.297c-3.693-1.443-7.854,0.379-9.298,4.072 c-0.937,2.396-0.494,4.985,0.942,6.911l-4.316,11.043l-2.145-0.443l1.164-1.573l-5.244-2.971l1.589-1.132l-4.069-4.45 l1.862-0.589l-2.491-5.489l1.948,0.018l-0.672-5.99l1.85,0.618l1.211-5.908l1.566,1.161l2.978-5.242l1.132,1.589l4.45-4.069 l0.589,1.862l5.492-2.498l-0.021,1.955l5.992-0.679l-0.621,1.857l5.908,1.211L838,283.163l5.242,2.978l-1.589,1.132 l4.069,4.45l-1.862,0.589l2.491,5.489L844.394,297.784z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#274B57",points:"824.321,324.712 812.772,354.261 808.287,352.509 819.448,323.954 821.291,324.675 \t\t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4A6F78",points:"824.321,324.712 821.291,324.675 819.448,323.954 816.652,322.862 805.492,351.416  798.211,348.57 809.76,319.021 814.064,319.088 816.693,312.361 820.456,313.129 819.838,314.979 820.724,314.881  818.18,321.391 820.149,322.161 821.113,321.843 \t\t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#274B57",d:"M833.437,299.632c-0.937,2.396-3.017,3.999-5.379,4.441l-4.081,10.441l-3.254,0.368l4.371-11.183 l-2.057-1.062l0.411-1.051l3.265,0.824l4.249-1.57l1.921-3.24l0.635-2.967C834.077,296.198,834.089,297.964,833.437,299.632z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4A6F78",d:"M833.518,294.631l-0.635,2.967l-1.921,3.24l-4.249,1.57l-3.265-0.824l-0.411,1.051l2.057,1.062 l-4.371,11.183l-0.886,0.098l0.618-1.85l-3.763-0.768l4.316-11.043c-1.436-1.926-1.879-4.515-0.942-6.911 c1.443-3.693,5.605-5.515,9.298-4.072C831.39,291.126,832.855,292.732,833.518,294.631z M829.306,297.719 c0.529-1.352-0.142-2.883-1.494-3.411c-1.352-0.529-2.882,0.142-3.411,1.494s0.142,2.883,1.494,3.411 C827.248,299.741,828.778,299.071,829.306,297.719z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#274B57",points:"823.978,314.513 821.113,321.843 820.149,322.161 818.18,321.391 820.724,314.881 \t\t\t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"797.118",y:"336.161",transform:"matrix(0.364 -0.9314 0.9314 0.364 202.2186 971.4662)",fill:"#72818C",width:"30.658",height:"3.002"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#274B57",cx:"826.854",cy:"296.76",r:"2.633"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"front_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#301C0F",points:"824.666,411.533 824.666,342.669 812.734,384.199 769.604,378.871 769.604,379.233  769.604,388.838 769.604,403.916 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#4F361F",points:"824.666,342.669 824.666,411.533 859.283,391.031 859.283,332.098 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#26160B",points:"769.604,364.597 769.604,378.871 812.734,384.199 824.666,342.669 808.174,368.578 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#301C0F",points:"839.803,314.791 830.83,331.313 824.666,342.669 859.283,332.098 873,309.524 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7D5631",points:"820.957,342.488 813.731,342.125 769.604,339.945 748.984,362.47 769.604,364.597  808.174,368.578 824.666,342.669 \t\t\t\t"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"boxback"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#BA9E65",points:"504.591,434.247 363.99,470.002 363.99,329.555 504.747,315.634 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C4A774",points:"343.32,301.586 476.8,294.495 504.747,315.634 363.99,329.555 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#493815",points:"504.591,434.247 680.322,483.622 680.322,335.074 504.747,315.634 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"boxeye"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_27_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#281E17",points:"243.001,339.472 243.001,400.24 263.201,396.843 263.186,396.843 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#160E08",points:"243.001,339.472 263.186,396.843 263.201,396.843 290.568,392.245 289.99,343.528 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#38281C",points:"243.001,339.472 289.99,343.528 289.902,336.36 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#38281C",points:"243.001,400.24 298.161,411.229 298.161,402.458 298.117,402.458 263.201,396.843 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#160E08",points:"263.201,396.843 298.117,402.458 298.161,402.458 298.161,393.211 290.568,392.245 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#38281C",points:"289.902,336.36 289.99,343.528 298.161,344.231 353.233,340.526 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#140C06",points:"289.99,343.528 290.568,392.245 298.161,393.211 298.161,344.231 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#281E17",points:"298.161,402.458 298.161,411.229 353.233,400.24 298.161,393.211 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#281E17",points:"298.161,344.231 298.161,393.211 353.233,400.24 353.233,376.921 341.152,378.678  341.152,363.669 353.233,362.615 353.233,340.526 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#38281C",points:"341.152,363.669 341.152,378.678 353.233,376.921 353.233,362.615 \t\t\t\t"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"eye"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"eyewhite"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#455359",cx:"278.955",cy:"365.061",r:"11.131"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#748489",cx:"277.249",cy:"363.997",r:"8.699"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"mover"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#721010",cx:"278.955",cy:"365.061",r:"4.802"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#160E08",cx:"278.955",cy:"365.061",r:"2.244"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#CECAC0",cx:"275.775",cy:"361.753",r:"1.18"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#160E08",d:"M262.705,363.997c8.358-1.906,23.825-2.63,31.525,2.964c0,0-1.316-15.729-14.347-15.729 S262.705,363.997,262.705,363.997z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#160E08",d:"M294.23,368.343c-8.358,1.906-23.825,2.63-31.525-2.964c0,0,1.316,15.729,14.347,15.729 C290.084,381.109,294.23,368.343,294.23,368.343z"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"tentacleL"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_23_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#385604",d:"M287.825,228.382c0.811-7.81,5.191-15.528,13.813-20.765c24.172-14.693,49.712,8.297,51.705,10.081 c1.367,1.228,3.986,0.765,4.89,0.07c1.066-0.811,1.182-2.874,0.417-4.264c-2.943-5.493-25.725-37.637-62.389-23.408 c-33.373,12.955-41.809,50.848-23.361,78.635c16.918,25.47,55.83,25.169,89.992,21.739 c43.455-4.334,56.503,28.692,60.651,73.676c0.834,9.178,17.127,9.479,33.489,6.142v-0.023 c-4.913-47.325-29.572-82.969-55.599-99.47c-39.213-24.844-111.081,36.826-113.561-36.293c0-0.023,0-0.046,0-0.07 c-0.255-1.97-0.278-3.986-0.046-6.026v-0.024H287.825z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#835D93",d:"M299.598,253.342c-6.651-4.334-10.777-11.333-11.727-18.842c2.48,73.12,74.348,11.449,113.561,36.293 c26.026,16.501,50.685,52.145,55.599,99.47v0.023c17.729-3.639,35.575-11.518,33.906-16.941 c-3.175-10.429-23.361-90.084-81.695-104.569C365.742,237.954,321.476,267.526,299.598,253.342z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"437.259",cy:"276.576",r:"4.925"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"461.124",cy:"293.71",r:"2.662"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"455.372",cy:"314.526",r:"3.09"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"443.439",cy:"293.765",r:"4.152"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"416.787",cy:"253.787",r:"5.504"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"363.881",cy:"250.153",r:"1.22"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"381.661",cy:"257.77",r:"2.438"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"324.566",cy:"263.347",r:"2.318"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"336.818",cy:"260.558",r:"2.788"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"300.377",cy:"257.408",r:"3.621"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"477.333",cy:"321.479",r:"3.863"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"474.919",cy:"345.524",r:"9.174"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"465.096",cy:"307.919",r:"1.311"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"445.467",cy:"305.642",r:"0.966"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"458.248",cy:"334.591",r:"2.876"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"399.212",cy:"263.636",r:"4.345"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"tentacleR"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_28_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#835D93",d:"M664.764,236.762c-97.887-11.886-156.446,64.78-163.554,121.318 c-2.542,20.456,30.486,36.149,57.491,36.205c-6.771-122.406,68.2-139.877,111.079-139.633 c38.912,0.241,79.538,34.897,116.449,28.122c0.061-0.011,0.122-0.022,0.183-0.033c3.828-0.907,7.523-2.055,11.06-3.452 c13.662-5.413,24.909-14.748,32.459-29.162c1.117-2.135,1.283-4.085,0.006-5.067c-1.303-0.99-3.367-1.854-6.049,0.778 C782.361,286.884,745.476,246.574,664.764,236.762z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#385604",d:"M669.779,254.652C626.9,254.409,551.929,271.88,558.7,394.285c18.491,0.055,34.108-7.19,33.572-25.245 c-2.309-76.209,61.945-104.462,119.526-90.329c26.665,6.56,52.787,9.139,74.43,4.063 C749.317,289.549,708.692,254.893,669.779,254.652z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"562.236",cy:"275.472",r:"8.175"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"607.087",cy:"258.625",r:"4.748"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"590.192",cy:"253.679",r:"6.833"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"520.567",cy:"317.349",r:"8.514"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"559.208",cy:"301.809",r:"5.675"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"535.759",cy:"292.048",r:"5.675"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"650.707",cy:"240.758",r:"3.112"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"775.368",cy:"272.227",r:"2.722"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"758.61",cy:"271.454",r:"3.967"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"790.789",cy:"269.018",r:"1.1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"801.199",cy:"261.381",r:"2.668"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"820.36",cy:"256.013",r:"2.316"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"717.816",cy:"257.974",r:"5.212"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"740.472",cy:"258.18",r:"2.635"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"677.278",cy:"245.504",r:"4.633"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"697.121",cy:"256.519",r:"2.087"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"697.126",cy:"245.588",r:"3.066"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"635.554",cy:"251.451",r:"1.679"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"631.143",cy:"241.17",r:"4.169"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"608.713",cy:"242.146",r:"3.069"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#563568",cx:"535.864",cy:"348.82",r:"12.878"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"boxfront"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#BA9E65",points:"680.322,483.691 538.951,543.794 538.951,358.732 680.322,335.074 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#7C6635",points:"363.99,470.104 538.951,544.369 538.951,358.732 363.99,329.555 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#373737",d:"M552.66,515.332v-0.067c1.683-1.427,2.809-3.664,2.809-6.291c0-5.12-3.109-4.813-5.99-3.727l-5.265,1.985 c-0.522,0.197-0.946,0.961-0.946,1.707v21.25c0,0.746,0.424,1.176,0.946,0.962l5.871-2.41c2.922-1.199,6.14-4.148,6.14-9.064 C556.224,516.621,554.803,514.889,552.66,515.332z M546.951,510.643l2.481-0.951c1.141-0.437,2.441-0.434,2.441,1.538 c0,1.905-1.16,3.026-2.278,3.462l-2.645,1.032v-5.081H546.951z M550.225,524.261l-3.273,1.323v-5.418l2.761-1.095 c1.187-0.471,2.924-0.793,2.924,1.444C552.637,522.585,551.363,523.801,550.225,524.261z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#373737",d:"M566.868,498.104c-4.939,1.858-8.582,8.03-8.582,15.547c0,7.517,3.643,10.82,8.582,8.788 c4.869-2.003,8.374-8.13,8.374-15.465C575.242,499.64,571.737,496.272,566.868,498.104z M566.868,517.729 c-2.964,1.199-4.917-1.173-4.917-5.521c0-4.348,1.953-8.259,4.917-9.394c2.939-1.125,4.848,1.262,4.848,5.549 C571.715,512.65,569.806,516.54,566.868,517.729z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#373737",d:"M586.94,501.764l3.875-10.128c0.374-0.978-0.018-1.965-0.682-1.714l-1.88,0.709 c-0.296,0.111-0.569,0.453-0.719,0.898l-2.798,8.329l-2.947-6.178c-0.154-0.323-0.429-0.451-0.725-0.34l-2.08,0.784 c-0.69,0.26-1.097,1.577-0.704,2.28l4.067,7.26l-4.404,11.639c-0.382,1.01,0.026,1.989,0.711,1.708l1.869-0.767 c0.301-0.124,0.58-0.477,0.732-0.93l3.311-9.813l3.382,7.086c0.151,0.316,0.42,0.436,0.711,0.317l2.028-0.832 c0.664-0.273,1.055-1.569,0.68-2.251L586.94,501.764z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#373737",d:"M551.389,477.821v-26.677c0-0.523-0.294-0.859-0.658-0.75l-4.106,1.232 c-0.368,0.11-0.667,0.628-0.667,1.155v26.634c0,4.349-1.654,10.65-6.974,12.527c-0.012,0.004-0.022,0.007-0.034,0.011v7.53 c0.011-0.004,0.022-0.007,0.034-0.011C546.089,496.889,551.389,488.365,551.389,477.821z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#373737",d:"M560.969,489.451v-16.947l12.129-4.077c0.341-0.115,0.618-0.619,0.618-1.126v-4.97 c0-0.507-0.276-0.828-0.618-0.717l-12.129,3.956v-11.314l12.892-3.995c0.34-0.106,0.616-0.602,0.616-1.109v-4.964 c0-0.507-0.276-0.835-0.616-0.733l-17.526,5.257c-0.359,0.108-0.649,0.617-0.649,1.138v41.505c0,0.521,0.291,0.838,0.649,0.708 l3.994-1.445C560.683,490.49,560.969,489.967,560.969,489.451z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#373737",d:"M594.675,437.212l-16.461,4.938c-0.336,0.101-0.609,0.592-0.609,1.096v40.208 c0,0.504,0.273,0.815,0.609,0.693l3.749-1.356c0.332-0.12,0.602-0.624,0.602-1.124v-16.421l11.394-3.83 c0.321-0.108,0.58-0.594,0.58-1.086v-4.818c0-0.492-0.26-0.806-0.58-0.701l-11.394,3.717v-10.962l12.111-3.753 c0.32-0.099,0.579-0.578,0.579-1.069v-4.813C595.254,437.437,594.995,437.116,594.675,437.212z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#222222",d:"M489.996,490.68l-1.582-0.594c-0.456-0.171-0.826,0.251-0.826,0.944v19.739 c0,0.693,0.37,1.405,0.826,1.592l1.582,0.647c0.459,0.188,0.832-0.224,0.832-0.92v-19.835 C490.828,491.557,490.455,490.853,489.996,490.68z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#222222",d:"M508.45,497.609l-1.671-0.627c-0.482-0.181-0.872,0.25-0.872,0.961v14.595l-0.044-0.017l-6.254-17.62 c-0.155-0.438-0.431-0.772-0.728-0.884l-3.185-1.196c-0.466-0.175-0.844,0.251-0.844,0.951v19.953c0,0.7,0.378,1.422,0.844,1.613 l1.617,0.661c0.469,0.192,0.85-0.223,0.85-0.926V500.26l0.043,0.016l6.402,18.091c0.158,0.446,0.438,0.793,0.74,0.916 l3.102,1.268c0.485,0.198,0.878-0.221,0.878-0.936v-20.38C509.329,498.518,508.935,497.791,508.45,497.609z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#222222",d:"M526.159,504.258l-1.767-0.663c-0.366-0.137-0.697,0.052-0.842,0.481l-6.177,18.292 c-0.257,0.76,0.179,1.903,0.827,2.168l1.906,0.779c0.373,0.152,0.708-0.041,0.845-0.489l1.119-3.664l6.342,2.547l1.186,4.655 c0.143,0.561,0.484,1.029,0.864,1.184l2.072,0.847c0.677,0.277,1.133-0.527,0.863-1.522l-6.391-23.497 C526.859,504.834,526.526,504.396,526.159,504.258z M523.192,517.242l1.977-6.519l2.012,8.097L523.192,517.242z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#222222",d:"M488.364,449.806c0-3.77,2.223-4.595,4.461-3.907c1.683,0.517,3.344,1.856,4.438,3.933 c0.233,0.443,0.631,0.55,0.865,0.253l2.727-3.454c0.244-0.309,0.219-0.929-0.054-1.348c-2.112-3.234-4.803-5.097-7.472-5.891 c-5.041-1.5-9.969,0.948-9.969,9.353c0,14.565,12.89,13.699,12.89,22.796c0,3.815-2.571,4.787-4.815,3.997 c-1.933-0.681-3.764-2.587-4.969-5.236c-0.22-0.483-0.615-0.668-0.863-0.388l-2.305,2.604l-0.402,0.454 c-0.229,0.258-0.235,0.816-0.016,1.247c0.136,0.266,0.275,0.526,0.417,0.779c2.14,3.794,5.038,6.061,8.022,7.141 c5.4,1.955,10.132-0.708,10.132-9.697C501.45,457.54,488.364,458.042,488.364,449.806z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#222222",d:"M524.059,455.662v-5.085c0-0.519-0.292-1.027-0.651-1.135l-19.319-5.779 c-0.34-0.102-0.615,0.225-0.615,0.728v4.937c0,0.504,0.275,0.998,0.615,1.103l6.943,2.146v34.698c0,0.51,0.281,1.024,0.629,1.149 l3.917,1.412c0.352,0.127,0.637-0.187,0.637-0.7v-34.958l7.193,2.223C523.768,456.512,524.059,456.181,524.059,455.662z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#222222",d:"M532.026,479.453V452.97c0-0.524-0.298-1.039-0.665-1.149l-4.098-1.226 c-0.363-0.109-0.657,0.225-0.657,0.746v26.527c0,10.469,5.273,18.933,12.345,21.514v-7.486 C533.67,490.015,532.026,483.768,532.026,479.453z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#222222",points:"363.99,460.918 473.876,505.71 473.876,434.349 363.99,401.524 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#373737",points:"672.419,382.108 664.614,358.349 656.598,385.993 661.503,382.666 661.503,491.69  667.693,489.049 667.693,381.168 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#222222",points:"389.197,377.752 381.673,350.569 374.345,374.13 378.783,373.138 378.783,390.41 384.593,391.984  384.593,374.534 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AA8D59",points:"576.075,269.468 722.485,262.794 680.322,335.074 538.951,358.732 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AA8D59",points:"464.147,387.097 302.303,350.112 363.99,329.555 538.951,358.732 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C1BA97",points:"607.498,514.458 607.498,477.334 618.152,475.266 622.376,479.385 633.638,476.778  633.638,503.474 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"XMLID_2_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#C1BA97",points:"663.254,261.334 658.457,265.922 631.552,266.965 632.595,265.297 649.28,262.377 \t\t\t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#AAA280",points:"658.457,265.922 652.409,284.276 641.355,280.73 639.686,277.81 636.975,280.939  632.595,281.773 627.798,284.484 631.552,266.965 \t\t\t\t"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"boxes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"back"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"494.613,323.607 435.542,332.629 430.064,303.216 489.603,295.198         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"494.613,323.607 509.08,350.786 513.697,340.382 495.154,311.107      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"435.542,332.629 411.668,343.539 415.355,377.305 439.456,364.811         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"439.456,364.811 509.08,350.786 519.378,385.292 442.52,403.913       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"509.08,350.786 493.972,354.568 494.613,323.607         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"494.613,323.607 493.972,354.568 439.456,364.811 435.542,332.629         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"383.947,320.545 434.174,334.303 441.621,305.325 390.859,292.538         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"383.947,320.545 367.681,346.688 359.076,326.163 379.55,298.204      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"434.174,334.303 443.159,316.469 433.755,361.247 428.1,366.147       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"428.1,366.147 367.681,346.688 355.081,380.421 422.408,404.954       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"367.681,346.688 382.499,351.479 383.947,320.545        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"383.947,320.545 382.499,351.479 428.1,366.147 434.174,334.303       "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"358.099,326.903 310.227,326.335 309.731,302.37 357.842,303.793      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"358.099,326.903 365.992,350.275 370.997,342.652 360.156,317.093         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"310.227,326.335 289.933,331.847 288.446,359.02 309.126,352.285      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"309.126,352.285 365.992,350.275 369.634,378.894 306.451,383.594         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"365.992,350.275 353.556,351.295 358.099,326.903        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"358.099,326.903 353.556,351.295 309.126,352.285 310.227,326.335         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"262.18,366.381 262.001,399.972 294.257,361.184 296.445,333.142         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"262.18,366.381 217.982,343.308 222.116,373.812 262.001,399.972      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"296.445,333.142 257.579,316.869 271.295,290.324 311.038,305.686             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"257.579,316.869 217.982,343.308 201.261,319.971 243.081,296.634             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"296.445,333.142 262.18,366.381 274.308,360.982 303.972,330.642          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#181610",d:"M262.18,366.381c-0.56-0.022-44.198-23.073-44.198-23.073l-22.586-6.371l54.444,29.65L262.18,366.381z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"257.579,316.869 258.883,348.137 247.182,358.663 217.982,343.308             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"258.883,348.137 273.812,355.096 296.445,333.142 257.579,316.869            "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"258.883,348.137 247.182,358.663 262.18,366.381 273.812,355.096          "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"215.563,322.913 155.811,322.204 155.192,292.291 215.243,294.068         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"215.563,322.913 225.415,352.084 231.663,342.57 218.131,310.668      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"155.811,322.204 130.481,329.084 128.624,363 154.437,354.593         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"154.437,354.593 225.415,352.084 229.962,387.806 151.098,393.673         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"225.415,352.084 209.893,353.358 215.563,322.913        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"215.563,322.913 209.893,353.358 154.437,354.593 155.811,322.204         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"58.117,368.944 55.093,405.383 -4.237,388.785 -3.996,355.516         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"58.117,368.944 72.729,327.97 69.119,359.542 55.093,405.383         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"72.729,327.97 76.625,302.894 24.789,295.19 21.197,319.497           "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"21.197,319.497 -3.996,355.516 -28.808,340.147 0.41,305.071          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"72.729,327.97 58.117,368.944 66.31,363.335 80.036,321.076           "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"58.117,368.944 -3.996,355.516 -16.188,355.652 55.347,371.801            "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"72.729,327.97 61.751,358.756 23.533,349.863 21.197,319.497             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"21.197,319.497 23.533,349.863 17.284,360.115 -3.996,355.516             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"23.533,349.863 61.751,358.756 58.117,368.944 17.284,360.115             "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"644.307,361.12 640.52,406.758 566.212,385.97 566.513,344.303        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"644.307,361.12 662.606,309.803 658.085,349.345 640.52,406.758      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"662.606,309.803 667.486,278.397 602.565,268.748 598.066,299.192             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"598.066,299.192 566.513,344.303 535.438,325.054 572.032,281.124             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"662.606,309.803 644.307,361.12 654.568,354.096 671.758,301.169          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"644.307,361.12 566.513,344.303 551.244,344.473 640.837,364.699          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"662.606,309.803 648.858,348.361 600.993,337.222 598.066,299.192            "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"598.066,299.192 600.993,337.222 593.165,350.063 566.513,344.303             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"600.993,337.222 648.858,348.361 644.307,361.12 593.165,350.063          "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"827.969,322.101 768.218,321.392 767.598,291.479 827.649,293.255         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"827.969,322.101 837.821,351.272 844.069,341.758 830.537,309.856         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"768.218,321.392 742.887,328.271 741.03,362.187 766.843,353.781      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"766.843,353.781 837.821,351.272 842.368,386.993 763.504,392.861         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"837.821,351.272 822.3,352.546 827.969,322.101      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"827.969,322.101 822.3,352.546 766.843,353.781 768.218,321.392       "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"100.244,366.055 100.065,399.646 132.321,360.858 134.509,332.816        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"100.244,366.055 56.046,342.982 60.18,373.486 100.065,399.646        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"134.509,332.816 95.643,316.543 109.359,289.998 149.102,305.36           "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"95.643,316.543 56.046,342.982 39.325,319.645 81.145,296.308             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"134.509,332.816 100.244,366.055 112.372,360.656 142.036,330.315             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#181610",d:"M100.244,366.055c-0.56-0.022-44.198-23.073-44.198-23.073l-22.586-6.371l54.444,29.65L100.244,366.055z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"95.643,316.543 96.947,347.81 85.246,358.337 56.046,342.982          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"96.947,347.81 111.876,354.77 134.509,332.816 95.643,316.543            "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"96.947,347.81 85.246,358.337 100.244,366.055 111.876,354.77             "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"674.972,509.948 675.065,545.355 733.62,533.936 735.967,501.804      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"674.972,509.948 664.046,469.266 665.082,500.02 675.065,545.355         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"664.046,469.266 662.23,444.759 712.861,441.343 714.443,465.084          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"714.443,465.084 735.967,501.804 761.108,488.893 735.627,452.771             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"664.046,469.266 674.972,509.948 667.498,503.899 657.528,462.045             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"674.972,509.948 735.967,501.804 747.725,502.881 677.425,512.921             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"664.046,469.266 672.255,499.833 709.833,494.213 714.443,465.084            "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"714.443,465.084 709.833,494.213 715.07,504.594 735.967,501.804          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"709.833,494.213 672.255,499.833 674.972,509.948 715.07,504.594          "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"172.5,413.8 222.727,427.558 230.175,398.58 179.413,385.793      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"172.5,413.8 156.234,439.943 147.63,419.418 168.103,391.459      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"222.727,427.558 231.713,409.724 222.308,454.502 216.653,459.403         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"216.653,459.403 156.234,439.943 143.634,473.676 210.962,498.21      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"156.234,439.943 171.053,444.734 172.5,413.8        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"172.5,413.8 171.053,444.734 216.653,459.403 222.727,427.558         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"637.17,466.494 577.418,465.785 576.799,435.872 636.85,437.648   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"637.17,466.494 647.022,495.665 653.27,486.151 639.738,454.249   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"577.418,465.785 552.088,472.665 550.231,506.581 576.044,498.174     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"576.044,498.174 647.022,495.665 651.569,531.387 572.705,537.254     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"647.022,495.665 631.5,496.939 637.17,466.494   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"637.17,466.494 631.5,496.939 576.044,498.174 577.418,465.785    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"118.929,464.537 118.75,498.127 151.006,459.34 153.193,431.298  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"118.929,464.537 74.731,441.464 78.865,471.967 118.75,498.127    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"153.193,431.298 114.328,415.025 128.044,388.48 167.786,403.842      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"114.328,415.025 74.731,441.464 58.01,418.126 99.83,394.79       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"153.193,431.298 118.929,464.537 131.057,459.137 160.721,428.797         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#181610",d:"M118.929,464.537c-0.56-0.022-44.198-23.073-44.198-23.073l-22.586-6.371l54.444,29.65L118.929,464.537z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"114.328,415.025 115.631,446.292 103.931,456.819 74.731,441.464      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"115.631,446.292 130.561,453.252 153.193,431.298 114.328,415.025        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"115.631,446.292 103.931,456.819 118.929,464.537 130.561,453.252         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"871.216,393.296 871.309,428.702 929.864,417.283 932.212,385.151     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"871.216,393.296 860.291,352.613 861.326,383.367 871.309,428.702    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"860.291,352.613 858.474,328.106 909.106,324.69 910.688,348.431      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"910.688,348.431 932.212,385.151 957.353,372.241 931.871,336.118         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"860.291,352.613 871.216,393.296 863.743,387.247 853.772,345.392         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"871.216,393.296 932.212,385.151 943.969,386.228 873.669,396.268         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"860.291,352.613 868.499,383.18 906.078,377.56 910.688,348.431      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"910.688,348.431 906.078,377.56 911.315,387.941 932.212,385.151      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"906.078,377.56 868.499,383.18 871.216,393.296 911.315,387.941       "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"588.751,345.148 638.978,358.906 646.426,329.928 595.663,317.141     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"588.751,345.148 572.485,371.291 563.881,350.767 584.354,322.808     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"638.978,358.906 647.964,341.072 638.559,385.85 632.904,390.751  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"632.904,390.751 572.485,371.291 559.885,405.024 627.213,429.558     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"572.485,371.291 587.304,376.082 588.751,345.148    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"588.751,345.148 587.304,376.082 632.904,390.751 638.978,358.906     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"819.934,378.993 760.182,378.284 759.563,348.371 819.613,350.147     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"819.934,378.993 829.785,408.164 836.034,398.65 822.501,366.748  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"760.182,378.284 734.851,385.164 732.995,419.08 758.808,410.673  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"758.808,410.673 829.785,408.164 834.332,443.886 755.468,449.753     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"829.785,408.164 814.264,409.438 819.934,378.993    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"819.934,378.993 814.264,409.438 758.808,410.673 760.182,378.284     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"724.137,373.753 721.113,410.191 661.783,393.594 662.024,360.325     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"724.137,373.753 738.748,332.779 735.138,364.351 721.113,410.191    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"738.748,332.779 742.645,307.702 690.809,299.999 687.217,324.306         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"687.217,324.306 662.024,360.325 637.212,344.955 666.429,309.88      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"738.748,332.779 724.137,373.753 732.33,368.144 746.056,325.885      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"724.137,373.753 662.024,360.325 649.831,360.461 721.366,376.61      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"738.748,332.779 727.771,363.565 689.553,354.671 687.217,324.306        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"687.217,324.306 689.553,354.671 683.304,364.924 662.024,360.325         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"689.553,354.671 727.771,363.565 724.137,373.753 683.304,364.924         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"970.125,464.521 967.101,500.959 907.771,484.362 908.011,451.093         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"970.125,464.521 984.736,423.547 981.126,455.119 967.101,500.959        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"984.736,423.547 988.632,398.47 936.796,390.767 933.204,415.074          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"933.204,415.074 908.011,451.093 883.2,435.723 912.417,400.648           "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"984.736,423.547 970.125,464.521 978.318,458.912 992.043,416.653             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"970.125,464.521 908.011,451.093 895.819,451.229 967.354,467.378             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"984.736,423.547 973.758,454.333 935.541,445.439 933.204,415.074            "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"933.204,415.074 935.541,445.439 929.291,455.692 908.011,451.093             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"935.541,445.439 973.758,454.333 970.125,464.521 929.291,455.692             "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"810.049,446.136 860.276,459.894 867.723,430.916 816.961,418.129         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"810.049,446.136 793.783,472.279 785.178,451.755 805.652,423.796         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"860.276,459.894 869.261,442.06 859.857,486.838 854.202,491.739      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"854.202,491.739 793.783,472.279 781.183,506.012 848.51,530.546      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"793.783,472.279 808.601,477.07 810.049,446.136         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"810.049,446.136 808.601,477.07 854.202,491.739 860.276,459.894      "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"280.753,493.454 280.846,528.86 339.401,517.441 341.749,485.309      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"280.753,493.454 269.828,452.771 270.864,483.525 280.846,528.86             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"269.828,452.771 268.012,428.264 318.643,424.849 320.225,448.59              "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"320.225,448.59 341.749,485.309 366.89,472.399 341.408,436.277               "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"269.828,452.771 280.753,493.454 273.28,487.405 263.309,445.55               "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"280.753,493.454 341.749,485.309 353.507,486.386 283.206,496.427                 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"269.828,452.771 278.036,483.338 315.615,477.718 320.225,448.59                 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"320.225,448.59 315.615,477.718 320.852,488.099 341.749,485.309              "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"315.615,477.718 278.036,483.338 280.753,493.454 320.852,488.099                 "})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"479.063,402.19 479.156,437.597 537.71,426.177 540.058,394.046   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"479.063,402.19 468.137,361.508 469.173,392.262 479.156,437.597     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"468.137,361.508 466.321,337.001 516.952,333.585 518.534,357.326         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"518.534,357.326 540.058,394.046 565.199,381.135 539.718,345.013         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"468.137,361.508 479.063,402.19 471.589,396.141 461.618,354.287      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"479.063,402.19 540.058,394.046 551.816,395.123 481.515,405.163      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"468.137,361.508 476.346,392.075 513.924,386.454 518.534,357.326        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"518.534,357.326 513.924,386.454 519.161,396.835 540.058,394.046         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"513.924,386.454 476.346,392.075 479.063,402.19 519.161,396.835      "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"360.235,402.929 300.483,402.22 299.864,372.307 359.915,374.084      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"360.235,402.929 370.087,432.101 376.335,422.586 362.803,390.684         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"300.483,402.22 275.153,409.1 273.296,443.016 299.109,434.61         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"299.109,434.61 370.087,432.101 374.634,467.822 295.769,473.689      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"370.087,432.101 354.565,433.374 360.235,402.929        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"360.235,402.929 354.565,433.374 299.109,434.61 300.483,402.22       "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"66.9,429.482 63.876,465.92 4.546,449.323 4.787,416.053  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"66.9,429.482 81.511,388.508 77.902,420.08 63.876,465.92    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"81.511,388.508 85.408,363.431 33.572,355.728 29.98,380.035      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"29.98,380.035 4.787,416.053 -20.025,400.684 9.193,365.609       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"81.511,388.508 66.9,429.482 75.093,423.873 88.819,381.614       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"66.9,429.482 4.787,416.053 -7.405,416.189 64.13,432.339         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"81.511,388.508 70.534,419.293 32.316,410.4 29.98,380.035       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"29.98,380.035 32.316,410.4 26.067,420.653 4.787,416.053         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"32.316,410.4 70.534,419.293 66.9,429.482 26.067,420.653         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"623.706,457.906 619.918,503.544 545.611,482.756 545.912,441.089     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"623.706,457.906 642.005,406.589 637.484,446.131 619.918,503.544    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"642.005,406.589 646.885,375.183 581.964,365.534 577.465,395.978         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"577.465,395.978 545.912,441.089 514.837,421.84 551.43,377.909       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"642.005,406.589 623.706,457.906 633.967,450.882 651.157,397.955         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"623.706,457.906 545.912,441.089 530.642,441.259 620.235,461.485         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"642.005,406.589 628.256,445.146 580.391,434.008 577.465,395.978        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"577.465,395.978 580.391,434.008 572.564,446.849 545.912,441.089         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"580.391,434.008 628.256,445.146 623.706,457.906 572.564,446.849         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"235.341,383.024 285.568,396.782 293.015,367.805 242.253,355.017         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"235.341,383.024 219.075,409.167 210.47,388.643 230.944,360.684      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"285.568,396.782 294.553,378.948 285.149,423.726 279.494,428.627         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"279.494,428.627 219.075,409.167 206.475,442.9 273.802,467.434       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"219.075,409.167 233.893,413.959 235.341,383.024        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"235.341,383.024 233.893,413.959 279.494,428.627 285.568,396.782         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"849.835,415.713 849.928,451.12 908.482,439.701 910.83,407.569       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"849.835,415.713 838.909,375.031 839.945,405.785 849.928,451.12         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"838.909,375.031 837.093,350.524 887.724,347.108 889.306,370.849             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"889.306,370.849 910.83,407.569 935.971,394.658 910.49,358.536           "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"838.909,375.031 849.835,415.713 842.361,409.664 832.39,367.81           "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"849.835,415.713 910.83,407.569 922.588,408.646 852.287,418.686          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"838.909,375.031 847.118,405.598 884.696,399.978 889.306,370.849            "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"889.306,370.849 884.696,399.978 889.933,410.359 910.83,407.569          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"884.696,399.978 847.118,405.598 849.835,415.713 889.933,410.359             "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"510.711,317.812 560.938,331.57 568.386,302.592 517.623,289.805  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"510.711,317.812 494.445,343.955 485.84,323.43 506.314,295.471   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"560.938,331.57 569.924,313.736 560.519,358.514 554.864,363.414  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"554.864,363.414 494.445,343.955 481.845,377.688 549.173,402.221     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"494.445,343.955 509.263,348.746 510.711,317.812    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"510.711,317.812 509.263,348.746 554.864,363.414 560.938,331.57  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"692.646,433.186 689.622,469.625 630.292,453.028 630.532,419.758     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"692.646,433.186 707.257,392.212 703.647,423.784 689.622,469.625    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"707.257,392.212 711.153,367.136 659.317,359.432 655.725,383.74      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"655.725,383.74 630.532,419.758 605.721,404.389 634.938,369.313      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"707.257,392.212 692.646,433.186 700.839,427.578 714.565,385.319         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"692.646,433.186 630.532,419.758 618.34,419.894 689.875,436.044      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"707.257,392.212 696.279,422.998 658.062,414.105 655.725,383.74         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"655.725,383.74 658.062,414.105 651.812,424.358 630.532,419.758      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"658.062,414.105 696.279,422.998 692.646,433.186 651.812,424.358         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{display:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",points:"286.031,305.698 287.198,339.269 317.874,299.22 318.936,271.113        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#0C0A07",points:"286.031,305.698 240.944,284.415 246.297,314.728 287.198,339.269        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#181610",points:"318.936,271.113 279.45,256.41 292.091,229.337 332.417,243.094      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#181610",points:"279.45,256.41 240.944,284.415 223.301,261.766 264.152,236.772      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#181610",points:"318.936,271.113 286.031,305.698 297.933,299.817 326.357,268.312        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{display:"inline",fill:"#181610",d:"M286.031,305.698c-0.56,0-45.087-21.283-45.087-21.283l-22.824-5.461l55.589,27.444 L286.031,305.698z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#0C0A07",points:"279.45,256.41 282.005,287.6 270.736,298.587 240.944,284.415        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",points:"282.005,287.6 297.201,293.956 318.936,271.113 279.45,256.41       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{display:"inline",fill:"#241B0D",points:"282.005,287.6 270.736,298.587 286.031,305.698 297.201,293.956      "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"977.658,350.877 1027.885,364.635 1035.333,335.657 984.571,322.87    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"977.658,350.877 961.393,377.02 952.788,356.496 973.261,328.537  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"1027.885,364.635 1036.871,346.801 1027.466,391.579 1021.811,396.48  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"1021.811,396.48 961.393,377.02 948.792,410.753 1016.12,435.287  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"961.393,377.02 976.211,381.811 977.658,350.877     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"977.658,350.877 976.211,381.811 1021.811,396.48 1027.885,364.635    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"465.043,426.765 465.136,462.172 523.69,450.753 526.038,418.621  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"465.043,426.765 454.117,386.083 455.153,416.837 465.136,462.172    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"454.117,386.083 452.301,361.576 502.932,358.16 504.514,381.901      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"504.514,381.901 526.038,418.621 551.179,405.71 525.698,369.588      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"454.117,386.083 465.043,426.765 457.569,420.716 447.598,378.862         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#181610",points:"465.043,426.765 526.038,418.621 537.796,419.698 467.496,429.738         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"454.117,386.083 462.326,416.65 499.904,411.03 504.514,381.901      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#0C0A07",points:"504.514,381.901 499.904,411.03 505.141,421.411 526.038,418.621      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#241B0D",points:"499.904,411.03 462.326,416.65 465.043,426.765 505.141,421.411       "}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"mid"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"657.101,653.183 659.535,710.139 753.001,687.99 754.704,636.145  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"657.101,653.183 636.898,588.439 640.549,637.849 659.535,710.139     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"636.898,588.439 632.395,549.13 713.63,540.367 717.707,578.459       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"717.707,578.459 754.704,636.145 794.318,613.753 750.992,557.283         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"636.898,588.439 657.101,653.183 644.687,643.934 625.945,577.242         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"657.101,653.183 754.704,636.145 773.69,637.119 661.238,657.808      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"636.898,588.439 652.077,637.085 712.17,625.618 717.707,578.459      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"717.707,578.459 712.17,625.618 721.265,641.981 754.704,636.145      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"712.17,625.618 652.077,637.085 657.101,653.183 721.265,641.981      "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"216.309,526.971 298.002,545.864 308.114,498.764 225.623,481.468     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"216.309,526.971 191.828,570.079 176.66,537.615 207.794,491.313  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"298.002,545.864 311.307,516.593 299.067,589.238 290.285,597.487     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"290.285,597.487 191.828,570.079 173.733,625.162 283.633,660.287     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"191.828,570.079 215.977,576.831 216.309,526.971     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"216.309,526.971 215.977,576.831 290.285,597.487 298.002,545.864     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"590.419,566.503 494.245,569.218 491.319,521.134 588.043,520.117     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"590.419,566.503 608.151,612.798 617.589,597.088 593.76,546.637  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"494.245,569.218 453.937,581.921 453.139,636.604 494.124,621.415     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"494.124,621.415 608.151,612.798 617.771,669.973 491.273,684.502     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"608.151,612.798 583.262,615.848 590.419,566.503     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"590.419,566.503 583.262,615.848 494.124,621.415 494.245,569.218     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"89.768,589.803 91.647,643.856 141.038,579.373 142.748,534.118   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"89.768,589.803 17.174,555.535 25.792,604.343 91.647,643.856     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"142.748,534.118 79.172,510.446 99.525,466.855 164.454,489.005       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"79.172,510.446 17.174,555.535 -11.233,519.069 54.541,478.827        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"142.748,534.118 89.768,589.803 108.931,580.334 154.696,529.609      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262015",d:"M89.768,589.803c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L89.768,589.803z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"79.172,510.446 83.286,560.664 65.141,578.355 17.174,555.535         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"83.286,560.664 107.753,570.897 142.748,534.118 79.172,510.446       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"83.286,560.664 65.141,578.355 89.768,589.803 107.753,570.897        "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"921.297,505.271 923.731,562.227 1017.197,540.077 1018.901,488.233   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"921.297,505.271 901.095,440.526 904.746,489.936 923.731,562.227     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"901.095,440.526 896.592,401.217 977.827,392.454 981.904,430.547         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"981.904,430.547 1018.901,488.233 1058.514,465.84 1015.189,409.371       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"901.095,440.526 921.297,505.271 908.884,496.021 890.142,429.33      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"921.297,505.271 1018.901,488.233 1037.886,489.206 925.435,509.895       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"901.095,440.526 916.273,489.172 976.367,477.705 981.904,430.547         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"981.904,430.547 976.367,477.705 985.462,494.068 1018.901,488.233        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"976.367,477.705 916.273,489.172 921.297,505.271 985.462,494.068         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"141.717,571.094 144.151,628.05 237.617,605.901 239.321,554.056  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"141.717,571.094 121.515,506.349 125.166,555.76 144.151,628.05   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"121.515,506.349 117.012,467.04 198.247,458.278 202.324,496.37       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"202.324,496.37 239.321,554.056 278.934,531.663 235.609,475.194      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"121.515,506.349 141.717,571.094 129.304,561.845 110.562,495.153         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"141.717,571.094 239.321,554.056 258.306,555.03 145.855,575.719      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"121.515,506.349 136.693,554.995 196.787,543.529 202.324,496.37      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"202.324,496.37 196.787,543.529 205.882,559.892 239.321,554.056      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"196.787,543.529 136.693,554.995 141.717,571.094 205.882,559.892         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"-27.592,556.21 -25.158,613.166 68.308,591.016 70.012,539.172    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"-27.592,556.21 -47.794,491.465 -44.143,540.876 -25.158,613.166  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"-47.794,491.465 -52.297,452.156 28.938,443.393 33.015,481.486       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"33.015,481.486 70.012,539.172 109.625,516.779 66.3,460.31       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"-47.794,491.465 -27.592,556.21 -40.005,546.961 -58.747,480.269      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"-27.592,556.21 70.012,539.172 88.997,540.145 -23.454,560.834        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"-47.794,491.465 -32.616,540.111 27.477,528.645 33.015,481.486       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"33.015,481.486 27.477,528.645 36.573,545.008 70.012,539.172         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"27.477,528.645 -32.616,540.111 -27.592,556.21 36.573,545.008        "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"497.251,433.944 578.944,452.837 589.056,405.737 506.564,388.441     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"497.251,433.944 472.77,477.052 457.602,444.588 488.736,398.286  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"578.944,452.837 592.249,423.566 580.008,496.211 571.227,504.461     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"571.227,504.461 472.77,477.052 454.675,532.135 564.574,567.26   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"472.77,477.052 496.918,483.804 497.251,433.944  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"497.251,433.944 496.918,483.804 571.227,504.461 578.944,452.837     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"878.803,413.939 782.629,416.654 779.703,368.569 876.426,367.553     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"878.803,413.939 896.535,460.234 905.973,444.524 882.143,394.073     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"782.629,416.654 742.321,429.356 741.523,484.04 782.508,468.851  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"782.508,468.851 896.535,460.234 906.155,517.409 779.657,531.937     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"896.535,460.234 871.646,463.284 878.803,413.939     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"878.803,413.939 871.646,463.284 782.508,468.851 782.629,416.654     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"912.292,490.686 816.118,493.401 813.192,445.317 909.916,444.3   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"912.292,490.686 930.024,536.981 939.463,521.271 915.633,470.82  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"816.118,493.401 775.811,506.104 775.012,560.787 815.998,545.598     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"815.998,545.598 930.024,536.981 939.644,594.156 813.146,608.685     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"930.024,536.981 905.136,540.031 912.292,490.686     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"912.292,490.686 905.136,540.031 815.998,545.598 816.118,493.401     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"746.674,453.552 744.16,512.37 647.639,489.496 645.879,435.957   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"746.674,453.552 767.537,386.691 763.766,437.716 744.16,512.37   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"767.537,386.691 772.187,346.096 688.296,337.048 684.086,376.385         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"684.086,376.385 645.879,435.957 604.971,412.832 649.713,354.517         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"767.537,386.691 746.674,453.552 759.493,444 778.848,375.128         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"746.674,453.552 645.879,435.957 626.273,436.962 742.401,458.328         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"767.537,386.691 751.862,436.927 689.804,425.086 684.086,376.385         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"684.086,376.385 689.804,425.086 680.411,441.984 645.879,435.957         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"689.804,425.086 751.862,436.927 746.674,453.552 680.411,441.984         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"994.126,636.815 991.612,695.633 895.091,672.759 893.331,619.22  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"994.126,636.815 1014.988,569.954 1011.218,620.979 991.612,695.633   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"1014.988,569.954 1019.638,529.359 935.748,520.311 931.537,559.648       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"931.537,559.648 893.331,619.22 852.423,596.095 897.164,537.78       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"1014.988,569.954 994.126,636.815 1006.945,627.263 1026.299,558.391      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"994.126,636.815 893.331,619.22 873.725,620.225 989.852,641.591      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"1014.988,569.954 999.314,620.19 937.256,608.349 931.537,559.648         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"931.537,559.648 937.256,608.349 927.863,625.247 893.331,619.22      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"937.256,608.349 999.314,620.19 994.126,636.815 927.863,625.247      "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"350.846,468.29 352.726,522.343 402.117,457.86 403.827,412.605   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"350.846,468.29 278.252,434.022 286.871,482.83 352.726,522.343   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"403.827,412.605 340.25,388.933 360.604,345.342 425.532,367.492      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"340.25,388.933 278.252,434.022 249.846,397.556 315.62,357.314       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"403.827,412.605 350.846,468.29 370.009,458.821 415.775,408.096      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262015",d:"M350.846,468.29c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L350.846,468.29z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"340.25,388.933 344.365,439.151 326.22,456.842 278.252,434.022       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"344.365,439.151 368.832,449.385 403.827,412.605 340.25,388.933      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"344.365,439.151 326.22,456.842 350.846,468.29 368.832,449.385       "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"638.3,502.71 640.179,556.763 689.571,492.28 691.28,447.025  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"638.3,502.71 565.706,468.442 574.325,517.25 640.179,556.763     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"691.28,447.025 627.704,423.353 648.057,379.762 712.986,401.912      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"627.704,423.353 565.706,468.442 537.299,431.976 603.074,391.734         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"691.28,447.025 638.3,502.71 657.463,493.241 703.229,442.516         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262015",d:"M638.3,502.71c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L638.3,502.71z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"627.704,423.353 631.818,473.571 613.673,491.262 565.706,468.442         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"631.818,473.571 656.285,483.805 691.28,447.025 627.704,423.353      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"631.818,473.571 613.673,491.262 638.3,502.71 656.285,483.805        "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"765.281,534.107 767.161,588.159 816.552,523.676 818.262,478.421     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"765.281,534.107 692.687,499.839 701.306,548.646 767.161,588.159     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"818.262,478.421 754.685,454.749 775.039,411.158 839.967,433.309         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"754.685,454.749 692.687,499.839 664.281,463.373 730.055,423.13      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"818.262,478.421 765.281,534.107 784.445,524.638 830.21,473.912      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262015",d:"M765.281,534.107c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L765.281,534.107z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"754.685,454.749 758.8,504.968 740.655,522.658 692.687,499.839       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"758.8,504.968 783.267,515.201 818.262,478.421 754.685,454.749       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"758.8,504.968 740.655,522.658 765.281,534.107 783.267,515.201       "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"1056.068,574.11 1057.948,628.162 1107.339,563.679 1109.048,518.425  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"1056.068,574.11 983.474,539.842 992.093,588.649 1057.948,628.162    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"1109.048,518.425 1045.472,494.753 1065.825,451.162 1130.754,473.312         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"1045.472,494.753 983.474,539.842 955.068,503.376 1020.842,463.134       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"1109.048,518.425 1056.068,574.11 1075.231,564.641 1120.997,513.916      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#262015",d:"M1056.068,574.11c-0.902,0-72.594-34.268-72.594-34.268l-36.748-8.792l89.503,44.188L1056.068,574.11z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"1045.472,494.753 1049.587,544.971 1031.442,562.662 983.474,539.842      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"1049.587,544.971 1074.054,555.204 1109.048,518.425 1045.472,494.753         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"1049.587,544.971 1031.442,562.662 1056.068,574.11 1074.054,555.204      "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"209.939,394.403 113.765,397.118 110.839,349.034 207.563,348.017     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"209.939,394.403 227.671,440.698 237.109,424.988 213.28,374.538  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"113.765,397.118 73.457,409.821 72.659,464.504 113.644,449.315   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"113.644,449.315 227.671,440.698 237.291,497.873 110.793,512.402     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"227.671,440.698 202.782,443.749 209.939,394.403     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"209.939,394.403 202.782,443.749 113.644,449.315 113.765,397.118     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"435.964,564.254 433.45,623.072 336.929,600.198 335.169,546.659      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"435.964,564.254 456.827,497.393 453.056,548.418 433.45,623.072      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"456.827,497.393 461.477,456.798 377.586,447.75 373.376,487.087          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"373.376,487.087 335.169,546.659 294.261,523.534 339.003,465.219             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"456.827,497.393 435.964,564.254 448.783,554.702 468.138,485.83          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#262015",points:"435.964,564.254 335.169,546.659 315.563,547.664 431.691,569.03          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#050402",points:"456.827,497.393 441.152,547.629 379.094,535.788 373.376,487.087             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#15120C",points:"373.376,487.087 379.094,535.788 369.702,552.686 335.169,546.659             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#36260D",points:"379.094,535.788 441.152,547.629 435.964,564.254 369.702,552.686             "})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"front"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"712.282,748.881 715.692,828.673 846.632,797.643 849.019,725.012     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"712.282,748.881 683.98,658.178 689.094,727.399 715.692,828.673  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"683.98,658.178 677.671,603.108 791.477,590.833 797.188,644.198      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"797.188,644.198 849.019,725.012 904.515,693.641 843.819,614.531         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"683.98,658.178 712.282,748.881 694.891,735.924 668.635,642.493      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"712.282,748.881 849.019,725.012 875.616,726.376 718.079,755.36      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"683.98,658.178 705.244,726.328 789.431,710.264 797.188,644.198      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"797.188,644.198 789.431,710.264 802.173,733.188 849.019,725.012         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#594421",points:"789.431,710.264 705.244,726.328 712.282,748.881 802.173,733.188         "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"174.726,670.864 289.173,697.332 303.339,631.348 187.773,607.117     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"174.726,670.864 140.429,731.256 119.18,685.776 162.796,620.91   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"289.173,697.332 307.812,656.325 290.664,758.097 278.362,769.654     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"278.362,769.654 140.429,731.256 115.079,808.424 269.042,857.632     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"140.429,731.256 174.26,740.716 174.726,670.864  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"174.726,670.864 174.26,740.716 278.362,769.654 289.173,697.332  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"618.865,627.447 484.132,631.251 480.032,563.888 615.536,562.464     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"618.865,627.447 643.707,692.304 656.929,670.296 623.545,599.617     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"484.132,631.251 427.663,649.047 426.545,725.655 483.962,704.375     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"483.962,704.375 643.707,692.304 657.184,772.403 479.968,792.756     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"643.707,692.304 608.839,696.577 618.865,627.447     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"618.865,627.447 608.839,696.577 483.962,704.375 484.132,631.251     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"33.767,784.746 36.401,860.47 105.595,770.133 107.989,706.734    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"33.767,784.746 -67.932,736.738 -55.858,805.114 36.401,860.47    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"107.989,706.734 18.923,673.571 47.437,612.503 138.398,643.534       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"18.923,673.571 -67.932,736.738 -107.728,685.652 -15.582,629.275         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"107.989,706.734 33.767,784.746 60.614,771.481 124.729,700.417       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#494232",d:"M33.767,784.746c-1.263,0-101.7-48.007-101.7-48.007l-51.482-12.318L5.974,786.325L33.767,784.746z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"18.923,673.571 24.687,743.924 -0.733,768.707 -67.932,736.738        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"24.687,743.924 58.964,758.26 107.989,706.734 18.923,673.571         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#594421",points:"24.687,743.924 -0.733,768.707 33.767,784.746 58.964,758.26      "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"697.971,609.134 825.708,638.676 841.519,565.029 712.534,537.984     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"697.971,609.134 659.692,676.539 635.975,625.777 684.657,553.379     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"825.708,638.676 846.512,592.907 827.373,706.497 813.642,719.396     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"813.642,719.396 659.692,676.539 631.398,762.668 803.24,817.591  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"659.692,676.539 697.451,687.097 697.971,609.134     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"697.971,609.134 697.451,687.097 813.642,719.396 825.708,638.676     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"440.277,836.726 436.756,919.126 301.535,887.082 299.07,812.077  "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"440.277,836.726 469.505,743.058 464.223,814.542 436.756,919.126     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"469.505,743.058 476.019,686.188 358.494,673.511 352.595,728.62      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"352.595,728.62 299.07,812.077 241.76,779.68 304.441,697.984         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"469.505,743.058 440.277,836.726 458.236,823.345 485.351,726.86      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"440.277,836.726 299.07,812.077 271.604,813.485 434.291,843.417      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"469.505,743.058 447.546,813.436 360.606,796.847 352.595,728.62      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"352.595,728.62 360.606,796.847 347.448,820.52 299.07,812.077        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#594421",points:"360.606,796.847 447.546,813.436 440.277,836.726 347.448,820.52      "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"1026.287,746.416 1022.766,828.816 887.545,796.772 885.08,721.767    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"1026.287,746.416 1055.514,652.748 1050.232,724.231 1022.766,828.816     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"1055.514,652.748 1062.029,595.878 944.503,583.201 938.605,638.31        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"938.605,638.31 885.08,721.766 827.77,689.37 890.45,607.674      "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"1055.514,652.748 1026.287,746.416 1044.246,733.035 1071.361,636.549         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"1026.287,746.416 885.08,721.766 857.614,723.175 1020.301,753.107        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"1055.514,652.748 1033.555,723.126 946.616,706.537 938.605,638.31        "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"938.605,638.31 946.616,706.537 933.458,730.209 885.08,721.767       "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#594421",points:"946.616,706.537 1033.555,723.126 1026.287,746.416 933.458,730.209       "})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"400.489,717.376 395.785,827.448 215.155,784.642 211.862,684.449         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"400.489,717.376 439.531,592.252 432.476,687.742 395.785,827.448         "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"439.531,592.252 448.234,516.284 291.241,499.35 283.361,572.966          "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"283.361,572.966 211.862,684.449 135.306,641.173 219.035,532.042             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"439.531,592.252 400.489,717.376 424.479,699.502 460.699,570.614             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#494232",points:"400.489,717.376 211.862,684.449 175.171,686.331 392.492,726.314             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#282114",points:"439.531,592.252 410.198,686.265 294.063,664.105 283.362,572.966             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#383122",points:"283.362,572.966 294.063,664.105 276.485,695.727 211.862,684.449             "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#594421",points:"294.063,664.105 410.198,686.265 400.489,717.376 276.485,695.727             "}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"legend"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"light"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#9DE1E3",points:"647,768 595.69,0 459.843,0 377,768 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#CFE1E3",points:"610.105,768 565.081,0 470.307,0 404.896,768 \t\t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#DDE3E3",points:"593.907,768 513.405,0 489.326,0 502.082,768 \t\t"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"fingerbang",d:"M611.323,402.209l-0.002-0.006l-5.295-17.21l-3.971-17.207l-0.002-0.009l-18.293-4.573l-8.193-2.048 l-3.973-9.27l-1.617-0.308l-26.194-4.989l-0.014-0.138l-1.284-13.092l-1.112-11.23l-8.25-5.403l-1.963-0.201l-14.432-1.48 l-1.43-0.146l-6.701,2.384l0.093-49.49L496.77,251.9c0,0-6.622-1.324-7.946-1.324c-0.001,0-0.002,0.001-0.003,0.001 c-0.908,0.013-6.039,6.677-9.267,10.977c-1.531,2.059-2.64,3.577-2.647,3.587l-0.001,0.002v0.007l-0.702,81.332l-0.223,26.775 l-0.002,0.268l-6.688,31.651l-6.224-9.085l-20.936-30.497l-0.319-0.465l-19.07-4.767l-2.119-0.53l0,0l0,0l-0.45,0.371l-7.496,6.251 l0,0l0,0l1.616,3.589l4.688,10.385l17.268,38.283l0.054,0.12l0.006,0.028l4.179,20.432l8.846,14.422l12.343,25.308l22.513,14.567 l-1.324,23.838H591.46l0,0l0,0l-0.001-0.006l-1.324-14.561l1.814-4.834l14.078-37.544l1.324-43.702L611.323,402.209 L611.323,402.209L611.323,402.209z"}))))));}}]);return IntroView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Intro=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(){return{};},mapDispatchToProps)(IntroView);/* harmony default export */ __webpack_exports__["a"] = (Intro);

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * VERSION: 0.6.2
 * DATE: 2018-02-15
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 */
var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {

	"use strict";

		var _getText = function(e) {
				var type = e.nodeType,
					result = "";
				if (type === 1 || type === 9 || type === 11) {
					if (typeof(e.textContent) === "string") {
						return e.textContent;
					} else {
						for ( e = e.firstChild; e; e = e.nextSibling ) {
							result += _getText(e);
						}
					}
				} else if (type === 3 || type === 4) {
					return e.nodeValue;
				}
				return result;
			},
			_emoji = "[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D]|[\uD800-\uDBFF][\uDC00-\uDFFF]",
			_emojiExp = new RegExp(_emoji),
			_emojiAndCharsExp = new RegExp(_emoji + "|.", "g"),
			_emojiSafeSplit = function(text, delimiter) {
				return ((delimiter === "" || !delimiter) && _emojiExp.test(text)) ? text.match(_emojiAndCharsExp) : text.split(delimiter || "");
			},
			/* //previous emoji-related splitting. New method above is faster and more concise.
			_emojiStart = 0xD800,
			_emojiEnd = 0xDBFF,
			_emojiLowStart = 0xDC00,
			_emojiRegionStart = 0x1F1E6,
			_emojiRegionEnd = 0x1F1FF,
			_emojiModStart = 0x1f3fb,
			_emojiModEnd = 0x1f3ff,
			_emojiPairCode = function(s) {
				return ((s.charCodeAt(0) - _emojiStart) << 10) + (s.charCodeAt(1) - _emojiLowStart) + 0x10000;
			},
			_emojiSafeSplit = function(text, delimiter) { //like calling String.split(delimiter) except that it keeps emoji characters together.
				if (delimiter !== "") {
					return text.split(delimiter);
				}
				var l = text.length,
					a = [],
					character, i, emojiPair1, emojiPair2, j;
				for (i = 0; i < l; i++) {
					character = text.charAt(i);
					if ((character.charCodeAt(0) >= _emojiStart && character.charCodeAt(0) <= _emojiEnd) || (text.charCodeAt(i+1) >= 0xFE00 && text.charCodeAt(i+1) <= 0xFE0F)) { //special emoji characters use 2 or 4 unicode characters that we must keep together.
						emojiPair1 = _emojiPairCode(text.substr(i, 2));
						emojiPair2 = _emojiPairCode(text.substr(i + 2, 2));
						j = ((emojiPair1 >= _emojiRegionStart && emojiPair1 <= _emojiRegionEnd && emojiPair2 >= _emojiRegionStart && emojiPair2 <= _emojiRegionEnd) || (emojiPair2 >= _emojiModStart && emojiPair2 <= _emojiModEnd)) ? 4 : 2;
						a.push(text.substr(i, j));
						i += j - 1;
					} else {
						a.push(character);
					}
				}
				return a;
			},
			*/
			TextPlugin = _gsScope._gsDefine.plugin({
				propName: "text",
				API: 2,
				version:"0.6.2",

				//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
				init: function(target, value, tween, index) {
					var i = target.nodeName.toUpperCase(),
						shrt;
					if (typeof(value) === "function") {
						value = value(index, target);
					}
					this._svg = (target.getBBox && (i === "TEXT" || i === "TSPAN"));
					if (!("innerHTML" in target) && !this._svg) {
						return false;
					}
					this._target = target;
					if (typeof(value) !== "object") {
						value = {value:value};
					}
					if (value.value === undefined) {
						this._text = this._original = [""];
						return true;
					}
					this._delimiter = value.delimiter || "";
					this._original = _emojiSafeSplit(_getText(target).replace(/\s+/g, " "), this._delimiter);
					this._text = _emojiSafeSplit(value.value.replace(/\s+/g, " "), this._delimiter);
					this._runBackwards = (tween.vars.runBackwards === true);
					if (this._runBackwards) {
						i = this._original;
						this._original = this._text;
						this._text = i;
					}
					if (typeof(value.newClass) === "string") {
						this._newClass = value.newClass;
						this._hasClass = true;
					}
					if (typeof(value.oldClass) === "string") {
						this._oldClass = value.oldClass;
						this._hasClass = true;
					}
					i = this._original.length - this._text.length;
					shrt = (i < 0) ? this._original : this._text;
					this._fillChar = value.fillChar || (value.padSpace ? "&nbsp;" : "");
					if (i < 0) {
						i = -i;
					}
					while (--i > -1) {
						shrt.push(this._fillChar);
					}
					return true;
				},

				//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
				set: function(ratio) {
					if (ratio > 1) {
						ratio = 1;
					} else if (ratio < 0) {
						ratio = 0;
					}
					if (this._runBackwards) {
						ratio = 1 - ratio;
					}
					var l = this._text.length,
						i = (ratio * l + 0.5) | 0,
						applyNew, applyOld, str;
					if (this._hasClass) {
						applyNew = (this._newClass && i !== 0);
						applyOld = (this._oldClass && i !== l);
						str = (applyNew ? "<span class='" + this._newClass + "'>" : "") + this._text.slice(0, i).join(this._delimiter) + (applyNew ? "</span>" : "") + (applyOld ? "<span class='" + this._oldClass + "'>" : "") + this._delimiter + this._original.slice(i).join(this._delimiter) + (applyOld ? "</span>" : "");
					} else {
						str = this._text.slice(0, i).join(this._delimiter) + this._delimiter + this._original.slice(i).join(this._delimiter);
					}
					if (this._svg) { //SVG text elements don't have an "innerHTML" in Microsoft browsers.
						this._target.textContent = str;
					} else {
						this._target.innerHTML = (this._fillChar === "&nbsp;" && str.indexOf("  ") !== -1) ? str.split("  ").join("&nbsp;&nbsp;") : str;
					}
				}

			}),
			p = TextPlugin.prototype;

		p._newClass = p._oldClass = p._delimiter = "";

}); if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); }

//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
(function(name) {
	"use strict";
	var getGlobal = function() {
		return (_gsScope.GreenSockGlobals || _gsScope)[name];
	};
	if (typeof(module) !== "undefined" && module.exports) { //node
		__webpack_require__(87);
		module.exports = getGlobal();
	} else if (true) { //AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(87)], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
}("TextPlugin"));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScoreEntry__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return{scores:state.scores};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getHighScores:function getHighScores(round){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators_js__["g" /* getHighScores */])(round));}};};var HighScoresView=function(_Component){_inherits(HighScoresView,_Component);function HighScoresView(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HighScoresView);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HighScoresView.__proto__||Object.getPrototypeOf(HighScoresView)).call.apply(_ref,[this].concat(args))),_this),_this.back=function(e){_this.props.router.push('/');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HighScoresView,[{key:'componentDidMount',value:function componentDidMount(){this.props.getHighScores();this.animateEye();}},{key:'componentWillUnMount',value:function componentWillUnMount(){__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].killAll(true,true,true,true);}},{key:'animateEye',value:function animateEye(){var _this2=this;__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].set(['#mover','#eyelid','#iris'],{autoAlpha:0});__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].delayedCall(2,function(){return _this2.moveEye();});}},{key:'moveEye',value:function moveEye(){var _this3=this;__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].set(['#mover','#iris'],{autoAlpha:1});__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].delayedCall(1,function(){return _this3.squint();});}},{key:'squint',value:function squint(){var _this4=this;__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].set(['#eyelid'],{autoAlpha:1});__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to('#mover',1,{x:-10,delay:0.2,ease:__WEBPACK_IMPORTED_MODULE_4_gsap__["Sine"].easeOut,onComplete:function onComplete(){return _this4.randomMoves();}});}},{key:'randomMoves',value:function randomMoves(){var _this5=this;__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to('#mover',this.getRandomArbitrary(0.2,1.2),{x:this.getRandomArbitrary(-15,15),y:this.getRandomArbitrary(-5,5),delay:this.getRandomArbitrary(0,1.4),ease:__WEBPACK_IMPORTED_MODULE_4_gsap__["Sine"].easeOut,onComplete:function onComplete(){return _this5.randomMoves();}});if(Math.random()>0.75)this.blink();// 50-50 odds of blinking
}},{key:'blink',value:function blink(){__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].set(['#mover','#iris'],{autoAlpha:0});__WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].set(['#mover','#iris'],{autoAlpha:1,delay:0.2});}},{key:'getRandomArbitrary',value:function getRandomArbitrary(min,max){return Math.random()*(max-min)+min;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'highscores'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaderboardeye'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',id:'eyeinabox',x:'0px',y:'0px',viewBox:'0 0 265.768 180.509',enableBackground:'new 0 0 265.768 180.509',preserveAspectRatio:'xMidYMid meet'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'0,7.502 132.99,7.502 132.99,180.509 0,154.014 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#281E17',points:'0,7.502 0,154.014 48.684,145.823 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#38281C',points:'0,7.502 113.291,17.282 113.079,0 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#38281C',points:'0,154.014 132.99,180.509 132.99,159.362 132.884,159.362 48.702,145.823 48.684,145.823 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#38281C',points:'113.079,0 113.291,17.282 132.99,18.976 265.768,10.044 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#281E17',points:'132.99,159.362 132.99,180.509 265.768,154.014 132.99,137.068 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#281E17',points:'132.99,18.976 132.99,137.068 265.768,154.014 265.768,97.792 236.66,102.029 236.66,65.842  265.768,63.3 265.768,10.044 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:'#38281C',points:'236.66,65.842 236.66,102.029 265.768,97.792 265.768,63.3 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'iris'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ellipse',{transform:'matrix(0.3162 -0.9487 0.9487 0.3162 -6.3649 129.561)',fill:'#455359',cx:'86.697',cy:'69.196',rx:'26.837',ry:'26.837'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{fill:'#748489',cx:'82.575',cy:'66.63',r:'20.974'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'mover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{fill:'#721010',cx:'84.514',cy:'70.963',r:'11.578'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{fill:'#160E08',cx:'84.514',cy:'70.963',r:'5.411'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{fill:'#CECAC0',cx:'76.846',cy:'62.987',r:'2.845'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'eyelid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M47.511,66.63c20.152-4.596,57.441-6.341,76.006,7.146c0,0-3.174-37.924-34.591-37.924S47.511,66.63,47.511,66.63z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M123.517,77.109c-20.152,4.596-57.441,6.341-76.006-7.146c0,0,3.174,37.924,34.591,37.924S123.517,77.109,123.517,77.109z'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaderboard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'HIGH SCORES'),this.props.scores.highscores!==undefined&&this.props.scores.highscores.sort(function(a,b){return a.score>b.score?-1:1;})// alphabetical by name 'place'
.map(function(user,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ScoreEntry__["a" /* default */],{key:index,rank:index+1,name:user.twitterHandle,score:user.score});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaderboard-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btnPill hover',onClick:this.back},'Back')));}}]);return HighScoresView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var HighScores=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(HighScoresView);/* harmony default export */ __webpack_exports__["a"] = (HighScores);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScoreEntry=function(_Component){_inherits(ScoreEntry,_Component);function ScoreEntry(){_classCallCheck(this,ScoreEntry);return _possibleConstructorReturn(this,(ScoreEntry.__proto__||Object.getPrototypeOf(ScoreEntry)).apply(this,arguments));}_createClass(ScoreEntry,[{key:"displayUsername",value:function displayUsername(){if(this.props.name===undefined){return null;}else return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://twitter.com/"+this.props.name},"@",this.props.name);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"score-entry"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"rank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"place"},this.props.rank)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"name"},this.displayUsername()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"scored"},this.props.score.toLocaleString()));}}]);return ScoreEntry;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ScoreEntry);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Images_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_player__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_player__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { Link } from 'react-router';
// import TopScoreEntry from "../TopScoreEntry";
// import { getRank } from '../../actions/actionCreators.js';
// client logos
// user portraits
// video player
var mapStateToProps=function mapStateToProps(state){return{score:state.game.score,// || 9411999, // for testing
rank:state.game.rank,scores:state.scores,token:state.game.token,// || 'SZz-w_3pJAvVZp3VWX6LHM5D5FigsLOm1MH0MKDyrlrXjUdkovNGurl_0I-Ohq0SetMHvgkDSjyiU3I=', // for testing
mobile:state.game.mobile,showPlayback:false};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{// getRank : score => dispatch( getRank( score ) )
};};var WinnerView=function(_Component){_inherits(WinnerView,_Component);function WinnerView(props){_classCallCheck(this,WinnerView);var _this=_possibleConstructorReturn(this,(WinnerView.__proto__||Object.getPrototypeOf(WinnerView)).call(this,props));_this.state={twitterAccount:"",ranking:0};return _this;}_createClass(WinnerView,[{key:'playAgain',value:function playAgain(){// reload site to play again
window.location.reload();// old method, go back to beginning
// this.props.router.push('/');
}// leaderboard () {
// 	this.props.router.push('/scores');
// }
},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;// this.props.getRank( this.props.score );
var tl=new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]({});// .timeScale(2)
tl.set(this.refs.winBoss,{css:{left:'800px'},transformOrigin:"center center"}).to(this.refs.winBoss,2,{css:{bottom:'-300px',left:'0',rotation:'-60deg'},ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeIn,x:100,delay:1}).set(this.refs.winBoss,{css:{rotation:'0'}}).to(this.refs.winBoss,3,{css:{bottom:'0',rotation:'-20deg'},ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeInOut,delay:0.5}).to(this.refs.winBoss,4,{css:{rotation:'-70deg'},ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeInOut},'-=1').to(this.refs.winBoss,6,{css:{bottom:'-300px'},ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeIn},'-=3.5');// // score
__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set(['.yourMsg','.youScored','.final_score','.defeatedBoss'],{scaleX:0,scaleY:0});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to('.defeatedBoss',0.6,{scaleX:1,scaleY:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut,delay:1.2});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to('.youScored',0.6,{scaleX:1,scaleY:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut,delay:2.6});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to('.final_score',0.6,{scaleX:1,scaleY:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut,delay:3.2});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to('.yourMsg',0.6,{scaleX:1,scaleY:1,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut,delay:5});__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(['.yourMsg','.youScored','.final_score','.defeatedBoss'],0.6,{scaleX:0,scaleY:0,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut,delay:8,autoAlpha:0,onComplete:function onComplete(){return _this2.showPlayback();}});}},{key:'showPlayback',value:function showPlayback(){// console.log('show playback');
__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].set('.winner-imagery',{autoAlpha:0,css:{display:'none'}});var twitterMsg='I beat B.O.S.S. and scored '+this.props.score.toLocaleString()+' points in Rage Click! Try it out at rage-click.com #rageclick';var twitterLink='https://twitter.com/home?status='+encodeURIComponent(twitterMsg);// console.log('twitterMsg', twitterLink);
var linkedinLink='https://www.linkedin.com/sharing/share-offsite/?url=http%3A%2F%2Frage-click.com';this.setState({showPlayback:true,twitterPrepPop:twitterLink,LinkedInPrepPop:linkedinLink});}},{key:'animateOut',value:function animateOut(){var _this3=this;__WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to('.win-wrap',1.4,{autoAlpha:0,delay:0.2,ease:__WEBPACK_IMPORTED_MODULE_2_gsap__["Sine"].easeInOut,onComplete:function onComplete(){return _this3.props.router.push("/replay");}});}},{key:'handleTwitterAccountChange',value:function handleTwitterAccountChange(e){this.setState({twitterAccount:e.target.value});}},{key:'handleSubmit',value:function handleSubmit(){if(this.state.twitterAccount!=="")this.props.postScore(this.props.score,this.state.twitterAccount);}},{key:'render',value:function render(){var _this4=this;var replayData=this.props.token!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{width:'100%',height:'100%',src:'https://app.fullstory.com/embed/'+this.props.token+'?autoPlay=1&hideEventList='+(this.props.mobile?'1':'1'),frameBorder:'0',title:'Your gameplay'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Unable to retrieve playback.');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'winner '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-wrap'},!this.state.showPlayback&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'winner-imagery'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'congrats-message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'defeatedBoss'},'With the power of the Rage Click,',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'you defeated B.O.S.S.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'youScored'},'AND SCORED'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'final_score'},this.props.score.toLocaleString()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'yourMsg'},'AWESOME!!!',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'NOW LET\'S SEE YOUR PLAYBACK!'))),this.state.showPlayback&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'winning-final-screen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'winning-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rclogo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score-social'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myscore'},'My Score'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score-number'},this.props.score.toLocaleString())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{ref:'startbutton',onClick:function onClick(e){return _this4.playAgain();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Play Again')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.state.LinkedInPrepPop,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:'16',height:'16',viewBox:'0 0 16 16',fill:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fillRule:'evenodd',clipRule:'evenodd',d:'M0 13.6039C0 14.9276 1.07263 16 2.39607 16H13.6039C14.9276 16 16 14.9274 16 13.6039V2.39607C16 1.0724 14.9274 0 13.6039 0H2.39607C1.0724 0 0 1.07263 0 2.39607V13.6039ZM2.39534 1.60007H13.6032C14.0431 1.60007 14.3993 1.9562 14.3993 2.39614V13.604C14.3993 14.0439 14.0431 14.4001 13.6032 14.4001H2.39534C1.95547 14.4001 1.59926 14.0439 1.59926 13.604V2.39614C1.59926 1.95628 1.9554 1.60007 2.39534 1.60007ZM4.8 6.39993C4.35817 6.39993 4 6.7581 4 7.19993V11.1999C4 11.6418 4.35817 11.9999 4.8 11.9999C5.24183 11.9999 5.6 11.6418 5.6 11.1999V7.19993C5.6 6.7581 5.24183 6.39993 4.8 6.39993ZM4.8 5.6C5.24183 5.6 5.6 5.24183 5.6 4.8C5.6 4.35817 5.24183 4 4.8 4C4.35817 4 4 4.35817 4 4.8C4 5.24183 4.35817 5.6 4.8 5.6ZM9.40055 7.99993C8.84947 7.99993 8.40055 8.44855 8.40055 9.00013V11.1999C8.40055 11.6418 8.04238 11.9999 7.60055 11.9999C7.15872 11.9999 6.80055 11.6418 6.80055 11.1999V9.00013C6.80055 7.56466 7.96605 6.39993 9.40055 6.39993C10.8356 6.39993 12.0006 7.56642 12.0006 9.00013V11.1999C12.0006 11.6418 11.6424 11.9999 11.2006 11.9999C10.7587 11.9999 10.4006 11.6418 10.4006 11.1999V9.00013C10.4006 8.4496 9.95149 7.99993 9.40055 7.99993Z',fill:'#FF5910'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.state.twitterPrepPop,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:'18',height:'16',viewBox:'0 0 18 16',fill:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fillRule:'evenodd',clipRule:'evenodd',d:'M12.0038 7.35413e-05C9.28361 0.0142437 7.65771 2.03783 7.56794 4.65866L7.56937 4.70599C5.71881 4.25656 4.09986 3.19729 2.94766 1.68738C2.54971 1.16589 1.74333 1.24034 1.44759 1.82587C-0.155221 4.99923 0.001372 8.83152 2.75842 11.587L2.80396 11.6306L2.68153 11.6599C2.25413 11.7615 1.02313 12.0207 0.888993 12.0472C0.809003 12.063 0.752347 12.074 0.72295 12.0796C0.0820839 12.202 -0.212959 12.9501 0.171849 13.477C1.46174 15.2431 3.3335 16 6.23069 16C12.0973 16 16.4527 11.6158 16.457 5.26996C16.457 5.19482 16.4554 5.07854 16.4541 4.99289L16.4541 4.99177L16.4541 4.99014L16.4541 4.98931C16.4534 4.9415 16.4529 4.90375 16.4529 4.88893C16.4529 4.78883 16.4507 4.68951 16.4463 4.59104L17.2946 3.38276C17.774 2.69991 17.2557 1.76488 16.4225 1.80961L15.6139 1.85303C14.8614 0.712278 13.6263 -0.00837833 12.0038 7.35413e-05ZM6.23079 14.2222C11.1131 14.2222 14.6757 10.6361 14.6793 5.26873C14.6794 5.20734 14.6775 5.07168 14.6763 4.97976L14.6763 4.97951V4.97945C14.6757 4.93274 14.6752 4.89738 14.6752 4.88891C14.6752 3.04061 13.7058 1.76898 12.0132 1.7778C10.3085 1.78668 9.34189 3.04917 9.34189 4.88891C9.34189 4.94218 9.34118 5.13392 9.34048 5.32614L9.34048 5.32663C9.33977 5.51963 9.33906 5.71298 9.33906 5.767C9.33906 6.30012 8.87302 6.71333 8.34374 6.64949C6.11433 6.38058 4.09019 5.40198 2.52838 3.88575L2.50495 3.95496C2.40088 4.30543 2.32301 4.66007 2.27284 5.01595C2.30185 5.05042 2.33582 5.08946 2.37477 5.13245C2.58893 5.36887 2.85299 5.60812 3.16731 5.83256C3.40849 6.00477 3.66964 6.1609 3.95109 6.29706C4.39301 6.51084 4.57796 7.0424 4.36417 7.48432C4.15039 7.92625 3.61883 8.11119 3.17691 7.8974C2.89747 7.76222 2.63282 7.61205 2.38278 7.44901C2.7347 8.88605 3.6233 10.2278 5.15547 11.2636C5.72765 11.6504 5.65942 12.5134 5.03356 12.8055C4.7991 12.9149 3.45277 13.3039 3.0926 13.3895C2.97065 13.4185 2.71488 13.4778 2.71488 13.4778C3.54525 13.9669 4.70913 14.2222 6.23079 14.2222Z',fill:'#0A2032'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'by-fullstory'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Brought to you by'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',id:'Layer_1',x:'0px',y:'0px',viewBox:'0 0 135.2 39'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M66.4,25.1c0,4.1-3.2,6-7.4,6c-2.3,0-4.6-0.6-6.1-1.6l0,0v-4.2c1.8,1.4,4,2.2,6,2.2s3.3-0.7,3.3-2.2   c0-1.6-1.2-2.2-3.7-2.8c-4.1-0.9-5.8-2.6-5.8-6c0-4,3-6,7-6c2.2,0,4,0.5,5.7,1.5v4c-1.7-1.2-3.4-2-5.5-2C58,14,57,14.9,57,16.2   s0.8,2,3.1,2.6C64.5,19.9,66.4,21.5,66.4,25.1z M45,31h4V0h-4V31z M37,31h4V0h-4V31z M7.4,7.2c0-2.4,1.1-3.3,2.9-3.3   c1.3,0,2.3,0.4,3.4,1.1V1c-1.1-0.7-2.3-1-3.9-1c-4,0-6.7,2.4-6.7,7.3V11H0v3.7h3.1V31h4.4V14.7h6.6V11H7.4V7.2z M28.4,27.2   c-1.1,0.2-2.3,0.3-3.4,0.3c-2.9,0-4.7-1.1-4.7-4V11H16v12.8c0,5.5,3.5,7.3,9.1,7.3c2.3,0,5.4-0.3,7.7-0.9V11h-4.4V27.2z M74,24v-9.4   h5.6V11H74V6h-4.4v5H67v3.7h2.7V25c0,4.5,2.7,6.1,5.9,6.1c1.9,0,3.5-0.4,4.8-1.1v-4c-1.2,0.7-2.3,1.1-3.6,1.1C75,27.2,74,26.4,74,24   z M111.9,10.7c-2.8,0-5.6,0.8-7.7,2V31h4.4V15.4c1-0.4,2.2-0.6,3.3-0.6c0.7,0,1.4,0.1,2.1,0.2l-1.6-4.3   C112.4,10.7,112.1,10.7,111.9,10.7z M130.7,11l-5.5,15.5L119.5,11h-4.7l8.2,20.5l-2.8,7.5h4.3l10.7-28H130.7z M101.5,20.8   c0,6.1-4.3,10.3-10.2,10.3c-5.9,0-10.2-4.2-10.2-10.3s4.3-10.3,10.2-10.3C97.2,10.5,101.5,14.7,101.5,20.8z M97,20.8   c0-4-2.4-6.5-5.8-6.5c-3.3,0-5.7,2.5-5.7,6.5s2.4,6.5,5.7,6.5C94.6,27.3,97,24.8,97,20.8z'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'replay-marketing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marketing-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Resolve rage on your website'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'FullStory reproduces real user experiences on your website, showing you the good, the bad, and the rageful.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/signup/',className:'fs-button pill medium white'},'Start Your Free Trial')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'replay'},replayData,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'watch-playback-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',width:'258',height:'101',viewBox:'0 0 258 101'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M4.31252 71.4307C4.15315 71.4448 3.96215 71.344 3.73952 71.1282C3.51689 70.9123 3.3952 70.6876 3.37445 70.4538C3.35275 70.2094 3.54257 69.0307 3.94392 66.9176C4.34527 64.8045 4.5408 63.2076 4.53051 62.1269C4.38484 62.0542 4.25086 61.9322 4.12858 61.761C4.00629 61.5899 3.93901 61.4352 3.92675 61.2971C3.90505 61.0527 4.24413 60.7709 4.94398 60.4518C5.64288 60.122 6.42796 59.9185 7.29919 59.8411C8.18106 59.7628 8.9596 59.9078 9.63483 60.2762C10.3197 60.633 10.6962 61.194 10.7641 61.9589C10.8103 62.4796 10.705 62.9815 10.448 63.4648C10.2008 63.9365 9.8774 64.3347 9.47787 64.6593C9.08898 64.9829 8.69725 65.2747 8.30269 65.5347C7.90813 65.7946 7.56871 66.0121 7.28442 66.1873C7.00981 66.3509 6.87534 66.4645 6.881 66.5283C6.90175 66.762 7.10926 67.0488 7.50353 67.3886C7.90842 67.7275 8.19137 67.9593 8.35238 68.0843C8.51339 68.2092 8.72646 68.3776 8.99159 68.5897C9.25577 68.7911 9.50213 68.9727 9.73067 69.1345C9.96983 69.2953 10.1583 69.4285 10.2962 69.534C10.4447 69.6386 10.5937 69.7485 10.7431 69.8638C11.0305 70.0846 11.1807 70.2693 11.1939 70.4181C11.2166 70.6731 11.0526 70.8161 10.702 70.8473C10.0645 70.9039 9.10699 70.432 7.82951 69.4318C6.5511 68.4209 5.74464 67.5394 5.41015 66.7874C5.05795 68.4892 4.85646 69.4762 4.80567 69.7485C4.75394 70.0101 4.69252 70.2832 4.62143 70.568C4.50049 71.1356 4.39752 71.4231 4.31252 71.4307ZM5.93933 62.4355C6.00065 63.1262 5.87894 64.2881 5.57421 65.9215C5.74257 65.7673 6.06995 65.5348 6.55636 65.2239C7.04183 64.9024 7.47652 64.6121 7.86046 64.3531C8.25407 64.0826 8.6039 63.741 8.90993 63.3283C9.21596 62.9156 9.35058 62.5021 9.31379 62.0877C9.2553 61.429 8.65231 61.1506 7.50483 61.2524C6.98421 61.2987 6.39038 61.4853 5.72335 61.8122C5.85035 62.0365 5.92235 62.2443 5.93933 62.4355ZM18.4134 64.8939C18.4634 65.457 18.1963 65.9466 17.6121 66.3625C17.0377 66.7669 16.3626 67.0036 15.587 67.0724C14.822 67.1404 14.1185 67.1171 13.4766 67.0028C13.3693 67.4835 13.3322 67.9098 13.3652 68.2817C13.3973 68.6429 13.5339 68.9146 13.7749 69.0966C14.0266 69.2777 14.4127 69.3452 14.9334 69.299C15.4646 69.2518 15.9984 69.1134 16.5349 68.8837C17.081 68.6424 17.3807 68.5195 17.4338 68.5147C17.71 68.4902 17.8576 68.5842 17.8765 68.7967C17.9019 69.0836 17.6057 69.4258 16.9878 69.8233C16.3689 70.2102 15.7514 70.4311 15.1351 70.4858C14.3064 70.5594 13.61 70.3749 13.046 69.9324C12.481 69.4792 12.1651 68.8755 12.0981 68.1211C12.0311 67.3667 12.1631 66.5626 12.4943 65.7086C12.8244 64.844 13.2832 64.1019 13.8707 63.4821C14.4582 62.8624 15.0654 62.5247 15.6923 62.4691C16.3191 62.4134 16.914 62.6604 17.4768 63.2101C18.0503 63.7589 18.3624 64.3202 18.4134 64.8939ZM15.8837 63.721C15.4906 63.756 15.1 63.9995 14.7118 64.4516C14.3226 64.893 14.0062 65.4298 13.7625 66.0618C14.1959 66.1197 14.6836 66.1246 15.2255 66.0765C15.7674 66.0284 16.2326 65.9014 16.6213 65.6956C17.009 65.4791 17.1901 65.2274 17.1646 64.9405C17.1392 64.6537 16.9804 64.3733 16.6884 64.0994C16.4069 63.8245 16.1387 63.6984 15.8837 63.721ZM25.5512 63.2964L25.7057 66.3025C25.7793 67.1312 25.8697 67.7282 25.9771 68.0935C26.3916 67.5748 26.7351 66.9821 27.0079 66.3153C27.2904 65.637 27.4867 65.0146 27.5971 64.4479C27.718 63.8803 27.8157 63.3523 27.8901 62.8638C27.9742 62.3637 28.0566 61.9655 28.1374 61.6692C28.2182 61.3729 28.3276 61.2186 28.4658 61.2064C28.6676 61.1885 28.8558 61.2574 29.0303 61.4133C29.2038 61.5585 29.3 61.7373 29.3189 61.9498C29.367 62.4917 29.2019 63.4059 28.8235 64.6924C28.511 65.8767 28.0625 66.9767 27.4781 67.9923C26.8927 68.9974 26.414 69.5164 26.0422 69.5494C25.6703 69.5825 25.3703 69.4003 25.1423 69.0029C24.9249 68.6045 24.7537 67.822 24.6286 66.6551C24.5027 65.4776 24.428 64.4562 24.4048 63.5909C23.849 65.6535 23.3348 67.2198 22.8623 68.2897C22.3897 69.3597 21.9888 69.9093 21.6594 69.9386C21.5107 69.9518 21.3452 69.8969 21.1629 69.7739C20.9913 69.6499 20.8477 69.4806 20.7323 69.266C20.4485 68.7236 20.1514 67.6684 19.8408 66.1004C19.5399 64.5208 19.3593 63.391 19.2989 62.711C19.2602 62.2754 19.3737 62.0458 19.6393 62.0222C19.8731 62.0015 20.0974 62.1154 20.3122 62.3641C20.5377 62.6118 20.6781 62.867 20.7336 63.1298C20.7881 63.382 20.8788 64.1021 21.0057 65.2902C21.1423 66.4667 21.3367 67.5096 21.5887 68.4189C21.9574 67.6258 22.309 66.6415 22.6437 65.466C22.989 64.2895 23.271 63.365 23.4897 62.6923C23.719 62.0187 23.9506 61.6716 24.1843 61.6508C24.5349 61.6197 24.8364 61.7589 25.0888 62.0684C25.3508 62.3664 25.505 62.7757 25.5512 63.2964ZM33.9572 60.8473C34.4353 60.8048 34.8979 61.0101 35.345 61.463C35.7912 61.9052 36.0318 62.3229 36.0667 62.716C36.1007 63.0985 36.0028 63.5034 35.773 63.9308C35.9146 64.0788 35.9907 64.2113 36.001 64.3282C36.0274 64.6257 36.0037 65.1418 35.9297 65.8765C35.8663 66.6104 35.8286 67.0902 35.8166 67.3162C35.8151 67.5412 35.8099 67.7237 35.8009 67.8637C35.791 67.9931 35.7758 68.123 35.7552 68.2533C35.7363 68.5227 35.6525 68.664 35.5037 68.6772C35.3125 68.6942 35.1385 68.5436 34.9817 68.2256C34.8347 67.896 34.7269 67.4665 34.6585 66.9371C33.8195 68.2217 32.9963 68.8998 32.1888 68.9715C31.7 69.0149 31.1982 68.8507 30.6833 68.4788C30.1781 68.0953 29.9056 67.6804 29.866 67.2342C29.8094 66.5967 29.9733 65.7897 30.3578 64.8132C30.7413 63.8261 31.2724 62.9329 31.9511 62.1338C32.6297 61.3346 33.2984 60.9058 33.9572 60.8473ZM34.9393 63.5872C34.8516 62.5991 34.6112 62.1224 34.218 62.1574C33.8037 62.1941 33.3467 62.5346 32.847 63.1786C32.3464 63.812 31.9379 64.5176 31.6214 65.2953C31.3049 66.073 31.1661 66.6797 31.2047 67.1153C31.2208 67.2959 31.3084 67.4381 31.4675 67.5417C31.6257 67.6348 31.8057 67.6723 32.0076 67.6544C32.5069 67.6101 33.0403 67.2254 33.6078 66.5004C34.1743 65.7647 34.5368 64.9026 34.6953 63.914C34.713 63.7518 34.7948 63.6482 34.9407 63.6031L34.9393 63.5872ZM39.5338 66.7131C39.5517 66.9149 39.6776 67.0055 39.9113 66.9847C40.3151 66.9489 40.7939 66.7939 41.3478 66.5199C41.9114 66.2342 42.2251 66.0886 42.2889 66.0829C42.4801 66.0659 42.5847 66.1584 42.6026 66.3603C42.63 66.6684 42.3428 67.0526 41.7412 67.513C41.1502 67.9724 40.5944 68.2252 40.0737 68.2714C39.5638 68.3167 39.1265 68.2163 38.762 67.9703C38.3965 67.7136 38.2006 67.4365 38.1741 67.139C38.1477 66.8415 38.178 66.4586 38.2649 65.9905C38.3509 65.5116 38.4773 64.8847 38.6441 64.1096C38.8205 63.3229 38.9556 62.6737 39.0494 62.1621C38.5604 62.3233 38.2309 62.4114 38.0609 62.4265C37.8909 62.4416 37.7134 62.3717 37.5283 62.2168C37.3529 62.0503 37.2581 61.8874 37.2439 61.7281C37.2213 61.4731 37.8902 61.1674 39.2507 60.811C39.3636 59.9121 39.3899 59.1227 39.3295 58.4427C39.3012 58.124 39.3933 57.9552 39.6058 57.9363C39.7865 57.9203 40.02 58.0173 40.3063 58.2275C40.5918 58.427 40.7472 58.6702 40.7727 58.9571C40.7982 59.244 40.7527 59.7567 40.6362 60.4952C41.2371 60.3883 41.7182 60.3188 42.0794 60.2867C42.7169 60.2301 43.0479 60.3399 43.0724 60.6162C43.0866 60.7756 42.9231 60.9239 42.5819 61.0613C42.2513 61.1978 41.5435 61.4266 40.4583 61.7478C40.3097 62.607 40.1135 63.5936 39.8697 64.7075C39.625 65.8108 39.513 66.4793 39.5338 66.7131ZM46.6195 67.6902C46.0033 67.7449 45.403 67.5573 44.8186 67.1273C44.2334 66.6866 43.9115 66.137 43.853 65.4782C43.7936 64.8088 43.9483 64.0187 44.3172 63.1079C44.6861 62.197 45.1938 61.4023 45.8403 60.7238C46.4975 60.0444 47.1607 59.6749 47.8301 59.6155C48.2657 59.5768 48.6656 59.7394 49.0299 60.1033C49.3942 60.4672 49.5895 60.7978 49.616 61.0953C49.6235 61.1803 49.6035 61.2571 49.5561 61.3255C49.5077 61.3834 49.4304 61.417 49.3241 61.4264C49.2285 61.4349 49.0447 61.3549 48.7727 61.1863C48.5007 61.0177 48.2638 60.9423 48.0619 60.9603C47.4882 61.0112 46.8636 61.5753 46.1883 62.6526C45.5129 63.7299 45.2087 64.6457 45.2757 65.4001C45.3049 65.7295 45.429 65.9808 45.6478 66.1541C45.8773 66.3265 46.2205 66.3924 46.6774 66.3518C47.1448 66.3103 47.5651 66.2195 47.9382 66.0793C48.3209 65.9275 48.6138 65.789 48.8169 65.6639C49.019 65.5282 49.1785 65.4551 49.2954 65.4447C49.4973 65.4268 49.6072 65.5188 49.6251 65.7207C49.6524 66.0288 49.3126 66.423 48.6057 66.9035C47.9084 67.3723 47.2464 67.6345 46.6195 67.6902ZM51.9883 55.3751C51.9515 54.9607 52.0606 54.7422 52.3156 54.7196C52.5175 54.7017 52.7442 54.8422 52.9956 55.1411C53.2576 55.4391 53.4019 55.7368 53.4283 56.0343C53.4896 56.7249 53.419 57.9199 53.2165 59.6191C53.0237 61.3068 52.7246 63.0039 52.3193 64.7104C53.211 62.693 53.9751 61.2276 54.6115 60.3145C55.2575 59.3897 55.8356 58.9047 56.3456 58.8594C56.6218 58.8348 56.9618 59.0456 57.3655 59.4917C57.7798 59.9367 58.0082 60.3984 58.0507 60.8765C58.0931 61.3546 58.024 62.0836 57.8433 63.0634C57.3977 65.5231 56.8828 66.7789 56.2984 66.8308C56.0647 66.8515 55.9336 66.7025 55.9053 66.3838C55.877 66.0651 55.9569 65.5172 56.1449 64.7402C56.5618 63.0433 56.7448 61.908 56.6938 61.3343C56.6768 61.143 56.6149 60.9879 56.5079 60.8689C56.401 60.7499 56.2785 60.6965 56.1403 60.7088C56.0022 60.721 55.8388 60.8105 55.6502 60.9772C55.4615 61.1439 55.2402 61.4259 54.9864 61.8232C54.6676 62.3334 54.338 62.9034 53.9978 63.5333C53.6681 64.1623 53.4664 64.5443 53.3927 64.6793C53.3287 64.8028 53.21 65.0329 53.0364 65.3696C52.8735 65.7053 52.7512 65.9571 52.6698 66.125C52.5874 66.2822 52.4851 66.4573 52.363 66.6501C52.1498 67.0225 51.9794 67.2143 51.8519 67.2256C51.7244 67.2369 51.544 67.1351 51.3108 66.9203C51.0766 66.6948 50.9524 66.5023 50.9383 66.343C50.9232 66.173 50.9538 65.8543 51.0301 65.3871C51.3802 63.2999 51.5908 61.8731 51.662 61.1064C51.9692 58.2949 52.078 56.3845 51.9883 55.3751ZM71.6215 57.503C71.7915 57.4879 71.9834 57.5994 72.1973 57.8374C72.4209 58.0638 72.5463 58.3311 72.5737 58.6392C72.5926 58.8517 72.4389 59.5936 72.1127 60.8647C71.7865 62.1359 71.5636 63.0017 71.4438 63.4621C71.3338 63.9109 71.1785 64.5137 70.9779 65.2704C70.7871 66.0155 70.6001 66.7442 70.4171 67.4565C70.0208 69.0231 69.2913 69.8535 68.2289 69.9478C67.6232 70.0016 67.0277 69.8671 66.4422 69.5443C65.8576 69.2321 65.5479 68.8794 65.5129 68.4863C65.4997 68.3376 65.5542 68.1667 65.6763 67.9739C65.7877 67.7819 65.8913 67.6817 65.9869 67.6732C66.0825 67.6647 66.247 67.7679 66.4802 67.9828C67.1587 68.6293 67.7158 68.9332 68.1514 68.8945C68.4808 68.8653 68.7523 68.5467 68.9661 67.9388C69.1807 67.3414 69.3724 66.6658 69.541 65.912C69.7213 65.1678 69.8187 64.7575 69.8333 64.6813C69.8586 64.6041 69.882 64.5056 69.9035 64.3859C69.9356 64.2653 69.9634 64.1557 69.9868 64.0573C69.3239 65.1549 68.6259 65.7362 67.8928 65.8013C67.4466 65.8409 67.0138 65.6705 66.5945 65.2901C66.1858 64.9088 65.9565 64.4365 65.9065 63.8734C65.8565 63.3103 65.9272 62.5384 66.1185 61.5576C66.3099 60.5768 66.5603 59.7193 66.8699 58.9851C67.1795 58.2508 67.4512 57.8733 67.685 57.8525C67.8762 57.8355 68.0595 57.9103 68.235 58.0768C68.42 58.2317 68.5206 58.3994 68.5366 58.5801C68.5527 58.7607 68.4481 59.1501 68.2227 59.7484C67.5187 61.5885 67.2101 62.9974 67.2969 63.9748C67.312 64.1448 67.3779 64.2836 67.4945 64.391C67.6102 64.4878 67.7424 64.5296 67.8912 64.5164C68.2736 64.4824 68.7003 64.1019 69.1712 63.3747C69.6421 62.6476 70.0591 61.7967 70.4223 60.8221C70.7244 60.0028 71.023 58.9643 71.3183 57.7066C71.3504 57.586 71.4515 57.5181 71.6215 57.503ZM77.9142 59.675C77.8822 59.3137 77.7935 58.9789 77.6484 58.6705C77.5022 58.3515 77.311 58.1276 77.0747 57.9986C76.3595 58.2656 75.7778 58.8902 75.3296 59.8723C74.891 60.8429 74.7081 61.7373 74.7807 62.5554C74.8534 63.3735 75.1005 63.8656 75.5222 64.0316C76.274 63.8149 76.8759 63.2367 77.3278 62.2971C77.7895 61.3459 77.985 60.4718 77.9142 59.675ZM73.7355 60.1906C74.0337 59.3288 74.4568 58.6059 75.0046 58.0218C75.5621 57.4262 76.1543 57.1005 76.7812 57.0449C77.4187 56.9883 77.974 57.212 78.4471 57.7161C78.9192 58.2097 79.1898 58.8442 79.2586 59.6198C79.3266 60.3848 79.2104 61.1876 78.9103 62.0281C78.6091 62.858 78.1528 63.5678 77.5412 64.1575C76.9393 64.7357 76.2718 65.0573 75.5387 65.1224C74.9969 65.1705 74.5231 64.9609 74.1175 64.4936C73.712 64.0263 73.4752 63.4102 73.4073 62.6452C73.3384 61.8696 73.4478 61.0514 73.7355 60.1906ZM85.7636 56.697C85.791 56.5233 85.8231 56.4026 85.86 56.3351C85.8968 56.2676 85.9843 56.2277 86.1224 56.2154C86.2712 56.2022 86.4587 56.3248 86.6851 56.5831C86.9222 56.8405 87.052 57.0967 87.0747 57.3517C87.0869 57.4898 86.9258 58.3287 86.5913 59.8683C86.2569 61.4079 86.0013 62.6299 85.8246 63.5345C85.7367 63.992 85.5759 64.2312 85.3422 64.2519C85.204 64.2642 85.082 64.2161 84.976 64.1078C84.87 63.9994 84.8033 63.7911 84.7759 63.483C84.7486 63.1749 84.8212 62.6062 84.9939 61.777C84.6118 62.5391 84.1812 63.1771 83.7021 63.6908C83.223 64.2045 82.7656 64.4807 82.33 64.5194C81.905 64.5571 81.4833 64.3911 81.065 64.0213C80.6466 63.6515 80.4186 63.2541 80.3809 62.8292C80.2912 61.8198 80.4716 60.5348 80.922 58.9742C81.3821 57.402 81.8087 56.5984 82.2019 56.5635C82.3931 56.5466 82.5658 56.6223 82.72 56.7906C82.8838 56.9474 82.9756 57.1374 82.9954 57.3605C83.0039 57.4561 82.8912 57.8141 82.6571 58.4346C82.4221 59.0444 82.1966 59.7605 81.9805 60.5829C81.7634 61.3946 81.6813 62.0979 81.7341 62.6929C81.7492 62.8629 81.8151 63.0016 81.9317 63.1091C82.0474 63.2059 82.1796 63.2477 82.3284 63.2345C82.7321 63.1986 83.1786 62.8003 83.6679 62.0393C84.1678 61.2775 84.6042 60.4034 84.9771 59.4173C85.35 58.4311 85.6122 57.5244 85.7636 56.697ZM88.884 57.9299L88.7301 56.7388C88.6857 56.2395 88.7804 55.9794 89.0142 55.9587C89.216 55.9407 89.4191 56.0566 89.6233 56.3062C89.8372 56.5442 89.9602 56.8438 89.9922 57.205C90.0234 57.5557 90.0363 57.8222 90.0311 58.0047C90.831 56.5202 91.6452 55.7411 92.474 55.6675C92.9946 55.6213 93.2662 55.7257 93.2889 55.9807C93.3002 56.1082 93.2521 56.2302 93.1447 56.3469C93.0373 56.4635 92.8622 56.6022 92.6194 56.7629C92.078 57.0573 91.6334 57.477 91.2856 58.0219C90.9474 58.5552 90.6844 59.1514 90.4967 59.8106C90.3089 60.4698 90.16 61.0238 90.0499 61.4727C89.9505 61.9205 89.8744 62.27 89.8217 62.521C89.7691 62.7719 89.7053 63.0185 89.6304 63.2608C89.4982 63.7009 89.3205 63.9308 89.0973 63.9506C88.9167 63.9667 88.759 63.8789 88.6242 63.6874C88.4991 63.4844 88.428 63.2872 88.4111 63.096C88.3931 62.8941 88.4485 62.493 88.5773 61.8926C88.894 60.5151 88.9963 59.1943 88.884 57.9299ZM101.228 62.8253C101.069 62.8395 100.878 62.7386 100.655 62.5228C100.432 62.307 100.311 62.0822 100.29 61.8485C100.268 61.6041 100.458 60.4253 100.86 58.3122C101.261 56.1991 101.456 54.6022 101.446 53.5216C101.3 53.4488 101.166 53.3269 101.044 53.1557C100.922 52.9845 100.855 52.8298 100.842 52.6917C100.821 52.4474 101.16 52.1656 101.86 51.8464C102.558 51.5167 103.344 51.3131 104.215 51.2357C105.097 51.1574 105.875 51.3025 106.55 51.6709C107.235 52.0277 107.612 52.5886 107.68 53.3536C107.726 53.8742 107.621 54.3762 107.364 54.8595C107.116 55.3312 106.793 55.7293 106.393 56.0539C106.005 56.3776 105.613 56.6694 105.218 56.9293C104.824 57.1892 104.484 57.4068 104.2 57.5819C103.925 57.7455 103.791 57.8592 103.797 57.9229C103.817 58.1567 104.025 58.4435 104.419 58.7833C104.824 59.1221 105.107 59.354 105.268 59.4789C105.429 59.6038 105.642 59.7723 105.907 59.9844C106.171 60.1858 106.418 60.3674 106.646 60.5291C106.885 60.6899 107.074 60.8231 107.212 60.9287C107.36 61.0333 107.509 61.1432 107.659 61.2584C107.946 61.4792 108.096 61.664 108.11 61.8127C108.132 62.0677 107.968 62.2108 107.618 62.2419C106.98 62.2985 106.023 61.8267 104.745 60.8264C103.467 59.8155 102.66 58.9341 102.326 58.182C101.974 59.8839 101.772 60.8709 101.721 61.1431C101.67 61.4047 101.608 61.6779 101.537 61.9626C101.416 62.5302 101.313 62.8178 101.228 62.8253ZM102.855 53.8302C102.916 54.5208 102.795 55.6828 102.49 57.3161C102.658 57.162 102.986 56.9294 103.472 56.6185C103.957 56.297 104.392 56.0068 104.776 55.7478C105.17 55.4772 105.519 55.1356 105.826 54.723C106.132 54.3103 106.266 53.8967 106.229 53.4824C106.171 52.8236 105.568 52.5452 104.42 52.6471C103.9 52.6933 103.306 52.8799 102.639 53.2068C102.766 53.4312 102.838 53.6389 102.855 53.8302ZM112.974 53.8312C113.453 53.7887 113.915 53.9939 114.362 54.4468C114.808 54.8891 115.049 55.3068 115.084 55.6999C115.118 56.0824 115.02 56.4873 114.79 56.9147C114.932 57.0627 115.008 57.1952 115.018 57.3121C115.045 57.6095 115.021 58.1257 114.947 58.8604C114.884 59.5942 114.846 60.0741 114.834 60.3001C114.832 60.5251 114.827 60.7076 114.818 60.8476C114.808 60.977 114.793 61.1068 114.772 61.2372C114.754 61.5066 114.67 61.6479 114.521 61.6611C114.33 61.6781 114.156 61.5275 113.999 61.2095C113.852 60.8799 113.744 60.4504 113.676 59.921C112.837 61.2056 112.014 61.8837 111.206 61.9554C110.717 61.9988 110.215 61.8346 109.701 61.4626C109.195 61.0792 108.923 60.6643 108.883 60.218C108.827 59.5806 108.991 58.7736 109.375 57.7971C109.759 56.8099 110.29 55.9168 110.968 55.1176C111.647 54.3185 112.316 53.8897 112.974 53.8312ZM113.957 56.5711C113.869 55.5829 113.628 55.1063 113.235 55.1412C112.821 55.178 112.364 55.5185 111.864 56.1625C111.364 56.7959 110.955 57.5015 110.639 58.2792C110.322 59.0569 110.183 59.6636 110.222 60.0992C110.238 60.2798 110.326 60.4219 110.485 60.5256C110.643 60.6187 110.823 60.6562 111.025 60.6383C111.524 60.5939 112.058 60.2093 112.625 59.4842C113.192 58.7486 113.554 57.8865 113.713 56.8979C113.73 56.7357 113.812 56.6321 113.958 56.587L113.957 56.5711ZM122.837 56.5857C122.874 57.0107 122.731 57.5107 122.408 58.0855C122.178 58.7591 121.953 59.7215 121.732 60.9726C121.511 62.2131 121.311 63.1035 121.134 63.6439C120.784 64.7673 120.147 65.37 119.223 65.4521C118.468 65.5191 117.812 65.3685 117.255 65.0004C116.709 64.6419 116.418 64.2608 116.382 63.857C116.367 63.687 116.405 63.5123 116.497 63.3329C116.577 63.1544 116.671 63.0605 116.777 63.051C116.894 63.0406 117.028 63.109 117.18 63.2561C117.333 63.4032 117.475 63.5619 117.608 63.7321C117.753 63.9121 117.954 64.0709 118.213 64.2085C118.482 64.3453 118.733 64.4033 118.967 64.3825C119.201 64.3618 119.373 64.309 119.483 64.2243C119.594 64.1501 119.696 64.0287 119.788 63.8599C119.881 63.7017 119.958 63.5396 120.018 63.3736C120.079 63.2183 120.139 62.9934 120.199 62.699C120.27 62.4142 120.323 62.1686 120.358 61.962C120.394 61.7554 120.443 61.4672 120.507 61.0975C120.569 60.7171 120.622 60.4125 120.666 60.1838C119.892 60.8736 119.245 61.2416 118.724 61.2878C118.204 61.3341 117.734 61.167 117.315 60.7866C116.894 60.3955 116.66 59.9238 116.611 59.3713C116.561 58.8082 116.702 58.046 117.034 57.0849C117.377 56.1228 117.872 55.2436 118.519 54.4472C119.165 53.6509 119.829 53.2226 120.509 53.1622C120.944 53.1235 121.326 53.2556 121.652 53.5586C122.189 54.0571 122.502 54.8057 122.591 55.8044C122.602 55.9319 122.605 56.0227 122.599 56.0768C122.742 56.2461 122.822 56.4157 122.837 56.5857ZM117.916 59.416C117.932 59.5967 118.003 59.7402 118.131 59.8467C118.257 59.9426 118.41 59.9825 118.591 59.9665C119.122 59.9193 119.721 59.5502 120.388 58.8592C121.054 58.1575 121.498 57.3738 121.721 56.508C121.667 56.3737 121.611 56.1645 121.553 55.8805C121.496 55.5964 121.444 55.3708 121.397 55.2036C121.35 55.0365 121.266 54.8726 121.144 54.712C121.022 54.5409 120.876 54.4628 120.706 54.4779C120.292 54.5147 119.85 54.8537 119.383 55.4949C118.915 56.1361 118.544 56.8384 118.269 57.6017C117.994 58.365 117.876 58.9698 117.916 59.416ZM130.364 54.9536C130.414 55.5167 130.146 56.0063 129.562 56.4222C128.988 56.8266 128.313 57.0633 127.537 57.1321C126.772 57.2 126.069 57.1768 125.427 57.0625C125.32 57.5432 125.282 57.9695 125.315 58.3414C125.347 58.7026 125.484 58.9743 125.725 59.1563C125.977 59.3374 126.363 59.4049 126.884 59.3587C127.415 59.3115 127.949 59.1731 128.485 58.9434C129.031 58.7021 129.331 58.5792 129.384 58.5744C129.66 58.5499 129.808 58.6439 129.827 58.8564C129.852 59.1433 129.556 59.4855 128.938 59.883C128.319 60.2699 127.702 60.4907 127.085 60.5455C126.257 60.6191 125.56 60.4346 124.996 59.9921C124.431 59.5389 124.115 58.9352 124.048 58.1808C123.981 57.4264 124.113 56.6223 124.444 55.7683C124.775 54.9037 125.233 54.1616 125.821 53.5418C126.408 52.9221 127.016 52.5844 127.642 52.5288C128.269 52.4731 128.864 52.7201 129.427 53.2698C130 53.8186 130.313 54.3799 130.364 54.9536ZM127.834 53.7807C127.441 53.8157 127.05 54.0592 126.662 54.5113C126.273 54.9527 125.956 55.4895 125.713 56.1215C126.146 56.1794 126.634 56.1843 127.176 56.1362C127.718 56.0881 128.183 55.9611 128.571 55.7553C128.959 55.5388 129.14 55.2871 129.115 55.0002C129.089 54.7134 128.931 54.433 128.639 54.1591C128.357 53.8842 128.089 53.7581 127.834 53.7807ZM137.648 48.3153C137.924 48.2908 138.222 48.4411 138.54 48.7662C138.868 49.0905 139.043 49.3694 139.064 49.6032C139.083 49.8263 139.051 49.9416 138.966 49.9492C138.891 49.9558 138.739 49.9318 138.51 49.8772C138.279 49.8121 138.073 49.7875 137.893 49.8035C137.478 49.8403 136.993 50.0976 136.435 50.5754C135.889 51.0523 135.378 51.6278 134.902 52.3018C134.437 52.9749 134.054 53.7317 133.754 54.5722C133.453 55.4021 133.329 56.1092 133.38 56.6936C133.432 57.278 133.619 57.6951 133.941 57.9449C134.273 58.1832 134.683 58.2806 135.172 58.2372C135.661 58.1938 136.159 58.0799 136.668 57.8956C137.175 57.7006 137.585 57.4982 137.899 57.2883C138.708 56.756 139.155 56.486 139.24 56.4785C139.421 56.4624 139.522 56.5766 139.544 56.821C139.565 57.0547 139.349 57.3952 138.896 57.8423C138.442 58.2788 137.868 58.6885 137.174 59.0714C136.479 59.4543 135.845 59.6713 135.272 59.7222C134.528 59.7882 133.798 59.5318 133.083 58.9528C132.367 58.3631 131.974 57.6805 131.905 56.9049C131.817 55.9062 132.041 54.7511 132.577 53.4399C133.124 52.117 133.867 50.9534 134.805 49.9491C135.755 48.9439 136.703 48.3993 137.648 48.3153ZM143.347 47.986C143.525 49.9834 143.341 52.6127 142.795 55.8737C142.456 58.0884 142.18 59.2051 141.968 59.224C141.819 59.2372 141.634 59.1359 141.411 58.9201C141.199 58.7033 141.087 58.5312 141.076 58.4037C141.065 58.2762 141.16 57.6038 141.363 56.3864C141.565 55.1691 141.744 53.6808 141.898 51.9216C142.051 50.1517 142.066 48.5709 141.943 47.179C141.929 47.0303 141.941 46.9222 141.978 46.8546C142.015 46.7871 142.102 46.7472 142.24 46.735C142.379 46.7227 142.589 46.8593 142.871 47.1448C143.163 47.4187 143.322 47.6991 143.347 47.986ZM146.231 48.5973C146.212 48.3848 146.279 48.1754 146.432 47.9691C146.585 47.7627 146.746 47.652 146.916 47.6369C147.097 47.6209 147.329 47.8198 147.612 48.2338C147.894 48.637 148.048 48.9821 148.073 49.269C148.083 49.3753 148.043 49.4751 147.955 49.5686C147.867 49.6621 147.77 49.7136 147.664 49.723C147.409 49.7456 147.108 49.6171 146.762 49.3372C146.427 49.0565 146.25 48.8098 146.231 48.5973ZM146.352 50.8675C146.554 50.8496 146.756 50.9548 146.958 51.1831C147.161 51.4115 147.272 51.6425 147.293 51.8762C147.314 52.11 147.222 52.8249 147.017 54.021C146.812 55.2065 146.54 56.5425 146.201 58.029C146.067 58.5762 145.862 58.8621 145.586 58.8867C145.437 58.8999 145.305 58.8528 145.188 58.7453C145.071 58.6273 145.005 58.4938 144.992 58.3451C144.978 58.1857 144.993 57.9381 145.038 57.6021C145.093 57.2545 145.171 56.7979 145.27 56.2322C145.38 55.6549 145.461 55.1872 145.515 54.8291C145.58 54.4699 145.64 54.0683 145.697 53.6242C145.753 53.1695 145.796 52.807 145.826 52.5366C145.865 52.2547 145.909 51.9723 145.959 51.6895C146.062 51.1557 146.193 50.8817 146.352 50.8675ZM151.457 58.3814C150.841 58.4362 150.241 58.2485 149.656 57.8185C149.071 57.3779 148.749 56.8282 148.691 56.1695C148.631 55.5001 148.786 54.71 149.155 53.7991C149.524 52.8883 150.031 52.0936 150.678 51.4151C151.335 50.7356 151.998 50.3662 152.668 50.3067C153.103 50.2681 153.503 50.4307 153.867 50.7945C154.232 51.1584 154.427 51.4891 154.454 51.7866C154.461 51.8716 154.441 51.9483 154.394 52.0168C154.345 52.0746 154.268 52.1083 154.162 52.1177C154.066 52.1262 153.882 52.0461 153.61 51.8775C153.338 51.7089 153.101 51.6336 152.899 51.6515C152.326 51.7024 151.701 52.2666 151.026 53.3438C150.35 54.4211 150.046 55.337 150.113 56.0913C150.142 56.4207 150.267 56.672 150.485 56.8454C150.715 57.0177 151.058 57.0837 151.515 57.0431C151.982 57.0016 152.403 56.9107 152.776 56.7705C153.158 56.6187 153.451 56.4803 153.654 56.3552C153.857 56.2194 154.016 56.1464 154.133 56.136C154.335 56.1181 154.445 56.21 154.463 56.4119C154.49 56.72 154.15 57.1143 153.443 57.5947C152.746 58.0635 152.084 58.3258 151.457 58.3814ZM162.407 50.3094C162.416 50.405 161.987 50.9463 161.122 51.9334C160.801 52.3045 160.513 52.737 160.257 53.231C160.011 53.7133 159.905 54.1457 159.938 54.5282C159.972 54.9107 160.116 55.2567 160.368 55.5663C160.63 55.8643 160.901 56.0865 161.182 56.2329C161.473 56.3677 161.736 56.5049 161.974 56.6445C162.222 56.7831 162.35 56.9056 162.36 57.0118C162.383 57.2774 162.183 57.4291 161.758 57.4668C161.343 57.5036 160.823 57.3142 160.197 56.8986C159.581 56.4714 159.178 55.9718 158.988 55.3997C158.925 55.2982 158.874 55.201 158.833 55.1082C158.198 56.1499 157.732 56.8765 157.437 57.2883C157.151 57.6885 156.929 57.8956 156.769 57.9098C156.61 57.9239 156.424 57.8173 156.211 57.5899C155.997 57.3519 155.883 57.1532 155.869 56.9938C155.854 56.8238 155.963 56.1234 156.196 54.8926C156.439 53.6503 156.656 52.1693 156.846 50.4498C157.046 48.7293 157.088 47.205 156.97 45.8769C156.955 45.7069 156.965 45.5881 157.002 45.5206C157.05 45.4521 157.153 45.4108 157.313 45.3967C157.472 45.3825 157.683 45.5244 157.945 45.8224C158.206 46.1098 158.35 46.4022 158.376 46.6997C158.46 47.6453 158.386 48.9851 158.155 50.7191C157.923 52.453 157.61 54.1085 157.214 55.6857C158.263 53.8685 159.176 52.3953 159.954 51.2661C160.742 50.1253 161.236 49.5459 161.438 49.528C161.651 49.5091 161.861 49.5921 162.071 49.777C162.28 49.9619 162.392 50.1394 162.407 50.3094ZM16.834 87.1207C16.884 87.6838 16.6169 88.1734 16.0327 88.5893C15.4582 88.9937 14.7832 89.2304 14.0076 89.2992C13.2426 89.3671 12.5391 89.3439 11.8971 89.2296C11.7899 89.7103 11.7528 90.1366 11.7858 90.5085C11.8179 90.8697 11.9545 91.1414 12.1955 91.3234C12.4472 91.5045 12.8333 91.572 13.3539 91.5258C13.8852 91.4786 14.419 91.3402 14.9555 91.1105C15.5016 90.8692 15.8012 90.7463 15.8544 90.7415C16.1306 90.717 16.2782 90.811 16.297 91.0235C16.3225 91.3104 16.0263 91.6526 15.4084 92.0501C14.7895 92.437 14.1719 92.6578 13.5557 92.7126C12.727 92.7861 12.0306 92.6017 11.4666 92.1592C10.9016 91.706 10.5856 91.1023 10.5186 90.3479C10.4517 89.5935 10.5837 88.7894 10.9148 87.9354C11.245 87.0708 11.7038 86.3287 12.2913 85.7089C12.8788 85.0892 13.486 84.7515 14.1128 84.6959C14.7397 84.6402 15.3346 84.8872 15.8974 85.4369C16.4708 85.9857 16.783 86.547 16.834 87.1207ZM14.3043 85.9478C13.9112 85.9827 13.5205 86.2263 13.1323 86.6784C12.7432 87.1198 12.4268 87.6566 12.183 88.2886C12.6165 88.3465 13.1042 88.3514 13.6461 88.3033C14.1879 88.2552 14.6532 88.1282 15.0418 87.9223C15.4296 87.7059 15.6107 87.4542 15.5852 87.1673C15.5597 86.8805 15.401 86.6001 15.1089 86.3262C14.8275 86.0513 14.5593 85.9252 14.3043 85.9478ZM20.4987 87.2933C21.2565 86.0587 21.8218 85.1893 22.1947 84.685C22.5782 84.1798 22.8708 83.9182 23.0727 83.9003C23.2746 83.8824 23.4787 83.9499 23.685 84.1029C23.902 84.255 24.0162 84.3948 24.0275 84.5223C24.0379 84.6392 24.0096 84.7434 23.9428 84.835C23.875 84.916 23.7623 85.0331 23.6045 85.1863C23.4574 85.3386 23.3166 85.501 23.182 85.6736C23.0571 85.8346 22.8953 86.0631 22.6967 86.3592C22.4972 86.6446 22.256 87.0034 21.9731 87.4354C21.6999 87.8559 21.4732 88.1973 21.293 88.4596C21.3652 88.5495 21.475 88.7004 21.6223 88.9122C21.7802 89.1231 21.9083 89.2991 22.0065 89.4403C22.1154 89.5806 22.2492 89.7614 22.4081 89.9829C22.5766 90.1928 22.7153 90.3679 22.8242 90.5082C22.9321 90.6378 23.0351 90.7732 23.1333 90.9144C23.3278 91.1756 23.4298 91.3593 23.4393 91.4655C23.4487 91.5718 23.4195 91.6654 23.3518 91.7464C23.283 91.8167 23.1956 91.8566 23.0893 91.8661C22.6112 91.9085 21.7703 91.1211 20.5665 89.5039C19.3265 91.3381 18.5578 92.2684 18.2603 92.2948C18.0903 92.3099 17.9075 92.2405 17.7117 92.0865C17.5151 91.9219 17.4101 91.7653 17.3969 91.6165C17.3922 91.5634 17.4964 91.4096 17.7093 91.1551C18.6484 90.033 19.3442 89.1252 19.7967 88.4318C19.2306 87.604 18.7445 86.8333 18.3385 86.1197C17.9324 85.4062 17.7228 84.975 17.7096 84.8263C17.6954 84.6669 17.6918 84.5655 17.6986 84.522C17.7114 84.4245 17.824 84.3663 18.0365 84.3475C18.249 84.3286 18.515 84.3692 18.8344 84.4694C19.1539 84.5695 19.3216 84.7099 19.3377 84.8905C19.3773 85.3368 19.7643 86.1377 20.4987 87.2933ZM29.4236 83.2882C29.8805 83.2476 30.2995 83.5049 30.6808 84.06C31.0727 84.6142 31.2964 85.2047 31.3521 85.8316C31.4068 86.4479 31.2814 87.0854 30.9758 87.7444C30.6693 88.3927 30.2721 88.9848 29.7842 89.5207C29.2964 90.0566 28.743 90.5181 28.1242 90.905C27.515 91.2803 26.9394 91.4921 26.3976 91.5402C26.1851 91.559 25.9808 91.5504 25.7849 91.5143C25.7584 91.6987 25.7128 92.0293 25.6481 92.5063C25.5833 92.9832 25.5275 93.379 25.4805 93.6937C25.4334 94.0085 25.3777 94.3454 25.3132 94.7045C25.1861 95.444 25.0482 95.8203 24.8994 95.8335C24.7507 95.8467 24.5862 95.7435 24.4061 95.5239C24.2163 95.3159 24.1134 95.1216 24.0973 94.9409C24.0813 94.7603 24.1824 93.9696 24.4007 92.5688C25.0537 88.3452 25.3166 85.5162 25.1892 84.0818C25.1609 83.7631 25.2636 83.5933 25.4974 83.5726C25.6886 83.5556 25.9298 83.6787 26.2209 83.942C26.5216 84.1937 26.6871 84.4896 26.7173 84.8296C26.7324 84.9996 26.7277 85.1874 26.7031 85.3931C27.5393 84.0766 28.4461 83.375 29.4236 83.2882ZM26.1278 90.3112C26.6909 90.2612 27.2796 90.0162 27.8937 89.5762C28.5185 89.1352 29.0315 88.581 29.4327 87.9135C29.8436 87.2345 30.0212 86.5816 29.9656 85.9547C29.8873 85.0729 29.6409 84.6503 29.2266 84.6871C28.8122 84.7239 28.2807 85.1298 27.632 85.9049C26.994 86.679 26.5182 87.6529 26.2048 88.8266L25.9685 90.3254L26.1278 90.3112ZM38.4209 85.204C38.4709 85.7671 38.2038 86.2566 37.6197 86.6726C37.0452 87.077 36.3701 87.3136 35.5945 87.3825C34.8295 87.4504 34.1261 87.4272 33.4841 87.3129C33.3769 87.7936 33.3397 88.2198 33.3728 88.5917C33.4048 88.953 33.5414 89.2246 33.7824 89.4067C34.0341 89.5878 34.4203 89.6552 34.9409 89.609C35.4721 89.5618 36.006 89.4234 36.5424 89.1937C37.0886 88.9525 37.3882 88.8295 37.4413 88.8248C37.7176 88.8003 37.8651 88.8942 37.884 89.1067C37.9095 89.3936 37.6132 89.7358 36.9953 90.1334C36.3764 90.5203 35.7589 90.7411 35.1426 90.7958C34.3139 90.8694 33.6175 90.6849 33.0535 90.2424C32.4885 89.7893 32.1726 89.1855 32.1056 88.4312C32.0386 87.6768 32.1707 86.8726 32.5018 86.0187C32.8319 85.1541 33.2908 84.4119 33.8783 83.7922C34.4657 83.1725 35.0729 82.8348 35.6998 82.7791C36.3267 82.7235 36.9215 82.9705 37.4843 83.5202C38.0578 84.069 38.37 84.6302 38.4209 85.204ZM35.8913 84.0311C35.4982 84.066 35.1075 84.3095 34.7193 84.7616C34.3301 85.2031 34.0137 85.7398 33.77 86.3719C34.2035 86.4298 34.6911 86.4347 35.233 86.3865C35.7749 86.3384 36.2401 86.2114 36.6288 86.0056C37.0165 85.7891 37.1976 85.5375 37.1721 85.2506C37.1467 84.9637 36.9879 84.6833 36.6959 84.4094C36.4145 84.1346 36.1463 84.0084 35.8913 84.0311ZM40.1308 84.3454L39.9769 83.1543C39.9325 82.6549 40.0272 82.3949 40.261 82.3741C40.4628 82.3562 40.6659 82.472 40.8701 82.7216C41.084 82.9596 41.207 83.2593 41.239 83.6205C41.2702 83.9711 41.2831 84.2377 41.2779 84.4202C42.0778 82.9356 42.892 82.1566 43.7208 82.083C44.2414 82.0368 44.513 82.1411 44.5357 82.3961C44.547 82.5236 44.4989 82.6457 44.3915 82.7623C44.2841 82.8789 44.109 83.0176 43.8662 83.1784C43.3248 83.4728 42.8802 83.8924 42.5324 84.4373C42.1942 84.9706 41.9312 85.5669 41.7435 86.2261C41.5557 86.8853 41.4068 87.4393 41.2967 87.8881C41.1973 88.336 41.1212 88.6854 41.0685 88.9364C41.0159 89.1874 40.9521 89.434 40.8772 89.6762C40.745 90.1163 40.5673 90.3463 40.3441 90.3661C40.1635 90.3821 40.0058 90.2944 39.871 90.1029C39.7459 89.8998 39.6748 89.7027 39.6579 89.5114C39.6399 89.3096 39.6953 88.9084 39.8241 88.308C40.1408 86.9306 40.2431 85.6097 40.1308 84.3454ZM46.1171 79.5732C46.0982 79.3607 46.1653 79.1513 46.3183 78.9449C46.4713 78.7386 46.6328 78.6279 46.8028 78.6128C46.9834 78.5968 47.2153 78.7957 47.4983 79.2096C47.7804 79.6129 47.9342 79.958 47.9597 80.2449C47.9691 80.3511 47.9298 80.451 47.8417 80.5445C47.7537 80.638 47.6565 80.6894 47.5502 80.6989C47.2952 80.7215 46.9947 80.5929 46.6486 80.3131C46.3131 80.0323 46.1359 79.7857 46.1171 79.5732ZM46.2383 81.8434C46.4402 81.8255 46.6423 81.9307 46.8446 82.159C47.0469 82.3873 47.1585 82.6184 47.1792 82.8521C47.2 83.0859 47.1082 83.8008 46.9038 84.9969C46.6986 86.1823 46.4263 87.5183 46.0871 89.0048C45.9537 89.5521 45.7488 89.838 45.4726 89.8625C45.3238 89.8757 45.1911 89.8286 45.0745 89.7212C44.9569 89.6031 44.8916 89.4697 44.8783 89.321C44.8642 89.1616 44.8797 88.9139 44.9248 88.5779C44.9796 88.2304 45.0569 87.7738 45.1566 87.2081C45.2659 86.6308 45.3476 86.1631 45.4014 85.8049C45.4659 85.4458 45.5266 85.0442 45.5836 84.6001C45.6396 84.1454 45.6824 83.7828 45.7119 83.5125C45.7511 83.2306 45.7956 82.9482 45.8455 82.6653C45.948 82.1315 46.079 81.8575 46.2383 81.8434ZM54.6695 83.7612C54.7195 84.3243 54.4524 84.8139 53.8682 85.2298C53.2938 85.6342 52.6187 85.8709 51.8431 85.9397C51.0781 86.0076 50.3746 85.9844 49.7327 85.8701C49.6254 86.3508 49.5883 86.7771 49.6213 87.149C49.6534 87.5102 49.79 87.7819 50.031 87.9639C50.2827 88.145 50.6688 88.2125 51.1895 88.1663C51.7207 88.1191 52.2545 87.9807 52.791 87.751C53.3371 87.5097 53.6368 87.3868 53.6899 87.382C53.9661 87.3575 54.1137 87.4515 54.1326 87.664C54.158 87.9509 53.8618 88.2931 53.2439 88.6906C52.625 89.0775 52.0075 89.2983 51.3912 89.3531C50.5625 89.4267 49.8661 89.2422 49.3021 88.7997C48.7371 88.3465 48.4212 87.7428 48.3542 86.9884C48.2872 86.234 48.4192 85.4299 48.7504 84.5759C49.0805 83.7113 49.5393 82.9692 50.1268 82.3494C50.7143 81.7297 51.3215 81.392 51.9484 81.3364C52.5752 81.2807 53.1701 81.5277 53.7329 82.0774C54.3064 82.6262 54.6185 83.1875 54.6695 83.7612ZM52.1398 82.5883C51.7467 82.6232 51.3561 82.8668 50.9679 83.3189C50.5787 83.7603 50.2623 84.2971 50.0186 84.9291C50.452 84.987 50.9397 84.9919 51.4816 84.9438C52.0235 84.8957 52.4887 84.7687 52.8774 84.5629C53.2651 84.3464 53.4462 84.0947 53.4207 83.8078C53.3953 83.521 53.2365 83.2406 52.9445 82.9667C52.663 82.6918 52.3948 82.5657 52.1398 82.5883ZM57.268 86.0363C58.1342 84.2139 58.8488 82.8547 59.4118 81.9587C59.9844 81.0512 60.4726 80.5795 60.8764 80.5436C61.2907 80.5068 61.6979 80.6902 62.0978 81.0938C62.5084 81.4964 62.7353 81.942 62.7787 82.4308C62.8467 83.1958 62.7544 84.1463 62.5019 85.2824C62.0455 87.379 61.5623 88.45 61.0523 88.4952C60.8186 88.516 60.6876 88.367 60.6593 88.0482C60.6394 87.8251 60.7109 87.3637 60.8737 86.6639C61.0461 85.9525 61.1987 85.2589 61.3314 84.5832C61.4739 83.8959 61.5305 83.3876 61.5012 83.0582C61.471 82.7182 61.3957 82.4733 61.2753 82.3233C61.1656 82.1724 61.0575 82.1017 60.9513 82.1112C60.8557 82.1196 60.7576 82.1605 60.657 82.2337C60.5564 82.3068 60.4436 82.4239 60.3187 82.585C60.2044 82.745 60.0955 82.9046 59.9918 83.0637C59.8872 83.2122 59.7564 83.4273 59.5993 83.709C59.4529 83.9897 59.3298 84.2309 59.2299 84.4325C59.129 84.6235 58.9826 84.9042 58.7906 85.2746C58.5986 85.6451 58.4522 85.9258 58.3514 86.1168C58.2505 86.3078 58.1182 86.5658 57.9543 86.8909C57.7904 87.2161 57.6576 87.4688 57.5558 87.6492C57.4646 87.8286 57.359 88.0254 57.2388 88.2395C57.0081 88.6562 56.813 88.8717 56.6536 88.8858C56.5049 88.899 56.3192 88.7977 56.0966 88.5819C55.873 88.3554 55.7532 88.1519 55.7372 87.9713C55.7324 87.9182 55.7569 87.7714 55.8105 87.5311C55.9577 86.8969 56.1133 86.1174 56.2775 85.1926C56.4408 84.2572 56.4816 83.2094 56.4 82.0494C56.363 81.271 56.4401 80.8733 56.6314 80.8563C56.8651 80.8355 57.1097 80.937 57.3652 81.1606C57.6206 81.3842 57.7615 81.6448 57.788 81.9423C57.8134 82.2291 57.7731 82.8003 57.667 83.6557C57.5706 84.4995 57.4376 85.2931 57.268 86.0363ZM67.0161 87.9657C66.3999 88.0204 65.7996 87.8328 65.2153 87.4028C64.63 86.9621 64.3081 86.4124 64.2496 85.7537C64.1902 85.0843 64.3449 84.2942 64.7138 83.3834C65.0827 82.4725 65.5904 81.6778 66.2369 80.9993C66.8941 80.3199 67.5573 79.9504 68.2267 79.891C68.6623 79.8523 69.0623 80.0149 69.4265 80.3788C69.7908 80.7426 69.9862 81.0733 70.0126 81.3708C70.0201 81.4558 70.0002 81.5326 69.9527 81.601C69.9043 81.6589 69.827 81.6925 69.7207 81.7019C69.6251 81.7104 69.4413 81.6304 69.1693 81.4618C68.8973 81.2932 68.6604 81.2178 68.4585 81.2357C67.8848 81.2867 67.2602 81.8508 66.5849 82.9281C65.9095 84.0054 65.6053 84.9212 65.6723 85.6756C65.7015 86.0049 65.8256 86.2563 66.0444 86.4296C66.2739 86.602 66.6171 86.6679 67.074 86.6273C67.5415 86.5858 67.9617 86.495 68.3348 86.3548C68.7175 86.203 69.0105 86.0645 69.2135 85.9394C69.4156 85.8037 69.5751 85.7306 69.692 85.7202C69.8939 85.7023 70.0038 85.7943 70.0217 85.9962C70.0491 86.3043 69.7093 86.6985 69.0023 87.1789C68.305 87.6478 67.643 87.91 67.0161 87.9657ZM77.4393 81.7394C77.4893 82.3025 77.2222 82.7921 76.638 83.208C76.0636 83.6124 75.3885 83.8491 74.6129 83.9179C73.8479 83.9859 73.1444 83.9627 72.5025 83.8483C72.3952 84.329 72.3581 84.7553 72.3911 85.1272C72.4232 85.4884 72.5598 85.7601 72.8008 85.9421C73.0525 86.1233 73.4386 86.1907 73.9592 86.1445C74.4905 86.0973 75.0243 85.9589 75.5608 85.7292C76.1069 85.488 76.4066 85.365 76.4597 85.3603C76.7359 85.3357 76.8835 85.4297 76.9024 85.6422C76.9278 85.9291 76.6316 86.2713 76.0137 86.6688C75.3948 87.0558 74.7772 87.2766 74.161 87.3313C73.3323 87.4049 72.6359 87.2204 72.0719 86.7779C71.5069 86.3247 71.1909 85.721 71.124 84.9666C71.057 84.2123 71.189 83.4081 71.5201 82.5541C71.8503 81.6895 72.3091 80.9474 72.8966 80.3277C73.4841 79.7079 74.0913 79.3703 74.7182 79.3146C75.345 79.2589 75.9399 79.506 76.5027 80.0557C77.0761 80.6044 77.3883 81.1657 77.4393 81.7394ZM74.9096 80.5666C74.5165 80.6015 74.1259 80.845 73.7377 81.2971C73.3485 81.7386 73.0321 82.2753 72.7884 82.9074C73.2218 82.9652 73.7095 82.9701 74.2514 82.922C74.7933 82.8739 75.2585 82.7469 75.6472 82.5411C76.0349 82.3246 76.216 82.0729 76.1905 81.7861C76.165 81.4992 76.0063 81.2188 75.7143 80.9449C75.4328 80.67 75.1646 80.5439 74.9096 80.5666ZM86.256 76.0092C86.2372 75.7967 86.3042 75.5873 86.4573 75.3809C86.6103 75.1746 86.7718 75.0639 86.9418 75.0488C87.1224 75.0327 87.3542 75.2317 87.6373 75.6456C87.9194 76.0489 88.0732 76.394 88.0987 76.6808C88.1081 76.7871 88.0688 76.887 87.9807 76.9805C87.8926 77.0739 87.7955 77.1254 87.6892 77.1348C87.4342 77.1575 87.1337 77.0289 86.7876 76.7491C86.4521 76.4683 86.2749 76.2217 86.256 76.0092ZM86.3773 78.2794C86.5792 78.2614 86.7813 78.3666 86.9836 78.595C87.1859 78.8233 87.2974 79.0543 87.3182 79.2881C87.3389 79.5218 87.2472 80.2368 87.0428 81.4328C86.8375 82.6183 86.5653 83.9543 86.2261 85.4408C86.0926 85.9881 85.8878 86.274 85.6115 86.2985C85.4628 86.3117 85.3301 86.2646 85.2135 86.1572C85.0959 86.0391 85.0305 85.9057 85.0173 85.7569C85.0032 85.5976 85.0186 85.3499 85.0638 85.0139C85.1186 84.6664 85.1958 84.2098 85.2955 83.6441C85.4049 83.0668 85.4865 82.5991 85.5404 82.2409C85.6049 81.8818 85.6656 81.4802 85.7225 81.0361C85.7785 80.5813 85.8213 80.2188 85.8508 79.9485C85.8901 79.6665 85.9346 79.3842 85.9844 79.1013C86.087 78.5675 86.2179 78.2935 86.3773 78.2794ZM90.2321 83.1093C91.0983 81.2869 91.8129 79.9277 92.3758 79.0318C92.9485 78.1242 93.4367 77.6525 93.8404 77.6167C94.2548 77.5799 94.6619 77.7633 95.0619 78.1668C95.4724 78.5694 95.6994 79.0151 95.7428 79.5038C95.8107 80.2688 95.7184 81.2194 95.4659 82.3555C95.0096 84.4521 94.5264 85.523 94.0164 85.5683C93.7826 85.589 93.6516 85.44 93.6233 85.1213C93.6035 84.8982 93.675 84.4367 93.8377 83.7369C94.0101 83.0255 94.1627 82.332 94.2955 81.6563C94.4379 80.969 94.4945 80.4606 94.4653 80.1313C94.4351 79.7913 94.3598 79.5463 94.2394 79.3964C94.1296 79.2455 94.0216 79.1748 93.9154 79.1842C93.8197 79.1927 93.7216 79.2335 93.621 79.3067C93.5205 79.3799 93.4077 79.497 93.2828 79.658C93.1685 79.8181 93.0595 79.9777 92.9559 80.1368C92.8512 80.2853 92.7204 80.5004 92.5634 80.782C92.417 81.0628 92.2938 81.3039 92.1939 81.5055C92.0931 81.6965 91.9467 81.9773 91.7547 82.3477C91.5627 82.7181 91.4163 82.9988 91.3154 83.1898C91.2146 83.3808 91.0822 83.6389 90.9184 83.964C90.7545 84.2891 90.6216 84.5418 90.5199 84.7222C90.4287 84.9016 90.323 85.0984 90.2028 85.3126C89.9721 85.7293 89.7771 85.9447 89.6177 85.9589C89.4689 85.9721 89.2833 85.8708 89.0606 85.6549C88.8371 85.4285 88.7173 85.2249 88.7012 85.0443C88.6965 84.9912 88.721 84.8445 88.7746 84.6041C88.9217 83.9699 89.0774 83.1905 89.2416 82.2656C89.4048 81.3302 89.4456 80.2825 89.3641 79.1225C89.3271 78.344 89.4042 77.9463 89.5954 77.9294C89.8292 77.9086 90.0738 78.01 90.3292 78.2336C90.5847 78.4573 90.7256 78.7178 90.752 79.0153C90.7775 79.3022 90.7372 79.8733 90.6311 80.7287C90.5347 81.5726 90.4017 82.3661 90.2321 83.1093ZM106.035 79.7144L106.003 79.7172C105.991 79.8253 105.923 80.2598 105.797 81.0205C105.683 81.7803 105.609 82.2794 105.577 82.5179C105.544 82.7457 105.512 82.9306 105.482 83.0725C105.462 83.2134 105.439 83.3761 105.413 83.5605C105.385 83.7343 105.355 83.8762 105.322 83.9862C105.299 84.0846 105.275 84.1831 105.252 84.2815C105.204 84.4678 105.148 84.5638 105.085 84.5695C104.946 84.5817 104.753 84.449 104.503 84.1713C104.253 83.883 104.119 83.6432 104.102 83.452C104.085 83.2607 104.27 81.9057 104.657 79.387C105.054 76.8673 105.227 75.1975 105.175 74.3775C105.161 74.2181 105.187 74.0873 105.253 73.9851C105.34 73.7525 105.639 73.5653 106.151 73.4235C106.674 73.2807 107.44 73.1645 108.449 73.0748C109.469 72.9843 110.271 72.9666 110.854 73.0219C111.448 73.0763 111.753 73.1991 111.77 73.3904C111.781 73.5179 111.699 73.6162 111.523 73.6853C111.347 73.7545 111.192 73.8112 111.056 73.8553C110.92 73.8888 110.742 73.9314 110.522 73.9831C110.3 74.0242 110.095 74.0638 109.906 74.102C109.715 74.1296 109.468 74.1731 109.162 74.2323C108.868 74.2906 108.594 74.347 108.342 74.4015C108.089 74.4454 107.747 74.5132 107.316 74.605C106.885 74.6968 106.606 74.7537 106.48 74.7757C106.493 74.8066 106.503 74.8539 106.508 74.9177C106.553 75.4171 106.448 76.5829 106.193 78.4153C106.854 78.3887 107.559 78.31 108.308 78.1793C109.067 78.0476 109.532 77.9743 109.702 77.9592C110.106 77.9233 110.315 77.9904 110.33 78.1604C110.36 78.4898 109.922 78.807 109.017 79.1122C108.123 79.4165 107.129 79.6172 106.035 79.7144ZM117.133 75.9983C117.16 75.8245 117.192 75.7039 117.229 75.6363C117.266 75.5688 117.353 75.5289 117.492 75.5167C117.64 75.5034 117.828 75.626 118.054 75.8843C118.291 76.1417 118.421 76.3979 118.444 76.6529C118.456 76.791 118.295 77.6299 117.96 79.1695C117.626 80.7091 117.37 81.9312 117.194 82.8357C117.106 83.2932 116.945 83.5324 116.711 83.5532C116.573 83.5654 116.451 83.5174 116.345 83.409C116.239 83.3006 116.172 83.0923 116.145 82.7842C116.118 82.4761 116.19 81.9074 116.363 81.0783C115.981 81.8404 115.55 82.4783 115.071 82.992C114.592 83.5057 114.135 83.7819 113.699 83.8206C113.274 83.8584 112.852 83.6923 112.434 83.3225C112.016 82.9528 111.788 82.5554 111.75 82.1304C111.66 81.121 111.841 79.836 112.291 78.2754C112.751 76.7032 113.178 75.8997 113.571 75.8648C113.762 75.8478 113.935 75.9235 114.089 76.0918C114.253 76.2486 114.345 76.4386 114.365 76.6617C114.373 76.7573 114.26 77.1154 114.026 77.7358C113.791 78.3457 113.566 79.0618 113.35 79.8841C113.132 80.6958 113.05 81.3992 113.103 81.9942C113.118 82.1642 113.184 82.3029 113.301 82.4103C113.416 82.5071 113.549 82.5489 113.697 82.5357C114.101 82.4999 114.548 82.1015 115.037 81.3406C115.537 80.5787 115.973 79.7047 116.346 78.7185C116.719 77.7323 116.981 76.8256 117.133 75.9983ZM121.986 71.9692C122.164 73.9667 121.98 76.5959 121.434 79.857C121.095 82.0716 120.82 83.1884 120.607 83.2072C120.458 83.2204 120.273 83.1191 120.05 82.9033C119.838 82.6866 119.726 82.5144 119.715 82.3869C119.704 82.2594 119.799 81.587 120.002 80.3697C120.204 79.1523 120.383 77.664 120.537 75.9048C120.69 74.135 120.705 72.5541 120.582 71.1623C120.568 71.0135 120.58 70.9054 120.617 70.8379C120.654 70.7704 120.741 70.7305 120.88 70.7182C121.018 70.7059 121.228 70.8425 121.51 71.128C121.802 71.4019 121.961 71.6823 121.986 71.9692ZM125.893 71.6223C126.07 73.6198 125.886 76.2491 125.34 79.5101C125.002 81.7248 124.726 82.8415 124.514 82.8604C124.365 82.8736 124.179 82.7723 123.956 82.5565C123.744 82.3397 123.633 82.1676 123.621 82.0401C123.61 81.9126 123.706 81.2401 123.908 80.0228C124.111 78.8054 124.289 77.3172 124.443 75.558C124.597 73.7881 124.612 72.2073 124.488 70.8154C124.475 70.6667 124.487 70.5585 124.524 70.491C124.56 70.4235 124.648 70.3836 124.786 70.3713C124.924 70.3591 125.134 70.4957 125.417 70.7812C125.709 71.0551 125.868 71.3355 125.893 71.6223ZM134.322 78.7929C134.399 79.6642 134.071 80.4322 133.338 81.097C132.604 81.7512 131.727 82.1235 130.707 82.2141C129.697 82.3037 128.84 82.1175 128.135 81.6554C127.429 81.1826 127.055 80.7125 127.014 80.245C126.986 79.9262 127.067 79.7584 127.258 79.7414C127.428 79.7263 127.786 79.9516 128.33 80.4172C128.538 80.5809 128.808 80.7282 129.141 80.8593C129.484 80.9894 129.836 81.0385 130.198 81.0064C130.941 80.9403 131.583 80.6906 132.123 80.2572C132.673 79.8228 132.929 79.3825 132.889 78.9362C132.864 78.6493 132.64 78.2998 132.218 77.8875C131.796 77.4752 131.333 77.0933 130.831 76.7417C130.338 76.3785 129.88 75.9854 129.457 75.5625C129.034 75.1396 128.811 74.7954 128.787 74.5297C128.764 74.2641 128.792 73.9778 128.872 73.6709C128.952 73.364 129.049 73.1358 129.164 72.9863C129.538 72.4927 130.144 72.0159 130.981 71.5561C131.829 71.0953 132.55 70.8385 133.145 70.7856C133.453 70.7583 133.723 70.8361 133.953 71.0191C134.184 71.2021 134.309 71.4052 134.328 71.6283C134.338 71.7345 134.234 71.8294 134.016 71.913C133.799 71.9966 133.467 72.1117 133.019 72.2586C132.581 72.3938 132.193 72.5461 131.855 72.7153C130.675 73.2913 130.104 73.7971 130.142 74.2327C130.163 74.4665 130.843 75.0647 132.181 76.0274C132.696 76.3994 133.169 76.8446 133.601 77.3631C134.042 77.8701 134.282 78.3467 134.322 78.7929ZM137.749 80.0789C137.767 80.2807 137.893 80.3713 138.127 80.3505C138.531 80.3147 139.009 80.1597 139.563 79.8857C140.127 79.6 140.441 79.4544 140.504 79.4487C140.696 79.4317 140.8 79.5242 140.818 79.726C140.845 80.0342 140.558 80.4184 139.957 80.8788C139.366 81.3382 138.81 81.591 138.289 81.6372C137.779 81.6825 137.342 81.5821 136.977 81.336C136.612 81.0794 136.416 80.8023 136.39 80.5048C136.363 80.2073 136.393 79.8244 136.48 79.3562C136.566 78.8774 136.693 78.2505 136.86 77.4753C137.036 76.6887 137.171 76.0395 137.265 75.5279C136.776 75.6891 136.446 75.7772 136.276 75.7923C136.106 75.8074 135.929 75.7375 135.744 75.5826C135.568 75.4161 135.474 75.2532 135.459 75.0938C135.437 74.8388 136.106 74.5331 137.466 74.1768C137.579 73.2779 137.605 72.4885 137.545 71.8085C137.517 71.4898 137.609 71.321 137.821 71.3021C138.002 71.286 138.235 71.3831 138.522 71.5933C138.807 71.7928 138.963 72.036 138.988 72.3229C139.014 72.6098 138.968 73.1225 138.852 73.861C139.453 73.7541 139.934 73.6846 140.295 73.6525C140.932 73.5959 141.263 73.7057 141.288 73.982C141.302 74.1414 141.139 74.2897 140.797 74.4271C140.467 74.5636 139.759 74.7924 138.674 75.1136C138.525 75.9728 138.329 76.9594 138.085 78.0733C137.84 79.1766 137.729 79.8451 137.749 80.0789ZM146.621 75.6609C146.589 75.2997 146.5 74.9648 146.355 74.6565C146.209 74.3375 146.018 74.1135 145.781 73.9846C145.066 74.2516 144.484 74.8761 144.036 75.8583C143.598 76.8289 143.415 77.7232 143.487 78.5413C143.56 79.3594 143.807 79.8515 144.229 80.0175C144.981 79.8009 145.582 79.2227 146.034 78.283C146.496 77.3318 146.692 76.4578 146.621 75.6609ZM142.442 76.1765C142.74 75.3148 143.163 74.5918 143.711 74.0078C144.269 73.4121 144.861 73.0865 145.488 73.0308C146.125 72.9742 146.681 73.198 147.154 73.7021C147.626 74.1956 147.896 74.8302 147.965 75.6058C148.033 76.3708 147.917 77.1735 147.617 78.014C147.316 78.8439 146.859 79.5537 146.248 80.1435C145.646 80.7216 144.978 81.0433 144.245 81.1084C143.703 81.1565 143.23 80.9469 142.824 80.4796C142.419 80.0123 142.182 79.3961 142.114 78.6312C142.045 77.8555 142.154 77.0373 142.442 76.1765ZM149.918 74.5971L149.764 73.4061C149.719 72.9067 149.814 72.6467 150.048 72.6259C150.25 72.608 150.453 72.7238 150.657 72.9734C150.871 73.2114 150.994 73.511 151.026 73.8723C151.057 74.2229 151.07 74.4895 151.065 74.672C151.865 73.1874 152.679 72.4084 153.508 72.3348C154.028 72.2885 154.3 72.3929 154.322 72.6479C154.334 72.7754 154.286 72.8975 154.178 73.0141C154.071 73.1307 153.896 73.2694 153.653 73.4302C153.112 73.7246 152.667 74.1442 152.319 74.6891C151.981 75.2224 151.718 75.8187 151.53 76.4779C151.343 77.1371 151.194 77.6911 151.084 78.1399C150.984 78.5878 150.908 78.9372 150.855 79.1882C150.803 79.4392 150.739 79.6858 150.664 79.928C150.532 80.3681 150.354 80.5981 150.131 80.6179C149.95 80.6339 149.793 80.5462 149.658 80.3547C149.533 80.1516 149.462 79.9545 149.445 79.7632C149.427 79.5613 149.482 79.1602 149.611 78.5598C149.928 77.1824 150.03 75.8615 149.918 74.5971ZM160.296 71.7159C160.466 71.7008 160.658 71.8123 160.872 72.0503C161.096 72.2767 161.221 72.544 161.249 72.8522C161.267 73.0646 161.114 73.8065 160.788 75.0776C160.461 76.3488 160.238 77.2146 160.119 77.675C160.009 78.1238 159.853 78.7266 159.653 79.4833C159.462 80.2284 159.275 80.9571 159.092 81.6694C158.696 83.236 157.966 84.0664 156.904 84.1607C156.298 84.2145 155.703 84.08 155.117 83.7572C154.532 83.445 154.223 83.0923 154.188 82.6992C154.175 82.5505 154.229 82.3797 154.351 82.1868C154.463 81.9948 154.566 81.8946 154.662 81.8861C154.757 81.8776 154.922 81.9808 155.155 82.1957C155.834 82.8422 156.391 83.1461 156.826 83.1075C157.156 83.0782 157.427 82.7596 157.641 82.1517C157.856 81.5543 158.047 80.8787 158.216 80.1249C158.396 79.3807 158.494 78.9705 158.508 78.8942C158.533 78.817 158.557 78.7185 158.578 78.5988C158.61 78.4782 158.638 78.3686 158.662 78.2702C157.999 79.3678 157.301 79.9491 156.568 80.0142C156.121 80.0538 155.689 79.8834 155.269 79.503C154.861 79.1217 154.631 78.6495 154.581 78.0863C154.531 77.5232 154.602 76.7513 154.793 75.7705C154.985 74.7897 155.235 73.9322 155.545 73.198C155.854 72.4637 156.126 72.0862 156.36 72.0654C156.551 72.0485 156.734 72.1232 156.91 72.2897C157.095 72.4446 157.195 72.6124 157.212 72.793C157.228 72.9736 157.123 73.363 156.898 73.9613C156.194 75.8015 155.885 77.2103 155.972 78.1878C155.987 78.3578 156.053 78.4965 156.169 78.6039C156.285 78.7007 156.417 78.7425 156.566 78.7293C156.949 78.6954 157.375 78.3148 157.846 77.5876C158.317 76.8605 158.734 76.0096 159.097 75.035C159.399 74.2157 159.698 73.1772 159.993 71.9195C160.025 71.7989 160.126 71.731 160.296 71.7159ZM164.084 79.6842C163.818 79.7077 163.5 79.5646 163.13 79.2548C162.759 78.9344 162.564 78.6626 162.544 78.4395C162.523 78.2057 162.593 77.9693 162.754 77.7301C162.924 77.4794 163.105 77.3455 163.297 77.3286C163.498 77.3106 163.75 77.5507 164.051 78.0486C164.363 78.5457 164.531 78.927 164.554 79.1926C164.562 79.2776 164.512 79.3784 164.404 79.4951C164.297 79.6117 164.19 79.6747 164.084 79.6842Z',fill:'#F8F8F8'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M92.5932 69.5856C83.212 68.9129 71.9283 71.6086 66.7002 73.0541C66.2109 73.1894 66.2314 74.0103 66.7238 74.0217C75.1813 74.2179 87.5356 73.6225 92.7717 71.0224C93.4874 70.667 93.3375 69.639 92.5932 69.5856Z',fill:'#F8598B'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M176.55 64.7201C217.5 72.5001 278.5 48.5001 234.477 17.568',stroke:'#496274',strokeWidth:'2',strokeLinecap:'round',strokeLinejoin:'round',strokeDasharray:'7 7',fill:'none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M228.706 21.9547L225.77 11.7963L236.246 10.3621',stroke:'#496274',strokeWidth:'2',strokeLinecap:'round',strokeLinejoin:'round',fill:'none'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-flame-bot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-flames win-flames-far'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-flames win-flames-near'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-boss',ref:'winBoss'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-wreckage win-wreckage-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-wreckage win-wreckage-2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'win-wreckage win-wreckage-3'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'more-arrow-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'more-arrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:'188',height:'271',viewBox:'0 0 188 271',fill:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M50 51L138 40L130 211L57 206.5L50 51Z',fill:'white'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M92.4 121.537L92.4 99.7109C92.4 98.8764 93.1102 98.2 94 98.2C94.8837 98.2 95.6 98.8724 95.6 99.7109L95.6 121.537L99.2686 117.869C99.8935 117.244 100.907 117.244 101.531 117.869C102.156 118.493 102.156 119.507 101.531 120.131L95.1314 126.531C94.5065 127.156 93.4935 127.156 92.8686 126.531L86.4686 120.131C85.8438 119.507 85.8438 118.493 86.4686 117.869C87.0935 117.244 88.1065 117.244 88.7314 117.869L92.4 121.537Z',fill:'#F8598B'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M87.3252 76L86.6412 67.3H84.6012L82.1892 73.9L79.7772 67.3H77.7012L76.9932 76H78.4692L78.9612 69.544L81.3492 76.024H82.8132L85.2012 69.544L85.7052 76H87.3252ZM97.3229 71.644C97.3229 68.956 95.6669 67.144 93.0749 67.144C90.4949 67.144 88.8149 68.968 88.8149 71.668C88.8149 74.344 90.4829 76.168 93.0509 76.168C95.6429 76.168 97.3229 74.32 97.3229 71.644ZM95.6549 71.656C95.6549 73.564 94.6709 74.788 93.0629 74.788C91.4669 74.788 90.4829 73.564 90.4829 71.656C90.4829 69.736 91.4549 68.512 93.0629 68.512C94.6589 68.512 95.6549 69.736 95.6549 71.656ZM105.642 75.772L103.134 72.34C104.274 71.98 105.018 71.176 105.018 69.904C105.018 68.224 103.806 67.3 101.802 67.3H99.042V76H100.674V72.652H101.466L103.914 76.084L105.642 75.772ZM103.386 70C103.386 70.912 102.702 71.392 101.586 71.392H100.662V68.632H101.682C102.798 68.632 103.386 69.124 103.386 70ZM112.245 76V74.608H108.525V72.184H111.525L111.297 70.804H108.525V68.704H112.113V67.3H106.905V76H112.245Z',fill:'black'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M104.779 94.0755L105.53 95.7362L103.877 119.213L100.647 119.817V101.926L104.779 94.0755Z',fill:'#765CA2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M84.1224 118.006L81.7188 97.397L82.2446 95.7363L86.9768 103.059V119.742L85.4745 120.572L84.3478 118.232L84.1224 118.006Z',fill:'#702A71'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M116.699 117.568L117 118.904L94.3379 143V140.675L116.699 117.568Z',fill:'#765CA2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M94.338 140.675V143L71 117.394L71.1502 115.907L94.338 140.675Z',fill:'#702A71'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M116.7 117.492L111.277 123.096L102.953 131.697L101.159 133.551L98.2434 136.564L94.3382 140.599L85.3853 131.036L82.7916 128.266L76.8861 121.958L75.6332 120.62L71.1504 115.831L84.8482 117.303L84.348 113.146L83.1589 103.259L83.1184 102.921L82.4994 97.776L82.2448 95.6608L104.779 94L104.511 98.5912L103.963 107.972L103.862 109.716L103.471 116.407L103.379 117.987L116.7 117.492Z',fill:'#B6E5FF'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{opacity:'0.6',d:'M103.963 107.972L103.862 109.716L103.471 116.407C99.4295 116.558 95.394 115.974 91.5588 114.684C89.2197 113.903 86.801 113.387 84.3478 113.146L83.1587 103.256L83.1182 102.919C86.1813 102.37 90.4531 102.262 93.9624 104.642C96.7447 106.531 100.47 107.636 103.963 107.972Z',fill:'#70CEEF'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M104.511 98.5912L103.963 107.972L103.862 109.716C100.016 109.539 95.7417 108.479 91.5586 105.701C88.6419 103.765 85.8018 103.114 83.1585 103.259L83.118 102.921L82.499 97.7745C85.3406 97.7133 88.548 98.392 91.4083 100.794C95.2136 103.987 100.412 101.601 104.511 98.5912Z',fill:'#B6E5FF'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{opacity:'0.6',d:'M111.277 123.096L102.953 131.697L101.159 133.551C100.161 133.597 99.1604 133.55 98.1709 133.41C96.3681 133.155 94.5368 132.589 92.8685 131.531C90.0563 129.749 86.3441 128.662 82.7912 128.266L76.8857 121.958L75.6328 120.62C79.689 119.746 87.1704 118.864 95.4412 121.487C100.989 123.247 106.679 123.429 111.277 123.096Z',fill:'#70CEEF'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M102.953 131.697L101.159 133.551L98.243 136.564C96.1118 135.878 94.1993 134.637 92.7003 132.967C90.7751 130.836 88.1341 130.486 85.3849 131.036L82.7927 128.266L76.8857 121.958C81.7637 122.011 87.8261 123.317 93.2224 128.086C96.429 130.923 99.7866 131.84 102.953 131.697Z',fill:'#B6E5FF'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fs-marketing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-12 medium-6 large-4 columns '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'About FullStory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'See how product teams use FullStory to improve their customer experience.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'usecases',style:{marginTop:'3em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'aria-label':'Golden Use Cases',className:'orbit','data-auto-play':'false','data-orbit':'c39teq-orbit','data-use-m-u-i':'false',role:'region'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orbit-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orbit-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orbit-slide is-active no-motionui'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-middle align-center guc-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-11 medium-5 large-5 columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'player-wrapper row align-middle align-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_player___default.a,{className:'react-player',url:'https://home.wistia.com/medias/9g4zd7c8na',width:'100%',height:'100%'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-middle align-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('blockquote',{className:'trans'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Jane.com'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Any e-commerce company should have this type of technology... visual representation of exactly what the user is seeing. It\u2019s critical.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('cite',null,'Jason Mitchell',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'Sr. product manager, Jane.com'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-11 medium-5 large-6 medium-offset-1 columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portrait'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'Chris Savage - Wistia',className:'',src:__WEBPACK_IMPORTED_MODULE_3__Images_js__["Chris"]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'FullStory is magic. It gives us a level of insight that we can\'t get anywhere else. It\'s absolutely invaluable.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('cite',null,'Chris Savage',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'CEO, Wistia'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('blockquote',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portrait'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'Dan DeMeyere - thredUP',className:'',src:__WEBPACK_IMPORTED_MODULE_3__Images_js__["Dan"]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We might have been pulling our hair out for weeks had we not thought to use FullStory [to resolve a bug we encountered].'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('cite',null,'Dan DeMeyere',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'VP & Engineer, thredUP')))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pink-gradient'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'cta-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-12 columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'tiempos-headline'},'Understand your users like never before\u2014get started with FullStory!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cta-bank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'fs-button pill medium black',href:'https://app.fullstory.com/signup/'},'Sign up Free')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://app.fullstory.com/login/'},'Already using FullStory? Sign in.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'logos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-11 medium-12 columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-6 medium-2 columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-wrapper active',id:'logo-position-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'client-logo active',src:__WEBPACK_IMPORTED_MODULE_3__Images_js__["DigitalOcean"],alt:'Digital ocean'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-6 medium-2 columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-wrapper active',id:'logo-position-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'client-logo active',src:__WEBPACK_IMPORTED_MODULE_3__Images_js__["Segment"],alt:'Segment'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-6 medium-2 columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-wrapper active',id:'logo-position-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'client-logo active',src:__WEBPACK_IMPORTED_MODULE_3__Images_js__["Jane"],alt:'Jane'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-6 medium-2 columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-wrapper active',id:'logo-position-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'client-logo active',src:__WEBPACK_IMPORTED_MODULE_3__Images_js__["Maritzcx"],alt:'Maritzcx'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-6 medium-2 columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-wrapper active',id:'logo-position-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'client-logo active',src:__WEBPACK_IMPORTED_MODULE_3__Images_js__["DonorsChoose"],alt:'Donors choose'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-6 medium-2 columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-wrapper active',id:'logo-position-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'client-logo active',src:__WEBPACK_IMPORTED_MODULE_3__Images_js__["Teespring"],alt:'Teespring'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-11 medium-12 columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-12 medium-4 columns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',{className:'social'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',null,'Follow Along'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.facebook.com/getfullstory/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',id:'Layer_1',x:'0px',y:'0px',viewBox:'0 0 24 24',className:'svg replaced-svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#ffffff',d:'M22.7,0H1.3C0.6,0,0,0.6,0,1.3v21.4C0,23.4,0.6,24,1.3,24h11.5v-9.3H9.7v-3.6h3.1V8.4c0-3.1,1.9-4.8,4.7-4.8  c1.3,0,2.5,0.1,2.8,0.1V7h-1.9c-1.5,0-1.8,0.7-1.8,1.8v2.3h3.6l-0.5,3.6h-3.1V24h6.1c0.7,0,1.3-0.6,1.3-1.3V1.3  C24,0.6,23.4,0,22.7,0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://twitter.com/fullstory'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',id:'Layer_1',x:'0px',y:'0px',viewBox:'0 0 24 24',className:'svg replaced-svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#ffffff',d:'M24,4.6c-0.9,0.4-1.8,0.7-2.8,0.8c1-0.6,1.8-1.6,2.2-2.7c-1,0.6-2,1-3.1,1.2c-0.9-1-2.2-1.6-3.6-1.6  c-2.7,0-4.9,2.2-4.9,4.9c0,0.4,0,0.8,0.1,1.1C7.7,8.1,4.1,6.1,1.6,3.2C1.2,3.9,1,4.7,1,5.6c0,1.7,0.9,3.2,2.2,4.1  c-0.8,0-1.6-0.2-2.2-0.6v0.1c0,2.4,1.7,4.4,3.9,4.8c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6,0-0.9-0.1c0.6,2,2.4,3.4,4.6,3.4  c-1.7,1.3-3.8,2.1-6.1,2.1c-0.4,0-0.8,0-1.2-0.1c2.2,1.4,4.8,2.2,7.6,2.2c9.1,0,14-7.5,14-14c0-0.2,0-0.4,0-0.6  C22.5,6.4,23.3,5.6,24,4.6C24,4.6,24,4.6,24,4.6z'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.instagram.com/fullstoryhq/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',id:'Layer_1',x:'0px',y:'0px',viewBox:'0 0 24 24',className:'svg replaced-svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#ffffff',d:'M12,0C8.7,0,8.3,0,7.1,0.1C5.8,0.1,4.9,0.3,4.1,0.6C3.4,0.9,2.7,1.3,2,2S0.9,3.3,0.6,4.1  C0.3,4.9,0.1,5.8,0.1,7.1C0,8.3,0,8.7,0,12s0,3.7,0.1,4.9c0.1,1.3,0.3,2.1,0.6,2.9C0.9,20.6,1.3,21.3,2,22c0.7,0.7,1.3,1.1,2.1,1.4  c0.8,0.3,1.6,0.5,2.9,0.6C8.3,24,8.7,24,12,24s3.7,0,4.9-0.1c1.3-0.1,2.1-0.3,2.9-0.6c0.8-0.3,1.5-0.7,2.1-1.4  c0.7-0.7,1.1-1.3,1.4-2.1c0.3-0.8,0.5-1.6,0.6-2.9C24,15.7,24,15.3,24,12s0-3.7-0.1-4.9c-0.1-1.3-0.3-2.1-0.6-2.9  C23.1,3.4,22.7,2.7,22,2c-0.7-0.7-1.3-1.1-2.1-1.4c-0.8-0.3-1.6-0.5-2.9-0.6C15.7,0,15.3,0,12,0z M12,2.2c3.2,0,3.6,0,4.9,0.1  c1.2,0.1,1.8,0.2,2.2,0.4c0.6,0.2,1,0.5,1.4,0.9c0.4,0.4,0.7,0.8,0.9,1.4c0.2,0.4,0.4,1.1,0.4,2.2c0.1,1.3,0.1,1.6,0.1,4.8  s0,3.6-0.1,4.9c-0.1,1.2-0.3,1.8-0.4,2.2c-0.2,0.6-0.5,1-0.9,1.4c-0.4,0.4-0.8,0.7-1.4,0.9c-0.4,0.2-1.1,0.4-2.2,0.4  c-1.3,0.1-1.6,0.1-4.9,0.1c-3.2,0-3.6,0-4.9-0.1c-1.2-0.1-1.8-0.3-2.2-0.4c-0.6-0.2-1-0.5-1.4-0.9c-0.4-0.4-0.7-0.8-0.9-1.4  c-0.2-0.4-0.4-1.1-0.4-2.2c0-1.3-0.1-1.6-0.1-4.8c0-3.2,0-3.6,0.1-4.9C2.2,6,2.4,5.3,2.6,4.9c0.2-0.6,0.5-1,0.9-1.4  c0.4-0.4,0.8-0.7,1.4-0.9c0.4-0.2,1.1-0.4,2.2-0.4C8.4,2.1,8.7,2.1,12,2.2C12,2.1,12,2.2,12,2.2z M12,5.8c-3.4,0-6.2,2.8-6.2,6.2  c0,3.4,2.8,6.2,6.2,6.2c3.4,0,6.2-2.8,6.2-6.2C18.2,8.6,15.4,5.8,12,5.8z M12,16c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4  S14.2,16,12,16z M19.8,5.6c0,0.8-0.6,1.4-1.4,1.4C17.6,7,17,6.4,17,5.6s0.6-1.4,1.4-1.4C19.2,4.2,19.8,4.8,19.8,5.6z'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.linkedin.com/company/fullstory'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',id:'Layer_1',x:'0px',y:'0px',viewBox:'0 0 24 24',className:'svg replaced-svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#ffffff',d:'M20.4,20.5h-3.6v-5.6c0-1.3,0-3-1.9-3c-1.9,0-2.1,1.4-2.1,2.9v5.7H9.4V9h3.4v1.6h0c0.5-0.9,1.6-1.9,3.4-1.9  c3.6,0,4.3,2.4,4.3,5.5L20.4,20.5L20.4,20.5z M5.3,7.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1  C7.4,6.5,6.5,7.4,5.3,7.4z M7.1,20.5H3.6V9h3.6V20.5z M22.2,0H1.8C0.8,0,0,0.8,0,1.7v20.5c0,1,0.8,1.7,1.8,1.7h20.5  c1,0,1.8-0.8,1.8-1.7V1.7C24,0.8,23.2,0,22.2,0L22.2,0z'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://dribbble.com/fullstory'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',id:'Layer_1',x:'0px',y:'0px',viewBox:'0 0 24 24',className:'svg replaced-svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#ffffff',d:'M12,24C5.4,24,0,18.6,0,12S5.4,0,12,0s12,5.4,12,12S18.6,24,12,24z M22.1,13.6c-0.4-0.1-3.2-1-6.4-0.4  c1.3,3.7,1.9,6.7,2,7.3C20,19,21.7,16.5,22.1,13.6L22.1,13.6z M16,21.5c-0.2-0.9-0.8-4-2.2-7.8l-0.1,0c-5.8,2-7.9,6-8,6.4  c1.7,1.4,3.9,2.2,6.3,2.2C13.4,22.3,14.8,22,16,21.5L16,21.5z M4.4,18.9c0.2-0.4,3-5.1,8.3-6.8c0.1,0,0.3-0.1,0.4-0.1  c-0.3-0.6-0.5-1.2-0.8-1.7c-5.1,1.5-10.1,1.5-10.5,1.5l0,0.3C1.8,14.6,2.8,17,4.4,18.9L4.4,18.9z M2,9.9c0.5,0,4.7,0,9.5-1.2  c-1.7-3-3.5-5.6-3.8-5.9C4.8,4.1,2.6,6.7,2,9.9L2,9.9z M9.6,2.1c0.3,0.4,2.1,2.9,3.8,6c3.6-1.4,5.2-3.4,5.4-3.7  C17,2.7,14.6,1.8,12,1.8C11.2,1.8,10.4,1.9,9.6,2.1L9.6,2.1z M19.9,5.5c-0.2,0.3-1.9,2.5-5.7,4c0.2,0.5,0.5,1,0.7,1.5  c0.1,0.2,0.1,0.4,0.2,0.5c3.4-0.4,6.8,0.3,7.1,0.3C22.2,9.5,21.4,7.3,19.9,5.5L19.9,5.5z'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-6 medium-2 column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',null,'FullStory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/features/'},' Features')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/pricing/'},' Pricing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/signup/'},' Sign Up Free')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/pricing/demo/'},' Request a Demo')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://blog.fullstory.com'},' Foreward')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://bionic.fullstory.com'},' Bionic')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com//ui/'},' Log In')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-6 medium-2 column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',null,'Support'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://help.fullstory.com/'},' Support')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://help.fullstory.com/11268-Using-FullStory'},' Using FullStory')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://help.fullstory.com/11270-Integrate'},' Integrations')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://help.fullstory.com/11269-Develop'},' Developer API')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://help.fullstory.com/11532-Security-Privacy-Performance'},' Security, Privacy, & Performance')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-6 medium-2 column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',null,'Customers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/customers/'},' Case Studies')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/resources/'},' Resources')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/resources/gamefilm/'},' Game Film')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/love/'},' Wall of Love ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{role:'img','aria-label':'Smiling Face With Heart-Eyes'},'\uD83D\uDE0D'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-6 medium-2 column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',null,'Company'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/investors/'},' Investors')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/partners/solutions/'},' Partners')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/contact/'},' Contact Us')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/jobs/'},' Jobs')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subfooter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-middle align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-11 medium-6 columns'},'\xA9 FullStory\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-for-mobile'},'\xA0\xA0\xA0|\xA0\xA0\xA0'),'Made with ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://blog.fullstory.com/empathy-at-scale-meet-fullstory-huggers/',className:'hugs'},'Hugs'),' in Atlanta, Georgia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-11 medium-2 columns legal-links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/legal/acceptable-use/'},' Acceptable Use Policy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-11 medium-2 columns legal-links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/legal/terms-and-conditions/'},' Terms & Conditions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-11 medium-2 columns legal-links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.fullstory.com/legal/privacy/'},' Privacy Policy'))))))));}}]);return WinnerView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Winner=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(WinnerView);/* harmony default export */ __webpack_exports__["a"] = (Winner);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePlayer = exports.Mixcloud = exports.DailyMotion = exports.Twitch = exports.Wistia = exports.Streamable = exports.Facebook = exports.Vimeo = exports.SoundCloud = exports.YouTube = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _YouTube = __webpack_require__(47);

Object.defineProperty(exports, 'YouTube', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_YouTube)['default'];
  }
});

var _SoundCloud = __webpack_require__(49);

Object.defineProperty(exports, 'SoundCloud', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SoundCloud)['default'];
  }
});

var _Vimeo = __webpack_require__(50);

Object.defineProperty(exports, 'Vimeo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Vimeo)['default'];
  }
});

var _Facebook = __webpack_require__(88);

Object.defineProperty(exports, 'Facebook', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Facebook)['default'];
  }
});

var _Streamable = __webpack_require__(89);

Object.defineProperty(exports, 'Streamable', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Streamable)['default'];
  }
});

var _Wistia = __webpack_require__(90);

Object.defineProperty(exports, 'Wistia', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Wistia)['default'];
  }
});

var _Twitch = __webpack_require__(91);

Object.defineProperty(exports, 'Twitch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Twitch)['default'];
  }
});

var _DailyMotion = __webpack_require__(51);

Object.defineProperty(exports, 'DailyMotion', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DailyMotion)['default'];
  }
});

var _Mixcloud = __webpack_require__(92);

Object.defineProperty(exports, 'Mixcloud', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Mixcloud)['default'];
  }
});

var _FilePlayer = __webpack_require__(93);

Object.defineProperty(exports, 'FilePlayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FilePlayer)['default'];
  }
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props2 = __webpack_require__(28);

var _utils = __webpack_require__(6);

var _players = __webpack_require__(299);

var _players2 = _interopRequireDefault(_players);

var _Player4 = __webpack_require__(48);

var _Player5 = _interopRequireDefault(_Player4);

var _Preview = __webpack_require__(300);

var _Preview2 = _interopRequireDefault(_Preview);

var _preload = __webpack_require__(301);

var _preload2 = _interopRequireDefault(_preload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SUPPORTED_PROPS = Object.keys(_props2.propTypes);

var customPlayers = [];

var ReactPlayer = function (_Component) {
  _inherits(ReactPlayer, _Component);

  function ReactPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.state = {
      showPreview: !!_this.props.light
    }, _this.onClickPreview = function () {
      _this.setState({ showPreview: false });
    }, _this.getDuration = function () {
      if (!_this.player) return null;
      return _this.player.getDuration();
    }, _this.getCurrentTime = function () {
      if (!_this.player) return null;
      return _this.player.getCurrentTime();
    }, _this.getSecondsLoaded = function () {
      if (!_this.player) return null;
      return _this.player.getSecondsLoaded();
    }, _this.getInternalPlayer = function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';

      if (!_this.player) return null;
      return _this.player.getInternalPlayer(key);
    }, _this.seekTo = function (fraction, type) {
      if (!_this.player) return null;
      _this.player.seekTo(fraction, type);
    }, _this.onReady = function () {
      _this.props.onReady(_this);
    }, _this.wrapperRef = function (wrapper) {
      _this.wrapper = wrapper;
    }, _this.activePlayerRef = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.progressFrequency) {
        var message = 'ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead';
        console.warn(message, 'font-weight: bold', '', 'font-weight: bold', '');
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _utils.isEqual)(this.props, nextProps) || !(0, _utils.isEqual)(this.state, nextState);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
      if (!this.props.light && nextProps.light) {
        this.setState({ showPreview: true });
      }
    }
  }, {
    key: 'getActivePlayer',
    value: function getActivePlayer(url) {
      var _arr = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));

      for (var _i = 0; _i < _arr.length; _i++) {
        var _Player = _arr[_i];
        if (_Player.canPlay(url)) {
          return _Player;
        }
      }
      // Fall back to FilePlayer if nothing else can play the URL
      return _FilePlayer.FilePlayer;
    }
  }, {
    key: 'renderActivePlayer',
    value: function renderActivePlayer(url, activePlayer) {
      if (!url) return null;
      return _react2['default'].createElement(_Player5['default'], _extends({}, this.props, {
        key: activePlayer.displayName,
        ref: this.activePlayerRef,
        config: this.config,
        activePlayer: activePlayer,
        onReady: this.onReady
      }));
    }
  }, {
    key: 'sortPlayers',
    value: function sortPlayers(a, b) {
      // Retain player order to prevent weird iframe behaviour when switching players
      if (a && b) {
        return a.key < b.key ? -1 : 1;
      }
      return 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          controls = _props.controls,
          style = _props.style,
          width = _props.width,
          height = _props.height,
          light = _props.light,
          Wrapper = _props.wrapper;

      var showPreview = this.state.showPreview && url;
      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
      var activePlayer = this.getActivePlayer(url);
      var renderedActivePlayer = this.renderActivePlayer(url, activePlayer);
      var preloadPlayers = (0, _preload2['default'])(url, controls, this.config);
      var players = [renderedActivePlayer].concat(_toConsumableArray(preloadPlayers)).sort(this.sortPlayers);
      var preview = _react2['default'].createElement(_Preview2['default'], { url: url, light: light, onClick: this.onClickPreview });
      return _react2['default'].createElement(
        Wrapper,
        _extends({ ref: this.wrapperRef, style: _extends({}, style, { width: width, height: height }) }, otherProps),
        showPreview ? preview : players
      );
    }
  }]);

  return ReactPlayer;
}(_react.Component);

ReactPlayer.addCustomPlayer = function (player) {
  customPlayers.push(player);
};

ReactPlayer.removeCustomPlayers = function () {
  customPlayers = [];
};

ReactPlayer.displayName = 'ReactPlayer';
ReactPlayer.propTypes = _props2.propTypes;
ReactPlayer.defaultProps = _props2.defaultProps;

ReactPlayer.canPlay = function (url) {
  var _arr2 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));

  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var _Player2 = _arr2[_i2];
    if (_Player2.canPlay(url)) {
      return true;
    }
  }
  return false;
};

ReactPlayer.canEnablePIP = function (url) {
  var _arr3 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));

  for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
    var _Player3 = _arr3[_i3];
    if (_Player3.canEnablePIP && _Player3.canEnablePIP(url)) {
      return true;
    }
  }
  return false;
};

exports['default'] = ReactPlayer;

/***/ }),
/* 297 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.deepmerge = factory());
}(this, (function () { 'use strict';

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

return deepmerge_1;

})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _YouTube = __webpack_require__(47);

var _SoundCloud = __webpack_require__(49);

var _Vimeo = __webpack_require__(50);

var _Facebook = __webpack_require__(88);

var _Streamable = __webpack_require__(89);

var _Wistia = __webpack_require__(90);

var _Twitch = __webpack_require__(91);

var _DailyMotion = __webpack_require__(51);

var _Mixcloud = __webpack_require__(92);

var _FilePlayer = __webpack_require__(93);

exports['default'] = [_YouTube.YouTube, _SoundCloud.SoundCloud, _Vimeo.Vimeo, _Facebook.Facebook, _Streamable.Streamable, _Wistia.Wistia, _Twitch.Twitch, _DailyMotion.DailyMotion, _Mixcloud.Mixcloud, _FilePlayer.FilePlayer];

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICON_SIZE = '64px';

var Preview = function (_Component) {
  _inherits(Preview, _Component);

  function Preview() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Preview.__proto__ || Object.getPrototypeOf(Preview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      image: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Preview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchImage(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.url !== nextProps.url) {
        this.fetchImage(nextProps);
      }
    }
  }, {
    key: 'fetchImage',
    value: function fetchImage(_ref2) {
      var _this2 = this;

      var url = _ref2.url,
          light = _ref2.light;

      if (typeof light === 'string') {
        this.setState({ image: light });
        return;
      }
      this.setState({ image: null });
      return window.fetch('https://noembed.com/embed?url=' + url).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.thumbnail_url) {
          var image = data.thumbnail_url.replace('height=100', 'height=480');
          _this2.setState({ image: image });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var onClick = this.props.onClick;
      var image = this.state.image;

      var flexCenter = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
      var styles = {
        preview: _extends({
          width: '100%',
          height: '100%',
          backgroundImage: image ? 'url(' + image + ')' : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer'
        }, flexCenter),
        shadow: _extends({
          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
          borderRadius: ICON_SIZE,
          width: ICON_SIZE,
          height: ICON_SIZE
        }, flexCenter),
        playIcon: {
          borderStyle: 'solid',
          borderWidth: '16px 0 16px 26px',
          borderColor: 'transparent transparent transparent white',
          marginLeft: '7px'
        }
      };
      return _react2['default'].createElement(
        'div',
        { style: styles.preview, className: 'react-player__preview', onClick: onClick },
        _react2['default'].createElement(
          'div',
          { style: styles.shadow, className: 'react-player__shadow' },
          _react2['default'].createElement('div', { style: styles.playIcon, className: 'react-player__play-icon' })
        )
      );
    }
  }]);

  return Preview;
}(_react.Component);

exports['default'] = Preview;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = renderPreloadPlayers;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Player = __webpack_require__(48);

var _Player2 = _interopRequireDefault(_Player);

var _YouTube = __webpack_require__(47);

var _SoundCloud = __webpack_require__(49);

var _Vimeo = __webpack_require__(50);

var _DailyMotion = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PRELOAD_PLAYERS = [{
  Player: _YouTube.YouTube,
  configKey: 'youtube',
  url: 'https://www.youtube.com/watch?v=GlCmAC4MHek'
}, {
  Player: _SoundCloud.SoundCloud,
  configKey: 'soundcloud',
  url: 'https://soundcloud.com/seucheu/john-cage-433-8-bit-version'
}, {
  Player: _Vimeo.Vimeo,
  configKey: 'vimeo',
  url: 'https://vimeo.com/300970506'
}, {
  Player: _DailyMotion.DailyMotion,
  configKey: 'dailymotion',
  url: 'http://www.dailymotion.com/video/xqdpyk'
}];

function renderPreloadPlayers(url, controls, config) {
  var players = [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = PRELOAD_PLAYERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var player = _step.value;

      if (!player.Player.canPlay(url) && config[player.configKey].preload) {
        players.push(_react2['default'].createElement(_Player2['default'], {
          key: player.Player.displayName,
          activePlayer: player.Player,
          url: player.url,
          controls: controls,
          playing: true,
          muted: true,
          style: { display: 'none' }
        }));
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return players;
}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var invariant = __webpack_require__(25);
var defaultClickRejectionStrategy = __webpack_require__(304);

var alreadyInjected = false;

module.exports = function injectTapEventPlugin(strategyOverrides) {
  strategyOverrides = strategyOverrides || {}
  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;

  if (false) {
    invariant(
      !alreadyInjected,
      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
It is recommended to call injectTapEventPlugin() just before you call \
ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
itself, please contact the maintainer as it shouldn\'t be called in library code and \
should be injected by the application.'
    )
  }

  alreadyInjected = true;

  __webpack_require__(30).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.EventPluginHub.injection.injectEventPluginsByName({
    'TapEventPlugin': __webpack_require__(305)(shouldRejectClick)
  });
};



/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = function(lastTouchEvent, clickTimestamp) {
  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
    return true;
  }
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule TapEventPlugin
 * @flow
 */



var EventPropagators = __webpack_require__(30).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.EventPropagators;
var TouchEventUtils = __webpack_require__(306);
var SyntheticEvent = __webpack_require__(307);

function isEndish(topLevelType) {
  return (
    topLevelType === 'topMouseUp' ||
    topLevelType === 'topTouchEnd' ||
    topLevelType === 'topTouchCancel'
  );
}

function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

/**
 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
 * in order to still be considered a 'tap' event.
 */
var tapMoveThreshold = 10;
var startCoords = {x: 0, y: 0};

var Axis = {
  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
};

function getAxisCoordOfEvent(
  axis,
  nativeEvent
) {
  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
  if (singleTouch) {
    return singleTouch[axis.page];
  }
  return nativeEvent[axis.page];
}

function getDistance(coords, nativeEvent) {
  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
  return Math.pow(
    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
    0.5
  );
}

var touchEvents = [
  'topTouchStart',
  'topTouchCancel',
  'topTouchEnd',
  'topTouchMove'
];

var dependencies = ['topMouseDown', 'topMouseMove', 'topMouseUp'].concat(
  touchEvents
);

var eventTypes = {
  touchTap: {
    phasedRegistrationNames: {
      bubbled: 'onTouchTap',
      captured: 'onTouchTapCapture'
    },
    dependencies: dependencies
  }
};

var usedTouchTime = 0;

// var TapEventPlugin = {
function createTapEventPlugin(shouldRejectClick) {
  return {
    tapMoveThreshold: tapMoveThreshold,

    eventTypes: eventTypes,

    extractEvents: function(
      topLevelType,
      targetInst,
      nativeEvent,
      nativeEventTarget
    ) {
      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
        return null;
      }
      // on ios, there is a delay after touch event and synthetic
      // mouse events, so that user can perform double tap
      // solution: ignore mouse events following touchevent within small timeframe
      if (touchEvents.indexOf(topLevelType) !== -1) {
        usedTouchTime = Date.now();
      } else {
        if (shouldRejectClick(usedTouchTime, Date.now())) {
          return null;
        }
      }
      var event = null;
      var distance = getDistance(startCoords, nativeEvent);
      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
        event = SyntheticEvent.getPooled(
          eventTypes.touchTap,
          targetInst,
          nativeEvent,
          nativeEventTarget
        );
      }
      if (isStartish(topLevelType)) {
        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
      } else if (isEndish(topLevelType)) {
        startCoords.x = 0;
        startCoords.y = 0;
      }
      EventPropagators.accumulateTwoPhaseDispatches(event);
      return event;
    }
  };
}

module.exports = createTapEventPlugin;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var TouchEventUtils = {
  /**
   * Utility function for common case of extracting out the primary touch from a
   * touch event.
   * - `touchEnd` events usually do not have the `touches` property.
   *   http://stackoverflow.com/questions/3666929/
   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
   *
   * @param {Event} nativeEvent Native event that may or may not be a touch.
   * @return {TouchesObject?} an object with pageX and pageY or null.
   */
  extractSingleTouch: function extractSingleTouch(nativeEvent) {
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;

    return !hasTouches && hasChangedTouches ? changedTouches[0] : hasTouches ? touches[0] : nativeEvent;
  }
};

module.exports = TouchEventUtils;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule SyntheticEvent
 */

/* eslint valid-typeof: 0 */



var emptyFunction = __webpack_require__(14);
var invariant = __webpack_require__(25);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';
var EVENT_POOL_SIZE = 10;

var __DEV__ = "production" !== 'production';

if (__DEV__) {
  var warning = __webpack_require__(308);
}

var shouldBeReleasedProperties = [
  'dispatchConfig',
  '_targetInst',
  'nativeEvent',
  'isDefaultPrevented',
  'isPropagationStopped',
  '_dispatchListeners',
  '_dispatchInstances'
];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function(event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(
  dispatchConfig,
  targetInst,
  nativeEvent,
  nativeEventTarget
) {
  if (__DEV__) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (__DEV__) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null
    ? nativeEvent.defaultPrevented
    : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

Object.assign(SyntheticEvent.prototype, {
  preventDefault: function() {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function() {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function() {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function() {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (__DEV__) {
        Object.defineProperty(
          this,
          propName,
          getPooledWarningPropertyDefinition(propName, Interface[propName])
        );
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (__DEV__) {
      Object.defineProperty(
        this,
        'nativeEvent',
        getPooledWarningPropertyDefinition('nativeEvent', null)
      );
      Object.defineProperty(
        this,
        'preventDefault',
        getPooledWarningPropertyDefinition('preventDefault', emptyFunction)
      );
      Object.defineProperty(
        this,
        'stopPropagation',
        getPooledWarningPropertyDefinition('stopPropagation', emptyFunction)
      );
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function(Class, Interface) {
  var Super = this;

  var E = function() {};
  E.prototype = Super.prototype;
  var prototype = new E();

  Object.assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = Object.assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;
  addEventPoolingTo(Class);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (__DEV__) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function(target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function(constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function(target, prop, value) {
            if (
              prop !== 'isPersistent' &&
              !target.constructor.Interface.hasOwnProperty(prop) &&
              shouldBeReleasedProperties.indexOf(prop) === -1
            ) {
              warning(
                didWarnForAddedNewProperty || target.isPersistent(),
                "This synthetic event is reused for performance reasons. If you're " +
                  "seeing this, you're adding a new property in the synthetic event object. " +
                  'The property is never released. See ' +
                  'https://fb.me/react-event-pooling for more information.'
              );
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

addEventPoolingTo(SyntheticEvent);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {String} propName
  * @param {?object} getVal
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction
      ? 'This is a no-op function'
      : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
    warning(
      warningCondition,
      "This synthetic event is reused for performance reasons. If you're seeing this, " +
        "you're %s `%s` on a released/nullified synthetic event. %s. " +
        'If you must keep the original synthetic event around, use event.persist(). ' +
        'See https://fb.me/react-event-pooling for more information.',
      action,
      propName,
      result
    );
  }
}

function getPooledEvent(dispatchConfig, targetInst, nativeEvent, nativeInst) {
  var EventConstructor = this;
  if (EventConstructor.eventPool.length) {
    var instance = EventConstructor.eventPool.pop();
    EventConstructor.call(
      instance,
      dispatchConfig,
      targetInst,
      nativeEvent,
      nativeInst
    );
    return instance;
  }
  return new EventConstructor(
    dispatchConfig,
    targetInst,
    nativeEvent,
    nativeInst
  );
}

function releasePooledEvent(event) {
  var EventConstructor = this;
  invariant(
    event instanceof EventConstructor,
    'Trying to release an event instance  into a pool of a different type.'
  );
  event.destructor();
  if (EventConstructor.eventPool.length < EVENT_POOL_SIZE) {
    EventConstructor.eventPool.push(event);
  }
}

function addEventPoolingTo(EventConstructor) {
  EventConstructor.eventPool = [];
  EventConstructor.getPooled = getPooledEvent;
  EventConstructor.release = releasePooledEvent;
}


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(14);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.4200d4a1.js